/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 183);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(191);
} else {
  module.exports = require('./cjs/react.development.js');
}


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _typeof2 = __webpack_require__(84);

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && ((typeof call === "undefined" ? "undefined" : (0, _typeof3.default)(call)) === "object" || typeof call === "function") ? call : self;
};

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _setPrototypeOf = __webpack_require__(231);

var _setPrototypeOf2 = _interopRequireDefault(_setPrototypeOf);

var _create = __webpack_require__(235);

var _create2 = _interopRequireDefault(_create);

var _typeof2 = __webpack_require__(84);

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, _typeof3.default)(superClass)));
  }

  subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass;
};

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _assign = __webpack_require__(114);

var _assign2 = _interopRequireDefault(_assign);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _assign2.default || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) {
  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
    Symbol.for &&
    Symbol.for('react.element')) ||
    0xeac7;

  var isValidElement = function(object) {
    return typeof object === 'object' &&
      object !== null &&
      object.$$typeof === REACT_ELEMENT_TYPE;
  };

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(isValidElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(238)();
}


/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2016 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;

	function classNames () {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg)) {
				classes.push(classNames.apply(null, arg));
			} else if (argType === 'object') {
				for (var key in arg) {
					if (hasOwn.call(arg, key) && arg[key]) {
						classes.push(key);
					}
				}
			}
		}

		return classes.join(' ');
	}

	if (typeof module !== 'undefined' && module.exports) {
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
			return classNames;
		}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {
		window.classNames = classNames;
	}
}());


/***/ }),
/* 8 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["e"] = prefix;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return bsClass; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return bsStyles; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return bsSizes; });
/* harmony export (immutable) */ __webpack_exports__["d"] = getClassSet;
/* harmony export (immutable) */ __webpack_exports__["f"] = splitBsProps;
/* harmony export (immutable) */ __webpack_exports__["g"] = splitBsPropsAndOmit;
/* unused harmony export addStyle */
/* unused harmony export _curry */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__StyleConfig__ = __webpack_require__(15);


// TODO: The publicly exposed parts of this should be in lib/BootstrapUtils.






function curry(fn) {
  return function () {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var last = args[args.length - 1];
    if (typeof last === 'function') {
      return fn.apply(undefined, args);
    }
    return function (Component) {
      return fn.apply(undefined, args.concat([Component]));
    };
  };
}

function prefix(props, variant) {
  !(props.bsClass != null) ?  false ? invariant(false, 'A `bsClass` prop is required for this component') : __WEBPACK_IMPORTED_MODULE_2_invariant___default()(false) : void 0;
  return props.bsClass + (variant ? '-' + variant : '');
}

var bsClass = curry(function (defaultClass, Component) {
  var propTypes = Component.propTypes || (Component.propTypes = {});
  var defaultProps = Component.defaultProps || (Component.defaultProps = {});

  propTypes.bsClass = __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string;
  defaultProps.bsClass = defaultClass;

  return Component;
});

var bsStyles = curry(function (styles, defaultStyle, Component) {
  if (typeof defaultStyle !== 'string') {
    Component = defaultStyle;
    defaultStyle = undefined;
  }

  var existing = Component.STYLES || [];
  var propTypes = Component.propTypes || {};

  styles.forEach(function (style) {
    if (existing.indexOf(style) === -1) {
      existing.push(style);
    }
  });

  var propType = __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOf(existing);

  // expose the values on the propType function for documentation
  Component.STYLES = propType._values = existing;

  Component.propTypes = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, propTypes, {
    bsStyle: propType
  });

  if (defaultStyle !== undefined) {
    var defaultProps = Component.defaultProps || (Component.defaultProps = {});
    defaultProps.bsStyle = defaultStyle;
  }

  return Component;
});

var bsSizes = curry(function (sizes, defaultSize, Component) {
  if (typeof defaultSize !== 'string') {
    Component = defaultSize;
    defaultSize = undefined;
  }

  var existing = Component.SIZES || [];
  var propTypes = Component.propTypes || {};

  sizes.forEach(function (size) {
    if (existing.indexOf(size) === -1) {
      existing.push(size);
    }
  });

  var values = [];
  existing.forEach(function (size) {
    var mappedSize = __WEBPACK_IMPORTED_MODULE_4__StyleConfig__["b" /* SIZE_MAP */][size];
    if (mappedSize && mappedSize !== size) {
      values.push(mappedSize);
    }

    values.push(size);
  });

  var propType = __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOf(values);
  propType._values = values;

  // expose the values on the propType function for documentation
  Component.SIZES = existing;

  Component.propTypes = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, propTypes, {
    bsSize: propType
  });

  if (defaultSize !== undefined) {
    if (!Component.defaultProps) {
      Component.defaultProps = {};
    }
    Component.defaultProps.bsSize = defaultSize;
  }

  return Component;
});

function getClassSet(props) {
  var _classes;

  var classes = (_classes = {}, _classes[prefix(props)] = true, _classes);

  if (props.bsSize) {
    var bsSize = __WEBPACK_IMPORTED_MODULE_4__StyleConfig__["b" /* SIZE_MAP */][props.bsSize] || props.bsSize;
    classes[prefix(props, bsSize)] = true;
  }

  if (props.bsStyle) {
    classes[prefix(props, props.bsStyle)] = true;
  }

  return classes;
}

function getBsProps(props) {
  return {
    bsClass: props.bsClass,
    bsSize: props.bsSize,
    bsStyle: props.bsStyle,
    bsRole: props.bsRole
  };
}

function isBsProp(propName) {
  return propName === 'bsClass' || propName === 'bsSize' || propName === 'bsStyle' || propName === 'bsRole';
}

function splitBsProps(props) {
  var elementProps = {};
  __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries___default()(props).forEach(function (_ref) {
    var propName = _ref[0],
        propValue = _ref[1];

    if (!isBsProp(propName)) {
      elementProps[propName] = propValue;
    }
  });

  return [getBsProps(props), elementProps];
}

function splitBsPropsAndOmit(props, omittedPropNames) {
  var isOmittedProp = {};
  omittedPropNames.forEach(function (propName) {
    isOmittedProp[propName] = true;
  });

  var elementProps = {};
  __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries___default()(props).forEach(function (_ref2) {
    var propName = _ref2[0],
        propValue = _ref2[1];

    if (!isBsProp(propName) && !isOmittedProp[propName]) {
      elementProps[propName] = propValue;
    }
  });

  return [getBsProps(props), elementProps];
}

/**
 * Add a style variant to a Component. Mutates the propTypes of the component
 * in order to validate the new variant.
 */
function addStyle(Component) {
  for (var _len2 = arguments.length, styleVariant = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
    styleVariant[_key2 - 1] = arguments[_key2];
  }

  bsStyles(styleVariant, Component);
}

var _curry = curry;

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory) {
	if (true) {
		// CommonJS
		module.exports = exports = factory();
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define([], factory);
	}
	else {
		// Global (browser)
		root.CryptoJS = factory();
	}
}(this, function () {

	/**
	 * CryptoJS core components.
	 */
	var CryptoJS = CryptoJS || (function (Math, undefined) {
	    /*
	     * Local polyfil of Object.create
	     */
	    var create = Object.create || (function () {
	        function F() {};

	        return function (obj) {
	            var subtype;

	            F.prototype = obj;

	            subtype = new F();

	            F.prototype = null;

	            return subtype;
	        };
	    }())

	    /**
	     * CryptoJS namespace.
	     */
	    var C = {};

	    /**
	     * Library namespace.
	     */
	    var C_lib = C.lib = {};

	    /**
	     * Base object for prototypal inheritance.
	     */
	    var Base = C_lib.Base = (function () {


	        return {
	            /**
	             * Creates a new object that inherits from this object.
	             *
	             * @param {Object} overrides Properties to copy into the new object.
	             *
	             * @return {Object} The new object.
	             *
	             * @static
	             *
	             * @example
	             *
	             *     var MyType = CryptoJS.lib.Base.extend({
	             *         field: 'value',
	             *
	             *         method: function () {
	             *         }
	             *     });
	             */
	            extend: function (overrides) {
	                // Spawn
	                var subtype = create(this);

	                // Augment
	                if (overrides) {
	                    subtype.mixIn(overrides);
	                }

	                // Create default initializer
	                if (!subtype.hasOwnProperty('init') || this.init === subtype.init) {
	                    subtype.init = function () {
	                        subtype.$super.init.apply(this, arguments);
	                    };
	                }

	                // Initializer's prototype is the subtype object
	                subtype.init.prototype = subtype;

	                // Reference supertype
	                subtype.$super = this;

	                return subtype;
	            },

	            /**
	             * Extends this object and runs the init method.
	             * Arguments to create() will be passed to init().
	             *
	             * @return {Object} The new object.
	             *
	             * @static
	             *
	             * @example
	             *
	             *     var instance = MyType.create();
	             */
	            create: function () {
	                var instance = this.extend();
	                instance.init.apply(instance, arguments);

	                return instance;
	            },

	            /**
	             * Initializes a newly created object.
	             * Override this method to add some logic when your objects are created.
	             *
	             * @example
	             *
	             *     var MyType = CryptoJS.lib.Base.extend({
	             *         init: function () {
	             *             // ...
	             *         }
	             *     });
	             */
	            init: function () {
	            },

	            /**
	             * Copies properties into this object.
	             *
	             * @param {Object} properties The properties to mix in.
	             *
	             * @example
	             *
	             *     MyType.mixIn({
	             *         field: 'value'
	             *     });
	             */
	            mixIn: function (properties) {
	                for (var propertyName in properties) {
	                    if (properties.hasOwnProperty(propertyName)) {
	                        this[propertyName] = properties[propertyName];
	                    }
	                }

	                // IE won't copy toString using the loop above
	                if (properties.hasOwnProperty('toString')) {
	                    this.toString = properties.toString;
	                }
	            },

	            /**
	             * Creates a copy of this object.
	             *
	             * @return {Object} The clone.
	             *
	             * @example
	             *
	             *     var clone = instance.clone();
	             */
	            clone: function () {
	                return this.init.prototype.extend(this);
	            }
	        };
	    }());

	    /**
	     * An array of 32-bit words.
	     *
	     * @property {Array} words The array of 32-bit words.
	     * @property {number} sigBytes The number of significant bytes in this word array.
	     */
	    var WordArray = C_lib.WordArray = Base.extend({
	        /**
	         * Initializes a newly created word array.
	         *
	         * @param {Array} words (Optional) An array of 32-bit words.
	         * @param {number} sigBytes (Optional) The number of significant bytes in the words.
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.lib.WordArray.create();
	         *     var wordArray = CryptoJS.lib.WordArray.create([0x00010203, 0x04050607]);
	         *     var wordArray = CryptoJS.lib.WordArray.create([0x00010203, 0x04050607], 6);
	         */
	        init: function (words, sigBytes) {
	            words = this.words = words || [];

	            if (sigBytes != undefined) {
	                this.sigBytes = sigBytes;
	            } else {
	                this.sigBytes = words.length * 4;
	            }
	        },

	        /**
	         * Converts this word array to a string.
	         *
	         * @param {Encoder} encoder (Optional) The encoding strategy to use. Default: CryptoJS.enc.Hex
	         *
	         * @return {string} The stringified word array.
	         *
	         * @example
	         *
	         *     var string = wordArray + '';
	         *     var string = wordArray.toString();
	         *     var string = wordArray.toString(CryptoJS.enc.Utf8);
	         */
	        toString: function (encoder) {
	            return (encoder || Hex).stringify(this);
	        },

	        /**
	         * Concatenates a word array to this word array.
	         *
	         * @param {WordArray} wordArray The word array to append.
	         *
	         * @return {WordArray} This word array.
	         *
	         * @example
	         *
	         *     wordArray1.concat(wordArray2);
	         */
	        concat: function (wordArray) {
	            // Shortcuts
	            var thisWords = this.words;
	            var thatWords = wordArray.words;
	            var thisSigBytes = this.sigBytes;
	            var thatSigBytes = wordArray.sigBytes;

	            // Clamp excess bits
	            this.clamp();

	            // Concat
	            if (thisSigBytes % 4) {
	                // Copy one byte at a time
	                for (var i = 0; i < thatSigBytes; i++) {
	                    var thatByte = (thatWords[i >>> 2] >>> (24 - (i % 4) * 8)) & 0xff;
	                    thisWords[(thisSigBytes + i) >>> 2] |= thatByte << (24 - ((thisSigBytes + i) % 4) * 8);
	                }
	            } else {
	                // Copy one word at a time
	                for (var i = 0; i < thatSigBytes; i += 4) {
	                    thisWords[(thisSigBytes + i) >>> 2] = thatWords[i >>> 2];
	                }
	            }
	            this.sigBytes += thatSigBytes;

	            // Chainable
	            return this;
	        },

	        /**
	         * Removes insignificant bits.
	         *
	         * @example
	         *
	         *     wordArray.clamp();
	         */
	        clamp: function () {
	            // Shortcuts
	            var words = this.words;
	            var sigBytes = this.sigBytes;

	            // Clamp
	            words[sigBytes >>> 2] &= 0xffffffff << (32 - (sigBytes % 4) * 8);
	            words.length = Math.ceil(sigBytes / 4);
	        },

	        /**
	         * Creates a copy of this word array.
	         *
	         * @return {WordArray} The clone.
	         *
	         * @example
	         *
	         *     var clone = wordArray.clone();
	         */
	        clone: function () {
	            var clone = Base.clone.call(this);
	            clone.words = this.words.slice(0);

	            return clone;
	        },

	        /**
	         * Creates a word array filled with random bytes.
	         *
	         * @param {number} nBytes The number of random bytes to generate.
	         *
	         * @return {WordArray} The random word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.lib.WordArray.random(16);
	         */
	        random: function (nBytes) {
	            var words = [];

	            var r = (function (m_w) {
	                var m_w = m_w;
	                var m_z = 0x3ade68b1;
	                var mask = 0xffffffff;

	                return function () {
	                    m_z = (0x9069 * (m_z & 0xFFFF) + (m_z >> 0x10)) & mask;
	                    m_w = (0x4650 * (m_w & 0xFFFF) + (m_w >> 0x10)) & mask;
	                    var result = ((m_z << 0x10) + m_w) & mask;
	                    result /= 0x100000000;
	                    result += 0.5;
	                    return result * (Math.random() > .5 ? 1 : -1);
	                }
	            });

	            for (var i = 0, rcache; i < nBytes; i += 4) {
	                var _r = r((rcache || Math.random()) * 0x100000000);

	                rcache = _r() * 0x3ade67b7;
	                words.push((_r() * 0x100000000) | 0);
	            }

	            return new WordArray.init(words, nBytes);
	        }
	    });

	    /**
	     * Encoder namespace.
	     */
	    var C_enc = C.enc = {};

	    /**
	     * Hex encoding strategy.
	     */
	    var Hex = C_enc.Hex = {
	        /**
	         * Converts a word array to a hex string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @return {string} The hex string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var hexString = CryptoJS.enc.Hex.stringify(wordArray);
	         */
	        stringify: function (wordArray) {
	            // Shortcuts
	            var words = wordArray.words;
	            var sigBytes = wordArray.sigBytes;

	            // Convert
	            var hexChars = [];
	            for (var i = 0; i < sigBytes; i++) {
	                var bite = (words[i >>> 2] >>> (24 - (i % 4) * 8)) & 0xff;
	                hexChars.push((bite >>> 4).toString(16));
	                hexChars.push((bite & 0x0f).toString(16));
	            }

	            return hexChars.join('');
	        },

	        /**
	         * Converts a hex string to a word array.
	         *
	         * @param {string} hexStr The hex string.
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Hex.parse(hexString);
	         */
	        parse: function (hexStr) {
	            // Shortcut
	            var hexStrLength = hexStr.length;

	            // Convert
	            var words = [];
	            for (var i = 0; i < hexStrLength; i += 2) {
	                words[i >>> 3] |= parseInt(hexStr.substr(i, 2), 16) << (24 - (i % 8) * 4);
	            }

	            return new WordArray.init(words, hexStrLength / 2);
	        }
	    };

	    /**
	     * Latin1 encoding strategy.
	     */
	    var Latin1 = C_enc.Latin1 = {
	        /**
	         * Converts a word array to a Latin1 string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @return {string} The Latin1 string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var latin1String = CryptoJS.enc.Latin1.stringify(wordArray);
	         */
	        stringify: function (wordArray) {
	            // Shortcuts
	            var words = wordArray.words;
	            var sigBytes = wordArray.sigBytes;

	            // Convert
	            var latin1Chars = [];
	            for (var i = 0; i < sigBytes; i++) {
	                var bite = (words[i >>> 2] >>> (24 - (i % 4) * 8)) & 0xff;
	                latin1Chars.push(String.fromCharCode(bite));
	            }

	            return latin1Chars.join('');
	        },

	        /**
	         * Converts a Latin1 string to a word array.
	         *
	         * @param {string} latin1Str The Latin1 string.
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Latin1.parse(latin1String);
	         */
	        parse: function (latin1Str) {
	            // Shortcut
	            var latin1StrLength = latin1Str.length;

	            // Convert
	            var words = [];
	            for (var i = 0; i < latin1StrLength; i++) {
	                words[i >>> 2] |= (latin1Str.charCodeAt(i) & 0xff) << (24 - (i % 4) * 8);
	            }

	            return new WordArray.init(words, latin1StrLength);
	        }
	    };

	    /**
	     * UTF-8 encoding strategy.
	     */
	    var Utf8 = C_enc.Utf8 = {
	        /**
	         * Converts a word array to a UTF-8 string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @return {string} The UTF-8 string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var utf8String = CryptoJS.enc.Utf8.stringify(wordArray);
	         */
	        stringify: function (wordArray) {
	            try {
	                return decodeURIComponent(escape(Latin1.stringify(wordArray)));
	            } catch (e) {
	                throw new Error('Malformed UTF-8 data');
	            }
	        },

	        /**
	         * Converts a UTF-8 string to a word array.
	         *
	         * @param {string} utf8Str The UTF-8 string.
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Utf8.parse(utf8String);
	         */
	        parse: function (utf8Str) {
	            return Latin1.parse(unescape(encodeURIComponent(utf8Str)));
	        }
	    };

	    /**
	     * Abstract buffered block algorithm template.
	     *
	     * The property blockSize must be implemented in a concrete subtype.
	     *
	     * @property {number} _minBufferSize The number of blocks that should be kept unprocessed in the buffer. Default: 0
	     */
	    var BufferedBlockAlgorithm = C_lib.BufferedBlockAlgorithm = Base.extend({
	        /**
	         * Resets this block algorithm's data buffer to its initial state.
	         *
	         * @example
	         *
	         *     bufferedBlockAlgorithm.reset();
	         */
	        reset: function () {
	            // Initial values
	            this._data = new WordArray.init();
	            this._nDataBytes = 0;
	        },

	        /**
	         * Adds new data to this block algorithm's buffer.
	         *
	         * @param {WordArray|string} data The data to append. Strings are converted to a WordArray using UTF-8.
	         *
	         * @example
	         *
	         *     bufferedBlockAlgorithm._append('data');
	         *     bufferedBlockAlgorithm._append(wordArray);
	         */
	        _append: function (data) {
	            // Convert string to WordArray, else assume WordArray already
	            if (typeof data == 'string') {
	                data = Utf8.parse(data);
	            }

	            // Append
	            this._data.concat(data);
	            this._nDataBytes += data.sigBytes;
	        },

	        /**
	         * Processes available data blocks.
	         *
	         * This method invokes _doProcessBlock(offset), which must be implemented by a concrete subtype.
	         *
	         * @param {boolean} doFlush Whether all blocks and partial blocks should be processed.
	         *
	         * @return {WordArray} The processed data.
	         *
	         * @example
	         *
	         *     var processedData = bufferedBlockAlgorithm._process();
	         *     var processedData = bufferedBlockAlgorithm._process(!!'flush');
	         */
	        _process: function (doFlush) {
	            // Shortcuts
	            var data = this._data;
	            var dataWords = data.words;
	            var dataSigBytes = data.sigBytes;
	            var blockSize = this.blockSize;
	            var blockSizeBytes = blockSize * 4;

	            // Count blocks ready
	            var nBlocksReady = dataSigBytes / blockSizeBytes;
	            if (doFlush) {
	                // Round up to include partial blocks
	                nBlocksReady = Math.ceil(nBlocksReady);
	            } else {
	                // Round down to include only full blocks,
	                // less the number of blocks that must remain in the buffer
	                nBlocksReady = Math.max((nBlocksReady | 0) - this._minBufferSize, 0);
	            }

	            // Count words ready
	            var nWordsReady = nBlocksReady * blockSize;

	            // Count bytes ready
	            var nBytesReady = Math.min(nWordsReady * 4, dataSigBytes);

	            // Process blocks
	            if (nWordsReady) {
	                for (var offset = 0; offset < nWordsReady; offset += blockSize) {
	                    // Perform concrete-algorithm logic
	                    this._doProcessBlock(dataWords, offset);
	                }

	                // Remove processed words
	                var processedWords = dataWords.splice(0, nWordsReady);
	                data.sigBytes -= nBytesReady;
	            }

	            // Return processed words
	            return new WordArray.init(processedWords, nBytesReady);
	        },

	        /**
	         * Creates a copy of this object.
	         *
	         * @return {Object} The clone.
	         *
	         * @example
	         *
	         *     var clone = bufferedBlockAlgorithm.clone();
	         */
	        clone: function () {
	            var clone = Base.clone.call(this);
	            clone._data = this._data.clone();

	            return clone;
	        },

	        _minBufferSize: 0
	    });

	    /**
	     * Abstract hasher template.
	     *
	     * @property {number} blockSize The number of 32-bit words this hasher operates on. Default: 16 (512 bits)
	     */
	    var Hasher = C_lib.Hasher = BufferedBlockAlgorithm.extend({
	        /**
	         * Configuration options.
	         */
	        cfg: Base.extend(),

	        /**
	         * Initializes a newly created hasher.
	         *
	         * @param {Object} cfg (Optional) The configuration options to use for this hash computation.
	         *
	         * @example
	         *
	         *     var hasher = CryptoJS.algo.SHA256.create();
	         */
	        init: function (cfg) {
	            // Apply config defaults
	            this.cfg = this.cfg.extend(cfg);

	            // Set initial values
	            this.reset();
	        },

	        /**
	         * Resets this hasher to its initial state.
	         *
	         * @example
	         *
	         *     hasher.reset();
	         */
	        reset: function () {
	            // Reset data buffer
	            BufferedBlockAlgorithm.reset.call(this);

	            // Perform concrete-hasher logic
	            this._doReset();
	        },

	        /**
	         * Updates this hasher with a message.
	         *
	         * @param {WordArray|string} messageUpdate The message to append.
	         *
	         * @return {Hasher} This hasher.
	         *
	         * @example
	         *
	         *     hasher.update('message');
	         *     hasher.update(wordArray);
	         */
	        update: function (messageUpdate) {
	            // Append
	            this._append(messageUpdate);

	            // Update the hash
	            this._process();

	            // Chainable
	            return this;
	        },

	        /**
	         * Finalizes the hash computation.
	         * Note that the finalize operation is effectively a destructive, read-once operation.
	         *
	         * @param {WordArray|string} messageUpdate (Optional) A final message update.
	         *
	         * @return {WordArray} The hash.
	         *
	         * @example
	         *
	         *     var hash = hasher.finalize();
	         *     var hash = hasher.finalize('message');
	         *     var hash = hasher.finalize(wordArray);
	         */
	        finalize: function (messageUpdate) {
	            // Final message update
	            if (messageUpdate) {
	                this._append(messageUpdate);
	            }

	            // Perform concrete-hasher logic
	            var hash = this._doFinalize();

	            return hash;
	        },

	        blockSize: 512/32,

	        /**
	         * Creates a shortcut function to a hasher's object interface.
	         *
	         * @param {Hasher} hasher The hasher to create a helper for.
	         *
	         * @return {Function} The shortcut function.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var SHA256 = CryptoJS.lib.Hasher._createHelper(CryptoJS.algo.SHA256);
	         */
	        _createHelper: function (hasher) {
	            return function (message, cfg) {
	                return new hasher.init(cfg).finalize(message);
	            };
	        },

	        /**
	         * Creates a shortcut function to the HMAC's object interface.
	         *
	         * @param {Hasher} hasher The hasher to use in this HMAC helper.
	         *
	         * @return {Function} The shortcut function.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var HmacSHA256 = CryptoJS.lib.Hasher._createHmacHelper(CryptoJS.algo.SHA256);
	         */
	        _createHmacHelper: function (hasher) {
	            return function (message, key) {
	                return new C_algo.HMAC.init(hasher, key).finalize(message);
	            };
	        }
	    });

	    /**
	     * Algorithm namespace.
	     */
	    var C_algo = C.algo = {};

	    return C;
	}(Math));


	return CryptoJS;

}));

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _createChainableTypeChecker = __webpack_require__(56);

var _createChainableTypeChecker2 = _interopRequireDefault(_createChainableTypeChecker);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function elementType(props, propName, componentName, location, propFullName) {
  var propValue = props[propName];
  var propType = typeof propValue === 'undefined' ? 'undefined' : _typeof(propValue);

  if (_react2.default.isValidElement(propValue)) {
    return new Error('Invalid ' + location + ' `' + propFullName + '` of type ReactElement ' + ('supplied to `' + componentName + '`, expected an element type (a string ') + 'or a ReactClass).');
  }

  if (propType !== 'function' && propType !== 'string') {
    return new Error('Invalid ' + location + ' `' + propFullName + '` of value `' + propValue + '` ' + ('supplied to `' + componentName + '`, expected an element type (a string ') + 'or a ReactClass).');
  }

  return null;
}

exports.default = (0, _createChainableTypeChecker2.default)(elementType);
module.exports = exports['default'];

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var warning = function() {};

if (false) {
  warning = function(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error(
        '`warning(condition, format, ...args)` requires a warning ' +
        'message argument'
      );
    }

    if (format.length < 10 || (/^[s\W]*$/).test(format)) {
      throw new Error(
        'The warning format should be able to uniquely identify this ' +
        'warning. Please, use a more descriptive format than: ' + format
      );
    }

    if (!condition) {
      var argIndex = 0;
      var message = 'Warning: ' +
        format.replace(/%s/g, function() {
          return args[argIndex++];
        });
      if (typeof console !== 'undefined') {
        console.error(message);
      }
      try {
        // This error was thrown as a convenience so that you can use this stack
        // to find the callsite that caused this warning to fire.
        throw new Error(message);
      } catch(x) {}
    }
  };
}

module.exports = warning;


/***/ }),
/* 12 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Safe chained function
 *
 * Will only create a new function if needed,
 * otherwise will pass back existing functions or null.
 *
 * @param {function} functions to chain
 * @returns {function|null}
 */
function createChainedFunction() {
  for (var _len = arguments.length, funcs = Array(_len), _key = 0; _key < _len; _key++) {
    funcs[_key] = arguments[_key];
  }

  return funcs.filter(function (f) {
    return f != null;
  }).reduce(function (acc, f) {
    if (typeof f !== 'function') {
      throw new Error('Invalid Argument Type, must only provide functions, undefined, or null.');
    }

    if (acc === null) {
      return f;
    }

    return function chainedFunction() {
      for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      acc.apply(this, args);
      f.apply(this, args);
    };
  }, null);
}

/* harmony default export */ __webpack_exports__["a"] = (createChainedFunction);

/***/ }),
/* 13 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Accordion__ = __webpack_require__(203);
/* unused harmony reexport Accordion */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Alert__ = __webpack_require__(241);
/* unused harmony reexport Alert */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Badge__ = __webpack_require__(244);
/* unused harmony reexport Badge */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Breadcrumb__ = __webpack_require__(245);
/* unused harmony reexport Breadcrumb */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__BreadcrumbItem__ = __webpack_require__(129);
/* unused harmony reexport BreadcrumbItem */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Button__ = __webpack_require__(48);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_5__Button__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ButtonGroup__ = __webpack_require__(91);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_6__ButtonGroup__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ButtonToolbar__ = __webpack_require__(246);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_7__ButtonToolbar__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Carousel__ = __webpack_require__(247);
/* unused harmony reexport Carousel */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__CarouselItem__ = __webpack_require__(130);
/* unused harmony reexport CarouselItem */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Checkbox__ = __webpack_require__(250);
/* unused harmony reexport Checkbox */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Clearfix__ = __webpack_require__(251);
/* unused harmony reexport Clearfix */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__CloseButton__ = __webpack_require__(90);
/* unused harmony reexport CloseButton */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__ControlLabel__ = __webpack_require__(252);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_13__ControlLabel__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__Col__ = __webpack_require__(253);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_14__Col__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__Collapse__ = __webpack_require__(93);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_15__Collapse__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__Dropdown__ = __webpack_require__(60);
/* unused harmony reexport Dropdown */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__DropdownButton__ = __webpack_require__(273);
/* unused harmony reexport DropdownButton */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__Fade__ = __webpack_require__(64);
/* unused harmony reexport Fade */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__Form__ = __webpack_require__(274);
/* unused harmony reexport Form */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__FormControl__ = __webpack_require__(275);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_20__FormControl__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__FormGroup__ = __webpack_require__(278);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_21__FormGroup__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__Glyphicon__ = __webpack_require__(92);
/* unused harmony reexport Glyphicon */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__Grid__ = __webpack_require__(136);
/* unused harmony reexport Grid */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__HelpBlock__ = __webpack_require__(279);
/* unused harmony reexport HelpBlock */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__Image__ = __webpack_require__(280);
/* unused harmony reexport Image */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__InputGroup__ = __webpack_require__(281);
/* unused harmony reexport InputGroup */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__Jumbotron__ = __webpack_require__(284);
/* unused harmony reexport Jumbotron */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__Label__ = __webpack_require__(285);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_28__Label__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__ListGroup__ = __webpack_require__(286);
/* unused harmony reexport ListGroup */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__ListGroupItem__ = __webpack_require__(137);
/* unused harmony reexport ListGroupItem */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__Media__ = __webpack_require__(98);
/* unused harmony reexport Media */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__MenuItem__ = __webpack_require__(293);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return __WEBPACK_IMPORTED_MODULE_32__MenuItem__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__Modal__ = __webpack_require__(294);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return __WEBPACK_IMPORTED_MODULE_33__Modal__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__ModalBody__ = __webpack_require__(142);
/* unused harmony reexport ModalBody */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__ModalFooter__ = __webpack_require__(143);
/* unused harmony reexport ModalFooter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__ModalHeader__ = __webpack_require__(144);
/* unused harmony reexport ModalHeader */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__ModalTitle__ = __webpack_require__(145);
/* unused harmony reexport ModalTitle */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__Nav__ = __webpack_require__(146);
/* unused harmony reexport Nav */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__Navbar__ = __webpack_require__(307);
/* unused harmony reexport Navbar */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__NavbarBrand__ = __webpack_require__(147);
/* unused harmony reexport NavbarBrand */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__NavDropdown__ = __webpack_require__(311);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return __WEBPACK_IMPORTED_MODULE_41__NavDropdown__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__NavItem__ = __webpack_require__(148);
/* unused harmony reexport NavItem */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__Overlay__ = __webpack_require__(149);
/* unused harmony reexport Overlay */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__OverlayTrigger__ = __webpack_require__(315);
/* unused harmony reexport OverlayTrigger */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__PageHeader__ = __webpack_require__(316);
/* unused harmony reexport PageHeader */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46__PageItem__ = __webpack_require__(317);
/* unused harmony reexport PageItem */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47__Pager__ = __webpack_require__(319);
/* unused harmony reexport Pager */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48__Pagination__ = __webpack_require__(320);
/* unused harmony reexport Pagination */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49__PaginationButton__ = __webpack_require__(154);
/* unused harmony reexport PaginationButton */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50__Panel__ = __webpack_require__(321);
/* unused harmony reexport Panel */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_51__PanelGroup__ = __webpack_require__(125);
/* unused harmony reexport PanelGroup */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_52__Popover__ = __webpack_require__(322);
/* unused harmony reexport Popover */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_53__ProgressBar__ = __webpack_require__(323);
/* unused harmony reexport ProgressBar */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_54__Radio__ = __webpack_require__(324);
/* unused harmony reexport Radio */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_55__ResponsiveEmbed__ = __webpack_require__(325);
/* unused harmony reexport ResponsiveEmbed */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_56__Row__ = __webpack_require__(326);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return __WEBPACK_IMPORTED_MODULE_56__Row__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_57__SafeAnchor__ = __webpack_require__(21);
/* unused harmony reexport SafeAnchor */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_58__SplitButton__ = __webpack_require__(327);
/* unused harmony reexport SplitButton */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_59__Tab__ = __webpack_require__(329);
/* unused harmony reexport Tab */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_60__TabContainer__ = __webpack_require__(101);
/* unused harmony reexport TabContainer */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_61__TabContent__ = __webpack_require__(102);
/* unused harmony reexport TabContent */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_62__Table__ = __webpack_require__(330);
/* unused harmony reexport Table */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_63__TabPane__ = __webpack_require__(155);
/* unused harmony reexport TabPane */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_64__Tabs__ = __webpack_require__(331);
/* unused harmony reexport Tabs */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_65__Thumbnail__ = __webpack_require__(332);
/* unused harmony reexport Thumbnail */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_66__ToggleButton__ = __webpack_require__(156);
/* unused harmony reexport ToggleButton */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_67__ToggleButtonGroup__ = __webpack_require__(333);
/* unused harmony reexport ToggleButtonGroup */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_68__Tooltip__ = __webpack_require__(334);
/* unused harmony reexport Tooltip */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_69__Well__ = __webpack_require__(335);
/* unused harmony reexport Well */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_70__utils__ = __webpack_require__(336);
/* unused harmony reexport utils */















































































































































/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory, undef) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(9), __webpack_require__(33));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core", "./evpkdf"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	/**
	 * Cipher core components.
	 */
	CryptoJS.lib.Cipher || (function (undefined) {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var Base = C_lib.Base;
	    var WordArray = C_lib.WordArray;
	    var BufferedBlockAlgorithm = C_lib.BufferedBlockAlgorithm;
	    var C_enc = C.enc;
	    var Utf8 = C_enc.Utf8;
	    var Base64 = C_enc.Base64;
	    var C_algo = C.algo;
	    var EvpKDF = C_algo.EvpKDF;

	    /**
	     * Abstract base cipher template.
	     *
	     * @property {number} keySize This cipher's key size. Default: 4 (128 bits)
	     * @property {number} ivSize This cipher's IV size. Default: 4 (128 bits)
	     * @property {number} _ENC_XFORM_MODE A constant representing encryption mode.
	     * @property {number} _DEC_XFORM_MODE A constant representing decryption mode.
	     */
	    var Cipher = C_lib.Cipher = BufferedBlockAlgorithm.extend({
	        /**
	         * Configuration options.
	         *
	         * @property {WordArray} iv The IV to use for this operation.
	         */
	        cfg: Base.extend(),

	        /**
	         * Creates this cipher in encryption mode.
	         *
	         * @param {WordArray} key The key.
	         * @param {Object} cfg (Optional) The configuration options to use for this operation.
	         *
	         * @return {Cipher} A cipher instance.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var cipher = CryptoJS.algo.AES.createEncryptor(keyWordArray, { iv: ivWordArray });
	         */
	        createEncryptor: function (key, cfg) {
	            return this.create(this._ENC_XFORM_MODE, key, cfg);
	        },

	        /**
	         * Creates this cipher in decryption mode.
	         *
	         * @param {WordArray} key The key.
	         * @param {Object} cfg (Optional) The configuration options to use for this operation.
	         *
	         * @return {Cipher} A cipher instance.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var cipher = CryptoJS.algo.AES.createDecryptor(keyWordArray, { iv: ivWordArray });
	         */
	        createDecryptor: function (key, cfg) {
	            return this.create(this._DEC_XFORM_MODE, key, cfg);
	        },

	        /**
	         * Initializes a newly created cipher.
	         *
	         * @param {number} xformMode Either the encryption or decryption transormation mode constant.
	         * @param {WordArray} key The key.
	         * @param {Object} cfg (Optional) The configuration options to use for this operation.
	         *
	         * @example
	         *
	         *     var cipher = CryptoJS.algo.AES.create(CryptoJS.algo.AES._ENC_XFORM_MODE, keyWordArray, { iv: ivWordArray });
	         */
	        init: function (xformMode, key, cfg) {
	            // Apply config defaults
	            this.cfg = this.cfg.extend(cfg);

	            // Store transform mode and key
	            this._xformMode = xformMode;
	            this._key = key;

	            // Set initial values
	            this.reset();
	        },

	        /**
	         * Resets this cipher to its initial state.
	         *
	         * @example
	         *
	         *     cipher.reset();
	         */
	        reset: function () {
	            // Reset data buffer
	            BufferedBlockAlgorithm.reset.call(this);

	            // Perform concrete-cipher logic
	            this._doReset();
	        },

	        /**
	         * Adds data to be encrypted or decrypted.
	         *
	         * @param {WordArray|string} dataUpdate The data to encrypt or decrypt.
	         *
	         * @return {WordArray} The data after processing.
	         *
	         * @example
	         *
	         *     var encrypted = cipher.process('data');
	         *     var encrypted = cipher.process(wordArray);
	         */
	        process: function (dataUpdate) {
	            // Append
	            this._append(dataUpdate);

	            // Process available blocks
	            return this._process();
	        },

	        /**
	         * Finalizes the encryption or decryption process.
	         * Note that the finalize operation is effectively a destructive, read-once operation.
	         *
	         * @param {WordArray|string} dataUpdate The final data to encrypt or decrypt.
	         *
	         * @return {WordArray} The data after final processing.
	         *
	         * @example
	         *
	         *     var encrypted = cipher.finalize();
	         *     var encrypted = cipher.finalize('data');
	         *     var encrypted = cipher.finalize(wordArray);
	         */
	        finalize: function (dataUpdate) {
	            // Final data update
	            if (dataUpdate) {
	                this._append(dataUpdate);
	            }

	            // Perform concrete-cipher logic
	            var finalProcessedData = this._doFinalize();

	            return finalProcessedData;
	        },

	        keySize: 128/32,

	        ivSize: 128/32,

	        _ENC_XFORM_MODE: 1,

	        _DEC_XFORM_MODE: 2,

	        /**
	         * Creates shortcut functions to a cipher's object interface.
	         *
	         * @param {Cipher} cipher The cipher to create a helper for.
	         *
	         * @return {Object} An object with encrypt and decrypt shortcut functions.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var AES = CryptoJS.lib.Cipher._createHelper(CryptoJS.algo.AES);
	         */
	        _createHelper: (function () {
	            function selectCipherStrategy(key) {
	                if (typeof key == 'string') {
	                    return PasswordBasedCipher;
	                } else {
	                    return SerializableCipher;
	                }
	            }

	            return function (cipher) {
	                return {
	                    encrypt: function (message, key, cfg) {
	                        return selectCipherStrategy(key).encrypt(cipher, message, key, cfg);
	                    },

	                    decrypt: function (ciphertext, key, cfg) {
	                        return selectCipherStrategy(key).decrypt(cipher, ciphertext, key, cfg);
	                    }
	                };
	            };
	        }())
	    });

	    /**
	     * Abstract base stream cipher template.
	     *
	     * @property {number} blockSize The number of 32-bit words this cipher operates on. Default: 1 (32 bits)
	     */
	    var StreamCipher = C_lib.StreamCipher = Cipher.extend({
	        _doFinalize: function () {
	            // Process partial blocks
	            var finalProcessedBlocks = this._process(!!'flush');

	            return finalProcessedBlocks;
	        },

	        blockSize: 1
	    });

	    /**
	     * Mode namespace.
	     */
	    var C_mode = C.mode = {};

	    /**
	     * Abstract base block cipher mode template.
	     */
	    var BlockCipherMode = C_lib.BlockCipherMode = Base.extend({
	        /**
	         * Creates this mode for encryption.
	         *
	         * @param {Cipher} cipher A block cipher instance.
	         * @param {Array} iv The IV words.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var mode = CryptoJS.mode.CBC.createEncryptor(cipher, iv.words);
	         */
	        createEncryptor: function (cipher, iv) {
	            return this.Encryptor.create(cipher, iv);
	        },

	        /**
	         * Creates this mode for decryption.
	         *
	         * @param {Cipher} cipher A block cipher instance.
	         * @param {Array} iv The IV words.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var mode = CryptoJS.mode.CBC.createDecryptor(cipher, iv.words);
	         */
	        createDecryptor: function (cipher, iv) {
	            return this.Decryptor.create(cipher, iv);
	        },

	        /**
	         * Initializes a newly created mode.
	         *
	         * @param {Cipher} cipher A block cipher instance.
	         * @param {Array} iv The IV words.
	         *
	         * @example
	         *
	         *     var mode = CryptoJS.mode.CBC.Encryptor.create(cipher, iv.words);
	         */
	        init: function (cipher, iv) {
	            this._cipher = cipher;
	            this._iv = iv;
	        }
	    });

	    /**
	     * Cipher Block Chaining mode.
	     */
	    var CBC = C_mode.CBC = (function () {
	        /**
	         * Abstract base CBC mode.
	         */
	        var CBC = BlockCipherMode.extend();

	        /**
	         * CBC encryptor.
	         */
	        CBC.Encryptor = CBC.extend({
	            /**
	             * Processes the data block at offset.
	             *
	             * @param {Array} words The data words to operate on.
	             * @param {number} offset The offset where the block starts.
	             *
	             * @example
	             *
	             *     mode.processBlock(data.words, offset);
	             */
	            processBlock: function (words, offset) {
	                // Shortcuts
	                var cipher = this._cipher;
	                var blockSize = cipher.blockSize;

	                // XOR and encrypt
	                xorBlock.call(this, words, offset, blockSize);
	                cipher.encryptBlock(words, offset);

	                // Remember this block to use with next block
	                this._prevBlock = words.slice(offset, offset + blockSize);
	            }
	        });

	        /**
	         * CBC decryptor.
	         */
	        CBC.Decryptor = CBC.extend({
	            /**
	             * Processes the data block at offset.
	             *
	             * @param {Array} words The data words to operate on.
	             * @param {number} offset The offset where the block starts.
	             *
	             * @example
	             *
	             *     mode.processBlock(data.words, offset);
	             */
	            processBlock: function (words, offset) {
	                // Shortcuts
	                var cipher = this._cipher;
	                var blockSize = cipher.blockSize;

	                // Remember this block to use with next block
	                var thisBlock = words.slice(offset, offset + blockSize);

	                // Decrypt and XOR
	                cipher.decryptBlock(words, offset);
	                xorBlock.call(this, words, offset, blockSize);

	                // This block becomes the previous block
	                this._prevBlock = thisBlock;
	            }
	        });

	        function xorBlock(words, offset, blockSize) {
	            // Shortcut
	            var iv = this._iv;

	            // Choose mixing block
	            if (iv) {
	                var block = iv;

	                // Remove IV for subsequent blocks
	                this._iv = undefined;
	            } else {
	                var block = this._prevBlock;
	            }

	            // XOR blocks
	            for (var i = 0; i < blockSize; i++) {
	                words[offset + i] ^= block[i];
	            }
	        }

	        return CBC;
	    }());

	    /**
	     * Padding namespace.
	     */
	    var C_pad = C.pad = {};

	    /**
	     * PKCS #5/7 padding strategy.
	     */
	    var Pkcs7 = C_pad.Pkcs7 = {
	        /**
	         * Pads data using the algorithm defined in PKCS #5/7.
	         *
	         * @param {WordArray} data The data to pad.
	         * @param {number} blockSize The multiple that the data should be padded to.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     CryptoJS.pad.Pkcs7.pad(wordArray, 4);
	         */
	        pad: function (data, blockSize) {
	            // Shortcut
	            var blockSizeBytes = blockSize * 4;

	            // Count padding bytes
	            var nPaddingBytes = blockSizeBytes - data.sigBytes % blockSizeBytes;

	            // Create padding word
	            var paddingWord = (nPaddingBytes << 24) | (nPaddingBytes << 16) | (nPaddingBytes << 8) | nPaddingBytes;

	            // Create padding
	            var paddingWords = [];
	            for (var i = 0; i < nPaddingBytes; i += 4) {
	                paddingWords.push(paddingWord);
	            }
	            var padding = WordArray.create(paddingWords, nPaddingBytes);

	            // Add padding
	            data.concat(padding);
	        },

	        /**
	         * Unpads data that had been padded using the algorithm defined in PKCS #5/7.
	         *
	         * @param {WordArray} data The data to unpad.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     CryptoJS.pad.Pkcs7.unpad(wordArray);
	         */
	        unpad: function (data) {
	            // Get number of padding bytes from last byte
	            var nPaddingBytes = data.words[(data.sigBytes - 1) >>> 2] & 0xff;

	            // Remove padding
	            data.sigBytes -= nPaddingBytes;
	        }
	    };

	    /**
	     * Abstract base block cipher template.
	     *
	     * @property {number} blockSize The number of 32-bit words this cipher operates on. Default: 4 (128 bits)
	     */
	    var BlockCipher = C_lib.BlockCipher = Cipher.extend({
	        /**
	         * Configuration options.
	         *
	         * @property {Mode} mode The block mode to use. Default: CBC
	         * @property {Padding} padding The padding strategy to use. Default: Pkcs7
	         */
	        cfg: Cipher.cfg.extend({
	            mode: CBC,
	            padding: Pkcs7
	        }),

	        reset: function () {
	            // Reset cipher
	            Cipher.reset.call(this);

	            // Shortcuts
	            var cfg = this.cfg;
	            var iv = cfg.iv;
	            var mode = cfg.mode;

	            // Reset block mode
	            if (this._xformMode == this._ENC_XFORM_MODE) {
	                var modeCreator = mode.createEncryptor;
	            } else /* if (this._xformMode == this._DEC_XFORM_MODE) */ {
	                var modeCreator = mode.createDecryptor;
	                // Keep at least one block in the buffer for unpadding
	                this._minBufferSize = 1;
	            }

	            if (this._mode && this._mode.__creator == modeCreator) {
	                this._mode.init(this, iv && iv.words);
	            } else {
	                this._mode = modeCreator.call(mode, this, iv && iv.words);
	                this._mode.__creator = modeCreator;
	            }
	        },

	        _doProcessBlock: function (words, offset) {
	            this._mode.processBlock(words, offset);
	        },

	        _doFinalize: function () {
	            // Shortcut
	            var padding = this.cfg.padding;

	            // Finalize
	            if (this._xformMode == this._ENC_XFORM_MODE) {
	                // Pad data
	                padding.pad(this._data, this.blockSize);

	                // Process final blocks
	                var finalProcessedBlocks = this._process(!!'flush');
	            } else /* if (this._xformMode == this._DEC_XFORM_MODE) */ {
	                // Process final blocks
	                var finalProcessedBlocks = this._process(!!'flush');

	                // Unpad data
	                padding.unpad(finalProcessedBlocks);
	            }

	            return finalProcessedBlocks;
	        },

	        blockSize: 128/32
	    });

	    /**
	     * A collection of cipher parameters.
	     *
	     * @property {WordArray} ciphertext The raw ciphertext.
	     * @property {WordArray} key The key to this ciphertext.
	     * @property {WordArray} iv The IV used in the ciphering operation.
	     * @property {WordArray} salt The salt used with a key derivation function.
	     * @property {Cipher} algorithm The cipher algorithm.
	     * @property {Mode} mode The block mode used in the ciphering operation.
	     * @property {Padding} padding The padding scheme used in the ciphering operation.
	     * @property {number} blockSize The block size of the cipher.
	     * @property {Format} formatter The default formatting strategy to convert this cipher params object to a string.
	     */
	    var CipherParams = C_lib.CipherParams = Base.extend({
	        /**
	         * Initializes a newly created cipher params object.
	         *
	         * @param {Object} cipherParams An object with any of the possible cipher parameters.
	         *
	         * @example
	         *
	         *     var cipherParams = CryptoJS.lib.CipherParams.create({
	         *         ciphertext: ciphertextWordArray,
	         *         key: keyWordArray,
	         *         iv: ivWordArray,
	         *         salt: saltWordArray,
	         *         algorithm: CryptoJS.algo.AES,
	         *         mode: CryptoJS.mode.CBC,
	         *         padding: CryptoJS.pad.PKCS7,
	         *         blockSize: 4,
	         *         formatter: CryptoJS.format.OpenSSL
	         *     });
	         */
	        init: function (cipherParams) {
	            this.mixIn(cipherParams);
	        },

	        /**
	         * Converts this cipher params object to a string.
	         *
	         * @param {Format} formatter (Optional) The formatting strategy to use.
	         *
	         * @return {string} The stringified cipher params.
	         *
	         * @throws Error If neither the formatter nor the default formatter is set.
	         *
	         * @example
	         *
	         *     var string = cipherParams + '';
	         *     var string = cipherParams.toString();
	         *     var string = cipherParams.toString(CryptoJS.format.OpenSSL);
	         */
	        toString: function (formatter) {
	            return (formatter || this.formatter).stringify(this);
	        }
	    });

	    /**
	     * Format namespace.
	     */
	    var C_format = C.format = {};

	    /**
	     * OpenSSL formatting strategy.
	     */
	    var OpenSSLFormatter = C_format.OpenSSL = {
	        /**
	         * Converts a cipher params object to an OpenSSL-compatible string.
	         *
	         * @param {CipherParams} cipherParams The cipher params object.
	         *
	         * @return {string} The OpenSSL-compatible string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var openSSLString = CryptoJS.format.OpenSSL.stringify(cipherParams);
	         */
	        stringify: function (cipherParams) {
	            // Shortcuts
	            var ciphertext = cipherParams.ciphertext;
	            var salt = cipherParams.salt;

	            // Format
	            if (salt) {
	                var wordArray = WordArray.create([0x53616c74, 0x65645f5f]).concat(salt).concat(ciphertext);
	            } else {
	                var wordArray = ciphertext;
	            }

	            return wordArray.toString(Base64);
	        },

	        /**
	         * Converts an OpenSSL-compatible string to a cipher params object.
	         *
	         * @param {string} openSSLStr The OpenSSL-compatible string.
	         *
	         * @return {CipherParams} The cipher params object.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var cipherParams = CryptoJS.format.OpenSSL.parse(openSSLString);
	         */
	        parse: function (openSSLStr) {
	            // Parse base64
	            var ciphertext = Base64.parse(openSSLStr);

	            // Shortcut
	            var ciphertextWords = ciphertext.words;

	            // Test for salt
	            if (ciphertextWords[0] == 0x53616c74 && ciphertextWords[1] == 0x65645f5f) {
	                // Extract salt
	                var salt = WordArray.create(ciphertextWords.slice(2, 4));

	                // Remove salt from ciphertext
	                ciphertextWords.splice(0, 4);
	                ciphertext.sigBytes -= 16;
	            }

	            return CipherParams.create({ ciphertext: ciphertext, salt: salt });
	        }
	    };

	    /**
	     * A cipher wrapper that returns ciphertext as a serializable cipher params object.
	     */
	    var SerializableCipher = C_lib.SerializableCipher = Base.extend({
	        /**
	         * Configuration options.
	         *
	         * @property {Formatter} format The formatting strategy to convert cipher param objects to and from a string. Default: OpenSSL
	         */
	        cfg: Base.extend({
	            format: OpenSSLFormatter
	        }),

	        /**
	         * Encrypts a message.
	         *
	         * @param {Cipher} cipher The cipher algorithm to use.
	         * @param {WordArray|string} message The message to encrypt.
	         * @param {WordArray} key The key.
	         * @param {Object} cfg (Optional) The configuration options to use for this operation.
	         *
	         * @return {CipherParams} A cipher params object.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var ciphertextParams = CryptoJS.lib.SerializableCipher.encrypt(CryptoJS.algo.AES, message, key);
	         *     var ciphertextParams = CryptoJS.lib.SerializableCipher.encrypt(CryptoJS.algo.AES, message, key, { iv: iv });
	         *     var ciphertextParams = CryptoJS.lib.SerializableCipher.encrypt(CryptoJS.algo.AES, message, key, { iv: iv, format: CryptoJS.format.OpenSSL });
	         */
	        encrypt: function (cipher, message, key, cfg) {
	            // Apply config defaults
	            cfg = this.cfg.extend(cfg);

	            // Encrypt
	            var encryptor = cipher.createEncryptor(key, cfg);
	            var ciphertext = encryptor.finalize(message);

	            // Shortcut
	            var cipherCfg = encryptor.cfg;

	            // Create and return serializable cipher params
	            return CipherParams.create({
	                ciphertext: ciphertext,
	                key: key,
	                iv: cipherCfg.iv,
	                algorithm: cipher,
	                mode: cipherCfg.mode,
	                padding: cipherCfg.padding,
	                blockSize: cipher.blockSize,
	                formatter: cfg.format
	            });
	        },

	        /**
	         * Decrypts serialized ciphertext.
	         *
	         * @param {Cipher} cipher The cipher algorithm to use.
	         * @param {CipherParams|string} ciphertext The ciphertext to decrypt.
	         * @param {WordArray} key The key.
	         * @param {Object} cfg (Optional) The configuration options to use for this operation.
	         *
	         * @return {WordArray} The plaintext.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var plaintext = CryptoJS.lib.SerializableCipher.decrypt(CryptoJS.algo.AES, formattedCiphertext, key, { iv: iv, format: CryptoJS.format.OpenSSL });
	         *     var plaintext = CryptoJS.lib.SerializableCipher.decrypt(CryptoJS.algo.AES, ciphertextParams, key, { iv: iv, format: CryptoJS.format.OpenSSL });
	         */
	        decrypt: function (cipher, ciphertext, key, cfg) {
	            // Apply config defaults
	            cfg = this.cfg.extend(cfg);

	            // Convert string to CipherParams
	            ciphertext = this._parse(ciphertext, cfg.format);

	            // Decrypt
	            var plaintext = cipher.createDecryptor(key, cfg).finalize(ciphertext.ciphertext);

	            return plaintext;
	        },

	        /**
	         * Converts serialized ciphertext to CipherParams,
	         * else assumed CipherParams already and returns ciphertext unchanged.
	         *
	         * @param {CipherParams|string} ciphertext The ciphertext.
	         * @param {Formatter} format The formatting strategy to use to parse serialized ciphertext.
	         *
	         * @return {CipherParams} The unserialized ciphertext.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var ciphertextParams = CryptoJS.lib.SerializableCipher._parse(ciphertextStringOrParams, format);
	         */
	        _parse: function (ciphertext, format) {
	            if (typeof ciphertext == 'string') {
	                return format.parse(ciphertext, this);
	            } else {
	                return ciphertext;
	            }
	        }
	    });

	    /**
	     * Key derivation function namespace.
	     */
	    var C_kdf = C.kdf = {};

	    /**
	     * OpenSSL key derivation function.
	     */
	    var OpenSSLKdf = C_kdf.OpenSSL = {
	        /**
	         * Derives a key and IV from a password.
	         *
	         * @param {string} password The password to derive from.
	         * @param {number} keySize The size in words of the key to generate.
	         * @param {number} ivSize The size in words of the IV to generate.
	         * @param {WordArray|string} salt (Optional) A 64-bit salt to use. If omitted, a salt will be generated randomly.
	         *
	         * @return {CipherParams} A cipher params object with the key, IV, and salt.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var derivedParams = CryptoJS.kdf.OpenSSL.execute('Password', 256/32, 128/32);
	         *     var derivedParams = CryptoJS.kdf.OpenSSL.execute('Password', 256/32, 128/32, 'saltsalt');
	         */
	        execute: function (password, keySize, ivSize, salt) {
	            // Generate random salt
	            if (!salt) {
	                salt = WordArray.random(64/8);
	            }

	            // Derive key and IV
	            var key = EvpKDF.create({ keySize: keySize + ivSize }).compute(password, salt);

	            // Separate key and IV
	            var iv = WordArray.create(key.words.slice(keySize), ivSize * 4);
	            key.sigBytes = keySize * 4;

	            // Return params
	            return CipherParams.create({ key: key, iv: iv, salt: salt });
	        }
	    };

	    /**
	     * A serializable cipher wrapper that derives the key from a password,
	     * and returns ciphertext as a serializable cipher params object.
	     */
	    var PasswordBasedCipher = C_lib.PasswordBasedCipher = SerializableCipher.extend({
	        /**
	         * Configuration options.
	         *
	         * @property {KDF} kdf The key derivation function to use to generate a key and IV from a password. Default: OpenSSL
	         */
	        cfg: SerializableCipher.cfg.extend({
	            kdf: OpenSSLKdf
	        }),

	        /**
	         * Encrypts a message using a password.
	         *
	         * @param {Cipher} cipher The cipher algorithm to use.
	         * @param {WordArray|string} message The message to encrypt.
	         * @param {string} password The password.
	         * @param {Object} cfg (Optional) The configuration options to use for this operation.
	         *
	         * @return {CipherParams} A cipher params object.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var ciphertextParams = CryptoJS.lib.PasswordBasedCipher.encrypt(CryptoJS.algo.AES, message, 'password');
	         *     var ciphertextParams = CryptoJS.lib.PasswordBasedCipher.encrypt(CryptoJS.algo.AES, message, 'password', { format: CryptoJS.format.OpenSSL });
	         */
	        encrypt: function (cipher, message, password, cfg) {
	            // Apply config defaults
	            cfg = this.cfg.extend(cfg);

	            // Derive key and other params
	            var derivedParams = cfg.kdf.execute(password, cipher.keySize, cipher.ivSize);

	            // Add IV to config
	            cfg.iv = derivedParams.iv;

	            // Encrypt
	            var ciphertext = SerializableCipher.encrypt.call(this, cipher, message, derivedParams.key, cfg);

	            // Mix in derived params
	            ciphertext.mixIn(derivedParams);

	            return ciphertext;
	        },

	        /**
	         * Decrypts serialized ciphertext using a password.
	         *
	         * @param {Cipher} cipher The cipher algorithm to use.
	         * @param {CipherParams|string} ciphertext The ciphertext to decrypt.
	         * @param {string} password The password.
	         * @param {Object} cfg (Optional) The configuration options to use for this operation.
	         *
	         * @return {WordArray} The plaintext.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var plaintext = CryptoJS.lib.PasswordBasedCipher.decrypt(CryptoJS.algo.AES, formattedCiphertext, 'password', { format: CryptoJS.format.OpenSSL });
	         *     var plaintext = CryptoJS.lib.PasswordBasedCipher.decrypt(CryptoJS.algo.AES, ciphertextParams, 'password', { format: CryptoJS.format.OpenSSL });
	         */
	        decrypt: function (cipher, ciphertext, password, cfg) {
	            // Apply config defaults
	            cfg = this.cfg.extend(cfg);

	            // Convert string to CipherParams
	            ciphertext = this._parse(ciphertext, cfg.format);

	            // Derive key and other params
	            var derivedParams = cfg.kdf.execute(password, cipher.keySize, cipher.ivSize, ciphertext.salt);

	            // Add IV to config
	            cfg.iv = derivedParams.iv;

	            // Decrypt
	            var plaintext = SerializableCipher.decrypt.call(this, cipher, ciphertext, derivedParams.key, cfg);

	            return plaintext;
	        }
	    });
	}());


}));

/***/ }),
/* 15 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return Size; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SIZE_MAP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DEVICE_SIZES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return State; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return Style; });
var Size = {
  LARGE: 'large',
  SMALL: 'small',
  XSMALL: 'xsmall'
};

var SIZE_MAP = {
  large: 'lg',
  medium: 'md',
  small: 'sm',
  xsmall: 'xs',
  lg: 'lg',
  md: 'md',
  sm: 'sm',
  xs: 'xs'
};

var DEVICE_SIZES = ['lg', 'md', 'sm', 'xs'];

var State = {
  SUCCESS: 'success',
  WARNING: 'warning',
  DANGER: 'danger',
  INFO: 'info'
};

var Style = {
  DEFAULT: 'default',
  PRIMARY: 'primary',
  LINK: 'link',
  INVERSE: 'inverse'
};

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function checkDCE() {
  /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */
  if (
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' ||
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function'
  ) {
    return;
  }
  if (false) {
    // This branch is unreachable because this function is only called
    // in production, but the condition is true only in development.
    // Therefore if the branch is still here, dead code elimination wasn't
    // properly applied.
    // Don't change the message. React DevTools relies on it. Also make sure
    // this message doesn't occur elsewhere in this function, or it will cause
    // a false positive.
    throw new Error('^_^');
  }
  try {
    // Verify that the code above has been dead code eliminated (DCE'd).
    __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(checkDCE);
  } catch (err) {
    // DevTools shouldn't crash React, no matter what.
    // We should still report in case we break this code.
    console.error(err);
  }
}

if (true) {
  // DCE check should happen before ReactDOM bundle executes so that
  // DevTools can report bad minification during injection.
  checkDCE();
  module.exports = __webpack_require__(192);
} else {
  module.exports = require('./cjs/react-dom.development.js');
}


/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var invariant = function(condition, format, a, b, c, d, e, f) {
  if (false) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  }

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error(
        'Minified exception occurred; use the non-minified dev environment ' +
        'for the full error message and additional helpful warnings.'
      );
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(
        format.replace(/%s/g, function() { return args[argIndex++]; })
      );
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
};

module.exports = invariant;


/***/ }),
/* 18 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
// TODO: This module should be ElementChildren, and should use named exports.



/**
 * Iterates through children that are typically specified as `props.children`,
 * but only maps over children that are "valid components".
 *
 * The mapFunction provided index will be normalised to the components mapped,
 * so an invalid component would not increase the index.
 *
 * @param {?*} children Children tree container.
 * @param {function(*, int)} func.
 * @param {*} context Context for func.
 * @return {object} Object containing the ordered map of results.
 */
function map(children, func, context) {
  var index = 0;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.map(children, function (child) {
    if (!__WEBPACK_IMPORTED_MODULE_0_react___default.a.isValidElement(child)) {
      return child;
    }

    return func.call(context, child, index++);
  });
}

/**
 * Iterates through children that are "valid components".
 *
 * The provided forEachFunc(child, index) will be called for each
 * leaf child with the index reflecting the position relative to "valid components".
 *
 * @param {?*} children Children tree container.
 * @param {function(*, int)} func.
 * @param {*} context Context for context.
 */
function forEach(children, func, context) {
  var index = 0;

  __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.forEach(children, function (child) {
    if (!__WEBPACK_IMPORTED_MODULE_0_react___default.a.isValidElement(child)) {
      return;
    }

    func.call(context, child, index++);
  });
}

/**
 * Count the number of "valid components" in the Children container.
 *
 * @param {?*} children Children tree container.
 * @returns {number}
 */
function count(children) {
  var result = 0;

  __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.forEach(children, function (child) {
    if (!__WEBPACK_IMPORTED_MODULE_0_react___default.a.isValidElement(child)) {
      return;
    }

    ++result;
  });

  return result;
}

/**
 * Finds children that are typically specified as `props.children`,
 * but only iterates over children that are "valid components".
 *
 * The provided forEachFunc(child, index) will be called for each
 * leaf child with the index reflecting the position relative to "valid components".
 *
 * @param {?*} children Children tree container.
 * @param {function(*, int)} func.
 * @param {*} context Context for func.
 * @returns {array} of children that meet the func return statement
 */
function filter(children, func, context) {
  var index = 0;
  var result = [];

  __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.forEach(children, function (child) {
    if (!__WEBPACK_IMPORTED_MODULE_0_react___default.a.isValidElement(child)) {
      return;
    }

    if (func.call(context, child, index++)) {
      result.push(child);
    }
  });

  return result;
}

function find(children, func, context) {
  var index = 0;
  var result = undefined;

  __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.forEach(children, function (child) {
    if (result) {
      return;
    }
    if (!__WEBPACK_IMPORTED_MODULE_0_react___default.a.isValidElement(child)) {
      return;
    }

    if (func.call(context, child, index++)) {
      result = child;
    }
  });

  return result;
}

function every(children, func, context) {
  var index = 0;
  var result = true;

  __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.forEach(children, function (child) {
    if (!result) {
      return;
    }
    if (!__WEBPACK_IMPORTED_MODULE_0_react___default.a.isValidElement(child)) {
      return;
    }

    if (!func.call(context, child, index++)) {
      result = false;
    }
  });

  return result;
}

function some(children, func, context) {
  var index = 0;
  var result = false;

  __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.forEach(children, function (child) {
    if (result) {
      return;
    }
    if (!__WEBPACK_IMPORTED_MODULE_0_react___default.a.isValidElement(child)) {
      return;
    }

    if (func.call(context, child, index++)) {
      result = true;
    }
  });

  return result;
}

function toArray(children) {
  var result = [];

  __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.forEach(children, function (child) {
    if (!__WEBPACK_IMPORTED_MODULE_0_react___default.a.isValidElement(child)) {
      return;
    }

    result.push(child);
  });

  return result;
}

/* harmony default export */ __webpack_exports__["a"] = ({
  map: map,
  forEach: forEach,
  count: count,
  find: find,
  filter: filter,
  every: every,
  some: some,
  toArray: toArray
});

/***/ }),
/* 19 */
/***/ (function(module, exports) {

var core = module.exports = { version: '2.5.1' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

var store = __webpack_require__(80)('wks');
var uid = __webpack_require__(55);
var Symbol = __webpack_require__(26).Symbol;
var USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function (name) {
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};

$exports.store = store;


/***/ }),
/* 21 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_elementType__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_elementType___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_elementType__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_createChainedFunction__ = __webpack_require__(12);











var propTypes = {
  href: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  onClick: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  onKeyDown: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  disabled: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  role: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  tabIndex: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string]),
  /**
   * this is sort of silly but needed for Button
   */
  componentClass: __WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_elementType___default.a
};

var defaultProps = {
  componentClass: 'a'
};

function isTrivialHref(href) {
  return !href || href.trim() === '#';
}

/**
 * There are situations due to browser quirks or Bootstrap CSS where
 * an anchor tag is needed, when semantically a button tag is the
 * better choice. SafeAnchor ensures that when an anchor is used like a
 * button its accessible. It also emulates input `disabled` behavior for
 * links, which is usually desirable for Buttons, NavItems, MenuItems, etc.
 */

var SafeAnchor = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(SafeAnchor, _React$Component);

  function SafeAnchor(props, context) {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, SafeAnchor);

    var _this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props, context));

    _this.handleClick = _this.handleClick.bind(_this);
    _this.handleKeyDown = _this.handleKeyDown.bind(_this);
    return _this;
  }

  SafeAnchor.prototype.handleClick = function handleClick(event) {
    var _props = this.props,
        disabled = _props.disabled,
        href = _props.href,
        onClick = _props.onClick;


    if (disabled || isTrivialHref(href)) {
      event.preventDefault();
    }

    if (disabled) {
      event.stopPropagation();
      return;
    }

    if (onClick) {
      onClick(event);
    }
  };

  SafeAnchor.prototype.handleKeyDown = function handleKeyDown(event) {
    if (event.key === ' ') {
      event.preventDefault();
      this.handleClick(event);
    }
  };

  SafeAnchor.prototype.render = function render() {
    var _props2 = this.props,
        Component = _props2.componentClass,
        disabled = _props2.disabled,
        onKeyDown = _props2.onKeyDown,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props2, ['componentClass', 'disabled', 'onKeyDown']);

    if (isTrivialHref(props.href)) {
      props.role = props.role || 'button';
      // we want to make sure there is a href attribute on the node
      // otherwise, the cursor incorrectly styled (except with role='button')
      props.href = props.href || '#';
    }

    if (disabled) {
      props.tabIndex = -1;
      props.style = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({ pointerEvents: 'none' }, props.style);
    }

    return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(Component, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, props, {
      onClick: this.handleClick,
      onKeyDown: Object(__WEBPACK_IMPORTED_MODULE_8__utils_createChainedFunction__["a" /* default */])(this.handleKeyDown, onKeyDown)
    }));
  };

  return SafeAnchor;
}(__WEBPACK_IMPORTED_MODULE_5_react___default.a.Component);

SafeAnchor.propTypes = propTypes;
SafeAnchor.defaultProps = defaultProps;

/* harmony default export */ __webpack_exports__["a"] = (SafeAnchor);

/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var validateFormat = function validateFormat(format) {};

if (false) {
  validateFormat = function validateFormat(format) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  };
}

function invariant(condition, format, a, b, c, d, e, f) {
  validateFormat(format);

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(format.replace(/%s/g, function () {
        return args[argIndex++];
      }));
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
}

module.exports = invariant;

/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
module.exports = exports['default'];

/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/


/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

module.exports = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};


/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(26);
var core = __webpack_require__(19);
var ctx = __webpack_require__(74);
var hide = __webpack_require__(34);
var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var IS_WRAP = type & $export.W;
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE];
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE];
  var key, own, out;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    if (own && key in exports) continue;
    // export native or passed
    out = own ? target[key] : source[key];
    // prevent global pollution for namespaces
    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
    // bind timers to global for call from export context
    : IS_BIND && own ? ctx(out, global)
    // wrap global constructors for prevent change them in library
    : IS_WRAP && target[key] == out ? (function (C) {
      var F = function (a, b, c) {
        if (this instanceof C) {
          switch (arguments.length) {
            case 0: return new C();
            case 1: return new C(a);
            case 2: return new C(a, b);
          } return new C(a, b, c);
        } return C.apply(this, arguments);
      };
      F[PROTOTYPE] = C[PROTOTYPE];
      return F;
    // make static versions for prototype methods
    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
    if (IS_PROTO) {
      (exports.virtual || (exports.virtual = {}))[key] = out;
      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
      if (type & $export.R && expProto && !expProto[key]) hide(expProto, key, out);
    }
  }
};
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;


/***/ }),
/* 26 */
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

function makeEmptyFunction(arg) {
  return function () {
    return arg;
  };
}

/**
 * This function accepts and discards inputs; it has no side effects. This is
 * primarily useful idiomatically for overridable function endpoints which
 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
 */
var emptyFunction = function emptyFunction() {};

emptyFunction.thatReturns = makeEmptyFunction;
emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
emptyFunction.thatReturnsNull = makeEmptyFunction(null);
emptyFunction.thatReturnsThis = function () {
  return this;
};
emptyFunction.thatReturnsArgument = function (arg) {
  return arg;
};

module.exports = emptyFunction;

/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(35);
var IE8_DOM_DEFINE = __webpack_require__(115);
var toPrimitive = __webpack_require__(75);
var dP = Object.defineProperty;

exports.f = __webpack_require__(36) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),
/* 29 */
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};


/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__(118);
var defined = __webpack_require__(77);
module.exports = function (it) {
  return IObject(defined(it));
};


/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = ownerDocument;
function ownerDocument(node) {
  return node && node.ownerDocument || document;
}
module.exports = exports["default"];

/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (componentOrElement) {
  return (0, _ownerDocument2.default)(_reactDom2.default.findDOMNode(componentOrElement));
};

var _reactDom = __webpack_require__(16);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _ownerDocument = __webpack_require__(31);

var _ownerDocument2 = _interopRequireDefault(_ownerDocument);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

module.exports = exports['default'];

/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory, undef) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(9), __webpack_require__(111), __webpack_require__(112));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core", "./sha1", "./hmac"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	(function () {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var Base = C_lib.Base;
	    var WordArray = C_lib.WordArray;
	    var C_algo = C.algo;
	    var MD5 = C_algo.MD5;

	    /**
	     * This key derivation function is meant to conform with EVP_BytesToKey.
	     * www.openssl.org/docs/crypto/EVP_BytesToKey.html
	     */
	    var EvpKDF = C_algo.EvpKDF = Base.extend({
	        /**
	         * Configuration options.
	         *
	         * @property {number} keySize The key size in words to generate. Default: 4 (128 bits)
	         * @property {Hasher} hasher The hash algorithm to use. Default: MD5
	         * @property {number} iterations The number of iterations to perform. Default: 1
	         */
	        cfg: Base.extend({
	            keySize: 128/32,
	            hasher: MD5,
	            iterations: 1
	        }),

	        /**
	         * Initializes a newly created key derivation function.
	         *
	         * @param {Object} cfg (Optional) The configuration options to use for the derivation.
	         *
	         * @example
	         *
	         *     var kdf = CryptoJS.algo.EvpKDF.create();
	         *     var kdf = CryptoJS.algo.EvpKDF.create({ keySize: 8 });
	         *     var kdf = CryptoJS.algo.EvpKDF.create({ keySize: 8, iterations: 1000 });
	         */
	        init: function (cfg) {
	            this.cfg = this.cfg.extend(cfg);
	        },

	        /**
	         * Derives a key from a password.
	         *
	         * @param {WordArray|string} password The password.
	         * @param {WordArray|string} salt A salt.
	         *
	         * @return {WordArray} The derived key.
	         *
	         * @example
	         *
	         *     var key = kdf.compute(password, salt);
	         */
	        compute: function (password, salt) {
	            // Shortcut
	            var cfg = this.cfg;

	            // Init hasher
	            var hasher = cfg.hasher.create();

	            // Initial values
	            var derivedKey = WordArray.create();

	            // Shortcuts
	            var derivedKeyWords = derivedKey.words;
	            var keySize = cfg.keySize;
	            var iterations = cfg.iterations;

	            // Generate key
	            while (derivedKeyWords.length < keySize) {
	                if (block) {
	                    hasher.update(block);
	                }
	                var block = hasher.update(password).finalize(salt);
	                hasher.reset();

	                // Iterations
	                for (var i = 1; i < iterations; i++) {
	                    block = hasher.finalize(block);
	                    hasher.reset();
	                }

	                derivedKey.concat(block);
	            }
	            derivedKey.sigBytes = keySize * 4;

	            return derivedKey;
	        }
	    });

	    /**
	     * Derives a key from a password.
	     *
	     * @param {WordArray|string} password The password.
	     * @param {WordArray|string} salt A salt.
	     * @param {Object} cfg (Optional) The configuration options to use for this computation.
	     *
	     * @return {WordArray} The derived key.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var key = CryptoJS.EvpKDF(password, salt);
	     *     var key = CryptoJS.EvpKDF(password, salt, { keySize: 8 });
	     *     var key = CryptoJS.EvpKDF(password, salt, { keySize: 8, iterations: 1000 });
	     */
	    C.EvpKDF = function (password, salt, cfg) {
	        return EvpKDF.create(cfg).compute(password, salt);
	    };
	}());


	return CryptoJS.EvpKDF;

}));

/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(28);
var createDesc = __webpack_require__(44);
module.exports = __webpack_require__(36) ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(42);
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};


/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__(43)(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(242), __esModule: true };

/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _inDOM = __webpack_require__(23);

var _inDOM2 = _interopRequireDefault(_inDOM);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  // HTML DOM and SVG DOM may have different support levels,
  // so we need to check on context instead of a document root element.
  return _inDOM2.default ? function (context, node) {
    if (context.contains) {
      return context.contains(node);
    } else if (context.compareDocumentPosition) {
      return context === node || !!(context.compareDocumentPosition(node) & 16);
    } else {
      return fallback(context, node);
    }
  } : fallback;
}();

function fallback(context, node) {
  if (node) do {
    if (node === context) return true;
  } while (node = node.parentNode);

  return false;
}
module.exports = exports['default'];

/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _assign = __webpack_require__(24);

var ReactCurrentOwner = __webpack_require__(160);

var warning = __webpack_require__(70);
var canDefineProperty = __webpack_require__(159);
var hasOwnProperty = Object.prototype.hasOwnProperty;

var REACT_ELEMENT_TYPE = __webpack_require__(161);

var RESERVED_PROPS = {
  key: true,
  ref: true,
  __self: true,
  __source: true
};

var specialPropKeyWarningShown, specialPropRefWarningShown;

function hasValidRef(config) {
  if (false) {
    if (hasOwnProperty.call(config, 'ref')) {
      var getter = Object.getOwnPropertyDescriptor(config, 'ref').get;
      if (getter && getter.isReactWarning) {
        return false;
      }
    }
  }
  return config.ref !== undefined;
}

function hasValidKey(config) {
  if (false) {
    if (hasOwnProperty.call(config, 'key')) {
      var getter = Object.getOwnPropertyDescriptor(config, 'key').get;
      if (getter && getter.isReactWarning) {
        return false;
      }
    }
  }
  return config.key !== undefined;
}

function defineKeyPropWarningGetter(props, displayName) {
  var warnAboutAccessingKey = function () {
    if (!specialPropKeyWarningShown) {
      specialPropKeyWarningShown = true;
       false ? warning(false, '%s: `key` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://fb.me/react-special-props)', displayName) : void 0;
    }
  };
  warnAboutAccessingKey.isReactWarning = true;
  Object.defineProperty(props, 'key', {
    get: warnAboutAccessingKey,
    configurable: true
  });
}

function defineRefPropWarningGetter(props, displayName) {
  var warnAboutAccessingRef = function () {
    if (!specialPropRefWarningShown) {
      specialPropRefWarningShown = true;
       false ? warning(false, '%s: `ref` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://fb.me/react-special-props)', displayName) : void 0;
    }
  };
  warnAboutAccessingRef.isReactWarning = true;
  Object.defineProperty(props, 'ref', {
    get: warnAboutAccessingRef,
    configurable: true
  });
}

/**
 * Factory method to create a new React element. This no longer adheres to
 * the class pattern, so do not use new to call it. Also, no instanceof check
 * will work. Instead test $$typeof field against Symbol.for('react.element') to check
 * if something is a React Element.
 *
 * @param {*} type
 * @param {*} key
 * @param {string|object} ref
 * @param {*} self A *temporary* helper to detect places where `this` is
 * different from the `owner` when React.createElement is called, so that we
 * can warn. We want to get rid of owner and replace string `ref`s with arrow
 * functions, and as long as `this` and owner are the same, there will be no
 * change in behavior.
 * @param {*} source An annotation object (added by a transpiler or otherwise)
 * indicating filename, line number, and/or other information.
 * @param {*} owner
 * @param {*} props
 * @internal
 */
var ReactElement = function (type, key, ref, self, source, owner, props) {
  var element = {
    // This tag allow us to uniquely identify this as a React Element
    $$typeof: REACT_ELEMENT_TYPE,

    // Built-in properties that belong on the element
    type: type,
    key: key,
    ref: ref,
    props: props,

    // Record the component responsible for creating this element.
    _owner: owner
  };

  if (false) {
    // The validation flag is currently mutative. We put it on
    // an external backing store so that we can freeze the whole object.
    // This can be replaced with a WeakMap once they are implemented in
    // commonly used development environments.
    element._store = {};

    // To make comparing ReactElements easier for testing purposes, we make
    // the validation flag non-enumerable (where possible, which should
    // include every environment we run tests in), so the test framework
    // ignores it.
    if (canDefineProperty) {
      Object.defineProperty(element._store, 'validated', {
        configurable: false,
        enumerable: false,
        writable: true,
        value: false
      });
      // self and source are DEV only properties.
      Object.defineProperty(element, '_self', {
        configurable: false,
        enumerable: false,
        writable: false,
        value: self
      });
      // Two elements created in two different places should be considered
      // equal for testing purposes and therefore we hide it from enumeration.
      Object.defineProperty(element, '_source', {
        configurable: false,
        enumerable: false,
        writable: false,
        value: source
      });
    } else {
      element._store.validated = false;
      element._self = self;
      element._source = source;
    }
    if (Object.freeze) {
      Object.freeze(element.props);
      Object.freeze(element);
    }
  }

  return element;
};

/**
 * Create and return a new ReactElement of the given type.
 * See https://facebook.github.io/react/docs/top-level-api.html#react.createelement
 */
ReactElement.createElement = function (type, config, children) {
  var propName;

  // Reserved names are extracted
  var props = {};

  var key = null;
  var ref = null;
  var self = null;
  var source = null;

  if (config != null) {
    if (hasValidRef(config)) {
      ref = config.ref;
    }
    if (hasValidKey(config)) {
      key = '' + config.key;
    }

    self = config.__self === undefined ? null : config.__self;
    source = config.__source === undefined ? null : config.__source;
    // Remaining properties are added to a new props object
    for (propName in config) {
      if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
        props[propName] = config[propName];
      }
    }
  }

  // Children can be more than one argument, and those are transferred onto
  // the newly allocated props object.
  var childrenLength = arguments.length - 2;
  if (childrenLength === 1) {
    props.children = children;
  } else if (childrenLength > 1) {
    var childArray = Array(childrenLength);
    for (var i = 0; i < childrenLength; i++) {
      childArray[i] = arguments[i + 2];
    }
    if (false) {
      if (Object.freeze) {
        Object.freeze(childArray);
      }
    }
    props.children = childArray;
  }

  // Resolve default props
  if (type && type.defaultProps) {
    var defaultProps = type.defaultProps;
    for (propName in defaultProps) {
      if (props[propName] === undefined) {
        props[propName] = defaultProps[propName];
      }
    }
  }
  if (false) {
    if (key || ref) {
      if (typeof props.$$typeof === 'undefined' || props.$$typeof !== REACT_ELEMENT_TYPE) {
        var displayName = typeof type === 'function' ? type.displayName || type.name || 'Unknown' : type;
        if (key) {
          defineKeyPropWarningGetter(props, displayName);
        }
        if (ref) {
          defineRefPropWarningGetter(props, displayName);
        }
      }
    }
  }
  return ReactElement(type, key, ref, self, source, ReactCurrentOwner.current, props);
};

/**
 * Return a function that produces ReactElements of a given type.
 * See https://facebook.github.io/react/docs/top-level-api.html#react.createfactory
 */
ReactElement.createFactory = function (type) {
  var factory = ReactElement.createElement.bind(null, type);
  // Expose the type on the factory and the prototype so that it can be
  // easily accessed on elements. E.g. `<Foo />.type === Foo`.
  // This should not be named `constructor` since this may not be the function
  // that created the element, and it may not even be a constructor.
  // Legacy hook TODO: Warn if this is accessed
  factory.type = type;
  return factory;
};

ReactElement.cloneAndReplaceKey = function (oldElement, newKey) {
  var newElement = ReactElement(oldElement.type, newKey, oldElement.ref, oldElement._self, oldElement._source, oldElement._owner, oldElement.props);

  return newElement;
};

/**
 * Clone and return a new ReactElement using element as the starting point.
 * See https://facebook.github.io/react/docs/top-level-api.html#react.cloneelement
 */
ReactElement.cloneElement = function (element, config, children) {
  var propName;

  // Original props are copied
  var props = _assign({}, element.props);

  // Reserved names are extracted
  var key = element.key;
  var ref = element.ref;
  // Self is preserved since the owner is preserved.
  var self = element._self;
  // Source is preserved since cloneElement is unlikely to be targeted by a
  // transpiler, and the original source is probably a better indicator of the
  // true owner.
  var source = element._source;

  // Owner will be preserved, unless ref is overridden
  var owner = element._owner;

  if (config != null) {
    if (hasValidRef(config)) {
      // Silently steal the ref from the parent.
      ref = config.ref;
      owner = ReactCurrentOwner.current;
    }
    if (hasValidKey(config)) {
      key = '' + config.key;
    }

    // Remaining properties override existing props
    var defaultProps;
    if (element.type && element.type.defaultProps) {
      defaultProps = element.type.defaultProps;
    }
    for (propName in config) {
      if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
        if (config[propName] === undefined && defaultProps !== undefined) {
          // Resolve default props
          props[propName] = defaultProps[propName];
        } else {
          props[propName] = config[propName];
        }
      }
    }
  }

  // Children can be more than one argument, and those are transferred onto
  // the newly allocated props object.
  var childrenLength = arguments.length - 2;
  if (childrenLength === 1) {
    props.children = children;
  } else if (childrenLength > 1) {
    var childArray = Array(childrenLength);
    for (var i = 0; i < childrenLength; i++) {
      childArray[i] = arguments[i + 2];
    }
    props.children = childArray;
  }

  return ReactElement(element.type, key, ref, self, source, owner, props);
};

/**
 * Verifies the object is a ReactElement.
 * See https://facebook.github.io/react/docs/top-level-api.html#react.isvalidelement
 * @param {?object} object
 * @return {boolean} True if `object` is a valid component.
 * @final
 */
ReactElement.isValidElement = function (object) {
  return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
};

module.exports = ReactElement;

/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(9));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	(function () {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var WordArray = C_lib.WordArray;
	    var C_enc = C.enc;

	    /**
	     * Base64 encoding strategy.
	     */
	    var Base64 = C_enc.Base64 = {
	        /**
	         * Converts a word array to a Base64 string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @return {string} The Base64 string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var base64String = CryptoJS.enc.Base64.stringify(wordArray);
	         */
	        stringify: function (wordArray) {
	            // Shortcuts
	            var words = wordArray.words;
	            var sigBytes = wordArray.sigBytes;
	            var map = this._map;

	            // Clamp excess bits
	            wordArray.clamp();

	            // Convert
	            var base64Chars = [];
	            for (var i = 0; i < sigBytes; i += 3) {
	                var byte1 = (words[i >>> 2]       >>> (24 - (i % 4) * 8))       & 0xff;
	                var byte2 = (words[(i + 1) >>> 2] >>> (24 - ((i + 1) % 4) * 8)) & 0xff;
	                var byte3 = (words[(i + 2) >>> 2] >>> (24 - ((i + 2) % 4) * 8)) & 0xff;

	                var triplet = (byte1 << 16) | (byte2 << 8) | byte3;

	                for (var j = 0; (j < 4) && (i + j * 0.75 < sigBytes); j++) {
	                    base64Chars.push(map.charAt((triplet >>> (6 * (3 - j))) & 0x3f));
	                }
	            }

	            // Add padding
	            var paddingChar = map.charAt(64);
	            if (paddingChar) {
	                while (base64Chars.length % 4) {
	                    base64Chars.push(paddingChar);
	                }
	            }

	            return base64Chars.join('');
	        },

	        /**
	         * Converts a Base64 string to a word array.
	         *
	         * @param {string} base64Str The Base64 string.
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Base64.parse(base64String);
	         */
	        parse: function (base64Str) {
	            // Shortcuts
	            var base64StrLength = base64Str.length;
	            var map = this._map;
	            var reverseMap = this._reverseMap;

	            if (!reverseMap) {
	                    reverseMap = this._reverseMap = [];
	                    for (var j = 0; j < map.length; j++) {
	                        reverseMap[map.charCodeAt(j)] = j;
	                    }
	            }

	            // Ignore padding
	            var paddingChar = map.charAt(64);
	            if (paddingChar) {
	                var paddingIndex = base64Str.indexOf(paddingChar);
	                if (paddingIndex !== -1) {
	                    base64StrLength = paddingIndex;
	                }
	            }

	            // Convert
	            return parseLoop(base64Str, base64StrLength, reverseMap);

	        },

	        _map: 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/='
	    };

	    function parseLoop(base64Str, base64StrLength, reverseMap) {
	      var words = [];
	      var nBytes = 0;
	      for (var i = 0; i < base64StrLength; i++) {
	          if (i % 4) {
	              var bits1 = reverseMap[base64Str.charCodeAt(i - 1)] << ((i % 4) * 2);
	              var bits2 = reverseMap[base64Str.charCodeAt(i)] >>> (6 - (i % 4) * 2);
	              words[nBytes >>> 2] |= (bits1 | bits2) << (24 - (nBytes % 4) * 8);
	              nBytes++;
	          }
	      }
	      return WordArray.create(words, nBytes);
	    }
	}());


	return CryptoJS.enc.Base64;

}));

/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(9));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	(function (Math) {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var WordArray = C_lib.WordArray;
	    var Hasher = C_lib.Hasher;
	    var C_algo = C.algo;

	    // Constants table
	    var T = [];

	    // Compute constants
	    (function () {
	        for (var i = 0; i < 64; i++) {
	            T[i] = (Math.abs(Math.sin(i + 1)) * 0x100000000) | 0;
	        }
	    }());

	    /**
	     * MD5 hash algorithm.
	     */
	    var MD5 = C_algo.MD5 = Hasher.extend({
	        _doReset: function () {
	            this._hash = new WordArray.init([
	                0x67452301, 0xefcdab89,
	                0x98badcfe, 0x10325476
	            ]);
	        },

	        _doProcessBlock: function (M, offset) {
	            // Swap endian
	            for (var i = 0; i < 16; i++) {
	                // Shortcuts
	                var offset_i = offset + i;
	                var M_offset_i = M[offset_i];

	                M[offset_i] = (
	                    (((M_offset_i << 8)  | (M_offset_i >>> 24)) & 0x00ff00ff) |
	                    (((M_offset_i << 24) | (M_offset_i >>> 8))  & 0xff00ff00)
	                );
	            }

	            // Shortcuts
	            var H = this._hash.words;

	            var M_offset_0  = M[offset + 0];
	            var M_offset_1  = M[offset + 1];
	            var M_offset_2  = M[offset + 2];
	            var M_offset_3  = M[offset + 3];
	            var M_offset_4  = M[offset + 4];
	            var M_offset_5  = M[offset + 5];
	            var M_offset_6  = M[offset + 6];
	            var M_offset_7  = M[offset + 7];
	            var M_offset_8  = M[offset + 8];
	            var M_offset_9  = M[offset + 9];
	            var M_offset_10 = M[offset + 10];
	            var M_offset_11 = M[offset + 11];
	            var M_offset_12 = M[offset + 12];
	            var M_offset_13 = M[offset + 13];
	            var M_offset_14 = M[offset + 14];
	            var M_offset_15 = M[offset + 15];

	            // Working varialbes
	            var a = H[0];
	            var b = H[1];
	            var c = H[2];
	            var d = H[3];

	            // Computation
	            a = FF(a, b, c, d, M_offset_0,  7,  T[0]);
	            d = FF(d, a, b, c, M_offset_1,  12, T[1]);
	            c = FF(c, d, a, b, M_offset_2,  17, T[2]);
	            b = FF(b, c, d, a, M_offset_3,  22, T[3]);
	            a = FF(a, b, c, d, M_offset_4,  7,  T[4]);
	            d = FF(d, a, b, c, M_offset_5,  12, T[5]);
	            c = FF(c, d, a, b, M_offset_6,  17, T[6]);
	            b = FF(b, c, d, a, M_offset_7,  22, T[7]);
	            a = FF(a, b, c, d, M_offset_8,  7,  T[8]);
	            d = FF(d, a, b, c, M_offset_9,  12, T[9]);
	            c = FF(c, d, a, b, M_offset_10, 17, T[10]);
	            b = FF(b, c, d, a, M_offset_11, 22, T[11]);
	            a = FF(a, b, c, d, M_offset_12, 7,  T[12]);
	            d = FF(d, a, b, c, M_offset_13, 12, T[13]);
	            c = FF(c, d, a, b, M_offset_14, 17, T[14]);
	            b = FF(b, c, d, a, M_offset_15, 22, T[15]);

	            a = GG(a, b, c, d, M_offset_1,  5,  T[16]);
	            d = GG(d, a, b, c, M_offset_6,  9,  T[17]);
	            c = GG(c, d, a, b, M_offset_11, 14, T[18]);
	            b = GG(b, c, d, a, M_offset_0,  20, T[19]);
	            a = GG(a, b, c, d, M_offset_5,  5,  T[20]);
	            d = GG(d, a, b, c, M_offset_10, 9,  T[21]);
	            c = GG(c, d, a, b, M_offset_15, 14, T[22]);
	            b = GG(b, c, d, a, M_offset_4,  20, T[23]);
	            a = GG(a, b, c, d, M_offset_9,  5,  T[24]);
	            d = GG(d, a, b, c, M_offset_14, 9,  T[25]);
	            c = GG(c, d, a, b, M_offset_3,  14, T[26]);
	            b = GG(b, c, d, a, M_offset_8,  20, T[27]);
	            a = GG(a, b, c, d, M_offset_13, 5,  T[28]);
	            d = GG(d, a, b, c, M_offset_2,  9,  T[29]);
	            c = GG(c, d, a, b, M_offset_7,  14, T[30]);
	            b = GG(b, c, d, a, M_offset_12, 20, T[31]);

	            a = HH(a, b, c, d, M_offset_5,  4,  T[32]);
	            d = HH(d, a, b, c, M_offset_8,  11, T[33]);
	            c = HH(c, d, a, b, M_offset_11, 16, T[34]);
	            b = HH(b, c, d, a, M_offset_14, 23, T[35]);
	            a = HH(a, b, c, d, M_offset_1,  4,  T[36]);
	            d = HH(d, a, b, c, M_offset_4,  11, T[37]);
	            c = HH(c, d, a, b, M_offset_7,  16, T[38]);
	            b = HH(b, c, d, a, M_offset_10, 23, T[39]);
	            a = HH(a, b, c, d, M_offset_13, 4,  T[40]);
	            d = HH(d, a, b, c, M_offset_0,  11, T[41]);
	            c = HH(c, d, a, b, M_offset_3,  16, T[42]);
	            b = HH(b, c, d, a, M_offset_6,  23, T[43]);
	            a = HH(a, b, c, d, M_offset_9,  4,  T[44]);
	            d = HH(d, a, b, c, M_offset_12, 11, T[45]);
	            c = HH(c, d, a, b, M_offset_15, 16, T[46]);
	            b = HH(b, c, d, a, M_offset_2,  23, T[47]);

	            a = II(a, b, c, d, M_offset_0,  6,  T[48]);
	            d = II(d, a, b, c, M_offset_7,  10, T[49]);
	            c = II(c, d, a, b, M_offset_14, 15, T[50]);
	            b = II(b, c, d, a, M_offset_5,  21, T[51]);
	            a = II(a, b, c, d, M_offset_12, 6,  T[52]);
	            d = II(d, a, b, c, M_offset_3,  10, T[53]);
	            c = II(c, d, a, b, M_offset_10, 15, T[54]);
	            b = II(b, c, d, a, M_offset_1,  21, T[55]);
	            a = II(a, b, c, d, M_offset_8,  6,  T[56]);
	            d = II(d, a, b, c, M_offset_15, 10, T[57]);
	            c = II(c, d, a, b, M_offset_6,  15, T[58]);
	            b = II(b, c, d, a, M_offset_13, 21, T[59]);
	            a = II(a, b, c, d, M_offset_4,  6,  T[60]);
	            d = II(d, a, b, c, M_offset_11, 10, T[61]);
	            c = II(c, d, a, b, M_offset_2,  15, T[62]);
	            b = II(b, c, d, a, M_offset_9,  21, T[63]);

	            // Intermediate hash value
	            H[0] = (H[0] + a) | 0;
	            H[1] = (H[1] + b) | 0;
	            H[2] = (H[2] + c) | 0;
	            H[3] = (H[3] + d) | 0;
	        },

	        _doFinalize: function () {
	            // Shortcuts
	            var data = this._data;
	            var dataWords = data.words;

	            var nBitsTotal = this._nDataBytes * 8;
	            var nBitsLeft = data.sigBytes * 8;

	            // Add padding
	            dataWords[nBitsLeft >>> 5] |= 0x80 << (24 - nBitsLeft % 32);

	            var nBitsTotalH = Math.floor(nBitsTotal / 0x100000000);
	            var nBitsTotalL = nBitsTotal;
	            dataWords[(((nBitsLeft + 64) >>> 9) << 4) + 15] = (
	                (((nBitsTotalH << 8)  | (nBitsTotalH >>> 24)) & 0x00ff00ff) |
	                (((nBitsTotalH << 24) | (nBitsTotalH >>> 8))  & 0xff00ff00)
	            );
	            dataWords[(((nBitsLeft + 64) >>> 9) << 4) + 14] = (
	                (((nBitsTotalL << 8)  | (nBitsTotalL >>> 24)) & 0x00ff00ff) |
	                (((nBitsTotalL << 24) | (nBitsTotalL >>> 8))  & 0xff00ff00)
	            );

	            data.sigBytes = (dataWords.length + 1) * 4;

	            // Hash final blocks
	            this._process();

	            // Shortcuts
	            var hash = this._hash;
	            var H = hash.words;

	            // Swap endian
	            for (var i = 0; i < 4; i++) {
	                // Shortcut
	                var H_i = H[i];

	                H[i] = (((H_i << 8)  | (H_i >>> 24)) & 0x00ff00ff) |
	                       (((H_i << 24) | (H_i >>> 8))  & 0xff00ff00);
	            }

	            // Return final computed hash
	            return hash;
	        },

	        clone: function () {
	            var clone = Hasher.clone.call(this);
	            clone._hash = this._hash.clone();

	            return clone;
	        }
	    });

	    function FF(a, b, c, d, x, s, t) {
	        var n = a + ((b & c) | (~b & d)) + x + t;
	        return ((n << s) | (n >>> (32 - s))) + b;
	    }

	    function GG(a, b, c, d, x, s, t) {
	        var n = a + ((b & d) | (c & ~d)) + x + t;
	        return ((n << s) | (n >>> (32 - s))) + b;
	    }

	    function HH(a, b, c, d, x, s, t) {
	        var n = a + (b ^ c ^ d) + x + t;
	        return ((n << s) | (n >>> (32 - s))) + b;
	    }

	    function II(a, b, c, d, x, s, t) {
	        var n = a + (c ^ (b | ~d)) + x + t;
	        return ((n << s) | (n >>> (32 - s))) + b;
	    }

	    /**
	     * Shortcut function to the hasher's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     *
	     * @return {WordArray} The hash.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hash = CryptoJS.MD5('message');
	     *     var hash = CryptoJS.MD5(wordArray);
	     */
	    C.MD5 = Hasher._createHelper(MD5);

	    /**
	     * Shortcut function to the HMAC's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     * @param {WordArray|string} key The secret key.
	     *
	     * @return {WordArray} The HMAC.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hmac = CryptoJS.HmacMD5(message, key);
	     */
	    C.HmacMD5 = Hasher._createHmacHelper(MD5);
	}(Math));


	return CryptoJS.MD5;

}));

/***/ }),
/* 42 */
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),
/* 43 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};


/***/ }),
/* 44 */
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys = __webpack_require__(117);
var enumBugKeys = __webpack_require__(81);

module.exports = Object.keys || function keys(O) {
  return $keys(O, enumBugKeys);
};


/***/ }),
/* 46 */
/***/ (function(module, exports) {

exports.f = {}.propertyIsEnumerable;


/***/ }),
/* 47 */
/***/ (function(module, exports) {

module.exports = {};


/***/ }),
/* 48 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_prop_types_extra_lib_elementType__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_prop_types_extra_lib_elementType___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_prop_types_extra_lib_elementType__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_bootstrapUtils__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils_StyleConfig__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__SafeAnchor__ = __webpack_require__(21);
















var propTypes = {
  active: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool,
  disabled: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool,
  block: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool,
  onClick: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func,
  componentClass: __WEBPACK_IMPORTED_MODULE_9_prop_types_extra_lib_elementType___default.a,
  href: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.string,
  /**
   * Defines HTML button type attribute
   * @defaultValue 'button'
   */
  type: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.oneOf(['button', 'reset', 'submit'])
};

var defaultProps = {
  active: false,
  block: false,
  disabled: false
};

var Button = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(Button, _React$Component);

  function Button() {
    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, Button);

    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  Button.prototype.renderAnchor = function renderAnchor(elementProps, className) {
    return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__SafeAnchor__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, elementProps, {
      className: __WEBPACK_IMPORTED_MODULE_6_classnames___default()(className, elementProps.disabled && 'disabled')
    }));
  };

  Button.prototype.renderButton = function renderButton(_ref, className) {
    var componentClass = _ref.componentClass,
        elementProps = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_ref, ['componentClass']);

    var Component = componentClass || 'button';

    return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(Component, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, elementProps, {
      type: elementProps.type || 'button',
      className: className
    }));
  };

  Button.prototype.render = function render() {
    var _extends2;

    var _props = this.props,
        active = _props.active,
        block = _props.block,
        className = _props.className,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['active', 'block', 'className']);

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_10__utils_bootstrapUtils__["f" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_10__utils_bootstrapUtils__["d" /* getClassSet */])(bsProps), (_extends2 = {
      active: active
    }, _extends2[Object(__WEBPACK_IMPORTED_MODULE_10__utils_bootstrapUtils__["e" /* prefix */])(bsProps, 'block')] = block, _extends2));
    var fullClassName = __WEBPACK_IMPORTED_MODULE_6_classnames___default()(className, classes);

    if (elementProps.href) {
      return this.renderAnchor(elementProps, fullClassName);
    }

    return this.renderButton(elementProps, fullClassName);
  };

  return Button;
}(__WEBPACK_IMPORTED_MODULE_7_react___default.a.Component);

Button.propTypes = propTypes;
Button.defaultProps = defaultProps;

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_10__utils_bootstrapUtils__["a" /* bsClass */])('btn', Object(__WEBPACK_IMPORTED_MODULE_10__utils_bootstrapUtils__["b" /* bsSizes */])([__WEBPACK_IMPORTED_MODULE_11__utils_StyleConfig__["c" /* Size */].LARGE, __WEBPACK_IMPORTED_MODULE_11__utils_StyleConfig__["c" /* Size */].SMALL, __WEBPACK_IMPORTED_MODULE_11__utils_StyleConfig__["c" /* Size */].XSMALL], Object(__WEBPACK_IMPORTED_MODULE_10__utils_bootstrapUtils__["c" /* bsStyles */])([].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default()(__WEBPACK_IMPORTED_MODULE_11__utils_StyleConfig__["d" /* State */]), [__WEBPACK_IMPORTED_MODULE_11__utils_StyleConfig__["e" /* Style */].DEFAULT, __WEBPACK_IMPORTED_MODULE_11__utils_StyleConfig__["e" /* Style */].PRIMARY, __WEBPACK_IMPORTED_MODULE_11__utils_StyleConfig__["e" /* Style */].LINK]), __WEBPACK_IMPORTED_MODULE_11__utils_StyleConfig__["e" /* Style */].DEFAULT, Button))));

/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _createUncontrollable = __webpack_require__(260);

var _createUncontrollable2 = _interopRequireDefault(_createUncontrollable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mixin = {
  shouldComponentUpdate: function shouldComponentUpdate() {
    //let the forceUpdate trigger the update
    return !this._notifying;
  }
};

function set(component, propName, handler, value, args) {
  if (handler) {
    component._notifying = true;
    handler.call.apply(handler, [component, value].concat(args));
    component._notifying = false;
  }

  component._values[propName] = value;

  if (!component.unmounted) component.forceUpdate();
}

exports.default = (0, _createUncontrollable2.default)(mixin, set);
module.exports = exports['default'];

/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getWindow;
function getWindow(node) {
  return node === node.window ? node : node.nodeType === 9 ? node.defaultView || node.parentWindow : false;
}
module.exports = exports["default"];

/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = offset;

var _contains = __webpack_require__(38);

var _contains2 = _interopRequireDefault(_contains);

var _isWindow = __webpack_require__(50);

var _isWindow2 = _interopRequireDefault(_isWindow);

var _ownerDocument = __webpack_require__(31);

var _ownerDocument2 = _interopRequireDefault(_ownerDocument);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function offset(node) {
  var doc = (0, _ownerDocument2.default)(node),
      win = (0, _isWindow2.default)(doc),
      docElem = doc && doc.documentElement,
      box = { top: 0, left: 0, height: 0, width: 0 };

  if (!doc) return;

  // Make sure it's not a disconnected DOM node
  if (!(0, _contains2.default)(docElem, node)) return box;

  if (node.getBoundingClientRect !== undefined) box = node.getBoundingClientRect();

  // IE8 getBoundingClientRect doesn't support width & height
  box = {
    top: box.top + (win.pageYOffset || docElem.scrollTop) - (docElem.clientTop || 0),
    left: box.left + (win.pageXOffset || docElem.scrollLeft) - (docElem.clientLeft || 0),
    width: (box.width == null ? node.offsetWidth : box.width) || 0,
    height: (box.height == null ? node.offsetHeight : box.height) || 0
  };

  return box;
}
module.exports = exports['default'];

/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
var addLeadingSlash = exports.addLeadingSlash = function addLeadingSlash(path) {
  return path.charAt(0) === '/' ? path : '/' + path;
};

var stripLeadingSlash = exports.stripLeadingSlash = function stripLeadingSlash(path) {
  return path.charAt(0) === '/' ? path.substr(1) : path;
};

var hasBasename = exports.hasBasename = function hasBasename(path, prefix) {
  return new RegExp('^' + prefix + '(\\/|\\?|#|$)', 'i').test(path);
};

var stripBasename = exports.stripBasename = function stripBasename(path, prefix) {
  return hasBasename(path, prefix) ? path.substr(prefix.length) : path;
};

var stripTrailingSlash = exports.stripTrailingSlash = function stripTrailingSlash(path) {
  return path.charAt(path.length - 1) === '/' ? path.slice(0, -1) : path;
};

var parsePath = exports.parsePath = function parsePath(path) {
  var pathname = path || '/';
  var search = '';
  var hash = '';

  var hashIndex = pathname.indexOf('#');
  if (hashIndex !== -1) {
    hash = pathname.substr(hashIndex);
    pathname = pathname.substr(0, hashIndex);
  }

  var searchIndex = pathname.indexOf('?');
  if (searchIndex !== -1) {
    search = pathname.substr(searchIndex);
    pathname = pathname.substr(0, searchIndex);
  }

  return {
    pathname: pathname,
    search: search === '?' ? '' : search,
    hash: hash === '#' ? '' : hash
  };
};

var createPath = exports.createPath = function createPath(location) {
  var pathname = location.pathname,
      search = location.search,
      hash = location.hash;


  var path = pathname || '/';

  if (search && search !== '?') path += search.charAt(0) === '?' ? search : '?' + search;

  if (hash && hash !== '#') path += hash.charAt(0) === '#' ? hash : '#' + hash;

  return path;
};

/***/ }),
/* 53 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return addLeadingSlash; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return stripLeadingSlash; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return hasBasename; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return stripBasename; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return stripTrailingSlash; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return parsePath; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return createPath; });
var addLeadingSlash = function addLeadingSlash(path) {
  return path.charAt(0) === '/' ? path : '/' + path;
};

var stripLeadingSlash = function stripLeadingSlash(path) {
  return path.charAt(0) === '/' ? path.substr(1) : path;
};

var hasBasename = function hasBasename(path, prefix) {
  return new RegExp('^' + prefix + '(\\/|\\?|#|$)', 'i').test(path);
};

var stripBasename = function stripBasename(path, prefix) {
  return hasBasename(path, prefix) ? path.substr(prefix.length) : path;
};

var stripTrailingSlash = function stripTrailingSlash(path) {
  return path.charAt(path.length - 1) === '/' ? path.slice(0, -1) : path;
};

var parsePath = function parsePath(path) {
  var pathname = path || '/';
  var search = '';
  var hash = '';

  var hashIndex = pathname.indexOf('#');
  if (hashIndex !== -1) {
    hash = pathname.substr(hashIndex);
    pathname = pathname.substr(0, hashIndex);
  }

  var searchIndex = pathname.indexOf('?');
  if (searchIndex !== -1) {
    search = pathname.substr(searchIndex);
    pathname = pathname.substr(0, searchIndex);
  }

  return {
    pathname: pathname,
    search: search === '?' ? '' : search,
    hash: hash === '#' ? '' : hash
  };
};

var createPath = function createPath(location) {
  var pathname = location.pathname,
      search = location.search,
      hash = location.hash;


  var path = pathname || '/';

  if (search && search !== '?') path += search.charAt(0) === '?' ? search : '?' + search;

  if (hash && hash !== '#') path += hash.charAt(0) === '#' ? hash : '#' + hash;

  return path;
};

/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var emptyObject = {};

if (false) {
  Object.freeze(emptyObject);
}

module.exports = emptyObject;

/***/ }),
/* 55 */
/***/ (function(module, exports) {

var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};


/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = createChainableTypeChecker;
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */

// Mostly taken from ReactPropTypes.

function createChainableTypeChecker(validate) {
  function checkType(isRequired, props, propName, componentName, location, propFullName) {
    var componentNameSafe = componentName || '<<anonymous>>';
    var propFullNameSafe = propFullName || propName;

    if (props[propName] == null) {
      if (isRequired) {
        return new Error('Required ' + location + ' `' + propFullNameSafe + '` was not specified ' + ('in `' + componentNameSafe + '`.'));
      }

      return null;
    }

    for (var _len = arguments.length, args = Array(_len > 6 ? _len - 6 : 0), _key = 6; _key < _len; _key++) {
      args[_key - 6] = arguments[_key];
    }

    return validate.apply(undefined, [props, propName, componentNameSafe, location, propFullNameSafe].concat(args));
  }

  var chainedCheckType = checkType.bind(null, false);
  chainedCheckType.isRequired = checkType.bind(null, true);

  return chainedCheckType;
}
module.exports = exports['default'];

/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = all;

var _createChainableTypeChecker = __webpack_require__(56);

var _createChainableTypeChecker2 = _interopRequireDefault(_createChainableTypeChecker);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function all() {
  for (var _len = arguments.length, validators = Array(_len), _key = 0; _key < _len; _key++) {
    validators[_key] = arguments[_key];
  }

  function allPropTypes() {
    for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    var error = null;

    validators.forEach(function (validator) {
      if (error != null) {
        return;
      }

      var result = validator.apply(undefined, args);
      if (result != null) {
        error = result;
      }
    });

    return error;
  }

  return (0, _createChainableTypeChecker2.default)(allPropTypes);
}
module.exports = exports['default'];

/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = style;

var _camelizeStyle = __webpack_require__(132);

var _camelizeStyle2 = _interopRequireDefault(_camelizeStyle);

var _hyphenateStyle = __webpack_require__(255);

var _hyphenateStyle2 = _interopRequireDefault(_hyphenateStyle);

var _getComputedStyle2 = __webpack_require__(257);

var _getComputedStyle3 = _interopRequireDefault(_getComputedStyle2);

var _removeStyle = __webpack_require__(258);

var _removeStyle2 = _interopRequireDefault(_removeStyle);

var _properties = __webpack_require__(133);

var _isTransform = __webpack_require__(259);

var _isTransform2 = _interopRequireDefault(_isTransform);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function style(node, property, value) {
  var css = '';
  var transforms = '';
  var props = property;

  if (typeof property === 'string') {
    if (value === undefined) {
      return node.style[(0, _camelizeStyle2.default)(property)] || (0, _getComputedStyle3.default)(node).getPropertyValue((0, _hyphenateStyle2.default)(property));
    } else {
      (props = {})[property] = value;
    }
  }

  Object.keys(props).forEach(function (key) {
    var value = props[key];
    if (!value && value !== 0) {
      (0, _removeStyle2.default)(node, (0, _hyphenateStyle2.default)(key));
    } else if ((0, _isTransform2.default)(key)) {
      transforms += key + '(' + value + ') ';
    } else {
      css += (0, _hyphenateStyle2.default)(key) + ': ' + value + ';';
    }
  });

  if (transforms) {
    css += _properties.transform + ': ' + transforms + ';';
  }

  node.style.cssText += ';' + css;
}
module.exports = exports['default'];

/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _inDOM = __webpack_require__(23);

var _inDOM2 = _interopRequireDefault(_inDOM);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var on = function on() {};
if (_inDOM2.default) {
  on = function () {

    if (document.addEventListener) return function (node, eventName, handler, capture) {
      return node.addEventListener(eventName, handler, capture || false);
    };else if (document.attachEvent) return function (node, eventName, handler) {
      return node.attachEvent('on' + eventName, function (e) {
        e = e || window.event;
        e.target = e.target || e.srcElement;
        e.currentTarget = node;
        handler.call(node, e);
      });
    };
  }();
}

exports.default = on;
module.exports = exports['default'];

/***/ }),
/* 60 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_dom_helpers_activeElement__ = __webpack_require__(134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_dom_helpers_activeElement___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_dom_helpers_activeElement__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_dom_helpers_query_contains__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_dom_helpers_query_contains___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_dom_helpers_query_contains__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_keycode__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_keycode___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_keycode__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_dom__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_prop_types_extra_lib_all__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_prop_types_extra_lib_all___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_prop_types_extra_lib_all__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_prop_types_extra_lib_elementType__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_prop_types_extra_lib_elementType___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_prop_types_extra_lib_elementType__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_prop_types_extra_lib_isRequiredForA11y__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_prop_types_extra_lib_isRequiredForA11y___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_prop_types_extra_lib_isRequiredForA11y__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_uncontrollable__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_uncontrollable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_uncontrollable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_warning__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__ButtonGroup__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__DropdownMenu__ = __webpack_require__(262);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__DropdownToggle__ = __webpack_require__(135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__utils_bootstrapUtils__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__utils_createChainedFunction__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__utils_PropTypes__ = __webpack_require__(272);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__utils_ValidComponentChildren__ = __webpack_require__(18);


























var TOGGLE_ROLE = __WEBPACK_IMPORTED_MODULE_19__DropdownToggle__["a" /* default */].defaultProps.bsRole;
var MENU_ROLE = __WEBPACK_IMPORTED_MODULE_18__DropdownMenu__["a" /* default */].defaultProps.bsRole;

var propTypes = {
  /**
   * The menu will open above the dropdown button, instead of below it.
   */
  dropup: __WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.bool,

  /**
   * An html id attribute, necessary for assistive technologies, such as screen readers.
   * @type {string|number}
   * @required
   */
  id: __WEBPACK_IMPORTED_MODULE_14_prop_types_extra_lib_isRequiredForA11y___default()(__WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.number])),

  componentClass: __WEBPACK_IMPORTED_MODULE_13_prop_types_extra_lib_elementType___default.a,

  /**
   * The children of a Dropdown may be a `<Dropdown.Toggle>` or a `<Dropdown.Menu>`.
   * @type {node}
   */
  children: __WEBPACK_IMPORTED_MODULE_12_prop_types_extra_lib_all___default()(Object(__WEBPACK_IMPORTED_MODULE_22__utils_PropTypes__["b" /* requiredRoles */])(TOGGLE_ROLE, MENU_ROLE), Object(__WEBPACK_IMPORTED_MODULE_22__utils_PropTypes__["a" /* exclusiveRoles */])(MENU_ROLE)),

  /**
   * Whether or not component is disabled.
   */
  disabled: __WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.bool,

  /**
   * Align the menu to the right side of the Dropdown toggle
   */
  pullRight: __WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.bool,

  /**
   * Whether or not the Dropdown is visible.
   *
   * @controllable onToggle
   */
  open: __WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.bool,

  defaultOpen: __WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.bool,

  /**
   * A callback fired when the Dropdown wishes to change visibility. Called with the requested
   * `open` value, the DOM event, and the source that fired it: `'click'`,`'keydown'`,`'rootClose'`, or `'select'`.
   *
   * ```js
   * function(Boolean isOpen, Object event, { String source }) {}
   * ```
   * @controllable open
   */
  onToggle: __WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.func,

  /**
   * A callback fired when a menu item is selected.
   *
   * ```js
   * (eventKey: any, event: Object) => any
   * ```
   */
  onSelect: __WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.func,

  /**
   * If `'menuitem'`, causes the dropdown to behave like a menu item rather than
   * a menu button.
   */
  role: __WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.string,

  /**
   * Which event when fired outside the component will cause it to be closed
   */
  rootCloseEvent: __WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.oneOf(['click', 'mousedown']),

  /**
   * @private
   */
  onMouseEnter: __WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.func,
  /**
   * @private
   */
  onMouseLeave: __WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.func
};

var defaultProps = {
  componentClass: __WEBPACK_IMPORTED_MODULE_17__ButtonGroup__["a" /* default */]
};

var Dropdown = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Dropdown, _React$Component);

  function Dropdown(props, context) {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, Dropdown);

    var _this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props, context));

    _this.handleClick = _this.handleClick.bind(_this);
    _this.handleKeyDown = _this.handleKeyDown.bind(_this);
    _this.handleClose = _this.handleClose.bind(_this);

    _this._focusInDropdown = false;
    _this.lastOpenEventType = null;
    return _this;
  }

  Dropdown.prototype.componentDidMount = function componentDidMount() {
    this.focusNextOnOpen();
  };

  Dropdown.prototype.componentWillUpdate = function componentWillUpdate(nextProps) {
    if (!nextProps.open && this.props.open) {
      this._focusInDropdown = __WEBPACK_IMPORTED_MODULE_7_dom_helpers_query_contains___default()(__WEBPACK_IMPORTED_MODULE_11_react_dom___default.a.findDOMNode(this.menu), __WEBPACK_IMPORTED_MODULE_6_dom_helpers_activeElement___default()(document));
    }
  };

  Dropdown.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
    var open = this.props.open;

    var prevOpen = prevProps.open;

    if (open && !prevOpen) {
      this.focusNextOnOpen();
    }

    if (!open && prevOpen) {
      // if focus hasn't already moved from the menu let's return it
      // to the toggle
      if (this._focusInDropdown) {
        this._focusInDropdown = false;
        this.focus();
      }
    }
  };

  Dropdown.prototype.handleClick = function handleClick(event) {
    if (this.props.disabled) {
      return;
    }

    this.toggleOpen(event, { source: 'click' });
  };

  Dropdown.prototype.handleKeyDown = function handleKeyDown(event) {
    if (this.props.disabled) {
      return;
    }

    switch (event.keyCode) {
      case __WEBPACK_IMPORTED_MODULE_8_keycode___default.a.codes.down:
        if (!this.props.open) {
          this.toggleOpen(event, { source: 'keydown' });
        } else if (this.menu.focusNext) {
          this.menu.focusNext();
        }
        event.preventDefault();
        break;
      case __WEBPACK_IMPORTED_MODULE_8_keycode___default.a.codes.esc:
      case __WEBPACK_IMPORTED_MODULE_8_keycode___default.a.codes.tab:
        this.handleClose(event, { source: 'keydown' });
        break;
      default:
    }
  };

  Dropdown.prototype.toggleOpen = function toggleOpen(event, eventDetails) {
    var open = !this.props.open;

    if (open) {
      this.lastOpenEventType = eventDetails.source;
    }

    if (this.props.onToggle) {
      this.props.onToggle(open, event, eventDetails);
    }
  };

  Dropdown.prototype.handleClose = function handleClose(event, eventDetails) {
    if (!this.props.open) {
      return;
    }

    this.toggleOpen(event, eventDetails);
  };

  Dropdown.prototype.focusNextOnOpen = function focusNextOnOpen() {
    var menu = this.menu;

    if (!menu.focusNext) {
      return;
    }

    if (this.lastOpenEventType === 'keydown' || this.props.role === 'menuitem') {
      menu.focusNext();
    }
  };

  Dropdown.prototype.focus = function focus() {
    var toggle = __WEBPACK_IMPORTED_MODULE_11_react_dom___default.a.findDOMNode(this.toggle);

    if (toggle && toggle.focus) {
      toggle.focus();
    }
  };

  Dropdown.prototype.renderToggle = function renderToggle(child, props) {
    var _this2 = this;

    var ref = function ref(c) {
      _this2.toggle = c;
    };

    if (typeof child.ref === 'string') {
       false ? warning(false, 'String refs are not supported on `<Dropdown.Toggle>` components. ' + 'To apply a ref to the component use the callback signature:\n\n ' + 'https://facebook.github.io/react/docs/more-about-refs.html#the-ref-callback-attribute') : void 0;
    } else {
      ref = Object(__WEBPACK_IMPORTED_MODULE_21__utils_createChainedFunction__["a" /* default */])(child.ref, ref);
    }

    return Object(__WEBPACK_IMPORTED_MODULE_9_react__["cloneElement"])(child, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, props, {
      ref: ref,
      bsClass: Object(__WEBPACK_IMPORTED_MODULE_20__utils_bootstrapUtils__["e" /* prefix */])(props, 'toggle'),
      onClick: Object(__WEBPACK_IMPORTED_MODULE_21__utils_createChainedFunction__["a" /* default */])(child.props.onClick, this.handleClick),
      onKeyDown: Object(__WEBPACK_IMPORTED_MODULE_21__utils_createChainedFunction__["a" /* default */])(child.props.onKeyDown, this.handleKeyDown)
    }));
  };

  Dropdown.prototype.renderMenu = function renderMenu(child, _ref) {
    var _this3 = this;

    var id = _ref.id,
        onSelect = _ref.onSelect,
        rootCloseEvent = _ref.rootCloseEvent,
        props = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default()(_ref, ['id', 'onSelect', 'rootCloseEvent']);

    var ref = function ref(c) {
      _this3.menu = c;
    };

    if (typeof child.ref === 'string') {
       false ? warning(false, 'String refs are not supported on `<Dropdown.Menu>` components. ' + 'To apply a ref to the component use the callback signature:\n\n ' + 'https://facebook.github.io/react/docs/more-about-refs.html#the-ref-callback-attribute') : void 0;
    } else {
      ref = Object(__WEBPACK_IMPORTED_MODULE_21__utils_createChainedFunction__["a" /* default */])(child.ref, ref);
    }

    return Object(__WEBPACK_IMPORTED_MODULE_9_react__["cloneElement"])(child, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, props, {
      ref: ref,
      labelledBy: id,
      bsClass: Object(__WEBPACK_IMPORTED_MODULE_20__utils_bootstrapUtils__["e" /* prefix */])(props, 'menu'),
      onClose: Object(__WEBPACK_IMPORTED_MODULE_21__utils_createChainedFunction__["a" /* default */])(child.props.onClose, this.handleClose),
      onSelect: Object(__WEBPACK_IMPORTED_MODULE_21__utils_createChainedFunction__["a" /* default */])(child.props.onSelect, onSelect, function (key, event) {
        return _this3.handleClose(event, { source: 'select' });
      }),
      rootCloseEvent: rootCloseEvent
    }));
  };

  Dropdown.prototype.render = function render() {
    var _classes,
        _this4 = this;

    var _props = this.props,
        Component = _props.componentClass,
        id = _props.id,
        dropup = _props.dropup,
        disabled = _props.disabled,
        pullRight = _props.pullRight,
        open = _props.open,
        onSelect = _props.onSelect,
        role = _props.role,
        bsClass = _props.bsClass,
        className = _props.className,
        rootCloseEvent = _props.rootCloseEvent,
        children = _props.children,
        props = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['componentClass', 'id', 'dropup', 'disabled', 'pullRight', 'open', 'onSelect', 'role', 'bsClass', 'className', 'rootCloseEvent', 'children']);

    delete props.onToggle;

    var classes = (_classes = {}, _classes[bsClass] = true, _classes.open = open, _classes.disabled = disabled, _classes);

    if (dropup) {
      classes[bsClass] = false;
      classes.dropup = true;
    }

    // This intentionally forwards bsSize and bsStyle (if set) to the
    // underlying component, to allow it to render size and style variants.

    return __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
      Component,
      __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, props, {
        className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, classes)
      }),
      __WEBPACK_IMPORTED_MODULE_23__utils_ValidComponentChildren__["a" /* default */].map(children, function (child) {
        switch (child.props.bsRole) {
          case TOGGLE_ROLE:
            return _this4.renderToggle(child, {
              id: id, disabled: disabled, open: open, role: role, bsClass: bsClass
            });
          case MENU_ROLE:
            return _this4.renderMenu(child, {
              id: id, open: open, pullRight: pullRight, bsClass: bsClass, onSelect: onSelect, rootCloseEvent: rootCloseEvent
            });
          default:
            return child;
        }
      })
    );
  };

  return Dropdown;
}(__WEBPACK_IMPORTED_MODULE_9_react___default.a.Component);

Dropdown.propTypes = propTypes;
Dropdown.defaultProps = defaultProps;

Object(__WEBPACK_IMPORTED_MODULE_20__utils_bootstrapUtils__["a" /* bsClass */])('dropdown', Dropdown);

var UncontrolledDropdown = __WEBPACK_IMPORTED_MODULE_15_uncontrollable___default()(Dropdown, { open: 'onToggle' });

UncontrolledDropdown.Toggle = __WEBPACK_IMPORTED_MODULE_19__DropdownToggle__["a" /* default */];
UncontrolledDropdown.Menu = __WEBPACK_IMPORTED_MODULE_18__DropdownMenu__["a" /* default */];

/* harmony default export */ __webpack_exports__["a"] = (UncontrolledDropdown);

/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isRequiredForA11y;
function isRequiredForA11y(validator) {
  return function validate(props, propName, componentName, location, propFullName) {
    var componentNameSafe = componentName || '<<anonymous>>';
    var propFullNameSafe = propFullName || propName;

    if (props[propName] == null) {
      return new Error('The ' + location + ' `' + propFullNameSafe + '` is required to make ' + ('`' + componentNameSafe + '` accessible for users of assistive ') + 'technologies such as screen readers.');
    }

    for (var _len = arguments.length, args = Array(_len > 5 ? _len - 5 : 0), _key = 5; _key < _len; _key++) {
      args[_key - 5] = arguments[_key];
    }

    return validator.apply(undefined, [props, propName, componentName, location, propFullName].concat(args));
  };
}
module.exports = exports['default'];

/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (node, event, handler, capture) {
  (0, _on2.default)(node, event, handler, capture);

  return {
    remove: function remove() {
      (0, _off2.default)(node, event, handler, capture);
    }
  };
};

var _on = __webpack_require__(59);

var _on2 = _interopRequireDefault(_on);

var _off = __webpack_require__(97);

var _off2 = _interopRequireDefault(_off);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

module.exports = exports['default'];

/***/ }),
/* 63 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = splitComponentProps;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries__);

function splitComponentProps(props, Component) {
  var componentPropTypes = Component.propTypes;

  var parentProps = {};
  var childProps = {};

  __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries___default()(props).forEach(function (_ref) {
    var propName = _ref[0],
        propValue = _ref[1];

    if (componentPropTypes[propName]) {
      parentProps[propName] = propValue;
    } else {
      childProps[propName] = propValue;
    }
  });

  return [parentProps, childProps];
}

/***/ }),
/* 64 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_overlays_lib_Transition__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_overlays_lib_Transition___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react_overlays_lib_Transition__);









var propTypes = {
  /**
   * Show the component; triggers the fade in or fade out animation
   */
  'in': __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,

  /**
   * Wait until the first "enter" transition to mount the component (add it to the DOM)
   */
  mountOnEnter: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,

  /**
   * Unmount the component (remove it from the DOM) when it is faded out
   */
  unmountOnExit: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,

  /**
   * Run the fade in animation when the component mounts, if it is initially
   * shown
   */
  transitionAppear: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,

  /**
   * Duration of the fade animation in milliseconds, to ensure that finishing
   * callbacks are fired even if the original browser transition end events are
   * canceled
   */
  timeout: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number,

  /**
   * Callback fired before the component fades in
   */
  onEnter: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  /**
   * Callback fired after the component starts to fade in
   */
  onEntering: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  /**
   * Callback fired after the has component faded in
   */
  onEntered: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  /**
   * Callback fired before the component fades out
   */
  onExit: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  /**
   * Callback fired after the component starts to fade out
   */
  onExiting: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  /**
   * Callback fired after the component has faded out
   */
  onExited: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func
};

var defaultProps = {
  'in': false,
  timeout: 300,
  mountOnEnter: false,
  unmountOnExit: false,
  transitionAppear: false
};

var Fade = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(Fade, _React$Component);

  function Fade() {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Fade);

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  Fade.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_overlays_lib_Transition___default.a, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.props, {
      className: __WEBPACK_IMPORTED_MODULE_4_classnames___default()(this.props.className, 'fade'),
      enteredClassName: 'in',
      enteringClassName: 'in'
    }));
  };

  return Fade;
}(__WEBPACK_IMPORTED_MODULE_5_react___default.a.Component);

Fade.propTypes = propTypes;
Fade.defaultProps = defaultProps;

/* harmony default export */ __webpack_exports__["a"] = (Fade);

/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _createChainableTypeChecker = __webpack_require__(56);

var _createChainableTypeChecker2 = _interopRequireDefault(_createChainableTypeChecker);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function validate(props, propName, componentName, location, propFullName) {
  var propValue = props[propName];
  var propType = typeof propValue === 'undefined' ? 'undefined' : _typeof(propValue);

  if (_react2.default.isValidElement(propValue)) {
    return new Error('Invalid ' + location + ' `' + propFullName + '` of type ReactElement ' + ('supplied to `' + componentName + '`, expected a ReactComponent or a ') + 'DOMElement. You can usually obtain a ReactComponent or DOMElement ' + 'from a ReactElement by attaching a ref to it.');
  }

  if ((propType !== 'object' || typeof propValue.render !== 'function') && propValue.nodeType !== 1) {
    return new Error('Invalid ' + location + ' `' + propFullName + '` of value `' + propValue + '` ' + ('supplied to `' + componentName + '`, expected a ReactComponent or a ') + 'DOMElement.');
  }

  return null;
}

exports.default = (0, _createChainableTypeChecker2.default)(validate);
module.exports = exports['default'];

/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = getContainer;

var _reactDom = __webpack_require__(16);

var _reactDom2 = _interopRequireDefault(_reactDom);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getContainer(container, defaultContainer) {
  container = typeof container === 'function' ? container() : container;
  return _reactDom2.default.findDOMNode(container) || defaultContainer;
}
module.exports = exports['default'];

/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*
 * Toastr
 * Copyright 2012-2015
 * Authors: John Papa, Hans Fjällemark, and Tim Ferrell.
 * All Rights Reserved.
 * Use, reproduction, distribution, and modification of this code is subject to the terms and
 * conditions of the MIT license, available at http://www.opensource.org/licenses/mit-license.php
 *
 * ARIA Support: Greta Krafsig
 *
 * Project: https://github.com/CodeSeven/toastr
 */
/* global define */
; (function (define) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(337)], __WEBPACK_AMD_DEFINE_RESULT__ = function ($) {
        return (function () {
            var $container;
            var listener;
            var toastId = 0;
            var toastType = {
                error: 'error',
                info: 'info',
                success: 'success',
                warning: 'warning'
            };

            var toastr = {
                clear: clear,
                remove: remove,
                error: error,
                getContainer: getContainer,
                info: info,
                options: {},
                subscribe: subscribe,
                success: success,
                version: '2.1.2',
                warning: warning
            };

            var previousToast;

            return toastr;

            ////////////////

            function error(message, title, optionsOverride) {
                return notify({
                    type: toastType.error,
                    iconClass: getOptions().iconClasses.error,
                    message: message,
                    optionsOverride: optionsOverride,
                    title: title
                });
            }

            function getContainer(options, create) {
                if (!options) { options = getOptions(); }
                $container = $('#' + options.containerId);
                if ($container.length) {
                    return $container;
                }
                if (create) {
                    $container = createContainer(options);
                }
                return $container;
            }

            function info(message, title, optionsOverride) {
                return notify({
                    type: toastType.info,
                    iconClass: getOptions().iconClasses.info,
                    message: message,
                    optionsOverride: optionsOverride,
                    title: title
                });
            }

            function subscribe(callback) {
                listener = callback;
            }

            function success(message, title, optionsOverride) {
                return notify({
                    type: toastType.success,
                    iconClass: getOptions().iconClasses.success,
                    message: message,
                    optionsOverride: optionsOverride,
                    title: title
                });
            }

            function warning(message, title, optionsOverride) {
                return notify({
                    type: toastType.warning,
                    iconClass: getOptions().iconClasses.warning,
                    message: message,
                    optionsOverride: optionsOverride,
                    title: title
                });
            }

            function clear($toastElement, clearOptions) {
                var options = getOptions();
                if (!$container) { getContainer(options); }
                if (!clearToast($toastElement, options, clearOptions)) {
                    clearContainer(options);
                }
            }

            function remove($toastElement) {
                var options = getOptions();
                if (!$container) { getContainer(options); }
                if ($toastElement && $(':focus', $toastElement).length === 0) {
                    removeToast($toastElement);
                    return;
                }
                if ($container.children().length) {
                    $container.remove();
                }
            }

            // internal functions

            function clearContainer (options) {
                var toastsToClear = $container.children();
                for (var i = toastsToClear.length - 1; i >= 0; i--) {
                    clearToast($(toastsToClear[i]), options);
                }
            }

            function clearToast ($toastElement, options, clearOptions) {
                var force = clearOptions && clearOptions.force ? clearOptions.force : false;
                if ($toastElement && (force || $(':focus', $toastElement).length === 0)) {
                    $toastElement[options.hideMethod]({
                        duration: options.hideDuration,
                        easing: options.hideEasing,
                        complete: function () { removeToast($toastElement); }
                    });
                    return true;
                }
                return false;
            }

            function createContainer(options) {
                $container = $('<div/>')
                    .attr('id', options.containerId)
                    .addClass(options.positionClass)
                    .attr('aria-live', 'polite')
                    .attr('role', 'alert');

                $container.appendTo($(options.target));
                return $container;
            }

            function getDefaults() {
                return {
                    tapToDismiss: true,
                    toastClass: 'toast',
                    containerId: 'toast-container',
                    debug: false,

                    showMethod: 'fadeIn', //fadeIn, slideDown, and show are built into jQuery
                    showDuration: 300,
                    showEasing: 'swing', //swing and linear are built into jQuery
                    onShown: undefined,
                    hideMethod: 'fadeOut',
                    hideDuration: 1000,
                    hideEasing: 'swing',
                    onHidden: undefined,
                    closeMethod: false,
                    closeDuration: false,
                    closeEasing: false,

                    extendedTimeOut: 1000,
                    iconClasses: {
                        error: 'toast-error',
                        info: 'toast-info',
                        success: 'toast-success',
                        warning: 'toast-warning'
                    },
                    iconClass: 'toast-info',
                    positionClass: 'toast-top-right',
                    timeOut: 5000, // Set timeOut and extendedTimeOut to 0 to make it sticky
                    titleClass: 'toast-title',
                    messageClass: 'toast-message',
                    escapeHtml: false,
                    target: 'body',
                    closeHtml: '<button type="button">&times;</button>',
                    newestOnTop: true,
                    preventDuplicates: false,
                    progressBar: false
                };
            }

            function publish(args) {
                if (!listener) { return; }
                listener(args);
            }

            function notify(map) {
                var options = getOptions();
                var iconClass = map.iconClass || options.iconClass;

                if (typeof (map.optionsOverride) !== 'undefined') {
                    options = $.extend(options, map.optionsOverride);
                    iconClass = map.optionsOverride.iconClass || iconClass;
                }

                if (shouldExit(options, map)) { return; }

                toastId++;

                $container = getContainer(options, true);

                var intervalId = null;
                var $toastElement = $('<div/>');
                var $titleElement = $('<div/>');
                var $messageElement = $('<div/>');
                var $progressElement = $('<div/>');
                var $closeElement = $(options.closeHtml);
                var progressBar = {
                    intervalId: null,
                    hideEta: null,
                    maxHideTime: null
                };
                var response = {
                    toastId: toastId,
                    state: 'visible',
                    startTime: new Date(),
                    options: options,
                    map: map
                };

                personalizeToast();

                displayToast();

                handleEvents();

                publish(response);

                if (options.debug && console) {
                    console.log(response);
                }

                return $toastElement;

                function escapeHtml(source) {
                    if (source == null)
                        source = "";

                    return new String(source)
                        .replace(/&/g, '&amp;')
                        .replace(/"/g, '&quot;')
                        .replace(/'/g, '&#39;')
                        .replace(/</g, '&lt;')
                        .replace(/>/g, '&gt;');
                }

                function personalizeToast() {
                    setIcon();
                    setTitle();
                    setMessage();
                    setCloseButton();
                    setProgressBar();
                    setSequence();
                }

                function handleEvents() {
                    $toastElement.hover(stickAround, delayedHideToast);
                    if (!options.onclick && options.tapToDismiss) {
                        $toastElement.click(hideToast);
                    }

                    if (options.closeButton && $closeElement) {
                        $closeElement.click(function (event) {
                            if (event.stopPropagation) {
                                event.stopPropagation();
                            } else if (event.cancelBubble !== undefined && event.cancelBubble !== true) {
                                event.cancelBubble = true;
                            }
                            hideToast(true);
                        });
                    }

                    if (options.onclick) {
                        $toastElement.click(function (event) {
                            options.onclick(event);
                            hideToast();
                        });
                    }
                }

                function displayToast() {
                    $toastElement.hide();

                    $toastElement[options.showMethod](
                        {duration: options.showDuration, easing: options.showEasing, complete: options.onShown}
                    );

                    if (options.timeOut > 0) {
                        intervalId = setTimeout(hideToast, options.timeOut);
                        progressBar.maxHideTime = parseFloat(options.timeOut);
                        progressBar.hideEta = new Date().getTime() + progressBar.maxHideTime;
                        if (options.progressBar) {
                            progressBar.intervalId = setInterval(updateProgress, 10);
                        }
                    }
                }

                function setIcon() {
                    if (map.iconClass) {
                        $toastElement.addClass(options.toastClass).addClass(iconClass);
                    }
                }

                function setSequence() {
                    if (options.newestOnTop) {
                        $container.prepend($toastElement);
                    } else {
                        $container.append($toastElement);
                    }
                }

                function setTitle() {
                    if (map.title) {
                        $titleElement.append(!options.escapeHtml ? map.title : escapeHtml(map.title)).addClass(options.titleClass);
                        $toastElement.append($titleElement);
                    }
                }

                function setMessage() {
                    if (map.message) {
                        $messageElement.append(!options.escapeHtml ? map.message : escapeHtml(map.message)).addClass(options.messageClass);
                        $toastElement.append($messageElement);
                    }
                }

                function setCloseButton() {
                    if (options.closeButton) {
                        $closeElement.addClass('toast-close-button').attr('role', 'button');
                        $toastElement.prepend($closeElement);
                    }
                }

                function setProgressBar() {
                    if (options.progressBar) {
                        $progressElement.addClass('toast-progress');
                        $toastElement.prepend($progressElement);
                    }
                }

                function shouldExit(options, map) {
                    if (options.preventDuplicates) {
                        if (map.message === previousToast) {
                            return true;
                        } else {
                            previousToast = map.message;
                        }
                    }
                    return false;
                }

                function hideToast(override) {
                    var method = override && options.closeMethod !== false ? options.closeMethod : options.hideMethod;
                    var duration = override && options.closeDuration !== false ?
                        options.closeDuration : options.hideDuration;
                    var easing = override && options.closeEasing !== false ? options.closeEasing : options.hideEasing;
                    if ($(':focus', $toastElement).length && !override) {
                        return;
                    }
                    clearTimeout(progressBar.intervalId);
                    return $toastElement[method]({
                        duration: duration,
                        easing: easing,
                        complete: function () {
                            removeToast($toastElement);
                            if (options.onHidden && response.state !== 'hidden') {
                                options.onHidden();
                            }
                            response.state = 'hidden';
                            response.endTime = new Date();
                            publish(response);
                        }
                    });
                }

                function delayedHideToast() {
                    if (options.timeOut > 0 || options.extendedTimeOut > 0) {
                        intervalId = setTimeout(hideToast, options.extendedTimeOut);
                        progressBar.maxHideTime = parseFloat(options.extendedTimeOut);
                        progressBar.hideEta = new Date().getTime() + progressBar.maxHideTime;
                    }
                }

                function stickAround() {
                    clearTimeout(intervalId);
                    progressBar.hideEta = 0;
                    $toastElement.stop(true, true)[options.showMethod](
                        {duration: options.showDuration, easing: options.showEasing}
                    );
                }

                function updateProgress() {
                    var percentage = ((progressBar.hideEta - (new Date().getTime())) / progressBar.maxHideTime) * 100;
                    $progressElement.width(percentage + '%');
                }
            }

            function getOptions() {
                return $.extend({}, getDefaults(), toastr.options);
            }

            function removeToast($toastElement) {
                if (!$container) { $container = getContainer(); }
                if ($toastElement.is(':visible')) {
                    return;
                }
                $toastElement.remove();
                $toastElement = null;
                if ($container.children().length === 0) {
                    $container.remove();
                    previousToast = undefined;
                }
            }

        })();
    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
}(__webpack_require__(338)));


/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _Chart = __webpack_require__(340);

var _Chart2 = _interopRequireDefault(_Chart);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = { Chart: _Chart2.default };
module.exports = exports['default'];

/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */


/**
 * WARNING: DO NOT manually require this module.
 * This is a replacement for `invariant(...)` used by the error code system
 * and will _only_ be required by the corresponding babel pass.
 * It always throws.
 */

function reactProdInvariant(code) {
  var argCount = arguments.length - 1;

  var message = 'Minified React error #' + code + '; visit ' + 'http://facebook.github.io/react/docs/error-decoder.html?invariant=' + code;

  for (var argIdx = 0; argIdx < argCount; argIdx++) {
    message += '&args[]=' + encodeURIComponent(arguments[argIdx + 1]);
  }

  message += ' for the full message or use the non-minified dev environment' + ' for full errors and additional helpful warnings.';

  var error = new Error(message);
  error.name = 'Invariant Violation';
  error.framesToPop = 1; // we don't care about reactProdInvariant's own frame

  throw error;
}

module.exports = reactProdInvariant;

/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var emptyFunction = __webpack_require__(27);

/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var warning = emptyFunction;

if (false) {
  var printWarning = function printWarning(format) {
    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    var argIndex = 0;
    var message = 'Warning: ' + format.replace(/%s/g, function () {
      return args[argIndex++];
    });
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };

  warning = function warning(condition, format) {
    if (format === undefined) {
      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
    }

    if (format.indexOf('Failed Composite propType: ') === 0) {
      return; // Ignore CompositeComponent proptype check.
    }

    if (!condition) {
      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
        args[_key2 - 2] = arguments[_key2];
      }

      printWarning.apply(undefined, [format].concat(args));
    }
  };
}

module.exports = warning;

/***/ }),
/* 71 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_overlays__ = __webpack_require__(367);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_overlays___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_overlays__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__ = __webpack_require__(13);
var focus=function focus(){};var cDU=__WEBPACK_IMPORTED_MODULE_0_react_overlays__["Modal"].prototype.componentDidUpdate;var cDM=__WEBPACK_IMPORTED_MODULE_0_react_overlays__["Modal"].prototype.componentDidMount;__WEBPACK_IMPORTED_MODULE_0_react_overlays__["Modal"].prototype.componentDidUpdate=function(prevProps){if(this.focus!==focus){this.focus=focus;}cDU.call(this,prevProps);};__WEBPACK_IMPORTED_MODULE_0_react_overlays__["Modal"].prototype.componentDidMount=function(){if(this.focus!==focus){this.focus=focus;}cDM.call(this);};/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["k" /* Modal */]);

/***/ }),
/* 72 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return createLocation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return locationsAreEqual; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_resolve_pathname__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_value_equal__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__PathUtils__ = __webpack_require__(53);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var createLocation = function createLocation(path, state, key, currentLocation) {
  var location = void 0;
  if (typeof path === 'string') {
    // Two-arg form: push(path, state)
    location = Object(__WEBPACK_IMPORTED_MODULE_2__PathUtils__["d" /* parsePath */])(path);
    location.state = state;
  } else {
    // One-arg form: push(location)
    location = _extends({}, path);

    if (location.pathname === undefined) location.pathname = '';

    if (location.search) {
      if (location.search.charAt(0) !== '?') location.search = '?' + location.search;
    } else {
      location.search = '';
    }

    if (location.hash) {
      if (location.hash.charAt(0) !== '#') location.hash = '#' + location.hash;
    } else {
      location.hash = '';
    }

    if (state !== undefined && location.state === undefined) location.state = state;
  }

  try {
    location.pathname = decodeURI(location.pathname);
  } catch (e) {
    if (e instanceof URIError) {
      throw new URIError('Pathname "' + location.pathname + '" could not be decoded. ' + 'This is likely caused by an invalid percent-encoding.');
    } else {
      throw e;
    }
  }

  if (key) location.key = key;

  if (currentLocation) {
    // Resolve incomplete/relative pathname relative to current location.
    if (!location.pathname) {
      location.pathname = currentLocation.pathname;
    } else if (location.pathname.charAt(0) !== '/') {
      location.pathname = Object(__WEBPACK_IMPORTED_MODULE_0_resolve_pathname__["default"])(location.pathname, currentLocation.pathname);
    }
  } else {
    // When there is no prior location and pathname is empty, set it to /
    if (!location.pathname) {
      location.pathname = '/';
    }
  }

  return location;
};

var locationsAreEqual = function locationsAreEqual(a, b) {
  return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash && a.key === b.key && Object(__WEBPACK_IMPORTED_MODULE_1_value_equal__["default"])(a.state, b.state);
};

/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(9));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	(function (undefined) {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var Base = C_lib.Base;
	    var X32WordArray = C_lib.WordArray;

	    /**
	     * x64 namespace.
	     */
	    var C_x64 = C.x64 = {};

	    /**
	     * A 64-bit word.
	     */
	    var X64Word = C_x64.Word = Base.extend({
	        /**
	         * Initializes a newly created 64-bit word.
	         *
	         * @param {number} high The high 32 bits.
	         * @param {number} low The low 32 bits.
	         *
	         * @example
	         *
	         *     var x64Word = CryptoJS.x64.Word.create(0x00010203, 0x04050607);
	         */
	        init: function (high, low) {
	            this.high = high;
	            this.low = low;
	        }

	        /**
	         * Bitwise NOTs this word.
	         *
	         * @return {X64Word} A new x64-Word object after negating.
	         *
	         * @example
	         *
	         *     var negated = x64Word.not();
	         */
	        // not: function () {
	            // var high = ~this.high;
	            // var low = ~this.low;

	            // return X64Word.create(high, low);
	        // },

	        /**
	         * Bitwise ANDs this word with the passed word.
	         *
	         * @param {X64Word} word The x64-Word to AND with this word.
	         *
	         * @return {X64Word} A new x64-Word object after ANDing.
	         *
	         * @example
	         *
	         *     var anded = x64Word.and(anotherX64Word);
	         */
	        // and: function (word) {
	            // var high = this.high & word.high;
	            // var low = this.low & word.low;

	            // return X64Word.create(high, low);
	        // },

	        /**
	         * Bitwise ORs this word with the passed word.
	         *
	         * @param {X64Word} word The x64-Word to OR with this word.
	         *
	         * @return {X64Word} A new x64-Word object after ORing.
	         *
	         * @example
	         *
	         *     var ored = x64Word.or(anotherX64Word);
	         */
	        // or: function (word) {
	            // var high = this.high | word.high;
	            // var low = this.low | word.low;

	            // return X64Word.create(high, low);
	        // },

	        /**
	         * Bitwise XORs this word with the passed word.
	         *
	         * @param {X64Word} word The x64-Word to XOR with this word.
	         *
	         * @return {X64Word} A new x64-Word object after XORing.
	         *
	         * @example
	         *
	         *     var xored = x64Word.xor(anotherX64Word);
	         */
	        // xor: function (word) {
	            // var high = this.high ^ word.high;
	            // var low = this.low ^ word.low;

	            // return X64Word.create(high, low);
	        // },

	        /**
	         * Shifts this word n bits to the left.
	         *
	         * @param {number} n The number of bits to shift.
	         *
	         * @return {X64Word} A new x64-Word object after shifting.
	         *
	         * @example
	         *
	         *     var shifted = x64Word.shiftL(25);
	         */
	        // shiftL: function (n) {
	            // if (n < 32) {
	                // var high = (this.high << n) | (this.low >>> (32 - n));
	                // var low = this.low << n;
	            // } else {
	                // var high = this.low << (n - 32);
	                // var low = 0;
	            // }

	            // return X64Word.create(high, low);
	        // },

	        /**
	         * Shifts this word n bits to the right.
	         *
	         * @param {number} n The number of bits to shift.
	         *
	         * @return {X64Word} A new x64-Word object after shifting.
	         *
	         * @example
	         *
	         *     var shifted = x64Word.shiftR(7);
	         */
	        // shiftR: function (n) {
	            // if (n < 32) {
	                // var low = (this.low >>> n) | (this.high << (32 - n));
	                // var high = this.high >>> n;
	            // } else {
	                // var low = this.high >>> (n - 32);
	                // var high = 0;
	            // }

	            // return X64Word.create(high, low);
	        // },

	        /**
	         * Rotates this word n bits to the left.
	         *
	         * @param {number} n The number of bits to rotate.
	         *
	         * @return {X64Word} A new x64-Word object after rotating.
	         *
	         * @example
	         *
	         *     var rotated = x64Word.rotL(25);
	         */
	        // rotL: function (n) {
	            // return this.shiftL(n).or(this.shiftR(64 - n));
	        // },

	        /**
	         * Rotates this word n bits to the right.
	         *
	         * @param {number} n The number of bits to rotate.
	         *
	         * @return {X64Word} A new x64-Word object after rotating.
	         *
	         * @example
	         *
	         *     var rotated = x64Word.rotR(7);
	         */
	        // rotR: function (n) {
	            // return this.shiftR(n).or(this.shiftL(64 - n));
	        // },

	        /**
	         * Adds this word with the passed word.
	         *
	         * @param {X64Word} word The x64-Word to add with this word.
	         *
	         * @return {X64Word} A new x64-Word object after adding.
	         *
	         * @example
	         *
	         *     var added = x64Word.add(anotherX64Word);
	         */
	        // add: function (word) {
	            // var low = (this.low + word.low) | 0;
	            // var carry = (low >>> 0) < (this.low >>> 0) ? 1 : 0;
	            // var high = (this.high + word.high + carry) | 0;

	            // return X64Word.create(high, low);
	        // }
	    });

	    /**
	     * An array of 64-bit words.
	     *
	     * @property {Array} words The array of CryptoJS.x64.Word objects.
	     * @property {number} sigBytes The number of significant bytes in this word array.
	     */
	    var X64WordArray = C_x64.WordArray = Base.extend({
	        /**
	         * Initializes a newly created word array.
	         *
	         * @param {Array} words (Optional) An array of CryptoJS.x64.Word objects.
	         * @param {number} sigBytes (Optional) The number of significant bytes in the words.
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.x64.WordArray.create();
	         *
	         *     var wordArray = CryptoJS.x64.WordArray.create([
	         *         CryptoJS.x64.Word.create(0x00010203, 0x04050607),
	         *         CryptoJS.x64.Word.create(0x18191a1b, 0x1c1d1e1f)
	         *     ]);
	         *
	         *     var wordArray = CryptoJS.x64.WordArray.create([
	         *         CryptoJS.x64.Word.create(0x00010203, 0x04050607),
	         *         CryptoJS.x64.Word.create(0x18191a1b, 0x1c1d1e1f)
	         *     ], 10);
	         */
	        init: function (words, sigBytes) {
	            words = this.words = words || [];

	            if (sigBytes != undefined) {
	                this.sigBytes = sigBytes;
	            } else {
	                this.sigBytes = words.length * 8;
	            }
	        },

	        /**
	         * Converts this 64-bit word array to a 32-bit word array.
	         *
	         * @return {CryptoJS.lib.WordArray} This word array's data as a 32-bit word array.
	         *
	         * @example
	         *
	         *     var x32WordArray = x64WordArray.toX32();
	         */
	        toX32: function () {
	            // Shortcuts
	            var x64Words = this.words;
	            var x64WordsLength = x64Words.length;

	            // Convert
	            var x32Words = [];
	            for (var i = 0; i < x64WordsLength; i++) {
	                var x64Word = x64Words[i];
	                x32Words.push(x64Word.high);
	                x32Words.push(x64Word.low);
	            }

	            return X32WordArray.create(x32Words, this.sigBytes);
	        },

	        /**
	         * Creates a copy of this word array.
	         *
	         * @return {X64WordArray} The clone.
	         *
	         * @example
	         *
	         *     var clone = x64WordArray.clone();
	         */
	        clone: function () {
	            var clone = Base.clone.call(this);

	            // Clone "words" array
	            var words = clone.words = this.words.slice(0);

	            // Clone each X64Word object
	            var wordsLength = words.length;
	            for (var i = 0; i < wordsLength; i++) {
	                words[i] = words[i].clone();
	            }

	            return clone;
	        }
	    });
	}());


	return CryptoJS;

}));

/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__(206);
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__(42);
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),
/* 76 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};


/***/ }),
/* 77 */
/***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};


/***/ }),
/* 78 */
/***/ (function(module, exports) {

// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};


/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__(80)('keys');
var uid = __webpack_require__(55);
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};


/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(26);
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});
module.exports = function (key) {
  return store[key] || (store[key] = {});
};


/***/ }),
/* 81 */
/***/ (function(module, exports) {

// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');


/***/ }),
/* 82 */
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;


/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.13 ToObject(argument)
var defined = __webpack_require__(77);
module.exports = function (it) {
  return Object(defined(it));
};


/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _iterator = __webpack_require__(210);

var _iterator2 = _interopRequireDefault(_iterator);

var _symbol = __webpack_require__(221);

var _symbol2 = _interopRequireDefault(_symbol);

var _typeof = typeof _symbol2.default === "function" && typeof _iterator2.default === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = typeof _symbol2.default === "function" && _typeof(_iterator2.default) === "symbol" ? function (obj) {
  return typeof obj === "undefined" ? "undefined" : _typeof(obj);
} : function (obj) {
  return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof(obj);
};

/***/ }),
/* 85 */
/***/ (function(module, exports) {

module.exports = true;


/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject = __webpack_require__(35);
var dPs = __webpack_require__(214);
var enumBugKeys = __webpack_require__(81);
var IE_PROTO = __webpack_require__(79)('IE_PROTO');
var Empty = function () { /* empty */ };
var PROTOTYPE = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = __webpack_require__(116)('iframe');
  var i = enumBugKeys.length;
  var lt = '<';
  var gt = '>';
  var iframeDocument;
  iframe.style.display = 'none';
  __webpack_require__(215).appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
  return createDict();
};

module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty();
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};


/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

var def = __webpack_require__(28).f;
var has = __webpack_require__(29);
var TAG = __webpack_require__(20)('toStringTag');

module.exports = function (it, tag, stat) {
  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
};


/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

exports.f = __webpack_require__(20);


/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(26);
var core = __webpack_require__(19);
var LIBRARY = __webpack_require__(85);
var wksExt = __webpack_require__(88);
var defineProperty = __webpack_require__(28).f;
module.exports = function (name) {
  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
};


/***/ }),
/* 90 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);






var propTypes = {
  label: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string.isRequired,
  onClick: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func
};

var defaultProps = {
  label: 'Close'
};

var CloseButton = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(CloseButton, _React$Component);

  function CloseButton() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, CloseButton);

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  CloseButton.prototype.render = function render() {
    var _props = this.props,
        label = _props.label,
        onClick = _props.onClick;

    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
      'button',
      {
        type: 'button',
        className: 'close',
        onClick: onClick
      },
      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        'span',
        { 'aria-hidden': 'true' },
        '\xD7'
      ),
      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        'span',
        { className: 'sr-only' },
        label
      )
    );
  };

  return CloseButton;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

CloseButton.propTypes = propTypes;
CloseButton.defaultProps = defaultProps;

/* harmony default export */ __webpack_exports__["a"] = (CloseButton);

/***/ }),
/* 91 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types_extra_lib_all__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types_extra_lib_all___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_prop_types_extra_lib_all__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Button__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_bootstrapUtils__ = __webpack_require__(8);













var propTypes = {
  vertical: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  justified: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,

  /**
   * Display block buttons; only useful when used with the "vertical" prop.
   * @type {bool}
   */
  block: __WEBPACK_IMPORTED_MODULE_8_prop_types_extra_lib_all___default()(__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool, function (_ref) {
    var block = _ref.block,
        vertical = _ref.vertical;
    return block && !vertical ? new Error('`block` requires `vertical` to be set to have any effect') : null;
  })
};

var defaultProps = {
  block: false,
  justified: false,
  vertical: false
};

var ButtonGroup = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(ButtonGroup, _React$Component);

  function ButtonGroup() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, ButtonGroup);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  ButtonGroup.prototype.render = function render() {
    var _extends2;

    var _props = this.props,
        block = _props.block,
        justified = _props.justified,
        vertical = _props.vertical,
        className = _props.className,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['block', 'justified', 'vertical', 'className']);

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_10__utils_bootstrapUtils__["f" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_10__utils_bootstrapUtils__["d" /* getClassSet */])(bsProps), (_extends2 = {}, _extends2[Object(__WEBPACK_IMPORTED_MODULE_10__utils_bootstrapUtils__["e" /* prefix */])(bsProps)] = !vertical, _extends2[Object(__WEBPACK_IMPORTED_MODULE_10__utils_bootstrapUtils__["e" /* prefix */])(bsProps, 'vertical')] = vertical, _extends2[Object(__WEBPACK_IMPORTED_MODULE_10__utils_bootstrapUtils__["e" /* prefix */])(bsProps, 'justified')] = justified, _extends2[Object(__WEBPACK_IMPORTED_MODULE_10__utils_bootstrapUtils__["e" /* prefix */])(__WEBPACK_IMPORTED_MODULE_9__Button__["a" /* default */].defaultProps, 'block')] = block, _extends2));

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('div', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, elementProps, {
      className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, classes)
    }));
  };

  return ButtonGroup;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

ButtonGroup.propTypes = propTypes;
ButtonGroup.defaultProps = defaultProps;

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_10__utils_bootstrapUtils__["a" /* bsClass */])('btn-group', ButtonGroup));

/***/ }),
/* 92 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__ = __webpack_require__(8);











var propTypes = {
  /**
   * An icon name without "glyphicon-" prefix. See e.g. http://getbootstrap.com/components/#glyphicons
   */
  glyph: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string.isRequired
};

var Glyphicon = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Glyphicon, _React$Component);

  function Glyphicon() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, Glyphicon);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  Glyphicon.prototype.render = function render() {
    var _extends2;

    var _props = this.props,
        glyph = _props.glyph,
        className = _props.className,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['glyph', 'className']);

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["f" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["d" /* getClassSet */])(bsProps), (_extends2 = {}, _extends2[Object(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["e" /* prefix */])(bsProps, glyph)] = true, _extends2));

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('span', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, elementProps, {
      className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, classes)
    }));
  };

  return Glyphicon;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

Glyphicon.propTypes = propTypes;

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["a" /* bsClass */])('glyphicon', Glyphicon));

/***/ }),
/* 93 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_dom_helpers_style__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_dom_helpers_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_dom_helpers_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_overlays_lib_Transition__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_overlays_lib_Transition___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_react_overlays_lib_Transition__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_capitalize__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils_createChainedFunction__ = __webpack_require__(12);














var MARGINS = {
  height: ['marginTop', 'marginBottom'],
  width: ['marginLeft', 'marginRight']
};

// reading a dimension prop will cause the browser to recalculate,
// which will let our animations work
function triggerBrowserReflow(node) {
  node.offsetHeight; // eslint-disable-line no-unused-expressions
}

function getDimensionValue(dimension, elem) {
  var value = elem['offset' + Object(__WEBPACK_IMPORTED_MODULE_10__utils_capitalize__["a" /* default */])(dimension)];
  var margins = MARGINS[dimension];

  return value + parseInt(__WEBPACK_IMPORTED_MODULE_6_dom_helpers_style___default()(elem, margins[0]), 10) + parseInt(__WEBPACK_IMPORTED_MODULE_6_dom_helpers_style___default()(elem, margins[1]), 10);
}

var propTypes = {
  /**
   * Show the component; triggers the expand or collapse animation
   */
  'in': __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool,

  /**
   * Wait until the first "enter" transition to mount the component (add it to the DOM)
   */
  mountOnEnter: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool,

  /**
   * Unmount the component (remove it from the DOM) when it is collapsed
   */
  unmountOnExit: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool,

  /**
   * Run the expand animation when the component mounts, if it is initially
   * shown
   */
  transitionAppear: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool,

  /**
   * Duration of the collapse animation in milliseconds, to ensure that
   * finishing callbacks are fired even if the original browser transition end
   * events are canceled
   */
  timeout: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.number,

  /**
   * Callback fired before the component expands
   */
  onEnter: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func,
  /**
   * Callback fired after the component starts to expand
   */
  onEntering: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func,
  /**
   * Callback fired after the component has expanded
   */
  onEntered: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func,
  /**
   * Callback fired before the component collapses
   */
  onExit: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func,
  /**
   * Callback fired after the component starts to collapse
   */
  onExiting: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func,
  /**
   * Callback fired after the component has collapsed
   */
  onExited: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func,

  /**
   * The dimension used when collapsing, or a function that returns the
   * dimension
   *
   * _Note: Bootstrap only partially supports 'width'!
   * You will need to supply your own CSS animation for the `.width` CSS class._
   */
  dimension: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.oneOf(['height', 'width']), __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func]),

  /**
   * Function that returns the height or width of the animating DOM node
   *
   * Allows for providing some custom logic for how much the Collapse component
   * should animate in its specified dimension. Called with the current
   * dimension prop value and the DOM node.
   */
  getDimensionValue: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func,

  /**
   * ARIA role of collapsible element
   */
  role: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.string
};

var defaultProps = {
  'in': false,
  timeout: 300,
  mountOnEnter: false,
  unmountOnExit: false,
  transitionAppear: false,

  dimension: 'height',
  getDimensionValue: getDimensionValue
};

var Collapse = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Collapse, _React$Component);

  function Collapse(props, context) {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, Collapse);

    var _this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props, context));

    _this.handleEnter = _this.handleEnter.bind(_this);
    _this.handleEntering = _this.handleEntering.bind(_this);
    _this.handleEntered = _this.handleEntered.bind(_this);
    _this.handleExit = _this.handleExit.bind(_this);
    _this.handleExiting = _this.handleExiting.bind(_this);
    return _this;
  }

  /* -- Expanding -- */


  Collapse.prototype.handleEnter = function handleEnter(elem) {
    var dimension = this._dimension();
    elem.style[dimension] = '0';
  };

  Collapse.prototype.handleEntering = function handleEntering(elem) {
    var dimension = this._dimension();
    elem.style[dimension] = this._getScrollDimensionValue(elem, dimension);
  };

  Collapse.prototype.handleEntered = function handleEntered(elem) {
    var dimension = this._dimension();
    elem.style[dimension] = null;
  };

  /* -- Collapsing -- */


  Collapse.prototype.handleExit = function handleExit(elem) {
    var dimension = this._dimension();
    elem.style[dimension] = this.props.getDimensionValue(dimension, elem) + 'px';
    triggerBrowserReflow(elem);
  };

  Collapse.prototype.handleExiting = function handleExiting(elem) {
    var dimension = this._dimension();
    elem.style[dimension] = '0';
  };

  Collapse.prototype._dimension = function _dimension() {
    return typeof this.props.dimension === 'function' ? this.props.dimension() : this.props.dimension;
  };

  // for testing


  Collapse.prototype._getScrollDimensionValue = function _getScrollDimensionValue(elem, dimension) {
    return elem['scroll' + Object(__WEBPACK_IMPORTED_MODULE_10__utils_capitalize__["a" /* default */])(dimension)] + 'px';
  };

  Collapse.prototype.render = function render() {
    var _props = this.props,
        onEnter = _props.onEnter,
        onEntering = _props.onEntering,
        onEntered = _props.onEntered,
        onExit = _props.onExit,
        onExiting = _props.onExiting,
        className = _props.className,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['onEnter', 'onEntering', 'onEntered', 'onExit', 'onExiting', 'className']);

    delete props.dimension;
    delete props.getDimensionValue;

    var handleEnter = Object(__WEBPACK_IMPORTED_MODULE_11__utils_createChainedFunction__["a" /* default */])(this.handleEnter, onEnter);
    var handleEntering = Object(__WEBPACK_IMPORTED_MODULE_11__utils_createChainedFunction__["a" /* default */])(this.handleEntering, onEntering);
    var handleEntered = Object(__WEBPACK_IMPORTED_MODULE_11__utils_createChainedFunction__["a" /* default */])(this.handleEntered, onEntered);
    var handleExit = Object(__WEBPACK_IMPORTED_MODULE_11__utils_createChainedFunction__["a" /* default */])(this.handleExit, onExit);
    var handleExiting = Object(__WEBPACK_IMPORTED_MODULE_11__utils_createChainedFunction__["a" /* default */])(this.handleExiting, onExiting);

    var classes = {
      width: this._dimension() === 'width'
    };

    return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_overlays_lib_Transition___default.a, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, props, {
      'aria-expanded': props.role ? props['in'] : null,
      className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, classes),
      exitedClassName: 'collapse',
      exitingClassName: 'collapsing',
      enteredClassName: 'collapse in',
      enteringClassName: 'collapsing',
      onEnter: handleEnter,
      onEntering: handleEntering,
      onEntered: handleEntered,
      onExit: handleExit,
      onExiting: handleExiting
    }));
  };

  return Collapse;
}(__WEBPACK_IMPORTED_MODULE_7_react___default.a.Component);

Collapse.propTypes = propTypes;
Collapse.defaultProps = defaultProps;

/* harmony default export */ __webpack_exports__["a"] = (Collapse);

/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.EXITING = exports.ENTERED = exports.ENTERING = exports.EXITED = exports.UNMOUNTED = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _classnames = __webpack_require__(7);

var _classnames2 = _interopRequireDefault(_classnames);

var _on = __webpack_require__(59);

var _on2 = _interopRequireDefault(_on);

var _properties = __webpack_require__(133);

var _properties2 = _interopRequireDefault(_properties);

var _propTypes = __webpack_require__(5);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(16);

var _reactDom2 = _interopRequireDefault(_reactDom);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var transitionEndEvent = _properties2.default.end;

var UNMOUNTED = exports.UNMOUNTED = 0;
var EXITED = exports.EXITED = 1;
var ENTERING = exports.ENTERING = 2;
var ENTERED = exports.ENTERED = 3;
var EXITING = exports.EXITING = 4;

/**
 * The Transition component lets you define and run css transitions with a simple declarative api.
 * It works similar to React's own [CSSTransitionGroup](http://facebook.github.io/react/docs/animation.html#high-level-api-reactcsstransitiongroup)
 * but is specifically optimized for transitioning a single child "in" or "out".
 *
 * You don't even need to use class based css transitions if you don't want to (but it is easiest).
 * The extensive set of lifecycle callbacks means you have control over
 * the transitioning now at each step of the way.
 */

var Transition = function (_React$Component) {
  _inherits(Transition, _React$Component);

  function Transition(props, context) {
    _classCallCheck(this, Transition);

    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props, context));

    _this.updateStatus = function () {
      if (_this.nextStatus !== null) {
        // nextStatus will always be ENTERING or EXITING.
        _this.cancelNextCallback();
        var node = _reactDom2.default.findDOMNode(_this);

        if (_this.nextStatus === ENTERING) {
          _this.props.onEnter(node);

          _this.safeSetState({ status: ENTERING }, function () {
            _this.props.onEntering(node);

            _this.onTransitionEnd(node, function () {
              _this.safeSetState({ status: ENTERED }, function () {
                _this.props.onEntered(node);
              });
            });
          });
        } else {
          _this.props.onExit(node);

          _this.safeSetState({ status: EXITING }, function () {
            _this.props.onExiting(node);

            _this.onTransitionEnd(node, function () {
              _this.safeSetState({ status: EXITED }, function () {
                _this.props.onExited(node);
              });
            });
          });
        }

        _this.nextStatus = null;
      } else if (_this.props.unmountOnExit && _this.state.status === EXITED) {
        _this.setState({ status: UNMOUNTED });
      }
    };

    _this.cancelNextCallback = function () {
      if (_this.nextCallback !== null) {
        _this.nextCallback.cancel();
        _this.nextCallback = null;
      }
    };

    _this.safeSetState = function (nextState, callback) {
      // This shouldn't be necessary, but there are weird race conditions with
      // setState callbacks and unmounting in testing, so always make sure that
      // we can cancel any pending setState callbacks after we unmount.
      _this.setState(nextState, _this.setNextCallback(callback));
    };

    _this.setNextCallback = function (callback) {
      var active = true;

      _this.nextCallback = function (event) {
        if (active) {
          active = false;
          _this.nextCallback = null;

          callback(event);
        }
      };

      _this.nextCallback.cancel = function () {
        active = false;
      };

      return _this.nextCallback;
    };

    _this.onTransitionEnd = function (node, handler) {
      _this.setNextCallback(handler);

      if (node) {
        (0, _on2.default)(node, transitionEndEvent, _this.nextCallback);
        setTimeout(_this.nextCallback, _this.props.timeout);
      } else {
        setTimeout(_this.nextCallback, 0);
      }
    };

    var initialStatus = void 0;
    _this.nextStatus = null;

    if (props.in) {
      if (props.transitionAppear) {
        initialStatus = EXITED;
        _this.nextStatus = ENTERING;
      } else {
        initialStatus = ENTERED;
      }
    } else {
      if (props.unmountOnExit || props.mountOnEnter) {
        initialStatus = UNMOUNTED;
      } else {
        initialStatus = EXITED;
      }
    }

    _this.state = { status: initialStatus };

    _this.nextCallback = null;
    return _this;
  }

  Transition.prototype.componentDidMount = function componentDidMount() {
    this.updateStatus();
  };

  Transition.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var status = this.state.status;


    if (nextProps.in) {
      if (status === UNMOUNTED) {
        this.setState({ status: EXITED });
      }
      if (status !== ENTERING && status !== ENTERED) {
        this.nextStatus = ENTERING;
      }
    } else {
      if (status === ENTERING || status === ENTERED) {
        this.nextStatus = EXITING;
      }
    }
  };

  Transition.prototype.componentDidUpdate = function componentDidUpdate() {
    this.updateStatus();
  };

  Transition.prototype.componentWillUnmount = function componentWillUnmount() {
    this.cancelNextCallback();
  };

  Transition.prototype.render = function render() {
    var status = this.state.status;
    if (status === UNMOUNTED) {
      return null;
    }

    var _props = this.props,
        children = _props.children,
        className = _props.className,
        childProps = _objectWithoutProperties(_props, ['children', 'className']);

    Object.keys(Transition.propTypes).forEach(function (key) {
      return delete childProps[key];
    });

    var transitionClassName = void 0;
    if (status === EXITED) {
      transitionClassName = this.props.exitedClassName;
    } else if (status === ENTERING) {
      transitionClassName = this.props.enteringClassName;
    } else if (status === ENTERED) {
      transitionClassName = this.props.enteredClassName;
    } else if (status === EXITING) {
      transitionClassName = this.props.exitingClassName;
    }

    var child = _react2.default.Children.only(children);
    return _react2.default.cloneElement(child, _extends({}, childProps, {
      className: (0, _classnames2.default)(child.props.className, className, transitionClassName)
    }));
  };

  return Transition;
}(_react2.default.Component);

Transition.propTypes = {
  /**
   * Show the component; triggers the enter or exit animation
   */
  in: _propTypes2.default.bool,

  /**
   * Wait until the first "enter" transition to mount the component (add it to the DOM)
   */
  mountOnEnter: _propTypes2.default.bool,

  /**
   * Unmount the component (remove it from the DOM) when it is not shown
   */
  unmountOnExit: _propTypes2.default.bool,

  /**
   * Run the enter animation when the component mounts, if it is initially
   * shown
   */
  transitionAppear: _propTypes2.default.bool,

  /**
   * A Timeout for the animation, in milliseconds, to ensure that a node doesn't
   * transition indefinately if the browser transitionEnd events are
   * canceled or interrupted.
   *
   * By default this is set to a high number (5 seconds) as a failsafe. You should consider
   * setting this to the duration of your animation (or a bit above it).
   */
  timeout: _propTypes2.default.number,

  /**
   * CSS class or classes applied when the component is exited
   */
  exitedClassName: _propTypes2.default.string,
  /**
   * CSS class or classes applied while the component is exiting
   */
  exitingClassName: _propTypes2.default.string,
  /**
   * CSS class or classes applied when the component is entered
   */
  enteredClassName: _propTypes2.default.string,
  /**
   * CSS class or classes applied while the component is entering
   */
  enteringClassName: _propTypes2.default.string,

  /**
   * Callback fired before the "entering" classes are applied
   */
  onEnter: _propTypes2.default.func,
  /**
   * Callback fired after the "entering" classes are applied
   */
  onEntering: _propTypes2.default.func,
  /**
   * Callback fired after the "enter" classes are applied
   */
  onEntered: _propTypes2.default.func,
  /**
   * Callback fired before the "exiting" classes are applied
   */
  onExit: _propTypes2.default.func,
  /**
   * Callback fired after the "exiting" classes are applied
   */
  onExiting: _propTypes2.default.func,
  /**
   * Callback fired after the "exited" classes are applied
   */
  onExited: _propTypes2.default.func
};

// Name the function so it is clearer in the documentation
function noop() {}

Transition.displayName = 'Transition';

Transition.defaultProps = {
  in: false,
  unmountOnExit: false,
  transitionAppear: false,

  timeout: 5000,

  onEnter: noop,
  onEntering: noop,
  onEntered: noop,

  onExit: noop,
  onExiting: noop,
  onExited: noop
};

exports.default = Transition;

/***/ }),
/* 95 */
/***/ (function(module, exports) {

// Source: http://jsfiddle.net/vWx8V/
// http://stackoverflow.com/questions/5603195/full-list-of-javascript-keycodes

/**
 * Conenience method returns corresponding value for given keyName or keyCode.
 *
 * @param {Mixed} keyCode {Number} or keyName {String}
 * @return {Mixed}
 * @api public
 */

exports = module.exports = function(searchInput) {
  // Keyboard Events
  if (searchInput && 'object' === typeof searchInput) {
    var hasKeyCode = searchInput.which || searchInput.keyCode || searchInput.charCode
    if (hasKeyCode) searchInput = hasKeyCode
  }

  // Numbers
  if ('number' === typeof searchInput) return names[searchInput]

  // Everything else (cast to string)
  var search = String(searchInput)

  // check codes
  var foundNamedKey = codes[search.toLowerCase()]
  if (foundNamedKey) return foundNamedKey

  // check aliases
  var foundNamedKey = aliases[search.toLowerCase()]
  if (foundNamedKey) return foundNamedKey

  // weird character?
  if (search.length === 1) return search.charCodeAt(0)

  return undefined
}

/**
 * Get by name
 *
 *   exports.code['enter'] // => 13
 */

var codes = exports.code = exports.codes = {
  'backspace': 8,
  'tab': 9,
  'enter': 13,
  'shift': 16,
  'ctrl': 17,
  'alt': 18,
  'pause/break': 19,
  'caps lock': 20,
  'esc': 27,
  'space': 32,
  'page up': 33,
  'page down': 34,
  'end': 35,
  'home': 36,
  'left': 37,
  'up': 38,
  'right': 39,
  'down': 40,
  'insert': 45,
  'delete': 46,
  'command': 91,
  'left command': 91,
  'right command': 93,
  'numpad *': 106,
  'numpad +': 107,
  'numpad -': 109,
  'numpad .': 110,
  'numpad /': 111,
  'num lock': 144,
  'scroll lock': 145,
  'my computer': 182,
  'my calculator': 183,
  ';': 186,
  '=': 187,
  ',': 188,
  '-': 189,
  '.': 190,
  '/': 191,
  '`': 192,
  '[': 219,
  '\\': 220,
  ']': 221,
  "'": 222
}

// Helper aliases

var aliases = exports.aliases = {
  'windows': 91,
  '⇧': 16,
  '⌥': 18,
  '⌃': 17,
  '⌘': 91,
  'ctl': 17,
  'control': 17,
  'option': 18,
  'pause': 19,
  'break': 19,
  'caps': 20,
  'return': 13,
  'escape': 27,
  'spc': 32,
  'pgup': 33,
  'pgdn': 34,
  'ins': 45,
  'del': 46,
  'cmd': 91
}


/*!
 * Programatically add the following
 */

// lower case chars
for (i = 97; i < 123; i++) codes[String.fromCharCode(i)] = i - 32

// numbers
for (var i = 48; i < 58; i++) codes[i - 48] = i

// function keys
for (i = 1; i < 13; i++) codes['f'+i] = i + 111

// numpad keys
for (i = 0; i < 10; i++) codes['numpad '+i] = i + 96

/**
 * Get by code
 *
 *   exports.name[13] // => 'Enter'
 */

var names = exports.names = exports.title = {} // title for backward compat

// Create reverse mapping
for (i in codes) names[codes[i]] = i

// Add aliases
for (var alias in aliases) {
  codes[alias] = aliases[alias]
}


/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _contains = __webpack_require__(38);

var _contains2 = _interopRequireDefault(_contains);

var _propTypes = __webpack_require__(5);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(16);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _addEventListener = __webpack_require__(62);

var _addEventListener2 = _interopRequireDefault(_addEventListener);

var _ownerDocument = __webpack_require__(32);

var _ownerDocument2 = _interopRequireDefault(_ownerDocument);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var escapeKeyCode = 27;

function isLeftClickEvent(event) {
  return event.button === 0;
}

function isModifiedEvent(event) {
  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}

/**
 * The `<RootCloseWrapper/>` component registers your callback on the document
 * when rendered. Powers the `<Overlay/>` component. This is used achieve modal
 * style behavior where your callback is triggered when the user tries to
 * interact with the rest of the document or hits the `esc` key.
 */

var RootCloseWrapper = function (_React$Component) {
  _inherits(RootCloseWrapper, _React$Component);

  function RootCloseWrapper(props, context) {
    _classCallCheck(this, RootCloseWrapper);

    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props, context));

    _this.addEventListeners = function () {
      var event = _this.props.event;

      var doc = (0, _ownerDocument2.default)(_this);

      // Use capture for this listener so it fires before React's listener, to
      // avoid false positives in the contains() check below if the target DOM
      // element is removed in the React mouse callback.
      _this.documentMouseCaptureListener = (0, _addEventListener2.default)(doc, event, _this.handleMouseCapture, true);

      _this.documentMouseListener = (0, _addEventListener2.default)(doc, event, _this.handleMouse);

      _this.documentKeyupListener = (0, _addEventListener2.default)(doc, 'keyup', _this.handleKeyUp);
    };

    _this.removeEventListeners = function () {
      if (_this.documentMouseCaptureListener) {
        _this.documentMouseCaptureListener.remove();
      }

      if (_this.documentMouseListener) {
        _this.documentMouseListener.remove();
      }

      if (_this.documentKeyupListener) {
        _this.documentKeyupListener.remove();
      }
    };

    _this.handleMouseCapture = function (e) {
      _this.preventMouseRootClose = isModifiedEvent(e) || !isLeftClickEvent(e) || (0, _contains2.default)(_reactDom2.default.findDOMNode(_this), e.target);
    };

    _this.handleMouse = function (e) {
      if (!_this.preventMouseRootClose && _this.props.onRootClose) {
        _this.props.onRootClose(e);
      }
    };

    _this.handleKeyUp = function (e) {
      if (e.keyCode === escapeKeyCode && _this.props.onRootClose) {
        _this.props.onRootClose(e);
      }
    };

    _this.preventMouseRootClose = false;
    return _this;
  }

  RootCloseWrapper.prototype.componentDidMount = function componentDidMount() {
    if (!this.props.disabled) {
      this.addEventListeners();
    }
  };

  RootCloseWrapper.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
    if (!this.props.disabled && prevProps.disabled) {
      this.addEventListeners();
    } else if (this.props.disabled && !prevProps.disabled) {
      this.removeEventListeners();
    }
  };

  RootCloseWrapper.prototype.componentWillUnmount = function componentWillUnmount() {
    if (!this.props.disabled) {
      this.removeEventListeners();
    }
  };

  RootCloseWrapper.prototype.render = function render() {
    return this.props.children;
  };

  return RootCloseWrapper;
}(_react2.default.Component);

RootCloseWrapper.displayName = 'RootCloseWrapper';

RootCloseWrapper.propTypes = {
  /**
   * Callback fired after click or mousedown. Also triggers when user hits `esc`.
   */
  onRootClose: _propTypes2.default.func,
  /**
   * Children to render.
   */
  children: _propTypes2.default.element,
  /**
   * Disable the the RootCloseWrapper, preventing it from triggering `onRootClose`.
   */
  disabled: _propTypes2.default.bool,
  /**
   * Choose which document mouse event to bind to.
   */
  event: _propTypes2.default.oneOf(['click', 'mousedown'])
};

RootCloseWrapper.defaultProps = {
  event: 'click'
};

exports.default = RootCloseWrapper;
module.exports = exports['default'];

/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _inDOM = __webpack_require__(23);

var _inDOM2 = _interopRequireDefault(_inDOM);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var off = function off() {};
if (_inDOM2.default) {
  off = function () {
    if (document.addEventListener) return function (node, eventName, handler, capture) {
      return node.removeEventListener(eventName, handler, capture || false);
    };else if (document.attachEvent) return function (node, eventName, handler) {
      return node.detachEvent('on' + eventName, handler);
    };
  }();
}

exports.default = off;
module.exports = exports['default'];

/***/ }),
/* 98 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_elementType__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_elementType___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_elementType__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__MediaBody__ = __webpack_require__(287);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__MediaHeading__ = __webpack_require__(288);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__MediaLeft__ = __webpack_require__(289);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__MediaList__ = __webpack_require__(290);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__MediaListItem__ = __webpack_require__(291);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__MediaRight__ = __webpack_require__(292);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__utils_bootstrapUtils__ = __webpack_require__(8);

















var propTypes = {
  componentClass: __WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_elementType___default.a
};

var defaultProps = {
  componentClass: 'div'
};

var Media = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Media, _React$Component);

  function Media() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, Media);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  Media.prototype.render = function render() {
    var _props = this.props,
        Component = _props.componentClass,
        className = _props.className,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['componentClass', 'className']);

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_14__utils_bootstrapUtils__["f" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = Object(__WEBPACK_IMPORTED_MODULE_14__utils_bootstrapUtils__["d" /* getClassSet */])(bsProps);

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Component, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, elementProps, {
      className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, classes)
    }));
  };

  return Media;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

Media.propTypes = propTypes;
Media.defaultProps = defaultProps;

Media.Heading = __WEBPACK_IMPORTED_MODULE_9__MediaHeading__["a" /* default */];
Media.Body = __WEBPACK_IMPORTED_MODULE_8__MediaBody__["a" /* default */];
Media.Left = __WEBPACK_IMPORTED_MODULE_10__MediaLeft__["a" /* default */];
Media.Right = __WEBPACK_IMPORTED_MODULE_13__MediaRight__["a" /* default */];
Media.List = __WEBPACK_IMPORTED_MODULE_11__MediaList__["a" /* default */];
Media.ListItem = __WEBPACK_IMPORTED_MODULE_12__MediaListItem__["a" /* default */];

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_14__utils_bootstrapUtils__["a" /* bsClass */])('media', Media));

/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _propTypes = __webpack_require__(5);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _componentOrElement = __webpack_require__(65);

var _componentOrElement2 = _interopRequireDefault(_componentOrElement);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(16);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _getContainer = __webpack_require__(66);

var _getContainer2 = _interopRequireDefault(_getContainer);

var _ownerDocument = __webpack_require__(32);

var _ownerDocument2 = _interopRequireDefault(_ownerDocument);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * The `<Portal/>` component renders its children into a new "subtree" outside of current component hierarchy.
 * You can think of it as a declarative `appendChild()`, or jQuery's `$.fn.appendTo()`.
 * The children of `<Portal/>` component will be appended to the `container` specified.
 */
var Portal = function (_React$Component) {
  _inherits(Portal, _React$Component);

  function Portal() {
    var _temp, _this, _ret;

    _classCallCheck(this, Portal);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this._mountOverlayTarget = function () {
      if (!_this._overlayTarget) {
        _this._overlayTarget = document.createElement('div');
        _this._portalContainerNode = (0, _getContainer2.default)(_this.props.container, (0, _ownerDocument2.default)(_this).body);
        _this._portalContainerNode.appendChild(_this._overlayTarget);
      }
    }, _this._unmountOverlayTarget = function () {
      if (_this._overlayTarget) {
        _this._portalContainerNode.removeChild(_this._overlayTarget);
        _this._overlayTarget = null;
      }
      _this._portalContainerNode = null;
    }, _this._renderOverlay = function () {

      var overlay = !_this.props.children ? null : _react2.default.Children.only(_this.props.children);

      // Save reference for future access.
      if (overlay !== null) {
        _this._mountOverlayTarget();
        _this._overlayInstance = _reactDom2.default.unstable_renderSubtreeIntoContainer(_this, overlay, _this._overlayTarget);
      } else {
        // Unrender if the component is null for transitions to null
        _this._unrenderOverlay();
        _this._unmountOverlayTarget();
      }
    }, _this._unrenderOverlay = function () {
      if (_this._overlayTarget) {
        _reactDom2.default.unmountComponentAtNode(_this._overlayTarget);
        _this._overlayInstance = null;
      }
    }, _this.getMountNode = function () {
      return _this._overlayTarget;
    }, _this.getOverlayDOMNode = function () {
      if (!_this._isMounted) {
        throw new Error('getOverlayDOMNode(): A component must be mounted to have a DOM node.');
      }

      if (_this._overlayInstance) {
        return _reactDom2.default.findDOMNode(_this._overlayInstance);
      }

      return null;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Portal.prototype.componentDidMount = function componentDidMount() {
    this._isMounted = true;
    this._renderOverlay();
  };

  Portal.prototype.componentDidUpdate = function componentDidUpdate() {
    this._renderOverlay();
  };

  Portal.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if (this._overlayTarget && nextProps.container !== this.props.container) {
      this._portalContainerNode.removeChild(this._overlayTarget);
      this._portalContainerNode = (0, _getContainer2.default)(nextProps.container, (0, _ownerDocument2.default)(this).body);
      this._portalContainerNode.appendChild(this._overlayTarget);
    }
  };

  Portal.prototype.componentWillUnmount = function componentWillUnmount() {
    this._isMounted = false;
    this._unrenderOverlay();
    this._unmountOverlayTarget();
  };

  Portal.prototype.render = function render() {
    return null;
  };

  return Portal;
}(_react2.default.Component);

Portal.displayName = 'Portal';
Portal.propTypes = {
  /**
   * A Node, Component instance, or function that returns either. The `container` will have the Portal children
   * appended to it.
   */
  container: _propTypes2.default.oneOfType([_componentOrElement2.default, _propTypes2.default.func])
};
exports.default = Portal;
module.exports = exports['default'];

/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = scrollTop;

var _isWindow = __webpack_require__(50);

var _isWindow2 = _interopRequireDefault(_isWindow);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function scrollTop(node, val) {
  var win = (0, _isWindow2.default)(node);

  if (val === undefined) return win ? 'pageYOffset' in win ? win.pageYOffset : win.document.documentElement.scrollTop : node.scrollTop;

  if (win) win.scrollTo('pageXOffset' in win ? win.pageXOffset : win.document.documentElement.scrollLeft, val);else node.scrollTop = val;
}
module.exports = exports['default'];

/***/ }),
/* 101 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_uncontrollable__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_uncontrollable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_uncontrollable__);








var TAB = 'tab';
var PANE = 'pane';

var idPropType = __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number]);

var propTypes = {
  /**
   * HTML id attribute, required if no `generateChildId` prop
   * is specified.
   */
  id: function id(props) {
    var error = null;

    if (!props.generateChildId) {
      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      error = idPropType.apply(undefined, [props].concat(args));

      if (!error && !props.id) {
        error = new Error('In order to properly initialize Tabs in a way that is accessible ' + 'to assistive technologies (such as screen readers) an `id` or a ' + '`generateChildId` prop to TabContainer is required');
      }
    }

    return error;
  },


  /**
   * A function that takes an `eventKey` and `type` and returns a unique id for
   * child tab `<NavItem>`s and `<TabPane>`s. The function _must_ be a pure
   * function, meaning it should always return the _same_ id for the same set
   * of inputs. The default value requires that an `id` to be set for the
   * `<TabContainer>`.
   *
   * The `type` argument will either be `"tab"` or `"pane"`.
   *
   * @defaultValue (eventKey, type) => `${this.props.id}-${type}-${key}`
   */
  generateChildId: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,

  /**
   * A callback fired when a tab is selected.
   *
   * @controllable activeKey
   */
  onSelect: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,

  /**
   * The `eventKey` of the currently active tab.
   *
   * @controllable onSelect
   */
  activeKey: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.any
};

var childContextTypes = {
  $bs_tabContainer: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.shape({
    activeKey: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.any,
    onSelect: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func.isRequired,
    getTabId: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func.isRequired,
    getPaneId: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func.isRequired
  })
};

var TabContainer = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(TabContainer, _React$Component);

  function TabContainer() {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, TabContainer);

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  TabContainer.prototype.getChildContext = function getChildContext() {
    var _props = this.props,
        activeKey = _props.activeKey,
        onSelect = _props.onSelect,
        generateChildId = _props.generateChildId,
        id = _props.id;


    var getId = generateChildId || function (key, type) {
      return id ? id + '-' + type + '-' + key : null;
    };

    return {
      $bs_tabContainer: {
        activeKey: activeKey,
        onSelect: onSelect,
        getTabId: function getTabId(key) {
          return getId(key, TAB);
        },
        getPaneId: function getPaneId(key) {
          return getId(key, PANE);
        }
      }
    };
  };

  TabContainer.prototype.render = function render() {
    var _props2 = this.props,
        children = _props2.children,
        props = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default()(_props2, ['children']);

    delete props.generateChildId;
    delete props.onSelect;
    delete props.activeKey;

    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.cloneElement(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Children.only(children), props);
  };

  return TabContainer;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

TabContainer.propTypes = propTypes;
TabContainer.childContextTypes = childContextTypes;

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_6_uncontrollable___default()(TabContainer, { activeKey: 'onSelect' }));

/***/ }),
/* 102 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types_extra_lib_elementType__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types_extra_lib_elementType___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_prop_types_extra_lib_elementType__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__ = __webpack_require__(8);












var propTypes = {
  componentClass: __WEBPACK_IMPORTED_MODULE_8_prop_types_extra_lib_elementType___default.a,

  /**
   * Sets a default animation strategy for all children `<TabPane>`s. Use
   * `false` to disable, `true` to enable the default `<Fade>` animation or any
   * `<Transition>` component.
   */
  animation: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool, __WEBPACK_IMPORTED_MODULE_8_prop_types_extra_lib_elementType___default.a]),

  /**
   * Wait until the first "enter" transition to mount tabs (add them to the DOM)
   */
  mountOnEnter: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,

  /**
   * Unmount tabs (remove it from the DOM) when they are no longer visible
   */
  unmountOnExit: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool
};

var defaultProps = {
  componentClass: 'div',
  animation: true,
  mountOnEnter: false,
  unmountOnExit: false
};

var contextTypes = {
  $bs_tabContainer: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.shape({
    activeKey: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.any
  })
};

var childContextTypes = {
  $bs_tabContent: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.shape({
    bsClass: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string,
    animation: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool, __WEBPACK_IMPORTED_MODULE_8_prop_types_extra_lib_elementType___default.a]),
    activeKey: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.any,
    mountOnEnter: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
    unmountOnExit: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
    onPaneEnter: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func.isRequired,
    onPaneExited: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func.isRequired,
    exiting: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool.isRequired
  })
};

var TabContent = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(TabContent, _React$Component);

  function TabContent(props, context) {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, TabContent);

    var _this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props, context));

    _this.handlePaneEnter = _this.handlePaneEnter.bind(_this);
    _this.handlePaneExited = _this.handlePaneExited.bind(_this);

    // Active entries in state will be `null` unless `animation` is set. Need
    // to track active child in case keys swap and the active child changes
    // but the active key does not.
    _this.state = {
      activeKey: null,
      activeChild: null
    };
    return _this;
  }

  TabContent.prototype.getChildContext = function getChildContext() {
    var _props = this.props,
        bsClass = _props.bsClass,
        animation = _props.animation,
        mountOnEnter = _props.mountOnEnter,
        unmountOnExit = _props.unmountOnExit;


    var stateActiveKey = this.state.activeKey;
    var containerActiveKey = this.getContainerActiveKey();

    var activeKey = stateActiveKey != null ? stateActiveKey : containerActiveKey;
    var exiting = stateActiveKey != null && stateActiveKey !== containerActiveKey;

    return {
      $bs_tabContent: {
        bsClass: bsClass,
        animation: animation,
        activeKey: activeKey,
        mountOnEnter: mountOnEnter,
        unmountOnExit: unmountOnExit,
        onPaneEnter: this.handlePaneEnter,
        onPaneExited: this.handlePaneExited,
        exiting: exiting
      }
    };
  };

  TabContent.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if (!nextProps.animation && this.state.activeChild) {
      this.setState({ activeKey: null, activeChild: null });
    }
  };

  TabContent.prototype.componentWillUnmount = function componentWillUnmount() {
    this.isUnmounted = true;
  };

  TabContent.prototype.handlePaneEnter = function handlePaneEnter(child, childKey) {
    if (!this.props.animation) {
      return false;
    }

    // It's possible that this child should be transitioning out.
    if (childKey !== this.getContainerActiveKey()) {
      return false;
    }

    this.setState({
      activeKey: childKey,
      activeChild: child
    });

    return true;
  };

  TabContent.prototype.handlePaneExited = function handlePaneExited(child) {
    // This might happen as everything is unmounting.
    if (this.isUnmounted) {
      return;
    }

    this.setState(function (_ref) {
      var activeChild = _ref.activeChild;

      if (activeChild !== child) {
        return null;
      }

      return {
        activeKey: null,
        activeChild: null
      };
    });
  };

  TabContent.prototype.getContainerActiveKey = function getContainerActiveKey() {
    var tabContainer = this.context.$bs_tabContainer;
    return tabContainer && tabContainer.activeKey;
  };

  TabContent.prototype.render = function render() {
    var _props2 = this.props,
        Component = _props2.componentClass,
        className = _props2.className,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props2, ['componentClass', 'className']);

    var _splitBsPropsAndOmit = Object(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["g" /* splitBsPropsAndOmit */])(props, ['animation', 'mountOnEnter', 'unmountOnExit']),
        bsProps = _splitBsPropsAndOmit[0],
        elementProps = _splitBsPropsAndOmit[1];

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Component, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, elementProps, {
      className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, Object(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["e" /* prefix */])(bsProps, 'content'))
    }));
  };

  return TabContent;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

TabContent.propTypes = propTypes;
TabContent.defaultProps = defaultProps;
TabContent.contextTypes = contextTypes;
TabContent.childContextTypes = childContextTypes;

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["a" /* bsClass */])('tab', TabContent));

/***/ }),
/* 103 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return HeaderBar; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__ = __webpack_require__(13);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var HeaderBar=function(_Component){_inherits(HeaderBar,_Component);function HeaderBar(){var _ref;var _temp,_this,_ret;_classCallCheck(this,HeaderBar);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=HeaderBar.__proto__||Object.getPrototypeOf(HeaderBar)).call.apply(_ref,[this].concat(args))),_this),_this.changeView=function(e){_this.props.onChangeView(e);},_this.linkLogin=function(){_this.props.onChangeView('login');},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(HeaderBar,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row border-bottom white-bg'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('nav',{className:'navbar navbar-static-top'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'navbar-header'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{'aria-controls':'navbar','aria-expanded':'false','data-target':'#navbar','data-toggle':'collapse',className:'navbar-toggle collapsed',type:'button'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-reorder'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'navbar-brand logo'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:'/img/nxxt-logo.png',className:'img-responsive nxxt-logo'}),'NXXT')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'navbar-collapse collapse',id:'navbar'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'nav navbar-nav'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["l" /* NavDropdown */],{eventKey:3,title:'Select View',id:'basic-nav-dropdown'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["j" /* MenuItem */],{eventKey:'dashboard',onSelect:this.changeView},'Main Dashboard'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["j" /* MenuItem */],{eventKey:'logisticcreator',onSelect:this.changeView},'Shipper RFQ'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["j" /* MenuItem */],{eventKey:'truckdispatcher',onSelect:this.changeView},'Carrier View'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["j" /* MenuItem */],{eventKey:'recipientapp',onSelect:this.changeView},'Recipient App View'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["j" /* MenuItem */],{eventKey:'truckerapp',onSelect:this.changeView},'Trucker App View'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'nav navbar-top-links navbar-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{onClick:this.linkLogin},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-sign-out'}),' Log out'))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'btn-group btn-breadcrumb breadcrumb-default'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'btn btn-default'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'glyphicon glyphicon-home'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'btn btn-default visible-lg-block visible-md-block'},this.props.actualPosition)));}}]);return HeaderBar;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);;

/***/ }),
/* 104 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CollapsablePanel; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__ = __webpack_require__(13);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var CollapsablePanel=function(_Component){_inherits(CollapsablePanel,_Component);function CollapsablePanel(props){_classCallCheck(this,CollapsablePanel);var _this=_possibleConstructorReturn(this,(CollapsablePanel.__proto__||Object.getPrototypeOf(CollapsablePanel)).call(this,props));_this.state={panelOpen:true};return _this;}_createClass(CollapsablePanel,[{key:'render',value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ibox float-e-margins'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ibox-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5',null,this.props.title),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ibox-tools'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'collapse-link'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:this.state.panelOpen?'fa fa-chevron-up':'fa fa-chevron-down',onClick:function onClick(){return _this2.setState({panelOpen:!_this2.state.panelOpen});}})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["e" /* Collapse */],{'in':this.state.panelOpen},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ibox-content'},this.props.children)));}}]);return CollapsablePanel;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);;

/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.locationsAreEqual = exports.createLocation = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _resolvePathname = __webpack_require__(174);

var _resolvePathname2 = _interopRequireDefault(_resolvePathname);

var _valueEqual = __webpack_require__(175);

var _valueEqual2 = _interopRequireDefault(_valueEqual);

var _PathUtils = __webpack_require__(52);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var createLocation = exports.createLocation = function createLocation(path, state, key, currentLocation) {
  var location = void 0;
  if (typeof path === 'string') {
    // Two-arg form: push(path, state)
    location = (0, _PathUtils.parsePath)(path);
    location.state = state;
  } else {
    // One-arg form: push(location)
    location = _extends({}, path);

    if (location.pathname === undefined) location.pathname = '';

    if (location.search) {
      if (location.search.charAt(0) !== '?') location.search = '?' + location.search;
    } else {
      location.search = '';
    }

    if (location.hash) {
      if (location.hash.charAt(0) !== '#') location.hash = '#' + location.hash;
    } else {
      location.hash = '';
    }

    if (state !== undefined && location.state === undefined) location.state = state;
  }

  try {
    location.pathname = decodeURI(location.pathname);
  } catch (e) {
    if (e instanceof URIError) {
      throw new URIError('Pathname "' + location.pathname + '" could not be decoded. ' + 'This is likely caused by an invalid percent-encoding.');
    } else {
      throw e;
    }
  }

  if (key) location.key = key;

  if (currentLocation) {
    // Resolve incomplete/relative pathname relative to current location.
    if (!location.pathname) {
      location.pathname = currentLocation.pathname;
    } else if (location.pathname.charAt(0) !== '/') {
      location.pathname = (0, _resolvePathname2.default)(location.pathname, currentLocation.pathname);
    }
  } else {
    // When there is no prior location and pathname is empty, set it to /
    if (!location.pathname) {
      location.pathname = '/';
    }
  }

  return location;
};

var locationsAreEqual = exports.locationsAreEqual = function locationsAreEqual(a, b) {
  return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash && a.key === b.key && (0, _valueEqual2.default)(a.state, b.state);
};

/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _warning = __webpack_require__(11);

var _warning2 = _interopRequireDefault(_warning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var createTransitionManager = function createTransitionManager() {
  var prompt = null;

  var setPrompt = function setPrompt(nextPrompt) {
    (0, _warning2.default)(prompt == null, 'A history supports only one prompt at a time');

    prompt = nextPrompt;

    return function () {
      if (prompt === nextPrompt) prompt = null;
    };
  };

  var confirmTransitionTo = function confirmTransitionTo(location, action, getUserConfirmation, callback) {
    // TODO: If another transition starts while we're still confirming
    // the previous one, we may end up in a weird state. Figure out the
    // best way to handle this.
    if (prompt != null) {
      var result = typeof prompt === 'function' ? prompt(location, action) : prompt;

      if (typeof result === 'string') {
        if (typeof getUserConfirmation === 'function') {
          getUserConfirmation(result, callback);
        } else {
          (0, _warning2.default)(false, 'A history needs a getUserConfirmation function in order to use a prompt message');

          callback(true);
        }
      } else {
        // Return false from a transition hook to cancel the transition.
        callback(result !== false);
      }
    } else {
      callback(true);
    }
  };

  var listeners = [];

  var appendListener = function appendListener(fn) {
    var isActive = true;

    var listener = function listener() {
      if (isActive) fn.apply(undefined, arguments);
    };

    listeners.push(listener);

    return function () {
      isActive = false;
      listeners = listeners.filter(function (item) {
        return item !== listener;
      });
    };
  };

  var notifyListeners = function notifyListeners() {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    listeners.forEach(function (listener) {
      return listener.apply(undefined, args);
    });
  };

  return {
    setPrompt: setPrompt,
    confirmTransitionTo: confirmTransitionTo,
    appendListener: appendListener,
    notifyListeners: notifyListeners
  };
};

exports.default = createTransitionManager;

/***/ }),
/* 107 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Router__ = __webpack_require__(108);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Router__["a" /* default */]);

/***/ }),
/* 108 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






/**
 * The public API for putting history on context.
 */

var Router = function (_React$Component) {
  _inherits(Router, _React$Component);

  function Router() {
    var _temp, _this, _ret;

    _classCallCheck(this, Router);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
      match: _this.computeMatch(_this.props.history.location.pathname)
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Router.prototype.getChildContext = function getChildContext() {
    return {
      router: _extends({}, this.context.router, {
        history: this.props.history,
        route: {
          location: this.props.history.location,
          match: this.state.match
        }
      })
    };
  };

  Router.prototype.computeMatch = function computeMatch(pathname) {
    return {
      path: '/',
      url: '/',
      params: {},
      isExact: pathname === '/'
    };
  };

  Router.prototype.componentWillMount = function componentWillMount() {
    var _this2 = this;

    var _props = this.props,
        children = _props.children,
        history = _props.history;


    __WEBPACK_IMPORTED_MODULE_1_invariant___default()(children == null || __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.count(children) === 1, 'A <Router> may have only one child element');

    // Do this here so we can setState when a <Redirect> changes the
    // location in componentWillMount. This happens e.g. when doing
    // server rendering using a <StaticRouter>.
    this.unlisten = history.listen(function () {
      _this2.setState({
        match: _this2.computeMatch(history.location.pathname)
      });
    });
  };

  Router.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(this.props.history === nextProps.history, 'You cannot change <Router history>');
  };

  Router.prototype.componentWillUnmount = function componentWillUnmount() {
    this.unlisten();
  };

  Router.prototype.render = function render() {
    var children = this.props.children;

    return children ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.only(children) : null;
  };

  return Router;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

Router.propTypes = {
  history: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
  children: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.node
};
Router.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
};
Router.childContextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Router);

/***/ }),
/* 109 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_path_to_regexp__ = __webpack_require__(397);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_path_to_regexp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_path_to_regexp__);


var patternCache = {};
var cacheLimit = 10000;
var cacheCount = 0;

var compilePath = function compilePath(pattern, options) {
  var cacheKey = '' + options.end + options.strict + options.sensitive;
  var cache = patternCache[cacheKey] || (patternCache[cacheKey] = {});

  if (cache[pattern]) return cache[pattern];

  var keys = [];
  var re = __WEBPACK_IMPORTED_MODULE_0_path_to_regexp___default()(pattern, keys, options);
  var compiledPattern = { re: re, keys: keys };

  if (cacheCount < cacheLimit) {
    cache[pattern] = compiledPattern;
    cacheCount++;
  }

  return compiledPattern;
};

/**
 * Public API for matching a URL pathname to a path pattern.
 */
var matchPath = function matchPath(pathname) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  if (typeof options === 'string') options = { path: options };

  var _options = options,
      _options$path = _options.path,
      path = _options$path === undefined ? '/' : _options$path,
      _options$exact = _options.exact,
      exact = _options$exact === undefined ? false : _options$exact,
      _options$strict = _options.strict,
      strict = _options$strict === undefined ? false : _options$strict,
      _options$sensitive = _options.sensitive,
      sensitive = _options$sensitive === undefined ? false : _options$sensitive;

  var _compilePath = compilePath(path, { end: exact, strict: strict, sensitive: sensitive }),
      re = _compilePath.re,
      keys = _compilePath.keys;

  var match = re.exec(pathname);

  if (!match) return null;

  var url = match[0],
      values = match.slice(1);

  var isExact = pathname === url;

  if (exact && !isExact) return null;

  return {
    path: path, // the path pattern used to match
    url: path === '/' && url === '' ? '/' : url, // the matched portion of the URL
    isExact: isExact, // whether or not we matched exactly
    params: keys.reduce(function (memo, key, index) {
      memo[key.name] = values[index];
      return memo;
    }, {})
  };
};

/* harmony default export */ __webpack_exports__["a"] = (matchPath);

/***/ }),
/* 110 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);


var createTransitionManager = function createTransitionManager() {
  var prompt = null;

  var setPrompt = function setPrompt(nextPrompt) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(prompt == null, 'A history supports only one prompt at a time');

    prompt = nextPrompt;

    return function () {
      if (prompt === nextPrompt) prompt = null;
    };
  };

  var confirmTransitionTo = function confirmTransitionTo(location, action, getUserConfirmation, callback) {
    // TODO: If another transition starts while we're still confirming
    // the previous one, we may end up in a weird state. Figure out the
    // best way to handle this.
    if (prompt != null) {
      var result = typeof prompt === 'function' ? prompt(location, action) : prompt;

      if (typeof result === 'string') {
        if (typeof getUserConfirmation === 'function') {
          getUserConfirmation(result, callback);
        } else {
          __WEBPACK_IMPORTED_MODULE_0_warning___default()(false, 'A history needs a getUserConfirmation function in order to use a prompt message');

          callback(true);
        }
      } else {
        // Return false from a transition hook to cancel the transition.
        callback(result !== false);
      }
    } else {
      callback(true);
    }
  };

  var listeners = [];

  var appendListener = function appendListener(fn) {
    var isActive = true;

    var listener = function listener() {
      if (isActive) fn.apply(undefined, arguments);
    };

    listeners.push(listener);

    return function () {
      isActive = false;
      listeners = listeners.filter(function (item) {
        return item !== listener;
      });
    };
  };

  var notifyListeners = function notifyListeners() {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    listeners.forEach(function (listener) {
      return listener.apply(undefined, args);
    });
  };

  return {
    setPrompt: setPrompt,
    confirmTransitionTo: confirmTransitionTo,
    appendListener: appendListener,
    notifyListeners: notifyListeners
  };
};

/* harmony default export */ __webpack_exports__["a"] = (createTransitionManager);

/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(9));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	(function () {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var WordArray = C_lib.WordArray;
	    var Hasher = C_lib.Hasher;
	    var C_algo = C.algo;

	    // Reusable object
	    var W = [];

	    /**
	     * SHA-1 hash algorithm.
	     */
	    var SHA1 = C_algo.SHA1 = Hasher.extend({
	        _doReset: function () {
	            this._hash = new WordArray.init([
	                0x67452301, 0xefcdab89,
	                0x98badcfe, 0x10325476,
	                0xc3d2e1f0
	            ]);
	        },

	        _doProcessBlock: function (M, offset) {
	            // Shortcut
	            var H = this._hash.words;

	            // Working variables
	            var a = H[0];
	            var b = H[1];
	            var c = H[2];
	            var d = H[3];
	            var e = H[4];

	            // Computation
	            for (var i = 0; i < 80; i++) {
	                if (i < 16) {
	                    W[i] = M[offset + i] | 0;
	                } else {
	                    var n = W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16];
	                    W[i] = (n << 1) | (n >>> 31);
	                }

	                var t = ((a << 5) | (a >>> 27)) + e + W[i];
	                if (i < 20) {
	                    t += ((b & c) | (~b & d)) + 0x5a827999;
	                } else if (i < 40) {
	                    t += (b ^ c ^ d) + 0x6ed9eba1;
	                } else if (i < 60) {
	                    t += ((b & c) | (b & d) | (c & d)) - 0x70e44324;
	                } else /* if (i < 80) */ {
	                    t += (b ^ c ^ d) - 0x359d3e2a;
	                }

	                e = d;
	                d = c;
	                c = (b << 30) | (b >>> 2);
	                b = a;
	                a = t;
	            }

	            // Intermediate hash value
	            H[0] = (H[0] + a) | 0;
	            H[1] = (H[1] + b) | 0;
	            H[2] = (H[2] + c) | 0;
	            H[3] = (H[3] + d) | 0;
	            H[4] = (H[4] + e) | 0;
	        },

	        _doFinalize: function () {
	            // Shortcuts
	            var data = this._data;
	            var dataWords = data.words;

	            var nBitsTotal = this._nDataBytes * 8;
	            var nBitsLeft = data.sigBytes * 8;

	            // Add padding
	            dataWords[nBitsLeft >>> 5] |= 0x80 << (24 - nBitsLeft % 32);
	            dataWords[(((nBitsLeft + 64) >>> 9) << 4) + 14] = Math.floor(nBitsTotal / 0x100000000);
	            dataWords[(((nBitsLeft + 64) >>> 9) << 4) + 15] = nBitsTotal;
	            data.sigBytes = dataWords.length * 4;

	            // Hash final blocks
	            this._process();

	            // Return final computed hash
	            return this._hash;
	        },

	        clone: function () {
	            var clone = Hasher.clone.call(this);
	            clone._hash = this._hash.clone();

	            return clone;
	        }
	    });

	    /**
	     * Shortcut function to the hasher's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     *
	     * @return {WordArray} The hash.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hash = CryptoJS.SHA1('message');
	     *     var hash = CryptoJS.SHA1(wordArray);
	     */
	    C.SHA1 = Hasher._createHelper(SHA1);

	    /**
	     * Shortcut function to the HMAC's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     * @param {WordArray|string} key The secret key.
	     *
	     * @return {WordArray} The HMAC.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hmac = CryptoJS.HmacSHA1(message, key);
	     */
	    C.HmacSHA1 = Hasher._createHmacHelper(SHA1);
	}());


	return CryptoJS.SHA1;

}));

/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(9));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	(function () {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var Base = C_lib.Base;
	    var C_enc = C.enc;
	    var Utf8 = C_enc.Utf8;
	    var C_algo = C.algo;

	    /**
	     * HMAC algorithm.
	     */
	    var HMAC = C_algo.HMAC = Base.extend({
	        /**
	         * Initializes a newly created HMAC.
	         *
	         * @param {Hasher} hasher The hash algorithm to use.
	         * @param {WordArray|string} key The secret key.
	         *
	         * @example
	         *
	         *     var hmacHasher = CryptoJS.algo.HMAC.create(CryptoJS.algo.SHA256, key);
	         */
	        init: function (hasher, key) {
	            // Init hasher
	            hasher = this._hasher = new hasher.init();

	            // Convert string to WordArray, else assume WordArray already
	            if (typeof key == 'string') {
	                key = Utf8.parse(key);
	            }

	            // Shortcuts
	            var hasherBlockSize = hasher.blockSize;
	            var hasherBlockSizeBytes = hasherBlockSize * 4;

	            // Allow arbitrary length keys
	            if (key.sigBytes > hasherBlockSizeBytes) {
	                key = hasher.finalize(key);
	            }

	            // Clamp excess bits
	            key.clamp();

	            // Clone key for inner and outer pads
	            var oKey = this._oKey = key.clone();
	            var iKey = this._iKey = key.clone();

	            // Shortcuts
	            var oKeyWords = oKey.words;
	            var iKeyWords = iKey.words;

	            // XOR keys with pad constants
	            for (var i = 0; i < hasherBlockSize; i++) {
	                oKeyWords[i] ^= 0x5c5c5c5c;
	                iKeyWords[i] ^= 0x36363636;
	            }
	            oKey.sigBytes = iKey.sigBytes = hasherBlockSizeBytes;

	            // Set initial values
	            this.reset();
	        },

	        /**
	         * Resets this HMAC to its initial state.
	         *
	         * @example
	         *
	         *     hmacHasher.reset();
	         */
	        reset: function () {
	            // Shortcut
	            var hasher = this._hasher;

	            // Reset
	            hasher.reset();
	            hasher.update(this._iKey);
	        },

	        /**
	         * Updates this HMAC with a message.
	         *
	         * @param {WordArray|string} messageUpdate The message to append.
	         *
	         * @return {HMAC} This HMAC instance.
	         *
	         * @example
	         *
	         *     hmacHasher.update('message');
	         *     hmacHasher.update(wordArray);
	         */
	        update: function (messageUpdate) {
	            this._hasher.update(messageUpdate);

	            // Chainable
	            return this;
	        },

	        /**
	         * Finalizes the HMAC computation.
	         * Note that the finalize operation is effectively a destructive, read-once operation.
	         *
	         * @param {WordArray|string} messageUpdate (Optional) A final message update.
	         *
	         * @return {WordArray} The HMAC.
	         *
	         * @example
	         *
	         *     var hmac = hmacHasher.finalize();
	         *     var hmac = hmacHasher.finalize('message');
	         *     var hmac = hmacHasher.finalize(wordArray);
	         */
	        finalize: function (messageUpdate) {
	            // Shortcut
	            var hasher = this._hasher;

	            // Compute HMAC
	            var innerHash = hasher.finalize(messageUpdate);
	            hasher.reset();
	            var hmac = hasher.finalize(this._oKey.clone().concat(innerHash));

	            return hmac;
	        }
	    });
	}());


}));

/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var asap = __webpack_require__(186);

function noop() {}

// States:
//
// 0 - pending
// 1 - fulfilled with _value
// 2 - rejected with _value
// 3 - adopted the state of another promise, _value
//
// once the state is no longer pending (0) it is immutable

// All `_` prefixed properties will be reduced to `_{random number}`
// at build time to obfuscate them and discourage their use.
// We don't use symbols or Object.defineProperty to fully hide them
// because the performance isn't good enough.


// to avoid using try/catch inside critical functions, we
// extract them to here.
var LAST_ERROR = null;
var IS_ERROR = {};
function getThen(obj) {
  try {
    return obj.then;
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}

function tryCallOne(fn, a) {
  try {
    return fn(a);
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}
function tryCallTwo(fn, a, b) {
  try {
    fn(a, b);
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}

module.exports = Promise;

function Promise(fn) {
  if (typeof this !== 'object') {
    throw new TypeError('Promises must be constructed via new');
  }
  if (typeof fn !== 'function') {
    throw new TypeError('Promise constructor\'s argument is not a function');
  }
  this._75 = 0;
  this._83 = 0;
  this._18 = null;
  this._38 = null;
  if (fn === noop) return;
  doResolve(fn, this);
}
Promise._47 = null;
Promise._71 = null;
Promise._44 = noop;

Promise.prototype.then = function(onFulfilled, onRejected) {
  if (this.constructor !== Promise) {
    return safeThen(this, onFulfilled, onRejected);
  }
  var res = new Promise(noop);
  handle(this, new Handler(onFulfilled, onRejected, res));
  return res;
};

function safeThen(self, onFulfilled, onRejected) {
  return new self.constructor(function (resolve, reject) {
    var res = new Promise(noop);
    res.then(resolve, reject);
    handle(self, new Handler(onFulfilled, onRejected, res));
  });
}
function handle(self, deferred) {
  while (self._83 === 3) {
    self = self._18;
  }
  if (Promise._47) {
    Promise._47(self);
  }
  if (self._83 === 0) {
    if (self._75 === 0) {
      self._75 = 1;
      self._38 = deferred;
      return;
    }
    if (self._75 === 1) {
      self._75 = 2;
      self._38 = [self._38, deferred];
      return;
    }
    self._38.push(deferred);
    return;
  }
  handleResolved(self, deferred);
}

function handleResolved(self, deferred) {
  asap(function() {
    var cb = self._83 === 1 ? deferred.onFulfilled : deferred.onRejected;
    if (cb === null) {
      if (self._83 === 1) {
        resolve(deferred.promise, self._18);
      } else {
        reject(deferred.promise, self._18);
      }
      return;
    }
    var ret = tryCallOne(cb, self._18);
    if (ret === IS_ERROR) {
      reject(deferred.promise, LAST_ERROR);
    } else {
      resolve(deferred.promise, ret);
    }
  });
}
function resolve(self, newValue) {
  // Promise Resolution Procedure: https://github.com/promises-aplus/promises-spec#the-promise-resolution-procedure
  if (newValue === self) {
    return reject(
      self,
      new TypeError('A promise cannot be resolved with itself.')
    );
  }
  if (
    newValue &&
    (typeof newValue === 'object' || typeof newValue === 'function')
  ) {
    var then = getThen(newValue);
    if (then === IS_ERROR) {
      return reject(self, LAST_ERROR);
    }
    if (
      then === self.then &&
      newValue instanceof Promise
    ) {
      self._83 = 3;
      self._18 = newValue;
      finale(self);
      return;
    } else if (typeof then === 'function') {
      doResolve(then.bind(newValue), self);
      return;
    }
  }
  self._83 = 1;
  self._18 = newValue;
  finale(self);
}

function reject(self, newValue) {
  self._83 = 2;
  self._18 = newValue;
  if (Promise._71) {
    Promise._71(self, newValue);
  }
  finale(self);
}
function finale(self) {
  if (self._75 === 1) {
    handle(self, self._38);
    self._38 = null;
  }
  if (self._75 === 2) {
    for (var i = 0; i < self._38.length; i++) {
      handle(self, self._38[i]);
    }
    self._38 = null;
  }
}

function Handler(onFulfilled, onRejected, promise){
  this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
  this.onRejected = typeof onRejected === 'function' ? onRejected : null;
  this.promise = promise;
}

/**
 * Take a potentially misbehaving resolver function and make sure
 * onFulfilled and onRejected are only called once.
 *
 * Makes no guarantees about asynchrony.
 */
function doResolve(fn, promise) {
  var done = false;
  var res = tryCallTwo(fn, function (value) {
    if (done) return;
    done = true;
    resolve(promise, value);
  }, function (reason) {
    if (done) return;
    done = true;
    reject(promise, reason);
  });
  if (!done && res === IS_ERROR) {
    done = true;
    reject(promise, LAST_ERROR);
  }
}


/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(204), __esModule: true };

/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__(36) && !__webpack_require__(43)(function () {
  return Object.defineProperty(__webpack_require__(116)('div'), 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(42);
var document = __webpack_require__(26).document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};


/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__(29);
var toIObject = __webpack_require__(30);
var arrayIndexOf = __webpack_require__(208)(false);
var IE_PROTO = __webpack_require__(79)('IE_PROTO');

module.exports = function (object, names) {
  var O = toIObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};


/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__(76);
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return cof(it) == 'String' ? it.split('') : Object(it);
};


/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.15 ToLength
var toInteger = __webpack_require__(78);
var min = Math.min;
module.exports = function (it) {
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};


/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $at = __webpack_require__(212)(true);

// 21.1.3.27 String.prototype[@@iterator]()
__webpack_require__(121)(String, 'String', function (iterated) {
  this._t = String(iterated); // target
  this._i = 0;                // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var index = this._i;
  var point;
  if (index >= O.length) return { value: undefined, done: true };
  point = $at(O, index);
  this._i += point.length;
  return { value: point, done: false };
});


/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(85);
var $export = __webpack_require__(25);
var redefine = __webpack_require__(122);
var hide = __webpack_require__(34);
var has = __webpack_require__(29);
var Iterators = __webpack_require__(47);
var $iterCreate = __webpack_require__(213);
var setToStringTag = __webpack_require__(87);
var getPrototypeOf = __webpack_require__(216);
var ITERATOR = __webpack_require__(20)('iterator');
var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var FF_ITERATOR = '@@iterator';
var KEYS = 'keys';
var VALUES = 'values';

var returnThis = function () { return this; };

module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
  $iterCreate(Constructor, NAME, next);
  var getMethod = function (kind) {
    if (!BUGGY && kind in proto) return proto[kind];
    switch (kind) {
      case KEYS: return function keys() { return new Constructor(this, kind); };
      case VALUES: return function values() { return new Constructor(this, kind); };
    } return function entries() { return new Constructor(this, kind); };
  };
  var TAG = NAME + ' Iterator';
  var DEF_VALUES = DEFAULT == VALUES;
  var VALUES_BUG = false;
  var proto = Base.prototype;
  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
  var $default = $native || getMethod(DEFAULT);
  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
  var methods, key, IteratorPrototype;
  // Fix native
  if ($anyNative) {
    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
      // Set @@toStringTag to native iterators
      setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if (!LIBRARY && !has(IteratorPrototype, ITERATOR)) hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEF_VALUES && $native && $native.name !== VALUES) {
    VALUES_BUG = true;
    $default = function values() { return $native.call(this); };
  }
  // Define iterator
  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
    hide(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators[NAME] = $default;
  Iterators[TAG] = returnThis;
  if (DEFAULT) {
    methods = {
      values: DEF_VALUES ? $default : getMethod(VALUES),
      keys: IS_SET ? $default : getMethod(KEYS),
      entries: $entries
    };
    if (FORCED) for (key in methods) {
      if (!(key in proto)) redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};


/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(34);


/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
var $keys = __webpack_require__(117);
var hiddenKeys = __webpack_require__(81).concat('length', 'prototype');

exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return $keys(O, hiddenKeys);
};


/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

var pIE = __webpack_require__(46);
var createDesc = __webpack_require__(44);
var toIObject = __webpack_require__(30);
var toPrimitive = __webpack_require__(75);
var has = __webpack_require__(29);
var IE8_DOM_DEFINE = __webpack_require__(115);
var gOPD = Object.getOwnPropertyDescriptor;

exports.f = __webpack_require__(36) ? gOPD : function getOwnPropertyDescriptor(O, P) {
  O = toIObject(O);
  P = toPrimitive(P, true);
  if (IE8_DOM_DEFINE) try {
    return gOPD(O, P);
  } catch (e) { /* empty */ }
  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
};


/***/ }),
/* 125 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_createChainedFunction__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils_ValidComponentChildren__ = __webpack_require__(18);














var propTypes = {
  accordion: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool,
  activeKey: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.any,
  defaultActiveKey: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.any,
  onSelect: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func,
  role: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.string
};

var defaultProps = {
  accordion: false
};

// TODO: Use uncontrollable.

var PanelGroup = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(PanelGroup, _React$Component);

  function PanelGroup(props, context) {
    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, PanelGroup);

    var _this = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props, context));

    _this.handleSelect = _this.handleSelect.bind(_this);

    _this.state = {
      activeKey: props.defaultActiveKey
    };
    return _this;
  }

  PanelGroup.prototype.handleSelect = function handleSelect(key, e) {
    e.preventDefault();

    if (this.props.onSelect) {
      this.props.onSelect(key, e);
    }

    if (this.state.activeKey === key) {
      key = null;
    }

    this.setState({ activeKey: key });
  };

  PanelGroup.prototype.render = function render() {
    var _this2 = this;

    var _props = this.props,
        accordion = _props.accordion,
        propsActiveKey = _props.activeKey,
        className = _props.className,
        children = _props.children,
        props = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['accordion', 'activeKey', 'className', 'children']);

    var _splitBsPropsAndOmit = Object(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["g" /* splitBsPropsAndOmit */])(props, ['defaultActiveKey', 'onSelect']),
        bsProps = _splitBsPropsAndOmit[0],
        elementProps = _splitBsPropsAndOmit[1];

    var activeKey = void 0;
    if (accordion) {
      activeKey = propsActiveKey != null ? propsActiveKey : this.state.activeKey;
      elementProps.role = elementProps.role || 'tablist';
    }

    var classes = Object(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["d" /* getClassSet */])(bsProps);

    return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
      'div',
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, elementProps, {
        className: __WEBPACK_IMPORTED_MODULE_6_classnames___default()(className, classes)
      }),
      __WEBPACK_IMPORTED_MODULE_11__utils_ValidComponentChildren__["a" /* default */].map(children, function (child) {
        var childProps = {
          bsStyle: child.props.bsStyle || bsProps.bsStyle
        };

        if (accordion) {
          __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(childProps, {
            headerRole: 'tab',
            panelRole: 'tabpanel',
            collapsible: true,
            expanded: child.props.eventKey === activeKey,
            onSelect: Object(__WEBPACK_IMPORTED_MODULE_10__utils_createChainedFunction__["a" /* default */])(_this2.handleSelect, child.props.onSelect)
          });
        }

        return Object(__WEBPACK_IMPORTED_MODULE_7_react__["cloneElement"])(child, childProps);
      })
    );
  };

  return PanelGroup;
}(__WEBPACK_IMPORTED_MODULE_7_react___default.a.Component);

PanelGroup.propTypes = propTypes;
PanelGroup.defaultProps = defaultProps;

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["a" /* bsClass */])('panel-group', PanelGroup));

/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(239), __esModule: true };

/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

var getKeys = __webpack_require__(45);
var toIObject = __webpack_require__(30);
var isEnum = __webpack_require__(46).f;
module.exports = function (isEntries) {
  return function (it) {
    var O = toIObject(it);
    var keys = getKeys(O);
    var length = keys.length;
    var i = 0;
    var result = [];
    var key;
    while (length > i) if (isEnum.call(O, key = keys[i++])) {
      result.push(isEntries ? [key, O[key]] : O[key]);
    } return result;
  };
};


/***/ }),
/* 129 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__SafeAnchor__ = __webpack_require__(21);











var propTypes = {
  /**
   * If set to true, renders `span` instead of `a`
   */
  active: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  /**
   * `href` attribute for the inner `a` element
   */
  href: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string,
  /**
   * `title` attribute for the inner `a` element
   */
  title: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.node,
  /**
   * `target` attribute for the inner `a` element
   */
  target: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string
};

var defaultProps = {
  active: false
};

var BreadcrumbItem = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(BreadcrumbItem, _React$Component);

  function BreadcrumbItem() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, BreadcrumbItem);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  BreadcrumbItem.prototype.render = function render() {
    var _props = this.props,
        active = _props.active,
        href = _props.href,
        title = _props.title,
        target = _props.target,
        className = _props.className,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['active', 'href', 'title', 'target', 'className']);

    // Don't try to render these props on non-active <span>.


    var linkProps = { href: href, title: title, target: target };

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
      'li',
      { className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, { active: active }) },
      active ? __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('span', props) : __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__SafeAnchor__["a" /* default */], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, props, linkProps))
    );
  };

  return BreadcrumbItem;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

BreadcrumbItem.propTypes = propTypes;
BreadcrumbItem.defaultProps = defaultProps;

/* harmony default export */ __webpack_exports__["a"] = (BreadcrumbItem);

/***/ }),
/* 130 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_dom__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_TransitionEvents__ = __webpack_require__(249);












// TODO: This should use a timeout instead of TransitionEvents, or else just
// not wait until transition end to trigger continuing animations.

var propTypes = {
  direction: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.oneOf(['prev', 'next']),
  onAnimateOutEnd: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
  active: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  animateIn: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  animateOut: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  index: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.number
};

var defaultProps = {
  active: false,
  animateIn: false,
  animateOut: false
};

var CarouselItem = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(CarouselItem, _React$Component);

  function CarouselItem(props, context) {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, CarouselItem);

    var _this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props, context));

    _this.handleAnimateOutEnd = _this.handleAnimateOutEnd.bind(_this);

    _this.state = {
      direction: null
    };

    _this.isUnmounted = false;
    return _this;
  }

  CarouselItem.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if (this.props.active !== nextProps.active) {
      this.setState({ direction: null });
    }
  };

  CarouselItem.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
    var _this2 = this;

    var active = this.props.active;

    var prevActive = prevProps.active;

    if (!active && prevActive) {
      __WEBPACK_IMPORTED_MODULE_9__utils_TransitionEvents__["a" /* default */].addEndEventListener(__WEBPACK_IMPORTED_MODULE_8_react_dom___default.a.findDOMNode(this), this.handleAnimateOutEnd);
    }

    if (active !== prevActive) {
      setTimeout(function () {
        return _this2.startAnimation();
      }, 20);
    }
  };

  CarouselItem.prototype.componentWillUnmount = function componentWillUnmount() {
    this.isUnmounted = true;
  };

  CarouselItem.prototype.handleAnimateOutEnd = function handleAnimateOutEnd() {
    if (this.isUnmounted) {
      return;
    }

    if (this.props.onAnimateOutEnd) {
      this.props.onAnimateOutEnd(this.props.index);
    }
  };

  CarouselItem.prototype.startAnimation = function startAnimation() {
    if (this.isUnmounted) {
      return;
    }

    this.setState({
      direction: this.props.direction === 'prev' ? 'right' : 'left'
    });
  };

  CarouselItem.prototype.render = function render() {
    var _props = this.props,
        direction = _props.direction,
        active = _props.active,
        animateIn = _props.animateIn,
        animateOut = _props.animateOut,
        className = _props.className,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['direction', 'active', 'animateIn', 'animateOut', 'className']);

    delete props.onAnimateOutEnd;
    delete props.index;

    var classes = {
      item: true,
      active: active && !animateIn || animateOut
    };
    if (direction && active && animateIn) {
      classes[direction] = true;
    }
    if (this.state.direction && (animateIn || animateOut)) {
      classes[this.state.direction] = true;
    }

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('div', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, props, {
      className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, classes)
    }));
  };

  return CarouselItem;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

CarouselItem.propTypes = propTypes;
CarouselItem.defaultProps = defaultProps;

/* harmony default export */ __webpack_exports__["a"] = (CarouselItem);

/***/ }),
/* 131 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = capitalize;
function capitalize(string) {
  return "" + string.charAt(0).toUpperCase() + string.slice(1);
}

/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = camelizeStyleName;

var _camelize = __webpack_require__(254);

var _camelize2 = _interopRequireDefault(_camelize);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var msPattern = /^-ms-/; /**
                          * Copyright 2014-2015, Facebook, Inc.
                          * All rights reserved.
                          * https://github.com/facebook/react/blob/2aeb8a2a6beb00617a4217f7f8284924fa2ad819/src/vendor/core/camelizeStyleName.js
                          */
function camelizeStyleName(string) {
  return (0, _camelize2.default)(string.replace(msPattern, 'ms-'));
}
module.exports = exports['default'];

/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.animationEnd = exports.animationDelay = exports.animationTiming = exports.animationDuration = exports.animationName = exports.transitionEnd = exports.transitionDuration = exports.transitionDelay = exports.transitionTiming = exports.transitionProperty = exports.transform = undefined;

var _inDOM = __webpack_require__(23);

var _inDOM2 = _interopRequireDefault(_inDOM);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var transform = 'transform';
var prefix = void 0,
    transitionEnd = void 0,
    animationEnd = void 0;
var transitionProperty = void 0,
    transitionDuration = void 0,
    transitionTiming = void 0,
    transitionDelay = void 0;
var animationName = void 0,
    animationDuration = void 0,
    animationTiming = void 0,
    animationDelay = void 0;

if (_inDOM2.default) {
  var _getTransitionPropert = getTransitionProperties();

  prefix = _getTransitionPropert.prefix;
  exports.transitionEnd = transitionEnd = _getTransitionPropert.transitionEnd;
  exports.animationEnd = animationEnd = _getTransitionPropert.animationEnd;


  exports.transform = transform = prefix + '-' + transform;
  exports.transitionProperty = transitionProperty = prefix + '-transition-property';
  exports.transitionDuration = transitionDuration = prefix + '-transition-duration';
  exports.transitionDelay = transitionDelay = prefix + '-transition-delay';
  exports.transitionTiming = transitionTiming = prefix + '-transition-timing-function';

  exports.animationName = animationName = prefix + '-animation-name';
  exports.animationDuration = animationDuration = prefix + '-animation-duration';
  exports.animationTiming = animationTiming = prefix + '-animation-delay';
  exports.animationDelay = animationDelay = prefix + '-animation-timing-function';
}

exports.transform = transform;
exports.transitionProperty = transitionProperty;
exports.transitionTiming = transitionTiming;
exports.transitionDelay = transitionDelay;
exports.transitionDuration = transitionDuration;
exports.transitionEnd = transitionEnd;
exports.animationName = animationName;
exports.animationDuration = animationDuration;
exports.animationTiming = animationTiming;
exports.animationDelay = animationDelay;
exports.animationEnd = animationEnd;
exports.default = {
  transform: transform,
  end: transitionEnd,
  property: transitionProperty,
  timing: transitionTiming,
  delay: transitionDelay,
  duration: transitionDuration
};


function getTransitionProperties() {
  var style = document.createElement('div').style;

  var vendorMap = {
    O: function O(e) {
      return 'o' + e.toLowerCase();
    },
    Moz: function Moz(e) {
      return e.toLowerCase();
    },
    Webkit: function Webkit(e) {
      return 'webkit' + e;
    },
    ms: function ms(e) {
      return 'MS' + e;
    }
  };

  var vendors = Object.keys(vendorMap);

  var transitionEnd = void 0,
      animationEnd = void 0;
  var prefix = '';

  for (var i = 0; i < vendors.length; i++) {
    var vendor = vendors[i];

    if (vendor + 'TransitionProperty' in style) {
      prefix = '-' + vendor.toLowerCase();
      transitionEnd = vendorMap[vendor]('TransitionEnd');
      animationEnd = vendorMap[vendor]('AnimationEnd');
      break;
    }
  }

  if (!transitionEnd && 'transitionProperty' in style) transitionEnd = 'transitionend';

  if (!animationEnd && 'animationName' in style) animationEnd = 'animationend';

  style = null;

  return { animationEnd: animationEnd, transitionEnd: transitionEnd, prefix: prefix };
}

/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = activeElement;

var _ownerDocument = __webpack_require__(31);

var _ownerDocument2 = _interopRequireDefault(_ownerDocument);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function activeElement() {
  var doc = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _ownerDocument2.default)();

  try {
    return doc.activeElement;
  } catch (e) {/* ie throws if no active element */}
}
module.exports = exports['default'];

/***/ }),
/* 135 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_classnames__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Button__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__SafeAnchor__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_bootstrapUtils__ = __webpack_require__(8);













var propTypes = {
  noCaret: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  open: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  title: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  useAnchor: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool
};

var defaultProps = {
  open: false,
  useAnchor: false,
  bsRole: 'toggle'
};

var DropdownToggle = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(DropdownToggle, _React$Component);

  function DropdownToggle() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, DropdownToggle);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  DropdownToggle.prototype.render = function render() {
    var _props = this.props,
        noCaret = _props.noCaret,
        open = _props.open,
        useAnchor = _props.useAnchor,
        bsClass = _props.bsClass,
        className = _props.className,
        children = _props.children,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['noCaret', 'open', 'useAnchor', 'bsClass', 'className', 'children']);

    delete props.bsRole;

    var Component = useAnchor ? __WEBPACK_IMPORTED_MODULE_9__SafeAnchor__["a" /* default */] : __WEBPACK_IMPORTED_MODULE_8__Button__["a" /* default */];
    var useCaret = !noCaret;

    // This intentionally forwards bsSize and bsStyle (if set) to the
    // underlying component, to allow it to render size and style variants.

    // FIXME: Should this really fall back to `title` as children?

    return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
      Component,
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, props, {
        role: 'button',
        className: __WEBPACK_IMPORTED_MODULE_7_classnames___default()(className, bsClass),
        'aria-haspopup': true,
        'aria-expanded': open
      }),
      children || props.title,
      useCaret && ' ',
      useCaret && __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement('span', { className: 'caret' })
    );
  };

  return DropdownToggle;
}(__WEBPACK_IMPORTED_MODULE_5_react___default.a.Component);

DropdownToggle.propTypes = propTypes;
DropdownToggle.defaultProps = defaultProps;

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_10__utils_bootstrapUtils__["a" /* bsClass */])('dropdown-toggle', DropdownToggle));

/***/ }),
/* 136 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types_extra_lib_elementType__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types_extra_lib_elementType___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_prop_types_extra_lib_elementType__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__ = __webpack_require__(8);












var propTypes = {
  /**
   * Turn any fixed-width grid layout into a full-width layout by this property.
   *
   * Adds `container-fluid` class.
   */
  fluid: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  /**
   * You can use a custom element for this component
   */
  componentClass: __WEBPACK_IMPORTED_MODULE_8_prop_types_extra_lib_elementType___default.a
};

var defaultProps = {
  componentClass: 'div',
  fluid: false
};

var Grid = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Grid, _React$Component);

  function Grid() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, Grid);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  Grid.prototype.render = function render() {
    var _props = this.props,
        fluid = _props.fluid,
        Component = _props.componentClass,
        className = _props.className,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['fluid', 'componentClass', 'className']);

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["f" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = Object(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["e" /* prefix */])(bsProps, fluid && 'fluid');

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Component, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, elementProps, {
      className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, classes)
    }));
  };

  return Grid;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

Grid.propTypes = propTypes;
Grid.defaultProps = defaultProps;

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["a" /* bsClass */])('container', Grid));

/***/ }),
/* 137 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_StyleConfig__ = __webpack_require__(15);













var propTypes = {
  active: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.any,
  disabled: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.any,
  header: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.node,
  listItem: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool,
  onClick: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func,
  href: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.string,
  type: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.string
};

var defaultProps = {
  listItem: false
};

var ListGroupItem = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(ListGroupItem, _React$Component);

  function ListGroupItem() {
    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, ListGroupItem);

    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  ListGroupItem.prototype.renderHeader = function renderHeader(header, headingClassName) {
    if (__WEBPACK_IMPORTED_MODULE_7_react___default.a.isValidElement(header)) {
      return Object(__WEBPACK_IMPORTED_MODULE_7_react__["cloneElement"])(header, {
        className: __WEBPACK_IMPORTED_MODULE_6_classnames___default()(header.props.className, headingClassName)
      });
    }

    return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
      'h4',
      { className: headingClassName },
      header
    );
  };

  ListGroupItem.prototype.render = function render() {
    var _props = this.props,
        active = _props.active,
        disabled = _props.disabled,
        className = _props.className,
        header = _props.header,
        listItem = _props.listItem,
        children = _props.children,
        props = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['active', 'disabled', 'className', 'header', 'listItem', 'children']);

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["f" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["d" /* getClassSet */])(bsProps), {
      active: active,
      disabled: disabled
    });

    var Component = void 0;

    if (elementProps.href) {
      Component = 'a';
    } else if (elementProps.onClick) {
      Component = 'button';
      elementProps.type = elementProps.type || 'button';
    } else if (listItem) {
      Component = 'li';
    } else {
      Component = 'span';
    }

    elementProps.className = __WEBPACK_IMPORTED_MODULE_6_classnames___default()(className, classes);

    // TODO: Deprecate `header` prop.
    if (header) {
      return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
        Component,
        elementProps,
        this.renderHeader(header, Object(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["e" /* prefix */])(bsProps, 'heading')),
        __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
          'p',
          { className: Object(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["e" /* prefix */])(bsProps, 'text') },
          children
        )
      );
    }

    return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
      Component,
      elementProps,
      children
    );
  };

  return ListGroupItem;
}(__WEBPACK_IMPORTED_MODULE_7_react___default.a.Component);

ListGroupItem.propTypes = propTypes;
ListGroupItem.defaultProps = defaultProps;

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["a" /* bsClass */])('list-group-item', Object(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["c" /* bsStyles */])(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default()(__WEBPACK_IMPORTED_MODULE_10__utils_StyleConfig__["d" /* State */]), ListGroupItem)));

/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (recalc) {
  if (!size || recalc) {
    if (_inDOM2.default) {
      var scrollDiv = document.createElement('div');

      scrollDiv.style.position = 'absolute';
      scrollDiv.style.top = '-9999px';
      scrollDiv.style.width = '50px';
      scrollDiv.style.height = '50px';
      scrollDiv.style.overflow = 'scroll';

      document.body.appendChild(scrollDiv);
      size = scrollDiv.offsetWidth - scrollDiv.clientWidth;
      document.body.removeChild(scrollDiv);
    }
  }

  return size;
};

var _inDOM = __webpack_require__(23);

var _inDOM2 = _interopRequireDefault(_inDOM);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var size = void 0;

module.exports = exports['default'];

/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _activeElement = __webpack_require__(134);

var _activeElement2 = _interopRequireDefault(_activeElement);

var _contains = __webpack_require__(38);

var _contains2 = _interopRequireDefault(_contains);

var _inDOM = __webpack_require__(23);

var _inDOM2 = _interopRequireDefault(_inDOM);

var _propTypes = __webpack_require__(5);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _componentOrElement = __webpack_require__(65);

var _componentOrElement2 = _interopRequireDefault(_componentOrElement);

var _deprecated = __webpack_require__(299);

var _deprecated2 = _interopRequireDefault(_deprecated);

var _elementType = __webpack_require__(10);

var _elementType2 = _interopRequireDefault(_elementType);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _warning = __webpack_require__(11);

var _warning2 = _interopRequireDefault(_warning);

var _Portal = __webpack_require__(99);

var _Portal2 = _interopRequireDefault(_Portal);

var _ModalManager = __webpack_require__(300);

var _ModalManager2 = _interopRequireDefault(_ModalManager);

var _addEventListener = __webpack_require__(62);

var _addEventListener2 = _interopRequireDefault(_addEventListener);

var _addFocusListener = __webpack_require__(305);

var _addFocusListener2 = _interopRequireDefault(_addFocusListener);

var _getContainer = __webpack_require__(66);

var _getContainer2 = _interopRequireDefault(_getContainer);

var _ownerDocument = __webpack_require__(32);

var _ownerDocument2 = _interopRequireDefault(_ownerDocument);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*eslint-disable react/prop-types */

var modalManager = new _ModalManager2.default();

/**
 * Love them or hate them, `<Modal/>` provides a solid foundation for creating dialogs, lightboxes, or whatever else.
 * The Modal component renders its `children` node in front of a backdrop component.
 *
 * The Modal offers a few helpful features over using just a `<Portal/>` component and some styles:
 *
 * - Manages dialog stacking when one-at-a-time just isn't enough.
 * - Creates a backdrop, for disabling interaction below the modal.
 * - It properly manages focus; moving to the modal content, and keeping it there until the modal is closed.
 * - It disables scrolling of the page content while open.
 * - Adds the appropriate ARIA roles are automatically.
 * - Easily pluggable animations via a `<Transition/>` component.
 *
 * Note that, in the same way the backdrop element prevents users from clicking or interacting
 * with the page content underneath the Modal, Screen readers also need to be signaled to not to
 * interact with page content while the Modal is open. To do this, we use a common technique of applying
 * the `aria-hidden='true'` attribute to the non-Modal elements in the Modal `container`. This means that for
 * a Modal to be truly modal, it should have a `container` that is _outside_ your app's
 * React hierarchy (such as the default: document.body).
 */

var Modal = function (_React$Component) {
  _inherits(Modal, _React$Component);

  function Modal() {
    var _temp, _this, _ret;

    _classCallCheck(this, Modal);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _initialiseProps.call(_this), _temp), _possibleConstructorReturn(_this, _ret);
  }

  Modal.prototype.omitProps = function omitProps(props, propTypes) {

    var keys = Object.keys(props);
    var newProps = {};
    keys.map(function (prop) {
      if (!Object.prototype.hasOwnProperty.call(propTypes, prop)) {
        newProps[prop] = props[prop];
      }
    });

    return newProps;
  };

  Modal.prototype.render = function render() {
    var _props = this.props,
        show = _props.show,
        container = _props.container,
        children = _props.children,
        Transition = _props.transition,
        backdrop = _props.backdrop,
        dialogTransitionTimeout = _props.dialogTransitionTimeout,
        className = _props.className,
        style = _props.style,
        onExit = _props.onExit,
        onExiting = _props.onExiting,
        onEnter = _props.onEnter,
        onEntering = _props.onEntering,
        onEntered = _props.onEntered;


    var dialog = _react2.default.Children.only(children);
    var filteredProps = this.omitProps(this.props, Modal.propTypes);

    var mountModal = show || Transition && !this.state.exited;
    if (!mountModal) {
      return null;
    }

    var _dialog$props = dialog.props,
        role = _dialog$props.role,
        tabIndex = _dialog$props.tabIndex;


    if (role === undefined || tabIndex === undefined) {
      dialog = (0, _react.cloneElement)(dialog, {
        role: role === undefined ? 'document' : role,
        tabIndex: tabIndex == null ? '-1' : tabIndex
      });
    }

    if (Transition) {
      dialog = _react2.default.createElement(
        Transition,
        {
          transitionAppear: true,
          unmountOnExit: true,
          'in': show,
          timeout: dialogTransitionTimeout,
          onExit: onExit,
          onExiting: onExiting,
          onExited: this.handleHidden,
          onEnter: onEnter,
          onEntering: onEntering,
          onEntered: onEntered
        },
        dialog
      );
    }

    return _react2.default.createElement(
      _Portal2.default,
      {
        ref: this.setMountNode,
        container: container
      },
      _react2.default.createElement(
        'div',
        _extends({
          ref: this.setModalNode,
          role: role || 'dialog'
        }, filteredProps, {
          style: style,
          className: className
        }),
        backdrop && this.renderBackdrop(),
        dialog
      )
    );
  };

  Modal.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if (nextProps.show) {
      this.setState({ exited: false });
    } else if (!nextProps.transition) {
      // Otherwise let handleHidden take care of marking exited.
      this.setState({ exited: true });
    }
  };

  Modal.prototype.componentWillUpdate = function componentWillUpdate(nextProps) {
    if (!this.props.show && nextProps.show) {
      this.checkForFocus();
    }
  };

  Modal.prototype.componentDidMount = function componentDidMount() {
    this._isMounted = true;
    if (this.props.show) {
      this.onShow();
    }
  };

  Modal.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
    var transition = this.props.transition;


    if (prevProps.show && !this.props.show && !transition) {
      // Otherwise handleHidden will call this.
      this.onHide();
    } else if (!prevProps.show && this.props.show) {
      this.onShow();
    }
  };

  Modal.prototype.componentWillUnmount = function componentWillUnmount() {
    var _props2 = this.props,
        show = _props2.show,
        transition = _props2.transition;


    this._isMounted = false;

    if (show || transition && !this.state.exited) {
      this.onHide();
    }
  };

  //instead of a ref, which might conflict with one the parent applied.


  return Modal;
}(_react2.default.Component);

Modal.propTypes = _extends({}, _Portal2.default.propTypes, {

  /**
   * Set the visibility of the Modal
   */
  show: _propTypes2.default.bool,

  /**
   * A Node, Component instance, or function that returns either. The Modal is appended to it's container element.
   *
   * For the sake of assistive technologies, the container should usually be the document body, so that the rest of the
   * page content can be placed behind a virtual backdrop as well as a visual one.
   */
  container: _propTypes2.default.oneOfType([_componentOrElement2.default, _propTypes2.default.func]),

  /**
   * A callback fired when the Modal is opening.
   */
  onShow: _propTypes2.default.func,

  /**
   * A callback fired when either the backdrop is clicked, or the escape key is pressed.
   *
   * The `onHide` callback only signals intent from the Modal,
   * you must actually set the `show` prop to `false` for the Modal to close.
   */
  onHide: _propTypes2.default.func,

  /**
   * Include a backdrop component.
   */
  backdrop: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.oneOf(['static'])]),

  /**
   * A function that returns a backdrop component. Useful for custom
   * backdrop rendering.
   *
   * ```js
   *  renderBackdrop={props => <MyBackdrop {...props} />}
   * ```
   */
  renderBackdrop: _propTypes2.default.func,

  /**
   * A callback fired when the escape key, if specified in `keyboard`, is pressed.
   */
  onEscapeKeyDown: _propTypes2.default.func,

  /**
   * Support for this function will be deprecated. Please use `onEscapeKeyDown` instead
   * A callback fired when the escape key, if specified in `keyboard`, is pressed.
   * @deprecated
   */
  onEscapeKeyUp: (0, _deprecated2.default)(_propTypes2.default.func, 'Please use onEscapeKeyDown instead for consistency'),

  /**
   * A callback fired when the backdrop, if specified, is clicked.
   */
  onBackdropClick: _propTypes2.default.func,

  /**
   * A style object for the backdrop component.
   */
  backdropStyle: _propTypes2.default.object,

  /**
   * A css class or classes for the backdrop component.
   */
  backdropClassName: _propTypes2.default.string,

  /**
   * A css class or set of classes applied to the modal container when the modal is open,
   * and removed when it is closed.
   */
  containerClassName: _propTypes2.default.string,

  /**
   * Close the modal when escape key is pressed
   */
  keyboard: _propTypes2.default.bool,

  /**
   * A `<Transition/>` component to use for the dialog and backdrop components.
   */
  transition: _elementType2.default,

  /**
   * The `timeout` of the dialog transition if specified. This number is used to ensure that
   * transition callbacks are always fired, even if browser transition events are canceled.
   *
   * See the Transition `timeout` prop for more infomation.
   */
  dialogTransitionTimeout: _propTypes2.default.number,

  /**
   * The `timeout` of the backdrop transition if specified. This number is used to
   * ensure that transition callbacks are always fired, even if browser transition events are canceled.
   *
   * See the Transition `timeout` prop for more infomation.
   */
  backdropTransitionTimeout: _propTypes2.default.number,

  /**
   * When `true` The modal will automatically shift focus to itself when it opens, and
   * replace it to the last focused element when it closes. This also
   * works correctly with any Modal children that have the `autoFocus` prop.
   *
   * Generally this should never be set to `false` as it makes the Modal less
   * accessible to assistive technologies, like screen readers.
   */
  autoFocus: _propTypes2.default.bool,

  /**
   * When `true` The modal will prevent focus from leaving the Modal while open.
   *
   * Generally this should never be set to `false` as it makes the Modal less
   * accessible to assistive technologies, like screen readers.
   */
  enforceFocus: _propTypes2.default.bool,

  /**
   * When `true` The modal will restore focus to previously focused element once
   * modal is hidden
   */
  restoreFocus: _propTypes2.default.bool,

  /**
   * Callback fired before the Modal transitions in
   */
  onEnter: _propTypes2.default.func,

  /**
   * Callback fired as the Modal begins to transition in
   */
  onEntering: _propTypes2.default.func,

  /**
   * Callback fired after the Modal finishes transitioning in
   */
  onEntered: _propTypes2.default.func,

  /**
   * Callback fired right before the Modal transitions out
   */
  onExit: _propTypes2.default.func,

  /**
   * Callback fired as the Modal begins to transition out
   */
  onExiting: _propTypes2.default.func,

  /**
   * Callback fired after the Modal finishes transitioning out
   */
  onExited: _propTypes2.default.func,

  /**
   * A ModalManager instance used to track and manage the state of open
   * Modals. Useful when customizing how modals interact within a container
   */
  manager: _propTypes2.default.object.isRequired
});
Modal.defaultProps = {
  show: false,
  backdrop: true,
  keyboard: true,
  autoFocus: true,
  enforceFocus: true,
  restoreFocus: true,
  onHide: function onHide() {},
  manager: modalManager,
  renderBackdrop: function renderBackdrop(props) {
    return _react2.default.createElement('div', props);
  }
};

var _initialiseProps = function _initialiseProps() {
  var _this2 = this;

  this.state = { exited: !this.props.show };

  this.renderBackdrop = function () {
    var _props3 = _this2.props,
        backdropStyle = _props3.backdropStyle,
        backdropClassName = _props3.backdropClassName,
        renderBackdrop = _props3.renderBackdrop,
        Transition = _props3.transition,
        backdropTransitionTimeout = _props3.backdropTransitionTimeout;


    var backdropRef = function backdropRef(ref) {
      return _this2.backdrop = ref;
    };

    var backdrop = renderBackdrop({
      ref: backdropRef,
      style: backdropStyle,
      className: backdropClassName,
      onClick: _this2.handleBackdropClick
    });

    if (Transition) {
      backdrop = _react2.default.createElement(
        Transition,
        { transitionAppear: true,
          'in': _this2.props.show,
          timeout: backdropTransitionTimeout
        },
        backdrop
      );
    }

    return backdrop;
  };

  this.onShow = function () {
    var doc = (0, _ownerDocument2.default)(_this2);
    var container = (0, _getContainer2.default)(_this2.props.container, doc.body);

    _this2.props.manager.add(_this2, container, _this2.props.containerClassName);

    _this2._onDocumentKeydownListener = (0, _addEventListener2.default)(doc, 'keydown', _this2.handleDocumentKeyDown);

    _this2._onDocumentKeyupListener = (0, _addEventListener2.default)(doc, 'keyup', _this2.handleDocumentKeyUp);

    _this2._onFocusinListener = (0, _addFocusListener2.default)(_this2.enforceFocus);

    _this2.focus();

    if (_this2.props.onShow) {
      _this2.props.onShow();
    }
  };

  this.onHide = function () {
    _this2.props.manager.remove(_this2);

    _this2._onDocumentKeydownListener.remove();

    _this2._onDocumentKeyupListener.remove();

    _this2._onFocusinListener.remove();

    if (_this2.props.restoreFocus) {
      _this2.restoreLastFocus();
    }
  };

  this.setMountNode = function (ref) {
    _this2.mountNode = ref ? ref.getMountNode() : ref;
  };

  this.setModalNode = function (ref) {
    _this2.modalNode = ref;
  };

  this.handleHidden = function () {
    _this2.setState({ exited: true });
    _this2.onHide();

    if (_this2.props.onExited) {
      var _props4;

      (_props4 = _this2.props).onExited.apply(_props4, arguments);
    }
  };

  this.handleBackdropClick = function (e) {
    if (e.target !== e.currentTarget) {
      return;
    }

    if (_this2.props.onBackdropClick) {
      _this2.props.onBackdropClick(e);
    }

    if (_this2.props.backdrop === true) {
      _this2.props.onHide();
    }
  };

  this.handleDocumentKeyDown = function (e) {
    if (_this2.props.keyboard && e.key === 'Escape' && _this2.isTopModal()) {
      if (_this2.props.onEscapeKeyDown) {
        _this2.props.onEscapeKeyDown(e);
      }

      _this2.props.onHide();
    }
  };

  this.handleDocumentKeyUp = function (e) {
    if (_this2.props.keyboard && e.key === 'Escape' && _this2.isTopModal()) {
      if (_this2.props.onEscapeKeyUp) {
        _this2.props.onEscapeKeyUp(e);
      }
    }
  };

  this.checkForFocus = function () {
    if (_inDOM2.default) {
      _this2.lastFocus = (0, _activeElement2.default)();
    }
  };

  this.focus = function () {
    var autoFocus = _this2.props.autoFocus;
    var modalContent = _this2.getDialogElement();
    var current = (0, _activeElement2.default)((0, _ownerDocument2.default)(_this2));
    var focusInModal = current && (0, _contains2.default)(modalContent, current);

    if (modalContent && autoFocus && !focusInModal) {
      _this2.lastFocus = current;

      if (!modalContent.hasAttribute('tabIndex')) {
        modalContent.setAttribute('tabIndex', -1);
        (0, _warning2.default)(false, 'The modal content node does not accept focus. ' + 'For the benefit of assistive technologies, the tabIndex of the node is being set to "-1".');
      }

      modalContent.focus();
    }
  };

  this.restoreLastFocus = function () {
    // Support: <=IE11 doesn't support `focus()` on svg elements (RB: #917)
    if (_this2.lastFocus && _this2.lastFocus.focus) {
      _this2.lastFocus.focus();
      _this2.lastFocus = null;
    }
  };

  this.enforceFocus = function () {
    var enforceFocus = _this2.props.enforceFocus;


    if (!enforceFocus || !_this2._isMounted || !_this2.isTopModal()) {
      return;
    }

    var active = (0, _activeElement2.default)((0, _ownerDocument2.default)(_this2));
    var modal = _this2.getDialogElement();

    if (modal && modal !== active && !(0, _contains2.default)(modal, active)) {
      modal.focus();
    }
  };

  this.getDialogElement = function () {
    var node = _this2.modalNode;
    return node && node.lastChild;
  };

  this.isTopModal = function () {
    return _this2.props.manager.isTopModal(_this2);
  };
};

Modal.Manager = _ModalManager2.default;

exports.default = Modal;
module.exports = exports['default'];

/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = hasClass;
function hasClass(element, className) {
  if (element.classList) return !!className && element.classList.contains(className);else return (" " + element.className + " ").indexOf(" " + className + " ") !== -1;
}
module.exports = exports["default"];

/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = isOverflowing;

var _isWindow = __webpack_require__(50);

var _isWindow2 = _interopRequireDefault(_isWindow);

var _ownerDocument = __webpack_require__(31);

var _ownerDocument2 = _interopRequireDefault(_ownerDocument);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function isBody(node) {
  return node && node.tagName.toLowerCase() === 'body';
}

function bodyIsOverflowing(node) {
  var doc = (0, _ownerDocument2.default)(node);
  var win = (0, _isWindow2.default)(doc);
  var fullWidth = win.innerWidth;

  // Support: ie8, no innerWidth
  if (!fullWidth) {
    var documentElementRect = doc.documentElement.getBoundingClientRect();
    fullWidth = documentElementRect.right - Math.abs(documentElementRect.left);
  }

  return doc.body.clientWidth < fullWidth;
}

function isOverflowing(container) {
  var win = (0, _isWindow2.default)(container);

  return win || isBody(container) ? bodyIsOverflowing(container) : container.scrollHeight > container.clientHeight;
}
module.exports = exports['default'];

/***/ }),
/* 142 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_elementType__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_elementType___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_elementType__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__ = __webpack_require__(8);











var propTypes = {
  componentClass: __WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_elementType___default.a
};

var defaultProps = {
  componentClass: 'div'
};

var ModalBody = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(ModalBody, _React$Component);

  function ModalBody() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, ModalBody);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  ModalBody.prototype.render = function render() {
    var _props = this.props,
        Component = _props.componentClass,
        className = _props.className,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['componentClass', 'className']);

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["f" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = Object(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["d" /* getClassSet */])(bsProps);

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Component, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, elementProps, {
      className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, classes)
    }));
  };

  return ModalBody;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

ModalBody.propTypes = propTypes;
ModalBody.defaultProps = defaultProps;

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["a" /* bsClass */])('modal-body', ModalBody));

/***/ }),
/* 143 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_elementType__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_elementType___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_elementType__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__ = __webpack_require__(8);











var propTypes = {
  componentClass: __WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_elementType___default.a
};

var defaultProps = {
  componentClass: 'div'
};

var ModalFooter = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(ModalFooter, _React$Component);

  function ModalFooter() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, ModalFooter);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  ModalFooter.prototype.render = function render() {
    var _props = this.props,
        Component = _props.componentClass,
        className = _props.className,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['componentClass', 'className']);

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["f" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = Object(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["d" /* getClassSet */])(bsProps);

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Component, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, elementProps, {
      className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, classes)
    }));
  };

  return ModalFooter;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

ModalFooter.propTypes = propTypes;
ModalFooter.defaultProps = defaultProps;

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["a" /* bsClass */])('modal-footer', ModalFooter));

/***/ }),
/* 144 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_createChainedFunction__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__CloseButton__ = __webpack_require__(90);













// TODO: `aria-label` should be `closeLabel`.

var propTypes = {
  /**
   * Provides an accessible label for the close
   * button. It is used for Assistive Technology when the label text is not
   * readable.
   */
  closeLabel: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string,

  /**
   * Specify whether the Component should contain a close button
   */
  closeButton: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,

  /**
   * A Callback fired when the close button is clicked. If used directly inside
   * a Modal component, the onHide will automatically be propagated up to the
   * parent Modal `onHide`.
   */
  onHide: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func
};

var defaultProps = {
  closeLabel: 'Close',
  closeButton: false
};

var contextTypes = {
  $bs_modal: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.shape({
    onHide: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func
  })
};

var ModalHeader = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(ModalHeader, _React$Component);

  function ModalHeader() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, ModalHeader);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  ModalHeader.prototype.render = function render() {
    var _props = this.props,
        closeLabel = _props.closeLabel,
        closeButton = _props.closeButton,
        onHide = _props.onHide,
        className = _props.className,
        children = _props.children,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['closeLabel', 'closeButton', 'onHide', 'className', 'children']);

    var modal = this.context.$bs_modal;

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["f" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = Object(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["d" /* getClassSet */])(bsProps);

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
      'div',
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, elementProps, {
        className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, classes)
      }),
      closeButton && __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__CloseButton__["a" /* default */], {
        label: closeLabel,
        onClick: Object(__WEBPACK_IMPORTED_MODULE_9__utils_createChainedFunction__["a" /* default */])(modal && modal.onHide, onHide)
      }),
      children
    );
  };

  return ModalHeader;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

ModalHeader.propTypes = propTypes;
ModalHeader.defaultProps = defaultProps;
ModalHeader.contextTypes = contextTypes;

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["a" /* bsClass */])('modal-header', ModalHeader));

/***/ }),
/* 145 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_elementType__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_elementType___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_elementType__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__ = __webpack_require__(8);











var propTypes = {
  componentClass: __WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_elementType___default.a
};

var defaultProps = {
  componentClass: 'h4'
};

var ModalTitle = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(ModalTitle, _React$Component);

  function ModalTitle() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, ModalTitle);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  ModalTitle.prototype.render = function render() {
    var _props = this.props,
        Component = _props.componentClass,
        className = _props.className,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['componentClass', 'className']);

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["f" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = Object(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["d" /* getClassSet */])(bsProps);

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Component, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, elementProps, {
      className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, classes)
    }));
  };

  return ModalTitle;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

ModalTitle.propTypes = propTypes;
ModalTitle.defaultProps = defaultProps;

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["a" /* bsClass */])('modal-title', ModalTitle));

/***/ }),
/* 146 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_keycode__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_keycode___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_keycode__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_dom__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_prop_types_extra_lib_all__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_prop_types_extra_lib_all___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_prop_types_extra_lib_all__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_warning__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__utils_bootstrapUtils__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__utils_createChainedFunction__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__utils_ValidComponentChildren__ = __webpack_require__(18);

















// TODO: Should we expose `<NavItem>` as `<Nav.Item>`?

// TODO: This `bsStyle` is very unlike the others. Should we rename it?

// TODO: `pullRight` and `pullLeft` don't render right outside of `navbar`.
// Consider renaming or replacing them.

var propTypes = {
  /**
   * Marks the NavItem with a matching `eventKey` as active. Has a
   * higher precedence over `activeHref`.
   */
  activeKey: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.any,

  /**
   * Marks the child NavItem with a matching `href` prop as active.
   */
  activeHref: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.string,

  /**
   * NavItems are be positioned vertically.
   */
  stacked: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool,

  justified: __WEBPACK_IMPORTED_MODULE_10_prop_types_extra_lib_all___default()(__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool, function (_ref) {
    var justified = _ref.justified,
        navbar = _ref.navbar;
    return justified && navbar ? Error('justified navbar `Nav`s are not supported') : null;
  }),

  /**
   * A callback fired when a NavItem is selected.
   *
   * ```js
   * function (
   * 	Any eventKey,
   * 	SyntheticEvent event?
   * )
   * ```
   */
  onSelect: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func,

  /**
   * ARIA role for the Nav, in the context of a TabContainer, the default will
   * be set to "tablist", but can be overridden by the Nav when set explicitly.
   *
   * When the role is set to "tablist" NavItem focus is managed according to
   * the ARIA authoring practices for tabs:
   * https://www.w3.org/TR/2013/WD-wai-aria-practices-20130307/#tabpanel
   */
  role: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.string,

  /**
   * Apply styling an alignment for use in a Navbar. This prop will be set
   * automatically when the Nav is used inside a Navbar.
   */
  navbar: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool,

  /**
   * Float the Nav to the right. When `navbar` is `true` the appropriate
   * contextual classes are added as well.
   */
  pullRight: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool,

  /**
   * Float the Nav to the left. When `navbar` is `true` the appropriate
   * contextual classes are added as well.
   */
  pullLeft: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool
};

var defaultProps = {
  justified: false,
  pullRight: false,
  pullLeft: false,
  stacked: false
};

var contextTypes = {
  $bs_navbar: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.shape({
    bsClass: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.string,
    onSelect: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func
  }),

  $bs_tabContainer: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.shape({
    activeKey: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.any,
    onSelect: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func.isRequired,
    getTabId: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func.isRequired,
    getPaneId: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func.isRequired
  })
};

var Nav = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Nav, _React$Component);

  function Nav() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, Nav);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  Nav.prototype.componentDidUpdate = function componentDidUpdate() {
    var _this2 = this;

    if (!this._needsRefocus) {
      return;
    }

    this._needsRefocus = false;

    var children = this.props.children;

    var _getActiveProps = this.getActiveProps(),
        activeKey = _getActiveProps.activeKey,
        activeHref = _getActiveProps.activeHref;

    var activeChild = __WEBPACK_IMPORTED_MODULE_14__utils_ValidComponentChildren__["a" /* default */].find(children, function (child) {
      return _this2.isActive(child, activeKey, activeHref);
    });

    var childrenArray = __WEBPACK_IMPORTED_MODULE_14__utils_ValidComponentChildren__["a" /* default */].toArray(children);
    var activeChildIndex = childrenArray.indexOf(activeChild);

    var childNodes = __WEBPACK_IMPORTED_MODULE_9_react_dom___default.a.findDOMNode(this).children;
    var activeNode = childNodes && childNodes[activeChildIndex];

    if (!activeNode || !activeNode.firstChild) {
      return;
    }

    activeNode.firstChild.focus();
  };

  Nav.prototype.handleTabKeyDown = function handleTabKeyDown(onSelect, event) {
    var nextActiveChild = void 0;

    switch (event.keyCode) {
      case __WEBPACK_IMPORTED_MODULE_6_keycode___default.a.codes.left:
      case __WEBPACK_IMPORTED_MODULE_6_keycode___default.a.codes.up:
        nextActiveChild = this.getNextActiveChild(-1);
        break;
      case __WEBPACK_IMPORTED_MODULE_6_keycode___default.a.codes.right:
      case __WEBPACK_IMPORTED_MODULE_6_keycode___default.a.codes.down:
        nextActiveChild = this.getNextActiveChild(1);
        break;
      default:
        // It was a different key; don't handle this keypress.
        return;
    }

    event.preventDefault();

    if (onSelect && nextActiveChild && nextActiveChild.props.eventKey != null) {
      onSelect(nextActiveChild.props.eventKey);
    }

    this._needsRefocus = true;
  };

  Nav.prototype.getNextActiveChild = function getNextActiveChild(offset) {
    var _this3 = this;

    var children = this.props.children;

    var validChildren = children.filter(function (child) {
      return child.props.eventKey != null && !child.props.disabled;
    });

    var _getActiveProps2 = this.getActiveProps(),
        activeKey = _getActiveProps2.activeKey,
        activeHref = _getActiveProps2.activeHref;

    var activeChild = __WEBPACK_IMPORTED_MODULE_14__utils_ValidComponentChildren__["a" /* default */].find(children, function (child) {
      return _this3.isActive(child, activeKey, activeHref);
    });

    // This assumes the active child is not disabled.
    var activeChildIndex = validChildren.indexOf(activeChild);
    if (activeChildIndex === -1) {
      // Something has gone wrong. Select the first valid child we can find.
      return validChildren[0];
    }

    var nextIndex = activeChildIndex + offset;
    var numValidChildren = validChildren.length;

    if (nextIndex >= numValidChildren) {
      nextIndex = 0;
    } else if (nextIndex < 0) {
      nextIndex = numValidChildren - 1;
    }

    return validChildren[nextIndex];
  };

  Nav.prototype.getActiveProps = function getActiveProps() {
    var tabContainer = this.context.$bs_tabContainer;

    if (tabContainer) {
       false ? warning(this.props.activeKey == null && !this.props.activeHref, 'Specifying a `<Nav>` `activeKey` or `activeHref` in the context of ' + 'a `<TabContainer>` is not supported. Instead use `<TabContainer ' + ('activeKey={' + this.props.activeKey + '} />`.')) : void 0;

      return tabContainer;
    }

    return this.props;
  };

  Nav.prototype.isActive = function isActive(_ref2, activeKey, activeHref) {
    var props = _ref2.props;

    if (props.active || activeKey != null && props.eventKey === activeKey || activeHref && props.href === activeHref) {
      return true;
    }

    return props.active;
  };

  Nav.prototype.getTabProps = function getTabProps(child, tabContainer, navRole, active, onSelect) {
    var _this4 = this;

    if (!tabContainer && navRole !== 'tablist') {
      // No tab props here.
      return null;
    }

    var _child$props = child.props,
        id = _child$props.id,
        controls = _child$props['aria-controls'],
        eventKey = _child$props.eventKey,
        role = _child$props.role,
        onKeyDown = _child$props.onKeyDown,
        tabIndex = _child$props.tabIndex;


    if (tabContainer) {
       false ? warning(!id && !controls, 'In the context of a `<TabContainer>`, `<NavItem>`s are given ' + 'generated `id` and `aria-controls` attributes for the sake of ' + 'proper component accessibility. Any provided ones will be ignored. ' + 'To control these attributes directly, provide a `generateChildId` ' + 'prop to the parent `<TabContainer>`.') : void 0;

      id = tabContainer.getTabId(eventKey);
      controls = tabContainer.getPaneId(eventKey);
    }

    if (navRole === 'tablist') {
      role = role || 'tab';
      onKeyDown = Object(__WEBPACK_IMPORTED_MODULE_13__utils_createChainedFunction__["a" /* default */])(function (event) {
        return _this4.handleTabKeyDown(onSelect, event);
      }, onKeyDown);
      tabIndex = active ? tabIndex : -1;
    }

    return {
      id: id,
      role: role,
      onKeyDown: onKeyDown,
      'aria-controls': controls,
      tabIndex: tabIndex
    };
  };

  Nav.prototype.render = function render() {
    var _extends2,
        _this5 = this;

    var _props = this.props,
        stacked = _props.stacked,
        justified = _props.justified,
        onSelect = _props.onSelect,
        propsRole = _props.role,
        propsNavbar = _props.navbar,
        pullRight = _props.pullRight,
        pullLeft = _props.pullLeft,
        className = _props.className,
        children = _props.children,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['stacked', 'justified', 'onSelect', 'role', 'navbar', 'pullRight', 'pullLeft', 'className', 'children']);

    var tabContainer = this.context.$bs_tabContainer;
    var role = propsRole || (tabContainer ? 'tablist' : null);

    var _getActiveProps3 = this.getActiveProps(),
        activeKey = _getActiveProps3.activeKey,
        activeHref = _getActiveProps3.activeHref;

    delete props.activeKey; // Accessed via this.getActiveProps().
    delete props.activeHref; // Accessed via this.getActiveProps().

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_12__utils_bootstrapUtils__["f" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_12__utils_bootstrapUtils__["d" /* getClassSet */])(bsProps), (_extends2 = {}, _extends2[Object(__WEBPACK_IMPORTED_MODULE_12__utils_bootstrapUtils__["e" /* prefix */])(bsProps, 'stacked')] = stacked, _extends2[Object(__WEBPACK_IMPORTED_MODULE_12__utils_bootstrapUtils__["e" /* prefix */])(bsProps, 'justified')] = justified, _extends2));

    var navbar = propsNavbar != null ? propsNavbar : this.context.$bs_navbar;
    var pullLeftClassName = void 0;
    var pullRightClassName = void 0;

    if (navbar) {
      var navbarProps = this.context.$bs_navbar || { bsClass: 'navbar' };

      classes[Object(__WEBPACK_IMPORTED_MODULE_12__utils_bootstrapUtils__["e" /* prefix */])(navbarProps, 'nav')] = true;

      pullRightClassName = Object(__WEBPACK_IMPORTED_MODULE_12__utils_bootstrapUtils__["e" /* prefix */])(navbarProps, 'right');
      pullLeftClassName = Object(__WEBPACK_IMPORTED_MODULE_12__utils_bootstrapUtils__["e" /* prefix */])(navbarProps, 'left');
    } else {
      pullRightClassName = 'pull-right';
      pullLeftClassName = 'pull-left';
    }

    classes[pullRightClassName] = pullRight;
    classes[pullLeftClassName] = pullLeft;

    return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
      'ul',
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, elementProps, {
        role: role,
        className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, classes)
      }),
      __WEBPACK_IMPORTED_MODULE_14__utils_ValidComponentChildren__["a" /* default */].map(children, function (child) {
        var active = _this5.isActive(child, activeKey, activeHref);
        var childOnSelect = Object(__WEBPACK_IMPORTED_MODULE_13__utils_createChainedFunction__["a" /* default */])(child.props.onSelect, onSelect, navbar && navbar.onSelect, tabContainer && tabContainer.onSelect);

        return Object(__WEBPACK_IMPORTED_MODULE_7_react__["cloneElement"])(child, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, _this5.getTabProps(child, tabContainer, role, active, childOnSelect), {
          active: active,
          activeKey: activeKey,
          activeHref: activeHref,
          onSelect: childOnSelect
        }));
      })
    );
  };

  return Nav;
}(__WEBPACK_IMPORTED_MODULE_7_react___default.a.Component);

Nav.propTypes = propTypes;
Nav.defaultProps = defaultProps;
Nav.contextTypes = contextTypes;

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_12__utils_bootstrapUtils__["a" /* bsClass */])('nav', Object(__WEBPACK_IMPORTED_MODULE_12__utils_bootstrapUtils__["c" /* bsStyles */])(['tabs', 'pills'], Nav)));

/***/ }),
/* 147 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__ = __webpack_require__(8);











var contextTypes = {
  $bs_navbar: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.shape({
    bsClass: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string
  })
};

var NavbarBrand = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(NavbarBrand, _React$Component);

  function NavbarBrand() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, NavbarBrand);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  NavbarBrand.prototype.render = function render() {
    var _props = this.props,
        className = _props.className,
        children = _props.children,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['className', 'children']);

    var navbarProps = this.context.$bs_navbar || { bsClass: 'navbar' };

    var bsClassName = Object(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["e" /* prefix */])(navbarProps, 'brand');

    if (__WEBPACK_IMPORTED_MODULE_6_react___default.a.isValidElement(children)) {
      return __WEBPACK_IMPORTED_MODULE_6_react___default.a.cloneElement(children, {
        className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(children.props.className, className, bsClassName)
      });
    }

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
      'span',
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, props, { className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, bsClassName) }),
      children
    );
  };

  return NavbarBrand;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

NavbarBrand.contextTypes = contextTypes;

/* harmony default export */ __webpack_exports__["a"] = (NavbarBrand);

/***/ }),
/* 148 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__SafeAnchor__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_createChainedFunction__ = __webpack_require__(12);












var propTypes = {
  active: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  disabled: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  role: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string,
  href: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string,
  onClick: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
  onSelect: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
  eventKey: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.any
};

var defaultProps = {
  active: false,
  disabled: false
};

var NavItem = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(NavItem, _React$Component);

  function NavItem(props, context) {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, NavItem);

    var _this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props, context));

    _this.handleClick = _this.handleClick.bind(_this);
    return _this;
  }

  NavItem.prototype.handleClick = function handleClick(e) {
    if (this.props.onSelect) {
      e.preventDefault();

      if (!this.props.disabled) {
        this.props.onSelect(this.props.eventKey, e);
      }
    }
  };

  NavItem.prototype.render = function render() {
    var _props = this.props,
        active = _props.active,
        disabled = _props.disabled,
        onClick = _props.onClick,
        className = _props.className,
        style = _props.style,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['active', 'disabled', 'onClick', 'className', 'style']);

    delete props.onSelect;
    delete props.eventKey;

    // These are injected down by `<Nav>` for building `<SubNav>`s.
    delete props.activeKey;
    delete props.activeHref;

    if (!props.role) {
      if (props.href === '#') {
        props.role = 'button';
      }
    } else if (props.role === 'tab') {
      props['aria-selected'] = active;
    }

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
      'li',
      {
        role: 'presentation',
        className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, { active: active, disabled: disabled }),
        style: style
      },
      __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__SafeAnchor__["a" /* default */], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, props, {
        disabled: disabled,
        onClick: Object(__WEBPACK_IMPORTED_MODULE_9__utils_createChainedFunction__["a" /* default */])(onClick, this.handleClick)
      }))
    );
  };

  return NavItem;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

NavItem.propTypes = propTypes;
NavItem.defaultProps = defaultProps;

/* harmony default export */ __webpack_exports__["a"] = (NavItem);

/***/ }),
/* 149 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_overlays_lib_Overlay__ = __webpack_require__(150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_overlays_lib_Overlay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react_overlays_lib_Overlay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_prop_types_extra_lib_elementType__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_prop_types_extra_lib_elementType___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_prop_types_extra_lib_elementType__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Fade__ = __webpack_require__(64);













var propTypes = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_8_react_overlays_lib_Overlay___default.a.propTypes, {

  /**
   * Set the visibility of the Overlay
   */
  show: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  /**
   * Specify whether the overlay should trigger onHide when the user clicks outside the overlay
   */
  rootClose: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  /**
   * A callback invoked by the overlay when it wishes to be hidden. Required if
   * `rootClose` is specified.
   */
  onHide: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,

  /**
   * Use animation
   */
  animation: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool, __WEBPACK_IMPORTED_MODULE_9_prop_types_extra_lib_elementType___default.a]),

  /**
   * Callback fired before the Overlay transitions in
   */
  onEnter: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,

  /**
   * Callback fired as the Overlay begins to transition in
   */
  onEntering: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,

  /**
   * Callback fired after the Overlay finishes transitioning in
   */
  onEntered: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,

  /**
   * Callback fired right before the Overlay transitions out
   */
  onExit: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,

  /**
   * Callback fired as the Overlay begins to transition out
   */
  onExiting: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,

  /**
   * Callback fired after the Overlay finishes transitioning out
   */
  onExited: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,

  /**
   * Sets the direction of the Overlay.
   */
  placement: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.oneOf(['top', 'right', 'bottom', 'left'])
});

var defaultProps = {
  animation: __WEBPACK_IMPORTED_MODULE_10__Fade__["a" /* default */],
  rootClose: false,
  show: false,
  placement: 'right'
};

var Overlay = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(Overlay, _React$Component);

  function Overlay() {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Overlay);

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  Overlay.prototype.render = function render() {
    var _props = this.props,
        animation = _props.animation,
        children = _props.children,
        props = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['animation', 'children']);

    var transition = animation === true ? __WEBPACK_IMPORTED_MODULE_10__Fade__["a" /* default */] : animation || null;

    var child = void 0;

    if (!transition) {
      child = Object(__WEBPACK_IMPORTED_MODULE_6_react__["cloneElement"])(children, {
        className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(children.props.className, 'in')
      });
    } else {
      child = children;
    }

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_8_react_overlays_lib_Overlay___default.a,
      __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, props, {
        transition: transition
      }),
      child
    );
  };

  return Overlay;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

Overlay.propTypes = propTypes;
Overlay.defaultProps = defaultProps;

/* harmony default export */ __webpack_exports__["a"] = (Overlay);

/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _propTypes = __webpack_require__(5);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _elementType = __webpack_require__(10);

var _elementType2 = _interopRequireDefault(_elementType);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Portal = __webpack_require__(99);

var _Portal2 = _interopRequireDefault(_Portal);

var _Position = __webpack_require__(151);

var _Position2 = _interopRequireDefault(_Position);

var _RootCloseWrapper = __webpack_require__(96);

var _RootCloseWrapper2 = _interopRequireDefault(_RootCloseWrapper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Built on top of `<Position/>` and `<Portal/>`, the overlay component is great for custom tooltip overlays.
 */
var Overlay = function (_React$Component) {
  _inherits(Overlay, _React$Component);

  function Overlay(props, context) {
    _classCallCheck(this, Overlay);

    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props, context));

    _this.handleHidden = function () {
      _this.setState({ exited: true });

      if (_this.props.onExited) {
        var _this$props;

        (_this$props = _this.props).onExited.apply(_this$props, arguments);
      }
    };

    _this.state = { exited: !props.show };
    _this.onHiddenListener = _this.handleHidden.bind(_this);
    return _this;
  }

  Overlay.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if (nextProps.show) {
      this.setState({ exited: false });
    } else if (!nextProps.transition) {
      // Otherwise let handleHidden take care of marking exited.
      this.setState({ exited: true });
    }
  };

  Overlay.prototype.render = function render() {
    var _props = this.props,
        container = _props.container,
        containerPadding = _props.containerPadding,
        target = _props.target,
        placement = _props.placement,
        shouldUpdatePosition = _props.shouldUpdatePosition,
        rootClose = _props.rootClose,
        children = _props.children,
        Transition = _props.transition,
        props = _objectWithoutProperties(_props, ['container', 'containerPadding', 'target', 'placement', 'shouldUpdatePosition', 'rootClose', 'children', 'transition']);

    // Don't un-render the overlay while it's transitioning out.


    var mountOverlay = props.show || Transition && !this.state.exited;
    if (!mountOverlay) {
      // Don't bother showing anything if we don't have to.
      return null;
    }

    var child = children;

    // Position is be inner-most because it adds inline styles into the child,
    // which the other wrappers don't forward correctly.
    child = _react2.default.createElement(
      _Position2.default,
      { container: container, containerPadding: containerPadding, target: target, placement: placement, shouldUpdatePosition: shouldUpdatePosition },
      child
    );

    if (Transition) {
      var onExit = props.onExit,
          onExiting = props.onExiting,
          onEnter = props.onEnter,
          onEntering = props.onEntering,
          onEntered = props.onEntered;

      // This animates the child node by injecting props, so it must precede
      // anything that adds a wrapping div.

      child = _react2.default.createElement(
        Transition,
        {
          'in': props.show,
          transitionAppear: true,
          onExit: onExit,
          onExiting: onExiting,
          onExited: this.onHiddenListener,
          onEnter: onEnter,
          onEntering: onEntering,
          onEntered: onEntered
        },
        child
      );
    }

    // This goes after everything else because it adds a wrapping div.
    if (rootClose) {
      child = _react2.default.createElement(
        _RootCloseWrapper2.default,
        { onRootClose: props.onHide },
        child
      );
    }

    return _react2.default.createElement(
      _Portal2.default,
      { container: container },
      child
    );
  };

  return Overlay;
}(_react2.default.Component);

Overlay.propTypes = _extends({}, _Portal2.default.propTypes, _Position2.default.propTypes, {

  /**
   * Set the visibility of the Overlay
   */
  show: _propTypes2.default.bool,

  /**
   * Specify whether the overlay should trigger `onHide` when the user clicks outside the overlay
   */
  rootClose: _propTypes2.default.bool,

  /**
   * A Callback fired by the Overlay when it wishes to be hidden.
   *
   * __required__ when `rootClose` is `true`.
   *
   * @type func
   */
  onHide: function onHide(props) {
    var propType = _propTypes2.default.func;
    if (props.rootClose) {
      propType = propType.isRequired;
    }

    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    return propType.apply(undefined, [props].concat(args));
  },


  /**
   * A `<Transition/>` component used to animate the overlay changes visibility.
   */
  transition: _elementType2.default,

  /**
   * Callback fired before the Overlay transitions in
   */
  onEnter: _propTypes2.default.func,

  /**
   * Callback fired as the Overlay begins to transition in
   */
  onEntering: _propTypes2.default.func,

  /**
   * Callback fired after the Overlay finishes transitioning in
   */
  onEntered: _propTypes2.default.func,

  /**
   * Callback fired right before the Overlay transitions out
   */
  onExit: _propTypes2.default.func,

  /**
   * Callback fired as the Overlay begins to transition out
   */
  onExiting: _propTypes2.default.func,

  /**
   * Callback fired after the Overlay finishes transitioning out
   */
  onExited: _propTypes2.default.func
});

exports.default = Overlay;
module.exports = exports['default'];

/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _classnames = __webpack_require__(7);

var _classnames2 = _interopRequireDefault(_classnames);

var _propTypes = __webpack_require__(5);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _componentOrElement = __webpack_require__(65);

var _componentOrElement2 = _interopRequireDefault(_componentOrElement);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(16);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _calculatePosition = __webpack_require__(312);

var _calculatePosition2 = _interopRequireDefault(_calculatePosition);

var _getContainer = __webpack_require__(66);

var _getContainer2 = _interopRequireDefault(_getContainer);

var _ownerDocument = __webpack_require__(32);

var _ownerDocument2 = _interopRequireDefault(_ownerDocument);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * The Position component calculates the coordinates for its child, to position
 * it relative to a `target` component or node. Useful for creating callouts
 * and tooltips, the Position component injects a `style` props with `left` and
 * `top` values for positioning your component.
 *
 * It also injects "arrow" `left`, and `top` values for styling callout arrows
 * for giving your components a sense of directionality.
 */
var Position = function (_React$Component) {
  _inherits(Position, _React$Component);

  function Position(props, context) {
    _classCallCheck(this, Position);

    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props, context));

    _this.getTarget = function () {
      var target = _this.props.target;

      var targetElement = typeof target === 'function' ? target() : target;
      return targetElement && _reactDom2.default.findDOMNode(targetElement) || null;
    };

    _this.maybeUpdatePosition = function (placementChanged) {
      var target = _this.getTarget();

      if (!_this.props.shouldUpdatePosition && target === _this._lastTarget && !placementChanged) {
        return;
      }

      _this.updatePosition(target);
    };

    _this.state = {
      positionLeft: 0,
      positionTop: 0,
      arrowOffsetLeft: null,
      arrowOffsetTop: null
    };

    _this._needsFlush = false;
    _this._lastTarget = null;
    return _this;
  }

  Position.prototype.componentDidMount = function componentDidMount() {
    this.updatePosition(this.getTarget());
  };

  Position.prototype.componentWillReceiveProps = function componentWillReceiveProps() {
    this._needsFlush = true;
  };

  Position.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
    if (this._needsFlush) {
      this._needsFlush = false;
      this.maybeUpdatePosition(this.props.placement !== prevProps.placement);
    }
  };

  Position.prototype.render = function render() {
    var _props = this.props,
        children = _props.children,
        className = _props.className,
        props = _objectWithoutProperties(_props, ['children', 'className']);

    var _state = this.state,
        positionLeft = _state.positionLeft,
        positionTop = _state.positionTop,
        arrowPosition = _objectWithoutProperties(_state, ['positionLeft', 'positionTop']);

    // These should not be forwarded to the child.


    delete props.target;
    delete props.container;
    delete props.containerPadding;
    delete props.shouldUpdatePosition;

    var child = _react2.default.Children.only(children);
    return (0, _react.cloneElement)(child, _extends({}, props, arrowPosition, {
      // FIXME: Don't forward `positionLeft` and `positionTop` via both props
      // and `props.style`.
      positionLeft: positionLeft,
      positionTop: positionTop,
      className: (0, _classnames2.default)(className, child.props.className),
      style: _extends({}, child.props.style, {
        left: positionLeft,
        top: positionTop
      })
    }));
  };

  Position.prototype.updatePosition = function updatePosition(target) {
    this._lastTarget = target;

    if (!target) {
      this.setState({
        positionLeft: 0,
        positionTop: 0,
        arrowOffsetLeft: null,
        arrowOffsetTop: null
      });

      return;
    }

    var overlay = _reactDom2.default.findDOMNode(this);
    var container = (0, _getContainer2.default)(this.props.container, (0, _ownerDocument2.default)(this).body);

    this.setState((0, _calculatePosition2.default)(this.props.placement, overlay, target, container, this.props.containerPadding));
  };

  return Position;
}(_react2.default.Component);

Position.propTypes = {
  /**
   * A node, element, or function that returns either. The child will be
   * be positioned next to the `target` specified.
   */
  target: _propTypes2.default.oneOfType([_componentOrElement2.default, _propTypes2.default.func]),

  /**
   * "offsetParent" of the component
   */
  container: _propTypes2.default.oneOfType([_componentOrElement2.default, _propTypes2.default.func]),
  /**
   * Minimum spacing in pixels between container border and component border
   */
  containerPadding: _propTypes2.default.number,
  /**
   * How to position the component relative to the target
   */
  placement: _propTypes2.default.oneOf(['top', 'right', 'bottom', 'left']),
  /**
   * Whether the position should be changed on each update
   */
  shouldUpdatePosition: _propTypes2.default.bool
};

Position.displayName = 'Position';

Position.defaultProps = {
  containerPadding: 0,
  placement: 'right',
  shouldUpdatePosition: false
};

exports.default = Position;
module.exports = exports['default'];

/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = offsetParent;

var _ownerDocument = __webpack_require__(31);

var _ownerDocument2 = _interopRequireDefault(_ownerDocument);

var _style = __webpack_require__(58);

var _style2 = _interopRequireDefault(_style);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function nodeName(node) {
  return node.nodeName && node.nodeName.toLowerCase();
}

function offsetParent(node) {
  var doc = (0, _ownerDocument2.default)(node),
      offsetParent = node && node.offsetParent;

  while (offsetParent && nodeName(node) !== 'html' && (0, _style2.default)(offsetParent, 'position') === 'static') {
    offsetParent = offsetParent.offsetParent;
  }

  return offsetParent || doc.documentElement;
}
module.exports = exports['default'];

/***/ }),
/* 153 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__SafeAnchor__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_createChainedFunction__ = __webpack_require__(12);












var propTypes = {
  disabled: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  previous: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  next: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  onClick: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
  onSelect: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
  eventKey: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.any
};

var defaultProps = {
  disabled: false,
  previous: false,
  next: false
};

var PagerItem = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(PagerItem, _React$Component);

  function PagerItem(props, context) {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, PagerItem);

    var _this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props, context));

    _this.handleSelect = _this.handleSelect.bind(_this);
    return _this;
  }

  PagerItem.prototype.handleSelect = function handleSelect(e) {
    var _props = this.props,
        disabled = _props.disabled,
        onSelect = _props.onSelect,
        eventKey = _props.eventKey;


    if (onSelect || disabled) {
      e.preventDefault();
    }

    if (disabled) {
      return;
    }

    if (onSelect) {
      onSelect(eventKey, e);
    }
  };

  PagerItem.prototype.render = function render() {
    var _props2 = this.props,
        disabled = _props2.disabled,
        previous = _props2.previous,
        next = _props2.next,
        onClick = _props2.onClick,
        className = _props2.className,
        style = _props2.style,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props2, ['disabled', 'previous', 'next', 'onClick', 'className', 'style']);

    delete props.onSelect;
    delete props.eventKey;

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
      'li',
      {
        className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, { disabled: disabled, previous: previous, next: next }),
        style: style
      },
      __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__SafeAnchor__["a" /* default */], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, props, {
        disabled: disabled,
        onClick: Object(__WEBPACK_IMPORTED_MODULE_9__utils_createChainedFunction__["a" /* default */])(onClick, this.handleSelect)
      }))
    );
  };

  return PagerItem;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

PagerItem.propTypes = propTypes;
PagerItem.defaultProps = defaultProps;

/* harmony default export */ __webpack_exports__["a"] = (PagerItem);

/***/ }),
/* 154 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types_extra_lib_elementType__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types_extra_lib_elementType___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_prop_types_extra_lib_elementType__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__SafeAnchor__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_createChainedFunction__ = __webpack_require__(12);













// TODO: This should be `<Pagination.Item>`.

// TODO: This should use `componentClass` like other components.

var propTypes = {
  componentClass: __WEBPACK_IMPORTED_MODULE_8_prop_types_extra_lib_elementType___default.a,
  className: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string,
  eventKey: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.any,
  onSelect: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
  disabled: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  active: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  onClick: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func
};

var defaultProps = {
  componentClass: __WEBPACK_IMPORTED_MODULE_9__SafeAnchor__["a" /* default */],
  active: false,
  disabled: false
};

var PaginationButton = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(PaginationButton, _React$Component);

  function PaginationButton(props, context) {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, PaginationButton);

    var _this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props, context));

    _this.handleClick = _this.handleClick.bind(_this);
    return _this;
  }

  PaginationButton.prototype.handleClick = function handleClick(event) {
    var _props = this.props,
        disabled = _props.disabled,
        onSelect = _props.onSelect,
        eventKey = _props.eventKey;


    if (disabled) {
      return;
    }

    if (onSelect) {
      onSelect(eventKey, event);
    }
  };

  PaginationButton.prototype.render = function render() {
    var _props2 = this.props,
        Component = _props2.componentClass,
        active = _props2.active,
        disabled = _props2.disabled,
        onClick = _props2.onClick,
        className = _props2.className,
        style = _props2.style,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props2, ['componentClass', 'active', 'disabled', 'onClick', 'className', 'style']);

    if (Component === __WEBPACK_IMPORTED_MODULE_9__SafeAnchor__["a" /* default */]) {
      // Assume that custom components want `eventKey`.
      delete props.eventKey;
    }

    delete props.onSelect;

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
      'li',
      {
        className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, { active: active, disabled: disabled }),
        style: style
      },
      __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Component, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, props, {
        disabled: disabled,
        onClick: Object(__WEBPACK_IMPORTED_MODULE_10__utils_createChainedFunction__["a" /* default */])(onClick, this.handleClick)
      }))
    );
  };

  return PaginationButton;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

PaginationButton.propTypes = propTypes;
PaginationButton.defaultProps = defaultProps;

/* harmony default export */ __webpack_exports__["a"] = (PaginationButton);

/***/ }),
/* 155 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types_extra_lib_elementType__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types_extra_lib_elementType___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_prop_types_extra_lib_elementType__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_warning__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_bootstrapUtils__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils_createChainedFunction__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Fade__ = __webpack_require__(64);
















var propTypes = {
  /**
   * Uniquely identify the `<TabPane>` among its siblings.
   */
  eventKey: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.any,

  /**
   * Use animation when showing or hiding `<TabPane>`s. Use `false` to disable,
   * `true` to enable the default `<Fade>` animation or any `<Transition>`
   * component.
   */
  animation: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool, __WEBPACK_IMPORTED_MODULE_8_prop_types_extra_lib_elementType___default.a]),

  /** @private **/
  id: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string,

  /** @private **/
  'aria-labelledby': __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string,

  /**
   * If not explicitly specified and rendered in the context of a
   * `<TabContent>`, the `bsClass` of the `<TabContent>` suffixed by `-pane`.
   * If otherwise not explicitly specified, `tab-pane`.
   */
  bsClass: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string,

  /**
   * Transition onEnter callback when animation is not `false`
   */
  onEnter: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,

  /**
   * Transition onEntering callback when animation is not `false`
   */
  onEntering: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,

  /**
   * Transition onEntered callback when animation is not `false`
   */
  onEntered: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,

  /**
   * Transition onExit callback when animation is not `false`
   */
  onExit: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,

  /**
   * Transition onExiting callback when animation is not `false`
   */
  onExiting: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,

  /**
   * Transition onExited callback when animation is not `false`
   */
  onExited: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,

  /**
   * Wait until the first "enter" transition to mount the tab (add it to the DOM)
   */
  mountOnEnter: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,

  /**
   * Unmount the tab (remove it from the DOM) when it is no longer visible
   */
  unmountOnExit: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool
};

var contextTypes = {
  $bs_tabContainer: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.shape({
    getTabId: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
    getPaneId: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func
  }),
  $bs_tabContent: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.shape({
    bsClass: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string,
    animation: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool, __WEBPACK_IMPORTED_MODULE_8_prop_types_extra_lib_elementType___default.a]),
    activeKey: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.any,
    mountOnEnter: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
    unmountOnExit: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
    onPaneEnter: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func.isRequired,
    onPaneExited: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func.isRequired,
    exiting: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool.isRequired
  })
};

/**
 * We override the `<TabContainer>` context so `<Nav>`s in `<TabPane>`s don't
 * conflict with the top level one.
 */
var childContextTypes = {
  $bs_tabContainer: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.oneOf([null])
};

var TabPane = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(TabPane, _React$Component);

  function TabPane(props, context) {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, TabPane);

    var _this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props, context));

    _this.handleEnter = _this.handleEnter.bind(_this);
    _this.handleExited = _this.handleExited.bind(_this);

    _this['in'] = false;
    return _this;
  }

  TabPane.prototype.getChildContext = function getChildContext() {
    return {
      $bs_tabContainer: null
    };
  };

  TabPane.prototype.componentDidMount = function componentDidMount() {
    if (this.shouldBeIn()) {
      // In lieu of the action event firing.
      this.handleEnter();
    }
  };

  TabPane.prototype.componentDidUpdate = function componentDidUpdate() {
    if (this['in']) {
      if (!this.shouldBeIn()) {
        // We shouldn't be active any more. Notify the parent.
        this.handleExited();
      }
    } else if (this.shouldBeIn()) {
      // We are the active child. Notify the parent.
      this.handleEnter();
    }
  };

  TabPane.prototype.componentWillUnmount = function componentWillUnmount() {
    if (this['in']) {
      // In lieu of the action event firing.
      this.handleExited();
    }
  };

  TabPane.prototype.handleEnter = function handleEnter() {
    var tabContent = this.context.$bs_tabContent;
    if (!tabContent) {
      return;
    }

    this['in'] = tabContent.onPaneEnter(this, this.props.eventKey);
  };

  TabPane.prototype.handleExited = function handleExited() {
    var tabContent = this.context.$bs_tabContent;
    if (!tabContent) {
      return;
    }

    tabContent.onPaneExited(this);
    this['in'] = false;
  };

  TabPane.prototype.getAnimation = function getAnimation() {
    if (this.props.animation != null) {
      return this.props.animation;
    }

    var tabContent = this.context.$bs_tabContent;
    return tabContent && tabContent.animation;
  };

  TabPane.prototype.isActive = function isActive() {
    var tabContent = this.context.$bs_tabContent;
    var activeKey = tabContent && tabContent.activeKey;

    return this.props.eventKey === activeKey;
  };

  TabPane.prototype.shouldBeIn = function shouldBeIn() {
    return this.getAnimation() && this.isActive();
  };

  TabPane.prototype.render = function render() {
    var _props = this.props,
        eventKey = _props.eventKey,
        className = _props.className,
        onEnter = _props.onEnter,
        onEntering = _props.onEntering,
        onEntered = _props.onEntered,
        onExit = _props.onExit,
        onExiting = _props.onExiting,
        onExited = _props.onExited,
        propsMountOnEnter = _props.mountOnEnter,
        propsUnmountOnExit = _props.unmountOnExit,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['eventKey', 'className', 'onEnter', 'onEntering', 'onEntered', 'onExit', 'onExiting', 'onExited', 'mountOnEnter', 'unmountOnExit']);

    var _context = this.context,
        tabContent = _context.$bs_tabContent,
        tabContainer = _context.$bs_tabContainer;

    var _splitBsPropsAndOmit = Object(__WEBPACK_IMPORTED_MODULE_10__utils_bootstrapUtils__["g" /* splitBsPropsAndOmit */])(props, ['animation']),
        bsProps = _splitBsPropsAndOmit[0],
        elementProps = _splitBsPropsAndOmit[1];

    var active = this.isActive();
    var animation = this.getAnimation();

    var mountOnEnter = propsMountOnEnter != null ? propsMountOnEnter : tabContent && tabContent.mountOnEnter;
    var unmountOnExit = propsUnmountOnExit != null ? propsUnmountOnExit : tabContent && tabContent.unmountOnExit;

    if (!active && !animation && unmountOnExit) {
      return null;
    }

    var Transition = animation === true ? __WEBPACK_IMPORTED_MODULE_12__Fade__["a" /* default */] : animation || null;

    if (tabContent) {
      bsProps.bsClass = Object(__WEBPACK_IMPORTED_MODULE_10__utils_bootstrapUtils__["e" /* prefix */])(tabContent, 'pane');
    }

    var classes = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_10__utils_bootstrapUtils__["d" /* getClassSet */])(bsProps), {
      active: active
    });

    if (tabContainer) {
       false ? warning(!elementProps.id && !elementProps['aria-labelledby'], 'In the context of a `<TabContainer>`, `<TabPanes>` are given ' + 'generated `id` and `aria-labelledby` attributes for the sake of ' + 'proper component accessibility. Any provided ones will be ignored. ' + 'To control these attributes directly provide a `generateChildId` ' + 'prop to the parent `<TabContainer>`.') : void 0;

      elementProps.id = tabContainer.getPaneId(eventKey);
      elementProps['aria-labelledby'] = tabContainer.getTabId(eventKey);
    }

    var pane = __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('div', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, elementProps, {
      role: 'tabpanel',
      'aria-hidden': !active,
      className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, classes)
    }));

    if (Transition) {
      var exiting = tabContent && tabContent.exiting;

      return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        Transition,
        {
          'in': active && !exiting,
          onEnter: Object(__WEBPACK_IMPORTED_MODULE_11__utils_createChainedFunction__["a" /* default */])(this.handleEnter, onEnter),
          onEntering: onEntering,
          onEntered: onEntered,
          onExit: onExit,
          onExiting: onExiting,
          onExited: Object(__WEBPACK_IMPORTED_MODULE_11__utils_createChainedFunction__["a" /* default */])(this.handleExited, onExited),
          mountOnEnter: mountOnEnter,
          unmountOnExit: unmountOnExit
        },
        pane
      );
    }

    return pane;
  };

  return TabPane;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

TabPane.propTypes = propTypes;
TabPane.contextTypes = contextTypes;
TabPane.childContextTypes = childContextTypes;

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_10__utils_bootstrapUtils__["a" /* bsClass */])('tab-pane', TabPane));

/***/ }),
/* 156 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Button__ = __webpack_require__(48);










var propTypes = {
  /**
   * The `<input>` `type`
   * @type {[type]}
   */
  type: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.oneOf(['checkbox', 'radio']),

  /**
   * The HTML input name, used to group like checkboxes or radio buttons together
   * semantically
   */
  name: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,

  /**
   * The checked state of the input, managed by `<ToggleButtonGroup>`` automatically
   */
  checked: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,

  /**
   * The disabled state of both the label and input
   */
  disabled: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,

  /**
   * [onChange description]
   */
  onChange: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  /**
   * The value of the input, and unique identifier in the ToggleButtonGroup
   */
  value: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.any.isRequired
};

var ToggleButton = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(ToggleButton, _React$Component);

  function ToggleButton() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, ToggleButton);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  ToggleButton.prototype.render = function render() {
    var _props = this.props,
        children = _props.children,
        name = _props.name,
        checked = _props.checked,
        type = _props.type,
        onChange = _props.onChange,
        value = _props.value,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['children', 'name', 'checked', 'type', 'onChange', 'value']);

    var disabled = props.disabled;

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_7__Button__["a" /* default */],
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, props, {
        active: !!checked,
        componentClass: 'label'
      }),
      __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('input', {
        name: name,
        type: type,
        autoComplete: 'off',
        value: value,
        checked: !!checked,
        disabled: !!disabled,
        onChange: onChange
      }),
      children
    );
  };

  return ToggleButton;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

ToggleButton.propTypes = propTypes;

/* harmony default export */ __webpack_exports__["a"] = (ToggleButton);

/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _prodInvariant = __webpack_require__(69),
    _assign = __webpack_require__(24);

var ReactNoopUpdateQueue = __webpack_require__(158);

var canDefineProperty = __webpack_require__(159);
var emptyObject = __webpack_require__(54);
var invariant = __webpack_require__(22);
var lowPriorityWarning = __webpack_require__(343);

/**
 * Base class helpers for the updating state of a component.
 */
function ReactComponent(props, context, updater) {
  this.props = props;
  this.context = context;
  this.refs = emptyObject;
  // We initialize the default updater but the real one gets injected by the
  // renderer.
  this.updater = updater || ReactNoopUpdateQueue;
}

ReactComponent.prototype.isReactComponent = {};

/**
 * Sets a subset of the state. Always use this to mutate
 * state. You should treat `this.state` as immutable.
 *
 * There is no guarantee that `this.state` will be immediately updated, so
 * accessing `this.state` after calling this method may return the old value.
 *
 * There is no guarantee that calls to `setState` will run synchronously,
 * as they may eventually be batched together.  You can provide an optional
 * callback that will be executed when the call to setState is actually
 * completed.
 *
 * When a function is provided to setState, it will be called at some point in
 * the future (not synchronously). It will be called with the up to date
 * component arguments (state, props, context). These values can be different
 * from this.* because your function may be called after receiveProps but before
 * shouldComponentUpdate, and this new state, props, and context will not yet be
 * assigned to this.
 *
 * @param {object|function} partialState Next partial state or function to
 *        produce next partial state to be merged with current state.
 * @param {?function} callback Called after state is updated.
 * @final
 * @protected
 */
ReactComponent.prototype.setState = function (partialState, callback) {
  !(typeof partialState === 'object' || typeof partialState === 'function' || partialState == null) ?  false ? invariant(false, 'setState(...): takes an object of state variables to update or a function which returns an object of state variables.') : _prodInvariant('85') : void 0;
  this.updater.enqueueSetState(this, partialState);
  if (callback) {
    this.updater.enqueueCallback(this, callback, 'setState');
  }
};

/**
 * Forces an update. This should only be invoked when it is known with
 * certainty that we are **not** in a DOM transaction.
 *
 * You may want to call this when you know that some deeper aspect of the
 * component's state has changed but `setState` was not called.
 *
 * This will not invoke `shouldComponentUpdate`, but it will invoke
 * `componentWillUpdate` and `componentDidUpdate`.
 *
 * @param {?function} callback Called after update is complete.
 * @final
 * @protected
 */
ReactComponent.prototype.forceUpdate = function (callback) {
  this.updater.enqueueForceUpdate(this);
  if (callback) {
    this.updater.enqueueCallback(this, callback, 'forceUpdate');
  }
};

/**
 * Deprecated APIs. These APIs used to exist on classic React classes but since
 * we would like to deprecate them, we're not going to move them over to this
 * modern base class. Instead, we define a getter that warns if it's accessed.
 */
if (false) {
  var deprecatedAPIs = {
    isMounted: ['isMounted', 'Instead, make sure to clean up subscriptions and pending requests in ' + 'componentWillUnmount to prevent memory leaks.'],
    replaceState: ['replaceState', 'Refactor your code to use setState instead (see ' + 'https://github.com/facebook/react/issues/3236).']
  };
  var defineDeprecationWarning = function (methodName, info) {
    if (canDefineProperty) {
      Object.defineProperty(ReactComponent.prototype, methodName, {
        get: function () {
          lowPriorityWarning(false, '%s(...) is deprecated in plain JavaScript React classes. %s', info[0], info[1]);
          return undefined;
        }
      });
    }
  };
  for (var fnName in deprecatedAPIs) {
    if (deprecatedAPIs.hasOwnProperty(fnName)) {
      defineDeprecationWarning(fnName, deprecatedAPIs[fnName]);
    }
  }
}

/**
 * Base class helpers for the updating state of a component.
 */
function ReactPureComponent(props, context, updater) {
  // Duplicated from ReactComponent.
  this.props = props;
  this.context = context;
  this.refs = emptyObject;
  // We initialize the default updater but the real one gets injected by the
  // renderer.
  this.updater = updater || ReactNoopUpdateQueue;
}

function ComponentDummy() {}
ComponentDummy.prototype = ReactComponent.prototype;
ReactPureComponent.prototype = new ComponentDummy();
ReactPureComponent.prototype.constructor = ReactPureComponent;
// Avoid an extra prototype jump for these methods.
_assign(ReactPureComponent.prototype, ReactComponent.prototype);
ReactPureComponent.prototype.isPureReactComponent = true;

module.exports = {
  Component: ReactComponent,
  PureComponent: ReactPureComponent
};

/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var warning = __webpack_require__(70);

function warnNoop(publicInstance, callerName) {
  if (false) {
    var constructor = publicInstance.constructor;
    process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): Can only update a mounted or mounting component. ' + 'This usually means you called %s() on an unmounted component. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, constructor && (constructor.displayName || constructor.name) || 'ReactClass') : void 0;
  }
}

/**
 * This is the abstract API for an update queue.
 */
var ReactNoopUpdateQueue = {
  /**
   * Checks whether or not this composite component is mounted.
   * @param {ReactClass} publicInstance The instance we want to test.
   * @return {boolean} True if mounted, false otherwise.
   * @protected
   * @final
   */
  isMounted: function (publicInstance) {
    return false;
  },

  /**
   * Enqueue a callback that will be executed after all the pending updates
   * have processed.
   *
   * @param {ReactClass} publicInstance The instance to use as `this` context.
   * @param {?function} callback Called after state is updated.
   * @internal
   */
  enqueueCallback: function (publicInstance, callback) {},

  /**
   * Forces an update. This should only be invoked when it is known with
   * certainty that we are **not** in a DOM transaction.
   *
   * You may want to call this when you know that some deeper aspect of the
   * component's state has changed but `setState` was not called.
   *
   * This will not invoke `shouldComponentUpdate`, but it will invoke
   * `componentWillUpdate` and `componentDidUpdate`.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @internal
   */
  enqueueForceUpdate: function (publicInstance) {
    warnNoop(publicInstance, 'forceUpdate');
  },

  /**
   * Replaces all of the state. Always use this or `setState` to mutate state.
   * You should treat `this.state` as immutable.
   *
   * There is no guarantee that `this.state` will be immediately updated, so
   * accessing `this.state` after calling this method may return the old value.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object} completeState Next state.
   * @internal
   */
  enqueueReplaceState: function (publicInstance, completeState) {
    warnNoop(publicInstance, 'replaceState');
  },

  /**
   * Sets a subset of the state. This only exists because _pendingState is
   * internal. This provides a merging strategy that is not available to deep
   * properties which is confusing. TODO: Expose pendingState or don't use it
   * during the merge.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object} partialState Next partial state to be merged with state.
   * @internal
   */
  enqueueSetState: function (publicInstance, partialState) {
    warnNoop(publicInstance, 'setState');
  }
};

module.exports = ReactNoopUpdateQueue;

/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



var canDefineProperty = false;
if (false) {
  try {
    // $FlowFixMe https://github.com/facebook/flow/issues/285
    Object.defineProperty({}, 'x', { get: function () {} });
    canDefineProperty = true;
  } catch (x) {
    // IE will fail on defineProperty
  }
}

module.exports = canDefineProperty;

/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



/**
 * Keeps track of the current owner.
 *
 * The current owner is the component who should own any components that are
 * currently being constructed.
 */
var ReactCurrentOwner = {
  /**
   * @internal
   * @type {ReactComponent}
   */
  current: null
};

module.exports = ReactCurrentOwner;

/***/ }),
/* 161 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



// The Symbol used to tag the ReactElement type. If there is no native Symbol
// nor polyfill, then a plain number is used for performance.

var REACT_ELEMENT_TYPE = typeof Symbol === 'function' && Symbol['for'] && Symbol['for']('react.element') || 0xeac7;

module.exports = REACT_ELEMENT_TYPE;

/***/ }),
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {/**
 * This is the web browser implementation of `debug()`.
 *
 * Expose `debug()` as the module.
 */

exports = module.exports = __webpack_require__(359);
exports.log = log;
exports.formatArgs = formatArgs;
exports.save = save;
exports.load = load;
exports.useColors = useColors;
exports.storage = 'undefined' != typeof chrome
               && 'undefined' != typeof chrome.storage
                  ? chrome.storage.local
                  : localstorage();

/**
 * Colors.
 */

exports.colors = [
  'lightseagreen',
  'forestgreen',
  'goldenrod',
  'dodgerblue',
  'darkorchid',
  'crimson'
];

/**
 * Currently only WebKit-based Web Inspectors, Firefox >= v31,
 * and the Firebug extension (any Firefox version) are known
 * to support "%c" CSS customizations.
 *
 * TODO: add a `localStorage` variable to explicitly enable/disable colors
 */

function useColors() {
  // NB: In an Electron preload script, document will be defined but not fully
  // initialized. Since we know we're in Chrome, we'll just detect this case
  // explicitly
  if (typeof window !== 'undefined' && window.process && window.process.type === 'renderer') {
    return true;
  }

  // is webkit? http://stackoverflow.com/a/16459606/376773
  // document is undefined in react-native: https://github.com/facebook/react-native/pull/1632
  return (typeof document !== 'undefined' && document.documentElement && document.documentElement.style && document.documentElement.style.WebkitAppearance) ||
    // is firebug? http://stackoverflow.com/a/398120/376773
    (typeof window !== 'undefined' && window.console && (window.console.firebug || (window.console.exception && window.console.table))) ||
    // is firefox >= v31?
    // https://developer.mozilla.org/en-US/docs/Tools/Web_Console#Styling_messages
    (typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/firefox\/(\d+)/) && parseInt(RegExp.$1, 10) >= 31) ||
    // double check webkit in userAgent just in case we are in a worker
    (typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/applewebkit\/(\d+)/));
}

/**
 * Map %j to `JSON.stringify()`, since no Web Inspectors do that by default.
 */

exports.formatters.j = function(v) {
  try {
    return JSON.stringify(v);
  } catch (err) {
    return '[UnexpectedJSONParseError]: ' + err.message;
  }
};


/**
 * Colorize log arguments if enabled.
 *
 * @api public
 */

function formatArgs(args) {
  var useColors = this.useColors;

  args[0] = (useColors ? '%c' : '')
    + this.namespace
    + (useColors ? ' %c' : ' ')
    + args[0]
    + (useColors ? '%c ' : ' ')
    + '+' + exports.humanize(this.diff);

  if (!useColors) return;

  var c = 'color: ' + this.color;
  args.splice(1, 0, c, 'color: inherit')

  // the final "%c" is somewhat tricky, because there could be other
  // arguments passed either before or after the %c, so we need to
  // figure out the correct index to insert the CSS into
  var index = 0;
  var lastC = 0;
  args[0].replace(/%[a-zA-Z%]/g, function(match) {
    if ('%%' === match) return;
    index++;
    if ('%c' === match) {
      // we only are interested in the *last* %c
      // (the user may have provided their own)
      lastC = index;
    }
  });

  args.splice(lastC, 0, c);
}

/**
 * Invokes `console.log()` when available.
 * No-op when `console.log` is not a "function".
 *
 * @api public
 */

function log() {
  // this hackery is required for IE8/9, where
  // the `console.log` function doesn't have 'apply'
  return 'object' === typeof console
    && console.log
    && Function.prototype.apply.call(console.log, console, arguments);
}

/**
 * Save `namespaces`.
 *
 * @param {String} namespaces
 * @api private
 */

function save(namespaces) {
  try {
    if (null == namespaces) {
      exports.storage.removeItem('debug');
    } else {
      exports.storage.debug = namespaces;
    }
  } catch(e) {}
}

/**
 * Load `namespaces`.
 *
 * @return {String} returns the previously persisted debug modes
 * @api private
 */

function load() {
  var r;
  try {
    r = exports.storage.debug;
  } catch(e) {}

  // If debug isn't set in LS, and we're in Electron, try to load $DEBUG
  if (!r && typeof process !== 'undefined' && 'env' in process) {
    r = Object({"NODE_ENV":"production","PUBLIC_URL":"","REACT_APP_MAPBOX_API_KEY":"pk.eyJ1IjoicmRzbGFiIiwiYSI6ImNqZXJjeDR1eDEwdHQzM280YmxobDR1d3IifQ.-kg4yiUEPenYfPVgUFdWPQ"}).DEBUG;
  }

  return r;
}

/**
 * Enable namespaces listed in `localStorage.debug` initially.
 */

exports.enable(load());

/**
 * Localstorage attempts to return the localstorage.
 *
 * This is necessary because safari throws
 * when a user disables cookies/localstorage
 * and you attempt to access it.
 *
 * @return {LocalStorage}
 * @api private
 */

function localstorage() {
  try {
    return window.localStorage;
  } catch (e) {}
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(358)))

/***/ }),
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _classnames = __webpack_require__(7);

var _classnames2 = _interopRequireDefault(_classnames);

var _height = __webpack_require__(368);

var _height2 = _interopRequireDefault(_height);

var _offset = __webpack_require__(51);

var _offset2 = _interopRequireDefault(_offset);

var _offsetParent = __webpack_require__(152);

var _offsetParent2 = _interopRequireDefault(_offsetParent);

var _scrollTop = __webpack_require__(100);

var _scrollTop2 = _interopRequireDefault(_scrollTop);

var _requestAnimationFrame = __webpack_require__(164);

var _requestAnimationFrame2 = _interopRequireDefault(_requestAnimationFrame);

var _propTypes = __webpack_require__(5);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(16);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _addEventListener = __webpack_require__(62);

var _addEventListener2 = _interopRequireDefault(_addEventListener);

var _getDocumentHeight = __webpack_require__(165);

var _getDocumentHeight2 = _interopRequireDefault(_getDocumentHeight);

var _ownerDocument = __webpack_require__(32);

var _ownerDocument2 = _interopRequireDefault(_ownerDocument);

var _ownerWindow = __webpack_require__(166);

var _ownerWindow2 = _interopRequireDefault(_ownerWindow);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * The `<Affix/>` component toggles `position: fixed;` on and off, emulating
 * the effect found with `position: sticky;`.
 */
var Affix = function (_React$Component) {
  _inherits(Affix, _React$Component);

  function Affix(props, context) {
    _classCallCheck(this, Affix);

    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props, context));

    _this.onWindowScroll = function () {
      _this.onUpdate();
    };

    _this.onDocumentClick = function () {
      (0, _requestAnimationFrame2.default)(function () {
        return _this.onUpdate();
      });
    };

    _this.onUpdate = function () {
      if (!_this._isMounted) {
        return;
      }

      var _this$props = _this.props,
          offsetTop = _this$props.offsetTop,
          viewportOffsetTop = _this$props.viewportOffsetTop;

      var scrollTop = (0, _scrollTop2.default)((0, _ownerWindow2.default)(_this));
      var positionTopMin = scrollTop + (viewportOffsetTop || 0);

      if (positionTopMin <= offsetTop) {
        _this.updateState('top', null, null);
        return;
      }

      if (positionTopMin > _this.getPositionTopMax()) {
        if (_this.state.affixed === 'bottom') {
          _this.updateStateAtBottom();
        } else {
          // Setting position away from `fixed` can change the offset parent of
          // the affix, so we can't calculate the correct position until after
          // we've updated its position.
          _this.setState({
            affixed: 'bottom',
            position: 'absolute',
            top: null
          }, function () {
            if (!_this._isMounted) {
              return;
            }

            _this.updateStateAtBottom();
          });
        }
        return;
      }

      _this.updateState('affix', 'fixed', viewportOffsetTop);
    };

    _this.getPositionTopMax = function () {
      var documentHeight = (0, _getDocumentHeight2.default)((0, _ownerDocument2.default)(_this));
      var height = (0, _height2.default)(_reactDom2.default.findDOMNode(_this));

      return documentHeight - height - _this.props.offsetBottom;
    };

    _this.updateState = function (affixed, position, top) {
      if (affixed === _this.state.affixed && position === _this.state.position && top === _this.state.top) {
        return;
      }

      var upperName = affixed === 'affix' ? '' : affixed.charAt(0).toUpperCase() + affixed.substr(1);

      if (_this.props['onAffix' + upperName]) {
        _this.props['onAffix' + upperName]();
      }

      _this.setState({ affixed: affixed, position: position, top: top }, function () {
        if (_this.props['onAffixed' + upperName]) {
          _this.props['onAffixed' + upperName]();
        }
      });
    };

    _this.updateStateAtBottom = function () {
      var positionTopMax = _this.getPositionTopMax();
      var offsetParent = (0, _offsetParent2.default)(_reactDom2.default.findDOMNode(_this));
      var parentTop = (0, _offset2.default)(offsetParent).top;

      _this.updateState('bottom', 'absolute', positionTopMax - parentTop);
    };

    _this.state = {
      affixed: 'top',
      position: null,
      top: null
    };

    _this._needPositionUpdate = false;
    return _this;
  }

  Affix.prototype.componentDidMount = function componentDidMount() {
    var _this2 = this;

    this._isMounted = true;

    this._windowScrollListener = (0, _addEventListener2.default)((0, _ownerWindow2.default)(this), 'scroll', function () {
      return _this2.onWindowScroll();
    });
    this._documentClickListener = (0, _addEventListener2.default)((0, _ownerDocument2.default)(this), 'click', function () {
      return _this2.onDocumentClick();
    });

    this.onUpdate();
  };

  Affix.prototype.componentWillReceiveProps = function componentWillReceiveProps() {
    this._needPositionUpdate = true;
  };

  Affix.prototype.componentDidUpdate = function componentDidUpdate() {
    if (this._needPositionUpdate) {
      this._needPositionUpdate = false;
      this.onUpdate();
    }
  };

  Affix.prototype.componentWillUnmount = function componentWillUnmount() {
    this._isMounted = false;

    if (this._windowScrollListener) {
      this._windowScrollListener.remove();
    }
    if (this._documentClickListener) {
      this._documentClickListener.remove();
    }
  };

  Affix.prototype.render = function render() {
    var child = _react2.default.Children.only(this.props.children);
    var _child$props = child.props,
        className = _child$props.className,
        style = _child$props.style;
    var _state = this.state,
        affixed = _state.affixed,
        position = _state.position,
        top = _state.top;

    var positionStyle = { position: position, top: top };

    var affixClassName = void 0;
    var affixStyle = void 0;
    if (affixed === 'top') {
      affixClassName = this.props.topClassName;
      affixStyle = this.props.topStyle;
    } else if (affixed === 'bottom') {
      affixClassName = this.props.bottomClassName;
      affixStyle = this.props.bottomStyle;
    } else {
      affixClassName = this.props.affixClassName;
      affixStyle = this.props.affixStyle;
    }

    return _react2.default.cloneElement(child, {
      className: (0, _classnames2.default)(affixClassName, className),
      style: _extends({}, positionStyle, affixStyle, style)
    });
  };

  return Affix;
}(_react2.default.Component);

Affix.propTypes = {
  /**
   * Pixels to offset from top of screen when calculating position
   */
  offsetTop: _propTypes2.default.number,

  /**
   * When affixed, pixels to offset from top of viewport
   */
  viewportOffsetTop: _propTypes2.default.number,

  /**
   * Pixels to offset from bottom of screen when calculating position
   */
  offsetBottom: _propTypes2.default.number,

  /**
   * CSS class or classes to apply when at top
   */
  topClassName: _propTypes2.default.string,

  /**
   * Style to apply when at top
   */
  topStyle: _propTypes2.default.object,

  /**
   * CSS class or classes to apply when affixed
   */
  affixClassName: _propTypes2.default.string,
  /**
   * Style to apply when affixed
   */
  affixStyle: _propTypes2.default.object,

  /**
   * CSS class or classes to apply when at bottom
   */
  bottomClassName: _propTypes2.default.string,

  /**
   * Style to apply when at bottom
   */
  bottomStyle: _propTypes2.default.object,

  /**
   * Callback fired when the right before the `affixStyle` and `affixStyle` props are rendered
   */
  onAffix: _propTypes2.default.func,
  /**
   * Callback fired after the component `affixStyle` and `affixClassName` props have been rendered.
   */
  onAffixed: _propTypes2.default.func,

  /**
   * Callback fired when the right before the `topStyle` and `topClassName` props are rendered
   */
  onAffixTop: _propTypes2.default.func,

  /**
   * Callback fired after the component `topStyle` and `topClassName` props have been rendered.
   */
  onAffixedTop: _propTypes2.default.func,

  /**
   * Callback fired when the right before the `bottomStyle` and `bottomClassName` props are rendered
   */
  onAffixBottom: _propTypes2.default.func,

  /**
   * Callback fired after the component `bottomStyle` and `bottomClassName` props have been rendered.
   */
  onAffixedBottom: _propTypes2.default.func
};

Affix.defaultProps = {
  offsetTop: 0,
  viewportOffsetTop: null,
  offsetBottom: 0
};

exports.default = Affix;
module.exports = exports['default'];

/***/ }),
/* 164 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _inDOM = __webpack_require__(23);

var _inDOM2 = _interopRequireDefault(_inDOM);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var vendors = ['', 'webkit', 'moz', 'o', 'ms'];
var cancel = 'clearTimeout';
var raf = fallback;
var compatRaf = void 0;

var getKey = function getKey(vendor, k) {
  return vendor + (!vendor ? k : k[0].toUpperCase() + k.substr(1)) + 'AnimationFrame';
};

if (_inDOM2.default) {
  vendors.some(function (vendor) {
    var rafKey = getKey(vendor, 'request');

    if (rafKey in window) {
      cancel = getKey(vendor, 'cancel');
      return raf = function raf(cb) {
        return window[rafKey](cb);
      };
    }
  });
}

/* https://github.com/component/raf */
var prev = new Date().getTime();
function fallback(fn) {
  var curr = new Date().getTime(),
      ms = Math.max(0, 16 - (curr - prev)),
      req = setTimeout(fn, ms);

  prev = curr;
  return req;
}

compatRaf = function compatRaf(cb) {
  return raf(cb);
};
compatRaf.cancel = function (id) {
  window[cancel] && typeof window[cancel] === 'function' && window[cancel](id);
};
exports.default = compatRaf;
module.exports = exports['default'];

/***/ }),
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (doc) {
  return Math.max(doc.documentElement.offsetHeight || 0, doc.height || 0, doc.body.scrollHeight || 0, doc.body.offsetHeight || 0);
};

module.exports = exports["default"]; /**
                                      * Get the height of the document
                                      *
                                      * @returns {documentHeight: number}
                                      */

/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (componentOrElement) {
  return (0, _ownerWindow2.default)(_reactDom2.default.findDOMNode(componentOrElement));
};

var _reactDom = __webpack_require__(16);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _ownerWindow = __webpack_require__(369);

var _ownerWindow2 = _interopRequireDefault(_ownerWindow);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

module.exports = exports['default'];

/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

/* @preserve
 * Leaflet 1.2.0, a JS library for interactive maps. http://leafletjs.com
 * (c) 2010-2017 Vladimir Agafonkin, (c) 2010-2011 CloudMade
 */
(function (global, factory) {
	 true ? factory(exports) :
	typeof define === 'function' && define.amd ? define(['exports'], factory) :
	(factory((global.L = {})));
}(this, (function (exports) { 'use strict';

var version = "1.2.0";

/*
 * @namespace Util
 *
 * Various utility functions, used by Leaflet internally.
 */

var freeze = Object.freeze;
Object.freeze = function (obj) { return obj; };

// @function extend(dest: Object, src?: Object): Object
// Merges the properties of the `src` object (or multiple objects) into `dest` object and returns the latter. Has an `L.extend` shortcut.
function extend(dest) {
	var i, j, len, src;

	for (j = 1, len = arguments.length; j < len; j++) {
		src = arguments[j];
		for (i in src) {
			dest[i] = src[i];
		}
	}
	return dest;
}

// @function create(proto: Object, properties?: Object): Object
// Compatibility polyfill for [Object.create](https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Object/create)
var create = Object.create || (function () {
	function F() {}
	return function (proto) {
		F.prototype = proto;
		return new F();
	};
})();

// @function bind(fn: Function, …): Function
// Returns a new function bound to the arguments passed, like [Function.prototype.bind](https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Function/bind).
// Has a `L.bind()` shortcut.
function bind(fn, obj) {
	var slice = Array.prototype.slice;

	if (fn.bind) {
		return fn.bind.apply(fn, slice.call(arguments, 1));
	}

	var args = slice.call(arguments, 2);

	return function () {
		return fn.apply(obj, args.length ? args.concat(slice.call(arguments)) : arguments);
	};
}

// @property lastId: Number
// Last unique ID used by [`stamp()`](#util-stamp)
var lastId = 0;

// @function stamp(obj: Object): Number
// Returns the unique ID of an object, assiging it one if it doesn't have it.
function stamp(obj) {
	/*eslint-disable */
	obj._leaflet_id = obj._leaflet_id || ++lastId;
	return obj._leaflet_id;
	/*eslint-enable */
}

// @function throttle(fn: Function, time: Number, context: Object): Function
// Returns a function which executes function `fn` with the given scope `context`
// (so that the `this` keyword refers to `context` inside `fn`'s code). The function
// `fn` will be called no more than one time per given amount of `time`. The arguments
// received by the bound function will be any arguments passed when binding the
// function, followed by any arguments passed when invoking the bound function.
// Has an `L.throttle` shortcut.
function throttle(fn, time, context) {
	var lock, args, wrapperFn, later;

	later = function () {
		// reset lock and call if queued
		lock = false;
		if (args) {
			wrapperFn.apply(context, args);
			args = false;
		}
	};

	wrapperFn = function () {
		if (lock) {
			// called too soon, queue to call later
			args = arguments;

		} else {
			// call and lock until later
			fn.apply(context, arguments);
			setTimeout(later, time);
			lock = true;
		}
	};

	return wrapperFn;
}

// @function wrapNum(num: Number, range: Number[], includeMax?: Boolean): Number
// Returns the number `num` modulo `range` in such a way so it lies within
// `range[0]` and `range[1]`. The returned value will be always smaller than
// `range[1]` unless `includeMax` is set to `true`.
function wrapNum(x, range, includeMax) {
	var max = range[1],
	    min = range[0],
	    d = max - min;
	return x === max && includeMax ? x : ((x - min) % d + d) % d + min;
}

// @function falseFn(): Function
// Returns a function which always returns `false`.
function falseFn() { return false; }

// @function formatNum(num: Number, digits?: Number): Number
// Returns the number `num` rounded to `digits` decimals, or to 5 decimals by default.
function formatNum(num, digits) {
	var pow = Math.pow(10, digits || 5);
	return Math.round(num * pow) / pow;
}

// @function trim(str: String): String
// Compatibility polyfill for [String.prototype.trim](https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/String/Trim)
function trim(str) {
	return str.trim ? str.trim() : str.replace(/^\s+|\s+$/g, '');
}

// @function splitWords(str: String): String[]
// Trims and splits the string on whitespace and returns the array of parts.
function splitWords(str) {
	return trim(str).split(/\s+/);
}

// @function setOptions(obj: Object, options: Object): Object
// Merges the given properties to the `options` of the `obj` object, returning the resulting options. See `Class options`. Has an `L.setOptions` shortcut.
function setOptions(obj, options) {
	if (!obj.hasOwnProperty('options')) {
		obj.options = obj.options ? create(obj.options) : {};
	}
	for (var i in options) {
		obj.options[i] = options[i];
	}
	return obj.options;
}

// @function getParamString(obj: Object, existingUrl?: String, uppercase?: Boolean): String
// Converts an object into a parameter URL string, e.g. `{a: "foo", b: "bar"}`
// translates to `'?a=foo&b=bar'`. If `existingUrl` is set, the parameters will
// be appended at the end. If `uppercase` is `true`, the parameter names will
// be uppercased (e.g. `'?A=foo&B=bar'`)
function getParamString(obj, existingUrl, uppercase) {
	var params = [];
	for (var i in obj) {
		params.push(encodeURIComponent(uppercase ? i.toUpperCase() : i) + '=' + encodeURIComponent(obj[i]));
	}
	return ((!existingUrl || existingUrl.indexOf('?') === -1) ? '?' : '&') + params.join('&');
}

var templateRe = /\{ *([\w_\-]+) *\}/g;

// @function template(str: String, data: Object): String
// Simple templating facility, accepts a template string of the form `'Hello {a}, {b}'`
// and a data object like `{a: 'foo', b: 'bar'}`, returns evaluated string
// `('Hello foo, bar')`. You can also specify functions instead of strings for
// data values — they will be evaluated passing `data` as an argument.
function template(str, data) {
	return str.replace(templateRe, function (str, key) {
		var value = data[key];

		if (value === undefined) {
			throw new Error('No value provided for variable ' + str);

		} else if (typeof value === 'function') {
			value = value(data);
		}
		return value;
	});
}

// @function isArray(obj): Boolean
// Compatibility polyfill for [Array.isArray](https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Array/isArray)
var isArray = Array.isArray || function (obj) {
	return (Object.prototype.toString.call(obj) === '[object Array]');
};

// @function indexOf(array: Array, el: Object): Number
// Compatibility polyfill for [Array.prototype.indexOf](https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Array/indexOf)
function indexOf(array, el) {
	for (var i = 0; i < array.length; i++) {
		if (array[i] === el) { return i; }
	}
	return -1;
}

// @property emptyImageUrl: String
// Data URI string containing a base64-encoded empty GIF image.
// Used as a hack to free memory from unused images on WebKit-powered
// mobile devices (by setting image `src` to this string).
var emptyImageUrl = 'data:image/gif;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs=';

// inspired by http://paulirish.com/2011/requestanimationframe-for-smart-animating/

function getPrefixed(name) {
	return window['webkit' + name] || window['moz' + name] || window['ms' + name];
}

var lastTime = 0;

// fallback for IE 7-8
function timeoutDefer(fn) {
	var time = +new Date(),
	    timeToCall = Math.max(0, 16 - (time - lastTime));

	lastTime = time + timeToCall;
	return window.setTimeout(fn, timeToCall);
}

var requestFn = window.requestAnimationFrame || getPrefixed('RequestAnimationFrame') || timeoutDefer;
var cancelFn = window.cancelAnimationFrame || getPrefixed('CancelAnimationFrame') ||
		getPrefixed('CancelRequestAnimationFrame') || function (id) { window.clearTimeout(id); };

// @function requestAnimFrame(fn: Function, context?: Object, immediate?: Boolean): Number
// Schedules `fn` to be executed when the browser repaints. `fn` is bound to
// `context` if given. When `immediate` is set, `fn` is called immediately if
// the browser doesn't have native support for
// [`window.requestAnimationFrame`](https://developer.mozilla.org/docs/Web/API/window/requestAnimationFrame),
// otherwise it's delayed. Returns a request ID that can be used to cancel the request.
function requestAnimFrame(fn, context, immediate) {
	if (immediate && requestFn === timeoutDefer) {
		fn.call(context);
	} else {
		return requestFn.call(window, bind(fn, context));
	}
}

// @function cancelAnimFrame(id: Number): undefined
// Cancels a previous `requestAnimFrame`. See also [window.cancelAnimationFrame](https://developer.mozilla.org/docs/Web/API/window/cancelAnimationFrame).
function cancelAnimFrame(id) {
	if (id) {
		cancelFn.call(window, id);
	}
}


var Util = (Object.freeze || Object)({
	freeze: freeze,
	extend: extend,
	create: create,
	bind: bind,
	lastId: lastId,
	stamp: stamp,
	throttle: throttle,
	wrapNum: wrapNum,
	falseFn: falseFn,
	formatNum: formatNum,
	trim: trim,
	splitWords: splitWords,
	setOptions: setOptions,
	getParamString: getParamString,
	template: template,
	isArray: isArray,
	indexOf: indexOf,
	emptyImageUrl: emptyImageUrl,
	requestFn: requestFn,
	cancelFn: cancelFn,
	requestAnimFrame: requestAnimFrame,
	cancelAnimFrame: cancelAnimFrame
});

// @class Class
// @aka L.Class

// @section
// @uninheritable

// Thanks to John Resig and Dean Edwards for inspiration!

function Class() {}

Class.extend = function (props) {

	// @function extend(props: Object): Function
	// [Extends the current class](#class-inheritance) given the properties to be included.
	// Returns a Javascript function that is a class constructor (to be called with `new`).
	var NewClass = function () {

		// call the constructor
		if (this.initialize) {
			this.initialize.apply(this, arguments);
		}

		// call all constructor hooks
		this.callInitHooks();
	};

	var parentProto = NewClass.__super__ = this.prototype;

	var proto = create(parentProto);
	proto.constructor = NewClass;

	NewClass.prototype = proto;

	// inherit parent's statics
	for (var i in this) {
		if (this.hasOwnProperty(i) && i !== 'prototype' && i !== '__super__') {
			NewClass[i] = this[i];
		}
	}

	// mix static properties into the class
	if (props.statics) {
		extend(NewClass, props.statics);
		delete props.statics;
	}

	// mix includes into the prototype
	if (props.includes) {
		checkDeprecatedMixinEvents(props.includes);
		extend.apply(null, [proto].concat(props.includes));
		delete props.includes;
	}

	// merge options
	if (proto.options) {
		props.options = extend(create(proto.options), props.options);
	}

	// mix given properties into the prototype
	extend(proto, props);

	proto._initHooks = [];

	// add method for calling all hooks
	proto.callInitHooks = function () {

		if (this._initHooksCalled) { return; }

		if (parentProto.callInitHooks) {
			parentProto.callInitHooks.call(this);
		}

		this._initHooksCalled = true;

		for (var i = 0, len = proto._initHooks.length; i < len; i++) {
			proto._initHooks[i].call(this);
		}
	};

	return NewClass;
};


// @function include(properties: Object): this
// [Includes a mixin](#class-includes) into the current class.
Class.include = function (props) {
	extend(this.prototype, props);
	return this;
};

// @function mergeOptions(options: Object): this
// [Merges `options`](#class-options) into the defaults of the class.
Class.mergeOptions = function (options) {
	extend(this.prototype.options, options);
	return this;
};

// @function addInitHook(fn: Function): this
// Adds a [constructor hook](#class-constructor-hooks) to the class.
Class.addInitHook = function (fn) { // (Function) || (String, args...)
	var args = Array.prototype.slice.call(arguments, 1);

	var init = typeof fn === 'function' ? fn : function () {
		this[fn].apply(this, args);
	};

	this.prototype._initHooks = this.prototype._initHooks || [];
	this.prototype._initHooks.push(init);
	return this;
};

function checkDeprecatedMixinEvents(includes) {
	if (!L || !L.Mixin) { return; }

	includes = isArray(includes) ? includes : [includes];

	for (var i = 0; i < includes.length; i++) {
		if (includes[i] === L.Mixin.Events) {
			console.warn('Deprecated include of L.Mixin.Events: ' +
				'this property will be removed in future releases, ' +
				'please inherit from L.Evented instead.', new Error().stack);
		}
	}
}

/*
 * @class Evented
 * @aka L.Evented
 * @inherits Class
 *
 * A set of methods shared between event-powered classes (like `Map` and `Marker`). Generally, events allow you to execute some function when something happens with an object (e.g. the user clicks on the map, causing the map to fire `'click'` event).
 *
 * @example
 *
 * ```js
 * map.on('click', function(e) {
 * 	alert(e.latlng);
 * } );
 * ```
 *
 * Leaflet deals with event listeners by reference, so if you want to add a listener and then remove it, define it as a function:
 *
 * ```js
 * function onClick(e) { ... }
 *
 * map.on('click', onClick);
 * map.off('click', onClick);
 * ```
 */

var Events = {
	/* @method on(type: String, fn: Function, context?: Object): this
	 * Adds a listener function (`fn`) to a particular event type of the object. You can optionally specify the context of the listener (object the this keyword will point to). You can also pass several space-separated types (e.g. `'click dblclick'`).
	 *
	 * @alternative
	 * @method on(eventMap: Object): this
	 * Adds a set of type/listener pairs, e.g. `{click: onClick, mousemove: onMouseMove}`
	 */
	on: function (types, fn, context) {

		// types can be a map of types/handlers
		if (typeof types === 'object') {
			for (var type in types) {
				// we don't process space-separated events here for performance;
				// it's a hot path since Layer uses the on(obj) syntax
				this._on(type, types[type], fn);
			}

		} else {
			// types can be a string of space-separated words
			types = splitWords(types);

			for (var i = 0, len = types.length; i < len; i++) {
				this._on(types[i], fn, context);
			}
		}

		return this;
	},

	/* @method off(type: String, fn?: Function, context?: Object): this
	 * Removes a previously added listener function. If no function is specified, it will remove all the listeners of that particular event from the object. Note that if you passed a custom context to `on`, you must pass the same context to `off` in order to remove the listener.
	 *
	 * @alternative
	 * @method off(eventMap: Object): this
	 * Removes a set of type/listener pairs.
	 *
	 * @alternative
	 * @method off: this
	 * Removes all listeners to all events on the object.
	 */
	off: function (types, fn, context) {

		if (!types) {
			// clear all listeners if called without arguments
			delete this._events;

		} else if (typeof types === 'object') {
			for (var type in types) {
				this._off(type, types[type], fn);
			}

		} else {
			types = splitWords(types);

			for (var i = 0, len = types.length; i < len; i++) {
				this._off(types[i], fn, context);
			}
		}

		return this;
	},

	// attach listener (without syntactic sugar now)
	_on: function (type, fn, context) {
		this._events = this._events || {};

		/* get/init listeners for type */
		var typeListeners = this._events[type];
		if (!typeListeners) {
			typeListeners = [];
			this._events[type] = typeListeners;
		}

		if (context === this) {
			// Less memory footprint.
			context = undefined;
		}
		var newListener = {fn: fn, ctx: context},
		    listeners = typeListeners;

		// check if fn already there
		for (var i = 0, len = listeners.length; i < len; i++) {
			if (listeners[i].fn === fn && listeners[i].ctx === context) {
				return;
			}
		}

		listeners.push(newListener);
	},

	_off: function (type, fn, context) {
		var listeners,
		    i,
		    len;

		if (!this._events) { return; }

		listeners = this._events[type];

		if (!listeners) {
			return;
		}

		if (!fn) {
			// Set all removed listeners to noop so they are not called if remove happens in fire
			for (i = 0, len = listeners.length; i < len; i++) {
				listeners[i].fn = falseFn;
			}
			// clear all listeners for a type if function isn't specified
			delete this._events[type];
			return;
		}

		if (context === this) {
			context = undefined;
		}

		if (listeners) {

			// find fn and remove it
			for (i = 0, len = listeners.length; i < len; i++) {
				var l = listeners[i];
				if (l.ctx !== context) { continue; }
				if (l.fn === fn) {

					// set the removed listener to noop so that's not called if remove happens in fire
					l.fn = falseFn;

					if (this._firingCount) {
						/* copy array in case events are being fired */
						this._events[type] = listeners = listeners.slice();
					}
					listeners.splice(i, 1);

					return;
				}
			}
		}
	},

	// @method fire(type: String, data?: Object, propagate?: Boolean): this
	// Fires an event of the specified type. You can optionally provide an data
	// object — the first argument of the listener function will contain its
	// properties. The event can optionally be propagated to event parents.
	fire: function (type, data, propagate) {
		if (!this.listens(type, propagate)) { return this; }

		var event = extend({}, data, {type: type, target: this});

		if (this._events) {
			var listeners = this._events[type];

			if (listeners) {
				this._firingCount = (this._firingCount + 1) || 1;
				for (var i = 0, len = listeners.length; i < len; i++) {
					var l = listeners[i];
					l.fn.call(l.ctx || this, event);
				}

				this._firingCount--;
			}
		}

		if (propagate) {
			// propagate the event to parents (set with addEventParent)
			this._propagateEvent(event);
		}

		return this;
	},

	// @method listens(type: String): Boolean
	// Returns `true` if a particular event type has any listeners attached to it.
	listens: function (type, propagate) {
		var listeners = this._events && this._events[type];
		if (listeners && listeners.length) { return true; }

		if (propagate) {
			// also check parents for listeners if event propagates
			for (var id in this._eventParents) {
				if (this._eventParents[id].listens(type, propagate)) { return true; }
			}
		}
		return false;
	},

	// @method once(…): this
	// Behaves as [`on(…)`](#evented-on), except the listener will only get fired once and then removed.
	once: function (types, fn, context) {

		if (typeof types === 'object') {
			for (var type in types) {
				this.once(type, types[type], fn);
			}
			return this;
		}

		var handler = bind(function () {
			this
			    .off(types, fn, context)
			    .off(types, handler, context);
		}, this);

		// add a listener that's executed once and removed after that
		return this
		    .on(types, fn, context)
		    .on(types, handler, context);
	},

	// @method addEventParent(obj: Evented): this
	// Adds an event parent - an `Evented` that will receive propagated events
	addEventParent: function (obj) {
		this._eventParents = this._eventParents || {};
		this._eventParents[stamp(obj)] = obj;
		return this;
	},

	// @method removeEventParent(obj: Evented): this
	// Removes an event parent, so it will stop receiving propagated events
	removeEventParent: function (obj) {
		if (this._eventParents) {
			delete this._eventParents[stamp(obj)];
		}
		return this;
	},

	_propagateEvent: function (e) {
		for (var id in this._eventParents) {
			this._eventParents[id].fire(e.type, extend({layer: e.target}, e), true);
		}
	}
};

// aliases; we should ditch those eventually

// @method addEventListener(…): this
// Alias to [`on(…)`](#evented-on)
Events.addEventListener = Events.on;

// @method removeEventListener(…): this
// Alias to [`off(…)`](#evented-off)

// @method clearAllEventListeners(…): this
// Alias to [`off()`](#evented-off)
Events.removeEventListener = Events.clearAllEventListeners = Events.off;

// @method addOneTimeEventListener(…): this
// Alias to [`once(…)`](#evented-once)
Events.addOneTimeEventListener = Events.once;

// @method fireEvent(…): this
// Alias to [`fire(…)`](#evented-fire)
Events.fireEvent = Events.fire;

// @method hasEventListeners(…): Boolean
// Alias to [`listens(…)`](#evented-listens)
Events.hasEventListeners = Events.listens;

var Evented = Class.extend(Events);

/*
 * @class Point
 * @aka L.Point
 *
 * Represents a point with `x` and `y` coordinates in pixels.
 *
 * @example
 *
 * ```js
 * var point = L.point(200, 300);
 * ```
 *
 * All Leaflet methods and options that accept `Point` objects also accept them in a simple Array form (unless noted otherwise), so these lines are equivalent:
 *
 * ```js
 * map.panBy([200, 300]);
 * map.panBy(L.point(200, 300));
 * ```
 */

function Point(x, y, round) {
	// @property x: Number; The `x` coordinate of the point
	this.x = (round ? Math.round(x) : x);
	// @property y: Number; The `y` coordinate of the point
	this.y = (round ? Math.round(y) : y);
}

Point.prototype = {

	// @method clone(): Point
	// Returns a copy of the current point.
	clone: function () {
		return new Point(this.x, this.y);
	},

	// @method add(otherPoint: Point): Point
	// Returns the result of addition of the current and the given points.
	add: function (point) {
		// non-destructive, returns a new point
		return this.clone()._add(toPoint(point));
	},

	_add: function (point) {
		// destructive, used directly for performance in situations where it's safe to modify existing point
		this.x += point.x;
		this.y += point.y;
		return this;
	},

	// @method subtract(otherPoint: Point): Point
	// Returns the result of subtraction of the given point from the current.
	subtract: function (point) {
		return this.clone()._subtract(toPoint(point));
	},

	_subtract: function (point) {
		this.x -= point.x;
		this.y -= point.y;
		return this;
	},

	// @method divideBy(num: Number): Point
	// Returns the result of division of the current point by the given number.
	divideBy: function (num) {
		return this.clone()._divideBy(num);
	},

	_divideBy: function (num) {
		this.x /= num;
		this.y /= num;
		return this;
	},

	// @method multiplyBy(num: Number): Point
	// Returns the result of multiplication of the current point by the given number.
	multiplyBy: function (num) {
		return this.clone()._multiplyBy(num);
	},

	_multiplyBy: function (num) {
		this.x *= num;
		this.y *= num;
		return this;
	},

	// @method scaleBy(scale: Point): Point
	// Multiply each coordinate of the current point by each coordinate of
	// `scale`. In linear algebra terms, multiply the point by the
	// [scaling matrix](https://en.wikipedia.org/wiki/Scaling_%28geometry%29#Matrix_representation)
	// defined by `scale`.
	scaleBy: function (point) {
		return new Point(this.x * point.x, this.y * point.y);
	},

	// @method unscaleBy(scale: Point): Point
	// Inverse of `scaleBy`. Divide each coordinate of the current point by
	// each coordinate of `scale`.
	unscaleBy: function (point) {
		return new Point(this.x / point.x, this.y / point.y);
	},

	// @method round(): Point
	// Returns a copy of the current point with rounded coordinates.
	round: function () {
		return this.clone()._round();
	},

	_round: function () {
		this.x = Math.round(this.x);
		this.y = Math.round(this.y);
		return this;
	},

	// @method floor(): Point
	// Returns a copy of the current point with floored coordinates (rounded down).
	floor: function () {
		return this.clone()._floor();
	},

	_floor: function () {
		this.x = Math.floor(this.x);
		this.y = Math.floor(this.y);
		return this;
	},

	// @method ceil(): Point
	// Returns a copy of the current point with ceiled coordinates (rounded up).
	ceil: function () {
		return this.clone()._ceil();
	},

	_ceil: function () {
		this.x = Math.ceil(this.x);
		this.y = Math.ceil(this.y);
		return this;
	},

	// @method distanceTo(otherPoint: Point): Number
	// Returns the cartesian distance between the current and the given points.
	distanceTo: function (point) {
		point = toPoint(point);

		var x = point.x - this.x,
		    y = point.y - this.y;

		return Math.sqrt(x * x + y * y);
	},

	// @method equals(otherPoint: Point): Boolean
	// Returns `true` if the given point has the same coordinates.
	equals: function (point) {
		point = toPoint(point);

		return point.x === this.x &&
		       point.y === this.y;
	},

	// @method contains(otherPoint: Point): Boolean
	// Returns `true` if both coordinates of the given point are less than the corresponding current point coordinates (in absolute values).
	contains: function (point) {
		point = toPoint(point);

		return Math.abs(point.x) <= Math.abs(this.x) &&
		       Math.abs(point.y) <= Math.abs(this.y);
	},

	// @method toString(): String
	// Returns a string representation of the point for debugging purposes.
	toString: function () {
		return 'Point(' +
		        formatNum(this.x) + ', ' +
		        formatNum(this.y) + ')';
	}
};

// @factory L.point(x: Number, y: Number, round?: Boolean)
// Creates a Point object with the given `x` and `y` coordinates. If optional `round` is set to true, rounds the `x` and `y` values.

// @alternative
// @factory L.point(coords: Number[])
// Expects an array of the form `[x, y]` instead.

// @alternative
// @factory L.point(coords: Object)
// Expects a plain object of the form `{x: Number, y: Number}` instead.
function toPoint(x, y, round) {
	if (x instanceof Point) {
		return x;
	}
	if (isArray(x)) {
		return new Point(x[0], x[1]);
	}
	if (x === undefined || x === null) {
		return x;
	}
	if (typeof x === 'object' && 'x' in x && 'y' in x) {
		return new Point(x.x, x.y);
	}
	return new Point(x, y, round);
}

/*
 * @class Bounds
 * @aka L.Bounds
 *
 * Represents a rectangular area in pixel coordinates.
 *
 * @example
 *
 * ```js
 * var p1 = L.point(10, 10),
 * p2 = L.point(40, 60),
 * bounds = L.bounds(p1, p2);
 * ```
 *
 * All Leaflet methods that accept `Bounds` objects also accept them in a simple Array form (unless noted otherwise), so the bounds example above can be passed like this:
 *
 * ```js
 * otherBounds.intersects([[10, 10], [40, 60]]);
 * ```
 */

function Bounds(a, b) {
	if (!a) { return; }

	var points = b ? [a, b] : a;

	for (var i = 0, len = points.length; i < len; i++) {
		this.extend(points[i]);
	}
}

Bounds.prototype = {
	// @method extend(point: Point): this
	// Extends the bounds to contain the given point.
	extend: function (point) { // (Point)
		point = toPoint(point);

		// @property min: Point
		// The top left corner of the rectangle.
		// @property max: Point
		// The bottom right corner of the rectangle.
		if (!this.min && !this.max) {
			this.min = point.clone();
			this.max = point.clone();
		} else {
			this.min.x = Math.min(point.x, this.min.x);
			this.max.x = Math.max(point.x, this.max.x);
			this.min.y = Math.min(point.y, this.min.y);
			this.max.y = Math.max(point.y, this.max.y);
		}
		return this;
	},

	// @method getCenter(round?: Boolean): Point
	// Returns the center point of the bounds.
	getCenter: function (round) {
		return new Point(
		        (this.min.x + this.max.x) / 2,
		        (this.min.y + this.max.y) / 2, round);
	},

	// @method getBottomLeft(): Point
	// Returns the bottom-left point of the bounds.
	getBottomLeft: function () {
		return new Point(this.min.x, this.max.y);
	},

	// @method getTopRight(): Point
	// Returns the top-right point of the bounds.
	getTopRight: function () { // -> Point
		return new Point(this.max.x, this.min.y);
	},

	// @method getTopLeft(): Point
	// Returns the top-left point of the bounds (i.e. [`this.min`](#bounds-min)).
	getTopLeft: function () {
		return this.min; // left, top
	},

	// @method getBottomRight(): Point
	// Returns the bottom-right point of the bounds (i.e. [`this.max`](#bounds-max)).
	getBottomRight: function () {
		return this.max; // right, bottom
	},

	// @method getSize(): Point
	// Returns the size of the given bounds
	getSize: function () {
		return this.max.subtract(this.min);
	},

	// @method contains(otherBounds: Bounds): Boolean
	// Returns `true` if the rectangle contains the given one.
	// @alternative
	// @method contains(point: Point): Boolean
	// Returns `true` if the rectangle contains the given point.
	contains: function (obj) {
		var min, max;

		if (typeof obj[0] === 'number' || obj instanceof Point) {
			obj = toPoint(obj);
		} else {
			obj = toBounds(obj);
		}

		if (obj instanceof Bounds) {
			min = obj.min;
			max = obj.max;
		} else {
			min = max = obj;
		}

		return (min.x >= this.min.x) &&
		       (max.x <= this.max.x) &&
		       (min.y >= this.min.y) &&
		       (max.y <= this.max.y);
	},

	// @method intersects(otherBounds: Bounds): Boolean
	// Returns `true` if the rectangle intersects the given bounds. Two bounds
	// intersect if they have at least one point in common.
	intersects: function (bounds) { // (Bounds) -> Boolean
		bounds = toBounds(bounds);

		var min = this.min,
		    max = this.max,
		    min2 = bounds.min,
		    max2 = bounds.max,
		    xIntersects = (max2.x >= min.x) && (min2.x <= max.x),
		    yIntersects = (max2.y >= min.y) && (min2.y <= max.y);

		return xIntersects && yIntersects;
	},

	// @method overlaps(otherBounds: Bounds): Boolean
	// Returns `true` if the rectangle overlaps the given bounds. Two bounds
	// overlap if their intersection is an area.
	overlaps: function (bounds) { // (Bounds) -> Boolean
		bounds = toBounds(bounds);

		var min = this.min,
		    max = this.max,
		    min2 = bounds.min,
		    max2 = bounds.max,
		    xOverlaps = (max2.x > min.x) && (min2.x < max.x),
		    yOverlaps = (max2.y > min.y) && (min2.y < max.y);

		return xOverlaps && yOverlaps;
	},

	isValid: function () {
		return !!(this.min && this.max);
	}
};


// @factory L.bounds(corner1: Point, corner2: Point)
// Creates a Bounds object from two corners coordinate pairs.
// @alternative
// @factory L.bounds(points: Point[])
// Creates a Bounds object from the given array of points.
function toBounds(a, b) {
	if (!a || a instanceof Bounds) {
		return a;
	}
	return new Bounds(a, b);
}

/*
 * @class LatLngBounds
 * @aka L.LatLngBounds
 *
 * Represents a rectangular geographical area on a map.
 *
 * @example
 *
 * ```js
 * var corner1 = L.latLng(40.712, -74.227),
 * corner2 = L.latLng(40.774, -74.125),
 * bounds = L.latLngBounds(corner1, corner2);
 * ```
 *
 * All Leaflet methods that accept LatLngBounds objects also accept them in a simple Array form (unless noted otherwise), so the bounds example above can be passed like this:
 *
 * ```js
 * map.fitBounds([
 * 	[40.712, -74.227],
 * 	[40.774, -74.125]
 * ]);
 * ```
 *
 * Caution: if the area crosses the antimeridian (often confused with the International Date Line), you must specify corners _outside_ the [-180, 180] degrees longitude range.
 */

function LatLngBounds(corner1, corner2) { // (LatLng, LatLng) or (LatLng[])
	if (!corner1) { return; }

	var latlngs = corner2 ? [corner1, corner2] : corner1;

	for (var i = 0, len = latlngs.length; i < len; i++) {
		this.extend(latlngs[i]);
	}
}

LatLngBounds.prototype = {

	// @method extend(latlng: LatLng): this
	// Extend the bounds to contain the given point

	// @alternative
	// @method extend(otherBounds: LatLngBounds): this
	// Extend the bounds to contain the given bounds
	extend: function (obj) {
		var sw = this._southWest,
		    ne = this._northEast,
		    sw2, ne2;

		if (obj instanceof LatLng) {
			sw2 = obj;
			ne2 = obj;

		} else if (obj instanceof LatLngBounds) {
			sw2 = obj._southWest;
			ne2 = obj._northEast;

			if (!sw2 || !ne2) { return this; }

		} else {
			return obj ? this.extend(toLatLng(obj) || toLatLngBounds(obj)) : this;
		}

		if (!sw && !ne) {
			this._southWest = new LatLng(sw2.lat, sw2.lng);
			this._northEast = new LatLng(ne2.lat, ne2.lng);
		} else {
			sw.lat = Math.min(sw2.lat, sw.lat);
			sw.lng = Math.min(sw2.lng, sw.lng);
			ne.lat = Math.max(ne2.lat, ne.lat);
			ne.lng = Math.max(ne2.lng, ne.lng);
		}

		return this;
	},

	// @method pad(bufferRatio: Number): LatLngBounds
	// Returns bigger bounds created by extending the current bounds by a given percentage in each direction.
	pad: function (bufferRatio) {
		var sw = this._southWest,
		    ne = this._northEast,
		    heightBuffer = Math.abs(sw.lat - ne.lat) * bufferRatio,
		    widthBuffer = Math.abs(sw.lng - ne.lng) * bufferRatio;

		return new LatLngBounds(
		        new LatLng(sw.lat - heightBuffer, sw.lng - widthBuffer),
		        new LatLng(ne.lat + heightBuffer, ne.lng + widthBuffer));
	},

	// @method getCenter(): LatLng
	// Returns the center point of the bounds.
	getCenter: function () {
		return new LatLng(
		        (this._southWest.lat + this._northEast.lat) / 2,
		        (this._southWest.lng + this._northEast.lng) / 2);
	},

	// @method getSouthWest(): LatLng
	// Returns the south-west point of the bounds.
	getSouthWest: function () {
		return this._southWest;
	},

	// @method getNorthEast(): LatLng
	// Returns the north-east point of the bounds.
	getNorthEast: function () {
		return this._northEast;
	},

	// @method getNorthWest(): LatLng
	// Returns the north-west point of the bounds.
	getNorthWest: function () {
		return new LatLng(this.getNorth(), this.getWest());
	},

	// @method getSouthEast(): LatLng
	// Returns the south-east point of the bounds.
	getSouthEast: function () {
		return new LatLng(this.getSouth(), this.getEast());
	},

	// @method getWest(): Number
	// Returns the west longitude of the bounds
	getWest: function () {
		return this._southWest.lng;
	},

	// @method getSouth(): Number
	// Returns the south latitude of the bounds
	getSouth: function () {
		return this._southWest.lat;
	},

	// @method getEast(): Number
	// Returns the east longitude of the bounds
	getEast: function () {
		return this._northEast.lng;
	},

	// @method getNorth(): Number
	// Returns the north latitude of the bounds
	getNorth: function () {
		return this._northEast.lat;
	},

	// @method contains(otherBounds: LatLngBounds): Boolean
	// Returns `true` if the rectangle contains the given one.

	// @alternative
	// @method contains (latlng: LatLng): Boolean
	// Returns `true` if the rectangle contains the given point.
	contains: function (obj) { // (LatLngBounds) or (LatLng) -> Boolean
		if (typeof obj[0] === 'number' || obj instanceof LatLng || 'lat' in obj) {
			obj = toLatLng(obj);
		} else {
			obj = toLatLngBounds(obj);
		}

		var sw = this._southWest,
		    ne = this._northEast,
		    sw2, ne2;

		if (obj instanceof LatLngBounds) {
			sw2 = obj.getSouthWest();
			ne2 = obj.getNorthEast();
		} else {
			sw2 = ne2 = obj;
		}

		return (sw2.lat >= sw.lat) && (ne2.lat <= ne.lat) &&
		       (sw2.lng >= sw.lng) && (ne2.lng <= ne.lng);
	},

	// @method intersects(otherBounds: LatLngBounds): Boolean
	// Returns `true` if the rectangle intersects the given bounds. Two bounds intersect if they have at least one point in common.
	intersects: function (bounds) {
		bounds = toLatLngBounds(bounds);

		var sw = this._southWest,
		    ne = this._northEast,
		    sw2 = bounds.getSouthWest(),
		    ne2 = bounds.getNorthEast(),

		    latIntersects = (ne2.lat >= sw.lat) && (sw2.lat <= ne.lat),
		    lngIntersects = (ne2.lng >= sw.lng) && (sw2.lng <= ne.lng);

		return latIntersects && lngIntersects;
	},

	// @method overlaps(otherBounds: Bounds): Boolean
	// Returns `true` if the rectangle overlaps the given bounds. Two bounds overlap if their intersection is an area.
	overlaps: function (bounds) {
		bounds = toLatLngBounds(bounds);

		var sw = this._southWest,
		    ne = this._northEast,
		    sw2 = bounds.getSouthWest(),
		    ne2 = bounds.getNorthEast(),

		    latOverlaps = (ne2.lat > sw.lat) && (sw2.lat < ne.lat),
		    lngOverlaps = (ne2.lng > sw.lng) && (sw2.lng < ne.lng);

		return latOverlaps && lngOverlaps;
	},

	// @method toBBoxString(): String
	// Returns a string with bounding box coordinates in a 'southwest_lng,southwest_lat,northeast_lng,northeast_lat' format. Useful for sending requests to web services that return geo data.
	toBBoxString: function () {
		return [this.getWest(), this.getSouth(), this.getEast(), this.getNorth()].join(',');
	},

	// @method equals(otherBounds: LatLngBounds, maxMargin?: Number): Boolean
	// Returns `true` if the rectangle is equivalent (within a small margin of error) to the given bounds. The margin of error can be overriden by setting `maxMargin` to a small number.
	equals: function (bounds, maxMargin) {
		if (!bounds) { return false; }

		bounds = toLatLngBounds(bounds);

		return this._southWest.equals(bounds.getSouthWest(), maxMargin) &&
		       this._northEast.equals(bounds.getNorthEast(), maxMargin);
	},

	// @method isValid(): Boolean
	// Returns `true` if the bounds are properly initialized.
	isValid: function () {
		return !!(this._southWest && this._northEast);
	}
};

// TODO International date line?

// @factory L.latLngBounds(corner1: LatLng, corner2: LatLng)
// Creates a `LatLngBounds` object by defining two diagonally opposite corners of the rectangle.

// @alternative
// @factory L.latLngBounds(latlngs: LatLng[])
// Creates a `LatLngBounds` object defined by the geographical points it contains. Very useful for zooming the map to fit a particular set of locations with [`fitBounds`](#map-fitbounds).
function toLatLngBounds(a, b) {
	if (a instanceof LatLngBounds) {
		return a;
	}
	return new LatLngBounds(a, b);
}

/* @class LatLng
 * @aka L.LatLng
 *
 * Represents a geographical point with a certain latitude and longitude.
 *
 * @example
 *
 * ```
 * var latlng = L.latLng(50.5, 30.5);
 * ```
 *
 * All Leaflet methods that accept LatLng objects also accept them in a simple Array form and simple object form (unless noted otherwise), so these lines are equivalent:
 *
 * ```
 * map.panTo([50, 30]);
 * map.panTo({lon: 30, lat: 50});
 * map.panTo({lat: 50, lng: 30});
 * map.panTo(L.latLng(50, 30));
 * ```
 */

function LatLng(lat, lng, alt) {
	if (isNaN(lat) || isNaN(lng)) {
		throw new Error('Invalid LatLng object: (' + lat + ', ' + lng + ')');
	}

	// @property lat: Number
	// Latitude in degrees
	this.lat = +lat;

	// @property lng: Number
	// Longitude in degrees
	this.lng = +lng;

	// @property alt: Number
	// Altitude in meters (optional)
	if (alt !== undefined) {
		this.alt = +alt;
	}
}

LatLng.prototype = {
	// @method equals(otherLatLng: LatLng, maxMargin?: Number): Boolean
	// Returns `true` if the given `LatLng` point is at the same position (within a small margin of error). The margin of error can be overriden by setting `maxMargin` to a small number.
	equals: function (obj, maxMargin) {
		if (!obj) { return false; }

		obj = toLatLng(obj);

		var margin = Math.max(
		        Math.abs(this.lat - obj.lat),
		        Math.abs(this.lng - obj.lng));

		return margin <= (maxMargin === undefined ? 1.0E-9 : maxMargin);
	},

	// @method toString(): String
	// Returns a string representation of the point (for debugging purposes).
	toString: function (precision) {
		return 'LatLng(' +
		        formatNum(this.lat, precision) + ', ' +
		        formatNum(this.lng, precision) + ')';
	},

	// @method distanceTo(otherLatLng: LatLng): Number
	// Returns the distance (in meters) to the given `LatLng` calculated using the [Haversine formula](http://en.wikipedia.org/wiki/Haversine_formula).
	distanceTo: function (other) {
		return Earth.distance(this, toLatLng(other));
	},

	// @method wrap(): LatLng
	// Returns a new `LatLng` object with the longitude wrapped so it's always between -180 and +180 degrees.
	wrap: function () {
		return Earth.wrapLatLng(this);
	},

	// @method toBounds(sizeInMeters: Number): LatLngBounds
	// Returns a new `LatLngBounds` object in which each boundary is `sizeInMeters/2` meters apart from the `LatLng`.
	toBounds: function (sizeInMeters) {
		var latAccuracy = 180 * sizeInMeters / 40075017,
		    lngAccuracy = latAccuracy / Math.cos((Math.PI / 180) * this.lat);

		return toLatLngBounds(
		        [this.lat - latAccuracy, this.lng - lngAccuracy],
		        [this.lat + latAccuracy, this.lng + lngAccuracy]);
	},

	clone: function () {
		return new LatLng(this.lat, this.lng, this.alt);
	}
};



// @factory L.latLng(latitude: Number, longitude: Number, altitude?: Number): LatLng
// Creates an object representing a geographical point with the given latitude and longitude (and optionally altitude).

// @alternative
// @factory L.latLng(coords: Array): LatLng
// Expects an array of the form `[Number, Number]` or `[Number, Number, Number]` instead.

// @alternative
// @factory L.latLng(coords: Object): LatLng
// Expects an plain object of the form `{lat: Number, lng: Number}` or `{lat: Number, lng: Number, alt: Number}` instead.

function toLatLng(a, b, c) {
	if (a instanceof LatLng) {
		return a;
	}
	if (isArray(a) && typeof a[0] !== 'object') {
		if (a.length === 3) {
			return new LatLng(a[0], a[1], a[2]);
		}
		if (a.length === 2) {
			return new LatLng(a[0], a[1]);
		}
		return null;
	}
	if (a === undefined || a === null) {
		return a;
	}
	if (typeof a === 'object' && 'lat' in a) {
		return new LatLng(a.lat, 'lng' in a ? a.lng : a.lon, a.alt);
	}
	if (b === undefined) {
		return null;
	}
	return new LatLng(a, b, c);
}

/*
 * @namespace CRS
 * @crs L.CRS.Base
 * Object that defines coordinate reference systems for projecting
 * geographical points into pixel (screen) coordinates and back (and to
 * coordinates in other units for [WMS](https://en.wikipedia.org/wiki/Web_Map_Service) services). See
 * [spatial reference system](http://en.wikipedia.org/wiki/Coordinate_reference_system).
 *
 * Leaflet defines the most usual CRSs by default. If you want to use a
 * CRS not defined by default, take a look at the
 * [Proj4Leaflet](https://github.com/kartena/Proj4Leaflet) plugin.
 */

var CRS = {
	// @method latLngToPoint(latlng: LatLng, zoom: Number): Point
	// Projects geographical coordinates into pixel coordinates for a given zoom.
	latLngToPoint: function (latlng, zoom) {
		var projectedPoint = this.projection.project(latlng),
		    scale = this.scale(zoom);

		return this.transformation._transform(projectedPoint, scale);
	},

	// @method pointToLatLng(point: Point, zoom: Number): LatLng
	// The inverse of `latLngToPoint`. Projects pixel coordinates on a given
	// zoom into geographical coordinates.
	pointToLatLng: function (point, zoom) {
		var scale = this.scale(zoom),
		    untransformedPoint = this.transformation.untransform(point, scale);

		return this.projection.unproject(untransformedPoint);
	},

	// @method project(latlng: LatLng): Point
	// Projects geographical coordinates into coordinates in units accepted for
	// this CRS (e.g. meters for EPSG:3857, for passing it to WMS services).
	project: function (latlng) {
		return this.projection.project(latlng);
	},

	// @method unproject(point: Point): LatLng
	// Given a projected coordinate returns the corresponding LatLng.
	// The inverse of `project`.
	unproject: function (point) {
		return this.projection.unproject(point);
	},

	// @method scale(zoom: Number): Number
	// Returns the scale used when transforming projected coordinates into
	// pixel coordinates for a particular zoom. For example, it returns
	// `256 * 2^zoom` for Mercator-based CRS.
	scale: function (zoom) {
		return 256 * Math.pow(2, zoom);
	},

	// @method zoom(scale: Number): Number
	// Inverse of `scale()`, returns the zoom level corresponding to a scale
	// factor of `scale`.
	zoom: function (scale) {
		return Math.log(scale / 256) / Math.LN2;
	},

	// @method getProjectedBounds(zoom: Number): Bounds
	// Returns the projection's bounds scaled and transformed for the provided `zoom`.
	getProjectedBounds: function (zoom) {
		if (this.infinite) { return null; }

		var b = this.projection.bounds,
		    s = this.scale(zoom),
		    min = this.transformation.transform(b.min, s),
		    max = this.transformation.transform(b.max, s);

		return new Bounds(min, max);
	},

	// @method distance(latlng1: LatLng, latlng2: LatLng): Number
	// Returns the distance between two geographical coordinates.

	// @property code: String
	// Standard code name of the CRS passed into WMS services (e.g. `'EPSG:3857'`)
	//
	// @property wrapLng: Number[]
	// An array of two numbers defining whether the longitude (horizontal) coordinate
	// axis wraps around a given range and how. Defaults to `[-180, 180]` in most
	// geographical CRSs. If `undefined`, the longitude axis does not wrap around.
	//
	// @property wrapLat: Number[]
	// Like `wrapLng`, but for the latitude (vertical) axis.

	// wrapLng: [min, max],
	// wrapLat: [min, max],

	// @property infinite: Boolean
	// If true, the coordinate space will be unbounded (infinite in both axes)
	infinite: false,

	// @method wrapLatLng(latlng: LatLng): LatLng
	// Returns a `LatLng` where lat and lng has been wrapped according to the
	// CRS's `wrapLat` and `wrapLng` properties, if they are outside the CRS's bounds.
	wrapLatLng: function (latlng) {
		var lng = this.wrapLng ? wrapNum(latlng.lng, this.wrapLng, true) : latlng.lng,
		    lat = this.wrapLat ? wrapNum(latlng.lat, this.wrapLat, true) : latlng.lat,
		    alt = latlng.alt;

		return new LatLng(lat, lng, alt);
	},

	// @method wrapLatLngBounds(bounds: LatLngBounds): LatLngBounds
	// Returns a `LatLngBounds` with the same size as the given one, ensuring
	// that its center is within the CRS's bounds.
	// Only accepts actual `L.LatLngBounds` instances, not arrays.
	wrapLatLngBounds: function (bounds) {
		var center = bounds.getCenter(),
		    newCenter = this.wrapLatLng(center),
		    latShift = center.lat - newCenter.lat,
		    lngShift = center.lng - newCenter.lng;

		if (latShift === 0 && lngShift === 0) {
			return bounds;
		}

		var sw = bounds.getSouthWest(),
		    ne = bounds.getNorthEast(),
		    newSw = new LatLng(sw.lat - latShift, sw.lng - lngShift),
		    newNe = new LatLng(ne.lat - latShift, ne.lng - lngShift);

		return new LatLngBounds(newSw, newNe);
	}
};

/*
 * @namespace CRS
 * @crs L.CRS.Earth
 *
 * Serves as the base for CRS that are global such that they cover the earth.
 * Can only be used as the base for other CRS and cannot be used directly,
 * since it does not have a `code`, `projection` or `transformation`. `distance()` returns
 * meters.
 */

var Earth = extend({}, CRS, {
	wrapLng: [-180, 180],

	// Mean Earth Radius, as recommended for use by
	// the International Union of Geodesy and Geophysics,
	// see http://rosettacode.org/wiki/Haversine_formula
	R: 6371000,

	// distance between two geographical points using spherical law of cosines approximation
	distance: function (latlng1, latlng2) {
		var rad = Math.PI / 180,
		    lat1 = latlng1.lat * rad,
		    lat2 = latlng2.lat * rad,
		    a = Math.sin(lat1) * Math.sin(lat2) +
		        Math.cos(lat1) * Math.cos(lat2) * Math.cos((latlng2.lng - latlng1.lng) * rad);

		return this.R * Math.acos(Math.min(a, 1));
	}
});

/*
 * @namespace Projection
 * @projection L.Projection.SphericalMercator
 *
 * Spherical Mercator projection — the most common projection for online maps,
 * used by almost all free and commercial tile providers. Assumes that Earth is
 * a sphere. Used by the `EPSG:3857` CRS.
 */

var SphericalMercator = {

	R: 6378137,
	MAX_LATITUDE: 85.0511287798,

	project: function (latlng) {
		var d = Math.PI / 180,
		    max = this.MAX_LATITUDE,
		    lat = Math.max(Math.min(max, latlng.lat), -max),
		    sin = Math.sin(lat * d);

		return new Point(
				this.R * latlng.lng * d,
				this.R * Math.log((1 + sin) / (1 - sin)) / 2);
	},

	unproject: function (point) {
		var d = 180 / Math.PI;

		return new LatLng(
			(2 * Math.atan(Math.exp(point.y / this.R)) - (Math.PI / 2)) * d,
			point.x * d / this.R);
	},

	bounds: (function () {
		var d = 6378137 * Math.PI;
		return new Bounds([-d, -d], [d, d]);
	})()
};

/*
 * @class Transformation
 * @aka L.Transformation
 *
 * Represents an affine transformation: a set of coefficients `a`, `b`, `c`, `d`
 * for transforming a point of a form `(x, y)` into `(a*x + b, c*y + d)` and doing
 * the reverse. Used by Leaflet in its projections code.
 *
 * @example
 *
 * ```js
 * var transformation = L.transformation(2, 5, -1, 10),
 * 	p = L.point(1, 2),
 * 	p2 = transformation.transform(p), //  L.point(7, 8)
 * 	p3 = transformation.untransform(p2); //  L.point(1, 2)
 * ```
 */


// factory new L.Transformation(a: Number, b: Number, c: Number, d: Number)
// Creates a `Transformation` object with the given coefficients.
function Transformation(a, b, c, d) {
	if (isArray(a)) {
		// use array properties
		this._a = a[0];
		this._b = a[1];
		this._c = a[2];
		this._d = a[3];
		return;
	}
	this._a = a;
	this._b = b;
	this._c = c;
	this._d = d;
}

Transformation.prototype = {
	// @method transform(point: Point, scale?: Number): Point
	// Returns a transformed point, optionally multiplied by the given scale.
	// Only accepts actual `L.Point` instances, not arrays.
	transform: function (point, scale) { // (Point, Number) -> Point
		return this._transform(point.clone(), scale);
	},

	// destructive transform (faster)
	_transform: function (point, scale) {
		scale = scale || 1;
		point.x = scale * (this._a * point.x + this._b);
		point.y = scale * (this._c * point.y + this._d);
		return point;
	},

	// @method untransform(point: Point, scale?: Number): Point
	// Returns the reverse transformation of the given point, optionally divided
	// by the given scale. Only accepts actual `L.Point` instances, not arrays.
	untransform: function (point, scale) {
		scale = scale || 1;
		return new Point(
		        (point.x / scale - this._b) / this._a,
		        (point.y / scale - this._d) / this._c);
	}
};

// factory L.transformation(a: Number, b: Number, c: Number, d: Number)

// @factory L.transformation(a: Number, b: Number, c: Number, d: Number)
// Instantiates a Transformation object with the given coefficients.

// @alternative
// @factory L.transformation(coefficients: Array): Transformation
// Expects an coeficients array of the form
// `[a: Number, b: Number, c: Number, d: Number]`.

function toTransformation(a, b, c, d) {
	return new Transformation(a, b, c, d);
}

/*
 * @namespace CRS
 * @crs L.CRS.EPSG3857
 *
 * The most common CRS for online maps, used by almost all free and commercial
 * tile providers. Uses Spherical Mercator projection. Set in by default in
 * Map's `crs` option.
 */

var EPSG3857 = extend({}, Earth, {
	code: 'EPSG:3857',
	projection: SphericalMercator,

	transformation: (function () {
		var scale = 0.5 / (Math.PI * SphericalMercator.R);
		return toTransformation(scale, 0.5, -scale, 0.5);
	}())
});

var EPSG900913 = extend({}, EPSG3857, {
	code: 'EPSG:900913'
});

// @namespace SVG; @section
// There are several static functions which can be called without instantiating L.SVG:

// @function create(name: String): SVGElement
// Returns a instance of [SVGElement](https://developer.mozilla.org/docs/Web/API/SVGElement),
// corresponding to the class name passed. For example, using 'line' will return
// an instance of [SVGLineElement](https://developer.mozilla.org/docs/Web/API/SVGLineElement).
function svgCreate(name) {
	return document.createElementNS('http://www.w3.org/2000/svg', name);
}

// @function pointsToPath(rings: Point[], closed: Boolean): String
// Generates a SVG path string for multiple rings, with each ring turning
// into "M..L..L.." instructions
function pointsToPath(rings, closed) {
	var str = '',
	i, j, len, len2, points, p;

	for (i = 0, len = rings.length; i < len; i++) {
		points = rings[i];

		for (j = 0, len2 = points.length; j < len2; j++) {
			p = points[j];
			str += (j ? 'L' : 'M') + p.x + ' ' + p.y;
		}

		// closes the ring for polygons; "x" is VML syntax
		str += closed ? (svg ? 'z' : 'x') : '';
	}

	// SVG complains about empty path strings
	return str || 'M0 0';
}

/*
 * @namespace Browser
 * @aka L.Browser
 *
 * A namespace with static properties for browser/feature detection used by Leaflet internally.
 *
 * @example
 *
 * ```js
 * if (L.Browser.ielt9) {
 *   alert('Upgrade your browser, dude!');
 * }
 * ```
 */

var style$1 = document.documentElement.style;

// @property ie: Boolean; `true` for all Internet Explorer versions (not Edge).
var ie = 'ActiveXObject' in window;

// @property ielt9: Boolean; `true` for Internet Explorer versions less than 9.
var ielt9 = ie && !document.addEventListener;

// @property edge: Boolean; `true` for the Edge web browser.
var edge = 'msLaunchUri' in navigator && !('documentMode' in document);

// @property webkit: Boolean;
// `true` for webkit-based browsers like Chrome and Safari (including mobile versions).
var webkit = userAgentContains('webkit');

// @property android: Boolean
// `true` for any browser running on an Android platform.
var android = userAgentContains('android');

// @property android23: Boolean; `true` for browsers running on Android 2 or Android 3.
var android23 = userAgentContains('android 2') || userAgentContains('android 3');

// @property opera: Boolean; `true` for the Opera browser
var opera = !!window.opera;

// @property chrome: Boolean; `true` for the Chrome browser.
var chrome = userAgentContains('chrome');

// @property gecko: Boolean; `true` for gecko-based browsers like Firefox.
var gecko = userAgentContains('gecko') && !webkit && !opera && !ie;

// @property safari: Boolean; `true` for the Safari browser.
var safari = !chrome && userAgentContains('safari');

var phantom = userAgentContains('phantom');

// @property opera12: Boolean
// `true` for the Opera browser supporting CSS transforms (version 12 or later).
var opera12 = 'OTransition' in style$1;

// @property win: Boolean; `true` when the browser is running in a Windows platform
var win = navigator.platform.indexOf('Win') === 0;

// @property ie3d: Boolean; `true` for all Internet Explorer versions supporting CSS transforms.
var ie3d = ie && ('transition' in style$1);

// @property webkit3d: Boolean; `true` for webkit-based browsers supporting CSS transforms.
var webkit3d = ('WebKitCSSMatrix' in window) && ('m11' in new window.WebKitCSSMatrix()) && !android23;

// @property gecko3d: Boolean; `true` for gecko-based browsers supporting CSS transforms.
var gecko3d = 'MozPerspective' in style$1;

// @property any3d: Boolean
// `true` for all browsers supporting CSS transforms.
var any3d = !window.L_DISABLE_3D && (ie3d || webkit3d || gecko3d) && !opera12 && !phantom;

// @property mobile: Boolean; `true` for all browsers running in a mobile device.
var mobile = typeof orientation !== 'undefined' || userAgentContains('mobile');

// @property mobileWebkit: Boolean; `true` for all webkit-based browsers in a mobile device.
var mobileWebkit = mobile && webkit;

// @property mobileWebkit3d: Boolean
// `true` for all webkit-based browsers in a mobile device supporting CSS transforms.
var mobileWebkit3d = mobile && webkit3d;

// @property msPointer: Boolean
// `true` for browsers implementing the Microsoft touch events model (notably IE10).
var msPointer = !window.PointerEvent && window.MSPointerEvent;

// @property pointer: Boolean
// `true` for all browsers supporting [pointer events](https://msdn.microsoft.com/en-us/library/dn433244%28v=vs.85%29.aspx).
var pointer = !!(window.PointerEvent || msPointer);

// @property touch: Boolean
// `true` for all browsers supporting [touch events](https://developer.mozilla.org/docs/Web/API/Touch_events).
// This does not necessarily mean that the browser is running in a computer with
// a touchscreen, it only means that the browser is capable of understanding
// touch events.
var touch = !window.L_NO_TOUCH && (pointer || 'ontouchstart' in window ||
		(window.DocumentTouch && document instanceof window.DocumentTouch));

// @property mobileOpera: Boolean; `true` for the Opera browser in a mobile device.
var mobileOpera = mobile && opera;

// @property mobileGecko: Boolean
// `true` for gecko-based browsers running in a mobile device.
var mobileGecko = mobile && gecko;

// @property retina: Boolean
// `true` for browsers on a high-resolution "retina" screen.
var retina = (window.devicePixelRatio || (window.screen.deviceXDPI / window.screen.logicalXDPI)) > 1;


// @property canvas: Boolean
// `true` when the browser supports [`<canvas>`](https://developer.mozilla.org/docs/Web/API/Canvas_API).
var canvas = (function () {
	return !!document.createElement('canvas').getContext;
}());

// @property svg: Boolean
// `true` when the browser supports [SVG](https://developer.mozilla.org/docs/Web/SVG).
var svg = !!(document.createElementNS && svgCreate('svg').createSVGRect);

// @property vml: Boolean
// `true` if the browser supports [VML](https://en.wikipedia.org/wiki/Vector_Markup_Language).
var vml = !svg && (function () {
	try {
		var div = document.createElement('div');
		div.innerHTML = '<v:shape adj="1"/>';

		var shape = div.firstChild;
		shape.style.behavior = 'url(#default#VML)';

		return shape && (typeof shape.adj === 'object');

	} catch (e) {
		return false;
	}
}());


function userAgentContains(str) {
	return navigator.userAgent.toLowerCase().indexOf(str) >= 0;
}


var Browser = (Object.freeze || Object)({
	ie: ie,
	ielt9: ielt9,
	edge: edge,
	webkit: webkit,
	android: android,
	android23: android23,
	opera: opera,
	chrome: chrome,
	gecko: gecko,
	safari: safari,
	phantom: phantom,
	opera12: opera12,
	win: win,
	ie3d: ie3d,
	webkit3d: webkit3d,
	gecko3d: gecko3d,
	any3d: any3d,
	mobile: mobile,
	mobileWebkit: mobileWebkit,
	mobileWebkit3d: mobileWebkit3d,
	msPointer: msPointer,
	pointer: pointer,
	touch: touch,
	mobileOpera: mobileOpera,
	mobileGecko: mobileGecko,
	retina: retina,
	canvas: canvas,
	svg: svg,
	vml: vml
});

/*
 * Extends L.DomEvent to provide touch support for Internet Explorer and Windows-based devices.
 */


var POINTER_DOWN =   msPointer ? 'MSPointerDown'   : 'pointerdown';
var POINTER_MOVE =   msPointer ? 'MSPointerMove'   : 'pointermove';
var POINTER_UP =     msPointer ? 'MSPointerUp'     : 'pointerup';
var POINTER_CANCEL = msPointer ? 'MSPointerCancel' : 'pointercancel';
var TAG_WHITE_LIST = ['INPUT', 'SELECT', 'OPTION'];
var _pointers = {};
var _pointerDocListener = false;

// DomEvent.DoubleTap needs to know about this
var _pointersCount = 0;

// Provides a touch events wrapper for (ms)pointer events.
// ref http://www.w3.org/TR/pointerevents/ https://www.w3.org/Bugs/Public/show_bug.cgi?id=22890

function addPointerListener(obj, type, handler, id) {
	if (type === 'touchstart') {
		_addPointerStart(obj, handler, id);

	} else if (type === 'touchmove') {
		_addPointerMove(obj, handler, id);

	} else if (type === 'touchend') {
		_addPointerEnd(obj, handler, id);
	}

	return this;
}

function removePointerListener(obj, type, id) {
	var handler = obj['_leaflet_' + type + id];

	if (type === 'touchstart') {
		obj.removeEventListener(POINTER_DOWN, handler, false);

	} else if (type === 'touchmove') {
		obj.removeEventListener(POINTER_MOVE, handler, false);

	} else if (type === 'touchend') {
		obj.removeEventListener(POINTER_UP, handler, false);
		obj.removeEventListener(POINTER_CANCEL, handler, false);
	}

	return this;
}

function _addPointerStart(obj, handler, id) {
	var onDown = bind(function (e) {
		if (e.pointerType !== 'mouse' && e.pointerType !== e.MSPOINTER_TYPE_MOUSE && e.pointerType !== e.MSPOINTER_TYPE_MOUSE) {
			// In IE11, some touch events needs to fire for form controls, or
			// the controls will stop working. We keep a whitelist of tag names that
			// need these events. For other target tags, we prevent default on the event.
			if (TAG_WHITE_LIST.indexOf(e.target.tagName) < 0) {
				preventDefault(e);
			} else {
				return;
			}
		}

		_handlePointer(e, handler);
	});

	obj['_leaflet_touchstart' + id] = onDown;
	obj.addEventListener(POINTER_DOWN, onDown, false);

	// need to keep track of what pointers and how many are active to provide e.touches emulation
	if (!_pointerDocListener) {
		// we listen documentElement as any drags that end by moving the touch off the screen get fired there
		document.documentElement.addEventListener(POINTER_DOWN, _globalPointerDown, true);
		document.documentElement.addEventListener(POINTER_MOVE, _globalPointerMove, true);
		document.documentElement.addEventListener(POINTER_UP, _globalPointerUp, true);
		document.documentElement.addEventListener(POINTER_CANCEL, _globalPointerUp, true);

		_pointerDocListener = true;
	}
}

function _globalPointerDown(e) {
	_pointers[e.pointerId] = e;
	_pointersCount++;
}

function _globalPointerMove(e) {
	if (_pointers[e.pointerId]) {
		_pointers[e.pointerId] = e;
	}
}

function _globalPointerUp(e) {
	delete _pointers[e.pointerId];
	_pointersCount--;
}

function _handlePointer(e, handler) {
	e.touches = [];
	for (var i in _pointers) {
		e.touches.push(_pointers[i]);
	}
	e.changedTouches = [e];

	handler(e);
}

function _addPointerMove(obj, handler, id) {
	var onMove = function (e) {
		// don't fire touch moves when mouse isn't down
		if ((e.pointerType === e.MSPOINTER_TYPE_MOUSE || e.pointerType === 'mouse') && e.buttons === 0) { return; }

		_handlePointer(e, handler);
	};

	obj['_leaflet_touchmove' + id] = onMove;
	obj.addEventListener(POINTER_MOVE, onMove, false);
}

function _addPointerEnd(obj, handler, id) {
	var onUp = function (e) {
		_handlePointer(e, handler);
	};

	obj['_leaflet_touchend' + id] = onUp;
	obj.addEventListener(POINTER_UP, onUp, false);
	obj.addEventListener(POINTER_CANCEL, onUp, false);
}

/*
 * Extends the event handling code with double tap support for mobile browsers.
 */

var _touchstart = msPointer ? 'MSPointerDown' : pointer ? 'pointerdown' : 'touchstart';
var _touchend = msPointer ? 'MSPointerUp' : pointer ? 'pointerup' : 'touchend';
var _pre = '_leaflet_';

// inspired by Zepto touch code by Thomas Fuchs
function addDoubleTapListener(obj, handler, id) {
	var last, touch$$1,
	    doubleTap = false,
	    delay = 250;

	function onTouchStart(e) {
		var count;

		if (pointer) {
			if ((!edge) || e.pointerType === 'mouse') { return; }
			count = _pointersCount;
		} else {
			count = e.touches.length;
		}

		if (count > 1) { return; }

		var now = Date.now(),
		    delta = now - (last || now);

		touch$$1 = e.touches ? e.touches[0] : e;
		doubleTap = (delta > 0 && delta <= delay);
		last = now;
	}

	function onTouchEnd(e) {
		if (doubleTap && !touch$$1.cancelBubble) {
			if (pointer) {
				if ((!edge) || e.pointerType === 'mouse') { return; }
				// work around .type being readonly with MSPointer* events
				var newTouch = {},
				    prop, i;

				for (i in touch$$1) {
					prop = touch$$1[i];
					newTouch[i] = prop && prop.bind ? prop.bind(touch$$1) : prop;
				}
				touch$$1 = newTouch;
			}
			touch$$1.type = 'dblclick';
			handler(touch$$1);
			last = null;
		}
	}

	obj[_pre + _touchstart + id] = onTouchStart;
	obj[_pre + _touchend + id] = onTouchEnd;
	obj[_pre + 'dblclick' + id] = handler;

	obj.addEventListener(_touchstart, onTouchStart, false);
	obj.addEventListener(_touchend, onTouchEnd, false);

	// On some platforms (notably, chrome<55 on win10 + touchscreen + mouse),
	// the browser doesn't fire touchend/pointerup events but does fire
	// native dblclicks. See #4127.
	// Edge 14 also fires native dblclicks, but only for pointerType mouse, see #5180.
	obj.addEventListener('dblclick', handler, false);

	return this;
}

function removeDoubleTapListener(obj, id) {
	var touchstart = obj[_pre + _touchstart + id],
	    touchend = obj[_pre + _touchend + id],
	    dblclick = obj[_pre + 'dblclick' + id];

	obj.removeEventListener(_touchstart, touchstart, false);
	obj.removeEventListener(_touchend, touchend, false);
	if (!edge) {
		obj.removeEventListener('dblclick', dblclick, false);
	}

	return this;
}

/*
 * @namespace DomEvent
 * Utility functions to work with the [DOM events](https://developer.mozilla.org/docs/Web/API/Event), used by Leaflet internally.
 */

// Inspired by John Resig, Dean Edwards and YUI addEvent implementations.

// @function on(el: HTMLElement, types: String, fn: Function, context?: Object): this
// Adds a listener function (`fn`) to a particular DOM event type of the
// element `el`. You can optionally specify the context of the listener
// (object the `this` keyword will point to). You can also pass several
// space-separated types (e.g. `'click dblclick'`).

// @alternative
// @function on(el: HTMLElement, eventMap: Object, context?: Object): this
// Adds a set of type/listener pairs, e.g. `{click: onClick, mousemove: onMouseMove}`
function on(obj, types, fn, context) {

	if (typeof types === 'object') {
		for (var type in types) {
			addOne(obj, type, types[type], fn);
		}
	} else {
		types = splitWords(types);

		for (var i = 0, len = types.length; i < len; i++) {
			addOne(obj, types[i], fn, context);
		}
	}

	return this;
}

var eventsKey = '_leaflet_events';

// @function off(el: HTMLElement, types: String, fn: Function, context?: Object): this
// Removes a previously added listener function. If no function is specified,
// it will remove all the listeners of that particular DOM event from the element.
// Note that if you passed a custom context to on, you must pass the same
// context to `off` in order to remove the listener.

// @alternative
// @function off(el: HTMLElement, eventMap: Object, context?: Object): this
// Removes a set of type/listener pairs, e.g. `{click: onClick, mousemove: onMouseMove}`

// @alternative
// @function off(el: HTMLElement): this
// Removes all known event listeners
function off(obj, types, fn, context) {

	if (typeof types === 'object') {
		for (var type in types) {
			removeOne(obj, type, types[type], fn);
		}
	} else if (types) {
		types = splitWords(types);

		for (var i = 0, len = types.length; i < len; i++) {
			removeOne(obj, types[i], fn, context);
		}
	} else {
		for (var j in obj[eventsKey]) {
			removeOne(obj, j, obj[eventsKey][j]);
		}
		delete obj[eventsKey];
	}

	return this;
}

function addOne(obj, type, fn, context) {
	var id = type + stamp(fn) + (context ? '_' + stamp(context) : '');

	if (obj[eventsKey] && obj[eventsKey][id]) { return this; }

	var handler = function (e) {
		return fn.call(context || obj, e || window.event);
	};

	var originalHandler = handler;

	if (pointer && type.indexOf('touch') === 0) {
		// Needs DomEvent.Pointer.js
		addPointerListener(obj, type, handler, id);

	} else if (touch && (type === 'dblclick') && addDoubleTapListener &&
	           !(pointer && chrome)) {
		// Chrome >55 does not need the synthetic dblclicks from addDoubleTapListener
		// See #5180
		addDoubleTapListener(obj, handler, id);

	} else if ('addEventListener' in obj) {

		if (type === 'mousewheel') {
			obj.addEventListener('onwheel' in obj ? 'wheel' : 'mousewheel', handler, false);

		} else if ((type === 'mouseenter') || (type === 'mouseleave')) {
			handler = function (e) {
				e = e || window.event;
				if (isExternalTarget(obj, e)) {
					originalHandler(e);
				}
			};
			obj.addEventListener(type === 'mouseenter' ? 'mouseover' : 'mouseout', handler, false);

		} else {
			if (type === 'click' && android) {
				handler = function (e) {
					filterClick(e, originalHandler);
				};
			}
			obj.addEventListener(type, handler, false);
		}

	} else if ('attachEvent' in obj) {
		obj.attachEvent('on' + type, handler);
	}

	obj[eventsKey] = obj[eventsKey] || {};
	obj[eventsKey][id] = handler;
}

function removeOne(obj, type, fn, context) {

	var id = type + stamp(fn) + (context ? '_' + stamp(context) : ''),
	    handler = obj[eventsKey] && obj[eventsKey][id];

	if (!handler) { return this; }

	if (pointer && type.indexOf('touch') === 0) {
		removePointerListener(obj, type, id);

	} else if (touch && (type === 'dblclick') && removeDoubleTapListener) {
		removeDoubleTapListener(obj, id);

	} else if ('removeEventListener' in obj) {

		if (type === 'mousewheel') {
			obj.removeEventListener('onwheel' in obj ? 'wheel' : 'mousewheel', handler, false);

		} else {
			obj.removeEventListener(
				type === 'mouseenter' ? 'mouseover' :
				type === 'mouseleave' ? 'mouseout' : type, handler, false);
		}

	} else if ('detachEvent' in obj) {
		obj.detachEvent('on' + type, handler);
	}

	obj[eventsKey][id] = null;
}

// @function stopPropagation(ev: DOMEvent): this
// Stop the given event from propagation to parent elements. Used inside the listener functions:
// ```js
// L.DomEvent.on(div, 'click', function (ev) {
// 	L.DomEvent.stopPropagation(ev);
// });
// ```
function stopPropagation(e) {

	if (e.stopPropagation) {
		e.stopPropagation();
	} else if (e.originalEvent) {  // In case of Leaflet event.
		e.originalEvent._stopped = true;
	} else {
		e.cancelBubble = true;
	}
	skipped(e);

	return this;
}

// @function disableScrollPropagation(el: HTMLElement): this
// Adds `stopPropagation` to the element's `'mousewheel'` events (plus browser variants).
function disableScrollPropagation(el) {
	addOne(el, 'mousewheel', stopPropagation);
	return this;
}

// @function disableClickPropagation(el: HTMLElement): this
// Adds `stopPropagation` to the element's `'click'`, `'doubleclick'`,
// `'mousedown'` and `'touchstart'` events (plus browser variants).
function disableClickPropagation(el) {
	on(el, 'mousedown touchstart dblclick', stopPropagation);
	addOne(el, 'click', fakeStop);
	return this;
}

// @function preventDefault(ev: DOMEvent): this
// Prevents the default action of the DOM Event `ev` from happening (such as
// following a link in the href of the a element, or doing a POST request
// with page reload when a `<form>` is submitted).
// Use it inside listener functions.
function preventDefault(e) {
	if (e.preventDefault) {
		e.preventDefault();
	} else {
		e.returnValue = false;
	}
	return this;
}

// @function stop(ev): this
// Does `stopPropagation` and `preventDefault` at the same time.
function stop(e) {
	preventDefault(e);
	stopPropagation(e);
	return this;
}

// @function getMousePosition(ev: DOMEvent, container?: HTMLElement): Point
// Gets normalized mouse position from a DOM event relative to the
// `container` or to the whole page if not specified.
function getMousePosition(e, container) {
	if (!container) {
		return new Point(e.clientX, e.clientY);
	}

	var rect = container.getBoundingClientRect();

	return new Point(
		e.clientX - rect.left - container.clientLeft,
		e.clientY - rect.top - container.clientTop);
}

// Chrome on Win scrolls double the pixels as in other platforms (see #4538),
// and Firefox scrolls device pixels, not CSS pixels
var wheelPxFactor =
	(win && chrome) ? 2 * window.devicePixelRatio :
	gecko ? window.devicePixelRatio : 1;

// @function getWheelDelta(ev: DOMEvent): Number
// Gets normalized wheel delta from a mousewheel DOM event, in vertical
// pixels scrolled (negative if scrolling down).
// Events from pointing devices without precise scrolling are mapped to
// a best guess of 60 pixels.
function getWheelDelta(e) {
	return (edge) ? e.wheelDeltaY / 2 : // Don't trust window-geometry-based delta
	       (e.deltaY && e.deltaMode === 0) ? -e.deltaY / wheelPxFactor : // Pixels
	       (e.deltaY && e.deltaMode === 1) ? -e.deltaY * 20 : // Lines
	       (e.deltaY && e.deltaMode === 2) ? -e.deltaY * 60 : // Pages
	       (e.deltaX || e.deltaZ) ? 0 :	// Skip horizontal/depth wheel events
	       e.wheelDelta ? (e.wheelDeltaY || e.wheelDelta) / 2 : // Legacy IE pixels
	       (e.detail && Math.abs(e.detail) < 32765) ? -e.detail * 20 : // Legacy Moz lines
	       e.detail ? e.detail / -32765 * 60 : // Legacy Moz pages
	       0;
}

var skipEvents = {};

function fakeStop(e) {
	// fakes stopPropagation by setting a special event flag, checked/reset with skipped(e)
	skipEvents[e.type] = true;
}

function skipped(e) {
	var events = skipEvents[e.type];
	// reset when checking, as it's only used in map container and propagates outside of the map
	skipEvents[e.type] = false;
	return events;
}

// check if element really left/entered the event target (for mouseenter/mouseleave)
function isExternalTarget(el, e) {

	var related = e.relatedTarget;

	if (!related) { return true; }

	try {
		while (related && (related !== el)) {
			related = related.parentNode;
		}
	} catch (err) {
		return false;
	}
	return (related !== el);
}

var lastClick;

// this is a horrible workaround for a bug in Android where a single touch triggers two click events
function filterClick(e, handler) {
	var timeStamp = (e.timeStamp || (e.originalEvent && e.originalEvent.timeStamp)),
	    elapsed = lastClick && (timeStamp - lastClick);

	// are they closer together than 500ms yet more than 100ms?
	// Android typically triggers them ~300ms apart while multiple listeners
	// on the same event should be triggered far faster;
	// or check if click is simulated on the element, and if it is, reject any non-simulated events

	if ((elapsed && elapsed > 100 && elapsed < 500) || (e.target._simulatedClick && !e._simulated)) {
		stop(e);
		return;
	}
	lastClick = timeStamp;

	handler(e);
}




var DomEvent = (Object.freeze || Object)({
	on: on,
	off: off,
	stopPropagation: stopPropagation,
	disableScrollPropagation: disableScrollPropagation,
	disableClickPropagation: disableClickPropagation,
	preventDefault: preventDefault,
	stop: stop,
	getMousePosition: getMousePosition,
	getWheelDelta: getWheelDelta,
	fakeStop: fakeStop,
	skipped: skipped,
	isExternalTarget: isExternalTarget,
	addListener: on,
	removeListener: off
});

/*
 * @namespace DomUtil
 *
 * Utility functions to work with the [DOM](https://developer.mozilla.org/docs/Web/API/Document_Object_Model)
 * tree, used by Leaflet internally.
 *
 * Most functions expecting or returning a `HTMLElement` also work for
 * SVG elements. The only difference is that classes refer to CSS classes
 * in HTML and SVG classes in SVG.
 */


// @property TRANSFORM: String
// Vendor-prefixed transform style name (e.g. `'webkitTransform'` for WebKit).
var TRANSFORM = testProp(
	['transform', 'WebkitTransform', 'OTransform', 'MozTransform', 'msTransform']);

// webkitTransition comes first because some browser versions that drop vendor prefix don't do
// the same for the transitionend event, in particular the Android 4.1 stock browser

// @property TRANSITION: String
// Vendor-prefixed transition style name.
var TRANSITION = testProp(
	['webkitTransition', 'transition', 'OTransition', 'MozTransition', 'msTransition']);

// @property TRANSITION_END: String
// Vendor-prefixed transitionend event name.
var TRANSITION_END =
	TRANSITION === 'webkitTransition' || TRANSITION === 'OTransition' ? TRANSITION + 'End' : 'transitionend';


// @function get(id: String|HTMLElement): HTMLElement
// Returns an element given its DOM id, or returns the element itself
// if it was passed directly.
function get(id) {
	return typeof id === 'string' ? document.getElementById(id) : id;
}

// @function getStyle(el: HTMLElement, styleAttrib: String): String
// Returns the value for a certain style attribute on an element,
// including computed values or values set through CSS.
function getStyle(el, style) {
	var value = el.style[style] || (el.currentStyle && el.currentStyle[style]);

	if ((!value || value === 'auto') && document.defaultView) {
		var css = document.defaultView.getComputedStyle(el, null);
		value = css ? css[style] : null;
	}
	return value === 'auto' ? null : value;
}

// @function create(tagName: String, className?: String, container?: HTMLElement): HTMLElement
// Creates an HTML element with `tagName`, sets its class to `className`, and optionally appends it to `container` element.
function create$1(tagName, className, container) {
	var el = document.createElement(tagName);
	el.className = className || '';

	if (container) {
		container.appendChild(el);
	}
	return el;
}

// @function remove(el: HTMLElement)
// Removes `el` from its parent element
function remove(el) {
	var parent = el.parentNode;
	if (parent) {
		parent.removeChild(el);
	}
}

// @function empty(el: HTMLElement)
// Removes all of `el`'s children elements from `el`
function empty(el) {
	while (el.firstChild) {
		el.removeChild(el.firstChild);
	}
}

// @function toFront(el: HTMLElement)
// Makes `el` the last child of its parent, so it renders in front of the other children.
function toFront(el) {
	var parent = el.parentNode;
	if (parent.lastChild !== el) {
		parent.appendChild(el);
	}
}

// @function toBack(el: HTMLElement)
// Makes `el` the first child of its parent, so it renders behind the other children.
function toBack(el) {
	var parent = el.parentNode;
	if (parent.firstChild !== el) {
		parent.insertBefore(el, parent.firstChild);
	}
}

// @function hasClass(el: HTMLElement, name: String): Boolean
// Returns `true` if the element's class attribute contains `name`.
function hasClass(el, name) {
	if (el.classList !== undefined) {
		return el.classList.contains(name);
	}
	var className = getClass(el);
	return className.length > 0 && new RegExp('(^|\\s)' + name + '(\\s|$)').test(className);
}

// @function addClass(el: HTMLElement, name: String)
// Adds `name` to the element's class attribute.
function addClass(el, name) {
	if (el.classList !== undefined) {
		var classes = splitWords(name);
		for (var i = 0, len = classes.length; i < len; i++) {
			el.classList.add(classes[i]);
		}
	} else if (!hasClass(el, name)) {
		var className = getClass(el);
		setClass(el, (className ? className + ' ' : '') + name);
	}
}

// @function removeClass(el: HTMLElement, name: String)
// Removes `name` from the element's class attribute.
function removeClass(el, name) {
	if (el.classList !== undefined) {
		el.classList.remove(name);
	} else {
		setClass(el, trim((' ' + getClass(el) + ' ').replace(' ' + name + ' ', ' ')));
	}
}

// @function setClass(el: HTMLElement, name: String)
// Sets the element's class.
function setClass(el, name) {
	if (el.className.baseVal === undefined) {
		el.className = name;
	} else {
		// in case of SVG element
		el.className.baseVal = name;
	}
}

// @function getClass(el: HTMLElement): String
// Returns the element's class.
function getClass(el) {
	return el.className.baseVal === undefined ? el.className : el.className.baseVal;
}

// @function setOpacity(el: HTMLElement, opacity: Number)
// Set the opacity of an element (including old IE support).
// `opacity` must be a number from `0` to `1`.
function setOpacity(el, value) {
	if ('opacity' in el.style) {
		el.style.opacity = value;
	} else if ('filter' in el.style) {
		_setOpacityIE(el, value);
	}
}

function _setOpacityIE(el, value) {
	var filter = false,
	    filterName = 'DXImageTransform.Microsoft.Alpha';

	// filters collection throws an error if we try to retrieve a filter that doesn't exist
	try {
		filter = el.filters.item(filterName);
	} catch (e) {
		// don't set opacity to 1 if we haven't already set an opacity,
		// it isn't needed and breaks transparent pngs.
		if (value === 1) { return; }
	}

	value = Math.round(value * 100);

	if (filter) {
		filter.Enabled = (value !== 100);
		filter.Opacity = value;
	} else {
		el.style.filter += ' progid:' + filterName + '(opacity=' + value + ')';
	}
}

// @function testProp(props: String[]): String|false
// Goes through the array of style names and returns the first name
// that is a valid style name for an element. If no such name is found,
// it returns false. Useful for vendor-prefixed styles like `transform`.
function testProp(props) {
	var style = document.documentElement.style;

	for (var i = 0; i < props.length; i++) {
		if (props[i] in style) {
			return props[i];
		}
	}
	return false;
}

// @function setTransform(el: HTMLElement, offset: Point, scale?: Number)
// Resets the 3D CSS transform of `el` so it is translated by `offset` pixels
// and optionally scaled by `scale`. Does not have an effect if the
// browser doesn't support 3D CSS transforms.
function setTransform(el, offset, scale) {
	var pos = offset || new Point(0, 0);

	el.style[TRANSFORM] =
		(ie3d ?
			'translate(' + pos.x + 'px,' + pos.y + 'px)' :
			'translate3d(' + pos.x + 'px,' + pos.y + 'px,0)') +
		(scale ? ' scale(' + scale + ')' : '');
}

// @function setPosition(el: HTMLElement, position: Point)
// Sets the position of `el` to coordinates specified by `position`,
// using CSS translate or top/left positioning depending on the browser
// (used by Leaflet internally to position its layers).
function setPosition(el, point) {

	/*eslint-disable */
	el._leaflet_pos = point;
	/*eslint-enable */

	if (any3d) {
		setTransform(el, point);
	} else {
		el.style.left = point.x + 'px';
		el.style.top = point.y + 'px';
	}
}

// @function getPosition(el: HTMLElement): Point
// Returns the coordinates of an element previously positioned with setPosition.
function getPosition(el) {
	// this method is only used for elements previously positioned using setPosition,
	// so it's safe to cache the position for performance

	return el._leaflet_pos || new Point(0, 0);
}

// @function disableTextSelection()
// Prevents the user from generating `selectstart` DOM events, usually generated
// when the user drags the mouse through a page with text. Used internally
// by Leaflet to override the behaviour of any click-and-drag interaction on
// the map. Affects drag interactions on the whole document.

// @function enableTextSelection()
// Cancels the effects of a previous [`L.DomUtil.disableTextSelection`](#domutil-disabletextselection).
var disableTextSelection;
var enableTextSelection;
var _userSelect;
if ('onselectstart' in document) {
	disableTextSelection = function () {
		on(window, 'selectstart', preventDefault);
	};
	enableTextSelection = function () {
		off(window, 'selectstart', preventDefault);
	};
} else {
	var userSelectProperty = testProp(
		['userSelect', 'WebkitUserSelect', 'OUserSelect', 'MozUserSelect', 'msUserSelect']);

	disableTextSelection = function () {
		if (userSelectProperty) {
			var style = document.documentElement.style;
			_userSelect = style[userSelectProperty];
			style[userSelectProperty] = 'none';
		}
	};
	enableTextSelection = function () {
		if (userSelectProperty) {
			document.documentElement.style[userSelectProperty] = _userSelect;
			_userSelect = undefined;
		}
	};
}

// @function disableImageDrag()
// As [`L.DomUtil.disableTextSelection`](#domutil-disabletextselection), but
// for `dragstart` DOM events, usually generated when the user drags an image.
function disableImageDrag() {
	on(window, 'dragstart', preventDefault);
}

// @function enableImageDrag()
// Cancels the effects of a previous [`L.DomUtil.disableImageDrag`](#domutil-disabletextselection).
function enableImageDrag() {
	off(window, 'dragstart', preventDefault);
}

var _outlineElement;
var _outlineStyle;
// @function preventOutline(el: HTMLElement)
// Makes the [outline](https://developer.mozilla.org/docs/Web/CSS/outline)
// of the element `el` invisible. Used internally by Leaflet to prevent
// focusable elements from displaying an outline when the user performs a
// drag interaction on them.
function preventOutline(element) {
	while (element.tabIndex === -1) {
		element = element.parentNode;
	}
	if (!element.style) { return; }
	restoreOutline();
	_outlineElement = element;
	_outlineStyle = element.style.outline;
	element.style.outline = 'none';
	on(window, 'keydown', restoreOutline);
}

// @function restoreOutline()
// Cancels the effects of a previous [`L.DomUtil.preventOutline`]().
function restoreOutline() {
	if (!_outlineElement) { return; }
	_outlineElement.style.outline = _outlineStyle;
	_outlineElement = undefined;
	_outlineStyle = undefined;
	off(window, 'keydown', restoreOutline);
}


var DomUtil = (Object.freeze || Object)({
	TRANSFORM: TRANSFORM,
	TRANSITION: TRANSITION,
	TRANSITION_END: TRANSITION_END,
	get: get,
	getStyle: getStyle,
	create: create$1,
	remove: remove,
	empty: empty,
	toFront: toFront,
	toBack: toBack,
	hasClass: hasClass,
	addClass: addClass,
	removeClass: removeClass,
	setClass: setClass,
	getClass: getClass,
	setOpacity: setOpacity,
	testProp: testProp,
	setTransform: setTransform,
	setPosition: setPosition,
	getPosition: getPosition,
	disableTextSelection: disableTextSelection,
	enableTextSelection: enableTextSelection,
	disableImageDrag: disableImageDrag,
	enableImageDrag: enableImageDrag,
	preventOutline: preventOutline,
	restoreOutline: restoreOutline
});

/*
 * @class PosAnimation
 * @aka L.PosAnimation
 * @inherits Evented
 * Used internally for panning animations, utilizing CSS3 Transitions for modern browsers and a timer fallback for IE6-9.
 *
 * @example
 * ```js
 * var fx = new L.PosAnimation();
 * fx.run(el, [300, 500], 0.5);
 * ```
 *
 * @constructor L.PosAnimation()
 * Creates a `PosAnimation` object.
 *
 */

var PosAnimation = Evented.extend({

	// @method run(el: HTMLElement, newPos: Point, duration?: Number, easeLinearity?: Number)
	// Run an animation of a given element to a new position, optionally setting
	// duration in seconds (`0.25` by default) and easing linearity factor (3rd
	// argument of the [cubic bezier curve](http://cubic-bezier.com/#0,0,.5,1),
	// `0.5` by default).
	run: function (el, newPos, duration, easeLinearity) {
		this.stop();

		this._el = el;
		this._inProgress = true;
		this._duration = duration || 0.25;
		this._easeOutPower = 1 / Math.max(easeLinearity || 0.5, 0.2);

		this._startPos = getPosition(el);
		this._offset = newPos.subtract(this._startPos);
		this._startTime = +new Date();

		// @event start: Event
		// Fired when the animation starts
		this.fire('start');

		this._animate();
	},

	// @method stop()
	// Stops the animation (if currently running).
	stop: function () {
		if (!this._inProgress) { return; }

		this._step(true);
		this._complete();
	},

	_animate: function () {
		// animation loop
		this._animId = requestAnimFrame(this._animate, this);
		this._step();
	},

	_step: function (round) {
		var elapsed = (+new Date()) - this._startTime,
		    duration = this._duration * 1000;

		if (elapsed < duration) {
			this._runFrame(this._easeOut(elapsed / duration), round);
		} else {
			this._runFrame(1);
			this._complete();
		}
	},

	_runFrame: function (progress, round) {
		var pos = this._startPos.add(this._offset.multiplyBy(progress));
		if (round) {
			pos._round();
		}
		setPosition(this._el, pos);

		// @event step: Event
		// Fired continuously during the animation.
		this.fire('step');
	},

	_complete: function () {
		cancelAnimFrame(this._animId);

		this._inProgress = false;
		// @event end: Event
		// Fired when the animation ends.
		this.fire('end');
	},

	_easeOut: function (t) {
		return 1 - Math.pow(1 - t, this._easeOutPower);
	}
});

/*
 * @class Map
 * @aka L.Map
 * @inherits Evented
 *
 * The central class of the API — it is used to create a map on a page and manipulate it.
 *
 * @example
 *
 * ```js
 * // initialize the map on the "map" div with a given center and zoom
 * var map = L.map('map', {
 * 	center: [51.505, -0.09],
 * 	zoom: 13
 * });
 * ```
 *
 */

var Map = Evented.extend({

	options: {
		// @section Map State Options
		// @option crs: CRS = L.CRS.EPSG3857
		// The [Coordinate Reference System](#crs) to use. Don't change this if you're not
		// sure what it means.
		crs: EPSG3857,

		// @option center: LatLng = undefined
		// Initial geographic center of the map
		center: undefined,

		// @option zoom: Number = undefined
		// Initial map zoom level
		zoom: undefined,

		// @option minZoom: Number = *
		// Minimum zoom level of the map.
		// If not specified and at least one `GridLayer` or `TileLayer` is in the map,
		// the lowest of their `minZoom` options will be used instead.
		minZoom: undefined,

		// @option maxZoom: Number = *
		// Maximum zoom level of the map.
		// If not specified and at least one `GridLayer` or `TileLayer` is in the map,
		// the highest of their `maxZoom` options will be used instead.
		maxZoom: undefined,

		// @option layers: Layer[] = []
		// Array of layers that will be added to the map initially
		layers: [],

		// @option maxBounds: LatLngBounds = null
		// When this option is set, the map restricts the view to the given
		// geographical bounds, bouncing the user back if the user tries to pan
		// outside the view. To set the restriction dynamically, use
		// [`setMaxBounds`](#map-setmaxbounds) method.
		maxBounds: undefined,

		// @option renderer: Renderer = *
		// The default method for drawing vector layers on the map. `L.SVG`
		// or `L.Canvas` by default depending on browser support.
		renderer: undefined,


		// @section Animation Options
		// @option zoomAnimation: Boolean = true
		// Whether the map zoom animation is enabled. By default it's enabled
		// in all browsers that support CSS3 Transitions except Android.
		zoomAnimation: true,

		// @option zoomAnimationThreshold: Number = 4
		// Won't animate zoom if the zoom difference exceeds this value.
		zoomAnimationThreshold: 4,

		// @option fadeAnimation: Boolean = true
		// Whether the tile fade animation is enabled. By default it's enabled
		// in all browsers that support CSS3 Transitions except Android.
		fadeAnimation: true,

		// @option markerZoomAnimation: Boolean = true
		// Whether markers animate their zoom with the zoom animation, if disabled
		// they will disappear for the length of the animation. By default it's
		// enabled in all browsers that support CSS3 Transitions except Android.
		markerZoomAnimation: true,

		// @option transform3DLimit: Number = 2^23
		// Defines the maximum size of a CSS translation transform. The default
		// value should not be changed unless a web browser positions layers in
		// the wrong place after doing a large `panBy`.
		transform3DLimit: 8388608, // Precision limit of a 32-bit float

		// @section Interaction Options
		// @option zoomSnap: Number = 1
		// Forces the map's zoom level to always be a multiple of this, particularly
		// right after a [`fitBounds()`](#map-fitbounds) or a pinch-zoom.
		// By default, the zoom level snaps to the nearest integer; lower values
		// (e.g. `0.5` or `0.1`) allow for greater granularity. A value of `0`
		// means the zoom level will not be snapped after `fitBounds` or a pinch-zoom.
		zoomSnap: 1,

		// @option zoomDelta: Number = 1
		// Controls how much the map's zoom level will change after a
		// [`zoomIn()`](#map-zoomin), [`zoomOut()`](#map-zoomout), pressing `+`
		// or `-` on the keyboard, or using the [zoom controls](#control-zoom).
		// Values smaller than `1` (e.g. `0.5`) allow for greater granularity.
		zoomDelta: 1,

		// @option trackResize: Boolean = true
		// Whether the map automatically handles browser window resize to update itself.
		trackResize: true
	},

	initialize: function (id, options) { // (HTMLElement or String, Object)
		options = setOptions(this, options);

		this._initContainer(id);
		this._initLayout();

		// hack for https://github.com/Leaflet/Leaflet/issues/1980
		this._onResize = bind(this._onResize, this);

		this._initEvents();

		if (options.maxBounds) {
			this.setMaxBounds(options.maxBounds);
		}

		if (options.zoom !== undefined) {
			this._zoom = this._limitZoom(options.zoom);
		}

		if (options.center && options.zoom !== undefined) {
			this.setView(toLatLng(options.center), options.zoom, {reset: true});
		}

		this._handlers = [];
		this._layers = {};
		this._zoomBoundLayers = {};
		this._sizeChanged = true;

		this.callInitHooks();

		// don't animate on browsers without hardware-accelerated transitions or old Android/Opera
		this._zoomAnimated = TRANSITION && any3d && !mobileOpera &&
				this.options.zoomAnimation;

		// zoom transitions run with the same duration for all layers, so if one of transitionend events
		// happens after starting zoom animation (propagating to the map pane), we know that it ended globally
		if (this._zoomAnimated) {
			this._createAnimProxy();
			on(this._proxy, TRANSITION_END, this._catchTransitionEnd, this);
		}

		this._addLayers(this.options.layers);
	},


	// @section Methods for modifying map state

	// @method setView(center: LatLng, zoom: Number, options?: Zoom/pan options): this
	// Sets the view of the map (geographical center and zoom) with the given
	// animation options.
	setView: function (center, zoom, options) {

		zoom = zoom === undefined ? this._zoom : this._limitZoom(zoom);
		center = this._limitCenter(toLatLng(center), zoom, this.options.maxBounds);
		options = options || {};

		this._stop();

		if (this._loaded && !options.reset && options !== true) {

			if (options.animate !== undefined) {
				options.zoom = extend({animate: options.animate}, options.zoom);
				options.pan = extend({animate: options.animate, duration: options.duration}, options.pan);
			}

			// try animating pan or zoom
			var moved = (this._zoom !== zoom) ?
				this._tryAnimatedZoom && this._tryAnimatedZoom(center, zoom, options.zoom) :
				this._tryAnimatedPan(center, options.pan);

			if (moved) {
				// prevent resize handler call, the view will refresh after animation anyway
				clearTimeout(this._sizeTimer);
				return this;
			}
		}

		// animation didn't start, just reset the map view
		this._resetView(center, zoom);

		return this;
	},

	// @method setZoom(zoom: Number, options?: Zoom/pan options): this
	// Sets the zoom of the map.
	setZoom: function (zoom, options) {
		if (!this._loaded) {
			this._zoom = zoom;
			return this;
		}
		return this.setView(this.getCenter(), zoom, {zoom: options});
	},

	// @method zoomIn(delta?: Number, options?: Zoom options): this
	// Increases the zoom of the map by `delta` ([`zoomDelta`](#map-zoomdelta) by default).
	zoomIn: function (delta, options) {
		delta = delta || (any3d ? this.options.zoomDelta : 1);
		return this.setZoom(this._zoom + delta, options);
	},

	// @method zoomOut(delta?: Number, options?: Zoom options): this
	// Decreases the zoom of the map by `delta` ([`zoomDelta`](#map-zoomdelta) by default).
	zoomOut: function (delta, options) {
		delta = delta || (any3d ? this.options.zoomDelta : 1);
		return this.setZoom(this._zoom - delta, options);
	},

	// @method setZoomAround(latlng: LatLng, zoom: Number, options: Zoom options): this
	// Zooms the map while keeping a specified geographical point on the map
	// stationary (e.g. used internally for scroll zoom and double-click zoom).
	// @alternative
	// @method setZoomAround(offset: Point, zoom: Number, options: Zoom options): this
	// Zooms the map while keeping a specified pixel on the map (relative to the top-left corner) stationary.
	setZoomAround: function (latlng, zoom, options) {
		var scale = this.getZoomScale(zoom),
		    viewHalf = this.getSize().divideBy(2),
		    containerPoint = latlng instanceof Point ? latlng : this.latLngToContainerPoint(latlng),

		    centerOffset = containerPoint.subtract(viewHalf).multiplyBy(1 - 1 / scale),
		    newCenter = this.containerPointToLatLng(viewHalf.add(centerOffset));

		return this.setView(newCenter, zoom, {zoom: options});
	},

	_getBoundsCenterZoom: function (bounds, options) {

		options = options || {};
		bounds = bounds.getBounds ? bounds.getBounds() : toLatLngBounds(bounds);

		var paddingTL = toPoint(options.paddingTopLeft || options.padding || [0, 0]),
		    paddingBR = toPoint(options.paddingBottomRight || options.padding || [0, 0]),

		    zoom = this.getBoundsZoom(bounds, false, paddingTL.add(paddingBR));

		zoom = (typeof options.maxZoom === 'number') ? Math.min(options.maxZoom, zoom) : zoom;

		if (zoom === Infinity) {
			return {
				center: bounds.getCenter(),
				zoom: zoom
			};
		}

		var paddingOffset = paddingBR.subtract(paddingTL).divideBy(2),

		    swPoint = this.project(bounds.getSouthWest(), zoom),
		    nePoint = this.project(bounds.getNorthEast(), zoom),
		    center = this.unproject(swPoint.add(nePoint).divideBy(2).add(paddingOffset), zoom);

		return {
			center: center,
			zoom: zoom
		};
	},

	// @method fitBounds(bounds: LatLngBounds, options?: fitBounds options): this
	// Sets a map view that contains the given geographical bounds with the
	// maximum zoom level possible.
	fitBounds: function (bounds, options) {

		bounds = toLatLngBounds(bounds);

		if (!bounds.isValid()) {
			throw new Error('Bounds are not valid.');
		}

		var target = this._getBoundsCenterZoom(bounds, options);
		return this.setView(target.center, target.zoom, options);
	},

	// @method fitWorld(options?: fitBounds options): this
	// Sets a map view that mostly contains the whole world with the maximum
	// zoom level possible.
	fitWorld: function (options) {
		return this.fitBounds([[-90, -180], [90, 180]], options);
	},

	// @method panTo(latlng: LatLng, options?: Pan options): this
	// Pans the map to a given center.
	panTo: function (center, options) { // (LatLng)
		return this.setView(center, this._zoom, {pan: options});
	},

	// @method panBy(offset: Point, options?: Pan options): this
	// Pans the map by a given number of pixels (animated).
	panBy: function (offset, options) {
		offset = toPoint(offset).round();
		options = options || {};

		if (!offset.x && !offset.y) {
			return this.fire('moveend');
		}
		// If we pan too far, Chrome gets issues with tiles
		// and makes them disappear or appear in the wrong place (slightly offset) #2602
		if (options.animate !== true && !this.getSize().contains(offset)) {
			this._resetView(this.unproject(this.project(this.getCenter()).add(offset)), this.getZoom());
			return this;
		}

		if (!this._panAnim) {
			this._panAnim = new PosAnimation();

			this._panAnim.on({
				'step': this._onPanTransitionStep,
				'end': this._onPanTransitionEnd
			}, this);
		}

		// don't fire movestart if animating inertia
		if (!options.noMoveStart) {
			this.fire('movestart');
		}

		// animate pan unless animate: false specified
		if (options.animate !== false) {
			addClass(this._mapPane, 'leaflet-pan-anim');

			var newPos = this._getMapPanePos().subtract(offset).round();
			this._panAnim.run(this._mapPane, newPos, options.duration || 0.25, options.easeLinearity);
		} else {
			this._rawPanBy(offset);
			this.fire('move').fire('moveend');
		}

		return this;
	},

	// @method flyTo(latlng: LatLng, zoom?: Number, options?: Zoom/pan options): this
	// Sets the view of the map (geographical center and zoom) performing a smooth
	// pan-zoom animation.
	flyTo: function (targetCenter, targetZoom, options) {

		options = options || {};
		if (options.animate === false || !any3d) {
			return this.setView(targetCenter, targetZoom, options);
		}

		this._stop();

		var from = this.project(this.getCenter()),
		    to = this.project(targetCenter),
		    size = this.getSize(),
		    startZoom = this._zoom;

		targetCenter = toLatLng(targetCenter);
		targetZoom = targetZoom === undefined ? startZoom : targetZoom;

		var w0 = Math.max(size.x, size.y),
		    w1 = w0 * this.getZoomScale(startZoom, targetZoom),
		    u1 = (to.distanceTo(from)) || 1,
		    rho = 1.42,
		    rho2 = rho * rho;

		function r(i) {
			var s1 = i ? -1 : 1,
			    s2 = i ? w1 : w0,
			    t1 = w1 * w1 - w0 * w0 + s1 * rho2 * rho2 * u1 * u1,
			    b1 = 2 * s2 * rho2 * u1,
			    b = t1 / b1,
			    sq = Math.sqrt(b * b + 1) - b;

			    // workaround for floating point precision bug when sq = 0, log = -Infinite,
			    // thus triggering an infinite loop in flyTo
			    var log = sq < 0.000000001 ? -18 : Math.log(sq);

			return log;
		}

		function sinh(n) { return (Math.exp(n) - Math.exp(-n)) / 2; }
		function cosh(n) { return (Math.exp(n) + Math.exp(-n)) / 2; }
		function tanh(n) { return sinh(n) / cosh(n); }

		var r0 = r(0);

		function w(s) { return w0 * (cosh(r0) / cosh(r0 + rho * s)); }
		function u(s) { return w0 * (cosh(r0) * tanh(r0 + rho * s) - sinh(r0)) / rho2; }

		function easeOut(t) { return 1 - Math.pow(1 - t, 1.5); }

		var start = Date.now(),
		    S = (r(1) - r0) / rho,
		    duration = options.duration ? 1000 * options.duration : 1000 * S * 0.8;

		function frame() {
			var t = (Date.now() - start) / duration,
			    s = easeOut(t) * S;

			if (t <= 1) {
				this._flyToFrame = requestAnimFrame(frame, this);

				this._move(
					this.unproject(from.add(to.subtract(from).multiplyBy(u(s) / u1)), startZoom),
					this.getScaleZoom(w0 / w(s), startZoom),
					{flyTo: true});

			} else {
				this
					._move(targetCenter, targetZoom)
					._moveEnd(true);
			}
		}

		this._moveStart(true);

		frame.call(this);
		return this;
	},

	// @method flyToBounds(bounds: LatLngBounds, options?: fitBounds options): this
	// Sets the view of the map with a smooth animation like [`flyTo`](#map-flyto),
	// but takes a bounds parameter like [`fitBounds`](#map-fitbounds).
	flyToBounds: function (bounds, options) {
		var target = this._getBoundsCenterZoom(bounds, options);
		return this.flyTo(target.center, target.zoom, options);
	},

	// @method setMaxBounds(bounds: Bounds): this
	// Restricts the map view to the given bounds (see the [maxBounds](#map-maxbounds) option).
	setMaxBounds: function (bounds) {
		bounds = toLatLngBounds(bounds);

		if (!bounds.isValid()) {
			this.options.maxBounds = null;
			return this.off('moveend', this._panInsideMaxBounds);
		} else if (this.options.maxBounds) {
			this.off('moveend', this._panInsideMaxBounds);
		}

		this.options.maxBounds = bounds;

		if (this._loaded) {
			this._panInsideMaxBounds();
		}

		return this.on('moveend', this._panInsideMaxBounds);
	},

	// @method setMinZoom(zoom: Number): this
	// Sets the lower limit for the available zoom levels (see the [minZoom](#map-minzoom) option).
	setMinZoom: function (zoom) {
		this.options.minZoom = zoom;

		if (this._loaded && this.getZoom() < this.options.minZoom) {
			return this.setZoom(zoom);
		}

		return this;
	},

	// @method setMaxZoom(zoom: Number): this
	// Sets the upper limit for the available zoom levels (see the [maxZoom](#map-maxzoom) option).
	setMaxZoom: function (zoom) {
		this.options.maxZoom = zoom;

		if (this._loaded && (this.getZoom() > this.options.maxZoom)) {
			return this.setZoom(zoom);
		}

		return this;
	},

	// @method panInsideBounds(bounds: LatLngBounds, options?: Pan options): this
	// Pans the map to the closest view that would lie inside the given bounds (if it's not already), controlling the animation using the options specific, if any.
	panInsideBounds: function (bounds, options) {
		this._enforcingBounds = true;
		var center = this.getCenter(),
		    newCenter = this._limitCenter(center, this._zoom, toLatLngBounds(bounds));

		if (!center.equals(newCenter)) {
			this.panTo(newCenter, options);
		}

		this._enforcingBounds = false;
		return this;
	},

	// @method invalidateSize(options: Zoom/Pan options): this
	// Checks if the map container size changed and updates the map if so —
	// call it after you've changed the map size dynamically, also animating
	// pan by default. If `options.pan` is `false`, panning will not occur.
	// If `options.debounceMoveend` is `true`, it will delay `moveend` event so
	// that it doesn't happen often even if the method is called many
	// times in a row.

	// @alternative
	// @method invalidateSize(animate: Boolean): this
	// Checks if the map container size changed and updates the map if so —
	// call it after you've changed the map size dynamically, also animating
	// pan by default.
	invalidateSize: function (options) {
		if (!this._loaded) { return this; }

		options = extend({
			animate: false,
			pan: true
		}, options === true ? {animate: true} : options);

		var oldSize = this.getSize();
		this._sizeChanged = true;
		this._lastCenter = null;

		var newSize = this.getSize(),
		    oldCenter = oldSize.divideBy(2).round(),
		    newCenter = newSize.divideBy(2).round(),
		    offset = oldCenter.subtract(newCenter);

		if (!offset.x && !offset.y) { return this; }

		if (options.animate && options.pan) {
			this.panBy(offset);

		} else {
			if (options.pan) {
				this._rawPanBy(offset);
			}

			this.fire('move');

			if (options.debounceMoveend) {
				clearTimeout(this._sizeTimer);
				this._sizeTimer = setTimeout(bind(this.fire, this, 'moveend'), 200);
			} else {
				this.fire('moveend');
			}
		}

		// @section Map state change events
		// @event resize: ResizeEvent
		// Fired when the map is resized.
		return this.fire('resize', {
			oldSize: oldSize,
			newSize: newSize
		});
	},

	// @section Methods for modifying map state
	// @method stop(): this
	// Stops the currently running `panTo` or `flyTo` animation, if any.
	stop: function () {
		this.setZoom(this._limitZoom(this._zoom));
		if (!this.options.zoomSnap) {
			this.fire('viewreset');
		}
		return this._stop();
	},

	// @section Geolocation methods
	// @method locate(options?: Locate options): this
	// Tries to locate the user using the Geolocation API, firing a [`locationfound`](#map-locationfound)
	// event with location data on success or a [`locationerror`](#map-locationerror) event on failure,
	// and optionally sets the map view to the user's location with respect to
	// detection accuracy (or to the world view if geolocation failed).
	// Note that, if your page doesn't use HTTPS, this method will fail in
	// modern browsers ([Chrome 50 and newer](https://sites.google.com/a/chromium.org/dev/Home/chromium-security/deprecating-powerful-features-on-insecure-origins))
	// See `Locate options` for more details.
	locate: function (options) {

		options = this._locateOptions = extend({
			timeout: 10000,
			watch: false
			// setView: false
			// maxZoom: <Number>
			// maximumAge: 0
			// enableHighAccuracy: false
		}, options);

		if (!('geolocation' in navigator)) {
			this._handleGeolocationError({
				code: 0,
				message: 'Geolocation not supported.'
			});
			return this;
		}

		var onResponse = bind(this._handleGeolocationResponse, this),
		    onError = bind(this._handleGeolocationError, this);

		if (options.watch) {
			this._locationWatchId =
			        navigator.geolocation.watchPosition(onResponse, onError, options);
		} else {
			navigator.geolocation.getCurrentPosition(onResponse, onError, options);
		}
		return this;
	},

	// @method stopLocate(): this
	// Stops watching location previously initiated by `map.locate({watch: true})`
	// and aborts resetting the map view if map.locate was called with
	// `{setView: true}`.
	stopLocate: function () {
		if (navigator.geolocation && navigator.geolocation.clearWatch) {
			navigator.geolocation.clearWatch(this._locationWatchId);
		}
		if (this._locateOptions) {
			this._locateOptions.setView = false;
		}
		return this;
	},

	_handleGeolocationError: function (error) {
		var c = error.code,
		    message = error.message ||
		            (c === 1 ? 'permission denied' :
		            (c === 2 ? 'position unavailable' : 'timeout'));

		if (this._locateOptions.setView && !this._loaded) {
			this.fitWorld();
		}

		// @section Location events
		// @event locationerror: ErrorEvent
		// Fired when geolocation (using the [`locate`](#map-locate) method) failed.
		this.fire('locationerror', {
			code: c,
			message: 'Geolocation error: ' + message + '.'
		});
	},

	_handleGeolocationResponse: function (pos) {
		var lat = pos.coords.latitude,
		    lng = pos.coords.longitude,
		    latlng = new LatLng(lat, lng),
		    bounds = latlng.toBounds(pos.coords.accuracy),
		    options = this._locateOptions;

		if (options.setView) {
			var zoom = this.getBoundsZoom(bounds);
			this.setView(latlng, options.maxZoom ? Math.min(zoom, options.maxZoom) : zoom);
		}

		var data = {
			latlng: latlng,
			bounds: bounds,
			timestamp: pos.timestamp
		};

		for (var i in pos.coords) {
			if (typeof pos.coords[i] === 'number') {
				data[i] = pos.coords[i];
			}
		}

		// @event locationfound: LocationEvent
		// Fired when geolocation (using the [`locate`](#map-locate) method)
		// went successfully.
		this.fire('locationfound', data);
	},

	// TODO handler.addTo
	// TODO Appropiate docs section?
	// @section Other Methods
	// @method addHandler(name: String, HandlerClass: Function): this
	// Adds a new `Handler` to the map, given its name and constructor function.
	addHandler: function (name, HandlerClass) {
		if (!HandlerClass) { return this; }

		var handler = this[name] = new HandlerClass(this);

		this._handlers.push(handler);

		if (this.options[name]) {
			handler.enable();
		}

		return this;
	},

	// @method remove(): this
	// Destroys the map and clears all related event listeners.
	remove: function () {

		this._initEvents(true);

		if (this._containerId !== this._container._leaflet_id) {
			throw new Error('Map container is being reused by another instance');
		}

		try {
			// throws error in IE6-8
			delete this._container._leaflet_id;
			delete this._containerId;
		} catch (e) {
			/*eslint-disable */
			this._container._leaflet_id = undefined;
			/*eslint-enable */
			this._containerId = undefined;
		}

		remove(this._mapPane);

		if (this._clearControlPos) {
			this._clearControlPos();
		}

		this._clearHandlers();

		if (this._loaded) {
			// @section Map state change events
			// @event unload: Event
			// Fired when the map is destroyed with [remove](#map-remove) method.
			this.fire('unload');
		}

		var i;
		for (i in this._layers) {
			this._layers[i].remove();
		}
		for (i in this._panes) {
			remove(this._panes[i]);
		}

		this._layers = [];
		this._panes = [];
		delete this._mapPane;
		delete this._renderer;

		return this;
	},

	// @section Other Methods
	// @method createPane(name: String, container?: HTMLElement): HTMLElement
	// Creates a new [map pane](#map-pane) with the given name if it doesn't exist already,
	// then returns it. The pane is created as a child of `container`, or
	// as a child of the main map pane if not set.
	createPane: function (name, container) {
		var className = 'leaflet-pane' + (name ? ' leaflet-' + name.replace('Pane', '') + '-pane' : ''),
		    pane = create$1('div', className, container || this._mapPane);

		if (name) {
			this._panes[name] = pane;
		}
		return pane;
	},

	// @section Methods for Getting Map State

	// @method getCenter(): LatLng
	// Returns the geographical center of the map view
	getCenter: function () {
		this._checkIfLoaded();

		if (this._lastCenter && !this._moved()) {
			return this._lastCenter;
		}
		return this.layerPointToLatLng(this._getCenterLayerPoint());
	},

	// @method getZoom(): Number
	// Returns the current zoom level of the map view
	getZoom: function () {
		return this._zoom;
	},

	// @method getBounds(): LatLngBounds
	// Returns the geographical bounds visible in the current map view
	getBounds: function () {
		var bounds = this.getPixelBounds(),
		    sw = this.unproject(bounds.getBottomLeft()),
		    ne = this.unproject(bounds.getTopRight());

		return new LatLngBounds(sw, ne);
	},

	// @method getMinZoom(): Number
	// Returns the minimum zoom level of the map (if set in the `minZoom` option of the map or of any layers), or `0` by default.
	getMinZoom: function () {
		return this.options.minZoom === undefined ? this._layersMinZoom || 0 : this.options.minZoom;
	},

	// @method getMaxZoom(): Number
	// Returns the maximum zoom level of the map (if set in the `maxZoom` option of the map or of any layers).
	getMaxZoom: function () {
		return this.options.maxZoom === undefined ?
			(this._layersMaxZoom === undefined ? Infinity : this._layersMaxZoom) :
			this.options.maxZoom;
	},

	// @method getBoundsZoom(bounds: LatLngBounds, inside?: Boolean): Number
	// Returns the maximum zoom level on which the given bounds fit to the map
	// view in its entirety. If `inside` (optional) is set to `true`, the method
	// instead returns the minimum zoom level on which the map view fits into
	// the given bounds in its entirety.
	getBoundsZoom: function (bounds, inside, padding) { // (LatLngBounds[, Boolean, Point]) -> Number
		bounds = toLatLngBounds(bounds);
		padding = toPoint(padding || [0, 0]);

		var zoom = this.getZoom() || 0,
		    min = this.getMinZoom(),
		    max = this.getMaxZoom(),
		    nw = bounds.getNorthWest(),
		    se = bounds.getSouthEast(),
		    size = this.getSize().subtract(padding),
		    boundsSize = toBounds(this.project(se, zoom), this.project(nw, zoom)).getSize(),
		    snap = any3d ? this.options.zoomSnap : 1,
		    scalex = size.x / boundsSize.x,
		    scaley = size.y / boundsSize.y,
		    scale = inside ? Math.max(scalex, scaley) : Math.min(scalex, scaley);

		zoom = this.getScaleZoom(scale, zoom);

		if (snap) {
			zoom = Math.round(zoom / (snap / 100)) * (snap / 100); // don't jump if within 1% of a snap level
			zoom = inside ? Math.ceil(zoom / snap) * snap : Math.floor(zoom / snap) * snap;
		}

		return Math.max(min, Math.min(max, zoom));
	},

	// @method getSize(): Point
	// Returns the current size of the map container (in pixels).
	getSize: function () {
		if (!this._size || this._sizeChanged) {
			this._size = new Point(
				this._container.clientWidth || 0,
				this._container.clientHeight || 0);

			this._sizeChanged = false;
		}
		return this._size.clone();
	},

	// @method getPixelBounds(): Bounds
	// Returns the bounds of the current map view in projected pixel
	// coordinates (sometimes useful in layer and overlay implementations).
	getPixelBounds: function (center, zoom) {
		var topLeftPoint = this._getTopLeftPoint(center, zoom);
		return new Bounds(topLeftPoint, topLeftPoint.add(this.getSize()));
	},

	// TODO: Check semantics - isn't the pixel origin the 0,0 coord relative to
	// the map pane? "left point of the map layer" can be confusing, specially
	// since there can be negative offsets.
	// @method getPixelOrigin(): Point
	// Returns the projected pixel coordinates of the top left point of
	// the map layer (useful in custom layer and overlay implementations).
	getPixelOrigin: function () {
		this._checkIfLoaded();
		return this._pixelOrigin;
	},

	// @method getPixelWorldBounds(zoom?: Number): Bounds
	// Returns the world's bounds in pixel coordinates for zoom level `zoom`.
	// If `zoom` is omitted, the map's current zoom level is used.
	getPixelWorldBounds: function (zoom) {
		return this.options.crs.getProjectedBounds(zoom === undefined ? this.getZoom() : zoom);
	},

	// @section Other Methods

	// @method getPane(pane: String|HTMLElement): HTMLElement
	// Returns a [map pane](#map-pane), given its name or its HTML element (its identity).
	getPane: function (pane) {
		return typeof pane === 'string' ? this._panes[pane] : pane;
	},

	// @method getPanes(): Object
	// Returns a plain object containing the names of all [panes](#map-pane) as keys and
	// the panes as values.
	getPanes: function () {
		return this._panes;
	},

	// @method getContainer: HTMLElement
	// Returns the HTML element that contains the map.
	getContainer: function () {
		return this._container;
	},


	// @section Conversion Methods

	// @method getZoomScale(toZoom: Number, fromZoom: Number): Number
	// Returns the scale factor to be applied to a map transition from zoom level
	// `fromZoom` to `toZoom`. Used internally to help with zoom animations.
	getZoomScale: function (toZoom, fromZoom) {
		// TODO replace with universal implementation after refactoring projections
		var crs = this.options.crs;
		fromZoom = fromZoom === undefined ? this._zoom : fromZoom;
		return crs.scale(toZoom) / crs.scale(fromZoom);
	},

	// @method getScaleZoom(scale: Number, fromZoom: Number): Number
	// Returns the zoom level that the map would end up at, if it is at `fromZoom`
	// level and everything is scaled by a factor of `scale`. Inverse of
	// [`getZoomScale`](#map-getZoomScale).
	getScaleZoom: function (scale, fromZoom) {
		var crs = this.options.crs;
		fromZoom = fromZoom === undefined ? this._zoom : fromZoom;
		var zoom = crs.zoom(scale * crs.scale(fromZoom));
		return isNaN(zoom) ? Infinity : zoom;
	},

	// @method project(latlng: LatLng, zoom: Number): Point
	// Projects a geographical coordinate `LatLng` according to the projection
	// of the map's CRS, then scales it according to `zoom` and the CRS's
	// `Transformation`. The result is pixel coordinate relative to
	// the CRS origin.
	project: function (latlng, zoom) {
		zoom = zoom === undefined ? this._zoom : zoom;
		return this.options.crs.latLngToPoint(toLatLng(latlng), zoom);
	},

	// @method unproject(point: Point, zoom: Number): LatLng
	// Inverse of [`project`](#map-project).
	unproject: function (point, zoom) {
		zoom = zoom === undefined ? this._zoom : zoom;
		return this.options.crs.pointToLatLng(toPoint(point), zoom);
	},

	// @method layerPointToLatLng(point: Point): LatLng
	// Given a pixel coordinate relative to the [origin pixel](#map-getpixelorigin),
	// returns the corresponding geographical coordinate (for the current zoom level).
	layerPointToLatLng: function (point) {
		var projectedPoint = toPoint(point).add(this.getPixelOrigin());
		return this.unproject(projectedPoint);
	},

	// @method latLngToLayerPoint(latlng: LatLng): Point
	// Given a geographical coordinate, returns the corresponding pixel coordinate
	// relative to the [origin pixel](#map-getpixelorigin).
	latLngToLayerPoint: function (latlng) {
		var projectedPoint = this.project(toLatLng(latlng))._round();
		return projectedPoint._subtract(this.getPixelOrigin());
	},

	// @method wrapLatLng(latlng: LatLng): LatLng
	// Returns a `LatLng` where `lat` and `lng` has been wrapped according to the
	// map's CRS's `wrapLat` and `wrapLng` properties, if they are outside the
	// CRS's bounds.
	// By default this means longitude is wrapped around the dateline so its
	// value is between -180 and +180 degrees.
	wrapLatLng: function (latlng) {
		return this.options.crs.wrapLatLng(toLatLng(latlng));
	},

	// @method wrapLatLngBounds(bounds: LatLngBounds): LatLngBounds
	// Returns a `LatLngBounds` with the same size as the given one, ensuring that
	// its center is within the CRS's bounds.
	// By default this means the center longitude is wrapped around the dateline so its
	// value is between -180 and +180 degrees, and the majority of the bounds
	// overlaps the CRS's bounds.
	wrapLatLngBounds: function (latlng) {
		return this.options.crs.wrapLatLngBounds(toLatLngBounds(latlng));
	},

	// @method distance(latlng1: LatLng, latlng2: LatLng): Number
	// Returns the distance between two geographical coordinates according to
	// the map's CRS. By default this measures distance in meters.
	distance: function (latlng1, latlng2) {
		return this.options.crs.distance(toLatLng(latlng1), toLatLng(latlng2));
	},

	// @method containerPointToLayerPoint(point: Point): Point
	// Given a pixel coordinate relative to the map container, returns the corresponding
	// pixel coordinate relative to the [origin pixel](#map-getpixelorigin).
	containerPointToLayerPoint: function (point) { // (Point)
		return toPoint(point).subtract(this._getMapPanePos());
	},

	// @method layerPointToContainerPoint(point: Point): Point
	// Given a pixel coordinate relative to the [origin pixel](#map-getpixelorigin),
	// returns the corresponding pixel coordinate relative to the map container.
	layerPointToContainerPoint: function (point) { // (Point)
		return toPoint(point).add(this._getMapPanePos());
	},

	// @method containerPointToLatLng(point: Point): LatLng
	// Given a pixel coordinate relative to the map container, returns
	// the corresponding geographical coordinate (for the current zoom level).
	containerPointToLatLng: function (point) {
		var layerPoint = this.containerPointToLayerPoint(toPoint(point));
		return this.layerPointToLatLng(layerPoint);
	},

	// @method latLngToContainerPoint(latlng: LatLng): Point
	// Given a geographical coordinate, returns the corresponding pixel coordinate
	// relative to the map container.
	latLngToContainerPoint: function (latlng) {
		return this.layerPointToContainerPoint(this.latLngToLayerPoint(toLatLng(latlng)));
	},

	// @method mouseEventToContainerPoint(ev: MouseEvent): Point
	// Given a MouseEvent object, returns the pixel coordinate relative to the
	// map container where the event took place.
	mouseEventToContainerPoint: function (e) {
		return getMousePosition(e, this._container);
	},

	// @method mouseEventToLayerPoint(ev: MouseEvent): Point
	// Given a MouseEvent object, returns the pixel coordinate relative to
	// the [origin pixel](#map-getpixelorigin) where the event took place.
	mouseEventToLayerPoint: function (e) {
		return this.containerPointToLayerPoint(this.mouseEventToContainerPoint(e));
	},

	// @method mouseEventToLatLng(ev: MouseEvent): LatLng
	// Given a MouseEvent object, returns geographical coordinate where the
	// event took place.
	mouseEventToLatLng: function (e) { // (MouseEvent)
		return this.layerPointToLatLng(this.mouseEventToLayerPoint(e));
	},


	// map initialization methods

	_initContainer: function (id) {
		var container = this._container = get(id);

		if (!container) {
			throw new Error('Map container not found.');
		} else if (container._leaflet_id) {
			throw new Error('Map container is already initialized.');
		}

		on(container, 'scroll', this._onScroll, this);
		this._containerId = stamp(container);
	},

	_initLayout: function () {
		var container = this._container;

		this._fadeAnimated = this.options.fadeAnimation && any3d;

		addClass(container, 'leaflet-container' +
			(touch ? ' leaflet-touch' : '') +
			(retina ? ' leaflet-retina' : '') +
			(ielt9 ? ' leaflet-oldie' : '') +
			(safari ? ' leaflet-safari' : '') +
			(this._fadeAnimated ? ' leaflet-fade-anim' : ''));

		var position = getStyle(container, 'position');

		if (position !== 'absolute' && position !== 'relative' && position !== 'fixed') {
			container.style.position = 'relative';
		}

		this._initPanes();

		if (this._initControlPos) {
			this._initControlPos();
		}
	},

	_initPanes: function () {
		var panes = this._panes = {};
		this._paneRenderers = {};

		// @section
		//
		// Panes are DOM elements used to control the ordering of layers on the map. You
		// can access panes with [`map.getPane`](#map-getpane) or
		// [`map.getPanes`](#map-getpanes) methods. New panes can be created with the
		// [`map.createPane`](#map-createpane) method.
		//
		// Every map has the following default panes that differ only in zIndex.
		//
		// @pane mapPane: HTMLElement = 'auto'
		// Pane that contains all other map panes

		this._mapPane = this.createPane('mapPane', this._container);
		setPosition(this._mapPane, new Point(0, 0));

		// @pane tilePane: HTMLElement = 200
		// Pane for `GridLayer`s and `TileLayer`s
		this.createPane('tilePane');
		// @pane overlayPane: HTMLElement = 400
		// Pane for vector overlays (`Path`s), like `Polyline`s and `Polygon`s
		this.createPane('shadowPane');
		// @pane shadowPane: HTMLElement = 500
		// Pane for overlay shadows (e.g. `Marker` shadows)
		this.createPane('overlayPane');
		// @pane markerPane: HTMLElement = 600
		// Pane for `Icon`s of `Marker`s
		this.createPane('markerPane');
		// @pane tooltipPane: HTMLElement = 650
		// Pane for tooltip.
		this.createPane('tooltipPane');
		// @pane popupPane: HTMLElement = 700
		// Pane for `Popup`s.
		this.createPane('popupPane');

		if (!this.options.markerZoomAnimation) {
			addClass(panes.markerPane, 'leaflet-zoom-hide');
			addClass(panes.shadowPane, 'leaflet-zoom-hide');
		}
	},


	// private methods that modify map state

	// @section Map state change events
	_resetView: function (center, zoom) {
		setPosition(this._mapPane, new Point(0, 0));

		var loading = !this._loaded;
		this._loaded = true;
		zoom = this._limitZoom(zoom);

		this.fire('viewprereset');

		var zoomChanged = this._zoom !== zoom;
		this
			._moveStart(zoomChanged)
			._move(center, zoom)
			._moveEnd(zoomChanged);

		// @event viewreset: Event
		// Fired when the map needs to redraw its content (this usually happens
		// on map zoom or load). Very useful for creating custom overlays.
		this.fire('viewreset');

		// @event load: Event
		// Fired when the map is initialized (when its center and zoom are set
		// for the first time).
		if (loading) {
			this.fire('load');
		}
	},

	_moveStart: function (zoomChanged) {
		// @event zoomstart: Event
		// Fired when the map zoom is about to change (e.g. before zoom animation).
		// @event movestart: Event
		// Fired when the view of the map starts changing (e.g. user starts dragging the map).
		if (zoomChanged) {
			this.fire('zoomstart');
		}
		return this.fire('movestart');
	},

	_move: function (center, zoom, data) {
		if (zoom === undefined) {
			zoom = this._zoom;
		}
		var zoomChanged = this._zoom !== zoom;

		this._zoom = zoom;
		this._lastCenter = center;
		this._pixelOrigin = this._getNewPixelOrigin(center);

		// @event zoom: Event
		// Fired repeatedly during any change in zoom level, including zoom
		// and fly animations.
		if (zoomChanged || (data && data.pinch)) {	// Always fire 'zoom' if pinching because #3530
			this.fire('zoom', data);
		}

		// @event move: Event
		// Fired repeatedly during any movement of the map, including pan and
		// fly animations.
		return this.fire('move', data);
	},

	_moveEnd: function (zoomChanged) {
		// @event zoomend: Event
		// Fired when the map has changed, after any animations.
		if (zoomChanged) {
			this.fire('zoomend');
		}

		// @event moveend: Event
		// Fired when the center of the map stops changing (e.g. user stopped
		// dragging the map).
		return this.fire('moveend');
	},

	_stop: function () {
		cancelAnimFrame(this._flyToFrame);
		if (this._panAnim) {
			this._panAnim.stop();
		}
		return this;
	},

	_rawPanBy: function (offset) {
		setPosition(this._mapPane, this._getMapPanePos().subtract(offset));
	},

	_getZoomSpan: function () {
		return this.getMaxZoom() - this.getMinZoom();
	},

	_panInsideMaxBounds: function () {
		if (!this._enforcingBounds) {
			this.panInsideBounds(this.options.maxBounds);
		}
	},

	_checkIfLoaded: function () {
		if (!this._loaded) {
			throw new Error('Set map center and zoom first.');
		}
	},

	// DOM event handling

	// @section Interaction events
	_initEvents: function (remove$$1) {
		this._targets = {};
		this._targets[stamp(this._container)] = this;

		var onOff = remove$$1 ? off : on;

		// @event click: MouseEvent
		// Fired when the user clicks (or taps) the map.
		// @event dblclick: MouseEvent
		// Fired when the user double-clicks (or double-taps) the map.
		// @event mousedown: MouseEvent
		// Fired when the user pushes the mouse button on the map.
		// @event mouseup: MouseEvent
		// Fired when the user releases the mouse button on the map.
		// @event mouseover: MouseEvent
		// Fired when the mouse enters the map.
		// @event mouseout: MouseEvent
		// Fired when the mouse leaves the map.
		// @event mousemove: MouseEvent
		// Fired while the mouse moves over the map.
		// @event contextmenu: MouseEvent
		// Fired when the user pushes the right mouse button on the map, prevents
		// default browser context menu from showing if there are listeners on
		// this event. Also fired on mobile when the user holds a single touch
		// for a second (also called long press).
		// @event keypress: KeyboardEvent
		// Fired when the user presses a key from the keyboard while the map is focused.
		onOff(this._container, 'click dblclick mousedown mouseup ' +
			'mouseover mouseout mousemove contextmenu keypress', this._handleDOMEvent, this);

		if (this.options.trackResize) {
			onOff(window, 'resize', this._onResize, this);
		}

		if (any3d && this.options.transform3DLimit) {
			(remove$$1 ? this.off : this.on).call(this, 'moveend', this._onMoveEnd);
		}
	},

	_onResize: function () {
		cancelAnimFrame(this._resizeRequest);
		this._resizeRequest = requestAnimFrame(
		        function () { this.invalidateSize({debounceMoveend: true}); }, this);
	},

	_onScroll: function () {
		this._container.scrollTop  = 0;
		this._container.scrollLeft = 0;
	},

	_onMoveEnd: function () {
		var pos = this._getMapPanePos();
		if (Math.max(Math.abs(pos.x), Math.abs(pos.y)) >= this.options.transform3DLimit) {
			// https://bugzilla.mozilla.org/show_bug.cgi?id=1203873 but Webkit also have
			// a pixel offset on very high values, see: http://jsfiddle.net/dg6r5hhb/
			this._resetView(this.getCenter(), this.getZoom());
		}
	},

	_findEventTargets: function (e, type) {
		var targets = [],
		    target,
		    isHover = type === 'mouseout' || type === 'mouseover',
		    src = e.target || e.srcElement,
		    dragging = false;

		while (src) {
			target = this._targets[stamp(src)];
			if (target && (type === 'click' || type === 'preclick') && !e._simulated && this._draggableMoved(target)) {
				// Prevent firing click after you just dragged an object.
				dragging = true;
				break;
			}
			if (target && target.listens(type, true)) {
				if (isHover && !isExternalTarget(src, e)) { break; }
				targets.push(target);
				if (isHover) { break; }
			}
			if (src === this._container) { break; }
			src = src.parentNode;
		}
		if (!targets.length && !dragging && !isHover && isExternalTarget(src, e)) {
			targets = [this];
		}
		return targets;
	},

	_handleDOMEvent: function (e) {
		if (!this._loaded || skipped(e)) { return; }

		var type = e.type;

		if (type === 'mousedown' || type === 'keypress') {
			// prevents outline when clicking on keyboard-focusable element
			preventOutline(e.target || e.srcElement);
		}

		this._fireDOMEvent(e, type);
	},

	_mouseEvents: ['click', 'dblclick', 'mouseover', 'mouseout', 'contextmenu'],

	_fireDOMEvent: function (e, type, targets) {

		if (e.type === 'click') {
			// Fire a synthetic 'preclick' event which propagates up (mainly for closing popups).
			// @event preclick: MouseEvent
			// Fired before mouse click on the map (sometimes useful when you
			// want something to happen on click before any existing click
			// handlers start running).
			var synth = extend({}, e);
			synth.type = 'preclick';
			this._fireDOMEvent(synth, synth.type, targets);
		}

		if (e._stopped) { return; }

		// Find the layer the event is propagating from and its parents.
		targets = (targets || []).concat(this._findEventTargets(e, type));

		if (!targets.length) { return; }

		var target = targets[0];
		if (type === 'contextmenu' && target.listens(type, true)) {
			preventDefault(e);
		}

		var data = {
			originalEvent: e
		};

		if (e.type !== 'keypress') {
			var isMarker = (target.options && 'icon' in target.options);
			data.containerPoint = isMarker ?
					this.latLngToContainerPoint(target.getLatLng()) : this.mouseEventToContainerPoint(e);
			data.layerPoint = this.containerPointToLayerPoint(data.containerPoint);
			data.latlng = isMarker ? target.getLatLng() : this.layerPointToLatLng(data.layerPoint);
		}

		for (var i = 0; i < targets.length; i++) {
			targets[i].fire(type, data, true);
			if (data.originalEvent._stopped ||
				(targets[i].options.bubblingMouseEvents === false && indexOf(this._mouseEvents, type) !== -1)) { return; }
		}
	},

	_draggableMoved: function (obj) {
		obj = obj.dragging && obj.dragging.enabled() ? obj : this;
		return (obj.dragging && obj.dragging.moved()) || (this.boxZoom && this.boxZoom.moved());
	},

	_clearHandlers: function () {
		for (var i = 0, len = this._handlers.length; i < len; i++) {
			this._handlers[i].disable();
		}
	},

	// @section Other Methods

	// @method whenReady(fn: Function, context?: Object): this
	// Runs the given function `fn` when the map gets initialized with
	// a view (center and zoom) and at least one layer, or immediately
	// if it's already initialized, optionally passing a function context.
	whenReady: function (callback, context) {
		if (this._loaded) {
			callback.call(context || this, {target: this});
		} else {
			this.on('load', callback, context);
		}
		return this;
	},


	// private methods for getting map state

	_getMapPanePos: function () {
		return getPosition(this._mapPane) || new Point(0, 0);
	},

	_moved: function () {
		var pos = this._getMapPanePos();
		return pos && !pos.equals([0, 0]);
	},

	_getTopLeftPoint: function (center, zoom) {
		var pixelOrigin = center && zoom !== undefined ?
			this._getNewPixelOrigin(center, zoom) :
			this.getPixelOrigin();
		return pixelOrigin.subtract(this._getMapPanePos());
	},

	_getNewPixelOrigin: function (center, zoom) {
		var viewHalf = this.getSize()._divideBy(2);
		return this.project(center, zoom)._subtract(viewHalf)._add(this._getMapPanePos())._round();
	},

	_latLngToNewLayerPoint: function (latlng, zoom, center) {
		var topLeft = this._getNewPixelOrigin(center, zoom);
		return this.project(latlng, zoom)._subtract(topLeft);
	},

	_latLngBoundsToNewLayerBounds: function (latLngBounds, zoom, center) {
		var topLeft = this._getNewPixelOrigin(center, zoom);
		return toBounds([
			this.project(latLngBounds.getSouthWest(), zoom)._subtract(topLeft),
			this.project(latLngBounds.getNorthWest(), zoom)._subtract(topLeft),
			this.project(latLngBounds.getSouthEast(), zoom)._subtract(topLeft),
			this.project(latLngBounds.getNorthEast(), zoom)._subtract(topLeft)
		]);
	},

	// layer point of the current center
	_getCenterLayerPoint: function () {
		return this.containerPointToLayerPoint(this.getSize()._divideBy(2));
	},

	// offset of the specified place to the current center in pixels
	_getCenterOffset: function (latlng) {
		return this.latLngToLayerPoint(latlng).subtract(this._getCenterLayerPoint());
	},

	// adjust center for view to get inside bounds
	_limitCenter: function (center, zoom, bounds) {

		if (!bounds) { return center; }

		var centerPoint = this.project(center, zoom),
		    viewHalf = this.getSize().divideBy(2),
		    viewBounds = new Bounds(centerPoint.subtract(viewHalf), centerPoint.add(viewHalf)),
		    offset = this._getBoundsOffset(viewBounds, bounds, zoom);

		// If offset is less than a pixel, ignore.
		// This prevents unstable projections from getting into
		// an infinite loop of tiny offsets.
		if (offset.round().equals([0, 0])) {
			return center;
		}

		return this.unproject(centerPoint.add(offset), zoom);
	},

	// adjust offset for view to get inside bounds
	_limitOffset: function (offset, bounds) {
		if (!bounds) { return offset; }

		var viewBounds = this.getPixelBounds(),
		    newBounds = new Bounds(viewBounds.min.add(offset), viewBounds.max.add(offset));

		return offset.add(this._getBoundsOffset(newBounds, bounds));
	},

	// returns offset needed for pxBounds to get inside maxBounds at a specified zoom
	_getBoundsOffset: function (pxBounds, maxBounds, zoom) {
		var projectedMaxBounds = toBounds(
		        this.project(maxBounds.getNorthEast(), zoom),
		        this.project(maxBounds.getSouthWest(), zoom)
		    ),
		    minOffset = projectedMaxBounds.min.subtract(pxBounds.min),
		    maxOffset = projectedMaxBounds.max.subtract(pxBounds.max),

		    dx = this._rebound(minOffset.x, -maxOffset.x),
		    dy = this._rebound(minOffset.y, -maxOffset.y);

		return new Point(dx, dy);
	},

	_rebound: function (left, right) {
		return left + right > 0 ?
			Math.round(left - right) / 2 :
			Math.max(0, Math.ceil(left)) - Math.max(0, Math.floor(right));
	},

	_limitZoom: function (zoom) {
		var min = this.getMinZoom(),
		    max = this.getMaxZoom(),
		    snap = any3d ? this.options.zoomSnap : 1;
		if (snap) {
			zoom = Math.round(zoom / snap) * snap;
		}
		return Math.max(min, Math.min(max, zoom));
	},

	_onPanTransitionStep: function () {
		this.fire('move');
	},

	_onPanTransitionEnd: function () {
		removeClass(this._mapPane, 'leaflet-pan-anim');
		this.fire('moveend');
	},

	_tryAnimatedPan: function (center, options) {
		// difference between the new and current centers in pixels
		var offset = this._getCenterOffset(center)._floor();

		// don't animate too far unless animate: true specified in options
		if ((options && options.animate) !== true && !this.getSize().contains(offset)) { return false; }

		this.panBy(offset, options);

		return true;
	},

	_createAnimProxy: function () {

		var proxy = this._proxy = create$1('div', 'leaflet-proxy leaflet-zoom-animated');
		this._panes.mapPane.appendChild(proxy);

		this.on('zoomanim', function (e) {
			var prop = TRANSFORM,
			    transform = this._proxy.style[prop];

			setTransform(this._proxy, this.project(e.center, e.zoom), this.getZoomScale(e.zoom, 1));

			// workaround for case when transform is the same and so transitionend event is not fired
			if (transform === this._proxy.style[prop] && this._animatingZoom) {
				this._onZoomTransitionEnd();
			}
		}, this);

		this.on('load moveend', function () {
			var c = this.getCenter(),
			    z = this.getZoom();
			setTransform(this._proxy, this.project(c, z), this.getZoomScale(z, 1));
		}, this);

		this._on('unload', this._destroyAnimProxy, this);
	},

	_destroyAnimProxy: function () {
		remove(this._proxy);
		delete this._proxy;
	},

	_catchTransitionEnd: function (e) {
		if (this._animatingZoom && e.propertyName.indexOf('transform') >= 0) {
			this._onZoomTransitionEnd();
		}
	},

	_nothingToAnimate: function () {
		return !this._container.getElementsByClassName('leaflet-zoom-animated').length;
	},

	_tryAnimatedZoom: function (center, zoom, options) {

		if (this._animatingZoom) { return true; }

		options = options || {};

		// don't animate if disabled, not supported or zoom difference is too large
		if (!this._zoomAnimated || options.animate === false || this._nothingToAnimate() ||
		        Math.abs(zoom - this._zoom) > this.options.zoomAnimationThreshold) { return false; }

		// offset is the pixel coords of the zoom origin relative to the current center
		var scale = this.getZoomScale(zoom),
		    offset = this._getCenterOffset(center)._divideBy(1 - 1 / scale);

		// don't animate if the zoom origin isn't within one screen from the current center, unless forced
		if (options.animate !== true && !this.getSize().contains(offset)) { return false; }

		requestAnimFrame(function () {
			this
			    ._moveStart(true)
			    ._animateZoom(center, zoom, true);
		}, this);

		return true;
	},

	_animateZoom: function (center, zoom, startAnim, noUpdate) {
		if (startAnim) {
			this._animatingZoom = true;

			// remember what center/zoom to set after animation
			this._animateToCenter = center;
			this._animateToZoom = zoom;

			addClass(this._mapPane, 'leaflet-zoom-anim');
		}

		// @event zoomanim: ZoomAnimEvent
		// Fired on every frame of a zoom animation
		this.fire('zoomanim', {
			center: center,
			zoom: zoom,
			noUpdate: noUpdate
		});

		// Work around webkit not firing 'transitionend', see https://github.com/Leaflet/Leaflet/issues/3689, 2693
		setTimeout(bind(this._onZoomTransitionEnd, this), 250);
	},

	_onZoomTransitionEnd: function () {
		if (!this._animatingZoom) { return; }

		removeClass(this._mapPane, 'leaflet-zoom-anim');

		this._animatingZoom = false;

		this._move(this._animateToCenter, this._animateToZoom);

		// This anim frame should prevent an obscure iOS webkit tile loading race condition.
		requestAnimFrame(function () {
			this._moveEnd(true);
		}, this);
	}
});

// @section

// @factory L.map(id: String, options?: Map options)
// Instantiates a map object given the DOM ID of a `<div>` element
// and optionally an object literal with `Map options`.
//
// @alternative
// @factory L.map(el: HTMLElement, options?: Map options)
// Instantiates a map object given an instance of a `<div>` HTML element
// and optionally an object literal with `Map options`.
function createMap(id, options) {
	return new Map(id, options);
}

/*
 * @class Control
 * @aka L.Control
 * @inherits Class
 *
 * L.Control is a base class for implementing map controls. Handles positioning.
 * All other controls extend from this class.
 */

var Control = Class.extend({
	// @section
	// @aka Control options
	options: {
		// @option position: String = 'topright'
		// The position of the control (one of the map corners). Possible values are `'topleft'`,
		// `'topright'`, `'bottomleft'` or `'bottomright'`
		position: 'topright'
	},

	initialize: function (options) {
		setOptions(this, options);
	},

	/* @section
	 * Classes extending L.Control will inherit the following methods:
	 *
	 * @method getPosition: string
	 * Returns the position of the control.
	 */
	getPosition: function () {
		return this.options.position;
	},

	// @method setPosition(position: string): this
	// Sets the position of the control.
	setPosition: function (position) {
		var map = this._map;

		if (map) {
			map.removeControl(this);
		}

		this.options.position = position;

		if (map) {
			map.addControl(this);
		}

		return this;
	},

	// @method getContainer: HTMLElement
	// Returns the HTMLElement that contains the control.
	getContainer: function () {
		return this._container;
	},

	// @method addTo(map: Map): this
	// Adds the control to the given map.
	addTo: function (map) {
		this.remove();
		this._map = map;

		var container = this._container = this.onAdd(map),
		    pos = this.getPosition(),
		    corner = map._controlCorners[pos];

		addClass(container, 'leaflet-control');

		if (pos.indexOf('bottom') !== -1) {
			corner.insertBefore(container, corner.firstChild);
		} else {
			corner.appendChild(container);
		}

		return this;
	},

	// @method remove: this
	// Removes the control from the map it is currently active on.
	remove: function () {
		if (!this._map) {
			return this;
		}

		remove(this._container);

		if (this.onRemove) {
			this.onRemove(this._map);
		}

		this._map = null;

		return this;
	},

	_refocusOnMap: function (e) {
		// if map exists and event is not a keyboard event
		if (this._map && e && e.screenX > 0 && e.screenY > 0) {
			this._map.getContainer().focus();
		}
	}
});

var control = function (options) {
	return new Control(options);
};

/* @section Extension methods
 * @uninheritable
 *
 * Every control should extend from `L.Control` and (re-)implement the following methods.
 *
 * @method onAdd(map: Map): HTMLElement
 * Should return the container DOM element for the control and add listeners on relevant map events. Called on [`control.addTo(map)`](#control-addTo).
 *
 * @method onRemove(map: Map)
 * Optional method. Should contain all clean up code that removes the listeners previously added in [`onAdd`](#control-onadd). Called on [`control.remove()`](#control-remove).
 */

/* @namespace Map
 * @section Methods for Layers and Controls
 */
Map.include({
	// @method addControl(control: Control): this
	// Adds the given control to the map
	addControl: function (control) {
		control.addTo(this);
		return this;
	},

	// @method removeControl(control: Control): this
	// Removes the given control from the map
	removeControl: function (control) {
		control.remove();
		return this;
	},

	_initControlPos: function () {
		var corners = this._controlCorners = {},
		    l = 'leaflet-',
		    container = this._controlContainer =
		            create$1('div', l + 'control-container', this._container);

		function createCorner(vSide, hSide) {
			var className = l + vSide + ' ' + l + hSide;

			corners[vSide + hSide] = create$1('div', className, container);
		}

		createCorner('top', 'left');
		createCorner('top', 'right');
		createCorner('bottom', 'left');
		createCorner('bottom', 'right');
	},

	_clearControlPos: function () {
		for (var i in this._controlCorners) {
			remove(this._controlCorners[i]);
		}
		remove(this._controlContainer);
		delete this._controlCorners;
		delete this._controlContainer;
	}
});

/*
 * @class Control.Layers
 * @aka L.Control.Layers
 * @inherits Control
 *
 * The layers control gives users the ability to switch between different base layers and switch overlays on/off (check out the [detailed example](http://leafletjs.com/examples/layers-control/)). Extends `Control`.
 *
 * @example
 *
 * ```js
 * var baseLayers = {
 * 	"Mapbox": mapbox,
 * 	"OpenStreetMap": osm
 * };
 *
 * var overlays = {
 * 	"Marker": marker,
 * 	"Roads": roadsLayer
 * };
 *
 * L.control.layers(baseLayers, overlays).addTo(map);
 * ```
 *
 * The `baseLayers` and `overlays` parameters are object literals with layer names as keys and `Layer` objects as values:
 *
 * ```js
 * {
 *     "<someName1>": layer1,
 *     "<someName2>": layer2
 * }
 * ```
 *
 * The layer names can contain HTML, which allows you to add additional styling to the items:
 *
 * ```js
 * {"<img src='my-layer-icon' /> <span class='my-layer-item'>My Layer</span>": myLayer}
 * ```
 */

var Layers = Control.extend({
	// @section
	// @aka Control.Layers options
	options: {
		// @option collapsed: Boolean = true
		// If `true`, the control will be collapsed into an icon and expanded on mouse hover or touch.
		collapsed: true,
		position: 'topright',

		// @option autoZIndex: Boolean = true
		// If `true`, the control will assign zIndexes in increasing order to all of its layers so that the order is preserved when switching them on/off.
		autoZIndex: true,

		// @option hideSingleBase: Boolean = false
		// If `true`, the base layers in the control will be hidden when there is only one.
		hideSingleBase: false,

		// @option sortLayers: Boolean = false
		// Whether to sort the layers. When `false`, layers will keep the order
		// in which they were added to the control.
		sortLayers: false,

		// @option sortFunction: Function = *
		// A [compare function](https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Array/sort)
		// that will be used for sorting the layers, when `sortLayers` is `true`.
		// The function receives both the `L.Layer` instances and their names, as in
		// `sortFunction(layerA, layerB, nameA, nameB)`.
		// By default, it sorts layers alphabetically by their name.
		sortFunction: function (layerA, layerB, nameA, nameB) {
			return nameA < nameB ? -1 : (nameB < nameA ? 1 : 0);
		}
	},

	initialize: function (baseLayers, overlays, options) {
		setOptions(this, options);

		this._layerControlInputs = [];
		this._layers = [];
		this._lastZIndex = 0;
		this._handlingClick = false;

		for (var i in baseLayers) {
			this._addLayer(baseLayers[i], i);
		}

		for (i in overlays) {
			this._addLayer(overlays[i], i, true);
		}
	},

	onAdd: function (map) {
		this._initLayout();
		this._update();

		this._map = map;
		map.on('zoomend', this._checkDisabledLayers, this);

		for (var i = 0; i < this._layers.length; i++) {
			this._layers[i].layer.on('add remove', this._onLayerChange, this);
		}

		return this._container;
	},

	addTo: function (map) {
		Control.prototype.addTo.call(this, map);
		// Trigger expand after Layers Control has been inserted into DOM so that is now has an actual height.
		return this._expandIfNotCollapsed();
	},

	onRemove: function () {
		this._map.off('zoomend', this._checkDisabledLayers, this);

		for (var i = 0; i < this._layers.length; i++) {
			this._layers[i].layer.off('add remove', this._onLayerChange, this);
		}
	},

	// @method addBaseLayer(layer: Layer, name: String): this
	// Adds a base layer (radio button entry) with the given name to the control.
	addBaseLayer: function (layer, name) {
		this._addLayer(layer, name);
		return (this._map) ? this._update() : this;
	},

	// @method addOverlay(layer: Layer, name: String): this
	// Adds an overlay (checkbox entry) with the given name to the control.
	addOverlay: function (layer, name) {
		this._addLayer(layer, name, true);
		return (this._map) ? this._update() : this;
	},

	// @method removeLayer(layer: Layer): this
	// Remove the given layer from the control.
	removeLayer: function (layer) {
		layer.off('add remove', this._onLayerChange, this);

		var obj = this._getLayer(stamp(layer));
		if (obj) {
			this._layers.splice(this._layers.indexOf(obj), 1);
		}
		return (this._map) ? this._update() : this;
	},

	// @method expand(): this
	// Expand the control container if collapsed.
	expand: function () {
		addClass(this._container, 'leaflet-control-layers-expanded');
		this._form.style.height = null;
		var acceptableHeight = this._map.getSize().y - (this._container.offsetTop + 50);
		if (acceptableHeight < this._form.clientHeight) {
			addClass(this._form, 'leaflet-control-layers-scrollbar');
			this._form.style.height = acceptableHeight + 'px';
		} else {
			removeClass(this._form, 'leaflet-control-layers-scrollbar');
		}
		this._checkDisabledLayers();
		return this;
	},

	// @method collapse(): this
	// Collapse the control container if expanded.
	collapse: function () {
		removeClass(this._container, 'leaflet-control-layers-expanded');
		return this;
	},

	_initLayout: function () {
		var className = 'leaflet-control-layers',
		    container = this._container = create$1('div', className),
		    collapsed = this.options.collapsed;

		// makes this work on IE touch devices by stopping it from firing a mouseout event when the touch is released
		container.setAttribute('aria-haspopup', true);

		disableClickPropagation(container);
		disableScrollPropagation(container);

		var form = this._form = create$1('form', className + '-list');

		if (collapsed) {
			this._map.on('click', this.collapse, this);

			if (!android) {
				on(container, {
					mouseenter: this.expand,
					mouseleave: this.collapse
				}, this);
			}
		}

		var link = this._layersLink = create$1('a', className + '-toggle', container);
		link.href = '#';
		link.title = 'Layers';

		if (touch) {
			on(link, 'click', stop);
			on(link, 'click', this.expand, this);
		} else {
			on(link, 'focus', this.expand, this);
		}

		if (!collapsed) {
			this.expand();
		}

		this._baseLayersList = create$1('div', className + '-base', form);
		this._separator = create$1('div', className + '-separator', form);
		this._overlaysList = create$1('div', className + '-overlays', form);

		container.appendChild(form);
	},

	_getLayer: function (id) {
		for (var i = 0; i < this._layers.length; i++) {

			if (this._layers[i] && stamp(this._layers[i].layer) === id) {
				return this._layers[i];
			}
		}
	},

	_addLayer: function (layer, name, overlay) {
		if (this._map) {
			layer.on('add remove', this._onLayerChange, this);
		}

		this._layers.push({
			layer: layer,
			name: name,
			overlay: overlay
		});

		if (this.options.sortLayers) {
			this._layers.sort(bind(function (a, b) {
				return this.options.sortFunction(a.layer, b.layer, a.name, b.name);
			}, this));
		}

		if (this.options.autoZIndex && layer.setZIndex) {
			this._lastZIndex++;
			layer.setZIndex(this._lastZIndex);
		}

		this._expandIfNotCollapsed();
	},

	_update: function () {
		if (!this._container) { return this; }

		empty(this._baseLayersList);
		empty(this._overlaysList);

		this._layerControlInputs = [];
		var baseLayersPresent, overlaysPresent, i, obj, baseLayersCount = 0;

		for (i = 0; i < this._layers.length; i++) {
			obj = this._layers[i];
			this._addItem(obj);
			overlaysPresent = overlaysPresent || obj.overlay;
			baseLayersPresent = baseLayersPresent || !obj.overlay;
			baseLayersCount += !obj.overlay ? 1 : 0;
		}

		// Hide base layers section if there's only one layer.
		if (this.options.hideSingleBase) {
			baseLayersPresent = baseLayersPresent && baseLayersCount > 1;
			this._baseLayersList.style.display = baseLayersPresent ? '' : 'none';
		}

		this._separator.style.display = overlaysPresent && baseLayersPresent ? '' : 'none';

		return this;
	},

	_onLayerChange: function (e) {
		if (!this._handlingClick) {
			this._update();
		}

		var obj = this._getLayer(stamp(e.target));

		// @namespace Map
		// @section Layer events
		// @event baselayerchange: LayersControlEvent
		// Fired when the base layer is changed through the [layer control](#control-layers).
		// @event overlayadd: LayersControlEvent
		// Fired when an overlay is selected through the [layer control](#control-layers).
		// @event overlayremove: LayersControlEvent
		// Fired when an overlay is deselected through the [layer control](#control-layers).
		// @namespace Control.Layers
		var type = obj.overlay ?
			(e.type === 'add' ? 'overlayadd' : 'overlayremove') :
			(e.type === 'add' ? 'baselayerchange' : null);

		if (type) {
			this._map.fire(type, obj);
		}
	},

	// IE7 bugs out if you create a radio dynamically, so you have to do it this hacky way (see http://bit.ly/PqYLBe)
	_createRadioElement: function (name, checked) {

		var radioHtml = '<input type="radio" class="leaflet-control-layers-selector" name="' +
				name + '"' + (checked ? ' checked="checked"' : '') + '/>';

		var radioFragment = document.createElement('div');
		radioFragment.innerHTML = radioHtml;

		return radioFragment.firstChild;
	},

	_addItem: function (obj) {
		var label = document.createElement('label'),
		    checked = this._map.hasLayer(obj.layer),
		    input;

		if (obj.overlay) {
			input = document.createElement('input');
			input.type = 'checkbox';
			input.className = 'leaflet-control-layers-selector';
			input.defaultChecked = checked;
		} else {
			input = this._createRadioElement('leaflet-base-layers', checked);
		}

		this._layerControlInputs.push(input);
		input.layerId = stamp(obj.layer);

		on(input, 'click', this._onInputClick, this);

		var name = document.createElement('span');
		name.innerHTML = ' ' + obj.name;

		// Helps from preventing layer control flicker when checkboxes are disabled
		// https://github.com/Leaflet/Leaflet/issues/2771
		var holder = document.createElement('div');

		label.appendChild(holder);
		holder.appendChild(input);
		holder.appendChild(name);

		var container = obj.overlay ? this._overlaysList : this._baseLayersList;
		container.appendChild(label);

		this._checkDisabledLayers();
		return label;
	},

	_onInputClick: function () {
		var inputs = this._layerControlInputs,
		    input, layer;
		var addedLayers = [],
		    removedLayers = [];

		this._handlingClick = true;

		for (var i = inputs.length - 1; i >= 0; i--) {
			input = inputs[i];
			layer = this._getLayer(input.layerId).layer;

			if (input.checked) {
				addedLayers.push(layer);
			} else if (!input.checked) {
				removedLayers.push(layer);
			}
		}

		// Bugfix issue 2318: Should remove all old layers before readding new ones
		for (i = 0; i < removedLayers.length; i++) {
			if (this._map.hasLayer(removedLayers[i])) {
				this._map.removeLayer(removedLayers[i]);
			}
		}
		for (i = 0; i < addedLayers.length; i++) {
			if (!this._map.hasLayer(addedLayers[i])) {
				this._map.addLayer(addedLayers[i]);
			}
		}

		this._handlingClick = false;

		this._refocusOnMap();
	},

	_checkDisabledLayers: function () {
		var inputs = this._layerControlInputs,
		    input,
		    layer,
		    zoom = this._map.getZoom();

		for (var i = inputs.length - 1; i >= 0; i--) {
			input = inputs[i];
			layer = this._getLayer(input.layerId).layer;
			input.disabled = (layer.options.minZoom !== undefined && zoom < layer.options.minZoom) ||
			                 (layer.options.maxZoom !== undefined && zoom > layer.options.maxZoom);

		}
	},

	_expandIfNotCollapsed: function () {
		if (this._map && !this.options.collapsed) {
			this.expand();
		}
		return this;
	},

	_expand: function () {
		// Backward compatibility, remove me in 1.1.
		return this.expand();
	},

	_collapse: function () {
		// Backward compatibility, remove me in 1.1.
		return this.collapse();
	}

});


// @factory L.control.layers(baselayers?: Object, overlays?: Object, options?: Control.Layers options)
// Creates an attribution control with the given layers. Base layers will be switched with radio buttons, while overlays will be switched with checkboxes. Note that all base layers should be passed in the base layers object, but only one should be added to the map during map instantiation.
var layers = function (baseLayers, overlays, options) {
	return new Layers(baseLayers, overlays, options);
};

/*
 * @class Control.Zoom
 * @aka L.Control.Zoom
 * @inherits Control
 *
 * A basic zoom control with two buttons (zoom in and zoom out). It is put on the map by default unless you set its [`zoomControl` option](#map-zoomcontrol) to `false`. Extends `Control`.
 */

var Zoom = Control.extend({
	// @section
	// @aka Control.Zoom options
	options: {
		position: 'topleft',

		// @option zoomInText: String = '+'
		// The text set on the 'zoom in' button.
		zoomInText: '+',

		// @option zoomInTitle: String = 'Zoom in'
		// The title set on the 'zoom in' button.
		zoomInTitle: 'Zoom in',

		// @option zoomOutText: String = '&#x2212;'
		// The text set on the 'zoom out' button.
		zoomOutText: '&#x2212;',

		// @option zoomOutTitle: String = 'Zoom out'
		// The title set on the 'zoom out' button.
		zoomOutTitle: 'Zoom out'
	},

	onAdd: function (map) {
		var zoomName = 'leaflet-control-zoom',
		    container = create$1('div', zoomName + ' leaflet-bar'),
		    options = this.options;

		this._zoomInButton  = this._createButton(options.zoomInText, options.zoomInTitle,
		        zoomName + '-in',  container, this._zoomIn);
		this._zoomOutButton = this._createButton(options.zoomOutText, options.zoomOutTitle,
		        zoomName + '-out', container, this._zoomOut);

		this._updateDisabled();
		map.on('zoomend zoomlevelschange', this._updateDisabled, this);

		return container;
	},

	onRemove: function (map) {
		map.off('zoomend zoomlevelschange', this._updateDisabled, this);
	},

	disable: function () {
		this._disabled = true;
		this._updateDisabled();
		return this;
	},

	enable: function () {
		this._disabled = false;
		this._updateDisabled();
		return this;
	},

	_zoomIn: function (e) {
		if (!this._disabled && this._map._zoom < this._map.getMaxZoom()) {
			this._map.zoomIn(this._map.options.zoomDelta * (e.shiftKey ? 3 : 1));
		}
	},

	_zoomOut: function (e) {
		if (!this._disabled && this._map._zoom > this._map.getMinZoom()) {
			this._map.zoomOut(this._map.options.zoomDelta * (e.shiftKey ? 3 : 1));
		}
	},

	_createButton: function (html, title, className, container, fn) {
		var link = create$1('a', className, container);
		link.innerHTML = html;
		link.href = '#';
		link.title = title;

		/*
		 * Will force screen readers like VoiceOver to read this as "Zoom in - button"
		 */
		link.setAttribute('role', 'button');
		link.setAttribute('aria-label', title);

		disableClickPropagation(link);
		on(link, 'click', stop);
		on(link, 'click', fn, this);
		on(link, 'click', this._refocusOnMap, this);

		return link;
	},

	_updateDisabled: function () {
		var map = this._map,
		    className = 'leaflet-disabled';

		removeClass(this._zoomInButton, className);
		removeClass(this._zoomOutButton, className);

		if (this._disabled || map._zoom === map.getMinZoom()) {
			addClass(this._zoomOutButton, className);
		}
		if (this._disabled || map._zoom === map.getMaxZoom()) {
			addClass(this._zoomInButton, className);
		}
	}
});

// @namespace Map
// @section Control options
// @option zoomControl: Boolean = true
// Whether a [zoom control](#control-zoom) is added to the map by default.
Map.mergeOptions({
	zoomControl: true
});

Map.addInitHook(function () {
	if (this.options.zoomControl) {
		this.zoomControl = new Zoom();
		this.addControl(this.zoomControl);
	}
});

// @namespace Control.Zoom
// @factory L.control.zoom(options: Control.Zoom options)
// Creates a zoom control
var zoom = function (options) {
	return new Zoom(options);
};

/*
 * @class Control.Scale
 * @aka L.Control.Scale
 * @inherits Control
 *
 * A simple scale control that shows the scale of the current center of screen in metric (m/km) and imperial (mi/ft) systems. Extends `Control`.
 *
 * @example
 *
 * ```js
 * L.control.scale().addTo(map);
 * ```
 */

var Scale = Control.extend({
	// @section
	// @aka Control.Scale options
	options: {
		position: 'bottomleft',

		// @option maxWidth: Number = 100
		// Maximum width of the control in pixels. The width is set dynamically to show round values (e.g. 100, 200, 500).
		maxWidth: 100,

		// @option metric: Boolean = True
		// Whether to show the metric scale line (m/km).
		metric: true,

		// @option imperial: Boolean = True
		// Whether to show the imperial scale line (mi/ft).
		imperial: true

		// @option updateWhenIdle: Boolean = false
		// If `true`, the control is updated on [`moveend`](#map-moveend), otherwise it's always up-to-date (updated on [`move`](#map-move)).
	},

	onAdd: function (map) {
		var className = 'leaflet-control-scale',
		    container = create$1('div', className),
		    options = this.options;

		this._addScales(options, className + '-line', container);

		map.on(options.updateWhenIdle ? 'moveend' : 'move', this._update, this);
		map.whenReady(this._update, this);

		return container;
	},

	onRemove: function (map) {
		map.off(this.options.updateWhenIdle ? 'moveend' : 'move', this._update, this);
	},

	_addScales: function (options, className, container) {
		if (options.metric) {
			this._mScale = create$1('div', className, container);
		}
		if (options.imperial) {
			this._iScale = create$1('div', className, container);
		}
	},

	_update: function () {
		var map = this._map,
		    y = map.getSize().y / 2;

		var maxMeters = map.distance(
				map.containerPointToLatLng([0, y]),
				map.containerPointToLatLng([this.options.maxWidth, y]));

		this._updateScales(maxMeters);
	},

	_updateScales: function (maxMeters) {
		if (this.options.metric && maxMeters) {
			this._updateMetric(maxMeters);
		}
		if (this.options.imperial && maxMeters) {
			this._updateImperial(maxMeters);
		}
	},

	_updateMetric: function (maxMeters) {
		var meters = this._getRoundNum(maxMeters),
		    label = meters < 1000 ? meters + ' m' : (meters / 1000) + ' km';

		this._updateScale(this._mScale, label, meters / maxMeters);
	},

	_updateImperial: function (maxMeters) {
		var maxFeet = maxMeters * 3.2808399,
		    maxMiles, miles, feet;

		if (maxFeet > 5280) {
			maxMiles = maxFeet / 5280;
			miles = this._getRoundNum(maxMiles);
			this._updateScale(this._iScale, miles + ' mi', miles / maxMiles);

		} else {
			feet = this._getRoundNum(maxFeet);
			this._updateScale(this._iScale, feet + ' ft', feet / maxFeet);
		}
	},

	_updateScale: function (scale, text, ratio) {
		scale.style.width = Math.round(this.options.maxWidth * ratio) + 'px';
		scale.innerHTML = text;
	},

	_getRoundNum: function (num) {
		var pow10 = Math.pow(10, (Math.floor(num) + '').length - 1),
		    d = num / pow10;

		d = d >= 10 ? 10 :
		    d >= 5 ? 5 :
		    d >= 3 ? 3 :
		    d >= 2 ? 2 : 1;

		return pow10 * d;
	}
});


// @factory L.control.scale(options?: Control.Scale options)
// Creates an scale control with the given options.
var scale = function (options) {
	return new Scale(options);
};

/*
 * @class Control.Attribution
 * @aka L.Control.Attribution
 * @inherits Control
 *
 * The attribution control allows you to display attribution data in a small text box on a map. It is put on the map by default unless you set its [`attributionControl` option](#map-attributioncontrol) to `false`, and it fetches attribution texts from layers with the [`getAttribution` method](#layer-getattribution) automatically. Extends Control.
 */

var Attribution = Control.extend({
	// @section
	// @aka Control.Attribution options
	options: {
		position: 'bottomright',

		// @option prefix: String = 'Leaflet'
		// The HTML text shown before the attributions. Pass `false` to disable.
		prefix: '<a href="http://leafletjs.com" title="A JS library for interactive maps">Leaflet</a>'
	},

	initialize: function (options) {
		setOptions(this, options);

		this._attributions = {};
	},

	onAdd: function (map) {
		map.attributionControl = this;
		this._container = create$1('div', 'leaflet-control-attribution');
		disableClickPropagation(this._container);

		// TODO ugly, refactor
		for (var i in map._layers) {
			if (map._layers[i].getAttribution) {
				this.addAttribution(map._layers[i].getAttribution());
			}
		}

		this._update();

		return this._container;
	},

	// @method setPrefix(prefix: String): this
	// Sets the text before the attributions.
	setPrefix: function (prefix) {
		this.options.prefix = prefix;
		this._update();
		return this;
	},

	// @method addAttribution(text: String): this
	// Adds an attribution text (e.g. `'Vector data &copy; Mapbox'`).
	addAttribution: function (text) {
		if (!text) { return this; }

		if (!this._attributions[text]) {
			this._attributions[text] = 0;
		}
		this._attributions[text]++;

		this._update();

		return this;
	},

	// @method removeAttribution(text: String): this
	// Removes an attribution text.
	removeAttribution: function (text) {
		if (!text) { return this; }

		if (this._attributions[text]) {
			this._attributions[text]--;
			this._update();
		}

		return this;
	},

	_update: function () {
		if (!this._map) { return; }

		var attribs = [];

		for (var i in this._attributions) {
			if (this._attributions[i]) {
				attribs.push(i);
			}
		}

		var prefixAndAttribs = [];

		if (this.options.prefix) {
			prefixAndAttribs.push(this.options.prefix);
		}
		if (attribs.length) {
			prefixAndAttribs.push(attribs.join(', '));
		}

		this._container.innerHTML = prefixAndAttribs.join(' | ');
	}
});

// @namespace Map
// @section Control options
// @option attributionControl: Boolean = true
// Whether a [attribution control](#control-attribution) is added to the map by default.
Map.mergeOptions({
	attributionControl: true
});

Map.addInitHook(function () {
	if (this.options.attributionControl) {
		new Attribution().addTo(this);
	}
});

// @namespace Control.Attribution
// @factory L.control.attribution(options: Control.Attribution options)
// Creates an attribution control.
var attribution = function (options) {
	return new Attribution(options);
};

Control.Layers = Layers;
Control.Zoom = Zoom;
Control.Scale = Scale;
Control.Attribution = Attribution;

control.layers = layers;
control.zoom = zoom;
control.scale = scale;
control.attribution = attribution;

/*
	L.Handler is a base class for handler classes that are used internally to inject
	interaction features like dragging to classes like Map and Marker.
*/

// @class Handler
// @aka L.Handler
// Abstract class for map interaction handlers

var Handler = Class.extend({
	initialize: function (map) {
		this._map = map;
	},

	// @method enable(): this
	// Enables the handler
	enable: function () {
		if (this._enabled) { return this; }

		this._enabled = true;
		this.addHooks();
		return this;
	},

	// @method disable(): this
	// Disables the handler
	disable: function () {
		if (!this._enabled) { return this; }

		this._enabled = false;
		this.removeHooks();
		return this;
	},

	// @method enabled(): Boolean
	// Returns `true` if the handler is enabled
	enabled: function () {
		return !!this._enabled;
	}

	// @section Extension methods
	// Classes inheriting from `Handler` must implement the two following methods:
	// @method addHooks()
	// Called when the handler is enabled, should add event hooks.
	// @method removeHooks()
	// Called when the handler is disabled, should remove the event hooks added previously.
});

var Mixin = {Events: Events};

/*
 * @class Draggable
 * @aka L.Draggable
 * @inherits Evented
 *
 * A class for making DOM elements draggable (including touch support).
 * Used internally for map and marker dragging. Only works for elements
 * that were positioned with [`L.DomUtil.setPosition`](#domutil-setposition).
 *
 * @example
 * ```js
 * var draggable = new L.Draggable(elementToDrag);
 * draggable.enable();
 * ```
 */

var START = touch ? 'touchstart mousedown' : 'mousedown';
var END = {
	mousedown: 'mouseup',
	touchstart: 'touchend',
	pointerdown: 'touchend',
	MSPointerDown: 'touchend'
};
var MOVE = {
	mousedown: 'mousemove',
	touchstart: 'touchmove',
	pointerdown: 'touchmove',
	MSPointerDown: 'touchmove'
};


var Draggable = Evented.extend({

	options: {
		// @section
		// @aka Draggable options
		// @option clickTolerance: Number = 3
		// The max number of pixels a user can shift the mouse pointer during a click
		// for it to be considered a valid click (as opposed to a mouse drag).
		clickTolerance: 3
	},

	// @constructor L.Draggable(el: HTMLElement, dragHandle?: HTMLElement, preventOutline?: Boolean, options?: Draggable options)
	// Creates a `Draggable` object for moving `el` when you start dragging the `dragHandle` element (equals `el` itself by default).
	initialize: function (element, dragStartTarget, preventOutline$$1, options) {
		setOptions(this, options);

		this._element = element;
		this._dragStartTarget = dragStartTarget || element;
		this._preventOutline = preventOutline$$1;
	},

	// @method enable()
	// Enables the dragging ability
	enable: function () {
		if (this._enabled) { return; }

		on(this._dragStartTarget, START, this._onDown, this);

		this._enabled = true;
	},

	// @method disable()
	// Disables the dragging ability
	disable: function () {
		if (!this._enabled) { return; }

		// If we're currently dragging this draggable,
		// disabling it counts as first ending the drag.
		if (Draggable._dragging === this) {
			this.finishDrag();
		}

		off(this._dragStartTarget, START, this._onDown, this);

		this._enabled = false;
		this._moved = false;
	},

	_onDown: function (e) {
		// Ignore simulated events, since we handle both touch and
		// mouse explicitly; otherwise we risk getting duplicates of
		// touch events, see #4315.
		// Also ignore the event if disabled; this happens in IE11
		// under some circumstances, see #3666.
		if (e._simulated || !this._enabled) { return; }

		this._moved = false;

		if (hasClass(this._element, 'leaflet-zoom-anim')) { return; }

		if (Draggable._dragging || e.shiftKey || ((e.which !== 1) && (e.button !== 1) && !e.touches)) { return; }
		Draggable._dragging = this;  // Prevent dragging multiple objects at once.

		if (this._preventOutline) {
			preventOutline(this._element);
		}

		disableImageDrag();
		disableTextSelection();

		if (this._moving) { return; }

		// @event down: Event
		// Fired when a drag is about to start.
		this.fire('down');

		var first = e.touches ? e.touches[0] : e;

		this._startPoint = new Point(first.clientX, first.clientY);

		on(document, MOVE[e.type], this._onMove, this);
		on(document, END[e.type], this._onUp, this);
	},

	_onMove: function (e) {
		// Ignore simulated events, since we handle both touch and
		// mouse explicitly; otherwise we risk getting duplicates of
		// touch events, see #4315.
		// Also ignore the event if disabled; this happens in IE11
		// under some circumstances, see #3666.
		if (e._simulated || !this._enabled) { return; }

		if (e.touches && e.touches.length > 1) {
			this._moved = true;
			return;
		}

		var first = (e.touches && e.touches.length === 1 ? e.touches[0] : e),
		    newPoint = new Point(first.clientX, first.clientY),
		    offset = newPoint.subtract(this._startPoint);

		if (!offset.x && !offset.y) { return; }
		if (Math.abs(offset.x) + Math.abs(offset.y) < this.options.clickTolerance) { return; }

		preventDefault(e);

		if (!this._moved) {
			// @event dragstart: Event
			// Fired when a drag starts
			this.fire('dragstart');

			this._moved = true;
			this._startPos = getPosition(this._element).subtract(offset);

			addClass(document.body, 'leaflet-dragging');

			this._lastTarget = e.target || e.srcElement;
			// IE and Edge do not give the <use> element, so fetch it
			// if necessary
			if ((window.SVGElementInstance) && (this._lastTarget instanceof SVGElementInstance)) {
				this._lastTarget = this._lastTarget.correspondingUseElement;
			}
			addClass(this._lastTarget, 'leaflet-drag-target');
		}

		this._newPos = this._startPos.add(offset);
		this._moving = true;

		cancelAnimFrame(this._animRequest);
		this._lastEvent = e;
		this._animRequest = requestAnimFrame(this._updatePosition, this, true);
	},

	_updatePosition: function () {
		var e = {originalEvent: this._lastEvent};

		// @event predrag: Event
		// Fired continuously during dragging *before* each corresponding
		// update of the element's position.
		this.fire('predrag', e);
		setPosition(this._element, this._newPos);

		// @event drag: Event
		// Fired continuously during dragging.
		this.fire('drag', e);
	},

	_onUp: function (e) {
		// Ignore simulated events, since we handle both touch and
		// mouse explicitly; otherwise we risk getting duplicates of
		// touch events, see #4315.
		// Also ignore the event if disabled; this happens in IE11
		// under some circumstances, see #3666.
		if (e._simulated || !this._enabled) { return; }
		this.finishDrag();
	},

	finishDrag: function () {
		removeClass(document.body, 'leaflet-dragging');

		if (this._lastTarget) {
			removeClass(this._lastTarget, 'leaflet-drag-target');
			this._lastTarget = null;
		}

		for (var i in MOVE) {
			off(document, MOVE[i], this._onMove, this);
			off(document, END[i], this._onUp, this);
		}

		enableImageDrag();
		enableTextSelection();

		if (this._moved && this._moving) {
			// ensure drag is not fired after dragend
			cancelAnimFrame(this._animRequest);

			// @event dragend: DragEndEvent
			// Fired when the drag ends.
			this.fire('dragend', {
				distance: this._newPos.distanceTo(this._startPos)
			});
		}

		this._moving = false;
		Draggable._dragging = false;
	}

});

/*
 * @namespace LineUtil
 *
 * Various utility functions for polyine points processing, used by Leaflet internally to make polylines lightning-fast.
 */

// Simplify polyline with vertex reduction and Douglas-Peucker simplification.
// Improves rendering performance dramatically by lessening the number of points to draw.

// @function simplify(points: Point[], tolerance: Number): Point[]
// Dramatically reduces the number of points in a polyline while retaining
// its shape and returns a new array of simplified points, using the
// [Douglas-Peucker algorithm](http://en.wikipedia.org/wiki/Douglas-Peucker_algorithm).
// Used for a huge performance boost when processing/displaying Leaflet polylines for
// each zoom level and also reducing visual noise. tolerance affects the amount of
// simplification (lesser value means higher quality but slower and with more points).
// Also released as a separated micro-library [Simplify.js](http://mourner.github.com/simplify-js/).
function simplify(points, tolerance) {
	if (!tolerance || !points.length) {
		return points.slice();
	}

	var sqTolerance = tolerance * tolerance;

	    // stage 1: vertex reduction
	    points = _reducePoints(points, sqTolerance);

	    // stage 2: Douglas-Peucker simplification
	    points = _simplifyDP(points, sqTolerance);

	return points;
}

// @function pointToSegmentDistance(p: Point, p1: Point, p2: Point): Number
// Returns the distance between point `p` and segment `p1` to `p2`.
function pointToSegmentDistance(p, p1, p2) {
	return Math.sqrt(_sqClosestPointOnSegment(p, p1, p2, true));
}

// @function closestPointOnSegment(p: Point, p1: Point, p2: Point): Number
// Returns the closest point from a point `p` on a segment `p1` to `p2`.
function closestPointOnSegment(p, p1, p2) {
	return _sqClosestPointOnSegment(p, p1, p2);
}

// Douglas-Peucker simplification, see http://en.wikipedia.org/wiki/Douglas-Peucker_algorithm
function _simplifyDP(points, sqTolerance) {

	var len = points.length,
	    ArrayConstructor = typeof Uint8Array !== undefined + '' ? Uint8Array : Array,
	    markers = new ArrayConstructor(len);

	    markers[0] = markers[len - 1] = 1;

	_simplifyDPStep(points, markers, sqTolerance, 0, len - 1);

	var i,
	    newPoints = [];

	for (i = 0; i < len; i++) {
		if (markers[i]) {
			newPoints.push(points[i]);
		}
	}

	return newPoints;
}

function _simplifyDPStep(points, markers, sqTolerance, first, last) {

	var maxSqDist = 0,
	index, i, sqDist;

	for (i = first + 1; i <= last - 1; i++) {
		sqDist = _sqClosestPointOnSegment(points[i], points[first], points[last], true);

		if (sqDist > maxSqDist) {
			index = i;
			maxSqDist = sqDist;
		}
	}

	if (maxSqDist > sqTolerance) {
		markers[index] = 1;

		_simplifyDPStep(points, markers, sqTolerance, first, index);
		_simplifyDPStep(points, markers, sqTolerance, index, last);
	}
}

// reduce points that are too close to each other to a single point
function _reducePoints(points, sqTolerance) {
	var reducedPoints = [points[0]];

	for (var i = 1, prev = 0, len = points.length; i < len; i++) {
		if (_sqDist(points[i], points[prev]) > sqTolerance) {
			reducedPoints.push(points[i]);
			prev = i;
		}
	}
	if (prev < len - 1) {
		reducedPoints.push(points[len - 1]);
	}
	return reducedPoints;
}

var _lastCode;

// @function clipSegment(a: Point, b: Point, bounds: Bounds, useLastCode?: Boolean, round?: Boolean): Point[]|Boolean
// Clips the segment a to b by rectangular bounds with the
// [Cohen-Sutherland algorithm](https://en.wikipedia.org/wiki/Cohen%E2%80%93Sutherland_algorithm)
// (modifying the segment points directly!). Used by Leaflet to only show polyline
// points that are on the screen or near, increasing performance.
function clipSegment(a, b, bounds, useLastCode, round) {
	var codeA = useLastCode ? _lastCode : _getBitCode(a, bounds),
	    codeB = _getBitCode(b, bounds),

	    codeOut, p, newCode;

	    // save 2nd code to avoid calculating it on the next segment
	    _lastCode = codeB;

	while (true) {
		// if a,b is inside the clip window (trivial accept)
		if (!(codeA | codeB)) {
			return [a, b];
		}

		// if a,b is outside the clip window (trivial reject)
		if (codeA & codeB) {
			return false;
		}

		// other cases
		codeOut = codeA || codeB;
		p = _getEdgeIntersection(a, b, codeOut, bounds, round);
		newCode = _getBitCode(p, bounds);

		if (codeOut === codeA) {
			a = p;
			codeA = newCode;
		} else {
			b = p;
			codeB = newCode;
		}
	}
}

function _getEdgeIntersection(a, b, code, bounds, round) {
	var dx = b.x - a.x,
	    dy = b.y - a.y,
	    min = bounds.min,
	    max = bounds.max,
	    x, y;

	if (code & 8) { // top
		x = a.x + dx * (max.y - a.y) / dy;
		y = max.y;

	} else if (code & 4) { // bottom
		x = a.x + dx * (min.y - a.y) / dy;
		y = min.y;

	} else if (code & 2) { // right
		x = max.x;
		y = a.y + dy * (max.x - a.x) / dx;

	} else if (code & 1) { // left
		x = min.x;
		y = a.y + dy * (min.x - a.x) / dx;
	}

	return new Point(x, y, round);
}

function _getBitCode(p, bounds) {
	var code = 0;

	if (p.x < bounds.min.x) { // left
		code |= 1;
	} else if (p.x > bounds.max.x) { // right
		code |= 2;
	}

	if (p.y < bounds.min.y) { // bottom
		code |= 4;
	} else if (p.y > bounds.max.y) { // top
		code |= 8;
	}

	return code;
}

// square distance (to avoid unnecessary Math.sqrt calls)
function _sqDist(p1, p2) {
	var dx = p2.x - p1.x,
	    dy = p2.y - p1.y;
	return dx * dx + dy * dy;
}

// return closest point on segment or distance to that point
function _sqClosestPointOnSegment(p, p1, p2, sqDist) {
	var x = p1.x,
	    y = p1.y,
	    dx = p2.x - x,
	    dy = p2.y - y,
	    dot = dx * dx + dy * dy,
	    t;

	if (dot > 0) {
		t = ((p.x - x) * dx + (p.y - y) * dy) / dot;

		if (t > 1) {
			x = p2.x;
			y = p2.y;
		} else if (t > 0) {
			x += dx * t;
			y += dy * t;
		}
	}

	dx = p.x - x;
	dy = p.y - y;

	return sqDist ? dx * dx + dy * dy : new Point(x, y);
}


// @function isFlat(latlngs: LatLng[]): Boolean
// Returns true if `latlngs` is a flat array, false is nested.
function isFlat(latlngs) {
	return !isArray(latlngs[0]) || (typeof latlngs[0][0] !== 'object' && typeof latlngs[0][0] !== 'undefined');
}

function _flat(latlngs) {
	console.warn('Deprecated use of _flat, please use L.LineUtil.isFlat instead.');
	return isFlat(latlngs);
}


var LineUtil = (Object.freeze || Object)({
	simplify: simplify,
	pointToSegmentDistance: pointToSegmentDistance,
	closestPointOnSegment: closestPointOnSegment,
	clipSegment: clipSegment,
	_getEdgeIntersection: _getEdgeIntersection,
	_getBitCode: _getBitCode,
	_sqClosestPointOnSegment: _sqClosestPointOnSegment,
	isFlat: isFlat,
	_flat: _flat
});

/*
 * @namespace PolyUtil
 * Various utility functions for polygon geometries.
 */

/* @function clipPolygon(points: Point[], bounds: Bounds, round?: Boolean): Point[]
 * Clips the polygon geometry defined by the given `points` by the given bounds (using the [Sutherland-Hodgeman algorithm](https://en.wikipedia.org/wiki/Sutherland%E2%80%93Hodgman_algorithm)).
 * Used by Leaflet to only show polygon points that are on the screen or near, increasing
 * performance. Note that polygon points needs different algorithm for clipping
 * than polyline, so there's a seperate method for it.
 */
function clipPolygon(points, bounds, round) {
	var clippedPoints,
	    edges = [1, 4, 2, 8],
	    i, j, k,
	    a, b,
	    len, edge, p;

	for (i = 0, len = points.length; i < len; i++) {
		points[i]._code = _getBitCode(points[i], bounds);
	}

	// for each edge (left, bottom, right, top)
	for (k = 0; k < 4; k++) {
		edge = edges[k];
		clippedPoints = [];

		for (i = 0, len = points.length, j = len - 1; i < len; j = i++) {
			a = points[i];
			b = points[j];

			// if a is inside the clip window
			if (!(a._code & edge)) {
				// if b is outside the clip window (a->b goes out of screen)
				if (b._code & edge) {
					p = _getEdgeIntersection(b, a, edge, bounds, round);
					p._code = _getBitCode(p, bounds);
					clippedPoints.push(p);
				}
				clippedPoints.push(a);

			// else if b is inside the clip window (a->b enters the screen)
			} else if (!(b._code & edge)) {
				p = _getEdgeIntersection(b, a, edge, bounds, round);
				p._code = _getBitCode(p, bounds);
				clippedPoints.push(p);
			}
		}
		points = clippedPoints;
	}

	return points;
}


var PolyUtil = (Object.freeze || Object)({
	clipPolygon: clipPolygon
});

/*
 * @namespace Projection
 * @section
 * Leaflet comes with a set of already defined Projections out of the box:
 *
 * @projection L.Projection.LonLat
 *
 * Equirectangular, or Plate Carree projection — the most simple projection,
 * mostly used by GIS enthusiasts. Directly maps `x` as longitude, and `y` as
 * latitude. Also suitable for flat worlds, e.g. game maps. Used by the
 * `EPSG:4326` and `Simple` CRS.
 */

var LonLat = {
	project: function (latlng) {
		return new Point(latlng.lng, latlng.lat);
	},

	unproject: function (point) {
		return new LatLng(point.y, point.x);
	},

	bounds: new Bounds([-180, -90], [180, 90])
};

/*
 * @namespace Projection
 * @projection L.Projection.Mercator
 *
 * Elliptical Mercator projection — more complex than Spherical Mercator. Takes into account that Earth is a geoid, not a perfect sphere. Used by the EPSG:3395 CRS.
 */

var Mercator = {
	R: 6378137,
	R_MINOR: 6356752.314245179,

	bounds: new Bounds([-20037508.34279, -15496570.73972], [20037508.34279, 18764656.23138]),

	project: function (latlng) {
		var d = Math.PI / 180,
		    r = this.R,
		    y = latlng.lat * d,
		    tmp = this.R_MINOR / r,
		    e = Math.sqrt(1 - tmp * tmp),
		    con = e * Math.sin(y);

		var ts = Math.tan(Math.PI / 4 - y / 2) / Math.pow((1 - con) / (1 + con), e / 2);
		y = -r * Math.log(Math.max(ts, 1E-10));

		return new Point(latlng.lng * d * r, y);
	},

	unproject: function (point) {
		var d = 180 / Math.PI,
		    r = this.R,
		    tmp = this.R_MINOR / r,
		    e = Math.sqrt(1 - tmp * tmp),
		    ts = Math.exp(-point.y / r),
		    phi = Math.PI / 2 - 2 * Math.atan(ts);

		for (var i = 0, dphi = 0.1, con; i < 15 && Math.abs(dphi) > 1e-7; i++) {
			con = e * Math.sin(phi);
			con = Math.pow((1 - con) / (1 + con), e / 2);
			dphi = Math.PI / 2 - 2 * Math.atan(ts * con) - phi;
			phi += dphi;
		}

		return new LatLng(phi * d, point.x * d / r);
	}
};

/*
 * @class Projection

 * An object with methods for projecting geographical coordinates of the world onto
 * a flat surface (and back). See [Map projection](http://en.wikipedia.org/wiki/Map_projection).

 * @property bounds: Bounds
 * The bounds (specified in CRS units) where the projection is valid

 * @method project(latlng: LatLng): Point
 * Projects geographical coordinates into a 2D point.
 * Only accepts actual `L.LatLng` instances, not arrays.

 * @method unproject(point: Point): LatLng
 * The inverse of `project`. Projects a 2D point into a geographical location.
 * Only accepts actual `L.Point` instances, not arrays.

 */




var index = (Object.freeze || Object)({
	LonLat: LonLat,
	Mercator: Mercator,
	SphericalMercator: SphericalMercator
});

/*
 * @namespace CRS
 * @crs L.CRS.EPSG3395
 *
 * Rarely used by some commercial tile providers. Uses Elliptical Mercator projection.
 */
var EPSG3395 = extend({}, Earth, {
	code: 'EPSG:3395',
	projection: Mercator,

	transformation: (function () {
		var scale = 0.5 / (Math.PI * Mercator.R);
		return toTransformation(scale, 0.5, -scale, 0.5);
	}())
});

/*
 * @namespace CRS
 * @crs L.CRS.EPSG4326
 *
 * A common CRS among GIS enthusiasts. Uses simple Equirectangular projection.
 *
 * Leaflet 1.0.x complies with the [TMS coordinate scheme for EPSG:4326](https://wiki.osgeo.org/wiki/Tile_Map_Service_Specification#global-geodetic),
 * which is a breaking change from 0.7.x behaviour.  If you are using a `TileLayer`
 * with this CRS, ensure that there are two 256x256 pixel tiles covering the
 * whole earth at zoom level zero, and that the tile coordinate origin is (-180,+90),
 * or (-180,-90) for `TileLayer`s with [the `tms` option](#tilelayer-tms) set.
 */

var EPSG4326 = extend({}, Earth, {
	code: 'EPSG:4326',
	projection: LonLat,
	transformation: toTransformation(1 / 180, 1, -1 / 180, 0.5)
});

/*
 * @namespace CRS
 * @crs L.CRS.Simple
 *
 * A simple CRS that maps longitude and latitude into `x` and `y` directly.
 * May be used for maps of flat surfaces (e.g. game maps). Note that the `y`
 * axis should still be inverted (going from bottom to top). `distance()` returns
 * simple euclidean distance.
 */

var Simple = extend({}, CRS, {
	projection: LonLat,
	transformation: toTransformation(1, 0, -1, 0),

	scale: function (zoom) {
		return Math.pow(2, zoom);
	},

	zoom: function (scale) {
		return Math.log(scale) / Math.LN2;
	},

	distance: function (latlng1, latlng2) {
		var dx = latlng2.lng - latlng1.lng,
		    dy = latlng2.lat - latlng1.lat;

		return Math.sqrt(dx * dx + dy * dy);
	},

	infinite: true
});

CRS.Earth = Earth;
CRS.EPSG3395 = EPSG3395;
CRS.EPSG3857 = EPSG3857;
CRS.EPSG900913 = EPSG900913;
CRS.EPSG4326 = EPSG4326;
CRS.Simple = Simple;

/*
 * @class Layer
 * @inherits Evented
 * @aka L.Layer
 * @aka ILayer
 *
 * A set of methods from the Layer base class that all Leaflet layers use.
 * Inherits all methods, options and events from `L.Evented`.
 *
 * @example
 *
 * ```js
 * var layer = L.Marker(latlng).addTo(map);
 * layer.addTo(map);
 * layer.remove();
 * ```
 *
 * @event add: Event
 * Fired after the layer is added to a map
 *
 * @event remove: Event
 * Fired after the layer is removed from a map
 */


var Layer = Evented.extend({

	// Classes extending `L.Layer` will inherit the following options:
	options: {
		// @option pane: String = 'overlayPane'
		// By default the layer will be added to the map's [overlay pane](#map-overlaypane). Overriding this option will cause the layer to be placed on another pane by default.
		pane: 'overlayPane',

		// @option attribution: String = null
		// String to be shown in the attribution control, describes the layer data, e.g. "© Mapbox".
		attribution: null,

		bubblingMouseEvents: true
	},

	/* @section
	 * Classes extending `L.Layer` will inherit the following methods:
	 *
	 * @method addTo(map: Map|LayerGroup): this
	 * Adds the layer to the given map or layer group.
	 */
	addTo: function (map) {
		map.addLayer(this);
		return this;
	},

	// @method remove: this
	// Removes the layer from the map it is currently active on.
	remove: function () {
		return this.removeFrom(this._map || this._mapToAdd);
	},

	// @method removeFrom(map: Map): this
	// Removes the layer from the given map
	removeFrom: function (obj) {
		if (obj) {
			obj.removeLayer(this);
		}
		return this;
	},

	// @method getPane(name? : String): HTMLElement
	// Returns the `HTMLElement` representing the named pane on the map. If `name` is omitted, returns the pane for this layer.
	getPane: function (name) {
		return this._map.getPane(name ? (this.options[name] || name) : this.options.pane);
	},

	addInteractiveTarget: function (targetEl) {
		this._map._targets[stamp(targetEl)] = this;
		return this;
	},

	removeInteractiveTarget: function (targetEl) {
		delete this._map._targets[stamp(targetEl)];
		return this;
	},

	// @method getAttribution: String
	// Used by the `attribution control`, returns the [attribution option](#gridlayer-attribution).
	getAttribution: function () {
		return this.options.attribution;
	},

	_layerAdd: function (e) {
		var map = e.target;

		// check in case layer gets added and then removed before the map is ready
		if (!map.hasLayer(this)) { return; }

		this._map = map;
		this._zoomAnimated = map._zoomAnimated;

		if (this.getEvents) {
			var events = this.getEvents();
			map.on(events, this);
			this.once('remove', function () {
				map.off(events, this);
			}, this);
		}

		this.onAdd(map);

		if (this.getAttribution && map.attributionControl) {
			map.attributionControl.addAttribution(this.getAttribution());
		}

		this.fire('add');
		map.fire('layeradd', {layer: this});
	}
});

/* @section Extension methods
 * @uninheritable
 *
 * Every layer should extend from `L.Layer` and (re-)implement the following methods.
 *
 * @method onAdd(map: Map): this
 * Should contain code that creates DOM elements for the layer, adds them to `map panes` where they should belong and puts listeners on relevant map events. Called on [`map.addLayer(layer)`](#map-addlayer).
 *
 * @method onRemove(map: Map): this
 * Should contain all clean up code that removes the layer's elements from the DOM and removes listeners previously added in [`onAdd`](#layer-onadd). Called on [`map.removeLayer(layer)`](#map-removelayer).
 *
 * @method getEvents(): Object
 * This optional method should return an object like `{ viewreset: this._reset }` for [`addEventListener`](#evented-addeventlistener). The event handlers in this object will be automatically added and removed from the map with your layer.
 *
 * @method getAttribution(): String
 * This optional method should return a string containing HTML to be shown on the `Attribution control` whenever the layer is visible.
 *
 * @method beforeAdd(map: Map): this
 * Optional method. Called on [`map.addLayer(layer)`](#map-addlayer), before the layer is added to the map, before events are initialized, without waiting until the map is in a usable state. Use for early initialization only.
 */


/* @namespace Map
 * @section Layer events
 *
 * @event layeradd: LayerEvent
 * Fired when a new layer is added to the map.
 *
 * @event layerremove: LayerEvent
 * Fired when some layer is removed from the map
 *
 * @section Methods for Layers and Controls
 */
Map.include({
	// @method addLayer(layer: Layer): this
	// Adds the given layer to the map
	addLayer: function (layer) {
		if (!layer._layerAdd) {
			throw new Error('The provided object is not a Layer.');
		}

		var id = stamp(layer);
		if (this._layers[id]) { return this; }
		this._layers[id] = layer;

		layer._mapToAdd = this;

		if (layer.beforeAdd) {
			layer.beforeAdd(this);
		}

		this.whenReady(layer._layerAdd, layer);

		return this;
	},

	// @method removeLayer(layer: Layer): this
	// Removes the given layer from the map.
	removeLayer: function (layer) {
		var id = stamp(layer);

		if (!this._layers[id]) { return this; }

		if (this._loaded) {
			layer.onRemove(this);
		}

		if (layer.getAttribution && this.attributionControl) {
			this.attributionControl.removeAttribution(layer.getAttribution());
		}

		delete this._layers[id];

		if (this._loaded) {
			this.fire('layerremove', {layer: layer});
			layer.fire('remove');
		}

		layer._map = layer._mapToAdd = null;

		return this;
	},

	// @method hasLayer(layer: Layer): Boolean
	// Returns `true` if the given layer is currently added to the map
	hasLayer: function (layer) {
		return !!layer && (stamp(layer) in this._layers);
	},

	/* @method eachLayer(fn: Function, context?: Object): this
	 * Iterates over the layers of the map, optionally specifying context of the iterator function.
	 * ```
	 * map.eachLayer(function(layer){
	 *     layer.bindPopup('Hello');
	 * });
	 * ```
	 */
	eachLayer: function (method, context) {
		for (var i in this._layers) {
			method.call(context, this._layers[i]);
		}
		return this;
	},

	_addLayers: function (layers) {
		layers = layers ? (isArray(layers) ? layers : [layers]) : [];

		for (var i = 0, len = layers.length; i < len; i++) {
			this.addLayer(layers[i]);
		}
	},

	_addZoomLimit: function (layer) {
		if (isNaN(layer.options.maxZoom) || !isNaN(layer.options.minZoom)) {
			this._zoomBoundLayers[stamp(layer)] = layer;
			this._updateZoomLevels();
		}
	},

	_removeZoomLimit: function (layer) {
		var id = stamp(layer);

		if (this._zoomBoundLayers[id]) {
			delete this._zoomBoundLayers[id];
			this._updateZoomLevels();
		}
	},

	_updateZoomLevels: function () {
		var minZoom = Infinity,
		    maxZoom = -Infinity,
		    oldZoomSpan = this._getZoomSpan();

		for (var i in this._zoomBoundLayers) {
			var options = this._zoomBoundLayers[i].options;

			minZoom = options.minZoom === undefined ? minZoom : Math.min(minZoom, options.minZoom);
			maxZoom = options.maxZoom === undefined ? maxZoom : Math.max(maxZoom, options.maxZoom);
		}

		this._layersMaxZoom = maxZoom === -Infinity ? undefined : maxZoom;
		this._layersMinZoom = minZoom === Infinity ? undefined : minZoom;

		// @section Map state change events
		// @event zoomlevelschange: Event
		// Fired when the number of zoomlevels on the map is changed due
		// to adding or removing a layer.
		if (oldZoomSpan !== this._getZoomSpan()) {
			this.fire('zoomlevelschange');
		}

		if (this.options.maxZoom === undefined && this._layersMaxZoom && this.getZoom() > this._layersMaxZoom) {
			this.setZoom(this._layersMaxZoom);
		}
		if (this.options.minZoom === undefined && this._layersMinZoom && this.getZoom() < this._layersMinZoom) {
			this.setZoom(this._layersMinZoom);
		}
	}
});

/*
 * @class LayerGroup
 * @aka L.LayerGroup
 * @inherits Layer
 *
 * Used to group several layers and handle them as one. If you add it to the map,
 * any layers added or removed from the group will be added/removed on the map as
 * well. Extends `Layer`.
 *
 * @example
 *
 * ```js
 * L.layerGroup([marker1, marker2])
 * 	.addLayer(polyline)
 * 	.addTo(map);
 * ```
 */

var LayerGroup = Layer.extend({

	initialize: function (layers) {
		this._layers = {};

		var i, len;

		if (layers) {
			for (i = 0, len = layers.length; i < len; i++) {
				this.addLayer(layers[i]);
			}
		}
	},

	// @method addLayer(layer: Layer): this
	// Adds the given layer to the group.
	addLayer: function (layer) {
		var id = this.getLayerId(layer);

		this._layers[id] = layer;

		if (this._map) {
			this._map.addLayer(layer);
		}

		return this;
	},

	// @method removeLayer(layer: Layer): this
	// Removes the given layer from the group.
	// @alternative
	// @method removeLayer(id: Number): this
	// Removes the layer with the given internal ID from the group.
	removeLayer: function (layer) {
		var id = layer in this._layers ? layer : this.getLayerId(layer);

		if (this._map && this._layers[id]) {
			this._map.removeLayer(this._layers[id]);
		}

		delete this._layers[id];

		return this;
	},

	// @method hasLayer(layer: Layer): Boolean
	// Returns `true` if the given layer is currently added to the group.
	// @alternative
	// @method hasLayer(id: Number): Boolean
	// Returns `true` if the given internal ID is currently added to the group.
	hasLayer: function (layer) {
		return !!layer && (layer in this._layers || this.getLayerId(layer) in this._layers);
	},

	// @method clearLayers(): this
	// Removes all the layers from the group.
	clearLayers: function () {
		for (var i in this._layers) {
			this.removeLayer(this._layers[i]);
		}
		return this;
	},

	// @method invoke(methodName: String, …): this
	// Calls `methodName` on every layer contained in this group, passing any
	// additional parameters. Has no effect if the layers contained do not
	// implement `methodName`.
	invoke: function (methodName) {
		var args = Array.prototype.slice.call(arguments, 1),
		    i, layer;

		for (i in this._layers) {
			layer = this._layers[i];

			if (layer[methodName]) {
				layer[methodName].apply(layer, args);
			}
		}

		return this;
	},

	onAdd: function (map) {
		for (var i in this._layers) {
			map.addLayer(this._layers[i]);
		}
	},

	onRemove: function (map) {
		for (var i in this._layers) {
			map.removeLayer(this._layers[i]);
		}
	},

	// @method eachLayer(fn: Function, context?: Object): this
	// Iterates over the layers of the group, optionally specifying context of the iterator function.
	// ```js
	// group.eachLayer(function (layer) {
	// 	layer.bindPopup('Hello');
	// });
	// ```
	eachLayer: function (method, context) {
		for (var i in this._layers) {
			method.call(context, this._layers[i]);
		}
		return this;
	},

	// @method getLayer(id: Number): Layer
	// Returns the layer with the given internal ID.
	getLayer: function (id) {
		return this._layers[id];
	},

	// @method getLayers(): Layer[]
	// Returns an array of all the layers added to the group.
	getLayers: function () {
		var layers = [];

		for (var i in this._layers) {
			layers.push(this._layers[i]);
		}
		return layers;
	},

	// @method setZIndex(zIndex: Number): this
	// Calls `setZIndex` on every layer contained in this group, passing the z-index.
	setZIndex: function (zIndex) {
		return this.invoke('setZIndex', zIndex);
	},

	// @method getLayerId(layer: Layer): Number
	// Returns the internal ID for a layer
	getLayerId: function (layer) {
		return stamp(layer);
	}
});


// @factory L.layerGroup(layers?: Layer[])
// Create a layer group, optionally given an initial set of layers.
var layerGroup = function (layers) {
	return new LayerGroup(layers);
};

/*
 * @class FeatureGroup
 * @aka L.FeatureGroup
 * @inherits LayerGroup
 *
 * Extended `LayerGroup` that makes it easier to do the same thing to all its member layers:
 *  * [`bindPopup`](#layer-bindpopup) binds a popup to all of the layers at once (likewise with [`bindTooltip`](#layer-bindtooltip))
 *  * Events are propagated to the `FeatureGroup`, so if the group has an event
 * handler, it will handle events from any of the layers. This includes mouse events
 * and custom events.
 *  * Has `layeradd` and `layerremove` events
 *
 * @example
 *
 * ```js
 * L.featureGroup([marker1, marker2, polyline])
 * 	.bindPopup('Hello world!')
 * 	.on('click', function() { alert('Clicked on a member of the group!'); })
 * 	.addTo(map);
 * ```
 */

var FeatureGroup = LayerGroup.extend({

	addLayer: function (layer) {
		if (this.hasLayer(layer)) {
			return this;
		}

		layer.addEventParent(this);

		LayerGroup.prototype.addLayer.call(this, layer);

		// @event layeradd: LayerEvent
		// Fired when a layer is added to this `FeatureGroup`
		return this.fire('layeradd', {layer: layer});
	},

	removeLayer: function (layer) {
		if (!this.hasLayer(layer)) {
			return this;
		}
		if (layer in this._layers) {
			layer = this._layers[layer];
		}

		layer.removeEventParent(this);

		LayerGroup.prototype.removeLayer.call(this, layer);

		// @event layerremove: LayerEvent
		// Fired when a layer is removed from this `FeatureGroup`
		return this.fire('layerremove', {layer: layer});
	},

	// @method setStyle(style: Path options): this
	// Sets the given path options to each layer of the group that has a `setStyle` method.
	setStyle: function (style) {
		return this.invoke('setStyle', style);
	},

	// @method bringToFront(): this
	// Brings the layer group to the top of all other layers
	bringToFront: function () {
		return this.invoke('bringToFront');
	},

	// @method bringToBack(): this
	// Brings the layer group to the top of all other layers
	bringToBack: function () {
		return this.invoke('bringToBack');
	},

	// @method getBounds(): LatLngBounds
	// Returns the LatLngBounds of the Feature Group (created from bounds and coordinates of its children).
	getBounds: function () {
		var bounds = new LatLngBounds();

		for (var id in this._layers) {
			var layer = this._layers[id];
			bounds.extend(layer.getBounds ? layer.getBounds() : layer.getLatLng());
		}
		return bounds;
	}
});

// @factory L.featureGroup(layers: Layer[])
// Create a feature group, optionally given an initial set of layers.
var featureGroup = function (layers) {
	return new FeatureGroup(layers);
};

/*
 * @class Icon
 * @aka L.Icon
 *
 * Represents an icon to provide when creating a marker.
 *
 * @example
 *
 * ```js
 * var myIcon = L.icon({
 *     iconUrl: 'my-icon.png',
 *     iconRetinaUrl: 'my-icon@2x.png',
 *     iconSize: [38, 95],
 *     iconAnchor: [22, 94],
 *     popupAnchor: [-3, -76],
 *     shadowUrl: 'my-icon-shadow.png',
 *     shadowRetinaUrl: 'my-icon-shadow@2x.png',
 *     shadowSize: [68, 95],
 *     shadowAnchor: [22, 94]
 * });
 *
 * L.marker([50.505, 30.57], {icon: myIcon}).addTo(map);
 * ```
 *
 * `L.Icon.Default` extends `L.Icon` and is the blue icon Leaflet uses for markers by default.
 *
 */

var Icon = Class.extend({

	/* @section
	 * @aka Icon options
	 *
	 * @option iconUrl: String = null
	 * **(required)** The URL to the icon image (absolute or relative to your script path).
	 *
	 * @option iconRetinaUrl: String = null
	 * The URL to a retina sized version of the icon image (absolute or relative to your
	 * script path). Used for Retina screen devices.
	 *
	 * @option iconSize: Point = null
	 * Size of the icon image in pixels.
	 *
	 * @option iconAnchor: Point = null
	 * The coordinates of the "tip" of the icon (relative to its top left corner). The icon
	 * will be aligned so that this point is at the marker's geographical location. Centered
	 * by default if size is specified, also can be set in CSS with negative margins.
	 *
	 * @option popupAnchor: Point = null
	 * The coordinates of the point from which popups will "open", relative to the icon anchor.
	 *
	 * @option shadowUrl: String = null
	 * The URL to the icon shadow image. If not specified, no shadow image will be created.
	 *
	 * @option shadowRetinaUrl: String = null
	 *
	 * @option shadowSize: Point = null
	 * Size of the shadow image in pixels.
	 *
	 * @option shadowAnchor: Point = null
	 * The coordinates of the "tip" of the shadow (relative to its top left corner) (the same
	 * as iconAnchor if not specified).
	 *
	 * @option className: String = ''
	 * A custom class name to assign to both icon and shadow images. Empty by default.
	 */

	initialize: function (options) {
		setOptions(this, options);
	},

	// @method createIcon(oldIcon?: HTMLElement): HTMLElement
	// Called internally when the icon has to be shown, returns a `<img>` HTML element
	// styled according to the options.
	createIcon: function (oldIcon) {
		return this._createIcon('icon', oldIcon);
	},

	// @method createShadow(oldIcon?: HTMLElement): HTMLElement
	// As `createIcon`, but for the shadow beneath it.
	createShadow: function (oldIcon) {
		return this._createIcon('shadow', oldIcon);
	},

	_createIcon: function (name, oldIcon) {
		var src = this._getIconUrl(name);

		if (!src) {
			if (name === 'icon') {
				throw new Error('iconUrl not set in Icon options (see the docs).');
			}
			return null;
		}

		var img = this._createImg(src, oldIcon && oldIcon.tagName === 'IMG' ? oldIcon : null);
		this._setIconStyles(img, name);

		return img;
	},

	_setIconStyles: function (img, name) {
		var options = this.options;
		var sizeOption = options[name + 'Size'];

		if (typeof sizeOption === 'number') {
			sizeOption = [sizeOption, sizeOption];
		}

		var size = toPoint(sizeOption),
		    anchor = toPoint(name === 'shadow' && options.shadowAnchor || options.iconAnchor ||
		            size && size.divideBy(2, true));

		img.className = 'leaflet-marker-' + name + ' ' + (options.className || '');

		if (anchor) {
			img.style.marginLeft = (-anchor.x) + 'px';
			img.style.marginTop  = (-anchor.y) + 'px';
		}

		if (size) {
			img.style.width  = size.x + 'px';
			img.style.height = size.y + 'px';
		}
	},

	_createImg: function (src, el) {
		el = el || document.createElement('img');
		el.src = src;
		return el;
	},

	_getIconUrl: function (name) {
		return retina && this.options[name + 'RetinaUrl'] || this.options[name + 'Url'];
	}
});


// @factory L.icon(options: Icon options)
// Creates an icon instance with the given options.
function icon(options) {
	return new Icon(options);
}

/*
 * @miniclass Icon.Default (Icon)
 * @aka L.Icon.Default
 * @section
 *
 * A trivial subclass of `Icon`, represents the icon to use in `Marker`s when
 * no icon is specified. Points to the blue marker image distributed with Leaflet
 * releases.
 *
 * In order to customize the default icon, just change the properties of `L.Icon.Default.prototype.options`
 * (which is a set of `Icon options`).
 *
 * If you want to _completely_ replace the default icon, override the
 * `L.Marker.prototype.options.icon` with your own icon instead.
 */

var IconDefault = Icon.extend({

	options: {
		iconUrl:       'marker-icon.png',
		iconRetinaUrl: 'marker-icon-2x.png',
		shadowUrl:     'marker-shadow.png',
		iconSize:    [25, 41],
		iconAnchor:  [12, 41],
		popupAnchor: [1, -34],
		tooltipAnchor: [16, -28],
		shadowSize:  [41, 41]
	},

	_getIconUrl: function (name) {
		if (!IconDefault.imagePath) {	// Deprecated, backwards-compatibility only
			IconDefault.imagePath = this._detectIconPath();
		}

		// @option imagePath: String
		// `Icon.Default` will try to auto-detect the absolute location of the
		// blue icon images. If you are placing these images in a non-standard
		// way, set this option to point to the right absolute path.
		return (this.options.imagePath || IconDefault.imagePath) + Icon.prototype._getIconUrl.call(this, name);
	},

	_detectIconPath: function () {
		var el = create$1('div',  'leaflet-default-icon-path', document.body);
		var path = getStyle(el, 'background-image') ||
		           getStyle(el, 'backgroundImage');	// IE8

		document.body.removeChild(el);

		if (path === null || path.indexOf('url') !== 0) {
			path = '';
		} else {
			path = path.replace(/^url\([\"\']?/, '').replace(/marker-icon\.png[\"\']?\)$/, '');
		}

		return path;
	}
});

/*
 * L.Handler.MarkerDrag is used internally by L.Marker to make the markers draggable.
 */


/* @namespace Marker
 * @section Interaction handlers
 *
 * Interaction handlers are properties of a marker instance that allow you to control interaction behavior in runtime, enabling or disabling certain features such as dragging (see `Handler` methods). Example:
 *
 * ```js
 * marker.dragging.disable();
 * ```
 *
 * @property dragging: Handler
 * Marker dragging handler (by both mouse and touch). Only valid when the marker is on the map (Otherwise set [`marker.options.draggable`](#marker-draggable)).
 */

var MarkerDrag = Handler.extend({
	initialize: function (marker) {
		this._marker = marker;
	},

	addHooks: function () {
		var icon = this._marker._icon;

		if (!this._draggable) {
			this._draggable = new Draggable(icon, icon, true);
		}

		this._draggable.on({
			dragstart: this._onDragStart,
			drag: this._onDrag,
			dragend: this._onDragEnd
		}, this).enable();

		addClass(icon, 'leaflet-marker-draggable');
	},

	removeHooks: function () {
		this._draggable.off({
			dragstart: this._onDragStart,
			drag: this._onDrag,
			dragend: this._onDragEnd
		}, this).disable();

		if (this._marker._icon) {
			removeClass(this._marker._icon, 'leaflet-marker-draggable');
		}
	},

	moved: function () {
		return this._draggable && this._draggable._moved;
	},

	_onDragStart: function () {
		// @section Dragging events
		// @event dragstart: Event
		// Fired when the user starts dragging the marker.

		// @event movestart: Event
		// Fired when the marker starts moving (because of dragging).

		this._oldLatLng = this._marker.getLatLng();
		this._marker
		    .closePopup()
		    .fire('movestart')
		    .fire('dragstart');
	},

	_onDrag: function (e) {
		var marker = this._marker,
		    shadow = marker._shadow,
		iconPos = getPosition(marker._icon),
		    latlng = marker._map.layerPointToLatLng(iconPos);

		// update shadow position
		if (shadow) {
			setPosition(shadow, iconPos);
		}

		marker._latlng = latlng;
		e.latlng = latlng;
		e.oldLatLng = this._oldLatLng;

		// @event drag: Event
		// Fired repeatedly while the user drags the marker.
		marker
		    .fire('move', e)
		    .fire('drag', e);
	},

	_onDragEnd: function (e) {
		// @event dragend: DragEndEvent
		// Fired when the user stops dragging the marker.

		// @event moveend: Event
		// Fired when the marker stops moving (because of dragging).
		delete this._oldLatLng;
		this._marker
		    .fire('moveend')
		    .fire('dragend', e);
	}
});

/*
 * @class Marker
 * @inherits Interactive layer
 * @aka L.Marker
 * L.Marker is used to display clickable/draggable icons on the map. Extends `Layer`.
 *
 * @example
 *
 * ```js
 * L.marker([50.5, 30.5]).addTo(map);
 * ```
 */

var Marker = Layer.extend({

	// @section
	// @aka Marker options
	options: {
		// @option icon: Icon = *
		// Icon instance to use for rendering the marker.
		// See [Icon documentation](#L.Icon) for details on how to customize the marker icon.
		// If not specified, a common instance of `L.Icon.Default` is used.
		icon: new IconDefault(),

		// Option inherited from "Interactive layer" abstract class
		interactive: true,

		// @option draggable: Boolean = false
		// Whether the marker is draggable with mouse/touch or not.
		draggable: false,

		// @option keyboard: Boolean = true
		// Whether the marker can be tabbed to with a keyboard and clicked by pressing enter.
		keyboard: true,

		// @option title: String = ''
		// Text for the browser tooltip that appear on marker hover (no tooltip by default).
		title: '',

		// @option alt: String = ''
		// Text for the `alt` attribute of the icon image (useful for accessibility).
		alt: '',

		// @option zIndexOffset: Number = 0
		// By default, marker images zIndex is set automatically based on its latitude. Use this option if you want to put the marker on top of all others (or below), specifying a high value like `1000` (or high negative value, respectively).
		zIndexOffset: 0,

		// @option opacity: Number = 1.0
		// The opacity of the marker.
		opacity: 1,

		// @option riseOnHover: Boolean = false
		// If `true`, the marker will get on top of others when you hover the mouse over it.
		riseOnHover: false,

		// @option riseOffset: Number = 250
		// The z-index offset used for the `riseOnHover` feature.
		riseOffset: 250,

		// @option pane: String = 'markerPane'
		// `Map pane` where the markers icon will be added.
		pane: 'markerPane',

		// @option bubblingMouseEvents: Boolean = false
		// When `true`, a mouse event on this marker will trigger the same event on the map
		// (unless [`L.DomEvent.stopPropagation`](#domevent-stoppropagation) is used).
		bubblingMouseEvents: false
	},

	/* @section
	 *
	 * In addition to [shared layer methods](#Layer) like `addTo()` and `remove()` and [popup methods](#Popup) like bindPopup() you can also use the following methods:
	 */

	initialize: function (latlng, options) {
		setOptions(this, options);
		this._latlng = toLatLng(latlng);
	},

	onAdd: function (map) {
		this._zoomAnimated = this._zoomAnimated && map.options.markerZoomAnimation;

		if (this._zoomAnimated) {
			map.on('zoomanim', this._animateZoom, this);
		}

		this._initIcon();
		this.update();
	},

	onRemove: function (map) {
		if (this.dragging && this.dragging.enabled()) {
			this.options.draggable = true;
			this.dragging.removeHooks();
		}
		delete this.dragging;

		if (this._zoomAnimated) {
			map.off('zoomanim', this._animateZoom, this);
		}

		this._removeIcon();
		this._removeShadow();
	},

	getEvents: function () {
		return {
			zoom: this.update,
			viewreset: this.update
		};
	},

	// @method getLatLng: LatLng
	// Returns the current geographical position of the marker.
	getLatLng: function () {
		return this._latlng;
	},

	// @method setLatLng(latlng: LatLng): this
	// Changes the marker position to the given point.
	setLatLng: function (latlng) {
		var oldLatLng = this._latlng;
		this._latlng = toLatLng(latlng);
		this.update();

		// @event move: Event
		// Fired when the marker is moved via [`setLatLng`](#marker-setlatlng) or by [dragging](#marker-dragging). Old and new coordinates are included in event arguments as `oldLatLng`, `latlng`.
		return this.fire('move', {oldLatLng: oldLatLng, latlng: this._latlng});
	},

	// @method setZIndexOffset(offset: Number): this
	// Changes the [zIndex offset](#marker-zindexoffset) of the marker.
	setZIndexOffset: function (offset) {
		this.options.zIndexOffset = offset;
		return this.update();
	},

	// @method setIcon(icon: Icon): this
	// Changes the marker icon.
	setIcon: function (icon) {

		this.options.icon = icon;

		if (this._map) {
			this._initIcon();
			this.update();
		}

		if (this._popup) {
			this.bindPopup(this._popup, this._popup.options);
		}

		return this;
	},

	getElement: function () {
		return this._icon;
	},

	update: function () {

		if (this._icon) {
			var pos = this._map.latLngToLayerPoint(this._latlng).round();
			this._setPos(pos);
		}

		return this;
	},

	_initIcon: function () {
		var options = this.options,
		    classToAdd = 'leaflet-zoom-' + (this._zoomAnimated ? 'animated' : 'hide');

		var icon = options.icon.createIcon(this._icon),
		    addIcon = false;

		// if we're not reusing the icon, remove the old one and init new one
		if (icon !== this._icon) {
			if (this._icon) {
				this._removeIcon();
			}
			addIcon = true;

			if (options.title) {
				icon.title = options.title;
			}
			if (options.alt) {
				icon.alt = options.alt;
			}
		}

		addClass(icon, classToAdd);

		if (options.keyboard) {
			icon.tabIndex = '0';
		}

		this._icon = icon;

		if (options.riseOnHover) {
			this.on({
				mouseover: this._bringToFront,
				mouseout: this._resetZIndex
			});
		}

		var newShadow = options.icon.createShadow(this._shadow),
		    addShadow = false;

		if (newShadow !== this._shadow) {
			this._removeShadow();
			addShadow = true;
		}

		if (newShadow) {
			addClass(newShadow, classToAdd);
			newShadow.alt = '';
		}
		this._shadow = newShadow;


		if (options.opacity < 1) {
			this._updateOpacity();
		}


		if (addIcon) {
			this.getPane().appendChild(this._icon);
		}
		this._initInteraction();
		if (newShadow && addShadow) {
			this.getPane('shadowPane').appendChild(this._shadow);
		}
	},

	_removeIcon: function () {
		if (this.options.riseOnHover) {
			this.off({
				mouseover: this._bringToFront,
				mouseout: this._resetZIndex
			});
		}

		remove(this._icon);
		this.removeInteractiveTarget(this._icon);

		this._icon = null;
	},

	_removeShadow: function () {
		if (this._shadow) {
			remove(this._shadow);
		}
		this._shadow = null;
	},

	_setPos: function (pos) {
		setPosition(this._icon, pos);

		if (this._shadow) {
			setPosition(this._shadow, pos);
		}

		this._zIndex = pos.y + this.options.zIndexOffset;

		this._resetZIndex();
	},

	_updateZIndex: function (offset) {
		this._icon.style.zIndex = this._zIndex + offset;
	},

	_animateZoom: function (opt) {
		var pos = this._map._latLngToNewLayerPoint(this._latlng, opt.zoom, opt.center).round();

		this._setPos(pos);
	},

	_initInteraction: function () {

		if (!this.options.interactive) { return; }

		addClass(this._icon, 'leaflet-interactive');

		this.addInteractiveTarget(this._icon);

		if (MarkerDrag) {
			var draggable = this.options.draggable;
			if (this.dragging) {
				draggable = this.dragging.enabled();
				this.dragging.disable();
			}

			this.dragging = new MarkerDrag(this);

			if (draggable) {
				this.dragging.enable();
			}
		}
	},

	// @method setOpacity(opacity: Number): this
	// Changes the opacity of the marker.
	setOpacity: function (opacity) {
		this.options.opacity = opacity;
		if (this._map) {
			this._updateOpacity();
		}

		return this;
	},

	_updateOpacity: function () {
		var opacity = this.options.opacity;

		setOpacity(this._icon, opacity);

		if (this._shadow) {
			setOpacity(this._shadow, opacity);
		}
	},

	_bringToFront: function () {
		this._updateZIndex(this.options.riseOffset);
	},

	_resetZIndex: function () {
		this._updateZIndex(0);
	},

	_getPopupAnchor: function () {
		return this.options.icon.options.popupAnchor || [0, 0];
	},

	_getTooltipAnchor: function () {
		return this.options.icon.options.tooltipAnchor || [0, 0];
	}
});


// factory L.marker(latlng: LatLng, options? : Marker options)

// @factory L.marker(latlng: LatLng, options? : Marker options)
// Instantiates a Marker object given a geographical point and optionally an options object.
function marker(latlng, options) {
	return new Marker(latlng, options);
}

/*
 * @class Path
 * @aka L.Path
 * @inherits Interactive layer
 *
 * An abstract class that contains options and constants shared between vector
 * overlays (Polygon, Polyline, Circle). Do not use it directly. Extends `Layer`.
 */

var Path = Layer.extend({

	// @section
	// @aka Path options
	options: {
		// @option stroke: Boolean = true
		// Whether to draw stroke along the path. Set it to `false` to disable borders on polygons or circles.
		stroke: true,

		// @option color: String = '#3388ff'
		// Stroke color
		color: '#3388ff',

		// @option weight: Number = 3
		// Stroke width in pixels
		weight: 3,

		// @option opacity: Number = 1.0
		// Stroke opacity
		opacity: 1,

		// @option lineCap: String= 'round'
		// A string that defines [shape to be used at the end](https://developer.mozilla.org/docs/Web/SVG/Attribute/stroke-linecap) of the stroke.
		lineCap: 'round',

		// @option lineJoin: String = 'round'
		// A string that defines [shape to be used at the corners](https://developer.mozilla.org/docs/Web/SVG/Attribute/stroke-linejoin) of the stroke.
		lineJoin: 'round',

		// @option dashArray: String = null
		// A string that defines the stroke [dash pattern](https://developer.mozilla.org/docs/Web/SVG/Attribute/stroke-dasharray). Doesn't work on `Canvas`-powered layers in [some old browsers](https://developer.mozilla.org/docs/Web/API/CanvasRenderingContext2D/setLineDash#Browser_compatibility).
		dashArray: null,

		// @option dashOffset: String = null
		// A string that defines the [distance into the dash pattern to start the dash](https://developer.mozilla.org/docs/Web/SVG/Attribute/stroke-dashoffset). Doesn't work on `Canvas`-powered layers in [some old browsers](https://developer.mozilla.org/docs/Web/API/CanvasRenderingContext2D/setLineDash#Browser_compatibility).
		dashOffset: null,

		// @option fill: Boolean = depends
		// Whether to fill the path with color. Set it to `false` to disable filling on polygons or circles.
		fill: false,

		// @option fillColor: String = *
		// Fill color. Defaults to the value of the [`color`](#path-color) option
		fillColor: null,

		// @option fillOpacity: Number = 0.2
		// Fill opacity.
		fillOpacity: 0.2,

		// @option fillRule: String = 'evenodd'
		// A string that defines [how the inside of a shape](https://developer.mozilla.org/docs/Web/SVG/Attribute/fill-rule) is determined.
		fillRule: 'evenodd',

		// className: '',

		// Option inherited from "Interactive layer" abstract class
		interactive: true,

		// @option bubblingMouseEvents: Boolean = true
		// When `true`, a mouse event on this path will trigger the same event on the map
		// (unless [`L.DomEvent.stopPropagation`](#domevent-stoppropagation) is used).
		bubblingMouseEvents: true
	},

	beforeAdd: function (map) {
		// Renderer is set here because we need to call renderer.getEvents
		// before this.getEvents.
		this._renderer = map.getRenderer(this);
	},

	onAdd: function () {
		this._renderer._initPath(this);
		this._reset();
		this._renderer._addPath(this);
	},

	onRemove: function () {
		this._renderer._removePath(this);
	},

	// @method redraw(): this
	// Redraws the layer. Sometimes useful after you changed the coordinates that the path uses.
	redraw: function () {
		if (this._map) {
			this._renderer._updatePath(this);
		}
		return this;
	},

	// @method setStyle(style: Path options): this
	// Changes the appearance of a Path based on the options in the `Path options` object.
	setStyle: function (style) {
		setOptions(this, style);
		if (this._renderer) {
			this._renderer._updateStyle(this);
		}
		return this;
	},

	// @method bringToFront(): this
	// Brings the layer to the top of all path layers.
	bringToFront: function () {
		if (this._renderer) {
			this._renderer._bringToFront(this);
		}
		return this;
	},

	// @method bringToBack(): this
	// Brings the layer to the bottom of all path layers.
	bringToBack: function () {
		if (this._renderer) {
			this._renderer._bringToBack(this);
		}
		return this;
	},

	getElement: function () {
		return this._path;
	},

	_reset: function () {
		// defined in child classes
		this._project();
		this._update();
	},

	_clickTolerance: function () {
		// used when doing hit detection for Canvas layers
		return (this.options.stroke ? this.options.weight / 2 : 0) + (touch ? 10 : 0);
	}
});

/*
 * @class CircleMarker
 * @aka L.CircleMarker
 * @inherits Path
 *
 * A circle of a fixed size with radius specified in pixels. Extends `Path`.
 */

var CircleMarker = Path.extend({

	// @section
	// @aka CircleMarker options
	options: {
		fill: true,

		// @option radius: Number = 10
		// Radius of the circle marker, in pixels
		radius: 10
	},

	initialize: function (latlng, options) {
		setOptions(this, options);
		this._latlng = toLatLng(latlng);
		this._radius = this.options.radius;
	},

	// @method setLatLng(latLng: LatLng): this
	// Sets the position of a circle marker to a new location.
	setLatLng: function (latlng) {
		this._latlng = toLatLng(latlng);
		this.redraw();
		return this.fire('move', {latlng: this._latlng});
	},

	// @method getLatLng(): LatLng
	// Returns the current geographical position of the circle marker
	getLatLng: function () {
		return this._latlng;
	},

	// @method setRadius(radius: Number): this
	// Sets the radius of a circle marker. Units are in pixels.
	setRadius: function (radius) {
		this.options.radius = this._radius = radius;
		return this.redraw();
	},

	// @method getRadius(): Number
	// Returns the current radius of the circle
	getRadius: function () {
		return this._radius;
	},

	setStyle : function (options) {
		var radius = options && options.radius || this._radius;
		Path.prototype.setStyle.call(this, options);
		this.setRadius(radius);
		return this;
	},

	_project: function () {
		this._point = this._map.latLngToLayerPoint(this._latlng);
		this._updateBounds();
	},

	_updateBounds: function () {
		var r = this._radius,
		    r2 = this._radiusY || r,
		    w = this._clickTolerance(),
		    p = [r + w, r2 + w];
		this._pxBounds = new Bounds(this._point.subtract(p), this._point.add(p));
	},

	_update: function () {
		if (this._map) {
			this._updatePath();
		}
	},

	_updatePath: function () {
		this._renderer._updateCircle(this);
	},

	_empty: function () {
		return this._radius && !this._renderer._bounds.intersects(this._pxBounds);
	},

	// Needed by the `Canvas` renderer for interactivity
	_containsPoint: function (p) {
		return p.distanceTo(this._point) <= this._radius + this._clickTolerance();
	}
});


// @factory L.circleMarker(latlng: LatLng, options?: CircleMarker options)
// Instantiates a circle marker object given a geographical point, and an optional options object.
function circleMarker(latlng, options) {
	return new CircleMarker(latlng, options);
}

/*
 * @class Circle
 * @aka L.Circle
 * @inherits CircleMarker
 *
 * A class for drawing circle overlays on a map. Extends `CircleMarker`.
 *
 * It's an approximation and starts to diverge from a real circle closer to poles (due to projection distortion).
 *
 * @example
 *
 * ```js
 * L.circle([50.5, 30.5], {radius: 200}).addTo(map);
 * ```
 */

var Circle = CircleMarker.extend({

	initialize: function (latlng, options, legacyOptions) {
		if (typeof options === 'number') {
			// Backwards compatibility with 0.7.x factory (latlng, radius, options?)
			options = extend({}, legacyOptions, {radius: options});
		}
		setOptions(this, options);
		this._latlng = toLatLng(latlng);

		if (isNaN(this.options.radius)) { throw new Error('Circle radius cannot be NaN'); }

		// @section
		// @aka Circle options
		// @option radius: Number; Radius of the circle, in meters.
		this._mRadius = this.options.radius;
	},

	// @method setRadius(radius: Number): this
	// Sets the radius of a circle. Units are in meters.
	setRadius: function (radius) {
		this._mRadius = radius;
		return this.redraw();
	},

	// @method getRadius(): Number
	// Returns the current radius of a circle. Units are in meters.
	getRadius: function () {
		return this._mRadius;
	},

	// @method getBounds(): LatLngBounds
	// Returns the `LatLngBounds` of the path.
	getBounds: function () {
		var half = [this._radius, this._radiusY || this._radius];

		return new LatLngBounds(
			this._map.layerPointToLatLng(this._point.subtract(half)),
			this._map.layerPointToLatLng(this._point.add(half)));
	},

	setStyle: Path.prototype.setStyle,

	_project: function () {

		var lng = this._latlng.lng,
		    lat = this._latlng.lat,
		    map = this._map,
		    crs = map.options.crs;

		if (crs.distance === Earth.distance) {
			var d = Math.PI / 180,
			    latR = (this._mRadius / Earth.R) / d,
			    top = map.project([lat + latR, lng]),
			    bottom = map.project([lat - latR, lng]),
			    p = top.add(bottom).divideBy(2),
			    lat2 = map.unproject(p).lat,
			    lngR = Math.acos((Math.cos(latR * d) - Math.sin(lat * d) * Math.sin(lat2 * d)) /
			            (Math.cos(lat * d) * Math.cos(lat2 * d))) / d;

			if (isNaN(lngR) || lngR === 0) {
				lngR = latR / Math.cos(Math.PI / 180 * lat); // Fallback for edge case, #2425
			}

			this._point = p.subtract(map.getPixelOrigin());
			this._radius = isNaN(lngR) ? 0 : Math.max(Math.round(p.x - map.project([lat2, lng - lngR]).x), 1);
			this._radiusY = Math.max(Math.round(p.y - top.y), 1);

		} else {
			var latlng2 = crs.unproject(crs.project(this._latlng).subtract([this._mRadius, 0]));

			this._point = map.latLngToLayerPoint(this._latlng);
			this._radius = this._point.x - map.latLngToLayerPoint(latlng2).x;
		}

		this._updateBounds();
	}
});

// @factory L.circle(latlng: LatLng, options?: Circle options)
// Instantiates a circle object given a geographical point, and an options object
// which contains the circle radius.
// @alternative
// @factory L.circle(latlng: LatLng, radius: Number, options?: Circle options)
// Obsolete way of instantiating a circle, for compatibility with 0.7.x code.
// Do not use in new applications or plugins.
function circle(latlng, options, legacyOptions) {
	return new Circle(latlng, options, legacyOptions);
}

/*
 * @class Polyline
 * @aka L.Polyline
 * @inherits Path
 *
 * A class for drawing polyline overlays on a map. Extends `Path`.
 *
 * @example
 *
 * ```js
 * // create a red polyline from an array of LatLng points
 * var latlngs = [
 * 	[45.51, -122.68],
 * 	[37.77, -122.43],
 * 	[34.04, -118.2]
 * ];
 *
 * var polyline = L.polyline(latlngs, {color: 'red'}).addTo(map);
 *
 * // zoom the map to the polyline
 * map.fitBounds(polyline.getBounds());
 * ```
 *
 * You can also pass a multi-dimensional array to represent a `MultiPolyline` shape:
 *
 * ```js
 * // create a red polyline from an array of arrays of LatLng points
 * var latlngs = [
 * 	[[45.51, -122.68],
 * 	 [37.77, -122.43],
 * 	 [34.04, -118.2]],
 * 	[[40.78, -73.91],
 * 	 [41.83, -87.62],
 * 	 [32.76, -96.72]]
 * ];
 * ```
 */


var Polyline = Path.extend({

	// @section
	// @aka Polyline options
	options: {
		// @option smoothFactor: Number = 1.0
		// How much to simplify the polyline on each zoom level. More means
		// better performance and smoother look, and less means more accurate representation.
		smoothFactor: 1.0,

		// @option noClip: Boolean = false
		// Disable polyline clipping.
		noClip: false
	},

	initialize: function (latlngs, options) {
		setOptions(this, options);
		this._setLatLngs(latlngs);
	},

	// @method getLatLngs(): LatLng[]
	// Returns an array of the points in the path, or nested arrays of points in case of multi-polyline.
	getLatLngs: function () {
		return this._latlngs;
	},

	// @method setLatLngs(latlngs: LatLng[]): this
	// Replaces all the points in the polyline with the given array of geographical points.
	setLatLngs: function (latlngs) {
		this._setLatLngs(latlngs);
		return this.redraw();
	},

	// @method isEmpty(): Boolean
	// Returns `true` if the Polyline has no LatLngs.
	isEmpty: function () {
		return !this._latlngs.length;
	},

	closestLayerPoint: function (p) {
		var minDistance = Infinity,
		    minPoint = null,
		    closest = _sqClosestPointOnSegment,
		    p1, p2;

		for (var j = 0, jLen = this._parts.length; j < jLen; j++) {
			var points = this._parts[j];

			for (var i = 1, len = points.length; i < len; i++) {
				p1 = points[i - 1];
				p2 = points[i];

				var sqDist = closest(p, p1, p2, true);

				if (sqDist < minDistance) {
					minDistance = sqDist;
					minPoint = closest(p, p1, p2);
				}
			}
		}
		if (minPoint) {
			minPoint.distance = Math.sqrt(minDistance);
		}
		return minPoint;
	},

	// @method getCenter(): LatLng
	// Returns the center ([centroid](http://en.wikipedia.org/wiki/Centroid)) of the polyline.
	getCenter: function () {
		// throws error when not yet added to map as this center calculation requires projected coordinates
		if (!this._map) {
			throw new Error('Must add layer to map before using getCenter()');
		}

		var i, halfDist, segDist, dist, p1, p2, ratio,
		    points = this._rings[0],
		    len = points.length;

		if (!len) { return null; }

		// polyline centroid algorithm; only uses the first ring if there are multiple

		for (i = 0, halfDist = 0; i < len - 1; i++) {
			halfDist += points[i].distanceTo(points[i + 1]) / 2;
		}

		// The line is so small in the current view that all points are on the same pixel.
		if (halfDist === 0) {
			return this._map.layerPointToLatLng(points[0]);
		}

		for (i = 0, dist = 0; i < len - 1; i++) {
			p1 = points[i];
			p2 = points[i + 1];
			segDist = p1.distanceTo(p2);
			dist += segDist;

			if (dist > halfDist) {
				ratio = (dist - halfDist) / segDist;
				return this._map.layerPointToLatLng([
					p2.x - ratio * (p2.x - p1.x),
					p2.y - ratio * (p2.y - p1.y)
				]);
			}
		}
	},

	// @method getBounds(): LatLngBounds
	// Returns the `LatLngBounds` of the path.
	getBounds: function () {
		return this._bounds;
	},

	// @method addLatLng(latlng: LatLng, latlngs? LatLng[]): this
	// Adds a given point to the polyline. By default, adds to the first ring of
	// the polyline in case of a multi-polyline, but can be overridden by passing
	// a specific ring as a LatLng array (that you can earlier access with [`getLatLngs`](#polyline-getlatlngs)).
	addLatLng: function (latlng, latlngs) {
		latlngs = latlngs || this._defaultShape();
		latlng = toLatLng(latlng);
		latlngs.push(latlng);
		this._bounds.extend(latlng);
		return this.redraw();
	},

	_setLatLngs: function (latlngs) {
		this._bounds = new LatLngBounds();
		this._latlngs = this._convertLatLngs(latlngs);
	},

	_defaultShape: function () {
		return isFlat(this._latlngs) ? this._latlngs : this._latlngs[0];
	},

	// recursively convert latlngs input into actual LatLng instances; calculate bounds along the way
	_convertLatLngs: function (latlngs) {
		var result = [],
		    flat = isFlat(latlngs);

		for (var i = 0, len = latlngs.length; i < len; i++) {
			if (flat) {
				result[i] = toLatLng(latlngs[i]);
				this._bounds.extend(result[i]);
			} else {
				result[i] = this._convertLatLngs(latlngs[i]);
			}
		}

		return result;
	},

	_project: function () {
		var pxBounds = new Bounds();
		this._rings = [];
		this._projectLatlngs(this._latlngs, this._rings, pxBounds);

		var w = this._clickTolerance(),
		    p = new Point(w, w);

		if (this._bounds.isValid() && pxBounds.isValid()) {
			pxBounds.min._subtract(p);
			pxBounds.max._add(p);
			this._pxBounds = pxBounds;
		}
	},

	// recursively turns latlngs into a set of rings with projected coordinates
	_projectLatlngs: function (latlngs, result, projectedBounds) {
		var flat = latlngs[0] instanceof LatLng,
		    len = latlngs.length,
		    i, ring;

		if (flat) {
			ring = [];
			for (i = 0; i < len; i++) {
				ring[i] = this._map.latLngToLayerPoint(latlngs[i]);
				projectedBounds.extend(ring[i]);
			}
			result.push(ring);
		} else {
			for (i = 0; i < len; i++) {
				this._projectLatlngs(latlngs[i], result, projectedBounds);
			}
		}
	},

	// clip polyline by renderer bounds so that we have less to render for performance
	_clipPoints: function () {
		var bounds = this._renderer._bounds;

		this._parts = [];
		if (!this._pxBounds || !this._pxBounds.intersects(bounds)) {
			return;
		}

		if (this.options.noClip) {
			this._parts = this._rings;
			return;
		}

		var parts = this._parts,
		    i, j, k, len, len2, segment, points;

		for (i = 0, k = 0, len = this._rings.length; i < len; i++) {
			points = this._rings[i];

			for (j = 0, len2 = points.length; j < len2 - 1; j++) {
				segment = clipSegment(points[j], points[j + 1], bounds, j, true);

				if (!segment) { continue; }

				parts[k] = parts[k] || [];
				parts[k].push(segment[0]);

				// if segment goes out of screen, or it's the last one, it's the end of the line part
				if ((segment[1] !== points[j + 1]) || (j === len2 - 2)) {
					parts[k].push(segment[1]);
					k++;
				}
			}
		}
	},

	// simplify each clipped part of the polyline for performance
	_simplifyPoints: function () {
		var parts = this._parts,
		    tolerance = this.options.smoothFactor;

		for (var i = 0, len = parts.length; i < len; i++) {
			parts[i] = simplify(parts[i], tolerance);
		}
	},

	_update: function () {
		if (!this._map) { return; }

		this._clipPoints();
		this._simplifyPoints();
		this._updatePath();
	},

	_updatePath: function () {
		this._renderer._updatePoly(this);
	},

	// Needed by the `Canvas` renderer for interactivity
	_containsPoint: function (p, closed) {
		var i, j, k, len, len2, part,
		    w = this._clickTolerance();

		if (!this._pxBounds || !this._pxBounds.contains(p)) { return false; }

		// hit detection for polylines
		for (i = 0, len = this._parts.length; i < len; i++) {
			part = this._parts[i];

			for (j = 0, len2 = part.length, k = len2 - 1; j < len2; k = j++) {
				if (!closed && (j === 0)) { continue; }

				if (pointToSegmentDistance(p, part[k], part[j]) <= w) {
					return true;
				}
			}
		}
		return false;
	}
});

// @factory L.polyline(latlngs: LatLng[], options?: Polyline options)
// Instantiates a polyline object given an array of geographical points and
// optionally an options object. You can create a `Polyline` object with
// multiple separate lines (`MultiPolyline`) by passing an array of arrays
// of geographic points.
function polyline(latlngs, options) {
	return new Polyline(latlngs, options);
}

// Retrocompat. Allow plugins to support Leaflet versions before and after 1.1.
Polyline._flat = _flat;

/*
 * @class Polygon
 * @aka L.Polygon
 * @inherits Polyline
 *
 * A class for drawing polygon overlays on a map. Extends `Polyline`.
 *
 * Note that points you pass when creating a polygon shouldn't have an additional last point equal to the first one — it's better to filter out such points.
 *
 *
 * @example
 *
 * ```js
 * // create a red polygon from an array of LatLng points
 * var latlngs = [[37, -109.05],[41, -109.03],[41, -102.05],[37, -102.04]];
 *
 * var polygon = L.polygon(latlngs, {color: 'red'}).addTo(map);
 *
 * // zoom the map to the polygon
 * map.fitBounds(polygon.getBounds());
 * ```
 *
 * You can also pass an array of arrays of latlngs, with the first array representing the outer shape and the other arrays representing holes in the outer shape:
 *
 * ```js
 * var latlngs = [
 *   [[37, -109.05],[41, -109.03],[41, -102.05],[37, -102.04]], // outer ring
 *   [[37.29, -108.58],[40.71, -108.58],[40.71, -102.50],[37.29, -102.50]] // hole
 * ];
 * ```
 *
 * Additionally, you can pass a multi-dimensional array to represent a MultiPolygon shape.
 *
 * ```js
 * var latlngs = [
 *   [ // first polygon
 *     [[37, -109.05],[41, -109.03],[41, -102.05],[37, -102.04]], // outer ring
 *     [[37.29, -108.58],[40.71, -108.58],[40.71, -102.50],[37.29, -102.50]] // hole
 *   ],
 *   [ // second polygon
 *     [[41, -111.03],[45, -111.04],[45, -104.05],[41, -104.05]]
 *   ]
 * ];
 * ```
 */

var Polygon = Polyline.extend({

	options: {
		fill: true
	},

	isEmpty: function () {
		return !this._latlngs.length || !this._latlngs[0].length;
	},

	getCenter: function () {
		// throws error when not yet added to map as this center calculation requires projected coordinates
		if (!this._map) {
			throw new Error('Must add layer to map before using getCenter()');
		}

		var i, j, p1, p2, f, area, x, y, center,
		    points = this._rings[0],
		    len = points.length;

		if (!len) { return null; }

		// polygon centroid algorithm; only uses the first ring if there are multiple

		area = x = y = 0;

		for (i = 0, j = len - 1; i < len; j = i++) {
			p1 = points[i];
			p2 = points[j];

			f = p1.y * p2.x - p2.y * p1.x;
			x += (p1.x + p2.x) * f;
			y += (p1.y + p2.y) * f;
			area += f * 3;
		}

		if (area === 0) {
			// Polygon is so small that all points are on same pixel.
			center = points[0];
		} else {
			center = [x / area, y / area];
		}
		return this._map.layerPointToLatLng(center);
	},

	_convertLatLngs: function (latlngs) {
		var result = Polyline.prototype._convertLatLngs.call(this, latlngs),
		    len = result.length;

		// remove last point if it equals first one
		if (len >= 2 && result[0] instanceof LatLng && result[0].equals(result[len - 1])) {
			result.pop();
		}
		return result;
	},

	_setLatLngs: function (latlngs) {
		Polyline.prototype._setLatLngs.call(this, latlngs);
		if (isFlat(this._latlngs)) {
			this._latlngs = [this._latlngs];
		}
	},

	_defaultShape: function () {
		return isFlat(this._latlngs[0]) ? this._latlngs[0] : this._latlngs[0][0];
	},

	_clipPoints: function () {
		// polygons need a different clipping algorithm so we redefine that

		var bounds = this._renderer._bounds,
		    w = this.options.weight,
		    p = new Point(w, w);

		// increase clip padding by stroke width to avoid stroke on clip edges
		bounds = new Bounds(bounds.min.subtract(p), bounds.max.add(p));

		this._parts = [];
		if (!this._pxBounds || !this._pxBounds.intersects(bounds)) {
			return;
		}

		if (this.options.noClip) {
			this._parts = this._rings;
			return;
		}

		for (var i = 0, len = this._rings.length, clipped; i < len; i++) {
			clipped = clipPolygon(this._rings[i], bounds, true);
			if (clipped.length) {
				this._parts.push(clipped);
			}
		}
	},

	_updatePath: function () {
		this._renderer._updatePoly(this, true);
	},

	// Needed by the `Canvas` renderer for interactivity
	_containsPoint: function (p) {
		var inside = false,
		    part, p1, p2, i, j, k, len, len2;

		if (!this._pxBounds.contains(p)) { return false; }

		// ray casting algorithm for detecting if point is in polygon
		for (i = 0, len = this._parts.length; i < len; i++) {
			part = this._parts[i];

			for (j = 0, len2 = part.length, k = len2 - 1; j < len2; k = j++) {
				p1 = part[j];
				p2 = part[k];

				if (((p1.y > p.y) !== (p2.y > p.y)) && (p.x < (p2.x - p1.x) * (p.y - p1.y) / (p2.y - p1.y) + p1.x)) {
					inside = !inside;
				}
			}
		}

		// also check if it's on polygon stroke
		return inside || Polyline.prototype._containsPoint.call(this, p, true);
	}

});


// @factory L.polygon(latlngs: LatLng[], options?: Polyline options)
function polygon(latlngs, options) {
	return new Polygon(latlngs, options);
}

/*
 * @class GeoJSON
 * @aka L.GeoJSON
 * @inherits FeatureGroup
 *
 * Represents a GeoJSON object or an array of GeoJSON objects. Allows you to parse
 * GeoJSON data and display it on the map. Extends `FeatureGroup`.
 *
 * @example
 *
 * ```js
 * L.geoJSON(data, {
 * 	style: function (feature) {
 * 		return {color: feature.properties.color};
 * 	}
 * }).bindPopup(function (layer) {
 * 	return layer.feature.properties.description;
 * }).addTo(map);
 * ```
 */

var GeoJSON = FeatureGroup.extend({

	/* @section
	 * @aka GeoJSON options
	 *
	 * @option pointToLayer: Function = *
	 * A `Function` defining how GeoJSON points spawn Leaflet layers. It is internally
	 * called when data is added, passing the GeoJSON point feature and its `LatLng`.
	 * The default is to spawn a default `Marker`:
	 * ```js
	 * function(geoJsonPoint, latlng) {
	 * 	return L.marker(latlng);
	 * }
	 * ```
	 *
	 * @option style: Function = *
	 * A `Function` defining the `Path options` for styling GeoJSON lines and polygons,
	 * called internally when data is added.
	 * The default value is to not override any defaults:
	 * ```js
	 * function (geoJsonFeature) {
	 * 	return {}
	 * }
	 * ```
	 *
	 * @option onEachFeature: Function = *
	 * A `Function` that will be called once for each created `Feature`, after it has
	 * been created and styled. Useful for attaching events and popups to features.
	 * The default is to do nothing with the newly created layers:
	 * ```js
	 * function (feature, layer) {}
	 * ```
	 *
	 * @option filter: Function = *
	 * A `Function` that will be used to decide whether to include a feature or not.
	 * The default is to include all features:
	 * ```js
	 * function (geoJsonFeature) {
	 * 	return true;
	 * }
	 * ```
	 * Note: dynamically changing the `filter` option will have effect only on newly
	 * added data. It will _not_ re-evaluate already included features.
	 *
	 * @option coordsToLatLng: Function = *
	 * A `Function` that will be used for converting GeoJSON coordinates to `LatLng`s.
	 * The default is the `coordsToLatLng` static method.
	 */

	initialize: function (geojson, options) {
		setOptions(this, options);

		this._layers = {};

		if (geojson) {
			this.addData(geojson);
		}
	},

	// @method addData( <GeoJSON> data ): this
	// Adds a GeoJSON object to the layer.
	addData: function (geojson) {
		var features = isArray(geojson) ? geojson : geojson.features,
		    i, len, feature;

		if (features) {
			for (i = 0, len = features.length; i < len; i++) {
				// only add this if geometry or geometries are set and not null
				feature = features[i];
				if (feature.geometries || feature.geometry || feature.features || feature.coordinates) {
					this.addData(feature);
				}
			}
			return this;
		}

		var options = this.options;

		if (options.filter && !options.filter(geojson)) { return this; }

		var layer = geometryToLayer(geojson, options);
		if (!layer) {
			return this;
		}
		layer.feature = asFeature(geojson);

		layer.defaultOptions = layer.options;
		this.resetStyle(layer);

		if (options.onEachFeature) {
			options.onEachFeature(geojson, layer);
		}

		return this.addLayer(layer);
	},

	// @method resetStyle( <Path> layer ): this
	// Resets the given vector layer's style to the original GeoJSON style, useful for resetting style after hover events.
	resetStyle: function (layer) {
		// reset any custom styles
		layer.options = extend({}, layer.defaultOptions);
		this._setLayerStyle(layer, this.options.style);
		return this;
	},

	// @method setStyle( <Function> style ): this
	// Changes styles of GeoJSON vector layers with the given style function.
	setStyle: function (style) {
		return this.eachLayer(function (layer) {
			this._setLayerStyle(layer, style);
		}, this);
	},

	_setLayerStyle: function (layer, style) {
		if (typeof style === 'function') {
			style = style(layer.feature);
		}
		if (layer.setStyle) {
			layer.setStyle(style);
		}
	}
});

// @section
// There are several static functions which can be called without instantiating L.GeoJSON:

// @function geometryToLayer(featureData: Object, options?: GeoJSON options): Layer
// Creates a `Layer` from a given GeoJSON feature. Can use a custom
// [`pointToLayer`](#geojson-pointtolayer) and/or [`coordsToLatLng`](#geojson-coordstolatlng)
// functions if provided as options.
function geometryToLayer(geojson, options) {

	var geometry = geojson.type === 'Feature' ? geojson.geometry : geojson,
	    coords = geometry ? geometry.coordinates : null,
	    layers = [],
	    pointToLayer = options && options.pointToLayer,
	    _coordsToLatLng = options && options.coordsToLatLng || coordsToLatLng,
	    latlng, latlngs, i, len;

	if (!coords && !geometry) {
		return null;
	}

	switch (geometry.type) {
	case 'Point':
		latlng = _coordsToLatLng(coords);
		return pointToLayer ? pointToLayer(geojson, latlng) : new Marker(latlng);

	case 'MultiPoint':
		for (i = 0, len = coords.length; i < len; i++) {
			latlng = _coordsToLatLng(coords[i]);
			layers.push(pointToLayer ? pointToLayer(geojson, latlng) : new Marker(latlng));
		}
		return new FeatureGroup(layers);

	case 'LineString':
	case 'MultiLineString':
		latlngs = coordsToLatLngs(coords, geometry.type === 'LineString' ? 0 : 1, _coordsToLatLng);
		return new Polyline(latlngs, options);

	case 'Polygon':
	case 'MultiPolygon':
		latlngs = coordsToLatLngs(coords, geometry.type === 'Polygon' ? 1 : 2, _coordsToLatLng);
		return new Polygon(latlngs, options);

	case 'GeometryCollection':
		for (i = 0, len = geometry.geometries.length; i < len; i++) {
			var layer = geometryToLayer({
				geometry: geometry.geometries[i],
				type: 'Feature',
				properties: geojson.properties
			}, options);

			if (layer) {
				layers.push(layer);
			}
		}
		return new FeatureGroup(layers);

	default:
		throw new Error('Invalid GeoJSON object.');
	}
}

// @function coordsToLatLng(coords: Array): LatLng
// Creates a `LatLng` object from an array of 2 numbers (longitude, latitude)
// or 3 numbers (longitude, latitude, altitude) used in GeoJSON for points.
function coordsToLatLng(coords) {
	return new LatLng(coords[1], coords[0], coords[2]);
}

// @function coordsToLatLngs(coords: Array, levelsDeep?: Number, coordsToLatLng?: Function): Array
// Creates a multidimensional array of `LatLng`s from a GeoJSON coordinates array.
// `levelsDeep` specifies the nesting level (0 is for an array of points, 1 for an array of arrays of points, etc., 0 by default).
// Can use a custom [`coordsToLatLng`](#geojson-coordstolatlng) function.
function coordsToLatLngs(coords, levelsDeep, _coordsToLatLng) {
	var latlngs = [];

	for (var i = 0, len = coords.length, latlng; i < len; i++) {
		latlng = levelsDeep ?
				coordsToLatLngs(coords[i], levelsDeep - 1, _coordsToLatLng) :
				(_coordsToLatLng || coordsToLatLng)(coords[i]);

		latlngs.push(latlng);
	}

	return latlngs;
}

// @function latLngToCoords(latlng: LatLng, precision?: Number): Array
// Reverse of [`coordsToLatLng`](#geojson-coordstolatlng)
function latLngToCoords(latlng, precision) {
	precision = typeof precision === 'number' ? precision : 6;
	return latlng.alt !== undefined ?
			[formatNum(latlng.lng, precision), formatNum(latlng.lat, precision), formatNum(latlng.alt, precision)] :
			[formatNum(latlng.lng, precision), formatNum(latlng.lat, precision)];
}

// @function latLngsToCoords(latlngs: Array, levelsDeep?: Number, closed?: Boolean): Array
// Reverse of [`coordsToLatLngs`](#geojson-coordstolatlngs)
// `closed` determines whether the first point should be appended to the end of the array to close the feature, only used when `levelsDeep` is 0. False by default.
function latLngsToCoords(latlngs, levelsDeep, closed, precision) {
	var coords = [];

	for (var i = 0, len = latlngs.length; i < len; i++) {
		coords.push(levelsDeep ?
			latLngsToCoords(latlngs[i], levelsDeep - 1, closed, precision) :
			latLngToCoords(latlngs[i], precision));
	}

	if (!levelsDeep && closed) {
		coords.push(coords[0]);
	}

	return coords;
}

function getFeature(layer, newGeometry) {
	return layer.feature ?
			extend({}, layer.feature, {geometry: newGeometry}) :
			asFeature(newGeometry);
}

// @function asFeature(geojson: Object): Object
// Normalize GeoJSON geometries/features into GeoJSON features.
function asFeature(geojson) {
	if (geojson.type === 'Feature' || geojson.type === 'FeatureCollection') {
		return geojson;
	}

	return {
		type: 'Feature',
		properties: {},
		geometry: geojson
	};
}

var PointToGeoJSON = {
	toGeoJSON: function (precision) {
		return getFeature(this, {
			type: 'Point',
			coordinates: latLngToCoords(this.getLatLng(), precision)
		});
	}
};

// @namespace Marker
// @method toGeoJSON(): Object
// Returns a [`GeoJSON`](http://en.wikipedia.org/wiki/GeoJSON) representation of the marker (as a GeoJSON `Point` Feature).
Marker.include(PointToGeoJSON);

// @namespace CircleMarker
// @method toGeoJSON(): Object
// Returns a [`GeoJSON`](http://en.wikipedia.org/wiki/GeoJSON) representation of the circle marker (as a GeoJSON `Point` Feature).
Circle.include(PointToGeoJSON);
CircleMarker.include(PointToGeoJSON);


// @namespace Polyline
// @method toGeoJSON(): Object
// Returns a [`GeoJSON`](http://en.wikipedia.org/wiki/GeoJSON) representation of the polyline (as a GeoJSON `LineString` or `MultiLineString` Feature).
Polyline.include({
	toGeoJSON: function (precision) {
		var multi = !isFlat(this._latlngs);

		var coords = latLngsToCoords(this._latlngs, multi ? 1 : 0, false, precision);

		return getFeature(this, {
			type: (multi ? 'Multi' : '') + 'LineString',
			coordinates: coords
		});
	}
});

// @namespace Polygon
// @method toGeoJSON(): Object
// Returns a [`GeoJSON`](http://en.wikipedia.org/wiki/GeoJSON) representation of the polygon (as a GeoJSON `Polygon` or `MultiPolygon` Feature).
Polygon.include({
	toGeoJSON: function (precision) {
		var holes = !isFlat(this._latlngs),
		    multi = holes && !isFlat(this._latlngs[0]);

		var coords = latLngsToCoords(this._latlngs, multi ? 2 : holes ? 1 : 0, true, precision);

		if (!holes) {
			coords = [coords];
		}

		return getFeature(this, {
			type: (multi ? 'Multi' : '') + 'Polygon',
			coordinates: coords
		});
	}
});


// @namespace LayerGroup
LayerGroup.include({
	toMultiPoint: function (precision) {
		var coords = [];

		this.eachLayer(function (layer) {
			coords.push(layer.toGeoJSON(precision).geometry.coordinates);
		});

		return getFeature(this, {
			type: 'MultiPoint',
			coordinates: coords
		});
	},

	// @method toGeoJSON(): Object
	// Returns a [`GeoJSON`](http://en.wikipedia.org/wiki/GeoJSON) representation of the layer group (as a GeoJSON `FeatureCollection`, `GeometryCollection`, or `MultiPoint`).
	toGeoJSON: function (precision) {

		var type = this.feature && this.feature.geometry && this.feature.geometry.type;

		if (type === 'MultiPoint') {
			return this.toMultiPoint(precision);
		}

		var isGeometryCollection = type === 'GeometryCollection',
		    jsons = [];

		this.eachLayer(function (layer) {
			if (layer.toGeoJSON) {
				var json = layer.toGeoJSON(precision);
				if (isGeometryCollection) {
					jsons.push(json.geometry);
				} else {
					var feature = asFeature(json);
					// Squash nested feature collections
					if (feature.type === 'FeatureCollection') {
						jsons.push.apply(jsons, feature.features);
					} else {
						jsons.push(feature);
					}
				}
			}
		});

		if (isGeometryCollection) {
			return getFeature(this, {
				geometries: jsons,
				type: 'GeometryCollection'
			});
		}

		return {
			type: 'FeatureCollection',
			features: jsons
		};
	}
});

// @namespace GeoJSON
// @factory L.geoJSON(geojson?: Object, options?: GeoJSON options)
// Creates a GeoJSON layer. Optionally accepts an object in
// [GeoJSON format](http://geojson.org/geojson-spec.html) to display on the map
// (you can alternatively add it later with `addData` method) and an `options` object.
function geoJSON(geojson, options) {
	return new GeoJSON(geojson, options);
}

// Backward compatibility.
var geoJson = geoJSON;

/*
 * @class ImageOverlay
 * @aka L.ImageOverlay
 * @inherits Interactive layer
 *
 * Used to load and display a single image over specific bounds of the map. Extends `Layer`.
 *
 * @example
 *
 * ```js
 * var imageUrl = 'http://www.lib.utexas.edu/maps/historical/newark_nj_1922.jpg',
 * 	imageBounds = [[40.712216, -74.22655], [40.773941, -74.12544]];
 * L.imageOverlay(imageUrl, imageBounds).addTo(map);
 * ```
 */

var ImageOverlay = Layer.extend({

	// @section
	// @aka ImageOverlay options
	options: {
		// @option opacity: Number = 1.0
		// The opacity of the image overlay.
		opacity: 1,

		// @option alt: String = ''
		// Text for the `alt` attribute of the image (useful for accessibility).
		alt: '',

		// @option interactive: Boolean = false
		// If `true`, the image overlay will emit [mouse events](#interactive-layer) when clicked or hovered.
		interactive: false,

		// @option crossOrigin: Boolean = false
		// If true, the image will have its crossOrigin attribute set to ''. This is needed if you want to access image pixel data.
		crossOrigin: false,

		// @option errorOverlayUrl: String = ''
		// URL to the overlay image to show in place of the overlay that failed to load.
		errorOverlayUrl: '',

		// @option zIndex: Number = 1
		// The explicit [zIndex](https://developer.mozilla.org/docs/Web/CSS/CSS_Positioning/Understanding_z_index) of the tile layer.
		zIndex: 1,

		// @option className: String = ''
		// A custom class name to assign to the image. Empty by default.
		className: '',
	},

	initialize: function (url, bounds, options) { // (String, LatLngBounds, Object)
		this._url = url;
		this._bounds = toLatLngBounds(bounds);

		setOptions(this, options);
	},

	onAdd: function () {
		if (!this._image) {
			this._initImage();

			if (this.options.opacity < 1) {
				this._updateOpacity();
			}
		}

		if (this.options.interactive) {
			addClass(this._image, 'leaflet-interactive');
			this.addInteractiveTarget(this._image);
		}

		this.getPane().appendChild(this._image);
		this._reset();
	},

	onRemove: function () {
		remove(this._image);
		if (this.options.interactive) {
			this.removeInteractiveTarget(this._image);
		}
	},

	// @method setOpacity(opacity: Number): this
	// Sets the opacity of the overlay.
	setOpacity: function (opacity) {
		this.options.opacity = opacity;

		if (this._image) {
			this._updateOpacity();
		}
		return this;
	},

	setStyle: function (styleOpts) {
		if (styleOpts.opacity) {
			this.setOpacity(styleOpts.opacity);
		}
		return this;
	},

	// @method bringToFront(): this
	// Brings the layer to the top of all overlays.
	bringToFront: function () {
		if (this._map) {
			toFront(this._image);
		}
		return this;
	},

	// @method bringToBack(): this
	// Brings the layer to the bottom of all overlays.
	bringToBack: function () {
		if (this._map) {
			toBack(this._image);
		}
		return this;
	},

	// @method setUrl(url: String): this
	// Changes the URL of the image.
	setUrl: function (url) {
		this._url = url;

		if (this._image) {
			this._image.src = url;
		}
		return this;
	},

	// @method setBounds(bounds: LatLngBounds): this
	// Update the bounds that this ImageOverlay covers
	setBounds: function (bounds) {
		this._bounds = toLatLngBounds(bounds);

		if (this._map) {
			this._reset();
		}
		return this;
	},

	getEvents: function () {
		var events = {
			zoom: this._reset,
			viewreset: this._reset
		};

		if (this._zoomAnimated) {
			events.zoomanim = this._animateZoom;
		}

		return events;
	},

	// @method: setZIndex(value: Number) : this
	// Changes the [zIndex](#imageoverlay-zindex) of the image overlay.
	setZIndex: function (value) {
		this.options.zIndex = value;
		this._updateZIndex();
		return this;
	},

	// @method getBounds(): LatLngBounds
	// Get the bounds that this ImageOverlay covers
	getBounds: function () {
		return this._bounds;
	},

	// @method getElement(): HTMLElement
	// Returns the instance of [`HTMLImageElement`](https://developer.mozilla.org/docs/Web/API/HTMLImageElement)
	// used by this overlay.
	getElement: function () {
		return this._image;
	},

	_initImage: function () {
		var img = this._image = create$1('img',
				'leaflet-image-layer ' + (this._zoomAnimated ? 'leaflet-zoom-animated' : '') +
				 (this.options.className || ''));

		img.onselectstart = falseFn;
		img.onmousemove = falseFn;

		// @event load: Event
		// Fired when the ImageOverlay layer has loaded its image
		img.onload = bind(this.fire, this, 'load');
		img.onerror = bind(this._overlayOnError, this, 'error');

		if (this.options.crossOrigin) {
			img.crossOrigin = '';
		}

		if (this.options.zIndex) {
			this._updateZIndex();
		}

		img.src = this._url;
		img.alt = this.options.alt;
	},

	_animateZoom: function (e) {
		var scale = this._map.getZoomScale(e.zoom),
		    offset = this._map._latLngBoundsToNewLayerBounds(this._bounds, e.zoom, e.center).min;

		setTransform(this._image, offset, scale);
	},

	_reset: function () {
		var image = this._image,
		    bounds = new Bounds(
		        this._map.latLngToLayerPoint(this._bounds.getNorthWest()),
		        this._map.latLngToLayerPoint(this._bounds.getSouthEast())),
		    size = bounds.getSize();

		setPosition(image, bounds.min);

		image.style.width  = size.x + 'px';
		image.style.height = size.y + 'px';
	},

	_updateOpacity: function () {
		setOpacity(this._image, this.options.opacity);
	},

	_updateZIndex: function () {
		if (this._image && this.options.zIndex !== undefined && this.options.zIndex !== null) {
			this._image.style.zIndex = this.options.zIndex;
		}
	},

	_overlayOnError: function () {
		// @event error: Event
		// Fired when the ImageOverlay layer has loaded its image
		this.fire('error');

		var errorUrl = this.options.errorOverlayUrl;
		if (errorUrl && this._url !== errorUrl) {
			this._url = errorUrl;
			this._image.src = errorUrl;
		}
	}
});

// @factory L.imageOverlay(imageUrl: String, bounds: LatLngBounds, options?: ImageOverlay options)
// Instantiates an image overlay object given the URL of the image and the
// geographical bounds it is tied to.
var imageOverlay = function (url, bounds, options) {
	return new ImageOverlay(url, bounds, options);
};

/*
 * @class VideoOverlay
 * @aka L.VideoOverlay
 * @inherits ImageOverlay
 *
 * Used to load and display a video player over specific bounds of the map. Extends `ImageOverlay`.
 *
 * A video overlay uses the [`<video>`](https://developer.mozilla.org/docs/Web/HTML/Element/video)
 * HTML5 element.
 *
 * @example
 *
 * ```js
 * var videoUrl = 'https://www.mapbox.com/bites/00188/patricia_nasa.webm',
 * 	videoBounds = [[ 32, -130], [ 13, -100]];
 * L.VideoOverlay(videoUrl, videoBounds ).addTo(map);
 * ```
 */

var VideoOverlay = ImageOverlay.extend({

	// @section
	// @aka VideoOverlay options
	options: {
		// @option autoplay: Boolean = true
		// Whether the video starts playing automatically when loaded.
		autoplay: true,

		// @option loop: Boolean = true
		// Whether the video will loop back to the beginning when played.
		loop: true
	},

	_initImage: function () {
		var wasElementSupplied = this._url.tagName === 'VIDEO';
		var vid = this._image = wasElementSupplied ? this._url : create$1('video');

		vid.class = vid.class || '';
		vid.class += 'leaflet-image-layer ' + (this._zoomAnimated ? 'leaflet-zoom-animated' : '');

		vid.onselectstart = falseFn;
		vid.onmousemove = falseFn;

		// @event load: Event
		// Fired when the video has finished loading the first frame
		vid.onloadeddata = bind(this.fire, this, 'load');

		if (wasElementSupplied) { return; }

		if (!isArray(this._url)) { this._url = [this._url]; }

		vid.autoplay = !!this.options.autoplay;
		vid.loop = !!this.options.loop;
		for (var i = 0; i < this._url.length; i++) {
			var source = create$1('source');
			source.src = this._url[i];
			vid.appendChild(source);
		}
	}

	// @method getElement(): HTMLVideoElement
	// Returns the instance of [`HTMLVideoElement`](https://developer.mozilla.org/docs/Web/API/HTMLVideoElement)
	// used by this overlay.
});


// @factory L.videoOverlay(video: String|Array|HTMLVideoElement, bounds: LatLngBounds, options?: VideoOverlay options)
// Instantiates an image overlay object given the URL of the video (or array of URLs, or even a video element) and the
// geographical bounds it is tied to.

function videoOverlay(video, bounds, options) {
	return new VideoOverlay(video, bounds, options);
}

/*
 * @class DivOverlay
 * @inherits Layer
 * @aka L.DivOverlay
 * Base model for L.Popup and L.Tooltip. Inherit from it for custom popup like plugins.
 */

// @namespace DivOverlay
var DivOverlay = Layer.extend({

	// @section
	// @aka DivOverlay options
	options: {
		// @option offset: Point = Point(0, 7)
		// The offset of the popup position. Useful to control the anchor
		// of the popup when opening it on some overlays.
		offset: [0, 7],

		// @option className: String = ''
		// A custom CSS class name to assign to the popup.
		className: '',

		// @option pane: String = 'popupPane'
		// `Map pane` where the popup will be added.
		pane: 'popupPane'
	},

	initialize: function (options, source) {
		setOptions(this, options);

		this._source = source;
	},

	onAdd: function (map) {
		this._zoomAnimated = map._zoomAnimated;

		if (!this._container) {
			this._initLayout();
		}

		if (map._fadeAnimated) {
			setOpacity(this._container, 0);
		}

		clearTimeout(this._removeTimeout);
		this.getPane().appendChild(this._container);
		this.update();

		if (map._fadeAnimated) {
			setOpacity(this._container, 1);
		}

		this.bringToFront();
	},

	onRemove: function (map) {
		if (map._fadeAnimated) {
			setOpacity(this._container, 0);
			this._removeTimeout = setTimeout(bind(remove, undefined, this._container), 200);
		} else {
			remove(this._container);
		}
	},

	// @namespace Popup
	// @method getLatLng: LatLng
	// Returns the geographical point of popup.
	getLatLng: function () {
		return this._latlng;
	},

	// @method setLatLng(latlng: LatLng): this
	// Sets the geographical point where the popup will open.
	setLatLng: function (latlng) {
		this._latlng = toLatLng(latlng);
		if (this._map) {
			this._updatePosition();
			this._adjustPan();
		}
		return this;
	},

	// @method getContent: String|HTMLElement
	// Returns the content of the popup.
	getContent: function () {
		return this._content;
	},

	// @method setContent(htmlContent: String|HTMLElement|Function): this
	// Sets the HTML content of the popup. If a function is passed the source layer will be passed to the function. The function should return a `String` or `HTMLElement` to be used in the popup.
	setContent: function (content) {
		this._content = content;
		this.update();
		return this;
	},

	// @method getElement: String|HTMLElement
	// Alias for [getContent()](#popup-getcontent)
	getElement: function () {
		return this._container;
	},

	// @method update: null
	// Updates the popup content, layout and position. Useful for updating the popup after something inside changed, e.g. image loaded.
	update: function () {
		if (!this._map) { return; }

		this._container.style.visibility = 'hidden';

		this._updateContent();
		this._updateLayout();
		this._updatePosition();

		this._container.style.visibility = '';

		this._adjustPan();
	},

	getEvents: function () {
		var events = {
			zoom: this._updatePosition,
			viewreset: this._updatePosition
		};

		if (this._zoomAnimated) {
			events.zoomanim = this._animateZoom;
		}
		return events;
	},

	// @method isOpen: Boolean
	// Returns `true` when the popup is visible on the map.
	isOpen: function () {
		return !!this._map && this._map.hasLayer(this);
	},

	// @method bringToFront: this
	// Brings this popup in front of other popups (in the same map pane).
	bringToFront: function () {
		if (this._map) {
			toFront(this._container);
		}
		return this;
	},

	// @method bringToBack: this
	// Brings this popup to the back of other popups (in the same map pane).
	bringToBack: function () {
		if (this._map) {
			toBack(this._container);
		}
		return this;
	},

	_updateContent: function () {
		if (!this._content) { return; }

		var node = this._contentNode;
		var content = (typeof this._content === 'function') ? this._content(this._source || this) : this._content;

		if (typeof content === 'string') {
			node.innerHTML = content;
		} else {
			while (node.hasChildNodes()) {
				node.removeChild(node.firstChild);
			}
			node.appendChild(content);
		}
		this.fire('contentupdate');
	},

	_updatePosition: function () {
		if (!this._map) { return; }

		var pos = this._map.latLngToLayerPoint(this._latlng),
		    offset = toPoint(this.options.offset),
		    anchor = this._getAnchor();

		if (this._zoomAnimated) {
			setPosition(this._container, pos.add(anchor));
		} else {
			offset = offset.add(pos).add(anchor);
		}

		var bottom = this._containerBottom = -offset.y,
		    left = this._containerLeft = -Math.round(this._containerWidth / 2) + offset.x;

		// bottom position the popup in case the height of the popup changes (images loading etc)
		this._container.style.bottom = bottom + 'px';
		this._container.style.left = left + 'px';
	},

	_getAnchor: function () {
		return [0, 0];
	}

});

/*
 * @class Popup
 * @inherits DivOverlay
 * @aka L.Popup
 * Used to open popups in certain places of the map. Use [Map.openPopup](#map-openpopup) to
 * open popups while making sure that only one popup is open at one time
 * (recommended for usability), or use [Map.addLayer](#map-addlayer) to open as many as you want.
 *
 * @example
 *
 * If you want to just bind a popup to marker click and then open it, it's really easy:
 *
 * ```js
 * marker.bindPopup(popupContent).openPopup();
 * ```
 * Path overlays like polylines also have a `bindPopup` method.
 * Here's a more complicated way to open a popup on a map:
 *
 * ```js
 * var popup = L.popup()
 * 	.setLatLng(latlng)
 * 	.setContent('<p>Hello world!<br />This is a nice popup.</p>')
 * 	.openOn(map);
 * ```
 */


// @namespace Popup
var Popup = DivOverlay.extend({

	// @section
	// @aka Popup options
	options: {
		// @option maxWidth: Number = 300
		// Max width of the popup, in pixels.
		maxWidth: 300,

		// @option minWidth: Number = 50
		// Min width of the popup, in pixels.
		minWidth: 50,

		// @option maxHeight: Number = null
		// If set, creates a scrollable container of the given height
		// inside a popup if its content exceeds it.
		maxHeight: null,

		// @option autoPan: Boolean = true
		// Set it to `false` if you don't want the map to do panning animation
		// to fit the opened popup.
		autoPan: true,

		// @option autoPanPaddingTopLeft: Point = null
		// The margin between the popup and the top left corner of the map
		// view after autopanning was performed.
		autoPanPaddingTopLeft: null,

		// @option autoPanPaddingBottomRight: Point = null
		// The margin between the popup and the bottom right corner of the map
		// view after autopanning was performed.
		autoPanPaddingBottomRight: null,

		// @option autoPanPadding: Point = Point(5, 5)
		// Equivalent of setting both top left and bottom right autopan padding to the same value.
		autoPanPadding: [5, 5],

		// @option keepInView: Boolean = false
		// Set it to `true` if you want to prevent users from panning the popup
		// off of the screen while it is open.
		keepInView: false,

		// @option closeButton: Boolean = true
		// Controls the presence of a close button in the popup.
		closeButton: true,

		// @option autoClose: Boolean = true
		// Set it to `false` if you want to override the default behavior of
		// the popup closing when another popup is opened.
		autoClose: true,

		// @option closeOnClick: Boolean = *
		// Set it if you want to override the default behavior of the popup closing when user clicks
		// on the map. Defaults to the map's [`closePopupOnClick`](#map-closepopuponclick) option.

		// @option className: String = ''
		// A custom CSS class name to assign to the popup.
		className: ''
	},

	// @namespace Popup
	// @method openOn(map: Map): this
	// Adds the popup to the map and closes the previous one. The same as `map.openPopup(popup)`.
	openOn: function (map) {
		map.openPopup(this);
		return this;
	},

	onAdd: function (map) {
		DivOverlay.prototype.onAdd.call(this, map);

		// @namespace Map
		// @section Popup events
		// @event popupopen: PopupEvent
		// Fired when a popup is opened in the map
		map.fire('popupopen', {popup: this});

		if (this._source) {
			// @namespace Layer
			// @section Popup events
			// @event popupopen: PopupEvent
			// Fired when a popup bound to this layer is opened
			this._source.fire('popupopen', {popup: this}, true);
			// For non-path layers, we toggle the popup when clicking
			// again the layer, so prevent the map to reopen it.
			if (!(this._source instanceof Path)) {
				this._source.on('preclick', stopPropagation);
			}
		}
	},

	onRemove: function (map) {
		DivOverlay.prototype.onRemove.call(this, map);

		// @namespace Map
		// @section Popup events
		// @event popupclose: PopupEvent
		// Fired when a popup in the map is closed
		map.fire('popupclose', {popup: this});

		if (this._source) {
			// @namespace Layer
			// @section Popup events
			// @event popupclose: PopupEvent
			// Fired when a popup bound to this layer is closed
			this._source.fire('popupclose', {popup: this}, true);
			if (!(this._source instanceof Path)) {
				this._source.off('preclick', stopPropagation);
			}
		}
	},

	getEvents: function () {
		var events = DivOverlay.prototype.getEvents.call(this);

		if (this.options.closeOnClick !== undefined ? this.options.closeOnClick : this._map.options.closePopupOnClick) {
			events.preclick = this._close;
		}

		if (this.options.keepInView) {
			events.moveend = this._adjustPan;
		}

		return events;
	},

	_close: function () {
		if (this._map) {
			this._map.closePopup(this);
		}
	},

	_initLayout: function () {
		var prefix = 'leaflet-popup',
		    container = this._container = create$1('div',
			prefix + ' ' + (this.options.className || '') +
			' leaflet-zoom-animated');

		var wrapper = this._wrapper = create$1('div', prefix + '-content-wrapper', container);
		this._contentNode = create$1('div', prefix + '-content', wrapper);

		disableClickPropagation(wrapper);
		disableScrollPropagation(this._contentNode);
		on(wrapper, 'contextmenu', stopPropagation);

		this._tipContainer = create$1('div', prefix + '-tip-container', container);
		this._tip = create$1('div', prefix + '-tip', this._tipContainer);

		if (this.options.closeButton) {
			var closeButton = this._closeButton = create$1('a', prefix + '-close-button', container);
			closeButton.href = '#close';
			closeButton.innerHTML = '&#215;';

			on(closeButton, 'click', this._onCloseButtonClick, this);
		}
	},

	_updateLayout: function () {
		var container = this._contentNode,
		    style = container.style;

		style.width = '';
		style.whiteSpace = 'nowrap';

		var width = container.offsetWidth;
		width = Math.min(width, this.options.maxWidth);
		width = Math.max(width, this.options.minWidth);

		style.width = (width + 1) + 'px';
		style.whiteSpace = '';

		style.height = '';

		var height = container.offsetHeight,
		    maxHeight = this.options.maxHeight,
		    scrolledClass = 'leaflet-popup-scrolled';

		if (maxHeight && height > maxHeight) {
			style.height = maxHeight + 'px';
			addClass(container, scrolledClass);
		} else {
			removeClass(container, scrolledClass);
		}

		this._containerWidth = this._container.offsetWidth;
	},

	_animateZoom: function (e) {
		var pos = this._map._latLngToNewLayerPoint(this._latlng, e.zoom, e.center),
		    anchor = this._getAnchor();
		setPosition(this._container, pos.add(anchor));
	},

	_adjustPan: function () {
		if (!this.options.autoPan || (this._map._panAnim && this._map._panAnim._inProgress)) { return; }

		var map = this._map,
		    marginBottom = parseInt(getStyle(this._container, 'marginBottom'), 10) || 0,
		    containerHeight = this._container.offsetHeight + marginBottom,
		    containerWidth = this._containerWidth,
		    layerPos = new Point(this._containerLeft, -containerHeight - this._containerBottom);

		layerPos._add(getPosition(this._container));

		var containerPos = map.layerPointToContainerPoint(layerPos),
		    padding = toPoint(this.options.autoPanPadding),
		    paddingTL = toPoint(this.options.autoPanPaddingTopLeft || padding),
		    paddingBR = toPoint(this.options.autoPanPaddingBottomRight || padding),
		    size = map.getSize(),
		    dx = 0,
		    dy = 0;

		if (containerPos.x + containerWidth + paddingBR.x > size.x) { // right
			dx = containerPos.x + containerWidth - size.x + paddingBR.x;
		}
		if (containerPos.x - dx - paddingTL.x < 0) { // left
			dx = containerPos.x - paddingTL.x;
		}
		if (containerPos.y + containerHeight + paddingBR.y > size.y) { // bottom
			dy = containerPos.y + containerHeight - size.y + paddingBR.y;
		}
		if (containerPos.y - dy - paddingTL.y < 0) { // top
			dy = containerPos.y - paddingTL.y;
		}

		// @namespace Map
		// @section Popup events
		// @event autopanstart: Event
		// Fired when the map starts autopanning when opening a popup.
		if (dx || dy) {
			map
			    .fire('autopanstart')
			    .panBy([dx, dy]);
		}
	},

	_onCloseButtonClick: function (e) {
		this._close();
		stop(e);
	},

	_getAnchor: function () {
		// Where should we anchor the popup on the source layer?
		return toPoint(this._source && this._source._getPopupAnchor ? this._source._getPopupAnchor() : [0, 0]);
	}

});

// @namespace Popup
// @factory L.popup(options?: Popup options, source?: Layer)
// Instantiates a `Popup` object given an optional `options` object that describes its appearance and location and an optional `source` object that is used to tag the popup with a reference to the Layer to which it refers.
var popup = function (options, source) {
	return new Popup(options, source);
};


/* @namespace Map
 * @section Interaction Options
 * @option closePopupOnClick: Boolean = true
 * Set it to `false` if you don't want popups to close when user clicks the map.
 */
Map.mergeOptions({
	closePopupOnClick: true
});


// @namespace Map
// @section Methods for Layers and Controls
Map.include({
	// @method openPopup(popup: Popup): this
	// Opens the specified popup while closing the previously opened (to make sure only one is opened at one time for usability).
	// @alternative
	// @method openPopup(content: String|HTMLElement, latlng: LatLng, options?: Popup options): this
	// Creates a popup with the specified content and options and opens it in the given point on a map.
	openPopup: function (popup, latlng, options) {
		if (!(popup instanceof Popup)) {
			popup = new Popup(options).setContent(popup);
		}

		if (latlng) {
			popup.setLatLng(latlng);
		}

		if (this.hasLayer(popup)) {
			return this;
		}

		if (this._popup && this._popup.options.autoClose) {
			this.closePopup();
		}

		this._popup = popup;
		return this.addLayer(popup);
	},

	// @method closePopup(popup?: Popup): this
	// Closes the popup previously opened with [openPopup](#map-openpopup) (or the given one).
	closePopup: function (popup) {
		if (!popup || popup === this._popup) {
			popup = this._popup;
			this._popup = null;
		}
		if (popup) {
			this.removeLayer(popup);
		}
		return this;
	}
});

/*
 * @namespace Layer
 * @section Popup methods example
 *
 * All layers share a set of methods convenient for binding popups to it.
 *
 * ```js
 * var layer = L.Polygon(latlngs).bindPopup('Hi There!').addTo(map);
 * layer.openPopup();
 * layer.closePopup();
 * ```
 *
 * Popups will also be automatically opened when the layer is clicked on and closed when the layer is removed from the map or another popup is opened.
 */

// @section Popup methods
Layer.include({

	// @method bindPopup(content: String|HTMLElement|Function|Popup, options?: Popup options): this
	// Binds a popup to the layer with the passed `content` and sets up the
	// necessary event listeners. If a `Function` is passed it will receive
	// the layer as the first argument and should return a `String` or `HTMLElement`.
	bindPopup: function (content, options) {

		if (content instanceof Popup) {
			setOptions(content, options);
			this._popup = content;
			content._source = this;
		} else {
			if (!this._popup || options) {
				this._popup = new Popup(options, this);
			}
			this._popup.setContent(content);
		}

		if (!this._popupHandlersAdded) {
			this.on({
				click: this._openPopup,
				keypress: this._onKeyPress,
				remove: this.closePopup,
				move: this._movePopup
			});
			this._popupHandlersAdded = true;
		}

		return this;
	},

	// @method unbindPopup(): this
	// Removes the popup previously bound with `bindPopup`.
	unbindPopup: function () {
		if (this._popup) {
			this.off({
				click: this._openPopup,
				keypress: this._onKeyPress,
				remove: this.closePopup,
				move: this._movePopup
			});
			this._popupHandlersAdded = false;
			this._popup = null;
		}
		return this;
	},

	// @method openPopup(latlng?: LatLng): this
	// Opens the bound popup at the specificed `latlng` or at the default popup anchor if no `latlng` is passed.
	openPopup: function (layer, latlng) {
		if (!(layer instanceof Layer)) {
			latlng = layer;
			layer = this;
		}

		if (layer instanceof FeatureGroup) {
			for (var id in this._layers) {
				layer = this._layers[id];
				break;
			}
		}

		if (!latlng) {
			latlng = layer.getCenter ? layer.getCenter() : layer.getLatLng();
		}

		if (this._popup && this._map) {
			// set popup source to this layer
			this._popup._source = layer;

			// update the popup (content, layout, ect...)
			this._popup.update();

			// open the popup on the map
			this._map.openPopup(this._popup, latlng);
		}

		return this;
	},

	// @method closePopup(): this
	// Closes the popup bound to this layer if it is open.
	closePopup: function () {
		if (this._popup) {
			this._popup._close();
		}
		return this;
	},

	// @method togglePopup(): this
	// Opens or closes the popup bound to this layer depending on its current state.
	togglePopup: function (target) {
		if (this._popup) {
			if (this._popup._map) {
				this.closePopup();
			} else {
				this.openPopup(target);
			}
		}
		return this;
	},

	// @method isPopupOpen(): boolean
	// Returns `true` if the popup bound to this layer is currently open.
	isPopupOpen: function () {
		return (this._popup ? this._popup.isOpen() : false);
	},

	// @method setPopupContent(content: String|HTMLElement|Popup): this
	// Sets the content of the popup bound to this layer.
	setPopupContent: function (content) {
		if (this._popup) {
			this._popup.setContent(content);
		}
		return this;
	},

	// @method getPopup(): Popup
	// Returns the popup bound to this layer.
	getPopup: function () {
		return this._popup;
	},

	_openPopup: function (e) {
		var layer = e.layer || e.target;

		if (!this._popup) {
			return;
		}

		if (!this._map) {
			return;
		}

		// prevent map click
		stop(e);

		// if this inherits from Path its a vector and we can just
		// open the popup at the new location
		if (layer instanceof Path) {
			this.openPopup(e.layer || e.target, e.latlng);
			return;
		}

		// otherwise treat it like a marker and figure out
		// if we should toggle it open/closed
		if (this._map.hasLayer(this._popup) && this._popup._source === layer) {
			this.closePopup();
		} else {
			this.openPopup(layer, e.latlng);
		}
	},

	_movePopup: function (e) {
		this._popup.setLatLng(e.latlng);
	},

	_onKeyPress: function (e) {
		if (e.originalEvent.keyCode === 13) {
			this._openPopup(e);
		}
	}
});

/*
 * @class Tooltip
 * @inherits DivOverlay
 * @aka L.Tooltip
 * Used to display small texts on top of map layers.
 *
 * @example
 *
 * ```js
 * marker.bindTooltip("my tooltip text").openTooltip();
 * ```
 * Note about tooltip offset. Leaflet takes two options in consideration
 * for computing tooltip offseting:
 * - the `offset` Tooltip option: it defaults to [0, 0], and it's specific to one tooltip.
 *   Add a positive x offset to move the tooltip to the right, and a positive y offset to
 *   move it to the bottom. Negatives will move to the left and top.
 * - the `tooltipAnchor` Icon option: this will only be considered for Marker. You
 *   should adapt this value if you use a custom icon.
 */


// @namespace Tooltip
var Tooltip = DivOverlay.extend({

	// @section
	// @aka Tooltip options
	options: {
		// @option pane: String = 'tooltipPane'
		// `Map pane` where the tooltip will be added.
		pane: 'tooltipPane',

		// @option offset: Point = Point(0, 0)
		// Optional offset of the tooltip position.
		offset: [0, 0],

		// @option direction: String = 'auto'
		// Direction where to open the tooltip. Possible values are: `right`, `left`,
		// `top`, `bottom`, `center`, `auto`.
		// `auto` will dynamicaly switch between `right` and `left` according to the tooltip
		// position on the map.
		direction: 'auto',

		// @option permanent: Boolean = false
		// Whether to open the tooltip permanently or only on mouseover.
		permanent: false,

		// @option sticky: Boolean = false
		// If true, the tooltip will follow the mouse instead of being fixed at the feature center.
		sticky: false,

		// @option interactive: Boolean = false
		// If true, the tooltip will listen to the feature events.
		interactive: false,

		// @option opacity: Number = 0.9
		// Tooltip container opacity.
		opacity: 0.9
	},

	onAdd: function (map) {
		DivOverlay.prototype.onAdd.call(this, map);
		this.setOpacity(this.options.opacity);

		// @namespace Map
		// @section Tooltip events
		// @event tooltipopen: TooltipEvent
		// Fired when a tooltip is opened in the map.
		map.fire('tooltipopen', {tooltip: this});

		if (this._source) {
			// @namespace Layer
			// @section Tooltip events
			// @event tooltipopen: TooltipEvent
			// Fired when a tooltip bound to this layer is opened.
			this._source.fire('tooltipopen', {tooltip: this}, true);
		}
	},

	onRemove: function (map) {
		DivOverlay.prototype.onRemove.call(this, map);

		// @namespace Map
		// @section Tooltip events
		// @event tooltipclose: TooltipEvent
		// Fired when a tooltip in the map is closed.
		map.fire('tooltipclose', {tooltip: this});

		if (this._source) {
			// @namespace Layer
			// @section Tooltip events
			// @event tooltipclose: TooltipEvent
			// Fired when a tooltip bound to this layer is closed.
			this._source.fire('tooltipclose', {tooltip: this}, true);
		}
	},

	getEvents: function () {
		var events = DivOverlay.prototype.getEvents.call(this);

		if (touch && !this.options.permanent) {
			events.preclick = this._close;
		}

		return events;
	},

	_close: function () {
		if (this._map) {
			this._map.closeTooltip(this);
		}
	},

	_initLayout: function () {
		var prefix = 'leaflet-tooltip',
		    className = prefix + ' ' + (this.options.className || '') + ' leaflet-zoom-' + (this._zoomAnimated ? 'animated' : 'hide');

		this._contentNode = this._container = create$1('div', className);
	},

	_updateLayout: function () {},

	_adjustPan: function () {},

	_setPosition: function (pos) {
		var map = this._map,
		    container = this._container,
		    centerPoint = map.latLngToContainerPoint(map.getCenter()),
		    tooltipPoint = map.layerPointToContainerPoint(pos),
		    direction = this.options.direction,
		    tooltipWidth = container.offsetWidth,
		    tooltipHeight = container.offsetHeight,
		    offset = toPoint(this.options.offset),
		    anchor = this._getAnchor();

		if (direction === 'top') {
			pos = pos.add(toPoint(-tooltipWidth / 2 + offset.x, -tooltipHeight + offset.y + anchor.y, true));
		} else if (direction === 'bottom') {
			pos = pos.subtract(toPoint(tooltipWidth / 2 - offset.x, -offset.y, true));
		} else if (direction === 'center') {
			pos = pos.subtract(toPoint(tooltipWidth / 2 + offset.x, tooltipHeight / 2 - anchor.y + offset.y, true));
		} else if (direction === 'right' || direction === 'auto' && tooltipPoint.x < centerPoint.x) {
			direction = 'right';
			pos = pos.add(toPoint(offset.x + anchor.x, anchor.y - tooltipHeight / 2 + offset.y, true));
		} else {
			direction = 'left';
			pos = pos.subtract(toPoint(tooltipWidth + anchor.x - offset.x, tooltipHeight / 2 - anchor.y - offset.y, true));
		}

		removeClass(container, 'leaflet-tooltip-right');
		removeClass(container, 'leaflet-tooltip-left');
		removeClass(container, 'leaflet-tooltip-top');
		removeClass(container, 'leaflet-tooltip-bottom');
		addClass(container, 'leaflet-tooltip-' + direction);
		setPosition(container, pos);
	},

	_updatePosition: function () {
		var pos = this._map.latLngToLayerPoint(this._latlng);
		this._setPosition(pos);
	},

	setOpacity: function (opacity) {
		this.options.opacity = opacity;

		if (this._container) {
			setOpacity(this._container, opacity);
		}
	},

	_animateZoom: function (e) {
		var pos = this._map._latLngToNewLayerPoint(this._latlng, e.zoom, e.center);
		this._setPosition(pos);
	},

	_getAnchor: function () {
		// Where should we anchor the tooltip on the source layer?
		return toPoint(this._source && this._source._getTooltipAnchor && !this.options.sticky ? this._source._getTooltipAnchor() : [0, 0]);
	}

});

// @namespace Tooltip
// @factory L.tooltip(options?: Tooltip options, source?: Layer)
// Instantiates a Tooltip object given an optional `options` object that describes its appearance and location and an optional `source` object that is used to tag the tooltip with a reference to the Layer to which it refers.
var tooltip = function (options, source) {
	return new Tooltip(options, source);
};

// @namespace Map
// @section Methods for Layers and Controls
Map.include({

	// @method openTooltip(tooltip: Tooltip): this
	// Opens the specified tooltip.
	// @alternative
	// @method openTooltip(content: String|HTMLElement, latlng: LatLng, options?: Tooltip options): this
	// Creates a tooltip with the specified content and options and open it.
	openTooltip: function (tooltip, latlng, options) {
		if (!(tooltip instanceof Tooltip)) {
			tooltip = new Tooltip(options).setContent(tooltip);
		}

		if (latlng) {
			tooltip.setLatLng(latlng);
		}

		if (this.hasLayer(tooltip)) {
			return this;
		}

		return this.addLayer(tooltip);
	},

	// @method closeTooltip(tooltip?: Tooltip): this
	// Closes the tooltip given as parameter.
	closeTooltip: function (tooltip) {
		if (tooltip) {
			this.removeLayer(tooltip);
		}
		return this;
	}

});

/*
 * @namespace Layer
 * @section Tooltip methods example
 *
 * All layers share a set of methods convenient for binding tooltips to it.
 *
 * ```js
 * var layer = L.Polygon(latlngs).bindTooltip('Hi There!').addTo(map);
 * layer.openTooltip();
 * layer.closeTooltip();
 * ```
 */

// @section Tooltip methods
Layer.include({

	// @method bindTooltip(content: String|HTMLElement|Function|Tooltip, options?: Tooltip options): this
	// Binds a tooltip to the layer with the passed `content` and sets up the
	// necessary event listeners. If a `Function` is passed it will receive
	// the layer as the first argument and should return a `String` or `HTMLElement`.
	bindTooltip: function (content, options) {

		if (content instanceof Tooltip) {
			setOptions(content, options);
			this._tooltip = content;
			content._source = this;
		} else {
			if (!this._tooltip || options) {
				this._tooltip = new Tooltip(options, this);
			}
			this._tooltip.setContent(content);

		}

		this._initTooltipInteractions();

		if (this._tooltip.options.permanent && this._map && this._map.hasLayer(this)) {
			this.openTooltip();
		}

		return this;
	},

	// @method unbindTooltip(): this
	// Removes the tooltip previously bound with `bindTooltip`.
	unbindTooltip: function () {
		if (this._tooltip) {
			this._initTooltipInteractions(true);
			this.closeTooltip();
			this._tooltip = null;
		}
		return this;
	},

	_initTooltipInteractions: function (remove$$1) {
		if (!remove$$1 && this._tooltipHandlersAdded) { return; }
		var onOff = remove$$1 ? 'off' : 'on',
		    events = {
			remove: this.closeTooltip,
			move: this._moveTooltip
		    };
		if (!this._tooltip.options.permanent) {
			events.mouseover = this._openTooltip;
			events.mouseout = this.closeTooltip;
			if (this._tooltip.options.sticky) {
				events.mousemove = this._moveTooltip;
			}
			if (touch) {
				events.click = this._openTooltip;
			}
		} else {
			events.add = this._openTooltip;
		}
		this[onOff](events);
		this._tooltipHandlersAdded = !remove$$1;
	},

	// @method openTooltip(latlng?: LatLng): this
	// Opens the bound tooltip at the specificed `latlng` or at the default tooltip anchor if no `latlng` is passed.
	openTooltip: function (layer, latlng) {
		if (!(layer instanceof Layer)) {
			latlng = layer;
			layer = this;
		}

		if (layer instanceof FeatureGroup) {
			for (var id in this._layers) {
				layer = this._layers[id];
				break;
			}
		}

		if (!latlng) {
			latlng = layer.getCenter ? layer.getCenter() : layer.getLatLng();
		}

		if (this._tooltip && this._map) {

			// set tooltip source to this layer
			this._tooltip._source = layer;

			// update the tooltip (content, layout, ect...)
			this._tooltip.update();

			// open the tooltip on the map
			this._map.openTooltip(this._tooltip, latlng);

			// Tooltip container may not be defined if not permanent and never
			// opened.
			if (this._tooltip.options.interactive && this._tooltip._container) {
				addClass(this._tooltip._container, 'leaflet-clickable');
				this.addInteractiveTarget(this._tooltip._container);
			}
		}

		return this;
	},

	// @method closeTooltip(): this
	// Closes the tooltip bound to this layer if it is open.
	closeTooltip: function () {
		if (this._tooltip) {
			this._tooltip._close();
			if (this._tooltip.options.interactive && this._tooltip._container) {
				removeClass(this._tooltip._container, 'leaflet-clickable');
				this.removeInteractiveTarget(this._tooltip._container);
			}
		}
		return this;
	},

	// @method toggleTooltip(): this
	// Opens or closes the tooltip bound to this layer depending on its current state.
	toggleTooltip: function (target) {
		if (this._tooltip) {
			if (this._tooltip._map) {
				this.closeTooltip();
			} else {
				this.openTooltip(target);
			}
		}
		return this;
	},

	// @method isTooltipOpen(): boolean
	// Returns `true` if the tooltip bound to this layer is currently open.
	isTooltipOpen: function () {
		return this._tooltip.isOpen();
	},

	// @method setTooltipContent(content: String|HTMLElement|Tooltip): this
	// Sets the content of the tooltip bound to this layer.
	setTooltipContent: function (content) {
		if (this._tooltip) {
			this._tooltip.setContent(content);
		}
		return this;
	},

	// @method getTooltip(): Tooltip
	// Returns the tooltip bound to this layer.
	getTooltip: function () {
		return this._tooltip;
	},

	_openTooltip: function (e) {
		var layer = e.layer || e.target;

		if (!this._tooltip || !this._map) {
			return;
		}
		this.openTooltip(layer, this._tooltip.options.sticky ? e.latlng : undefined);
	},

	_moveTooltip: function (e) {
		var latlng = e.latlng, containerPoint, layerPoint;
		if (this._tooltip.options.sticky && e.originalEvent) {
			containerPoint = this._map.mouseEventToContainerPoint(e.originalEvent);
			layerPoint = this._map.containerPointToLayerPoint(containerPoint);
			latlng = this._map.layerPointToLatLng(layerPoint);
		}
		this._tooltip.setLatLng(latlng);
	}
});

/*
 * @class DivIcon
 * @aka L.DivIcon
 * @inherits Icon
 *
 * Represents a lightweight icon for markers that uses a simple `<div>`
 * element instead of an image. Inherits from `Icon` but ignores the `iconUrl` and shadow options.
 *
 * @example
 * ```js
 * var myIcon = L.divIcon({className: 'my-div-icon'});
 * // you can set .my-div-icon styles in CSS
 *
 * L.marker([50.505, 30.57], {icon: myIcon}).addTo(map);
 * ```
 *
 * By default, it has a 'leaflet-div-icon' CSS class and is styled as a little white square with a shadow.
 */

var DivIcon = Icon.extend({
	options: {
		// @section
		// @aka DivIcon options
		iconSize: [12, 12], // also can be set through CSS

		// iconAnchor: (Point),
		// popupAnchor: (Point),

		// @option html: String = ''
		// Custom HTML code to put inside the div element, empty by default.
		html: false,

		// @option bgPos: Point = [0, 0]
		// Optional relative position of the background, in pixels
		bgPos: null,

		className: 'leaflet-div-icon'
	},

	createIcon: function (oldIcon) {
		var div = (oldIcon && oldIcon.tagName === 'DIV') ? oldIcon : document.createElement('div'),
		    options = this.options;

		div.innerHTML = options.html !== false ? options.html : '';

		if (options.bgPos) {
			var bgPos = toPoint(options.bgPos);
			div.style.backgroundPosition = (-bgPos.x) + 'px ' + (-bgPos.y) + 'px';
		}
		this._setIconStyles(div, 'icon');

		return div;
	},

	createShadow: function () {
		return null;
	}
});

// @factory L.divIcon(options: DivIcon options)
// Creates a `DivIcon` instance with the given options.
function divIcon(options) {
	return new DivIcon(options);
}

Icon.Default = IconDefault;

/*
 * @class GridLayer
 * @inherits Layer
 * @aka L.GridLayer
 *
 * Generic class for handling a tiled grid of HTML elements. This is the base class for all tile layers and replaces `TileLayer.Canvas`.
 * GridLayer can be extended to create a tiled grid of HTML elements like `<canvas>`, `<img>` or `<div>`. GridLayer will handle creating and animating these DOM elements for you.
 *
 *
 * @section Synchronous usage
 * @example
 *
 * To create a custom layer, extend GridLayer and implement the `createTile()` method, which will be passed a `Point` object with the `x`, `y`, and `z` (zoom level) coordinates to draw your tile.
 *
 * ```js
 * var CanvasLayer = L.GridLayer.extend({
 *     createTile: function(coords){
 *         // create a <canvas> element for drawing
 *         var tile = L.DomUtil.create('canvas', 'leaflet-tile');
 *
 *         // setup tile width and height according to the options
 *         var size = this.getTileSize();
 *         tile.width = size.x;
 *         tile.height = size.y;
 *
 *         // get a canvas context and draw something on it using coords.x, coords.y and coords.z
 *         var ctx = tile.getContext('2d');
 *
 *         // return the tile so it can be rendered on screen
 *         return tile;
 *     }
 * });
 * ```
 *
 * @section Asynchronous usage
 * @example
 *
 * Tile creation can also be asynchronous, this is useful when using a third-party drawing library. Once the tile is finished drawing it can be passed to the `done()` callback.
 *
 * ```js
 * var CanvasLayer = L.GridLayer.extend({
 *     createTile: function(coords, done){
 *         var error;
 *
 *         // create a <canvas> element for drawing
 *         var tile = L.DomUtil.create('canvas', 'leaflet-tile');
 *
 *         // setup tile width and height according to the options
 *         var size = this.getTileSize();
 *         tile.width = size.x;
 *         tile.height = size.y;
 *
 *         // draw something asynchronously and pass the tile to the done() callback
 *         setTimeout(function() {
 *             done(error, tile);
 *         }, 1000);
 *
 *         return tile;
 *     }
 * });
 * ```
 *
 * @section
 */


var GridLayer = Layer.extend({

	// @section
	// @aka GridLayer options
	options: {
		// @option tileSize: Number|Point = 256
		// Width and height of tiles in the grid. Use a number if width and height are equal, or `L.point(width, height)` otherwise.
		tileSize: 256,

		// @option opacity: Number = 1.0
		// Opacity of the tiles. Can be used in the `createTile()` function.
		opacity: 1,

		// @option updateWhenIdle: Boolean = (depends)
		// Load new tiles only when panning ends.
		// `true` by default on mobile browsers, in order to avoid too many requests and keep smooth navigation.
		// `false` otherwise in order to display new tiles _during_ panning, since it is easy to pan outside the
		// [`keepBuffer`](#gridlayer-keepbuffer) option in desktop browsers.
		updateWhenIdle: mobile,

		// @option updateWhenZooming: Boolean = true
		// By default, a smooth zoom animation (during a [touch zoom](#map-touchzoom) or a [`flyTo()`](#map-flyto)) will update grid layers every integer zoom level. Setting this option to `false` will update the grid layer only when the smooth animation ends.
		updateWhenZooming: true,

		// @option updateInterval: Number = 200
		// Tiles will not update more than once every `updateInterval` milliseconds when panning.
		updateInterval: 200,

		// @option zIndex: Number = 1
		// The explicit zIndex of the tile layer.
		zIndex: 1,

		// @option bounds: LatLngBounds = undefined
		// If set, tiles will only be loaded inside the set `LatLngBounds`.
		bounds: null,

		// @option minZoom: Number = 0
		// The minimum zoom level down to which this layer will be displayed (inclusive).
		minZoom: 0,

		// @option maxZoom: Number = undefined
		// The maximum zoom level up to which this layer will be displayed (inclusive).
		maxZoom: undefined,

		// @option maxNativeZoom: Number = undefined
		// Maximum zoom number the tile source has available. If it is specified,
		// the tiles on all zoom levels higher than `maxNativeZoom` will be loaded
		// from `maxNativeZoom` level and auto-scaled.
		maxNativeZoom: undefined,

		// @option minNativeZoom: Number = undefined
		// Minimum zoom number the tile source has available. If it is specified,
		// the tiles on all zoom levels lower than `minNativeZoom` will be loaded
		// from `minNativeZoom` level and auto-scaled.
		minNativeZoom: undefined,

		// @option noWrap: Boolean = false
		// Whether the layer is wrapped around the antimeridian. If `true`, the
		// GridLayer will only be displayed once at low zoom levels. Has no
		// effect when the [map CRS](#map-crs) doesn't wrap around. Can be used
		// in combination with [`bounds`](#gridlayer-bounds) to prevent requesting
		// tiles outside the CRS limits.
		noWrap: false,

		// @option pane: String = 'tilePane'
		// `Map pane` where the grid layer will be added.
		pane: 'tilePane',

		// @option className: String = ''
		// A custom class name to assign to the tile layer. Empty by default.
		className: '',

		// @option keepBuffer: Number = 2
		// When panning the map, keep this many rows and columns of tiles before unloading them.
		keepBuffer: 2
	},

	initialize: function (options) {
		setOptions(this, options);
	},

	onAdd: function () {
		this._initContainer();

		this._levels = {};
		this._tiles = {};

		this._resetView();
		this._update();
	},

	beforeAdd: function (map) {
		map._addZoomLimit(this);
	},

	onRemove: function (map) {
		this._removeAllTiles();
		remove(this._container);
		map._removeZoomLimit(this);
		this._container = null;
		this._tileZoom = null;
	},

	// @method bringToFront: this
	// Brings the tile layer to the top of all tile layers.
	bringToFront: function () {
		if (this._map) {
			toFront(this._container);
			this._setAutoZIndex(Math.max);
		}
		return this;
	},

	// @method bringToBack: this
	// Brings the tile layer to the bottom of all tile layers.
	bringToBack: function () {
		if (this._map) {
			toBack(this._container);
			this._setAutoZIndex(Math.min);
		}
		return this;
	},

	// @method getContainer: HTMLElement
	// Returns the HTML element that contains the tiles for this layer.
	getContainer: function () {
		return this._container;
	},

	// @method setOpacity(opacity: Number): this
	// Changes the [opacity](#gridlayer-opacity) of the grid layer.
	setOpacity: function (opacity) {
		this.options.opacity = opacity;
		this._updateOpacity();
		return this;
	},

	// @method setZIndex(zIndex: Number): this
	// Changes the [zIndex](#gridlayer-zindex) of the grid layer.
	setZIndex: function (zIndex) {
		this.options.zIndex = zIndex;
		this._updateZIndex();

		return this;
	},

	// @method isLoading: Boolean
	// Returns `true` if any tile in the grid layer has not finished loading.
	isLoading: function () {
		return this._loading;
	},

	// @method redraw: this
	// Causes the layer to clear all the tiles and request them again.
	redraw: function () {
		if (this._map) {
			this._removeAllTiles();
			this._update();
		}
		return this;
	},

	getEvents: function () {
		var events = {
			viewprereset: this._invalidateAll,
			viewreset: this._resetView,
			zoom: this._resetView,
			moveend: this._onMoveEnd
		};

		if (!this.options.updateWhenIdle) {
			// update tiles on move, but not more often than once per given interval
			if (!this._onMove) {
				this._onMove = throttle(this._onMoveEnd, this.options.updateInterval, this);
			}

			events.move = this._onMove;
		}

		if (this._zoomAnimated) {
			events.zoomanim = this._animateZoom;
		}

		return events;
	},

	// @section Extension methods
	// Layers extending `GridLayer` shall reimplement the following method.
	// @method createTile(coords: Object, done?: Function): HTMLElement
	// Called only internally, must be overriden by classes extending `GridLayer`.
	// Returns the `HTMLElement` corresponding to the given `coords`. If the `done` callback
	// is specified, it must be called when the tile has finished loading and drawing.
	createTile: function () {
		return document.createElement('div');
	},

	// @section
	// @method getTileSize: Point
	// Normalizes the [tileSize option](#gridlayer-tilesize) into a point. Used by the `createTile()` method.
	getTileSize: function () {
		var s = this.options.tileSize;
		return s instanceof Point ? s : new Point(s, s);
	},

	_updateZIndex: function () {
		if (this._container && this.options.zIndex !== undefined && this.options.zIndex !== null) {
			this._container.style.zIndex = this.options.zIndex;
		}
	},

	_setAutoZIndex: function (compare) {
		// go through all other layers of the same pane, set zIndex to max + 1 (front) or min - 1 (back)

		var layers = this.getPane().children,
		    edgeZIndex = -compare(-Infinity, Infinity); // -Infinity for max, Infinity for min

		for (var i = 0, len = layers.length, zIndex; i < len; i++) {

			zIndex = layers[i].style.zIndex;

			if (layers[i] !== this._container && zIndex) {
				edgeZIndex = compare(edgeZIndex, +zIndex);
			}
		}

		if (isFinite(edgeZIndex)) {
			this.options.zIndex = edgeZIndex + compare(-1, 1);
			this._updateZIndex();
		}
	},

	_updateOpacity: function () {
		if (!this._map) { return; }

		// IE doesn't inherit filter opacity properly, so we're forced to set it on tiles
		if (ielt9) { return; }

		setOpacity(this._container, this.options.opacity);

		var now = +new Date(),
		    nextFrame = false,
		    willPrune = false;

		for (var key in this._tiles) {
			var tile = this._tiles[key];
			if (!tile.current || !tile.loaded) { continue; }

			var fade = Math.min(1, (now - tile.loaded) / 200);

			setOpacity(tile.el, fade);
			if (fade < 1) {
				nextFrame = true;
			} else {
				if (tile.active) {
					willPrune = true;
				} else {
					this._onOpaqueTile(tile);
				}
				tile.active = true;
			}
		}

		if (willPrune && !this._noPrune) { this._pruneTiles(); }

		if (nextFrame) {
			cancelAnimFrame(this._fadeFrame);
			this._fadeFrame = requestAnimFrame(this._updateOpacity, this);
		}
	},

	_onOpaqueTile: falseFn,

	_initContainer: function () {
		if (this._container) { return; }

		this._container = create$1('div', 'leaflet-layer ' + (this.options.className || ''));
		this._updateZIndex();

		if (this.options.opacity < 1) {
			this._updateOpacity();
		}

		this.getPane().appendChild(this._container);
	},

	_updateLevels: function () {

		var zoom = this._tileZoom,
		    maxZoom = this.options.maxZoom;

		if (zoom === undefined) { return undefined; }

		for (var z in this._levels) {
			if (this._levels[z].el.children.length || z === zoom) {
				this._levels[z].el.style.zIndex = maxZoom - Math.abs(zoom - z);
				this._onUpdateLevel(z);
			} else {
				remove(this._levels[z].el);
				this._removeTilesAtZoom(z);
				this._onRemoveLevel(z);
				delete this._levels[z];
			}
		}

		var level = this._levels[zoom],
		    map = this._map;

		if (!level) {
			level = this._levels[zoom] = {};

			level.el = create$1('div', 'leaflet-tile-container leaflet-zoom-animated', this._container);
			level.el.style.zIndex = maxZoom;

			level.origin = map.project(map.unproject(map.getPixelOrigin()), zoom).round();
			level.zoom = zoom;

			this._setZoomTransform(level, map.getCenter(), map.getZoom());

			// force the browser to consider the newly added element for transition
			falseFn(level.el.offsetWidth);

			this._onCreateLevel(level);
		}

		this._level = level;

		return level;
	},

	_onUpdateLevel: falseFn,

	_onRemoveLevel: falseFn,

	_onCreateLevel: falseFn,

	_pruneTiles: function () {
		if (!this._map) {
			return;
		}

		var key, tile;

		var zoom = this._map.getZoom();
		if (zoom > this.options.maxZoom ||
			zoom < this.options.minZoom) {
			this._removeAllTiles();
			return;
		}

		for (key in this._tiles) {
			tile = this._tiles[key];
			tile.retain = tile.current;
		}

		for (key in this._tiles) {
			tile = this._tiles[key];
			if (tile.current && !tile.active) {
				var coords = tile.coords;
				if (!this._retainParent(coords.x, coords.y, coords.z, coords.z - 5)) {
					this._retainChildren(coords.x, coords.y, coords.z, coords.z + 2);
				}
			}
		}

		for (key in this._tiles) {
			if (!this._tiles[key].retain) {
				this._removeTile(key);
			}
		}
	},

	_removeTilesAtZoom: function (zoom) {
		for (var key in this._tiles) {
			if (this._tiles[key].coords.z !== zoom) {
				continue;
			}
			this._removeTile(key);
		}
	},

	_removeAllTiles: function () {
		for (var key in this._tiles) {
			this._removeTile(key);
		}
	},

	_invalidateAll: function () {
		for (var z in this._levels) {
			remove(this._levels[z].el);
			this._onRemoveLevel(z);
			delete this._levels[z];
		}
		this._removeAllTiles();

		this._tileZoom = null;
	},

	_retainParent: function (x, y, z, minZoom) {
		var x2 = Math.floor(x / 2),
		    y2 = Math.floor(y / 2),
		    z2 = z - 1,
		    coords2 = new Point(+x2, +y2);
		coords2.z = +z2;

		var key = this._tileCoordsToKey(coords2),
		    tile = this._tiles[key];

		if (tile && tile.active) {
			tile.retain = true;
			return true;

		} else if (tile && tile.loaded) {
			tile.retain = true;
		}

		if (z2 > minZoom) {
			return this._retainParent(x2, y2, z2, minZoom);
		}

		return false;
	},

	_retainChildren: function (x, y, z, maxZoom) {

		for (var i = 2 * x; i < 2 * x + 2; i++) {
			for (var j = 2 * y; j < 2 * y + 2; j++) {

				var coords = new Point(i, j);
				coords.z = z + 1;

				var key = this._tileCoordsToKey(coords),
				    tile = this._tiles[key];

				if (tile && tile.active) {
					tile.retain = true;
					continue;

				} else if (tile && tile.loaded) {
					tile.retain = true;
				}

				if (z + 1 < maxZoom) {
					this._retainChildren(i, j, z + 1, maxZoom);
				}
			}
		}
	},

	_resetView: function (e) {
		var animating = e && (e.pinch || e.flyTo);
		this._setView(this._map.getCenter(), this._map.getZoom(), animating, animating);
	},

	_animateZoom: function (e) {
		this._setView(e.center, e.zoom, true, e.noUpdate);
	},

	_clampZoom: function (zoom) {
		var options = this.options;

		if (undefined !== options.minNativeZoom && zoom < options.minNativeZoom) {
			return options.minNativeZoom;
		}

		if (undefined !== options.maxNativeZoom && options.maxNativeZoom < zoom) {
			return options.maxNativeZoom;
		}

		return zoom;
	},

	_setView: function (center, zoom, noPrune, noUpdate) {
		var tileZoom = this._clampZoom(Math.round(zoom));
		if ((this.options.maxZoom !== undefined && tileZoom > this.options.maxZoom) ||
		    (this.options.minZoom !== undefined && tileZoom < this.options.minZoom)) {
			tileZoom = undefined;
		}

		var tileZoomChanged = this.options.updateWhenZooming && (tileZoom !== this._tileZoom);

		if (!noUpdate || tileZoomChanged) {

			this._tileZoom = tileZoom;

			if (this._abortLoading) {
				this._abortLoading();
			}

			this._updateLevels();
			this._resetGrid();

			if (tileZoom !== undefined) {
				this._update(center);
			}

			if (!noPrune) {
				this._pruneTiles();
			}

			// Flag to prevent _updateOpacity from pruning tiles during
			// a zoom anim or a pinch gesture
			this._noPrune = !!noPrune;
		}

		this._setZoomTransforms(center, zoom);
	},

	_setZoomTransforms: function (center, zoom) {
		for (var i in this._levels) {
			this._setZoomTransform(this._levels[i], center, zoom);
		}
	},

	_setZoomTransform: function (level, center, zoom) {
		var scale = this._map.getZoomScale(zoom, level.zoom),
		    translate = level.origin.multiplyBy(scale)
		        .subtract(this._map._getNewPixelOrigin(center, zoom)).round();

		if (any3d) {
			setTransform(level.el, translate, scale);
		} else {
			setPosition(level.el, translate);
		}
	},

	_resetGrid: function () {
		var map = this._map,
		    crs = map.options.crs,
		    tileSize = this._tileSize = this.getTileSize(),
		    tileZoom = this._tileZoom;

		var bounds = this._map.getPixelWorldBounds(this._tileZoom);
		if (bounds) {
			this._globalTileRange = this._pxBoundsToTileRange(bounds);
		}

		this._wrapX = crs.wrapLng && !this.options.noWrap && [
			Math.floor(map.project([0, crs.wrapLng[0]], tileZoom).x / tileSize.x),
			Math.ceil(map.project([0, crs.wrapLng[1]], tileZoom).x / tileSize.y)
		];
		this._wrapY = crs.wrapLat && !this.options.noWrap && [
			Math.floor(map.project([crs.wrapLat[0], 0], tileZoom).y / tileSize.x),
			Math.ceil(map.project([crs.wrapLat[1], 0], tileZoom).y / tileSize.y)
		];
	},

	_onMoveEnd: function () {
		if (!this._map || this._map._animatingZoom) { return; }

		this._update();
	},

	_getTiledPixelBounds: function (center) {
		var map = this._map,
		    mapZoom = map._animatingZoom ? Math.max(map._animateToZoom, map.getZoom()) : map.getZoom(),
		    scale = map.getZoomScale(mapZoom, this._tileZoom),
		    pixelCenter = map.project(center, this._tileZoom).floor(),
		    halfSize = map.getSize().divideBy(scale * 2);

		return new Bounds(pixelCenter.subtract(halfSize), pixelCenter.add(halfSize));
	},

	// Private method to load tiles in the grid's active zoom level according to map bounds
	_update: function (center) {
		var map = this._map;
		if (!map) { return; }
		var zoom = this._clampZoom(map.getZoom());

		if (center === undefined) { center = map.getCenter(); }
		if (this._tileZoom === undefined) { return; }	// if out of minzoom/maxzoom

		var pixelBounds = this._getTiledPixelBounds(center),
		    tileRange = this._pxBoundsToTileRange(pixelBounds),
		    tileCenter = tileRange.getCenter(),
		    queue = [],
		    margin = this.options.keepBuffer,
		    noPruneRange = new Bounds(tileRange.getBottomLeft().subtract([margin, -margin]),
		                              tileRange.getTopRight().add([margin, -margin]));

		// Sanity check: panic if the tile range contains Infinity somewhere.
		if (!(isFinite(tileRange.min.x) &&
		      isFinite(tileRange.min.y) &&
		      isFinite(tileRange.max.x) &&
		      isFinite(tileRange.max.y))) { throw new Error('Attempted to load an infinite number of tiles'); }

		for (var key in this._tiles) {
			var c = this._tiles[key].coords;
			if (c.z !== this._tileZoom || !noPruneRange.contains(new Point(c.x, c.y))) {
				this._tiles[key].current = false;
			}
		}

		// _update just loads more tiles. If the tile zoom level differs too much
		// from the map's, let _setView reset levels and prune old tiles.
		if (Math.abs(zoom - this._tileZoom) > 1) { this._setView(center, zoom); return; }

		// create a queue of coordinates to load tiles from
		for (var j = tileRange.min.y; j <= tileRange.max.y; j++) {
			for (var i = tileRange.min.x; i <= tileRange.max.x; i++) {
				var coords = new Point(i, j);
				coords.z = this._tileZoom;

				if (!this._isValidTile(coords)) { continue; }

				if (!this._tiles[this._tileCoordsToKey(coords)]) {
					queue.push(coords);
				}
			}
		}

		// sort tile queue to load tiles in order of their distance to center
		queue.sort(function (a, b) {
			return a.distanceTo(tileCenter) - b.distanceTo(tileCenter);
		});

		if (queue.length !== 0) {
			// if it's the first batch of tiles to load
			if (!this._loading) {
				this._loading = true;
				// @event loading: Event
				// Fired when the grid layer starts loading tiles.
				this.fire('loading');
			}

			// create DOM fragment to append tiles in one batch
			var fragment = document.createDocumentFragment();

			for (i = 0; i < queue.length; i++) {
				this._addTile(queue[i], fragment);
			}

			this._level.el.appendChild(fragment);
		}
	},

	_isValidTile: function (coords) {
		var crs = this._map.options.crs;

		if (!crs.infinite) {
			// don't load tile if it's out of bounds and not wrapped
			var bounds = this._globalTileRange;
			if ((!crs.wrapLng && (coords.x < bounds.min.x || coords.x > bounds.max.x)) ||
			    (!crs.wrapLat && (coords.y < bounds.min.y || coords.y > bounds.max.y))) { return false; }
		}

		if (!this.options.bounds) { return true; }

		// don't load tile if it doesn't intersect the bounds in options
		var tileBounds = this._tileCoordsToBounds(coords);
		return toLatLngBounds(this.options.bounds).overlaps(tileBounds);
	},

	_keyToBounds: function (key) {
		return this._tileCoordsToBounds(this._keyToTileCoords(key));
	},

	// converts tile coordinates to its geographical bounds
	_tileCoordsToBounds: function (coords) {

		var map = this._map,
		    tileSize = this.getTileSize(),

		    nwPoint = coords.scaleBy(tileSize),
		    sePoint = nwPoint.add(tileSize),

		    nw = map.unproject(nwPoint, coords.z),
		    se = map.unproject(sePoint, coords.z),
		    bounds = new LatLngBounds(nw, se);

		if (!this.options.noWrap) {
			map.wrapLatLngBounds(bounds);
		}

		return bounds;
	},

	// converts tile coordinates to key for the tile cache
	_tileCoordsToKey: function (coords) {
		return coords.x + ':' + coords.y + ':' + coords.z;
	},

	// converts tile cache key to coordinates
	_keyToTileCoords: function (key) {
		var k = key.split(':'),
		    coords = new Point(+k[0], +k[1]);
		coords.z = +k[2];
		return coords;
	},

	_removeTile: function (key) {
		var tile = this._tiles[key];
		if (!tile) { return; }

		remove(tile.el);

		delete this._tiles[key];

		// @event tileunload: TileEvent
		// Fired when a tile is removed (e.g. when a tile goes off the screen).
		this.fire('tileunload', {
			tile: tile.el,
			coords: this._keyToTileCoords(key)
		});
	},

	_initTile: function (tile) {
		addClass(tile, 'leaflet-tile');

		var tileSize = this.getTileSize();
		tile.style.width = tileSize.x + 'px';
		tile.style.height = tileSize.y + 'px';

		tile.onselectstart = falseFn;
		tile.onmousemove = falseFn;

		// update opacity on tiles in IE7-8 because of filter inheritance problems
		if (ielt9 && this.options.opacity < 1) {
			setOpacity(tile, this.options.opacity);
		}

		// without this hack, tiles disappear after zoom on Chrome for Android
		// https://github.com/Leaflet/Leaflet/issues/2078
		if (android && !android23) {
			tile.style.WebkitBackfaceVisibility = 'hidden';
		}
	},

	_addTile: function (coords, container) {
		var tilePos = this._getTilePos(coords),
		    key = this._tileCoordsToKey(coords);

		var tile = this.createTile(this._wrapCoords(coords), bind(this._tileReady, this, coords));

		this._initTile(tile);

		// if createTile is defined with a second argument ("done" callback),
		// we know that tile is async and will be ready later; otherwise
		if (this.createTile.length < 2) {
			// mark tile as ready, but delay one frame for opacity animation to happen
			requestAnimFrame(bind(this._tileReady, this, coords, null, tile));
		}

		setPosition(tile, tilePos);

		// save tile in cache
		this._tiles[key] = {
			el: tile,
			coords: coords,
			current: true
		};

		container.appendChild(tile);
		// @event tileloadstart: TileEvent
		// Fired when a tile is requested and starts loading.
		this.fire('tileloadstart', {
			tile: tile,
			coords: coords
		});
	},

	_tileReady: function (coords, err, tile) {
		if (!this._map) { return; }

		if (err) {
			// @event tileerror: TileErrorEvent
			// Fired when there is an error loading a tile.
			this.fire('tileerror', {
				error: err,
				tile: tile,
				coords: coords
			});
		}

		var key = this._tileCoordsToKey(coords);

		tile = this._tiles[key];
		if (!tile) { return; }

		tile.loaded = +new Date();
		if (this._map._fadeAnimated) {
			setOpacity(tile.el, 0);
			cancelAnimFrame(this._fadeFrame);
			this._fadeFrame = requestAnimFrame(this._updateOpacity, this);
		} else {
			tile.active = true;
			this._pruneTiles();
		}

		if (!err) {
			addClass(tile.el, 'leaflet-tile-loaded');

			// @event tileload: TileEvent
			// Fired when a tile loads.
			this.fire('tileload', {
				tile: tile.el,
				coords: coords
			});
		}

		if (this._noTilesToLoad()) {
			this._loading = false;
			// @event load: Event
			// Fired when the grid layer loaded all visible tiles.
			this.fire('load');

			if (ielt9 || !this._map._fadeAnimated) {
				requestAnimFrame(this._pruneTiles, this);
			} else {
				// Wait a bit more than 0.2 secs (the duration of the tile fade-in)
				// to trigger a pruning.
				setTimeout(bind(this._pruneTiles, this), 250);
			}
		}
	},

	_getTilePos: function (coords) {
		return coords.scaleBy(this.getTileSize()).subtract(this._level.origin);
	},

	_wrapCoords: function (coords) {
		var newCoords = new Point(
			this._wrapX ? wrapNum(coords.x, this._wrapX) : coords.x,
			this._wrapY ? wrapNum(coords.y, this._wrapY) : coords.y);
		newCoords.z = coords.z;
		return newCoords;
	},

	_pxBoundsToTileRange: function (bounds) {
		var tileSize = this.getTileSize();
		return new Bounds(
			bounds.min.unscaleBy(tileSize).floor(),
			bounds.max.unscaleBy(tileSize).ceil().subtract([1, 1]));
	},

	_noTilesToLoad: function () {
		for (var key in this._tiles) {
			if (!this._tiles[key].loaded) { return false; }
		}
		return true;
	}
});

// @factory L.gridLayer(options?: GridLayer options)
// Creates a new instance of GridLayer with the supplied options.
function gridLayer(options) {
	return new GridLayer(options);
}

/*
 * @class TileLayer
 * @inherits GridLayer
 * @aka L.TileLayer
 * Used to load and display tile layers on the map. Extends `GridLayer`.
 *
 * @example
 *
 * ```js
 * L.tileLayer('http://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png?{foo}', {foo: 'bar'}).addTo(map);
 * ```
 *
 * @section URL template
 * @example
 *
 * A string of the following form:
 *
 * ```
 * 'http://{s}.somedomain.com/blabla/{z}/{x}/{y}{r}.png'
 * ```
 *
 * `{s}` means one of the available subdomains (used sequentially to help with browser parallel requests per domain limitation; subdomain values are specified in options; `a`, `b` or `c` by default, can be omitted), `{z}` — zoom level, `{x}` and `{y}` — tile coordinates. `{r}` can be used to add "&commat;2x" to the URL to load retina tiles.
 *
 * You can use custom keys in the template, which will be [evaluated](#util-template) from TileLayer options, like this:
 *
 * ```
 * L.tileLayer('http://{s}.somedomain.com/{foo}/{z}/{x}/{y}.png', {foo: 'bar'});
 * ```
 */


var TileLayer = GridLayer.extend({

	// @section
	// @aka TileLayer options
	options: {
		// @option minZoom: Number = 0
		// The minimum zoom level down to which this layer will be displayed (inclusive).
		minZoom: 0,

		// @option maxZoom: Number = 18
		// The maximum zoom level up to which this layer will be displayed (inclusive).
		maxZoom: 18,

		// @option subdomains: String|String[] = 'abc'
		// Subdomains of the tile service. Can be passed in the form of one string (where each letter is a subdomain name) or an array of strings.
		subdomains: 'abc',

		// @option errorTileUrl: String = ''
		// URL to the tile image to show in place of the tile that failed to load.
		errorTileUrl: '',

		// @option zoomOffset: Number = 0
		// The zoom number used in tile URLs will be offset with this value.
		zoomOffset: 0,

		// @option tms: Boolean = false
		// If `true`, inverses Y axis numbering for tiles (turn this on for [TMS](https://en.wikipedia.org/wiki/Tile_Map_Service) services).
		tms: false,

		// @option zoomReverse: Boolean = false
		// If set to true, the zoom number used in tile URLs will be reversed (`maxZoom - zoom` instead of `zoom`)
		zoomReverse: false,

		// @option detectRetina: Boolean = false
		// If `true` and user is on a retina display, it will request four tiles of half the specified size and a bigger zoom level in place of one to utilize the high resolution.
		detectRetina: false,

		// @option crossOrigin: Boolean = false
		// If true, all tiles will have their crossOrigin attribute set to ''. This is needed if you want to access tile pixel data.
		crossOrigin: false
	},

	initialize: function (url, options) {

		this._url = url;

		options = setOptions(this, options);

		// detecting retina displays, adjusting tileSize and zoom levels
		if (options.detectRetina && retina && options.maxZoom > 0) {

			options.tileSize = Math.floor(options.tileSize / 2);

			if (!options.zoomReverse) {
				options.zoomOffset++;
				options.maxZoom--;
			} else {
				options.zoomOffset--;
				options.minZoom++;
			}

			options.minZoom = Math.max(0, options.minZoom);
		}

		if (typeof options.subdomains === 'string') {
			options.subdomains = options.subdomains.split('');
		}

		// for https://github.com/Leaflet/Leaflet/issues/137
		if (!android) {
			this.on('tileunload', this._onTileRemove);
		}
	},

	// @method setUrl(url: String, noRedraw?: Boolean): this
	// Updates the layer's URL template and redraws it (unless `noRedraw` is set to `true`).
	setUrl: function (url, noRedraw) {
		this._url = url;

		if (!noRedraw) {
			this.redraw();
		}
		return this;
	},

	// @method createTile(coords: Object, done?: Function): HTMLElement
	// Called only internally, overrides GridLayer's [`createTile()`](#gridlayer-createtile)
	// to return an `<img>` HTML element with the appropiate image URL given `coords`. The `done`
	// callback is called when the tile has been loaded.
	createTile: function (coords, done) {
		var tile = document.createElement('img');

		on(tile, 'load', bind(this._tileOnLoad, this, done, tile));
		on(tile, 'error', bind(this._tileOnError, this, done, tile));

		if (this.options.crossOrigin) {
			tile.crossOrigin = '';
		}

		/*
		 Alt tag is set to empty string to keep screen readers from reading URL and for compliance reasons
		 http://www.w3.org/TR/WCAG20-TECHS/H67
		*/
		tile.alt = '';

		/*
		 Set role="presentation" to force screen readers to ignore this
		 https://www.w3.org/TR/wai-aria/roles#textalternativecomputation
		*/
		tile.setAttribute('role', 'presentation');

		tile.src = this.getTileUrl(coords);

		return tile;
	},

	// @section Extension methods
	// @uninheritable
	// Layers extending `TileLayer` might reimplement the following method.
	// @method getTileUrl(coords: Object): String
	// Called only internally, returns the URL for a tile given its coordinates.
	// Classes extending `TileLayer` can override this function to provide custom tile URL naming schemes.
	getTileUrl: function (coords) {
		var data = {
			r: retina ? '@2x' : '',
			s: this._getSubdomain(coords),
			x: coords.x,
			y: coords.y,
			z: this._getZoomForUrl()
		};
		if (this._map && !this._map.options.crs.infinite) {
			var invertedY = this._globalTileRange.max.y - coords.y;
			if (this.options.tms) {
				data['y'] = invertedY;
			}
			data['-y'] = invertedY;
		}

		return template(this._url, extend(data, this.options));
	},

	_tileOnLoad: function (done, tile) {
		// For https://github.com/Leaflet/Leaflet/issues/3332
		if (ielt9) {
			setTimeout(bind(done, this, null, tile), 0);
		} else {
			done(null, tile);
		}
	},

	_tileOnError: function (done, tile, e) {
		var errorUrl = this.options.errorTileUrl;
		if (errorUrl && tile.src !== errorUrl) {
			tile.src = errorUrl;
		}
		done(e, tile);
	},

	_onTileRemove: function (e) {
		e.tile.onload = null;
	},

	_getZoomForUrl: function () {
		var zoom = this._tileZoom,
		maxZoom = this.options.maxZoom,
		zoomReverse = this.options.zoomReverse,
		zoomOffset = this.options.zoomOffset;

		if (zoomReverse) {
			zoom = maxZoom - zoom;
		}

		return zoom + zoomOffset;
	},

	_getSubdomain: function (tilePoint) {
		var index = Math.abs(tilePoint.x + tilePoint.y) % this.options.subdomains.length;
		return this.options.subdomains[index];
	},

	// stops loading all tiles in the background layer
	_abortLoading: function () {
		var i, tile;
		for (i in this._tiles) {
			if (this._tiles[i].coords.z !== this._tileZoom) {
				tile = this._tiles[i].el;

				tile.onload = falseFn;
				tile.onerror = falseFn;

				if (!tile.complete) {
					tile.src = emptyImageUrl;
					remove(tile);
				}
			}
		}
	}
});


// @factory L.tilelayer(urlTemplate: String, options?: TileLayer options)
// Instantiates a tile layer object given a `URL template` and optionally an options object.

function tileLayer(url, options) {
	return new TileLayer(url, options);
}

/*
 * @class TileLayer.WMS
 * @inherits TileLayer
 * @aka L.TileLayer.WMS
 * Used to display [WMS](https://en.wikipedia.org/wiki/Web_Map_Service) services as tile layers on the map. Extends `TileLayer`.
 *
 * @example
 *
 * ```js
 * var nexrad = L.tileLayer.wms("http://mesonet.agron.iastate.edu/cgi-bin/wms/nexrad/n0r.cgi", {
 * 	layers: 'nexrad-n0r-900913',
 * 	format: 'image/png',
 * 	transparent: true,
 * 	attribution: "Weather data © 2012 IEM Nexrad"
 * });
 * ```
 */

var TileLayerWMS = TileLayer.extend({

	// @section
	// @aka TileLayer.WMS options
	// If any custom options not documented here are used, they will be sent to the
	// WMS server as extra parameters in each request URL. This can be useful for
	// [non-standard vendor WMS parameters](http://docs.geoserver.org/stable/en/user/services/wms/vendor.html).
	defaultWmsParams: {
		service: 'WMS',
		request: 'GetMap',

		// @option layers: String = ''
		// **(required)** Comma-separated list of WMS layers to show.
		layers: '',

		// @option styles: String = ''
		// Comma-separated list of WMS styles.
		styles: '',

		// @option format: String = 'image/jpeg'
		// WMS image format (use `'image/png'` for layers with transparency).
		format: 'image/jpeg',

		// @option transparent: Boolean = false
		// If `true`, the WMS service will return images with transparency.
		transparent: false,

		// @option version: String = '1.1.1'
		// Version of the WMS service to use
		version: '1.1.1'
	},

	options: {
		// @option crs: CRS = null
		// Coordinate Reference System to use for the WMS requests, defaults to
		// map CRS. Don't change this if you're not sure what it means.
		crs: null,

		// @option uppercase: Boolean = false
		// If `true`, WMS request parameter keys will be uppercase.
		uppercase: false
	},

	initialize: function (url, options) {

		this._url = url;

		var wmsParams = extend({}, this.defaultWmsParams);

		// all keys that are not TileLayer options go to WMS params
		for (var i in options) {
			if (!(i in this.options)) {
				wmsParams[i] = options[i];
			}
		}

		options = setOptions(this, options);

		wmsParams.width = wmsParams.height = options.tileSize * (options.detectRetina && retina ? 2 : 1);

		this.wmsParams = wmsParams;
	},

	onAdd: function (map) {

		this._crs = this.options.crs || map.options.crs;
		this._wmsVersion = parseFloat(this.wmsParams.version);

		var projectionKey = this._wmsVersion >= 1.3 ? 'crs' : 'srs';
		this.wmsParams[projectionKey] = this._crs.code;

		TileLayer.prototype.onAdd.call(this, map);
	},

	getTileUrl: function (coords) {

		var tileBounds = this._tileCoordsToBounds(coords),
		    nw = this._crs.project(tileBounds.getNorthWest()),
		    se = this._crs.project(tileBounds.getSouthEast()),

		    bbox = (this._wmsVersion >= 1.3 && this._crs === EPSG4326 ?
			    [se.y, nw.x, nw.y, se.x] :
			    [nw.x, se.y, se.x, nw.y]).join(','),

		    url = TileLayer.prototype.getTileUrl.call(this, coords);

		return url +
			getParamString(this.wmsParams, url, this.options.uppercase) +
			(this.options.uppercase ? '&BBOX=' : '&bbox=') + bbox;
	},

	// @method setParams(params: Object, noRedraw?: Boolean): this
	// Merges an object with the new parameters and re-requests tiles on the current screen (unless `noRedraw` was set to true).
	setParams: function (params, noRedraw) {

		extend(this.wmsParams, params);

		if (!noRedraw) {
			this.redraw();
		}

		return this;
	}
});


// @factory L.tileLayer.wms(baseUrl: String, options: TileLayer.WMS options)
// Instantiates a WMS tile layer object given a base URL of the WMS service and a WMS parameters/options object.
function tileLayerWMS(url, options) {
	return new TileLayerWMS(url, options);
}

TileLayer.WMS = TileLayerWMS;
tileLayer.wms = tileLayerWMS;

/*
 * @class Renderer
 * @inherits Layer
 * @aka L.Renderer
 *
 * Base class for vector renderer implementations (`SVG`, `Canvas`). Handles the
 * DOM container of the renderer, its bounds, and its zoom animation.
 *
 * A `Renderer` works as an implicit layer group for all `Path`s - the renderer
 * itself can be added or removed to the map. All paths use a renderer, which can
 * be implicit (the map will decide the type of renderer and use it automatically)
 * or explicit (using the [`renderer`](#path-renderer) option of the path).
 *
 * Do not use this class directly, use `SVG` and `Canvas` instead.
 *
 * @event update: Event
 * Fired when the renderer updates its bounds, center and zoom, for example when
 * its map has moved
 */

var Renderer = Layer.extend({

	// @section
	// @aka Renderer options
	options: {
		// @option padding: Number = 0.1
		// How much to extend the clip area around the map view (relative to its size)
		// e.g. 0.1 would be 10% of map view in each direction
		padding: 0.1
	},

	initialize: function (options) {
		setOptions(this, options);
		stamp(this);
		this._layers = this._layers || {};
	},

	onAdd: function () {
		if (!this._container) {
			this._initContainer(); // defined by renderer implementations

			if (this._zoomAnimated) {
				addClass(this._container, 'leaflet-zoom-animated');
			}
		}

		this.getPane().appendChild(this._container);
		this._update();
		this.on('update', this._updatePaths, this);
	},

	onRemove: function () {
		this.off('update', this._updatePaths, this);
		this._destroyContainer();
	},

	getEvents: function () {
		var events = {
			viewreset: this._reset,
			zoom: this._onZoom,
			moveend: this._update,
			zoomend: this._onZoomEnd
		};
		if (this._zoomAnimated) {
			events.zoomanim = this._onAnimZoom;
		}
		return events;
	},

	_onAnimZoom: function (ev) {
		this._updateTransform(ev.center, ev.zoom);
	},

	_onZoom: function () {
		this._updateTransform(this._map.getCenter(), this._map.getZoom());
	},

	_updateTransform: function (center, zoom) {
		var scale = this._map.getZoomScale(zoom, this._zoom),
		    position = getPosition(this._container),
		    viewHalf = this._map.getSize().multiplyBy(0.5 + this.options.padding),
		    currentCenterPoint = this._map.project(this._center, zoom),
		    destCenterPoint = this._map.project(center, zoom),
		    centerOffset = destCenterPoint.subtract(currentCenterPoint),

		    topLeftOffset = viewHalf.multiplyBy(-scale).add(position).add(viewHalf).subtract(centerOffset);

		if (any3d) {
			setTransform(this._container, topLeftOffset, scale);
		} else {
			setPosition(this._container, topLeftOffset);
		}
	},

	_reset: function () {
		this._update();
		this._updateTransform(this._center, this._zoom);

		for (var id in this._layers) {
			this._layers[id]._reset();
		}
	},

	_onZoomEnd: function () {
		for (var id in this._layers) {
			this._layers[id]._project();
		}
	},

	_updatePaths: function () {
		for (var id in this._layers) {
			this._layers[id]._update();
		}
	},

	_update: function () {
		// Update pixel bounds of renderer container (for positioning/sizing/clipping later)
		// Subclasses are responsible of firing the 'update' event.
		var p = this.options.padding,
		    size = this._map.getSize(),
		    min = this._map.containerPointToLayerPoint(size.multiplyBy(-p)).round();

		this._bounds = new Bounds(min, min.add(size.multiplyBy(1 + p * 2)).round());

		this._center = this._map.getCenter();
		this._zoom = this._map.getZoom();
	}
});

/*
 * @class Canvas
 * @inherits Renderer
 * @aka L.Canvas
 *
 * Allows vector layers to be displayed with [`<canvas>`](https://developer.mozilla.org/docs/Web/API/Canvas_API).
 * Inherits `Renderer`.
 *
 * Due to [technical limitations](http://caniuse.com/#search=canvas), Canvas is not
 * available in all web browsers, notably IE8, and overlapping geometries might
 * not display properly in some edge cases.
 *
 * @example
 *
 * Use Canvas by default for all paths in the map:
 *
 * ```js
 * var map = L.map('map', {
 * 	renderer: L.canvas()
 * });
 * ```
 *
 * Use a Canvas renderer with extra padding for specific vector geometries:
 *
 * ```js
 * var map = L.map('map');
 * var myRenderer = L.canvas({ padding: 0.5 });
 * var line = L.polyline( coordinates, { renderer: myRenderer } );
 * var circle = L.circle( center, { renderer: myRenderer } );
 * ```
 */

var Canvas = Renderer.extend({
	getEvents: function () {
		var events = Renderer.prototype.getEvents.call(this);
		events.viewprereset = this._onViewPreReset;
		return events;
	},

	_onViewPreReset: function () {
		// Set a flag so that a viewprereset+moveend+viewreset only updates&redraws once
		this._postponeUpdatePaths = true;
	},

	onAdd: function () {
		Renderer.prototype.onAdd.call(this);

		// Redraw vectors since canvas is cleared upon removal,
		// in case of removing the renderer itself from the map.
		this._draw();
	},

	_initContainer: function () {
		var container = this._container = document.createElement('canvas');

		on(container, 'mousemove', throttle(this._onMouseMove, 32, this), this);
		on(container, 'click dblclick mousedown mouseup contextmenu', this._onClick, this);
		on(container, 'mouseout', this._handleMouseOut, this);

		this._ctx = container.getContext('2d');
	},

	_destroyContainer: function () {
		delete this._ctx;
		remove(this._container);
		off(this._container);
		delete this._container;
	},

	_updatePaths: function () {
		if (this._postponeUpdatePaths) { return; }

		var layer;
		this._redrawBounds = null;
		for (var id in this._layers) {
			layer = this._layers[id];
			layer._update();
		}
		this._redraw();
	},

	_update: function () {
		if (this._map._animatingZoom && this._bounds) { return; }

		this._drawnLayers = {};

		Renderer.prototype._update.call(this);

		var b = this._bounds,
		    container = this._container,
		    size = b.getSize(),
		    m = retina ? 2 : 1;

		setPosition(container, b.min);

		// set canvas size (also clearing it); use double size on retina
		container.width = m * size.x;
		container.height = m * size.y;
		container.style.width = size.x + 'px';
		container.style.height = size.y + 'px';

		if (retina) {
			this._ctx.scale(2, 2);
		}

		// translate so we use the same path coordinates after canvas element moves
		this._ctx.translate(-b.min.x, -b.min.y);

		// Tell paths to redraw themselves
		this.fire('update');
	},

	_reset: function () {
		Renderer.prototype._reset.call(this);

		if (this._postponeUpdatePaths) {
			this._postponeUpdatePaths = false;
			this._updatePaths();
		}
	},

	_initPath: function (layer) {
		this._updateDashArray(layer);
		this._layers[stamp(layer)] = layer;

		var order = layer._order = {
			layer: layer,
			prev: this._drawLast,
			next: null
		};
		if (this._drawLast) { this._drawLast.next = order; }
		this._drawLast = order;
		this._drawFirst = this._drawFirst || this._drawLast;
	},

	_addPath: function (layer) {
		this._requestRedraw(layer);
	},

	_removePath: function (layer) {
		var order = layer._order;
		var next = order.next;
		var prev = order.prev;

		if (next) {
			next.prev = prev;
		} else {
			this._drawLast = prev;
		}
		if (prev) {
			prev.next = next;
		} else {
			this._drawFirst = next;
		}

		delete layer._order;

		delete this._layers[L.stamp(layer)];

		this._requestRedraw(layer);
	},

	_updatePath: function (layer) {
		// Redraw the union of the layer's old pixel
		// bounds and the new pixel bounds.
		this._extendRedrawBounds(layer);
		layer._project();
		layer._update();
		// The redraw will extend the redraw bounds
		// with the new pixel bounds.
		this._requestRedraw(layer);
	},

	_updateStyle: function (layer) {
		this._updateDashArray(layer);
		this._requestRedraw(layer);
	},

	_updateDashArray: function (layer) {
		if (layer.options.dashArray) {
			var parts = layer.options.dashArray.split(','),
			    dashArray = [],
			    i;
			for (i = 0; i < parts.length; i++) {
				dashArray.push(Number(parts[i]));
			}
			layer.options._dashArray = dashArray;
		}
	},

	_requestRedraw: function (layer) {
		if (!this._map) { return; }

		this._extendRedrawBounds(layer);
		this._redrawRequest = this._redrawRequest || requestAnimFrame(this._redraw, this);
	},

	_extendRedrawBounds: function (layer) {
		if (layer._pxBounds) {
			var padding = (layer.options.weight || 0) + 1;
			this._redrawBounds = this._redrawBounds || new Bounds();
			this._redrawBounds.extend(layer._pxBounds.min.subtract([padding, padding]));
			this._redrawBounds.extend(layer._pxBounds.max.add([padding, padding]));
		}
	},

	_redraw: function () {
		this._redrawRequest = null;

		if (this._redrawBounds) {
			this._redrawBounds.min._floor();
			this._redrawBounds.max._ceil();
		}

		this._clear(); // clear layers in redraw bounds
		this._draw(); // draw layers

		this._redrawBounds = null;
	},

	_clear: function () {
		var bounds = this._redrawBounds;
		if (bounds) {
			var size = bounds.getSize();
			this._ctx.clearRect(bounds.min.x, bounds.min.y, size.x, size.y);
		} else {
			this._ctx.clearRect(0, 0, this._container.width, this._container.height);
		}
	},

	_draw: function () {
		var layer, bounds = this._redrawBounds;
		this._ctx.save();
		if (bounds) {
			var size = bounds.getSize();
			this._ctx.beginPath();
			this._ctx.rect(bounds.min.x, bounds.min.y, size.x, size.y);
			this._ctx.clip();
		}

		this._drawing = true;

		for (var order = this._drawFirst; order; order = order.next) {
			layer = order.layer;
			if (!bounds || (layer._pxBounds && layer._pxBounds.intersects(bounds))) {
				layer._updatePath();
			}
		}

		this._drawing = false;

		this._ctx.restore();  // Restore state before clipping.
	},

	_updatePoly: function (layer, closed) {
		if (!this._drawing) { return; }

		var i, j, len2, p,
		    parts = layer._parts,
		    len = parts.length,
		    ctx = this._ctx;

		if (!len) { return; }

		this._drawnLayers[layer._leaflet_id] = layer;

		ctx.beginPath();

		for (i = 0; i < len; i++) {
			for (j = 0, len2 = parts[i].length; j < len2; j++) {
				p = parts[i][j];
				ctx[j ? 'lineTo' : 'moveTo'](p.x, p.y);
			}
			if (closed) {
				ctx.closePath();
			}
		}

		this._fillStroke(ctx, layer);

		// TODO optimization: 1 fill/stroke for all features with equal style instead of 1 for each feature
	},

	_updateCircle: function (layer) {

		if (!this._drawing || layer._empty()) { return; }

		var p = layer._point,
		    ctx = this._ctx,
		    r = layer._radius,
		    s = (layer._radiusY || r) / r;

		this._drawnLayers[layer._leaflet_id] = layer;

		if (s !== 1) {
			ctx.save();
			ctx.scale(1, s);
		}

		ctx.beginPath();
		ctx.arc(p.x, p.y / s, r, 0, Math.PI * 2, false);

		if (s !== 1) {
			ctx.restore();
		}

		this._fillStroke(ctx, layer);
	},

	_fillStroke: function (ctx, layer) {
		var options = layer.options;

		if (options.fill) {
			ctx.globalAlpha = options.fillOpacity;
			ctx.fillStyle = options.fillColor || options.color;
			ctx.fill(options.fillRule || 'evenodd');
		}

		if (options.stroke && options.weight !== 0) {
			if (ctx.setLineDash) {
				ctx.setLineDash(layer.options && layer.options._dashArray || []);
			}
			ctx.globalAlpha = options.opacity;
			ctx.lineWidth = options.weight;
			ctx.strokeStyle = options.color;
			ctx.lineCap = options.lineCap;
			ctx.lineJoin = options.lineJoin;
			ctx.stroke();
		}
	},

	// Canvas obviously doesn't have mouse events for individual drawn objects,
	// so we emulate that by calculating what's under the mouse on mousemove/click manually

	_onClick: function (e) {
		var point = this._map.mouseEventToLayerPoint(e), layer, clickedLayer;

		for (var order = this._drawFirst; order; order = order.next) {
			layer = order.layer;
			if (layer.options.interactive && layer._containsPoint(point) && !this._map._draggableMoved(layer)) {
				clickedLayer = layer;
			}
		}
		if (clickedLayer)  {
			fakeStop(e);
			this._fireEvent([clickedLayer], e);
		}
	},

	_onMouseMove: function (e) {
		if (!this._map || this._map.dragging.moving() || this._map._animatingZoom) { return; }

		var point = this._map.mouseEventToLayerPoint(e);
		this._handleMouseHover(e, point);
	},


	_handleMouseOut: function (e) {
		var layer = this._hoveredLayer;
		if (layer) {
			// if we're leaving the layer, fire mouseout
			removeClass(this._container, 'leaflet-interactive');
			this._fireEvent([layer], e, 'mouseout');
			this._hoveredLayer = null;
		}
	},

	_handleMouseHover: function (e, point) {
		var layer, candidateHoveredLayer;

		for (var order = this._drawFirst; order; order = order.next) {
			layer = order.layer;
			if (layer.options.interactive && layer._containsPoint(point)) {
				candidateHoveredLayer = layer;
			}
		}

		if (candidateHoveredLayer !== this._hoveredLayer) {
			this._handleMouseOut(e);

			if (candidateHoveredLayer) {
				addClass(this._container, 'leaflet-interactive'); // change cursor
				this._fireEvent([candidateHoveredLayer], e, 'mouseover');
				this._hoveredLayer = candidateHoveredLayer;
			}
		}

		if (this._hoveredLayer) {
			this._fireEvent([this._hoveredLayer], e);
		}
	},

	_fireEvent: function (layers, e, type) {
		this._map._fireDOMEvent(e, type || e.type, layers);
	},

	_bringToFront: function (layer) {
		var order = layer._order;
		var next = order.next;
		var prev = order.prev;

		if (next) {
			next.prev = prev;
		} else {
			// Already last
			return;
		}
		if (prev) {
			prev.next = next;
		} else if (next) {
			// Update first entry unless this is the
			// signle entry
			this._drawFirst = next;
		}

		order.prev = this._drawLast;
		this._drawLast.next = order;

		order.next = null;
		this._drawLast = order;

		this._requestRedraw(layer);
	},

	_bringToBack: function (layer) {
		var order = layer._order;
		var next = order.next;
		var prev = order.prev;

		if (prev) {
			prev.next = next;
		} else {
			// Already first
			return;
		}
		if (next) {
			next.prev = prev;
		} else if (prev) {
			// Update last entry unless this is the
			// signle entry
			this._drawLast = prev;
		}

		order.prev = null;

		order.next = this._drawFirst;
		this._drawFirst.prev = order;
		this._drawFirst = order;

		this._requestRedraw(layer);
	}
});

// @factory L.canvas(options?: Renderer options)
// Creates a Canvas renderer with the given options.
function canvas$1(options) {
	return canvas ? new Canvas(options) : null;
}

/*
 * Thanks to Dmitry Baranovsky and his Raphael library for inspiration!
 */


var vmlCreate = (function () {
	try {
		document.namespaces.add('lvml', 'urn:schemas-microsoft-com:vml');
		return function (name) {
			return document.createElement('<lvml:' + name + ' class="lvml">');
		};
	} catch (e) {
		return function (name) {
			return document.createElement('<' + name + ' xmlns="urn:schemas-microsoft.com:vml" class="lvml">');
		};
	}
})();


/*
 * @class SVG
 *
 * Although SVG is not available on IE7 and IE8, these browsers support [VML](https://en.wikipedia.org/wiki/Vector_Markup_Language), and the SVG renderer will fall back to VML in this case.
 *
 * VML was deprecated in 2012, which means VML functionality exists only for backwards compatibility
 * with old versions of Internet Explorer.
 */

// mixin to redefine some SVG methods to handle VML syntax which is similar but with some differences
var vmlMixin = {

	_initContainer: function () {
		this._container = create$1('div', 'leaflet-vml-container');
	},

	_update: function () {
		if (this._map._animatingZoom) { return; }
		Renderer.prototype._update.call(this);
		this.fire('update');
	},

	_initPath: function (layer) {
		var container = layer._container = vmlCreate('shape');

		addClass(container, 'leaflet-vml-shape ' + (this.options.className || ''));

		container.coordsize = '1 1';

		layer._path = vmlCreate('path');
		container.appendChild(layer._path);

		this._updateStyle(layer);
		this._layers[stamp(layer)] = layer;
	},

	_addPath: function (layer) {
		var container = layer._container;
		this._container.appendChild(container);

		if (layer.options.interactive) {
			layer.addInteractiveTarget(container);
		}
	},

	_removePath: function (layer) {
		var container = layer._container;
		remove(container);
		layer.removeInteractiveTarget(container);
		delete this._layers[stamp(layer)];
	},

	_updateStyle: function (layer) {
		var stroke = layer._stroke,
		    fill = layer._fill,
		    options = layer.options,
		    container = layer._container;

		container.stroked = !!options.stroke;
		container.filled = !!options.fill;

		if (options.stroke) {
			if (!stroke) {
				stroke = layer._stroke = vmlCreate('stroke');
			}
			container.appendChild(stroke);
			stroke.weight = options.weight + 'px';
			stroke.color = options.color;
			stroke.opacity = options.opacity;

			if (options.dashArray) {
				stroke.dashStyle = isArray(options.dashArray) ?
				    options.dashArray.join(' ') :
				    options.dashArray.replace(/( *, *)/g, ' ');
			} else {
				stroke.dashStyle = '';
			}
			stroke.endcap = options.lineCap.replace('butt', 'flat');
			stroke.joinstyle = options.lineJoin;

		} else if (stroke) {
			container.removeChild(stroke);
			layer._stroke = null;
		}

		if (options.fill) {
			if (!fill) {
				fill = layer._fill = vmlCreate('fill');
			}
			container.appendChild(fill);
			fill.color = options.fillColor || options.color;
			fill.opacity = options.fillOpacity;

		} else if (fill) {
			container.removeChild(fill);
			layer._fill = null;
		}
	},

	_updateCircle: function (layer) {
		var p = layer._point.round(),
		    r = Math.round(layer._radius),
		    r2 = Math.round(layer._radiusY || r);

		this._setPath(layer, layer._empty() ? 'M0 0' :
				'AL ' + p.x + ',' + p.y + ' ' + r + ',' + r2 + ' 0,' + (65535 * 360));
	},

	_setPath: function (layer, path) {
		layer._path.v = path;
	},

	_bringToFront: function (layer) {
		toFront(layer._container);
	},

	_bringToBack: function (layer) {
		toBack(layer._container);
	}
};

var create$2 = vml ? vmlCreate : svgCreate;

/*
 * @class SVG
 * @inherits Renderer
 * @aka L.SVG
 *
 * Allows vector layers to be displayed with [SVG](https://developer.mozilla.org/docs/Web/SVG).
 * Inherits `Renderer`.
 *
 * Due to [technical limitations](http://caniuse.com/#search=svg), SVG is not
 * available in all web browsers, notably Android 2.x and 3.x.
 *
 * Although SVG is not available on IE7 and IE8, these browsers support
 * [VML](https://en.wikipedia.org/wiki/Vector_Markup_Language)
 * (a now deprecated technology), and the SVG renderer will fall back to VML in
 * this case.
 *
 * @example
 *
 * Use SVG by default for all paths in the map:
 *
 * ```js
 * var map = L.map('map', {
 * 	renderer: L.svg()
 * });
 * ```
 *
 * Use a SVG renderer with extra padding for specific vector geometries:
 *
 * ```js
 * var map = L.map('map');
 * var myRenderer = L.svg({ padding: 0.5 });
 * var line = L.polyline( coordinates, { renderer: myRenderer } );
 * var circle = L.circle( center, { renderer: myRenderer } );
 * ```
 */

var SVG = Renderer.extend({

	getEvents: function () {
		var events = Renderer.prototype.getEvents.call(this);
		events.zoomstart = this._onZoomStart;
		return events;
	},

	_initContainer: function () {
		this._container = create$2('svg');

		// makes it possible to click through svg root; we'll reset it back in individual paths
		this._container.setAttribute('pointer-events', 'none');

		this._rootGroup = create$2('g');
		this._container.appendChild(this._rootGroup);
	},

	_destroyContainer: function () {
		remove(this._container);
		off(this._container);
		delete this._container;
		delete this._rootGroup;
	},

	_onZoomStart: function () {
		// Drag-then-pinch interactions might mess up the center and zoom.
		// In this case, the easiest way to prevent this is re-do the renderer
		//   bounds and padding when the zooming starts.
		this._update();
	},

	_update: function () {
		if (this._map._animatingZoom && this._bounds) { return; }

		Renderer.prototype._update.call(this);

		var b = this._bounds,
		    size = b.getSize(),
		    container = this._container;

		// set size of svg-container if changed
		if (!this._svgSize || !this._svgSize.equals(size)) {
			this._svgSize = size;
			container.setAttribute('width', size.x);
			container.setAttribute('height', size.y);
		}

		// movement: update container viewBox so that we don't have to change coordinates of individual layers
		setPosition(container, b.min);
		container.setAttribute('viewBox', [b.min.x, b.min.y, size.x, size.y].join(' '));

		this.fire('update');
	},

	// methods below are called by vector layers implementations

	_initPath: function (layer) {
		var path = layer._path = create$2('path');

		// @namespace Path
		// @option className: String = null
		// Custom class name set on an element. Only for SVG renderer.
		if (layer.options.className) {
			addClass(path, layer.options.className);
		}

		if (layer.options.interactive) {
			addClass(path, 'leaflet-interactive');
		}

		this._updateStyle(layer);
		this._layers[stamp(layer)] = layer;
	},

	_addPath: function (layer) {
		if (!this._rootGroup) { this._initContainer(); }
		this._rootGroup.appendChild(layer._path);
		layer.addInteractiveTarget(layer._path);
	},

	_removePath: function (layer) {
		remove(layer._path);
		layer.removeInteractiveTarget(layer._path);
		delete this._layers[stamp(layer)];
	},

	_updatePath: function (layer) {
		layer._project();
		layer._update();
	},

	_updateStyle: function (layer) {
		var path = layer._path,
		    options = layer.options;

		if (!path) { return; }

		if (options.stroke) {
			path.setAttribute('stroke', options.color);
			path.setAttribute('stroke-opacity', options.opacity);
			path.setAttribute('stroke-width', options.weight);
			path.setAttribute('stroke-linecap', options.lineCap);
			path.setAttribute('stroke-linejoin', options.lineJoin);

			if (options.dashArray) {
				path.setAttribute('stroke-dasharray', options.dashArray);
			} else {
				path.removeAttribute('stroke-dasharray');
			}

			if (options.dashOffset) {
				path.setAttribute('stroke-dashoffset', options.dashOffset);
			} else {
				path.removeAttribute('stroke-dashoffset');
			}
		} else {
			path.setAttribute('stroke', 'none');
		}

		if (options.fill) {
			path.setAttribute('fill', options.fillColor || options.color);
			path.setAttribute('fill-opacity', options.fillOpacity);
			path.setAttribute('fill-rule', options.fillRule || 'evenodd');
		} else {
			path.setAttribute('fill', 'none');
		}
	},

	_updatePoly: function (layer, closed) {
		this._setPath(layer, pointsToPath(layer._parts, closed));
	},

	_updateCircle: function (layer) {
		var p = layer._point,
		    r = layer._radius,
		    r2 = layer._radiusY || r,
		    arc = 'a' + r + ',' + r2 + ' 0 1,0 ';

		// drawing a circle with two half-arcs
		var d = layer._empty() ? 'M0 0' :
				'M' + (p.x - r) + ',' + p.y +
				arc + (r * 2) + ',0 ' +
				arc + (-r * 2) + ',0 ';

		this._setPath(layer, d);
	},

	_setPath: function (layer, path) {
		layer._path.setAttribute('d', path);
	},

	// SVG does not have the concept of zIndex so we resort to changing the DOM order of elements
	_bringToFront: function (layer) {
		toFront(layer._path);
	},

	_bringToBack: function (layer) {
		toBack(layer._path);
	}
});

if (vml) {
	SVG.include(vmlMixin);
}

// @factory L.svg(options?: Renderer options)
// Creates a SVG renderer with the given options.
function svg$1(options) {
	return svg || vml ? new SVG(options) : null;
}

Map.include({
	// @namespace Map; @method getRenderer(layer: Path): Renderer
	// Returns the instance of `Renderer` that should be used to render the given
	// `Path`. It will ensure that the `renderer` options of the map and paths
	// are respected, and that the renderers do exist on the map.
	getRenderer: function (layer) {
		// @namespace Path; @option renderer: Renderer
		// Use this specific instance of `Renderer` for this path. Takes
		// precedence over the map's [default renderer](#map-renderer).
		var renderer = layer.options.renderer || this._getPaneRenderer(layer.options.pane) || this.options.renderer || this._renderer;

		if (!renderer) {
			// @namespace Map; @option preferCanvas: Boolean = false
			// Whether `Path`s should be rendered on a `Canvas` renderer.
			// By default, all `Path`s are rendered in a `SVG` renderer.
			renderer = this._renderer = (this.options.preferCanvas && canvas$1()) || svg$1();
		}

		if (!this.hasLayer(renderer)) {
			this.addLayer(renderer);
		}
		return renderer;
	},

	_getPaneRenderer: function (name) {
		if (name === 'overlayPane' || name === undefined) {
			return false;
		}

		var renderer = this._paneRenderers[name];
		if (renderer === undefined) {
			renderer = (SVG && svg$1({pane: name})) || (Canvas && canvas$1({pane: name}));
			this._paneRenderers[name] = renderer;
		}
		return renderer;
	}
});

/*
 * L.Rectangle extends Polygon and creates a rectangle when passed a LatLngBounds object.
 */

/*
 * @class Rectangle
 * @aka L.Retangle
 * @inherits Polygon
 *
 * A class for drawing rectangle overlays on a map. Extends `Polygon`.
 *
 * @example
 *
 * ```js
 * // define rectangle geographical bounds
 * var bounds = [[54.559322, -5.767822], [56.1210604, -3.021240]];
 *
 * // create an orange rectangle
 * L.rectangle(bounds, {color: "#ff7800", weight: 1}).addTo(map);
 *
 * // zoom the map to the rectangle bounds
 * map.fitBounds(bounds);
 * ```
 *
 */


var Rectangle = Polygon.extend({
	initialize: function (latLngBounds, options) {
		Polygon.prototype.initialize.call(this, this._boundsToLatLngs(latLngBounds), options);
	},

	// @method setBounds(latLngBounds: LatLngBounds): this
	// Redraws the rectangle with the passed bounds.
	setBounds: function (latLngBounds) {
		return this.setLatLngs(this._boundsToLatLngs(latLngBounds));
	},

	_boundsToLatLngs: function (latLngBounds) {
		latLngBounds = toLatLngBounds(latLngBounds);
		return [
			latLngBounds.getSouthWest(),
			latLngBounds.getNorthWest(),
			latLngBounds.getNorthEast(),
			latLngBounds.getSouthEast()
		];
	}
});


// @factory L.rectangle(latLngBounds: LatLngBounds, options?: Polyline options)
function rectangle(latLngBounds, options) {
	return new Rectangle(latLngBounds, options);
}

SVG.create = create$2;
SVG.pointsToPath = pointsToPath;

GeoJSON.geometryToLayer = geometryToLayer;
GeoJSON.coordsToLatLng = coordsToLatLng;
GeoJSON.coordsToLatLngs = coordsToLatLngs;
GeoJSON.latLngToCoords = latLngToCoords;
GeoJSON.latLngsToCoords = latLngsToCoords;
GeoJSON.getFeature = getFeature;
GeoJSON.asFeature = asFeature;

/*
 * L.Handler.BoxZoom is used to add shift-drag zoom interaction to the map
 * (zoom to a selected bounding box), enabled by default.
 */

// @namespace Map
// @section Interaction Options
Map.mergeOptions({
	// @option boxZoom: Boolean = true
	// Whether the map can be zoomed to a rectangular area specified by
	// dragging the mouse while pressing the shift key.
	boxZoom: true
});

var BoxZoom = Handler.extend({
	initialize: function (map) {
		this._map = map;
		this._container = map._container;
		this._pane = map._panes.overlayPane;
		this._resetStateTimeout = 0;
		map.on('unload', this._destroy, this);
	},

	addHooks: function () {
		on(this._container, 'mousedown', this._onMouseDown, this);
	},

	removeHooks: function () {
		off(this._container, 'mousedown', this._onMouseDown, this);
	},

	moved: function () {
		return this._moved;
	},

	_destroy: function () {
		remove(this._pane);
		delete this._pane;
	},

	_resetState: function () {
		this._resetStateTimeout = 0;
		this._moved = false;
	},

	_clearDeferredResetState: function () {
		if (this._resetStateTimeout !== 0) {
			clearTimeout(this._resetStateTimeout);
			this._resetStateTimeout = 0;
		}
	},

	_onMouseDown: function (e) {
		if (!e.shiftKey || ((e.which !== 1) && (e.button !== 1))) { return false; }

		// Clear the deferred resetState if it hasn't executed yet, otherwise it
		// will interrupt the interaction and orphan a box element in the container.
		this._clearDeferredResetState();
		this._resetState();

		disableTextSelection();
		disableImageDrag();

		this._startPoint = this._map.mouseEventToContainerPoint(e);

		on(document, {
			contextmenu: stop,
			mousemove: this._onMouseMove,
			mouseup: this._onMouseUp,
			keydown: this._onKeyDown
		}, this);
	},

	_onMouseMove: function (e) {
		if (!this._moved) {
			this._moved = true;

			this._box = create$1('div', 'leaflet-zoom-box', this._container);
			addClass(this._container, 'leaflet-crosshair');

			this._map.fire('boxzoomstart');
		}

		this._point = this._map.mouseEventToContainerPoint(e);

		var bounds = new Bounds(this._point, this._startPoint),
		    size = bounds.getSize();

		setPosition(this._box, bounds.min);

		this._box.style.width  = size.x + 'px';
		this._box.style.height = size.y + 'px';
	},

	_finish: function () {
		if (this._moved) {
			remove(this._box);
			removeClass(this._container, 'leaflet-crosshair');
		}

		enableTextSelection();
		enableImageDrag();

		off(document, {
			contextmenu: stop,
			mousemove: this._onMouseMove,
			mouseup: this._onMouseUp,
			keydown: this._onKeyDown
		}, this);
	},

	_onMouseUp: function (e) {
		if ((e.which !== 1) && (e.button !== 1)) { return; }

		this._finish();

		if (!this._moved) { return; }
		// Postpone to next JS tick so internal click event handling
		// still see it as "moved".
		this._clearDeferredResetState();
		this._resetStateTimeout = setTimeout(bind(this._resetState, this), 0);

		var bounds = new LatLngBounds(
		        this._map.containerPointToLatLng(this._startPoint),
		        this._map.containerPointToLatLng(this._point));

		this._map
			.fitBounds(bounds)
			.fire('boxzoomend', {boxZoomBounds: bounds});
	},

	_onKeyDown: function (e) {
		if (e.keyCode === 27) {
			this._finish();
		}
	}
});

// @section Handlers
// @property boxZoom: Handler
// Box (shift-drag with mouse) zoom handler.
Map.addInitHook('addHandler', 'boxZoom', BoxZoom);

/*
 * L.Handler.DoubleClickZoom is used to handle double-click zoom on the map, enabled by default.
 */

// @namespace Map
// @section Interaction Options

Map.mergeOptions({
	// @option doubleClickZoom: Boolean|String = true
	// Whether the map can be zoomed in by double clicking on it and
	// zoomed out by double clicking while holding shift. If passed
	// `'center'`, double-click zoom will zoom to the center of the
	//  view regardless of where the mouse was.
	doubleClickZoom: true
});

var DoubleClickZoom = Handler.extend({
	addHooks: function () {
		this._map.on('dblclick', this._onDoubleClick, this);
	},

	removeHooks: function () {
		this._map.off('dblclick', this._onDoubleClick, this);
	},

	_onDoubleClick: function (e) {
		var map = this._map,
		    oldZoom = map.getZoom(),
		    delta = map.options.zoomDelta,
		    zoom = e.originalEvent.shiftKey ? oldZoom - delta : oldZoom + delta;

		if (map.options.doubleClickZoom === 'center') {
			map.setZoom(zoom);
		} else {
			map.setZoomAround(e.containerPoint, zoom);
		}
	}
});

// @section Handlers
//
// Map properties include interaction handlers that allow you to control
// interaction behavior in runtime, enabling or disabling certain features such
// as dragging or touch zoom (see `Handler` methods). For example:
//
// ```js
// map.doubleClickZoom.disable();
// ```
//
// @property doubleClickZoom: Handler
// Double click zoom handler.
Map.addInitHook('addHandler', 'doubleClickZoom', DoubleClickZoom);

/*
 * L.Handler.MapDrag is used to make the map draggable (with panning inertia), enabled by default.
 */

// @namespace Map
// @section Interaction Options
Map.mergeOptions({
	// @option dragging: Boolean = true
	// Whether the map be draggable with mouse/touch or not.
	dragging: true,

	// @section Panning Inertia Options
	// @option inertia: Boolean = *
	// If enabled, panning of the map will have an inertia effect where
	// the map builds momentum while dragging and continues moving in
	// the same direction for some time. Feels especially nice on touch
	// devices. Enabled by default unless running on old Android devices.
	inertia: !android23,

	// @option inertiaDeceleration: Number = 3000
	// The rate with which the inertial movement slows down, in pixels/second².
	inertiaDeceleration: 3400, // px/s^2

	// @option inertiaMaxSpeed: Number = Infinity
	// Max speed of the inertial movement, in pixels/second.
	inertiaMaxSpeed: Infinity, // px/s

	// @option easeLinearity: Number = 0.2
	easeLinearity: 0.2,

	// TODO refactor, move to CRS
	// @option worldCopyJump: Boolean = false
	// With this option enabled, the map tracks when you pan to another "copy"
	// of the world and seamlessly jumps to the original one so that all overlays
	// like markers and vector layers are still visible.
	worldCopyJump: false,

	// @option maxBoundsViscosity: Number = 0.0
	// If `maxBounds` is set, this option will control how solid the bounds
	// are when dragging the map around. The default value of `0.0` allows the
	// user to drag outside the bounds at normal speed, higher values will
	// slow down map dragging outside bounds, and `1.0` makes the bounds fully
	// solid, preventing the user from dragging outside the bounds.
	maxBoundsViscosity: 0.0
});

var Drag = Handler.extend({
	addHooks: function () {
		if (!this._draggable) {
			var map = this._map;

			this._draggable = new Draggable(map._mapPane, map._container);

			this._draggable.on({
				dragstart: this._onDragStart,
				drag: this._onDrag,
				dragend: this._onDragEnd
			}, this);

			this._draggable.on('predrag', this._onPreDragLimit, this);
			if (map.options.worldCopyJump) {
				this._draggable.on('predrag', this._onPreDragWrap, this);
				map.on('zoomend', this._onZoomEnd, this);

				map.whenReady(this._onZoomEnd, this);
			}
		}
		addClass(this._map._container, 'leaflet-grab leaflet-touch-drag');
		this._draggable.enable();
		this._positions = [];
		this._times = [];
	},

	removeHooks: function () {
		removeClass(this._map._container, 'leaflet-grab');
		removeClass(this._map._container, 'leaflet-touch-drag');
		this._draggable.disable();
	},

	moved: function () {
		return this._draggable && this._draggable._moved;
	},

	moving: function () {
		return this._draggable && this._draggable._moving;
	},

	_onDragStart: function () {
		var map = this._map;

		map._stop();
		if (this._map.options.maxBounds && this._map.options.maxBoundsViscosity) {
			var bounds = toLatLngBounds(this._map.options.maxBounds);

			this._offsetLimit = toBounds(
				this._map.latLngToContainerPoint(bounds.getNorthWest()).multiplyBy(-1),
				this._map.latLngToContainerPoint(bounds.getSouthEast()).multiplyBy(-1)
					.add(this._map.getSize()));

			this._viscosity = Math.min(1.0, Math.max(0.0, this._map.options.maxBoundsViscosity));
		} else {
			this._offsetLimit = null;
		}

		map
		    .fire('movestart')
		    .fire('dragstart');

		if (map.options.inertia) {
			this._positions = [];
			this._times = [];
		}
	},

	_onDrag: function (e) {
		if (this._map.options.inertia) {
			var time = this._lastTime = +new Date(),
			    pos = this._lastPos = this._draggable._absPos || this._draggable._newPos;

			this._positions.push(pos);
			this._times.push(time);

			if (time - this._times[0] > 50) {
				this._positions.shift();
				this._times.shift();
			}
		}

		this._map
		    .fire('move', e)
		    .fire('drag', e);
	},

	_onZoomEnd: function () {
		var pxCenter = this._map.getSize().divideBy(2),
		    pxWorldCenter = this._map.latLngToLayerPoint([0, 0]);

		this._initialWorldOffset = pxWorldCenter.subtract(pxCenter).x;
		this._worldWidth = this._map.getPixelWorldBounds().getSize().x;
	},

	_viscousLimit: function (value, threshold) {
		return value - (value - threshold) * this._viscosity;
	},

	_onPreDragLimit: function () {
		if (!this._viscosity || !this._offsetLimit) { return; }

		var offset = this._draggable._newPos.subtract(this._draggable._startPos);

		var limit = this._offsetLimit;
		if (offset.x < limit.min.x) { offset.x = this._viscousLimit(offset.x, limit.min.x); }
		if (offset.y < limit.min.y) { offset.y = this._viscousLimit(offset.y, limit.min.y); }
		if (offset.x > limit.max.x) { offset.x = this._viscousLimit(offset.x, limit.max.x); }
		if (offset.y > limit.max.y) { offset.y = this._viscousLimit(offset.y, limit.max.y); }

		this._draggable._newPos = this._draggable._startPos.add(offset);
	},

	_onPreDragWrap: function () {
		// TODO refactor to be able to adjust map pane position after zoom
		var worldWidth = this._worldWidth,
		    halfWidth = Math.round(worldWidth / 2),
		    dx = this._initialWorldOffset,
		    x = this._draggable._newPos.x,
		    newX1 = (x - halfWidth + dx) % worldWidth + halfWidth - dx,
		    newX2 = (x + halfWidth + dx) % worldWidth - halfWidth - dx,
		    newX = Math.abs(newX1 + dx) < Math.abs(newX2 + dx) ? newX1 : newX2;

		this._draggable._absPos = this._draggable._newPos.clone();
		this._draggable._newPos.x = newX;
	},

	_onDragEnd: function (e) {
		var map = this._map,
		    options = map.options,

		    noInertia = !options.inertia || this._times.length < 2;

		map.fire('dragend', e);

		if (noInertia) {
			map.fire('moveend');

		} else {

			var direction = this._lastPos.subtract(this._positions[0]),
			    duration = (this._lastTime - this._times[0]) / 1000,
			    ease = options.easeLinearity,

			    speedVector = direction.multiplyBy(ease / duration),
			    speed = speedVector.distanceTo([0, 0]),

			    limitedSpeed = Math.min(options.inertiaMaxSpeed, speed),
			    limitedSpeedVector = speedVector.multiplyBy(limitedSpeed / speed),

			    decelerationDuration = limitedSpeed / (options.inertiaDeceleration * ease),
			    offset = limitedSpeedVector.multiplyBy(-decelerationDuration / 2).round();

			if (!offset.x && !offset.y) {
				map.fire('moveend');

			} else {
				offset = map._limitOffset(offset, map.options.maxBounds);

				requestAnimFrame(function () {
					map.panBy(offset, {
						duration: decelerationDuration,
						easeLinearity: ease,
						noMoveStart: true,
						animate: true
					});
				});
			}
		}
	}
});

// @section Handlers
// @property dragging: Handler
// Map dragging handler (by both mouse and touch).
Map.addInitHook('addHandler', 'dragging', Drag);

/*
 * L.Map.Keyboard is handling keyboard interaction with the map, enabled by default.
 */

// @namespace Map
// @section Keyboard Navigation Options
Map.mergeOptions({
	// @option keyboard: Boolean = true
	// Makes the map focusable and allows users to navigate the map with keyboard
	// arrows and `+`/`-` keys.
	keyboard: true,

	// @option keyboardPanDelta: Number = 80
	// Amount of pixels to pan when pressing an arrow key.
	keyboardPanDelta: 80
});

var Keyboard = Handler.extend({

	keyCodes: {
		left:    [37],
		right:   [39],
		down:    [40],
		up:      [38],
		zoomIn:  [187, 107, 61, 171],
		zoomOut: [189, 109, 54, 173]
	},

	initialize: function (map) {
		this._map = map;

		this._setPanDelta(map.options.keyboardPanDelta);
		this._setZoomDelta(map.options.zoomDelta);
	},

	addHooks: function () {
		var container = this._map._container;

		// make the container focusable by tabbing
		if (container.tabIndex <= 0) {
			container.tabIndex = '0';
		}

		on(container, {
			focus: this._onFocus,
			blur: this._onBlur,
			mousedown: this._onMouseDown
		}, this);

		this._map.on({
			focus: this._addHooks,
			blur: this._removeHooks
		}, this);
	},

	removeHooks: function () {
		this._removeHooks();

		off(this._map._container, {
			focus: this._onFocus,
			blur: this._onBlur,
			mousedown: this._onMouseDown
		}, this);

		this._map.off({
			focus: this._addHooks,
			blur: this._removeHooks
		}, this);
	},

	_onMouseDown: function () {
		if (this._focused) { return; }

		var body = document.body,
		    docEl = document.documentElement,
		    top = body.scrollTop || docEl.scrollTop,
		    left = body.scrollLeft || docEl.scrollLeft;

		this._map._container.focus();

		window.scrollTo(left, top);
	},

	_onFocus: function () {
		this._focused = true;
		this._map.fire('focus');
	},

	_onBlur: function () {
		this._focused = false;
		this._map.fire('blur');
	},

	_setPanDelta: function (panDelta) {
		var keys = this._panKeys = {},
		    codes = this.keyCodes,
		    i, len;

		for (i = 0, len = codes.left.length; i < len; i++) {
			keys[codes.left[i]] = [-1 * panDelta, 0];
		}
		for (i = 0, len = codes.right.length; i < len; i++) {
			keys[codes.right[i]] = [panDelta, 0];
		}
		for (i = 0, len = codes.down.length; i < len; i++) {
			keys[codes.down[i]] = [0, panDelta];
		}
		for (i = 0, len = codes.up.length; i < len; i++) {
			keys[codes.up[i]] = [0, -1 * panDelta];
		}
	},

	_setZoomDelta: function (zoomDelta) {
		var keys = this._zoomKeys = {},
		    codes = this.keyCodes,
		    i, len;

		for (i = 0, len = codes.zoomIn.length; i < len; i++) {
			keys[codes.zoomIn[i]] = zoomDelta;
		}
		for (i = 0, len = codes.zoomOut.length; i < len; i++) {
			keys[codes.zoomOut[i]] = -zoomDelta;
		}
	},

	_addHooks: function () {
		on(document, 'keydown', this._onKeyDown, this);
	},

	_removeHooks: function () {
		off(document, 'keydown', this._onKeyDown, this);
	},

	_onKeyDown: function (e) {
		if (e.altKey || e.ctrlKey || e.metaKey) { return; }

		var key = e.keyCode,
		    map = this._map,
		    offset;

		if (key in this._panKeys) {

			if (map._panAnim && map._panAnim._inProgress) { return; }

			offset = this._panKeys[key];
			if (e.shiftKey) {
				offset = toPoint(offset).multiplyBy(3);
			}

			map.panBy(offset);

			if (map.options.maxBounds) {
				map.panInsideBounds(map.options.maxBounds);
			}

		} else if (key in this._zoomKeys) {
			map.setZoom(map.getZoom() + (e.shiftKey ? 3 : 1) * this._zoomKeys[key]);

		} else if (key === 27 && map._popup) {
			map.closePopup();

		} else {
			return;
		}

		stop(e);
	}
});

// @section Handlers
// @section Handlers
// @property keyboard: Handler
// Keyboard navigation handler.
Map.addInitHook('addHandler', 'keyboard', Keyboard);

/*
 * L.Handler.ScrollWheelZoom is used by L.Map to enable mouse scroll wheel zoom on the map.
 */

// @namespace Map
// @section Interaction Options
Map.mergeOptions({
	// @section Mousewheel options
	// @option scrollWheelZoom: Boolean|String = true
	// Whether the map can be zoomed by using the mouse wheel. If passed `'center'`,
	// it will zoom to the center of the view regardless of where the mouse was.
	scrollWheelZoom: true,

	// @option wheelDebounceTime: Number = 40
	// Limits the rate at which a wheel can fire (in milliseconds). By default
	// user can't zoom via wheel more often than once per 40 ms.
	wheelDebounceTime: 40,

	// @option wheelPxPerZoomLevel: Number = 60
	// How many scroll pixels (as reported by [L.DomEvent.getWheelDelta](#domevent-getwheeldelta))
	// mean a change of one full zoom level. Smaller values will make wheel-zooming
	// faster (and vice versa).
	wheelPxPerZoomLevel: 60
});

var ScrollWheelZoom = Handler.extend({
	addHooks: function () {
		on(this._map._container, 'mousewheel', this._onWheelScroll, this);

		this._delta = 0;
	},

	removeHooks: function () {
		off(this._map._container, 'mousewheel', this._onWheelScroll, this);
	},

	_onWheelScroll: function (e) {
		var delta = getWheelDelta(e);

		var debounce = this._map.options.wheelDebounceTime;

		this._delta += delta;
		this._lastMousePos = this._map.mouseEventToContainerPoint(e);

		if (!this._startTime) {
			this._startTime = +new Date();
		}

		var left = Math.max(debounce - (+new Date() - this._startTime), 0);

		clearTimeout(this._timer);
		this._timer = setTimeout(bind(this._performZoom, this), left);

		stop(e);
	},

	_performZoom: function () {
		var map = this._map,
		    zoom = map.getZoom(),
		    snap = this._map.options.zoomSnap || 0;

		map._stop(); // stop panning and fly animations if any

		// map the delta with a sigmoid function to -4..4 range leaning on -1..1
		var d2 = this._delta / (this._map.options.wheelPxPerZoomLevel * 4),
		    d3 = 4 * Math.log(2 / (1 + Math.exp(-Math.abs(d2)))) / Math.LN2,
		    d4 = snap ? Math.ceil(d3 / snap) * snap : d3,
		    delta = map._limitZoom(zoom + (this._delta > 0 ? d4 : -d4)) - zoom;

		this._delta = 0;
		this._startTime = null;

		if (!delta) { return; }

		if (map.options.scrollWheelZoom === 'center') {
			map.setZoom(zoom + delta);
		} else {
			map.setZoomAround(this._lastMousePos, zoom + delta);
		}
	}
});

// @section Handlers
// @property scrollWheelZoom: Handler
// Scroll wheel zoom handler.
Map.addInitHook('addHandler', 'scrollWheelZoom', ScrollWheelZoom);

/*
 * L.Map.Tap is used to enable mobile hacks like quick taps and long hold.
 */

// @namespace Map
// @section Interaction Options
Map.mergeOptions({
	// @section Touch interaction options
	// @option tap: Boolean = true
	// Enables mobile hacks for supporting instant taps (fixing 200ms click
	// delay on iOS/Android) and touch holds (fired as `contextmenu` events).
	tap: true,

	// @option tapTolerance: Number = 15
	// The max number of pixels a user can shift his finger during touch
	// for it to be considered a valid tap.
	tapTolerance: 15
});

var Tap = Handler.extend({
	addHooks: function () {
		on(this._map._container, 'touchstart', this._onDown, this);
	},

	removeHooks: function () {
		off(this._map._container, 'touchstart', this._onDown, this);
	},

	_onDown: function (e) {
		if (!e.touches) { return; }

		preventDefault(e);

		this._fireClick = true;

		// don't simulate click or track longpress if more than 1 touch
		if (e.touches.length > 1) {
			this._fireClick = false;
			clearTimeout(this._holdTimeout);
			return;
		}

		var first = e.touches[0],
		    el = first.target;

		this._startPos = this._newPos = new Point(first.clientX, first.clientY);

		// if touching a link, highlight it
		if (el.tagName && el.tagName.toLowerCase() === 'a') {
			addClass(el, 'leaflet-active');
		}

		// simulate long hold but setting a timeout
		this._holdTimeout = setTimeout(bind(function () {
			if (this._isTapValid()) {
				this._fireClick = false;
				this._onUp();
				this._simulateEvent('contextmenu', first);
			}
		}, this), 1000);

		this._simulateEvent('mousedown', first);

		on(document, {
			touchmove: this._onMove,
			touchend: this._onUp
		}, this);
	},

	_onUp: function (e) {
		clearTimeout(this._holdTimeout);

		off(document, {
			touchmove: this._onMove,
			touchend: this._onUp
		}, this);

		if (this._fireClick && e && e.changedTouches) {

			var first = e.changedTouches[0],
			    el = first.target;

			if (el && el.tagName && el.tagName.toLowerCase() === 'a') {
				removeClass(el, 'leaflet-active');
			}

			this._simulateEvent('mouseup', first);

			// simulate click if the touch didn't move too much
			if (this._isTapValid()) {
				this._simulateEvent('click', first);
			}
		}
	},

	_isTapValid: function () {
		return this._newPos.distanceTo(this._startPos) <= this._map.options.tapTolerance;
	},

	_onMove: function (e) {
		var first = e.touches[0];
		this._newPos = new Point(first.clientX, first.clientY);
		this._simulateEvent('mousemove', first);
	},

	_simulateEvent: function (type, e) {
		var simulatedEvent = document.createEvent('MouseEvents');

		simulatedEvent._simulated = true;
		e.target._simulatedClick = true;

		simulatedEvent.initMouseEvent(
		        type, true, true, window, 1,
		        e.screenX, e.screenY,
		        e.clientX, e.clientY,
		        false, false, false, false, 0, null);

		e.target.dispatchEvent(simulatedEvent);
	}
});

// @section Handlers
// @property tap: Handler
// Mobile touch hacks (quick tap and touch hold) handler.
if (touch && !pointer) {
	Map.addInitHook('addHandler', 'tap', Tap);
}

/*
 * L.Handler.TouchZoom is used by L.Map to add pinch zoom on supported mobile browsers.
 */

// @namespace Map
// @section Interaction Options
Map.mergeOptions({
	// @section Touch interaction options
	// @option touchZoom: Boolean|String = *
	// Whether the map can be zoomed by touch-dragging with two fingers. If
	// passed `'center'`, it will zoom to the center of the view regardless of
	// where the touch events (fingers) were. Enabled for touch-capable web
	// browsers except for old Androids.
	touchZoom: touch && !android23,

	// @option bounceAtZoomLimits: Boolean = true
	// Set it to false if you don't want the map to zoom beyond min/max zoom
	// and then bounce back when pinch-zooming.
	bounceAtZoomLimits: true
});

var TouchZoom = Handler.extend({
	addHooks: function () {
		addClass(this._map._container, 'leaflet-touch-zoom');
		on(this._map._container, 'touchstart', this._onTouchStart, this);
	},

	removeHooks: function () {
		removeClass(this._map._container, 'leaflet-touch-zoom');
		off(this._map._container, 'touchstart', this._onTouchStart, this);
	},

	_onTouchStart: function (e) {
		var map = this._map;
		if (!e.touches || e.touches.length !== 2 || map._animatingZoom || this._zooming) { return; }

		var p1 = map.mouseEventToContainerPoint(e.touches[0]),
		    p2 = map.mouseEventToContainerPoint(e.touches[1]);

		this._centerPoint = map.getSize()._divideBy(2);
		this._startLatLng = map.containerPointToLatLng(this._centerPoint);
		if (map.options.touchZoom !== 'center') {
			this._pinchStartLatLng = map.containerPointToLatLng(p1.add(p2)._divideBy(2));
		}

		this._startDist = p1.distanceTo(p2);
		this._startZoom = map.getZoom();

		this._moved = false;
		this._zooming = true;

		map._stop();

		on(document, 'touchmove', this._onTouchMove, this);
		on(document, 'touchend', this._onTouchEnd, this);

		preventDefault(e);
	},

	_onTouchMove: function (e) {
		if (!e.touches || e.touches.length !== 2 || !this._zooming) { return; }

		var map = this._map,
		    p1 = map.mouseEventToContainerPoint(e.touches[0]),
		    p2 = map.mouseEventToContainerPoint(e.touches[1]),
		    scale = p1.distanceTo(p2) / this._startDist;

		this._zoom = map.getScaleZoom(scale, this._startZoom);

		if (!map.options.bounceAtZoomLimits && (
			(this._zoom < map.getMinZoom() && scale < 1) ||
			(this._zoom > map.getMaxZoom() && scale > 1))) {
			this._zoom = map._limitZoom(this._zoom);
		}

		if (map.options.touchZoom === 'center') {
			this._center = this._startLatLng;
			if (scale === 1) { return; }
		} else {
			// Get delta from pinch to center, so centerLatLng is delta applied to initial pinchLatLng
			var delta = p1._add(p2)._divideBy(2)._subtract(this._centerPoint);
			if (scale === 1 && delta.x === 0 && delta.y === 0) { return; }
			this._center = map.unproject(map.project(this._pinchStartLatLng, this._zoom).subtract(delta), this._zoom);
		}

		if (!this._moved) {
			map._moveStart(true);
			this._moved = true;
		}

		cancelAnimFrame(this._animRequest);

		var moveFn = bind(map._move, map, this._center, this._zoom, {pinch: true, round: false});
		this._animRequest = requestAnimFrame(moveFn, this, true);

		preventDefault(e);
	},

	_onTouchEnd: function () {
		if (!this._moved || !this._zooming) {
			this._zooming = false;
			return;
		}

		this._zooming = false;
		cancelAnimFrame(this._animRequest);

		off(document, 'touchmove', this._onTouchMove);
		off(document, 'touchend', this._onTouchEnd);

		// Pinch updates GridLayers' levels only when zoomSnap is off, so zoomSnap becomes noUpdate.
		if (this._map.options.zoomAnimation) {
			this._map._animateZoom(this._center, this._map._limitZoom(this._zoom), true, this._map.options.zoomSnap);
		} else {
			this._map._resetView(this._center, this._map._limitZoom(this._zoom));
		}
	}
});

// @section Handlers
// @property touchZoom: Handler
// Touch zoom handler.
Map.addInitHook('addHandler', 'touchZoom', TouchZoom);

Map.BoxZoom = BoxZoom;
Map.DoubleClickZoom = DoubleClickZoom;
Map.Drag = Drag;
Map.Keyboard = Keyboard;
Map.ScrollWheelZoom = ScrollWheelZoom;
Map.Tap = Tap;
Map.TouchZoom = TouchZoom;

// misc

var oldL = window.L;
function noConflict() {
	window.L = oldL;
	return this;
}

// Always export us to window global (see #2364)
window.L = exports;

Object.freeze = freeze;

exports.version = version;
exports.noConflict = noConflict;
exports.Control = Control;
exports.control = control;
exports.Browser = Browser;
exports.Evented = Evented;
exports.Mixin = Mixin;
exports.Util = Util;
exports.Class = Class;
exports.Handler = Handler;
exports.extend = extend;
exports.bind = bind;
exports.stamp = stamp;
exports.setOptions = setOptions;
exports.DomEvent = DomEvent;
exports.DomUtil = DomUtil;
exports.PosAnimation = PosAnimation;
exports.Draggable = Draggable;
exports.LineUtil = LineUtil;
exports.PolyUtil = PolyUtil;
exports.Point = Point;
exports.point = toPoint;
exports.Bounds = Bounds;
exports.bounds = toBounds;
exports.Transformation = Transformation;
exports.transformation = toTransformation;
exports.Projection = index;
exports.LatLng = LatLng;
exports.latLng = toLatLng;
exports.LatLngBounds = LatLngBounds;
exports.latLngBounds = toLatLngBounds;
exports.CRS = CRS;
exports.GeoJSON = GeoJSON;
exports.geoJSON = geoJSON;
exports.geoJson = geoJson;
exports.Layer = Layer;
exports.LayerGroup = LayerGroup;
exports.layerGroup = layerGroup;
exports.FeatureGroup = FeatureGroup;
exports.featureGroup = featureGroup;
exports.ImageOverlay = ImageOverlay;
exports.imageOverlay = imageOverlay;
exports.VideoOverlay = VideoOverlay;
exports.videoOverlay = videoOverlay;
exports.DivOverlay = DivOverlay;
exports.Popup = Popup;
exports.popup = popup;
exports.Tooltip = Tooltip;
exports.tooltip = tooltip;
exports.Icon = Icon;
exports.icon = icon;
exports.DivIcon = DivIcon;
exports.divIcon = divIcon;
exports.Marker = Marker;
exports.marker = marker;
exports.TileLayer = TileLayer;
exports.tileLayer = tileLayer;
exports.GridLayer = GridLayer;
exports.gridLayer = gridLayer;
exports.SVG = SVG;
exports.svg = svg$1;
exports.Renderer = Renderer;
exports.Canvas = Canvas;
exports.canvas = canvas$1;
exports.Path = Path;
exports.CircleMarker = CircleMarker;
exports.circleMarker = circleMarker;
exports.Circle = Circle;
exports.circle = circle;
exports.Polyline = Polyline;
exports.polyline = polyline;
exports.Polygon = Polygon;
exports.polygon = polygon;
exports.Rectangle = Rectangle;
exports.rectangle = rectangle;
exports.Map = Map;
exports.map = createMap;

})));
//# sourceMappingURL=leaflet-src.js.map


/***/ }),
/* 168 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 169 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABkAAAApCAYAAADAk4LOAAAFgUlEQVR4Aa1XA5BjWRTN2oW17d3YaZtr2962HUzbDNpjszW24mRt28p47v7zq/bXZtrp/lWnXr337j3nPCe85NcypgSFdugCpW5YoDAMRaIMqRi6aKq5E3YqDQO3qAwjVWrD8Ncq/RBpykd8oZUb/kaJutow8r1aP9II0WmLKLIsJyv1w/kqw9Ch2MYdB++12Onxee/QMwvf4/Dk/Lfp/i4nxTXtOoQ4pW5Aj7wpici1A9erdAN2OH64x8OSP9j3Ft3b7aWkTg/Fm91siTra0f9on5sQr9INejH6CUUUpavjFNq1B+Oadhxmnfa8RfEmN8VNAsQhPqF55xHkMzz3jSmChWU6f7/XZKNH+9+hBLOHYozuKQPxyMPUKkrX/K0uWnfFaJGS1QPRtZsOPtr3NsW0uyh6NNCOkU3Yz+bXbT3I8G3xE5EXLXtCXbbqwCO9zPQYPRTZ5vIDXD7U+w7rFDEoUUf7ibHIR4y6bLVPXrz8JVZEql13trxwue/uDivd3fkWRbS6/IA2bID4uk0UpF1N8qLlbBlXs4Ee7HLTfV1j54APvODnSfOWBqtKVvjgLKzF5YdEk5ewRkGlK0i33Eofffc7HT56jD7/6U+qH3Cx7SBLNntH5YIPvODnyfIXZYRVDPqgHtLs5ABHD3YzLuespb7t79FY34DjMwrVrcTuwlT55YMPvOBnRrJ4VXTdNnYug5ucHLBjEpt30701A3Ts+HEa73u6dT3FNWwflY86eMHPk+Yu+i6pzUpRrW7SNDg5JHR4KapmM5Wv2E8Tfcb1HoqqHMHU+uWDD7zg54mz5/2BSnizi9T1Dg4QQXLToGNCkb6tb1NU+QAlGr1++eADrzhn/u8Q2YZhQVlZ5+CAOtqfbhmaUCS1ezNFVm2imDbPmPng5wmz+gwh+oHDce0eUtQ6OGDIyR0uUhUsoO3vfDmmgOezH0mZN59x7MBi++WDL1g/eEiU3avlidO671bkLfwbw5XV2P8Pzo0ydy4t2/0eu33xYSOMOD8hTf4CrBtGMSoXfPLchX+J0ruSePw3LZeK0juPJbYzrhkH0io7B3k164hiGvawhOKMLkrQLyVpZg8rHFW7E2uHOL888IBPlNZ1FPzstSJM694fWr6RwpvcJK60+0HCILTBzZLFNdtAzJaohze60T8qBzyh5ZuOg5e7uwQppofEmf2++DYvmySqGBuKaicF1blQjhuHdvCIMvp8whTTfZzI7RldpwtSzL+F1+wkdZ2TBOW2gIF88PBTzD/gpeREAMEbxnJcaJHNHrpzji0gQCS6hdkEeYt9DF/2qPcEC8RM28Hwmr3sdNyht00byAut2k3gufWNtgtOEOFGUwcXWNDbdNbpgBGxEvKkOQsxivJx33iow0Vw5S6SVTrpVq11ysA2Rp7gTfPfktc6zhtXBBC+adRLshf6sG2RfHPZ5EAc4sVZ83yCN00Fk/4kggu40ZTvIEm5g24qtU4KjBrx/BTTH8ifVASAG7gKrnWxJDcU7x8X6Ecczhm3o6YicvsLXWfh3Ch1W0k8x0nXF+0fFxgt4phz8QvypiwCCFKMqXCnqXExjq10beH+UUA7+nG6mdG/Pu0f3LgFcGrl2s0kNNjpmoJ9o4B29CMO8dMT4Q5ox8uitF6fqsrJOr8qnwNbRzv6hSnG5wP+64C7h9lp30hKNtKdWjtdkbuPA19nJ7Tz3zR/ibgARbhb4AlhavcBebmTHcFl2fvYEnW0ox9xMxKBS8btJ+KiEbq9zA4RthQXDhPa0T9TEe69gWupwc6uBUphquXgf+/FrIjweHQS4/pduMe5ERUMHUd9xv8ZR98CxkS4F2n3EUrUZ10EYNw7BWm9x1GiPssi3GgiGRDKWRYZfXlON+dfNbM+GgIwYdwAAAAASUVORK5CYII="

/***/ }),
/* 170 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACkAAAApCAQAAAACach9AAACMUlEQVR4Ae3ShY7jQBAE0Aoz/f9/HTMzhg1zrdKUrJbdx+Kd2nD8VNudfsL/Th///dyQN2TH6f3y/BGpC379rV+S+qqetBOxImNQXL8JCAr2V4iMQXHGNJxeCfZXhSRBcQMfvkOWUdtfzlLgAENmZDcmo2TVmt8OSM2eXxBp3DjHSMFutqS7SbmemzBiR+xpKCNUIRkdkkYxhAkyGoBvyQFEJEefwSmmvBfJuJ6aKqKWnAkvGZOaZXTUgFqYULWNSHUckZuR1HIIimUExutRxwzOLROIG4vKmCKQt364mIlhSyzAf1m9lHZHJZrlAOMMztRRiKimp/rpdJDc9Awry5xTZCte7FHtuS8wJgeYGrex28xNTd086Dik7vUMscQOa8y4DoGtCCSkAKlNwpgNtphjrC6MIHUkR6YWxxs6Sc5xqn222mmCRFzIt8lEdKx+ikCtg91qS2WpwVfBelJCiQJwvzixfI9cxZQWgiSJelKnwBElKYtDOb2MFbhmUigbReQBV0Cg4+qMXSxXSyGUn4UbF8l+7qdSGnTC0XLCmahIgUHLhLOhpVCtw4CzYXvLQWQbJNmxoCsOKAxSgBJno75avolkRw8iIAFcsdc02e9iyCd8tHwmeSSoKTowIgvscSGZUOA7PuCN5b2BX9mQM7S0wYhMNU74zgsPBj3HU7wguAfnxxjFQGBE6pwN+GjME9zHY7zGp8wVxMShYX9NXvEWD3HbwJf4giO4CFIQxXScH1/TM+04kkBiAAAAAElFTkSuQmCC"

/***/ }),
/* 171 */
/***/ (function(module, exports) {

/*
  Leaflet.AwesomeMarkers, a plugin that adds colorful iconic markers for Leaflet, based on the Font Awesome icons
  (c) 2012-2013, Lennard Voogdt

  http://leafletjs.com
  https://github.com/lvoogdt
*//*global L*/(function(window,document,undefined){"use strict";/*
     * Leaflet.AwesomeMarkers assumes that you have already included the Leaflet library.
     */L.AwesomeMarkers={};L.AwesomeMarkers.version='2.0.1';L.AwesomeMarkers.Icon=L.Icon.extend({options:{iconSize:[35,45],iconAnchor:[17,42],popupAnchor:[1,-32],shadowAnchor:[10,12],shadowSize:[36,16],className:'awesome-marker',prefix:'glyphicon',spinClass:'fa-spin',extraClasses:'',icon:'home',markerColor:'blue',iconColor:'white'},initialize:function initialize(options){options=L.Util.setOptions(this,options);},createIcon:function createIcon(){var div=document.createElement('div'),options=this.options;if(options.icon){div.innerHTML=this._createInner();}if(options.bgPos){div.style.backgroundPosition=-options.bgPos.x+'px '+-options.bgPos.y+'px';}this._setIconStyles(div,'icon-'+options.markerColor);return div;},_createInner:function _createInner(){var iconClass,iconSpinClass="",iconColorClass="",iconColorStyle="",options=this.options;if(options.icon.slice(0,options.prefix.length+1)===options.prefix+"-"){iconClass=options.icon;}else{iconClass=options.prefix+"-"+options.icon;}if(options.spin&&typeof options.spinClass==="string"){iconSpinClass=options.spinClass;}if(options.iconColor){if(options.iconColor==='white'||options.iconColor==='black'){iconColorClass="icon-"+options.iconColor;}else{iconColorStyle="style='color: "+options.iconColor+"' ";}}return"<i "+iconColorStyle+"class='"+options.extraClasses+" "+options.prefix+" "+iconClass+" "+iconSpinClass+" "+iconColorClass+"'></i>";},_setIconStyles:function _setIconStyles(img,name){var options=this.options,size=L.point(options[name==='shadow'?'shadowSize':'iconSize']),anchor;if(name==='shadow'){anchor=L.point(options.shadowAnchor||options.iconAnchor);}else{anchor=L.point(options.iconAnchor);}if(!anchor&&size){anchor=size.divideBy(2,true);}img.className='awesome-marker-'+name+' '+options.className;if(anchor){img.style.marginLeft=-anchor.x+'px';img.style.marginTop=-anchor.y+'px';}if(size){img.style.width=size.x+'px';img.style.height=size.y+'px';}},createShadow:function createShadow(){var div=document.createElement('div');this._setIconStyles(div,'shadow');return div;}});L.AwesomeMarkers.icon=function(options){return new L.AwesomeMarkers.Icon(options);};})(this,document);

/***/ }),
/* 172 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/*
 * To change this license header, choose License Headers in Project Properties.
 * To change this template file, choose Tools | Templates
 * and open the template in the editor.
 *//* harmony default export */ __webpack_exports__["a"] = ({truksList:[{_id:'1',name:'Truck #1',plate:'AA129232',fromLocation:'New York',toLocation:'Philadelphia',pilotName:'John Braxton',address:'Viale Europa 1, Rome, Italy',mobile:'1 (916) 442-0945',truckType:'53ft Dry Van',maxCharge:'45.000',image:'/img/a1.jpg',truckModel:'Freightliner Cascadia',truckYear:'2013',actualPosition:[40.15041,-74.667519],vectorPath:[[-73.980715,40.764916],[-73.980531,40.764839],[-73.980939,40.764281],[-73.980984,40.764219],[-73.981015,40.764172],[-73.98123,40.763876],[-73.981353,40.763707],[-73.981386,40.763661],[-73.981433,40.763595],[-73.981477,40.763536],[-73.981847,40.763033],[-73.981898,40.762965],[-73.981934,40.762915],[-73.982068,40.76273],[-73.982274,40.762448],[-73.982305,40.762406],[-73.982357,40.762334],[-73.98239,40.76229],[-73.982752,40.761794],[-73.982807,40.761719],[-73.982845,40.761666],[-73.98321,40.761152],[-73.98325,40.761095],[-73.983294,40.761034],[-73.983467,40.760793],[-73.983651,40.760538],[-73.983706,40.760463],[-73.983758,40.760393],[-73.984174,40.759841],[-73.98463,40.75921],[-73.985087,40.758587],[-73.985481,40.758036],[-73.985534,40.757963],[-73.985707,40.758036],[-73.986728,40.758462],[-73.988386,40.75916],[-73.99114,40.760321],[-73.991227,40.760355],[-73.991684,40.759728],[-73.992139,40.759103],[-73.992631,40.75843],[-73.993071,40.757828],[-73.993571,40.757143],[-73.994018,40.756532],[-73.994652,40.756797],[-73.995071,40.756972],[-73.995507,40.757161],[-73.996847,40.757741],[-73.997876,40.758183],[-73.998126,40.758381],[-73.99824,40.75846],[-73.998353,40.758538],[-73.998441,40.75859],[-73.998542,40.758649],[-73.998697,40.758724],[-73.999208,40.758874],[-73.999426,40.758924],[-73.999634,40.758989],[-73.999838,40.759071],[-74.000033,40.759151],[-74.00953,40.763132],[-74.019228,40.767196],[-74.019426,40.76727],[-74.019635,40.767331],[-74.019845,40.767375],[-74.020062,40.767403],[-74.020295,40.767421],[-74.020549,40.767426],[-74.020765,40.767417],[-74.020985,40.767397],[-74.02121,40.767365],[-74.021425,40.767323],[-74.021631,40.767272],[-74.021846,40.767202],[-74.022059,40.767117],[-74.022261,40.76702],[-74.022454,40.76691],[-74.022627,40.766792],[-74.022766,40.766672],[-74.022909,40.766535],[-74.02328,40.7661],[-74.023445,40.765905],[-74.02355,40.765776],[-74.023652,40.765639],[-74.023731,40.765524],[-74.023802,40.765406],[-74.023859,40.765289],[-74.023953,40.765065],[-74.024109,40.764732],[-74.024168,40.764619],[-74.024241,40.764501],[-74.024322,40.764387],[-74.0244,40.764285],[-74.024487,40.764178],[-74.024638,40.764],[-74.024694,40.763932],[-74.02475,40.763843],[-74.024782,40.763765],[-74.024797,40.763684],[-74.024797,40.763604],[-74.024787,40.76353],[-74.024766,40.763446],[-74.024724,40.763336],[-74.024664,40.763217],[-74.024598,40.763112],[-74.024511,40.763009],[-74.024408,40.762917],[-74.024288,40.762836],[-74.024161,40.762769],[-74.024016,40.762716],[-74.023861,40.762676],[-74.023702,40.762655],[-74.023546,40.762649],[-74.023429,40.762658],[-74.023321,40.762673],[-74.023211,40.762697],[-74.0231,40.762728],[-74.022989,40.762767],[-74.022879,40.76282],[-74.022777,40.762882],[-74.022683,40.76296],[-74.022613,40.763029],[-74.022548,40.763112],[-74.022475,40.763222],[-74.022405,40.763347],[-74.022346,40.763459],[-74.022264,40.763624],[-74.022162,40.763838],[-74.022068,40.764042],[-74.021976,40.764254],[-74.021893,40.764458],[-74.02181,40.764672],[-74.021734,40.764873],[-74.021583,40.765323],[-74.021517,40.765544],[-74.021456,40.765762],[-74.021402,40.765978],[-74.021347,40.7662],[-74.0213,40.766417],[-74.021267,40.766588],[-74.02125,40.766707],[-74.021244,40.766811],[-74.021247,40.766918],[-74.021258,40.767009],[-74.021273,40.76711],[-74.0213,40.767203],[-74.021334,40.767298],[-74.021376,40.767389],[-74.021435,40.767496],[-74.021496,40.767589],[-74.021574,40.767691],[-74.021689,40.767798],[-74.0218,40.767893],[-74.021922,40.767982],[-74.022052,40.768064],[-74.022183,40.768137],[-74.022325,40.768205],[-74.023728,40.768827],[-74.024372,40.769105],[-74.025179,40.769469],[-74.026127,40.769871],[-74.027034,40.770245],[-74.028128,40.770671],[-74.028901,40.77098],[-74.029663,40.771346],[-74.030537,40.771756],[-74.032576,40.772743],[-74.033766,40.773308],[-74.034303,40.773544],[-74.035204,40.773921],[-74.037487,40.774792],[-74.038277,40.775072],[-74.038806,40.775262],[-74.039382,40.77547],[-74.040687,40.775944],[-74.042949,40.776756],[-74.043562,40.776951],[-74.04485,40.777445],[-74.045179,40.777574],[-74.046079,40.777902],[-74.046549,40.778085],[-74.046814,40.778186],[-74.047428,40.778402],[-74.04839,40.778753],[-74.049428,40.779143],[-74.050458,40.779509],[-74.051831,40.77997],[-74.053093,40.780423],[-74.053776,40.780704],[-74.05404,40.780779],[-74.0542,40.780814],[-74.0544,40.780856],[-74.054569,40.780882],[-74.054725,40.780894],[-74.054896,40.780903],[-74.055048,40.78091],[-74.055239,40.780904],[-74.055412,40.780893],[-74.05558,40.780873],[-74.05573,40.780846],[-74.055845,40.780823],[-74.055976,40.780792],[-74.056114,40.780758],[-74.056254,40.780717],[-74.056422,40.780652],[-74.056565,40.780584],[-74.056694,40.78051],[-74.056891,40.780393],[-74.057158,40.780196],[-74.057315,40.78002],[-74.057436,40.779847],[-74.057555,40.779644],[-74.057652,40.779438],[-74.057725,40.779259],[-74.057933,40.778768],[-74.058045,40.778462],[-74.058122,40.778234],[-74.058216,40.778],[-74.058276,40.777852],[-74.058363,40.777637],[-74.058385,40.777592],[-74.058411,40.777535],[-74.058809,40.7767],[-74.059178,40.776115],[-74.059907,40.774867],[-74.061495,40.772298],[-74.061811,40.771803],[-74.062219,40.771195],[-74.06247,40.770846],[-74.062731,40.770503],[-74.063005,40.770156],[-74.0633,40.769816],[-74.063606,40.769476],[-74.063918,40.76915],[-74.064243,40.768825],[-74.064579,40.768506],[-74.064924,40.768189],[-74.06528,40.76789],[-74.065647,40.767591],[-74.066028,40.767291],[-74.066416,40.767006],[-74.066804,40.766733],[-74.067206,40.766465],[-74.067648,40.766185],[-74.068053,40.765936],[-74.068447,40.765708],[-74.068902,40.765461],[-74.069192,40.765311],[-74.069392,40.765208],[-74.069838,40.764993],[-74.07033,40.764764],[-74.072965,40.763581],[-74.073552,40.763328],[-74.074507,40.762901],[-74.075998,40.762237],[-74.076676,40.76193],[-74.077257,40.761669],[-74.07865,40.761045],[-74.079406,40.760692],[-74.080772,40.760041],[-74.082647,40.759132],[-74.083118,40.758902],[-74.083419,40.758765],[-74.083759,40.758614],[-74.0841,40.758474],[-74.08441,40.758362],[-74.084767,40.75824],[-74.085173,40.758103],[-74.085758,40.757931],[-74.086187,40.757814],[-74.086553,40.757712],[-74.086947,40.757624],[-74.087344,40.757551],[-74.087752,40.75748],[-74.088167,40.75742],[-74.088613,40.757367],[-74.089028,40.757328],[-74.08946,40.757295],[-74.089917,40.757275],[-74.090566,40.757258],[-74.098108,40.75715],[-74.09866,40.757134],[-74.099159,40.757109],[-74.099666,40.757072],[-74.100132,40.757026],[-74.100582,40.756976],[-74.100994,40.756921],[-74.101437,40.756851],[-74.101879,40.756778],[-74.102371,40.756686],[-74.102822,40.756588],[-74.103214,40.756498],[-74.103635,40.756392],[-74.104093,40.756259],[-74.104499,40.756141],[-74.104914,40.756013],[-74.1053,40.755886],[-74.105633,40.755769],[-74.105895,40.755673],[-74.106412,40.755467],[-74.107244,40.755109],[-74.108625,40.754519],[-74.109331,40.754205],[-74.10992,40.753935],[-74.110279,40.753775],[-74.110526,40.753665],[-74.112041,40.752939],[-74.112703,40.752614],[-74.113491,40.752219],[-74.114282,40.751816],[-74.114876,40.751493],[-74.115332,40.751233],[-74.115813,40.750949],[-74.116068,40.750785],[-74.11635,40.75061],[-74.116614,40.750431],[-74.116913,40.750226],[-74.117197,40.749998],[-74.117454,40.749803],[-74.11772,40.749595],[-74.117989,40.749373],[-74.118313,40.749088],[-74.118622,40.748802],[-74.118931,40.748503],[-74.119222,40.748204],[-74.119506,40.747898],[-74.119781,40.747585],[-74.120036,40.74727],[-74.120287,40.746949],[-74.120518,40.746617],[-74.120742,40.746285],[-74.120958,40.745947],[-74.12116,40.745607],[-74.121351,40.745258],[-74.121524,40.744912],[-74.121723,40.744488],[-74.1219,40.744055],[-74.122077,40.743555],[-74.122959,40.740927],[-74.123128,40.740419],[-74.123254,40.739988],[-74.123354,40.739556],[-74.123421,40.739161],[-74.123461,40.738767],[-74.123485,40.738369],[-74.123614,40.735478],[-74.123644,40.735147],[-74.123689,40.734775],[-74.123745,40.734469],[-74.123826,40.734139],[-74.123922,40.733804],[-74.124046,40.733442],[-74.124166,40.733152],[-74.12437,40.73273],[-74.124573,40.73237],[-74.124823,40.731994],[-74.125072,40.731649],[-74.125351,40.731309],[-74.12567,40.730964],[-74.126003,40.730641],[-74.12636,40.730316],[-74.126864,40.729907],[-74.130008,40.727498],[-74.130308,40.727257],[-74.130582,40.727025],[-74.130828,40.726807],[-74.131057,40.726589],[-74.131322,40.726321],[-74.131564,40.726044],[-74.131698,40.725882],[-74.131827,40.725722],[-74.132009,40.725484],[-74.132191,40.725234],[-74.132315,40.725051],[-74.1325,40.72477],[-74.132706,40.724421],[-74.132894,40.724071],[-74.13306,40.723715],[-74.133213,40.723364],[-74.133956,40.721461],[-74.134688,40.719631],[-74.134887,40.719192],[-74.135085,40.718802],[-74.135311,40.718408],[-74.135571,40.718007],[-74.135815,40.717657],[-74.136027,40.717374],[-74.136281,40.717065],[-74.136592,40.716714],[-74.136917,40.716374],[-74.137236,40.716065],[-74.137577,40.715762],[-74.137901,40.7155],[-74.138323,40.715185],[-74.138334,40.715177],[-74.138698,40.714915],[-74.13909,40.714651],[-74.139519,40.714386],[-74.139964,40.714132],[-74.140412,40.713896],[-74.140839,40.713687],[-74.141268,40.713492],[-74.141563,40.713368],[-74.14188,40.713242],[-74.145069,40.712023],[-74.145624,40.711801],[-74.146136,40.711583],[-74.146582,40.711374],[-74.147097,40.711106],[-74.147536,40.710849],[-74.148054,40.710526],[-74.148502,40.710213],[-74.148966,40.709859],[-74.149291,40.709585],[-74.149594,40.709312],[-74.149889,40.709026],[-74.150161,40.708743],[-74.150438,40.708438],[-74.150709,40.708102],[-74.150955,40.707769],[-74.151272,40.707305],[-74.15231,40.705679],[-74.15275,40.705002],[-74.153217,40.704203],[-74.153477,40.703727],[-74.154633,40.701588],[-74.154981,40.700951],[-74.155341,40.700313],[-74.155708,40.699688],[-74.156086,40.699066],[-74.15647,40.698454],[-74.156835,40.697891],[-74.1572,40.697352],[-74.157621,40.696746],[-74.158047,40.696142],[-74.1607,40.692506],[-74.161853,40.690909],[-74.162591,40.689862],[-74.162797,40.689561],[-74.163594,40.688412],[-74.166939,40.683579],[-74.167979,40.682078],[-74.169084,40.680494],[-74.171008,40.677713],[-74.171646,40.676805],[-74.172081,40.676224],[-74.172609,40.675575],[-74.173167,40.67494],[-74.173677,40.674389],[-74.174594,40.673414],[-74.176946,40.670909],[-74.17744,40.670381],[-74.179301,40.668391],[-74.180757,40.666838],[-74.181221,40.666344],[-74.181691,40.665839],[-74.182192,40.665274],[-74.182608,40.664785],[-74.182933,40.664387],[-74.183265,40.66397],[-74.1837,40.663402],[-74.184099,40.662859],[-74.185255,40.66117],[-74.185572,40.660706],[-74.186307,40.65962],[-74.18703,40.65856],[-74.187499,40.65787],[-74.187641,40.657667],[-74.18788,40.657343],[-74.188041,40.657143],[-74.188202,40.656956],[-74.188452,40.656684],[-74.188765,40.656364],[-74.189066,40.656081],[-74.18938,40.655809],[-74.18972,40.655532],[-74.190042,40.655294],[-74.190414,40.655038],[-74.190797,40.654795],[-74.191216,40.654553],[-74.191535,40.654379],[-74.192019,40.654115],[-74.192384,40.653916],[-74.192771,40.653704],[-74.193157,40.653493],[-74.193531,40.653289],[-74.193922,40.653076],[-74.194285,40.652877],[-74.194679,40.652662],[-74.195045,40.652462],[-74.195452,40.65224],[-74.195794,40.652053],[-74.196268,40.651794],[-74.196678,40.65157],[-74.197121,40.651328],[-74.198897,40.650358],[-74.199274,40.650145],[-74.199677,40.649887],[-74.200065,40.649627],[-74.200424,40.649358],[-74.20077,40.649079],[-74.201135,40.64878],[-74.201487,40.648462],[-74.201817,40.648133],[-74.202114,40.647811],[-74.202356,40.647538],[-74.202712,40.647099],[-74.202962,40.646761],[-74.203206,40.646393],[-74.203423,40.646034],[-74.203581,40.645756],[-74.20386,40.645218],[-74.204467,40.644048],[-74.204786,40.64345],[-74.20514,40.642821],[-74.205748,40.641811],[-74.206923,40.63987],[-74.207876,40.638292],[-74.208285,40.637616],[-74.208779,40.636806],[-74.20924,40.636036],[-74.210596,40.633816],[-74.211882,40.631703],[-74.212121,40.631322],[-74.213564,40.629026],[-74.213867,40.62855],[-74.214476,40.627591],[-74.214945,40.626842],[-74.215543,40.625869],[-74.216718,40.623931],[-74.217265,40.623035],[-74.221146,40.61661],[-74.221206,40.61651],[-74.228348,40.604721],[-74.228649,40.604239],[-74.229016,40.603664],[-74.22937,40.603123],[-74.229738,40.602583],[-74.230352,40.601671],[-74.230556,40.601377],[-74.230762,40.60107],[-74.231079,40.600587],[-74.231334,40.600192],[-74.231627,40.59971],[-74.232394,40.598447],[-74.23286,40.597677],[-74.233622,40.596422],[-74.234454,40.595087],[-74.234865,40.594438],[-74.2359,40.592822],[-74.236409,40.592022],[-74.236855,40.591311],[-74.238279,40.588952],[-74.238656,40.58832],[-74.2391,40.5876],[-74.239521,40.586934],[-74.239904,40.586343],[-74.241685,40.583616],[-74.242399,40.58252],[-74.242951,40.581693],[-74.243625,40.580748],[-74.244322,40.579806],[-74.244875,40.579091],[-74.24543,40.578391],[-74.246181,40.577484],[-74.246883,40.576669],[-74.247541,40.57593],[-74.248192,40.575225],[-74.248985,40.574385],[-74.254049,40.569008],[-74.254339,40.568699],[-74.2562,40.566724],[-74.257456,40.565394],[-74.258627,40.564148],[-74.259798,40.562902],[-74.262207,40.560328],[-74.262794,40.559713],[-74.263309,40.5592],[-74.263846,40.55868],[-74.264371,40.558195],[-74.264943,40.557683],[-74.265538,40.557172],[-74.26611,40.556709],[-74.266718,40.556224],[-74.267161,40.555888],[-74.267573,40.555614],[-74.267729,40.555501],[-74.268068,40.555226],[-74.268593,40.554861],[-74.26909,40.554527],[-74.269787,40.554066],[-74.27042,40.553665],[-74.271449,40.553022],[-74.272143,40.552596],[-74.273694,40.551643],[-74.27464,40.551054],[-74.277779,40.54913],[-74.278527,40.548706],[-74.279266,40.548298],[-74.279936,40.547933],[-74.28054,40.547621],[-74.281151,40.547319],[-74.282101,40.546875],[-74.282994,40.546484],[-74.283767,40.54616],[-74.284544,40.54585],[-74.285333,40.545552],[-74.286116,40.545275],[-74.286913,40.545006],[-74.287742,40.544741],[-74.28857,40.544492],[-74.289405,40.54425],[-74.290244,40.544026],[-74.29107,40.54382],[-74.292071,40.543585],[-74.292959,40.543396],[-74.293833,40.543225],[-74.294769,40.54306],[-74.295646,40.542919],[-74.297892,40.542587],[-74.299896,40.542295],[-74.301666,40.54204],[-74.303399,40.54181],[-74.307653,40.541257],[-74.308311,40.541169],[-74.309008,40.541069],[-74.309646,40.540969],[-74.310387,40.540843],[-74.311076,40.540714],[-74.311789,40.540568],[-74.312489,40.540413],[-74.313224,40.540242],[-74.313885,40.54008],[-74.314542,40.539906],[-74.315172,40.539733],[-74.316479,40.539352],[-74.317168,40.539144],[-74.317793,40.538952],[-74.318332,40.538779],[-74.318946,40.538577],[-74.31951,40.538384],[-74.320092,40.538178],[-74.320762,40.537927],[-74.321449,40.537656],[-74.322082,40.537397],[-74.32268,40.537144],[-74.323442,40.536806],[-74.32415,40.536478],[-74.32492,40.5361],[-74.325647,40.535734],[-74.326352,40.535358],[-74.327052,40.534979],[-74.327739,40.534578],[-74.328415,40.534172],[-74.32904,40.533783],[-74.329616,40.533416],[-74.330673,40.532702],[-74.331032,40.53246],[-74.333509,40.53078],[-74.333909,40.530503],[-74.335148,40.529663],[-74.336355,40.52888],[-74.337404,40.528223],[-74.338326,40.527673],[-74.339163,40.527198],[-74.339928,40.526798],[-74.340697,40.526419],[-74.341422,40.526081],[-74.342334,40.525681],[-74.343275,40.525288],[-74.34523,40.524493],[-74.347121,40.523746],[-74.356572,40.52013],[-74.356982,40.519967],[-74.357832,40.519612],[-74.357995,40.51954],[-74.358629,40.519261],[-74.359353,40.518931],[-74.35978,40.518727],[-74.360608,40.518319],[-74.361373,40.517922],[-74.36209,40.517529],[-74.362792,40.517133],[-74.36349,40.516723],[-74.364168,40.516303],[-74.364839,40.515875],[-74.365496,40.515435],[-74.366148,40.514982],[-74.366781,40.514523],[-74.367403,40.514052],[-74.368004,40.513575],[-74.368602,40.513082],[-74.369189,40.51258],[-74.369763,40.512078],[-74.371805,40.510256],[-74.376986,40.505631],[-74.377506,40.505168],[-74.383217,40.500074],[-74.392233,40.49203],[-74.392609,40.491694],[-74.395324,40.489267],[-74.397223,40.487574],[-74.397661,40.487182],[-74.398041,40.486832],[-74.398528,40.486376],[-74.399003,40.485904],[-74.39951,40.485392],[-74.39995,40.484927],[-74.400347,40.484497],[-74.40076,40.484026],[-74.401159,40.483544],[-74.401551,40.483061],[-74.401932,40.482571],[-74.402313,40.482073],[-74.402672,40.481575],[-74.403517,40.480384],[-74.403858,40.4799],[-74.406003,40.476893],[-74.406438,40.476295],[-74.406897,40.475695],[-74.407387,40.475077],[-74.408197,40.474071],[-74.408895,40.473196],[-74.409214,40.472774],[-74.409509,40.472362],[-74.409922,40.471725],[-74.415479,40.462738],[-74.416855,40.460419],[-74.420141,40.454856],[-74.420291,40.454603],[-74.424539,40.4474],[-74.42755,40.442306],[-74.427933,40.441669],[-74.428327,40.441044],[-74.428735,40.440428],[-74.429154,40.439823],[-74.429585,40.439219],[-74.434674,40.432243],[-74.435444,40.431206],[-74.435913,40.430602],[-74.43753,40.428568],[-74.43915,40.426524],[-74.439814,40.425675],[-74.440631,40.424672],[-74.441446,40.423615],[-74.442286,40.4225],[-74.442865,40.421691],[-74.443539,40.420731],[-74.444488,40.419298],[-74.445003,40.418483],[-74.445762,40.417238],[-74.446307,40.416306],[-74.446666,40.415669],[-74.447028,40.414995],[-74.447401,40.414283],[-74.447921,40.413264],[-74.448358,40.412336],[-74.448659,40.411646],[-74.448935,40.41097],[-74.449166,40.4104],[-74.451786,40.403248],[-74.452138,40.402296],[-74.452486,40.401369],[-74.453358,40.39921],[-74.460391,40.381964],[-74.463564,40.374177],[-74.464888,40.370923],[-74.465885,40.368474],[-74.46604,40.368093],[-74.468502,40.362054],[-74.468974,40.36091],[-74.469363,40.360004],[-74.470165,40.35821],[-74.470398,40.357699],[-74.470755,40.356896],[-74.471058,40.356258],[-74.473402,40.351029],[-74.475558,40.346317],[-74.477922,40.341031],[-74.479319,40.337927],[-74.479831,40.336756],[-74.480422,40.335427],[-74.480649,40.33492],[-74.481162,40.333854],[-74.482443,40.331048],[-74.483324,40.329025],[-74.48412,40.327246],[-74.484983,40.325013],[-74.485717,40.322977],[-74.485899,40.322477],[-74.486106,40.321935],[-74.487102,40.319624],[-74.488726,40.31613],[-74.49065,40.312101],[-74.492426,40.308131],[-74.492477,40.308016],[-74.49402,40.304471],[-74.497613,40.296183],[-74.498105,40.295052],[-74.501217,40.288038],[-74.504425,40.280803],[-74.504549,40.280517],[-74.507751,40.273278],[-74.508158,40.272351],[-74.508677,40.271121],[-74.50888,40.270624],[-74.508984,40.27036],[-74.50951,40.269018],[-74.50959,40.268795],[-74.509623,40.268715],[-74.510387,40.266727],[-74.510919,40.265337],[-74.511924,40.262708],[-74.512345,40.261596],[-74.512743,40.260571],[-74.51279,40.26045],[-74.512882,40.260207],[-74.513152,40.259516],[-74.513765,40.257902],[-74.51415,40.256899],[-74.514828,40.255269],[-74.514988,40.254895],[-74.515193,40.254441],[-74.515408,40.25399],[-74.515634,40.253542],[-74.51587,40.253097],[-74.516116,40.252655],[-74.516372,40.252217],[-74.516638,40.251782],[-74.516943,40.251306],[-74.517205,40.250918],[-74.517476,40.250533],[-74.517755,40.250152],[-74.518428,40.249277],[-74.518991,40.24856],[-74.519309,40.248186],[-74.519625,40.247842],[-74.519958,40.247494],[-74.520301,40.24715],[-74.520623,40.24681],[-74.520881,40.246561],[-74.521015,40.246438],[-74.521315,40.246143],[-74.52168,40.245811],[-74.52205,40.245492],[-74.522431,40.245181],[-74.522833,40.244857],[-74.523214,40.244546],[-74.523611,40.244235],[-74.524008,40.243944],[-74.524405,40.243658],[-74.524845,40.243346],[-74.525236,40.243072],[-74.525703,40.242765],[-74.526497,40.242275],[-74.527157,40.241886],[-74.528574,40.241074],[-74.530225,40.240144],[-74.537553,40.236037],[-74.537832,40.235873],[-74.542072,40.233446],[-74.545768,40.231376],[-74.546682,40.230832],[-74.547583,40.230275],[-74.548471,40.229707],[-74.549346,40.229127],[-74.559737,40.222017],[-74.561891,40.220525],[-74.562855,40.219845],[-74.563044,40.219721],[-74.569082,40.215574],[-74.58331,40.205798],[-74.585426,40.204345],[-74.589909,40.201278],[-74.599948,40.194334],[-74.600202,40.194158],[-74.600536,40.19393],[-74.602582,40.192591],[-74.605807,40.190707],[-74.60606,40.190565],[-74.61107,40.187772],[-74.612539,40.186925],[-74.616634,40.184635],[-74.618743,40.183446],[-74.620359,40.182535],[-74.622078,40.181537],[-74.624359,40.180298],[-74.626737,40.178942],[-74.629434,40.177422],[-74.633694,40.175039],[-74.635426,40.17405],[-74.637742,40.172727],[-74.640624,40.171015],[-74.643151,40.16935],[-74.645449,40.167785],[-74.646535,40.167008],[-74.646802,40.166822],[-74.647167,40.16656],[-74.647363,40.166421],[-74.647697,40.166164],[-74.648142,40.165823],[-74.652793,40.162139],[-74.65521,40.160232],[-74.655307,40.160151],[-74.655632,40.159882],[-74.655882,40.159678],[-74.656113,40.159499],[-74.65657,40.159135],[-74.656794,40.15896],[-74.657235,40.158606],[-74.65809,40.157928],[-74.6583,40.157757],[-74.658718,40.157425],[-74.658927,40.157264],[-74.659543,40.15677],[-74.659738,40.156604],[-74.65994,40.156442],[-74.660142,40.156285],[-74.660342,40.156124],[-74.660543,40.155967],[-74.660753,40.155785],[-74.661538,40.155177],[-74.662127,40.154705],[-74.662927,40.154077],[-74.663899,40.153296],[-74.664094,40.153143],[-74.664486,40.152829],[-74.665082,40.152358],[-74.666294,40.151388],[-74.666496,40.151222],[-74.667109,40.150738],[-74.667314,40.150571],[-74.667519,40.15041],[-74.667726,40.150244],[-74.667899,40.150109],[-74.668348,40.14975],[-74.668558,40.149584],[-74.668769,40.149413],[-74.66898,40.149247],[-74.669835,40.148565],[-74.670051,40.148395],[-74.67048,40.148053],[-74.671127,40.147542],[-74.671169,40.147507],[-74.674933,40.144501],[-74.674989,40.144458],[-74.675648,40.143933],[-74.675869,40.143753],[-74.676114,40.143569],[-74.676754,40.143057],[-74.677187,40.142716],[-74.677403,40.142541],[-74.677835,40.1422],[-74.678042,40.142025],[-74.678384,40.141752],[-74.678706,40.1415],[-74.67893,40.14132],[-74.679621,40.140781],[-74.680076,40.140422],[-74.680763,40.13987],[-74.68098,40.139686],[-74.681443,40.139318],[-74.681998,40.138911],[-74.682389,40.138598],[-74.682635,40.138403],[-74.684219,40.137105],[-74.684453,40.136916],[-74.684921,40.136548],[-74.685155,40.136359],[-74.685858,40.135803],[-74.686091,40.135614],[-74.686783,40.135062],[-74.687238,40.134703],[-74.687913,40.134164],[-74.688328,40.133856],[-74.688592,40.133651],[-74.688956,40.133352],[-74.689263,40.133116],[-74.689488,40.13293],[-74.689724,40.13275],[-74.691013,40.131699],[-74.691233,40.131528],[-74.691452,40.131353],[-74.691664,40.131174],[-74.692322,40.130648],[-74.692763,40.130298],[-74.692986,40.130123],[-74.693209,40.129944],[-74.693433,40.129768],[-74.69379,40.129494],[-74.69402,40.129318],[-74.69458,40.128874],[-74.694838,40.128673],[-74.695036,40.128513],[-74.695256,40.128331],[-74.695484,40.128157],[-74.69572,40.127969],[-74.695941,40.127787],[-74.696181,40.1276],[-74.696402,40.127424],[-74.69659,40.127277],[-74.69686,40.12705],[-74.697092,40.126872],[-74.697339,40.126675],[-74.69757,40.126498],[-74.698909,40.125404],[-74.700111,40.124475],[-74.700642,40.124043],[-74.700767,40.123945],[-74.70116,40.123629],[-74.701337,40.123493],[-74.701878,40.123033],[-74.702072,40.122881],[-74.702454,40.122575],[-74.702557,40.122495],[-74.702753,40.122341],[-74.703199,40.121987],[-74.70356,40.121691],[-74.706228,40.119551],[-74.707019,40.118916],[-74.70722,40.118749],[-74.707624,40.118417],[-74.707826,40.118246],[-74.70803,40.11808],[-74.708845,40.117398],[-74.709048,40.117227],[-74.709453,40.116876],[-74.709657,40.116706],[-74.710066,40.116355],[-74.710475,40.115996],[-74.7113,40.115277],[-74.711506,40.115093],[-74.711712,40.114914],[-74.712537,40.114177],[-74.712741,40.113993],[-74.712945,40.113804],[-74.713149,40.11362],[-74.713353,40.113431],[-74.713792,40.113046],[-74.71413,40.112747],[-74.714559,40.112345],[-74.71484,40.11208],[-74.715172,40.111763],[-74.715576,40.11138],[-74.716146,40.110844],[-74.716715,40.110289],[-74.716917,40.110089],[-74.71747,40.109549],[-74.717844,40.109182],[-74.718103,40.108927],[-74.718742,40.108264],[-74.719481,40.107518],[-74.719849,40.107149],[-74.720036,40.10698],[-74.720334,40.106677],[-74.7206,40.10641],[-74.721001,40.106008],[-74.721693,40.105309],[-74.722827,40.104172],[-74.723347,40.103644],[-74.723508,40.103488],[-74.723806,40.103187],[-74.724102,40.10288],[-74.724427,40.102554],[-74.726702,40.100242],[-74.726811,40.100129],[-74.727286,40.099653],[-74.727543,40.099397],[-74.727674,40.099262],[-74.727946,40.098988],[-74.72823,40.098705],[-74.728374,40.098556],[-74.72867,40.098255],[-74.728824,40.098102],[-74.728981,40.09795],[-74.729455,40.09746],[-74.731976,40.094911],[-74.732369,40.09452],[-74.732567,40.094318],[-74.732965,40.093918],[-74.733165,40.09372],[-74.733969,40.092911],[-74.73417,40.092713],[-74.734751,40.092129],[-74.735377,40.091495],[-74.73558,40.091293],[-74.735783,40.091086],[-74.735987,40.090884],[-74.736191,40.090677],[-74.736613,40.090256],[-74.737057,40.089816],[-74.737444,40.089432],[-74.738091,40.088812],[-74.738518,40.088399],[-74.738804,40.088127],[-74.739374,40.08759],[-74.739808,40.087185],[-74.740247,40.086781],[-74.740693,40.086376],[-74.740918,40.086174],[-74.741144,40.085968],[-74.741832,40.085352],[-74.742064,40.08515],[-74.742524,40.084745],[-74.742756,40.084548],[-74.742987,40.084345],[-74.74322,40.084143],[-74.744154,40.083352],[-74.745333,40.082368],[-74.745569,40.082175],[-74.749085,40.079405],[-74.752901,40.076606],[-74.758364,40.072432],[-74.765656,40.066944],[-74.765856,40.066796],[-74.765962,40.066717],[-74.766449,40.066349],[-74.766692,40.066169],[-74.767176,40.065801],[-74.767418,40.065621],[-74.767895,40.065261],[-74.768132,40.065086],[-74.768366,40.064906],[-74.768607,40.064727],[-74.76907,40.064372],[-74.769303,40.064201],[-74.770229,40.0635],[-74.77046,40.063329],[-74.770691,40.063154],[-74.772978,40.061447],[-74.773211,40.061281],[-74.773683,40.060939],[-74.773928,40.060778],[-74.77417,40.060607],[-74.774413,40.060441],[-74.774659,40.06027],[-74.775154,40.059937],[-74.775405,40.059771],[-74.775657,40.05961],[-74.776166,40.059277],[-74.776423,40.059116],[-74.776677,40.058949],[-74.77694,40.058783],[-74.777729,40.058298],[-74.778256,40.057984],[-74.780394,40.056763],[-74.780664,40.056619],[-74.780936,40.056471],[-74.781209,40.056318],[-74.782028,40.055874],[-74.7823,40.055721],[-74.783657,40.05498],[-74.783929,40.054828],[-74.784475,40.054531],[-74.784751,40.054383],[-74.785863,40.053777],[-74.786142,40.05362],[-74.787261,40.053009],[-74.787828,40.052695],[-74.788114,40.052542],[-74.789551,40.051757],[-74.78984,40.051595],[-74.790417,40.051281],[-74.790706,40.051119],[-74.79301,40.049862],[-74.793582,40.049548],[-74.793865,40.049395],[-74.794713,40.048923],[-74.795278,40.048618],[-74.795561,40.048461],[-74.796682,40.047846],[-74.797233,40.047531],[-74.797779,40.047217],[-74.798051,40.047055],[-74.798321,40.046898],[-74.799394,40.046238],[-74.800034,40.045851],[-74.800675,40.045416],[-74.801603,40.044818],[-74.802132,40.044454],[-74.80258,40.044148],[-74.803395,40.043573],[-74.804088,40.043061],[-74.804639,40.042638],[-74.804891,40.042449],[-74.805141,40.042256],[-74.80539,40.042067],[-74.806124,40.041483],[-74.806843,40.040899],[-74.807079,40.040701],[-74.807546,40.040305],[-74.807777,40.040112],[-74.808233,40.039716],[-74.808455,40.039518],[-74.80934,40.038704],[-74.809565,40.038506],[-74.809784,40.0383],[-74.809995,40.038084],[-74.810221,40.037881],[-74.811095,40.037036],[-74.814362,40.033837],[-74.819002,40.02919],[-74.819966,40.028297],[-74.820444,40.027762],[-74.820656,40.027555],[-74.820867,40.027343],[-74.821079,40.027137],[-74.821289,40.026925],[-74.822335,40.025891],[-74.822645,40.025593],[-74.822957,40.02527],[-74.82338,40.024856],[-74.823591,40.024645],[-74.823802,40.024438],[-74.824013,40.024226],[-74.824225,40.024019],[-74.824863,40.023385],[-74.825076,40.023169],[-74.825504,40.022747],[-74.825719,40.022531],[-74.825935,40.022319],[-74.826151,40.022103],[-74.826367,40.021892],[-74.826582,40.021676],[-74.826795,40.021465],[-74.827009,40.021249],[-74.82765,40.020614],[-74.827866,40.020403],[-74.828502,40.019769],[-74.828931,40.019337],[-74.829147,40.01913],[-74.829783,40.018505],[-74.8302,40.018091],[-74.830407,40.017889],[-74.831021,40.017277],[-74.831224,40.017079],[-74.831426,40.016876],[-74.832225,40.016085],[-74.832818,40.015491],[-74.833015,40.015297],[-74.833212,40.0151],[-74.833411,40.014906],[-74.833808,40.01451],[-74.834613,40.013714],[-74.835014,40.013309],[-74.836038,40.012293],[-74.836247,40.01209],[-74.836457,40.011883],[-74.836675,40.011681],[-74.836897,40.011483],[-74.837119,40.01128],[-74.837343,40.011078],[-74.837566,40.010885],[-74.837797,40.010682],[-74.838029,40.010484],[-74.838265,40.010291],[-74.838502,40.010093],[-74.839228,40.009513],[-74.839472,40.009324],[-74.839966,40.008969],[-74.840208,40.008785],[-74.840462,40.0086],[-74.840713,40.008425],[-74.840967,40.008245],[-74.841478,40.007894],[-74.841992,40.007544],[-74.842519,40.007211],[-74.843053,40.006878],[-74.843327,40.006712],[-74.843878,40.006388],[-74.845013,40.005755],[-74.845588,40.005449],[-74.846165,40.005153],[-74.846742,40.004865],[-74.847031,40.004726],[-74.847606,40.004456],[-74.847892,40.004326],[-74.848179,40.0042],[-74.848466,40.00407],[-74.848752,40.003949],[-74.849039,40.003823],[-74.849329,40.003706],[-74.849613,40.003585],[-74.849899,40.003473],[-74.850186,40.003356],[-74.851318,40.002907],[-74.851879,40.002682],[-74.85216,40.002575],[-74.852444,40.002462],[-74.852723,40.002355],[-74.853563,40.002018],[-74.853843,40.00191],[-74.854689,40.001573],[-74.855258,40.001349],[-74.855546,40.001232],[-74.855834,40.00112],[-74.85671,40.000769],[-74.857587,40.000392],[-74.85817,40.000131],[-74.858462,39.999997],[-74.859325,39.999579],[-74.859609,39.999439],[-74.859888,39.999296],[-74.86071,39.998864],[-74.861247,39.998568],[-74.861512,39.998419],[-74.862299,39.997961],[-74.863073,39.997489],[-74.863329,39.997331],[-74.863584,39.997169],[-74.864084,39.996845],[-74.864365,39.996675],[-74.864618,39.996519],[-74.864665,39.99649],[-74.864975,39.996288],[-74.865219,39.996113],[-74.865527,39.99587],[-74.866233,39.995384],[-74.866709,39.99506],[-74.866949,39.994903],[-74.867432,39.994579],[-74.867675,39.994412],[-74.86841,39.993913],[-74.869403,39.993243],[-74.869653,39.993072],[-74.869901,39.992906],[-74.870149,39.992735],[-74.870394,39.992569],[-74.870639,39.992398],[-74.871126,39.992065],[-74.871848,39.991566],[-74.872088,39.991404],[-74.872329,39.991237],[-74.872613,39.991047],[-74.873055,39.990743],[-74.873298,39.990581],[-74.873536,39.990414],[-74.873775,39.990252],[-74.87425,39.989924],[-74.874495,39.989767],[-74.874739,39.989605],[-74.874985,39.989447],[-74.875236,39.989299],[-74.875483,39.989141],[-74.875729,39.988988],[-74.875977,39.988831],[-74.877233,39.988058],[-74.877497,39.987914],[-74.878018,39.987608],[-74.87828,39.98746],[-74.878541,39.987302],[-74.879349,39.986857],[-74.87962,39.986704],[-74.879894,39.986556],[-74.88017,39.986412],[-74.880725,39.986115],[-74.880998,39.985967],[-74.881553,39.985679],[-74.881828,39.98554],[-74.882103,39.985396],[-74.882377,39.985256],[-74.882655,39.985126],[-74.882925,39.984982],[-74.88319,39.984838],[-74.88346,39.984699],[-74.883727,39.984559],[-74.884262,39.98429],[-74.884527,39.984155],[-74.884792,39.984015],[-74.88532,39.983746],[-74.885585,39.983606],[-74.886116,39.983336],[-74.886382,39.983197],[-74.886914,39.982927],[-74.88718,39.982788],[-74.887446,39.982653],[-74.887713,39.982514],[-74.887981,39.982379],[-74.888249,39.982239],[-74.888519,39.982104],[-74.889058,39.981826],[-74.889328,39.981691],[-74.889598,39.981551],[-74.890684,39.980994],[-74.891563,39.98053],[-74.892319,39.980117],[-74.892588,39.979964],[-74.893125,39.979649],[-74.893922,39.979163],[-74.894449,39.97883],[-74.89471,39.97866],[-74.895228,39.978318],[-74.895738,39.977967],[-74.895988,39.977791],[-74.896234,39.977611],[-74.896478,39.977436],[-74.896719,39.977256],[-74.897195,39.976896],[-74.897665,39.976536],[-74.898128,39.976167],[-74.898355,39.975982],[-74.89858,39.975789],[-74.898985,39.975441],[-74.899249,39.975213],[-74.899469,39.975019],[-74.900113,39.97443],[-74.900324,39.974232],[-74.90076,39.973829],[-74.900952,39.973647],[-74.901372,39.973259],[-74.901795,39.972863],[-74.90201,39.972665],[-74.902443,39.97226],[-74.9031,39.971653],[-74.903319,39.971446],[-74.903753,39.971041],[-74.90397,39.970843],[-74.904609,39.970248],[-74.904819,39.97005],[-74.905445,39.96947],[-74.905653,39.969272],[-74.905861,39.969078],[-74.90607,39.968885],[-74.906278,39.968696],[-74.906692,39.968308],[-74.906901,39.968115],[-74.907109,39.967917],[-74.907416,39.967639],[-74.908162,39.966949],[-74.908371,39.966751],[-74.908582,39.966558],[-74.908793,39.966359],[-74.90922,39.965963],[-74.909434,39.96577],[-74.90965,39.965572],[-74.909866,39.965378],[-74.910082,39.96518],[-74.9103,39.964987],[-74.910519,39.964789],[-74.910739,39.964595],[-74.911406,39.964014],[-74.911856,39.963627],[-74.912766,39.962853],[-74.913,39.962664],[-74.913233,39.962471],[-74.913468,39.962282],[-74.913703,39.962088],[-74.91441,39.961521],[-74.914644,39.961327],[-74.914893,39.961128],[-74.915116,39.960945],[-74.915352,39.960756],[-74.915826,39.960369],[-74.916064,39.96018],[-74.916302,39.959986],[-74.916774,39.959608],[-74.917241,39.95923],[-74.917472,39.959041],[-74.91793,39.958672],[-74.918156,39.958487],[-74.918381,39.958307],[-74.918605,39.958123],[-74.918828,39.957943],[-74.91905,39.957767],[-74.919252,39.957601],[-74.919712,39.957232],[-74.919919,39.957062],[-74.920603,39.956516],[-74.920827,39.95634],[-74.920994,39.956203],[-74.921501,39.955796],[-74.921727,39.955611],[-74.922643,39.954868],[-74.922873,39.954684],[-74.923104,39.954495],[-74.923334,39.95431],[-74.92403,39.953743],[-74.924262,39.953559],[-74.925415,39.952622],[-74.925647,39.952438],[-74.92588,39.952249],[-74.926114,39.952064],[-74.926586,39.951686],[-74.926827,39.951501],[-74.927064,39.951308],[-74.927306,39.951119],[-74.927788,39.95075],[-74.928031,39.950561],[-74.928763,39.950007],[-74.929012,39.949827],[-74.929255,39.949633],[-74.929508,39.949458],[-74.929754,39.949269],[-74.93007,39.949039],[-74.930758,39.948531],[-74.931002,39.948337],[-74.931252,39.948148],[-74.931508,39.947972],[-74.931758,39.947788],[-74.932002,39.947594],[-74.932253,39.94741],[-74.933251,39.946672],[-74.933747,39.946302],[-74.933994,39.946122],[-74.934487,39.945758],[-74.934732,39.945573],[-74.93522,39.945213],[-74.935464,39.945029],[-74.936191,39.944488],[-74.936432,39.944313],[-74.936913,39.943953],[-74.937871,39.94325],[-74.938113,39.943079],[-74.938584,39.942728],[-74.938921,39.942467],[-74.939292,39.942197],[-74.93953,39.942026],[-74.939768,39.94185],[-74.940006,39.94167],[-74.940245,39.941495],[-74.941449,39.940594],[-74.94169,39.940419],[-74.941932,39.940239],[-74.942175,39.940054],[-74.942902,39.939514],[-74.94338,39.939145],[-74.943617,39.938965],[-74.944318,39.938411],[-74.944548,39.938231],[-74.944778,39.938046],[-74.945234,39.937686],[-74.945905,39.937132],[-74.946128,39.936952],[-74.947248,39.936029],[-74.947471,39.935849],[-74.947693,39.935664],[-74.948789,39.934764],[-74.949006,39.934588],[-74.949223,39.934408],[-74.949439,39.934233],[-74.949654,39.934052],[-74.950086,39.933701],[-74.950302,39.933521],[-74.950463,39.933391],[-74.951364,39.932756],[-74.951515,39.932634],[-74.951669,39.932526],[-74.951829,39.932427],[-74.951996,39.932346],[-74.952168,39.932274],[-74.95235,39.932216],[-74.952543,39.932175],[-74.952742,39.932148],[-74.952871,39.932143],[-74.952946,39.932139],[-74.95315,39.932126],[-74.95335,39.932117],[-74.953556,39.932109],[-74.953738,39.9321],[-74.953909,39.93208],[-74.954056,39.932056],[-74.954198,39.932025],[-74.954351,39.931974],[-74.954504,39.931918],[-74.954635,39.931864],[-74.954776,39.931794],[-74.954891,39.931716],[-74.955081,39.931604],[-74.955369,39.931421],[-74.955704,39.931166],[-74.956243,39.93058],[-74.956518,39.930405],[-74.956717,39.930263],[-74.956868,39.930181],[-74.957006,39.9301],[-74.957148,39.930028],[-74.957289,39.929974],[-74.957429,39.929934],[-74.957569,39.929916],[-74.957709,39.929907],[-74.957853,39.92992],[-74.957999,39.929943],[-74.958142,39.929988],[-74.958285,39.930037],[-74.958422,39.930092],[-74.958993,39.930299],[-74.959143,39.930403],[-74.959271,39.930493],[-74.959395,39.930578],[-74.959516,39.930664],[-74.95963,39.930741],[-74.959739,39.930817],[-74.959831,39.93088],[-74.959902,39.930926],[-74.959944,39.930957],[-74.959997,39.930989],[-74.960032,39.931016],[-74.960071,39.931043],[-74.960114,39.93107],[-74.96016,39.931101],[-74.96021,39.931133],[-74.96027,39.931173],[-74.960336,39.931219],[-74.960397,39.931259],[-74.960458,39.931304],[-74.960519,39.931345],[-74.960581,39.931385],[-74.960702,39.931466],[-74.96073,39.931484],[-74.96081,39.931539],[-74.960865,39.931575],[-74.960979,39.931646],[-74.961266,39.931822],[-74.961371,39.931895],[-74.961482,39.931967],[-74.961592,39.932037],[-74.961728,39.932124],[-74.961859,39.93221],[-74.961995,39.932296],[-74.962133,39.932381],[-74.96241,39.932562],[-74.962548,39.932656],[-74.962825,39.932837],[-74.962962,39.932931],[-74.963097,39.933021],[-74.963237,39.933112],[-74.963374,39.933206],[-74.963413,39.933229],[-74.963649,39.933391],[-74.963791,39.933486],[-74.963939,39.93358],[-74.964087,39.933679],[-74.964238,39.933783],[-74.964699,39.934094],[-74.964853,39.934193],[-74.965469,39.934616],[-74.965546,39.934669],[-74.965786,39.934815],[-74.965983,39.934943],[-74.966108,39.935032],[-74.966139,39.93505],[-74.96644,39.935252],[-74.966609,39.93537],[-74.966775,39.935482],[-74.966938,39.93559],[-74.967099,39.935699],[-74.967337,39.935855],[-74.967566,39.93601],[-74.967717,39.936109],[-74.967864,39.936208],[-74.968008,39.936302],[-74.968149,39.936397],[-74.968425,39.936586],[-74.96849,39.936629],[-74.968701,39.936771],[-74.968841,39.936861],[-74.968979,39.936956],[-74.969115,39.937046],[-74.969169,39.937081],[-74.969249,39.937132],[-74.969383,39.937222],[-74.969515,39.937307],[-74.969589,39.937357],[-74.969775,39.937483],[-74.970044,39.937659],[-74.970217,39.937776],[-74.970471,39.937943],[-74.970617,39.938042],[-74.970914,39.93824],[-74.970956,39.938269],[-74.971064,39.938344],[-74.971216,39.938443],[-74.97137,39.938547],[-74.971525,39.938646],[-74.97168,39.93875],[-74.971836,39.938853],[-74.971993,39.938961],[-74.972312,39.939169],[-74.972474,39.939277],[-74.972639,39.939385],[-74.972803,39.939498],[-74.972969,39.939606],[-74.973135,39.939719],[-74.973303,39.939831],[-74.973646,39.940066],[-74.973822,39.940183],[-74.974183,39.940426],[-74.974368,39.940548],[-74.974555,39.940674],[-74.974743,39.940796],[-74.974933,39.940922],[-74.975125,39.941048],[-74.97532,39.94117],[-74.975518,39.941296],[-74.975713,39.941417],[-74.976219,39.941724],[-74.976315,39.941778],[-74.97651,39.9419],[-74.976702,39.942017],[-74.97689,39.942138],[-74.977073,39.94226],[-74.977254,39.942377],[-74.97743,39.942499],[-74.977605,39.942625],[-74.978061,39.942951],[-74.978416,39.943211],[-74.978635,39.943378],[-74.978988,39.943617],[-74.979137,39.94372],[-74.979285,39.943824],[-74.979436,39.943932],[-74.979592,39.944036],[-74.979639,39.944072],[-74.97975,39.944144],[-74.97991,39.944252],[-74.979938,39.944269],[-74.980051,39.944337],[-74.980076,39.944356],[-74.980413,39.944563],[-74.980585,39.944666],[-74.980728,39.944757],[-74.981109,39.944991],[-74.981283,39.945095],[-74.981453,39.945198],[-74.981559,39.945266],[-74.98162,39.945302],[-74.981782,39.945405],[-74.981852,39.945451],[-74.982069,39.945591],[-74.982673,39.945996],[-74.983291,39.946403],[-74.983325,39.946425],[-74.983395,39.946482],[-74.983542,39.946581],[-74.983956,39.946865],[-74.984196,39.947032],[-74.984304,39.947113],[-74.984389,39.947181],[-74.984581,39.947334],[-74.984657,39.947397],[-74.984723,39.947456],[-74.984781,39.947505],[-74.984874,39.947591],[-74.984924,39.94764],[-74.984953,39.947667],[-74.984984,39.947699],[-74.985086,39.947803],[-74.985118,39.947834],[-74.985161,39.947879],[-74.985211,39.947929],[-74.985268,39.947983],[-74.985329,39.948046],[-74.985392,39.948113],[-74.985457,39.948186],[-74.985524,39.948258],[-74.985588,39.94833],[-74.985652,39.948406],[-74.985837,39.948636],[-74.985962,39.948803],[-74.98604,39.94892],[-74.986098,39.948987],[-74.986166,39.949087],[-74.986235,39.949186],[-74.986303,39.949289],[-74.986369,39.949397],[-74.9865,39.949623],[-74.986623,39.949857],[-74.986683,39.949979],[-74.986741,39.950109],[-74.986798,39.95024],[-74.986832,39.950321],[-74.986856,39.95038],[-74.986912,39.950524],[-74.986965,39.950672],[-74.987015,39.950826],[-74.987061,39.950979],[-74.987104,39.951136],[-74.987144,39.951299],[-74.987179,39.95147],[-74.987211,39.951641],[-74.987238,39.951821],[-74.987261,39.952006],[-74.987277,39.952191],[-74.98729,39.95238],[-74.987308,39.952675],[-74.987313,39.952804],[-74.98732,39.952952],[-74.987322,39.953015],[-74.987323,39.953056],[-74.987332,39.953339],[-74.987341,39.953533],[-74.987355,39.953722],[-74.987363,39.953912],[-74.987372,39.954096],[-74.987379,39.954281],[-74.987384,39.954466],[-74.987391,39.954646],[-74.9874,39.954831],[-74.987425,39.955218],[-74.987435,39.955371],[-74.987451,39.955551],[-74.987473,39.955732],[-74.987499,39.955912],[-74.987524,39.956074],[-74.987528,39.956101],[-74.9876,39.956479],[-74.987636,39.956673],[-74.987677,39.956867],[-74.987719,39.957038],[-74.987741,39.957259],[-74.987794,39.957457],[-74.987857,39.957646],[-74.98793,39.95784],[-74.988013,39.958025],[-74.988106,39.958209],[-74.988207,39.958394],[-74.988315,39.958579],[-74.988432,39.958759],[-74.98856,39.958935],[-74.988697,39.95911],[-74.988842,39.959282],[-74.988996,39.959444],[-74.98902,39.959467],[-74.989048,39.959495],[-74.98916,39.959606],[-74.989333,39.959764],[-74.98949,39.959921],[-74.989658,39.960079],[-74.989829,39.960228],[-74.990003,39.960376],[-74.990182,39.960521],[-74.990366,39.960656],[-74.990554,39.960791],[-74.990749,39.960917],[-74.990947,39.961043],[-74.991149,39.96116],[-74.991354,39.961277],[-74.991563,39.961386],[-74.991774,39.961494],[-74.991988,39.961597],[-74.992206,39.961696],[-74.992427,39.961791],[-74.992649,39.961881],[-74.993084,39.962052],[-74.993295,39.962138],[-74.993499,39.962219],[-74.993897,39.962381],[-74.994091,39.962462],[-74.99428,39.962539],[-74.994465,39.962616],[-74.994643,39.962688],[-74.994814,39.962755],[-74.995295,39.962954],[-74.995443,39.963017],[-74.995612,39.963083],[-74.995713,39.963125],[-74.99584,39.963174],[-74.995964,39.963224],[-74.996229,39.963336],[-74.996373,39.9634],[-74.996525,39.963463],[-74.996683,39.963526],[-74.996847,39.963593],[-74.997211,39.963752],[-74.997626,39.963909],[-74.998046,39.96408],[-74.998205,39.964152],[-74.998397,39.964242],[-74.99858,39.964332],[-74.998769,39.964427],[-74.998896,39.964494],[-74.999153,39.964638],[-74.999345,39.964751],[-74.999538,39.964868],[-74.999728,39.964994],[-74.999915,39.96512],[-75.000099,39.965256],[-75.00014,39.965283],[-75.000278,39.965391],[-75.000327,39.965428],[-75.000452,39.965526],[-75.000621,39.96567],[-75.000787,39.965814],[-75.00095,39.965958],[-75.00111,39.966107],[-75.00127,39.96626],[-75.001428,39.966418],[-75.001586,39.966585],[-75.001772,39.966771],[-75.001912,39.966913],[-75.002079,39.96708],[-75.002244,39.967251],[-75.002409,39.967418],[-75.002573,39.96758],[-75.002899,39.967913],[-75.00306,39.968076],[-75.003076,39.968091],[-75.003387,39.9684],[-75.003552,39.968562],[-75.00372,39.968724],[-75.004066,39.969044],[-75.004423,39.96936],[-75.004605,39.969517],[-75.00479,39.969675],[-75.004976,39.969828],[-75.005156,39.969981],[-75.005389,39.970188],[-75.005473,39.970265],[-75.005623,39.970391],[-75.005773,39.970513],[-75.005928,39.970634],[-75.006084,39.970765],[-75.006242,39.970891],[-75.006376,39.970994],[-75.006562,39.971152],[-75.006721,39.971288],[-75.006879,39.971427],[-75.007034,39.971571],[-75.00719,39.97172],[-75.007503,39.972026],[-75.007663,39.972184],[-75.007824,39.972346],[-75.007983,39.972513],[-75.008143,39.972688],[-75.008301,39.972869],[-75.008457,39.973044],[-75.00861,39.973225],[-75.008762,39.973396],[-75.008911,39.973562],[-75.009202,39.973896],[-75.00936,39.974062],[-75.009408,39.974125],[-75.009568,39.97427],[-75.009742,39.974436],[-75.00993,39.974589],[-75.010103,39.974738],[-75.010127,39.974757],[-75.010278,39.974878],[-75.010456,39.975008],[-75.010638,39.97513],[-75.010823,39.975247],[-75.011009,39.975351],[-75.011197,39.97545],[-75.011385,39.975531],[-75.011574,39.975607],[-75.011766,39.975675],[-75.011956,39.975733],[-75.01215,39.975783],[-75.012349,39.975833],[-75.012757,39.975905],[-75.012969,39.975927],[-75.013187,39.975945],[-75.013646,39.97597],[-75.013885,39.975975],[-75.014607,39.976007],[-75.015096,39.976037],[-75.015345,39.976048],[-75.015554,39.976058],[-75.015835,39.976072],[-75.017348,39.976138],[-75.018098,39.976168],[-75.018951,39.976211],[-75.019937,39.976256],[-75.02056,39.976293],[-75.021209,39.976308],[-75.021567,39.976315],[-75.022419,39.976287],[-75.023032,39.976237],[-75.023287,39.976199],[-75.024008,39.976092],[-75.024507,39.976002],[-75.024895,39.975914],[-75.025199,39.975831],[-75.026016,39.975577],[-75.026633,39.975331],[-75.026841,39.975248],[-75.028013,39.97478],[-75.02878,39.974474],[-75.02985,39.974028],[-75.030283,39.973864],[-75.030906,39.973639],[-75.031331,39.973512],[-75.031735,39.97339],[-75.03291,39.973122],[-75.033848,39.972973],[-75.034272,39.972919],[-75.034602,39.97289],[-75.035023,39.972853],[-75.035707,39.972824],[-75.035985,39.972816],[-75.03663,39.97281],[-75.037204,39.972831],[-75.038506,39.972933],[-75.039067,39.973008],[-75.039361,39.973056],[-75.039629,39.973101],[-75.040463,39.973277],[-75.040934,39.973405],[-75.041328,39.973525],[-75.042215,39.973815],[-75.042435,39.973896],[-75.042621,39.973964],[-75.042991,39.974105],[-75.043754,39.974436],[-75.044116,39.974606],[-75.044825,39.974976],[-75.045923,39.97555],[-75.046477,39.975839],[-75.04697,39.97611],[-75.047804,39.976568],[-75.048775,39.977069],[-75.049151,39.977268],[-75.050436,39.977875],[-75.05127,39.978268],[-75.052284,39.978789],[-75.053073,39.979194],[-75.053874,39.9796],[-75.054034,39.979681],[-75.054817,39.980076],[-75.055477,39.980398],[-75.055564,39.98044],[-75.055636,39.980475],[-75.055735,39.980522],[-75.056391,39.980831],[-75.057299,39.981236],[-75.057411,39.981283],[-75.057476,39.981311],[-75.057518,39.981327],[-75.057568,39.98135],[-75.057661,39.981389],[-75.057767,39.981434],[-75.058126,39.981587],[-75.058954,39.981964],[-75.061878,39.98317],[-75.065643,39.984718],[-75.068328,39.985846],[-75.069518,39.986348],[-75.0699,39.986509],[-75.070957,39.98699],[-75.071872,39.987456],[-75.072614,39.987886],[-75.073331,39.988311],[-75.073987,39.988752],[-75.074484,39.989135],[-75.075074,39.98959],[-75.075696,39.990125],[-75.076037,39.990437],[-75.076548,39.990919],[-75.076905,39.991289],[-75.078479,39.993066],[-75.078903,39.99359],[-75.079143,39.993901],[-75.079324,39.994153],[-75.079477,39.994388],[-75.079637,39.994655],[-75.07975,39.994863],[-75.080085,39.995816],[-75.080294,39.996453],[-75.080397,39.996769],[-75.080437,39.996899],[-75.080465,39.997077],[-75.080468,39.99727],[-75.080451,39.997505],[-75.080409,39.997697],[-75.080346,39.9979],[-75.080279,39.998078],[-75.080174,39.998324],[-75.079957,39.998811],[-75.079716,39.999372],[-75.079481,39.99986],[-75.079293,40.000194],[-75.078822,40.000984],[-75.078322,40.001636],[-75.078066,40.001971],[-75.077221,40.003016],[-75.076762,40.003598],[-75.076581,40.003831],[-75.076312,40.00417],[-75.07613,40.004377],[-75.075974,40.004524],[-75.075809,40.004663],[-75.075476,40.004914],[-75.075208,40.005104],[-75.074516,40.00562],[-75.074373,40.00573],[-75.074266,40.005847],[-75.074187,40.005958],[-75.074063,40.006183],[-75.073824,40.006673],[-75.073486,40.007188],[-75.07339,40.00736],[-75.073102,40.007566],[-75.072813,40.007776],[-75.072769,40.00784],[-75.072487,40.008123],[-75.072683,40.008101],[-75.073908,40.007962],[-75.076194,40.007673],[-75.078194,40.007411],[-75.080825,40.007056],[-75.082864,40.006792],[-75.083005,40.006767],[-75.086057,40.006376],[-75.086193,40.006349],[-75.086339,40.006291],[-75.086767,40.006054],[-75.087067,40.006213],[-75.087392,40.006356],[-75.088209,40.006618],[-75.088677,40.006512],[-75.089701,40.006324],[-75.089962,40.006271],[-75.090611,40.006154],[-75.091065,40.006076],[-75.091258,40.006055],[-75.091573,40.006021],[-75.091827,40.006009],[-75.092163,40.005996],[-75.092216,40.005998],[-75.09238,40.005996],[-75.092732,40.005992],[-75.093024,40.005983],[-75.093273,40.005957],[-75.09407,40.007105],[-75.09431,40.007471],[-75.094816,40.008195],[-75.095064,40.008559],[-75.095784,40.00961],[-75.095975,40.009907],[-75.096148,40.009987],[-75.096817,40.010077],[-75.097374,40.010151],[-75.098097,40.010247],[-75.098798,40.010336],[-75.099358,40.010412],[-75.100038,40.010503],[-75.100767,40.01059],[-75.101477,40.010683],[-75.102203,40.010779],[-75.103186,40.010908],[-75.1035,40.010949],[-75.104167,40.011037],[-75.104818,40.011123],[-75.105433,40.011204],[-75.106098,40.011291],[-75.106764,40.011379],[-75.107326,40.011452],[-75.108026,40.011547],[-75.109034,40.011679],[-75.109537,40.011746],[-75.109989,40.011789],[-75.112161,40.012085],[-75.114141,40.012326],[-75.11782,40.012812],[-75.119439,40.013026],[-75.119794,40.012524],[-75.121213,40.010515],[-75.121469,40.010153],[-75.122774,40.010321],[-75.126629,40.010814],[-75.131782,40.011468],[-75.132682,40.011582]]},{_id:'2',name:'Truck #2',plate:'AC478475',fromLocation:'Baltimore',toLocation:'Pittsburg',pilotName:'Jose Gutierrez',address:'Viale Europa 1, Rome, Italy',mobile:'1 (916) 442-0945',truckType:'Platform truck',maxCharge:'45.000',image:'/img/a2.jpg',truckModel:'Volvo D13',truckYear:'2014',actualPosition:[40.138355,-79.410683],vectorPath:[[-76.611076,39.290887],[-76.611048,39.290519],[-76.611041,39.290444],[-76.611028,39.290134],[-76.611002,39.289775],[-76.610978,39.289697],[-76.610917,39.288969],[-76.610872,39.288523],[-76.610858,39.288331],[-76.610854,39.288279],[-76.610835,39.287996],[-76.610827,39.287886],[-76.611209,39.28784],[-76.611746,39.287812],[-76.612056,39.287796],[-76.612159,39.287791],[-76.612258,39.287784],[-76.612365,39.287782],[-76.612856,39.287766],[-76.612962,39.287764],[-76.613097,39.287762],[-76.613368,39.287757],[-76.613509,39.287755],[-76.613622,39.287753],[-76.613617,39.287654],[-76.613602,39.287363],[-76.613586,39.287036],[-76.613571,39.286761],[-76.613563,39.286639],[-76.613554,39.286538],[-76.613549,39.28647],[-76.613458,39.285579],[-76.613422,39.285197],[-76.613354,39.284536],[-76.613335,39.284351],[-76.613485,39.284343],[-76.614596,39.284292],[-76.614691,39.284287],[-76.614797,39.284281],[-76.615013,39.284272],[-76.615432,39.284251],[-76.615829,39.28423],[-76.616305,39.284206],[-76.616736,39.284185],[-76.617511,39.284147],[-76.61767,39.284135],[-76.6178,39.28413],[-76.618159,39.284112],[-76.618471,39.284096],[-76.618802,39.284071],[-76.618914,39.284055],[-76.61898,39.28404],[-76.61905,39.284021],[-76.619145,39.283965],[-76.61919,39.283924],[-76.619207,39.283883],[-76.619221,39.283811],[-76.619236,39.28372],[-76.619221,39.283489],[-76.619199,39.283145],[-76.619175,39.282822],[-76.619161,39.282601],[-76.619142,39.282277],[-76.619124,39.282032],[-76.61906,39.281729],[-76.61905,39.281507],[-76.619032,39.28119],[-76.619014,39.280853],[-76.618986,39.28041],[-76.618981,39.280311],[-76.618975,39.280202],[-76.618969,39.280092],[-76.618967,39.279983],[-76.618972,39.279868],[-76.618973,39.27978],[-76.618982,39.279664],[-76.61899,39.279548],[-76.619013,39.27939],[-76.619069,39.279118],[-76.619127,39.278773],[-76.619206,39.2785],[-76.619287,39.27826],[-76.619301,39.278228],[-76.619341,39.278126],[-76.619353,39.278098],[-76.619392,39.278003],[-76.619404,39.277973],[-76.619454,39.27786],[-76.619996,39.276768],[-76.62129,39.273954],[-76.622988,39.270211],[-76.623184,39.269838],[-76.623397,39.269515],[-76.623644,39.26923],[-76.623919,39.268976],[-76.624172,39.268776],[-76.624509,39.268558],[-76.62472,39.268465],[-76.624898,39.268385],[-76.625162,39.268308],[-76.625498,39.268225],[-76.625777,39.268189],[-76.626051,39.268177],[-76.626425,39.268192],[-76.626776,39.26822],[-76.627201,39.268272],[-76.627628,39.268343],[-76.628049,39.268436],[-76.628518,39.26855],[-76.629241,39.268707],[-76.630415,39.268924],[-76.631268,39.269111],[-76.63286,39.269433],[-76.63404,39.269653],[-76.634863,39.269793],[-76.635757,39.269939],[-76.636404,39.270034],[-76.637124,39.27014],[-76.637928,39.270253],[-76.639189,39.270401],[-76.640168,39.270508],[-76.64256,39.270756],[-76.643705,39.270858],[-76.646733,39.271107],[-76.64952,39.271348],[-76.651426,39.271527],[-76.651881,39.271558],[-76.652413,39.271581],[-76.652833,39.271568],[-76.653221,39.271541],[-76.653721,39.271489],[-76.654101,39.271419],[-76.654508,39.271329],[-76.654832,39.271243],[-76.655163,39.271139],[-76.655465,39.271032],[-76.655757,39.270915],[-76.65743,39.27017],[-76.660191,39.268949],[-76.66051,39.268807],[-76.663957,39.267304],[-76.664664,39.266996],[-76.666471,39.266208],[-76.669436,39.264904],[-76.669902,39.264686],[-76.670269,39.264493],[-76.670724,39.264221],[-76.671153,39.263924],[-76.671568,39.263597],[-76.671935,39.263265],[-76.672273,39.262906],[-76.672502,39.262629],[-76.672778,39.262252],[-76.673195,39.261667],[-76.673942,39.260471],[-76.674915,39.258992],[-76.676005,39.257327],[-76.676284,39.256892],[-76.67669,39.256414],[-76.676938,39.256126],[-76.677114,39.255948],[-76.677263,39.255814],[-76.677465,39.255663],[-76.67766,39.255534],[-76.677935,39.255379],[-76.678214,39.25525],[-76.678434,39.255164],[-76.678642,39.255094],[-76.678848,39.25504],[-76.679067,39.254993],[-76.679346,39.254944],[-76.681981,39.254551],[-76.68253,39.254446],[-76.683232,39.254344],[-76.683566,39.254307],[-76.683864,39.254289],[-76.684176,39.254283],[-76.684506,39.254291],[-76.684872,39.254322],[-76.685183,39.254368],[-76.68547,39.25442],[-76.685754,39.254486],[-76.686143,39.254584],[-76.686517,39.254701],[-76.687221,39.254908],[-76.687713,39.255079],[-76.688105,39.255208],[-76.688621,39.255372],[-76.689149,39.255525],[-76.689954,39.255738],[-76.691375,39.256132],[-76.692113,39.256326],[-76.694493,39.256958],[-76.695788,39.257304],[-76.6968,39.257574],[-76.697145,39.25767],[-76.697786,39.257878],[-76.698302,39.258067],[-76.698916,39.25832],[-76.699404,39.258544],[-76.6999,39.258798],[-76.700372,39.259047],[-76.702621,39.260283],[-76.702769,39.26036],[-76.705702,39.26191],[-76.706207,39.262177],[-76.706897,39.262551],[-76.707684,39.26297],[-76.708365,39.263347],[-76.7109,39.264786],[-76.720815,39.270446],[-76.721242,39.270701],[-76.722039,39.271187],[-76.722375,39.271408],[-76.722673,39.271632],[-76.722949,39.271867],[-76.723209,39.272117],[-76.723456,39.272392],[-76.723673,39.272677],[-76.723881,39.272979],[-76.72409,39.273369],[-76.724287,39.2738],[-76.724433,39.274215],[-76.724839,39.275496],[-76.725075,39.276231],[-76.725241,39.276756],[-76.725437,39.277364],[-76.725608,39.277821],[-76.725749,39.278128],[-76.725979,39.278527],[-76.726188,39.278813],[-76.726417,39.279082],[-76.726665,39.27934],[-76.726937,39.279582],[-76.72724,39.279815],[-76.72746,39.279968],[-76.727676,39.280103],[-76.728022,39.280301],[-76.73084,39.281848],[-76.731065,39.281972],[-76.73145,39.282178],[-76.733522,39.283309],[-76.734434,39.283807],[-76.734459,39.28382],[-76.735516,39.284402],[-76.735965,39.284647],[-76.736458,39.284914],[-76.736934,39.28519],[-76.737323,39.285428],[-76.737706,39.28568],[-76.737979,39.285876],[-76.738196,39.286041],[-76.738532,39.286308],[-76.738843,39.28657],[-76.738891,39.286614],[-76.7392,39.286899],[-76.73954,39.287234],[-76.739807,39.287522],[-76.740039,39.287803],[-76.740322,39.288187],[-76.740593,39.288572],[-76.740778,39.288852],[-76.741002,39.289234],[-76.74107,39.289358],[-76.741235,39.289656],[-76.741385,39.289965],[-76.741531,39.290309],[-76.741717,39.290793],[-76.741832,39.291155],[-76.741943,39.291582],[-76.742021,39.291951],[-76.74207,39.292236],[-76.742145,39.292782],[-76.742969,39.2992],[-76.742962,39.300001],[-76.742933,39.300662],[-76.742889,39.301098],[-76.742832,39.301453],[-76.742762,39.301802],[-76.742681,39.302204],[-76.742606,39.302583],[-76.742546,39.302859],[-76.742514,39.303029],[-76.742485,39.303227],[-76.742484,39.303482],[-76.742506,39.303773],[-76.742544,39.303994],[-76.742603,39.30422],[-76.742681,39.304437],[-76.742806,39.304664],[-76.742949,39.304907],[-76.743105,39.305125],[-76.74329,39.305309],[-76.743621,39.305596],[-76.743948,39.305842],[-76.744223,39.305996],[-76.744539,39.306143],[-76.744894,39.306285],[-76.745214,39.306383],[-76.745707,39.306504],[-76.746119,39.306582],[-76.746382,39.306625],[-76.746687,39.30667],[-76.747016,39.306707],[-76.747619,39.306732],[-76.748243,39.306732],[-76.749328,39.306702],[-76.750024,39.306701],[-76.750422,39.306724],[-76.750851,39.30677],[-76.751594,39.306932],[-76.75212,39.307091],[-76.752699,39.307259],[-76.753188,39.307365],[-76.753384,39.307416],[-76.753761,39.307521],[-76.754147,39.307624],[-76.754769,39.307752],[-76.75532,39.307854],[-76.755942,39.307947],[-76.756577,39.308015],[-76.757103,39.30805],[-76.75753,39.308072],[-76.757989,39.30808],[-76.75851,39.308075],[-76.758966,39.308055],[-76.759411,39.30803],[-76.759969,39.307982],[-76.763537,39.307637],[-76.769088,39.307104],[-76.769698,39.307053],[-76.770308,39.307012],[-76.770812,39.306981],[-76.771377,39.306951],[-76.772086,39.306922],[-76.772934,39.306903],[-76.773667,39.306895],[-76.774514,39.306898],[-76.7751,39.30691],[-76.775801,39.306938],[-76.776423,39.306965],[-76.777036,39.306999],[-76.78268,39.30734],[-76.783267,39.307372],[-76.783752,39.307392],[-76.784284,39.307405],[-76.784882,39.307411],[-76.785367,39.3074],[-76.785944,39.307381],[-76.786534,39.307342],[-76.787155,39.307291],[-76.787662,39.307237],[-76.788331,39.307152],[-76.789032,39.307043],[-76.789791,39.306901],[-76.790359,39.306783],[-76.79096,39.306636],[-76.791593,39.306478],[-76.792565,39.306217],[-76.793069,39.306066],[-76.793712,39.305876],[-76.79448,39.305629],[-76.795244,39.305374],[-76.79774,39.30442],[-76.798156,39.304246],[-76.798499,39.30409],[-76.798844,39.303919],[-76.79921,39.303722],[-76.799576,39.303505],[-76.800102,39.303164],[-76.800674,39.302722],[-76.801004,39.302428],[-76.801305,39.302143],[-76.801537,39.301897],[-76.801804,39.301591],[-76.802304,39.300934],[-76.80246,39.300726],[-76.80262,39.300507],[-76.802798,39.300298],[-76.803019,39.300051],[-76.803213,39.299852],[-76.803467,39.299609],[-76.803676,39.299432],[-76.803954,39.299214],[-76.804338,39.29895],[-76.804769,39.298685],[-76.805254,39.298431],[-76.805696,39.298223],[-76.806208,39.29802],[-76.806653,39.297855],[-76.807164,39.297685],[-76.80769,39.29753],[-76.808225,39.297389],[-76.808791,39.297263],[-76.809372,39.297155],[-76.809956,39.297061],[-76.810508,39.296979],[-76.81117,39.296897],[-76.811812,39.296823],[-76.812305,39.296765],[-76.812934,39.296705],[-76.813553,39.296657],[-76.814382,39.296628],[-76.815166,39.296624],[-76.815732,39.296637],[-76.81633,39.296658],[-76.816997,39.296696],[-76.817675,39.296744],[-76.81809,39.296766],[-76.818537,39.296781],[-76.818958,39.296783],[-76.819453,39.29677],[-76.819801,39.296753],[-76.82111,39.296638],[-76.821574,39.29661],[-76.822159,39.296584],[-76.822689,39.296565],[-76.823204,39.296564],[-76.825387,39.296581],[-76.829512,39.296605],[-76.830267,39.296603],[-76.831007,39.296597],[-76.83195,39.296575],[-76.832948,39.296545],[-76.8339,39.296509],[-76.838461,39.296341],[-76.848495,39.295957],[-76.849082,39.295946],[-76.849566,39.29594],[-76.850172,39.295942],[-76.850899,39.295954],[-76.851486,39.295973],[-76.85211,39.296003],[-76.852693,39.296037],[-76.853328,39.296087],[-76.853794,39.296125],[-76.854304,39.296176],[-76.854834,39.296237],[-76.8554,39.296308],[-76.856219,39.296422],[-76.856776,39.296509],[-76.857385,39.296617],[-76.857948,39.29672],[-76.858522,39.296834],[-76.859064,39.296952],[-76.859635,39.297083],[-76.860189,39.297219],[-76.860765,39.29737],[-76.861341,39.297525],[-76.861829,39.297671],[-76.862306,39.297819],[-76.862872,39.298],[-76.863425,39.298186],[-76.864032,39.298399],[-76.86461,39.298612],[-76.865072,39.298794],[-76.865579,39.298999],[-76.866308,39.299305],[-76.871209,39.301424],[-76.875519,39.30328],[-76.876062,39.303502],[-76.876342,39.303611],[-76.876714,39.303753],[-76.877192,39.303929],[-76.877691,39.304099],[-76.878236,39.304277],[-76.878793,39.304447],[-76.879465,39.304638],[-76.880095,39.304802],[-76.880595,39.304925],[-76.881049,39.305027],[-76.881519,39.305129],[-76.882094,39.305241],[-76.882601,39.305332],[-76.883233,39.305436],[-76.883808,39.305517],[-76.884302,39.30558],[-76.884799,39.305638],[-76.8854,39.305696],[-76.885962,39.30574],[-76.886613,39.305782],[-76.887192,39.305806],[-76.887747,39.305821],[-76.888426,39.305829],[-76.889031,39.305821],[-76.889702,39.305805],[-76.89037,39.305778],[-76.890879,39.305748],[-76.891487,39.3057],[-76.892009,39.305648],[-76.892692,39.305568],[-76.893577,39.30545],[-76.894126,39.305366],[-76.894695,39.305267],[-76.89523,39.305172],[-76.895871,39.305042],[-76.896594,39.304892],[-76.897277,39.304736],[-76.898066,39.304546],[-76.89879,39.304356],[-76.899698,39.304107],[-76.900573,39.303848],[-76.901491,39.303556],[-76.902246,39.303299],[-76.903092,39.303012],[-76.903651,39.302833],[-76.904135,39.302707],[-76.904585,39.302601],[-76.905055,39.302513],[-76.905564,39.302433],[-76.906166,39.302356],[-76.906679,39.302318],[-76.907148,39.3023],[-76.907615,39.302296],[-76.908117,39.302309],[-76.908481,39.302331],[-76.908929,39.302367],[-76.909405,39.302426],[-76.909934,39.302507],[-76.910231,39.302565],[-76.910738,39.30267],[-76.911188,39.30278],[-76.911535,39.302879],[-76.911899,39.302992],[-76.912283,39.303127],[-76.912674,39.303275],[-76.913044,39.30343],[-76.913414,39.303595],[-76.913754,39.303757],[-76.914114,39.303925],[-76.914549,39.304121],[-76.915035,39.304322],[-76.915521,39.304501],[-76.915964,39.304648],[-76.916519,39.304816],[-76.917037,39.304951],[-76.917636,39.305091],[-76.918012,39.305162],[-76.918585,39.305261],[-76.919135,39.305332],[-76.91976,39.305404],[-76.925167,39.306014],[-76.928754,39.306406],[-76.94521,39.308204],[-76.951656,39.308905],[-76.952049,39.308947],[-76.952875,39.309036],[-76.955425,39.309317],[-76.956035,39.309388],[-76.956653,39.309465],[-76.957237,39.30956],[-76.957723,39.309649],[-76.958264,39.309756],[-76.95871,39.309853],[-76.959357,39.310016],[-76.959668,39.310102],[-76.960094,39.310226],[-76.960475,39.31034],[-76.961068,39.310535],[-76.961623,39.310737],[-76.962141,39.310933],[-76.963745,39.311602],[-76.974343,39.316017],[-76.975426,39.316449],[-76.97606,39.316684],[-76.976611,39.316889],[-76.977187,39.317086],[-76.977797,39.317285],[-76.983577,39.319061],[-76.988666,39.320612],[-76.989251,39.320786],[-76.989752,39.320924],[-76.990173,39.321036],[-76.990625,39.321144],[-76.991089,39.321241],[-76.991522,39.32133],[-76.991952,39.32141],[-76.992423,39.321484],[-76.993001,39.321567],[-76.993538,39.321634],[-76.99405,39.321685],[-77.002873,39.322413],[-77.003236,39.322446],[-77.003605,39.322494],[-77.003903,39.322534],[-77.004221,39.322584],[-77.004682,39.322667],[-77.005109,39.322758],[-77.005495,39.32285],[-77.005924,39.322968],[-77.006337,39.323088],[-77.006797,39.323242],[-77.007211,39.323388],[-77.00938,39.324204],[-77.015856,39.326647],[-77.016765,39.326986],[-77.021135,39.32863],[-77.022535,39.32916],[-77.028348,39.331352],[-77.039656,39.335614],[-77.040089,39.335766],[-77.040659,39.335959],[-77.041192,39.336125],[-77.041729,39.336279],[-77.042298,39.336422],[-77.042812,39.336543],[-77.043336,39.336655],[-77.043909,39.336766],[-77.044492,39.33686],[-77.045043,39.336937],[-77.051388,39.337779],[-77.052072,39.337877],[-77.052729,39.337979],[-77.053313,39.338076],[-77.053987,39.338201],[-77.054589,39.338316],[-77.055138,39.338428],[-77.055697,39.33855],[-77.056464,39.338731],[-77.057245,39.338926],[-77.058465,39.339231],[-77.064603,39.340769],[-77.066813,39.341325],[-77.067449,39.34149],[-77.068108,39.341669],[-77.068699,39.341844],[-77.069272,39.342017],[-77.069886,39.34221],[-77.07612,39.344292],[-77.076996,39.34458],[-77.077894,39.344866],[-77.078709,39.345117],[-77.079252,39.345269],[-77.079811,39.345419],[-77.080375,39.345568],[-77.081076,39.34574],[-77.081768,39.345897],[-77.082468,39.34605],[-77.08317,39.34619],[-77.084157,39.346369],[-77.08493,39.346498],[-77.085549,39.346591],[-77.101112,39.348733],[-77.101912,39.348849],[-77.102542,39.348953],[-77.103206,39.349065],[-77.103768,39.34917],[-77.104352,39.349284],[-77.104949,39.349412],[-77.105577,39.34955],[-77.106239,39.34971],[-77.118537,39.352694],[-77.120463,39.353151],[-77.120867,39.353238],[-77.121276,39.353315],[-77.121842,39.353414],[-77.122361,39.353492],[-77.122821,39.353554],[-77.123389,39.353616],[-77.123963,39.353665],[-77.130694,39.354112],[-77.131145,39.354147],[-77.131645,39.354202],[-77.132065,39.354255],[-77.132512,39.354328],[-77.132919,39.354405],[-77.133394,39.354509],[-77.133796,39.354604],[-77.134203,39.354713],[-77.134592,39.354829],[-77.135036,39.354976],[-77.135469,39.355132],[-77.135881,39.355295],[-77.136231,39.355445],[-77.136651,39.355643],[-77.137047,39.355842],[-77.137478,39.356079],[-77.137924,39.356341],[-77.139108,39.357083],[-77.143274,39.359684],[-77.143833,39.360021],[-77.144245,39.360256],[-77.144595,39.36043],[-77.144956,39.360593],[-77.145451,39.360787],[-77.145878,39.360934],[-77.1463,39.361057],[-77.146766,39.361179],[-77.147273,39.361283],[-77.147782,39.361361],[-77.148255,39.36142],[-77.148641,39.361452],[-77.149095,39.36147],[-77.149509,39.361474],[-77.149922,39.361464],[-77.150364,39.361433],[-77.150834,39.361385],[-77.158073,39.360478],[-77.158846,39.36038],[-77.165075,39.359596],[-77.165851,39.359498],[-77.166825,39.359375],[-77.167557,39.359284],[-77.168224,39.359208],[-77.168518,39.359175],[-77.168949,39.359137],[-77.169339,39.359117],[-77.169816,39.359109],[-77.170303,39.35912],[-77.170715,39.359144],[-77.171131,39.359179],[-77.171524,39.359228],[-77.172012,39.359299],[-77.172618,39.359428],[-77.172989,39.35952],[-77.173397,39.359636],[-77.173783,39.359761],[-77.174182,39.359907],[-77.174554,39.360056],[-77.174938,39.360222],[-77.175334,39.360423],[-77.175678,39.360608],[-77.176024,39.360816],[-77.176372,39.361042],[-77.176706,39.361274],[-77.177379,39.361777],[-77.178196,39.362375],[-77.17868,39.362711],[-77.179136,39.362999],[-77.179656,39.363297],[-77.1802,39.363587],[-77.180669,39.363822],[-77.181192,39.364058],[-77.181696,39.364272],[-77.182302,39.3645],[-77.182806,39.364675],[-77.183361,39.364854],[-77.183995,39.365028],[-77.184728,39.365207],[-77.185538,39.365375],[-77.193899,39.366966],[-77.194794,39.367134],[-77.195948,39.367357],[-77.196431,39.367443],[-77.198087,39.367763],[-77.198551,39.36786],[-77.19898,39.367968],[-77.199372,39.36809],[-77.199714,39.368214],[-77.199982,39.368326],[-77.200306,39.36848],[-77.200586,39.368622],[-77.200892,39.368807],[-77.201934,39.369464],[-77.202284,39.369675],[-77.202579,39.36983],[-77.202942,39.370003],[-77.20341,39.370201],[-77.203849,39.370356],[-77.204316,39.370508],[-77.204765,39.37062],[-77.205195,39.370713],[-77.205639,39.370789],[-77.206101,39.370853],[-77.206623,39.370903],[-77.207123,39.370939],[-77.207593,39.370958],[-77.208032,39.370959],[-77.208423,39.370947],[-77.208848,39.370922],[-77.209237,39.370893],[-77.209648,39.37085],[-77.210107,39.370786],[-77.210492,39.370727],[-77.210837,39.370656],[-77.211234,39.370565],[-77.211747,39.370434],[-77.212165,39.370313],[-77.213504,39.369889],[-77.213887,39.369787],[-77.214163,39.369724],[-77.214516,39.369654],[-77.214899,39.369597],[-77.215268,39.369554],[-77.215612,39.369529],[-77.215966,39.369515],[-77.216369,39.369514],[-77.216747,39.369525],[-77.217153,39.369561],[-77.217509,39.369603],[-77.217911,39.369667],[-77.218311,39.369748],[-77.218697,39.369848],[-77.219067,39.369962],[-77.219406,39.370075],[-77.219747,39.370206],[-77.220128,39.370374],[-77.220455,39.37054],[-77.220708,39.370681],[-77.221108,39.370936],[-77.222725,39.372042],[-77.223219,39.372367],[-77.223749,39.372694],[-77.224347,39.37304],[-77.224908,39.37334],[-77.225578,39.373674],[-77.226188,39.373948],[-77.22689,39.37424],[-77.227531,39.374484],[-77.22819,39.374712],[-77.228786,39.374902],[-77.229437,39.375089],[-77.230075,39.375253],[-77.23065,39.375385],[-77.231419,39.375559],[-77.231933,39.375667],[-77.251482,39.380015],[-77.252968,39.380341],[-77.258854,39.381643],[-77.259391,39.381757],[-77.259811,39.381835],[-77.260508,39.381936],[-77.261048,39.381993],[-77.261615,39.382038],[-77.262118,39.38206],[-77.262689,39.382071],[-77.263325,39.382061],[-77.263849,39.382032],[-77.264372,39.381992],[-77.26496,39.381926],[-77.26547,39.381851],[-77.267598,39.381503],[-77.26951,39.381186],[-77.272108,39.380757],[-77.272586,39.380694],[-77.27299,39.380647],[-77.273388,39.380624],[-77.273745,39.380615],[-77.274161,39.380624],[-77.274485,39.380641],[-77.274861,39.380669],[-77.27525,39.380719],[-77.275617,39.380781],[-77.276091,39.380878],[-77.27649,39.38098],[-77.276789,39.381069],[-77.277169,39.381195],[-77.277535,39.381339],[-77.277913,39.381503],[-77.279503,39.382223],[-77.279941,39.382411],[-77.280447,39.382599],[-77.280951,39.382772],[-77.281576,39.382959],[-77.282063,39.383087],[-77.28263,39.383217],[-77.283098,39.38331],[-77.30862,39.388021],[-77.309472,39.388188],[-77.310196,39.388333],[-77.31095,39.388498],[-77.31174,39.388674],[-77.312547,39.388864],[-77.313388,39.389071],[-77.314223,39.389282],[-77.31486,39.389457],[-77.315441,39.389617],[-77.319957,39.390869],[-77.321499,39.391291],[-77.321973,39.39144],[-77.322376,39.391577],[-77.322804,39.391736],[-77.323172,39.391885],[-77.323632,39.39208],[-77.324098,39.392301],[-77.324694,39.392618],[-77.325209,39.392942],[-77.325616,39.393191],[-77.32586,39.39336],[-77.326315,39.393696],[-77.326742,39.394042],[-77.32705,39.394315],[-77.331422,39.398244],[-77.331908,39.398658],[-77.332311,39.398983],[-77.332738,39.399293],[-77.333147,39.399569],[-77.333597,39.399858],[-77.334044,39.400115],[-77.33446,39.400335],[-77.334893,39.400553],[-77.335507,39.400828],[-77.336007,39.401034],[-77.336462,39.401204],[-77.336947,39.40137],[-77.337481,39.401535],[-77.338126,39.40171],[-77.347325,39.404075],[-77.347627,39.40415],[-77.34952,39.404629],[-77.350062,39.404744],[-77.350596,39.404837],[-77.35103,39.404902],[-77.351547,39.40497],[-77.352015,39.405016],[-77.35253,39.405048],[-77.35311,39.405069],[-77.35364,39.405068],[-77.354142,39.405054],[-77.354631,39.405033],[-77.360135,39.404628],[-77.360897,39.404575],[-77.361602,39.404533],[-77.362539,39.404498],[-77.36472,39.404416],[-77.366773,39.404339],[-77.377885,39.403932],[-77.378865,39.403885],[-77.379342,39.403869],[-77.37978,39.403869],[-77.3803,39.403893],[-77.380732,39.403922],[-77.381292,39.403985],[-77.381832,39.404068],[-77.384455,39.404542],[-77.384962,39.404615],[-77.385453,39.404676],[-77.385864,39.404713],[-77.386265,39.404739],[-77.386677,39.404755],[-77.38814,39.404765],[-77.389014,39.40477],[-77.389395,39.404749],[-77.389933,39.404715],[-77.390478,39.40466],[-77.390951,39.404599],[-77.391498,39.404512],[-77.391934,39.404432],[-77.392587,39.404291],[-77.393274,39.404135],[-77.394161,39.403911],[-77.399007,39.402672],[-77.401468,39.402052],[-77.402133,39.401902],[-77.40343,39.40157],[-77.403967,39.401438],[-77.408441,39.400292],[-77.416164,39.398344],[-77.416532,39.398258],[-77.416956,39.398169],[-77.417345,39.398107],[-77.417851,39.398046],[-77.418299,39.398012],[-77.419047,39.398009],[-77.419559,39.398017],[-77.420245,39.398069],[-77.420729,39.398135],[-77.421186,39.398219],[-77.424832,39.398899],[-77.425198,39.398962],[-77.425546,39.399015],[-77.425972,39.399061],[-77.426391,39.399088],[-77.426799,39.399094],[-77.427286,39.399073],[-77.427693,39.399044],[-77.427978,39.399026],[-77.430848,39.398776],[-77.432934,39.398594],[-77.433731,39.398521],[-77.434298,39.398493],[-77.434912,39.39849],[-77.435336,39.398495],[-77.435957,39.398526],[-77.436452,39.398566],[-77.436942,39.398618],[-77.437352,39.398676],[-77.437785,39.398743],[-77.438271,39.398837],[-77.438781,39.398953],[-77.439294,39.399087],[-77.439758,39.39922],[-77.44019,39.399361],[-77.44081,39.399591],[-77.441419,39.399832],[-77.441856,39.400029],[-77.442111,39.400148],[-77.443964,39.400993],[-77.44456,39.401246],[-77.445038,39.401465],[-77.445433,39.401608],[-77.446202,39.40187],[-77.446847,39.402072],[-77.447644,39.402289],[-77.44834,39.402457],[-77.44884,39.402557],[-77.44954,39.402693],[-77.450203,39.402805],[-77.450798,39.402888],[-77.451401,39.402963],[-77.454877,39.403339],[-77.457107,39.403585],[-77.460403,39.403945],[-77.461077,39.404026],[-77.461652,39.40411],[-77.462269,39.404219],[-77.462774,39.404323],[-77.463332,39.404456],[-77.463951,39.404618],[-77.464512,39.404791],[-77.465088,39.404987],[-77.465585,39.405173],[-77.466114,39.405385],[-77.466593,39.405602],[-77.467096,39.405843],[-77.467533,39.406071],[-77.468007,39.406339],[-77.468471,39.406613],[-77.468919,39.406907],[-77.469389,39.407236],[-77.469768,39.407517],[-77.470201,39.407872],[-77.470655,39.408279],[-77.471035,39.40864],[-77.471374,39.408993],[-77.471716,39.409367],[-77.472045,39.409762],[-77.472405,39.410252],[-77.47278,39.410805],[-77.473792,39.412398],[-77.474122,39.4129],[-77.47448,39.413409],[-77.474988,39.41408],[-77.475485,39.414654],[-77.475926,39.415116],[-77.476389,39.415568],[-77.476859,39.416],[-77.477343,39.41641],[-77.477844,39.41681],[-77.478475,39.41727],[-77.479014,39.417643],[-77.479503,39.417955],[-77.480001,39.418252],[-77.480588,39.418591],[-77.481379,39.419054],[-77.482505,39.419714],[-77.482948,39.419988],[-77.483393,39.420284],[-77.483883,39.420639],[-77.484276,39.420942],[-77.48463,39.42123],[-77.484946,39.421505],[-77.485489,39.422011],[-77.48602,39.422551],[-77.48644,39.42304],[-77.486867,39.423571],[-77.487182,39.424016],[-77.487518,39.424514],[-77.487704,39.424829],[-77.487876,39.42514],[-77.488051,39.425489],[-77.488379,39.426272],[-77.488526,39.426746],[-77.488651,39.427191],[-77.488757,39.427731],[-77.488825,39.428253],[-77.48886,39.428716],[-77.488871,39.429134],[-77.488871,39.429526],[-77.488872,39.430094],[-77.488868,39.430682],[-77.488865,39.432719],[-77.488869,39.434231],[-77.488888,39.434754],[-77.488931,39.435222],[-77.488994,39.43566],[-77.489094,39.436137],[-77.489212,39.43658],[-77.489373,39.437061],[-77.489539,39.437479],[-77.489778,39.437969],[-77.489969,39.438298],[-77.490259,39.438721],[-77.490592,39.439117],[-77.490921,39.43946],[-77.491229,39.439735],[-77.4916,39.440032],[-77.491973,39.440299],[-77.492427,39.440575],[-77.492867,39.440811],[-77.4933,39.441021],[-77.493817,39.441262],[-77.497673,39.443018],[-77.499593,39.44389],[-77.500111,39.444149],[-77.500482,39.444349],[-77.500843,39.44457],[-77.501341,39.444937],[-77.501707,39.445254],[-77.502023,39.44558],[-77.50231,39.445935],[-77.50252,39.446241],[-77.502725,39.4466],[-77.502874,39.446915],[-77.503022,39.447332],[-77.503136,39.447733],[-77.503245,39.44817],[-77.504374,39.452666],[-77.504486,39.453081],[-77.504593,39.453428],[-77.50473,39.453766],[-77.504911,39.454143],[-77.505139,39.454535],[-77.505403,39.454911],[-77.505656,39.455226],[-77.505891,39.455486],[-77.506214,39.455801],[-77.506517,39.456073],[-77.509048,39.458222],[-77.509406,39.45853],[-77.511884,39.460629],[-77.51237,39.461031],[-77.51278,39.461355],[-77.513323,39.461772],[-77.513798,39.462122],[-77.514449,39.462589],[-77.519043,39.465761],[-77.531247,39.474183],[-77.532072,39.47477],[-77.532741,39.475273],[-77.533386,39.475784],[-77.534046,39.476332],[-77.534578,39.476793],[-77.535116,39.477278],[-77.538398,39.480254],[-77.53916,39.480943],[-77.54078,39.482413],[-77.541165,39.482742],[-77.541568,39.483053],[-77.541997,39.483354],[-77.542365,39.483585],[-77.542779,39.483816],[-77.543242,39.484074],[-77.54373,39.484292],[-77.544181,39.484475],[-77.544615,39.484625],[-77.545074,39.484768],[-77.545471,39.484881],[-77.545968,39.484996],[-77.546608,39.485104],[-77.547611,39.485261],[-77.550182,39.485655],[-77.552256,39.485973],[-77.552787,39.486063],[-77.553224,39.486149],[-77.553704,39.486264],[-77.554122,39.486382],[-77.554561,39.486521],[-77.55499,39.486681],[-77.555403,39.486853],[-77.555771,39.487024],[-77.556225,39.487258],[-77.556628,39.487495],[-77.557025,39.487747],[-77.557481,39.488081],[-77.559716,39.489871],[-77.560167,39.490232],[-77.562394,39.492022],[-77.563036,39.492539],[-77.564636,39.493822],[-77.565532,39.494544],[-77.566191,39.495062],[-77.566957,39.49565],[-77.567567,39.49609],[-77.568441,39.496696],[-77.570768,39.498262],[-77.571839,39.499002],[-77.574934,39.501074],[-77.580943,39.505115],[-77.581368,39.505395],[-77.581729,39.505613],[-77.582129,39.505832],[-77.582527,39.506031],[-77.582953,39.506221],[-77.583448,39.506414],[-77.583942,39.506581],[-77.584555,39.506763],[-77.585122,39.506898],[-77.589345,39.507911],[-77.589688,39.508002],[-77.590024,39.508109],[-77.590346,39.508236],[-77.590639,39.508374],[-77.590938,39.50853],[-77.591224,39.508707],[-77.591468,39.508885],[-77.591681,39.509051],[-77.59187,39.50923],[-77.592068,39.509434],[-77.592229,39.509628],[-77.592376,39.509833],[-77.592493,39.510011],[-77.592627,39.510243],[-77.593902,39.51267],[-77.594688,39.514175],[-77.595033,39.514816],[-77.595234,39.515169],[-77.595415,39.515478],[-77.595634,39.515821],[-77.595945,39.516289],[-77.596275,39.516743],[-77.596555,39.517099],[-77.596909,39.517528],[-77.600138,39.521192],[-77.600855,39.522018],[-77.601104,39.522338],[-77.601331,39.52265],[-77.60153,39.522984],[-77.601724,39.523335],[-77.601922,39.523751],[-77.602092,39.524175],[-77.602217,39.524573],[-77.602312,39.524956],[-77.60287,39.528408],[-77.602953,39.528827],[-77.603073,39.529265],[-77.603215,39.529676],[-77.603471,39.530251],[-77.603715,39.530691],[-77.604039,39.531193],[-77.604282,39.53152],[-77.605118,39.532607],[-77.605327,39.532881],[-77.605542,39.533202],[-77.605695,39.533482],[-77.605839,39.533795],[-77.605944,39.534058],[-77.606015,39.534266],[-77.60609,39.534538],[-77.606137,39.534785],[-77.606175,39.535087],[-77.606189,39.535394],[-77.606184,39.535706],[-77.606168,39.535938],[-77.605705,39.53888],[-77.605658,39.539292],[-77.605642,39.539625],[-77.605645,39.540045],[-77.60568,39.540463],[-77.605736,39.540827],[-77.605827,39.541263],[-77.605947,39.541682],[-77.606058,39.541994],[-77.606159,39.542248],[-77.606464,39.542879],[-77.607351,39.544599],[-77.60758,39.545075],[-77.607772,39.545546],[-77.607965,39.546063],[-77.608131,39.546563],[-77.608277,39.547075],[-77.608394,39.547562],[-77.608492,39.548056],[-77.608585,39.54866],[-77.608705,39.549567],[-77.608841,39.550587],[-77.6089,39.551044],[-77.608961,39.551477],[-77.609044,39.55198],[-77.609141,39.55245],[-77.609266,39.552866],[-77.609456,39.55337],[-77.609675,39.553837],[-77.609998,39.554393],[-77.616196,39.564213],[-77.616412,39.564543],[-77.617576,39.566382],[-77.618001,39.567014],[-77.618452,39.567649],[-77.618896,39.568238],[-77.61939,39.568864],[-77.619932,39.569512],[-77.620502,39.57016],[-77.621062,39.570768],[-77.621664,39.571393],[-77.623118,39.572882],[-77.624347,39.574133],[-77.625804,39.575619],[-77.62651,39.576338],[-77.628591,39.57847],[-77.628936,39.578814],[-77.629843,39.579748],[-77.630599,39.580509],[-77.631071,39.580966],[-77.631568,39.581405],[-77.632027,39.581789],[-77.632537,39.58218],[-77.633135,39.582608],[-77.633671,39.582963],[-77.634146,39.583268],[-77.634775,39.583629],[-77.635453,39.583994],[-77.635982,39.584255],[-77.636523,39.584508],[-77.639477,39.585861],[-77.639916,39.586059],[-77.640706,39.586421],[-77.641309,39.586698],[-77.642248,39.58713],[-77.642653,39.58733],[-77.64328,39.587646],[-77.643796,39.58792],[-77.644461,39.588273],[-77.644955,39.588552],[-77.645502,39.588875],[-77.646048,39.589204],[-77.655435,39.595066],[-77.655828,39.595311],[-77.659276,39.597453],[-77.659761,39.597731],[-77.66032,39.598037],[-77.660833,39.598295],[-77.661385,39.598553],[-77.661958,39.598809],[-77.662473,39.599018],[-77.663027,39.599232],[-77.663662,39.599455],[-77.664273,39.599646],[-77.664967,39.599847],[-77.665521,39.59999],[-77.666166,39.600143],[-77.666943,39.600302],[-77.667687,39.600433],[-77.668258,39.600515],[-77.668957,39.600599],[-77.669606,39.600663],[-77.67024,39.600708],[-77.670951,39.60074],[-77.671527,39.600752],[-77.672166,39.600749],[-77.672756,39.600734],[-77.673295,39.600711],[-77.676349,39.600533],[-77.682835,39.600158],[-77.683239,39.600131],[-77.689097,39.599789],[-77.696093,39.59938],[-77.696784,39.599351],[-77.697383,39.599339],[-77.697931,39.599343],[-77.698585,39.599363],[-77.699153,39.599387],[-77.699735,39.599436],[-77.700241,39.599481],[-77.700705,39.599535],[-77.701224,39.599606],[-77.701709,39.599679],[-77.702201,39.599766],[-77.70283,39.59989],[-77.703116,39.599956],[-77.70357,39.60006],[-77.703978,39.600163],[-77.704466,39.600295],[-77.704904,39.600425],[-77.705368,39.600569],[-77.705845,39.600732],[-77.706794,39.601064],[-77.711718,39.602807],[-77.712473,39.60307],[-77.71431,39.603711],[-77.714847,39.603894],[-77.7154,39.604067],[-77.715938,39.604226],[-77.716467,39.60438],[-77.717128,39.604553],[-77.717751,39.604703],[-77.718391,39.604843],[-77.718914,39.604954],[-77.719477,39.60506],[-77.719999,39.60515],[-77.720562,39.605242],[-77.721152,39.605326],[-77.721808,39.605407],[-77.722391,39.605477],[-77.722952,39.605526],[-77.723619,39.605576],[-77.72428,39.605615],[-77.724955,39.605644],[-77.725625,39.605663],[-77.726043,39.605664],[-77.726807,39.605656],[-77.728765,39.605597],[-77.729419,39.605574],[-77.733159,39.605457],[-77.735097,39.605383],[-77.736039,39.605358],[-77.736869,39.605353],[-77.737624,39.605362],[-77.738394,39.605379],[-77.739078,39.605403],[-77.739861,39.605447],[-77.740624,39.605498],[-77.741304,39.605553],[-77.742047,39.605619],[-77.742767,39.605698],[-77.744312,39.605877],[-77.744719,39.605923],[-77.746206,39.606094],[-77.750204,39.606542],[-77.75076,39.606597],[-77.751448,39.60665],[-77.75206,39.606675],[-77.752839,39.606698],[-77.753854,39.606689],[-77.754475,39.606676],[-77.755482,39.606655],[-77.769497,39.606375],[-77.770228,39.60637],[-77.770819,39.606386],[-77.771476,39.60643],[-77.772079,39.606491],[-77.772694,39.606574],[-77.773176,39.606657],[-77.773696,39.606762],[-77.77436,39.606919],[-77.774819,39.607051],[-77.775394,39.607232],[-77.775867,39.607403],[-77.776357,39.607595],[-77.77685,39.607808],[-77.77734,39.608047],[-77.777815,39.608295],[-77.778478,39.608691],[-77.778796,39.608893],[-77.779173,39.609153],[-77.779538,39.609425],[-77.779929,39.609745],[-77.78033,39.610104],[-77.780695,39.610461],[-77.781044,39.610837],[-77.781305,39.611137],[-77.782003,39.612093],[-77.782297,39.612512],[-77.782544,39.612864],[-77.785237,39.616675],[-77.785702,39.61733],[-77.786757,39.618823],[-77.787111,39.619297],[-77.787521,39.619784],[-77.787751,39.620039],[-77.788033,39.620324],[-77.788328,39.620614],[-77.788745,39.620971],[-77.789286,39.621406],[-77.789805,39.621782],[-77.790056,39.621941],[-77.790391,39.622149],[-77.790826,39.6224],[-77.79115,39.622572],[-77.791445,39.622728],[-77.791906,39.622941],[-77.792488,39.623185],[-77.80548,39.628529],[-77.807122,39.629204],[-77.807862,39.629516],[-77.80859,39.629829],[-77.809228,39.630136],[-77.809817,39.630433],[-77.810281,39.630667],[-77.81076,39.630934],[-77.811299,39.631253],[-77.811848,39.631594],[-77.812363,39.631925],[-77.812836,39.632257],[-77.813318,39.632605],[-77.813999,39.633133],[-77.814493,39.633528],[-77.815246,39.634122],[-77.815844,39.634566],[-77.816499,39.635015],[-77.817142,39.635412],[-77.817782,39.635776],[-77.818286,39.636051],[-77.81887,39.636341],[-77.819507,39.636631],[-77.82007,39.636872],[-77.820733,39.637136],[-77.822806,39.637947],[-77.823333,39.638165],[-77.82392,39.638423],[-77.824442,39.638675],[-77.824918,39.638913],[-77.825441,39.6392],[-77.825945,39.639489],[-77.826432,39.639793],[-77.827121,39.64025],[-77.828823,39.641458],[-77.829762,39.642134],[-77.830645,39.642751],[-77.831,39.643007],[-77.83139,39.643285],[-77.831715,39.643516],[-77.832245,39.643899],[-77.832714,39.644217],[-77.833277,39.6446],[-77.833674,39.644847],[-77.834237,39.645171],[-77.834828,39.645493],[-77.835531,39.645842],[-77.836029,39.646075],[-77.836587,39.646316],[-77.837413,39.64664],[-77.83827,39.646957],[-77.83912,39.647263],[-77.839842,39.647523],[-77.840637,39.647809],[-77.841819,39.648236],[-77.842508,39.648486],[-77.84494,39.649366],[-77.845703,39.649639],[-77.84635,39.649869],[-77.847042,39.650091],[-77.847841,39.65032],[-77.848516,39.650487],[-77.849239,39.650649],[-77.84998,39.650791],[-77.850606,39.65089],[-77.851294,39.650986],[-77.852076,39.651068],[-77.852899,39.651134],[-77.85362,39.651165],[-77.854292,39.651181],[-77.863236,39.651336],[-77.864235,39.651349],[-77.86517,39.651351],[-77.865893,39.651355],[-77.873809,39.651223],[-77.874674,39.651213],[-77.87559,39.651222],[-77.876301,39.651241],[-77.877051,39.65127],[-77.878188,39.651331],[-77.887718,39.651912],[-77.888127,39.651934],[-77.907845,39.653134],[-77.9082,39.653156],[-77.911811,39.653372],[-77.912655,39.653416],[-77.913298,39.653437],[-77.914004,39.653444],[-77.914523,39.653433],[-77.915094,39.653413],[-77.915645,39.653379],[-77.916351,39.653324],[-77.917047,39.653247],[-77.917665,39.653166],[-77.918569,39.653011],[-77.919269,39.652877],[-77.920031,39.6527],[-77.920575,39.652564],[-77.921238,39.652372],[-77.921814,39.652191],[-77.922512,39.651968],[-77.923053,39.651791],[-77.923804,39.651553],[-77.928355,39.650089],[-77.929445,39.649743],[-77.937953,39.647011],[-77.938739,39.646754],[-77.939337,39.646543],[-77.93999,39.646295],[-77.940631,39.646025],[-77.941361,39.645694],[-77.941947,39.645399],[-77.942576,39.645056],[-77.943183,39.644708],[-77.943753,39.644346],[-77.949593,39.640529],[-77.950218,39.640134],[-77.950974,39.63968],[-77.951728,39.639249],[-77.952347,39.638909],[-77.960187,39.63476],[-77.961004,39.634328],[-77.96166,39.633948],[-77.962208,39.633613],[-77.962819,39.63322],[-77.963444,39.632788],[-77.964133,39.632285],[-77.966363,39.630604],[-77.966889,39.630238],[-77.967335,39.629964],[-77.967806,39.629712],[-77.968259,39.629491],[-77.968626,39.62934],[-77.969092,39.629163],[-77.969575,39.629016],[-77.97016,39.628861],[-77.97061,39.628762],[-77.971062,39.628678],[-77.971575,39.628607],[-77.972072,39.628555],[-77.972693,39.628512],[-77.984426,39.627848],[-77.985137,39.627808],[-77.985841,39.627755],[-77.986544,39.627687],[-77.987253,39.627597],[-77.98795,39.62749],[-77.988625,39.627361],[-77.989321,39.627215],[-77.990001,39.627049],[-77.990923,39.626806],[-77.995917,39.625474],[-77.996728,39.625262],[-78.000622,39.624228],[-78.0013,39.624071],[-78.0019,39.623961],[-78.002429,39.623873],[-78.002969,39.623802],[-78.003518,39.623758],[-78.004059,39.623725],[-78.004621,39.62371],[-78.00526,39.623713],[-78.005818,39.623732],[-78.006398,39.623774],[-78.006891,39.623828],[-78.007345,39.623889],[-78.007841,39.62397],[-78.008309,39.624057],[-78.008774,39.624157],[-78.009219,39.624267],[-78.00974,39.624412],[-78.010221,39.624567],[-78.010628,39.624708],[-78.011069,39.624877],[-78.011536,39.625074],[-78.012005,39.625285],[-78.012496,39.625547],[-78.012957,39.625792],[-78.013409,39.626065],[-78.013721,39.626265],[-78.014226,39.626616],[-78.020176,39.631007],[-78.020725,39.631425],[-78.021189,39.6318],[-78.021578,39.632143],[-78.021973,39.632501],[-78.022373,39.632888],[-78.026543,39.637435],[-78.026939,39.637835],[-78.027323,39.638205],[-78.027764,39.638595],[-78.028246,39.639],[-78.028747,39.639387],[-78.029327,39.63981],[-78.029791,39.640125],[-78.03024,39.640405],[-78.037502,39.644655],[-78.038037,39.644972],[-78.038464,39.645238],[-78.03895,39.645559],[-78.039518,39.645964],[-78.040023,39.646345],[-78.040404,39.646659],[-78.04582,39.651529],[-78.046685,39.652316],[-78.048559,39.654003],[-78.048978,39.654352],[-78.04932,39.654613],[-78.049943,39.655039],[-78.050437,39.655323],[-78.050873,39.655553],[-78.05139,39.65581],[-78.054842,39.657563],[-78.055565,39.657949],[-78.056149,39.658286],[-78.056736,39.658642],[-78.05726,39.658969],[-78.057745,39.65929],[-78.058258,39.65965],[-78.059389,39.660509],[-78.068355,39.667452],[-78.068877,39.667822],[-78.069317,39.668111],[-78.069749,39.668374],[-78.070214,39.668644],[-78.07078,39.668943],[-78.073972,39.670623],[-78.074451,39.670855],[-78.074916,39.671072],[-78.075356,39.671256],[-78.07588,39.671454],[-78.076453,39.671648],[-78.076906,39.671785],[-78.079322,39.672467],[-78.079888,39.672631],[-78.080364,39.67278],[-78.080763,39.672919],[-78.081168,39.673068],[-78.081588,39.673237],[-78.081989,39.673415],[-78.08243,39.673629],[-78.0828,39.673826],[-78.083255,39.674077],[-78.090718,39.678335],[-78.091365,39.678709],[-78.091931,39.679045],[-78.092706,39.679524],[-78.09373,39.680184],[-78.097972,39.683006],[-78.098454,39.683299],[-78.098836,39.683524],[-78.0993,39.683775],[-78.099857,39.684054],[-78.10046,39.684335],[-78.100999,39.68457],[-78.101609,39.684806],[-78.102374,39.685078],[-78.102741,39.685196],[-78.103183,39.685324],[-78.103698,39.685464],[-78.104286,39.685606],[-78.104898,39.68574],[-78.105481,39.685851],[-78.122574,39.68868],[-78.123506,39.688837],[-78.124033,39.688934],[-78.12449,39.689041],[-78.125057,39.689187],[-78.125489,39.689308],[-78.125999,39.689474],[-78.126526,39.689655],[-78.12831,39.690294],[-78.128778,39.69046],[-78.130776,39.69117],[-78.13134,39.691359],[-78.131947,39.691531],[-78.132471,39.69166],[-78.133026,39.691778],[-78.133602,39.691882],[-78.13472,39.692054],[-78.138384,39.692602],[-78.139461,39.69278],[-78.140251,39.692924],[-78.140835,39.69304],[-78.141411,39.693166],[-78.142041,39.693322],[-78.142677,39.693494],[-78.143244,39.693654],[-78.144129,39.693926],[-78.144584,39.694082],[-78.145459,39.694392],[-78.150579,39.696279],[-78.150921,39.696416],[-78.151299,39.69658],[-78.151682,39.696774],[-78.151945,39.696931],[-78.152303,39.697165],[-78.152543,39.697349],[-78.152876,39.697652],[-78.153192,39.697958],[-78.153371,39.698144],[-78.154364,39.699264],[-78.154739,39.699688],[-78.155026,39.699993],[-78.155314,39.700275],[-78.155667,39.700575],[-78.156103,39.700879],[-78.156491,39.701117],[-78.15689,39.701324],[-78.157344,39.701528],[-78.157782,39.701687],[-78.158277,39.701842],[-78.158706,39.701946],[-78.159206,39.702038],[-78.159659,39.702108],[-78.160167,39.702183],[-78.167461,39.703222],[-78.168085,39.703319],[-78.168795,39.703437],[-78.169401,39.703549],[-78.170046,39.703672],[-78.17054,39.703779],[-78.171046,39.703903],[-78.171543,39.704027],[-78.172114,39.704184],[-78.17509,39.705005],[-78.178608,39.705972],[-78.17906,39.706113],[-78.17955,39.706277],[-78.179992,39.706446],[-78.180357,39.706598],[-78.18128,39.707032],[-78.181738,39.707282],[-78.182175,39.707533],[-78.182647,39.707837],[-78.183061,39.708126],[-78.183462,39.708431],[-78.183825,39.708728],[-78.184187,39.709051],[-78.184495,39.709344],[-78.18477,39.709634],[-78.185339,39.710278],[-78.185475,39.710462],[-78.18571,39.71078],[-78.185943,39.711141],[-78.186232,39.711611],[-78.186472,39.71207],[-78.186762,39.712734],[-78.186913,39.713161],[-78.187032,39.713535],[-78.187126,39.713933],[-78.187208,39.714321],[-78.187264,39.714726],[-78.187305,39.715041],[-78.187332,39.715398],[-78.187328,39.71606],[-78.187305,39.716418],[-78.187228,39.717069],[-78.18718,39.717311],[-78.187121,39.717581],[-78.187041,39.717894],[-78.186951,39.718202],[-78.186814,39.718606],[-78.186661,39.719001],[-78.186424,39.719511],[-78.186173,39.719985],[-78.185906,39.720415],[-78.184672,39.722309],[-78.18413,39.723121],[-78.183752,39.723704],[-78.183543,39.72406],[-78.183341,39.724454],[-78.183152,39.724851],[-78.182981,39.725323],[-78.182854,39.725724],[-78.182768,39.726073],[-78.182702,39.726402],[-78.182638,39.726845],[-78.182535,39.727788],[-78.182103,39.731698],[-78.181937,39.733192],[-78.181407,39.737988],[-78.181274,39.739205],[-78.181214,39.739976],[-78.181179,39.740641],[-78.181162,39.7411],[-78.181159,39.741821],[-78.181203,39.743033],[-78.181363,39.746101],[-78.181389,39.746599],[-78.181429,39.747089],[-78.181505,39.747608],[-78.181585,39.748044],[-78.181704,39.748535],[-78.18183,39.748981],[-78.181972,39.74939],[-78.182149,39.749849],[-78.182337,39.750278],[-78.182539,39.750689],[-78.182759,39.751089],[-78.182989,39.751484],[-78.183242,39.751873],[-78.183521,39.75226],[-78.183845,39.752686],[-78.184198,39.753103],[-78.184607,39.75354],[-78.184951,39.75389],[-78.185325,39.754242],[-78.185696,39.754564],[-78.186431,39.755136],[-78.188886,39.756922],[-78.189984,39.757722],[-78.191639,39.758919],[-78.192657,39.759661],[-78.192803,39.759804],[-78.193047,39.75994],[-78.193853,39.760521],[-78.194046,39.760693],[-78.194253,39.760843],[-78.19467,39.761103],[-78.196498,39.762434],[-78.196703,39.762586],[-78.198345,39.763805],[-78.198507,39.763975],[-78.198804,39.764234],[-78.199107,39.764553],[-78.199596,39.765179],[-78.199945,39.765768],[-78.200184,39.766409],[-78.200346,39.767002],[-78.200454,39.767689],[-78.200456,39.768016],[-78.200421,39.768513],[-78.199826,39.773071],[-78.199857,39.774628],[-78.199951,39.774976],[-78.200067,39.775299],[-78.200074,39.775316],[-78.200232,39.775658],[-78.200416,39.775988],[-78.200628,39.776356],[-78.200855,39.776637],[-78.200871,39.77666],[-78.201062,39.776944],[-78.20335,39.78011],[-78.20361,39.780453],[-78.204224,39.7811],[-78.204806,39.781491],[-78.207266,39.782688],[-78.207442,39.782795],[-78.208059,39.783065],[-78.208523,39.783353],[-78.20885,39.783593],[-78.209162,39.783855],[-78.20945,39.78414],[-78.20971,39.784449],[-78.209937,39.78478],[-78.21013,39.785126],[-78.210294,39.785476],[-78.210622,39.786649],[-78.210665,39.78682],[-78.211007,39.788117],[-78.211249,39.78901],[-78.211604,39.790316],[-78.211884,39.790963],[-78.212111,39.791361],[-78.212241,39.791553],[-78.212679,39.792092],[-78.212998,39.792412],[-78.213166,39.79256],[-78.213516,39.792839],[-78.213889,39.793096],[-78.214496,39.793444],[-78.215158,39.793744],[-78.215859,39.793982],[-78.216339,39.794107],[-78.216582,39.794158],[-78.217075,39.794241],[-78.217829,39.794332],[-78.222658,39.794848],[-78.224254,39.795019],[-78.225739,39.795194],[-78.226525,39.795269],[-78.22672,39.795288],[-78.228007,39.795485],[-78.230612,39.796036],[-78.231268,39.796175],[-78.240388,39.798143],[-78.24151,39.798369],[-78.241531,39.798372],[-78.24245,39.798528],[-78.243463,39.798661],[-78.243924,39.798715],[-78.244354,39.798749],[-78.244629,39.798776],[-78.245657,39.798877],[-78.246008,39.798913],[-78.246968,39.799009],[-78.247813,39.799111],[-78.24791,39.799128],[-78.248627,39.799255],[-78.249167,39.799374],[-78.249617,39.799485],[-78.251926,39.800051],[-78.25289,39.800318],[-78.253394,39.800497],[-78.254288,39.80081],[-78.254897,39.801023],[-78.255354,39.801157],[-78.255581,39.801201],[-78.256049,39.80133],[-78.257485,39.801795],[-78.26478,39.804393],[-78.265018,39.804464],[-78.266701,39.805074],[-78.267631,39.805411],[-78.268242,39.805618],[-78.269295,39.806012],[-78.269472,39.806063],[-78.269517,39.806076],[-78.269876,39.806256],[-78.270357,39.806538],[-78.270733,39.806801],[-78.271099,39.807092],[-78.271436,39.807404],[-78.271874,39.807912],[-78.272124,39.808275],[-78.272337,39.808654],[-78.272506,39.809049],[-78.272575,39.809252],[-78.272681,39.809663],[-78.272743,39.810081],[-78.272759,39.810505],[-78.272727,39.810931],[-78.272652,39.811356],[-78.272525,39.81178],[-78.272044,39.813048],[-78.271826,39.813692],[-78.271593,39.814562],[-78.271448,39.815263],[-78.271336,39.816061],[-78.271274,39.816889],[-78.271263,39.817534],[-78.271305,39.818407],[-78.271348,39.818841],[-78.271445,39.819488],[-78.271526,39.819917],[-78.271677,39.82056],[-78.272039,39.821869],[-78.272744,39.824414],[-78.27338,39.82671],[-78.274606,39.831169],[-78.275584,39.834693],[-78.275733,39.83536],[-78.275853,39.836063],[-78.275952,39.836986],[-78.275987,39.838142],[-78.275958,39.838928],[-78.275855,39.839918],[-78.27576,39.84051],[-78.275637,39.841098],[-78.275603,39.841214],[-78.275104,39.842884],[-78.274906,39.843411],[-78.274665,39.843964],[-78.274003,39.845288],[-78.273463,39.846453],[-78.273353,39.846634],[-78.272287,39.848843],[-78.271705,39.849954],[-78.27107,39.851045],[-78.269805,39.853051],[-78.269488,39.853614],[-78.267972,39.856112],[-78.265146,39.860689],[-78.264421,39.861768],[-78.264119,39.862147],[-78.264028,39.862314],[-78.262967,39.863574],[-78.262491,39.864093],[-78.261837,39.864774],[-78.260501,39.866112],[-78.259807,39.866759],[-78.259243,39.867217],[-78.258439,39.867791],[-78.257795,39.868185],[-78.256885,39.86867],[-78.256671,39.868804],[-78.256426,39.868915],[-78.255524,39.869381],[-78.254108,39.870194],[-78.254003,39.870304],[-78.252868,39.871301],[-78.252643,39.871515],[-78.252391,39.87185],[-78.248873,39.876036],[-78.247583,39.877597],[-78.247329,39.877932],[-78.246467,39.878867],[-78.245863,39.879486],[-78.244379,39.881092],[-78.243998,39.881707],[-78.243786,39.882202],[-78.243642,39.882759],[-78.243589,39.883213],[-78.243591,39.883257],[-78.243606,39.883685],[-78.243669,39.8841],[-78.24371,39.884267],[-78.243772,39.88447],[-78.243861,39.88475],[-78.243969,39.884982],[-78.244149,39.885464],[-78.244369,39.8861],[-78.244382,39.886164],[-78.244408,39.886292],[-78.244446,39.886683],[-78.244434,39.886952],[-78.244429,39.887076],[-78.244402,39.887271],[-78.244312,39.887657],[-78.244177,39.888035],[-78.243874,39.888788],[-78.239714,39.898945],[-78.239402,39.899839],[-78.239156,39.90062],[-78.238967,39.901309],[-78.238918,39.901541],[-78.238856,39.901706],[-78.238431,39.903595],[-78.238195,39.904644],[-78.237888,39.906012],[-78.237827,39.906204],[-78.237795,39.906422],[-78.237684,39.906914],[-78.237621,39.907196],[-78.237466,39.90788],[-78.23704,39.909785],[-78.237007,39.91001],[-78.236843,39.910643],[-78.23558,39.916231],[-78.235068,39.918516],[-78.233358,39.926139],[-78.233284,39.92647],[-78.233268,39.926595],[-78.233149,39.927054],[-78.233052,39.927424],[-78.232619,39.928791],[-78.232604,39.928891],[-78.232335,39.929608],[-78.232152,39.93011],[-78.232095,39.930233],[-78.231996,39.930444],[-78.231696,39.931046],[-78.230469,39.933599],[-78.229371,39.935891],[-78.228392,39.937931],[-78.227999,39.938767],[-78.227441,39.939934],[-78.22733,39.940175],[-78.227248,39.940386],[-78.22718,39.940577],[-78.227127,39.940762],[-78.227081,39.94094],[-78.227033,39.941189],[-78.226989,39.941486],[-78.226972,39.941773],[-78.226971,39.941841],[-78.226972,39.942004],[-78.226981,39.942221],[-78.227007,39.942475],[-78.227044,39.9427],[-78.227086,39.942912],[-78.227144,39.943134],[-78.227208,39.943344],[-78.227316,39.94363],[-78.227489,39.944049],[-78.228199,39.945716],[-78.228488,39.946389],[-78.228572,39.946566],[-78.228671,39.94676],[-78.228791,39.946962],[-78.228935,39.947189],[-78.229066,39.947364],[-78.229167,39.947494],[-78.229279,39.94763],[-78.229412,39.947773],[-78.229599,39.947961],[-78.229751,39.948105],[-78.229949,39.948274],[-78.230204,39.948471],[-78.230376,39.948598],[-78.230514,39.94869],[-78.230795,39.948859],[-78.231143,39.949052],[-78.231344,39.949161],[-78.231563,39.949266],[-78.231823,39.949379],[-78.232125,39.949491],[-78.233116,39.949848],[-78.234517,39.950357],[-78.234803,39.950465],[-78.235078,39.950574],[-78.235375,39.950713],[-78.235618,39.950842],[-78.235984,39.95105],[-78.238634,39.952597],[-78.238987,39.952799],[-78.24128,39.954141],[-78.243686,39.95554],[-78.244155,39.955821],[-78.244528,39.956078],[-78.244721,39.956229],[-78.244831,39.956314],[-78.245072,39.956521],[-78.245289,39.956732],[-78.245523,39.956998],[-78.245712,39.957227],[-78.245899,39.957502],[-78.246056,39.957765],[-78.246183,39.958013],[-78.246321,39.958328],[-78.246458,39.958727],[-78.246565,39.959209],[-78.246634,39.959718],[-78.246922,39.961688],[-78.247024,39.962339],[-78.247066,39.962604],[-78.247075,39.962727],[-78.247154,39.963482],[-78.247156,39.963628],[-78.247167,39.96415],[-78.247102,39.964748],[-78.247085,39.964783],[-78.24699,39.965363],[-78.24678,39.966567],[-78.246359,39.968859],[-78.246307,39.969141],[-78.245885,39.971528],[-78.245769,39.972151],[-78.245737,39.972324],[-78.245531,39.973646],[-78.245485,39.973802],[-78.245305,39.974749],[-78.245175,39.975536],[-78.245025,39.976321],[-78.244904,39.977016],[-78.24489,39.977137],[-78.244686,39.978199],[-78.244675,39.978236],[-78.244611,39.978635],[-78.244587,39.978789],[-78.244562,39.978877],[-78.244145,39.981008],[-78.244057,39.981591],[-78.243977,39.982122],[-78.243812,39.982889],[-78.243651,39.98346],[-78.243356,39.98443],[-78.242809,39.986209],[-78.241797,39.98949],[-78.241609,39.990195],[-78.241537,39.990464],[-78.241395,39.990902],[-78.241277,39.991222],[-78.241176,39.991484],[-78.240929,39.992269],[-78.240633,39.993237],[-78.240323,39.994229],[-78.240144,39.994843],[-78.239995,39.995267],[-78.238892,39.998821],[-78.23881,39.998965],[-78.238756,39.999047],[-78.238702,39.999119],[-78.23862,39.9992],[-78.238557,39.99925],[-78.238469,39.999294],[-78.238327,39.999346],[-78.238176,39.999385],[-78.237889,39.999428],[-78.237746,39.999422],[-78.237271,39.999405],[-78.237179,39.999402],[-78.236923,39.999392],[-78.236093,39.999363],[-78.235909,39.999359],[-78.235388,39.999352],[-78.235054,39.999348],[-78.234726,39.999352],[-78.234385,39.999362],[-78.234187,39.999279],[-78.234113,39.999262],[-78.234021,39.999232],[-78.233944,39.999192],[-78.233863,39.999127],[-78.233806,39.99905],[-78.233769,39.998977],[-78.23374,39.998877],[-78.233725,39.998802],[-78.23371,39.998699],[-78.233688,39.998],[-78.233655,39.997019],[-78.233653,39.996645],[-78.233688,39.996314],[-78.233741,39.996058],[-78.233836,39.995761],[-78.233888,39.995633],[-78.233943,39.995531],[-78.234258,39.995016],[-78.23474,39.994458],[-78.235394,39.993762],[-78.236175,39.992919],[-78.236719,39.992403],[-78.237442,39.991877],[-78.237793,39.991672],[-78.2382,39.991467],[-78.238626,39.991284],[-78.238957,39.99117],[-78.239193,39.991087],[-78.239398,39.991026],[-78.239664,39.990956],[-78.240124,39.990861],[-78.240811,39.990762],[-78.241272,39.990724],[-78.241678,39.99071],[-78.246498,39.990545],[-78.247886,39.990499],[-78.248969,39.990441],[-78.249299,39.990423],[-78.249693,39.990382],[-78.250313,39.990305],[-78.250374,39.990306],[-78.250744,39.990284],[-78.251114,39.990245],[-78.251306,39.990214],[-78.251491,39.990177],[-78.251914,39.990062],[-78.252291,39.98996],[-78.252393,39.989932],[-78.252499,39.989903],[-78.252577,39.989882],[-78.252796,39.989822],[-78.253268,39.989684],[-78.253569,39.989589],[-78.253866,39.989472],[-78.254185,39.989347],[-78.254831,39.989072],[-78.255251,39.988883],[-78.255906,39.988598],[-78.256267,39.98842],[-78.25645,39.98833],[-78.256945,39.988081],[-78.257417,39.987839],[-78.258025,39.987554],[-78.25861,39.987346],[-78.259315,39.987178],[-78.259921,39.98707],[-78.260407,39.986976],[-78.261116,39.986811],[-78.261311,39.986781],[-78.261872,39.986667],[-78.262314,39.986559],[-78.263,39.9864],[-78.263379,39.986305],[-78.26385,39.986186],[-78.264139,39.9861],[-78.264933,39.985878],[-78.265966,39.985567],[-78.266901,39.985316],[-78.26848,39.984857],[-78.26969,39.984507],[-78.27068,39.984225],[-78.271399,39.984016],[-78.272209,39.98379],[-78.273051,39.983542],[-78.273664,39.983372],[-78.274124,39.98326],[-78.27483,39.983095],[-78.27574,39.982949],[-78.276736,39.982844],[-78.277556,39.982788],[-78.278316,39.982778],[-78.279923,39.982794],[-78.2815,39.982812],[-78.283061,39.982823],[-78.284244,39.982857],[-78.284695,39.982878],[-78.284992,39.982899],[-78.285368,39.982933],[-78.286237,39.983084],[-78.286956,39.983249],[-78.287254,39.983328],[-78.287753,39.983484],[-78.288248,39.983657],[-78.289474,39.984157],[-78.290203,39.984461],[-78.291506,39.98499],[-78.292336,39.985278],[-78.293511,39.985578],[-78.294618,39.985746],[-78.296229,39.985863],[-78.299925,39.986096],[-78.301039,39.986208],[-78.301925,39.986379],[-78.302735,39.986616],[-78.303752,39.987024],[-78.305149,39.98765],[-78.305662,39.987907],[-78.307446,39.988726],[-78.308387,39.98916],[-78.308682,39.989292],[-78.308926,39.989398],[-78.309536,39.989668],[-78.309798,39.989769],[-78.310177,39.9899],[-78.310521,39.990009],[-78.310863,39.99009],[-78.311223,39.990168],[-78.311573,39.990222],[-78.311995,39.990275],[-78.312425,39.990307],[-78.313583,39.990322],[-78.314213,39.990325],[-78.315671,39.990331],[-78.316166,39.990331],[-78.316548,39.990338],[-78.317183,39.99034],[-78.317614,39.990354],[-78.317945,39.990375],[-78.318297,39.990415],[-78.318501,39.990444],[-78.318637,39.990468],[-78.318979,39.990538],[-78.319188,39.990589],[-78.319367,39.990639],[-78.319686,39.990742],[-78.319904,39.990821],[-78.320293,39.990987],[-78.320559,39.991118],[-78.321096,39.991401],[-78.321732,39.991743],[-78.322209,39.991992],[-78.32281,39.992325],[-78.324474,39.993209],[-78.325562,39.993807],[-78.326167,39.994123],[-78.32674,39.994433],[-78.327078,39.994621],[-78.327335,39.994754],[-78.327473,39.994828],[-78.327763,39.994985],[-78.328056,39.99513],[-78.32838,39.995284],[-78.328549,39.995356],[-78.328962,39.99552],[-78.329487,39.9957],[-78.329612,39.99573],[-78.329842,39.995792],[-78.330175,39.995872],[-78.330501,39.99594],[-78.331438,39.99611],[-78.333026,39.996391],[-78.333508,39.996472],[-78.333737,39.99652],[-78.334206,39.99663],[-78.334581,39.99673],[-78.334753,39.996783],[-78.334914,39.99684],[-78.33526,39.996978],[-78.335631,39.997143],[-78.335844,39.997255],[-78.33625,39.997484],[-78.336368,39.99756],[-78.337002,39.997968],[-78.337253,39.998127],[-78.337445,39.998254],[-78.337651,39.998378],[-78.337987,39.998568],[-78.338262,39.99871],[-78.338417,39.99878],[-78.3387,39.998899],[-78.338871,39.998961],[-78.338988,39.999011],[-78.339306,39.999116],[-78.339511,39.999175],[-78.339773,39.999242],[-78.340682,39.999453],[-78.341308,39.999594],[-78.341849,39.999729],[-78.342257,39.999815],[-78.342937,39.999968],[-78.343331,40.000045],[-78.345743,40.000593],[-78.347016,40.000875],[-78.347363,40.000945],[-78.347696,40.001004],[-78.348096,40.00106],[-78.348515,40.001102],[-78.34898,40.001128],[-78.349461,40.001136],[-78.349749,40.001129],[-78.350239,40.001098],[-78.350272,40.001096],[-78.35075,40.001055],[-78.351565,40.000965],[-78.352899,40.000824],[-78.356338,40.000463],[-78.357188,40.000391],[-78.357616,40.000372],[-78.358023,40.000368],[-78.358295,40.000374],[-78.358608,40.000386],[-78.35901,40.000412],[-78.359439,40.000453],[-78.359859,40.000507],[-78.360375,40.000598],[-78.360869,40.0007],[-78.3609,40.000707],[-78.361108,40.000757],[-78.361764,40.000927],[-78.363938,40.001503],[-78.364434,40.001634],[-78.364737,40.001709],[-78.365405,40.001865],[-78.365826,40.001943],[-78.366096,40.001993],[-78.366382,40.002036],[-78.36679,40.00209],[-78.367236,40.00214],[-78.369613,40.002353],[-78.37141,40.002514],[-78.373045,40.002661],[-78.374283,40.002772],[-78.376185,40.002943],[-78.37638,40.002962],[-78.376936,40.003023],[-78.37723,40.003065],[-78.377644,40.003137],[-78.377728,40.003154],[-78.377761,40.003161],[-78.378043,40.003218],[-78.378811,40.003407],[-78.378982,40.003453],[-78.379367,40.003569],[-78.379676,40.003669],[-78.38003,40.003797],[-78.380299,40.003901],[-78.380344,40.00392],[-78.380643,40.004045],[-78.380876,40.004148],[-78.381169,40.004285],[-78.381508,40.00446],[-78.381855,40.004651],[-78.382179,40.004847],[-78.382446,40.00503],[-78.382556,40.005099],[-78.384713,40.006472],[-78.385037,40.006685],[-78.385363,40.006891],[-78.386162,40.007408],[-78.388861,40.00915],[-78.389,40.00924],[-78.389431,40.009489],[-78.389867,40.009718],[-78.390073,40.009817],[-78.390283,40.009907],[-78.39085,40.010129],[-78.391282,40.01027],[-78.391613,40.010363],[-78.392071,40.010473],[-78.392625,40.010573],[-78.393153,40.010639],[-78.393658,40.010674],[-78.395074,40.010751],[-78.395469,40.01077],[-78.395935,40.010806],[-78.396286,40.010845],[-78.396543,40.010882],[-78.396931,40.010954],[-78.397376,40.011047],[-78.397818,40.011163],[-78.399598,40.011735],[-78.401163,40.012252],[-78.401716,40.012417],[-78.401938,40.012479],[-78.402005,40.012497],[-78.402282,40.012555],[-78.402632,40.012618],[-78.403076,40.012678],[-78.403451,40.012719],[-78.403709,40.012729],[-78.404154,40.01273],[-78.404443,40.01272],[-78.404464,40.012719],[-78.404755,40.012701],[-78.405092,40.012662],[-78.405454,40.012613],[-78.405802,40.012551],[-78.40621,40.012453],[-78.40655,40.012358],[-78.406899,40.012248],[-78.407217,40.012129],[-78.407484,40.012014],[-78.40785,40.011828],[-78.408368,40.011537],[-78.408726,40.01129],[-78.409091,40.011022],[-78.409399,40.010736],[-78.409733,40.010384],[-78.409969,40.010092],[-78.410225,40.00972],[-78.410442,40.00934],[-78.410509,40.009222],[-78.410935,40.008388],[-78.411292,40.007705],[-78.411589,40.007306],[-78.411791,40.007007],[-78.412003,40.006692],[-78.412127,40.00657],[-78.41238,40.006303],[-78.412574,40.006121],[-78.412838,40.00589],[-78.413144,40.005651],[-78.413223,40.005598],[-78.413432,40.00546],[-78.413776,40.005246],[-78.41409,40.005063],[-78.414482,40.004865],[-78.414914,40.004658],[-78.415357,40.004482],[-78.415741,40.004366],[-78.416193,40.004235],[-78.416569,40.004151],[-78.417178,40.004038],[-78.418865,40.003823],[-78.419142,40.003787],[-78.420554,40.003617],[-78.421568,40.003491],[-78.422844,40.003326],[-78.422869,40.003326],[-78.423086,40.003298],[-78.423199,40.003286],[-78.426239,40.002915],[-78.427155,40.002815],[-78.427679,40.002781],[-78.427963,40.00277],[-78.428517,40.00278],[-78.428831,40.002805],[-78.429237,40.002849],[-78.429721,40.002922],[-78.430156,40.003013],[-78.430594,40.003121],[-78.431015,40.003254],[-78.431407,40.003399],[-78.431794,40.003558],[-78.432059,40.003691],[-78.432398,40.003874],[-78.43266,40.00403],[-78.432892,40.004174],[-78.433332,40.004485],[-78.43376,40.004806],[-78.43389,40.004901],[-78.435423,40.00603],[-78.436168,40.006581],[-78.436293,40.006677],[-78.436886,40.007114],[-78.437437,40.007513],[-78.438176,40.008064],[-78.438716,40.008467],[-78.439057,40.008712],[-78.439684,40.009185],[-78.440106,40.009493],[-78.440422,40.009733],[-78.440818,40.010021],[-78.441155,40.010256],[-78.441397,40.010417],[-78.441647,40.010564],[-78.442003,40.010761],[-78.442269,40.010888],[-78.442626,40.011041],[-78.44291,40.01115],[-78.443444,40.011321],[-78.443737,40.011391],[-78.44417,40.011482],[-78.444476,40.011532],[-78.44496,40.011589],[-78.445488,40.011622],[-78.445813,40.011629],[-78.446866,40.011628],[-78.447151,40.011626],[-78.447457,40.011623],[-78.451773,40.011606],[-78.452386,40.011608],[-78.454917,40.011597],[-78.455666,40.011597],[-78.45627,40.011591],[-78.458651,40.011585],[-78.459491,40.011581],[-78.461045,40.011573],[-78.46149,40.011575],[-78.462533,40.011568],[-78.462861,40.011575],[-78.463408,40.011599],[-78.463694,40.011622],[-78.46414,40.011676],[-78.464408,40.011711],[-78.464471,40.011722],[-78.464871,40.011792],[-78.465379,40.011901],[-78.465443,40.011918],[-78.466013,40.012069],[-78.466127,40.012099],[-78.46642,40.012191],[-78.466864,40.012345],[-78.467245,40.012498],[-78.467632,40.012668],[-78.467927,40.012812],[-78.468667,40.013205],[-78.469639,40.013846],[-78.470158,40.014289],[-78.470272,40.014395],[-78.470501,40.014617],[-78.471632,40.015908],[-78.471661,40.015934],[-78.472481,40.016843],[-78.473406,40.017724],[-78.473435,40.017743],[-78.474144,40.018313],[-78.474742,40.0188],[-78.474793,40.018841],[-78.4751,40.019092],[-78.475802,40.019647],[-78.476412,40.020157],[-78.478517,40.021821],[-78.481386,40.024129],[-78.481487,40.024215],[-78.482398,40.024948],[-78.483361,40.025703],[-78.483496,40.025818],[-78.484027,40.026238],[-78.484594,40.026656],[-78.485556,40.027295],[-78.4856,40.027315],[-78.486374,40.027777],[-78.487301,40.028275],[-78.487365,40.028305],[-78.487693,40.028459],[-78.488315,40.028752],[-78.490494,40.029656],[-78.491228,40.02996],[-78.491353,40.030004],[-78.492001,40.030283],[-78.493105,40.030748],[-78.493407,40.030889],[-78.493856,40.031121],[-78.494376,40.031425],[-78.494572,40.031557],[-78.494995,40.031854],[-78.495429,40.03225],[-78.495766,40.032507],[-78.496045,40.032769],[-78.497623,40.034513],[-78.497821,40.034726],[-78.498066,40.03497],[-78.498494,40.03538],[-78.49899,40.035826],[-78.499541,40.036304],[-78.500156,40.036849],[-78.501063,40.03764],[-78.501326,40.037873],[-78.50198,40.038451],[-78.502356,40.038785],[-78.502626,40.039024],[-78.503018,40.039386],[-78.503314,40.039666],[-78.503461,40.039821],[-78.503755,40.040161],[-78.503927,40.040368],[-78.504166,40.040688],[-78.504663,40.041376],[-78.505076,40.041971],[-78.505295,40.042342],[-78.505407,40.042568],[-78.505576,40.042991],[-78.505901,40.044039],[-78.506025,40.044399],[-78.50614,40.044699],[-78.506475,40.045329],[-78.506718,40.045719],[-78.506983,40.046094],[-78.507264,40.046439],[-78.507656,40.04687],[-78.508314,40.047518],[-78.508812,40.047992],[-78.509382,40.048497],[-78.509779,40.048789],[-78.510363,40.049141],[-78.51095,40.049432],[-78.511316,40.049588],[-78.51145,40.049638],[-78.511632,40.049705],[-78.511995,40.049821],[-78.512371,40.049928],[-78.513062,40.050074],[-78.51332,40.050116],[-78.51354,40.050142],[-78.513786,40.050177],[-78.513997,40.050189],[-78.514694,40.050216],[-78.515415,40.050194],[-78.515808,40.050169],[-78.516422,40.050125],[-78.517024,40.050082],[-78.517507,40.050048],[-78.517807,40.050037],[-78.51796,40.050026],[-78.518104,40.050016],[-78.518526,40.049987],[-78.520615,40.049838],[-78.520929,40.049818],[-78.521563,40.049778],[-78.521855,40.049767],[-78.522304,40.049756],[-78.522643,40.049755],[-78.522979,40.049763],[-78.52335,40.049777],[-78.524627,40.049894],[-78.525369,40.049955],[-78.52551,40.049967],[-78.526906,40.050095],[-78.529844,40.050363],[-78.5305,40.050416],[-78.531878,40.050543],[-78.533006,40.05064],[-78.533444,40.050667],[-78.534242,40.0507],[-78.534971,40.050711],[-78.535671,40.050701],[-78.536216,40.050681],[-78.53669,40.050655],[-78.537109,40.050625],[-78.537668,40.050574],[-78.538771,40.050431],[-78.538921,40.050411],[-78.540193,40.050214],[-78.540364,40.050186],[-78.541039,40.050076],[-78.544189,40.049581],[-78.545474,40.049371],[-78.545857,40.049315],[-78.546287,40.049242],[-78.546722,40.049177],[-78.549351,40.04876],[-78.550624,40.048559],[-78.551009,40.048497],[-78.551992,40.048339],[-78.553269,40.048131],[-78.5533,40.048126],[-78.553539,40.048079],[-78.554204,40.047928],[-78.554639,40.047808],[-78.555023,40.047694],[-78.555507,40.047529],[-78.556014,40.047335],[-78.556417,40.047162],[-78.556895,40.046937],[-78.55725,40.046756],[-78.557601,40.046565],[-78.557939,40.046355],[-78.558355,40.046083],[-78.558676,40.045852],[-78.558879,40.045699],[-78.559164,40.045465],[-78.559541,40.045134],[-78.560261,40.044437],[-78.560692,40.044039],[-78.562445,40.04233],[-78.562767,40.042017],[-78.563196,40.041602],[-78.564035,40.040781],[-78.565243,40.0396],[-78.565548,40.039289],[-78.56677,40.03811],[-78.567695,40.037211],[-78.569103,40.035828],[-78.569483,40.03545],[-78.569804,40.03514],[-78.5705,40.034454],[-78.571312,40.033669],[-78.571701,40.033306],[-78.5721,40.032921],[-78.572273,40.032751],[-78.573365,40.031678],[-78.574462,40.030591],[-78.574916,40.03017],[-78.576179,40.028917],[-78.577038,40.028082],[-78.578251,40.026896],[-78.579355,40.025833],[-78.580336,40.024866],[-78.58119,40.024036],[-78.582332,40.022927],[-78.58295,40.022333],[-78.583288,40.021985],[-78.584182,40.021119],[-78.58506,40.02026],[-78.585548,40.01978],[-78.586251,40.019093],[-78.586545,40.01883],[-78.586847,40.018565],[-78.587197,40.018266],[-78.587495,40.018044],[-78.587685,40.017903],[-78.587884,40.017761],[-78.588208,40.017556],[-78.588462,40.017396],[-78.588739,40.017226],[-78.589205,40.016966],[-78.589808,40.01663],[-78.591026,40.015931],[-78.594247,40.014089],[-78.594459,40.013976],[-78.594659,40.013852],[-78.596998,40.012541],[-78.597201,40.012426],[-78.597506,40.01226],[-78.597574,40.012214],[-78.599751,40.010991],[-78.601908,40.00977],[-78.602362,40.009525],[-78.60287,40.009286],[-78.603065,40.00921],[-78.603239,40.00915],[-78.603435,40.00909],[-78.603627,40.009039],[-78.60382,40.008995],[-78.604026,40.008955],[-78.604237,40.008925],[-78.604437,40.008901],[-78.604642,40.008884],[-78.604917,40.008876],[-78.605129,40.008878],[-78.605321,40.008885],[-78.605522,40.008901],[-78.605742,40.008924],[-78.605921,40.00895],[-78.606138,40.008991],[-78.606372,40.009044],[-78.606559,40.009093],[-78.606784,40.009161],[-78.607179,40.009316],[-78.607484,40.00946],[-78.607801,40.009635],[-78.607938,40.009724],[-78.608075,40.009823],[-78.608229,40.009941],[-78.608453,40.010134],[-78.608583,40.010265],[-78.608838,40.010552],[-78.609045,40.010857],[-78.609146,40.011047],[-78.609284,40.011356],[-78.609342,40.011523],[-78.609392,40.011705],[-78.609428,40.011878],[-78.609452,40.012023],[-78.609482,40.012374],[-78.609527,40.013344],[-78.609584,40.013844],[-78.609618,40.014057],[-78.609719,40.014463],[-78.609822,40.014785],[-78.609903,40.01499],[-78.61006,40.015338],[-78.610249,40.015696],[-78.610466,40.016038],[-78.610591,40.016215],[-78.6107,40.016358],[-78.610975,40.016687],[-78.611109,40.016835],[-78.611406,40.017129],[-78.61157,40.017279],[-78.611748,40.017428],[-78.611945,40.017585],[-78.612123,40.017712],[-78.612463,40.017945],[-78.612846,40.018175],[-78.613172,40.018356],[-78.61321,40.018377],[-78.613425,40.018481],[-78.613834,40.018668],[-78.614025,40.018746],[-78.614276,40.018838],[-78.614521,40.018921],[-78.614946,40.019048],[-78.615165,40.019107],[-78.61557,40.019201],[-78.616074,40.019301],[-78.616349,40.019341],[-78.616685,40.01938],[-78.616983,40.019404],[-78.617273,40.019421],[-78.617565,40.01943],[-78.617898,40.019431],[-78.6182,40.019425],[-78.618511,40.019404],[-78.618847,40.019376],[-78.619114,40.019345],[-78.619386,40.019306],[-78.619669,40.019257],[-78.620213,40.019149],[-78.620679,40.019029],[-78.622244,40.018604],[-78.622942,40.018445],[-78.623907,40.018198],[-78.624814,40.017966],[-78.625646,40.017743],[-78.626358,40.017564],[-78.630378,40.016529],[-78.630806,40.016415],[-78.631051,40.016349],[-78.631549,40.016224],[-78.635542,40.015188],[-78.636581,40.014928],[-78.638017,40.014553],[-78.639323,40.014212],[-78.640205,40.013994],[-78.640668,40.013867],[-78.6415,40.013658],[-78.642835,40.013306],[-78.643416,40.013157],[-78.644733,40.012819],[-78.645943,40.012507],[-78.645996,40.01249],[-78.648165,40.011935],[-78.649033,40.011707],[-78.649613,40.011588],[-78.650195,40.011461],[-78.650625,40.011382],[-78.651051,40.011317],[-78.651454,40.011261],[-78.652126,40.01118],[-78.652519,40.011132],[-78.652839,40.01111],[-78.653229,40.011079],[-78.653673,40.011055],[-78.654358,40.011022],[-78.655141,40.010991],[-78.656392,40.010929],[-78.657804,40.010863],[-78.661431,40.010702],[-78.66302,40.010634],[-78.665059,40.010535],[-78.666423,40.010479],[-78.667499,40.010428],[-78.668906,40.010356],[-78.67203,40.010219],[-78.672909,40.010182],[-78.673585,40.010153],[-78.674077,40.010121],[-78.6745,40.01008],[-78.674821,40.01005],[-78.675205,40.009998],[-78.675742,40.009937],[-78.676428,40.009836],[-78.676885,40.009756],[-78.677236,40.009689],[-78.677772,40.009584],[-78.678172,40.009492],[-78.678793,40.009345],[-78.67939,40.009191],[-78.679866,40.009056],[-78.680279,40.008933],[-78.680705,40.008783],[-78.680832,40.008743],[-78.681379,40.008556],[-78.681717,40.008435],[-78.682358,40.008186],[-78.683017,40.007899],[-78.683507,40.007678],[-78.683889,40.007486],[-78.684342,40.007272],[-78.684786,40.00704],[-78.685104,40.006869],[-78.685433,40.006677],[-78.685793,40.006455],[-78.686217,40.006203],[-78.686521,40.006],[-78.686983,40.005693],[-78.687204,40.005544],[-78.687471,40.005356],[-78.687673,40.0052],[-78.688038,40.004914],[-78.688476,40.004562],[-78.688711,40.004358],[-78.689029,40.004091],[-78.689795,40.003317],[-78.690946,40.002206],[-78.691049,40.002122],[-78.691719,40.001452],[-78.692289,40.000891],[-78.693693,39.999499],[-78.694823,39.998376],[-78.69545,39.997737],[-78.696077,39.997114],[-78.697475,39.995737],[-78.698227,39.994966],[-78.698255,39.994947],[-78.698973,39.994236],[-78.699615,39.993576],[-78.700154,39.99306],[-78.700357,39.992865],[-78.701087,39.992128],[-78.701148,39.992062],[-78.701839,39.991389],[-78.701935,39.991285],[-78.702486,39.990743],[-78.703285,39.989941],[-78.703878,39.989357],[-78.704301,39.988927],[-78.704868,39.988373],[-78.705721,39.987538],[-78.706104,39.987204],[-78.706632,39.986799],[-78.707045,39.986528],[-78.707574,39.986213],[-78.708279,39.985853],[-78.708634,39.985706],[-78.708939,39.985573],[-78.70925,39.985461],[-78.709523,39.985363],[-78.709719,39.985296],[-78.709994,39.985223],[-78.710369,39.985123],[-78.710661,39.98505],[-78.710909,39.985002],[-78.711354,39.984918],[-78.712277,39.98473],[-78.712859,39.984615],[-78.713414,39.984514],[-78.714243,39.984359],[-78.714747,39.984261],[-78.715959,39.984027],[-78.716194,39.983981],[-78.716799,39.983862],[-78.717367,39.98375],[-78.71763,39.983698],[-78.71852,39.983527],[-78.718997,39.983435],[-78.719208,39.983395],[-78.719479,39.983343],[-78.720955,39.983058],[-78.726482,39.981981],[-78.728272,39.981635],[-78.729927,39.981323],[-78.734013,39.980532],[-78.735456,39.980264],[-78.737626,39.979829],[-78.738733,39.979631],[-78.740469,39.979281],[-78.741188,39.979141],[-78.742183,39.978955],[-78.743086,39.978782],[-78.743773,39.978645],[-78.744918,39.978429],[-78.746071,39.978198],[-78.74754,39.977921],[-78.74825,39.977804],[-78.749556,39.977555],[-78.750658,39.977351],[-78.751544,39.977236],[-78.751569,39.977229],[-78.752384,39.977184],[-78.752948,39.977174],[-78.753824,39.977214],[-78.754719,39.977282],[-78.754757,39.977291],[-78.755984,39.977399],[-78.757905,39.97756],[-78.757926,39.977568],[-78.758046,39.977578],[-78.759407,39.977688],[-78.759629,39.977715],[-78.760054,39.977749],[-78.760561,39.977781],[-78.760783,39.977801],[-78.761306,39.977858],[-78.761915,39.977937],[-78.762782,39.978134],[-78.763529,39.978377],[-78.76419,39.978634],[-78.76491,39.978976],[-78.768464,39.980923],[-78.769442,39.981442],[-78.771072,39.982319],[-78.77241,39.983032],[-78.773342,39.98354],[-78.774641,39.984243],[-78.77614,39.985052],[-78.778284,39.986209],[-78.778747,39.986454],[-78.779253,39.986697],[-78.779543,39.98684],[-78.779887,39.986965],[-78.780211,39.987055],[-78.78048,39.987114],[-78.780792,39.987182],[-78.781212,39.987243],[-78.781502,39.98726],[-78.781821,39.987267],[-78.78226,39.98727],[-78.782446,39.98725],[-78.782826,39.987203],[-78.78315,39.987154],[-78.783654,39.987043],[-78.783951,39.986948],[-78.784314,39.986812],[-78.784619,39.986683],[-78.784867,39.986545],[-78.785213,39.986343],[-78.785616,39.986057],[-78.786097,39.985656],[-78.78658,39.985219],[-78.787269,39.98465],[-78.787678,39.984363],[-78.78903,39.983623],[-78.789271,39.983466],[-78.789468,39.983339],[-78.789688,39.983163],[-78.789957,39.982938],[-78.790515,39.98241],[-78.790775,39.982135],[-78.791263,39.981661],[-78.79173,39.981279],[-78.792169,39.980909],[-78.792621,39.980591],[-78.792821,39.980466],[-78.793567,39.980035],[-78.794073,39.979757],[-78.795446,39.978995],[-78.795919,39.978721],[-78.796425,39.978418],[-78.797156,39.97794],[-78.797734,39.977552],[-78.798148,39.977266],[-78.79858,39.976935],[-78.798935,39.976674],[-78.799529,39.976177],[-78.799919,39.975837],[-78.800558,39.975339],[-78.801155,39.974859],[-78.801981,39.974176],[-78.802231,39.973928],[-78.802417,39.973708],[-78.802637,39.973436],[-78.803145,39.97261],[-78.8033,39.972356],[-78.803502,39.972049],[-78.803719,39.971687],[-78.804505,39.970436],[-78.805184,39.969321],[-78.805438,39.968848],[-78.806134,39.967756],[-78.806652,39.96693],[-78.806854,39.966657],[-78.806986,39.966509],[-78.807288,39.966198],[-78.807645,39.965913],[-78.808026,39.965672],[-78.808487,39.965381],[-78.808704,39.965247],[-78.808782,39.965199],[-78.809095,39.965005],[-78.809399,39.964784],[-78.809699,39.964528],[-78.809957,39.964282],[-78.810123,39.964051],[-78.810321,39.963774],[-78.81049,39.963501],[-78.810594,39.963293],[-78.810875,39.962671],[-78.811387,39.961579],[-78.811843,39.960579],[-78.812198,39.959853],[-78.812506,39.959236],[-78.812606,39.959027],[-78.813238,39.957739],[-78.813429,39.957369],[-78.813648,39.957049],[-78.813871,39.956773],[-78.814191,39.956415],[-78.814564,39.956118],[-78.814858,39.955907],[-78.81517,39.955696],[-78.81576,39.955398],[-78.816439,39.95515],[-78.81679,39.95504],[-78.817092,39.954983],[-78.817403,39.954924],[-78.817705,39.954881],[-78.818012,39.95485],[-78.818301,39.954829],[-78.818572,39.954833],[-78.81889,39.954826],[-78.819265,39.954851],[-78.819505,39.954875],[-78.819706,39.954904],[-78.820066,39.954972],[-78.820349,39.955029],[-78.820587,39.955103],[-78.821082,39.95527],[-78.821397,39.955384],[-78.821715,39.955534],[-78.821968,39.955671],[-78.822191,39.955796],[-78.822418,39.955945],[-78.822655,39.95613],[-78.822885,39.956332],[-78.823185,39.956606],[-78.823808,39.957251],[-78.824999,39.958465],[-78.82557,39.959061],[-78.825881,39.959357],[-78.826046,39.959509],[-78.8264,39.959863],[-78.826589,39.960014],[-78.826927,39.960326],[-78.827273,39.960602],[-78.827993,39.961214],[-78.828107,39.961305],[-78.8286,39.961698],[-78.829134,39.962129],[-78.829499,39.962421],[-78.829823,39.962685],[-78.83004,39.962841],[-78.830418,39.9631],[-78.830734,39.963286],[-78.831158,39.96348],[-78.831396,39.963577],[-78.831689,39.963694],[-78.832441,39.963946],[-78.832815,39.964052],[-78.833225,39.96415],[-78.833541,39.964203],[-78.833926,39.964256],[-78.834278,39.964292],[-78.834534,39.96429],[-78.834815,39.964283],[-78.835175,39.964268],[-78.83554,39.964222],[-78.835866,39.964177],[-78.836145,39.964111],[-78.836372,39.964058],[-78.836616,39.963973],[-78.836832,39.963907],[-78.837068,39.963809],[-78.837385,39.963672],[-78.837654,39.963527],[-78.837922,39.963352],[-78.838371,39.963047],[-78.838983,39.962549],[-78.839567,39.962052],[-78.839962,39.961719],[-78.840247,39.961494],[-78.840789,39.961032],[-78.842399,39.959695],[-78.84337,39.958896],[-78.84379,39.958533],[-78.844063,39.958304],[-78.844309,39.958137],[-78.844507,39.958009],[-78.844692,39.9579],[-78.845006,39.957773],[-78.845256,39.957683],[-78.845416,39.957633],[-78.8456,39.957582],[-78.845819,39.957529],[-78.846023,39.957489],[-78.846281,39.957452],[-78.846508,39.957432],[-78.846731,39.957422],[-78.846933,39.95742],[-78.847135,39.957429],[-78.847356,39.957447],[-78.847524,39.957466],[-78.847623,39.957484],[-78.847858,39.957531],[-78.84806,39.957581],[-78.848225,39.957627],[-78.848402,39.957683],[-78.848555,39.957742],[-78.867036,39.965912],[-78.867258,39.96601],[-78.867653,39.966185],[-78.868385,39.966509],[-78.869757,39.967152],[-78.870446,39.967466],[-78.87128,39.967833],[-78.871935,39.968127],[-78.87247,39.968358],[-78.872725,39.968465],[-78.873018,39.968581],[-78.873386,39.968714],[-78.87369,39.96882],[-78.874054,39.968934],[-78.874445,39.969038],[-78.874822,39.969131],[-78.875172,39.969206],[-78.875615,39.969294],[-78.87602,39.969358],[-78.876504,39.969427],[-78.876747,39.969463],[-78.877498,39.96957],[-78.881054,39.97007],[-78.885894,39.970754],[-78.887836,39.971031],[-78.89143,39.971534],[-78.893393,39.971815],[-78.89667,39.972276],[-78.900144,39.97277],[-78.904129,39.97333],[-78.912924,39.974577],[-78.91326,39.974625],[-78.917662,39.975243],[-78.923219,39.976027],[-78.928776,39.976814],[-78.930196,39.977011],[-78.930391,39.977038],[-78.934072,39.977628],[-78.936361,39.978127],[-78.938568,39.978729],[-78.940799,39.979412],[-78.946849,39.981497],[-78.94904,39.98227],[-78.949304,39.982363],[-78.954188,39.98405],[-78.956482,39.984842],[-78.958113,39.985355],[-78.958403,39.98544],[-78.959014,39.985618],[-78.961477,39.986237],[-78.964088,39.986741],[-78.969279,39.987743],[-78.973338,39.988497],[-78.975648,39.988926],[-78.977939,39.989367],[-78.979785,39.989722],[-78.98381,39.990498],[-78.988083,39.991193],[-78.98819,39.99121],[-78.992064,39.991525],[-78.993948,39.991679],[-78.994581,39.991731],[-78.995709,39.991829],[-78.999251,39.992143],[-79.000024,39.992208],[-79.00283,39.992477],[-79.004391,39.992566],[-79.007336,39.992734],[-79.014908,39.993169],[-79.015165,39.993184],[-79.016807,39.993282],[-79.018227,39.99336],[-79.020764,39.993513],[-79.021677,39.993555],[-79.02446,39.993713],[-79.024667,39.993739],[-79.025781,39.993878],[-79.026906,39.994075],[-79.036519,39.997067],[-79.03775,39.997475],[-79.039622,39.998087],[-79.040276,39.998302],[-79.042561,39.999072],[-79.042776,39.999125],[-79.0433,39.99927],[-79.044902,39.999821],[-79.045656,40.000066],[-79.04659,40.000364],[-79.047343,40.000638],[-79.04786,40.000867],[-79.048343,40.001117],[-79.048874,40.001437],[-79.049112,40.001609],[-79.049455,40.001856],[-79.0498,40.002142],[-79.050292,40.002518],[-79.05169,40.003982],[-79.052464,40.004554],[-79.053029,40.005024],[-79.053886,40.00545],[-79.054684,40.005733],[-79.055604,40.006006],[-79.059237,40.006793],[-79.060183,40.007011],[-79.065174,40.008076],[-79.066438,40.008471],[-79.067156,40.008761],[-79.067665,40.009015],[-79.0687,40.009733],[-79.068885,40.009861],[-79.06951,40.010456],[-79.07111,40.012202],[-79.072085,40.013207],[-79.073467,40.014626],[-79.073629,40.014788],[-79.073937,40.015101],[-79.074911,40.016106],[-79.075452,40.016678],[-79.076044,40.017289],[-79.076349,40.017611],[-79.0767,40.017971],[-79.076902,40.018163],[-79.077045,40.018284],[-79.077207,40.018426],[-79.077602,40.018721],[-79.077934,40.018963],[-79.078231,40.019148],[-79.078588,40.019347],[-79.078875,40.019494],[-79.079244,40.019669],[-79.079652,40.019834],[-79.080978,40.020343],[-79.081438,40.020516],[-79.08161,40.020582],[-79.083097,40.021186],[-79.084294,40.021657],[-79.085366,40.022077],[-79.085863,40.02229],[-79.086243,40.022474],[-79.08681,40.022783],[-79.087249,40.023046],[-79.087674,40.023325],[-79.08799,40.023559],[-79.088223,40.023751],[-79.088523,40.02401],[-79.088847,40.024334],[-79.08909,40.024594],[-79.089237,40.024771],[-79.089863,40.025558],[-79.090248,40.026079],[-79.09061,40.026619],[-79.090851,40.026915],[-79.091248,40.027456],[-79.091519,40.027806],[-79.092118,40.028629],[-79.093111,40.029875],[-79.09333,40.030212],[-79.093605,40.030593],[-79.093957,40.031099],[-79.09442,40.031651],[-79.094892,40.032111],[-79.095788,40.032957],[-79.096068,40.033216],[-79.096673,40.033776],[-79.097446,40.034486],[-79.098811,40.035613],[-79.099836,40.036501],[-79.101149,40.03771],[-79.103527,40.039721],[-79.104119,40.04022],[-79.105081,40.040806],[-79.106242,40.041149],[-79.107707,40.041403],[-79.109089,40.041383],[-79.11186,40.041204],[-79.112945,40.041234],[-79.114081,40.041472],[-79.114891,40.041767],[-79.115578,40.042126],[-79.116513,40.042573],[-79.118805,40.043798],[-79.119579,40.044346],[-79.120354,40.045009],[-79.120633,40.045267],[-79.121487,40.046313],[-79.122286,40.047506],[-79.122923,40.048354],[-79.123601,40.049239],[-79.123845,40.049551],[-79.124284,40.050109],[-79.124736,40.050753],[-79.125053,40.051186],[-79.125414,40.051712],[-79.125723,40.052027],[-79.126581,40.052704],[-79.127869,40.053585],[-79.1321,40.05637],[-79.132993,40.056988],[-79.134065,40.057539],[-79.135379,40.057953],[-79.136803,40.058282],[-79.138157,40.058761],[-79.13908,40.059402],[-79.139619,40.059872],[-79.140031,40.060515],[-79.140254,40.060995],[-79.140331,40.061225],[-79.140503,40.061691],[-79.140626,40.062034],[-79.141042,40.062743],[-79.141473,40.063452],[-79.142314,40.064319],[-79.143318,40.065002],[-79.144082,40.065337],[-79.144829,40.065593],[-79.146811,40.066112],[-79.148335,40.066451],[-79.149346,40.066709],[-79.153743,40.067812],[-79.155506,40.068345],[-79.156519,40.068917],[-79.157515,40.06963],[-79.159774,40.072014],[-79.161385,40.073646],[-79.162767,40.074677],[-79.163917,40.075354],[-79.165394,40.075886],[-79.167478,40.076317],[-79.169235,40.076454],[-79.171052,40.076386],[-79.175191,40.076272],[-79.176277,40.076326],[-79.17765,40.076457],[-79.178886,40.076713],[-79.179736,40.076903],[-79.180938,40.077311],[-79.181862,40.077669],[-79.183169,40.078348],[-79.184242,40.079051],[-79.186723,40.08089],[-79.188199,40.082072],[-79.189485,40.082771],[-79.190885,40.08332],[-79.194695,40.084729],[-79.19624,40.085326],[-79.1972,40.085881],[-79.197909,40.086415],[-79.198397,40.086808],[-79.199819,40.087979],[-79.200149,40.088329],[-79.200358,40.088535],[-79.201043,40.089358],[-79.20155,40.090113],[-79.20169,40.090474],[-79.201913,40.090921],[-79.202056,40.09128],[-79.202151,40.091572],[-79.202354,40.092767],[-79.202235,40.094529],[-79.202027,40.095695],[-79.201887,40.097434],[-79.201801,40.098419],[-79.201844,40.099312],[-79.20193,40.099824],[-79.202394,40.100894],[-79.202582,40.101223],[-79.202849,40.10163],[-79.203055,40.101899],[-79.203286,40.102161],[-79.203982,40.102765],[-79.204557,40.10312],[-79.205518,40.103645],[-79.206187,40.103908],[-79.209809,40.104899],[-79.216979,40.106928],[-79.219447,40.107632],[-79.220014,40.107767],[-79.220875,40.107908],[-79.221352,40.107968],[-79.221743,40.108007],[-79.222015,40.10803],[-79.222332,40.10805],[-79.223139,40.108057],[-79.224607,40.107984],[-79.225525,40.107833],[-79.22707,40.107394],[-79.229542,40.106402],[-79.231203,40.10569],[-79.232198,40.105316],[-79.232836,40.105114],[-79.234087,40.104954],[-79.2357,40.104817],[-79.237408,40.105099],[-79.238456,40.10544],[-79.239099,40.105755],[-79.241434,40.107324],[-79.242318,40.107922],[-79.244876,40.10955],[-79.246403,40.110705],[-79.247339,40.111453],[-79.248172,40.11207],[-79.249116,40.112576],[-79.249754,40.112815],[-79.25109,40.113239],[-79.253849,40.113594],[-79.254981,40.113892],[-79.256798,40.114512],[-79.258703,40.115543],[-79.260248,40.116363],[-79.261596,40.116993],[-79.26362,40.117602],[-79.266033,40.11797],[-79.270067,40.118621],[-79.271037,40.118687],[-79.273363,40.1187],[-79.274762,40.1187],[-79.275723,40.118818],[-79.276564,40.119074],[-79.277388,40.119442],[-79.278204,40.120006],[-79.27871,40.120452],[-79.279114,40.121017],[-79.279233,40.121338],[-79.279397,40.121726],[-79.279517,40.122087],[-79.279706,40.122566],[-79.280067,40.123214],[-79.280424,40.123763],[-79.281139,40.124515],[-79.28192,40.125086],[-79.28289,40.125605],[-79.285182,40.126602],[-79.286246,40.127061],[-79.290091,40.128761],[-79.291483,40.129087],[-79.292854,40.129087],[-79.293954,40.128853],[-79.294752,40.128564],[-79.295962,40.127849],[-79.296829,40.12739],[-79.300442,40.12525],[-79.301387,40.124692],[-79.302686,40.124066],[-79.303491,40.123814],[-79.304846,40.123557],[-79.313115,40.122445],[-79.316484,40.121958],[-79.317182,40.121855],[-79.318663,40.121639],[-79.322804,40.121046],[-79.329136,40.120091],[-79.330114,40.119895],[-79.334689,40.118667],[-79.337732,40.117872],[-79.339124,40.117504],[-79.345874,40.115685],[-79.352121,40.114],[-79.354799,40.113279],[-79.359425,40.11207],[-79.362283,40.111309],[-79.363992,40.110705],[-79.366034,40.10972],[-79.367476,40.108795],[-79.368944,40.107797],[-79.370197,40.107298],[-79.370952,40.107101],[-79.372042,40.106983],[-79.37315,40.107003],[-79.374514,40.107272],[-79.376593,40.107742],[-79.37767,40.107987],[-79.378498,40.108218],[-79.379196,40.108453],[-79.380313,40.108937],[-79.381187,40.109325],[-79.38146,40.109446],[-79.382084,40.109699],[-79.383087,40.110124],[-79.383959,40.110508],[-79.384713,40.110822],[-79.385516,40.111168],[-79.386086,40.111422],[-79.387599,40.112098],[-79.38863,40.112556],[-79.389942,40.113101],[-79.394398,40.115059],[-79.394771,40.115245],[-79.395257,40.115528],[-79.395668,40.115807],[-79.396082,40.116121],[-79.396483,40.116479],[-79.396951,40.116971],[-79.397221,40.11732],[-79.397456,40.117677],[-79.397567,40.117888],[-79.397713,40.118185],[-79.397863,40.118505],[-79.398013,40.118858],[-79.398174,40.119522],[-79.398281,40.120162],[-79.398346,40.12054],[-79.39841,40.120827],[-79.398496,40.121147],[-79.398711,40.121713],[-79.399097,40.122279],[-79.399419,40.122632],[-79.399676,40.122993],[-79.400062,40.123304],[-79.400363,40.123518],[-79.401007,40.123936],[-79.402369,40.124855],[-79.403249,40.125413],[-79.403732,40.125716],[-79.404182,40.125971],[-79.405543,40.126858],[-79.406423,40.127478],[-79.407015,40.127964],[-79.407551,40.12853],[-79.407765,40.128861],[-79.408173,40.129597],[-79.408409,40.130146],[-79.408474,40.130515],[-79.408688,40.131606],[-79.40888,40.132981],[-79.409076,40.134244],[-79.409271,40.135334],[-79.40943,40.136296],[-79.409539,40.136717],[-79.410014,40.137469],[-79.410683,40.138355],[-79.411361,40.139031],[-79.412443,40.13972],[-79.413138,40.140061],[-79.414603,40.140752],[-79.415035,40.140947],[-79.41664,40.141728],[-79.420785,40.143992],[-79.421275,40.144241],[-79.421592,40.144412],[-79.421824,40.14453],[-79.422579,40.144884],[-79.423583,40.145514],[-79.425167,40.146964],[-79.42581,40.147474],[-79.426478,40.147898],[-79.427798,40.148716],[-79.428544,40.149555],[-79.428881,40.149974],[-79.428982,40.150146],[-79.42915,40.150386],[-79.429394,40.150802],[-79.429746,40.15134],[-79.429943,40.15153],[-79.430913,40.152678],[-79.431978,40.153977],[-79.432304,40.154233],[-79.432681,40.154495],[-79.4338,40.15503],[-79.434244,40.155191],[-79.434879,40.155289],[-79.43578,40.155309],[-79.438947,40.155145],[-79.439771,40.15504],[-79.443163,40.154184],[-79.444355,40.153772],[-79.445011,40.153383],[-79.445556,40.152888],[-79.446376,40.151976],[-79.446596,40.151746],[-79.446779,40.151567],[-79.447046,40.151328],[-79.447298,40.151135],[-79.4476,40.150942],[-79.447927,40.150763],[-79.448319,40.150592],[-79.448732,40.150449],[-79.449075,40.15036],[-79.44946,40.150283],[-79.449854,40.150235],[-79.450255,40.150208],[-79.450768,40.150187],[-79.45642,40.150113],[-79.456869,40.150106],[-79.457284,40.150112],[-79.457693,40.150121],[-79.45817,40.150146],[-79.458682,40.150196],[-79.459161,40.150255],[-79.459664,40.150344],[-79.460458,40.150515],[-79.462293,40.150946],[-79.464828,40.15156],[-79.46519,40.151654],[-79.465682,40.151805],[-79.466117,40.151961],[-79.46648,40.152122],[-79.466858,40.152307],[-79.467246,40.152526],[-79.467608,40.152765],[-79.468069,40.153093],[-79.469247,40.153965],[-79.469568,40.154166],[-79.469838,40.154312],[-79.470184,40.154473],[-79.470591,40.154629],[-79.470951,40.154745],[-79.472319,40.155158],[-79.472798,40.155323],[-79.47311,40.155448],[-79.473476,40.155615],[-79.474046,40.155904],[-79.480633,40.159433],[-79.482316,40.160334],[-79.482761,40.160589],[-79.483113,40.160812],[-79.48349,40.161078],[-79.483799,40.161322],[-79.484106,40.161587],[-79.484439,40.161908],[-79.484725,40.16222],[-79.484979,40.162521],[-79.485733,40.163535],[-79.485898,40.163738],[-79.486841,40.164899],[-79.48727,40.165292],[-79.488127,40.165812],[-79.488731,40.166082],[-79.489156,40.166199],[-79.49111,40.166648],[-79.491547,40.166743],[-79.493372,40.167194],[-79.494308,40.16749],[-79.495235,40.167857],[-79.496162,40.168316],[-79.497569,40.169064],[-79.501295,40.1713],[-79.504118,40.173005],[-79.507861,40.175189],[-79.508444,40.175438],[-79.509071,40.175648],[-79.513671,40.177012],[-79.515817,40.177714],[-79.516701,40.178035],[-79.522199,40.180303],[-79.522514,40.180448],[-79.527919,40.182744],[-79.528983,40.183216],[-79.529713,40.183636],[-79.530443,40.184121],[-79.530898,40.184521],[-79.531473,40.185209],[-79.532116,40.186344],[-79.533284,40.188252],[-79.533739,40.188914],[-79.534296,40.189596],[-79.535043,40.190258],[-79.535756,40.190822],[-79.536511,40.191347],[-79.537403,40.191825],[-79.538828,40.192455],[-79.541438,40.193215],[-79.545085,40.19433],[-79.547326,40.195451],[-79.551051,40.197411],[-79.553969,40.198939],[-79.556621,40.200381],[-79.559445,40.201876],[-79.562895,40.20375],[-79.564577,40.204616],[-79.565333,40.204963],[-79.569925,40.206661],[-79.571118,40.207067],[-79.57207,40.207507],[-79.573847,40.208332],[-79.577212,40.21001],[-79.581048,40.211892],[-79.581812,40.212167],[-79.582516,40.212383],[-79.583228,40.212521],[-79.584181,40.2126],[-79.585885,40.212597],[-79.589833,40.212525],[-79.591052,40.212643],[-79.592022,40.21286],[-79.592837,40.213135],[-79.593636,40.213528],[-79.594168,40.213882],[-79.594657,40.214328],[-79.595223,40.214918],[-79.596185,40.216124],[-79.596622,40.216471],[-79.597258,40.216805],[-79.597979,40.217087],[-79.599103,40.217533],[-79.600562,40.218116],[-79.601172,40.218414],[-79.601372,40.218536],[-79.601655,40.218734],[-79.60194,40.218955],[-79.602153,40.219148],[-79.602345,40.219337],[-79.602601,40.219624],[-79.603453,40.220736],[-79.603959,40.221407],[-79.604801,40.222527],[-79.605175,40.223006],[-79.605427,40.223296],[-79.605682,40.223563],[-79.605933,40.223802],[-79.606109,40.22396],[-79.606332,40.22415],[-79.606426,40.224226],[-79.606587,40.224347],[-79.60684,40.224538],[-79.607239,40.224813],[-79.608072,40.225349],[-79.608715,40.225762],[-79.608966,40.225947],[-79.610651,40.227021],[-79.616233,40.230615],[-79.617958,40.231736],[-79.61822,40.231914],[-79.618488,40.232104],[-79.618789,40.232331],[-79.619101,40.232592],[-79.619288,40.232762],[-79.619467,40.232936],[-79.619644,40.233113],[-79.619805,40.23328],[-79.620021,40.233523],[-79.620244,40.233792],[-79.622222,40.236299],[-79.622776,40.237],[-79.623018,40.237304],[-79.623182,40.237502],[-79.623333,40.23768],[-79.6235,40.237863],[-79.623698,40.238067],[-79.623889,40.238242],[-79.624134,40.238452],[-79.624374,40.238647],[-79.624673,40.238865],[-79.624916,40.239024],[-79.625108,40.239146],[-79.62537,40.239299],[-79.625655,40.239451],[-79.625956,40.239593],[-79.626334,40.239758],[-79.626655,40.23988],[-79.627017,40.240004],[-79.627345,40.240103],[-79.627762,40.240206],[-79.628096,40.240278],[-79.628426,40.240341],[-79.628841,40.240408],[-79.629392,40.240479],[-79.630413,40.240613],[-79.631035,40.240719],[-79.63161,40.240852],[-79.632195,40.241017],[-79.632633,40.24116],[-79.633132,40.241342],[-79.633477,40.241484],[-79.63389,40.241669],[-79.634219,40.241832],[-79.634517,40.241993],[-79.634867,40.242205],[-79.635218,40.242437],[-79.635559,40.242685],[-79.635905,40.242951],[-79.636378,40.243363],[-79.636895,40.243884],[-79.637294,40.244378],[-79.637616,40.244818],[-79.638294,40.245833],[-79.638881,40.246685],[-79.639862,40.248164],[-79.641168,40.250136],[-79.641395,40.250461],[-79.641508,40.250645],[-79.64166,40.250901],[-79.641798,40.251146],[-79.641894,40.251367],[-79.641989,40.251609],[-79.642065,40.251862],[-79.642109,40.252047],[-79.642159,40.252306],[-79.642197,40.252564],[-79.642212,40.252735],[-79.642229,40.252958],[-79.642248,40.253507],[-79.642295,40.254817],[-79.642331,40.255849],[-79.642365,40.256571],[-79.642395,40.256928],[-79.642438,40.257237],[-79.642488,40.257493],[-79.642549,40.25771],[-79.642626,40.257936],[-79.642724,40.258176],[-79.642802,40.258353],[-79.642888,40.258528],[-79.642999,40.258716],[-79.643153,40.258953],[-79.643295,40.259157],[-79.643426,40.259332],[-79.643569,40.259496],[-79.643736,40.259673],[-79.643881,40.259819],[-79.644041,40.259965],[-79.644287,40.260176],[-79.644619,40.260425],[-79.64486,40.260586],[-79.645184,40.260777],[-79.645594,40.260996],[-79.645834,40.261107],[-79.646084,40.261218],[-79.64636,40.261323],[-79.646682,40.261436],[-79.647045,40.261543],[-79.647497,40.261664],[-79.650327,40.262362],[-79.65193,40.262762],[-79.65406,40.263291],[-79.655899,40.263745],[-79.657302,40.264097],[-79.660994,40.265],[-79.662402,40.265341],[-79.663342,40.26558],[-79.663805,40.265709],[-79.664138,40.265825],[-79.664404,40.265932],[-79.664639,40.266032],[-79.664977,40.266197],[-79.665266,40.26636],[-79.665542,40.266533],[-79.665834,40.266735],[-79.666038,40.266886],[-79.666285,40.26709],[-79.666539,40.267332],[-79.666697,40.267493],[-79.666862,40.267678],[-79.667019,40.267869],[-79.667133,40.268023],[-79.667255,40.268188],[-79.66737,40.268386],[-79.66751,40.268638],[-79.667625,40.268903],[-79.667713,40.269129],[-79.667797,40.269392],[-79.667868,40.269648],[-79.66792,40.269911],[-79.66796,40.270255],[-79.667984,40.270627],[-79.668014,40.271034],[-79.668142,40.272403],[-79.668252,40.273617],[-79.668398,40.275559],[-79.668627,40.277984],[-79.668702,40.278982],[-79.669046,40.283238],[-79.669262,40.285896],[-79.669454,40.288292],[-79.669529,40.28926],[-79.669613,40.290239],[-79.669665,40.290833],[-79.669714,40.2912],[-79.669769,40.291535],[-79.669835,40.291884],[-79.669898,40.292172],[-79.6702,40.293432],[-79.67038,40.294187],[-79.670543,40.294866],[-79.670771,40.295809],[-79.671193,40.297571],[-79.671617,40.299332],[-79.672137,40.301495],[-79.672451,40.3028],[-79.672576,40.303323],[-79.672673,40.303709],[-79.67276,40.304028],[-79.672853,40.304328],[-79.673009,40.304753],[-79.673148,40.30508],[-79.673271,40.305348],[-79.673404,40.30561],[-79.673548,40.305871],[-79.673684,40.306112],[-79.673839,40.306358],[-79.673974,40.306562],[-79.674133,40.306785],[-79.674376,40.307109],[-79.674616,40.307387],[-79.674846,40.307647],[-79.675545,40.308371],[-79.675935,40.308773],[-79.676554,40.3094],[-79.677072,40.309946],[-79.677374,40.31028],[-79.677541,40.310478],[-79.677723,40.310721],[-79.677833,40.310883],[-79.677943,40.311066],[-79.678049,40.31126],[-79.678139,40.311443],[-79.67824,40.311676],[-79.678312,40.311875],[-79.67837,40.312055],[-79.678422,40.312267],[-79.678459,40.31243],[-79.678481,40.312593],[-79.678502,40.312751],[-79.678516,40.312904],[-79.678524,40.313141],[-79.67852,40.313358],[-79.678502,40.313602],[-79.678467,40.313846],[-79.678417,40.314126],[-79.678339,40.314513],[-79.678196,40.315219],[-79.678121,40.315612],[-79.678092,40.315818],[-79.678067,40.315997],[-79.678049,40.316177],[-79.678044,40.316365],[-79.678049,40.316621],[-79.678066,40.316842],[-79.678094,40.317062],[-79.678112,40.317175],[-79.678131,40.317282],[-79.678177,40.317467],[-79.678249,40.317707],[-79.67834,40.317956],[-79.678443,40.318201],[-79.678551,40.318422],[-79.678663,40.318618],[-79.678811,40.318849],[-79.678996,40.319108],[-79.679214,40.319396],[-79.679963,40.320348],[-79.682891,40.324069],[-79.684098,40.325592],[-79.684649,40.326276],[-79.685489,40.327329],[-79.685576,40.327441],[-79.685846,40.327803],[-79.686322,40.328402],[-79.687876,40.330294],[-79.688153,40.330616],[-79.688475,40.330988],[-79.688842,40.331445],[-79.689172,40.331866],[-79.689447,40.332223],[-79.689779,40.332673],[-79.690527,40.333695],[-79.690925,40.334285],[-79.691288,40.334945],[-79.691721,40.335929],[-79.692134,40.337362],[-79.692254,40.338541],[-79.692272,40.339266],[-79.692233,40.339856],[-79.692144,40.340598],[-79.692013,40.341165],[-79.691771,40.34197],[-79.691537,40.342571],[-79.691231,40.343177],[-79.690719,40.344004],[-79.690172,40.344772],[-79.687809,40.347828],[-79.687035,40.348796],[-79.686637,40.349321],[-79.686357,40.349873],[-79.685791,40.35096],[-79.684533,40.353751],[-79.684242,40.35428],[-79.683851,40.354897],[-79.68346,40.355421],[-79.681214,40.358266],[-79.681086,40.358412],[-79.680539,40.359077],[-79.680155,40.359569],[-79.679615,40.360289],[-79.67921,40.361035],[-79.678997,40.361614],[-79.678862,40.362111],[-79.678769,40.362663],[-79.678741,40.36322],[-79.678705,40.364177],[-79.678684,40.365199],[-79.678663,40.365902],[-79.678599,40.369131],[-79.678542,40.370299],[-79.678492,40.371267],[-79.67835,40.372208],[-79.678116,40.372976],[-79.677867,40.373549],[-79.67759,40.374068],[-79.677199,40.374701],[-79.676694,40.375453],[-79.676246,40.376134],[-79.675863,40.37674],[-79.6756,40.377146],[-79.675401,40.377562],[-79.675244,40.378189],[-79.675223,40.3788],[-79.67523,40.379347],[-79.675301,40.379779],[-79.675493,40.380299],[-79.675721,40.380758],[-79.676175,40.381369],[-79.676559,40.381791],[-79.677099,40.382272],[-79.677632,40.382716],[-79.678222,40.38323],[-79.678954,40.383873],[-79.679686,40.384533],[-79.680404,40.385144],[-79.681072,40.38569],[-79.681783,40.386302],[-79.682493,40.386945],[-79.68319,40.387551],[-79.684,40.388221],[-79.684704,40.388843],[-79.685365,40.389449],[-79.685947,40.389995],[-79.686587,40.390633],[-79.687028,40.391077],[-79.687326,40.391374],[-79.687753,40.391828],[-79.688286,40.392391],[-79.689089,40.393245],[-79.689778,40.393938],[-79.69056,40.39476],[-79.691242,40.395495],[-79.691725,40.395933],[-79.692443,40.396469],[-79.692976,40.396825],[-79.693459,40.397047],[-79.693872,40.397238],[-79.695975,40.398183],[-79.697525,40.398886],[-79.698456,40.399329],[-79.699365,40.39973],[-79.700296,40.400146],[-79.701284,40.4006],[-79.701838,40.400844],[-79.703224,40.401498],[-79.70402,40.401839],[-79.704973,40.402271],[-79.705818,40.402634],[-79.706664,40.403039],[-79.707567,40.403472],[-79.708491,40.403851],[-79.709301,40.404137],[-79.710473,40.404462],[-79.711326,40.40464],[-79.712072,40.404792],[-79.712819,40.404927],[-79.713799,40.405084],[-79.714595,40.405224],[-79.715149,40.405376],[-79.716415,40.405776],[-79.717374,40.406209],[-79.718113,40.406603],[-79.721753,40.40861],[-79.722576,40.409042],[-79.723998,40.409837],[-79.724292,40.410002],[-79.726727,40.411308],[-79.727708,40.411941],[-79.728319,40.412552],[-79.728539,40.412779],[-79.729058,40.413472],[-79.730756,40.416284],[-79.732248,40.418684],[-79.73271,40.419279],[-79.733187,40.419712],[-79.733968,40.420399],[-79.736008,40.422237],[-79.736662,40.42307],[-79.737024,40.423676],[-79.737422,40.424406],[-79.73809,40.425644],[-79.738644,40.426515],[-79.73916,40.427106],[-79.7397,40.42761],[-79.740098,40.427924],[-79.742496,40.429662],[-79.743495,40.430442],[-79.745719,40.432028],[-79.746671,40.432833],[-79.747156,40.433301],[-79.747538,40.433726],[-79.747728,40.433947],[-79.748007,40.434295],[-79.748085,40.434481],[-79.748109,40.434605],[-79.748117,40.434748],[-79.748101,40.434873],[-79.748064,40.434979],[-79.747991,40.435109],[-79.747846,40.435301],[-79.747575,40.435614],[-79.747525,40.435706],[-79.747511,40.435797],[-79.747514,40.435875],[-79.74757,40.435986],[-79.747651,40.436084],[-79.74775,40.436153],[-79.747879,40.436198],[-79.748002,40.436235],[-79.748139,40.436263],[-79.748276,40.436271],[-79.748426,40.436261],[-79.748573,40.436231],[-79.749002,40.436084],[-79.74933,40.435971],[-79.751318,40.435335],[-79.751805,40.435165],[-79.751993,40.43512],[-79.752181,40.435099],[-79.752347,40.435095],[-79.75253,40.435124],[-79.752696,40.435185],[-79.752825,40.435259],[-79.752921,40.435328],[-79.75299,40.435395],[-79.753653,40.436452],[-79.754215,40.437309],[-79.754576,40.437884],[-79.75481,40.438281],[-79.755256,40.439024],[-79.755414,40.439286],[-79.755516,40.439433],[-79.755604,40.439533],[-79.755715,40.439633],[-79.755805,40.4397],[-79.755962,40.439821],[-79.756142,40.439938],[-79.756257,40.439998],[-79.756402,40.440052],[-79.75654,40.440091],[-79.756715,40.440126],[-79.756995,40.440183],[-79.75913,40.440371],[-79.759441,40.440429],[-79.759557,40.440466],[-79.759709,40.440514],[-79.760004,40.440645],[-79.76038,40.440849],[-79.760691,40.441025],[-79.761184,40.441315],[-79.76186,40.441764],[-79.76266,40.442307],[-79.763067,40.442572],[-79.763427,40.442776],[-79.763861,40.443001],[-79.764357,40.443259],[-79.764781,40.443451],[-79.765244,40.443645],[-79.765674,40.443809],[-79.766146,40.443972],[-79.766683,40.444136],[-79.767055,40.44424],[-79.767478,40.444346],[-79.768281,40.444519],[-79.768567,40.444574],[-79.768895,40.444629],[-79.76925,40.444679],[-79.769814,40.444743],[-79.770313,40.444785],[-79.77069,40.444809],[-79.771097,40.44483],[-79.771548,40.444834],[-79.772207,40.444823],[-79.772597,40.444805],[-79.772966,40.44478],[-79.77335,40.444748],[-79.773692,40.444711],[-79.774052,40.444667],[-79.774498,40.444605],[-79.775101,40.444505],[-79.777878,40.444054],[-79.778678,40.443927],[-79.782427,40.443324],[-79.784217,40.443034],[-79.786123,40.442729],[-79.787294,40.442555],[-79.788036,40.442465],[-79.788902,40.442372],[-79.789839,40.442287],[-79.79072,40.44222],[-79.791744,40.442161],[-79.792615,40.442128],[-79.793443,40.442108],[-79.79456,40.4421],[-79.796131,40.442091],[-79.798615,40.442088],[-79.802858,40.442065],[-79.80394,40.442067],[-79.804498,40.442083],[-79.80491,40.442103],[-79.805523,40.442145],[-79.806299,40.442205],[-79.809684,40.442609],[-79.810585,40.442715],[-79.811503,40.442817],[-79.812018,40.442854],[-79.812533,40.442882],[-79.813198,40.442895],[-79.813632,40.442886],[-79.814346,40.442841],[-79.815848,40.442748],[-79.818589,40.442564],[-79.820569,40.442441],[-79.821725,40.442369],[-79.8239,40.442233],[-79.824637,40.442176],[-79.825426,40.442116],[-79.826022,40.442053],[-79.826655,40.441961],[-79.827084,40.441884],[-79.827784,40.44173],[-79.8282,40.44162],[-79.8289,40.441426],[-79.829884,40.441122],[-79.8313,40.440691],[-79.831622,40.440608],[-79.832016,40.440534],[-79.83233,40.440497],[-79.832617,40.440481],[-79.832952,40.440473],[-79.833253,40.440483],[-79.833505,40.440516],[-79.833819,40.440569],[-79.834057,40.440623],[-79.834358,40.440712],[-79.834677,40.440836],[-79.834999,40.440979],[-79.835297,40.441132],[-79.837601,40.442361],[-79.83936,40.443292],[-79.840653,40.443962],[-79.841632,40.444421],[-79.842198,40.444686],[-79.842874,40.445011],[-79.843207,40.445168],[-79.843528,40.445297],[-79.843767,40.44538],[-79.844049,40.445462],[-79.844349,40.445529],[-79.844652,40.445582],[-79.84499,40.445631],[-79.845312,40.445662],[-79.845621,40.445674],[-79.845897,40.445676],[-79.846178,40.445664],[-79.846433,40.445639],[-79.846955,40.445582],[-79.848059,40.445452],[-79.848696,40.445381],[-79.849971,40.445248],[-79.850601,40.445152],[-79.8511,40.445068],[-79.851505,40.444974],[-79.851873,40.44488],[-79.852224,40.444784],[-79.852594,40.444668],[-79.853037,40.444505],[-79.853426,40.444351],[-79.853935,40.444129],[-79.854332,40.443931],[-79.854694,40.443733],[-79.855043,40.443521],[-79.855285,40.443363],[-79.855904,40.442951],[-79.857106,40.442151],[-79.858737,40.441079],[-79.860222,40.440091],[-79.861038,40.439558],[-79.861561,40.439209],[-79.862331,40.438699],[-79.862953,40.438289],[-79.863841,40.437693],[-79.86475,40.437098],[-79.865598,40.436535],[-79.865804,40.4364],[-79.866145,40.436176],[-79.86681,40.435739],[-79.867245,40.435449],[-79.867789,40.435077],[-79.868105,40.434851],[-79.868299,40.4347],[-79.86902,40.434124],[-79.870034,40.433328],[-79.870654,40.432834],[-79.871944,40.431831],[-79.872711,40.431229],[-79.873483,40.430619],[-79.873743,40.430425],[-79.873971,40.430284],[-79.874344,40.430084],[-79.874682,40.429935],[-79.875039,40.429804],[-79.875498,40.429665],[-79.875803,40.429594],[-79.876206,40.429528],[-79.876616,40.429485],[-79.876957,40.429467],[-79.877238,40.429469],[-79.87763,40.429485],[-79.878003,40.429526],[-79.878384,40.42959],[-79.878722,40.429669],[-79.879867,40.429977],[-79.880146,40.430049],[-79.880414,40.43011],[-79.880943,40.430194],[-79.881302,40.430231],[-79.881643,40.430249],[-79.88208,40.430249],[-79.882442,40.430231],[-79.88274,40.430204],[-79.883206,40.430135],[-79.883614,40.430057],[-79.88422,40.429935],[-79.88586,40.429609],[-79.886317,40.429518],[-79.887251,40.42934],[-79.887583,40.429257],[-79.887919,40.429161],[-79.88827,40.42904],[-79.888568,40.428911],[-79.888903,40.42875],[-79.889222,40.428583],[-79.889549,40.428377],[-79.890772,40.427604],[-79.891315,40.427253],[-79.891515,40.427115],[-79.891765,40.426988],[-79.891937,40.426904],[-79.892207,40.42678],[-79.892489,40.426676],[-79.892779,40.426578],[-79.893168,40.426461],[-79.893506,40.426382],[-79.893932,40.426294],[-79.894359,40.426237],[-79.894723,40.4262],[-79.895177,40.426169],[-79.896483,40.4261],[-79.898546,40.42599],[-79.90074,40.425881],[-79.902671,40.425775],[-79.904696,40.425652],[-79.90777,40.425488],[-79.908226,40.425489],[-79.908513,40.425496],[-79.908867,40.425526],[-79.909293,40.425575],[-79.911544,40.425905],[-79.926473,40.428117],[-79.927017,40.428219],[-79.927404,40.428293],[-79.92749,40.428313],[-79.927699,40.428362],[-79.928632,40.428591],[-79.929126,40.428707],[-79.92963,40.42881],[-79.930027,40.428871],[-79.930418,40.428914],[-79.930912,40.428957],[-79.931349,40.428985],[-79.93184,40.429001],[-79.932245,40.428993],[-79.932755,40.428971],[-79.933294,40.428924],[-79.933809,40.428859],[-79.93567,40.428607],[-79.936099,40.428569],[-79.936496,40.42856],[-79.936869,40.42856],[-79.937151,40.428569],[-79.93758,40.428603],[-79.938028,40.428664],[-79.938165,40.428683],[-79.940069,40.429063],[-79.940954,40.429234],[-79.941426,40.429297],[-79.941828,40.429328],[-79.942201,40.429342],[-79.942526,40.429342],[-79.942818,40.429332],[-79.94317,40.429306],[-79.943475,40.429271],[-79.94384,40.429212],[-79.944023,40.429177],[-79.944291,40.429126],[-79.945299,40.428881],[-79.947542,40.42832],[-79.95031,40.427621],[-79.950682,40.42754],[-79.950812,40.427514],[-79.951087,40.42746],[-79.951358,40.427425],[-79.951758,40.427397],[-79.952099,40.427393],[-79.95249,40.427405],[-79.952836,40.427437],[-79.953239,40.427499],[-79.95363,40.427587],[-79.953957,40.427678],[-79.954325,40.427813],[-79.954722,40.427981],[-79.955049,40.428148],[-79.955309,40.428299],[-79.955529,40.428454],[-79.955757,40.428628],[-79.956009,40.42885],[-79.956385,40.429244],[-79.957144,40.430045],[-79.957828,40.430768],[-79.958032,40.430976],[-79.95826,40.431188],[-79.958533,40.431411],[-79.958772,40.431584],[-79.959059,40.43177],[-79.959125,40.431809],[-79.959378,40.431958],[-79.959716,40.432137],[-79.960057,40.432295],[-79.963543,40.433803],[-79.96622,40.434965],[-79.966752,40.435186],[-79.967272,40.435367],[-79.9678,40.435547],[-79.968305,40.435698],[-79.9693,40.435951],[-79.970204,40.436182],[-79.97133,40.436461],[-79.971767,40.436574],[-79.972078,40.436649],[-79.972253,40.436678],[-79.972483,40.436704],[-79.972652,40.436719],[-79.972964,40.436723],[-79.973318,40.436698],[-79.973894,40.436645],[-79.974932,40.436536],[-79.975428,40.436496],[-79.977783,40.436243],[-79.979593,40.436045],[-79.981548,40.435798],[-79.982805,40.43565],[-79.983331,40.435592],[-79.983828,40.435528],[-79.984413,40.43544],[-79.984802,40.435361],[-79.985727,40.435204],[-79.986393,40.435104],[-79.986913,40.435049],[-79.987913,40.434971],[-79.988745,40.434922],[-79.989335,40.434914],[-79.990577,40.434922],[-79.99118,40.434933],[-79.991491,40.434957],[-79.991824,40.435008],[-79.992151,40.43508],[-79.992841,40.43529],[-79.993339,40.435445],[-79.99364,40.435547],[-79.994213,40.435767],[-79.994423,40.435876],[-79.994492,40.435916],[-79.994547,40.435954],[-79.994593,40.435995],[-79.994629,40.43603],[-79.994673,40.43608],[-79.994704,40.436122],[-79.994729,40.436162],[-79.994758,40.436223],[-79.994774,40.436265],[-79.994785,40.436312],[-79.994789,40.436368],[-79.994791,40.436428],[-79.994788,40.436486],[-79.994779,40.436541],[-79.994758,40.436623],[-79.994737,40.436691],[-79.994695,40.436806],[-79.994533,40.43719],[-79.994331,40.437662],[-79.994015,40.43838],[-79.993844,40.43871],[-79.99368,40.438989],[-79.993638,40.439069],[-79.993591,40.439158],[-79.993449,40.439358],[-79.993242,40.43961],[-79.992891,40.440014],[-79.992772,40.440112],[-79.992668,40.44018],[-79.992553,40.440239],[-79.992462,40.440277],[-79.99238,40.440303],[-79.99229,40.440324],[-79.992203,40.440337],[-79.992092,40.440344],[-79.991736,40.440348],[-79.991665,40.440347],[-79.991564,40.440351],[-79.991398,40.440369],[-79.9909,40.440441],[-79.990477,40.440436],[-79.989656,40.44044],[-79.989651,40.440546],[-79.990471,40.44054],[-79.990477,40.440742],[-79.990477,40.440904],[-79.99009,40.440907]]},{_id:'3',name:'Truck #3',plate:'SY485984',fromLocation:'Columbus',toLocation:'Baltimore',pilotName:'Margaret Johnson',address:'Viale Europa 1, Rome, Italy',mobile:'1 (916) 442-0945',truckType:'Mobile crane',maxCharge:'45.000',image:'/img/a4.jpg',truckModel:'International HX520',truckYear:'2012',actualPosition:[39.941898,-82.526025],vectorPath:[[-83.000656,39.962305],[-83.000642,39.962232],[-83.000508,39.962247],[-82.999747,39.962332],[-82.999447,39.962365],[-82.999005,39.962415],[-82.998587,39.962462],[-82.99856,39.962464],[-82.998118,39.96251],[-82.997983,39.962524],[-82.997115,39.96263],[-82.996247,39.962731],[-82.995384,39.962829],[-82.99439,39.962942],[-82.992698,39.963135],[-82.991575,39.963262],[-82.99106,39.963321],[-82.990534,39.963381],[-82.989954,39.963447],[-82.988912,39.963567],[-82.988451,39.96362],[-82.987074,39.963778],[-82.98592,39.96391],[-82.98531,39.96398],[-82.98525,39.963987],[-82.9844,39.964084],[-82.983661,39.964169],[-82.983556,39.964181],[-82.983491,39.964026],[-82.983285,39.963527],[-82.98307,39.963003],[-82.982907,39.962465],[-82.982819,39.962077],[-82.982713,39.96145],[-82.982716,39.96126],[-82.982744,39.960898],[-82.982777,39.96055],[-82.982849,39.960018],[-82.982909,39.959379],[-82.982992,39.958651],[-82.982978,39.957761],[-82.982961,39.957537],[-82.982902,39.95732],[-82.982729,39.956866],[-82.982412,39.95639],[-82.982008,39.955985],[-82.98156,39.955631],[-82.981271,39.955454],[-82.980863,39.955222],[-82.980593,39.955095],[-82.980199,39.954938],[-82.980006,39.954869],[-82.979447,39.954706],[-82.978562,39.954541],[-82.977888,39.95447],[-82.977026,39.954352],[-82.975648,39.954239],[-82.972824,39.953958],[-82.970532,39.953747],[-82.970069,39.953709],[-82.968773,39.953624],[-82.967706,39.953582],[-82.966939,39.953564],[-82.96671,39.953559],[-82.965961,39.953541],[-82.964352,39.953511],[-82.96371,39.953498],[-82.963069,39.953484],[-82.959972,39.953418],[-82.95802,39.95337],[-82.956307,39.953298],[-82.955088,39.953247],[-82.954791,39.953232],[-82.953753,39.953183],[-82.953526,39.953174],[-82.95308,39.953155],[-82.953008,39.953152],[-82.952562,39.953135],[-82.951745,39.953107],[-82.94967,39.953019],[-82.948533,39.952965],[-82.948136,39.952935],[-82.947715,39.952889],[-82.947183,39.952777],[-82.946608,39.952606],[-82.946153,39.952429],[-82.945629,39.952166],[-82.945226,39.951856],[-82.944805,39.951501],[-82.944479,39.951106],[-82.944127,39.950554],[-82.94393,39.95008],[-82.943793,39.949567],[-82.943741,39.949053],[-82.943741,39.94858],[-82.94375,39.948205],[-82.943741,39.947678],[-82.94369,39.947218],[-82.943587,39.94679],[-82.943415,39.946323],[-82.943243,39.946027],[-82.943051,39.945711],[-82.942742,39.945256],[-82.942223,39.944564],[-82.941447,39.943509],[-82.938938,39.940295],[-82.937078,39.937911],[-82.93612,39.93663],[-82.93449,39.934471],[-82.933915,39.933853],[-82.933099,39.933155],[-82.932258,39.932681],[-82.931768,39.93247],[-82.931253,39.932259],[-82.930575,39.932049],[-82.929931,39.93193],[-82.929021,39.931819],[-82.928121,39.931773],[-82.926851,39.931773],[-82.923656,39.931679],[-82.921076,39.931637],[-82.91899,39.931607],[-82.917685,39.931587],[-82.914775,39.931549],[-82.91208,39.931507],[-82.910702,39.931492],[-82.910075,39.931491],[-82.909074,39.931549],[-82.907581,39.9317],[-82.906465,39.931878],[-82.905463,39.932068],[-82.903924,39.932395],[-82.902076,39.932838],[-82.901171,39.933074],[-82.89922,39.933575],[-82.899157,39.93359],[-82.898733,39.933695],[-82.89794,39.9339],[-82.89757,39.933995],[-82.89344,39.934958],[-82.892266,39.935178],[-82.88787,39.935758],[-82.886807,39.935856],[-82.885967,39.935939],[-82.885314,39.936005],[-82.884747,39.936062],[-82.884177,39.936113],[-82.883357,39.936187],[-82.880349,39.93647],[-82.87942,39.93656],[-82.878439,39.936654],[-82.876793,39.936808],[-82.875928,39.93689],[-82.874726,39.936969],[-82.874445,39.936977],[-82.873426,39.936987],[-82.872167,39.936939],[-82.87134,39.936886],[-82.870102,39.936744],[-82.870009,39.936732],[-82.869365,39.936637],[-82.867392,39.936229],[-82.86643,39.93602],[-82.86599,39.935924],[-82.864931,39.935655],[-82.864004,39.935405],[-82.862657,39.935017],[-82.861696,39.934754],[-82.860777,39.93453],[-82.85985,39.934359],[-82.858855,39.934254],[-82.857498,39.934168],[-82.854966,39.934036],[-82.852657,39.933908],[-82.850941,39.933813],[-82.846924,39.933576],[-82.845268,39.933477],[-82.841929,39.933279],[-82.836873,39.933016],[-82.835001,39.932906],[-82.832084,39.932733],[-82.830975,39.932676],[-82.829848,39.932618],[-82.825511,39.932377],[-82.824323,39.932311],[-82.823653,39.932273],[-82.82128,39.932137],[-82.818168,39.931962],[-82.8174,39.931919],[-82.812014,39.931617],[-82.81154,39.931598],[-82.806631,39.931318],[-82.806047,39.931291],[-82.805464,39.93125],[-82.804998,39.931228],[-82.802782,39.931104],[-82.802081,39.931073],[-82.801604,39.931064],[-82.801029,39.931071],[-82.800562,39.931087],[-82.800096,39.931117],[-82.799516,39.931172],[-82.798814,39.931264],[-82.798367,39.931336],[-82.797768,39.931451],[-82.797353,39.931544],[-82.796326,39.931794],[-82.795822,39.93192],[-82.795426,39.932015],[-82.794607,39.932213],[-82.793128,39.932576],[-82.792588,39.932708],[-82.792066,39.932836],[-82.790898,39.933122],[-82.790562,39.933197],[-82.789897,39.933368],[-82.789584,39.933445],[-82.788953,39.933599],[-82.788602,39.933684],[-82.786669,39.934156],[-82.786116,39.9343],[-82.785034,39.934555],[-82.78355,39.934912],[-82.78271,39.935118],[-82.781553,39.935401],[-82.780001,39.935781],[-82.779117,39.935997],[-82.777624,39.93636],[-82.775757,39.936819],[-82.773011,39.937496],[-82.771416,39.937888],[-82.77078,39.93806],[-82.770151,39.938247],[-82.769912,39.938325],[-82.769634,39.938415],[-82.769122,39.938594],[-82.768606,39.938788],[-82.768209,39.938948],[-82.767671,39.939206],[-82.767164,39.939443],[-82.76597,39.940074],[-82.765567,39.9403],[-82.765209,39.940517],[-82.764974,39.940655],[-82.764766,39.940785],[-82.763824,39.941332],[-82.763634,39.941463],[-82.763398,39.941616],[-82.763238,39.941727],[-82.763027,39.941858],[-82.762727,39.942048],[-82.762497,39.9422],[-82.762085,39.942469],[-82.761929,39.942574],[-82.761437,39.942901],[-82.760945,39.943199],[-82.760574,39.943443],[-82.75995,39.943856],[-82.759107,39.944437],[-82.758544,39.944781],[-82.757947,39.945143],[-82.75745,39.945483],[-82.757281,39.945609],[-82.756782,39.945945],[-82.756486,39.946116],[-82.756212,39.94629],[-82.755931,39.946467],[-82.755224,39.946896],[-82.755036,39.947018],[-82.754717,39.947223],[-82.754386,39.947442],[-82.754121,39.947604],[-82.753729,39.947861],[-82.753481,39.948016],[-82.753104,39.948244],[-82.75251,39.948606],[-82.752321,39.948722],[-82.752209,39.948792],[-82.752125,39.948841],[-82.751993,39.948907],[-82.751623,39.949087],[-82.751191,39.949306],[-82.750826,39.94947],[-82.750601,39.949563],[-82.750293,39.949692],[-82.749963,39.949823],[-82.74962,39.949958],[-82.749284,39.950083],[-82.748804,39.950253],[-82.748485,39.950369],[-82.748287,39.950429],[-82.747863,39.950564],[-82.747542,39.950664],[-82.747263,39.95074],[-82.746803,39.95085],[-82.746361,39.95095],[-82.745986,39.951033],[-82.745656,39.951102],[-82.745407,39.951153],[-82.744993,39.951226],[-82.744562,39.951292],[-82.744244,39.951335],[-82.743569,39.951422],[-82.74319,39.951458],[-82.742916,39.951483],[-82.742495,39.951513],[-82.742174,39.951533],[-82.741514,39.951562],[-82.740923,39.951575],[-82.740617,39.951578],[-82.740184,39.951574],[-82.739575,39.951555],[-82.739234,39.951539],[-82.738944,39.951518],[-82.738193,39.951476],[-82.737606,39.951446],[-82.73711,39.951419],[-82.736195,39.951367],[-82.735986,39.951356],[-82.731131,39.951115],[-82.730429,39.951072],[-82.729603,39.951031],[-82.728868,39.950997],[-82.728034,39.950939],[-82.727374,39.95091],[-82.726713,39.950873],[-82.725607,39.950814],[-82.724565,39.950757],[-82.723399,39.9507],[-82.722662,39.950657],[-82.721835,39.950616],[-82.720765,39.950557],[-82.719748,39.950508],[-82.718928,39.950463],[-82.718289,39.950432],[-82.717995,39.950416],[-82.717409,39.95038],[-82.71651,39.950335],[-82.715574,39.950284],[-82.714566,39.950226],[-82.713787,39.950185],[-82.713392,39.950166],[-82.712564,39.950127],[-82.711593,39.950061],[-82.710442,39.950002],[-82.709309,39.949957],[-82.708349,39.949907],[-82.70696,39.949832],[-82.705972,39.949788],[-82.705241,39.949751],[-82.704943,39.949735],[-82.704404,39.949702],[-82.702566,39.949603],[-82.701302,39.949533],[-82.699267,39.949417],[-82.697343,39.949316],[-82.696289,39.949269],[-82.696131,39.949263],[-82.695272,39.94921],[-82.693182,39.9491],[-82.692148,39.94905],[-82.690278,39.948964],[-82.689614,39.948936],[-82.688586,39.948883],[-82.687618,39.948837],[-82.686892,39.948801],[-82.685228,39.948731],[-82.683448,39.948641],[-82.682896,39.94862],[-82.681535,39.948549],[-82.67974,39.948465],[-82.678702,39.948401],[-82.677937,39.948351],[-82.673745,39.948179],[-82.671806,39.948093],[-82.670812,39.948042],[-82.670203,39.948012],[-82.669301,39.947962],[-82.668431,39.947914],[-82.66725,39.947856],[-82.665062,39.947754],[-82.661716,39.947588],[-82.658568,39.947444],[-82.656246,39.94732],[-82.655828,39.947302],[-82.654396,39.947238],[-82.651643,39.947121],[-82.649553,39.947018],[-82.64737,39.946928],[-82.646722,39.946901],[-82.645206,39.946843],[-82.644075,39.946777],[-82.641759,39.946664],[-82.640855,39.94663],[-82.639743,39.946583],[-82.638533,39.946526],[-82.636721,39.946453],[-82.635791,39.946414],[-82.63523,39.946387],[-82.63396,39.946328],[-82.633114,39.946285],[-82.631965,39.946243],[-82.629692,39.946157],[-82.627905,39.946067],[-82.627622,39.946051],[-82.627081,39.946021],[-82.625678,39.94595],[-82.62458,39.945908],[-82.622828,39.945833],[-82.619931,39.945707],[-82.619287,39.945674],[-82.618663,39.945631],[-82.618547,39.945624],[-82.618399,39.945615],[-82.618019,39.945615],[-82.617611,39.945604],[-82.617329,39.945586],[-82.616901,39.945543],[-82.616662,39.945533],[-82.616081,39.945527],[-82.61564,39.945517],[-82.614957,39.945491],[-82.61435,39.945473],[-82.61389,39.945453],[-82.613419,39.945443],[-82.61286,39.945438],[-82.612023,39.945444],[-82.611416,39.945445],[-82.610728,39.945457],[-82.609995,39.945488],[-82.609562,39.945508],[-82.609553,39.945508],[-82.609459,39.945512],[-82.609204,39.945523],[-82.608633,39.945552],[-82.607691,39.945602],[-82.60712,39.945636],[-82.606654,39.945656],[-82.60641,39.945662],[-82.60603,39.945662],[-82.605628,39.945654],[-82.605141,39.94564],[-82.604593,39.945626],[-82.604239,39.945605],[-82.604072,39.945596],[-82.603162,39.945527],[-82.602615,39.945466],[-82.601847,39.945353],[-82.600311,39.945155],[-82.600091,39.945129],[-82.599086,39.944998],[-82.598746,39.944951],[-82.598279,39.94491],[-82.598014,39.94489],[-82.59752,39.944857],[-82.595378,39.944722],[-82.594502,39.944687],[-82.592858,39.944633],[-82.591871,39.944596],[-82.588014,39.944378],[-82.582136,39.944199],[-82.581046,39.944135],[-82.579894,39.944093],[-82.578216,39.944035],[-82.576764,39.943978],[-82.576423,39.943958],[-82.575315,39.943919],[-82.574182,39.943873],[-82.570153,39.943725],[-82.568956,39.943681],[-82.567759,39.943623],[-82.566553,39.94357],[-82.565881,39.943551],[-82.562181,39.943389],[-82.560957,39.943347],[-82.557286,39.943218],[-82.556063,39.943163],[-82.554859,39.943117],[-82.553658,39.943063],[-82.550024,39.942916],[-82.549484,39.94284],[-82.548749,39.942808],[-82.548189,39.942848],[-82.547005,39.942797],[-82.545808,39.942754],[-82.544486,39.942699],[-82.543415,39.942656],[-82.542218,39.942606],[-82.541019,39.942559],[-82.539817,39.942514],[-82.539201,39.942488],[-82.537867,39.942418],[-82.537004,39.942378],[-82.536131,39.942342],[-82.535463,39.94233],[-82.534943,39.942311],[-82.534244,39.942287],[-82.53353,39.94225],[-82.532815,39.942215],[-82.532099,39.942181],[-82.529773,39.942078],[-82.52699,39.941955],[-82.526379,39.941919],[-82.526025,39.941898],[-82.525044,39.941859],[-82.524059,39.941832],[-82.523045,39.941831],[-82.522066,39.941851],[-82.521086,39.941882],[-82.520109,39.941925],[-82.519245,39.941983],[-82.518952,39.942002],[-82.518525,39.94203],[-82.517907,39.942073],[-82.517122,39.942149],[-82.516558,39.942179],[-82.515639,39.942256],[-82.514722,39.942335],[-82.513215,39.942475],[-82.5125,39.942536],[-82.511746,39.94261],[-82.51099,39.94268],[-82.510208,39.942747],[-82.509419,39.942809],[-82.508627,39.942868],[-82.507832,39.942932],[-82.507037,39.942999],[-82.506175,39.943069],[-82.50544,39.94313],[-82.503947,39.943252],[-82.503198,39.943312],[-82.500953,39.943495],[-82.498727,39.943673],[-82.497986,39.943731],[-82.49725,39.943793],[-82.495778,39.943914],[-82.494312,39.944031],[-82.493578,39.944092],[-82.49162,39.944198],[-82.491237,39.944231],[-82.490165,39.94432],[-82.487176,39.944562],[-82.486321,39.944633],[-82.48377,39.944845],[-82.480875,39.945078],[-82.479813,39.945157],[-82.478336,39.945286],[-82.477991,39.945315],[-82.476013,39.945476],[-82.474474,39.9456],[-82.470541,39.945961],[-82.466384,39.946287],[-82.464544,39.946488],[-82.462924,39.94661],[-82.461755,39.946702],[-82.460759,39.946774],[-82.460194,39.946795],[-82.459449,39.946811],[-82.458298,39.946781],[-82.457577,39.946778],[-82.456779,39.94676],[-82.455115,39.946669],[-82.453975,39.946618],[-82.452507,39.946533],[-82.451244,39.946464],[-82.449556,39.946366],[-82.446713,39.946215],[-82.444132,39.946066],[-82.443007,39.946056],[-82.441425,39.945939],[-82.440083,39.94585],[-82.439121,39.945793],[-82.438425,39.945745],[-82.437392,39.945665],[-82.436655,39.945617],[-82.435259,39.945545],[-82.433804,39.945475],[-82.431728,39.945357],[-82.42952,39.945229],[-82.426934,39.945067],[-82.425,39.944933],[-82.42237,39.944777],[-82.421549,39.944728],[-82.420013,39.94461],[-82.418878,39.944526],[-82.417506,39.944444],[-82.415982,39.944364],[-82.414981,39.944282],[-82.413896,39.94418],[-82.413348,39.944139],[-82.412146,39.944065],[-82.411166,39.943994],[-82.410314,39.94393],[-82.409845,39.943913],[-82.409241,39.943869],[-82.408788,39.943838],[-82.408057,39.943791],[-82.401722,39.943349],[-82.395166,39.942973],[-82.394565,39.942924],[-82.379265,39.942042],[-82.358114,39.940897],[-82.335557,39.939773],[-82.331081,39.93954],[-82.32639,39.939312],[-82.321584,39.939088],[-82.318863,39.938922],[-82.318314,39.938888],[-82.311307,39.938414],[-82.304089,39.93807],[-82.288676,39.93746],[-82.288075,39.937414],[-82.282188,39.937096],[-82.279425,39.93697],[-82.27375,39.936712],[-82.261127,39.936139],[-82.259344,39.936055],[-82.258688,39.936051],[-82.258539,39.936044],[-82.258256,39.93604],[-82.257108,39.936015],[-82.254857,39.935903],[-82.253785,39.935862],[-82.252706,39.935846],[-82.251939,39.93584],[-82.251269,39.93588],[-82.250691,39.935924],[-82.249979,39.935983],[-82.249766,39.936005],[-82.249599,39.936022],[-82.249028,39.936107],[-82.248551,39.936184],[-82.247956,39.936295],[-82.247618,39.936355],[-82.247134,39.93646],[-82.246388,39.936648],[-82.246002,39.936764],[-82.245437,39.936949],[-82.243012,39.93779],[-82.242399,39.938048],[-82.23207,39.942396],[-82.229191,39.943575],[-82.22556,39.945115],[-82.221457,39.946826],[-82.219496,39.947661],[-82.21854,39.948047],[-82.218095,39.94823],[-82.217561,39.948378],[-82.216204,39.948754],[-82.21435,39.949168],[-82.211381,39.949708],[-82.206856,39.950575],[-82.198614,39.952111],[-82.193809,39.95301],[-82.192478,39.953163],[-82.191155,39.953221],[-82.190238,39.953183],[-82.189378,39.953129],[-82.188376,39.952996],[-82.18516,39.952496],[-82.181634,39.951943],[-82.178113,39.951405],[-82.176463,39.951145],[-82.174266,39.950802],[-82.170453,39.950212],[-82.170006,39.95015],[-82.15499,39.947849],[-82.150087,39.947259],[-82.147202,39.946941],[-82.144007,39.946779],[-82.096533,39.944651],[-82.096114,39.944634],[-82.087638,39.944301],[-82.085557,39.944356],[-82.083216,39.944559],[-82.071507,39.94606],[-82.069894,39.94633],[-82.068097,39.946779],[-82.06043,39.949175],[-82.058391,39.949581],[-82.057369,39.949715],[-82.055139,39.949744],[-82.053262,39.949526],[-82.05202,39.949169],[-82.051446,39.948933],[-82.049616,39.948433],[-82.048671,39.948195],[-82.04759,39.947998],[-82.04618,39.947832],[-82.044749,39.947772],[-82.042816,39.947873],[-82.039681,39.948176],[-82.031041,39.949004],[-82.028991,39.949178],[-82.028114,39.949211],[-82.026592,39.949221],[-82.024999,39.949157],[-82.023661,39.948986],[-82.02212,39.948718],[-82.021099,39.948489],[-82.018916,39.948011],[-82.018527,39.947933],[-82.017756,39.947774],[-82.016929,39.947667],[-82.016106,39.947582],[-82.014482,39.947401],[-82.013411,39.947271],[-82.012445,39.947097],[-82.011609,39.94686],[-82.01119,39.946721],[-82.011004,39.946643],[-82.009918,39.946181],[-82.008501,39.945529],[-82.007949,39.945312],[-82.007603,39.945189],[-82.00699,39.945016],[-82.006298,39.944836],[-82.005961,39.94477],[-82.00501,39.944614],[-82.004626,39.944585],[-82.00378,39.944574],[-82.003393,39.944568],[-82.001358,39.944516],[-82.000807,39.944506],[-81.999733,39.944466],[-81.998273,39.944358],[-81.997086,39.944215],[-81.995893,39.943966],[-81.995007,39.943779],[-81.993977,39.943612],[-81.993277,39.943559],[-81.99269,39.943511],[-81.992064,39.943507],[-81.991267,39.943558],[-81.99063,39.943641],[-81.990042,39.943738],[-81.989487,39.943849],[-81.988872,39.944024],[-81.988282,39.944221],[-81.987349,39.944559],[-81.985802,39.945339],[-81.9847,39.945898],[-81.9835,39.9465],[-81.98286,39.946785],[-81.982115,39.947072],[-81.981223,39.947369],[-81.980069,39.94765],[-81.978516,39.947908],[-81.969217,39.949149],[-81.967613,39.949325],[-81.966137,39.949399],[-81.964438,39.949524],[-81.958989,39.949628],[-81.957247,39.94976],[-81.956354,39.949865],[-81.955281,39.950083],[-81.953977,39.950438],[-81.95241,39.951005],[-81.950926,39.951683],[-81.949747,39.952431],[-81.946976,39.953988],[-81.94538,39.954778],[-81.944102,39.955304],[-81.942849,39.955724],[-81.941823,39.95602],[-81.940782,39.956289],[-81.937282,39.957225],[-81.93513,39.957775],[-81.931523,39.958511],[-81.930775,39.958684],[-81.924904,39.959888],[-81.922287,39.96043],[-81.920087,39.96098],[-81.917872,39.961624],[-81.904387,39.966322],[-81.903624,39.966551],[-81.902756,39.966833],[-81.901591,39.967102],[-81.900308,39.96733],[-81.898666,39.967588],[-81.894146,39.968199],[-81.88678,39.969168],[-81.884265,39.969313],[-81.88375,39.969339],[-81.87914,39.969663],[-81.871413,39.970074],[-81.8701,39.970166],[-81.868847,39.970417],[-81.852197,39.974412],[-81.851697,39.974532],[-81.849217,39.975127],[-81.846602,39.975638],[-81.845818,39.975778],[-81.844434,39.975979],[-81.842814,39.976045],[-81.841184,39.975975],[-81.840154,39.975831],[-81.839542,39.975712],[-81.838062,39.975392],[-81.836897,39.975022],[-81.834641,39.974063],[-81.834241,39.97388],[-81.832183,39.973048],[-81.830049,39.972427],[-81.827242,39.972064],[-81.825343,39.971834],[-81.820403,39.971324],[-81.818726,39.971191],[-81.816076,39.971042],[-81.813004,39.971051],[-81.802836,39.971299],[-81.801624,39.971407],[-81.799547,39.97178],[-81.79787,39.972261],[-81.785106,39.976538],[-81.783786,39.976969],[-81.782672,39.977259],[-81.781082,39.977616],[-81.779449,39.977848],[-81.778129,39.977989],[-81.76888,39.978519],[-81.767852,39.978561],[-81.766608,39.978569],[-81.764737,39.978495],[-81.757273,39.97808],[-81.755964,39.978064],[-81.754309,39.978138],[-81.752806,39.978321],[-81.751324,39.978569],[-81.749214,39.97905],[-81.743254,39.980559],[-81.742064,39.980757],[-81.740517,39.980932],[-81.738959,39.980965],[-81.734027,39.980559],[-81.732415,39.980542],[-81.731563,39.980575],[-81.730765,39.980637],[-81.730338,39.980658],[-81.728434,39.980998],[-81.726292,39.981545],[-81.722739,39.982386],[-81.71796,39.983538],[-81.712686,39.984764],[-81.710457,39.985188],[-81.70856,39.985416],[-81.706026,39.98548],[-81.702668,39.98523],[-81.70219,39.985195],[-81.689847,39.984297],[-81.687874,39.984302],[-81.68642,39.984461],[-81.684731,39.984785],[-81.683048,39.985278],[-81.681546,39.985904],[-81.680618,39.986387],[-81.674145,39.990116],[-81.672144,39.991474],[-81.670601,39.992768],[-81.669274,39.994104],[-81.668641,39.994741],[-81.667056,39.996746],[-81.665418,39.999083],[-81.664086,40.000983],[-81.662978,40.002367],[-81.661891,40.003375],[-81.660264,40.004489],[-81.659157,40.005067],[-81.6578,40.005655],[-81.656221,40.006095],[-81.650441,40.007331],[-81.648904,40.007596],[-81.64691,40.007824],[-81.6452,40.007872],[-81.644023,40.007851],[-81.632484,40.00742],[-81.626217,40.007182],[-81.624403,40.007167],[-81.622907,40.007209],[-81.621087,40.007421],[-81.615921,40.00845],[-81.615441,40.008529],[-81.613658,40.008858],[-81.612481,40.009083],[-81.611082,40.009201],[-81.609201,40.009174],[-81.607602,40.009002],[-81.605885,40.00866],[-81.60431,40.008165],[-81.602675,40.00749],[-81.593576,40.003662],[-81.5918,40.002951],[-81.589813,40.002257],[-81.587897,40.001654],[-81.586236,40.001231],[-81.578788,39.999295],[-81.57339,39.997805],[-81.572931,39.997698],[-81.571342,39.997292],[-81.570687,39.997124],[-81.570012,39.996989],[-81.569132,39.99684],[-81.56847,39.996752],[-81.56779,39.996702],[-81.566327,39.996614],[-81.565302,39.996611],[-81.564054,39.996585],[-81.562622,39.996556],[-81.560771,39.996642],[-81.55908,39.996932],[-81.558098,39.997241],[-81.556723,39.99783],[-81.556206,39.998134],[-81.555763,39.998391],[-81.555077,39.998784],[-81.554075,39.999413],[-81.55349,39.999775],[-81.551761,40.000658],[-81.549986,40.001324],[-81.548422,40.001711],[-81.547258,40.001937],[-81.536689,40.003891],[-81.536127,40.004008],[-81.53441,40.004192],[-81.532282,40.004376],[-81.52981,40.004363],[-81.526256,40.004107],[-81.518197,40.003594],[-81.512891,40.003343],[-81.51133,40.003241],[-81.50564,40.002792],[-81.50352,40.002766],[-81.50237,40.002838],[-81.498979,40.003226],[-81.495769,40.003962],[-81.493521,40.00485],[-81.491607,40.005757],[-81.490456,40.006493],[-81.489469,40.00719],[-81.488405,40.007986],[-81.486465,40.009761],[-81.483676,40.01239],[-81.479788,40.015993],[-81.476166,40.01947],[-81.475376,40.020226],[-81.471865,40.023289],[-81.469763,40.024801],[-81.467608,40.02622],[-81.464784,40.027745],[-81.462424,40.028876],[-81.460364,40.029704],[-81.456854,40.030821],[-81.454262,40.031511],[-81.452245,40.031945],[-81.448889,40.032457],[-81.447776,40.032608],[-81.447235,40.032687],[-81.446056,40.032858],[-81.442992,40.033292],[-81.439911,40.033745],[-81.437113,40.034291],[-81.434503,40.03504],[-81.431886,40.035816],[-81.428356,40.03699],[-81.425851,40.037762],[-81.424752,40.038033],[-81.423185,40.038325],[-81.421367,40.038542],[-81.419886,40.038621],[-81.417578,40.038569],[-81.41496,40.038319],[-81.413101,40.038128],[-81.412723,40.038089],[-81.410754,40.037886],[-81.407192,40.037504],[-81.406068,40.037472],[-81.405166,40.037485],[-81.403373,40.037616],[-81.401562,40.037997],[-81.397013,40.03893],[-81.393948,40.039574],[-81.391296,40.040126],[-81.389545,40.040494],[-81.386867,40.041059],[-81.381409,40.04217],[-81.377303,40.04297],[-81.376932,40.043041],[-81.368946,40.04443],[-81.363599,40.045383],[-81.354346,40.046953],[-81.347231,40.048189],[-81.343128,40.048918],[-81.338201,40.049555],[-81.334485,40.050015],[-81.332349,40.050427],[-81.330288,40.050849],[-81.328916,40.051195],[-81.326078,40.052004],[-81.323438,40.052899],[-81.32062,40.053972],[-81.320331,40.054082],[-81.313688,40.056744],[-81.309594,40.058308],[-81.308702,40.058669],[-81.307697,40.058971],[-81.306865,40.059136],[-81.305612,40.0593],[-81.304384,40.059372],[-81.302977,40.059287],[-81.301638,40.059083],[-81.299724,40.058689],[-81.296222,40.057776],[-81.293707,40.057178],[-81.290883,40.056606],[-81.28957,40.05637],[-81.289085,40.056299],[-81.28818,40.056166],[-81.286463,40.055982],[-81.283648,40.055739],[-81.279948,40.055595],[-81.277408,40.055549],[-81.27449,40.055437],[-81.271717,40.055384],[-81.269717,40.055332],[-81.26861,40.055339],[-81.267786,40.055391],[-81.266894,40.055536],[-81.265846,40.055713],[-81.265306,40.055864],[-81.263108,40.056475],[-81.261023,40.057073],[-81.259933,40.05727],[-81.258748,40.057401],[-81.257504,40.05746],[-81.256148,40.057487],[-81.254379,40.057375],[-81.253178,40.057191],[-81.249556,40.056574],[-81.24874,40.056495],[-81.246131,40.056606],[-81.243522,40.056869],[-81.241368,40.057125],[-81.240647,40.057178],[-81.239814,40.057171],[-81.238295,40.057119],[-81.237291,40.056922],[-81.236029,40.056672],[-81.232973,40.055759],[-81.231094,40.055352],[-81.230133,40.055227],[-81.22975,40.05518],[-81.229404,40.055149],[-81.229375,40.055146],[-81.229138,40.055129],[-81.22893,40.055117],[-81.228648,40.055105],[-81.228092,40.055092],[-81.227467,40.055097],[-81.227196,40.055105],[-81.226905,40.05512],[-81.226296,40.055167],[-81.225908,40.05521],[-81.225774,40.055227],[-81.225463,40.055266],[-81.225121,40.055315],[-81.224607,40.055404],[-81.224081,40.055513],[-81.223782,40.055582],[-81.223307,40.055677],[-81.222863,40.055812],[-81.2223,40.055994],[-81.221027,40.056421],[-81.219782,40.056824],[-81.218961,40.057106],[-81.218092,40.057395],[-81.215162,40.058355],[-81.214825,40.058462],[-81.214583,40.058532],[-81.213712,40.058761],[-81.213432,40.058825],[-81.213104,40.058894],[-81.212592,40.058992],[-81.212123,40.059069],[-81.211749,40.059124],[-81.211469,40.059161],[-81.211191,40.059192],[-81.210625,40.059246],[-81.21036,40.059265],[-81.209879,40.059293],[-81.20943,40.05931],[-81.20902,40.059317],[-81.208478,40.05932],[-81.207475,40.059274],[-81.206522,40.059201],[-81.204753,40.059032],[-81.202027,40.058787],[-81.200801,40.058672],[-81.200373,40.058638],[-81.19998,40.058616],[-81.199544,40.058602],[-81.199172,40.058599],[-81.1988,40.058602],[-81.198389,40.058614],[-81.197931,40.05864],[-81.197507,40.058672],[-81.196644,40.058769],[-81.194867,40.058995],[-81.192801,40.059245],[-81.192476,40.059278],[-81.19181,40.05932],[-81.191145,40.059339],[-81.19076,40.05934],[-81.18934,40.059319],[-81.187562,40.059285],[-81.186548,40.059272],[-81.186151,40.059275],[-81.185735,40.059289],[-81.185381,40.059309],[-81.185008,40.059335],[-81.184615,40.059377],[-81.184188,40.059431],[-81.18284,40.059624],[-81.182246,40.05972],[-81.181508,40.059828],[-81.180853,40.059933],[-81.180144,40.060031],[-81.179756,40.060078],[-81.179377,40.060115],[-81.179079,40.060137],[-81.178686,40.060158],[-81.178334,40.060169],[-81.177836,40.060177],[-81.177489,40.060172],[-81.177056,40.060155],[-81.176657,40.060132],[-81.17134,40.05976],[-81.171014,40.059744],[-81.170697,40.059739],[-81.170299,40.059738],[-81.169861,40.059748],[-81.169442,40.059767],[-81.168998,40.059793],[-81.16584,40.059999],[-81.165349,40.060021],[-81.164982,40.060029],[-81.164289,40.060019],[-81.163913,40.060003],[-81.163589,40.059982],[-81.163215,40.059949],[-81.162745,40.059896],[-81.162179,40.059822],[-81.16186,40.059771],[-81.161539,40.059714],[-81.161122,40.05963],[-81.160704,40.059534],[-81.160152,40.059384],[-81.158629,40.058946],[-81.157825,40.058708],[-81.157704,40.058673],[-81.157178,40.05852],[-81.156526,40.058337],[-81.156175,40.058251],[-81.155604,40.058128],[-81.155067,40.058028],[-81.154779,40.057982],[-81.15424,40.057908],[-81.153916,40.057872],[-81.153537,40.057837],[-81.153145,40.057812],[-81.152685,40.057791],[-81.152252,40.057779],[-81.151844,40.057779],[-81.151702,40.057782],[-81.151512,40.057785],[-81.15116,40.057799],[-81.150739,40.057825],[-81.150389,40.057855],[-81.150024,40.057893],[-81.149656,40.057936],[-81.149115,40.058015],[-81.148658,40.058087],[-81.148391,40.058138],[-81.147525,40.058278],[-81.145866,40.058582],[-81.143519,40.058986],[-81.143099,40.059054],[-81.142753,40.059104],[-81.142357,40.059148],[-81.142192,40.059162],[-81.141576,40.05921],[-81.140978,40.059233],[-81.140371,40.059244],[-81.139325,40.059255],[-81.135865,40.059272],[-81.135319,40.059278],[-81.133261,40.059289],[-81.132159,40.059299],[-81.128042,40.059323],[-81.127635,40.05932],[-81.127229,40.059322],[-81.126659,40.059304],[-81.126102,40.059266],[-81.125401,40.059195],[-81.125,40.059144],[-81.124588,40.059081],[-81.124166,40.059003],[-81.12351,40.058858],[-81.123056,40.058745],[-81.122863,40.058697],[-81.12223,40.058527],[-81.121597,40.058362],[-81.120575,40.058141],[-81.119381,40.057842],[-81.118259,40.057475],[-81.117914,40.057388],[-81.117605,40.057306],[-81.117155,40.057187],[-81.116404,40.057002],[-81.115877,40.056891],[-81.115605,40.056842],[-81.115035,40.056764],[-81.114584,40.056718],[-81.114297,40.056696],[-81.113909,40.056683],[-81.113262,40.056676],[-81.112719,40.056689],[-81.112324,40.056715],[-81.111938,40.056756],[-81.111523,40.056808],[-81.110985,40.056895],[-81.110485,40.057],[-81.110189,40.05707],[-81.109822,40.057171],[-81.109426,40.057288],[-81.108861,40.057481],[-81.10849,40.057625],[-81.107146,40.058176],[-81.106718,40.058358],[-81.106379,40.058491],[-81.104681,40.0592],[-81.104052,40.059452],[-81.103691,40.059583],[-81.103169,40.059752],[-81.102635,40.059895],[-81.102265,40.059984],[-81.102011,40.060038],[-81.101734,40.06009],[-81.101432,40.060139],[-81.100798,40.060217],[-81.100385,40.060247],[-81.099963,40.060269],[-81.099565,40.060274],[-81.099147,40.060272],[-81.098881,40.06026],[-81.098465,40.060235],[-81.098031,40.060194],[-81.097651,40.060149],[-81.09618,40.059941],[-81.095438,40.05983],[-81.094878,40.059753],[-81.094204,40.059651],[-81.093808,40.059596],[-81.092649,40.059423],[-81.092596,40.059415],[-81.091195,40.059218],[-81.088097,40.058768],[-81.087518,40.058689],[-81.087028,40.05862],[-81.085926,40.058468],[-81.085081,40.058342],[-81.084191,40.058218],[-81.081975,40.05789],[-81.079856,40.057594],[-81.07918,40.05749],[-81.078399,40.05738],[-81.076936,40.057167],[-81.07623,40.057058],[-81.075222,40.056913],[-81.073112,40.056611],[-81.071435,40.056381],[-81.070749,40.056317],[-81.070616,40.056304],[-81.0704,40.056282],[-81.070128,40.05626],[-81.069493,40.056226],[-81.069019,40.056206],[-81.068203,40.056197],[-81.067628,40.056201],[-81.067207,40.056213],[-81.066798,40.056231],[-81.066211,40.056266],[-81.065844,40.056298],[-81.065512,40.056334],[-81.064689,40.056439],[-81.063778,40.056575],[-81.062868,40.056753],[-81.062786,40.056769],[-81.061863,40.056984],[-81.061637,40.057042],[-81.060666,40.057316],[-81.060239,40.057452],[-81.057845,40.058243],[-81.056738,40.058609],[-81.056376,40.058725],[-81.055406,40.059048],[-81.053506,40.059663],[-81.053265,40.059749],[-81.052968,40.059849],[-81.0528,40.059906],[-81.05258,40.059979],[-81.049124,40.06112],[-81.047626,40.061599],[-81.04674,40.061904],[-81.046003,40.06215],[-81.044626,40.062602],[-81.044232,40.062735],[-81.043826,40.062873],[-81.043306,40.06304],[-81.042175,40.063419],[-81.040993,40.0638],[-81.040614,40.063909],[-81.039825,40.064117],[-81.038887,40.06433],[-81.038431,40.064418],[-81.037628,40.064557],[-81.037172,40.064627],[-81.036461,40.064715],[-81.035898,40.064773],[-81.03547,40.064805],[-81.034937,40.064837],[-81.034115,40.064869],[-81.033681,40.064874],[-81.03327,40.064872],[-81.032441,40.064849],[-81.031624,40.064807],[-81.031573,40.064803],[-81.031376,40.06479],[-81.030073,40.064728],[-81.029142,40.064676],[-81.027064,40.064573],[-81.02147,40.064294],[-81.020948,40.064272],[-81.01908,40.064173],[-81.017735,40.064109],[-81.016233,40.064033],[-81.011219,40.063781],[-81.011066,40.06377],[-81.008199,40.063632],[-81.00697,40.063572],[-81.006673,40.06356],[-81.005789,40.063523],[-81.00525,40.063513],[-81.004264,40.063496],[-81.003439,40.063504],[-81.00236,40.06353],[-81.001891,40.063542],[-81.001368,40.063563],[-81.000285,40.063623],[-80.999686,40.063668],[-80.999394,40.06369],[-80.993702,40.064203],[-80.993303,40.064235],[-80.992428,40.064312],[-80.991038,40.064433],[-80.985439,40.064933],[-80.985174,40.064956],[-80.983065,40.065148],[-80.982527,40.065219],[-80.982016,40.0653],[-80.981402,40.065419],[-80.981027,40.065504],[-80.980655,40.065597],[-80.980279,40.0657],[-80.979907,40.065807],[-80.979408,40.065967],[-80.978472,40.066322],[-80.978163,40.066459],[-80.977817,40.066611],[-80.977581,40.066727],[-80.977243,40.066906],[-80.976907,40.067076],[-80.976501,40.067312],[-80.97617,40.067512],[-80.975914,40.067681],[-80.973891,40.06907],[-80.972367,40.070122],[-80.971431,40.070774],[-80.969625,40.071973],[-80.96908,40.072324],[-80.965966,40.074526],[-80.965424,40.074898],[-80.965096,40.075123],[-80.964749,40.075345],[-80.964478,40.075518],[-80.964192,40.075691],[-80.96376,40.075896],[-80.963449,40.076056],[-80.963118,40.076218],[-80.962785,40.076353],[-80.962318,40.076545],[-80.962019,40.076657],[-80.961639,40.076778],[-80.96093,40.07697],[-80.960665,40.07704],[-80.96009,40.077173],[-80.9597,40.077256],[-80.959283,40.077331],[-80.958865,40.077395],[-80.958133,40.077493],[-80.957823,40.077521],[-80.957629,40.077524],[-80.957375,40.077541],[-80.956935,40.077563],[-80.956588,40.077576],[-80.954392,40.07761],[-80.953878,40.077615],[-80.952641,40.077636],[-80.952064,40.077652],[-80.951936,40.077652],[-80.95032,40.077678],[-80.949959,40.077679],[-80.949377,40.07769],[-80.948465,40.0777],[-80.947041,40.077724],[-80.946363,40.07774],[-80.944773,40.077759],[-80.944721,40.077759],[-80.943173,40.077776],[-80.93973,40.077831],[-80.939421,40.077836],[-80.938741,40.07785],[-80.937054,40.077869],[-80.936394,40.077861],[-80.935585,40.077823],[-80.935076,40.077789],[-80.934764,40.07776],[-80.933837,40.077653],[-80.933589,40.077621],[-80.933141,40.07755],[-80.932534,40.077461],[-80.931946,40.077362],[-80.931305,40.077233],[-80.930976,40.077173],[-80.930664,40.077095],[-80.930296,40.077001],[-80.928423,40.076471],[-80.924117,40.075298],[-80.922882,40.07494],[-80.922342,40.074788],[-80.92132,40.07449],[-80.920639,40.074299],[-80.920179,40.074174],[-80.918715,40.073765],[-80.916812,40.073219],[-80.912366,40.071957],[-80.912095,40.07188],[-80.910166,40.07133],[-80.908723,40.070908],[-80.906858,40.070345],[-80.906328,40.070185],[-80.906107,40.070124],[-80.9058,40.070035],[-80.904559,40.069731],[-80.904369,40.069677],[-80.900809,40.068595],[-80.900191,40.068398],[-80.899521,40.068235],[-80.8991,40.068138],[-80.898467,40.06799],[-80.898098,40.06792],[-80.897745,40.067845],[-80.897424,40.067786],[-80.897125,40.06774],[-80.896855,40.067708],[-80.896551,40.067673],[-80.896071,40.067623],[-80.895436,40.067596],[-80.8948,40.067596],[-80.894174,40.067623],[-80.893539,40.067669],[-80.892955,40.067761],[-80.892225,40.067899],[-80.890063,40.068372],[-80.888283,40.068751],[-80.886645,40.069081],[-80.883783,40.069665],[-80.883029,40.069826],[-80.881293,40.070175],[-80.88037,40.07036],[-80.876775,40.071068],[-80.876296,40.071164],[-80.875413,40.071341],[-80.873874,40.071657],[-80.871161,40.072203],[-80.870745,40.072281],[-80.870221,40.072367],[-80.869829,40.072421],[-80.869437,40.072465],[-80.869079,40.072494],[-80.868609,40.072525],[-80.868407,40.072533],[-80.867075,40.0725],[-80.866729,40.072494],[-80.866018,40.072441],[-80.865321,40.072414],[-80.864921,40.072356],[-80.864486,40.072286],[-80.86399,40.072193],[-80.863618,40.072108],[-80.863196,40.072004],[-80.862762,40.071887],[-80.861046,40.071363],[-80.860472,40.071178],[-80.86042,40.071161],[-80.858405,40.070549],[-80.857891,40.070405],[-80.857488,40.0703],[-80.857271,40.070246],[-80.857123,40.07021],[-80.856564,40.070084],[-80.856245,40.07002],[-80.85577,40.069932],[-80.855225,40.069844],[-80.854636,40.06976],[-80.854006,40.069685],[-80.852549,40.069542],[-80.851764,40.069466],[-80.850847,40.069376],[-80.850462,40.069279],[-80.850076,40.069197],[-80.849402,40.069081],[-80.848909,40.069006],[-80.847958,40.068843],[-80.847404,40.068742],[-80.846833,40.068632],[-80.846002,40.068466],[-80.845615,40.068378],[-80.844903,40.068204],[-80.844614,40.06812],[-80.844235,40.067981],[-80.844087,40.067923],[-80.843828,40.067807],[-80.843606,40.067694],[-80.843269,40.067494],[-80.84304,40.067342],[-80.842763,40.067121],[-80.84256,40.066939],[-80.842342,40.066713],[-80.842308,40.066678],[-80.842154,40.066494],[-80.842001,40.066287],[-80.841888,40.066101],[-80.841792,40.065927],[-80.841447,40.065154],[-80.841401,40.06505],[-80.841319,40.064841],[-80.841218,40.064604],[-80.841123,40.064405],[-80.840916,40.064011],[-80.840791,40.063813],[-80.840657,40.063619],[-80.840511,40.063424],[-80.840348,40.063229],[-80.840198,40.063063],[-80.840062,40.062927],[-80.839908,40.062781],[-80.839781,40.062668],[-80.839595,40.062511],[-80.83931,40.062297],[-80.839117,40.062167],[-80.838883,40.062022],[-80.838644,40.061884],[-80.838325,40.061717],[-80.838083,40.061603],[-80.837882,40.061518],[-80.837671,40.061435],[-80.837255,40.061292],[-80.837001,40.061215],[-80.836675,40.061126],[-80.83632,40.061044],[-80.832383,40.060174],[-80.831661,40.060004],[-80.829584,40.059543],[-80.82821,40.05923],[-80.82779,40.059128],[-80.827399,40.059025],[-80.826936,40.058894],[-80.826537,40.058772],[-80.826102,40.058632],[-80.825662,40.058479],[-80.825198,40.058308],[-80.824409,40.057986],[-80.823736,40.057689],[-80.823388,40.05752],[-80.823024,40.057343],[-80.822607,40.057123],[-80.822219,40.056909],[-80.820944,40.056173],[-80.818761,40.05489],[-80.817956,40.054427],[-80.817565,40.054197],[-80.817135,40.053953],[-80.816738,40.053734],[-80.816488,40.053607],[-80.816274,40.053498],[-80.815677,40.053207],[-80.815291,40.053024],[-80.814946,40.052872],[-80.814593,40.052726],[-80.814221,40.05258],[-80.813876,40.052451],[-80.81345,40.052303],[-80.81296,40.05214],[-80.812441,40.051981],[-80.812049,40.051867],[-80.81151,40.051728],[-80.811185,40.051649],[-80.810673,40.051528],[-80.80971,40.051316],[-80.809227,40.051231],[-80.808524,40.051128],[-80.808107,40.051076],[-80.807968,40.051059],[-80.801985,40.050368],[-80.800591,40.050194],[-80.79795,40.049903],[-80.797052,40.049796],[-80.792331,40.049251],[-80.791391,40.04913],[-80.790457,40.049026],[-80.789666,40.048927],[-80.789023,40.04886],[-80.788888,40.048842],[-80.78759,40.048705],[-80.783049,40.04818],[-80.782394,40.048101],[-80.78208,40.048068],[-80.781158,40.047955],[-80.780058,40.047834],[-80.777251,40.047506],[-80.776285,40.047398],[-80.775966,40.047358],[-80.774358,40.047176],[-80.773726,40.047098],[-80.773016,40.047021],[-80.769525,40.046621],[-80.767912,40.046431],[-80.76621,40.046188],[-80.76363,40.045746],[-80.762254,40.045519],[-80.761381,40.045404],[-80.760801,40.045342],[-80.760136,40.045288],[-80.759404,40.045249],[-80.758606,40.045229],[-80.757893,40.045232],[-80.757147,40.045255],[-80.756776,40.045273],[-80.756398,40.045296],[-80.755641,40.045359],[-80.754654,40.045479],[-80.753798,40.045617],[-80.753261,40.045711],[-80.752345,40.045888],[-80.751017,40.046131],[-80.749592,40.046399],[-80.742659,40.047686],[-80.741717,40.047865],[-80.737899,40.04857],[-80.736547,40.048816],[-80.734284,40.049194],[-80.733994,40.049243],[-80.732639,40.049524],[-80.732245,40.049604],[-80.728308,40.050228],[-80.72805,40.050261],[-80.727696,40.050319],[-80.726988,40.050417],[-80.726525,40.050477],[-80.725507,40.050639],[-80.724713,40.050787],[-80.723812,40.050943],[-80.723008,40.05105],[-80.721935,40.051206],[-80.720647,40.051386],[-80.720293,40.051419],[-80.719263,40.051493],[-80.718662,40.051534],[-80.718319,40.051542],[-80.717997,40.051534],[-80.715873,40.051452],[-80.714907,40.051419],[-80.713513,40.051395],[-80.712397,40.051469],[-80.711571,40.0516],[-80.710734,40.051756],[-80.710208,40.051904],[-80.709339,40.052199],[-80.706496,40.053374],[-80.705638,40.053711],[-80.705026,40.053875],[-80.704468,40.053982],[-80.703932,40.054055],[-80.703449,40.054096],[-80.702923,40.054113],[-80.702633,40.054096],[-80.701958,40.053949],[-80.701153,40.053743],[-80.700724,40.053571],[-80.700209,40.053398],[-80.699769,40.053193],[-80.699436,40.052996],[-80.699157,40.052815],[-80.698814,40.052536],[-80.698524,40.05229],[-80.698117,40.051776],[-80.69773,40.051288],[-80.697237,40.050672],[-80.696936,40.050401],[-80.696314,40.0499],[-80.695746,40.049522],[-80.694791,40.049062],[-80.693943,40.04875],[-80.693262,40.048637],[-80.692603,40.048535],[-80.691882,40.048492],[-80.691126,40.048507],[-80.690131,40.048603],[-80.689244,40.048775],[-80.688321,40.048947],[-80.685832,40.049497],[-80.684008,40.049908],[-80.682249,40.050302],[-80.681154,40.050458],[-80.68021,40.050516],[-80.679502,40.050557],[-80.678365,40.050549],[-80.677507,40.050565],[-80.67638,40.050499],[-80.675275,40.050384],[-80.673462,40.050171],[-80.670157,40.049818],[-80.667687,40.049567],[-80.666477,40.049438],[-80.66549,40.049307],[-80.664451,40.049096],[-80.663533,40.048755],[-80.663185,40.048597],[-80.662709,40.04838],[-80.661619,40.047822],[-80.660343,40.047052],[-80.659138,40.046363],[-80.658537,40.046028],[-80.657684,40.045576],[-80.656726,40.045069],[-80.656364,40.044874],[-80.655611,40.044497],[-80.655275,40.044354],[-80.654778,40.044201],[-80.654154,40.044038],[-80.653422,40.043952],[-80.651625,40.043888],[-80.650486,40.044044],[-80.648984,40.044504],[-80.64683,40.045279],[-80.64586,40.045634],[-80.64433,40.046098],[-80.64312,40.046288],[-80.642115,40.0464],[-80.640931,40.046393],[-80.637687,40.045953],[-80.635558,40.04569],[-80.634725,40.045539],[-80.634004,40.045454],[-80.633,40.045283],[-80.631696,40.044935],[-80.631472,40.044856],[-80.629842,40.044231],[-80.629206,40.043982],[-80.628159,40.043772],[-80.627267,40.043653],[-80.626494,40.043634],[-80.625644,40.043726],[-80.624512,40.04385],[-80.623173,40.044087],[-80.621619,40.044304],[-80.620357,40.044409],[-80.619499,40.044396],[-80.618735,40.04431],[-80.617739,40.044093],[-80.613336,40.042681],[-80.612358,40.042457],[-80.611706,40.042359],[-80.61101,40.042326],[-80.609989,40.042398],[-80.609165,40.04251],[-80.608384,40.042694],[-80.607457,40.043062],[-80.606478,40.04362],[-80.605002,40.044836],[-80.604307,40.045473],[-80.603088,40.046551],[-80.599217,40.049928],[-80.598127,40.051091],[-80.597406,40.052096],[-80.596883,40.05318],[-80.596316,40.054317],[-80.592927,40.061199],[-80.592488,40.061826],[-80.591716,40.062569],[-80.590943,40.063087],[-80.590205,40.063422],[-80.589493,40.063724],[-80.588626,40.063974],[-80.587716,40.064099],[-80.586148,40.064169],[-80.582841,40.064282],[-80.579236,40.064414],[-80.577124,40.064545],[-80.575888,40.064723],[-80.57412,40.065058],[-80.573331,40.065228],[-80.57267,40.065399],[-80.571846,40.065583],[-80.570902,40.065905],[-80.570026,40.06624],[-80.569085,40.066713],[-80.568448,40.067044],[-80.567916,40.067319],[-80.566891,40.067853],[-80.565551,40.068737],[-80.55904,40.07357],[-80.55286,40.078161],[-80.547873,40.081904],[-80.546787,40.082717],[-80.546296,40.083084],[-80.540209,40.087637],[-80.537479,40.089627],[-80.535857,40.090713],[-80.534657,40.091385],[-80.533222,40.091945],[-80.532252,40.092286],[-80.531136,40.09268],[-80.530149,40.092949],[-80.528922,40.093245],[-80.527137,40.093672],[-80.525051,40.094164],[-80.522141,40.094873],[-80.520811,40.09521],[-80.519189,40.095609],[-80.518288,40.095828],[-80.512197,40.0973],[-80.510947,40.097592],[-80.510512,40.097707],[-80.510037,40.097845],[-80.509741,40.097938],[-80.509233,40.098121],[-80.508756,40.098298],[-80.508492,40.098409],[-80.50818,40.098548],[-80.507763,40.098746],[-80.507225,40.099016],[-80.506791,40.099264],[-80.50643,40.099472],[-80.506126,40.099663],[-80.505699,40.099956],[-80.50529,40.100264],[-80.504871,40.100607],[-80.504465,40.100973],[-80.503803,40.101594],[-80.503233,40.102117],[-80.50293,40.102374],[-80.502601,40.102633],[-80.502269,40.102878],[-80.50187,40.103152],[-80.501483,40.1034],[-80.501125,40.103613],[-80.50074,40.103825],[-80.500405,40.104003],[-80.499945,40.104223],[-80.499244,40.104535],[-80.496771,40.105598],[-80.494495,40.106595],[-80.494205,40.106735],[-80.493873,40.106905],[-80.493574,40.107085],[-80.493221,40.107319],[-80.492887,40.107571],[-80.492612,40.10781],[-80.49249,40.107919],[-80.492364,40.10804],[-80.492249,40.108165],[-80.492123,40.108307],[-80.491864,40.108648],[-80.491627,40.108954],[-80.491284,40.109457],[-80.490295,40.110852],[-80.489012,40.112693],[-80.488021,40.114115],[-80.487706,40.11455],[-80.487399,40.114938],[-80.487133,40.115231],[-80.486833,40.115525],[-80.48654,40.11578],[-80.486205,40.116047],[-80.485834,40.116314],[-80.485432,40.116566],[-80.484909,40.116856],[-80.484468,40.117066],[-80.484045,40.117248],[-80.483433,40.117479],[-80.481987,40.118036],[-80.480086,40.118766],[-80.479723,40.118899],[-80.479403,40.119002],[-80.478933,40.119122],[-80.478542,40.119213],[-80.478158,40.119285],[-80.477698,40.119349],[-80.477305,40.119385],[-80.476943,40.119409],[-80.476641,40.119419],[-80.47636,40.119421],[-80.476109,40.119416],[-80.475985,40.119411],[-80.475519,40.119381],[-80.475076,40.119333],[-80.474608,40.119255],[-80.474167,40.119168],[-80.473775,40.119075],[-80.473393,40.118963],[-80.473054,40.118852],[-80.472711,40.118723],[-80.472423,40.118605],[-80.472082,40.118446],[-80.471776,40.118294],[-80.471377,40.118069],[-80.471002,40.117829],[-80.470643,40.117572],[-80.470303,40.117293],[-80.469508,40.116597],[-80.468793,40.115961],[-80.468237,40.115475],[-80.467854,40.115146],[-80.467563,40.114911],[-80.467328,40.114732],[-80.467029,40.114525],[-80.466789,40.114377],[-80.466534,40.114228],[-80.466241,40.114074],[-80.465997,40.113958],[-80.465762,40.113848],[-80.465546,40.11376],[-80.465412,40.113709],[-80.465031,40.113566],[-80.464642,40.113453],[-80.464233,40.113341],[-80.463851,40.113256],[-80.463444,40.113183],[-80.463053,40.113126],[-80.462575,40.113079],[-80.462151,40.113054],[-80.461721,40.113048],[-80.461311,40.113058],[-80.460855,40.113083],[-80.460357,40.113135],[-80.4599,40.11321],[-80.459096,40.113386],[-80.458689,40.113497],[-80.458155,40.11368],[-80.457704,40.113861],[-80.45692,40.114223],[-80.456771,40.114293],[-80.455953,40.114671],[-80.45556,40.114852],[-80.455217,40.11499],[-80.454776,40.115154],[-80.454212,40.115332],[-80.453785,40.115455],[-80.453353,40.115568],[-80.4529,40.11567],[-80.452454,40.115755],[-80.451916,40.115838],[-80.451407,40.115902],[-80.450798,40.115953],[-80.450289,40.115981],[-80.449637,40.116008],[-80.448366,40.116067],[-80.44683,40.116133],[-80.445457,40.116195],[-80.445318,40.116202],[-80.442634,40.116321],[-80.436855,40.116577],[-80.43638,40.116595],[-80.436106,40.1166],[-80.435856,40.116585],[-80.435625,40.116579],[-80.435404,40.116566],[-80.434976,40.116528],[-80.434637,40.116482],[-80.434339,40.116432],[-80.434003,40.116363],[-80.433561,40.116252],[-80.432599,40.115993],[-80.432163,40.115887],[-80.429028,40.115021],[-80.428482,40.114873],[-80.426903,40.11444],[-80.4253,40.114005],[-80.424717,40.113847],[-80.424248,40.113737],[-80.423703,40.113623],[-80.423269,40.11355],[-80.423117,40.113523],[-80.422812,40.113481],[-80.422511,40.113438],[-80.422085,40.113393],[-80.421498,40.11335],[-80.421151,40.113333],[-80.420726,40.113322],[-80.420294,40.11332],[-80.419832,40.113327],[-80.419421,40.113343],[-80.419126,40.113363],[-80.418758,40.11339],[-80.418425,40.11343],[-80.417822,40.113513],[-80.417059,40.113639],[-80.416611,40.113725],[-80.416142,40.113835],[-80.415664,40.113964],[-80.415211,40.114099],[-80.414808,40.11423],[-80.414527,40.11433],[-80.414056,40.114509],[-80.413472,40.114755],[-80.413028,40.114954],[-80.412332,40.115299],[-80.409735,40.116594],[-80.406746,40.118074],[-80.405988,40.118462],[-80.404666,40.119111],[-80.403381,40.119757],[-80.402752,40.120057],[-80.402371,40.120212],[-80.401905,40.120391],[-80.401432,40.120539],[-80.401009,40.120659],[-80.400587,40.120768],[-80.400076,40.120874],[-80.399615,40.120955],[-80.399163,40.121012],[-80.398697,40.121051],[-80.398244,40.121081],[-80.397772,40.12109],[-80.397264,40.121087],[-80.396828,40.121069],[-80.396376,40.121037],[-80.39546,40.120972],[-80.394858,40.12093],[-80.394494,40.120915],[-80.394162,40.12091],[-80.393798,40.120915],[-80.393432,40.120931],[-80.393121,40.120957],[-80.392836,40.120985],[-80.392497,40.121031],[-80.3921,40.121103],[-80.391613,40.121205],[-80.391079,40.121332],[-80.388245,40.122014],[-80.383823,40.123074],[-80.37863,40.124323],[-80.377137,40.124683],[-80.376664,40.124784],[-80.376288,40.12485],[-80.375915,40.124903],[-80.375618,40.124935],[-80.375258,40.124963],[-80.374962,40.124977],[-80.374571,40.124984],[-80.374146,40.124977],[-80.373778,40.124951],[-80.373426,40.12492],[-80.373157,40.124885],[-80.372755,40.124815],[-80.372381,40.124741],[-80.371935,40.124636],[-80.371034,40.124397],[-80.370518,40.124269],[-80.370107,40.124182],[-80.36976,40.124125],[-80.369352,40.124077],[-80.368953,40.124039],[-80.368635,40.124022],[-80.368368,40.124015],[-80.368109,40.124017],[-80.367899,40.124024],[-80.367697,40.124036],[-80.367503,40.124051],[-80.367066,40.124102],[-80.366784,40.12414],[-80.366549,40.124172],[-80.366203,40.124235],[-80.365896,40.124303],[-80.365639,40.124373],[-80.365337,40.124463],[-80.364911,40.124609],[-80.364632,40.124721],[-80.364265,40.124886],[-80.363936,40.125056],[-80.36369,40.125195],[-80.363437,40.125348],[-80.363097,40.125576],[-80.362714,40.12587],[-80.361848,40.126555],[-80.359719,40.128259],[-80.358258,40.129434],[-80.357947,40.129658],[-80.357698,40.129821],[-80.357351,40.130022],[-80.357065,40.130177],[-80.356665,40.130366],[-80.356264,40.130522],[-80.355876,40.130656],[-80.355563,40.130751],[-80.355235,40.130836],[-80.354753,40.130937],[-80.354392,40.130994],[-80.353988,40.131041],[-80.35361,40.131067],[-80.353224,40.131081],[-80.352906,40.131082],[-80.35248,40.131069],[-80.351997,40.131028],[-80.351612,40.130976],[-80.351287,40.130916],[-80.350862,40.130826],[-80.350306,40.130682],[-80.348928,40.130315],[-80.348354,40.130172],[-80.348,40.130098],[-80.347646,40.130031],[-80.347188,40.129959],[-80.34661,40.129877],[-80.346129,40.12983],[-80.345644,40.129788],[-80.345093,40.129761],[-80.344418,40.129751],[-80.343935,40.129764],[-80.341761,40.12983],[-80.339158,40.129912],[-80.336273,40.130006],[-80.335833,40.130021],[-80.335669,40.130023],[-80.333505,40.130092],[-80.329846,40.130211],[-80.329121,40.130237],[-80.32883,40.130254],[-80.32853,40.130277],[-80.32824,40.13031],[-80.328002,40.130341],[-80.327734,40.130383],[-80.327406,40.130446],[-80.327155,40.1305],[-80.326804,40.130593],[-80.326484,40.130694],[-80.326146,40.130809],[-80.325811,40.130942],[-80.325456,40.131102],[-80.325142,40.131258],[-80.324816,40.131438],[-80.324539,40.131605],[-80.324319,40.131749],[-80.324088,40.131917],[-80.323773,40.132168],[-80.323532,40.132388],[-80.323315,40.132607],[-80.323017,40.13293],[-80.32274,40.133245],[-80.321979,40.134063],[-80.320628,40.13554],[-80.320192,40.135997],[-80.31987,40.136321],[-80.31943,40.136734],[-80.31904,40.137075],[-80.318603,40.137434],[-80.317932,40.137949],[-80.315041,40.14011],[-80.310734,40.143347],[-80.309048,40.144599],[-80.308229,40.145213],[-80.307767,40.145553],[-80.307545,40.145702],[-80.307309,40.145849],[-80.307021,40.14601],[-80.30677,40.146138],[-80.306538,40.146246],[-80.306311,40.146342],[-80.30598,40.146468],[-80.305664,40.146576],[-80.30534,40.146674],[-80.304985,40.14676],[-80.304572,40.146848],[-80.304086,40.146928],[-80.303438,40.147025],[-80.302291,40.147192],[-80.298462,40.147761],[-80.298087,40.147822],[-80.297637,40.147911],[-80.297145,40.148023],[-80.296724,40.14814],[-80.296183,40.148308],[-80.295726,40.148478],[-80.29537,40.148625],[-80.295019,40.148784],[-80.294615,40.148983],[-80.294411,40.149092],[-80.294188,40.149217],[-80.293739,40.149492],[-80.292164,40.150447],[-80.287893,40.153025],[-80.286325,40.153982],[-80.28515,40.154696],[-80.284714,40.154957],[-80.284422,40.155159],[-80.284156,40.155351],[-80.283835,40.155591],[-80.283479,40.155883],[-80.283216,40.156107],[-80.282902,40.156393],[-80.282601,40.156687],[-80.282226,40.157089],[-80.28189,40.157472],[-80.281406,40.158032],[-80.279589,40.160107],[-80.278443,40.161463],[-80.278101,40.161902],[-80.277893,40.162191],[-80.277707,40.162473],[-80.277478,40.162836],[-80.277262,40.163238],[-80.277096,40.163599],[-80.276897,40.164069],[-80.276176,40.165771],[-80.275631,40.16707],[-80.275334,40.167764],[-80.275187,40.168056],[-80.274998,40.168381],[-80.274765,40.168724],[-80.274511,40.169054],[-80.274287,40.169318],[-80.273912,40.169769],[-80.272748,40.171155],[-80.270746,40.173557],[-80.269765,40.17473],[-80.268089,40.176732],[-80.266628,40.178479],[-80.265723,40.179553],[-80.265282,40.180026],[-80.264987,40.180318],[-80.264572,40.180688],[-80.264343,40.180876],[-80.263892,40.181231],[-80.263594,40.181448],[-80.263128,40.181766],[-80.262777,40.181989],[-80.262328,40.182253],[-80.262021,40.182421],[-80.261797,40.182539],[-80.261385,40.182744],[-80.260974,40.182931],[-80.260662,40.183063],[-80.260321,40.183201],[-80.259933,40.183334],[-80.259526,40.183463],[-80.259058,40.183603],[-80.258694,40.183713],[-80.258104,40.183882],[-80.257608,40.184021],[-80.25726,40.184122],[-80.256951,40.18423],[-80.256519,40.184397],[-80.256152,40.184558],[-80.255839,40.184719],[-80.255471,40.184926],[-80.254718,40.185403],[-80.25349,40.186192],[-80.252898,40.186552],[-80.252479,40.186789],[-80.252043,40.187031],[-80.251545,40.187266],[-80.2511,40.187454],[-80.250667,40.187639],[-80.250157,40.187816],[-80.24976,40.187941],[-80.24938,40.188044],[-80.248896,40.188163],[-80.248613,40.188222],[-80.248285,40.188285],[-80.247906,40.188348],[-80.247507,40.188403],[-80.247178,40.188441],[-80.246788,40.188474],[-80.246129,40.188506],[-80.245741,40.188516],[-80.245224,40.188509],[-80.244759,40.188486],[-80.244402,40.188462],[-80.243925,40.188414],[-80.243504,40.188358],[-80.243097,40.188292],[-80.242691,40.188216],[-80.242265,40.188124],[-80.241738,40.187997],[-80.241011,40.187821],[-80.240518,40.187708],[-80.239775,40.187494],[-80.239342,40.187364],[-80.238732,40.187183],[-80.238199,40.187014],[-80.237742,40.186889],[-80.237106,40.18673],[-80.236561,40.186598],[-80.23578,40.186416],[-80.23486,40.186194],[-80.234503,40.186111],[-80.234079,40.186018],[-80.233598,40.185932],[-80.232623,40.18577],[-80.232201,40.185699],[-80.231942,40.18565],[-80.231683,40.185594],[-80.230891,40.185392],[-80.230421,40.185252],[-80.229904,40.185075],[-80.229336,40.184853],[-80.228937,40.184675],[-80.228412,40.184416],[-80.228251,40.184328],[-80.227817,40.184063],[-80.227237,40.183694],[-80.227037,40.183584],[-80.226513,40.183189],[-80.226157,40.182881],[-80.225924,40.182667],[-80.225701,40.182452],[-80.225556,40.182302],[-80.225435,40.182166],[-80.225348,40.18207],[-80.22502,40.18165],[-80.22481,40.181375],[-80.224569,40.181013],[-80.224422,40.18078],[-80.224203,40.180398],[-80.224038,40.180097],[-80.223877,40.179787],[-80.223643,40.179399],[-80.223411,40.178964],[-80.223176,40.17852],[-80.222967,40.17816],[-80.222842,40.177954],[-80.222681,40.177729],[-80.222505,40.177502],[-80.22236,40.177334],[-80.222113,40.177076],[-80.221908,40.176875],[-80.22166,40.176653],[-80.221427,40.176464],[-80.221201,40.176293],[-80.220916,40.176107],[-80.220707,40.175982],[-80.220376,40.175799],[-80.219989,40.175613],[-80.219566,40.175429],[-80.219155,40.175276],[-80.218584,40.175087],[-80.217349,40.174669],[-80.211914,40.172844],[-80.209092,40.171901],[-80.208548,40.171713],[-80.208124,40.171556],[-80.207719,40.171379],[-80.207341,40.171186],[-80.20691,40.170939],[-80.206606,40.170747],[-80.206291,40.170522],[-80.205896,40.17019],[-80.205639,40.169942],[-80.205354,40.169637],[-80.20505,40.169257],[-80.204457,40.168501],[-80.204155,40.1681],[-80.203786,40.167629],[-80.203364,40.167103],[-80.202988,40.166636],[-80.202475,40.166009],[-80.202188,40.16567],[-80.201938,40.165409],[-80.201744,40.165217],[-80.20156,40.165047],[-80.201353,40.164869],[-80.201109,40.164671],[-80.200871,40.164491],[-80.200538,40.164253],[-80.200212,40.164043],[-80.199974,40.163895],[-80.19975,40.163769],[-80.19944,40.1636],[-80.199099,40.163435],[-80.198717,40.163262],[-80.198315,40.163103],[-80.198019,40.162991],[-80.197703,40.162884],[-80.197392,40.162786],[-80.196994,40.162677],[-80.196674,40.162598],[-80.196418,40.162498],[-80.196017,40.162408],[-80.194938,40.162162],[-80.194772,40.162107],[-80.194635,40.162051],[-80.194506,40.161984],[-80.194394,40.161914],[-80.194278,40.161828],[-80.194182,40.16174],[-80.194088,40.161635],[-80.194026,40.161551],[-80.193959,40.161444],[-80.1939,40.161332],[-80.193841,40.161186],[-80.193806,40.161078],[-80.193777,40.160942],[-80.193761,40.160838],[-80.193776,40.160635],[-80.19382,40.160319],[-80.19386,40.1601],[-80.194074,40.159506],[-80.194332,40.159033],[-80.194495,40.158763],[-80.194741,40.158451],[-80.195063,40.158086],[-80.195348,40.157799],[-80.195911,40.157336],[-80.196404,40.156934],[-80.198791,40.155032],[-80.200251,40.153867],[-80.20171,40.152699],[-80.202588,40.152014],[-80.203619,40.151165],[-80.204124,40.15076],[-80.204429,40.150485],[-80.204714,40.150185],[-80.204955,40.14989],[-80.205234,40.149517],[-80.205492,40.149095],[-80.20569,40.148709],[-80.205851,40.148279],[-80.205964,40.147877],[-80.206039,40.147451],[-80.206087,40.147069],[-80.206125,40.146727],[-80.206194,40.146097],[-80.206473,40.143485],[-80.206634,40.142001],[-80.206747,40.140971],[-80.207004,40.138486],[-80.207128,40.137473],[-80.207192,40.137092],[-80.207332,40.136469],[-80.20753,40.135849],[-80.208249,40.134082],[-80.208598,40.133233],[-80.208973,40.132273],[-80.209327,40.131403],[-80.209633,40.130649],[-80.209772,40.130214],[-80.20988,40.129791],[-80.209939,40.129431],[-80.20996,40.129119],[-80.20996,40.128811],[-80.209949,40.128426],[-80.209912,40.12813],[-80.209848,40.127802],[-80.209772,40.127515],[-80.209692,40.12724],[-80.209622,40.12706],[-80.209494,40.126748],[-80.209343,40.126432],[-80.209193,40.126157],[-80.209021,40.125895],[-80.208814,40.125628],[-80.208407,40.125119],[-80.208072,40.124677],[-80.207804,40.124344],[-80.207509,40.123959],[-80.207273,40.123639],[-80.207021,40.123294],[-80.206768,40.122942],[-80.206554,40.122609],[-80.206334,40.122261],[-80.206146,40.121961],[-80.205932,40.121612],[-80.205722,40.12126],[-80.20562,40.121075],[-80.205352,40.120566],[-80.20503,40.119979],[-80.204677,40.119325],[-80.204294,40.118622],[-80.204013,40.118056],[-80.203818,40.117564],[-80.203668,40.117129],[-80.203507,40.116727],[-80.203314,40.116136],[-80.203142,40.115537],[-80.203035,40.114946],[-80.202927,40.114224],[-80.202852,40.113478],[-80.202791,40.112762],[-80.202802,40.112164],[-80.202831,40.111567],[-80.202874,40.111],[-80.202874,40.110376],[-80.202874,40.109506],[-80.202863,40.109121],[-80.202777,40.108653],[-80.202637,40.108191],[-80.20253,40.107847],[-80.202445,40.10752],[-80.202273,40.107135],[-80.201962,40.106529],[-80.20159,40.105985],[-80.201279,40.105603],[-80.200746,40.10503],[-80.200434,40.104728],[-80.199969,40.104342],[-80.199328,40.103872],[-80.198682,40.103392],[-80.198067,40.102974],[-80.197552,40.102589],[-80.196941,40.102121],[-80.196382,40.101641],[-80.195845,40.10114],[-80.19547,40.100713],[-80.19525,40.100402],[-80.195116,40.100213],[-80.194762,40.099696],[-80.194472,40.099179],[-80.194096,40.098465],[-80.19386,40.097989],[-80.193646,40.097414],[-80.193528,40.097078],[-80.193421,40.096692],[-80.193378,40.096413],[-80.193313,40.095838],[-80.193303,40.095247],[-80.193313,40.094451],[-80.193335,40.093852],[-80.193399,40.093081],[-80.193485,40.091899],[-80.193528,40.091209],[-80.19356,40.09052],[-80.19356,40.089929],[-80.193463,40.089166],[-80.193388,40.088205],[-80.193303,40.087138],[-80.193249,40.086457],[-80.193142,40.085127],[-80.193002,40.083502],[-80.192906,40.082213],[-80.192745,40.081006],[-80.192723,40.080538],[-80.19268,40.080112],[-80.192627,40.079644],[-80.192519,40.079209],[-80.192358,40.078765],[-80.192026,40.077854],[-80.191704,40.07691],[-80.19106,40.075161],[-80.190674,40.074069],[-80.190363,40.073191],[-80.189944,40.07205],[-80.189601,40.071147],[-80.189279,40.070235],[-80.188539,40.068232],[-80.188035,40.066795],[-80.18782,40.066171],[-80.187648,40.065506],[-80.187509,40.064554],[-80.187412,40.063659],[-80.18723,40.062189],[-80.187123,40.061696],[-80.186994,40.060883],[-80.186876,40.060177],[-80.186779,40.059758],[-80.186565,40.058921],[-80.186264,40.057853],[-80.186007,40.056933],[-80.185803,40.056227],[-80.185417,40.054995],[-80.184998,40.053443],[-80.184644,40.052014],[-80.184305,40.051038],[-80.184247,40.050873],[-80.184001,40.049887],[-80.183689,40.048787],[-80.183486,40.048105],[-80.183325,40.047555],[-80.183196,40.046848],[-80.182917,40.046068],[-80.182659,40.045329],[-80.182198,40.044237],[-80.181683,40.043136],[-80.181222,40.042142],[-80.180868,40.041206],[-80.180438,40.040142],[-80.180275,40.039753],[-80.179913,40.038939],[-80.179462,40.037904],[-80.179001,40.036795],[-80.178411,40.035464],[-80.178025,40.034552],[-80.177574,40.033492],[-80.177091,40.032318],[-80.176726,40.031513],[-80.176329,40.030593],[-80.176029,40.029763],[-80.175675,40.028917],[-80.175407,40.028317],[-80.175147,40.027689],[-80.174974,40.027208],[-80.174842,40.026785],[-80.174722,40.026347],[-80.174624,40.025895],[-80.174547,40.025446],[-80.174508,40.025104],[-80.174473,40.024779],[-80.174447,40.02427],[-80.174451,40.023766],[-80.174475,40.023355],[-80.174524,40.022844],[-80.174589,40.02243],[-80.174685,40.021936],[-80.174769,40.021589],[-80.174952,40.020933],[-80.175208,40.020042],[-80.17577,40.01808],[-80.175998,40.017288],[-80.176391,40.015873],[-80.17649,40.015566],[-80.17663,40.015097],[-80.176769,40.014686],[-80.176962,40.014243],[-80.177156,40.013815],[-80.17737,40.013405],[-80.177703,40.012862],[-80.178046,40.012369],[-80.178497,40.011843],[-80.178861,40.011432],[-80.179205,40.011071],[-80.179527,40.010759],[-80.180535,40.010012],[-80.181383,40.009429],[-80.182735,40.008583],[-80.18414,40.007769],[-80.185321,40.00712],[-80.185621,40.006964],[-80.1859,40.006791],[-80.186426,40.006364],[-80.186769,40.00606],[-80.187134,40.005673],[-80.187477,40.005271],[-80.187788,40.004778],[-80.188003,40.00435],[-80.188325,40.003627],[-80.188528,40.003101],[-80.188614,40.002822],[-80.188722,40.002452],[-80.188818,40.002074],[-80.188915,40.001433],[-80.188958,40.000611],[-80.188958,40.000101],[-80.188904,39.999723],[-80.188797,39.99891],[-80.1887,39.998367],[-80.188517,39.997783],[-80.188346,39.997241],[-80.18811,39.996715],[-80.187745,39.995844],[-80.187338,39.995014],[-80.18678,39.993888],[-80.186243,39.992803],[-80.185428,39.991036],[-80.184419,39.988865],[-80.183668,39.987287],[-80.183132,39.986071],[-80.182531,39.984895],[-80.181887,39.983555],[-80.181576,39.982947],[-80.181254,39.982157],[-80.18075,39.981122],[-80.180278,39.980135],[-80.179763,39.978976],[-80.179602,39.978581],[-80.17943,39.978154],[-80.179012,39.977299],[-80.178508,39.976263],[-80.178003,39.975194],[-80.177596,39.974306],[-80.177049,39.973081],[-80.17648,39.971848],[-80.176062,39.970943],[-80.175772,39.970392],[-80.175407,39.969644],[-80.174978,39.96874],[-80.174581,39.967876],[-80.17427,39.96707],[-80.173937,39.966191],[-80.173798,39.965763],[-80.173626,39.96522],[-80.173443,39.964636],[-80.17336,39.964334],[-80.173196,39.963727],[-80.173025,39.963066],[-80.172832,39.962285],[-80.172618,39.961364],[-80.172435,39.960706],[-80.172285,39.960369],[-80.172113,39.959949],[-80.171902,39.959564],[-80.171856,39.95948],[-80.171717,39.959258],[-80.171351,39.958721],[-80.170858,39.958091],[-80.170483,39.957581],[-80.169826,39.956707],[-80.169399,39.956125],[-80.166363,39.952186],[-80.166009,39.951725],[-80.165708,39.951281],[-80.165472,39.950853],[-80.165354,39.9505],[-80.165268,39.950113],[-80.165247,39.949718],[-80.165268,39.949315],[-80.165333,39.948953],[-80.165483,39.948591],[-80.16574,39.948049],[-80.166052,39.947522],[-80.16897,39.942521],[-80.169181,39.942073],[-80.169396,39.941604],[-80.169535,39.941185],[-80.169664,39.940666],[-80.169739,39.940247],[-80.169814,39.939737],[-80.169825,39.939326],[-80.169814,39.938906],[-80.16975,39.938412],[-80.169653,39.937886],[-80.169535,39.937433],[-80.169363,39.936981],[-80.169106,39.936422],[-80.168741,39.935796],[-80.168344,39.935253],[-80.167743,39.934562],[-80.166971,39.933658],[-80.165115,39.931535],[-80.164686,39.931008],[-80.164342,39.930457],[-80.164031,39.929832],[-80.163774,39.929174],[-80.163591,39.928565],[-80.163484,39.927956],[-80.163441,39.927388],[-80.163463,39.92664],[-80.163581,39.925545],[-80.16372,39.924344],[-80.163784,39.923571],[-80.163806,39.92274],[-80.163784,39.92204],[-80.163742,39.92153],[-80.163624,39.920831],[-80.163495,39.920181],[-80.163302,39.919333],[-80.163044,39.918576],[-80.162722,39.91772],[-80.162336,39.91698],[-80.1618,39.916083],[-80.161553,39.9157],[-80.161349,39.915383],[-80.160866,39.914742],[-80.160265,39.914026],[-80.159697,39.913384],[-80.159171,39.912874],[-80.158291,39.912117],[-80.157583,39.911573],[-80.156403,39.910726],[-80.155223,39.909903],[-80.15386,39.908965],[-80.152605,39.908068],[-80.151886,39.907442],[-80.151124,39.906677],[-80.150191,39.905536],[-80.148217,39.903201],[-80.147158,39.901944],[-80.146417,39.901057],[-80.145701,39.900225],[-80.145277,39.899756],[-80.144852,39.899298],[-80.144197,39.89863],[-80.143392,39.897835],[-80.142618,39.897139],[-80.141343,39.896018],[-80.139942,39.894785],[-80.138211,39.893266],[-80.136406,39.891667],[-80.135992,39.891288],[-80.135663,39.890945],[-80.135479,39.890742],[-80.135117,39.890336],[-80.134925,39.890088],[-80.134755,39.88984],[-80.134312,39.889153],[-80.133883,39.888297],[-80.133615,39.88763],[-80.133379,39.886856],[-80.133218,39.88614],[-80.133164,39.885448],[-80.133175,39.884666],[-80.133261,39.883547],[-80.133359,39.882458],[-80.133434,39.88124],[-80.133531,39.880252],[-80.133541,39.878918],[-80.133509,39.878284],[-80.133413,39.877469],[-80.133338,39.876926],[-80.13323,39.876555],[-80.133046,39.876052],[-80.132938,39.875675],[-80.132587,39.874184],[-80.132029,39.872092],[-80.131642,39.870833],[-80.131278,39.869951],[-80.130816,39.869227],[-80.130537,39.868922],[-80.130012,39.868453],[-80.129035,39.867736],[-80.127791,39.866839],[-80.126997,39.866213],[-80.126632,39.865867],[-80.125956,39.865185],[-80.125702,39.864885],[-80.125532,39.864669],[-80.125403,39.864486],[-80.12529,39.864313],[-80.125157,39.864078],[-80.125008,39.863807],[-80.124882,39.863554],[-80.124735,39.863218],[-80.124557,39.862796],[-80.124223,39.861986],[-80.123585,39.86021],[-80.121675,39.855309],[-80.121321,39.854469],[-80.120903,39.853645],[-80.120409,39.852912],[-80.119712,39.852204],[-80.118403,39.850894],[-80.117759,39.850112],[-80.117191,39.849329],[-80.116751,39.848605],[-80.116343,39.847748],[-80.115603,39.846026],[-80.1152,39.845111],[-80.115045,39.844758],[-80.114541,39.843638],[-80.113639,39.841768],[-80.113307,39.840985],[-80.113039,39.840351],[-80.112845,39.839758],[-80.112577,39.838711],[-80.112438,39.837723],[-80.112234,39.835762],[-80.112052,39.834559],[-80.111891,39.833636],[-80.111676,39.832837],[-80.111268,39.831915],[-80.110871,39.831157],[-80.110485,39.830596],[-80.110035,39.829987],[-80.109595,39.829459],[-80.108575,39.828512],[-80.107063,39.827185],[-80.105807,39.826007],[-80.101634,39.82239],[-80.100969,39.821788],[-80.100475,39.821228],[-80.09996,39.820552],[-80.099413,39.819613],[-80.098694,39.818171],[-80.097675,39.816135],[-80.096602,39.813712],[-80.095561,39.811545],[-80.094956,39.810434],[-80.094645,39.809813],[-80.094461,39.809466],[-80.094264,39.809164],[-80.094071,39.808909],[-80.093792,39.808593],[-80.093582,39.808389],[-80.093349,39.808189],[-80.093096,39.807999],[-80.092816,39.807815],[-80.092391,39.807562],[-80.091382,39.807013],[-80.085794,39.804015],[-80.085026,39.803575],[-80.084264,39.803072],[-80.08347,39.802512],[-80.08244,39.801654],[-80.08141,39.800715],[-80.079361,39.798802],[-80.078942,39.798333],[-80.078384,39.797566],[-80.077934,39.796676],[-80.077515,39.795538],[-80.077333,39.794458],[-80.077279,39.793708],[-80.07729,39.793032],[-80.077462,39.791936],[-80.077805,39.789578],[-80.078181,39.786544],[-80.078343,39.785423],[-80.078472,39.784714],[-80.078601,39.784236],[-80.078794,39.783791],[-80.079363,39.782868],[-80.080307,39.781532],[-80.080424,39.781358],[-80.08094,39.780592],[-80.081315,39.779974],[-80.081616,39.779429],[-80.081863,39.778852],[-80.082023,39.778316],[-80.082152,39.777756],[-80.082217,39.777096],[-80.082238,39.776478],[-80.082141,39.775777],[-80.082002,39.77515],[-80.081959,39.774919],[-80.080822,39.771126],[-80.080715,39.770672],[-80.08065,39.77031],[-80.080629,39.769963],[-80.080618,39.769254],[-80.080661,39.768693],[-80.0808,39.76777],[-80.080983,39.76692],[-80.08212,39.76137],[-80.082206,39.760809],[-80.08226,39.760215],[-80.082238,39.759498],[-80.082109,39.758986],[-80.081884,39.758417],[-80.081616,39.757939],[-80.080146,39.755926],[-80.07953,39.755115],[-80.07785,39.752908],[-80.076841,39.751621],[-80.076112,39.750829],[-80.075479,39.750235],[-80.074621,39.749509],[-80.073397,39.748627],[-80.072013,39.74776],[-80.069932,39.746515],[-80.067979,39.745343],[-80.063763,39.742849],[-80.062409,39.742035],[-80.05986,39.740501],[-80.059379,39.740182],[-80.059066,39.739929],[-80.058793,39.739688],[-80.058546,39.739419],[-80.058257,39.73904],[-80.058078,39.738744],[-80.057919,39.738444],[-80.057792,39.738122],[-80.05771,39.737847],[-80.057642,39.737503],[-80.057605,39.737186],[-80.057598,39.736825],[-80.057642,39.736428],[-80.057698,39.736132],[-80.057874,39.735445],[-80.058106,39.734578],[-80.058442,39.733278],[-80.058598,39.732695],[-80.059267,39.730185],[-80.059937,39.72764],[-80.061274,39.722569],[-80.061657,39.721095],[-80.061757,39.720669],[-80.06181,39.720387],[-80.061856,39.720016],[-80.061874,39.719726],[-80.061869,39.71934],[-80.061827,39.718925],[-80.061776,39.718608],[-80.06167,39.718157],[-80.061517,39.717718],[-80.06131,39.717258],[-80.061073,39.716851],[-80.060894,39.716577],[-80.060523,39.716088],[-80.059881,39.715319],[-80.059162,39.714498],[-80.058518,39.713743],[-80.057335,39.712232],[-80.056842,39.711646],[-80.056509,39.711176],[-80.056166,39.710556],[-80.055919,39.70997],[-80.055715,39.709063],[-80.055511,39.70799],[-80.055318,39.707371],[-80.055093,39.706727],[-80.054664,39.705835],[-80.054181,39.705018],[-80.053569,39.704184],[-80.053022,39.703565],[-80.052357,39.702946],[-80.050112,39.701174],[-80.046134,39.698035],[-80.045737,39.69768],[-80.045373,39.6973],[-80.044911,39.696764],[-80.044568,39.696293],[-80.044218,39.695734],[-80.04401,39.695401],[-80.043688,39.694807],[-80.043431,39.694237],[-80.043141,39.69342],[-80.042916,39.692743],[-80.042723,39.692116],[-80.042497,39.691505],[-80.042347,39.691109],[-80.042143,39.690646],[-80.041939,39.690316],[-80.041575,39.689837],[-80.041103,39.689226],[-80.040566,39.688524],[-80.040255,39.688079],[-80.040019,39.687641],[-80.039837,39.687179],[-80.039697,39.686758],[-80.039611,39.686394],[-80.039558,39.68599],[-80.039536,39.685115],[-80.039515,39.684016],[-80.039504,39.683257],[-80.039483,39.682679],[-80.039429,39.682249],[-80.039268,39.681498],[-80.039075,39.680813],[-80.03885,39.680243],[-80.038549,39.679615],[-80.038141,39.678897],[-80.037669,39.67817],[-80.037047,39.677452],[-80.036285,39.676684],[-80.035824,39.676304],[-80.035427,39.675982],[-80.035019,39.675677],[-80.034386,39.675264],[-80.033496,39.674744],[-80.032616,39.674298],[-80.03179,39.673885],[-80.031125,39.673464],[-80.03047,39.672935],[-80.02988,39.672324],[-80.029591,39.671969],[-80.029333,39.671556],[-80.029022,39.671011],[-80.028754,39.670532],[-80.028485,39.670152],[-80.028164,39.669756],[-80.027799,39.669409],[-80.027284,39.669012],[-80.026672,39.668649],[-80.025868,39.668302],[-80.024966,39.66798],[-80.022252,39.667022],[-80.020825,39.666485],[-80.016147,39.6648],[-80.014677,39.664247],[-80.013948,39.66395],[-80.013283,39.663586],[-80.01266,39.663132],[-80.012178,39.662678],[-80.011834,39.662273],[-80.01148,39.66172],[-80.011223,39.661034],[-80.011126,39.660638],[-80.011087,39.660036],[-80.011073,39.659812],[-80.011038,39.659259],[-80.010879,39.656747],[-80.010837,39.656318],[-80.010751,39.655822],[-80.010649,39.655482],[-80.010558,39.655186],[-80.0103,39.6546],[-80.010064,39.654096],[-80.009517,39.65322],[-80.00839,39.651643],[-80.008133,39.651263],[-80.0078,39.650701],[-80.007543,39.650164],[-80.007307,39.649602],[-80.007103,39.648875],[-80.006953,39.648024],[-80.006727,39.64619],[-80.00662,39.64534],[-80.006534,39.644761],[-80.006363,39.644175],[-80.006159,39.643687],[-80.005923,39.643274],[-80.005644,39.642886],[-80.005268,39.642473],[-80.004927,39.642162],[-80.004206,39.641506],[-79.998554,39.636762],[-79.997391,39.635799],[-79.992147,39.631352],[-79.991074,39.630468],[-79.990804,39.630213],[-79.990355,39.62979],[-79.989851,39.629228],[-79.989196,39.628336],[-79.988764,39.627511],[-79.988659,39.627274],[-79.988562,39.626985],[-79.988345,39.626256],[-79.988177,39.625534],[-79.988113,39.624931],[-79.988102,39.62422],[-79.988166,39.623659],[-79.988295,39.622931],[-79.988445,39.622345],[-79.988692,39.621642],[-79.990033,39.618427],[-79.992104,39.61322],[-79.99234,39.612642],[-79.992608,39.61203],[-79.992876,39.611328],[-79.993041,39.610765],[-79.99318,39.610225],[-79.993295,39.609653],[-79.9934,39.608923],[-79.993456,39.608121],[-79.993467,39.607658],[-79.993424,39.607129],[-79.993393,39.606782],[-79.993346,39.606474],[-79.993267,39.60598],[-79.993127,39.605332],[-79.992889,39.604487],[-79.992694,39.603847],[-79.992437,39.603161],[-79.992083,39.60245],[-79.991632,39.601706],[-79.991149,39.600979],[-79.990699,39.600417],[-79.990184,39.599805],[-79.989626,39.599218],[-79.988939,39.598581],[-79.988199,39.597978],[-79.987662,39.597598],[-79.987008,39.597143],[-79.985527,39.596291],[-79.982943,39.594866],[-79.981676,39.594167],[-79.981332,39.593968],[-79.980978,39.593704],[-79.980452,39.593208],[-79.980163,39.592836],[-79.979927,39.592472],[-79.979701,39.59205],[-79.979573,39.591686],[-79.979498,39.591331],[-79.979465,39.590934],[-79.979375,39.590289],[-79.979181,39.588125],[-79.979293,39.585994],[-79.979256,39.584848],[-79.979253,39.584467],[-79.979229,39.583825],[-79.97922,39.583448],[-79.979226,39.582926],[-79.979203,39.582063],[-79.97917,39.581356],[-79.979135,39.581039],[-79.979075,39.580752],[-79.979007,39.580544],[-79.978897,39.580289],[-79.97878,39.580087],[-79.978693,39.579962],[-79.978568,39.579798],[-79.97842,39.579638],[-79.978275,39.579506],[-79.978072,39.579333],[-79.977839,39.579172],[-79.977517,39.578984],[-79.977233,39.578861],[-79.976937,39.578753],[-79.976691,39.578682],[-79.976434,39.578624],[-79.976171,39.578577],[-79.975931,39.578551],[-79.975521,39.578542],[-79.975326,39.578546],[-79.975099,39.578559],[-79.974637,39.578609],[-79.973857,39.578723],[-79.972192,39.578971],[-79.971641,39.579025],[-79.970385,39.579229],[-79.968931,39.579442],[-79.968192,39.579554],[-79.967832,39.579615],[-79.967414,39.579696],[-79.966831,39.579815],[-79.966328,39.57993],[-79.965843,39.580056],[-79.965239,39.580221],[-79.964664,39.580393],[-79.963598,39.580735],[-79.962427,39.581116],[-79.96161,39.581383],[-79.9609,39.581628],[-79.959269,39.582156],[-79.958661,39.58237],[-79.958181,39.582518],[-79.957374,39.582787],[-79.956047,39.583217],[-79.954655,39.583664],[-79.953209,39.584136],[-79.948033,39.585802],[-79.945659,39.586568],[-79.943348,39.587309],[-79.940504,39.588227],[-79.937566,39.589171],[-79.935865,39.589739],[-79.935488,39.589873],[-79.935203,39.589984],[-79.934894,39.590115],[-79.934474,39.590316],[-79.934076,39.590525],[-79.933756,39.590712],[-79.933488,39.59088],[-79.933166,39.591091],[-79.932852,39.591323],[-79.932516,39.591591],[-79.932193,39.591863],[-79.931961,39.592095],[-79.931563,39.592482],[-79.931367,39.592695],[-79.931173,39.592954],[-79.930876,39.593387],[-79.930648,39.593732],[-79.930458,39.594076],[-79.930239,39.594542],[-79.930092,39.594915],[-79.930004,39.595168],[-79.929899,39.595557],[-79.929815,39.59593],[-79.929757,39.59636],[-79.929726,39.596799],[-79.929722,39.597037],[-79.929734,39.59734],[-79.92977,39.597714],[-79.929832,39.598137],[-79.929942,39.598614],[-79.930167,39.599391],[-79.930284,39.599783],[-79.930773,39.60146],[-79.931068,39.602488],[-79.931246,39.603114],[-79.931337,39.603457],[-79.931406,39.603808],[-79.931437,39.604067],[-79.931451,39.604312],[-79.931453,39.604516],[-79.931435,39.60476],[-79.931403,39.605038],[-79.931356,39.605294],[-79.931283,39.605565],[-79.931225,39.605754],[-79.931153,39.605938],[-79.931061,39.606155],[-79.930946,39.606389],[-79.930788,39.606664],[-79.930599,39.606942],[-79.930364,39.607246],[-79.930136,39.60749],[-79.929869,39.607752],[-79.929615,39.607974],[-79.929292,39.608215],[-79.929065,39.608368],[-79.928839,39.608507],[-79.928511,39.608685],[-79.928181,39.608849],[-79.927785,39.609023],[-79.927016,39.609329],[-79.925856,39.609792],[-79.925443,39.609968],[-79.924879,39.610224],[-79.924447,39.610433],[-79.923967,39.610672],[-79.923463,39.610938],[-79.922944,39.611228],[-79.922503,39.611499],[-79.921887,39.61191],[-79.921633,39.612098],[-79.921031,39.612572],[-79.920534,39.612976],[-79.919779,39.613645],[-79.919184,39.614182],[-79.918637,39.614695],[-79.917629,39.615616],[-79.917416,39.615784],[-79.9147,39.618265],[-79.913238,39.619592],[-79.912052,39.620678],[-79.910394,39.622204],[-79.909718,39.622828],[-79.90918,39.623312],[-79.908961,39.623508],[-79.908551,39.623854],[-79.908046,39.624255],[-79.907689,39.624516],[-79.907211,39.624861],[-79.906657,39.625224],[-79.906095,39.62557],[-79.904887,39.626291],[-79.904176,39.626725],[-79.903686,39.627051],[-79.903461,39.627219],[-79.90332,39.627333],[-79.903088,39.627525],[-79.902837,39.627747],[-79.902588,39.627979],[-79.902396,39.628168],[-79.902219,39.628359],[-79.902057,39.628541],[-79.901872,39.62877],[-79.901692,39.629009],[-79.90153,39.629234],[-79.901347,39.629523],[-79.90118,39.629813],[-79.901025,39.630113],[-79.90087,39.630455],[-79.900444,39.631575],[-79.89959,39.633861],[-79.898369,39.63712],[-79.897506,39.639424],[-79.89713,39.640406],[-79.895433,39.644946],[-79.895266,39.645379],[-79.895075,39.645811],[-79.894793,39.646374],[-79.894536,39.646864],[-79.894185,39.647451],[-79.89395,39.647807],[-79.893705,39.648148],[-79.893377,39.648594],[-79.893123,39.648915],[-79.891151,39.651242],[-79.890051,39.652505],[-79.888786,39.653958],[-79.88752,39.655455],[-79.884527,39.658989],[-79.884178,39.659388],[-79.883828,39.65977],[-79.883515,39.660091],[-79.883241,39.660347],[-79.882879,39.660651],[-79.882594,39.66087],[-79.882291,39.661083],[-79.881914,39.661318],[-79.881558,39.661526],[-79.881252,39.661686],[-79.878314,39.663197],[-79.875975,39.664388],[-79.874193,39.665296],[-79.873685,39.665546],[-79.872963,39.665878],[-79.872166,39.666234],[-79.871493,39.666518],[-79.870714,39.66683],[-79.870109,39.667058],[-79.869567,39.667245],[-79.868474,39.667625],[-79.866466,39.668323],[-79.860114,39.670516],[-79.856822,39.67167],[-79.856374,39.671802],[-79.855947,39.67191],[-79.855673,39.671967],[-79.855403,39.672011],[-79.855011,39.67206],[-79.854706,39.672089],[-79.854422,39.672109],[-79.854177,39.672115],[-79.853878,39.67211],[-79.853572,39.672094],[-79.853177,39.672062],[-79.852839,39.672019],[-79.85251,39.671963],[-79.852085,39.67187],[-79.85176,39.671779],[-79.851511,39.671705],[-79.851198,39.671599],[-79.850914,39.671495],[-79.850649,39.671381],[-79.850466,39.671289],[-79.850306,39.671207],[-79.850141,39.671115],[-79.849988,39.671026],[-79.849804,39.670913],[-79.849639,39.670803],[-79.849475,39.670693],[-79.849259,39.670532],[-79.849054,39.670363],[-79.848928,39.670251],[-79.848761,39.670083],[-79.84847,39.669772],[-79.848272,39.669529],[-79.84812,39.669322],[-79.847876,39.668933],[-79.847656,39.668548],[-79.847507,39.668247],[-79.846523,39.666289],[-79.845849,39.664972],[-79.845064,39.663413],[-79.844916,39.663115],[-79.844752,39.662839],[-79.844541,39.66252],[-79.844371,39.662278],[-79.844203,39.662069],[-79.843962,39.661796],[-79.843756,39.66158],[-79.843522,39.661354],[-79.843288,39.661151],[-79.842999,39.66093],[-79.842674,39.660699],[-79.842355,39.660499],[-79.84202,39.660298],[-79.841534,39.660045],[-79.84123,39.659908],[-79.840942,39.659795],[-79.839491,39.659252],[-79.837409,39.658467],[-79.835527,39.657757],[-79.835058,39.657593],[-79.834708,39.657483],[-79.834291,39.657366],[-79.833902,39.657272],[-79.833572,39.657203],[-79.833236,39.657139],[-79.832825,39.657081],[-79.832388,39.657031],[-79.832036,39.657006],[-79.831641,39.656989],[-79.831344,39.656981],[-79.83108,39.656981],[-79.830754,39.656991],[-79.830482,39.657005],[-79.830201,39.657029],[-79.82993,39.657048],[-79.829641,39.657085],[-79.829419,39.657115],[-79.82906,39.657179],[-79.828733,39.657248],[-79.828416,39.657324],[-79.828107,39.657408],[-79.827811,39.657495],[-79.827555,39.657583],[-79.827237,39.657693],[-79.82698,39.657796],[-79.826694,39.657913],[-79.82645,39.658022],[-79.826243,39.658122],[-79.826018,39.658235],[-79.825645,39.658448],[-79.825274,39.658668],[-79.823584,39.659746],[-79.822425,39.660484],[-79.822176,39.660632],[-79.821946,39.660761],[-79.821743,39.660864],[-79.821543,39.660955],[-79.821339,39.661041],[-79.821182,39.661108],[-79.821015,39.661167],[-79.820766,39.661245],[-79.82055,39.661301],[-79.820347,39.661348],[-79.820126,39.661391],[-79.819821,39.661441],[-79.819558,39.661468],[-79.819249,39.661491],[-79.818991,39.661502],[-79.818752,39.661499],[-79.818525,39.661488],[-79.81834,39.661473],[-79.818102,39.661449],[-79.81782,39.661409],[-79.817575,39.661361],[-79.817334,39.661307],[-79.817096,39.661244],[-79.816848,39.661168],[-79.816634,39.661097],[-79.816427,39.661016],[-79.816241,39.660933],[-79.815979,39.660809],[-79.815792,39.660709],[-79.815619,39.660607],[-79.815463,39.660506],[-79.815306,39.660396],[-79.815166,39.660293],[-79.814773,39.659981],[-79.814172,39.659489],[-79.813991,39.659363],[-79.81381,39.659246],[-79.813611,39.659128],[-79.813475,39.659056],[-79.813313,39.658979],[-79.813144,39.658907],[-79.812982,39.658844],[-79.81282,39.658785],[-79.812654,39.658733],[-79.8125,39.658689],[-79.812325,39.658648],[-79.812146,39.658611],[-79.811946,39.658577],[-79.811754,39.658554],[-79.81155,39.658534],[-79.81138,39.658524],[-79.811227,39.65852],[-79.811045,39.658522],[-79.810854,39.658532],[-79.810671,39.658547],[-79.810482,39.658571],[-79.81032,39.658594],[-79.810136,39.658626],[-79.809959,39.658668],[-79.809786,39.658711],[-79.809622,39.658761],[-79.80943,39.658827],[-79.809236,39.658896],[-79.809057,39.658968],[-79.808886,39.659042],[-79.8087,39.659127],[-79.807925,39.659505],[-79.807132,39.659891],[-79.806911,39.659996],[-79.806725,39.660081],[-79.806471,39.660184],[-79.8063,39.660249],[-79.806077,39.660322],[-79.805858,39.660388],[-79.805633,39.660448],[-79.805403,39.660499],[-79.805082,39.660561],[-79.804744,39.660604],[-79.804493,39.66063],[-79.804276,39.660646],[-79.804048,39.660656],[-79.802839,39.660697],[-79.799255,39.66083],[-79.798295,39.660863],[-79.797934,39.660875],[-79.79771,39.660875],[-79.797453,39.660864],[-79.797174,39.660846],[-79.796954,39.660822],[-79.796742,39.660782],[-79.796569,39.660746],[-79.796423,39.660712],[-79.796228,39.660655],[-79.796049,39.660599],[-79.795893,39.660541],[-79.795744,39.660481],[-79.795555,39.660396],[-79.795389,39.660312],[-79.795211,39.660209],[-79.794987,39.660072],[-79.794306,39.659649],[-79.794065,39.659501],[-79.793611,39.659242],[-79.793287,39.659068],[-79.792978,39.658916],[-79.792674,39.658775],[-79.792389,39.65865],[-79.792077,39.658527],[-79.791866,39.65845],[-79.791632,39.658369],[-79.791346,39.658276],[-79.791026,39.658181],[-79.790734,39.658104],[-79.790435,39.658036],[-79.790073,39.657955],[-79.789774,39.657895],[-79.789485,39.657853],[-79.78906,39.657797],[-79.788633,39.657749],[-79.788274,39.657726],[-79.787944,39.657717],[-79.787573,39.65771],[-79.787217,39.657711],[-79.786899,39.657725],[-79.78665,39.657742],[-79.786337,39.657765],[-79.78593,39.657806],[-79.785649,39.657844],[-79.785356,39.657889],[-79.784743,39.657987],[-79.784221,39.658081],[-79.783284,39.658231],[-79.782935,39.658288],[-79.782563,39.658347],[-79.782256,39.658388],[-79.78195,39.658416],[-79.781639,39.658434],[-79.781308,39.658439],[-79.780881,39.658426],[-79.780588,39.6584],[-79.780351,39.658372],[-79.780047,39.658321],[-79.779795,39.65827],[-79.779502,39.658198],[-79.779239,39.658117],[-79.778946,39.658018],[-79.778618,39.657893],[-79.775809,39.656741],[-79.774089,39.65602],[-79.773657,39.655854],[-79.773306,39.655723],[-79.773014,39.655624],[-79.772738,39.655543],[-79.772428,39.655465],[-79.772217,39.655415],[-79.771932,39.655363],[-79.771651,39.655322],[-79.771442,39.655299],[-79.771199,39.655281],[-79.770971,39.655271],[-79.770676,39.65527],[-79.770319,39.655274],[-79.769107,39.65532],[-79.765686,39.655465],[-79.763058,39.655576],[-79.761989,39.655617],[-79.761545,39.655631],[-79.761118,39.655631],[-79.760651,39.655615],[-79.760336,39.655592],[-79.759857,39.655548],[-79.759428,39.655486],[-79.759002,39.655412],[-79.756299,39.654848],[-79.755858,39.654771],[-79.755513,39.654718],[-79.755084,39.654666],[-79.75463,39.654628],[-79.754049,39.654604],[-79.753586,39.654596],[-79.752728,39.654604],[-79.751499,39.654619],[-79.750457,39.654631],[-79.749513,39.654604],[-79.74876,39.654566],[-79.747802,39.654506],[-79.741896,39.654153],[-79.74138,39.65412],[-79.737295,39.65386],[-79.736772,39.653823],[-79.736105,39.653748],[-79.735531,39.653673],[-79.734892,39.653574],[-79.734202,39.653448],[-79.733632,39.65333],[-79.733026,39.653197],[-79.732529,39.653066],[-79.732106,39.652949],[-79.731639,39.652807],[-79.729281,39.652115],[-79.726085,39.651153],[-79.724861,39.650784],[-79.724364,39.650629],[-79.724043,39.650543],[-79.723608,39.650443],[-79.723134,39.650344],[-79.722786,39.650281],[-79.722401,39.650212],[-79.721981,39.650151],[-79.721593,39.650108],[-79.721233,39.650076],[-79.720897,39.650055],[-79.72057,39.650038],[-79.720168,39.650025],[-79.719835,39.65002],[-79.719388,39.650028],[-79.718928,39.650042],[-79.718572,39.650062],[-79.717014,39.650179],[-79.716102,39.65025],[-79.715736,39.650266],[-79.715357,39.650279],[-79.715029,39.650281],[-79.714619,39.650272],[-79.714256,39.650252],[-79.713828,39.650215],[-79.713486,39.650179],[-79.713229,39.650148],[-79.712921,39.650095],[-79.712578,39.650033],[-79.712187,39.649946],[-79.711865,39.649866],[-79.71148,39.64976],[-79.709516,39.64915],[-79.708992,39.649002],[-79.70866,39.648915],[-79.708373,39.64885],[-79.708045,39.648787],[-79.707734,39.648744],[-79.707489,39.648718],[-79.707187,39.648694],[-79.706853,39.64868],[-79.706523,39.648681],[-79.706158,39.6487],[-79.705821,39.648735],[-79.705501,39.648779],[-79.705168,39.648836],[-79.704862,39.648901],[-79.704536,39.648983],[-79.70414,39.649105],[-79.703859,39.649207],[-79.703568,39.64933],[-79.703278,39.649471],[-79.702948,39.649645],[-79.702603,39.649852],[-79.702261,39.650094],[-79.701891,39.650393],[-79.701088,39.651094],[-79.699925,39.652125],[-79.699349,39.652609],[-79.699106,39.652806],[-79.698715,39.653071],[-79.698358,39.653309],[-79.697977,39.653532],[-79.697548,39.653755],[-79.697156,39.653937],[-79.696705,39.65413],[-79.696333,39.654275],[-79.695923,39.654416],[-79.6954,39.654565],[-79.69483,39.654709],[-79.692895,39.655114],[-79.689986,39.65572],[-79.688726,39.655972],[-79.688009,39.656133],[-79.687468,39.65626],[-79.686915,39.656412],[-79.68622,39.656626],[-79.685677,39.656803],[-79.685189,39.656975],[-79.684826,39.657112],[-79.68434,39.657314],[-79.683849,39.657529],[-79.683238,39.657817],[-79.682734,39.658068],[-79.682166,39.658364],[-79.681648,39.658644],[-79.681045,39.659011],[-79.679398,39.660081],[-79.67777,39.661144],[-79.677382,39.661387],[-79.676965,39.661628],[-79.676608,39.661826],[-79.676219,39.66201],[-79.675794,39.662193],[-79.675444,39.662331],[-79.675107,39.662449],[-79.674682,39.662586],[-79.674192,39.662721],[-79.673763,39.662816],[-79.673423,39.662885],[-79.673078,39.662942],[-79.67265,39.663],[-79.672222,39.663041],[-79.671838,39.663068],[-79.671333,39.663084],[-79.670931,39.663086],[-79.670414,39.66307],[-79.669964,39.663033],[-79.669689,39.663009],[-79.669286,39.662958],[-79.668968,39.662907],[-79.668669,39.66285],[-79.66829,39.662774],[-79.667871,39.662669],[-79.667583,39.662591],[-79.667261,39.662489],[-79.666888,39.662361],[-79.666471,39.662205],[-79.666055,39.662028],[-79.665636,39.661824],[-79.665118,39.661547],[-79.664638,39.661256],[-79.662962,39.660166],[-79.662539,39.659906],[-79.662035,39.659596],[-79.661428,39.659265],[-79.661022,39.659052],[-79.660703,39.658892],[-79.660325,39.65871],[-79.6599,39.658514],[-79.659501,39.658341],[-79.659007,39.658148],[-79.658482,39.65795],[-79.657979,39.65777],[-79.657582,39.657635],[-79.657219,39.657521],[-79.656763,39.657387],[-79.656376,39.657278],[-79.655832,39.657141],[-79.655286,39.657018],[-79.65477,39.656905],[-79.654296,39.656816],[-79.653873,39.656747],[-79.653382,39.656671],[-79.651386,39.656394],[-79.648884,39.656035],[-79.646357,39.655679],[-79.643952,39.655346],[-79.642199,39.655094],[-79.641203,39.654957],[-79.640754,39.654888],[-79.640157,39.654805],[-79.639708,39.654747],[-79.63926,39.654695],[-79.638899,39.654661],[-79.638532,39.654631],[-79.638225,39.654614],[-79.637901,39.654603],[-79.637583,39.654605],[-79.637252,39.654611],[-79.636931,39.654627],[-79.636663,39.654645],[-79.636374,39.654671],[-79.636087,39.654704],[-79.635793,39.654744],[-79.635271,39.654833],[-79.635,39.654887],[-79.634729,39.654948],[-79.634457,39.655015],[-79.634131,39.655104],[-79.63379,39.655209],[-79.633512,39.655302],[-79.633272,39.655387],[-79.633032,39.655482],[-79.632716,39.655609],[-79.63239,39.655755],[-79.632055,39.655918],[-79.631722,39.656084],[-79.631409,39.656272],[-79.630746,39.65668],[-79.629934,39.657221],[-79.628676,39.658047],[-79.627514,39.658814],[-79.625691,39.660023],[-79.624915,39.660524],[-79.624567,39.660737],[-79.624379,39.660844],[-79.624098,39.660997],[-79.62385,39.661115],[-79.623557,39.661249],[-79.623288,39.661364],[-79.623077,39.661448],[-79.622847,39.661534],[-79.622635,39.661607],[-79.622361,39.661693],[-79.622078,39.661775],[-79.621788,39.661849],[-79.621566,39.661905],[-79.621316,39.661965],[-79.621077,39.662019],[-79.620839,39.662068],[-79.620605,39.662109],[-79.620372,39.662145],[-79.620116,39.662177],[-79.619897,39.662203],[-79.619702,39.662222],[-79.619499,39.66224],[-79.619232,39.662255],[-79.618979,39.662264],[-79.618694,39.662271],[-79.618441,39.662275],[-79.618223,39.662272],[-79.617984,39.662265],[-79.617768,39.662256],[-79.617388,39.662229],[-79.617057,39.662198],[-79.616596,39.662142],[-79.613136,39.661705],[-79.611195,39.661449],[-79.610663,39.661386],[-79.610299,39.661349],[-79.610046,39.661325],[-79.609729,39.661298],[-79.609361,39.661274],[-79.609052,39.661258],[-79.608666,39.661247],[-79.608291,39.661236],[-79.607863,39.661229],[-79.607561,39.661226],[-79.607126,39.661239],[-79.606703,39.661265],[-79.60627,39.661285],[-79.605951,39.661306],[-79.605457,39.661343],[-79.605137,39.661377],[-79.604728,39.661417],[-79.604307,39.661464],[-79.603942,39.66151],[-79.603585,39.661564],[-79.603151,39.661638],[-79.602724,39.661717],[-79.60221,39.661829],[-79.600698,39.662179],[-79.599173,39.662538],[-79.598241,39.662762],[-79.597783,39.662861],[-79.597378,39.66294],[-79.596957,39.663009],[-79.596473,39.663081],[-79.595998,39.663135],[-79.595586,39.663174],[-79.595196,39.663204],[-79.594853,39.663225],[-79.594328,39.663242],[-79.593743,39.66325],[-79.593285,39.663242],[-79.592948,39.66323],[-79.592561,39.663209],[-79.592141,39.663176],[-79.591655,39.663132],[-79.591273,39.663085],[-79.590894,39.663032],[-79.590463,39.662963],[-79.590101,39.662897],[-79.589793,39.662832],[-79.589425,39.66275],[-79.588935,39.662628],[-79.588539,39.662519],[-79.588055,39.662378],[-79.587637,39.662243],[-79.586808,39.661971],[-79.584991,39.661366],[-79.583156,39.660758],[-79.581656,39.66027],[-79.580088,39.65975],[-79.577322,39.658835],[-79.575017,39.658075],[-79.574453,39.657891],[-79.574134,39.657794],[-79.573793,39.65769],[-79.573436,39.657591],[-79.573052,39.65748],[-79.572691,39.65739],[-79.572284,39.657288],[-79.571793,39.657184],[-79.571447,39.657113],[-79.571019,39.657034],[-79.570534,39.656957],[-79.570007,39.656879],[-79.569589,39.656824],[-79.569158,39.656779],[-79.568728,39.656738],[-79.568304,39.656704],[-79.567813,39.656675],[-79.567216,39.656653],[-79.566719,39.656642],[-79.566325,39.65664],[-79.565992,39.656643],[-79.56562,39.656651],[-79.565302,39.656663],[-79.564941,39.656681],[-79.564593,39.656704],[-79.564087,39.656745],[-79.562836,39.656854],[-79.561609,39.656962],[-79.561018,39.657007],[-79.560552,39.657038],[-79.560079,39.657059],[-79.559613,39.657071],[-79.559074,39.657074],[-79.558195,39.657053],[-79.55736,39.657013],[-79.556432,39.656956],[-79.552985,39.656742],[-79.5496,39.656534],[-79.546464,39.656336],[-79.545917,39.656309],[-79.545499,39.656291],[-79.545183,39.656287],[-79.544847,39.656287],[-79.544501,39.656295],[-79.544168,39.656304],[-79.543887,39.656322],[-79.543596,39.656344],[-79.543238,39.656376],[-79.542846,39.656419],[-79.54246,39.656473],[-79.542022,39.656545],[-79.541593,39.656623],[-79.541276,39.656697],[-79.540928,39.656773],[-79.540449,39.656897],[-79.539778,39.657067],[-79.539208,39.657208],[-79.538714,39.657333],[-79.538141,39.657467],[-79.537667,39.65757],[-79.537238,39.657647],[-79.536771,39.657719],[-79.536302,39.657775],[-79.535801,39.657824],[-79.535414,39.657847],[-79.534915,39.657869],[-79.534395,39.657877],[-79.533735,39.657871],[-79.532673,39.657852],[-79.531075,39.657817],[-79.529502,39.657789],[-79.528043,39.657768],[-79.527341,39.657756],[-79.526738,39.657727],[-79.524302,39.657684],[-79.519698,39.657605],[-79.513464,39.657495],[-79.512313,39.657481],[-79.511939,39.657481],[-79.51161,39.657488],[-79.51137,39.657499],[-79.511071,39.657526],[-79.510811,39.657559],[-79.510514,39.657604],[-79.510208,39.65766],[-79.509829,39.657749],[-79.509503,39.657837],[-79.509221,39.657926],[-79.508927,39.658027],[-79.508311,39.658267],[-79.507473,39.658586],[-79.507074,39.658736],[-79.506696,39.658874],[-79.506326,39.658997],[-79.506004,39.659081],[-79.505763,39.659143],[-79.505501,39.659203],[-79.505282,39.659245],[-79.505056,39.659279],[-79.504752,39.659322],[-79.504439,39.65936],[-79.504097,39.659384],[-79.503831,39.659398],[-79.503592,39.659403],[-79.503301,39.659403],[-79.502974,39.659395],[-79.501898,39.659353],[-79.500213,39.659298],[-79.49988,39.659283],[-79.499583,39.659279],[-79.499332,39.659281],[-79.499006,39.659289],[-79.498748,39.659305],[-79.498474,39.659326],[-79.498256,39.659344],[-79.497947,39.659387],[-79.497619,39.659441],[-79.497353,39.659486],[-79.497079,39.659548],[-79.496831,39.659612],[-79.496599,39.65967],[-79.496324,39.659755],[-79.496046,39.659848],[-79.495753,39.659953],[-79.495492,39.660063],[-79.495227,39.660176],[-79.494995,39.660285],[-79.494715,39.660424],[-79.494239,39.660686],[-79.493051,39.66134],[-79.492565,39.661608],[-79.492248,39.661769],[-79.492055,39.661861],[-79.491838,39.661959],[-79.491565,39.66207],[-79.491332,39.662162],[-79.491094,39.662251],[-79.490768,39.66236],[-79.490469,39.662454],[-79.490153,39.662542],[-79.48987,39.662615],[-79.489584,39.662682],[-79.489323,39.662735],[-79.488975,39.662808],[-79.48878,39.662837],[-79.488588,39.662864],[-79.488295,39.662895],[-79.487986,39.662923],[-79.487706,39.662943],[-79.487429,39.662958],[-79.48711,39.662968],[-79.486774,39.662972],[-79.484631,39.662946],[-79.483681,39.662938],[-79.483259,39.662944],[-79.482673,39.662958],[-79.482239,39.66298],[-79.481666,39.663033],[-79.48114,39.663097],[-79.480472,39.663171],[-79.478335,39.663418],[-79.477883,39.663458],[-79.477407,39.663494],[-79.477086,39.663514],[-79.476511,39.663524],[-79.475962,39.66352],[-79.475447,39.663502],[-79.474953,39.663476],[-79.474413,39.663425],[-79.473952,39.663368],[-79.473375,39.66328],[-79.472806,39.663166],[-79.472217,39.663033],[-79.471576,39.662869],[-79.465276,39.66117],[-79.464624,39.660993],[-79.449529,39.656948],[-79.449106,39.656823],[-79.448827,39.656733],[-79.448479,39.656611],[-79.448118,39.656469],[-79.447756,39.65631],[-79.447387,39.656133],[-79.446962,39.655905],[-79.446499,39.655636],[-79.444747,39.654541],[-79.444373,39.654324],[-79.443975,39.654118],[-79.443628,39.653965],[-79.443309,39.653845],[-79.442961,39.653726],[-79.442488,39.653593],[-79.442091,39.653512],[-79.44167,39.653441],[-79.441245,39.65339],[-79.440817,39.65336],[-79.440369,39.653349],[-79.439905,39.653362],[-79.439454,39.653404],[-79.438891,39.653479],[-79.438418,39.65358],[-79.437958,39.653703],[-79.437507,39.65385],[-79.436996,39.654054],[-79.436517,39.654285],[-79.436167,39.654482],[-79.435825,39.654702],[-79.435451,39.654986],[-79.435064,39.655326],[-79.432382,39.657827],[-79.430757,39.659316],[-79.430499,39.659553],[-79.430209,39.659789],[-79.42991,39.660012],[-79.429516,39.660262],[-79.429113,39.660477],[-79.428597,39.660754],[-79.428067,39.661024],[-79.427588,39.661238],[-79.427115,39.661422],[-79.426697,39.66156],[-79.426281,39.661678],[-79.425794,39.661788],[-79.42535,39.661878],[-79.424896,39.661951],[-79.424452,39.662007],[-79.423989,39.662054],[-79.423536,39.662077],[-79.423041,39.662081],[-79.418002,39.66205],[-79.415461,39.662029],[-79.414955,39.662011],[-79.414436,39.661984],[-79.414084,39.661963],[-79.413625,39.66192],[-79.412876,39.661825],[-79.412254,39.661727],[-79.411773,39.66164],[-79.409433,39.661181],[-79.407664,39.660862],[-79.407193,39.660782],[-79.406715,39.660707],[-79.406209,39.660653],[-79.405797,39.660633],[-79.405395,39.660625],[-79.404937,39.660635],[-79.404466,39.660673],[-79.404004,39.66073],[-79.401867,39.6611],[-79.399297,39.661551],[-79.396656,39.662004],[-79.396074,39.662125],[-79.395553,39.662253],[-79.395047,39.662393],[-79.394489,39.662575],[-79.393974,39.662782],[-79.393536,39.662978],[-79.393028,39.663218],[-79.392643,39.663429],[-79.392262,39.663668],[-79.391865,39.663935],[-79.391448,39.664256],[-79.39105,39.664614],[-79.386781,39.669037],[-79.386451,39.669409],[-79.386099,39.669821],[-79.385611,39.67043],[-79.385195,39.671008],[-79.384817,39.671592],[-79.384508,39.672112],[-79.384241,39.672495],[-79.383895,39.673001],[-79.382983,39.674432],[-79.38267,39.674939],[-79.382432,39.675288],[-79.382175,39.675574],[-79.381869,39.675867],[-79.381556,39.676128],[-79.381205,39.676384],[-79.380816,39.676636],[-79.380447,39.676845],[-79.380034,39.677036],[-79.379559,39.67723],[-79.379095,39.677379],[-79.378599,39.677501],[-79.373862,39.678481],[-79.373152,39.678625],[-79.372462,39.678784],[-79.371878,39.678942],[-79.371163,39.679166],[-79.370444,39.679436],[-79.369859,39.67968],[-79.369305,39.679955],[-79.360874,39.684751],[-79.360398,39.685018],[-79.359873,39.685293],[-79.35944,39.685495],[-79.358939,39.685711],[-79.358402,39.685914],[-79.357815,39.686113],[-79.357166,39.686313],[-79.356602,39.686445],[-79.356081,39.68656],[-79.352188,39.687223],[-79.351569,39.687349],[-79.351032,39.687471],[-79.350492,39.687614],[-79.349969,39.687776],[-79.349318,39.687998],[-79.348686,39.688255],[-79.348072,39.68853],[-79.347487,39.688828],[-79.346685,39.689286],[-79.346108,39.689659],[-79.34551,39.690095],[-79.34499,39.69052],[-79.342702,39.692576],[-79.342281,39.692938],[-79.341974,39.693187],[-79.341536,39.69351],[-79.341089,39.693825],[-79.340608,39.694139],[-79.340017,39.694484],[-79.339615,39.694713],[-79.339098,39.69497],[-79.338547,39.695237],[-79.337889,39.695526],[-79.337291,39.695757],[-79.335672,39.69631],[-79.331108,39.697863],[-79.33057,39.698021],[-79.330063,39.698132],[-79.329617,39.698202],[-79.329178,39.698252],[-79.328658,39.69828],[-79.328202,39.69828],[-79.327731,39.698256],[-79.327282,39.698202],[-79.32679,39.698111],[-79.326251,39.697989],[-79.324645,39.697555],[-79.324116,39.697423],[-79.323693,39.697332],[-79.323267,39.697266],[-79.32278,39.69722],[-79.32231,39.697202],[-79.321841,39.697202],[-79.321307,39.697235],[-79.320757,39.697304],[-79.320319,39.697382],[-79.319766,39.697524],[-79.318883,39.697809],[-79.312975,39.700075],[-79.311238,39.700748],[-79.310578,39.700976],[-79.310031,39.701137],[-79.309461,39.70127],[-79.308856,39.701381],[-79.308313,39.701459],[-79.307695,39.701517],[-79.307027,39.701551],[-79.306465,39.701549],[-79.305883,39.701518],[-79.305445,39.701485],[-79.297301,39.700733],[-79.295511,39.700584],[-79.288469,39.699931],[-79.287878,39.699864],[-79.287312,39.699781],[-79.286758,39.69968],[-79.286207,39.69956],[-79.285612,39.699413],[-79.285068,39.699253],[-79.284442,39.699042],[-79.28383,39.698805],[-79.282752,39.698351],[-79.278514,39.696538],[-79.278011,39.696307],[-79.277559,39.696134],[-79.277138,39.695994],[-79.276674,39.695853],[-79.276234,39.695739],[-79.275741,39.695631],[-79.275197,39.695539],[-79.274705,39.695473],[-79.274224,39.695429],[-79.273691,39.695397],[-79.27326,39.695386],[-79.27055,39.69543],[-79.269694,39.695429],[-79.268997,39.695415],[-79.268149,39.695373],[-79.267305,39.695317],[-79.266464,39.695241],[-79.265611,39.695139],[-79.264789,39.695022],[-79.263963,39.694886],[-79.261023,39.694393],[-79.258967,39.694046],[-79.258281,39.693907],[-79.257595,39.693747],[-79.25691,39.693555],[-79.256382,39.693384],[-79.25579,39.693181],[-79.255086,39.692904],[-79.254416,39.692613],[-79.253754,39.69229],[-79.253159,39.691971],[-79.252438,39.691535],[-79.251593,39.690962],[-79.249209,39.689305],[-79.248059,39.688502],[-79.245779,39.686931],[-79.241826,39.684167],[-79.239304,39.682412],[-79.23884,39.68209],[-79.238504,39.681876],[-79.238175,39.681687],[-79.237692,39.681434],[-79.237242,39.681224],[-79.236694,39.681001],[-79.236221,39.680831],[-79.235714,39.680674],[-79.235209,39.680544],[-79.234685,39.680427],[-79.234206,39.680343],[-79.23367,39.68027],[-79.233203,39.680222],[-79.232732,39.680192],[-79.232254,39.680179],[-79.231111,39.680165],[-79.22897,39.680121],[-79.219663,39.680015],[-79.21807,39.680008],[-79.217365,39.680033],[-79.216793,39.680074],[-79.216225,39.68014],[-79.215688,39.680227],[-79.215207,39.680327],[-79.214681,39.680449],[-79.214053,39.680636],[-79.213469,39.680845],[-79.212918,39.681074],[-79.212421,39.681309],[-79.209451,39.682911],[-79.208937,39.683165],[-79.208513,39.683367],[-79.208051,39.683569],[-79.207552,39.68378],[-79.207093,39.683955],[-79.206562,39.684148],[-79.20593,39.684358],[-79.205458,39.6845],[-79.204819,39.684681],[-79.204194,39.684841],[-79.2008,39.685673],[-79.192041,39.687829],[-79.191585,39.687955],[-79.191119,39.688113],[-79.190674,39.688293],[-79.190264,39.688498],[-79.189863,39.688727],[-79.189531,39.688945],[-79.189165,39.689222],[-79.188847,39.689495],[-79.1864,39.691911],[-79.186138,39.692164],[-79.185884,39.692395],[-79.185575,39.69264],[-79.185279,39.692845],[-79.184962,39.693044],[-79.184599,39.693242],[-79.184249,39.693412],[-79.183881,39.693562],[-79.183362,39.69374],[-79.182963,39.693848],[-79.182576,39.693934],[-79.182194,39.693995],[-79.181717,39.694056],[-79.17786,39.69445],[-79.177406,39.694482],[-79.176905,39.694501],[-79.176386,39.694498],[-79.175848,39.694482],[-79.175278,39.69443],[-79.174831,39.694367],[-79.174288,39.694285],[-79.173785,39.69421],[-79.170901,39.693768],[-79.170479,39.693702],[-79.169273,39.693516],[-79.168196,39.693337],[-79.167138,39.693177],[-79.166222,39.69306],[-79.165437,39.692988],[-79.164706,39.692941],[-79.163928,39.692913],[-79.163341,39.692909],[-79.162566,39.692914],[-79.160301,39.692959],[-79.159088,39.692971],[-79.158573,39.692958],[-79.158099,39.692928],[-79.157609,39.692887],[-79.15714,39.692831],[-79.156653,39.692766],[-79.156208,39.692693],[-79.15569,39.692595],[-79.154301,39.692323],[-79.153783,39.692224],[-79.15339,39.692154],[-79.15292,39.692091],[-79.152482,39.692052],[-79.15204,39.69202],[-79.151438,39.692005],[-79.150908,39.692015],[-79.150474,39.692039],[-79.150027,39.692077],[-79.14958,39.692132],[-79.149074,39.692211],[-79.148607,39.6923],[-79.148166,39.692403],[-79.147807,39.692501],[-79.142713,39.694098],[-79.141269,39.694549],[-79.140667,39.694733],[-79.139608,39.695064],[-79.139396,39.695132],[-79.139056,39.695221],[-79.13855,39.695335],[-79.138191,39.695404],[-79.137761,39.695478],[-79.137325,39.695523],[-79.136799,39.695561],[-79.136397,39.695565],[-79.13596,39.695561],[-79.135526,39.695527],[-79.135028,39.695469],[-79.134616,39.695394],[-79.134213,39.695302],[-79.133209,39.695046],[-79.132813,39.694956],[-79.132465,39.694887],[-79.132038,39.694816],[-79.131398,39.694737],[-79.130945,39.694705],[-79.130414,39.694684],[-79.129829,39.694686],[-79.129238,39.694706],[-79.125199,39.694892],[-79.124681,39.694915],[-79.124194,39.694933],[-79.123695,39.694929],[-79.123194,39.694901],[-79.122659,39.694848],[-79.122142,39.694762],[-79.121618,39.694649],[-79.121051,39.694504],[-79.120435,39.694303],[-79.119978,39.694129],[-79.114504,39.691834],[-79.113178,39.691301],[-79.112636,39.691101],[-79.11202,39.690886],[-79.111377,39.69067],[-79.110791,39.690489],[-79.109903,39.690235],[-79.109229,39.690056],[-79.108623,39.689906],[-79.1031,39.688695],[-79.101082,39.688271],[-79.097822,39.687556],[-79.095313,39.686987],[-79.084696,39.684661],[-79.08391,39.684495],[-79.083111,39.684335],[-79.082165,39.68417],[-79.080979,39.683989],[-79.080265,39.683893],[-79.079695,39.683825],[-79.078794,39.683727],[-79.07685,39.683547],[-79.074848,39.683395],[-79.074284,39.683348],[-79.073763,39.683298],[-79.065032,39.682538],[-79.061735,39.682255],[-79.061154,39.682216],[-79.060637,39.6822],[-79.060115,39.682212],[-79.059658,39.682238],[-79.05916,39.682287],[-79.058685,39.682359],[-79.058172,39.682456],[-79.057051,39.682717],[-79.056267,39.682896],[-79.05575,39.682998],[-79.055201,39.68308],[-79.054674,39.683126],[-79.05419,39.683148],[-79.053656,39.683144],[-79.053175,39.683114],[-79.052644,39.683055],[-79.052146,39.682974],[-79.051579,39.682863],[-79.050399,39.682609],[-79.049417,39.682385],[-79.047062,39.681882],[-79.046499,39.681783],[-79.046036,39.681723],[-79.045586,39.681675],[-79.045049,39.681645],[-79.044498,39.681633],[-79.043947,39.681642],[-79.043404,39.681676],[-79.042859,39.681731],[-79.04228,39.681817],[-79.041623,39.681942],[-79.038965,39.682519],[-79.038597,39.682592],[-79.038161,39.682655],[-79.03754,39.682715],[-79.036998,39.682734],[-79.036529,39.682729],[-79.035994,39.682697],[-79.035526,39.682643],[-79.034959,39.682556],[-79.033462,39.682292],[-79.031996,39.682061],[-79.031309,39.681965],[-79.030733,39.68192],[-79.030151,39.681893],[-79.029453,39.681899],[-79.028847,39.68193],[-79.028301,39.681983],[-79.027753,39.682063],[-79.027159,39.682171],[-79.024441,39.682708],[-79.020312,39.683521],[-79.019748,39.683619],[-79.019201,39.683693],[-79.018633,39.683755],[-79.017968,39.6838],[-79.017414,39.683821],[-79.016858,39.68382],[-79.016234,39.683797],[-79.015543,39.683739],[-79.015002,39.683673],[-79.011383,39.683287],[-79.010564,39.683203],[-79.009754,39.683136],[-79.008988,39.683083],[-79.0082,39.683037],[-79.007486,39.683014],[-79.00664,39.682991],[-79.00578,39.682984],[-79.004909,39.682992],[-79.004108,39.683008],[-79.003499,39.683032],[-79.002629,39.683077],[-79.001843,39.683132],[-79.000891,39.683211],[-79.000156,39.683283],[-78.999653,39.683342],[-78.998923,39.683438],[-78.998108,39.683559],[-78.997237,39.683695],[-78.995869,39.68394],[-78.994819,39.684154],[-78.993598,39.684432],[-78.99277,39.68464],[-78.983273,39.687088],[-78.981219,39.687618],[-78.980711,39.687738],[-78.980256,39.687822],[-78.979812,39.687886],[-78.97932,39.687931],[-78.978734,39.687959],[-78.978196,39.687957],[-78.977698,39.687926],[-78.977287,39.687882],[-78.976873,39.687821],[-78.976397,39.68773],[-78.975947,39.687624],[-78.975399,39.687455],[-78.974896,39.687276],[-78.974429,39.687072],[-78.974001,39.686861],[-78.973621,39.686643],[-78.97324,39.686395],[-78.972824,39.686097],[-78.97245,39.685773],[-78.97212,39.68546],[-78.966765,39.67953],[-78.966365,39.679067],[-78.965575,39.678155],[-78.965157,39.677623],[-78.964784,39.677098],[-78.964431,39.676561],[-78.964037,39.675883],[-78.96377,39.675375],[-78.963483,39.67476],[-78.963259,39.674209],[-78.963029,39.673554],[-78.962868,39.673008],[-78.962687,39.672316],[-78.962233,39.670415],[-78.961981,39.669471],[-78.96153,39.66761],[-78.961205,39.666267],[-78.961076,39.66584],[-78.960903,39.66539],[-78.960694,39.664934],[-78.960421,39.664456],[-78.960106,39.663975],[-78.959712,39.663481],[-78.959291,39.663023],[-78.958864,39.662616],[-78.958357,39.662188],[-78.957042,39.661117],[-78.956598,39.66072],[-78.956344,39.660462],[-78.956036,39.66014],[-78.955718,39.659753],[-78.95536,39.659269],[-78.95507,39.658808],[-78.954821,39.658354],[-78.954596,39.657873],[-78.954404,39.657367],[-78.954264,39.656896],[-78.954168,39.656477],[-78.954095,39.656024],[-78.954044,39.655507],[-78.954034,39.655033],[-78.954062,39.654471],[-78.954114,39.654067],[-78.954203,39.653604],[-78.954314,39.653175],[-78.955023,39.650672],[-78.955111,39.650295],[-78.95517,39.649909],[-78.955217,39.649477],[-78.955237,39.649004],[-78.955234,39.648606],[-78.955198,39.648164],[-78.955148,39.647705],[-78.955104,39.647199],[-78.955052,39.646795],[-78.95499,39.646441],[-78.954875,39.646038],[-78.954754,39.645687],[-78.954589,39.645318],[-78.95438,39.64491],[-78.954137,39.644541],[-78.953906,39.644237],[-78.953554,39.643828],[-78.953307,39.643573],[-78.95133,39.641652],[-78.949927,39.640276],[-78.949396,39.63975],[-78.947844,39.638248],[-78.94744,39.637887],[-78.947014,39.637518],[-78.946452,39.637073],[-78.945933,39.636691],[-78.94544,39.636348],[-78.944996,39.636064],[-78.944634,39.635851],[-78.944265,39.635658],[-78.943832,39.635458],[-78.943322,39.635249],[-78.942728,39.635045],[-78.942115,39.634873],[-78.941386,39.634698],[-78.940387,39.634481],[-78.939629,39.634324],[-78.93858,39.634133],[-78.93674,39.633849],[-78.936031,39.633758],[-78.935218,39.633666],[-78.933981,39.633549],[-78.933425,39.633508],[-78.932392,39.633447],[-78.931625,39.633414],[-78.930882,39.633377],[-78.92993,39.633361],[-78.929136,39.633368],[-78.928298,39.633382],[-78.92737,39.633416],[-78.926475,39.633461],[-78.925436,39.633514],[-78.924784,39.633529],[-78.924224,39.633522],[-78.923518,39.633485],[-78.922954,39.633436],[-78.922398,39.633367],[-78.921828,39.633281],[-78.918167,39.632673],[-78.917157,39.632517],[-78.916526,39.632417],[-78.916044,39.632353],[-78.915561,39.632317],[-78.915085,39.6323],[-78.914656,39.632308],[-78.914132,39.632335],[-78.913684,39.632381],[-78.913253,39.632444],[-78.912749,39.632535],[-78.912254,39.632657],[-78.911753,39.632814],[-78.910066,39.633362],[-78.908893,39.633741],[-78.906118,39.634649],[-78.905074,39.635011],[-78.896475,39.638272],[-78.895783,39.638541],[-78.894965,39.638848],[-78.894414,39.639044],[-78.893885,39.639198],[-78.893409,39.639315],[-78.892372,39.639543],[-78.889894,39.640089],[-78.8889,39.640307],[-78.888395,39.640397],[-78.887803,39.64049],[-78.886906,39.640612],[-78.88579,39.640742],[-78.884354,39.640913],[-78.883779,39.640967],[-78.883083,39.641012],[-78.882475,39.641041],[-78.881846,39.641053],[-78.88115,39.641051],[-78.88054,39.641035],[-78.878147,39.640889],[-78.877442,39.640855],[-78.876975,39.640858],[-78.876556,39.640877],[-78.876169,39.640915],[-78.874927,39.641095],[-78.874368,39.641162],[-78.873967,39.641197],[-78.873639,39.641217],[-78.873306,39.64123],[-78.872935,39.641239],[-78.872498,39.641233],[-78.872186,39.641218],[-78.871855,39.6412],[-78.871555,39.641175],[-78.871175,39.641135],[-78.87081,39.641087],[-78.870447,39.641029],[-78.869765,39.640898],[-78.86924,39.64077],[-78.868617,39.640598],[-78.864835,39.639457],[-78.864059,39.639228],[-78.863202,39.638991],[-78.862444,39.638796],[-78.86153,39.638577],[-78.860757,39.638408],[-78.859113,39.638049],[-78.85722,39.637658],[-78.856352,39.637497],[-78.855596,39.637356],[-78.854719,39.637171],[-78.853951,39.636995],[-78.853337,39.636861],[-78.852742,39.636735],[-78.851855,39.636566],[-78.849736,39.636151],[-78.849162,39.636016],[-78.848643,39.635883],[-78.84665,39.635317],[-78.846084,39.635158],[-78.845556,39.635038],[-78.844987,39.634945],[-78.84451,39.634899],[-78.843995,39.634877],[-78.843431,39.634883],[-78.843115,39.634905],[-78.842803,39.634938],[-78.842441,39.634992],[-78.841457,39.635159],[-78.840945,39.635238],[-78.840391,39.635303],[-78.839752,39.635344],[-78.839175,39.635356],[-78.838569,39.635344],[-78.838044,39.635311],[-78.837591,39.63526],[-78.835358,39.635014],[-78.83476,39.634964],[-78.834165,39.634934],[-78.833582,39.634924],[-78.832921,39.634929],[-78.832338,39.63496],[-78.831694,39.635016],[-78.830235,39.635158],[-78.829698,39.635209],[-78.829144,39.635261],[-78.826524,39.635524],[-78.82611,39.635576],[-78.825718,39.635636],[-78.825394,39.63571],[-78.824924,39.63583],[-78.82441,39.636006],[-78.823843,39.63624],[-78.823339,39.636495],[-78.822877,39.636761],[-78.819261,39.638877],[-78.818477,39.639352],[-78.817483,39.64003],[-78.816753,39.640569],[-78.816336,39.640872],[-78.816008,39.64109],[-78.815684,39.641256],[-78.815394,39.64137],[-78.815052,39.641458],[-78.814664,39.641526],[-78.814326,39.641554],[-78.813964,39.641555],[-78.81369,39.641532],[-78.813423,39.64149],[-78.813125,39.641415],[-78.812757,39.641299],[-78.812105,39.64108],[-78.811741,39.640958],[-78.811417,39.640866],[-78.811098,39.640793],[-78.810742,39.640729],[-78.810308,39.640671],[-78.809806,39.64064],[-78.809325,39.640639],[-78.808853,39.64067],[-78.808469,39.640719],[-78.807562,39.640844],[-78.80718,39.64089],[-78.806809,39.640928],[-78.80628,39.640964],[-78.805791,39.640975],[-78.805328,39.640973],[-78.804916,39.640956],[-78.804521,39.640932],[-78.804042,39.640887],[-78.803544,39.640822],[-78.803197,39.640766],[-78.802732,39.640683],[-78.80225,39.640575],[-78.801303,39.640372],[-78.800991,39.640317],[-78.800733,39.640291],[-78.800451,39.640274],[-78.800146,39.640291],[-78.799797,39.640336],[-78.799408,39.640421],[-78.799067,39.640519],[-78.798762,39.640648],[-78.798384,39.640841],[-78.797975,39.6411],[-78.797101,39.641689],[-78.796565,39.642018],[-78.796118,39.642276],[-78.795635,39.642541],[-78.795248,39.642746],[-78.794774,39.642969],[-78.794381,39.643146],[-78.793946,39.643338],[-78.793414,39.643553],[-78.792869,39.643768],[-78.792297,39.643967],[-78.791767,39.644134],[-78.791182,39.644308],[-78.790623,39.644457],[-78.790027,39.644599],[-78.789522,39.64471],[-78.788757,39.644859],[-78.787779,39.645014],[-78.787284,39.645076],[-78.786791,39.645127],[-78.786088,39.645188],[-78.785524,39.645219],[-78.784945,39.645244],[-78.784329,39.645268],[-78.783846,39.645295],[-78.783314,39.645357],[-78.782644,39.645453],[-78.781962,39.645582],[-78.781426,39.645707],[-78.780712,39.645901],[-78.779756,39.646205],[-78.779235,39.646361],[-78.778545,39.646576],[-78.778073,39.646698],[-78.777671,39.646794],[-78.777161,39.646883],[-78.776541,39.646955],[-78.776093,39.646987],[-78.775616,39.646998],[-78.773897,39.647022],[-78.772753,39.64704],[-78.771889,39.647055],[-78.771469,39.64707],[-78.771154,39.647112],[-78.77087,39.647174],[-78.770555,39.647273],[-78.770269,39.647389],[-78.769963,39.64756],[-78.769779,39.647686],[-78.769648,39.64778],[-78.7688,39.648515],[-78.768504,39.648763],[-78.76832,39.648892],[-78.76799,39.649079],[-78.767619,39.649221],[-78.767497,39.64925],[-78.767203,39.649319],[-78.76685,39.649375],[-78.766565,39.649389],[-78.766251,39.649379],[-78.765961,39.649349],[-78.765562,39.649277],[-78.76464,39.649091],[-78.763679,39.648898],[-78.763371,39.648845],[-78.763106,39.648816],[-78.762832,39.648804],[-78.762522,39.648808],[-78.762189,39.648836],[-78.761859,39.648881],[-78.761206,39.649049],[-78.760769,39.649171],[-78.760434,39.649239],[-78.760115,39.649292],[-78.759827,39.649327],[-78.759399,39.649356],[-78.757361,39.649463],[-78.757018,39.649503],[-78.756677,39.649563],[-78.75639,39.64963],[-78.756064,39.649727],[-78.755804,39.649819],[-78.755462,39.649963],[-78.755198,39.650099],[-78.755117,39.650145],[-78.754915,39.650262],[-78.754674,39.65043],[-78.754356,39.650691],[-78.754073,39.650974],[-78.753402,39.651716],[-78.751731,39.653545],[-78.751323,39.65398],[-78.75086,39.654426],[-78.750422,39.654846],[-78.749571,39.655606],[-78.748255,39.656782],[-78.747915,39.657089],[-78.746503,39.658445],[-78.745719,39.659189],[-78.745047,39.659802],[-78.74465,39.660171],[-78.744179,39.660624],[-78.741101,39.663583],[-78.74071,39.66395],[-78.740352,39.664263],[-78.739936,39.664594],[-78.739543,39.664883],[-78.739259,39.665073],[-78.738789,39.665382],[-78.737633,39.666065],[-78.737423,39.666186],[-78.736984,39.666465],[-78.736375,39.666935],[-78.73571,39.667474],[-78.735235,39.667919],[-78.734832,39.66834],[-78.734378,39.668857],[-78.733992,39.669369],[-78.732565,39.671324],[-78.732271,39.671715],[-78.732001,39.67201],[-78.731731,39.672247],[-78.731416,39.672474],[-78.731083,39.672671],[-78.730654,39.672869],[-78.730151,39.673042],[-78.729679,39.673158],[-78.729228,39.673225],[-78.728815,39.673255],[-78.728413,39.673256],[-78.728015,39.673251],[-78.727594,39.673242],[-78.725323,39.673221],[-78.723932,39.673205],[-78.723597,39.673197],[-78.722963,39.673189],[-78.722351,39.673191],[-78.721728,39.673224],[-78.721117,39.673288],[-78.719102,39.673535],[-78.718589,39.673581],[-78.718038,39.673601],[-78.717661,39.673592],[-78.717205,39.67356],[-78.71681,39.673513],[-78.716355,39.673432],[-78.715862,39.673321],[-78.715424,39.673187],[-78.714946,39.673005],[-78.71425,39.67272],[-78.711463,39.671549],[-78.711048,39.671382],[-78.710669,39.671239],[-78.710255,39.6711],[-78.709792,39.670955],[-78.709368,39.670833],[-78.707456,39.67029],[-78.70474,39.669544],[-78.704332,39.669445],[-78.703824,39.669351],[-78.703348,39.669293],[-78.702937,39.669268],[-78.702488,39.669256],[-78.702042,39.669267],[-78.701498,39.669313],[-78.701033,39.669381],[-78.700627,39.669459],[-78.700106,39.669592],[-78.699661,39.669731],[-78.699164,39.669925],[-78.698685,39.670147],[-78.69823,39.670408],[-78.697829,39.670672],[-78.694298,39.673128],[-78.693692,39.673532],[-78.693103,39.673904],[-78.692462,39.674301],[-78.691923,39.674626],[-78.691273,39.674994],[-78.690617,39.675357],[-78.68996,39.675714],[-78.689469,39.675963],[-78.688782,39.676302],[-78.688057,39.676638],[-78.687456,39.67691],[-78.68686,39.677173],[-78.686158,39.677475],[-78.68546,39.677746],[-78.684794,39.677998],[-78.684212,39.678209],[-78.683569,39.678431],[-78.682832,39.678665],[-78.682023,39.678917],[-78.681284,39.679128],[-78.680535,39.679336],[-78.678039,39.679982],[-78.677156,39.680206],[-78.676125,39.6805],[-78.675022,39.680832],[-78.671094,39.682053],[-78.670237,39.682327],[-78.669639,39.682543],[-78.668919,39.682805],[-78.668273,39.683066],[-78.66759,39.683349],[-78.66676,39.683728],[-78.665204,39.684519],[-78.664543,39.684884],[-78.663851,39.685295],[-78.663278,39.685654],[-78.662545,39.686138],[-78.661935,39.686577],[-78.661338,39.687021],[-78.66074,39.68749],[-78.656767,39.690698],[-78.655882,39.691413],[-78.65498,39.692135],[-78.654573,39.692445],[-78.654172,39.692716],[-78.653726,39.692978],[-78.653186,39.693254],[-78.652654,39.69348],[-78.652041,39.693688],[-78.651448,39.693847],[-78.650764,39.693984],[-78.650137,39.694076],[-78.649215,39.694186],[-78.645424,39.694656],[-78.644656,39.694755],[-78.643954,39.694876],[-78.643337,39.695004],[-78.64267,39.695172],[-78.641733,39.695451],[-78.640921,39.695736],[-78.640312,39.69598],[-78.639655,39.696289],[-78.638952,39.696654],[-78.638291,39.697048],[-78.637681,39.697449],[-78.637025,39.697917],[-78.636444,39.698382],[-78.635847,39.698892],[-78.635261,39.699451],[-78.634682,39.700007],[-78.634031,39.700626],[-78.633596,39.701019],[-78.633189,39.701366],[-78.632642,39.701811],[-78.63208,39.702249],[-78.630474,39.703424],[-78.630059,39.703718],[-78.629603,39.703983],[-78.629253,39.704158],[-78.628888,39.704316],[-78.628497,39.704467],[-78.627959,39.704633],[-78.627441,39.704752],[-78.625937,39.705066],[-78.625294,39.705201],[-78.624695,39.705363],[-78.624164,39.705548],[-78.623714,39.705739],[-78.623225,39.705984],[-78.622738,39.706291],[-78.622263,39.706643],[-78.621945,39.706921],[-78.621662,39.707211],[-78.621398,39.707519],[-78.619076,39.71042],[-78.618774,39.710785],[-78.618455,39.71114],[-78.618036,39.711569],[-78.617654,39.711917],[-78.617245,39.712265],[-78.616848,39.712577],[-78.616395,39.712896],[-78.615861,39.713223],[-78.615408,39.713461],[-78.614925,39.71367],[-78.614391,39.713858],[-78.61377,39.714032],[-78.613179,39.714154],[-78.612625,39.714229],[-78.612106,39.714275],[-78.611671,39.714291],[-78.611245,39.714282],[-78.610683,39.714246],[-78.610463,39.714221],[-78.610039,39.714156],[-78.60957,39.714067],[-78.609131,39.713959],[-78.608612,39.713796],[-78.608085,39.713597],[-78.607669,39.713407],[-78.607242,39.713182],[-78.60683,39.712928],[-78.606399,39.712618],[-78.603122,39.710024],[-78.602585,39.709636],[-78.602167,39.709371],[-78.601699,39.709101],[-78.601213,39.708847],[-78.600716,39.708622],[-78.600208,39.708416],[-78.599663,39.708216],[-78.599081,39.708026],[-78.598487,39.707856],[-78.597859,39.707703],[-78.597285,39.707577],[-78.596609,39.707449],[-78.59599,39.707347],[-78.595326,39.707262],[-78.594789,39.707203],[-78.594178,39.707153],[-78.593609,39.707118],[-78.581812,39.706529],[-78.575437,39.706209],[-78.57336,39.706109],[-78.572769,39.706073],[-78.572119,39.706018],[-78.571586,39.705953],[-78.571049,39.705873],[-78.570562,39.705787],[-78.570051,39.705688],[-78.569519,39.705568],[-78.568881,39.705404],[-78.568221,39.705205],[-78.567531,39.704976],[-78.56714,39.70483],[-78.566785,39.70469],[-78.56643,39.70454],[-78.565987,39.704346],[-78.565481,39.7041],[-78.565049,39.703866],[-78.564624,39.703614],[-78.564234,39.703348],[-78.56381,39.703036],[-78.563365,39.70267],[-78.563103,39.702413],[-78.562807,39.702087],[-78.562579,39.701799],[-78.561345,39.700193],[-78.561094,39.699877],[-78.560834,39.699613],[-78.560578,39.699374],[-78.560308,39.699154],[-78.560003,39.698929],[-78.559618,39.698679],[-78.559211,39.698459],[-78.558845,39.698283],[-78.558417,39.698108],[-78.557945,39.697949],[-78.557484,39.69782],[-78.557061,39.697729],[-78.556544,39.697633],[-78.553366,39.697047],[-78.552435,39.696874],[-78.549395,39.696315],[-78.547254,39.695919],[-78.546342,39.695752],[-78.545154,39.695514],[-78.543759,39.695262],[-78.542828,39.695107],[-78.541878,39.694969],[-78.541164,39.694878],[-78.540314,39.694779],[-78.539602,39.694703],[-78.538776,39.694637],[-78.537823,39.694576],[-78.53677,39.694522],[-78.535993,39.694501],[-78.5352,39.694489],[-78.534409,39.694489],[-78.533728,39.694496],[-78.532928,39.694518],[-78.531928,39.694564],[-78.530986,39.694623],[-78.530206,39.694681],[-78.529451,39.694757],[-78.528727,39.69484],[-78.527998,39.694939],[-78.527317,39.69505],[-78.526504,39.695198],[-78.52581,39.695341],[-78.52484,39.695557],[-78.521179,39.696386],[-78.520609,39.696498],[-78.520107,39.696577],[-78.519583,39.696642],[-78.519163,39.69668],[-78.518664,39.69671],[-78.518169,39.696728],[-78.5177,39.696736],[-78.51716,39.696715],[-78.516667,39.696676],[-78.516175,39.696623],[-78.515679,39.696552],[-78.515187,39.696465],[-78.514642,39.696348],[-78.514123,39.696214],[-78.513649,39.696072],[-78.513148,39.6959],[-78.512615,39.695696],[-78.506918,39.693315],[-78.506515,39.693133],[-78.506121,39.692937],[-78.505786,39.692744],[-78.505399,39.6925],[-78.505031,39.692228],[-78.504694,39.691953],[-78.504352,39.69163],[-78.504026,39.691274],[-78.502851,39.689947],[-78.502429,39.689497],[-78.501922,39.688997],[-78.501545,39.688651],[-78.50116,39.688315],[-78.495457,39.683523],[-78.495097,39.683245],[-78.494736,39.682997],[-78.494374,39.682778],[-78.494011,39.682584],[-78.493604,39.682396],[-78.493135,39.682202],[-78.492674,39.682051],[-78.492186,39.681914],[-78.491684,39.681807],[-78.491054,39.681686],[-78.490403,39.681589],[-78.489757,39.681513],[-78.489078,39.681455],[-78.48846,39.681419],[-78.487844,39.6814],[-78.484942,39.681329],[-78.484472,39.681308],[-78.483978,39.681265],[-78.483506,39.681202],[-78.483037,39.681113],[-78.482566,39.681003],[-78.482092,39.680865],[-78.481632,39.680709],[-78.481156,39.680519],[-78.474964,39.678034],[-78.474525,39.677871],[-78.474158,39.677763],[-78.473704,39.677651],[-78.473271,39.677568],[-78.472791,39.677499],[-78.472387,39.677464],[-78.471909,39.677447],[-78.471443,39.677457],[-78.470942,39.677492],[-78.470448,39.677551],[-78.467311,39.677982],[-78.466961,39.678019],[-78.466573,39.678047],[-78.466215,39.678054],[-78.465874,39.67805],[-78.465476,39.678026],[-78.465056,39.677981],[-78.464604,39.677908],[-78.464202,39.677823],[-78.463845,39.677727],[-78.460228,39.67657],[-78.45977,39.676405],[-78.459326,39.67622],[-78.458972,39.676047],[-78.458543,39.675807],[-78.458187,39.675577],[-78.457786,39.67528],[-78.457511,39.675052],[-78.457287,39.674836],[-78.457066,39.674607],[-78.456834,39.674338],[-78.456586,39.674003],[-78.456392,39.673697],[-78.456069,39.673114],[-78.455637,39.67235],[-78.455328,39.671891],[-78.454937,39.671382],[-78.454505,39.670904],[-78.45409,39.670492],[-78.453624,39.670083],[-78.453215,39.66977],[-78.452714,39.669412],[-78.452244,39.669115],[-78.451845,39.668885],[-78.451354,39.668627],[-78.450732,39.668345],[-78.450155,39.668115],[-78.449558,39.667908],[-78.448973,39.667736],[-78.448484,39.667611],[-78.447996,39.667506],[-78.447478,39.667412],[-78.446802,39.667321],[-78.446137,39.667259],[-78.445536,39.667227],[-78.444937,39.667221],[-78.444343,39.667238],[-78.443803,39.667275],[-78.443247,39.667332],[-78.434684,39.668396],[-78.434161,39.668457],[-78.433776,39.668481],[-78.433351,39.668477],[-78.432958,39.668442],[-78.432568,39.668377],[-78.432208,39.668292],[-78.431845,39.668182],[-78.431472,39.66804],[-78.431168,39.667892],[-78.430824,39.667695],[-78.425986,39.664896],[-78.425656,39.664721],[-78.425277,39.664544],[-78.424887,39.664393],[-78.424416,39.664248],[-78.423966,39.66414],[-78.423479,39.664057],[-78.422957,39.664001],[-78.422432,39.663986],[-78.421923,39.664001],[-78.421459,39.664051],[-78.421025,39.664122],[-78.420582,39.664223],[-78.420156,39.664346],[-78.419741,39.664498],[-78.419318,39.664689],[-78.418883,39.664919],[-78.418532,39.66514],[-78.418184,39.665397],[-78.417755,39.66574],[-78.417289,39.666155],[-78.416778,39.666657],[-78.416296,39.667196],[-78.415875,39.667743],[-78.415394,39.668408],[-78.402504,39.68674],[-78.402142,39.687244],[-78.401784,39.687718],[-78.401341,39.688276],[-78.400883,39.688822],[-78.400397,39.68937],[-78.399898,39.689907],[-78.399391,39.690424],[-78.398842,39.690958],[-78.39825,39.691504],[-78.397655,39.692029],[-78.397126,39.69247],[-78.396471,39.692995],[-78.395811,39.693497],[-78.395158,39.693971],[-78.394466,39.694447],[-78.393762,39.694909],[-78.393,39.695383],[-78.392199,39.695837],[-78.391431,39.69629],[-78.390688,39.69668],[-78.389837,39.697101],[-78.388915,39.697538],[-78.388003,39.697939],[-78.3871,39.698313],[-78.386292,39.698619],[-78.385562,39.698875],[-78.384729,39.699138],[-78.383914,39.699372],[-78.383124,39.699583],[-78.382252,39.699786],[-78.381344,39.699969],[-78.380513,39.700117],[-78.379531,39.700264],[-78.378623,39.700387],[-78.376745,39.700635],[-78.374184,39.700969],[-78.372768,39.70117],[-78.371118,39.701427],[-78.366728,39.702131],[-78.366204,39.702203],[-78.365445,39.702286],[-78.364618,39.702351],[-78.363899,39.702384],[-78.363199,39.7024],[-78.362486,39.702398],[-78.361776,39.702375],[-78.361004,39.702329],[-78.354622,39.701735],[-78.354104,39.701692],[-78.353557,39.701676],[-78.353098,39.70169],[-78.352693,39.701718],[-78.3523,39.701765],[-78.351886,39.701836],[-78.351452,39.701933],[-78.350956,39.702075],[-78.350455,39.702253],[-78.349952,39.702475],[-78.349447,39.702747],[-78.348995,39.703038],[-78.348612,39.703335],[-78.348261,39.703654],[-78.347432,39.704412],[-78.34708,39.704723],[-78.346805,39.704929],[-78.346461,39.705161],[-78.346053,39.705402],[-78.345682,39.705589],[-78.345252,39.705775],[-78.344825,39.705928],[-78.344302,39.706076],[-78.343752,39.706196],[-78.343192,39.70628],[-78.342584,39.706339],[-78.340356,39.706544],[-78.339518,39.706616],[-78.338838,39.706661],[-78.338128,39.706702],[-78.337349,39.706732],[-78.3365,39.706753],[-78.335582,39.706763],[-78.334583,39.706753],[-78.333684,39.706731],[-78.333042,39.706709],[-78.332486,39.706676],[-78.331989,39.706632],[-78.331337,39.706555],[-78.330819,39.706474],[-78.330233,39.706359],[-78.329592,39.706215],[-78.329033,39.70606],[-78.328635,39.70594],[-78.328155,39.705776],[-78.327652,39.705593],[-78.327153,39.70538],[-78.32455,39.704257],[-78.324197,39.704114],[-78.323691,39.703933],[-78.32298,39.703712],[-78.322482,39.703582],[-78.321961,39.703467],[-78.321444,39.703366],[-78.320654,39.703246],[-78.320197,39.703208],[-78.319718,39.703177],[-78.319267,39.703156],[-78.317282,39.703085],[-78.316742,39.703075],[-78.3162,39.703093],[-78.315728,39.70314],[-78.315198,39.703221],[-78.314615,39.703349],[-78.314045,39.703516],[-78.313533,39.703716],[-78.312998,39.703961],[-78.312511,39.704234],[-78.312078,39.704524],[-78.311683,39.704831],[-78.305318,39.710213],[-78.30418,39.711169],[-78.303851,39.71144],[-78.303564,39.711645],[-78.303144,39.711888],[-78.3028,39.712065],[-78.302441,39.712224],[-78.302085,39.712358],[-78.301703,39.712481],[-78.298058,39.713497],[-78.297787,39.713571],[-78.296126,39.714045],[-78.29566,39.714196],[-78.295058,39.714419],[-78.294459,39.714663],[-78.293927,39.714911],[-78.293387,39.715187],[-78.292889,39.71547],[-78.292335,39.71581],[-78.291839,39.716147],[-78.291357,39.716519],[-78.291044,39.716749],[-78.289306,39.718277],[-78.289009,39.71851],[-78.288715,39.71871],[-78.288335,39.71893],[-78.287993,39.719095],[-78.287527,39.719279],[-78.287113,39.719406],[-78.286677,39.719508],[-78.286183,39.719582],[-78.285727,39.719626],[-78.285273,39.719634],[-78.284795,39.719618],[-78.28436,39.719576],[-78.283932,39.719498],[-78.283509,39.719389],[-78.283131,39.719268],[-78.282784,39.719135],[-78.282404,39.718955],[-78.282124,39.718796],[-78.281842,39.718619],[-78.281542,39.718401],[-78.2813,39.718195],[-78.281059,39.717953],[-78.280792,39.717643],[-78.28057,39.717327],[-78.280389,39.717008],[-78.280229,39.716623],[-78.280115,39.716263],[-78.279361,39.713728],[-78.27921,39.713315],[-78.279058,39.712988],[-78.278868,39.712638],[-78.278606,39.712265],[-78.278313,39.711902],[-78.277909,39.711491],[-78.277527,39.711168],[-78.277081,39.710857],[-78.276537,39.710534],[-78.276266,39.7104],[-78.275952,39.710262],[-78.275696,39.710155],[-78.275264,39.710007],[-78.274712,39.709852],[-78.274134,39.709729],[-78.273662,39.709661],[-78.267868,39.708882],[-78.267126,39.708781],[-78.266032,39.708633],[-78.265486,39.708536],[-78.265057,39.708443],[-78.264572,39.70832],[-78.264126,39.708186],[-78.263615,39.708007],[-78.263184,39.707841],[-78.262682,39.707616],[-78.262221,39.70738],[-78.26175,39.707108],[-78.261301,39.706815],[-78.260892,39.706526],[-78.252373,39.699841],[-78.251878,39.699488],[-78.251438,39.699217],[-78.250945,39.698957],[-78.250468,39.698736],[-78.250009,39.698558],[-78.249534,39.6984],[-78.249015,39.69826],[-78.248472,39.698141],[-78.24792,39.698057],[-78.247342,39.697994],[-78.246699,39.697961],[-78.24622,39.697969],[-78.245594,39.698001],[-78.245038,39.698067],[-78.244523,39.698154],[-78.24399,39.698271],[-78.243409,39.698441],[-78.242915,39.698606],[-78.242392,39.698821],[-78.241928,39.699045],[-78.241485,39.699292],[-78.240965,39.699626],[-78.240495,39.699987],[-78.240064,39.70036],[-78.239675,39.700751],[-78.239356,39.701129],[-78.236421,39.704931],[-78.235887,39.705705],[-78.23544,39.706385],[-78.235012,39.707086],[-78.234584,39.707828],[-78.233029,39.710579],[-78.232844,39.710879],[-78.232655,39.711134],[-78.232408,39.711412],[-78.232146,39.711663],[-78.231822,39.711923],[-78.231519,39.712128],[-78.231205,39.712305],[-78.230864,39.712469],[-78.230541,39.712604],[-78.230179,39.712724],[-78.229742,39.712837],[-78.229398,39.712898],[-78.229,39.712957],[-78.228571,39.712987],[-78.228203,39.71299],[-78.227785,39.71297],[-78.22742,39.712928],[-78.227043,39.712865],[-78.226685,39.712781],[-78.221537,39.711483],[-78.217105,39.710367],[-78.216645,39.710264],[-78.216231,39.710184],[-78.215771,39.710112],[-78.215321,39.710059],[-78.214827,39.710022],[-78.214401,39.710004],[-78.213899,39.709999],[-78.213403,39.710016],[-78.21293,39.710047],[-78.212486,39.71009],[-78.212047,39.710151],[-78.203482,39.711562],[-78.203021,39.711636],[-78.198902,39.712317],[-78.197928,39.712463],[-78.197228,39.712557],[-78.19597,39.7127],[-78.194837,39.712807],[-78.192852,39.712977],[-78.191957,39.713062],[-78.19132,39.713117],[-78.191044,39.713124],[-78.19079,39.713109],[-78.190604,39.7131],[-78.190443,39.713082],[-78.190304,39.713056],[-78.190166,39.713025],[-78.190026,39.712993],[-78.189887,39.712952],[-78.18973,39.712905],[-78.189609,39.71286],[-78.189488,39.712815],[-78.189351,39.712751],[-78.189241,39.712697],[-78.189105,39.712624],[-78.189002,39.712563],[-78.188894,39.712488],[-78.188782,39.71241],[-78.188492,39.712163],[-78.188336,39.712006],[-78.188158,39.711785],[-78.187146,39.710398],[-78.186874,39.710043],[-78.186629,39.709743],[-78.186287,39.709388],[-78.185956,39.709079],[-78.185828,39.708992],[-78.185616,39.708853],[-78.185127,39.70845],[-78.184771,39.708182],[-78.184452,39.707957],[-78.184129,39.707743],[-78.183712,39.707503],[-78.183308,39.707295],[-78.182966,39.707122],[-78.182656,39.706989],[-78.182272,39.706834],[-78.18186,39.706693],[-78.181175,39.706478],[-78.18013,39.706192],[-78.17963,39.706051],[-78.175171,39.704827],[-78.172181,39.704001],[-78.171608,39.70385],[-78.171108,39.703724],[-78.1706,39.703603],[-78.170088,39.703486],[-78.169471,39.703358],[-78.168903,39.703252],[-78.168131,39.703124],[-78.167516,39.703038],[-78.160205,39.701996],[-78.159706,39.701925],[-78.159257,39.701832],[-78.158798,39.701728],[-78.158364,39.701606],[-78.15789,39.701445],[-78.157473,39.701282],[-78.157025,39.701079],[-78.15666,39.700875],[-78.156296,39.700645],[-78.155904,39.700343],[-78.155597,39.700065],[-78.155352,39.699811],[-78.155118,39.699532],[-78.15479,39.699133],[-78.154055,39.698184],[-78.153731,39.697767],[-78.153334,39.697325],[-78.153001,39.696994],[-78.15272,39.696753],[-78.15237,39.696485],[-78.152092,39.696301],[-78.1517,39.696071],[-78.151336,39.695887],[-78.150931,39.695698],[-78.150436,39.695526],[-78.150025,39.695391],[-78.149482,39.695229],[-78.143366,39.693384],[-78.1428,39.693225],[-78.14215,39.693054],[-78.141499,39.692895],[-78.140913,39.692766],[-78.140296,39.692641],[-78.139539,39.692497],[-78.138434,39.692288],[-78.133726,39.691404],[-78.133146,39.691289],[-78.132657,39.69118],[-78.132102,39.691036],[-78.131472,39.69085],[-78.130995,39.690691],[-78.128571,39.689829],[-78.127568,39.689474],[-78.127088,39.689309],[-78.126659,39.689177],[-78.126097,39.689036],[-78.125626,39.688922],[-78.125149,39.688829],[-78.1246,39.688731],[-78.124111,39.688648],[-78.105535,39.685568],[-78.104978,39.685464],[-78.104375,39.685338],[-78.103799,39.685197],[-78.103275,39.685054],[-78.102876,39.684928],[-78.102513,39.684808],[-78.101687,39.684532],[-78.101137,39.684309],[-78.100605,39.684079],[-78.100016,39.683804],[-78.099485,39.683536],[-78.098989,39.683267],[-78.098679,39.683087],[-78.098204,39.682794],[-78.092938,39.679289],[-78.092172,39.678804],[-78.091617,39.678454],[-78.090957,39.678051],[-78.090402,39.677728],[-78.084988,39.674639],[-78.084399,39.674308],[-78.083951,39.674067],[-78.08346,39.673822],[-78.082986,39.673604],[-78.082568,39.673417],[-78.082115,39.673222],[-78.081674,39.673047],[-78.081246,39.672892],[-78.080836,39.672751],[-78.080431,39.672616],[-78.079941,39.672469],[-78.079377,39.672301],[-78.076983,39.671614],[-78.076517,39.671472],[-78.075972,39.671289],[-78.075436,39.671084],[-78.075037,39.670917],[-78.074557,39.670704],[-78.074102,39.670479],[-78.070941,39.668791],[-78.070372,39.668465],[-78.06993,39.668188],[-78.069499,39.667907],[-78.069078,39.667614],[-78.06857,39.66723],[-78.059637,39.660314],[-78.058513,39.65946],[-78.057999,39.659101],[-78.057503,39.658765],[-78.056939,39.658408],[-78.056354,39.658055],[-78.055788,39.657729],[-78.054482,39.656963],[-78.050806,39.654814],[-78.050407,39.65458],[-78.049778,39.654205],[-78.049395,39.653963],[-78.04894,39.653646],[-78.048535,39.653338],[-78.048142,39.653012],[-78.047145,39.65214],[-78.046244,39.651352],[-78.040655,39.646456],[-78.040258,39.646134],[-78.039751,39.645747],[-78.039204,39.645359],[-78.038689,39.645018],[-78.03825,39.644749],[-78.037717,39.644431],[-78.030445,39.640173],[-78.030003,39.639892],[-78.029548,39.639588],[-78.029021,39.639198],[-78.028498,39.638795],[-78.028039,39.638412],[-78.027595,39.638022],[-78.027212,39.637658],[-78.026799,39.637234],[-78.022657,39.632724],[-78.022259,39.632334],[-78.021854,39.631959],[-78.021478,39.631639],[-78.020982,39.631232],[-78.020372,39.630772],[-78.019353,39.630019],[-78.0145,39.626439],[-78.013962,39.626043],[-78.013641,39.625827],[-78.013133,39.625514],[-78.012712,39.625267],[-78.012171,39.62499],[-78.01173,39.624781],[-78.011243,39.624568],[-78.010789,39.62439],[-78.01037,39.624239],[-78.009901,39.624082],[-78.009344,39.623922],[-78.008856,39.623799],[-78.008391,39.623696],[-78.007919,39.623603],[-78.007374,39.623514],[-78.006941,39.623456],[-78.006435,39.6234],[-78.005812,39.623355],[-78.005246,39.623336],[-78.004589,39.623334],[-78.004009,39.623349],[-78.00345,39.623384],[-78.002891,39.623441],[-78.002337,39.623512],[-78.001783,39.623599],[-78.001224,39.623708],[-77.985356,39.626788],[-77.984802,39.626888],[-77.984106,39.62699],[-77.983399,39.627077],[-77.982694,39.627147],[-77.98199,39.627193],[-77.981422,39.627216],[-77.980712,39.627229],[-77.974741,39.627207],[-77.974015,39.627212],[-77.973451,39.627229],[-77.97274,39.627279],[-77.972037,39.627357],[-77.971469,39.627444],[-77.970909,39.627548],[-77.970234,39.627695],[-77.969563,39.627875],[-77.968911,39.62808],[-77.968262,39.628314],[-77.967763,39.62852],[-77.967266,39.628742],[-77.966791,39.628982],[-77.966331,39.629226],[-77.96576,39.629564],[-77.955357,39.636381],[-77.954602,39.636868],[-77.953726,39.637432],[-77.952401,39.638261],[-77.943314,39.643834],[-77.942722,39.644183],[-77.942103,39.644523],[-77.941502,39.644846],[-77.940959,39.645116],[-77.940209,39.645465],[-77.939634,39.645716],[-77.938997,39.645978],[-77.938427,39.646203],[-77.937735,39.646457],[-77.930865,39.648923],[-77.928828,39.64963],[-77.928211,39.649834],[-77.923678,39.65129],[-77.922893,39.651527],[-77.92234,39.651672],[-77.921684,39.651836],[-77.921082,39.651961],[-77.920416,39.652089],[-77.919829,39.652182],[-77.919011,39.652295],[-77.918419,39.65236],[-77.91785,39.652404],[-77.917107,39.652452],[-77.916306,39.652474],[-77.915134,39.652464],[-77.914221,39.652421],[-77.913529,39.652369],[-77.909031,39.651983],[-77.908723,39.651954],[-77.902525,39.651439],[-77.901691,39.651378],[-77.900827,39.651329],[-77.9001,39.65129],[-77.899282,39.651251],[-77.898514,39.651222],[-77.897641,39.651195],[-77.896584,39.651173],[-77.895581,39.651159],[-77.888883,39.6511],[-77.88846,39.651094],[-77.880677,39.651029],[-77.879256,39.651011],[-77.878214,39.65099],[-77.877063,39.650957],[-77.876323,39.650927],[-77.875596,39.650893],[-77.865925,39.650491],[-77.865173,39.650468],[-77.864278,39.650451],[-77.863221,39.650434],[-77.854276,39.650331],[-77.853671,39.650312],[-77.85315,39.65028],[-77.852202,39.6502],[-77.851427,39.650105],[-77.850792,39.650011],[-77.8502,39.649909],[-77.849542,39.649776],[-77.848761,39.649595],[-77.848156,39.649436],[-77.847438,39.649225],[-77.846761,39.649005],[-77.846161,39.648795],[-77.845445,39.648514],[-77.843158,39.647571],[-77.842414,39.647267],[-77.841265,39.646831],[-77.840435,39.646542],[-77.839671,39.646281],[-77.838773,39.646004],[-77.837953,39.645758],[-77.837019,39.645477],[-77.836463,39.645305],[-77.835882,39.645104],[-77.835229,39.64486],[-77.834567,39.644595],[-77.834005,39.644349],[-77.833604,39.644159],[-77.833025,39.643867],[-77.832514,39.643599],[-77.831982,39.643293],[-77.831645,39.643092],[-77.831229,39.642824],[-77.830876,39.642584],[-77.830055,39.642007],[-77.829107,39.641333],[-77.82735,39.640087],[-77.826668,39.639621],[-77.826144,39.639292],[-77.825634,39.638993],[-77.825103,39.638704],[-77.824628,39.638455],[-77.824097,39.638197],[-77.823518,39.637941],[-77.822952,39.637706],[-77.820938,39.636913],[-77.820212,39.636624],[-77.819687,39.636399],[-77.819038,39.636099],[-77.818519,39.635842],[-77.817968,39.635546],[-77.817386,39.635212],[-77.816722,39.634801],[-77.816083,39.634371],[-77.815504,39.633942],[-77.814773,39.633362],[-77.814273,39.632958],[-77.813576,39.63242],[-77.813108,39.632076],[-77.812618,39.631738],[-77.812076,39.63138],[-77.81153,39.631049],[-77.810985,39.630726],[-77.810474,39.630446],[-77.809953,39.630169],[-77.809336,39.629859],[-77.80877,39.629597],[-77.807997,39.629267],[-77.807274,39.628966],[-77.803951,39.627622],[-77.792582,39.623036],[-77.792125,39.62284],[-77.791654,39.622624],[-77.791293,39.622447],[-77.79094,39.622261],[-77.790509,39.622007],[-77.790177,39.621804],[-77.789927,39.621635],[-77.789296,39.621181],[-77.7889,39.620869],[-77.788496,39.620512],[-77.788198,39.620231],[-77.787807,39.619821],[-77.787532,39.619506],[-77.787302,39.619231],[-77.786945,39.618753],[-77.785885,39.617256],[-77.785424,39.616599],[-77.782751,39.612797],[-77.782506,39.612435],[-77.782195,39.61202],[-77.781485,39.611069],[-77.781225,39.610761],[-77.780863,39.610363],[-77.780483,39.609994],[-77.780092,39.609641],[-77.779684,39.609306],[-77.779296,39.609011],[-77.778921,39.608745],[-77.778605,39.608535],[-77.777943,39.60814],[-77.777475,39.607891],[-77.776974,39.607645],[-77.776465,39.607416],[-77.775989,39.607226],[-77.77548,39.60704],[-77.774918,39.606857],[-77.774448,39.606716],[-77.773763,39.606542],[-77.773269,39.606438],[-77.772759,39.606352],[-77.772131,39.606253],[-77.771518,39.606182],[-77.770837,39.606129],[-77.770227,39.606107],[-77.769469,39.606105],[-77.762344,39.606257],[-77.755202,39.606408],[-77.754592,39.606421],[-77.753963,39.606439],[-77.752842,39.606447],[-77.752084,39.606432],[-77.75146,39.6064],[-77.750811,39.606353],[-77.750227,39.606295],[-77.744825,39.605655],[-77.744431,39.60561],[-77.742792,39.605425],[-77.742088,39.605348],[-77.741335,39.605277],[-77.740653,39.605224],[-77.739872,39.605174],[-77.739109,39.605132],[-77.738413,39.605108],[-77.737608,39.605086],[-77.736872,39.605081],[-77.736012,39.605086],[-77.735094,39.605107],[-77.729442,39.605298],[-77.728792,39.60532],[-77.726776,39.605385],[-77.726018,39.605389],[-77.725599,39.605381],[-77.72496,39.605367],[-77.724273,39.605337],[-77.723624,39.6053],[-77.722985,39.605252],[-77.722433,39.605202],[-77.721831,39.605133],[-77.721188,39.605052],[-77.720608,39.604969],[-77.720045,39.604878],[-77.719514,39.604784],[-77.718968,39.604683],[-77.718453,39.604577],[-77.717795,39.604428],[-77.717211,39.604284],[-77.716523,39.604103],[-77.715995,39.603952],[-77.715492,39.603804],[-77.714929,39.603625],[-77.714416,39.603451],[-77.71262,39.602813],[-77.711876,39.602551],[-77.706934,39.600815],[-77.705936,39.600466],[-77.70548,39.600313],[-77.705007,39.600162],[-77.704553,39.600028],[-77.704072,39.5999],[-77.703645,39.599788],[-77.703163,39.599678],[-77.70267,39.599572],[-77.702038,39.599452],[-77.701673,39.599393],[-77.701266,39.599329],[-77.700743,39.599261],[-77.700271,39.599207],[-77.699767,39.599159],[-77.699141,39.599114],[-77.69858,39.599086],[-77.697934,39.599068],[-77.697381,39.599065],[-77.696786,39.599076],[-77.696081,39.599105],[-77.688182,39.599564],[-77.682576,39.599895],[-77.681971,39.599931],[-77.676304,39.600262],[-77.673256,39.600442],[-77.672734,39.600466],[-77.672165,39.600479],[-77.671523,39.600483],[-77.670954,39.600473],[-77.670244,39.600441],[-77.66963,39.600391],[-77.668988,39.600329],[-77.668321,39.600251],[-77.667727,39.600167],[-77.666992,39.600033],[-77.666241,39.599881],[-77.665599,39.599732],[-77.665052,39.599585],[-77.66437,39.599389],[-77.663755,39.599188],[-77.663138,39.598969],[-77.662595,39.598763],[-77.662087,39.598556],[-77.66155,39.598318],[-77.661003,39.598063],[-77.660484,39.597799],[-77.659913,39.597483],[-77.659465,39.597231],[-77.655881,39.594986],[-77.655487,39.594748],[-77.646212,39.588962],[-77.645704,39.588657],[-77.645136,39.588325],[-77.644628,39.588038],[-77.643986,39.587688],[-77.643458,39.587415],[-77.642784,39.587074],[-77.642388,39.58688],[-77.64149,39.586462],[-77.640891,39.586189],[-77.64017,39.585859],[-77.639641,39.585618],[-77.636702,39.584275],[-77.636154,39.584018],[-77.63562,39.583751],[-77.634971,39.583407],[-77.634362,39.583052],[-77.633876,39.582747],[-77.633378,39.582417],[-77.632789,39.581995],[-77.632277,39.581606],[-77.631853,39.581247],[-77.631382,39.580839],[-77.630889,39.580364],[-77.630432,39.579896],[-77.629217,39.57865],[-77.628877,39.5783],[-77.626796,39.576178],[-77.626103,39.575471],[-77.625563,39.574914],[-77.625127,39.574431],[-77.624722,39.573977],[-77.624196,39.57336],[-77.623652,39.572672],[-77.623156,39.572023],[-77.622491,39.571068],[-77.622051,39.570378],[-77.617585,39.563728],[-77.617379,39.563424],[-77.614744,39.559476],[-77.611142,39.5541],[-77.610866,39.553659],[-77.610569,39.553115],[-77.610366,39.552681],[-77.610205,39.552293],[-77.610053,39.551867],[-77.609925,39.551419],[-77.609834,39.551044],[-77.609741,39.550538],[-77.609588,39.54953],[-77.609434,39.548617],[-77.609303,39.548017],[-77.609165,39.547495],[-77.609004,39.546994],[-77.608816,39.546468],[-77.608611,39.545971],[-77.608373,39.545433],[-77.608173,39.544981],[-77.60797,39.544532],[-77.606788,39.541889],[-77.606659,39.541575],[-77.606521,39.541186],[-77.606396,39.540779],[-77.606307,39.540417],[-77.606236,39.540025],[-77.606189,39.539628],[-77.606167,39.539311],[-77.606159,39.539032],[-77.606165,39.538657],[-77.60618,39.538373],[-77.606216,39.538066],[-77.606276,39.537627],[-77.606562,39.535966],[-77.6066,39.535729],[-77.606628,39.535403],[-77.606639,39.535069],[-77.606615,39.534764],[-77.60658,39.534482],[-77.606527,39.534187],[-77.606456,39.533942],[-77.606366,39.533691],[-77.606218,39.533334],[-77.606079,39.533064],[-77.605854,39.532704],[-77.605599,39.532361],[-77.604823,39.531347],[-77.604579,39.531022],[-77.604236,39.530559],[-77.603982,39.530124],[-77.603737,39.529614],[-77.603572,39.529204],[-77.603442,39.528801],[-77.603342,39.528389],[-77.602685,39.524936],[-77.602587,39.524524],[-77.602456,39.52411],[-77.6023,39.523706],[-77.602094,39.523266],[-77.601886,39.522891],[-77.601666,39.52254],[-77.601462,39.522251],[-77.601137,39.521841],[-77.597303,39.517344],[-77.596973,39.516932],[-77.596709,39.516578],[-77.596406,39.516136],[-77.596124,39.5157],[-77.595933,39.515383],[-77.59575,39.515048],[-77.595543,39.514665],[-77.595285,39.514135],[-77.594526,39.5125],[-77.593382,39.510067],[-77.593234,39.509815],[-77.593079,39.509579],[-77.592914,39.509369],[-77.592731,39.509161],[-77.592459,39.508908],[-77.592145,39.50865],[-77.591891,39.50848],[-77.591601,39.508301],[-77.591248,39.508136],[-77.590886,39.507981],[-77.590523,39.50786],[-77.590161,39.507758],[-77.589829,39.507679],[-77.589454,39.507587],[-77.585173,39.506572],[-77.584706,39.50646],[-77.584025,39.506264],[-77.583603,39.506118],[-77.583093,39.505918],[-77.582707,39.505755],[-77.582299,39.505553],[-77.581944,39.505361],[-77.581596,39.50516],[-77.58119,39.504897],[-77.575185,39.500853],[-77.572013,39.498733],[-77.568626,39.496451],[-77.5678,39.495881],[-77.567197,39.495442],[-77.566439,39.494864],[-77.565741,39.494311],[-77.563283,39.492328],[-77.562652,39.491828],[-77.560434,39.490044],[-77.559972,39.489674],[-77.557751,39.487899],[-77.55725,39.487537],[-77.556831,39.487264],[-77.556433,39.487034],[-77.555966,39.486786],[-77.55558,39.486592],[-77.555127,39.486406],[-77.554682,39.486243],[-77.554234,39.4861],[-77.553799,39.485974],[-77.553323,39.485862],[-77.552854,39.485771],[-77.552281,39.485674],[-77.550248,39.485367],[-77.547661,39.484989],[-77.54665,39.484826],[-77.546029,39.484705],[-77.545549,39.48459],[-77.545162,39.484481],[-77.54474,39.484349],[-77.544301,39.484193],[-77.543868,39.484016],[-77.54344,39.483825],[-77.542938,39.483563],[-77.542554,39.483345],[-77.542191,39.483117],[-77.54179,39.482843],[-77.541413,39.482548],[-77.54103,39.482219],[-77.539432,39.480764],[-77.538665,39.480072],[-77.535405,39.47711],[-77.534865,39.476602],[-77.534297,39.476106],[-77.533665,39.475588],[-77.533027,39.475079],[-77.532313,39.47454],[-77.531474,39.473943],[-77.519289,39.46554],[-77.514663,39.462345],[-77.514009,39.461877],[-77.513559,39.461536],[-77.513036,39.461136],[-77.512611,39.460801],[-77.512172,39.46044],[-77.509472,39.458145],[-77.509112,39.457843],[-77.506803,39.455878],[-77.506258,39.455338],[-77.50604,39.455079],[-77.505816,39.454791],[-77.505568,39.454415],[-77.50536,39.454045],[-77.50519,39.453688],[-77.505068,39.453375],[-77.504964,39.45303],[-77.504865,39.452644],[-77.503717,39.448089],[-77.503602,39.447664],[-77.503468,39.447279],[-77.50327,39.44684],[-77.503081,39.446502],[-77.502824,39.446108],[-77.502598,39.445808],[-77.502285,39.445452],[-77.501956,39.445125],[-77.501555,39.444791],[-77.501027,39.444406],[-77.500674,39.444175],[-77.500299,39.443958],[-77.499719,39.443674],[-77.497834,39.442759],[-77.494039,39.440921],[-77.493499,39.440651],[-77.493125,39.44044],[-77.492767,39.440212],[-77.492378,39.439931],[-77.492061,39.439676],[-77.491736,39.43938],[-77.49149,39.43912],[-77.491214,39.43881],[-77.490982,39.438505],[-77.490698,39.438064],[-77.490529,39.43776],[-77.490325,39.437343],[-77.490151,39.436929],[-77.489995,39.436481],[-77.489872,39.436063],[-77.489776,39.435608],[-77.48971,39.435188],[-77.489669,39.434752],[-77.489651,39.434227],[-77.489672,39.432694],[-77.489696,39.430702],[-77.489685,39.430082],[-77.489646,39.429534],[-77.489594,39.429093],[-77.489533,39.428694],[-77.489442,39.428217],[-77.489308,39.427687],[-77.48915,39.427135],[-77.488981,39.42666],[-77.488791,39.426172],[-77.488565,39.425677],[-77.488325,39.425209],[-77.488104,39.424804],[-77.48787,39.424404],[-77.487537,39.423902],[-77.487208,39.423446],[-77.48678,39.422904],[-77.48637,39.422429],[-77.486064,39.422114],[-77.485569,39.421632],[-77.485272,39.421354],[-77.484978,39.421091],[-77.484563,39.420742],[-77.484129,39.420414],[-77.483652,39.420063],[-77.483183,39.419759],[-77.482714,39.419464],[-77.481602,39.41881],[-77.480798,39.418345],[-77.480224,39.41801],[-77.479729,39.41771],[-77.47924,39.417401],[-77.47869,39.417029],[-77.478081,39.416577],[-77.477608,39.4162],[-77.477134,39.415792],[-77.476677,39.41538],[-77.476246,39.414957],[-77.4758,39.41449],[-77.475344,39.413965],[-77.474813,39.413289],[-77.474471,39.412812],[-77.47413,39.412301],[-77.473116,39.410702],[-77.472739,39.410136],[-77.472384,39.409667],[-77.472023,39.409226],[-77.471681,39.408846],[-77.471322,39.408473],[-77.470915,39.408082],[-77.470472,39.407692],[-77.470014,39.407324],[-77.469643,39.40704],[-77.46914,39.406687],[-77.468664,39.406378],[-77.468184,39.40609],[-77.467702,39.405819],[-77.467252,39.405587],[-77.466738,39.405335],[-77.466251,39.405124],[-77.465729,39.404912],[-77.465229,39.404727],[-77.464638,39.404526],[-77.464049,39.404349],[-77.46344,39.404188],[-77.462841,39.404044],[-77.462359,39.403946],[-77.461728,39.403834],[-77.461113,39.403746],[-77.460475,39.40367],[-77.457152,39.403305],[-77.454919,39.403061],[-77.451449,39.402681],[-77.450846,39.402609],[-77.450253,39.402528],[-77.449612,39.402419],[-77.448714,39.402236],[-77.448148,39.402109],[-77.44744,39.401918],[-77.446654,39.401691],[-77.445853,39.401412],[-77.44559,39.401336],[-77.444697,39.400994],[-77.444117,39.400746],[-77.44239,39.399956],[-77.442062,39.399804],[-77.441583,39.399591],[-77.44108,39.399373],[-77.440374,39.399098],[-77.440265,39.399057],[-77.439896,39.398935],[-77.439424,39.39879],[-77.438908,39.398643],[-77.438395,39.398506],[-77.437869,39.398391],[-77.437441,39.398306],[-77.437011,39.398231],[-77.436501,39.398152],[-77.435985,39.398089],[-77.435402,39.398029],[-77.434738,39.397984],[-77.433485,39.397932],[-77.428615,39.397932],[-77.424722,39.397927],[-77.423852,39.397927],[-77.42214,39.397916],[-77.421454,39.397893],[-77.42092,39.397867],[-77.419772,39.397789],[-77.419257,39.397767],[-77.41872,39.397767],[-77.418274,39.397783],[-77.417827,39.397816],[-77.417291,39.39788],[-77.416892,39.397942],[-77.416456,39.398029],[-77.416085,39.398115],[-77.408786,39.399955],[-77.403963,39.401208],[-77.403483,39.401335],[-77.397917,39.402737],[-77.394035,39.403715],[-77.393154,39.403937],[-77.392694,39.404051],[-77.391868,39.40424],[-77.39142,39.404324],[-77.390905,39.404403],[-77.390444,39.404462],[-77.389905,39.404513],[-77.389385,39.404546],[-77.388804,39.40456],[-77.388144,39.404567],[-77.386666,39.404556],[-77.386264,39.40454],[-77.385875,39.404519],[-77.385478,39.404487],[-77.385042,39.40443],[-77.384492,39.404349],[-77.381857,39.403879],[-77.381306,39.403771],[-77.380929,39.403725],[-77.380524,39.403678],[-77.379865,39.403646],[-77.379256,39.403634],[-77.378855,39.40365],[-77.374749,39.4038],[-77.366757,39.404098],[-77.364707,39.404178],[-77.362526,39.40426],[-77.361589,39.404298],[-77.360889,39.404339],[-77.360114,39.404392],[-77.35461,39.404796],[-77.354116,39.404822],[-77.353642,39.404835],[-77.353117,39.404835],[-77.352562,39.404813],[-77.352034,39.404776],[-77.35159,39.40474],[-77.351079,39.404678],[-77.350632,39.404604],[-77.350121,39.404511],[-77.349611,39.404405],[-77.347717,39.403924],[-77.347427,39.40385],[-77.338224,39.401491],[-77.337576,39.401314],[-77.337051,39.401151],[-77.336572,39.400994],[-77.336135,39.400826],[-77.335659,39.400634],[-77.335044,39.400355],[-77.334603,39.400136],[-77.334194,39.399915],[-77.333752,39.399654],[-77.33331,39.399379],[-77.332921,39.399118],[-77.332522,39.39882],[-77.332101,39.398484],[-77.33167,39.398113],[-77.327257,39.394146],[-77.326965,39.393886],[-77.326659,39.393633],[-77.326214,39.393295],[-77.325797,39.393002],[-77.325328,39.392705],[-77.324852,39.392425],[-77.324247,39.392101],[-77.323771,39.391874],[-77.323306,39.39167],[-77.32291,39.391511],[-77.322486,39.391354],[-77.322069,39.391216],[-77.321617,39.391077],[-77.320043,39.390639],[-77.31556,39.389393],[-77.314944,39.38922],[-77.314345,39.389061],[-77.313489,39.388842],[-77.312638,39.388633],[-77.311835,39.388446],[-77.311028,39.388267],[-77.310253,39.388098],[-77.309535,39.387952],[-77.308674,39.387788],[-77.283185,39.383077],[-77.282693,39.382984],[-77.282147,39.382859],[-77.281659,39.382726],[-77.281084,39.382554],[-77.280564,39.382382],[-77.280085,39.382195],[-77.27964,39.382007],[-77.278054,39.381292],[-77.277653,39.38112],[-77.27726,39.380966],[-77.276893,39.380842],[-77.276564,39.380747],[-77.276159,39.380646],[-77.275671,39.380544],[-77.275274,39.380482],[-77.2749,39.380433],[-77.274514,39.3804],[-77.274172,39.380384],[-77.273737,39.380376],[-77.273366,39.380389],[-77.272958,39.380408],[-77.272541,39.380453],[-77.272046,39.380523],[-77.269428,39.380958],[-77.26709,39.381341],[-77.265386,39.381619],[-77.264894,39.381694],[-77.264341,39.381757],[-77.263824,39.381795],[-77.263294,39.381821],[-77.26269,39.381837],[-77.262129,39.381823],[-77.261624,39.381802],[-77.261074,39.381756],[-77.260541,39.381694],[-77.259853,39.381597],[-77.259445,39.38152],[-77.258927,39.381409],[-77.253479,39.380205],[-77.251562,39.379781],[-77.244571,39.378231],[-77.231499,39.375326],[-77.230719,39.375153],[-77.230159,39.375022],[-77.229538,39.374862],[-77.228886,39.374675],[-77.228291,39.374493],[-77.227657,39.374266],[-77.227007,39.37402],[-77.226341,39.373738],[-77.225741,39.373465],[-77.225063,39.373134],[-77.224535,39.372854],[-77.22395,39.372509],[-77.223411,39.37218],[-77.222941,39.37187],[-77.221313,39.370757],[-77.220915,39.370512],[-77.220626,39.370352],[-77.220287,39.370178],[-77.21989,39.369999],[-77.219524,39.369856],[-77.21919,39.369738],[-77.218799,39.369623],[-77.218401,39.369524],[-77.217978,39.369434],[-77.217574,39.369368],[-77.217185,39.36932],[-77.216767,39.369286],[-77.216356,39.369274],[-77.215962,39.369276],[-77.215585,39.369291],[-77.215207,39.369316],[-77.214842,39.369361],[-77.214458,39.369417],[-77.214073,39.369493],[-77.213771,39.369559],[-77.213378,39.369666],[-77.212052,39.370086],[-77.211623,39.370215],[-77.211113,39.370344],[-77.210737,39.37043],[-77.210401,39.370493],[-77.210013,39.370555],[-77.209585,39.370612],[-77.20918,39.370661],[-77.208806,39.370693],[-77.208396,39.370714],[-77.208006,39.370722],[-77.207578,39.370717],[-77.207125,39.370704],[-77.206631,39.370665],[-77.206141,39.370615],[-77.205676,39.370551],[-77.205236,39.370474],[-77.204812,39.370382],[-77.204386,39.37027],[-77.203934,39.370127],[-77.203504,39.369965],[-77.203089,39.369788],[-77.20271,39.369613],[-77.202459,39.369476],[-77.202114,39.369276],[-77.201045,39.3686],[-77.200747,39.368428],[-77.200461,39.368272],[-77.200139,39.368119],[-77.199845,39.367995],[-77.199482,39.367863],[-77.199083,39.367736],[-77.198633,39.367629],[-77.198145,39.367528],[-77.196646,39.367242],[-77.196165,39.367148],[-77.195266,39.36698],[-77.194447,39.366824],[-77.193425,39.366627],[-77.185611,39.36514],[-77.184783,39.364971],[-77.184051,39.364792],[-77.183437,39.36462],[-77.182911,39.364456],[-77.182401,39.364276],[-77.181811,39.364053],[-77.181318,39.363843],[-77.180818,39.363614],[-77.180373,39.363391],[-77.179848,39.363115],[-77.179321,39.362806],[-77.178886,39.362536],[-77.178389,39.362196],[-77.177591,39.36161],[-77.176905,39.361109],[-77.176546,39.360848],[-77.1762,39.360622],[-77.175838,39.36041],[-77.175474,39.360211],[-77.175055,39.360005],[-77.17468,39.359838],[-77.174309,39.359687],[-77.17388,39.359533],[-77.173494,39.359409],[-77.173099,39.3593],[-77.172663,39.35919],[-77.172057,39.359071],[-77.17156,39.358991],[-77.171153,39.358942],[-77.170736,39.358907],[-77.170323,39.358877],[-77.16981,39.35887],[-77.169323,39.35888],[-77.168927,39.358897],[-77.1685,39.358932],[-77.168185,39.358965],[-77.167571,39.359038],[-77.167029,39.359113],[-77.166051,39.359233],[-77.162686,39.359659],[-77.158779,39.360147],[-77.150796,39.361149],[-77.150313,39.361196],[-77.149886,39.361221],[-77.149494,39.361234],[-77.149083,39.361232],[-77.148647,39.361212],[-77.148265,39.361178],[-77.147828,39.36113],[-77.147302,39.361043],[-77.146825,39.360944],[-77.146386,39.360831],[-77.145973,39.360707],[-77.14555,39.360558],[-77.14507,39.360367],[-77.144725,39.360213],[-77.144394,39.360046],[-77.143998,39.359826],[-77.143448,39.35949],[-77.139278,39.356882],[-77.1381,39.356148],[-77.137661,39.35589],[-77.137232,39.355649],[-77.136814,39.355438],[-77.136394,39.355243],[-77.136029,39.355089],[-77.135589,39.354913],[-77.135151,39.354757],[-77.134699,39.354607],[-77.134302,39.354488],[-77.133884,39.354378],[-77.133478,39.354279],[-77.13299,39.354175],[-77.132572,39.354096],[-77.132153,39.354029],[-77.131692,39.353967],[-77.131176,39.353913],[-77.130712,39.353875],[-77.124002,39.353432],[-77.123436,39.353381],[-77.122877,39.353316],[-77.12241,39.353257],[-77.121915,39.353182],[-77.121339,39.353085],[-77.120932,39.353006],[-77.120533,39.352914],[-77.118633,39.352465],[-77.106309,39.349474],[-77.105652,39.349321],[-77.10505,39.349183],[-77.104462,39.349059],[-77.103805,39.34893],[-77.103266,39.348832],[-77.102612,39.348719],[-77.101945,39.348611],[-77.10116,39.348498],[-77.085602,39.346357],[-77.084988,39.346262],[-77.084201,39.346135],[-77.08323,39.345956],[-77.082527,39.345817],[-77.081826,39.345662],[-77.081165,39.345513],[-77.080446,39.345334],[-77.079883,39.345189],[-77.079341,39.345036],[-77.0788,39.344885],[-77.07837,39.344759],[-77.076201,39.344053],[-77.070021,39.341994],[-77.069368,39.341786],[-77.068808,39.341619],[-77.068215,39.341448],[-77.067581,39.341271],[-77.066893,39.341093],[-77.064957,39.340607],[-77.058553,39.339002],[-77.057336,39.338697],[-77.05655,39.338503],[-77.055782,39.338323],[-77.055202,39.338194],[-77.054624,39.338076],[-77.054034,39.337962],[-77.053364,39.337838],[-77.052759,39.337735],[-77.052116,39.337637],[-77.051413,39.337536],[-77.045074,39.336698],[-77.044547,39.336623],[-77.043974,39.336527],[-77.043391,39.336416],[-77.042881,39.33631],[-77.042369,39.336188],[-77.041799,39.336041],[-77.041291,39.335896],[-77.040769,39.335732],[-77.040201,39.335548],[-77.039774,39.33539],[-77.028476,39.331136],[-77.022701,39.328956],[-77.016879,39.326765],[-77.015971,39.326428],[-77.009532,39.323997],[-77.007348,39.323177],[-77.00688,39.32301],[-77.006434,39.322863],[-77.006011,39.32274],[-77.005571,39.322624],[-77.005166,39.322525],[-77.004753,39.322439],[-77.004289,39.322355],[-77.003963,39.322303],[-77.003648,39.322257],[-77.003261,39.322213],[-77.002879,39.322172],[-76.994069,39.32145],[-76.993564,39.321398],[-76.993041,39.321335],[-76.992482,39.321253],[-76.992011,39.321179],[-76.991584,39.321102],[-76.991126,39.321009],[-76.990692,39.320914],[-76.990248,39.320806],[-76.989821,39.320697],[-76.98934,39.320564],[-76.988758,39.320388],[-76.977896,39.317068],[-76.977273,39.316859],[-76.976719,39.316668],[-76.976154,39.316463],[-76.975535,39.316232],[-76.974457,39.315802],[-76.963878,39.311391],[-76.96225,39.310717],[-76.961732,39.310518],[-76.961149,39.310305],[-76.960572,39.310117],[-76.960165,39.309993],[-76.959746,39.309875],[-76.95926,39.309745],[-76.958781,39.309627],[-76.958339,39.309527],[-76.957788,39.309415],[-76.957287,39.309324],[-76.956696,39.309234],[-76.956086,39.309152],[-76.955451,39.309078],[-76.953636,39.308878],[-76.953452,39.308857],[-76.95338,39.308849],[-76.952908,39.308797],[-76.952079,39.308708],[-76.945741,39.30802],[-76.928781,39.306169],[-76.919802,39.305183],[-76.919171,39.305108],[-76.918614,39.30504],[-76.918064,39.304961],[-76.917676,39.304885],[-76.917107,39.304756],[-76.916585,39.304615],[-76.916042,39.304453],[-76.915616,39.304309],[-76.915135,39.304132],[-76.914501,39.303861],[-76.913857,39.303565],[-76.913515,39.303406],[-76.913177,39.303255],[-76.912794,39.303097],[-76.912387,39.302944],[-76.91198,39.302804],[-76.911599,39.302683],[-76.911237,39.302585],[-76.910776,39.302468],[-76.910281,39.302362],[-76.909927,39.302297],[-76.90943,39.302222],[-76.908951,39.302164],[-76.908489,39.302125],[-76.908145,39.302108],[-76.907769,39.302094],[-76.907287,39.302093],[-76.906667,39.302115],[-76.906147,39.302145],[-76.905529,39.302207],[-76.905014,39.302273],[-76.904518,39.302358],[-76.904054,39.302455],[-76.903543,39.302582],[-76.902998,39.302738],[-76.902128,39.303037],[-76.901366,39.303294],[-76.900474,39.303579],[-76.899615,39.303834],[-76.898704,39.304088],[-76.897954,39.304277],[-76.897193,39.304467],[-76.896507,39.30462],[-76.895807,39.304768],[-76.895131,39.304899],[-76.894635,39.304993],[-76.894044,39.305092],[-76.893496,39.305182],[-76.892631,39.305301],[-76.891994,39.305372],[-76.89145,39.305424],[-76.890868,39.305472],[-76.890349,39.3055],[-76.889669,39.305531],[-76.889008,39.305543],[-76.888418,39.305548],[-76.887754,39.305546],[-76.887192,39.305526],[-76.886618,39.305502],[-76.885986,39.305461],[-76.885444,39.305417],[-76.884834,39.305357],[-76.884334,39.305301],[-76.883858,39.30524],[-76.883288,39.305159],[-76.882659,39.305058],[-76.882181,39.30497],[-76.881598,39.304855],[-76.881137,39.30476],[-76.880674,39.304651],[-76.880179,39.304532],[-76.879538,39.304364],[-76.878898,39.304179],[-76.878355,39.304015],[-76.877808,39.303834],[-76.877327,39.303671],[-76.876859,39.303499],[-76.876484,39.303363],[-76.876165,39.303232],[-76.875634,39.303018],[-76.871379,39.301179],[-76.866456,39.299055],[-76.865737,39.298751],[-76.865202,39.298532],[-76.864738,39.298354],[-76.864172,39.298145],[-76.863556,39.297922],[-76.862974,39.29773],[-76.862412,39.297553],[-76.861934,39.297405],[-76.86144,39.297264],[-76.860841,39.297096],[-76.860285,39.296955],[-76.859714,39.296813],[-76.859152,39.296686],[-76.858587,39.296564],[-76.858001,39.296445],[-76.857433,39.29634],[-76.856843,39.296237],[-76.856273,39.296147],[-76.855429,39.296029],[-76.854879,39.295963],[-76.85434,39.295902],[-76.853816,39.295849],[-76.853336,39.29581],[-76.852699,39.295763],[-76.852113,39.295725],[-76.851477,39.295698],[-76.850886,39.295681],[-76.850185,39.295668],[-76.849552,39.295664],[-76.84906,39.295672],[-76.848484,39.295683],[-76.834399,39.296216],[-76.833887,39.296235],[-76.832482,39.296282],[-76.831827,39.296304],[-76.830987,39.296321],[-76.830258,39.296326],[-76.829515,39.29633],[-76.82641,39.296302],[-76.82504,39.29629],[-76.823189,39.296284],[-76.822691,39.296275],[-76.822144,39.296251],[-76.821589,39.296219],[-76.821045,39.296176],[-76.819476,39.296053],[-76.81908,39.296023],[-76.818625,39.295997],[-76.81795,39.295959],[-76.817082,39.295977],[-76.816543,39.29602],[-76.816012,39.296074],[-76.813491,39.296392],[-76.812888,39.296461],[-76.812262,39.296529],[-76.811747,39.29658],[-76.811122,39.296651],[-76.810454,39.29674],[-76.809901,39.296819],[-76.809319,39.296909],[-76.808741,39.297002],[-76.808157,39.297114],[-76.807592,39.297234],[-76.807068,39.297362],[-76.806512,39.297525],[-76.80606,39.297675],[-76.805531,39.297866],[-76.805028,39.298065],[-76.804497,39.29831],[-76.804026,39.298534],[-76.803569,39.298784],[-76.803201,39.298996],[-76.802901,39.299194],[-76.802633,39.299381],[-76.802356,39.299594],[-76.80206,39.299847],[-76.801839,39.300053],[-76.801619,39.30027],[-76.801376,39.300555],[-76.800949,39.301094],[-76.800712,39.301402],[-76.800494,39.301651],[-76.80027,39.301889],[-76.799999,39.30216],[-76.799565,39.302542],[-76.799037,39.302945],[-76.798687,39.303185],[-76.798399,39.303366],[-76.798104,39.303539],[-76.797797,39.3037],[-76.797561,39.303819],[-76.79503,39.304972],[-76.794288,39.305271],[-76.793536,39.30556],[-76.79293,39.30578],[-76.792437,39.305948],[-76.791499,39.306232],[-76.790846,39.306407],[-76.790276,39.306542],[-76.789714,39.30666],[-76.788987,39.306796],[-76.788279,39.306907],[-76.787604,39.306995],[-76.787104,39.307047],[-76.786494,39.307098],[-76.785909,39.307132],[-76.785344,39.307152],[-76.78488,39.307163],[-76.784297,39.30716],[-76.783754,39.307146],[-76.783293,39.307125],[-76.782697,39.307094],[-76.777046,39.306752],[-76.776426,39.306718],[-76.77579,39.30669],[-76.775121,39.306666],[-76.774522,39.306655],[-76.773659,39.306647],[-76.772949,39.306655],[-76.772088,39.306677],[-76.77137,39.306703],[-76.770797,39.306733],[-76.770289,39.306761],[-76.769704,39.306805],[-76.769027,39.306861],[-76.763508,39.307392],[-76.759956,39.307735],[-76.759395,39.307782],[-76.758965,39.307811],[-76.758502,39.307823],[-76.757993,39.307828],[-76.757543,39.30782],[-76.757126,39.307801],[-76.756543,39.307758],[-76.756029,39.307689],[-76.755375,39.307607],[-76.754907,39.307522],[-76.75429,39.30739],[-76.753876,39.307278],[-76.753484,39.307172],[-76.752638,39.30691],[-76.75195,39.30659],[-76.751388,39.306319],[-76.750944,39.306102],[-76.749459,39.305388],[-76.748706,39.305004],[-76.748085,39.304705],[-76.747402,39.304383],[-76.74673,39.304071],[-76.74646,39.303928],[-76.746067,39.303707],[-76.745868,39.303585],[-76.74565,39.303434],[-76.745491,39.303322],[-76.745365,39.303232],[-76.745257,39.303137],[-76.744818,39.302741],[-76.744433,39.30231],[-76.744242,39.302072],[-76.743875,39.301506],[-76.743692,39.301117],[-76.743586,39.300822],[-76.743472,39.300473],[-76.743248,39.299605],[-76.742386,39.29276],[-76.742313,39.292217],[-76.742265,39.291927],[-76.742187,39.291561],[-76.742071,39.291115],[-76.741951,39.290743],[-76.741762,39.290236],[-76.741616,39.289894],[-76.741468,39.289593],[-76.741339,39.289339],[-76.741206,39.289107],[-76.740996,39.288773],[-76.740804,39.288475],[-76.740531,39.288104],[-76.740205,39.287709],[-76.739944,39.287421],[-76.739654,39.287124],[-76.739343,39.286823],[-76.739029,39.286529],[-76.738728,39.286262],[-76.738392,39.285993],[-76.738107,39.285774],[-76.737826,39.285574],[-76.737424,39.28531],[-76.737031,39.285066],[-76.736555,39.284799],[-76.736067,39.284529],[-76.735709,39.284333],[-76.734537,39.283691],[-76.731536,39.282051],[-76.731153,39.281842],[-76.730812,39.281655],[-76.728112,39.280177],[-76.727959,39.28009],[-76.727852,39.280028],[-76.727624,39.279887],[-76.727404,39.279739],[-76.727072,39.279488],[-76.726817,39.279274],[-76.726562,39.279006],[-76.726349,39.278755],[-76.726132,39.278459],[-76.725912,39.27808],[-76.725778,39.27779],[-76.72561,39.277342],[-76.725413,39.27673],[-76.724605,39.274189],[-76.724462,39.273756],[-76.724278,39.273317],[-76.724063,39.272908],[-76.723849,39.272581],[-76.72364,39.272305],[-76.723379,39.272011],[-76.72311,39.271748],[-76.722792,39.271476],[-76.722508,39.271257],[-76.722169,39.27102],[-76.721744,39.270758],[-76.720969,39.270274],[-76.711093,39.264598],[-76.708535,39.263146],[-76.707833,39.262757],[-76.707331,39.262485],[-76.706635,39.262113],[-76.703643,39.260533],[-76.702357,39.259822],[-76.700525,39.258828],[-76.700063,39.25858],[-76.699571,39.258329],[-76.699066,39.258095],[-76.698443,39.257836],[-76.697918,39.257642],[-76.697252,39.257422],[-76.695966,39.257083],[-76.693864,39.256518],[-76.692267,39.25609],[-76.690164,39.255534],[-76.689222,39.255289],[-76.688766,39.255155],[-76.688321,39.255009],[-76.687911,39.254872],[-76.687338,39.254677],[-76.686799,39.254473],[-76.685958,39.25412],[-76.685009,39.253621],[-76.684797,39.253488],[-76.68462,39.253359],[-76.684481,39.253244],[-76.684309,39.253086],[-76.684149,39.252907],[-76.684004,39.252723],[-76.683887,39.252537],[-76.683543,39.25186],[-76.683289,39.251394],[-76.682724,39.250285],[-76.6826,39.250047],[-76.68249,39.249891],[-76.682324,39.249691],[-76.682174,39.249544],[-76.682027,39.249433],[-76.681852,39.249319],[-76.681664,39.249211],[-76.681452,39.2491],[-76.681244,39.249019],[-76.680912,39.248931],[-76.680678,39.248883],[-76.68045,39.248858],[-76.680222,39.248851],[-76.679989,39.24886],[-76.679751,39.248878],[-76.679554,39.248907],[-76.679351,39.24895],[-76.679112,39.249018],[-76.678889,39.249102],[-76.678638,39.249227],[-76.678481,39.249319],[-76.678294,39.249456],[-76.678142,39.24958],[-76.677977,39.249745],[-76.677843,39.249919],[-76.67773,39.250077],[-76.677646,39.250263],[-76.677567,39.250479],[-76.676772,39.253297],[-76.676521,39.254059],[-76.676114,39.255583],[-76.675636,39.256747],[-76.675432,39.257204],[-76.675218,39.257667],[-76.674896,39.258289],[-76.674736,39.258587],[-76.674573,39.258892],[-76.673194,39.261117],[-76.672501,39.262168],[-76.672259,39.262504],[-76.672055,39.262762],[-76.671697,39.263132],[-76.671374,39.263428],[-76.670972,39.263749],[-76.670548,39.264037],[-76.670114,39.264298],[-76.669761,39.264484],[-76.669289,39.264705],[-76.666323,39.266013],[-76.664462,39.266838],[-76.662421,39.267757],[-76.66035,39.268688],[-76.660033,39.268828],[-76.657322,39.270013],[-76.655671,39.270734],[-76.655368,39.270853],[-76.655093,39.270954],[-76.654758,39.271057],[-76.654436,39.271145],[-76.654048,39.271229],[-76.653666,39.271294],[-76.653171,39.271349],[-76.65282,39.271373],[-76.65231,39.271389],[-76.651929,39.271378],[-76.651424,39.271349],[-76.649131,39.271145],[-76.64676,39.270925],[-76.643835,39.270638],[-76.642585,39.270539],[-76.641048,39.270389],[-76.640203,39.270305],[-76.639247,39.270205],[-76.637973,39.270041],[-76.637169,39.269918],[-76.635829,39.269721],[-76.634934,39.269575],[-76.634115,39.269428],[-76.632948,39.269212],[-76.631332,39.268818],[-76.630531,39.268633],[-76.630038,39.268499],[-76.629437,39.268318],[-76.628061,39.26786],[-76.62753,39.267702],[-76.627134,39.267604],[-76.62669,39.267517],[-76.626381,39.267483],[-76.626071,39.267472],[-76.625776,39.267484],[-76.625516,39.267514],[-76.625229,39.267571],[-76.624915,39.267658],[-76.6246,39.267778],[-76.624365,39.267892],[-76.624126,39.268044],[-76.623901,39.268227],[-76.623713,39.268394],[-76.623545,39.268592],[-76.623364,39.268842],[-76.623206,39.269091],[-76.622979,39.269493],[-76.622445,39.270658],[-76.621378,39.272947],[-76.620935,39.273956],[-76.620618,39.274914],[-76.620165,39.276023],[-76.619497,39.277456],[-76.619272,39.27795],[-76.619114,39.278359],[-76.618988,39.278762],[-76.618931,39.278951],[-76.618892,39.279079],[-76.618878,39.279167],[-76.618863,39.279245],[-76.618853,39.279329],[-76.618842,39.279402],[-76.618831,39.27949],[-76.618823,39.279572],[-76.618816,39.279643],[-76.618811,39.279708],[-76.618808,39.279773],[-76.6188,39.279958],[-76.618802,39.280067],[-76.618806,39.280286],[-76.618813,39.280393],[-76.618822,39.28063],[-76.618839,39.280956],[-76.618874,39.281621],[-76.618883,39.281897],[-76.618914,39.28245],[-76.618975,39.282779],[-76.619029,39.283561],[-76.619046,39.28386],[-76.619049,39.283986],[-76.61905,39.284021],[-76.619055,39.284116],[-76.619059,39.284206],[-76.61906,39.284267],[-76.619056,39.28439],[-76.619057,39.284522],[-76.619069,39.284824],[-76.619087,39.285107],[-76.619121,39.285179],[-76.619162,39.285264],[-76.619167,39.285348],[-76.619191,39.285756],[-76.619219,39.286223],[-76.619225,39.286314],[-76.619231,39.28641],[-76.619238,39.28652],[-76.619263,39.286903],[-76.619266,39.28698],[-76.619285,39.287506],[-76.619288,39.287564],[-76.619379,39.289351],[-76.61899,39.289366],[-76.618715,39.289377],[-76.618433,39.289388],[-76.61834,39.289392],[-76.618207,39.289398],[-76.618056,39.289405],[-76.61794,39.28941],[-76.617799,39.289417],[-76.617725,39.289419],[-76.617661,39.289421],[-76.616403,39.289478],[-76.616056,39.28949],[-76.615638,39.289505],[-76.615279,39.289518],[-76.615149,39.289523],[-76.615032,39.289528],[-76.614219,39.289564],[-76.613915,39.289574],[-76.613802,39.289578],[-76.613695,39.289581],[-76.613318,39.289599],[-76.61302,39.289612],[-76.612703,39.289625],[-76.612312,39.289644],[-76.61231,39.289796],[-76.612324,39.290052],[-76.612361,39.290443],[-76.612325,39.290506],[-76.612286,39.290576],[-76.612312,39.290967],[-76.612332,39.291034],[-76.612334,39.291042],[-76.612381,39.29111],[-76.612447,39.291199],[-76.611927,39.291219],[-76.611164,39.291251],[-76.611104,39.291254],[-76.611076,39.290887]]}]});

/***/ }),
/* 173 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/*
 * To change this license header, choose License Headers in Project Properties.
 * To change this template file, choose Tools | Templates
 * and open the template in the editor.
 *//* harmony default export */ __webpack_exports__["a"] = ({routesList:[{_id:'1',truck:'1',from:{name:'Philadelphia',lat:40.011582,lng:-75.132682},to:{name:'Baltimore',lat:39.290887,lng:-76.611076},startDate:new Date(2017,10,2,9,0),endDate:new Date(2017,10,2,18,0),km:100,revenue:214,selected:false,drive:3,duty:2,off:1,berth:2,time:4,distance:50,fuel:75,tolls:17,vectorPath:[[-75.132682,40.011582],[-75.131782,40.011468],[-75.126629,40.010814],[-75.126793,40.010036],[-75.126948,40.009302],[-75.127137,40.008406],[-75.127204,40.008089],[-75.127315,40.007649],[-75.127786,40.005426],[-75.1279,40.004916],[-75.128022,40.004328],[-75.12856,40.0044],[-75.129074,40.004467],[-75.130018,40.004586],[-75.130117,40.004119],[-75.130278,40.003374],[-75.13045,40.002631],[-75.130593,40.001878],[-75.130689,40.00145],[-75.13091,40.00039],[-75.131252,39.998797],[-75.13136,39.998271],[-75.131453,39.997874],[-75.1316,39.997211],[-75.131791,39.99628],[-75.131825,39.99615],[-75.131899,39.995777],[-75.131947,39.995583],[-75.131512,39.995311],[-75.131095,39.995033],[-75.130628,39.994708],[-75.130168,39.994385],[-75.129496,39.993868],[-75.12928,39.993698],[-75.128889,39.993371],[-75.128474,39.992959],[-75.127546,39.992085],[-75.127209,39.991801],[-75.127111,39.991716],[-75.126829,39.991403],[-75.126709,39.9913],[-75.126243,39.990867],[-75.126191,39.990813],[-75.125795,39.99046],[-75.125749,39.990404],[-75.12575,39.990366],[-75.125815,39.99032],[-75.125947,39.99023],[-75.125832,39.990149],[-75.125494,39.989839],[-75.125164,39.989539],[-75.124375,39.988822],[-75.123693,39.988197],[-75.123386,39.987916],[-75.122914,39.987462],[-75.122875,39.98743],[-75.122527,39.987142],[-75.122362,39.987034],[-75.122028,39.986745],[-75.122015,39.986733],[-75.121752,39.986478],[-75.121482,39.986176],[-75.121184,39.985839],[-75.120886,39.985499],[-75.120252,39.984755],[-75.11969,39.984112],[-75.119502,39.983901],[-75.119189,39.983549],[-75.119134,39.983485],[-75.118522,39.982825],[-75.117713,39.981892],[-75.117382,39.981504],[-75.117629,39.981034],[-75.117697,39.980904],[-75.118267,39.979641],[-75.118323,39.979516],[-75.118611,39.978879],[-75.118806,39.978454],[-75.119192,39.977613],[-75.119473,39.977],[-75.119572,39.976784],[-75.119763,39.976369],[-75.119921,39.976027],[-75.119954,39.975985],[-75.119988,39.975945],[-75.120031,39.975906],[-75.120138,39.975848],[-75.120614,39.975606],[-75.120655,39.975584],[-75.120872,39.975473],[-75.121027,39.975386],[-75.121124,39.975311],[-75.121265,39.975221],[-75.121371,39.975122],[-75.121781,39.974696],[-75.12237,39.974104],[-75.122748,39.973721],[-75.122883,39.973581],[-75.123165,39.973274],[-75.123281,39.973096],[-75.123386,39.972899],[-75.123462,39.972724],[-75.123493,39.972642],[-75.123584,39.972456],[-75.123669,39.972288],[-75.12385,39.971894],[-75.123922,39.971718],[-75.124032,39.971538],[-75.124145,39.971385],[-75.124279,39.971243],[-75.124515,39.971036],[-75.124882,39.970729],[-75.125242,39.970498],[-75.126272,39.969813],[-75.126411,39.969721],[-75.126979,39.969372],[-75.127552,39.969087],[-75.128025,39.968885],[-75.128436,39.968731],[-75.129395,39.968436],[-75.129568,39.968383],[-75.130752,39.968031],[-75.130907,39.967985],[-75.132645,39.967464],[-75.132851,39.967403],[-75.134282,39.966975],[-75.134774,39.966829],[-75.135307,39.966639],[-75.135867,39.9664],[-75.135946,39.966355],[-75.136016,39.966317],[-75.136361,39.966124],[-75.136521,39.966018],[-75.137098,39.965638],[-75.137272,39.965486],[-75.137331,39.965434],[-75.137666,39.965105],[-75.137783,39.964988],[-75.138258,39.964509],[-75.138504,39.964172],[-75.138731,39.963875],[-75.138921,39.963624],[-75.139233,39.963183],[-75.139543,39.962694],[-75.139632,39.962549],[-75.139819,39.962237],[-75.139862,39.962165],[-75.140086,39.961725],[-75.140174,39.961551],[-75.140349,39.961171],[-75.140541,39.960717],[-75.140603,39.960546],[-75.140667,39.960376],[-75.140798,39.959959],[-75.140867,39.959731],[-75.140998,39.95929],[-75.14112,39.9587],[-75.141333,39.957631],[-75.141404,39.957224],[-75.141436,39.957029],[-75.141485,39.956708],[-75.14156,39.956195],[-75.141594,39.955649],[-75.141625,39.955279],[-75.141622,39.954991],[-75.141614,39.954288],[-75.141608,39.954127],[-75.141605,39.95404],[-75.14158,39.953675],[-75.141544,39.953352],[-75.141482,39.952567],[-75.141455,39.952168],[-75.141469,39.951698],[-75.141502,39.951379],[-75.141746,39.949993],[-75.141776,39.949832],[-75.141803,39.949677],[-75.141881,39.94869],[-75.141994,39.948184],[-75.142216,39.947194],[-75.142632,39.945342],[-75.143031,39.943416],[-75.14315,39.942775],[-75.143508,39.940904],[-75.143665,39.939974],[-75.143758,39.93952],[-75.14387,39.938814],[-75.144001,39.938282],[-75.144106,39.937844],[-75.14446,39.936688],[-75.144535,39.936461],[-75.144826,39.935663],[-75.144917,39.935302],[-75.145113,39.934589],[-75.145272,39.933876],[-75.145558,39.932602],[-75.145915,39.930989],[-75.146054,39.930356],[-75.146794,39.927041],[-75.14693,39.926414],[-75.147072,39.925771],[-75.147199,39.925206],[-75.147817,39.922513],[-75.148215,39.920462],[-75.148223,39.920148],[-75.148158,39.919503],[-75.148058,39.918907],[-75.147862,39.917789],[-75.147775,39.917254],[-75.147721,39.916493],[-75.147788,39.915877],[-75.148486,39.913267],[-75.148679,39.912448],[-75.14889,39.911642],[-75.149013,39.911142],[-75.149059,39.910805],[-75.149434,39.908875],[-75.149585,39.908109],[-75.149769,39.907127],[-75.149853,39.9067],[-75.149943,39.906285],[-75.150063,39.905719],[-75.150255,39.904731],[-75.150443,39.903858],[-75.15049,39.903706],[-75.150621,39.903376],[-75.150785,39.903052],[-75.150901,39.902864],[-75.151045,39.902669],[-75.151348,39.902288],[-75.151548,39.902092],[-75.151776,39.901892],[-75.151989,39.901736],[-75.152201,39.901598],[-75.15242,39.901471],[-75.152663,39.901344],[-75.152906,39.901232],[-75.153158,39.90113],[-75.153426,39.901039],[-75.153681,39.900967],[-75.153804,39.900934],[-75.154084,39.900872],[-75.154351,39.900824],[-75.154781,39.900759],[-75.155293,39.900694],[-75.155674,39.900647],[-75.156291,39.90057],[-75.156775,39.900514],[-75.15802,39.90036],[-75.159413,39.900188],[-75.160523,39.900052],[-75.162059,39.899863],[-75.162912,39.899756],[-75.164258,39.899593],[-75.165992,39.899375],[-75.166851,39.899274],[-75.167227,39.89922],[-75.16818,39.8991],[-75.169356,39.898959],[-75.169634,39.898934],[-75.170066,39.898903],[-75.170498,39.898879],[-75.170782,39.898877],[-75.171056,39.898873],[-75.171496,39.898875],[-75.172091,39.898895],[-75.172818,39.898951],[-75.173672,39.899053],[-75.174377,39.89914],[-75.175206,39.899255],[-75.175604,39.899304],[-75.175905,39.899328],[-75.176193,39.899335],[-75.176726,39.899334],[-75.177161,39.89931],[-75.177433,39.899285],[-75.177933,39.899217],[-75.179538,39.898937],[-75.181191,39.898631],[-75.182854,39.898344],[-75.183544,39.898229],[-75.18424,39.898139],[-75.185611,39.897897],[-75.186322,39.897761],[-75.187116,39.897593],[-75.18752,39.897501],[-75.187794,39.897439],[-75.188065,39.897373],[-75.188739,39.897211],[-75.189417,39.897035],[-75.189878,39.896909],[-75.19026,39.8968],[-75.190665,39.896668],[-75.191216,39.89647],[-75.191622,39.896308],[-75.192011,39.896137],[-75.192147,39.896062],[-75.192469,39.895905],[-75.19282,39.895729],[-75.193211,39.895514],[-75.193561,39.895303],[-75.193885,39.895108],[-75.194185,39.894908],[-75.194591,39.894614],[-75.195841,39.893724],[-75.196993,39.892856],[-75.197649,39.892382],[-75.198412,39.891815],[-75.198941,39.891422],[-75.199484,39.891025],[-75.199846,39.890766],[-75.201245,39.889743],[-75.201947,39.889242],[-75.203036,39.88843],[-75.203557,39.888057],[-75.203921,39.887821],[-75.204232,39.887621],[-75.204434,39.887499],[-75.204572,39.887413],[-75.204718,39.887329],[-75.204874,39.887243],[-75.205363,39.88701],[-75.205892,39.886776],[-75.206371,39.886593],[-75.206654,39.886497],[-75.207297,39.886316],[-75.207878,39.886193],[-75.208243,39.886123],[-75.208665,39.886064],[-75.209143,39.886022],[-75.209666,39.886003],[-75.210136,39.885959],[-75.210775,39.88598],[-75.211022,39.885999],[-75.212163,39.886143],[-75.212227,39.886156],[-75.212326,39.886175],[-75.212718,39.886252],[-75.213083,39.886344],[-75.21346,39.886459],[-75.213978,39.886638],[-75.214315,39.886772],[-75.214634,39.886912],[-75.215428,39.887316],[-75.215918,39.887599],[-75.216229,39.887792],[-75.216937,39.888232],[-75.217309,39.888463],[-75.217447,39.888549],[-75.217718,39.888717],[-75.218553,39.889236],[-75.218675,39.889312],[-75.218822,39.889391],[-75.219125,39.889555],[-75.219269,39.889643],[-75.219411,39.889729],[-75.219721,39.889919],[-75.22034,39.890306],[-75.221182,39.890821],[-75.222044,39.891359],[-75.222581,39.891632],[-75.223342,39.891992],[-75.224408,39.892424],[-75.224582,39.892481],[-75.224805,39.892541],[-75.224942,39.892585],[-75.225241,39.892666],[-75.225501,39.892738],[-75.225891,39.892839],[-75.226163,39.892909],[-75.226587,39.893003],[-75.227212,39.893125],[-75.227478,39.893168],[-75.227984,39.893246],[-75.228353,39.89329],[-75.228693,39.893334],[-75.230138,39.893345],[-75.230775,39.893333],[-75.231347,39.893298],[-75.231738,39.893266],[-75.231805,39.893261],[-75.232272,39.893217],[-75.233064,39.893097],[-75.233802,39.892954],[-75.234729,39.892729],[-75.235155,39.892605],[-75.235418,39.892525],[-75.235698,39.89244],[-75.236277,39.89222],[-75.237047,39.891898],[-75.237683,39.891594],[-75.238282,39.89128],[-75.23877,39.890987],[-75.23921,39.890701],[-75.239899,39.890199],[-75.240525,39.889682],[-75.241055,39.889177],[-75.241574,39.888615],[-75.242029,39.888048],[-75.242324,39.887636],[-75.243865,39.885079],[-75.24421,39.884503],[-75.244442,39.884128],[-75.244702,39.883696],[-75.245318,39.882741],[-75.245549,39.882405],[-75.245995,39.881858],[-75.246607,39.881172],[-75.24712,39.880684],[-75.247839,39.88009],[-75.248537,39.879602],[-75.249408,39.879071],[-75.250344,39.87858],[-75.251408,39.878121],[-75.252626,39.877644],[-75.254318,39.877142],[-75.25435,39.877133],[-75.255485,39.876867],[-75.25676,39.876626],[-75.25771,39.876485],[-75.258342,39.87642],[-75.260591,39.876302],[-75.261709,39.876307],[-75.262768,39.876341],[-75.264373,39.876371],[-75.266215,39.876439],[-75.266968,39.87645],[-75.267158,39.876449],[-75.267605,39.87644],[-75.268096,39.876424],[-75.268543,39.876395],[-75.268966,39.876367],[-75.271839,39.876056],[-75.272723,39.87597],[-75.272924,39.875956],[-75.273581,39.875918],[-75.274373,39.875926],[-75.275075,39.875948],[-75.276062,39.876016],[-75.279468,39.876326],[-75.28001,39.876373],[-75.280596,39.876418],[-75.281218,39.876441],[-75.28165,39.876448],[-75.282155,39.876444],[-75.282691,39.876411],[-75.28312,39.876376],[-75.283546,39.876333],[-75.284062,39.876265],[-75.284699,39.876158],[-75.285237,39.876045],[-75.285674,39.875943],[-75.286268,39.875771],[-75.287001,39.875544],[-75.287929,39.875249],[-75.288595,39.875037],[-75.28937,39.874785],[-75.290243,39.874505],[-75.291335,39.874149],[-75.292993,39.873623],[-75.294602,39.873113],[-75.302108,39.870708],[-75.303593,39.870235],[-75.305633,39.869585],[-75.307155,39.869129],[-75.307902,39.868937],[-75.308463,39.86883],[-75.308961,39.868756],[-75.309217,39.868708],[-75.30948,39.868673],[-75.310145,39.868628],[-75.310706,39.868619],[-75.311243,39.868628],[-75.311649,39.868652],[-75.312461,39.86872],[-75.312902,39.868788],[-75.313424,39.868877],[-75.314024,39.869017],[-75.314689,39.869204],[-75.314967,39.869305],[-75.315234,39.869397],[-75.318459,39.870686],[-75.319209,39.870924],[-75.319619,39.871023],[-75.320712,39.871167],[-75.321365,39.871233],[-75.322023,39.871237],[-75.322474,39.871204],[-75.322915,39.87117],[-75.323581,39.871065],[-75.324111,39.870961],[-75.32455,39.870838],[-75.326405,39.870177],[-75.327704,39.869722],[-75.328705,39.869355],[-75.330024,39.868903],[-75.331842,39.868254],[-75.332572,39.868001],[-75.33298,39.867853],[-75.333553,39.86767],[-75.33403,39.86756],[-75.334279,39.867521],[-75.334492,39.867483],[-75.334744,39.867453],[-75.335013,39.867437],[-75.335292,39.867433],[-75.33553,39.867438],[-75.335752,39.86745],[-75.335999,39.867469],[-75.336325,39.867513],[-75.336665,39.867569],[-75.338115,39.867874],[-75.338872,39.868045],[-75.339206,39.868098],[-75.339602,39.86816],[-75.339899,39.868193],[-75.340199,39.868226],[-75.340435,39.868246],[-75.340601,39.868254],[-75.340811,39.868254],[-75.341047,39.868246],[-75.341294,39.86823],[-75.341516,39.868212],[-75.341782,39.868168],[-75.342098,39.868106],[-75.342345,39.868045],[-75.342597,39.867979],[-75.342875,39.867898],[-75.343079,39.867823],[-75.343297,39.867733],[-75.343469,39.867651],[-75.343959,39.867378],[-75.344115,39.867291],[-75.344222,39.867225],[-75.346085,39.86594],[-75.347031,39.865277],[-75.34799,39.864598],[-75.348599,39.864198],[-75.349038,39.863878],[-75.349386,39.863602],[-75.349665,39.863372],[-75.349934,39.863133],[-75.350239,39.862874],[-75.350454,39.862668],[-75.352038,39.861244],[-75.352763,39.860693],[-75.354012,39.859958],[-75.355317,39.859303],[-75.365898,39.855075],[-75.36849,39.854031],[-75.370862,39.853075],[-75.372208,39.852536],[-75.373653,39.851965],[-75.374049,39.851816],[-75.377293,39.85053],[-75.377801,39.850323],[-75.378427,39.85008],[-75.379323,39.849766],[-75.381005,39.849206],[-75.382245,39.848791],[-75.382653,39.848657],[-75.383865,39.848254],[-75.385175,39.847834],[-75.386233,39.847538],[-75.386737,39.847394],[-75.387299,39.847235],[-75.387808,39.847082],[-75.388619,39.846829],[-75.388928,39.846731],[-75.389395,39.846582],[-75.39006,39.846361],[-75.390321,39.846267],[-75.390702,39.846121],[-75.391201,39.845916],[-75.391577,39.845749],[-75.392303,39.845417],[-75.393269,39.844967],[-75.393994,39.844629],[-75.395089,39.844122],[-75.395818,39.843794],[-75.396071,39.843685],[-75.396933,39.84332],[-75.397438,39.84311],[-75.397945,39.842911],[-75.398583,39.842667],[-75.399095,39.842483],[-75.399471,39.842354],[-75.399863,39.84222],[-75.400265,39.842089],[-75.400656,39.841965],[-75.401055,39.841854],[-75.401322,39.841792],[-75.401731,39.841713],[-75.402278,39.841629],[-75.402572,39.841597],[-75.402986,39.841564],[-75.403702,39.841533],[-75.404114,39.841518],[-75.404394,39.841505],[-75.404834,39.84147],[-75.405099,39.84144],[-75.405383,39.841398],[-75.405654,39.841341],[-75.405922,39.84128],[-75.406204,39.841208],[-75.406468,39.841119],[-75.406693,39.84104],[-75.40696,39.840929],[-75.407215,39.840817],[-75.407448,39.840699],[-75.408023,39.840373],[-75.408477,39.840111],[-75.408827,39.839908],[-75.409413,39.83957],[-75.409851,39.839326],[-75.410321,39.839081],[-75.410428,39.839026],[-75.410673,39.838908],[-75.411048,39.838744],[-75.411299,39.838641],[-75.411549,39.838538],[-75.4118,39.838446],[-75.412188,39.838312],[-75.414283,39.837642],[-75.416773,39.836838],[-75.419691,39.835928],[-75.420893,39.835553],[-75.421424,39.835366],[-75.422756,39.834795],[-75.423485,39.834465],[-75.423917,39.834246],[-75.424045,39.834178],[-75.424301,39.834048],[-75.424556,39.833912],[-75.425218,39.833517],[-75.425436,39.833385],[-75.425868,39.833109],[-75.426156,39.832925],[-75.427073,39.832306],[-75.427783,39.831828],[-75.428517,39.831327],[-75.428625,39.831258],[-75.428821,39.831129],[-75.43003,39.830319],[-75.430819,39.829787],[-75.431665,39.829225],[-75.434708,39.8272],[-75.435472,39.826674],[-75.437666,39.825199],[-75.43866,39.824565],[-75.439388,39.824155],[-75.439829,39.823941],[-75.440502,39.82365],[-75.441006,39.823457],[-75.441322,39.823341],[-75.445698,39.821796],[-75.446588,39.821385],[-75.447088,39.821121],[-75.447671,39.820782],[-75.448075,39.82052],[-75.448363,39.82032],[-75.448509,39.820217],[-75.449818,39.819354],[-75.450023,39.819218],[-75.450565,39.818798],[-75.450989,39.818482],[-75.451767,39.817914],[-75.452175,39.817528],[-75.453721,39.81627],[-75.454287,39.815777],[-75.454775,39.815199],[-75.455115,39.814694],[-75.45538,39.814037],[-75.455484,39.813528],[-75.455512,39.813188],[-75.455532,39.812909],[-75.455511,39.81252],[-75.455452,39.812141],[-75.455343,39.811765],[-75.455155,39.811326],[-75.454753,39.810648],[-75.453756,39.809258],[-75.453383,39.808717],[-75.452516,39.807509],[-75.451886,39.806596],[-75.451715,39.806327],[-75.45159,39.806089],[-75.45143,39.805785],[-75.451112,39.80503],[-75.450981,39.804546],[-75.450881,39.804067],[-75.450815,39.803332],[-75.450832,39.802586],[-75.450858,39.802324],[-75.450925,39.80198],[-75.450978,39.801714],[-75.451068,39.801371],[-75.451119,39.801189],[-75.451375,39.80051],[-75.451829,39.799699],[-75.45236,39.798953],[-75.45271,39.798537],[-75.453249,39.79798],[-75.454012,39.797301],[-75.45425,39.79711],[-75.45448,39.796947],[-75.454758,39.796746],[-75.455537,39.796233],[-75.45839,39.794469],[-75.460721,39.793053],[-75.462618,39.7919],[-75.465607,39.790053],[-75.466961,39.789136],[-75.467175,39.788958],[-75.46768,39.788596],[-75.469065,39.787481],[-75.469426,39.787162],[-75.470162,39.786445],[-75.471112,39.78552],[-75.47168,39.784912],[-75.473857,39.7827],[-75.474297,39.782234],[-75.475763,39.78068],[-75.480657,39.775289],[-75.480925,39.774953],[-75.481389,39.774375],[-75.482065,39.773469],[-75.482744,39.772394],[-75.483294,39.771415],[-75.485607,39.767055],[-75.486597,39.765201],[-75.489039,39.760648],[-75.489579,39.759685],[-75.489814,39.759345],[-75.490378,39.758638],[-75.491122,39.757917],[-75.491616,39.757538],[-75.491765,39.757424],[-75.49235,39.75704],[-75.492673,39.756854],[-75.493479,39.756425],[-75.493918,39.756239],[-75.49472,39.755942],[-75.495436,39.755715],[-75.497341,39.755105],[-75.498231,39.754804],[-75.498811,39.754573],[-75.499567,39.754202],[-75.500145,39.753839],[-75.500677,39.753424],[-75.501455,39.752812],[-75.502494,39.751974],[-75.503083,39.75152],[-75.503827,39.751026],[-75.504497,39.750643],[-75.505044,39.750334],[-75.50579,39.750041],[-75.507043,39.749563],[-75.507985,39.749203],[-75.508656,39.748943],[-75.509189,39.748701],[-75.509789,39.748408],[-75.50996,39.74831],[-75.510439,39.747984],[-75.510755,39.74774],[-75.511273,39.747293],[-75.511677,39.746891],[-75.512527,39.745932],[-75.512838,39.745584],[-75.517786,39.740091],[-75.518588,39.739194],[-75.519545,39.738122],[-75.520024,39.737586],[-75.520639,39.736905],[-75.520823,39.736696],[-75.521864,39.735534],[-75.523077,39.734179],[-75.523963,39.733209],[-75.524566,39.732601],[-75.524919,39.732264],[-75.525473,39.731766],[-75.525947,39.731363],[-75.52633,39.731048],[-75.526759,39.730716],[-75.537806,39.722166],[-75.538676,39.721495],[-75.539136,39.721133],[-75.539536,39.720828],[-75.540038,39.720436],[-75.540389,39.72017],[-75.540655,39.719978],[-75.541008,39.719743],[-75.541177,39.719634],[-75.541522,39.719423],[-75.542093,39.719101],[-75.542581,39.718854],[-75.542911,39.718698],[-75.543184,39.718578],[-75.543527,39.718431],[-75.544181,39.71818],[-75.544559,39.718052],[-75.544808,39.717974],[-75.545215,39.717852],[-75.545476,39.71778],[-75.545765,39.717707],[-75.546014,39.717647],[-75.546287,39.717587],[-75.546566,39.717534],[-75.546818,39.717488],[-75.547111,39.71744],[-75.547389,39.717401],[-75.547808,39.71735],[-75.548215,39.717311],[-75.548506,39.717292],[-75.548926,39.71727],[-75.549195,39.717266],[-75.549472,39.717262],[-75.551892,39.717248],[-75.554015,39.717235],[-75.556934,39.717214],[-75.557685,39.717216],[-75.559691,39.717199],[-75.560077,39.717195],[-75.562346,39.717158],[-75.564201,39.717107],[-75.565563,39.717051],[-75.56718,39.716913],[-75.568629,39.716738],[-75.570882,39.716353],[-75.57673,39.715298],[-75.578123,39.715047],[-75.578721,39.714933],[-75.57984,39.714721],[-75.581984,39.714317],[-75.583257,39.714095],[-75.584058,39.713958],[-75.585244,39.713734],[-75.586248,39.713528],[-75.586725,39.713427],[-75.586939,39.713376],[-75.58724,39.713291],[-75.587634,39.713165],[-75.587832,39.713091],[-75.588118,39.712978],[-75.588324,39.71289],[-75.588547,39.712782],[-75.589547,39.712262],[-75.59071,39.711585],[-75.592993,39.710234],[-75.596404,39.70824],[-75.597332,39.707714],[-75.600487,39.705929],[-75.603912,39.703884],[-75.608207,39.701379],[-75.610594,39.699997],[-75.612092,39.699099],[-75.613075,39.69851],[-75.613383,39.698338],[-75.615124,39.697376],[-75.616955,39.696574],[-75.619026,39.695765],[-75.620645,39.69525],[-75.622104,39.694786],[-75.623129,39.694478],[-75.632356,39.691585],[-75.636612,39.690257],[-75.638877,39.689547],[-75.641856,39.688614],[-75.644763,39.687706],[-75.645518,39.687469],[-75.647123,39.686948],[-75.650129,39.68602],[-75.652863,39.685159],[-75.655809,39.684235],[-75.656809,39.683913],[-75.659201,39.683032],[-75.660907,39.682258],[-75.662476,39.681546],[-75.662894,39.681329],[-75.664774,39.680287],[-75.665514,39.679847],[-75.66629,39.67935],[-75.667215,39.678746],[-75.667601,39.678469],[-75.667707,39.678393],[-75.668174,39.678057],[-75.668986,39.677451],[-75.669808,39.676782],[-75.67004,39.676569],[-75.672259,39.674704],[-75.674315,39.673027],[-75.675747,39.671966],[-75.676318,39.671594],[-75.677562,39.670924],[-75.680275,39.669558],[-75.681964,39.668738],[-75.685027,39.667194],[-75.686049,39.666639],[-75.689206,39.664833],[-75.689523,39.664633],[-75.690884,39.663674],[-75.691658,39.663102],[-75.693495,39.661555],[-75.695256,39.660222],[-75.696086,39.659528],[-75.696838,39.658936],[-75.697545,39.658364],[-75.698016,39.657974],[-75.698754,39.657451],[-75.700328,39.656472],[-75.701959,39.655679],[-75.703675,39.654978],[-75.705366,39.654469],[-75.707401,39.653987],[-75.710829,39.653305],[-75.711541,39.653161],[-75.71982,39.651482],[-75.720043,39.651434],[-75.725773,39.650208],[-75.731802,39.648967],[-75.732419,39.648847],[-75.734693,39.648368],[-75.735133,39.64829],[-75.738481,39.647622],[-75.739397,39.647446],[-75.740584,39.647248],[-75.740724,39.647225],[-75.7422,39.6471],[-75.742301,39.647095],[-75.742776,39.647054],[-75.743115,39.647041],[-75.745519,39.64703],[-75.74642,39.64703],[-75.747085,39.647026],[-75.751206,39.647038],[-75.7552,39.647032],[-75.75673,39.647015],[-75.757419,39.646973],[-75.758223,39.6469],[-75.758771,39.646831],[-75.759343,39.646735],[-75.760377,39.646507],[-75.761507,39.646206],[-75.763049,39.645602],[-75.763698,39.645362],[-75.764535,39.645111],[-75.764585,39.645097],[-75.764629,39.645083],[-75.765243,39.644899],[-75.766064,39.644647],[-75.768032,39.644211],[-75.771357,39.643175],[-75.781631,39.639988],[-75.782111,39.639845],[-75.78259,39.639713],[-75.783056,39.639597],[-75.783521,39.639488],[-75.784039,39.639382],[-75.784544,39.639294],[-75.785106,39.639209],[-75.785596,39.639145],[-75.786049,39.639093],[-75.786581,39.639051],[-75.787139,39.63902],[-75.787516,39.639008],[-75.787732,39.639001],[-75.78826,39.638997],[-75.788684,39.638999],[-75.789186,39.639013],[-75.789593,39.639033],[-75.790139,39.639074],[-75.790641,39.639128],[-75.791136,39.639189],[-75.791522,39.639246],[-75.792128,39.639342],[-75.796616,39.640132],[-75.797226,39.640238],[-75.801472,39.640989],[-75.802328,39.64114],[-75.805335,39.641665],[-75.806051,39.641786],[-75.806825,39.641912],[-75.807639,39.642032],[-75.808335,39.642124],[-75.809074,39.64221],[-75.809739,39.642282],[-75.810448,39.642344],[-75.811172,39.642397],[-75.811762,39.642438],[-75.812423,39.642474],[-75.812998,39.6425],[-75.822141,39.642785],[-75.822694,39.642804],[-75.823994,39.642852],[-75.824615,39.642877],[-75.825235,39.642919],[-75.825841,39.642975],[-75.826459,39.643051],[-75.82709,39.64314],[-75.827759,39.643254],[-75.828306,39.643363],[-75.828897,39.643491],[-75.829508,39.643641],[-75.830033,39.643783],[-75.832645,39.644569],[-75.83594,39.645554],[-75.8367,39.645766],[-75.83727,39.645906],[-75.837911,39.646048],[-75.838524,39.64617],[-75.839129,39.646271],[-75.839751,39.646361],[-75.840407,39.646438],[-75.84098,39.646493],[-75.84154,39.646533],[-75.842134,39.646568],[-75.842744,39.646585],[-75.843352,39.646588],[-75.843945,39.646576],[-75.844519,39.646554],[-75.845117,39.646518],[-75.845739,39.646464],[-75.84627,39.646405],[-75.846841,39.646334],[-75.847554,39.646223],[-75.848179,39.646114],[-75.848758,39.645995],[-75.849399,39.645847],[-75.862347,39.642537],[-75.862964,39.642392],[-75.863597,39.642264],[-75.864257,39.642142],[-75.86482,39.642056],[-75.865477,39.641971],[-75.866225,39.641895],[-75.866698,39.641859],[-75.867216,39.641829],[-75.867747,39.641812],[-75.868267,39.641802],[-75.868911,39.641799],[-75.869495,39.641815],[-75.870154,39.64185],[-75.870806,39.6419],[-75.871486,39.641967],[-75.872105,39.642051],[-75.872748,39.642149],[-75.873381,39.642259],[-75.8739,39.64237],[-75.874459,39.64249],[-75.875145,39.642668],[-75.875736,39.642836],[-75.876377,39.643041],[-75.877399,39.643356],[-75.87788,39.643498],[-75.878433,39.643649],[-75.879024,39.643796],[-75.8796,39.643925],[-75.880128,39.644025],[-75.880641,39.644115],[-75.881156,39.644194],[-75.88165,39.644264],[-75.882138,39.644322],[-75.882685,39.644372],[-75.883215,39.644411],[-75.883718,39.644439],[-75.884256,39.644459],[-75.884744,39.644467],[-75.885209,39.644465],[-75.885685,39.644457],[-75.886152,39.64444],[-75.886648,39.644411],[-75.887214,39.644367],[-75.887709,39.644318],[-75.888268,39.644251],[-75.888802,39.644179],[-75.889354,39.644093],[-75.893493,39.643346],[-75.903652,39.64152],[-75.904091,39.641451],[-75.904509,39.641393],[-75.904931,39.641344],[-75.905311,39.641312],[-75.905731,39.641291],[-75.90616,39.641289],[-75.906581,39.641298],[-75.907065,39.641322],[-75.90751,39.641363],[-75.907929,39.641414],[-75.908349,39.64148],[-75.908762,39.64156],[-75.90916,39.641652],[-75.909554,39.641755],[-75.909967,39.641877],[-75.910439,39.642037],[-75.91868,39.644989],[-75.919136,39.645142],[-75.919521,39.645261],[-75.919904,39.645363],[-75.920282,39.645456],[-75.920637,39.645529],[-75.921029,39.645602],[-75.921475,39.645667],[-75.921917,39.645716],[-75.922366,39.645748],[-75.922808,39.645768],[-75.923292,39.645773],[-75.92373,39.645759],[-75.924162,39.645734],[-75.924635,39.645692],[-75.925098,39.645633],[-75.925496,39.645569],[-75.925976,39.645473],[-75.926644,39.645313],[-75.932191,39.643854],[-75.932901,39.643656],[-75.933451,39.643493],[-75.934058,39.643301],[-75.934591,39.643119],[-75.935212,39.642896],[-75.935814,39.642661],[-75.936427,39.642408],[-75.937912,39.641774],[-75.938565,39.641496],[-75.940575,39.640626],[-75.941291,39.640305],[-75.942085,39.639937],[-75.942755,39.639607],[-75.943453,39.63925],[-75.947229,39.637243],[-75.947966,39.63685],[-75.948206,39.636725],[-75.960485,39.630153],[-75.961144,39.629799],[-75.961905,39.629414],[-75.962385,39.62919],[-75.963149,39.628858],[-75.963788,39.628608],[-75.964287,39.628428],[-75.964863,39.62824],[-75.965339,39.628091],[-75.965857,39.627945],[-75.966328,39.627818],[-75.966834,39.627699],[-75.967387,39.627577],[-75.967903,39.627475],[-75.968492,39.627376],[-75.969001,39.6273],[-75.969499,39.627232],[-75.970012,39.627179],[-75.973328,39.626868],[-75.979537,39.626295],[-75.980154,39.626233],[-75.980751,39.626155],[-75.981421,39.626054],[-75.981967,39.625959],[-75.982549,39.625841],[-75.983084,39.625721],[-75.983681,39.625574],[-75.984271,39.62541],[-75.98481,39.625252],[-75.985329,39.625081],[-75.985884,39.624887],[-75.986437,39.624676],[-75.986973,39.624459],[-75.987421,39.624262],[-75.987876,39.62405],[-75.98839,39.623794],[-75.988752,39.62361],[-75.989208,39.62336],[-75.989595,39.623136],[-75.989983,39.622899],[-75.990362,39.622654],[-75.990737,39.622402],[-75.992709,39.621013],[-75.992945,39.620851],[-75.996744,39.618155],[-75.997357,39.617739],[-75.997932,39.617375],[-75.998533,39.617029],[-75.999136,39.616699],[-75.999753,39.616398],[-76.000561,39.616024],[-76.001348,39.615708],[-76.002087,39.615436],[-76.007813,39.613558],[-76.008677,39.613272],[-76.0091,39.61312],[-76.009463,39.612975],[-76.009828,39.612821],[-76.010266,39.612619],[-76.010677,39.61241],[-76.011027,39.612215],[-76.01139,39.611996],[-76.01176,39.61175],[-76.012084,39.611517],[-76.012936,39.610891],[-76.013419,39.610564],[-76.013938,39.610232],[-76.014369,39.60998],[-76.014821,39.609738],[-76.015372,39.609466],[-76.015907,39.609226],[-76.016484,39.608994],[-76.016865,39.608854],[-76.017299,39.608701],[-76.017766,39.608552],[-76.018336,39.60839],[-76.018703,39.608297],[-76.019144,39.608195],[-76.019768,39.608066],[-76.031694,39.605863],[-76.032412,39.605722],[-76.032958,39.605605],[-76.03353,39.605468],[-76.034169,39.605299],[-76.034693,39.605144],[-76.035305,39.604943],[-76.03594,39.604722],[-76.03654,39.604493],[-76.036885,39.604356],[-76.037269,39.604189],[-76.037835,39.603933],[-76.038307,39.603704],[-76.042881,39.601373],[-76.043468,39.601071],[-76.043982,39.600821],[-76.044501,39.600583],[-76.045131,39.600319],[-76.045584,39.600141],[-76.046016,39.599982],[-76.046612,39.599775],[-76.047117,39.599617],[-76.047734,39.599434],[-76.048423,39.599254],[-76.05904,39.596566],[-76.060795,39.596116],[-76.061096,39.596039],[-76.061721,39.59587],[-76.062235,39.595711],[-76.062738,39.595541],[-76.063194,39.595358],[-76.063601,39.595184],[-76.064026,39.594973],[-76.064458,39.594732],[-76.064938,39.594439],[-76.065396,39.59413],[-76.066679,39.5932],[-76.067484,39.59261],[-76.069445,39.591189],[-76.069867,39.590885],[-76.071329,39.589846],[-76.0726,39.588926],[-76.073501,39.588268],[-76.073872,39.588002],[-76.074297,39.587741],[-76.074697,39.587515],[-76.075017,39.587346],[-76.075287,39.587213],[-76.075637,39.587051],[-76.076025,39.586885],[-76.076577,39.586671],[-76.07711,39.586486],[-76.077546,39.58635],[-76.078001,39.586225],[-76.078399,39.586126],[-76.078797,39.586036],[-76.07919,39.58596],[-76.079641,39.585882],[-76.080159,39.585807],[-76.080503,39.585765],[-76.080859,39.585732],[-76.081228,39.585702],[-76.081659,39.585684],[-76.082085,39.585672],[-76.082488,39.585667],[-76.090886,39.585755],[-76.092777,39.585766],[-76.093242,39.585757],[-76.093661,39.585729],[-76.09411,39.585681],[-76.094526,39.585615],[-76.094961,39.585526],[-76.095446,39.585397],[-76.095967,39.585223],[-76.096469,39.585022],[-76.097124,39.584725],[-76.1048,39.581263],[-76.106825,39.580356],[-76.108953,39.5794],[-76.11093,39.578494],[-76.112693,39.577694],[-76.113105,39.577518],[-76.113483,39.57737],[-76.113861,39.577236],[-76.114227,39.577128],[-76.114577,39.577042],[-76.114879,39.576982],[-76.115258,39.576924],[-76.115615,39.576882],[-76.115997,39.576852],[-76.116471,39.576828],[-76.117014,39.576811],[-76.124193,39.576629],[-76.125318,39.576597],[-76.125979,39.576564],[-76.126568,39.576518],[-76.127221,39.576448],[-76.127841,39.576362],[-76.128441,39.57626],[-76.129056,39.576135],[-76.129691,39.575983],[-76.130446,39.575777],[-76.131106,39.57557],[-76.131695,39.575364],[-76.132316,39.57512],[-76.132768,39.574925],[-76.133291,39.574687],[-76.133735,39.574461],[-76.134353,39.57412],[-76.134985,39.573738],[-76.135406,39.573466],[-76.13583,39.573169],[-76.136307,39.572807],[-76.136704,39.572485],[-76.137083,39.572151],[-76.137428,39.571826],[-76.13782,39.571425],[-76.138169,39.571046],[-76.142793,39.565709],[-76.143254,39.565188],[-76.143713,39.564685],[-76.144117,39.564271],[-76.144581,39.563828],[-76.145047,39.563418],[-76.145448,39.563086],[-76.146038,39.562635],[-76.155478,39.555938],[-76.156481,39.555212],[-76.157148,39.554722],[-76.157786,39.554228],[-76.158465,39.553685],[-76.162775,39.550134],[-76.166632,39.546946],[-76.167084,39.546576],[-76.167538,39.546198],[-76.168065,39.545737],[-76.168439,39.545385],[-76.168857,39.544955],[-76.169253,39.544539],[-76.169615,39.54411],[-76.169997,39.543638],[-76.17035,39.543164],[-76.170611,39.542775],[-76.170968,39.542224],[-76.173452,39.538168],[-76.173879,39.537481],[-76.17437,39.536755],[-76.174753,39.536236],[-76.175207,39.535687],[-76.17562,39.535228],[-76.176185,39.534643],[-76.176694,39.534166],[-76.177162,39.533757],[-76.177627,39.533381],[-76.17815,39.532979],[-76.178731,39.532571],[-76.179286,39.532202],[-76.179878,39.531848],[-76.180494,39.531507],[-76.181039,39.531226],[-76.181417,39.531038],[-76.181916,39.530807],[-76.191546,39.526785],[-76.192026,39.526577],[-76.192395,39.526374],[-76.192755,39.526174],[-76.193113,39.525952],[-76.193494,39.525697],[-76.193864,39.525411],[-76.1942,39.525141],[-76.19447,39.524898],[-76.199725,39.519958],[-76.200441,39.519285],[-76.212403,39.508041],[-76.212874,39.507635],[-76.213303,39.507292],[-76.21374,39.506959],[-76.214105,39.5067],[-76.214607,39.506366],[-76.215099,39.506066],[-76.215515,39.50583],[-76.216142,39.505497],[-76.216667,39.505239],[-76.217152,39.505017],[-76.217603,39.50483],[-76.218124,39.504624],[-76.218723,39.504407],[-76.219244,39.504224],[-76.224505,39.502413],[-76.227391,39.50141],[-76.228021,39.501178],[-76.228618,39.500937],[-76.229413,39.50058],[-76.230096,39.500244],[-76.230764,39.499887],[-76.231391,39.499524],[-76.232094,39.499076],[-76.23258,39.498748],[-76.233073,39.49838],[-76.233611,39.497963],[-76.234236,39.497435],[-76.23478,39.496936],[-76.235259,39.496452],[-76.235766,39.495899],[-76.236276,39.49529],[-76.236681,39.494783],[-76.237087,39.494288],[-76.238576,39.492421],[-76.239109,39.491772],[-76.239785,39.491004],[-76.240226,39.490537],[-76.240697,39.490067],[-76.241283,39.489538],[-76.241816,39.489082],[-76.242392,39.488627],[-76.242951,39.488213],[-76.243406,39.487892],[-76.24389,39.487568],[-76.244418,39.487235],[-76.245025,39.486875],[-76.24566,39.48652],[-76.246166,39.48626],[-76.246671,39.486012],[-76.247156,39.485785],[-76.247664,39.485564],[-76.248274,39.485307],[-76.248818,39.485092],[-76.249406,39.48488],[-76.249949,39.484696],[-76.250487,39.484523],[-76.251113,39.48434],[-76.256093,39.48302],[-76.256723,39.482837],[-76.257209,39.482684],[-76.257798,39.482482],[-76.258343,39.48228],[-76.258864,39.482074],[-76.25941,39.481837],[-76.261857,39.480688],[-76.262292,39.480479],[-76.269583,39.477042],[-76.269959,39.476851],[-76.270309,39.476667],[-76.270718,39.476437],[-76.271158,39.476171],[-76.27158,39.475888],[-76.272058,39.475542],[-76.272506,39.47518],[-76.272982,39.474772],[-76.27505,39.472891],[-76.275637,39.472375],[-76.276132,39.471977],[-76.276608,39.471628],[-76.277127,39.471267],[-76.277621,39.470946],[-76.278168,39.470608],[-76.278765,39.470272],[-76.279408,39.469932],[-76.280053,39.469615],[-76.285374,39.467106],[-76.286031,39.466808],[-76.286504,39.466601],[-76.286987,39.466395],[-76.288269,39.465881],[-76.29966,39.461479],[-76.300599,39.46111],[-76.301854,39.460598],[-76.304036,39.459698],[-76.305509,39.459073],[-76.306758,39.458528],[-76.307749,39.458082],[-76.309187,39.457419],[-76.311003,39.456554],[-76.311861,39.456138],[-76.313053,39.455541],[-76.314312,39.454886],[-76.315653,39.454181],[-76.317847,39.453004],[-76.320949,39.451288],[-76.321809,39.450812],[-76.323245,39.450029],[-76.323956,39.449667],[-76.324557,39.449371],[-76.325133,39.449095],[-76.325743,39.448815],[-76.326407,39.448526],[-76.326971,39.448288],[-76.327655,39.448015],[-76.328305,39.447762],[-76.340099,39.443235],[-76.340606,39.443048],[-76.341181,39.442852],[-76.341708,39.442696],[-76.342242,39.442555],[-76.342796,39.442436],[-76.343347,39.442331],[-76.343835,39.442257],[-76.344244,39.442204],[-76.344734,39.442154],[-76.34521,39.442121],[-76.345863,39.442097],[-76.346428,39.442094],[-76.357848,39.442189],[-76.363785,39.442235],[-76.364455,39.442226],[-76.365045,39.442194],[-76.365685,39.442138],[-76.366376,39.44205],[-76.366936,39.44196],[-76.367583,39.44183],[-76.368186,39.441685],[-76.368725,39.441534],[-76.369266,39.441365],[-76.369913,39.441131],[-76.370542,39.440872],[-76.371169,39.44058],[-76.371767,39.44027],[-76.37222,39.440006],[-76.372673,39.43972],[-76.373312,39.439279],[-76.377322,39.436394],[-76.377588,39.436198],[-76.377866,39.435993],[-76.386424,39.429835],[-76.389793,39.427417],[-76.390416,39.426986],[-76.391201,39.426473],[-76.391846,39.426072],[-76.392468,39.4257],[-76.393148,39.425309],[-76.393863,39.424915],[-76.394654,39.424505],[-76.39522,39.424219],[-76.39592,39.423885],[-76.396596,39.423572],[-76.397256,39.42328],[-76.397918,39.423002],[-76.404279,39.420428],[-76.404845,39.420189],[-76.405367,39.419947],[-76.405868,39.419683],[-76.406327,39.419409],[-76.406721,39.419152],[-76.407082,39.418883],[-76.407413,39.418614],[-76.407712,39.418348],[-76.407985,39.418082],[-76.40827,39.417778],[-76.408543,39.417455],[-76.408799,39.417105],[-76.409064,39.416719],[-76.409322,39.416312],[-76.409699,39.415716],[-76.409825,39.41552],[-76.411092,39.413532],[-76.411327,39.413177],[-76.411603,39.412807],[-76.411875,39.412481],[-76.412097,39.412238],[-76.412367,39.411966],[-76.412834,39.411559],[-76.413171,39.411288],[-76.41356,39.410993],[-76.427915,39.400303],[-76.428412,39.399915],[-76.428902,39.399503],[-76.429366,39.399085],[-76.429735,39.398734],[-76.430167,39.39829],[-76.430576,39.397839],[-76.434618,39.393206],[-76.435109,39.392648],[-76.43555,39.392142],[-76.436049,39.391576],[-76.436616,39.390972],[-76.437131,39.390446],[-76.437621,39.390077],[-76.439947,39.387893],[-76.444062,39.383941],[-76.445534,39.382549],[-76.446603,39.38156],[-76.447495,39.380837],[-76.448239,39.380151],[-76.449673,39.378758],[-76.450371,39.378091],[-76.453155,39.375483],[-76.454188,39.374383],[-76.455005,39.373628],[-76.455711,39.373072],[-76.456212,39.372692],[-76.456723,39.372305],[-76.457084,39.372068],[-76.457845,39.371586],[-76.458669,39.371121],[-76.459307,39.370794],[-76.460275,39.370311],[-76.463485,39.368704],[-76.47309,39.363882],[-76.474026,39.36338],[-76.474781,39.362953],[-76.475494,39.362535],[-76.476261,39.362063],[-76.477933,39.360938],[-76.478515,39.360567],[-76.47924,39.360104],[-76.480057,39.359643],[-76.480968,39.359165],[-76.481946,39.358664],[-76.484153,39.357569],[-76.48631,39.356503],[-76.487567,39.355877],[-76.493018,39.353111],[-76.495473,39.351898],[-76.497917,39.350681],[-76.499562,39.349835],[-76.50071,39.349246],[-76.502514,39.348368],[-76.504412,39.347416],[-76.505243,39.347009],[-76.506355,39.346462],[-76.510258,39.344544],[-76.510743,39.344274],[-76.51119,39.344],[-76.511688,39.343661],[-76.512192,39.343273],[-76.512638,39.342882],[-76.512991,39.342517],[-76.513381,39.342072],[-76.513689,39.341667],[-76.513973,39.341232],[-76.514194,39.340803],[-76.516007,39.337477],[-76.516394,39.336843],[-76.51679,39.33622],[-76.51726,39.335561],[-76.517677,39.335035],[-76.518168,39.334429],[-76.51863,39.333908],[-76.519105,39.333403],[-76.526218,39.326426],[-76.529271,39.323368],[-76.531576,39.321078],[-76.533298,39.319393],[-76.535748,39.317],[-76.536343,39.316414],[-76.536896,39.315872],[-76.538446,39.31429],[-76.538748,39.313976],[-76.539043,39.313653],[-76.539344,39.313317],[-76.539692,39.312852],[-76.540225,39.312129],[-76.540573,39.311577],[-76.541063,39.310714],[-76.541139,39.310592],[-76.541232,39.310429],[-76.54115,39.310385],[-76.541022,39.310322],[-76.54079,39.310206],[-76.538669,39.309101],[-76.538478,39.308949],[-76.538287,39.30876],[-76.538138,39.308572],[-76.537983,39.308329],[-76.537874,39.308113],[-76.53779,39.307909],[-76.537728,39.307704],[-76.537686,39.307511],[-76.537664,39.307336],[-76.537657,39.307148],[-76.537665,39.306967],[-76.537688,39.306773],[-76.537733,39.306573],[-76.537802,39.306354],[-76.537885,39.306153],[-76.537963,39.306009],[-76.538051,39.305855],[-76.538154,39.305713],[-76.538275,39.305566],[-76.538398,39.305424],[-76.538546,39.305281],[-76.538752,39.305107],[-76.538943,39.304976],[-76.539166,39.304844],[-76.539454,39.304688],[-76.539789,39.304529],[-76.540114,39.304394],[-76.540421,39.304278],[-76.541944,39.303738],[-76.543749,39.303215],[-76.545675,39.302656],[-76.546481,39.302415],[-76.546532,39.302401],[-76.547607,39.302088],[-76.547807,39.30203],[-76.548274,39.301888],[-76.548656,39.301768],[-76.549391,39.301521],[-76.550074,39.301284],[-76.550881,39.301003],[-76.551958,39.300633],[-76.552302,39.300517],[-76.552707,39.300391],[-76.553454,39.300158],[-76.553973,39.30009],[-76.554378,39.300063],[-76.5568,39.299967],[-76.558567,39.299899],[-76.560438,39.299831],[-76.56242,39.299751],[-76.563286,39.299722],[-76.564532,39.299681],[-76.565835,39.299632],[-76.566553,39.299606],[-76.566682,39.299601],[-76.567206,39.299581],[-76.568269,39.299543],[-76.569589,39.299478],[-76.569734,39.299478],[-76.569839,39.29949],[-76.570141,39.299575],[-76.571111,39.299885],[-76.571959,39.300155],[-76.572248,39.300248],[-76.572402,39.300285],[-76.57252,39.300305],[-76.572571,39.300309],[-76.572696,39.30031],[-76.572716,39.30031],[-76.572858,39.300281],[-76.573488,39.300256],[-76.573693,39.300249],[-76.573908,39.300241],[-76.574556,39.300217],[-76.574749,39.30021],[-76.575379,39.300187],[-76.575654,39.300177],[-76.575686,39.300176],[-76.576026,39.300164],[-76.57634,39.300152],[-76.576717,39.300139],[-76.577101,39.300125],[-76.577437,39.300112],[-76.577744,39.300101],[-76.578135,39.300082],[-76.578509,39.300066],[-76.578834,39.300052],[-76.579167,39.300037],[-76.579536,39.300021],[-76.579906,39.300008],[-76.580243,39.299995],[-76.580568,39.29998],[-76.580948,39.299965],[-76.581641,39.299934],[-76.581976,39.299925],[-76.582343,39.299909],[-76.583081,39.299888],[-76.583393,39.299876],[-76.583788,39.29986],[-76.584482,39.299831],[-76.584791,39.299819],[-76.585193,39.299802],[-76.585612,39.299785],[-76.58597,39.299771],[-76.586324,39.299756],[-76.586727,39.29974],[-76.587312,39.299718],[-76.587533,39.299709],[-76.58791,39.299695],[-76.588768,39.299659],[-76.589226,39.299645],[-76.589669,39.299614],[-76.590042,39.299614],[-76.590307,39.299604],[-76.590949,39.299579],[-76.591629,39.299553],[-76.592267,39.299533],[-76.592428,39.299523],[-76.592866,39.299506],[-76.59331,39.29949],[-76.594212,39.299452],[-76.594469,39.299443],[-76.594881,39.299423],[-76.594903,39.299423],[-76.59493,39.299424],[-76.595339,39.299407],[-76.595754,39.29939],[-76.596266,39.299369],[-76.597015,39.299339],[-76.597665,39.299312],[-76.598418,39.299281],[-76.599211,39.299248],[-76.599706,39.299227],[-76.600142,39.299209],[-76.600759,39.299183],[-76.601496,39.299152],[-76.601939,39.299134],[-76.602745,39.299103],[-76.603578,39.299073],[-76.603739,39.299066],[-76.603805,39.298988],[-76.60386,39.298905],[-76.60396,39.29865],[-76.604104,39.29831],[-76.604195,39.298081],[-76.604234,39.297986],[-76.604276,39.297903],[-76.604293,39.297868],[-76.604393,39.297733],[-76.604454,39.297658],[-76.604532,39.297592],[-76.604626,39.297517],[-76.604765,39.297413],[-76.605538,39.296849],[-76.606192,39.29638],[-76.606865,39.295889],[-76.607454,39.29546],[-76.608229,39.294883],[-76.608617,39.294608],[-76.608781,39.294483],[-76.608956,39.294375],[-76.609106,39.294283],[-76.609294,39.294182],[-76.609358,39.294151],[-76.609646,39.294014],[-76.609889,39.293916],[-76.609994,39.293854],[-76.610085,39.2938],[-76.610167,39.293708],[-76.610323,39.293469],[-76.610399,39.293241],[-76.610388,39.292963],[-76.61037,39.292482],[-76.611177,39.292452],[-76.611144,39.291977],[-76.611128,39.291687],[-76.611104,39.291254],[-76.611076,39.290887]]},{_id:'2',truck:'1',from:{name:'Baltimore',lat:39.290887,lng:-76.611076},to:{name:'Pittsburg',lat:40.440907,lng:-79.99009},startDate:new Date(2017,10,3,11,0),endDate:new Date(2017,10,3,14,0),km:200,revenue:428,selected:false,drive:1,duty:2,off:1,berth:2,time:1,distance:50,fuel:140,tolls:82,vectorPath:[[-76.611076,39.290887],[-76.611048,39.290519],[-76.611041,39.290444],[-76.611028,39.290134],[-76.611002,39.289775],[-76.610978,39.289697],[-76.610917,39.288969],[-76.610872,39.288523],[-76.610858,39.288331],[-76.610854,39.288279],[-76.610835,39.287996],[-76.610827,39.287886],[-76.611209,39.28784],[-76.611746,39.287812],[-76.612056,39.287796],[-76.612159,39.287791],[-76.612258,39.287784],[-76.612365,39.287782],[-76.612856,39.287766],[-76.612962,39.287764],[-76.613097,39.287762],[-76.613368,39.287757],[-76.613509,39.287755],[-76.613622,39.287753],[-76.613617,39.287654],[-76.613602,39.287363],[-76.613586,39.287036],[-76.613571,39.286761],[-76.613563,39.286639],[-76.613554,39.286538],[-76.613549,39.28647],[-76.613458,39.285579],[-76.613422,39.285197],[-76.613354,39.284536],[-76.613335,39.284351],[-76.613485,39.284343],[-76.614596,39.284292],[-76.614691,39.284287],[-76.614797,39.284281],[-76.615013,39.284272],[-76.615432,39.284251],[-76.615829,39.28423],[-76.616305,39.284206],[-76.616736,39.284185],[-76.617511,39.284147],[-76.61767,39.284135],[-76.6178,39.28413],[-76.618159,39.284112],[-76.618471,39.284096],[-76.618802,39.284071],[-76.618914,39.284055],[-76.61898,39.28404],[-76.61905,39.284021],[-76.619145,39.283965],[-76.61919,39.283924],[-76.619207,39.283883],[-76.619221,39.283811],[-76.619236,39.28372],[-76.619221,39.283489],[-76.619199,39.283145],[-76.619175,39.282822],[-76.619161,39.282601],[-76.619142,39.282277],[-76.619124,39.282032],[-76.61906,39.281729],[-76.61905,39.281507],[-76.619032,39.28119],[-76.619014,39.280853],[-76.618986,39.28041],[-76.618981,39.280311],[-76.618975,39.280202],[-76.618969,39.280092],[-76.618967,39.279983],[-76.618972,39.279868],[-76.618973,39.27978],[-76.618982,39.279664],[-76.61899,39.279548],[-76.619013,39.27939],[-76.619069,39.279118],[-76.619127,39.278773],[-76.619206,39.2785],[-76.619287,39.27826],[-76.619301,39.278228],[-76.619341,39.278126],[-76.619353,39.278098],[-76.619392,39.278003],[-76.619404,39.277973],[-76.619454,39.27786],[-76.619996,39.276768],[-76.62129,39.273954],[-76.622988,39.270211],[-76.623184,39.269838],[-76.623397,39.269515],[-76.623644,39.26923],[-76.623919,39.268976],[-76.624172,39.268776],[-76.624509,39.268558],[-76.62472,39.268465],[-76.624898,39.268385],[-76.625162,39.268308],[-76.625498,39.268225],[-76.625777,39.268189],[-76.626051,39.268177],[-76.626425,39.268192],[-76.626776,39.26822],[-76.627201,39.268272],[-76.627628,39.268343],[-76.628049,39.268436],[-76.628518,39.26855],[-76.629241,39.268707],[-76.630415,39.268924],[-76.631268,39.269111],[-76.63286,39.269433],[-76.63404,39.269653],[-76.634863,39.269793],[-76.635757,39.269939],[-76.636404,39.270034],[-76.637124,39.27014],[-76.637928,39.270253],[-76.639189,39.270401],[-76.640168,39.270508],[-76.64256,39.270756],[-76.643705,39.270858],[-76.646733,39.271107],[-76.64952,39.271348],[-76.651426,39.271527],[-76.651881,39.271558],[-76.652413,39.271581],[-76.652833,39.271568],[-76.653221,39.271541],[-76.653721,39.271489],[-76.654101,39.271419],[-76.654508,39.271329],[-76.654832,39.271243],[-76.655163,39.271139],[-76.655465,39.271032],[-76.655757,39.270915],[-76.65743,39.27017],[-76.660191,39.268949],[-76.66051,39.268807],[-76.663957,39.267304],[-76.664664,39.266996],[-76.666471,39.266208],[-76.669436,39.264904],[-76.669902,39.264686],[-76.670269,39.264493],[-76.670724,39.264221],[-76.671153,39.263924],[-76.671568,39.263597],[-76.671935,39.263265],[-76.672273,39.262906],[-76.672502,39.262629],[-76.672778,39.262252],[-76.673195,39.261667],[-76.673942,39.260471],[-76.674915,39.258992],[-76.676005,39.257327],[-76.676284,39.256892],[-76.67669,39.256414],[-76.676938,39.256126],[-76.677114,39.255948],[-76.677263,39.255814],[-76.677465,39.255663],[-76.67766,39.255534],[-76.677935,39.255379],[-76.678214,39.25525],[-76.678434,39.255164],[-76.678642,39.255094],[-76.678848,39.25504],[-76.679067,39.254993],[-76.679346,39.254944],[-76.681981,39.254551],[-76.68253,39.254446],[-76.683232,39.254344],[-76.683566,39.254307],[-76.683864,39.254289],[-76.684176,39.254283],[-76.684506,39.254291],[-76.684872,39.254322],[-76.685183,39.254368],[-76.68547,39.25442],[-76.685754,39.254486],[-76.686143,39.254584],[-76.686517,39.254701],[-76.687221,39.254908],[-76.687713,39.255079],[-76.688105,39.255208],[-76.688621,39.255372],[-76.689149,39.255525],[-76.689954,39.255738],[-76.691375,39.256132],[-76.692113,39.256326],[-76.694493,39.256958],[-76.695788,39.257304],[-76.6968,39.257574],[-76.697145,39.25767],[-76.697786,39.257878],[-76.698302,39.258067],[-76.698916,39.25832],[-76.699404,39.258544],[-76.6999,39.258798],[-76.700372,39.259047],[-76.702621,39.260283],[-76.702769,39.26036],[-76.705702,39.26191],[-76.706207,39.262177],[-76.706897,39.262551],[-76.707684,39.26297],[-76.708365,39.263347],[-76.7109,39.264786],[-76.720815,39.270446],[-76.721242,39.270701],[-76.722039,39.271187],[-76.722375,39.271408],[-76.722673,39.271632],[-76.722949,39.271867],[-76.723209,39.272117],[-76.723456,39.272392],[-76.723673,39.272677],[-76.723881,39.272979],[-76.72409,39.273369],[-76.724287,39.2738],[-76.724433,39.274215],[-76.724839,39.275496],[-76.725075,39.276231],[-76.725241,39.276756],[-76.725437,39.277364],[-76.725608,39.277821],[-76.725749,39.278128],[-76.725979,39.278527],[-76.726188,39.278813],[-76.726417,39.279082],[-76.726665,39.27934],[-76.726937,39.279582],[-76.72724,39.279815],[-76.72746,39.279968],[-76.727676,39.280103],[-76.728022,39.280301],[-76.73084,39.281848],[-76.731065,39.281972],[-76.73145,39.282178],[-76.733522,39.283309],[-76.734434,39.283807],[-76.734459,39.28382],[-76.735516,39.284402],[-76.735965,39.284647],[-76.736458,39.284914],[-76.736934,39.28519],[-76.737323,39.285428],[-76.737706,39.28568],[-76.737979,39.285876],[-76.738196,39.286041],[-76.738532,39.286308],[-76.738843,39.28657],[-76.738891,39.286614],[-76.7392,39.286899],[-76.73954,39.287234],[-76.739807,39.287522],[-76.740039,39.287803],[-76.740322,39.288187],[-76.740593,39.288572],[-76.740778,39.288852],[-76.741002,39.289234],[-76.74107,39.289358],[-76.741235,39.289656],[-76.741385,39.289965],[-76.741531,39.290309],[-76.741717,39.290793],[-76.741832,39.291155],[-76.741943,39.291582],[-76.742021,39.291951],[-76.74207,39.292236],[-76.742145,39.292782],[-76.742969,39.2992],[-76.742962,39.300001],[-76.742933,39.300662],[-76.742889,39.301098],[-76.742832,39.301453],[-76.742762,39.301802],[-76.742681,39.302204],[-76.742606,39.302583],[-76.742546,39.302859],[-76.742514,39.303029],[-76.742485,39.303227],[-76.742484,39.303482],[-76.742506,39.303773],[-76.742544,39.303994],[-76.742603,39.30422],[-76.742681,39.304437],[-76.742806,39.304664],[-76.742949,39.304907],[-76.743105,39.305125],[-76.74329,39.305309],[-76.743621,39.305596],[-76.743948,39.305842],[-76.744223,39.305996],[-76.744539,39.306143],[-76.744894,39.306285],[-76.745214,39.306383],[-76.745707,39.306504],[-76.746119,39.306582],[-76.746382,39.306625],[-76.746687,39.30667],[-76.747016,39.306707],[-76.747619,39.306732],[-76.748243,39.306732],[-76.749328,39.306702],[-76.750024,39.306701],[-76.750422,39.306724],[-76.750851,39.30677],[-76.751594,39.306932],[-76.75212,39.307091],[-76.752699,39.307259],[-76.753188,39.307365],[-76.753384,39.307416],[-76.753761,39.307521],[-76.754147,39.307624],[-76.754769,39.307752],[-76.75532,39.307854],[-76.755942,39.307947],[-76.756577,39.308015],[-76.757103,39.30805],[-76.75753,39.308072],[-76.757989,39.30808],[-76.75851,39.308075],[-76.758966,39.308055],[-76.759411,39.30803],[-76.759969,39.307982],[-76.763537,39.307637],[-76.769088,39.307104],[-76.769698,39.307053],[-76.770308,39.307012],[-76.770812,39.306981],[-76.771377,39.306951],[-76.772086,39.306922],[-76.772934,39.306903],[-76.773667,39.306895],[-76.774514,39.306898],[-76.7751,39.30691],[-76.775801,39.306938],[-76.776423,39.306965],[-76.777036,39.306999],[-76.78268,39.30734],[-76.783267,39.307372],[-76.783752,39.307392],[-76.784284,39.307405],[-76.784882,39.307411],[-76.785367,39.3074],[-76.785944,39.307381],[-76.786534,39.307342],[-76.787155,39.307291],[-76.787662,39.307237],[-76.788331,39.307152],[-76.789032,39.307043],[-76.789791,39.306901],[-76.790359,39.306783],[-76.79096,39.306636],[-76.791593,39.306478],[-76.792565,39.306217],[-76.793069,39.306066],[-76.793712,39.305876],[-76.79448,39.305629],[-76.795244,39.305374],[-76.79774,39.30442],[-76.798156,39.304246],[-76.798499,39.30409],[-76.798844,39.303919],[-76.79921,39.303722],[-76.799576,39.303505],[-76.800102,39.303164],[-76.800674,39.302722],[-76.801004,39.302428],[-76.801305,39.302143],[-76.801537,39.301897],[-76.801804,39.301591],[-76.802304,39.300934],[-76.80246,39.300726],[-76.80262,39.300507],[-76.802798,39.300298],[-76.803019,39.300051],[-76.803213,39.299852],[-76.803467,39.299609],[-76.803676,39.299432],[-76.803954,39.299214],[-76.804338,39.29895],[-76.804769,39.298685],[-76.805254,39.298431],[-76.805696,39.298223],[-76.806208,39.29802],[-76.806653,39.297855],[-76.807164,39.297685],[-76.80769,39.29753],[-76.808225,39.297389],[-76.808791,39.297263],[-76.809372,39.297155],[-76.809956,39.297061],[-76.810508,39.296979],[-76.81117,39.296897],[-76.811812,39.296823],[-76.812305,39.296765],[-76.812934,39.296705],[-76.813553,39.296657],[-76.814382,39.296628],[-76.815166,39.296624],[-76.815732,39.296637],[-76.81633,39.296658],[-76.816997,39.296696],[-76.817675,39.296744],[-76.81809,39.296766],[-76.818537,39.296781],[-76.818958,39.296783],[-76.819453,39.29677],[-76.819801,39.296753],[-76.82111,39.296638],[-76.821574,39.29661],[-76.822159,39.296584],[-76.822689,39.296565],[-76.823204,39.296564],[-76.825387,39.296581],[-76.829512,39.296605],[-76.830267,39.296603],[-76.831007,39.296597],[-76.83195,39.296575],[-76.832948,39.296545],[-76.8339,39.296509],[-76.838461,39.296341],[-76.848495,39.295957],[-76.849082,39.295946],[-76.849566,39.29594],[-76.850172,39.295942],[-76.850899,39.295954],[-76.851486,39.295973],[-76.85211,39.296003],[-76.852693,39.296037],[-76.853328,39.296087],[-76.853794,39.296125],[-76.854304,39.296176],[-76.854834,39.296237],[-76.8554,39.296308],[-76.856219,39.296422],[-76.856776,39.296509],[-76.857385,39.296617],[-76.857948,39.29672],[-76.858522,39.296834],[-76.859064,39.296952],[-76.859635,39.297083],[-76.860189,39.297219],[-76.860765,39.29737],[-76.861341,39.297525],[-76.861829,39.297671],[-76.862306,39.297819],[-76.862872,39.298],[-76.863425,39.298186],[-76.864032,39.298399],[-76.86461,39.298612],[-76.865072,39.298794],[-76.865579,39.298999],[-76.866308,39.299305],[-76.871209,39.301424],[-76.875519,39.30328],[-76.876062,39.303502],[-76.876342,39.303611],[-76.876714,39.303753],[-76.877192,39.303929],[-76.877691,39.304099],[-76.878236,39.304277],[-76.878793,39.304447],[-76.879465,39.304638],[-76.880095,39.304802],[-76.880595,39.304925],[-76.881049,39.305027],[-76.881519,39.305129],[-76.882094,39.305241],[-76.882601,39.305332],[-76.883233,39.305436],[-76.883808,39.305517],[-76.884302,39.30558],[-76.884799,39.305638],[-76.8854,39.305696],[-76.885962,39.30574],[-76.886613,39.305782],[-76.887192,39.305806],[-76.887747,39.305821],[-76.888426,39.305829],[-76.889031,39.305821],[-76.889702,39.305805],[-76.89037,39.305778],[-76.890879,39.305748],[-76.891487,39.3057],[-76.892009,39.305648],[-76.892692,39.305568],[-76.893577,39.30545],[-76.894126,39.305366],[-76.894695,39.305267],[-76.89523,39.305172],[-76.895871,39.305042],[-76.896594,39.304892],[-76.897277,39.304736],[-76.898066,39.304546],[-76.89879,39.304356],[-76.899698,39.304107],[-76.900573,39.303848],[-76.901491,39.303556],[-76.902246,39.303299],[-76.903092,39.303012],[-76.903651,39.302833],[-76.904135,39.302707],[-76.904585,39.302601],[-76.905055,39.302513],[-76.905564,39.302433],[-76.906166,39.302356],[-76.906679,39.302318],[-76.907148,39.3023],[-76.907615,39.302296],[-76.908117,39.302309],[-76.908481,39.302331],[-76.908929,39.302367],[-76.909405,39.302426],[-76.909934,39.302507],[-76.910231,39.302565],[-76.910738,39.30267],[-76.911188,39.30278],[-76.911535,39.302879],[-76.911899,39.302992],[-76.912283,39.303127],[-76.912674,39.303275],[-76.913044,39.30343],[-76.913414,39.303595],[-76.913754,39.303757],[-76.914114,39.303925],[-76.914549,39.304121],[-76.915035,39.304322],[-76.915521,39.304501],[-76.915964,39.304648],[-76.916519,39.304816],[-76.917037,39.304951],[-76.917636,39.305091],[-76.918012,39.305162],[-76.918585,39.305261],[-76.919135,39.305332],[-76.91976,39.305404],[-76.925167,39.306014],[-76.928754,39.306406],[-76.94521,39.308204],[-76.951656,39.308905],[-76.952049,39.308947],[-76.952875,39.309036],[-76.955425,39.309317],[-76.956035,39.309388],[-76.956653,39.309465],[-76.957237,39.30956],[-76.957723,39.309649],[-76.958264,39.309756],[-76.95871,39.309853],[-76.959357,39.310016],[-76.959668,39.310102],[-76.960094,39.310226],[-76.960475,39.31034],[-76.961068,39.310535],[-76.961623,39.310737],[-76.962141,39.310933],[-76.963745,39.311602],[-76.974343,39.316017],[-76.975426,39.316449],[-76.97606,39.316684],[-76.976611,39.316889],[-76.977187,39.317086],[-76.977797,39.317285],[-76.983577,39.319061],[-76.988666,39.320612],[-76.989251,39.320786],[-76.989752,39.320924],[-76.990173,39.321036],[-76.990625,39.321144],[-76.991089,39.321241],[-76.991522,39.32133],[-76.991952,39.32141],[-76.992423,39.321484],[-76.993001,39.321567],[-76.993538,39.321634],[-76.99405,39.321685],[-77.002873,39.322413],[-77.003236,39.322446],[-77.003605,39.322494],[-77.003903,39.322534],[-77.004221,39.322584],[-77.004682,39.322667],[-77.005109,39.322758],[-77.005495,39.32285],[-77.005924,39.322968],[-77.006337,39.323088],[-77.006797,39.323242],[-77.007211,39.323388],[-77.00938,39.324204],[-77.015856,39.326647],[-77.016765,39.326986],[-77.021135,39.32863],[-77.022535,39.32916],[-77.028348,39.331352],[-77.039656,39.335614],[-77.040089,39.335766],[-77.040659,39.335959],[-77.041192,39.336125],[-77.041729,39.336279],[-77.042298,39.336422],[-77.042812,39.336543],[-77.043336,39.336655],[-77.043909,39.336766],[-77.044492,39.33686],[-77.045043,39.336937],[-77.051388,39.337779],[-77.052072,39.337877],[-77.052729,39.337979],[-77.053313,39.338076],[-77.053987,39.338201],[-77.054589,39.338316],[-77.055138,39.338428],[-77.055697,39.33855],[-77.056464,39.338731],[-77.057245,39.338926],[-77.058465,39.339231],[-77.064603,39.340769],[-77.066813,39.341325],[-77.067449,39.34149],[-77.068108,39.341669],[-77.068699,39.341844],[-77.069272,39.342017],[-77.069886,39.34221],[-77.07612,39.344292],[-77.076996,39.34458],[-77.077894,39.344866],[-77.078709,39.345117],[-77.079252,39.345269],[-77.079811,39.345419],[-77.080375,39.345568],[-77.081076,39.34574],[-77.081768,39.345897],[-77.082468,39.34605],[-77.08317,39.34619],[-77.084157,39.346369],[-77.08493,39.346498],[-77.085549,39.346591],[-77.101112,39.348733],[-77.101912,39.348849],[-77.102542,39.348953],[-77.103206,39.349065],[-77.103768,39.34917],[-77.104352,39.349284],[-77.104949,39.349412],[-77.105577,39.34955],[-77.106239,39.34971],[-77.118537,39.352694],[-77.120463,39.353151],[-77.120867,39.353238],[-77.121276,39.353315],[-77.121842,39.353414],[-77.122361,39.353492],[-77.122821,39.353554],[-77.123389,39.353616],[-77.123963,39.353665],[-77.130694,39.354112],[-77.131145,39.354147],[-77.131645,39.354202],[-77.132065,39.354255],[-77.132512,39.354328],[-77.132919,39.354405],[-77.133394,39.354509],[-77.133796,39.354604],[-77.134203,39.354713],[-77.134592,39.354829],[-77.135036,39.354976],[-77.135469,39.355132],[-77.135881,39.355295],[-77.136231,39.355445],[-77.136651,39.355643],[-77.137047,39.355842],[-77.137478,39.356079],[-77.137924,39.356341],[-77.139108,39.357083],[-77.143274,39.359684],[-77.143833,39.360021],[-77.144245,39.360256],[-77.144595,39.36043],[-77.144956,39.360593],[-77.145451,39.360787],[-77.145878,39.360934],[-77.1463,39.361057],[-77.146766,39.361179],[-77.147273,39.361283],[-77.147782,39.361361],[-77.148255,39.36142],[-77.148641,39.361452],[-77.149095,39.36147],[-77.149509,39.361474],[-77.149922,39.361464],[-77.150364,39.361433],[-77.150834,39.361385],[-77.158073,39.360478],[-77.158846,39.36038],[-77.165075,39.359596],[-77.165851,39.359498],[-77.166825,39.359375],[-77.167557,39.359284],[-77.168224,39.359208],[-77.168518,39.359175],[-77.168949,39.359137],[-77.169339,39.359117],[-77.169816,39.359109],[-77.170303,39.35912],[-77.170715,39.359144],[-77.171131,39.359179],[-77.171524,39.359228],[-77.172012,39.359299],[-77.172618,39.359428],[-77.172989,39.35952],[-77.173397,39.359636],[-77.173783,39.359761],[-77.174182,39.359907],[-77.174554,39.360056],[-77.174938,39.360222],[-77.175334,39.360423],[-77.175678,39.360608],[-77.176024,39.360816],[-77.176372,39.361042],[-77.176706,39.361274],[-77.177379,39.361777],[-77.178196,39.362375],[-77.17868,39.362711],[-77.179136,39.362999],[-77.179656,39.363297],[-77.1802,39.363587],[-77.180669,39.363822],[-77.181192,39.364058],[-77.181696,39.364272],[-77.182302,39.3645],[-77.182806,39.364675],[-77.183361,39.364854],[-77.183995,39.365028],[-77.184728,39.365207],[-77.185538,39.365375],[-77.193899,39.366966],[-77.194794,39.367134],[-77.195948,39.367357],[-77.196431,39.367443],[-77.198087,39.367763],[-77.198551,39.36786],[-77.19898,39.367968],[-77.199372,39.36809],[-77.199714,39.368214],[-77.199982,39.368326],[-77.200306,39.36848],[-77.200586,39.368622],[-77.200892,39.368807],[-77.201934,39.369464],[-77.202284,39.369675],[-77.202579,39.36983],[-77.202942,39.370003],[-77.20341,39.370201],[-77.203849,39.370356],[-77.204316,39.370508],[-77.204765,39.37062],[-77.205195,39.370713],[-77.205639,39.370789],[-77.206101,39.370853],[-77.206623,39.370903],[-77.207123,39.370939],[-77.207593,39.370958],[-77.208032,39.370959],[-77.208423,39.370947],[-77.208848,39.370922],[-77.209237,39.370893],[-77.209648,39.37085],[-77.210107,39.370786],[-77.210492,39.370727],[-77.210837,39.370656],[-77.211234,39.370565],[-77.211747,39.370434],[-77.212165,39.370313],[-77.213504,39.369889],[-77.213887,39.369787],[-77.214163,39.369724],[-77.214516,39.369654],[-77.214899,39.369597],[-77.215268,39.369554],[-77.215612,39.369529],[-77.215966,39.369515],[-77.216369,39.369514],[-77.216747,39.369525],[-77.217153,39.369561],[-77.217509,39.369603],[-77.217911,39.369667],[-77.218311,39.369748],[-77.218697,39.369848],[-77.219067,39.369962],[-77.219406,39.370075],[-77.219747,39.370206],[-77.220128,39.370374],[-77.220455,39.37054],[-77.220708,39.370681],[-77.221108,39.370936],[-77.222725,39.372042],[-77.223219,39.372367],[-77.223749,39.372694],[-77.224347,39.37304],[-77.224908,39.37334],[-77.225578,39.373674],[-77.226188,39.373948],[-77.22689,39.37424],[-77.227531,39.374484],[-77.22819,39.374712],[-77.228786,39.374902],[-77.229437,39.375089],[-77.230075,39.375253],[-77.23065,39.375385],[-77.231419,39.375559],[-77.231933,39.375667],[-77.251482,39.380015],[-77.252968,39.380341],[-77.258854,39.381643],[-77.259391,39.381757],[-77.259811,39.381835],[-77.260508,39.381936],[-77.261048,39.381993],[-77.261615,39.382038],[-77.262118,39.38206],[-77.262689,39.382071],[-77.263325,39.382061],[-77.263849,39.382032],[-77.264372,39.381992],[-77.26496,39.381926],[-77.26547,39.381851],[-77.267598,39.381503],[-77.26951,39.381186],[-77.272108,39.380757],[-77.272586,39.380694],[-77.27299,39.380647],[-77.273388,39.380624],[-77.273745,39.380615],[-77.274161,39.380624],[-77.274485,39.380641],[-77.274861,39.380669],[-77.27525,39.380719],[-77.275617,39.380781],[-77.276091,39.380878],[-77.27649,39.38098],[-77.276789,39.381069],[-77.277169,39.381195],[-77.277535,39.381339],[-77.277913,39.381503],[-77.279503,39.382223],[-77.279941,39.382411],[-77.280447,39.382599],[-77.280951,39.382772],[-77.281576,39.382959],[-77.282063,39.383087],[-77.28263,39.383217],[-77.283098,39.38331],[-77.30862,39.388021],[-77.309472,39.388188],[-77.310196,39.388333],[-77.31095,39.388498],[-77.31174,39.388674],[-77.312547,39.388864],[-77.313388,39.389071],[-77.314223,39.389282],[-77.31486,39.389457],[-77.315441,39.389617],[-77.319957,39.390869],[-77.321499,39.391291],[-77.321973,39.39144],[-77.322376,39.391577],[-77.322804,39.391736],[-77.323172,39.391885],[-77.323632,39.39208],[-77.324098,39.392301],[-77.324694,39.392618],[-77.325209,39.392942],[-77.325616,39.393191],[-77.32586,39.39336],[-77.326315,39.393696],[-77.326742,39.394042],[-77.32705,39.394315],[-77.331422,39.398244],[-77.331908,39.398658],[-77.332311,39.398983],[-77.332738,39.399293],[-77.333147,39.399569],[-77.333597,39.399858],[-77.334044,39.400115],[-77.33446,39.400335],[-77.334893,39.400553],[-77.335507,39.400828],[-77.336007,39.401034],[-77.336462,39.401204],[-77.336947,39.40137],[-77.337481,39.401535],[-77.338126,39.40171],[-77.347325,39.404075],[-77.347627,39.40415],[-77.34952,39.404629],[-77.350062,39.404744],[-77.350596,39.404837],[-77.35103,39.404902],[-77.351547,39.40497],[-77.352015,39.405016],[-77.35253,39.405048],[-77.35311,39.405069],[-77.35364,39.405068],[-77.354142,39.405054],[-77.354631,39.405033],[-77.360135,39.404628],[-77.360897,39.404575],[-77.361602,39.404533],[-77.362539,39.404498],[-77.36472,39.404416],[-77.366773,39.404339],[-77.377885,39.403932],[-77.378865,39.403885],[-77.379342,39.403869],[-77.37978,39.403869],[-77.3803,39.403893],[-77.380732,39.403922],[-77.381292,39.403985],[-77.381832,39.404068],[-77.384455,39.404542],[-77.384962,39.404615],[-77.385453,39.404676],[-77.385864,39.404713],[-77.386265,39.404739],[-77.386677,39.404755],[-77.38814,39.404765],[-77.389014,39.40477],[-77.389395,39.404749],[-77.389933,39.404715],[-77.390478,39.40466],[-77.390951,39.404599],[-77.391498,39.404512],[-77.391934,39.404432],[-77.392587,39.404291],[-77.393274,39.404135],[-77.394161,39.403911],[-77.399007,39.402672],[-77.401468,39.402052],[-77.402133,39.401902],[-77.40343,39.40157],[-77.403967,39.401438],[-77.408441,39.400292],[-77.416164,39.398344],[-77.416532,39.398258],[-77.416956,39.398169],[-77.417345,39.398107],[-77.417851,39.398046],[-77.418299,39.398012],[-77.419047,39.398009],[-77.419559,39.398017],[-77.420245,39.398069],[-77.420729,39.398135],[-77.421186,39.398219],[-77.424832,39.398899],[-77.425198,39.398962],[-77.425546,39.399015],[-77.425972,39.399061],[-77.426391,39.399088],[-77.426799,39.399094],[-77.427286,39.399073],[-77.427693,39.399044],[-77.427978,39.399026],[-77.430848,39.398776],[-77.432934,39.398594],[-77.433731,39.398521],[-77.434298,39.398493],[-77.434912,39.39849],[-77.435336,39.398495],[-77.435957,39.398526],[-77.436452,39.398566],[-77.436942,39.398618],[-77.437352,39.398676],[-77.437785,39.398743],[-77.438271,39.398837],[-77.438781,39.398953],[-77.439294,39.399087],[-77.439758,39.39922],[-77.44019,39.399361],[-77.44081,39.399591],[-77.441419,39.399832],[-77.441856,39.400029],[-77.442111,39.400148],[-77.443964,39.400993],[-77.44456,39.401246],[-77.445038,39.401465],[-77.445433,39.401608],[-77.446202,39.40187],[-77.446847,39.402072],[-77.447644,39.402289],[-77.44834,39.402457],[-77.44884,39.402557],[-77.44954,39.402693],[-77.450203,39.402805],[-77.450798,39.402888],[-77.451401,39.402963],[-77.454877,39.403339],[-77.457107,39.403585],[-77.460403,39.403945],[-77.461077,39.404026],[-77.461652,39.40411],[-77.462269,39.404219],[-77.462774,39.404323],[-77.463332,39.404456],[-77.463951,39.404618],[-77.464512,39.404791],[-77.465088,39.404987],[-77.465585,39.405173],[-77.466114,39.405385],[-77.466593,39.405602],[-77.467096,39.405843],[-77.467533,39.406071],[-77.468007,39.406339],[-77.468471,39.406613],[-77.468919,39.406907],[-77.469389,39.407236],[-77.469768,39.407517],[-77.470201,39.407872],[-77.470655,39.408279],[-77.471035,39.40864],[-77.471374,39.408993],[-77.471716,39.409367],[-77.472045,39.409762],[-77.472405,39.410252],[-77.47278,39.410805],[-77.473792,39.412398],[-77.474122,39.4129],[-77.47448,39.413409],[-77.474988,39.41408],[-77.475485,39.414654],[-77.475926,39.415116],[-77.476389,39.415568],[-77.476859,39.416],[-77.477343,39.41641],[-77.477844,39.41681],[-77.478475,39.41727],[-77.479014,39.417643],[-77.479503,39.417955],[-77.480001,39.418252],[-77.480588,39.418591],[-77.481379,39.419054],[-77.482505,39.419714],[-77.482948,39.419988],[-77.483393,39.420284],[-77.483883,39.420639],[-77.484276,39.420942],[-77.48463,39.42123],[-77.484946,39.421505],[-77.485489,39.422011],[-77.48602,39.422551],[-77.48644,39.42304],[-77.486867,39.423571],[-77.487182,39.424016],[-77.487518,39.424514],[-77.487704,39.424829],[-77.487876,39.42514],[-77.488051,39.425489],[-77.488379,39.426272],[-77.488526,39.426746],[-77.488651,39.427191],[-77.488757,39.427731],[-77.488825,39.428253],[-77.48886,39.428716],[-77.488871,39.429134],[-77.488871,39.429526],[-77.488872,39.430094],[-77.488868,39.430682],[-77.488865,39.432719],[-77.488869,39.434231],[-77.488888,39.434754],[-77.488931,39.435222],[-77.488994,39.43566],[-77.489094,39.436137],[-77.489212,39.43658],[-77.489373,39.437061],[-77.489539,39.437479],[-77.489778,39.437969],[-77.489969,39.438298],[-77.490259,39.438721],[-77.490592,39.439117],[-77.490921,39.43946],[-77.491229,39.439735],[-77.4916,39.440032],[-77.491973,39.440299],[-77.492427,39.440575],[-77.492867,39.440811],[-77.4933,39.441021],[-77.493817,39.441262],[-77.497673,39.443018],[-77.499593,39.44389],[-77.500111,39.444149],[-77.500482,39.444349],[-77.500843,39.44457],[-77.501341,39.444937],[-77.501707,39.445254],[-77.502023,39.44558],[-77.50231,39.445935],[-77.50252,39.446241],[-77.502725,39.4466],[-77.502874,39.446915],[-77.503022,39.447332],[-77.503136,39.447733],[-77.503245,39.44817],[-77.504374,39.452666],[-77.504486,39.453081],[-77.504593,39.453428],[-77.50473,39.453766],[-77.504911,39.454143],[-77.505139,39.454535],[-77.505403,39.454911],[-77.505656,39.455226],[-77.505891,39.455486],[-77.506214,39.455801],[-77.506517,39.456073],[-77.509048,39.458222],[-77.509406,39.45853],[-77.511884,39.460629],[-77.51237,39.461031],[-77.51278,39.461355],[-77.513323,39.461772],[-77.513798,39.462122],[-77.514449,39.462589],[-77.519043,39.465761],[-77.531247,39.474183],[-77.532072,39.47477],[-77.532741,39.475273],[-77.533386,39.475784],[-77.534046,39.476332],[-77.534578,39.476793],[-77.535116,39.477278],[-77.538398,39.480254],[-77.53916,39.480943],[-77.54078,39.482413],[-77.541165,39.482742],[-77.541568,39.483053],[-77.541997,39.483354],[-77.542365,39.483585],[-77.542779,39.483816],[-77.543242,39.484074],[-77.54373,39.484292],[-77.544181,39.484475],[-77.544615,39.484625],[-77.545074,39.484768],[-77.545471,39.484881],[-77.545968,39.484996],[-77.546608,39.485104],[-77.547611,39.485261],[-77.550182,39.485655],[-77.552256,39.485973],[-77.552787,39.486063],[-77.553224,39.486149],[-77.553704,39.486264],[-77.554122,39.486382],[-77.554561,39.486521],[-77.55499,39.486681],[-77.555403,39.486853],[-77.555771,39.487024],[-77.556225,39.487258],[-77.556628,39.487495],[-77.557025,39.487747],[-77.557481,39.488081],[-77.559716,39.489871],[-77.560167,39.490232],[-77.562394,39.492022],[-77.563036,39.492539],[-77.564636,39.493822],[-77.565532,39.494544],[-77.566191,39.495062],[-77.566957,39.49565],[-77.567567,39.49609],[-77.568441,39.496696],[-77.570768,39.498262],[-77.571839,39.499002],[-77.574934,39.501074],[-77.580943,39.505115],[-77.581368,39.505395],[-77.581729,39.505613],[-77.582129,39.505832],[-77.582527,39.506031],[-77.582953,39.506221],[-77.583448,39.506414],[-77.583942,39.506581],[-77.584555,39.506763],[-77.585122,39.506898],[-77.589345,39.507911],[-77.589688,39.508002],[-77.590024,39.508109],[-77.590346,39.508236],[-77.590639,39.508374],[-77.590938,39.50853],[-77.591224,39.508707],[-77.591468,39.508885],[-77.591681,39.509051],[-77.59187,39.50923],[-77.592068,39.509434],[-77.592229,39.509628],[-77.592376,39.509833],[-77.592493,39.510011],[-77.592627,39.510243],[-77.593902,39.51267],[-77.594688,39.514175],[-77.595033,39.514816],[-77.595234,39.515169],[-77.595415,39.515478],[-77.595634,39.515821],[-77.595945,39.516289],[-77.596275,39.516743],[-77.596555,39.517099],[-77.596909,39.517528],[-77.600138,39.521192],[-77.600855,39.522018],[-77.601104,39.522338],[-77.601331,39.52265],[-77.60153,39.522984],[-77.601724,39.523335],[-77.601922,39.523751],[-77.602092,39.524175],[-77.602217,39.524573],[-77.602312,39.524956],[-77.60287,39.528408],[-77.602953,39.528827],[-77.603073,39.529265],[-77.603215,39.529676],[-77.603471,39.530251],[-77.603715,39.530691],[-77.604039,39.531193],[-77.604282,39.53152],[-77.605118,39.532607],[-77.605327,39.532881],[-77.605542,39.533202],[-77.605695,39.533482],[-77.605839,39.533795],[-77.605944,39.534058],[-77.606015,39.534266],[-77.60609,39.534538],[-77.606137,39.534785],[-77.606175,39.535087],[-77.606189,39.535394],[-77.606184,39.535706],[-77.606168,39.535938],[-77.605705,39.53888],[-77.605658,39.539292],[-77.605642,39.539625],[-77.605645,39.540045],[-77.60568,39.540463],[-77.605736,39.540827],[-77.605827,39.541263],[-77.605947,39.541682],[-77.606058,39.541994],[-77.606159,39.542248],[-77.606464,39.542879],[-77.607351,39.544599],[-77.60758,39.545075],[-77.607772,39.545546],[-77.607965,39.546063],[-77.608131,39.546563],[-77.608277,39.547075],[-77.608394,39.547562],[-77.608492,39.548056],[-77.608585,39.54866],[-77.608705,39.549567],[-77.608841,39.550587],[-77.6089,39.551044],[-77.608961,39.551477],[-77.609044,39.55198],[-77.609141,39.55245],[-77.609266,39.552866],[-77.609456,39.55337],[-77.609675,39.553837],[-77.609998,39.554393],[-77.616196,39.564213],[-77.616412,39.564543],[-77.617576,39.566382],[-77.618001,39.567014],[-77.618452,39.567649],[-77.618896,39.568238],[-77.61939,39.568864],[-77.619932,39.569512],[-77.620502,39.57016],[-77.621062,39.570768],[-77.621664,39.571393],[-77.623118,39.572882],[-77.624347,39.574133],[-77.625804,39.575619],[-77.62651,39.576338],[-77.628591,39.57847],[-77.628936,39.578814],[-77.629843,39.579748],[-77.630599,39.580509],[-77.631071,39.580966],[-77.631568,39.581405],[-77.632027,39.581789],[-77.632537,39.58218],[-77.633135,39.582608],[-77.633671,39.582963],[-77.634146,39.583268],[-77.634775,39.583629],[-77.635453,39.583994],[-77.635982,39.584255],[-77.636523,39.584508],[-77.639477,39.585861],[-77.639916,39.586059],[-77.640706,39.586421],[-77.641309,39.586698],[-77.642248,39.58713],[-77.642653,39.58733],[-77.64328,39.587646],[-77.643796,39.58792],[-77.644461,39.588273],[-77.644955,39.588552],[-77.645502,39.588875],[-77.646048,39.589204],[-77.655435,39.595066],[-77.655828,39.595311],[-77.659276,39.597453],[-77.659761,39.597731],[-77.66032,39.598037],[-77.660833,39.598295],[-77.661385,39.598553],[-77.661958,39.598809],[-77.662473,39.599018],[-77.663027,39.599232],[-77.663662,39.599455],[-77.664273,39.599646],[-77.664967,39.599847],[-77.665521,39.59999],[-77.666166,39.600143],[-77.666943,39.600302],[-77.667687,39.600433],[-77.668258,39.600515],[-77.668957,39.600599],[-77.669606,39.600663],[-77.67024,39.600708],[-77.670951,39.60074],[-77.671527,39.600752],[-77.672166,39.600749],[-77.672756,39.600734],[-77.673295,39.600711],[-77.676349,39.600533],[-77.682835,39.600158],[-77.683239,39.600131],[-77.689097,39.599789],[-77.696093,39.59938],[-77.696784,39.599351],[-77.697383,39.599339],[-77.697931,39.599343],[-77.698585,39.599363],[-77.699153,39.599387],[-77.699735,39.599436],[-77.700241,39.599481],[-77.700705,39.599535],[-77.701224,39.599606],[-77.701709,39.599679],[-77.702201,39.599766],[-77.70283,39.59989],[-77.703116,39.599956],[-77.70357,39.60006],[-77.703978,39.600163],[-77.704466,39.600295],[-77.704904,39.600425],[-77.705368,39.600569],[-77.705845,39.600732],[-77.706794,39.601064],[-77.711718,39.602807],[-77.712473,39.60307],[-77.71431,39.603711],[-77.714847,39.603894],[-77.7154,39.604067],[-77.715938,39.604226],[-77.716467,39.60438],[-77.717128,39.604553],[-77.717751,39.604703],[-77.718391,39.604843],[-77.718914,39.604954],[-77.719477,39.60506],[-77.719999,39.60515],[-77.720562,39.605242],[-77.721152,39.605326],[-77.721808,39.605407],[-77.722391,39.605477],[-77.722952,39.605526],[-77.723619,39.605576],[-77.72428,39.605615],[-77.724955,39.605644],[-77.725625,39.605663],[-77.726043,39.605664],[-77.726807,39.605656],[-77.728765,39.605597],[-77.729419,39.605574],[-77.733159,39.605457],[-77.735097,39.605383],[-77.736039,39.605358],[-77.736869,39.605353],[-77.737624,39.605362],[-77.738394,39.605379],[-77.739078,39.605403],[-77.739861,39.605447],[-77.740624,39.605498],[-77.741304,39.605553],[-77.742047,39.605619],[-77.742767,39.605698],[-77.744312,39.605877],[-77.744719,39.605923],[-77.746206,39.606094],[-77.750204,39.606542],[-77.75076,39.606597],[-77.751448,39.60665],[-77.75206,39.606675],[-77.752839,39.606698],[-77.753854,39.606689],[-77.754475,39.606676],[-77.755482,39.606655],[-77.769497,39.606375],[-77.770228,39.60637],[-77.770819,39.606386],[-77.771476,39.60643],[-77.772079,39.606491],[-77.772694,39.606574],[-77.773176,39.606657],[-77.773696,39.606762],[-77.77436,39.606919],[-77.774819,39.607051],[-77.775394,39.607232],[-77.775867,39.607403],[-77.776357,39.607595],[-77.77685,39.607808],[-77.77734,39.608047],[-77.777815,39.608295],[-77.778478,39.608691],[-77.778796,39.608893],[-77.779173,39.609153],[-77.779538,39.609425],[-77.779929,39.609745],[-77.78033,39.610104],[-77.780695,39.610461],[-77.781044,39.610837],[-77.781305,39.611137],[-77.782003,39.612093],[-77.782297,39.612512],[-77.782544,39.612864],[-77.785237,39.616675],[-77.785702,39.61733],[-77.786757,39.618823],[-77.787111,39.619297],[-77.787521,39.619784],[-77.787751,39.620039],[-77.788033,39.620324],[-77.788328,39.620614],[-77.788745,39.620971],[-77.789286,39.621406],[-77.789805,39.621782],[-77.790056,39.621941],[-77.790391,39.622149],[-77.790826,39.6224],[-77.79115,39.622572],[-77.791445,39.622728],[-77.791906,39.622941],[-77.792488,39.623185],[-77.80548,39.628529],[-77.807122,39.629204],[-77.807862,39.629516],[-77.80859,39.629829],[-77.809228,39.630136],[-77.809817,39.630433],[-77.810281,39.630667],[-77.81076,39.630934],[-77.811299,39.631253],[-77.811848,39.631594],[-77.812363,39.631925],[-77.812836,39.632257],[-77.813318,39.632605],[-77.813999,39.633133],[-77.814493,39.633528],[-77.815246,39.634122],[-77.815844,39.634566],[-77.816499,39.635015],[-77.817142,39.635412],[-77.817782,39.635776],[-77.818286,39.636051],[-77.81887,39.636341],[-77.819507,39.636631],[-77.82007,39.636872],[-77.820733,39.637136],[-77.822806,39.637947],[-77.823333,39.638165],[-77.82392,39.638423],[-77.824442,39.638675],[-77.824918,39.638913],[-77.825441,39.6392],[-77.825945,39.639489],[-77.826432,39.639793],[-77.827121,39.64025],[-77.828823,39.641458],[-77.829762,39.642134],[-77.830645,39.642751],[-77.831,39.643007],[-77.83139,39.643285],[-77.831715,39.643516],[-77.832245,39.643899],[-77.832714,39.644217],[-77.833277,39.6446],[-77.833674,39.644847],[-77.834237,39.645171],[-77.834828,39.645493],[-77.835531,39.645842],[-77.836029,39.646075],[-77.836587,39.646316],[-77.837413,39.64664],[-77.83827,39.646957],[-77.83912,39.647263],[-77.839842,39.647523],[-77.840637,39.647809],[-77.841819,39.648236],[-77.842508,39.648486],[-77.84494,39.649366],[-77.845703,39.649639],[-77.84635,39.649869],[-77.847042,39.650091],[-77.847841,39.65032],[-77.848516,39.650487],[-77.849239,39.650649],[-77.84998,39.650791],[-77.850606,39.65089],[-77.851294,39.650986],[-77.852076,39.651068],[-77.852899,39.651134],[-77.85362,39.651165],[-77.854292,39.651181],[-77.863236,39.651336],[-77.864235,39.651349],[-77.86517,39.651351],[-77.865893,39.651355],[-77.873809,39.651223],[-77.874674,39.651213],[-77.87559,39.651222],[-77.876301,39.651241],[-77.877051,39.65127],[-77.878188,39.651331],[-77.887718,39.651912],[-77.888127,39.651934],[-77.907845,39.653134],[-77.9082,39.653156],[-77.911811,39.653372],[-77.912655,39.653416],[-77.913298,39.653437],[-77.914004,39.653444],[-77.914523,39.653433],[-77.915094,39.653413],[-77.915645,39.653379],[-77.916351,39.653324],[-77.917047,39.653247],[-77.917665,39.653166],[-77.918569,39.653011],[-77.919269,39.652877],[-77.920031,39.6527],[-77.920575,39.652564],[-77.921238,39.652372],[-77.921814,39.652191],[-77.922512,39.651968],[-77.923053,39.651791],[-77.923804,39.651553],[-77.928355,39.650089],[-77.929445,39.649743],[-77.937953,39.647011],[-77.938739,39.646754],[-77.939337,39.646543],[-77.93999,39.646295],[-77.940631,39.646025],[-77.941361,39.645694],[-77.941947,39.645399],[-77.942576,39.645056],[-77.943183,39.644708],[-77.943753,39.644346],[-77.949593,39.640529],[-77.950218,39.640134],[-77.950974,39.63968],[-77.951728,39.639249],[-77.952347,39.638909],[-77.960187,39.63476],[-77.961004,39.634328],[-77.96166,39.633948],[-77.962208,39.633613],[-77.962819,39.63322],[-77.963444,39.632788],[-77.964133,39.632285],[-77.966363,39.630604],[-77.966889,39.630238],[-77.967335,39.629964],[-77.967806,39.629712],[-77.968259,39.629491],[-77.968626,39.62934],[-77.969092,39.629163],[-77.969575,39.629016],[-77.97016,39.628861],[-77.97061,39.628762],[-77.971062,39.628678],[-77.971575,39.628607],[-77.972072,39.628555],[-77.972693,39.628512],[-77.984426,39.627848],[-77.985137,39.627808],[-77.985841,39.627755],[-77.986544,39.627687],[-77.987253,39.627597],[-77.98795,39.62749],[-77.988625,39.627361],[-77.989321,39.627215],[-77.990001,39.627049],[-77.990923,39.626806],[-77.995917,39.625474],[-77.996728,39.625262],[-78.000622,39.624228],[-78.0013,39.624071],[-78.0019,39.623961],[-78.002429,39.623873],[-78.002969,39.623802],[-78.003518,39.623758],[-78.004059,39.623725],[-78.004621,39.62371],[-78.00526,39.623713],[-78.005818,39.623732],[-78.006398,39.623774],[-78.006891,39.623828],[-78.007345,39.623889],[-78.007841,39.62397],[-78.008309,39.624057],[-78.008774,39.624157],[-78.009219,39.624267],[-78.00974,39.624412],[-78.010221,39.624567],[-78.010628,39.624708],[-78.011069,39.624877],[-78.011536,39.625074],[-78.012005,39.625285],[-78.012496,39.625547],[-78.012957,39.625792],[-78.013409,39.626065],[-78.013721,39.626265],[-78.014226,39.626616],[-78.020176,39.631007],[-78.020725,39.631425],[-78.021189,39.6318],[-78.021578,39.632143],[-78.021973,39.632501],[-78.022373,39.632888],[-78.026543,39.637435],[-78.026939,39.637835],[-78.027323,39.638205],[-78.027764,39.638595],[-78.028246,39.639],[-78.028747,39.639387],[-78.029327,39.63981],[-78.029791,39.640125],[-78.03024,39.640405],[-78.037502,39.644655],[-78.038037,39.644972],[-78.038464,39.645238],[-78.03895,39.645559],[-78.039518,39.645964],[-78.040023,39.646345],[-78.040404,39.646659],[-78.04582,39.651529],[-78.046685,39.652316],[-78.048559,39.654003],[-78.048978,39.654352],[-78.04932,39.654613],[-78.049943,39.655039],[-78.050437,39.655323],[-78.050873,39.655553],[-78.05139,39.65581],[-78.054842,39.657563],[-78.055565,39.657949],[-78.056149,39.658286],[-78.056736,39.658642],[-78.05726,39.658969],[-78.057745,39.65929],[-78.058258,39.65965],[-78.059389,39.660509],[-78.068355,39.667452],[-78.068877,39.667822],[-78.069317,39.668111],[-78.069749,39.668374],[-78.070214,39.668644],[-78.07078,39.668943],[-78.073972,39.670623],[-78.074451,39.670855],[-78.074916,39.671072],[-78.075356,39.671256],[-78.07588,39.671454],[-78.076453,39.671648],[-78.076906,39.671785],[-78.079322,39.672467],[-78.079888,39.672631],[-78.080364,39.67278],[-78.080763,39.672919],[-78.081168,39.673068],[-78.081588,39.673237],[-78.081989,39.673415],[-78.08243,39.673629],[-78.0828,39.673826],[-78.083255,39.674077],[-78.090718,39.678335],[-78.091365,39.678709],[-78.091931,39.679045],[-78.092706,39.679524],[-78.09373,39.680184],[-78.097972,39.683006],[-78.098454,39.683299],[-78.098836,39.683524],[-78.0993,39.683775],[-78.099857,39.684054],[-78.10046,39.684335],[-78.100999,39.68457],[-78.101609,39.684806],[-78.102374,39.685078],[-78.102741,39.685196],[-78.103183,39.685324],[-78.103698,39.685464],[-78.104286,39.685606],[-78.104898,39.68574],[-78.105481,39.685851],[-78.122574,39.68868],[-78.123506,39.688837],[-78.124033,39.688934],[-78.12449,39.689041],[-78.125057,39.689187],[-78.125489,39.689308],[-78.125999,39.689474],[-78.126526,39.689655],[-78.12831,39.690294],[-78.128778,39.69046],[-78.130776,39.69117],[-78.13134,39.691359],[-78.131947,39.691531],[-78.132471,39.69166],[-78.133026,39.691778],[-78.133602,39.691882],[-78.13472,39.692054],[-78.138384,39.692602],[-78.139461,39.69278],[-78.140251,39.692924],[-78.140835,39.69304],[-78.141411,39.693166],[-78.142041,39.693322],[-78.142677,39.693494],[-78.143244,39.693654],[-78.144129,39.693926],[-78.144584,39.694082],[-78.145459,39.694392],[-78.150579,39.696279],[-78.150921,39.696416],[-78.151299,39.69658],[-78.151682,39.696774],[-78.151945,39.696931],[-78.152303,39.697165],[-78.152543,39.697349],[-78.152876,39.697652],[-78.153192,39.697958],[-78.153371,39.698144],[-78.154364,39.699264],[-78.154739,39.699688],[-78.155026,39.699993],[-78.155314,39.700275],[-78.155667,39.700575],[-78.156103,39.700879],[-78.156491,39.701117],[-78.15689,39.701324],[-78.157344,39.701528],[-78.157782,39.701687],[-78.158277,39.701842],[-78.158706,39.701946],[-78.159206,39.702038],[-78.159659,39.702108],[-78.160167,39.702183],[-78.167461,39.703222],[-78.168085,39.703319],[-78.168795,39.703437],[-78.169401,39.703549],[-78.170046,39.703672],[-78.17054,39.703779],[-78.171046,39.703903],[-78.171543,39.704027],[-78.172114,39.704184],[-78.17509,39.705005],[-78.178608,39.705972],[-78.17906,39.706113],[-78.17955,39.706277],[-78.179992,39.706446],[-78.180357,39.706598],[-78.18128,39.707032],[-78.181738,39.707282],[-78.182175,39.707533],[-78.182647,39.707837],[-78.183061,39.708126],[-78.183462,39.708431],[-78.183825,39.708728],[-78.184187,39.709051],[-78.184495,39.709344],[-78.18477,39.709634],[-78.185339,39.710278],[-78.185475,39.710462],[-78.18571,39.71078],[-78.185943,39.711141],[-78.186232,39.711611],[-78.186472,39.71207],[-78.186762,39.712734],[-78.186913,39.713161],[-78.187032,39.713535],[-78.187126,39.713933],[-78.187208,39.714321],[-78.187264,39.714726],[-78.187305,39.715041],[-78.187332,39.715398],[-78.187328,39.71606],[-78.187305,39.716418],[-78.187228,39.717069],[-78.18718,39.717311],[-78.187121,39.717581],[-78.187041,39.717894],[-78.186951,39.718202],[-78.186814,39.718606],[-78.186661,39.719001],[-78.186424,39.719511],[-78.186173,39.719985],[-78.185906,39.720415],[-78.184672,39.722309],[-78.18413,39.723121],[-78.183752,39.723704],[-78.183543,39.72406],[-78.183341,39.724454],[-78.183152,39.724851],[-78.182981,39.725323],[-78.182854,39.725724],[-78.182768,39.726073],[-78.182702,39.726402],[-78.182638,39.726845],[-78.182535,39.727788],[-78.182103,39.731698],[-78.181937,39.733192],[-78.181407,39.737988],[-78.181274,39.739205],[-78.181214,39.739976],[-78.181179,39.740641],[-78.181162,39.7411],[-78.181159,39.741821],[-78.181203,39.743033],[-78.181363,39.746101],[-78.181389,39.746599],[-78.181429,39.747089],[-78.181505,39.747608],[-78.181585,39.748044],[-78.181704,39.748535],[-78.18183,39.748981],[-78.181972,39.74939],[-78.182149,39.749849],[-78.182337,39.750278],[-78.182539,39.750689],[-78.182759,39.751089],[-78.182989,39.751484],[-78.183242,39.751873],[-78.183521,39.75226],[-78.183845,39.752686],[-78.184198,39.753103],[-78.184607,39.75354],[-78.184951,39.75389],[-78.185325,39.754242],[-78.185696,39.754564],[-78.186431,39.755136],[-78.188886,39.756922],[-78.189984,39.757722],[-78.191639,39.758919],[-78.192657,39.759661],[-78.192803,39.759804],[-78.193047,39.75994],[-78.193853,39.760521],[-78.194046,39.760693],[-78.194253,39.760843],[-78.19467,39.761103],[-78.196498,39.762434],[-78.196703,39.762586],[-78.198345,39.763805],[-78.198507,39.763975],[-78.198804,39.764234],[-78.199107,39.764553],[-78.199596,39.765179],[-78.199945,39.765768],[-78.200184,39.766409],[-78.200346,39.767002],[-78.200454,39.767689],[-78.200456,39.768016],[-78.200421,39.768513],[-78.199826,39.773071],[-78.199857,39.774628],[-78.199951,39.774976],[-78.200067,39.775299],[-78.200074,39.775316],[-78.200232,39.775658],[-78.200416,39.775988],[-78.200628,39.776356],[-78.200855,39.776637],[-78.200871,39.77666],[-78.201062,39.776944],[-78.20335,39.78011],[-78.20361,39.780453],[-78.204224,39.7811],[-78.204806,39.781491],[-78.207266,39.782688],[-78.207442,39.782795],[-78.208059,39.783065],[-78.208523,39.783353],[-78.20885,39.783593],[-78.209162,39.783855],[-78.20945,39.78414],[-78.20971,39.784449],[-78.209937,39.78478],[-78.21013,39.785126],[-78.210294,39.785476],[-78.210622,39.786649],[-78.210665,39.78682],[-78.211007,39.788117],[-78.211249,39.78901],[-78.211604,39.790316],[-78.211884,39.790963],[-78.212111,39.791361],[-78.212241,39.791553],[-78.212679,39.792092],[-78.212998,39.792412],[-78.213166,39.79256],[-78.213516,39.792839],[-78.213889,39.793096],[-78.214496,39.793444],[-78.215158,39.793744],[-78.215859,39.793982],[-78.216339,39.794107],[-78.216582,39.794158],[-78.217075,39.794241],[-78.217829,39.794332],[-78.222658,39.794848],[-78.224254,39.795019],[-78.225739,39.795194],[-78.226525,39.795269],[-78.22672,39.795288],[-78.228007,39.795485],[-78.230612,39.796036],[-78.231268,39.796175],[-78.240388,39.798143],[-78.24151,39.798369],[-78.241531,39.798372],[-78.24245,39.798528],[-78.243463,39.798661],[-78.243924,39.798715],[-78.244354,39.798749],[-78.244629,39.798776],[-78.245657,39.798877],[-78.246008,39.798913],[-78.246968,39.799009],[-78.247813,39.799111],[-78.24791,39.799128],[-78.248627,39.799255],[-78.249167,39.799374],[-78.249617,39.799485],[-78.251926,39.800051],[-78.25289,39.800318],[-78.253394,39.800497],[-78.254288,39.80081],[-78.254897,39.801023],[-78.255354,39.801157],[-78.255581,39.801201],[-78.256049,39.80133],[-78.257485,39.801795],[-78.26478,39.804393],[-78.265018,39.804464],[-78.266701,39.805074],[-78.267631,39.805411],[-78.268242,39.805618],[-78.269295,39.806012],[-78.269472,39.806063],[-78.269517,39.806076],[-78.269876,39.806256],[-78.270357,39.806538],[-78.270733,39.806801],[-78.271099,39.807092],[-78.271436,39.807404],[-78.271874,39.807912],[-78.272124,39.808275],[-78.272337,39.808654],[-78.272506,39.809049],[-78.272575,39.809252],[-78.272681,39.809663],[-78.272743,39.810081],[-78.272759,39.810505],[-78.272727,39.810931],[-78.272652,39.811356],[-78.272525,39.81178],[-78.272044,39.813048],[-78.271826,39.813692],[-78.271593,39.814562],[-78.271448,39.815263],[-78.271336,39.816061],[-78.271274,39.816889],[-78.271263,39.817534],[-78.271305,39.818407],[-78.271348,39.818841],[-78.271445,39.819488],[-78.271526,39.819917],[-78.271677,39.82056],[-78.272039,39.821869],[-78.272744,39.824414],[-78.27338,39.82671],[-78.274606,39.831169],[-78.275584,39.834693],[-78.275733,39.83536],[-78.275853,39.836063],[-78.275952,39.836986],[-78.275987,39.838142],[-78.275958,39.838928],[-78.275855,39.839918],[-78.27576,39.84051],[-78.275637,39.841098],[-78.275603,39.841214],[-78.275104,39.842884],[-78.274906,39.843411],[-78.274665,39.843964],[-78.274003,39.845288],[-78.273463,39.846453],[-78.273353,39.846634],[-78.272287,39.848843],[-78.271705,39.849954],[-78.27107,39.851045],[-78.269805,39.853051],[-78.269488,39.853614],[-78.267972,39.856112],[-78.265146,39.860689],[-78.264421,39.861768],[-78.264119,39.862147],[-78.264028,39.862314],[-78.262967,39.863574],[-78.262491,39.864093],[-78.261837,39.864774],[-78.260501,39.866112],[-78.259807,39.866759],[-78.259243,39.867217],[-78.258439,39.867791],[-78.257795,39.868185],[-78.256885,39.86867],[-78.256671,39.868804],[-78.256426,39.868915],[-78.255524,39.869381],[-78.254108,39.870194],[-78.254003,39.870304],[-78.252868,39.871301],[-78.252643,39.871515],[-78.252391,39.87185],[-78.248873,39.876036],[-78.247583,39.877597],[-78.247329,39.877932],[-78.246467,39.878867],[-78.245863,39.879486],[-78.244379,39.881092],[-78.243998,39.881707],[-78.243786,39.882202],[-78.243642,39.882759],[-78.243589,39.883213],[-78.243591,39.883257],[-78.243606,39.883685],[-78.243669,39.8841],[-78.24371,39.884267],[-78.243772,39.88447],[-78.243861,39.88475],[-78.243969,39.884982],[-78.244149,39.885464],[-78.244369,39.8861],[-78.244382,39.886164],[-78.244408,39.886292],[-78.244446,39.886683],[-78.244434,39.886952],[-78.244429,39.887076],[-78.244402,39.887271],[-78.244312,39.887657],[-78.244177,39.888035],[-78.243874,39.888788],[-78.239714,39.898945],[-78.239402,39.899839],[-78.239156,39.90062],[-78.238967,39.901309],[-78.238918,39.901541],[-78.238856,39.901706],[-78.238431,39.903595],[-78.238195,39.904644],[-78.237888,39.906012],[-78.237827,39.906204],[-78.237795,39.906422],[-78.237684,39.906914],[-78.237621,39.907196],[-78.237466,39.90788],[-78.23704,39.909785],[-78.237007,39.91001],[-78.236843,39.910643],[-78.23558,39.916231],[-78.235068,39.918516],[-78.233358,39.926139],[-78.233284,39.92647],[-78.233268,39.926595],[-78.233149,39.927054],[-78.233052,39.927424],[-78.232619,39.928791],[-78.232604,39.928891],[-78.232335,39.929608],[-78.232152,39.93011],[-78.232095,39.930233],[-78.231996,39.930444],[-78.231696,39.931046],[-78.230469,39.933599],[-78.229371,39.935891],[-78.228392,39.937931],[-78.227999,39.938767],[-78.227441,39.939934],[-78.22733,39.940175],[-78.227248,39.940386],[-78.22718,39.940577],[-78.227127,39.940762],[-78.227081,39.94094],[-78.227033,39.941189],[-78.226989,39.941486],[-78.226972,39.941773],[-78.226971,39.941841],[-78.226972,39.942004],[-78.226981,39.942221],[-78.227007,39.942475],[-78.227044,39.9427],[-78.227086,39.942912],[-78.227144,39.943134],[-78.227208,39.943344],[-78.227316,39.94363],[-78.227489,39.944049],[-78.228199,39.945716],[-78.228488,39.946389],[-78.228572,39.946566],[-78.228671,39.94676],[-78.228791,39.946962],[-78.228935,39.947189],[-78.229066,39.947364],[-78.229167,39.947494],[-78.229279,39.94763],[-78.229412,39.947773],[-78.229599,39.947961],[-78.229751,39.948105],[-78.229949,39.948274],[-78.230204,39.948471],[-78.230376,39.948598],[-78.230514,39.94869],[-78.230795,39.948859],[-78.231143,39.949052],[-78.231344,39.949161],[-78.231563,39.949266],[-78.231823,39.949379],[-78.232125,39.949491],[-78.233116,39.949848],[-78.234517,39.950357],[-78.234803,39.950465],[-78.235078,39.950574],[-78.235375,39.950713],[-78.235618,39.950842],[-78.235984,39.95105],[-78.238634,39.952597],[-78.238987,39.952799],[-78.24128,39.954141],[-78.243686,39.95554],[-78.244155,39.955821],[-78.244528,39.956078],[-78.244721,39.956229],[-78.244831,39.956314],[-78.245072,39.956521],[-78.245289,39.956732],[-78.245523,39.956998],[-78.245712,39.957227],[-78.245899,39.957502],[-78.246056,39.957765],[-78.246183,39.958013],[-78.246321,39.958328],[-78.246458,39.958727],[-78.246565,39.959209],[-78.246634,39.959718],[-78.246922,39.961688],[-78.247024,39.962339],[-78.247066,39.962604],[-78.247075,39.962727],[-78.247154,39.963482],[-78.247156,39.963628],[-78.247167,39.96415],[-78.247102,39.964748],[-78.247085,39.964783],[-78.24699,39.965363],[-78.24678,39.966567],[-78.246359,39.968859],[-78.246307,39.969141],[-78.245885,39.971528],[-78.245769,39.972151],[-78.245737,39.972324],[-78.245531,39.973646],[-78.245485,39.973802],[-78.245305,39.974749],[-78.245175,39.975536],[-78.245025,39.976321],[-78.244904,39.977016],[-78.24489,39.977137],[-78.244686,39.978199],[-78.244675,39.978236],[-78.244611,39.978635],[-78.244587,39.978789],[-78.244562,39.978877],[-78.244145,39.981008],[-78.244057,39.981591],[-78.243977,39.982122],[-78.243812,39.982889],[-78.243651,39.98346],[-78.243356,39.98443],[-78.242809,39.986209],[-78.241797,39.98949],[-78.241609,39.990195],[-78.241537,39.990464],[-78.241395,39.990902],[-78.241277,39.991222],[-78.241176,39.991484],[-78.240929,39.992269],[-78.240633,39.993237],[-78.240323,39.994229],[-78.240144,39.994843],[-78.239995,39.995267],[-78.238892,39.998821],[-78.23881,39.998965],[-78.238756,39.999047],[-78.238702,39.999119],[-78.23862,39.9992],[-78.238557,39.99925],[-78.238469,39.999294],[-78.238327,39.999346],[-78.238176,39.999385],[-78.237889,39.999428],[-78.237746,39.999422],[-78.237271,39.999405],[-78.237179,39.999402],[-78.236923,39.999392],[-78.236093,39.999363],[-78.235909,39.999359],[-78.235388,39.999352],[-78.235054,39.999348],[-78.234726,39.999352],[-78.234385,39.999362],[-78.234187,39.999279],[-78.234113,39.999262],[-78.234021,39.999232],[-78.233944,39.999192],[-78.233863,39.999127],[-78.233806,39.99905],[-78.233769,39.998977],[-78.23374,39.998877],[-78.233725,39.998802],[-78.23371,39.998699],[-78.233688,39.998],[-78.233655,39.997019],[-78.233653,39.996645],[-78.233688,39.996314],[-78.233741,39.996058],[-78.233836,39.995761],[-78.233888,39.995633],[-78.233943,39.995531],[-78.234258,39.995016],[-78.23474,39.994458],[-78.235394,39.993762],[-78.236175,39.992919],[-78.236719,39.992403],[-78.237442,39.991877],[-78.237793,39.991672],[-78.2382,39.991467],[-78.238626,39.991284],[-78.238957,39.99117],[-78.239193,39.991087],[-78.239398,39.991026],[-78.239664,39.990956],[-78.240124,39.990861],[-78.240811,39.990762],[-78.241272,39.990724],[-78.241678,39.99071],[-78.246498,39.990545],[-78.247886,39.990499],[-78.248969,39.990441],[-78.249299,39.990423],[-78.249693,39.990382],[-78.250313,39.990305],[-78.250374,39.990306],[-78.250744,39.990284],[-78.251114,39.990245],[-78.251306,39.990214],[-78.251491,39.990177],[-78.251914,39.990062],[-78.252291,39.98996],[-78.252393,39.989932],[-78.252499,39.989903],[-78.252577,39.989882],[-78.252796,39.989822],[-78.253268,39.989684],[-78.253569,39.989589],[-78.253866,39.989472],[-78.254185,39.989347],[-78.254831,39.989072],[-78.255251,39.988883],[-78.255906,39.988598],[-78.256267,39.98842],[-78.25645,39.98833],[-78.256945,39.988081],[-78.257417,39.987839],[-78.258025,39.987554],[-78.25861,39.987346],[-78.259315,39.987178],[-78.259921,39.98707],[-78.260407,39.986976],[-78.261116,39.986811],[-78.261311,39.986781],[-78.261872,39.986667],[-78.262314,39.986559],[-78.263,39.9864],[-78.263379,39.986305],[-78.26385,39.986186],[-78.264139,39.9861],[-78.264933,39.985878],[-78.265966,39.985567],[-78.266901,39.985316],[-78.26848,39.984857],[-78.26969,39.984507],[-78.27068,39.984225],[-78.271399,39.984016],[-78.272209,39.98379],[-78.273051,39.983542],[-78.273664,39.983372],[-78.274124,39.98326],[-78.27483,39.983095],[-78.27574,39.982949],[-78.276736,39.982844],[-78.277556,39.982788],[-78.278316,39.982778],[-78.279923,39.982794],[-78.2815,39.982812],[-78.283061,39.982823],[-78.284244,39.982857],[-78.284695,39.982878],[-78.284992,39.982899],[-78.285368,39.982933],[-78.286237,39.983084],[-78.286956,39.983249],[-78.287254,39.983328],[-78.287753,39.983484],[-78.288248,39.983657],[-78.289474,39.984157],[-78.290203,39.984461],[-78.291506,39.98499],[-78.292336,39.985278],[-78.293511,39.985578],[-78.294618,39.985746],[-78.296229,39.985863],[-78.299925,39.986096],[-78.301039,39.986208],[-78.301925,39.986379],[-78.302735,39.986616],[-78.303752,39.987024],[-78.305149,39.98765],[-78.305662,39.987907],[-78.307446,39.988726],[-78.308387,39.98916],[-78.308682,39.989292],[-78.308926,39.989398],[-78.309536,39.989668],[-78.309798,39.989769],[-78.310177,39.9899],[-78.310521,39.990009],[-78.310863,39.99009],[-78.311223,39.990168],[-78.311573,39.990222],[-78.311995,39.990275],[-78.312425,39.990307],[-78.313583,39.990322],[-78.314213,39.990325],[-78.315671,39.990331],[-78.316166,39.990331],[-78.316548,39.990338],[-78.317183,39.99034],[-78.317614,39.990354],[-78.317945,39.990375],[-78.318297,39.990415],[-78.318501,39.990444],[-78.318637,39.990468],[-78.318979,39.990538],[-78.319188,39.990589],[-78.319367,39.990639],[-78.319686,39.990742],[-78.319904,39.990821],[-78.320293,39.990987],[-78.320559,39.991118],[-78.321096,39.991401],[-78.321732,39.991743],[-78.322209,39.991992],[-78.32281,39.992325],[-78.324474,39.993209],[-78.325562,39.993807],[-78.326167,39.994123],[-78.32674,39.994433],[-78.327078,39.994621],[-78.327335,39.994754],[-78.327473,39.994828],[-78.327763,39.994985],[-78.328056,39.99513],[-78.32838,39.995284],[-78.328549,39.995356],[-78.328962,39.99552],[-78.329487,39.9957],[-78.329612,39.99573],[-78.329842,39.995792],[-78.330175,39.995872],[-78.330501,39.99594],[-78.331438,39.99611],[-78.333026,39.996391],[-78.333508,39.996472],[-78.333737,39.99652],[-78.334206,39.99663],[-78.334581,39.99673],[-78.334753,39.996783],[-78.334914,39.99684],[-78.33526,39.996978],[-78.335631,39.997143],[-78.335844,39.997255],[-78.33625,39.997484],[-78.336368,39.99756],[-78.337002,39.997968],[-78.337253,39.998127],[-78.337445,39.998254],[-78.337651,39.998378],[-78.337987,39.998568],[-78.338262,39.99871],[-78.338417,39.99878],[-78.3387,39.998899],[-78.338871,39.998961],[-78.338988,39.999011],[-78.339306,39.999116],[-78.339511,39.999175],[-78.339773,39.999242],[-78.340682,39.999453],[-78.341308,39.999594],[-78.341849,39.999729],[-78.342257,39.999815],[-78.342937,39.999968],[-78.343331,40.000045],[-78.345743,40.000593],[-78.347016,40.000875],[-78.347363,40.000945],[-78.347696,40.001004],[-78.348096,40.00106],[-78.348515,40.001102],[-78.34898,40.001128],[-78.349461,40.001136],[-78.349749,40.001129],[-78.350239,40.001098],[-78.350272,40.001096],[-78.35075,40.001055],[-78.351565,40.000965],[-78.352899,40.000824],[-78.356338,40.000463],[-78.357188,40.000391],[-78.357616,40.000372],[-78.358023,40.000368],[-78.358295,40.000374],[-78.358608,40.000386],[-78.35901,40.000412],[-78.359439,40.000453],[-78.359859,40.000507],[-78.360375,40.000598],[-78.360869,40.0007],[-78.3609,40.000707],[-78.361108,40.000757],[-78.361764,40.000927],[-78.363938,40.001503],[-78.364434,40.001634],[-78.364737,40.001709],[-78.365405,40.001865],[-78.365826,40.001943],[-78.366096,40.001993],[-78.366382,40.002036],[-78.36679,40.00209],[-78.367236,40.00214],[-78.369613,40.002353],[-78.37141,40.002514],[-78.373045,40.002661],[-78.374283,40.002772],[-78.376185,40.002943],[-78.37638,40.002962],[-78.376936,40.003023],[-78.37723,40.003065],[-78.377644,40.003137],[-78.377728,40.003154],[-78.377761,40.003161],[-78.378043,40.003218],[-78.378811,40.003407],[-78.378982,40.003453],[-78.379367,40.003569],[-78.379676,40.003669],[-78.38003,40.003797],[-78.380299,40.003901],[-78.380344,40.00392],[-78.380643,40.004045],[-78.380876,40.004148],[-78.381169,40.004285],[-78.381508,40.00446],[-78.381855,40.004651],[-78.382179,40.004847],[-78.382446,40.00503],[-78.382556,40.005099],[-78.384713,40.006472],[-78.385037,40.006685],[-78.385363,40.006891],[-78.386162,40.007408],[-78.388861,40.00915],[-78.389,40.00924],[-78.389431,40.009489],[-78.389867,40.009718],[-78.390073,40.009817],[-78.390283,40.009907],[-78.39085,40.010129],[-78.391282,40.01027],[-78.391613,40.010363],[-78.392071,40.010473],[-78.392625,40.010573],[-78.393153,40.010639],[-78.393658,40.010674],[-78.395074,40.010751],[-78.395469,40.01077],[-78.395935,40.010806],[-78.396286,40.010845],[-78.396543,40.010882],[-78.396931,40.010954],[-78.397376,40.011047],[-78.397818,40.011163],[-78.399598,40.011735],[-78.401163,40.012252],[-78.401716,40.012417],[-78.401938,40.012479],[-78.402005,40.012497],[-78.402282,40.012555],[-78.402632,40.012618],[-78.403076,40.012678],[-78.403451,40.012719],[-78.403709,40.012729],[-78.404154,40.01273],[-78.404443,40.01272],[-78.404464,40.012719],[-78.404755,40.012701],[-78.405092,40.012662],[-78.405454,40.012613],[-78.405802,40.012551],[-78.40621,40.012453],[-78.40655,40.012358],[-78.406899,40.012248],[-78.407217,40.012129],[-78.407484,40.012014],[-78.40785,40.011828],[-78.408368,40.011537],[-78.408726,40.01129],[-78.409091,40.011022],[-78.409399,40.010736],[-78.409733,40.010384],[-78.409969,40.010092],[-78.410225,40.00972],[-78.410442,40.00934],[-78.410509,40.009222],[-78.410935,40.008388],[-78.411292,40.007705],[-78.411589,40.007306],[-78.411791,40.007007],[-78.412003,40.006692],[-78.412127,40.00657],[-78.41238,40.006303],[-78.412574,40.006121],[-78.412838,40.00589],[-78.413144,40.005651],[-78.413223,40.005598],[-78.413432,40.00546],[-78.413776,40.005246],[-78.41409,40.005063],[-78.414482,40.004865],[-78.414914,40.004658],[-78.415357,40.004482],[-78.415741,40.004366],[-78.416193,40.004235],[-78.416569,40.004151],[-78.417178,40.004038],[-78.418865,40.003823],[-78.419142,40.003787],[-78.420554,40.003617],[-78.421568,40.003491],[-78.422844,40.003326],[-78.422869,40.003326],[-78.423086,40.003298],[-78.423199,40.003286],[-78.426239,40.002915],[-78.427155,40.002815],[-78.427679,40.002781],[-78.427963,40.00277],[-78.428517,40.00278],[-78.428831,40.002805],[-78.429237,40.002849],[-78.429721,40.002922],[-78.430156,40.003013],[-78.430594,40.003121],[-78.431015,40.003254],[-78.431407,40.003399],[-78.431794,40.003558],[-78.432059,40.003691],[-78.432398,40.003874],[-78.43266,40.00403],[-78.432892,40.004174],[-78.433332,40.004485],[-78.43376,40.004806],[-78.43389,40.004901],[-78.435423,40.00603],[-78.436168,40.006581],[-78.436293,40.006677],[-78.436886,40.007114],[-78.437437,40.007513],[-78.438176,40.008064],[-78.438716,40.008467],[-78.439057,40.008712],[-78.439684,40.009185],[-78.440106,40.009493],[-78.440422,40.009733],[-78.440818,40.010021],[-78.441155,40.010256],[-78.441397,40.010417],[-78.441647,40.010564],[-78.442003,40.010761],[-78.442269,40.010888],[-78.442626,40.011041],[-78.44291,40.01115],[-78.443444,40.011321],[-78.443737,40.011391],[-78.44417,40.011482],[-78.444476,40.011532],[-78.44496,40.011589],[-78.445488,40.011622],[-78.445813,40.011629],[-78.446866,40.011628],[-78.447151,40.011626],[-78.447457,40.011623],[-78.451773,40.011606],[-78.452386,40.011608],[-78.454917,40.011597],[-78.455666,40.011597],[-78.45627,40.011591],[-78.458651,40.011585],[-78.459491,40.011581],[-78.461045,40.011573],[-78.46149,40.011575],[-78.462533,40.011568],[-78.462861,40.011575],[-78.463408,40.011599],[-78.463694,40.011622],[-78.46414,40.011676],[-78.464408,40.011711],[-78.464471,40.011722],[-78.464871,40.011792],[-78.465379,40.011901],[-78.465443,40.011918],[-78.466013,40.012069],[-78.466127,40.012099],[-78.46642,40.012191],[-78.466864,40.012345],[-78.467245,40.012498],[-78.467632,40.012668],[-78.467927,40.012812],[-78.468667,40.013205],[-78.469639,40.013846],[-78.470158,40.014289],[-78.470272,40.014395],[-78.470501,40.014617],[-78.471632,40.015908],[-78.471661,40.015934],[-78.472481,40.016843],[-78.473406,40.017724],[-78.473435,40.017743],[-78.474144,40.018313],[-78.474742,40.0188],[-78.474793,40.018841],[-78.4751,40.019092],[-78.475802,40.019647],[-78.476412,40.020157],[-78.478517,40.021821],[-78.481386,40.024129],[-78.481487,40.024215],[-78.482398,40.024948],[-78.483361,40.025703],[-78.483496,40.025818],[-78.484027,40.026238],[-78.484594,40.026656],[-78.485556,40.027295],[-78.4856,40.027315],[-78.486374,40.027777],[-78.487301,40.028275],[-78.487365,40.028305],[-78.487693,40.028459],[-78.488315,40.028752],[-78.490494,40.029656],[-78.491228,40.02996],[-78.491353,40.030004],[-78.492001,40.030283],[-78.493105,40.030748],[-78.493407,40.030889],[-78.493856,40.031121],[-78.494376,40.031425],[-78.494572,40.031557],[-78.494995,40.031854],[-78.495429,40.03225],[-78.495766,40.032507],[-78.496045,40.032769],[-78.497623,40.034513],[-78.497821,40.034726],[-78.498066,40.03497],[-78.498494,40.03538],[-78.49899,40.035826],[-78.499541,40.036304],[-78.500156,40.036849],[-78.501063,40.03764],[-78.501326,40.037873],[-78.50198,40.038451],[-78.502356,40.038785],[-78.502626,40.039024],[-78.503018,40.039386],[-78.503314,40.039666],[-78.503461,40.039821],[-78.503755,40.040161],[-78.503927,40.040368],[-78.504166,40.040688],[-78.504663,40.041376],[-78.505076,40.041971],[-78.505295,40.042342],[-78.505407,40.042568],[-78.505576,40.042991],[-78.505901,40.044039],[-78.506025,40.044399],[-78.50614,40.044699],[-78.506475,40.045329],[-78.506718,40.045719],[-78.506983,40.046094],[-78.507264,40.046439],[-78.507656,40.04687],[-78.508314,40.047518],[-78.508812,40.047992],[-78.509382,40.048497],[-78.509779,40.048789],[-78.510363,40.049141],[-78.51095,40.049432],[-78.511316,40.049588],[-78.51145,40.049638],[-78.511632,40.049705],[-78.511995,40.049821],[-78.512371,40.049928],[-78.513062,40.050074],[-78.51332,40.050116],[-78.51354,40.050142],[-78.513786,40.050177],[-78.513997,40.050189],[-78.514694,40.050216],[-78.515415,40.050194],[-78.515808,40.050169],[-78.516422,40.050125],[-78.517024,40.050082],[-78.517507,40.050048],[-78.517807,40.050037],[-78.51796,40.050026],[-78.518104,40.050016],[-78.518526,40.049987],[-78.520615,40.049838],[-78.520929,40.049818],[-78.521563,40.049778],[-78.521855,40.049767],[-78.522304,40.049756],[-78.522643,40.049755],[-78.522979,40.049763],[-78.52335,40.049777],[-78.524627,40.049894],[-78.525369,40.049955],[-78.52551,40.049967],[-78.526906,40.050095],[-78.529844,40.050363],[-78.5305,40.050416],[-78.531878,40.050543],[-78.533006,40.05064],[-78.533444,40.050667],[-78.534242,40.0507],[-78.534971,40.050711],[-78.535671,40.050701],[-78.536216,40.050681],[-78.53669,40.050655],[-78.537109,40.050625],[-78.537668,40.050574],[-78.538771,40.050431],[-78.538921,40.050411],[-78.540193,40.050214],[-78.540364,40.050186],[-78.541039,40.050076],[-78.544189,40.049581],[-78.545474,40.049371],[-78.545857,40.049315],[-78.546287,40.049242],[-78.546722,40.049177],[-78.549351,40.04876],[-78.550624,40.048559],[-78.551009,40.048497],[-78.551992,40.048339],[-78.553269,40.048131],[-78.5533,40.048126],[-78.553539,40.048079],[-78.554204,40.047928],[-78.554639,40.047808],[-78.555023,40.047694],[-78.555507,40.047529],[-78.556014,40.047335],[-78.556417,40.047162],[-78.556895,40.046937],[-78.55725,40.046756],[-78.557601,40.046565],[-78.557939,40.046355],[-78.558355,40.046083],[-78.558676,40.045852],[-78.558879,40.045699],[-78.559164,40.045465],[-78.559541,40.045134],[-78.560261,40.044437],[-78.560692,40.044039],[-78.562445,40.04233],[-78.562767,40.042017],[-78.563196,40.041602],[-78.564035,40.040781],[-78.565243,40.0396],[-78.565548,40.039289],[-78.56677,40.03811],[-78.567695,40.037211],[-78.569103,40.035828],[-78.569483,40.03545],[-78.569804,40.03514],[-78.5705,40.034454],[-78.571312,40.033669],[-78.571701,40.033306],[-78.5721,40.032921],[-78.572273,40.032751],[-78.573365,40.031678],[-78.574462,40.030591],[-78.574916,40.03017],[-78.576179,40.028917],[-78.577038,40.028082],[-78.578251,40.026896],[-78.579355,40.025833],[-78.580336,40.024866],[-78.58119,40.024036],[-78.582332,40.022927],[-78.58295,40.022333],[-78.583288,40.021985],[-78.584182,40.021119],[-78.58506,40.02026],[-78.585548,40.01978],[-78.586251,40.019093],[-78.586545,40.01883],[-78.586847,40.018565],[-78.587197,40.018266],[-78.587495,40.018044],[-78.587685,40.017903],[-78.587884,40.017761],[-78.588208,40.017556],[-78.588462,40.017396],[-78.588739,40.017226],[-78.589205,40.016966],[-78.589808,40.01663],[-78.591026,40.015931],[-78.594247,40.014089],[-78.594459,40.013976],[-78.594659,40.013852],[-78.596998,40.012541],[-78.597201,40.012426],[-78.597506,40.01226],[-78.597574,40.012214],[-78.599751,40.010991],[-78.601908,40.00977],[-78.602362,40.009525],[-78.60287,40.009286],[-78.603065,40.00921],[-78.603239,40.00915],[-78.603435,40.00909],[-78.603627,40.009039],[-78.60382,40.008995],[-78.604026,40.008955],[-78.604237,40.008925],[-78.604437,40.008901],[-78.604642,40.008884],[-78.604917,40.008876],[-78.605129,40.008878],[-78.605321,40.008885],[-78.605522,40.008901],[-78.605742,40.008924],[-78.605921,40.00895],[-78.606138,40.008991],[-78.606372,40.009044],[-78.606559,40.009093],[-78.606784,40.009161],[-78.607179,40.009316],[-78.607484,40.00946],[-78.607801,40.009635],[-78.607938,40.009724],[-78.608075,40.009823],[-78.608229,40.009941],[-78.608453,40.010134],[-78.608583,40.010265],[-78.608838,40.010552],[-78.609045,40.010857],[-78.609146,40.011047],[-78.609284,40.011356],[-78.609342,40.011523],[-78.609392,40.011705],[-78.609428,40.011878],[-78.609452,40.012023],[-78.609482,40.012374],[-78.609527,40.013344],[-78.609584,40.013844],[-78.609618,40.014057],[-78.609719,40.014463],[-78.609822,40.014785],[-78.609903,40.01499],[-78.61006,40.015338],[-78.610249,40.015696],[-78.610466,40.016038],[-78.610591,40.016215],[-78.6107,40.016358],[-78.610975,40.016687],[-78.611109,40.016835],[-78.611406,40.017129],[-78.61157,40.017279],[-78.611748,40.017428],[-78.611945,40.017585],[-78.612123,40.017712],[-78.612463,40.017945],[-78.612846,40.018175],[-78.613172,40.018356],[-78.61321,40.018377],[-78.613425,40.018481],[-78.613834,40.018668],[-78.614025,40.018746],[-78.614276,40.018838],[-78.614521,40.018921],[-78.614946,40.019048],[-78.615165,40.019107],[-78.61557,40.019201],[-78.616074,40.019301],[-78.616349,40.019341],[-78.616685,40.01938],[-78.616983,40.019404],[-78.617273,40.019421],[-78.617565,40.01943],[-78.617898,40.019431],[-78.6182,40.019425],[-78.618511,40.019404],[-78.618847,40.019376],[-78.619114,40.019345],[-78.619386,40.019306],[-78.619669,40.019257],[-78.620213,40.019149],[-78.620679,40.019029],[-78.622244,40.018604],[-78.622942,40.018445],[-78.623907,40.018198],[-78.624814,40.017966],[-78.625646,40.017743],[-78.626358,40.017564],[-78.630378,40.016529],[-78.630806,40.016415],[-78.631051,40.016349],[-78.631549,40.016224],[-78.635542,40.015188],[-78.636581,40.014928],[-78.638017,40.014553],[-78.639323,40.014212],[-78.640205,40.013994],[-78.640668,40.013867],[-78.6415,40.013658],[-78.642835,40.013306],[-78.643416,40.013157],[-78.644733,40.012819],[-78.645943,40.012507],[-78.645996,40.01249],[-78.648165,40.011935],[-78.649033,40.011707],[-78.649613,40.011588],[-78.650195,40.011461],[-78.650625,40.011382],[-78.651051,40.011317],[-78.651454,40.011261],[-78.652126,40.01118],[-78.652519,40.011132],[-78.652839,40.01111],[-78.653229,40.011079],[-78.653673,40.011055],[-78.654358,40.011022],[-78.655141,40.010991],[-78.656392,40.010929],[-78.657804,40.010863],[-78.661431,40.010702],[-78.66302,40.010634],[-78.665059,40.010535],[-78.666423,40.010479],[-78.667499,40.010428],[-78.668906,40.010356],[-78.67203,40.010219],[-78.672909,40.010182],[-78.673585,40.010153],[-78.674077,40.010121],[-78.6745,40.01008],[-78.674821,40.01005],[-78.675205,40.009998],[-78.675742,40.009937],[-78.676428,40.009836],[-78.676885,40.009756],[-78.677236,40.009689],[-78.677772,40.009584],[-78.678172,40.009492],[-78.678793,40.009345],[-78.67939,40.009191],[-78.679866,40.009056],[-78.680279,40.008933],[-78.680705,40.008783],[-78.680832,40.008743],[-78.681379,40.008556],[-78.681717,40.008435],[-78.682358,40.008186],[-78.683017,40.007899],[-78.683507,40.007678],[-78.683889,40.007486],[-78.684342,40.007272],[-78.684786,40.00704],[-78.685104,40.006869],[-78.685433,40.006677],[-78.685793,40.006455],[-78.686217,40.006203],[-78.686521,40.006],[-78.686983,40.005693],[-78.687204,40.005544],[-78.687471,40.005356],[-78.687673,40.0052],[-78.688038,40.004914],[-78.688476,40.004562],[-78.688711,40.004358],[-78.689029,40.004091],[-78.689795,40.003317],[-78.690946,40.002206],[-78.691049,40.002122],[-78.691719,40.001452],[-78.692289,40.000891],[-78.693693,39.999499],[-78.694823,39.998376],[-78.69545,39.997737],[-78.696077,39.997114],[-78.697475,39.995737],[-78.698227,39.994966],[-78.698255,39.994947],[-78.698973,39.994236],[-78.699615,39.993576],[-78.700154,39.99306],[-78.700357,39.992865],[-78.701087,39.992128],[-78.701148,39.992062],[-78.701839,39.991389],[-78.701935,39.991285],[-78.702486,39.990743],[-78.703285,39.989941],[-78.703878,39.989357],[-78.704301,39.988927],[-78.704868,39.988373],[-78.705721,39.987538],[-78.706104,39.987204],[-78.706632,39.986799],[-78.707045,39.986528],[-78.707574,39.986213],[-78.708279,39.985853],[-78.708634,39.985706],[-78.708939,39.985573],[-78.70925,39.985461],[-78.709523,39.985363],[-78.709719,39.985296],[-78.709994,39.985223],[-78.710369,39.985123],[-78.710661,39.98505],[-78.710909,39.985002],[-78.711354,39.984918],[-78.712277,39.98473],[-78.712859,39.984615],[-78.713414,39.984514],[-78.714243,39.984359],[-78.714747,39.984261],[-78.715959,39.984027],[-78.716194,39.983981],[-78.716799,39.983862],[-78.717367,39.98375],[-78.71763,39.983698],[-78.71852,39.983527],[-78.718997,39.983435],[-78.719208,39.983395],[-78.719479,39.983343],[-78.720955,39.983058],[-78.726482,39.981981],[-78.728272,39.981635],[-78.729927,39.981323],[-78.734013,39.980532],[-78.735456,39.980264],[-78.737626,39.979829],[-78.738733,39.979631],[-78.740469,39.979281],[-78.741188,39.979141],[-78.742183,39.978955],[-78.743086,39.978782],[-78.743773,39.978645],[-78.744918,39.978429],[-78.746071,39.978198],[-78.74754,39.977921],[-78.74825,39.977804],[-78.749556,39.977555],[-78.750658,39.977351],[-78.751544,39.977236],[-78.751569,39.977229],[-78.752384,39.977184],[-78.752948,39.977174],[-78.753824,39.977214],[-78.754719,39.977282],[-78.754757,39.977291],[-78.755984,39.977399],[-78.757905,39.97756],[-78.757926,39.977568],[-78.758046,39.977578],[-78.759407,39.977688],[-78.759629,39.977715],[-78.760054,39.977749],[-78.760561,39.977781],[-78.760783,39.977801],[-78.761306,39.977858],[-78.761915,39.977937],[-78.762782,39.978134],[-78.763529,39.978377],[-78.76419,39.978634],[-78.76491,39.978976],[-78.768464,39.980923],[-78.769442,39.981442],[-78.771072,39.982319],[-78.77241,39.983032],[-78.773342,39.98354],[-78.774641,39.984243],[-78.77614,39.985052],[-78.778284,39.986209],[-78.778747,39.986454],[-78.779253,39.986697],[-78.779543,39.98684],[-78.779887,39.986965],[-78.780211,39.987055],[-78.78048,39.987114],[-78.780792,39.987182],[-78.781212,39.987243],[-78.781502,39.98726],[-78.781821,39.987267],[-78.78226,39.98727],[-78.782446,39.98725],[-78.782826,39.987203],[-78.78315,39.987154],[-78.783654,39.987043],[-78.783951,39.986948],[-78.784314,39.986812],[-78.784619,39.986683],[-78.784867,39.986545],[-78.785213,39.986343],[-78.785616,39.986057],[-78.786097,39.985656],[-78.78658,39.985219],[-78.787269,39.98465],[-78.787678,39.984363],[-78.78903,39.983623],[-78.789271,39.983466],[-78.789468,39.983339],[-78.789688,39.983163],[-78.789957,39.982938],[-78.790515,39.98241],[-78.790775,39.982135],[-78.791263,39.981661],[-78.79173,39.981279],[-78.792169,39.980909],[-78.792621,39.980591],[-78.792821,39.980466],[-78.793567,39.980035],[-78.794073,39.979757],[-78.795446,39.978995],[-78.795919,39.978721],[-78.796425,39.978418],[-78.797156,39.97794],[-78.797734,39.977552],[-78.798148,39.977266],[-78.79858,39.976935],[-78.798935,39.976674],[-78.799529,39.976177],[-78.799919,39.975837],[-78.800558,39.975339],[-78.801155,39.974859],[-78.801981,39.974176],[-78.802231,39.973928],[-78.802417,39.973708],[-78.802637,39.973436],[-78.803145,39.97261],[-78.8033,39.972356],[-78.803502,39.972049],[-78.803719,39.971687],[-78.804505,39.970436],[-78.805184,39.969321],[-78.805438,39.968848],[-78.806134,39.967756],[-78.806652,39.96693],[-78.806854,39.966657],[-78.806986,39.966509],[-78.807288,39.966198],[-78.807645,39.965913],[-78.808026,39.965672],[-78.808487,39.965381],[-78.808704,39.965247],[-78.808782,39.965199],[-78.809095,39.965005],[-78.809399,39.964784],[-78.809699,39.964528],[-78.809957,39.964282],[-78.810123,39.964051],[-78.810321,39.963774],[-78.81049,39.963501],[-78.810594,39.963293],[-78.810875,39.962671],[-78.811387,39.961579],[-78.811843,39.960579],[-78.812198,39.959853],[-78.812506,39.959236],[-78.812606,39.959027],[-78.813238,39.957739],[-78.813429,39.957369],[-78.813648,39.957049],[-78.813871,39.956773],[-78.814191,39.956415],[-78.814564,39.956118],[-78.814858,39.955907],[-78.81517,39.955696],[-78.81576,39.955398],[-78.816439,39.95515],[-78.81679,39.95504],[-78.817092,39.954983],[-78.817403,39.954924],[-78.817705,39.954881],[-78.818012,39.95485],[-78.818301,39.954829],[-78.818572,39.954833],[-78.81889,39.954826],[-78.819265,39.954851],[-78.819505,39.954875],[-78.819706,39.954904],[-78.820066,39.954972],[-78.820349,39.955029],[-78.820587,39.955103],[-78.821082,39.95527],[-78.821397,39.955384],[-78.821715,39.955534],[-78.821968,39.955671],[-78.822191,39.955796],[-78.822418,39.955945],[-78.822655,39.95613],[-78.822885,39.956332],[-78.823185,39.956606],[-78.823808,39.957251],[-78.824999,39.958465],[-78.82557,39.959061],[-78.825881,39.959357],[-78.826046,39.959509],[-78.8264,39.959863],[-78.826589,39.960014],[-78.826927,39.960326],[-78.827273,39.960602],[-78.827993,39.961214],[-78.828107,39.961305],[-78.8286,39.961698],[-78.829134,39.962129],[-78.829499,39.962421],[-78.829823,39.962685],[-78.83004,39.962841],[-78.830418,39.9631],[-78.830734,39.963286],[-78.831158,39.96348],[-78.831396,39.963577],[-78.831689,39.963694],[-78.832441,39.963946],[-78.832815,39.964052],[-78.833225,39.96415],[-78.833541,39.964203],[-78.833926,39.964256],[-78.834278,39.964292],[-78.834534,39.96429],[-78.834815,39.964283],[-78.835175,39.964268],[-78.83554,39.964222],[-78.835866,39.964177],[-78.836145,39.964111],[-78.836372,39.964058],[-78.836616,39.963973],[-78.836832,39.963907],[-78.837068,39.963809],[-78.837385,39.963672],[-78.837654,39.963527],[-78.837922,39.963352],[-78.838371,39.963047],[-78.838983,39.962549],[-78.839567,39.962052],[-78.839962,39.961719],[-78.840247,39.961494],[-78.840789,39.961032],[-78.842399,39.959695],[-78.84337,39.958896],[-78.84379,39.958533],[-78.844063,39.958304],[-78.844309,39.958137],[-78.844507,39.958009],[-78.844692,39.9579],[-78.845006,39.957773],[-78.845256,39.957683],[-78.845416,39.957633],[-78.8456,39.957582],[-78.845819,39.957529],[-78.846023,39.957489],[-78.846281,39.957452],[-78.846508,39.957432],[-78.846731,39.957422],[-78.846933,39.95742],[-78.847135,39.957429],[-78.847356,39.957447],[-78.847524,39.957466],[-78.847623,39.957484],[-78.847858,39.957531],[-78.84806,39.957581],[-78.848225,39.957627],[-78.848402,39.957683],[-78.848555,39.957742],[-78.867036,39.965912],[-78.867258,39.96601],[-78.867653,39.966185],[-78.868385,39.966509],[-78.869757,39.967152],[-78.870446,39.967466],[-78.87128,39.967833],[-78.871935,39.968127],[-78.87247,39.968358],[-78.872725,39.968465],[-78.873018,39.968581],[-78.873386,39.968714],[-78.87369,39.96882],[-78.874054,39.968934],[-78.874445,39.969038],[-78.874822,39.969131],[-78.875172,39.969206],[-78.875615,39.969294],[-78.87602,39.969358],[-78.876504,39.969427],[-78.876747,39.969463],[-78.877498,39.96957],[-78.881054,39.97007],[-78.885894,39.970754],[-78.887836,39.971031],[-78.89143,39.971534],[-78.893393,39.971815],[-78.89667,39.972276],[-78.900144,39.97277],[-78.904129,39.97333],[-78.912924,39.974577],[-78.91326,39.974625],[-78.917662,39.975243],[-78.923219,39.976027],[-78.928776,39.976814],[-78.930196,39.977011],[-78.930391,39.977038],[-78.934072,39.977628],[-78.936361,39.978127],[-78.938568,39.978729],[-78.940799,39.979412],[-78.946849,39.981497],[-78.94904,39.98227],[-78.949304,39.982363],[-78.954188,39.98405],[-78.956482,39.984842],[-78.958113,39.985355],[-78.958403,39.98544],[-78.959014,39.985618],[-78.961477,39.986237],[-78.964088,39.986741],[-78.969279,39.987743],[-78.973338,39.988497],[-78.975648,39.988926],[-78.977939,39.989367],[-78.979785,39.989722],[-78.98381,39.990498],[-78.988083,39.991193],[-78.98819,39.99121],[-78.992064,39.991525],[-78.993948,39.991679],[-78.994581,39.991731],[-78.995709,39.991829],[-78.999251,39.992143],[-79.000024,39.992208],[-79.00283,39.992477],[-79.004391,39.992566],[-79.007336,39.992734],[-79.014908,39.993169],[-79.015165,39.993184],[-79.016807,39.993282],[-79.018227,39.99336],[-79.020764,39.993513],[-79.021677,39.993555],[-79.02446,39.993713],[-79.024667,39.993739],[-79.025781,39.993878],[-79.026906,39.994075],[-79.036519,39.997067],[-79.03775,39.997475],[-79.039622,39.998087],[-79.040276,39.998302],[-79.042561,39.999072],[-79.042776,39.999125],[-79.0433,39.99927],[-79.044902,39.999821],[-79.045656,40.000066],[-79.04659,40.000364],[-79.047343,40.000638],[-79.04786,40.000867],[-79.048343,40.001117],[-79.048874,40.001437],[-79.049112,40.001609],[-79.049455,40.001856],[-79.0498,40.002142],[-79.050292,40.002518],[-79.05169,40.003982],[-79.052464,40.004554],[-79.053029,40.005024],[-79.053886,40.00545],[-79.054684,40.005733],[-79.055604,40.006006],[-79.059237,40.006793],[-79.060183,40.007011],[-79.065174,40.008076],[-79.066438,40.008471],[-79.067156,40.008761],[-79.067665,40.009015],[-79.0687,40.009733],[-79.068885,40.009861],[-79.06951,40.010456],[-79.07111,40.012202],[-79.072085,40.013207],[-79.073467,40.014626],[-79.073629,40.014788],[-79.073937,40.015101],[-79.074911,40.016106],[-79.075452,40.016678],[-79.076044,40.017289],[-79.076349,40.017611],[-79.0767,40.017971],[-79.076902,40.018163],[-79.077045,40.018284],[-79.077207,40.018426],[-79.077602,40.018721],[-79.077934,40.018963],[-79.078231,40.019148],[-79.078588,40.019347],[-79.078875,40.019494],[-79.079244,40.019669],[-79.079652,40.019834],[-79.080978,40.020343],[-79.081438,40.020516],[-79.08161,40.020582],[-79.083097,40.021186],[-79.084294,40.021657],[-79.085366,40.022077],[-79.085863,40.02229],[-79.086243,40.022474],[-79.08681,40.022783],[-79.087249,40.023046],[-79.087674,40.023325],[-79.08799,40.023559],[-79.088223,40.023751],[-79.088523,40.02401],[-79.088847,40.024334],[-79.08909,40.024594],[-79.089237,40.024771],[-79.089863,40.025558],[-79.090248,40.026079],[-79.09061,40.026619],[-79.090851,40.026915],[-79.091248,40.027456],[-79.091519,40.027806],[-79.092118,40.028629],[-79.093111,40.029875],[-79.09333,40.030212],[-79.093605,40.030593],[-79.093957,40.031099],[-79.09442,40.031651],[-79.094892,40.032111],[-79.095788,40.032957],[-79.096068,40.033216],[-79.096673,40.033776],[-79.097446,40.034486],[-79.098811,40.035613],[-79.099836,40.036501],[-79.101149,40.03771],[-79.103527,40.039721],[-79.104119,40.04022],[-79.105081,40.040806],[-79.106242,40.041149],[-79.107707,40.041403],[-79.109089,40.041383],[-79.11186,40.041204],[-79.112945,40.041234],[-79.114081,40.041472],[-79.114891,40.041767],[-79.115578,40.042126],[-79.116513,40.042573],[-79.118805,40.043798],[-79.119579,40.044346],[-79.120354,40.045009],[-79.120633,40.045267],[-79.121487,40.046313],[-79.122286,40.047506],[-79.122923,40.048354],[-79.123601,40.049239],[-79.123845,40.049551],[-79.124284,40.050109],[-79.124736,40.050753],[-79.125053,40.051186],[-79.125414,40.051712],[-79.125723,40.052027],[-79.126581,40.052704],[-79.127869,40.053585],[-79.1321,40.05637],[-79.132993,40.056988],[-79.134065,40.057539],[-79.135379,40.057953],[-79.136803,40.058282],[-79.138157,40.058761],[-79.13908,40.059402],[-79.139619,40.059872],[-79.140031,40.060515],[-79.140254,40.060995],[-79.140331,40.061225],[-79.140503,40.061691],[-79.140626,40.062034],[-79.141042,40.062743],[-79.141473,40.063452],[-79.142314,40.064319],[-79.143318,40.065002],[-79.144082,40.065337],[-79.144829,40.065593],[-79.146811,40.066112],[-79.148335,40.066451],[-79.149346,40.066709],[-79.153743,40.067812],[-79.155506,40.068345],[-79.156519,40.068917],[-79.157515,40.06963],[-79.159774,40.072014],[-79.161385,40.073646],[-79.162767,40.074677],[-79.163917,40.075354],[-79.165394,40.075886],[-79.167478,40.076317],[-79.169235,40.076454],[-79.171052,40.076386],[-79.175191,40.076272],[-79.176277,40.076326],[-79.17765,40.076457],[-79.178886,40.076713],[-79.179736,40.076903],[-79.180938,40.077311],[-79.181862,40.077669],[-79.183169,40.078348],[-79.184242,40.079051],[-79.186723,40.08089],[-79.188199,40.082072],[-79.189485,40.082771],[-79.190885,40.08332],[-79.194695,40.084729],[-79.19624,40.085326],[-79.1972,40.085881],[-79.197909,40.086415],[-79.198397,40.086808],[-79.199819,40.087979],[-79.200149,40.088329],[-79.200358,40.088535],[-79.201043,40.089358],[-79.20155,40.090113],[-79.20169,40.090474],[-79.201913,40.090921],[-79.202056,40.09128],[-79.202151,40.091572],[-79.202354,40.092767],[-79.202235,40.094529],[-79.202027,40.095695],[-79.201887,40.097434],[-79.201801,40.098419],[-79.201844,40.099312],[-79.20193,40.099824],[-79.202394,40.100894],[-79.202582,40.101223],[-79.202849,40.10163],[-79.203055,40.101899],[-79.203286,40.102161],[-79.203982,40.102765],[-79.204557,40.10312],[-79.205518,40.103645],[-79.206187,40.103908],[-79.209809,40.104899],[-79.216979,40.106928],[-79.219447,40.107632],[-79.220014,40.107767],[-79.220875,40.107908],[-79.221352,40.107968],[-79.221743,40.108007],[-79.222015,40.10803],[-79.222332,40.10805],[-79.223139,40.108057],[-79.224607,40.107984],[-79.225525,40.107833],[-79.22707,40.107394],[-79.229542,40.106402],[-79.231203,40.10569],[-79.232198,40.105316],[-79.232836,40.105114],[-79.234087,40.104954],[-79.2357,40.104817],[-79.237408,40.105099],[-79.238456,40.10544],[-79.239099,40.105755],[-79.241434,40.107324],[-79.242318,40.107922],[-79.244876,40.10955],[-79.246403,40.110705],[-79.247339,40.111453],[-79.248172,40.11207],[-79.249116,40.112576],[-79.249754,40.112815],[-79.25109,40.113239],[-79.253849,40.113594],[-79.254981,40.113892],[-79.256798,40.114512],[-79.258703,40.115543],[-79.260248,40.116363],[-79.261596,40.116993],[-79.26362,40.117602],[-79.266033,40.11797],[-79.270067,40.118621],[-79.271037,40.118687],[-79.273363,40.1187],[-79.274762,40.1187],[-79.275723,40.118818],[-79.276564,40.119074],[-79.277388,40.119442],[-79.278204,40.120006],[-79.27871,40.120452],[-79.279114,40.121017],[-79.279233,40.121338],[-79.279397,40.121726],[-79.279517,40.122087],[-79.279706,40.122566],[-79.280067,40.123214],[-79.280424,40.123763],[-79.281139,40.124515],[-79.28192,40.125086],[-79.28289,40.125605],[-79.285182,40.126602],[-79.286246,40.127061],[-79.290091,40.128761],[-79.291483,40.129087],[-79.292854,40.129087],[-79.293954,40.128853],[-79.294752,40.128564],[-79.295962,40.127849],[-79.296829,40.12739],[-79.300442,40.12525],[-79.301387,40.124692],[-79.302686,40.124066],[-79.303491,40.123814],[-79.304846,40.123557],[-79.313115,40.122445],[-79.316484,40.121958],[-79.317182,40.121855],[-79.318663,40.121639],[-79.322804,40.121046],[-79.329136,40.120091],[-79.330114,40.119895],[-79.334689,40.118667],[-79.337732,40.117872],[-79.339124,40.117504],[-79.345874,40.115685],[-79.352121,40.114],[-79.354799,40.113279],[-79.359425,40.11207],[-79.362283,40.111309],[-79.363992,40.110705],[-79.366034,40.10972],[-79.367476,40.108795],[-79.368944,40.107797],[-79.370197,40.107298],[-79.370952,40.107101],[-79.372042,40.106983],[-79.37315,40.107003],[-79.374514,40.107272],[-79.376593,40.107742],[-79.37767,40.107987],[-79.378498,40.108218],[-79.379196,40.108453],[-79.380313,40.108937],[-79.381187,40.109325],[-79.38146,40.109446],[-79.382084,40.109699],[-79.383087,40.110124],[-79.383959,40.110508],[-79.384713,40.110822],[-79.385516,40.111168],[-79.386086,40.111422],[-79.387599,40.112098],[-79.38863,40.112556],[-79.389942,40.113101],[-79.394398,40.115059],[-79.394771,40.115245],[-79.395257,40.115528],[-79.395668,40.115807],[-79.396082,40.116121],[-79.396483,40.116479],[-79.396951,40.116971],[-79.397221,40.11732],[-79.397456,40.117677],[-79.397567,40.117888],[-79.397713,40.118185],[-79.397863,40.118505],[-79.398013,40.118858],[-79.398174,40.119522],[-79.398281,40.120162],[-79.398346,40.12054],[-79.39841,40.120827],[-79.398496,40.121147],[-79.398711,40.121713],[-79.399097,40.122279],[-79.399419,40.122632],[-79.399676,40.122993],[-79.400062,40.123304],[-79.400363,40.123518],[-79.401007,40.123936],[-79.402369,40.124855],[-79.403249,40.125413],[-79.403732,40.125716],[-79.404182,40.125971],[-79.405543,40.126858],[-79.406423,40.127478],[-79.407015,40.127964],[-79.407551,40.12853],[-79.407765,40.128861],[-79.408173,40.129597],[-79.408409,40.130146],[-79.408474,40.130515],[-79.408688,40.131606],[-79.40888,40.132981],[-79.409076,40.134244],[-79.409271,40.135334],[-79.40943,40.136296],[-79.409539,40.136717],[-79.410014,40.137469],[-79.410683,40.138355],[-79.411361,40.139031],[-79.412443,40.13972],[-79.413138,40.140061],[-79.414603,40.140752],[-79.415035,40.140947],[-79.41664,40.141728],[-79.420785,40.143992],[-79.421275,40.144241],[-79.421592,40.144412],[-79.421824,40.14453],[-79.422579,40.144884],[-79.423583,40.145514],[-79.425167,40.146964],[-79.42581,40.147474],[-79.426478,40.147898],[-79.427798,40.148716],[-79.428544,40.149555],[-79.428881,40.149974],[-79.428982,40.150146],[-79.42915,40.150386],[-79.429394,40.150802],[-79.429746,40.15134],[-79.429943,40.15153],[-79.430913,40.152678],[-79.431978,40.153977],[-79.432304,40.154233],[-79.432681,40.154495],[-79.4338,40.15503],[-79.434244,40.155191],[-79.434879,40.155289],[-79.43578,40.155309],[-79.438947,40.155145],[-79.439771,40.15504],[-79.443163,40.154184],[-79.444355,40.153772],[-79.445011,40.153383],[-79.445556,40.152888],[-79.446376,40.151976],[-79.446596,40.151746],[-79.446779,40.151567],[-79.447046,40.151328],[-79.447298,40.151135],[-79.4476,40.150942],[-79.447927,40.150763],[-79.448319,40.150592],[-79.448732,40.150449],[-79.449075,40.15036],[-79.44946,40.150283],[-79.449854,40.150235],[-79.450255,40.150208],[-79.450768,40.150187],[-79.45642,40.150113],[-79.456869,40.150106],[-79.457284,40.150112],[-79.457693,40.150121],[-79.45817,40.150146],[-79.458682,40.150196],[-79.459161,40.150255],[-79.459664,40.150344],[-79.460458,40.150515],[-79.462293,40.150946],[-79.464828,40.15156],[-79.46519,40.151654],[-79.465682,40.151805],[-79.466117,40.151961],[-79.46648,40.152122],[-79.466858,40.152307],[-79.467246,40.152526],[-79.467608,40.152765],[-79.468069,40.153093],[-79.469247,40.153965],[-79.469568,40.154166],[-79.469838,40.154312],[-79.470184,40.154473],[-79.470591,40.154629],[-79.470951,40.154745],[-79.472319,40.155158],[-79.472798,40.155323],[-79.47311,40.155448],[-79.473476,40.155615],[-79.474046,40.155904],[-79.480633,40.159433],[-79.482316,40.160334],[-79.482761,40.160589],[-79.483113,40.160812],[-79.48349,40.161078],[-79.483799,40.161322],[-79.484106,40.161587],[-79.484439,40.161908],[-79.484725,40.16222],[-79.484979,40.162521],[-79.485733,40.163535],[-79.485898,40.163738],[-79.486841,40.164899],[-79.48727,40.165292],[-79.488127,40.165812],[-79.488731,40.166082],[-79.489156,40.166199],[-79.49111,40.166648],[-79.491547,40.166743],[-79.493372,40.167194],[-79.494308,40.16749],[-79.495235,40.167857],[-79.496162,40.168316],[-79.497569,40.169064],[-79.501295,40.1713],[-79.504118,40.173005],[-79.507861,40.175189],[-79.508444,40.175438],[-79.509071,40.175648],[-79.513671,40.177012],[-79.515817,40.177714],[-79.516701,40.178035],[-79.522199,40.180303],[-79.522514,40.180448],[-79.527919,40.182744],[-79.528983,40.183216],[-79.529713,40.183636],[-79.530443,40.184121],[-79.530898,40.184521],[-79.531473,40.185209],[-79.532116,40.186344],[-79.533284,40.188252],[-79.533739,40.188914],[-79.534296,40.189596],[-79.535043,40.190258],[-79.535756,40.190822],[-79.536511,40.191347],[-79.537403,40.191825],[-79.538828,40.192455],[-79.541438,40.193215],[-79.545085,40.19433],[-79.547326,40.195451],[-79.551051,40.197411],[-79.553969,40.198939],[-79.556621,40.200381],[-79.559445,40.201876],[-79.562895,40.20375],[-79.564577,40.204616],[-79.565333,40.204963],[-79.569925,40.206661],[-79.571118,40.207067],[-79.57207,40.207507],[-79.573847,40.208332],[-79.577212,40.21001],[-79.581048,40.211892],[-79.581812,40.212167],[-79.582516,40.212383],[-79.583228,40.212521],[-79.584181,40.2126],[-79.585885,40.212597],[-79.589833,40.212525],[-79.591052,40.212643],[-79.592022,40.21286],[-79.592837,40.213135],[-79.593636,40.213528],[-79.594168,40.213882],[-79.594657,40.214328],[-79.595223,40.214918],[-79.596185,40.216124],[-79.596622,40.216471],[-79.597258,40.216805],[-79.597979,40.217087],[-79.599103,40.217533],[-79.600562,40.218116],[-79.601172,40.218414],[-79.601372,40.218536],[-79.601655,40.218734],[-79.60194,40.218955],[-79.602153,40.219148],[-79.602345,40.219337],[-79.602601,40.219624],[-79.603453,40.220736],[-79.603959,40.221407],[-79.604801,40.222527],[-79.605175,40.223006],[-79.605427,40.223296],[-79.605682,40.223563],[-79.605933,40.223802],[-79.606109,40.22396],[-79.606332,40.22415],[-79.606426,40.224226],[-79.606587,40.224347],[-79.60684,40.224538],[-79.607239,40.224813],[-79.608072,40.225349],[-79.608715,40.225762],[-79.608966,40.225947],[-79.610651,40.227021],[-79.616233,40.230615],[-79.617958,40.231736],[-79.61822,40.231914],[-79.618488,40.232104],[-79.618789,40.232331],[-79.619101,40.232592],[-79.619288,40.232762],[-79.619467,40.232936],[-79.619644,40.233113],[-79.619805,40.23328],[-79.620021,40.233523],[-79.620244,40.233792],[-79.622222,40.236299],[-79.622776,40.237],[-79.623018,40.237304],[-79.623182,40.237502],[-79.623333,40.23768],[-79.6235,40.237863],[-79.623698,40.238067],[-79.623889,40.238242],[-79.624134,40.238452],[-79.624374,40.238647],[-79.624673,40.238865],[-79.624916,40.239024],[-79.625108,40.239146],[-79.62537,40.239299],[-79.625655,40.239451],[-79.625956,40.239593],[-79.626334,40.239758],[-79.626655,40.23988],[-79.627017,40.240004],[-79.627345,40.240103],[-79.627762,40.240206],[-79.628096,40.240278],[-79.628426,40.240341],[-79.628841,40.240408],[-79.629392,40.240479],[-79.630413,40.240613],[-79.631035,40.240719],[-79.63161,40.240852],[-79.632195,40.241017],[-79.632633,40.24116],[-79.633132,40.241342],[-79.633477,40.241484],[-79.63389,40.241669],[-79.634219,40.241832],[-79.634517,40.241993],[-79.634867,40.242205],[-79.635218,40.242437],[-79.635559,40.242685],[-79.635905,40.242951],[-79.636378,40.243363],[-79.636895,40.243884],[-79.637294,40.244378],[-79.637616,40.244818],[-79.638294,40.245833],[-79.638881,40.246685],[-79.639862,40.248164],[-79.641168,40.250136],[-79.641395,40.250461],[-79.641508,40.250645],[-79.64166,40.250901],[-79.641798,40.251146],[-79.641894,40.251367],[-79.641989,40.251609],[-79.642065,40.251862],[-79.642109,40.252047],[-79.642159,40.252306],[-79.642197,40.252564],[-79.642212,40.252735],[-79.642229,40.252958],[-79.642248,40.253507],[-79.642295,40.254817],[-79.642331,40.255849],[-79.642365,40.256571],[-79.642395,40.256928],[-79.642438,40.257237],[-79.642488,40.257493],[-79.642549,40.25771],[-79.642626,40.257936],[-79.642724,40.258176],[-79.642802,40.258353],[-79.642888,40.258528],[-79.642999,40.258716],[-79.643153,40.258953],[-79.643295,40.259157],[-79.643426,40.259332],[-79.643569,40.259496],[-79.643736,40.259673],[-79.643881,40.259819],[-79.644041,40.259965],[-79.644287,40.260176],[-79.644619,40.260425],[-79.64486,40.260586],[-79.645184,40.260777],[-79.645594,40.260996],[-79.645834,40.261107],[-79.646084,40.261218],[-79.64636,40.261323],[-79.646682,40.261436],[-79.647045,40.261543],[-79.647497,40.261664],[-79.650327,40.262362],[-79.65193,40.262762],[-79.65406,40.263291],[-79.655899,40.263745],[-79.657302,40.264097],[-79.660994,40.265],[-79.662402,40.265341],[-79.663342,40.26558],[-79.663805,40.265709],[-79.664138,40.265825],[-79.664404,40.265932],[-79.664639,40.266032],[-79.664977,40.266197],[-79.665266,40.26636],[-79.665542,40.266533],[-79.665834,40.266735],[-79.666038,40.266886],[-79.666285,40.26709],[-79.666539,40.267332],[-79.666697,40.267493],[-79.666862,40.267678],[-79.667019,40.267869],[-79.667133,40.268023],[-79.667255,40.268188],[-79.66737,40.268386],[-79.66751,40.268638],[-79.667625,40.268903],[-79.667713,40.269129],[-79.667797,40.269392],[-79.667868,40.269648],[-79.66792,40.269911],[-79.66796,40.270255],[-79.667984,40.270627],[-79.668014,40.271034],[-79.668142,40.272403],[-79.668252,40.273617],[-79.668398,40.275559],[-79.668627,40.277984],[-79.668702,40.278982],[-79.669046,40.283238],[-79.669262,40.285896],[-79.669454,40.288292],[-79.669529,40.28926],[-79.669613,40.290239],[-79.669665,40.290833],[-79.669714,40.2912],[-79.669769,40.291535],[-79.669835,40.291884],[-79.669898,40.292172],[-79.6702,40.293432],[-79.67038,40.294187],[-79.670543,40.294866],[-79.670771,40.295809],[-79.671193,40.297571],[-79.671617,40.299332],[-79.672137,40.301495],[-79.672451,40.3028],[-79.672576,40.303323],[-79.672673,40.303709],[-79.67276,40.304028],[-79.672853,40.304328],[-79.673009,40.304753],[-79.673148,40.30508],[-79.673271,40.305348],[-79.673404,40.30561],[-79.673548,40.305871],[-79.673684,40.306112],[-79.673839,40.306358],[-79.673974,40.306562],[-79.674133,40.306785],[-79.674376,40.307109],[-79.674616,40.307387],[-79.674846,40.307647],[-79.675545,40.308371],[-79.675935,40.308773],[-79.676554,40.3094],[-79.677072,40.309946],[-79.677374,40.31028],[-79.677541,40.310478],[-79.677723,40.310721],[-79.677833,40.310883],[-79.677943,40.311066],[-79.678049,40.31126],[-79.678139,40.311443],[-79.67824,40.311676],[-79.678312,40.311875],[-79.67837,40.312055],[-79.678422,40.312267],[-79.678459,40.31243],[-79.678481,40.312593],[-79.678502,40.312751],[-79.678516,40.312904],[-79.678524,40.313141],[-79.67852,40.313358],[-79.678502,40.313602],[-79.678467,40.313846],[-79.678417,40.314126],[-79.678339,40.314513],[-79.678196,40.315219],[-79.678121,40.315612],[-79.678092,40.315818],[-79.678067,40.315997],[-79.678049,40.316177],[-79.678044,40.316365],[-79.678049,40.316621],[-79.678066,40.316842],[-79.678094,40.317062],[-79.678112,40.317175],[-79.678131,40.317282],[-79.678177,40.317467],[-79.678249,40.317707],[-79.67834,40.317956],[-79.678443,40.318201],[-79.678551,40.318422],[-79.678663,40.318618],[-79.678811,40.318849],[-79.678996,40.319108],[-79.679214,40.319396],[-79.679963,40.320348],[-79.682891,40.324069],[-79.684098,40.325592],[-79.684649,40.326276],[-79.685489,40.327329],[-79.685576,40.327441],[-79.685846,40.327803],[-79.686322,40.328402],[-79.687876,40.330294],[-79.688153,40.330616],[-79.688475,40.330988],[-79.688842,40.331445],[-79.689172,40.331866],[-79.689447,40.332223],[-79.689779,40.332673],[-79.690527,40.333695],[-79.690925,40.334285],[-79.691288,40.334945],[-79.691721,40.335929],[-79.692134,40.337362],[-79.692254,40.338541],[-79.692272,40.339266],[-79.692233,40.339856],[-79.692144,40.340598],[-79.692013,40.341165],[-79.691771,40.34197],[-79.691537,40.342571],[-79.691231,40.343177],[-79.690719,40.344004],[-79.690172,40.344772],[-79.687809,40.347828],[-79.687035,40.348796],[-79.686637,40.349321],[-79.686357,40.349873],[-79.685791,40.35096],[-79.684533,40.353751],[-79.684242,40.35428],[-79.683851,40.354897],[-79.68346,40.355421],[-79.681214,40.358266],[-79.681086,40.358412],[-79.680539,40.359077],[-79.680155,40.359569],[-79.679615,40.360289],[-79.67921,40.361035],[-79.678997,40.361614],[-79.678862,40.362111],[-79.678769,40.362663],[-79.678741,40.36322],[-79.678705,40.364177],[-79.678684,40.365199],[-79.678663,40.365902],[-79.678599,40.369131],[-79.678542,40.370299],[-79.678492,40.371267],[-79.67835,40.372208],[-79.678116,40.372976],[-79.677867,40.373549],[-79.67759,40.374068],[-79.677199,40.374701],[-79.676694,40.375453],[-79.676246,40.376134],[-79.675863,40.37674],[-79.6756,40.377146],[-79.675401,40.377562],[-79.675244,40.378189],[-79.675223,40.3788],[-79.67523,40.379347],[-79.675301,40.379779],[-79.675493,40.380299],[-79.675721,40.380758],[-79.676175,40.381369],[-79.676559,40.381791],[-79.677099,40.382272],[-79.677632,40.382716],[-79.678222,40.38323],[-79.678954,40.383873],[-79.679686,40.384533],[-79.680404,40.385144],[-79.681072,40.38569],[-79.681783,40.386302],[-79.682493,40.386945],[-79.68319,40.387551],[-79.684,40.388221],[-79.684704,40.388843],[-79.685365,40.389449],[-79.685947,40.389995],[-79.686587,40.390633],[-79.687028,40.391077],[-79.687326,40.391374],[-79.687753,40.391828],[-79.688286,40.392391],[-79.689089,40.393245],[-79.689778,40.393938],[-79.69056,40.39476],[-79.691242,40.395495],[-79.691725,40.395933],[-79.692443,40.396469],[-79.692976,40.396825],[-79.693459,40.397047],[-79.693872,40.397238],[-79.695975,40.398183],[-79.697525,40.398886],[-79.698456,40.399329],[-79.699365,40.39973],[-79.700296,40.400146],[-79.701284,40.4006],[-79.701838,40.400844],[-79.703224,40.401498],[-79.70402,40.401839],[-79.704973,40.402271],[-79.705818,40.402634],[-79.706664,40.403039],[-79.707567,40.403472],[-79.708491,40.403851],[-79.709301,40.404137],[-79.710473,40.404462],[-79.711326,40.40464],[-79.712072,40.404792],[-79.712819,40.404927],[-79.713799,40.405084],[-79.714595,40.405224],[-79.715149,40.405376],[-79.716415,40.405776],[-79.717374,40.406209],[-79.718113,40.406603],[-79.721753,40.40861],[-79.722576,40.409042],[-79.723998,40.409837],[-79.724292,40.410002],[-79.726727,40.411308],[-79.727708,40.411941],[-79.728319,40.412552],[-79.728539,40.412779],[-79.729058,40.413472],[-79.730756,40.416284],[-79.732248,40.418684],[-79.73271,40.419279],[-79.733187,40.419712],[-79.733968,40.420399],[-79.736008,40.422237],[-79.736662,40.42307],[-79.737024,40.423676],[-79.737422,40.424406],[-79.73809,40.425644],[-79.738644,40.426515],[-79.73916,40.427106],[-79.7397,40.42761],[-79.740098,40.427924],[-79.742496,40.429662],[-79.743495,40.430442],[-79.745719,40.432028],[-79.746671,40.432833],[-79.747156,40.433301],[-79.747538,40.433726],[-79.747728,40.433947],[-79.748007,40.434295],[-79.748085,40.434481],[-79.748109,40.434605],[-79.748117,40.434748],[-79.748101,40.434873],[-79.748064,40.434979],[-79.747991,40.435109],[-79.747846,40.435301],[-79.747575,40.435614],[-79.747525,40.435706],[-79.747511,40.435797],[-79.747514,40.435875],[-79.74757,40.435986],[-79.747651,40.436084],[-79.74775,40.436153],[-79.747879,40.436198],[-79.748002,40.436235],[-79.748139,40.436263],[-79.748276,40.436271],[-79.748426,40.436261],[-79.748573,40.436231],[-79.749002,40.436084],[-79.74933,40.435971],[-79.751318,40.435335],[-79.751805,40.435165],[-79.751993,40.43512],[-79.752181,40.435099],[-79.752347,40.435095],[-79.75253,40.435124],[-79.752696,40.435185],[-79.752825,40.435259],[-79.752921,40.435328],[-79.75299,40.435395],[-79.753653,40.436452],[-79.754215,40.437309],[-79.754576,40.437884],[-79.75481,40.438281],[-79.755256,40.439024],[-79.755414,40.439286],[-79.755516,40.439433],[-79.755604,40.439533],[-79.755715,40.439633],[-79.755805,40.4397],[-79.755962,40.439821],[-79.756142,40.439938],[-79.756257,40.439998],[-79.756402,40.440052],[-79.75654,40.440091],[-79.756715,40.440126],[-79.756995,40.440183],[-79.75913,40.440371],[-79.759441,40.440429],[-79.759557,40.440466],[-79.759709,40.440514],[-79.760004,40.440645],[-79.76038,40.440849],[-79.760691,40.441025],[-79.761184,40.441315],[-79.76186,40.441764],[-79.76266,40.442307],[-79.763067,40.442572],[-79.763427,40.442776],[-79.763861,40.443001],[-79.764357,40.443259],[-79.764781,40.443451],[-79.765244,40.443645],[-79.765674,40.443809],[-79.766146,40.443972],[-79.766683,40.444136],[-79.767055,40.44424],[-79.767478,40.444346],[-79.768281,40.444519],[-79.768567,40.444574],[-79.768895,40.444629],[-79.76925,40.444679],[-79.769814,40.444743],[-79.770313,40.444785],[-79.77069,40.444809],[-79.771097,40.44483],[-79.771548,40.444834],[-79.772207,40.444823],[-79.772597,40.444805],[-79.772966,40.44478],[-79.77335,40.444748],[-79.773692,40.444711],[-79.774052,40.444667],[-79.774498,40.444605],[-79.775101,40.444505],[-79.777878,40.444054],[-79.778678,40.443927],[-79.782427,40.443324],[-79.784217,40.443034],[-79.786123,40.442729],[-79.787294,40.442555],[-79.788036,40.442465],[-79.788902,40.442372],[-79.789839,40.442287],[-79.79072,40.44222],[-79.791744,40.442161],[-79.792615,40.442128],[-79.793443,40.442108],[-79.79456,40.4421],[-79.796131,40.442091],[-79.798615,40.442088],[-79.802858,40.442065],[-79.80394,40.442067],[-79.804498,40.442083],[-79.80491,40.442103],[-79.805523,40.442145],[-79.806299,40.442205],[-79.809684,40.442609],[-79.810585,40.442715],[-79.811503,40.442817],[-79.812018,40.442854],[-79.812533,40.442882],[-79.813198,40.442895],[-79.813632,40.442886],[-79.814346,40.442841],[-79.815848,40.442748],[-79.818589,40.442564],[-79.820569,40.442441],[-79.821725,40.442369],[-79.8239,40.442233],[-79.824637,40.442176],[-79.825426,40.442116],[-79.826022,40.442053],[-79.826655,40.441961],[-79.827084,40.441884],[-79.827784,40.44173],[-79.8282,40.44162],[-79.8289,40.441426],[-79.829884,40.441122],[-79.8313,40.440691],[-79.831622,40.440608],[-79.832016,40.440534],[-79.83233,40.440497],[-79.832617,40.440481],[-79.832952,40.440473],[-79.833253,40.440483],[-79.833505,40.440516],[-79.833819,40.440569],[-79.834057,40.440623],[-79.834358,40.440712],[-79.834677,40.440836],[-79.834999,40.440979],[-79.835297,40.441132],[-79.837601,40.442361],[-79.83936,40.443292],[-79.840653,40.443962],[-79.841632,40.444421],[-79.842198,40.444686],[-79.842874,40.445011],[-79.843207,40.445168],[-79.843528,40.445297],[-79.843767,40.44538],[-79.844049,40.445462],[-79.844349,40.445529],[-79.844652,40.445582],[-79.84499,40.445631],[-79.845312,40.445662],[-79.845621,40.445674],[-79.845897,40.445676],[-79.846178,40.445664],[-79.846433,40.445639],[-79.846955,40.445582],[-79.848059,40.445452],[-79.848696,40.445381],[-79.849971,40.445248],[-79.850601,40.445152],[-79.8511,40.445068],[-79.851505,40.444974],[-79.851873,40.44488],[-79.852224,40.444784],[-79.852594,40.444668],[-79.853037,40.444505],[-79.853426,40.444351],[-79.853935,40.444129],[-79.854332,40.443931],[-79.854694,40.443733],[-79.855043,40.443521],[-79.855285,40.443363],[-79.855904,40.442951],[-79.857106,40.442151],[-79.858737,40.441079],[-79.860222,40.440091],[-79.861038,40.439558],[-79.861561,40.439209],[-79.862331,40.438699],[-79.862953,40.438289],[-79.863841,40.437693],[-79.86475,40.437098],[-79.865598,40.436535],[-79.865804,40.4364],[-79.866145,40.436176],[-79.86681,40.435739],[-79.867245,40.435449],[-79.867789,40.435077],[-79.868105,40.434851],[-79.868299,40.4347],[-79.86902,40.434124],[-79.870034,40.433328],[-79.870654,40.432834],[-79.871944,40.431831],[-79.872711,40.431229],[-79.873483,40.430619],[-79.873743,40.430425],[-79.873971,40.430284],[-79.874344,40.430084],[-79.874682,40.429935],[-79.875039,40.429804],[-79.875498,40.429665],[-79.875803,40.429594],[-79.876206,40.429528],[-79.876616,40.429485],[-79.876957,40.429467],[-79.877238,40.429469],[-79.87763,40.429485],[-79.878003,40.429526],[-79.878384,40.42959],[-79.878722,40.429669],[-79.879867,40.429977],[-79.880146,40.430049],[-79.880414,40.43011],[-79.880943,40.430194],[-79.881302,40.430231],[-79.881643,40.430249],[-79.88208,40.430249],[-79.882442,40.430231],[-79.88274,40.430204],[-79.883206,40.430135],[-79.883614,40.430057],[-79.88422,40.429935],[-79.88586,40.429609],[-79.886317,40.429518],[-79.887251,40.42934],[-79.887583,40.429257],[-79.887919,40.429161],[-79.88827,40.42904],[-79.888568,40.428911],[-79.888903,40.42875],[-79.889222,40.428583],[-79.889549,40.428377],[-79.890772,40.427604],[-79.891315,40.427253],[-79.891515,40.427115],[-79.891765,40.426988],[-79.891937,40.426904],[-79.892207,40.42678],[-79.892489,40.426676],[-79.892779,40.426578],[-79.893168,40.426461],[-79.893506,40.426382],[-79.893932,40.426294],[-79.894359,40.426237],[-79.894723,40.4262],[-79.895177,40.426169],[-79.896483,40.4261],[-79.898546,40.42599],[-79.90074,40.425881],[-79.902671,40.425775],[-79.904696,40.425652],[-79.90777,40.425488],[-79.908226,40.425489],[-79.908513,40.425496],[-79.908867,40.425526],[-79.909293,40.425575],[-79.911544,40.425905],[-79.926473,40.428117],[-79.927017,40.428219],[-79.927404,40.428293],[-79.92749,40.428313],[-79.927699,40.428362],[-79.928632,40.428591],[-79.929126,40.428707],[-79.92963,40.42881],[-79.930027,40.428871],[-79.930418,40.428914],[-79.930912,40.428957],[-79.931349,40.428985],[-79.93184,40.429001],[-79.932245,40.428993],[-79.932755,40.428971],[-79.933294,40.428924],[-79.933809,40.428859],[-79.93567,40.428607],[-79.936099,40.428569],[-79.936496,40.42856],[-79.936869,40.42856],[-79.937151,40.428569],[-79.93758,40.428603],[-79.938028,40.428664],[-79.938165,40.428683],[-79.940069,40.429063],[-79.940954,40.429234],[-79.941426,40.429297],[-79.941828,40.429328],[-79.942201,40.429342],[-79.942526,40.429342],[-79.942818,40.429332],[-79.94317,40.429306],[-79.943475,40.429271],[-79.94384,40.429212],[-79.944023,40.429177],[-79.944291,40.429126],[-79.945299,40.428881],[-79.947542,40.42832],[-79.95031,40.427621],[-79.950682,40.42754],[-79.950812,40.427514],[-79.951087,40.42746],[-79.951358,40.427425],[-79.951758,40.427397],[-79.952099,40.427393],[-79.95249,40.427405],[-79.952836,40.427437],[-79.953239,40.427499],[-79.95363,40.427587],[-79.953957,40.427678],[-79.954325,40.427813],[-79.954722,40.427981],[-79.955049,40.428148],[-79.955309,40.428299],[-79.955529,40.428454],[-79.955757,40.428628],[-79.956009,40.42885],[-79.956385,40.429244],[-79.957144,40.430045],[-79.957828,40.430768],[-79.958032,40.430976],[-79.95826,40.431188],[-79.958533,40.431411],[-79.958772,40.431584],[-79.959059,40.43177],[-79.959125,40.431809],[-79.959378,40.431958],[-79.959716,40.432137],[-79.960057,40.432295],[-79.963543,40.433803],[-79.96622,40.434965],[-79.966752,40.435186],[-79.967272,40.435367],[-79.9678,40.435547],[-79.968305,40.435698],[-79.9693,40.435951],[-79.970204,40.436182],[-79.97133,40.436461],[-79.971767,40.436574],[-79.972078,40.436649],[-79.972253,40.436678],[-79.972483,40.436704],[-79.972652,40.436719],[-79.972964,40.436723],[-79.973318,40.436698],[-79.973894,40.436645],[-79.974932,40.436536],[-79.975428,40.436496],[-79.977783,40.436243],[-79.979593,40.436045],[-79.981548,40.435798],[-79.982805,40.43565],[-79.983331,40.435592],[-79.983828,40.435528],[-79.984413,40.43544],[-79.984802,40.435361],[-79.985727,40.435204],[-79.986393,40.435104],[-79.986913,40.435049],[-79.987913,40.434971],[-79.988745,40.434922],[-79.989335,40.434914],[-79.990577,40.434922],[-79.99118,40.434933],[-79.991491,40.434957],[-79.991824,40.435008],[-79.992151,40.43508],[-79.992841,40.43529],[-79.993339,40.435445],[-79.99364,40.435547],[-79.994213,40.435767],[-79.994423,40.435876],[-79.994492,40.435916],[-79.994547,40.435954],[-79.994593,40.435995],[-79.994629,40.43603],[-79.994673,40.43608],[-79.994704,40.436122],[-79.994729,40.436162],[-79.994758,40.436223],[-79.994774,40.436265],[-79.994785,40.436312],[-79.994789,40.436368],[-79.994791,40.436428],[-79.994788,40.436486],[-79.994779,40.436541],[-79.994758,40.436623],[-79.994737,40.436691],[-79.994695,40.436806],[-79.994533,40.43719],[-79.994331,40.437662],[-79.994015,40.43838],[-79.993844,40.43871],[-79.99368,40.438989],[-79.993638,40.439069],[-79.993591,40.439158],[-79.993449,40.439358],[-79.993242,40.43961],[-79.992891,40.440014],[-79.992772,40.440112],[-79.992668,40.44018],[-79.992553,40.440239],[-79.992462,40.440277],[-79.99238,40.440303],[-79.99229,40.440324],[-79.992203,40.440337],[-79.992092,40.440344],[-79.991736,40.440348],[-79.991665,40.440347],[-79.991564,40.440351],[-79.991398,40.440369],[-79.9909,40.440441],[-79.990477,40.440436],[-79.989656,40.44044],[-79.989651,40.440546],[-79.990471,40.44054],[-79.990477,40.440742],[-79.990477,40.440904],[-79.99009,40.440907]]},{_id:'3',truck:'1',from:{name:'Baltimore',lat:39.290887,lng:-76.611076},to:{name:'Wsh DC',lat:38.895,lng:-77.039472},startDate:new Date(2017,10,3,15,0),endDate:new Date(2017,10,3,18,0),km:350,revenue:724.50,selected:false,drive:3,duty:1,off:4,berth:2,time:6,distance:50,fuel:250,tolls:120,vectorPath:[[-76.611076,39.290887],[-76.611048,39.290519],[-76.611041,39.290444],[-76.611028,39.290134],[-76.611002,39.289775],[-76.610978,39.289697],[-76.610917,39.288969],[-76.610872,39.288523],[-76.610858,39.288331],[-76.610854,39.288279],[-76.610835,39.287996],[-76.610827,39.287886],[-76.611209,39.28784],[-76.611746,39.287812],[-76.612056,39.287796],[-76.612159,39.287791],[-76.612258,39.287784],[-76.612365,39.287782],[-76.612856,39.287766],[-76.612962,39.287764],[-76.613097,39.287762],[-76.613368,39.287757],[-76.613509,39.287755],[-76.613622,39.287753],[-76.613617,39.287654],[-76.613602,39.287363],[-76.613586,39.287036],[-76.613571,39.286761],[-76.613563,39.286639],[-76.613554,39.286538],[-76.613549,39.28647],[-76.613458,39.285579],[-76.613422,39.285197],[-76.613354,39.284536],[-76.613335,39.284351],[-76.613485,39.284343],[-76.614596,39.284292],[-76.614691,39.284287],[-76.614797,39.284281],[-76.615013,39.284272],[-76.615432,39.284251],[-76.615829,39.28423],[-76.616305,39.284206],[-76.616736,39.284185],[-76.617511,39.284147],[-76.61767,39.284135],[-76.6178,39.28413],[-76.618159,39.284112],[-76.618471,39.284096],[-76.618802,39.284071],[-76.618914,39.284055],[-76.61898,39.28404],[-76.61905,39.284021],[-76.619145,39.283965],[-76.61919,39.283924],[-76.619207,39.283883],[-76.619221,39.283811],[-76.619236,39.28372],[-76.619221,39.283489],[-76.619199,39.283145],[-76.619175,39.282822],[-76.619161,39.282601],[-76.619142,39.282277],[-76.619124,39.282032],[-76.61906,39.281729],[-76.61905,39.281507],[-76.619032,39.28119],[-76.619014,39.280853],[-76.618986,39.28041],[-76.618981,39.280311],[-76.618975,39.280202],[-76.618969,39.280092],[-76.618967,39.279983],[-76.618972,39.279868],[-76.618973,39.27978],[-76.618982,39.279664],[-76.61899,39.279548],[-76.619013,39.27939],[-76.619069,39.279118],[-76.619127,39.278773],[-76.619206,39.2785],[-76.619287,39.27826],[-76.619301,39.278228],[-76.619341,39.278126],[-76.619353,39.278098],[-76.619392,39.278003],[-76.619404,39.277973],[-76.619454,39.27786],[-76.619996,39.276768],[-76.62129,39.273954],[-76.622988,39.270211],[-76.623184,39.269838],[-76.623397,39.269515],[-76.623644,39.26923],[-76.623919,39.268976],[-76.624172,39.268776],[-76.624509,39.268558],[-76.62472,39.268465],[-76.624898,39.268385],[-76.625162,39.268308],[-76.625498,39.268225],[-76.625777,39.268189],[-76.626051,39.268177],[-76.626425,39.268192],[-76.626776,39.26822],[-76.627201,39.268272],[-76.627628,39.268343],[-76.628049,39.268436],[-76.628518,39.26855],[-76.629241,39.268707],[-76.630415,39.268924],[-76.631268,39.269111],[-76.63286,39.269433],[-76.63404,39.269653],[-76.634863,39.269793],[-76.635757,39.269939],[-76.636404,39.270034],[-76.637124,39.27014],[-76.637928,39.270253],[-76.639189,39.270401],[-76.640168,39.270508],[-76.64256,39.270756],[-76.643705,39.270858],[-76.646733,39.271107],[-76.64952,39.271348],[-76.651426,39.271527],[-76.651881,39.271558],[-76.652413,39.271581],[-76.652833,39.271568],[-76.653221,39.271541],[-76.653721,39.271489],[-76.654101,39.271419],[-76.654508,39.271329],[-76.654832,39.271243],[-76.655163,39.271139],[-76.655465,39.271032],[-76.655757,39.270915],[-76.65743,39.27017],[-76.660191,39.268949],[-76.66051,39.268807],[-76.663957,39.267304],[-76.664664,39.266996],[-76.666471,39.266208],[-76.669436,39.264904],[-76.669902,39.264686],[-76.670269,39.264493],[-76.670724,39.264221],[-76.671153,39.263924],[-76.671568,39.263597],[-76.671935,39.263265],[-76.672273,39.262906],[-76.672502,39.262629],[-76.672778,39.262252],[-76.673195,39.261667],[-76.673942,39.260471],[-76.674915,39.258992],[-76.676005,39.257327],[-76.676284,39.256892],[-76.676997,39.255811],[-76.677334,39.255328],[-76.677616,39.254939],[-76.677975,39.254457],[-76.678354,39.253975],[-76.678718,39.253531],[-76.67901,39.253187],[-76.679787,39.252303],[-76.68,39.252075],[-76.680493,39.25156],[-76.680919,39.251131],[-76.681486,39.250585],[-76.682217,39.249912],[-76.682546,39.249624],[-76.682968,39.249266],[-76.683456,39.24886],[-76.684057,39.248383],[-76.684609,39.24796],[-76.684948,39.247707],[-76.685419,39.247366],[-76.685953,39.246998],[-76.68659,39.246566],[-76.687288,39.246097],[-76.690608,39.24386],[-76.691903,39.24299],[-76.69333,39.242028],[-76.693667,39.241809],[-76.693998,39.241605],[-76.694378,39.241377],[-76.694709,39.241198],[-76.695133,39.240984],[-76.695455,39.240834],[-76.695826,39.240679],[-76.696277,39.240506],[-76.696724,39.240353],[-76.697103,39.240234],[-76.69752,39.240119],[-76.697857,39.240035],[-76.698266,39.239944],[-76.69862,39.239881],[-76.699012,39.239812],[-76.699308,39.239771],[-76.699706,39.239725],[-76.700107,39.239686],[-76.700684,39.239652],[-76.701682,39.23961],[-76.702248,39.239568],[-76.702812,39.239493],[-76.703359,39.239384],[-76.703899,39.239239],[-76.704494,39.23902],[-76.705052,39.238797],[-76.705705,39.238489],[-76.706734,39.238076],[-76.707828,39.237558],[-76.70803,39.237484],[-76.708246,39.237423],[-76.708464,39.237388],[-76.708661,39.237375],[-76.708848,39.237374],[-76.709581,39.237395],[-76.709821,39.237394],[-76.710022,39.237375],[-76.710253,39.237322],[-76.710408,39.237266],[-76.710554,39.237196],[-76.710749,39.237057],[-76.710849,39.236958],[-76.710933,39.236867],[-76.711005,39.236756],[-76.711049,39.236664],[-76.711089,39.236556],[-76.711118,39.23641],[-76.711122,39.236268],[-76.711102,39.236138],[-76.711059,39.236009],[-76.710986,39.235868],[-76.710859,39.235685],[-76.71051,39.23527],[-76.710195,39.234979],[-76.709888,39.234717],[-76.709494,39.234439],[-76.709016,39.234125],[-76.708246,39.233624],[-76.706515,39.232644],[-76.705482,39.232057],[-76.705105,39.23183],[-76.704654,39.23156],[-76.704349,39.23135],[-76.704092,39.231161],[-76.703779,39.230907],[-76.703448,39.230599],[-76.703139,39.230266],[-76.702883,39.229952],[-76.702622,39.229574],[-76.702392,39.229199],[-76.702233,39.228886],[-76.702064,39.228476],[-76.701946,39.228108],[-76.701859,39.227745],[-76.701812,39.22748],[-76.701778,39.227144],[-76.701767,39.226752],[-76.701779,39.226479],[-76.701806,39.226207],[-76.701856,39.22592],[-76.701972,39.225206],[-76.702073,39.224574],[-76.702191,39.223872],[-76.702252,39.223433],[-76.702289,39.222968],[-76.702288,39.22252],[-76.702264,39.2221],[-76.702213,39.221677],[-76.702113,39.221184],[-76.701977,39.220602],[-76.701865,39.220285],[-76.701756,39.219954],[-76.701545,39.219444],[-76.701395,39.219133],[-76.701216,39.218793],[-76.701004,39.21842],[-76.700805,39.218117],[-76.700552,39.217769],[-76.700312,39.217468],[-76.700001,39.21713],[-76.699612,39.216745],[-76.699302,39.216466],[-76.699017,39.216222],[-76.696715,39.214352],[-76.696467,39.214127],[-76.696199,39.21388],[-76.695955,39.213626],[-76.695703,39.213335],[-76.695496,39.21306],[-76.695303,39.212732],[-76.695124,39.212376],[-76.695003,39.21203],[-76.694909,39.211669],[-76.694859,39.211349],[-76.694833,39.210967],[-76.694866,39.210548],[-76.694922,39.210154],[-76.694988,39.209784],[-76.695856,39.205796],[-76.695984,39.205372],[-76.696086,39.205002],[-76.696151,39.204627],[-76.696284,39.203944],[-76.696722,39.201608],[-76.696753,39.201453],[-76.696789,39.201323],[-76.696838,39.201188],[-76.696918,39.20104],[-76.697,39.20089],[-76.697125,39.200708],[-76.697246,39.200567],[-76.697466,39.200357],[-76.697629,39.20023],[-76.697794,39.200119],[-76.697975,39.200017],[-76.698165,39.199927],[-76.700284,39.199053],[-76.701323,39.198594],[-76.703141,39.197908],[-76.703641,39.197711],[-76.704135,39.197508],[-76.704732,39.197244],[-76.705215,39.197012],[-76.705806,39.196711],[-76.706368,39.196401],[-76.706935,39.196068],[-76.707471,39.195727],[-76.708004,39.195366],[-76.708511,39.194994],[-76.708999,39.194615],[-76.709574,39.194132],[-76.710032,39.193717],[-76.710474,39.193289],[-76.710883,39.192859],[-76.711628,39.192036],[-76.715552,39.187682],[-76.715633,39.187592],[-76.716536,39.18659],[-76.719029,39.183823],[-76.721035,39.181598],[-76.72405,39.17825],[-76.726947,39.175032],[-76.727229,39.174717],[-76.727766,39.174124],[-76.73055,39.17103],[-76.730749,39.170805],[-76.730804,39.170743],[-76.731124,39.170387],[-76.731225,39.170275],[-76.731309,39.170183],[-76.731423,39.170059],[-76.733234,39.168041],[-76.7338,39.167409],[-76.734295,39.166882],[-76.734727,39.166446],[-76.735412,39.165774],[-76.735965,39.16526],[-76.736717,39.164587],[-76.742314,39.159457],[-76.745858,39.156123],[-76.748365,39.153794],[-76.74873,39.153449],[-76.749211,39.152955],[-76.749627,39.152494],[-76.750045,39.151981],[-76.750381,39.15154],[-76.750715,39.151068],[-76.750967,39.150687],[-76.751201,39.1503],[-76.751435,39.149887],[-76.751619,39.14953],[-76.751759,39.149249],[-76.751896,39.148962],[-76.753055,39.146417],[-76.753609,39.145138],[-76.753792,39.144744],[-76.755553,39.140962],[-76.755691,39.140653],[-76.755836,39.14033],[-76.755972,39.140027],[-76.756781,39.138242],[-76.757088,39.137565],[-76.7574,39.136875],[-76.758096,39.135345],[-76.758802,39.134013],[-76.759202,39.133357],[-76.759758,39.132542],[-76.760349,39.131705],[-76.760844,39.131028],[-76.761354,39.130349],[-76.762036,39.129462],[-76.76267,39.128667],[-76.763293,39.127908],[-76.764871,39.126034],[-76.765712,39.125061],[-76.766553,39.124102],[-76.767349,39.123205],[-76.768234,39.122229],[-76.768747,39.121669],[-76.769486,39.120894],[-76.770084,39.120287],[-76.77048,39.119891],[-76.770883,39.119515],[-76.771478,39.118972],[-76.773027,39.11772],[-76.773907,39.117039],[-76.774659,39.116517],[-76.777586,39.114613],[-76.777924,39.114395],[-76.780515,39.112707],[-76.781167,39.112261],[-76.781741,39.111855],[-76.782407,39.111362],[-76.783042,39.110871],[-76.784107,39.110046],[-76.786509,39.108003],[-76.787567,39.107191],[-76.788493,39.106526],[-76.788937,39.106211],[-76.789395,39.105901],[-76.790046,39.105472],[-76.791027,39.104851],[-76.792238,39.104095],[-76.793223,39.103474],[-76.794202,39.102837],[-76.795161,39.102194],[-76.796005,39.10161],[-76.796736,39.101092],[-76.797317,39.100668],[-76.797933,39.100212],[-76.798779,39.099568],[-76.799373,39.099102],[-76.799713,39.098834],[-76.800616,39.098101],[-76.801043,39.097746],[-76.801809,39.097097],[-76.802562,39.096438],[-76.802997,39.096046],[-76.803395,39.095688],[-76.803892,39.095226],[-76.804395,39.094752],[-76.804963,39.0942],[-76.805644,39.093544],[-76.805996,39.09319],[-76.806429,39.092763],[-76.80735,39.091859],[-76.808067,39.091154],[-76.808726,39.090505],[-76.80941,39.089855],[-76.810105,39.089202],[-76.810816,39.088547],[-76.811537,39.087905],[-76.812199,39.087325],[-76.81287,39.086752],[-76.813612,39.086133],[-76.814334,39.085542],[-76.815021,39.084996],[-76.815762,39.084413],[-76.81652,39.083833],[-76.817329,39.083227],[-76.818045,39.082688],[-76.818837,39.082075],[-76.819635,39.081437],[-76.820416,39.0808],[-76.821042,39.080276],[-76.821733,39.079672],[-76.822398,39.079086],[-76.82297,39.078572],[-76.823416,39.078151],[-76.82423,39.07738],[-76.8251,39.076517],[-76.825966,39.075635],[-76.826733,39.074835],[-76.827475,39.074031],[-76.828193,39.073238],[-76.828891,39.072433],[-76.829522,39.071685],[-76.830059,39.07104],[-76.830609,39.070356],[-76.831199,39.069587],[-76.831875,39.068759],[-76.832354,39.068139],[-76.832985,39.067329],[-76.83342,39.066756],[-76.834023,39.065958],[-76.834614,39.065154],[-76.835516,39.063867],[-76.835934,39.063244],[-76.836502,39.062369],[-76.837048,39.061492],[-76.837551,39.060645],[-76.837838,39.060141],[-76.838447,39.059055],[-76.838526,39.058906],[-76.838715,39.058549],[-76.83949,39.057008],[-76.839695,39.056581],[-76.840154,39.05557],[-76.840594,39.054556],[-76.840967,39.053701],[-76.841391,39.052763],[-76.842064,39.051392],[-76.842405,39.050743],[-76.84274,39.050121],[-76.843283,39.049163],[-76.843624,39.048588],[-76.844171,39.047696],[-76.845384,39.045818],[-76.846067,39.044719],[-76.846443,39.044083],[-76.846816,39.043442],[-76.847326,39.042536],[-76.848002,39.041317],[-76.848388,39.040613],[-76.848782,39.03989],[-76.849467,39.03863],[-76.850307,39.037058],[-76.850575,39.03655],[-76.851009,39.035725],[-76.851427,39.034926],[-76.85179,39.034232],[-76.852154,39.033546],[-76.852338,39.033163],[-76.8527,39.032437],[-76.853366,39.031113],[-76.853563,39.030715],[-76.853842,39.030154],[-76.854249,39.029312],[-76.854425,39.028953],[-76.854975,39.027807],[-76.855547,39.026587],[-76.855731,39.026195],[-76.856309,39.024929],[-76.856883,39.023658],[-76.85725,39.022824],[-76.85762,39.021976],[-76.857908,39.021308],[-76.858162,39.02071],[-76.858463,39.020002],[-76.858947,39.018812],[-76.859229,39.018096],[-76.859453,39.017511],[-76.859884,39.016336],[-76.860681,39.014076],[-76.861882,39.010665],[-76.862603,39.008605],[-76.862862,39.007872],[-76.862988,39.007511],[-76.863587,39.006034],[-76.863838,39.005415],[-76.864086,39.00489],[-76.86437,39.004312],[-76.864479,39.004111],[-76.86472,39.003672],[-76.864975,39.003268],[-76.865235,39.002883],[-76.865577,39.002428],[-76.865874,39.002067],[-76.866211,39.001693],[-76.86651,39.001379],[-76.866882,39.001023],[-76.867231,39.000708],[-76.867627,39.000378],[-76.868121,39],[-76.868547,38.999696],[-76.868876,38.999471],[-76.869243,38.999233],[-76.869778,38.998905],[-76.870196,38.998669],[-76.870709,38.998387],[-76.871244,38.998121],[-76.871708,38.997899],[-76.8723,38.997638],[-76.872905,38.99739],[-76.87353,38.997161],[-76.87407,38.996978],[-76.874605,38.99681],[-76.876128,38.996367],[-76.877184,38.996057],[-76.87812,38.995788],[-76.878902,38.995558],[-76.879629,38.995339],[-76.880216,38.995136],[-76.880798,38.994919],[-76.881202,38.994761],[-76.881509,38.99463],[-76.882075,38.994365],[-76.88253,38.994108],[-76.883141,38.993783],[-76.88359,38.993528],[-76.884018,38.993271],[-76.884479,38.992986],[-76.885018,38.992636],[-76.885603,38.992235],[-76.885755,38.992127],[-76.885834,38.992071],[-76.886003,38.991952],[-76.886405,38.991666],[-76.886801,38.991373],[-76.887023,38.991206],[-76.887504,38.990827],[-76.887909,38.990494],[-76.888279,38.990168],[-76.888839,38.989663],[-76.889302,38.989241],[-76.890016,38.98858],[-76.890363,38.988215],[-76.890699,38.987858],[-76.891069,38.987437],[-76.891401,38.987036],[-76.891697,38.986651],[-76.892024,38.986161],[-76.892294,38.985725],[-76.89251,38.985278],[-76.892745,38.984776],[-76.892944,38.984285],[-76.893118,38.98378],[-76.893255,38.983308],[-76.893358,38.982885],[-76.893829,38.980498],[-76.893941,38.980065],[-76.894074,38.979638],[-76.894258,38.979144],[-76.894459,38.978693],[-76.894671,38.978263],[-76.894936,38.97781],[-76.895184,38.977426],[-76.895439,38.977065],[-76.895771,38.976646],[-76.896168,38.976177],[-76.896647,38.975622],[-76.896957,38.975274],[-76.89727,38.97491],[-76.897609,38.974518],[-76.897981,38.974074],[-76.89835,38.973598],[-76.898689,38.973105],[-76.898905,38.972761],[-76.899181,38.972296],[-76.899452,38.971816],[-76.899721,38.97135],[-76.900058,38.970804],[-76.900402,38.970271],[-76.900711,38.96981],[-76.901054,38.969319],[-76.901438,38.968793],[-76.901734,38.968406],[-76.902038,38.96802],[-76.903503,38.966228],[-76.904069,38.965523],[-76.904433,38.965005],[-76.904638,38.964667],[-76.904822,38.964321],[-76.90506,38.96379],[-76.905198,38.963422],[-76.90533,38.962952],[-76.905371,38.962776],[-76.905425,38.96253],[-76.90546,38.962265],[-76.90549,38.961969],[-76.905507,38.961696],[-76.905515,38.961381],[-76.905513,38.961013],[-76.905491,38.960069],[-76.905488,38.959799],[-76.905491,38.959575],[-76.905504,38.959371],[-76.905516,38.959178],[-76.905539,38.958975],[-76.905568,38.958806],[-76.90561,38.958592],[-76.90566,38.958377],[-76.905726,38.958171],[-76.905775,38.958],[-76.905853,38.957799],[-76.906025,38.957411],[-76.906176,38.957123],[-76.906312,38.956894],[-76.906499,38.956615],[-76.906683,38.956366],[-76.90685,38.95616],[-76.907032,38.955956],[-76.907336,38.95564],[-76.907779,38.955196],[-76.908139,38.954834],[-76.908422,38.954535],[-76.908652,38.95426],[-76.90886,38.95399],[-76.909047,38.953719],[-76.90922,38.953441],[-76.909413,38.953099],[-76.909562,38.952771],[-76.909688,38.952463],[-76.909797,38.952138],[-76.909889,38.9518],[-76.909967,38.951423],[-76.910008,38.951115],[-76.910035,38.950762],[-76.910044,38.950435],[-76.910023,38.950042],[-76.90999,38.949642],[-76.909821,38.947651],[-76.909793,38.947291],[-76.909781,38.946941],[-76.90979,38.946546],[-76.90981,38.946222],[-76.909859,38.945848],[-76.909914,38.945522],[-76.910003,38.945126],[-76.910071,38.944873],[-76.910193,38.944494],[-76.910298,38.94422],[-76.910438,38.943887],[-76.910616,38.943519],[-76.910847,38.943103],[-76.911034,38.942791],[-76.911214,38.942504],[-76.911391,38.94224],[-76.911621,38.94195],[-76.911902,38.941635],[-76.912025,38.941506],[-76.912215,38.941309],[-76.912415,38.941113],[-76.912722,38.940826],[-76.913153,38.940428],[-76.91346,38.940147],[-76.913731,38.939874],[-76.914019,38.939553],[-76.914238,38.93929],[-76.914476,38.939004],[-76.914705,38.938673],[-76.914823,38.938482],[-76.914982,38.938203],[-76.915174,38.937843],[-76.915262,38.937672],[-76.915526,38.937158],[-76.915751,38.936754],[-76.915993,38.936375],[-76.916301,38.935966],[-76.916524,38.93571],[-76.916868,38.935355],[-76.916928,38.935293],[-76.917183,38.935061],[-76.917498,38.934793],[-76.917811,38.934546],[-76.918203,38.934278],[-76.918571,38.934039],[-76.919126,38.933731],[-76.919482,38.933549],[-76.920121,38.933275],[-76.921637,38.932693],[-76.922335,38.932421],[-76.922768,38.932243],[-76.923238,38.932026],[-76.923667,38.931805],[-76.924088,38.931561],[-76.924481,38.931313],[-76.92485,38.931053],[-76.925121,38.930838],[-76.925409,38.930598],[-76.925708,38.930326],[-76.92597,38.930065],[-76.926192,38.929825],[-76.926359,38.929628],[-76.92652,38.929435],[-76.926873,38.928958],[-76.928242,38.927093],[-76.928489,38.926745],[-76.928946,38.926129],[-76.929522,38.925397],[-76.929678,38.92521],[-76.929845,38.925028],[-76.92996,38.924913],[-76.93008,38.924799],[-76.930214,38.924678],[-76.930351,38.924563],[-76.93043,38.924495],[-76.930809,38.924122],[-76.931432,38.923568],[-76.931898,38.923154],[-76.932227,38.922842],[-76.932486,38.922551],[-76.932683,38.922282],[-76.932804,38.922083],[-76.932913,38.921886],[-76.932999,38.92171],[-76.93309,38.921495],[-76.933149,38.921313],[-76.933194,38.921125],[-76.933237,38.920908],[-76.933256,38.920753],[-76.933265,38.920577],[-76.933265,38.920382],[-76.933252,38.920115],[-76.933208,38.919856],[-76.933148,38.919534],[-76.933105,38.919304],[-76.932988,38.918628],[-76.932901,38.918201],[-76.932731,38.917374],[-76.932701,38.916962],[-76.932684,38.916744],[-76.932615,38.916332],[-76.932582,38.915927],[-76.932583,38.915646],[-76.932605,38.915321],[-76.932638,38.915086],[-76.932676,38.914847],[-76.932707,38.914731],[-76.932704,38.914621],[-76.932824,38.914281],[-76.932988,38.913897],[-76.933122,38.91363],[-76.933237,38.913434],[-76.933487,38.913094],[-76.933739,38.912783],[-76.934,38.912469],[-76.934315,38.912105],[-76.934493,38.911907],[-76.934734,38.911637],[-76.935052,38.911275],[-76.935143,38.911173],[-76.935373,38.910915],[-76.936256,38.909918],[-76.936649,38.909472],[-76.936848,38.90925],[-76.936985,38.909096],[-76.937352,38.908683],[-76.937919,38.908043],[-76.938022,38.907928],[-76.938345,38.907561],[-76.938642,38.907226],[-76.938999,38.906826],[-76.939504,38.906246],[-76.939925,38.905766],[-76.940191,38.905497],[-76.94048,38.905215],[-76.940703,38.905027],[-76.942089,38.903945],[-76.942989,38.90323],[-76.94366,38.902687],[-76.944292,38.902095],[-76.944686,38.901735],[-76.944802,38.901635],[-76.945593,38.900934],[-76.945753,38.900796],[-76.946175,38.900462],[-76.946653,38.90008],[-76.946832,38.899937],[-76.947233,38.89963],[-76.947528,38.899398],[-76.947722,38.899248],[-76.948481,38.898652],[-76.949084,38.898181],[-76.949951,38.89751],[-76.950307,38.897219],[-76.951089,38.896607],[-76.951487,38.89629],[-76.951743,38.896075],[-76.95202,38.895829],[-76.95361,38.894344],[-76.953948,38.894012],[-76.954499,38.89347],[-76.954805,38.893146],[-76.955227,38.892698],[-76.956067,38.891845],[-76.956631,38.891255],[-76.956861,38.891016],[-76.957078,38.890816],[-76.957427,38.890523],[-76.957676,38.890331],[-76.957888,38.890191],[-76.95828,38.889976],[-76.958848,38.889713],[-76.959825,38.889243],[-76.96049,38.888924],[-76.960629,38.888843],[-76.960762,38.888751],[-76.960891,38.888655],[-76.961015,38.888556],[-76.961133,38.888452],[-76.961231,38.888371],[-76.961325,38.888287],[-76.961415,38.888201],[-76.961501,38.888112],[-76.961606,38.887998],[-76.961705,38.887882],[-76.961857,38.887687],[-76.961939,38.887567],[-76.961978,38.887509],[-76.962139,38.887212],[-76.962271,38.886945],[-76.962456,38.886485],[-76.96298,38.885211],[-76.963045,38.885065],[-76.963224,38.884608],[-76.963365,38.884266],[-76.963534,38.8838],[-76.963835,38.883044],[-76.96413,38.882322],[-76.964403,38.881714],[-76.964859,38.880888],[-76.965165,38.880389],[-76.965417,38.880004],[-76.965916,38.879363],[-76.96631,38.878894],[-76.966793,38.878357],[-76.967228,38.877921],[-76.967769,38.877426],[-76.968158,38.8771],[-76.968453,38.876874],[-76.968778,38.876655],[-76.9691,38.876471],[-76.96947,38.876294],[-76.969813,38.87615],[-76.970221,38.876018],[-76.970513,38.875945],[-76.970934,38.875862],[-76.971315,38.875807],[-76.972662,38.875688],[-76.973053,38.875642],[-76.973448,38.875588],[-76.973759,38.87553],[-76.974035,38.875469],[-76.974314,38.875392],[-76.974671,38.875283],[-76.975081,38.875144],[-76.975912,38.874832],[-76.976228,38.874705],[-76.977085,38.87436],[-76.97782,38.874068],[-76.978399,38.873817],[-76.978714,38.873666],[-76.978857,38.873597],[-76.979011,38.873523],[-76.980395,38.872834],[-76.981516,38.872308],[-76.981811,38.872193],[-76.985333,38.870792],[-76.986151,38.870527],[-76.986576,38.87044],[-76.986765,38.870437],[-76.986935,38.870429],[-76.987285,38.870422],[-76.987528,38.870442],[-76.98778,38.870497],[-76.988015,38.870585],[-76.988245,38.870697],[-76.988481,38.870861],[-76.988853,38.871103],[-76.990305,38.872852],[-76.990601,38.87324],[-76.990694,38.873475],[-76.990788,38.873617],[-76.990889,38.873822],[-76.990933,38.873979],[-76.990974,38.874211],[-76.990992,38.874441],[-76.991,38.874552],[-76.990987,38.874773],[-76.990976,38.874944],[-76.990939,38.875247],[-76.990912,38.8754],[-76.990845,38.875938],[-76.990818,38.876243],[-76.990764,38.876571],[-76.990741,38.876693],[-76.990741,38.876749],[-76.990742,38.876804],[-76.990747,38.876916],[-76.990754,38.876978],[-76.990775,38.877102],[-76.99079,38.877163],[-76.990808,38.877224],[-76.990828,38.877284],[-76.99085,38.877344],[-76.990876,38.877403],[-76.990904,38.877461],[-76.991046,38.877628],[-76.991136,38.877705],[-76.991293,38.877826],[-76.991577,38.877972],[-76.991786,38.878033],[-76.992121,38.878129],[-76.992545,38.878233],[-76.992712,38.878271],[-76.992985,38.878361],[-76.993125,38.878396],[-76.993349,38.87844],[-76.993654,38.8785],[-76.993815,38.878534],[-76.994059,38.878584],[-76.994235,38.878622],[-76.994755,38.878735],[-76.995636,38.878925],[-76.996389,38.879107],[-76.997121,38.879284],[-76.998487,38.879646],[-76.998814,38.879733],[-76.999798,38.879994],[-77.000346,38.880138],[-77.000759,38.880253],[-77.001814,38.880545],[-77.002252,38.880666],[-77.002481,38.880729],[-77.002818,38.880805],[-77.003226,38.88088],[-77.003392,38.880908],[-77.00376,38.880942],[-77.003983,38.880957],[-77.004119,38.880962],[-77.004757,38.880983],[-77.005154,38.880991],[-77.005533,38.88099],[-77.005834,38.880995],[-77.006069,38.881007],[-77.006607,38.881056],[-77.006687,38.881067],[-77.006814,38.881084],[-77.006953,38.881107],[-77.007085,38.881138],[-77.007292,38.881186],[-77.007461,38.881228],[-77.007713,38.881294],[-77.007889,38.881343],[-77.008138,38.881414],[-77.008634,38.881551],[-77.009261,38.881727],[-77.009801,38.881876],[-77.010939,38.882195],[-77.011303,38.882286],[-77.011478,38.882322],[-77.011682,38.882361],[-77.011785,38.882379],[-77.012061,38.882427],[-77.012233,38.882451],[-77.01232,38.882461],[-77.012483,38.882476],[-77.012668,38.882487],[-77.012756,38.88249],[-77.012891,38.882493],[-77.013174,38.882497],[-77.013372,38.882497],[-77.013438,38.882496],[-77.013581,38.882497],[-77.013723,38.882497],[-77.015072,38.882508],[-77.015398,38.882511],[-77.015851,38.882536],[-77.015977,38.882537],[-77.016106,38.882537],[-77.016262,38.882537],[-77.0164,38.882537],[-77.016543,38.882536],[-77.01668,38.882536],[-77.01682,38.882536],[-77.016958,38.882536],[-77.017109,38.882536],[-77.017356,38.88253],[-77.017433,38.882533],[-77.017558,38.882531],[-77.017683,38.882529],[-77.017788,38.882528],[-77.018522,38.882529],[-77.018668,38.882528],[-77.018803,38.882529],[-77.018922,38.882528],[-77.019067,38.882526],[-77.019211,38.882525],[-77.01936,38.882527],[-77.01949,38.882529],[-77.019644,38.882527],[-77.019786,38.882526],[-77.01992,38.882524],[-77.020062,38.882525],[-77.020195,38.882526],[-77.020352,38.882528],[-77.020478,38.882529],[-77.020623,38.882527],[-77.020759,38.882528],[-77.020909,38.882537],[-77.021043,38.882543],[-77.021181,38.88255],[-77.02132,38.882563],[-77.021463,38.88262],[-77.021597,38.882629],[-77.022138,38.882666],[-77.02228,38.882676],[-77.022419,38.882684],[-77.022564,38.882698],[-77.022709,38.882709],[-77.022846,38.882718],[-77.022992,38.882727],[-77.023118,38.882732],[-77.02327,38.882736],[-77.02341,38.882742],[-77.023547,38.882746],[-77.023692,38.88275],[-77.024112,38.882756],[-77.024536,38.882742],[-77.024689,38.882747],[-77.024959,38.882738],[-77.025084,38.882739],[-77.025226,38.882741],[-77.02537,38.882742],[-77.025501,38.882744],[-77.025658,38.882747],[-77.025745,38.882748],[-77.02621,38.882756],[-77.026351,38.882758],[-77.026473,38.882761],[-77.026623,38.882764],[-77.026773,38.882765],[-77.027056,38.882754],[-77.02719,38.882745],[-77.027317,38.882736],[-77.027483,38.88271],[-77.02773,38.882676],[-77.027879,38.882653],[-77.02801,38.882632],[-77.028149,38.882611],[-77.028287,38.882587],[-77.028421,38.882578],[-77.028559,38.882562],[-77.028703,38.882554],[-77.028832,38.882546],[-77.028989,38.882548],[-77.029124,38.88255],[-77.029268,38.882558],[-77.029408,38.882569],[-77.029546,38.882587],[-77.029685,38.882608],[-77.029824,38.882633],[-77.029966,38.882661],[-77.030095,38.882691],[-77.030231,38.882729],[-77.030368,38.882766],[-77.030493,38.882805],[-77.03063,38.882846],[-77.030761,38.882891],[-77.030883,38.882935],[-77.03117,38.883067],[-77.031259,38.883103],[-77.031402,38.883167],[-77.031626,38.883284],[-77.03198,38.883479],[-77.032546,38.883758],[-77.032802,38.88391],[-77.03285,38.883939],[-77.032981,38.884022],[-77.033395,38.884314],[-77.03347,38.88436],[-77.033647,38.884488],[-77.033728,38.884565],[-77.033854,38.884688],[-77.033894,38.884726],[-77.033968,38.884798],[-77.034098,38.884945],[-77.034128,38.884985],[-77.034205,38.88507],[-77.034273,38.885168],[-77.034341,38.88527],[-77.034402,38.885366],[-77.034459,38.885464],[-77.034512,38.885559],[-77.034562,38.885663],[-77.034609,38.885772],[-77.034652,38.88587],[-77.034695,38.885987],[-77.034734,38.886096],[-77.034774,38.886188],[-77.034825,38.88629],[-77.034887,38.886398],[-77.034941,38.886493],[-77.034984,38.886568],[-77.035085,38.886691],[-77.035161,38.886779],[-77.035255,38.886864],[-77.035348,38.886948],[-77.03567,38.88715],[-77.035787,38.88721],[-77.035903,38.88726],[-77.036042,38.887306],[-77.036176,38.88735],[-77.036449,38.887414],[-77.036719,38.88747],[-77.037208,38.88759],[-77.037394,38.887636],[-77.037713,38.887721],[-77.037934,38.887764],[-77.038073,38.887794],[-77.038211,38.887822],[-77.03853,38.887897],[-77.038672,38.887931],[-77.038871,38.888022],[-77.038963,38.888078],[-77.039028,38.88812],[-77.039097,38.888187],[-77.039181,38.888284],[-77.039241,38.888358],[-77.039292,38.888427],[-77.039318,38.888479],[-77.039379,38.888591],[-77.039425,38.888727],[-77.03945,38.888844],[-77.03949,38.888916],[-77.039488,38.889212],[-77.039488,38.889268],[-77.039488,38.889377],[-77.039486,38.889909],[-77.039482,38.890951],[-77.039478,38.891851],[-77.039478,38.891939],[-77.039477,38.892102],[-77.039472,38.892259],[-77.039472,38.892347],[-77.039472,38.892861],[-77.039472,38.893379],[-77.039473,38.893481],[-77.039472,38.893551],[-77.039472,38.894339],[-77.039472,38.894396],[-77.039472,38.894522],[-77.039472,38.895]]},{_id:'4',truck:'1',from:{name:'Pittsburg',lat:40.440907,lng:-79.99009},to:{name:'Colmbus',lat:39.962305,lng:-83.000656},startDate:new Date(2017,10,4,9,0),endDate:new Date(2017,10,4,16,0),km:250,revenue:517.50,selected:false,drive:2,duty:2,off:6,berth:2,time:1,distance:50,fuel:216,tolls:47,vectorPath:[[-79.99009,40.440907],[-79.990477,40.440904],[-79.990477,40.440742],[-79.990471,40.44054],[-79.990922,40.440537],[-79.991315,40.440537],[-79.99138,40.440536],[-79.99148,40.440535],[-79.99165,40.440533],[-79.991754,40.44053],[-79.992108,40.440527],[-79.992375,40.440514],[-79.992605,40.440485],[-79.992797,40.440455],[-79.992936,40.440422],[-79.993094,40.440379],[-79.993292,40.440313],[-79.99336,40.440243],[-79.993407,40.440226],[-79.993448,40.440213],[-79.993586,40.440163],[-79.994025,40.440006],[-79.994068,40.439991],[-79.99422,40.439941],[-79.994219,40.439903],[-79.994224,40.439847],[-79.994233,40.439812],[-79.994333,40.439618],[-79.994657,40.439008],[-79.994688,40.438957],[-79.995409,40.438977],[-79.995605,40.438981],[-79.995773,40.43901],[-79.996181,40.439161],[-79.996754,40.439375],[-79.996845,40.43941],[-79.997312,40.438707],[-79.997757,40.438051],[-79.998099,40.437533],[-79.998358,40.437159],[-79.998408,40.437088],[-79.998504,40.436947],[-79.998738,40.436613],[-79.998785,40.436553],[-79.998986,40.436288],[-79.999076,40.436178],[-79.999195,40.436083],[-79.999283,40.43604],[-79.999422,40.436004],[-79.999562,40.435993],[-79.999685,40.436019],[-79.999819,40.436064],[-80.000013,40.436156],[-80.000798,40.436509],[-80.001372,40.436734],[-80.002488,40.437211],[-80.004068,40.437792],[-80.005761,40.43844],[-80.006117,40.438576],[-80.006658,40.438765],[-80.007725,40.439153],[-80.008402,40.439368],[-80.008654,40.439446],[-80.009073,40.439552],[-80.0094,40.439597],[-80.00969,40.439597],[-80.009979,40.439552],[-80.010332,40.439429],[-80.012214,40.438421],[-80.01279,40.438078],[-80.013852,40.43757],[-80.024521,40.431948],[-80.026925,40.430671],[-80.028374,40.429879],[-80.028777,40.429619],[-80.0289,40.42954],[-80.029334,40.429213],[-80.029779,40.428805],[-80.030058,40.428487],[-80.030396,40.428013],[-80.030638,40.427531],[-80.030782,40.427163],[-80.030879,40.426812],[-80.030949,40.426412],[-80.030986,40.425963],[-80.030954,40.425571],[-80.030913,40.425122],[-80.030808,40.424607],[-80.030595,40.423766],[-80.030525,40.423329],[-80.030503,40.42299],[-80.030536,40.422676],[-80.030622,40.42232],[-80.030777,40.421961],[-80.030959,40.421663],[-80.031147,40.421397],[-80.031448,40.421079],[-80.03192,40.420734],[-80.032263,40.420517],[-80.03281,40.420276],[-80.033524,40.420089],[-80.034098,40.419999],[-80.03465,40.41999],[-80.035305,40.420031],[-80.036833,40.42024],[-80.03929,40.420591],[-80.042289,40.42102],[-80.043083,40.421097],[-80.043839,40.421138],[-80.044488,40.421146],[-80.045213,40.421142],[-80.045937,40.421097],[-80.046366,40.421061],[-80.046863,40.421025],[-80.047736,40.420882],[-80.048614,40.420693],[-80.04951,40.420456],[-80.049853,40.42035],[-80.050443,40.420154],[-80.050867,40.420003],[-80.051468,40.41975],[-80.051872,40.419564],[-80.052117,40.419451],[-80.053801,40.418651],[-80.056773,40.417234],[-80.060496,40.415457],[-80.066048,40.412815],[-80.069572,40.411132],[-80.070114,40.410895],[-80.07057,40.410736],[-80.071005,40.410625],[-80.071509,40.410552],[-80.071992,40.410531],[-80.07255,40.410564],[-80.073006,40.410625],[-80.073451,40.410736],[-80.073843,40.410858],[-80.074937,40.411258],[-80.076283,40.411744],[-80.077346,40.412135],[-80.078515,40.412565],[-80.080382,40.413235],[-80.081007,40.413478],[-80.081495,40.413711],[-80.081998,40.413972],[-80.082453,40.414246],[-80.082718,40.414422],[-80.084043,40.41538],[-80.086001,40.416781],[-80.086286,40.416985],[-80.087549,40.417857],[-80.088749,40.418584],[-80.089308,40.418911],[-80.089994,40.419249],[-80.090573,40.419532],[-80.091541,40.419972],[-80.092391,40.42033],[-80.093016,40.420581],[-80.093609,40.420808],[-80.094598,40.421224],[-80.095642,40.421637],[-80.097066,40.422204],[-80.098493,40.422754],[-80.098794,40.422874],[-80.099169,40.423015],[-80.099348,40.423069],[-80.09957,40.423124],[-80.099784,40.423168],[-80.100002,40.423199],[-80.100273,40.423225],[-80.10049,40.423235],[-80.100709,40.423237],[-80.100976,40.423224],[-80.101222,40.423197],[-80.101427,40.423164],[-80.101635,40.423123],[-80.101941,40.423043],[-80.102171,40.422966],[-80.102423,40.422865],[-80.102657,40.422751],[-80.10284,40.422651],[-80.103019,40.422545],[-80.103263,40.422366],[-80.103441,40.422223],[-80.103573,40.422097],[-80.10372,40.421939],[-80.103822,40.421817],[-80.103927,40.421672],[-80.104046,40.421465],[-80.104129,40.421297],[-80.104191,40.421137],[-80.104245,40.420962],[-80.104276,40.420829],[-80.104301,40.420687],[-80.104317,40.420548],[-80.104317,40.42038],[-80.104308,40.420223],[-80.104293,40.420091],[-80.104267,40.419943],[-80.104218,40.419755],[-80.104168,40.419613],[-80.103964,40.418994],[-80.103666,40.418128],[-80.103605,40.417925],[-80.103563,40.417751],[-80.103541,40.417587],[-80.103529,40.417398],[-80.103536,40.417182],[-80.103549,40.416997],[-80.103581,40.416822],[-80.103625,40.416649],[-80.103672,40.416494],[-80.103738,40.416333],[-80.10384,40.416119],[-80.103973,40.415885],[-80.104097,40.415689],[-80.104239,40.415463],[-80.104388,40.415247],[-80.104551,40.415021],[-80.104828,40.414677],[-80.10503,40.414303],[-80.105886,40.413237],[-80.10631,40.412718],[-80.107085,40.411719],[-80.107332,40.411356],[-80.107525,40.411005],[-80.107723,40.410568],[-80.107887,40.410086],[-80.107959,40.409736],[-80.108014,40.409308],[-80.108029,40.409042],[-80.108027,40.408942],[-80.108021,40.408709],[-80.107967,40.408201],[-80.107881,40.407737],[-80.107726,40.40694],[-80.107131,40.404041],[-80.10687,40.402852],[-80.106694,40.402028],[-80.106556,40.401451],[-80.106477,40.401045],[-80.106348,40.400555],[-80.106205,40.40016],[-80.106071,40.399876],[-80.105904,40.399566],[-80.105711,40.399239],[-80.105502,40.398939],[-80.105178,40.398512],[-80.104887,40.398145],[-80.104386,40.397514],[-80.10275,40.395509],[-80.10208,40.394684],[-80.101711,40.394204],[-80.101119,40.39335],[-80.100564,40.392398],[-80.100043,40.391309],[-80.099773,40.390724],[-80.099644,40.390402],[-80.099199,40.389393],[-80.098598,40.388032],[-80.098099,40.386917],[-80.097236,40.384988],[-80.097107,40.38469],[-80.096822,40.383942],[-80.096699,40.383489],[-80.096651,40.383198],[-80.096635,40.382908],[-80.09664,40.38261],[-80.096672,40.382332],[-80.096758,40.381944],[-80.096849,40.381666],[-80.096999,40.381339],[-80.097181,40.380999],[-80.09758,40.380441],[-80.098125,40.379871],[-80.098672,40.379335],[-80.099633,40.378355],[-80.100721,40.377284],[-80.103039,40.374967],[-80.10396,40.374159],[-80.104383,40.373858],[-80.104938,40.373541],[-80.105413,40.373306],[-80.105995,40.373079],[-80.10666,40.372883],[-80.107395,40.372744],[-80.108178,40.372654],[-80.108905,40.372619],[-80.109809,40.372601],[-80.111878,40.372528],[-80.113149,40.372484],[-80.113907,40.372413],[-80.114497,40.372319],[-80.115066,40.37218],[-80.11572,40.371971],[-80.116257,40.371746],[-80.116809,40.371456],[-80.117303,40.371129],[-80.117839,40.370676],[-80.118242,40.370226],[-80.118617,40.369687],[-80.118944,40.368959],[-80.119075,40.368451],[-80.119143,40.367839],[-80.11916,40.366625],[-80.11914,40.365483],[-80.11908,40.364424],[-80.119075,40.362479],[-80.119046,40.360717],[-80.119049,40.359419],[-80.118988,40.358615],[-80.118904,40.357788],[-80.118822,40.357261],[-80.118691,40.356571],[-80.118551,40.355962],[-80.118518,40.355785],[-80.118398,40.355417],[-80.117723,40.352589],[-80.117556,40.351845],[-80.117471,40.351383],[-80.117438,40.35093],[-80.117492,40.3501],[-80.117562,40.349433],[-80.117782,40.348616],[-80.118017,40.348062],[-80.118249,40.34763],[-80.118538,40.347136],[-80.118968,40.346529],[-80.119305,40.34615],[-80.119678,40.345792],[-80.120161,40.345363],[-80.12065,40.344979],[-80.121176,40.344648],[-80.121934,40.344237],[-80.122755,40.34382],[-80.123641,40.343375],[-80.125083,40.342626],[-80.126799,40.341759],[-80.128033,40.341129],[-80.129734,40.340267],[-80.130932,40.339569],[-80.132089,40.338787],[-80.132936,40.338136],[-80.133703,40.337466],[-80.134363,40.336848],[-80.134873,40.336296],[-80.135281,40.335825],[-80.135652,40.335353],[-80.136113,40.334713],[-80.136927,40.33361],[-80.137657,40.332624],[-80.13821,40.331872],[-80.139905,40.329529],[-80.142302,40.326226],[-80.142642,40.325777],[-80.143047,40.325226],[-80.143323,40.32485],[-80.143778,40.324224],[-80.14499,40.322547],[-80.1458,40.321415],[-80.147275,40.319607],[-80.149197,40.317454],[-80.150332,40.316186],[-80.152554,40.313754],[-80.15331,40.312891],[-80.154099,40.312011],[-80.155102,40.310931],[-80.156985,40.30891],[-80.158616,40.307385],[-80.161057,40.30538],[-80.162194,40.304476],[-80.164619,40.302533],[-80.165783,40.301588],[-80.166496,40.30099],[-80.16696,40.300529],[-80.167285,40.300156],[-80.167649,40.299509],[-80.167843,40.299018],[-80.168115,40.298186],[-80.168218,40.297789],[-80.168422,40.296833],[-80.16867,40.296047],[-80.169096,40.294362],[-80.169288,40.293663],[-80.169565,40.29273],[-80.169865,40.291617],[-80.169967,40.29097],[-80.169998,40.290406],[-80.169983,40.290078],[-80.169945,40.289759],[-80.169892,40.289427],[-80.169784,40.289026],[-80.169559,40.288437],[-80.169296,40.287901],[-80.168848,40.287176],[-80.168191,40.286477],[-80.167408,40.285732],[-80.16575,40.284239],[-80.164775,40.283335],[-80.162524,40.281295],[-80.161505,40.280378],[-80.160559,40.279513],[-80.159748,40.278706],[-80.159442,40.278329],[-80.15923,40.277979],[-80.159045,40.277617],[-80.158809,40.276999],[-80.158712,40.27659],[-80.158659,40.276103],[-80.158664,40.275604],[-80.158727,40.274724],[-80.158863,40.274008],[-80.15896,40.273484],[-80.159116,40.272808],[-80.159465,40.271529],[-80.160048,40.270082],[-80.160472,40.269206],[-80.160907,40.268404],[-80.161449,40.267575],[-80.161745,40.267234],[-80.162503,40.266517],[-80.163009,40.266128],[-80.163535,40.265797],[-80.164173,40.265445],[-80.164742,40.265183],[-80.165434,40.264925],[-80.166013,40.264765],[-80.167226,40.26445],[-80.168068,40.264228],[-80.168866,40.263996],[-80.169573,40.263734],[-80.170267,40.26339],[-80.170882,40.262987],[-80.171469,40.262524],[-80.172595,40.261375],[-80.172858,40.261103],[-80.173427,40.260491],[-80.173985,40.259951],[-80.174339,40.259665],[-80.174661,40.259435],[-80.175004,40.259227],[-80.175353,40.259026],[-80.175921,40.258768],[-80.176613,40.25851],[-80.177246,40.258293],[-80.178024,40.258024],[-80.178937,40.257702],[-80.179522,40.257468],[-80.180229,40.257122],[-80.180535,40.256938],[-80.180835,40.256721],[-80.18113,40.256484],[-80.181506,40.256136],[-80.182101,40.255591],[-80.183002,40.254768],[-80.183314,40.254506],[-80.18371,40.254195],[-80.184134,40.253937],[-80.184563,40.253728],[-80.18503,40.253528],[-80.186747,40.252844],[-80.188051,40.252321],[-80.188861,40.252007],[-80.189217,40.251861],[-80.189955,40.25155],[-80.190593,40.251219],[-80.191215,40.250817],[-80.191704,40.250486],[-80.193039,40.249581],[-80.19438,40.248668],[-80.195378,40.248001],[-80.196204,40.247476],[-80.196794,40.247157],[-80.197578,40.246768],[-80.198582,40.2463],[-80.199364,40.245932],[-80.200716,40.245294],[-80.201086,40.245114],[-80.20117,40.245067],[-80.201515,40.244872],[-80.202287,40.244418],[-80.202599,40.244197],[-80.202955,40.243924],[-80.20335,40.243615],[-80.203757,40.243234],[-80.204192,40.242768],[-80.204567,40.242293],[-80.20522,40.24134],[-80.206176,40.239943],[-80.207865,40.237391],[-80.209513,40.234983],[-80.210055,40.234119],[-80.210533,40.233259],[-80.210871,40.232555],[-80.21108,40.232026],[-80.211321,40.231343],[-80.211598,40.230351],[-80.211797,40.22956],[-80.212123,40.228243],[-80.212805,40.225641],[-80.212968,40.224894],[-80.213096,40.224358],[-80.213323,40.223426],[-80.213449,40.222963],[-80.213591,40.222399],[-80.21377,40.221674],[-80.213939,40.221162],[-80.214122,40.220722],[-80.214302,40.220386],[-80.214522,40.21999],[-80.214715,40.219675],[-80.214976,40.219313],[-80.215386,40.218853],[-80.215551,40.218668],[-80.21597,40.218262],[-80.216488,40.217811],[-80.217188,40.217218],[-80.218534,40.216052],[-80.219891,40.214887],[-80.220841,40.214072],[-80.221689,40.213369],[-80.222651,40.212539],[-80.223102,40.212185],[-80.223663,40.211853],[-80.223948,40.211707],[-80.224268,40.211549],[-80.224628,40.211408],[-80.224942,40.211295],[-80.225262,40.211196],[-80.225611,40.211109],[-80.225916,40.211045],[-80.226138,40.210998],[-80.226511,40.210938],[-80.227047,40.210883],[-80.227517,40.210872],[-80.228134,40.210887],[-80.228496,40.210905],[-80.22882,40.21093],[-80.231376,40.211112],[-80.232908,40.211235],[-80.233701,40.211284],[-80.234423,40.211288],[-80.234941,40.211282],[-80.235746,40.211247],[-80.236016,40.211224],[-80.236679,40.211167],[-80.237342,40.211079],[-80.237913,40.210987],[-80.238632,40.210846],[-80.239147,40.210721],[-80.239775,40.210569],[-80.240558,40.210313],[-80.24122,40.210075],[-80.242042,40.209746],[-80.243081,40.209224],[-80.244012,40.208683],[-80.24482,40.208104],[-80.245706,40.207379],[-80.246071,40.207036],[-80.246428,40.206666],[-80.246949,40.206042],[-80.247272,40.205608],[-80.2477,40.204963],[-80.248047,40.20433],[-80.248392,40.203531],[-80.248594,40.202941],[-80.248741,40.202402],[-80.248861,40.201776],[-80.24893,40.201159],[-80.24895,40.200681],[-80.248945,40.200308],[-80.248901,40.199749],[-80.248794,40.198974],[-80.248631,40.198276],[-80.248368,40.197494],[-80.247609,40.19511],[-80.247212,40.193972],[-80.247048,40.19342],[-80.246986,40.193119],[-80.246954,40.192837],[-80.246951,40.192524],[-80.246989,40.192223],[-80.247085,40.191807],[-80.247256,40.191251],[-80.247356,40.190944],[-80.247457,40.190718],[-80.247747,40.18989],[-80.247882,40.189575],[-80.248037,40.189312],[-80.248151,40.189169],[-80.248283,40.189026],[-80.248434,40.188892],[-80.248643,40.188741],[-80.248839,40.188625],[-80.249038,40.188526],[-80.249333,40.188407],[-80.249789,40.188234],[-80.250756,40.187874],[-80.251295,40.187613],[-80.251733,40.187423],[-80.252057,40.187268],[-80.252441,40.187067],[-80.2528,40.186867],[-80.253201,40.186627],[-80.254205,40.185993],[-80.255251,40.185326],[-80.25556,40.185133],[-80.255857,40.184959],[-80.256098,40.184831],[-80.25634,40.184713],[-80.256591,40.184601],[-80.256954,40.184453],[-80.257245,40.184348],[-80.257498,40.184269],[-80.257749,40.184194],[-80.25812,40.184092],[-80.25868,40.183936],[-80.259123,40.183807],[-80.259461,40.183705],[-80.259834,40.183585],[-80.260139,40.183477],[-80.260601,40.1833],[-80.260943,40.18316],[-80.261286,40.183009],[-80.26161,40.182858],[-80.262158,40.18258],[-80.262477,40.182407],[-80.263028,40.182078],[-80.263618,40.181691],[-80.264099,40.181345],[-80.264313,40.181174],[-80.264566,40.180969],[-80.264771,40.180798],[-80.265114,40.18049],[-80.265329,40.180292],[-80.265457,40.180167],[-80.265865,40.179731],[-80.266247,40.179283],[-80.267144,40.178208],[-80.26839,40.17672],[-80.269594,40.175281],[-80.27094,40.173673],[-80.272225,40.172142],[-80.27302,40.171185],[-80.273944,40.170086],[-80.274609,40.169291],[-80.274875,40.16896],[-80.275057,40.168706],[-80.275232,40.168424],[-80.275373,40.16818],[-80.275505,40.167916],[-80.275655,40.167568],[-80.276282,40.16608],[-80.277131,40.164066],[-80.277314,40.163646],[-80.277475,40.163324],[-80.277618,40.163061],[-80.277767,40.162801],[-80.277939,40.162534],[-80.278048,40.162372],[-80.278264,40.162099],[-80.278489,40.1618],[-80.27883,40.161379],[-80.279126,40.161044],[-80.279321,40.160784],[-80.28044,40.159494],[-80.281033,40.158804],[-80.281612,40.158139],[-80.282094,40.157584],[-80.282496,40.157121],[-80.282858,40.156745],[-80.283256,40.156371],[-80.283667,40.156022],[-80.283961,40.15579],[-80.284285,40.15555],[-80.284642,40.155308],[-80.285081,40.155027],[-80.285877,40.154553],[-80.28668,40.154063],[-80.288182,40.153149],[-80.292406,40.15059],[-80.294267,40.149473],[-80.294489,40.149344],[-80.294689,40.149232],[-80.295036,40.149051],[-80.295392,40.148887],[-80.295756,40.148729],[-80.296032,40.148624],[-80.296361,40.148505],[-80.296768,40.148377],[-80.297202,40.148256],[-80.297675,40.148142],[-80.298082,40.148061],[-80.298692,40.147962],[-80.302341,40.147423],[-80.30379,40.147209],[-80.304103,40.147162],[-80.304478,40.1471],[-80.304839,40.147029],[-80.305127,40.146967],[-80.305448,40.146885],[-80.305764,40.146795],[-80.306042,40.146703],[-80.306348,40.146586],[-80.306615,40.146474],[-80.306875,40.146356],[-80.307189,40.146198],[-80.307547,40.145995],[-80.307801,40.145838],[-80.308069,40.145651],[-80.308334,40.145458],[-80.309251,40.144781],[-80.310972,40.143494],[-80.315316,40.140237],[-80.318213,40.138068],[-80.318814,40.13761],[-80.31929,40.137212],[-80.319614,40.136934],[-80.320053,40.136522],[-80.320366,40.136215],[-80.320775,40.135781],[-80.322312,40.134103],[-80.323032,40.133313],[-80.323631,40.132681],[-80.323897,40.132423],[-80.324135,40.13222],[-80.324444,40.131984],[-80.324669,40.131828],[-80.324978,40.131631],[-80.325194,40.131511],[-80.325419,40.131394],[-80.32578,40.131222],[-80.326119,40.131082],[-80.326483,40.130951],[-80.326851,40.130833],[-80.327277,40.130719],[-80.327616,40.130649],[-80.327921,40.130595],[-80.328345,40.130538],[-80.328666,40.130504],[-80.32905,40.130477],[-80.329545,40.130453],[-80.330059,40.130434],[-80.331076,40.130405],[-80.333272,40.130333],[-80.33504,40.130276],[-80.336009,40.130249],[-80.336476,40.130234],[-80.336962,40.130219],[-80.339201,40.130145],[-80.341782,40.130064],[-80.343918,40.129995],[-80.344297,40.129986],[-80.344742,40.129985],[-80.345187,40.13],[-80.34559,40.130018],[-80.346032,40.130051],[-80.346467,40.130098],[-80.346861,40.130143],[-80.347353,40.13022],[-80.347869,40.130317],[-80.348165,40.130375],[-80.348566,40.130465],[-80.349096,40.1306],[-80.349938,40.130832],[-80.350818,40.131059],[-80.351127,40.131135],[-80.351447,40.131203],[-80.351717,40.131249],[-80.352055,40.131298],[-80.352425,40.131337],[-80.352768,40.131359],[-80.353113,40.131372],[-80.353479,40.131374],[-80.353882,40.131353],[-80.354285,40.131317],[-80.354614,40.131277],[-80.354989,40.131216],[-80.355296,40.131153],[-80.355679,40.131064],[-80.355967,40.130982],[-80.356337,40.130863],[-80.356615,40.130759],[-80.35698,40.130611],[-80.357278,40.130469],[-80.357559,40.130323],[-80.357861,40.130152],[-80.358103,40.130001],[-80.358362,40.129826],[-80.358668,40.129599],[-80.358981,40.129346],[-80.360077,40.128474],[-80.36238,40.126626],[-80.363168,40.125994],[-80.363588,40.125692],[-80.363817,40.12555],[-80.364059,40.125404],[-80.364353,40.125247],[-80.364638,40.125108],[-80.365024,40.124939],[-80.365466,40.124777],[-80.365812,40.124666],[-80.366154,40.124578],[-80.366493,40.124502],[-80.366848,40.124437],[-80.367331,40.124373],[-80.367725,40.124331],[-80.368082,40.124306],[-80.368498,40.1243],[-80.368896,40.124307],[-80.369259,40.124333],[-80.369712,40.12438],[-80.37014,40.124447],[-80.370487,40.124513],[-80.370945,40.124621],[-80.371631,40.124802],[-80.372057,40.124917],[-80.372492,40.125024],[-80.373003,40.125133],[-80.373326,40.125195],[-80.373651,40.125241],[-80.373985,40.125274],[-80.374332,40.125296],[-80.374738,40.125307],[-80.37511,40.125301],[-80.375459,40.125287],[-80.375817,40.12526],[-80.376128,40.125225],[-80.376514,40.125166],[-80.376871,40.125097],[-80.377275,40.125006],[-80.378773,40.124647],[-80.383925,40.12341],[-80.388393,40.122334],[-80.391309,40.12163],[-80.392209,40.121415],[-80.392656,40.121325],[-80.393003,40.121265],[-80.393349,40.121221],[-80.393781,40.121182],[-80.394051,40.121166],[-80.39438,40.121158],[-80.394692,40.121159],[-80.394968,40.121171],[-80.395434,40.121198],[-80.396285,40.121264],[-80.396743,40.121298],[-80.397274,40.121324],[-80.397693,40.121327],[-80.398083,40.12132],[-80.398437,40.121306],[-80.398742,40.121288],[-80.399073,40.121258],[-80.399434,40.121216],[-80.399817,40.121162],[-80.400181,40.121098],[-80.400601,40.121008],[-80.400966,40.120923],[-80.401409,40.120804],[-80.40181,40.120677],[-80.402239,40.120528],[-80.402572,40.120398],[-80.402896,40.120259],[-80.403338,40.120049],[-80.403838,40.119804],[-80.405077,40.119186],[-80.406342,40.118557],[-80.407147,40.118158],[-80.409917,40.116783],[-80.411976,40.115758],[-80.4133,40.115102],[-80.413681,40.114926],[-80.413986,40.1148],[-80.41417,40.114726],[-80.414678,40.114534],[-80.414987,40.114422],[-80.415287,40.114323],[-80.4156,40.114229],[-80.415922,40.114138],[-80.416347,40.114027],[-80.41681,40.113925],[-80.417393,40.113816],[-80.417948,40.113729],[-80.41831,40.113677],[-80.418765,40.113624],[-80.419233,40.113589],[-80.419651,40.113567],[-80.420077,40.113552],[-80.420522,40.113554],[-80.420929,40.113561],[-80.421384,40.11358],[-80.421714,40.113595],[-80.4221,40.11363],[-80.422425,40.113664],[-80.422776,40.113712],[-80.423192,40.11377],[-80.423613,40.113848],[-80.424098,40.113943],[-80.424659,40.114072],[-80.424986,40.114159],[-80.425856,40.114402],[-80.428253,40.11506],[-80.428742,40.115189],[-80.430241,40.115611],[-80.431476,40.115948],[-80.432995,40.116364],[-80.433612,40.116522],[-80.434033,40.116623],[-80.434404,40.116691],[-80.434818,40.11676],[-80.435128,40.116794],[-80.435426,40.116814],[-80.435767,40.11683],[-80.436154,40.116832],[-80.436482,40.116824],[-80.439065,40.116736],[-80.443444,40.116578],[-80.445575,40.1165],[-80.445711,40.116495],[-80.446836,40.116452],[-80.450116,40.116331],[-80.450651,40.116301],[-80.45108,40.116269],[-80.451557,40.116216],[-80.451988,40.116156],[-80.452495,40.116071],[-80.45272,40.116029],[-80.453008,40.115972],[-80.453453,40.115876],[-80.453972,40.115739],[-80.454469,40.115595],[-80.455034,40.115417],[-80.455455,40.115266],[-80.455816,40.115124],[-80.45619,40.114964],[-80.456627,40.114761],[-80.456765,40.114697],[-80.457671,40.114275],[-80.458141,40.114064],[-80.458495,40.11392],[-80.458897,40.113784],[-80.459415,40.113636],[-80.459777,40.113551],[-80.460199,40.113468],[-80.460587,40.113405],[-80.46098,40.113364],[-80.461318,40.113341],[-80.461655,40.113328],[-80.462013,40.113324],[-80.462369,40.113337],[-80.462771,40.113366],[-80.463139,40.113404],[-80.463478,40.113453],[-80.463928,40.113536],[-80.464307,40.113627],[-80.464688,40.113733],[-80.465097,40.113864],[-80.465351,40.113961],[-80.465476,40.114011],[-80.465754,40.114128],[-80.466017,40.114251],[-80.466273,40.114379],[-80.46655,40.114534],[-80.466817,40.114698],[-80.467076,40.114873],[-80.467318,40.115049],[-80.467586,40.115263],[-80.468279,40.115865],[-80.469278,40.116748],[-80.46989,40.117281],[-80.47014,40.117498],[-80.470329,40.117649],[-80.470538,40.117816],[-80.470815,40.118015],[-80.471143,40.118222],[-80.471438,40.118398],[-80.471713,40.118544],[-80.472012,40.118688],[-80.472327,40.118828],[-80.472591,40.118939],[-80.472817,40.119025],[-80.473119,40.119128],[-80.473418,40.119225],[-80.473745,40.119313],[-80.47406,40.119386],[-80.474316,40.119441],[-80.47457,40.119488],[-80.474825,40.119533],[-80.475143,40.119573],[-80.475448,40.119607],[-80.475692,40.119627],[-80.4758,40.119633],[-80.476015,40.119642],[-80.476331,40.11965],[-80.476674,40.119648],[-80.477066,40.119633],[-80.477478,40.119605],[-80.477926,40.119554],[-80.478294,40.1195],[-80.478625,40.119437],[-80.478989,40.119356],[-80.47938,40.119253],[-80.479677,40.119163],[-80.480036,40.119044],[-80.480646,40.118815],[-80.482997,40.117912],[-80.483727,40.117634],[-80.484168,40.117457],[-80.484566,40.1173],[-80.48506,40.117075],[-80.485486,40.116856],[-80.485799,40.11668],[-80.486104,40.116492],[-80.486382,40.1163],[-80.48668,40.116076],[-80.486923,40.115881],[-80.487195,40.115645],[-80.487458,40.11539],[-80.487696,40.115135],[-80.487922,40.114876],[-80.488122,40.114618],[-80.488349,40.114299],[-80.489739,40.112241],[-80.491291,40.109949],[-80.49196,40.108967],[-80.492227,40.10864],[-80.492482,40.10832],[-80.492633,40.108168],[-80.492833,40.10798],[-80.493107,40.107744],[-80.493461,40.107482],[-80.493807,40.107251],[-80.494135,40.107061],[-80.494422,40.106906],[-80.494832,40.106716],[-80.496601,40.105951],[-80.498293,40.105216],[-80.4995,40.104689],[-80.500115,40.104421],[-80.500528,40.104223],[-80.500829,40.104075],[-80.501214,40.10386],[-80.501686,40.103584],[-80.502032,40.103358],[-80.502406,40.103102],[-80.502764,40.102839],[-80.50309,40.102584],[-80.503304,40.102408],[-80.503689,40.10206],[-80.504083,40.101694],[-80.504616,40.101194],[-80.504986,40.100857],[-80.505346,40.100554],[-80.505759,40.10023],[-80.506275,40.09988],[-80.506539,40.099705],[-80.506928,40.099465],[-80.507252,40.09928],[-80.507602,40.099099],[-80.508006,40.098894],[-80.508325,40.098745],[-80.50865,40.098602],[-80.509013,40.098456],[-80.509632,40.098235],[-80.510121,40.098071],[-80.51059,40.097934],[-80.510985,40.097831],[-80.512165,40.097553],[-80.514608,40.096957],[-80.518388,40.096048],[-80.519188,40.095853],[-80.522116,40.095149],[-80.524622,40.094499],[-80.528261,40.093639],[-80.530638,40.093061],[-80.531823,40.09268],[-80.533334,40.092142],[-80.53457,40.091636],[-80.536484,40.090625],[-80.537745,40.089791],[-80.539627,40.08837],[-80.540372,40.087808],[-80.542758,40.086107],[-80.545942,40.083671],[-80.54653,40.083243],[-80.547071,40.082849],[-80.54856,40.081766],[-80.552706,40.078673],[-80.555263,40.076749],[-80.557958,40.074752],[-80.560199,40.073091],[-80.563597,40.070549],[-80.565863,40.068828],[-80.566782,40.068191],[-80.568274,40.067403],[-80.568811,40.067134],[-80.570438,40.066352],[-80.572395,40.065708],[-80.573296,40.065491],[-80.575562,40.065058],[-80.577562,40.064769],[-80.57927,40.064657],[-80.581158,40.064598],[-80.583381,40.064512],[-80.58575,40.064447],[-80.587656,40.064342],[-80.588531,40.064243],[-80.589347,40.064013],[-80.590385,40.063652],[-80.591595,40.062988],[-80.592402,40.062272],[-80.593012,40.061523],[-80.593303,40.061037],[-80.593939,40.059809],[-80.595235,40.057306],[-80.596462,40.054711],[-80.597492,40.052576],[-80.598058,40.05163],[-80.598634,40.0509],[-80.599878,40.049724],[-80.603646,40.046387],[-80.6052,40.044987],[-80.606556,40.04387],[-80.607311,40.043417],[-80.60829,40.042963],[-80.609225,40.0427],[-80.610375,40.042556],[-80.611268,40.042569],[-80.611869,40.042595],[-80.612693,40.042733],[-80.613276,40.042871],[-80.617327,40.044192],[-80.618091,40.044409],[-80.618598,40.044507],[-80.619224,40.044586],[-80.619799,40.044593],[-80.620486,40.044593],[-80.621053,40.044567],[-80.622864,40.044323],[-80.62452,40.044061],[-80.625885,40.04389],[-80.626666,40.04385],[-80.627395,40.043877],[-80.628297,40.043975],[-80.629086,40.044172],[-80.629893,40.044468],[-80.63155,40.045092],[-80.631893,40.045204],[-80.632631,40.04544],[-80.634125,40.045657],[-80.635578,40.045877],[-80.637363,40.04614],[-80.639028,40.04637],[-80.64035,40.046541],[-80.641277,40.046606],[-80.642281,40.046567],[-80.643826,40.046396],[-80.644581,40.046232],[-80.645543,40.045949],[-80.646821,40.045548],[-80.649396,40.044622],[-80.650212,40.044392],[-80.650813,40.044241],[-80.651992,40.044108],[-80.652663,40.044108],[-80.653403,40.044174],[-80.65395,40.044268],[-80.654417,40.044392],[-80.65499,40.044593],[-80.6553,40.044703],[-80.655531,40.044795],[-80.656031,40.045029],[-80.657286,40.045705],[-80.659619,40.046961],[-80.660529,40.0475],[-80.662537,40.048545],[-80.663335,40.048899],[-80.664382,40.049234],[-80.664932,40.049346],[-80.666151,40.04953],[-80.66773,40.049694],[-80.670189,40.049982],[-80.673333,40.050319],[-80.675468,40.050549],[-80.676133,40.050623],[-80.676798,40.050672],[-80.677549,40.050688],[-80.678826,40.050697],[-80.680135,40.050672],[-80.681197,40.050565],[-80.682302,40.050393],[-80.683568,40.050155],[-80.685585,40.049727],[-80.687399,40.049333],[-80.688654,40.049046],[-80.689791,40.048791],[-80.690435,40.048668],[-80.691272,40.048586],[-80.692119,40.04861],[-80.692913,40.048701],[-80.693611,40.048816],[-80.694276,40.049029],[-80.695037,40.0493],[-80.695681,40.049629],[-80.696228,40.04999],[-80.696582,40.050302],[-80.697237,40.050943],[-80.69817,40.052101],[-80.698646,40.052554],[-80.699243,40.05307],[-80.699973,40.053456],[-80.700584,40.053686],[-80.7014,40.053957],[-80.701872,40.054088],[-80.702387,40.05417],[-80.702859,40.05422],[-80.703352,40.054236],[-80.703899,40.054187],[-80.704468,40.054105],[-80.70494,40.054023],[-80.705509,40.053858],[-80.706067,40.053686],[-80.706946,40.053333],[-80.707537,40.053078],[-80.708288,40.052741],[-80.71038,40.051945],[-80.711456,40.051727],[-80.711963,40.051624],[-80.71259,40.051551],[-80.713019,40.051518],[-80.713309,40.051493],[-80.713609,40.051477],[-80.716055,40.051567],[-80.717439,40.051641],[-80.71818,40.051674],[-80.718941,40.051641],[-80.720712,40.051477],[-80.721924,40.051321],[-80.722857,40.051198],[-80.727738,40.050453],[-80.728351,40.05036],[-80.729509,40.050187],[-80.732234,40.049717],[-80.732664,40.049635],[-80.733972,40.049391],[-80.734959,40.049218],[-80.735614,40.04912],[-80.736258,40.049013],[-80.737866,40.048735],[-80.738074,40.048709],[-80.73826,40.048679],[-80.739534,40.048448],[-80.743548,40.047703],[-80.747929,40.046919],[-80.74893,40.046729],[-80.750885,40.046365],[-80.752413,40.046085],[-80.753288,40.045917],[-80.753856,40.045817],[-80.754715,40.045683],[-80.755135,40.045629],[-80.75554,40.045583],[-80.756673,40.045487],[-80.757334,40.045454],[-80.757515,40.045448],[-80.757659,40.045444],[-80.757984,40.045439],[-80.758458,40.045439],[-80.759063,40.045446],[-80.759134,40.045449],[-80.759659,40.045472],[-80.760426,40.045525],[-80.761071,40.045587],[-80.761741,40.045661],[-80.7624,40.045756],[-80.763822,40.045995],[-80.765424,40.04627],[-80.766351,40.046422],[-80.767552,40.046594],[-80.768373,40.046695],[-80.770402,40.046927],[-80.771376,40.047043],[-80.772967,40.047225],[-80.773676,40.047301],[-80.775324,40.04749],[-80.778447,40.047857],[-80.779381,40.047962],[-80.780053,40.048042],[-80.781087,40.048155],[-80.784171,40.048514],[-80.786238,40.048762],[-80.788394,40.049012],[-80.788833,40.049081],[-80.788977,40.0491],[-80.789332,40.049138],[-80.790294,40.049246],[-80.791566,40.04938],[-80.795657,40.04985],[-80.796426,40.049934],[-80.799861,40.050339],[-80.80099,40.050463],[-80.801508,40.050528],[-80.801973,40.050587],[-80.802902,40.05069],[-80.803745,40.050778],[-80.804834,40.050899],[-80.807253,40.051179],[-80.808033,40.051274],[-80.808651,40.051349],[-80.809353,40.051457],[-80.809655,40.051499],[-80.810134,40.051589],[-80.810986,40.051793],[-80.811187,40.051843],[-80.811683,40.051969],[-80.812214,40.052115],[-80.812867,40.052313],[-80.813284,40.052451],[-80.813795,40.052631],[-80.814229,40.052791],[-80.814511,40.052904],[-80.815031,40.053122],[-80.815381,40.053279],[-80.81582,40.053484],[-80.815971,40.053559],[-80.816325,40.053735],[-80.816389,40.053768],[-80.816744,40.053955],[-80.817196,40.054205],[-80.818865,40.055177],[-80.819715,40.055678],[-80.822029,40.057026],[-80.822657,40.057366],[-80.823027,40.057555],[-80.823573,40.057817],[-80.823653,40.057855],[-80.824404,40.058184],[-80.824754,40.058329],[-80.825237,40.058516],[-80.825605,40.058651],[-80.825984,40.058783],[-80.826403,40.058918],[-80.826863,40.059059],[-80.827349,40.059196],[-80.827804,40.059315],[-80.828479,40.059477],[-80.829521,40.059711],[-80.831653,40.060184],[-80.832332,40.060351],[-80.836193,40.061196],[-80.836634,40.0613],[-80.836947,40.061386],[-80.837237,40.061474],[-80.837434,40.061541],[-80.837685,40.061634],[-80.837902,40.061726],[-80.838134,40.06183],[-80.838387,40.061956],[-80.83861,40.062078],[-80.838874,40.062238],[-80.839095,40.062383],[-80.839315,40.062543],[-80.839493,40.062682],[-80.83966,40.062825],[-80.839822,40.062975],[-80.839993,40.063147],[-80.840122,40.063286],[-80.840289,40.063487],[-80.840436,40.063679],[-80.840672,40.06403],[-80.84077,40.064198],[-80.840872,40.064388],[-80.840882,40.06441],[-80.841008,40.064685],[-80.841115,40.064931],[-80.841155,40.065021],[-80.84153,40.065924],[-80.841713,40.066377],[-80.841994,40.067096],[-80.842318,40.067848],[-80.842477,40.068168],[-80.842581,40.068338],[-80.842649,40.068435],[-80.842722,40.068522],[-80.842995,40.068807],[-80.843186,40.068971],[-80.843416,40.069127],[-80.843633,40.069255],[-80.843879,40.069376],[-80.844155,40.069491],[-80.844404,40.069571],[-80.844649,40.069632],[-80.844898,40.069678],[-80.84512,40.069706],[-80.84531,40.069731],[-80.845588,40.069728],[-80.845719,40.069727],[-80.845924,40.069717],[-80.846205,40.069692],[-80.846497,40.069653],[-80.84736,40.069531],[-80.847795,40.06947],[-80.848178,40.069429],[-80.848926,40.069429],[-80.852331,40.069638],[-80.853736,40.069814],[-80.85517,40.06995],[-80.856338,40.070163],[-80.857784,40.070476],[-80.859179,40.07088],[-80.861344,40.071646],[-80.864144,40.072343],[-80.865053,40.07249],[-80.86622,40.072605],[-80.866915,40.072632],[-80.867233,40.072643],[-80.868803,40.072638],[-80.86967,40.072572],[-80.870691,40.072421],[-80.872967,40.072001],[-80.881493,40.07028],[-80.891944,40.068079],[-80.893604,40.06779],[-80.895016,40.067676],[-80.896663,40.067793],[-80.897445,40.067863],[-80.898529,40.068096],[-80.900141,40.068556],[-80.900697,40.068723],[-80.903839,40.069657],[-80.906271,40.070295],[-80.906861,40.070466],[-80.912045,40.071962],[-80.912403,40.072065],[-80.92339,40.075211],[-80.930746,40.077254],[-80.931097,40.07735],[-80.93136,40.077429],[-80.931854,40.077551],[-80.932249,40.077633],[-80.932598,40.0777],[-80.932892,40.077751],[-80.933227,40.077804],[-80.93354,40.077849],[-80.934261,40.07794],[-80.934826,40.077997],[-80.93547,40.078048],[-80.935988,40.078076],[-80.936564,40.078098],[-80.936926,40.078108],[-80.937327,40.078112],[-80.93973,40.078085],[-80.940302,40.078078],[-80.942503,40.078043],[-80.943016,40.07804],[-80.94679,40.077977],[-80.948074,40.077964],[-80.951008,40.077919],[-80.951826,40.077898],[-80.953301,40.077883],[-80.954517,40.077862],[-80.956381,40.077813],[-80.956879,40.07781],[-80.957386,40.077788],[-80.957668,40.077773],[-80.958078,40.077732],[-80.958555,40.077679],[-80.95909,40.077608],[-80.959608,40.077521],[-80.960122,40.077421],[-80.960429,40.077351],[-80.960803,40.077264],[-80.961152,40.077165],[-80.961549,40.077055],[-80.961966,40.076917],[-80.962463,40.076746],[-80.963236,40.076448],[-80.963746,40.076202],[-80.964085,40.07602],[-80.964392,40.07585],[-80.964651,40.075694],[-80.964987,40.075486],[-80.965322,40.07527],[-80.965806,40.074945],[-80.969584,40.072314],[-80.970137,40.071953],[-80.970878,40.071456],[-80.974039,40.069273],[-80.974606,40.068884],[-80.975214,40.068462],[-80.976143,40.067829],[-80.97643,40.067643],[-80.976707,40.067472],[-80.976905,40.067356],[-80.977463,40.067055],[-80.977938,40.06682],[-80.978365,40.066628],[-80.978398,40.066613],[-80.978884,40.066413],[-80.97925,40.066274],[-80.97963,40.066139],[-80.980272,40.06594],[-80.980649,40.065836],[-80.981038,40.065734],[-80.981422,40.065648],[-80.981692,40.065592],[-80.981979,40.065539],[-80.982505,40.065453],[-80.982902,40.0654],[-80.985348,40.06517],[-80.985731,40.065136],[-80.98694,40.065026],[-80.992523,40.064533],[-80.99357,40.06444],[-80.995327,40.064289],[-80.996146,40.064212],[-80.999556,40.063908],[-81.000002,40.063874],[-81.000548,40.063839],[-81.001792,40.063775],[-81.002343,40.063758],[-81.002771,40.063745],[-81.003878,40.06373],[-81.00443,40.06373],[-81.005112,40.063739],[-81.006394,40.063777],[-81.006601,40.063786],[-81.006991,40.063804],[-81.007177,40.063813],[-81.007786,40.063844],[-81.008605,40.06388],[-81.014853,40.064197],[-81.01607,40.064256],[-81.016448,40.064274],[-81.019297,40.064414],[-81.020109,40.064458],[-81.020799,40.064486],[-81.022295,40.064566],[-81.027069,40.064802],[-81.028157,40.064857],[-81.031612,40.06504],[-81.031656,40.065041],[-81.03305,40.065095],[-81.033501,40.065101],[-81.034073,40.065096],[-81.034775,40.065074],[-81.035206,40.065053],[-81.035621,40.065026],[-81.036054,40.064987],[-81.03661,40.064929],[-81.037318,40.064836],[-81.038254,40.064683],[-81.038892,40.064564],[-81.039556,40.064419],[-81.040335,40.064223],[-81.040869,40.064075],[-81.04138,40.063921],[-81.042084,40.063695],[-81.044437,40.062915],[-81.046564,40.06221],[-81.048524,40.061575],[-81.04871,40.061511],[-81.049261,40.061322],[-81.050137,40.061037],[-81.051406,40.060611],[-81.052069,40.060398],[-81.052682,40.060192],[-81.05291,40.06012],[-81.053094,40.06006],[-81.05547,40.059272],[-81.058163,40.058386],[-81.0601,40.057748],[-81.060728,40.057547],[-81.06121,40.057402],[-81.061618,40.057293],[-81.06212,40.057166],[-81.06264,40.057041],[-81.063191,40.056926],[-81.063446,40.056873],[-81.063862,40.056799],[-81.06437,40.056719],[-81.064796,40.056659],[-81.065349,40.056587],[-81.065734,40.056543],[-81.066436,40.056483],[-81.066861,40.056458],[-81.06741,40.056437],[-81.067976,40.056428],[-81.068709,40.05643],[-81.069273,40.056448],[-81.069696,40.056466],[-81.07028,40.056505],[-81.070767,40.05655],[-81.070899,40.056566],[-81.071355,40.05661],[-81.0719,40.056675],[-81.072748,40.056793],[-81.07425,40.05701],[-81.075237,40.057147],[-81.07774,40.057518],[-81.078512,40.057626],[-81.079195,40.057728],[-81.082012,40.058128],[-81.082521,40.058206],[-81.083495,40.058348],[-81.086832,40.058823],[-81.087285,40.058887],[-81.089686,40.059236],[-81.093189,40.059738],[-81.093857,40.059839],[-81.09506,40.060009],[-81.097346,40.060341],[-81.098126,40.060438],[-81.098442,40.060466],[-81.098718,40.060485],[-81.099084,40.060501],[-81.099435,40.060507],[-81.099715,40.060506],[-81.10008,40.060496],[-81.100487,40.060474],[-81.100769,40.060452],[-81.101149,40.060411],[-81.101698,40.06033],[-81.101959,40.060288],[-81.102235,40.060233],[-81.102768,40.060106],[-81.103046,40.060035],[-81.103644,40.059848],[-81.10389,40.059763],[-81.104383,40.059575],[-81.104643,40.05947],[-81.104874,40.059382],[-81.105599,40.059078],[-81.10851,40.057884],[-81.10915,40.05764],[-81.109389,40.057556],[-81.109934,40.057386],[-81.110562,40.057223],[-81.110946,40.05714],[-81.111931,40.056986],[-81.112216,40.056956],[-81.112476,40.056933],[-81.112761,40.056914],[-81.113161,40.056897],[-81.113556,40.056893],[-81.11397,40.056906],[-81.114507,40.056942],[-81.115055,40.056999],[-81.115722,40.057102],[-81.116367,40.057229],[-81.11715,40.057425],[-81.11759,40.057545],[-81.117689,40.057572],[-81.11798,40.057646],[-81.118464,40.05778],[-81.119315,40.058082],[-81.120558,40.05837],[-81.12214,40.058749],[-81.122874,40.058941],[-81.123341,40.059063],[-81.123888,40.059184],[-81.1243,40.059266],[-81.124565,40.059312],[-81.124845,40.059355],[-81.12561,40.059451],[-81.126046,40.059492],[-81.126456,40.059523],[-81.126882,40.059543],[-81.127166,40.059552],[-81.128144,40.059555],[-81.129779,40.059539],[-81.133676,40.059518],[-81.134628,40.059518],[-81.136147,40.059501],[-81.140625,40.059472],[-81.141214,40.059457],[-81.14152,40.059442],[-81.141864,40.059419],[-81.142307,40.059384],[-81.142712,40.05934],[-81.143269,40.059266],[-81.144144,40.059113],[-81.144855,40.058996],[-81.145422,40.058893],[-81.147572,40.058528],[-81.148447,40.058375],[-81.149167,40.058242],[-81.149535,40.058185],[-81.14987,40.05814],[-81.150512,40.058074],[-81.150785,40.058051],[-81.151083,40.058032],[-81.151419,40.058016],[-81.15165,40.05801],[-81.151793,40.058006],[-81.152222,40.058003],[-81.152706,40.058015],[-81.153066,40.058032],[-81.15345,40.058059],[-81.153732,40.058083],[-81.154042,40.058116],[-81.154405,40.058161],[-81.154763,40.058214],[-81.155342,40.058314],[-81.155753,40.058397],[-81.156178,40.058492],[-81.156565,40.05859],[-81.157231,40.058778],[-81.157796,40.058944],[-81.158001,40.059004],[-81.15909,40.059324],[-81.160028,40.0596],[-81.160431,40.059704],[-81.160837,40.059803],[-81.161299,40.059903],[-81.161646,40.059968],[-81.162053,40.060036],[-81.162461,40.060095],[-81.16294,40.06015],[-81.16333,40.06019],[-81.163757,40.060222],[-81.164183,40.060243],[-81.164568,40.060255],[-81.164906,40.060256],[-81.165295,40.060249],[-81.165713,40.060235],[-81.168213,40.060075],[-81.169117,40.060014],[-81.169575,40.059988],[-81.170004,40.059971],[-81.170458,40.059966],[-81.170812,40.059969],[-81.171177,40.05998],[-81.17162,40.060006],[-81.176966,40.060381],[-81.177365,40.060397],[-81.177712,40.060403],[-81.178116,40.060402],[-81.178469,40.060394],[-81.178876,40.060377],[-81.17922,40.060354],[-81.179906,40.060289],[-81.1803,40.060244],[-81.180782,40.060175],[-81.181731,40.060025],[-81.182305,40.059945],[-81.183269,40.059796],[-81.184427,40.059629],[-81.184856,40.059581],[-81.185235,40.059549],[-81.185605,40.059525],[-81.185974,40.059508],[-81.18632,40.059502],[-81.186742,40.0595],[-81.190656,40.059563],[-81.191258,40.059565],[-81.191602,40.059556],[-81.19202,40.059539],[-81.192548,40.059497],[-81.192812,40.059472],[-81.193671,40.059375],[-81.194391,40.059283],[-81.195853,40.059106],[-81.197031,40.058956],[-81.197518,40.058904],[-81.198046,40.058865],[-81.198427,40.058844],[-81.198776,40.058832],[-81.199108,40.058827],[-81.199436,40.05883],[-81.1999,40.058845],[-81.200404,40.058876],[-81.20153,40.058971],[-81.204722,40.059263],[-81.205851,40.059372],[-81.207302,40.059499],[-81.207806,40.059529],[-81.208225,40.059548],[-81.208725,40.059553],[-81.209086,40.05955],[-81.209857,40.059524],[-81.210249,40.059503],[-81.210591,40.05948],[-81.211332,40.059411],[-81.211712,40.059362],[-81.212131,40.059303],[-81.212864,40.05918],[-81.213495,40.05905],[-81.21378,40.058985],[-81.214161,40.058892],[-81.214792,40.05872],[-81.215099,40.058629],[-81.215487,40.058507],[-81.222541,40.056175],[-81.223395,40.055943],[-81.22367,40.055858],[-81.223921,40.055789],[-81.224227,40.055718],[-81.224633,40.055637],[-81.225244,40.055533],[-81.225859,40.055449],[-81.226674,40.055369],[-81.227101,40.055339],[-81.227427,40.055327],[-81.228125,40.055321],[-81.228637,40.055336],[-81.229137,40.055361],[-81.2294,40.055382],[-81.229661,40.055403],[-81.229941,40.055432],[-81.230125,40.055459],[-81.230682,40.055555],[-81.231516,40.05572],[-81.232218,40.055858],[-81.233591,40.056252],[-81.236037,40.056922],[-81.2379,40.057316],[-81.238664,40.057375],[-81.240921,40.057441],[-81.242003,40.057323],[-81.245856,40.056896],[-81.248054,40.056764],[-81.249058,40.056797],[-81.254422,40.057625],[-81.25571,40.057789],[-81.256869,40.057782],[-81.257933,40.05773],[-81.259169,40.057658],[-81.260534,40.057434],[-81.262061,40.05704],[-81.263978,40.056518],[-81.26661,40.055864],[-81.268027,40.055628],[-81.269434,40.055582],[-81.27088,40.055622],[-81.282403,40.055923],[-81.285193,40.056133],[-81.286952,40.056298],[-81.289189,40.056598],[-81.289642,40.056658],[-81.292446,40.057207],[-81.295767,40.057927],[-81.299775,40.058925],[-81.301947,40.059451],[-81.302848,40.059596],[-81.303921,40.059674],[-81.305114,40.059655],[-81.306092,40.059582],[-81.30708,40.059438],[-81.308075,40.059215],[-81.309981,40.058558],[-81.311857,40.057895],[-81.3204,40.054476],[-81.321585,40.05399],[-81.322966,40.053387],[-81.324097,40.052975],[-81.325619,40.052453],[-81.327215,40.051973],[-81.328468,40.051651],[-81.329656,40.051339],[-81.330719,40.051106],[-81.332956,40.050645],[-81.337163,40.050009],[-81.344072,40.049108],[-81.345308,40.048872],[-81.356285,40.046948],[-81.357839,40.046717],[-81.362507,40.045916],[-81.367933,40.044923],[-81.370396,40.044522],[-81.371692,40.044266],[-81.375585,40.043599],[-81.377018,40.043325],[-81.377385,40.043258],[-81.380748,40.042676],[-81.390163,40.040672],[-81.391228,40.040455],[-81.393373,40.040041],[-81.395141,40.039673],[-81.396137,40.039456],[-81.397939,40.039114],[-81.400575,40.038556],[-81.403613,40.037945],[-81.405261,40.0378],[-81.407364,40.037833],[-81.412647,40.038386],[-81.413136,40.038437],[-81.417981,40.038943],[-81.421409,40.038818],[-81.422361,40.038728],[-81.423405,40.038626],[-81.425578,40.038152],[-81.426726,40.03784],[-81.428769,40.037183],[-81.431373,40.036227],[-81.433379,40.035653],[-81.435552,40.035035],[-81.437964,40.034417],[-81.438421,40.034322],[-81.438663,40.034271],[-81.439947,40.034002],[-81.440048,40.033982],[-81.443121,40.033601],[-81.447062,40.033022],[-81.44769,40.03293],[-81.451072,40.03249],[-81.451688,40.032379],[-81.452343,40.032288],[-81.454874,40.031692],[-81.457276,40.031003],[-81.457433,40.030959],[-81.460946,40.029792],[-81.463327,40.028853],[-81.465857,40.027594],[-81.468192,40.026266],[-81.470183,40.024998],[-81.471514,40.024045],[-81.473187,40.022704],[-81.47608,40.020016],[-81.477788,40.018399],[-81.481418,40.014954],[-81.484927,40.011682],[-81.486325,40.010286],[-81.488883,40.007996],[-81.490133,40.007103],[-81.491907,40.005974],[-81.493315,40.005251],[-81.494293,40.004817],[-81.496377,40.004091],[-81.496634,40.004014],[-81.497867,40.003644],[-81.499842,40.003346],[-81.503454,40.003096],[-81.504842,40.003076],[-81.504971,40.003074],[-81.511831,40.003501],[-81.513403,40.003602],[-81.516686,40.003758],[-81.52999,40.004666],[-81.53405,40.004528],[-81.535183,40.004455],[-81.53617,40.004363],[-81.536784,40.004214],[-81.549971,40.001714],[-81.552126,40.001271],[-81.556733,40.000051],[-81.557387,39.999865],[-81.557931,39.999694],[-81.55876,39.999464],[-81.560533,39.998859],[-81.563731,39.99752],[-81.564289,39.997349],[-81.565096,39.997139],[-81.565516,39.997066],[-81.567167,39.99696],[-81.568744,39.997076],[-81.569409,39.997174],[-81.570037,39.997296],[-81.570519,39.997394],[-81.571764,39.997689],[-81.57333,39.998094],[-81.573478,39.998132],[-81.578643,39.999588],[-81.585825,40.001456],[-81.587756,40.001951],[-81.589684,40.002509],[-81.591647,40.003212],[-81.593446,40.003941],[-81.602534,40.007796],[-81.60418,40.008462],[-81.605791,40.008984],[-81.607531,40.009345],[-81.609165,40.009516],[-81.610663,40.009585],[-81.611573,40.009506],[-81.612526,40.009381],[-81.613786,40.009158],[-81.615439,40.008836],[-81.615878,40.008753],[-81.616951,40.008554],[-81.619795,40.007954],[-81.621194,40.007738],[-81.623047,40.00753],[-81.625162,40.007452],[-81.626181,40.007477],[-81.63145,40.007692],[-81.644,40.008173],[-81.645838,40.008244],[-81.647829,40.008126],[-81.650078,40.007777],[-81.65638,40.006457],[-81.658017,40.00601],[-81.65941,40.005415],[-81.660558,40.004854],[-81.662203,40.003682],[-81.66338,40.002627],[-81.664653,40.001004],[-81.667214,39.997374],[-81.66897,39.994885],[-81.670939,39.992917],[-81.672414,39.991733],[-81.674437,39.990383],[-81.680924,39.986609],[-81.682267,39.985933],[-81.684374,39.985155],[-81.686232,39.984782],[-81.687627,39.984609],[-81.689567,39.984577],[-81.70221,39.985521],[-81.702668,39.985561],[-81.706026,39.985813],[-81.708627,39.985739],[-81.710553,39.98552],[-81.712816,39.985085],[-81.718092,39.983823],[-81.725221,39.982119],[-81.72748,39.981595],[-81.728575,39.981321],[-81.730425,39.980965],[-81.731049,39.980938],[-81.73182,39.980907],[-81.732523,39.980857],[-81.733994,39.980882],[-81.738992,39.981305],[-81.740571,39.981288],[-81.742172,39.981122],[-81.743394,39.980907],[-81.749333,39.979406],[-81.751432,39.978917],[-81.752849,39.978652],[-81.754352,39.978503],[-81.756018,39.978428],[-81.757251,39.978437],[-81.764759,39.978818],[-81.766641,39.978901],[-81.767906,39.978892],[-81.768934,39.978859],[-81.77815,39.978262],[-81.779503,39.978146],[-81.781179,39.977914],[-81.782802,39.977566],[-81.783949,39.977268],[-81.785236,39.976853],[-81.798054,39.972601],[-81.799644,39.972112],[-81.801667,39.971739],[-81.802857,39.971623],[-81.813047,39.971399],[-81.816054,39.971399],[-81.81865,39.971531],[-81.82037,39.971681],[-81.8246,39.972112],[-81.826206,39.972284],[-81.827247,39.972502],[-81.828443,39.972859],[-81.831954,39.974324],[-81.832437,39.974513],[-81.835158,39.975687],[-81.836694,39.976189],[-81.837638,39.976395],[-81.839446,39.976674],[-81.841259,39.976723],[-81.842949,39.976629],[-81.844467,39.976395],[-81.845845,39.976111],[-81.851819,39.974832],[-81.852273,39.974726],[-81.85554,39.973964],[-81.858658,39.973199],[-81.862083,39.97236],[-81.867871,39.970878],[-81.869459,39.970516],[-81.870893,39.970339],[-81.874854,39.970192],[-81.883605,39.969718],[-81.884093,39.969691],[-81.88638,39.969567],[-81.888485,39.969294],[-81.894492,39.968424],[-81.898245,39.967882],[-81.901059,39.967483],[-81.903483,39.966941],[-81.904793,39.966502],[-81.915345,39.962894],[-81.916153,39.962619],[-81.919662,39.961521],[-81.922637,39.960744],[-81.925143,39.960164],[-81.930751,39.959009],[-81.931558,39.95884],[-81.934518,39.958242],[-81.93598,39.957878],[-81.938843,39.957132],[-81.942534,39.956156],[-81.943927,39.955709],[-81.945567,39.955062],[-81.947195,39.954249],[-81.950204,39.952583],[-81.951722,39.951744],[-81.953169,39.951069],[-81.954125,39.950749],[-81.954805,39.950521],[-81.956571,39.950104],[-81.957944,39.949943],[-81.959582,39.94988],[-81.964201,39.949838],[-81.9662,39.949731],[-81.967653,39.949609],[-81.969349,39.949445],[-81.978904,39.948157],[-81.980178,39.947899],[-81.98102,39.947667],[-81.98192,39.947371],[-81.982867,39.946994],[-81.983506,39.946667],[-81.985843,39.945458],[-81.98762,39.944623],[-81.988553,39.94428],[-81.989092,39.944118],[-81.989854,39.943915],[-81.990605,39.943796],[-81.991225,39.943741],[-81.991815,39.943681],[-81.992555,39.943664],[-81.993676,39.943716],[-81.99434,39.943792],[-81.99512,39.943952],[-81.998261,39.944518],[-81.999709,39.944646],[-82.000812,39.944653],[-82.001353,39.944659],[-82.003382,39.944696],[-82.003773,39.944703],[-82.004615,39.944733],[-82.004995,39.944767],[-82.005956,39.944915],[-82.006287,39.944965],[-82.006992,39.945133],[-82.007656,39.94536],[-82.007782,39.945393],[-82.008409,39.945648],[-82.010058,39.946364],[-82.010931,39.946744],[-82.011693,39.947005],[-82.012444,39.947204],[-82.013118,39.94736],[-82.013813,39.947459],[-82.014658,39.947545],[-82.01779,39.947894],[-82.02079,39.948545],[-82.022094,39.948886],[-82.023617,39.949128],[-82.025936,39.949401],[-82.026968,39.949474],[-82.028439,39.949494],[-82.029941,39.949413],[-82.041877,39.948263],[-82.043626,39.948107],[-82.04468,39.948064],[-82.046597,39.948171],[-82.047841,39.948336],[-82.049068,39.948608],[-82.051939,39.949521],[-82.05384,39.949934],[-82.055057,39.95002],[-82.057366,39.94998],[-82.05862,39.949853],[-82.060603,39.949434],[-82.068242,39.947091],[-82.06991,39.946619],[-82.071603,39.946331],[-82.083308,39.94485],[-82.085551,39.944641],[-82.087653,39.944635],[-82.096248,39.944935],[-82.096666,39.944952],[-82.144037,39.94709],[-82.147198,39.947223],[-82.150066,39.947505],[-82.154974,39.94817],[-82.170011,39.950453],[-82.170477,39.950527],[-82.177913,39.951678],[-82.179709,39.951949],[-82.181517,39.952233],[-82.185072,39.952784],[-82.18674,39.953047],[-82.188439,39.953307],[-82.189793,39.953464],[-82.190771,39.953503],[-82.191853,39.953501],[-82.192854,39.953429],[-82.193892,39.953311],[-82.198659,39.952425],[-82.208298,39.950634],[-82.211527,39.949977],[-82.214428,39.949471],[-82.216333,39.949076],[-82.217689,39.948668],[-82.21896,39.948148],[-82.221543,39.947043],[-82.225706,39.945299],[-82.229302,39.943785],[-82.232048,39.942652],[-82.242519,39.938223],[-82.243136,39.937962],[-82.245804,39.937053],[-82.246111,39.936951],[-82.246608,39.936812],[-82.247062,39.936702],[-82.247457,39.936605],[-82.248124,39.93647],[-82.249286,39.936279],[-82.25006,39.936182],[-82.250242,39.93616],[-82.25074,39.93613],[-82.250998,39.936108],[-82.251339,39.936084],[-82.251826,39.936069],[-82.252267,39.936058],[-82.253756,39.936079],[-82.254637,39.936103],[-82.254954,39.936122],[-82.255333,39.936143],[-82.257378,39.936243],[-82.26082,39.936325],[-82.273726,39.936911],[-82.279408,39.937165],[-82.282167,39.937289],[-82.288092,39.937605],[-82.288702,39.937638],[-82.304067,39.938273],[-82.311283,39.938619],[-82.318262,39.939054],[-82.318863,39.939087],[-82.321481,39.939233],[-82.326373,39.939456],[-82.328677,39.939566],[-82.329836,39.939631],[-82.330998,39.93969],[-82.335557,39.939963],[-82.358067,39.941053],[-82.379328,39.942195],[-82.394557,39.943037],[-82.395097,39.943076],[-82.403539,39.943608],[-82.408077,39.943913],[-82.408816,39.943969],[-82.409009,39.943984],[-82.40947,39.944026],[-82.410252,39.944079],[-82.411655,39.944183],[-82.412916,39.944291],[-82.414149,39.944383],[-82.414463,39.944409],[-82.41551,39.94448],[-82.416793,39.944562],[-82.41812,39.944641],[-82.419428,39.944728],[-82.420667,39.944813],[-82.42185,39.944899],[-82.424579,39.945078],[-82.425941,39.945162],[-82.42734,39.945262],[-82.428712,39.945352],[-82.429957,39.945425],[-82.431192,39.945506],[-82.432134,39.945564],[-82.433405,39.945635],[-82.43414,39.945671],[-82.435217,39.945728],[-82.436003,39.945762],[-82.437247,39.945814],[-82.438407,39.945877],[-82.439112,39.945924],[-82.442408,39.946146],[-82.444131,39.94626],[-82.447183,39.94644],[-82.449481,39.946515],[-82.450819,39.946597],[-82.452426,39.946681],[-82.453618,39.946766],[-82.455725,39.946868],[-82.456602,39.946911],[-82.457209,39.94692],[-82.457609,39.946934],[-82.458611,39.946931],[-82.459578,39.946931],[-82.460258,39.946909],[-82.461647,39.946833],[-82.463947,39.946641],[-82.466433,39.946433],[-82.470543,39.946108],[-82.473974,39.945828],[-82.47519,39.945728],[-82.476933,39.945608],[-82.478036,39.94551],[-82.478383,39.945481],[-82.47985,39.945358],[-82.480821,39.945287],[-82.483754,39.945048],[-82.487226,39.944761],[-82.490216,39.944518],[-82.49125,39.944436],[-82.491615,39.944404],[-82.493231,39.944327],[-82.495081,39.944174],[-82.49878,39.943876],[-82.502385,39.943581],[-82.503934,39.943456],[-82.506179,39.943278],[-82.510398,39.942935],[-82.515449,39.942501],[-82.516318,39.942423],[-82.517946,39.942287],[-82.518844,39.942223],[-82.519183,39.9422],[-82.51948,39.942181],[-82.520747,39.942109],[-82.521618,39.942073],[-82.522403,39.942046],[-82.52308,39.942042],[-82.52407,39.942051],[-82.524568,39.942057],[-82.52519,39.942075],[-82.526371,39.942121],[-82.527749,39.94218],[-82.529028,39.942232],[-82.531541,39.942336],[-82.534265,39.942474],[-82.53545,39.942524],[-82.536738,39.942551],[-82.53919,39.94263],[-82.540964,39.942727],[-82.543046,39.942841],[-82.544469,39.942903],[-82.545441,39.942946],[-82.54884,39.943013],[-82.549529,39.943043],[-82.550677,39.943151],[-82.552825,39.943239],[-82.554847,39.943323],[-82.557117,39.943411],[-82.563018,39.943631],[-82.566065,39.943764],[-82.569165,39.943892],[-82.572638,39.944019],[-82.573293,39.944046],[-82.576428,39.944172],[-82.579315,39.944286],[-82.581032,39.944355],[-82.582049,39.944392],[-82.583411,39.944454],[-82.588006,39.944588],[-82.591837,39.944798],[-82.593466,39.944885],[-82.594945,39.944958],[-82.595813,39.945],[-82.596701,39.945014],[-82.597362,39.945049],[-82.598542,39.945143],[-82.598858,39.945172],[-82.600078,39.945329],[-82.600856,39.945425],[-82.603984,39.945835],[-82.604283,39.945878],[-82.605131,39.945943],[-82.60591,39.945965],[-82.606479,39.945964],[-82.607206,39.945954],[-82.607744,39.94593],[-82.60838,39.945897],[-82.608871,39.945867],[-82.609164,39.945857],[-82.609536,39.945835],[-82.610845,39.945773],[-82.61197,39.945748],[-82.613027,39.945751],[-82.613868,39.94577],[-82.614349,39.94579],[-82.615577,39.945834],[-82.616826,39.945875],[-82.617685,39.945912],[-82.618447,39.945939],[-82.619385,39.945995],[-82.620376,39.946036],[-82.621191,39.946073],[-82.622327,39.946128],[-82.623434,39.94618],[-82.624608,39.946238],[-82.626901,39.946332],[-82.627542,39.946368],[-82.627774,39.946376],[-82.629735,39.946478],[-82.631744,39.946545],[-82.632749,39.94658],[-82.633744,39.946626],[-82.634618,39.946674],[-82.634954,39.946691],[-82.637323,39.946791],[-82.638458,39.946846],[-82.639654,39.946898],[-82.640538,39.946924],[-82.641537,39.946973],[-82.642557,39.947011],[-82.643627,39.947067],[-82.64473,39.947128],[-82.645922,39.947189],[-82.646354,39.947209],[-82.649441,39.94734],[-82.651438,39.947425],[-82.652753,39.947484],[-82.654067,39.947549],[-82.655363,39.947601],[-82.656275,39.947646],[-82.658037,39.947727],[-82.659432,39.9478],[-82.660905,39.947862],[-82.662403,39.947942],[-82.664473,39.948042],[-82.666085,39.948123],[-82.667218,39.948176],[-82.667926,39.948212],[-82.669288,39.948289],[-82.670748,39.948359],[-82.678705,39.948742],[-82.681608,39.948861],[-82.68368,39.94897],[-82.684021,39.948981],[-82.685517,39.949055],[-82.686816,39.949156],[-82.687596,39.949191],[-82.691321,39.949344],[-82.692904,39.949413],[-82.694712,39.949498],[-82.696039,39.949562],[-82.697032,39.949619],[-82.697929,39.949665],[-82.699124,39.949733],[-82.70043,39.949805],[-82.701748,39.949874],[-82.705732,39.950091],[-82.706592,39.950138],[-82.707709,39.950202],[-82.708556,39.950247],[-82.709741,39.9503],[-82.710926,39.950356],[-82.712148,39.95043],[-82.713305,39.950483],[-82.714554,39.950544],[-82.716054,39.950632],[-82.717048,39.950701],[-82.717731,39.950733],[-82.718966,39.950795],[-82.72183,39.950944],[-82.723364,39.951027],[-82.726398,39.951186],[-82.72775,39.951252],[-82.728926,39.951315],[-82.731077,39.951439],[-82.733131,39.951545],[-82.735478,39.951662],[-82.73591,39.951685],[-82.738484,39.951824],[-82.739398,39.951866],[-82.740183,39.951889],[-82.740515,39.951892],[-82.740992,39.951895],[-82.741541,39.951883],[-82.742218,39.951848],[-82.742592,39.95183],[-82.743025,39.951801],[-82.74337,39.951767],[-82.74375,39.951727],[-82.744041,39.951688],[-82.744429,39.951638],[-82.744777,39.95159],[-82.745076,39.951544],[-82.745311,39.951504],[-82.745587,39.951453],[-82.745803,39.95141],[-82.746215,39.951323],[-82.746468,39.951266],[-82.74691,39.951163],[-82.747162,39.9511],[-82.747765,39.950938],[-82.748146,39.950829],[-82.748495,39.95072],[-82.748888,39.950585],[-82.749587,39.950335],[-82.750045,39.950162],[-82.750331,39.950051],[-82.750604,39.949939],[-82.750886,39.94982],[-82.751034,39.949748],[-82.751508,39.949508],[-82.751796,39.94937],[-82.75242,39.949048],[-82.752674,39.948903],[-82.753195,39.948608],[-82.75344,39.948466],[-82.753703,39.948318],[-82.753935,39.948185],[-82.754103,39.948081],[-82.754319,39.94794],[-82.754675,39.947698],[-82.755059,39.947444],[-82.755424,39.947213],[-82.755778,39.947006],[-82.756186,39.946757],[-82.756621,39.946476],[-82.75698,39.946238],[-82.757147,39.946122],[-82.757326,39.946],[-82.757825,39.945657],[-82.758149,39.945433],[-82.758515,39.945185],[-82.758672,39.945084],[-82.758841,39.944977],[-82.759153,39.944782],[-82.759454,39.944588],[-82.759891,39.944304],[-82.760347,39.944011],[-82.761208,39.943469],[-82.763894,39.94173],[-82.76411,39.941585],[-82.765411,39.940775],[-82.766411,39.940177],[-82.766856,39.939948],[-82.767313,39.939736],[-82.768002,39.939411],[-82.768529,39.939213],[-82.770028,39.938663],[-82.771565,39.938202],[-82.773013,39.937821],[-82.778994,39.936334],[-82.780572,39.935941],[-82.781416,39.935733],[-82.782684,39.935421],[-82.783761,39.935155],[-82.78501,39.934848],[-82.786773,39.934424],[-82.789052,39.93386],[-82.789652,39.933712],[-82.789802,39.933675],[-82.790792,39.93342],[-82.792568,39.932963],[-82.793428,39.932751],[-82.794121,39.932602],[-82.794724,39.93245],[-82.795545,39.932259],[-82.795913,39.932171],[-82.797242,39.931834],[-82.797803,39.931704],[-82.798368,39.931594],[-82.798844,39.931518],[-82.799103,39.931482],[-82.799863,39.931393],[-82.800212,39.931365],[-82.800678,39.931339],[-82.801262,39.931317],[-82.801848,39.931324],[-82.802393,39.931339],[-82.804535,39.93146],[-82.811518,39.931866],[-82.817338,39.932185],[-82.818142,39.932231],[-82.820932,39.932387],[-82.823633,39.93254],[-82.823718,39.932544],[-82.825127,39.932622],[-82.826852,39.932718],[-82.828202,39.932793],[-82.829827,39.932883],[-82.83205,39.933003],[-82.83514,39.933201],[-82.836779,39.933306],[-82.841903,39.933589],[-82.844873,39.93372],[-82.846873,39.933839],[-82.850881,39.93405],[-82.854898,39.93426],[-82.857481,39.934398],[-82.858803,39.934477],[-82.859781,39.934602],[-82.860666,39.934767],[-82.861532,39.934964],[-82.862554,39.935241],[-82.863876,39.935603],[-82.864811,39.935853],[-82.865877,39.93612],[-82.866366,39.936236],[-82.867695,39.936553],[-82.869338,39.936875],[-82.870015,39.936984],[-82.87096,39.937094],[-82.872187,39.937185],[-82.872384,39.937193],[-82.872969,39.93722],[-82.873723,39.937231],[-82.874795,39.937204],[-82.876251,39.937101],[-82.878141,39.936922],[-82.883358,39.936422],[-82.883839,39.93638],[-82.885088,39.936262],[-82.885365,39.936235],[-82.885618,39.936211],[-82.887115,39.936072],[-82.88724,39.93606],[-82.888038,39.935978],[-82.889378,39.93584],[-82.892268,39.93542],[-82.894642,39.934954],[-82.895216,39.934817],[-82.897403,39.934293],[-82.897916,39.934159],[-82.898395,39.934036],[-82.898734,39.933948],[-82.899256,39.933814],[-82.89931,39.933801],[-82.901171,39.933324],[-82.902279,39.933035],[-82.904008,39.932595],[-82.905486,39.932279],[-82.906526,39.932091],[-82.907624,39.931917],[-82.90904,39.931785],[-82.910076,39.931743],[-82.910509,39.931739],[-82.910959,39.931746],[-82.911194,39.93175],[-82.911325,39.931752],[-82.911999,39.931763],[-82.91367,39.93178],[-82.914599,39.931794],[-82.915805,39.93181],[-82.916894,39.931822],[-82.918992,39.931845],[-82.921066,39.931876],[-82.922594,39.931901],[-82.923657,39.931937],[-82.92534,39.931977],[-82.926997,39.932023],[-82.92831,39.93201],[-82.928997,39.932043],[-82.929855,39.932142],[-82.930506,39.932279],[-82.931267,39.932522],[-82.931776,39.932713],[-82.932308,39.932937],[-82.932944,39.933312],[-82.933699,39.933957],[-82.934258,39.934533],[-82.934478,39.934814],[-82.935217,39.935774],[-82.936859,39.937904],[-82.940719,39.942883],[-82.94168,39.944136],[-82.941733,39.944204],[-82.942691,39.945478],[-82.9429,39.945763],[-82.943089,39.946073],[-82.943226,39.946369],[-82.943381,39.946823],[-82.943484,39.947257],[-82.943518,39.947678],[-82.943544,39.948205],[-82.943535,39.948573],[-82.943535,39.949053],[-82.943578,39.94958],[-82.94369,39.950119],[-82.943921,39.950679],[-82.944325,39.951238],[-82.944659,39.951593],[-82.945089,39.951975],[-82.945518,39.952284],[-82.946067,39.952587],[-82.946591,39.952784],[-82.947174,39.952955],[-82.947698,39.953047],[-82.948136,39.953093],[-82.948378,39.953119],[-82.949205,39.953168],[-82.949545,39.95319],[-82.951305,39.953264],[-82.952595,39.953332],[-82.953054,39.953343],[-82.953527,39.95337],[-82.954179,39.953392],[-82.954792,39.953411],[-82.95508,39.953422],[-82.956273,39.953472],[-82.956614,39.953486],[-82.957991,39.953542],[-82.95937,39.953583],[-82.963053,39.953657],[-82.963711,39.953675],[-82.964331,39.953694],[-82.964873,39.953702],[-82.965957,39.95372],[-82.966823,39.953738],[-82.966906,39.95374],[-82.967697,39.953758],[-82.968797,39.953803],[-82.96997,39.953872],[-82.970507,39.953917],[-82.972361,39.954089],[-82.972557,39.954108],[-82.973654,39.954211],[-82.974833,39.954322],[-82.975203,39.954357],[-82.976014,39.954413],[-82.976834,39.954528],[-82.977569,39.954655],[-82.978276,39.954864],[-82.978665,39.954974],[-82.979077,39.955103],[-82.979316,39.955174],[-82.980154,39.955369],[-82.980729,39.955473],[-82.980905,39.955491],[-82.981527,39.955556],[-82.982067,39.955572],[-82.982447,39.955571],[-82.98285,39.955554],[-82.983202,39.955532],[-82.983772,39.955461],[-82.984214,39.955389],[-82.984494,39.955329],[-82.984897,39.955237],[-82.98557,39.955051],[-82.986441,39.9548],[-82.987242,39.954571],[-82.987878,39.954436],[-82.988228,39.954371],[-82.989531,39.954168],[-82.990467,39.954069],[-82.990612,39.954052],[-82.991273,39.954059],[-82.991887,39.954049],[-82.992876,39.954],[-82.994021,39.953996],[-82.994252,39.953996],[-82.994338,39.954005],[-82.994377,39.954039],[-82.99449,39.954058],[-82.994613,39.954152],[-82.994705,39.954638],[-82.994828,39.955305],[-82.994953,39.955982],[-82.995077,39.95666],[-82.995204,39.957319],[-82.995332,39.957984],[-82.995589,39.959315],[-82.995718,39.959987],[-82.995849,39.960667],[-82.99599,39.961398],[-82.996107,39.962007],[-82.996247,39.962731],[-82.997115,39.96263],[-82.997983,39.962524],[-82.998118,39.96251],[-82.99856,39.962464],[-82.998587,39.962462],[-82.999005,39.962415],[-82.999447,39.962365],[-82.999747,39.962332],[-83.000508,39.962247],[-83.000642,39.962232],[-83.000656,39.962305]]},{_id:'5',truck:'2',from:{name:'Pittsburg',lat:40.440907,lng:-79.99009},to:{name:'Colmbus',lat:39.962305,lng:-83.000656},startDate:new Date(2017,10,4,9,0),endDate:new Date(2017,10,4,16,0),km:515,revenue:1066,selected:false,drive:2,duty:2,off:6,berth:2,time:1,distance:50,fuel:525,tolls:85,vectorPath:[[-79.99009,40.440907],[-79.990477,40.440904],[-79.990477,40.440742],[-79.990471,40.44054],[-79.990922,40.440537],[-79.991315,40.440537],[-79.99138,40.440536],[-79.99148,40.440535],[-79.99165,40.440533],[-79.991754,40.44053],[-79.992108,40.440527],[-79.992375,40.440514],[-79.992605,40.440485],[-79.992797,40.440455],[-79.992936,40.440422],[-79.993094,40.440379],[-79.993292,40.440313],[-79.99336,40.440243],[-79.993407,40.440226],[-79.993448,40.440213],[-79.993586,40.440163],[-79.994025,40.440006],[-79.994068,40.439991],[-79.99422,40.439941],[-79.994219,40.439903],[-79.994224,40.439847],[-79.994233,40.439812],[-79.994333,40.439618],[-79.994657,40.439008],[-79.994688,40.438957],[-79.995409,40.438977],[-79.995605,40.438981],[-79.995773,40.43901],[-79.996181,40.439161],[-79.996754,40.439375],[-79.996845,40.43941],[-79.997312,40.438707],[-79.997757,40.438051],[-79.998099,40.437533],[-79.998358,40.437159],[-79.998408,40.437088],[-79.998504,40.436947],[-79.998738,40.436613],[-79.998785,40.436553],[-79.998986,40.436288],[-79.999076,40.436178],[-79.999195,40.436083],[-79.999283,40.43604],[-79.999422,40.436004],[-79.999562,40.435993],[-79.999685,40.436019],[-79.999819,40.436064],[-80.000013,40.436156],[-80.000798,40.436509],[-80.001372,40.436734],[-80.002488,40.437211],[-80.004068,40.437792],[-80.005761,40.43844],[-80.006117,40.438576],[-80.006658,40.438765],[-80.007725,40.439153],[-80.008402,40.439368],[-80.008654,40.439446],[-80.009073,40.439552],[-80.0094,40.439597],[-80.00969,40.439597],[-80.009979,40.439552],[-80.010332,40.439429],[-80.012214,40.438421],[-80.01279,40.438078],[-80.013852,40.43757],[-80.024521,40.431948],[-80.026925,40.430671],[-80.028374,40.429879],[-80.028777,40.429619],[-80.0289,40.42954],[-80.029334,40.429213],[-80.029779,40.428805],[-80.030058,40.428487],[-80.030396,40.428013],[-80.030638,40.427531],[-80.030782,40.427163],[-80.030879,40.426812],[-80.030949,40.426412],[-80.030986,40.425963],[-80.030954,40.425571],[-80.030913,40.425122],[-80.030808,40.424607],[-80.030595,40.423766],[-80.030525,40.423329],[-80.030503,40.42299],[-80.030536,40.422676],[-80.030622,40.42232],[-80.030777,40.421961],[-80.030959,40.421663],[-80.031147,40.421397],[-80.031448,40.421079],[-80.03192,40.420734],[-80.032263,40.420517],[-80.03281,40.420276],[-80.033524,40.420089],[-80.034098,40.419999],[-80.03465,40.41999],[-80.035305,40.420031],[-80.036833,40.42024],[-80.03929,40.420591],[-80.042289,40.42102],[-80.043083,40.421097],[-80.043839,40.421138],[-80.044488,40.421146],[-80.045213,40.421142],[-80.045937,40.421097],[-80.046366,40.421061],[-80.046863,40.421025],[-80.047736,40.420882],[-80.048614,40.420693],[-80.04951,40.420456],[-80.049853,40.42035],[-80.050443,40.420154],[-80.050867,40.420003],[-80.051468,40.41975],[-80.051872,40.419564],[-80.052117,40.419451],[-80.053801,40.418651],[-80.056773,40.417234],[-80.060496,40.415457],[-80.066048,40.412815],[-80.069572,40.411132],[-80.070114,40.410895],[-80.07057,40.410736],[-80.071005,40.410625],[-80.071509,40.410552],[-80.071992,40.410531],[-80.07255,40.410564],[-80.073006,40.410625],[-80.073451,40.410736],[-80.073843,40.410858],[-80.074937,40.411258],[-80.076283,40.411744],[-80.077346,40.412135],[-80.078515,40.412565],[-80.080382,40.413235],[-80.081007,40.413478],[-80.081495,40.413711],[-80.081998,40.413972],[-80.082453,40.414246],[-80.082718,40.414422],[-80.084043,40.41538],[-80.086001,40.416781],[-80.086286,40.416985],[-80.087549,40.417857],[-80.088749,40.418584],[-80.089308,40.418911],[-80.089994,40.419249],[-80.090573,40.419532],[-80.091541,40.419972],[-80.092391,40.42033],[-80.093016,40.420581],[-80.093609,40.420808],[-80.094598,40.421224],[-80.095642,40.421637],[-80.097066,40.422204],[-80.098493,40.422754],[-80.098794,40.422874],[-80.099169,40.423015],[-80.099348,40.423069],[-80.09957,40.423124],[-80.099784,40.423168],[-80.100002,40.423199],[-80.100273,40.423225],[-80.10049,40.423235],[-80.100709,40.423237],[-80.100976,40.423224],[-80.101222,40.423197],[-80.101427,40.423164],[-80.101635,40.423123],[-80.101941,40.423043],[-80.102171,40.422966],[-80.102423,40.422865],[-80.102657,40.422751],[-80.10284,40.422651],[-80.103019,40.422545],[-80.103263,40.422366],[-80.103441,40.422223],[-80.103573,40.422097],[-80.10372,40.421939],[-80.103822,40.421817],[-80.103927,40.421672],[-80.104046,40.421465],[-80.104129,40.421297],[-80.104191,40.421137],[-80.104245,40.420962],[-80.104276,40.420829],[-80.104301,40.420687],[-80.104317,40.420548],[-80.104317,40.42038],[-80.104308,40.420223],[-80.104293,40.420091],[-80.104267,40.419943],[-80.104218,40.419755],[-80.104168,40.419613],[-80.103964,40.418994],[-80.103666,40.418128],[-80.103605,40.417925],[-80.103563,40.417751],[-80.103541,40.417587],[-80.103529,40.417398],[-80.103536,40.417182],[-80.103549,40.416997],[-80.103581,40.416822],[-80.103625,40.416649],[-80.103672,40.416494],[-80.103738,40.416333],[-80.10384,40.416119],[-80.103973,40.415885],[-80.104097,40.415689],[-80.104239,40.415463],[-80.104388,40.415247],[-80.104551,40.415021],[-80.104828,40.414677],[-80.10503,40.414303],[-80.105886,40.413237],[-80.10631,40.412718],[-80.107085,40.411719],[-80.107332,40.411356],[-80.107525,40.411005],[-80.107723,40.410568],[-80.107887,40.410086],[-80.107959,40.409736],[-80.108014,40.409308],[-80.108029,40.409042],[-80.108027,40.408942],[-80.108021,40.408709],[-80.107967,40.408201],[-80.107881,40.407737],[-80.107726,40.40694],[-80.107131,40.404041],[-80.10687,40.402852],[-80.106694,40.402028],[-80.106556,40.401451],[-80.106477,40.401045],[-80.106348,40.400555],[-80.106205,40.40016],[-80.106071,40.399876],[-80.105904,40.399566],[-80.105711,40.399239],[-80.105502,40.398939],[-80.105178,40.398512],[-80.104887,40.398145],[-80.104386,40.397514],[-80.10275,40.395509],[-80.10208,40.394684],[-80.101711,40.394204],[-80.101119,40.39335],[-80.100564,40.392398],[-80.100043,40.391309],[-80.099773,40.390724],[-80.099644,40.390402],[-80.099199,40.389393],[-80.098598,40.388032],[-80.098099,40.386917],[-80.097236,40.384988],[-80.097107,40.38469],[-80.096822,40.383942],[-80.096699,40.383489],[-80.096651,40.383198],[-80.096635,40.382908],[-80.09664,40.38261],[-80.096672,40.382332],[-80.096758,40.381944],[-80.096849,40.381666],[-80.096999,40.381339],[-80.097181,40.380999],[-80.09758,40.380441],[-80.098125,40.379871],[-80.098672,40.379335],[-80.099633,40.378355],[-80.100721,40.377284],[-80.103039,40.374967],[-80.10396,40.374159],[-80.104383,40.373858],[-80.104938,40.373541],[-80.105413,40.373306],[-80.105995,40.373079],[-80.10666,40.372883],[-80.107395,40.372744],[-80.108178,40.372654],[-80.108905,40.372619],[-80.109809,40.372601],[-80.111878,40.372528],[-80.113149,40.372484],[-80.113907,40.372413],[-80.114497,40.372319],[-80.115066,40.37218],[-80.11572,40.371971],[-80.116257,40.371746],[-80.116809,40.371456],[-80.117303,40.371129],[-80.117839,40.370676],[-80.118242,40.370226],[-80.118617,40.369687],[-80.118944,40.368959],[-80.119075,40.368451],[-80.119143,40.367839],[-80.11916,40.366625],[-80.11914,40.365483],[-80.11908,40.364424],[-80.119075,40.362479],[-80.119046,40.360717],[-80.119049,40.359419],[-80.118988,40.358615],[-80.118904,40.357788],[-80.118822,40.357261],[-80.118691,40.356571],[-80.118551,40.355962],[-80.118518,40.355785],[-80.118398,40.355417],[-80.117723,40.352589],[-80.117556,40.351845],[-80.117471,40.351383],[-80.117438,40.35093],[-80.117492,40.3501],[-80.117562,40.349433],[-80.117782,40.348616],[-80.118017,40.348062],[-80.118249,40.34763],[-80.118538,40.347136],[-80.118968,40.346529],[-80.119305,40.34615],[-80.119678,40.345792],[-80.120161,40.345363],[-80.12065,40.344979],[-80.121176,40.344648],[-80.121934,40.344237],[-80.122755,40.34382],[-80.123641,40.343375],[-80.125083,40.342626],[-80.126799,40.341759],[-80.128033,40.341129],[-80.129734,40.340267],[-80.130932,40.339569],[-80.132089,40.338787],[-80.132936,40.338136],[-80.133703,40.337466],[-80.134363,40.336848],[-80.134873,40.336296],[-80.135281,40.335825],[-80.135652,40.335353],[-80.136113,40.334713],[-80.136927,40.33361],[-80.137657,40.332624],[-80.13821,40.331872],[-80.139905,40.329529],[-80.142302,40.326226],[-80.142642,40.325777],[-80.143047,40.325226],[-80.143323,40.32485],[-80.143778,40.324224],[-80.14499,40.322547],[-80.1458,40.321415],[-80.147275,40.319607],[-80.149197,40.317454],[-80.150332,40.316186],[-80.152554,40.313754],[-80.15331,40.312891],[-80.154099,40.312011],[-80.155102,40.310931],[-80.156985,40.30891],[-80.158616,40.307385],[-80.161057,40.30538],[-80.162194,40.304476],[-80.164619,40.302533],[-80.165783,40.301588],[-80.166496,40.30099],[-80.16696,40.300529],[-80.167285,40.300156],[-80.167649,40.299509],[-80.167843,40.299018],[-80.168115,40.298186],[-80.168218,40.297789],[-80.168422,40.296833],[-80.16867,40.296047],[-80.169096,40.294362],[-80.169288,40.293663],[-80.169565,40.29273],[-80.169865,40.291617],[-80.169967,40.29097],[-80.169998,40.290406],[-80.169983,40.290078],[-80.169945,40.289759],[-80.169892,40.289427],[-80.169784,40.289026],[-80.169559,40.288437],[-80.169296,40.287901],[-80.168848,40.287176],[-80.168191,40.286477],[-80.167408,40.285732],[-80.16575,40.284239],[-80.164775,40.283335],[-80.162524,40.281295],[-80.161505,40.280378],[-80.160559,40.279513],[-80.159748,40.278706],[-80.159442,40.278329],[-80.15923,40.277979],[-80.159045,40.277617],[-80.158809,40.276999],[-80.158712,40.27659],[-80.158659,40.276103],[-80.158664,40.275604],[-80.158727,40.274724],[-80.158863,40.274008],[-80.15896,40.273484],[-80.159116,40.272808],[-80.159465,40.271529],[-80.160048,40.270082],[-80.160472,40.269206],[-80.160907,40.268404],[-80.161449,40.267575],[-80.161745,40.267234],[-80.162503,40.266517],[-80.163009,40.266128],[-80.163535,40.265797],[-80.164173,40.265445],[-80.164742,40.265183],[-80.165434,40.264925],[-80.166013,40.264765],[-80.167226,40.26445],[-80.168068,40.264228],[-80.168866,40.263996],[-80.169573,40.263734],[-80.170267,40.26339],[-80.170882,40.262987],[-80.171469,40.262524],[-80.172595,40.261375],[-80.172858,40.261103],[-80.173427,40.260491],[-80.173985,40.259951],[-80.174339,40.259665],[-80.174661,40.259435],[-80.175004,40.259227],[-80.175353,40.259026],[-80.175921,40.258768],[-80.176613,40.25851],[-80.177246,40.258293],[-80.178024,40.258024],[-80.178937,40.257702],[-80.179522,40.257468],[-80.180229,40.257122],[-80.180535,40.256938],[-80.180835,40.256721],[-80.18113,40.256484],[-80.181506,40.256136],[-80.182101,40.255591],[-80.183002,40.254768],[-80.183314,40.254506],[-80.18371,40.254195],[-80.184134,40.253937],[-80.184563,40.253728],[-80.18503,40.253528],[-80.186747,40.252844],[-80.188051,40.252321],[-80.188861,40.252007],[-80.189217,40.251861],[-80.189955,40.25155],[-80.190593,40.251219],[-80.191215,40.250817],[-80.191704,40.250486],[-80.193039,40.249581],[-80.19438,40.248668],[-80.195378,40.248001],[-80.196204,40.247476],[-80.196794,40.247157],[-80.197578,40.246768],[-80.198582,40.2463],[-80.199364,40.245932],[-80.200716,40.245294],[-80.201086,40.245114],[-80.20117,40.245067],[-80.201515,40.244872],[-80.202287,40.244418],[-80.202599,40.244197],[-80.202955,40.243924],[-80.20335,40.243615],[-80.203757,40.243234],[-80.204192,40.242768],[-80.204567,40.242293],[-80.20522,40.24134],[-80.206176,40.239943],[-80.207865,40.237391],[-80.209513,40.234983],[-80.210055,40.234119],[-80.210533,40.233259],[-80.210871,40.232555],[-80.21108,40.232026],[-80.211321,40.231343],[-80.211598,40.230351],[-80.211797,40.22956],[-80.212123,40.228243],[-80.212805,40.225641],[-80.212968,40.224894],[-80.213096,40.224358],[-80.213323,40.223426],[-80.213449,40.222963],[-80.213591,40.222399],[-80.21377,40.221674],[-80.213939,40.221162],[-80.214122,40.220722],[-80.214302,40.220386],[-80.214522,40.21999],[-80.214715,40.219675],[-80.214976,40.219313],[-80.215386,40.218853],[-80.215551,40.218668],[-80.21597,40.218262],[-80.216488,40.217811],[-80.217188,40.217218],[-80.218534,40.216052],[-80.219891,40.214887],[-80.220841,40.214072],[-80.221689,40.213369],[-80.222651,40.212539],[-80.223102,40.212185],[-80.223663,40.211853],[-80.223948,40.211707],[-80.224268,40.211549],[-80.224628,40.211408],[-80.224942,40.211295],[-80.225262,40.211196],[-80.225611,40.211109],[-80.225916,40.211045],[-80.226138,40.210998],[-80.226511,40.210938],[-80.227047,40.210883],[-80.227517,40.210872],[-80.228134,40.210887],[-80.228496,40.210905],[-80.22882,40.21093],[-80.231376,40.211112],[-80.232908,40.211235],[-80.233701,40.211284],[-80.234423,40.211288],[-80.234941,40.211282],[-80.235746,40.211247],[-80.236016,40.211224],[-80.236679,40.211167],[-80.237342,40.211079],[-80.237913,40.210987],[-80.238632,40.210846],[-80.239147,40.210721],[-80.239775,40.210569],[-80.240558,40.210313],[-80.24122,40.210075],[-80.242042,40.209746],[-80.243081,40.209224],[-80.244012,40.208683],[-80.24482,40.208104],[-80.245706,40.207379],[-80.246071,40.207036],[-80.246428,40.206666],[-80.246949,40.206042],[-80.247272,40.205608],[-80.2477,40.204963],[-80.248047,40.20433],[-80.248392,40.203531],[-80.248594,40.202941],[-80.248741,40.202402],[-80.248861,40.201776],[-80.24893,40.201159],[-80.24895,40.200681],[-80.248945,40.200308],[-80.248901,40.199749],[-80.248794,40.198974],[-80.248631,40.198276],[-80.248368,40.197494],[-80.247609,40.19511],[-80.247212,40.193972],[-80.247048,40.19342],[-80.246986,40.193119],[-80.246954,40.192837],[-80.246951,40.192524],[-80.246989,40.192223],[-80.247085,40.191807],[-80.247256,40.191251],[-80.247356,40.190944],[-80.247457,40.190718],[-80.247747,40.18989],[-80.247882,40.189575],[-80.248037,40.189312],[-80.248151,40.189169],[-80.248283,40.189026],[-80.248434,40.188892],[-80.248643,40.188741],[-80.248839,40.188625],[-80.249038,40.188526],[-80.249333,40.188407],[-80.249789,40.188234],[-80.250756,40.187874],[-80.251295,40.187613],[-80.251733,40.187423],[-80.252057,40.187268],[-80.252441,40.187067],[-80.2528,40.186867],[-80.253201,40.186627],[-80.254205,40.185993],[-80.255251,40.185326],[-80.25556,40.185133],[-80.255857,40.184959],[-80.256098,40.184831],[-80.25634,40.184713],[-80.256591,40.184601],[-80.256954,40.184453],[-80.257245,40.184348],[-80.257498,40.184269],[-80.257749,40.184194],[-80.25812,40.184092],[-80.25868,40.183936],[-80.259123,40.183807],[-80.259461,40.183705],[-80.259834,40.183585],[-80.260139,40.183477],[-80.260601,40.1833],[-80.260943,40.18316],[-80.261286,40.183009],[-80.26161,40.182858],[-80.262158,40.18258],[-80.262477,40.182407],[-80.263028,40.182078],[-80.263618,40.181691],[-80.264099,40.181345],[-80.264313,40.181174],[-80.264566,40.180969],[-80.264771,40.180798],[-80.265114,40.18049],[-80.265329,40.180292],[-80.265457,40.180167],[-80.265865,40.179731],[-80.266247,40.179283],[-80.267144,40.178208],[-80.26839,40.17672],[-80.269594,40.175281],[-80.27094,40.173673],[-80.272225,40.172142],[-80.27302,40.171185],[-80.273944,40.170086],[-80.274609,40.169291],[-80.274875,40.16896],[-80.275057,40.168706],[-80.275232,40.168424],[-80.275373,40.16818],[-80.275505,40.167916],[-80.275655,40.167568],[-80.276282,40.16608],[-80.277131,40.164066],[-80.277314,40.163646],[-80.277475,40.163324],[-80.277618,40.163061],[-80.277767,40.162801],[-80.277939,40.162534],[-80.278048,40.162372],[-80.278264,40.162099],[-80.278489,40.1618],[-80.27883,40.161379],[-80.279126,40.161044],[-80.279321,40.160784],[-80.28044,40.159494],[-80.281033,40.158804],[-80.281612,40.158139],[-80.282094,40.157584],[-80.282496,40.157121],[-80.282858,40.156745],[-80.283256,40.156371],[-80.283667,40.156022],[-80.283961,40.15579],[-80.284285,40.15555],[-80.284642,40.155308],[-80.285081,40.155027],[-80.285877,40.154553],[-80.28668,40.154063],[-80.288182,40.153149],[-80.292406,40.15059],[-80.294267,40.149473],[-80.294489,40.149344],[-80.294689,40.149232],[-80.295036,40.149051],[-80.295392,40.148887],[-80.295756,40.148729],[-80.296032,40.148624],[-80.296361,40.148505],[-80.296768,40.148377],[-80.297202,40.148256],[-80.297675,40.148142],[-80.298082,40.148061],[-80.298692,40.147962],[-80.302341,40.147423],[-80.30379,40.147209],[-80.304103,40.147162],[-80.304478,40.1471],[-80.304839,40.147029],[-80.305127,40.146967],[-80.305448,40.146885],[-80.305764,40.146795],[-80.306042,40.146703],[-80.306348,40.146586],[-80.306615,40.146474],[-80.306875,40.146356],[-80.307189,40.146198],[-80.307547,40.145995],[-80.307801,40.145838],[-80.308069,40.145651],[-80.308334,40.145458],[-80.309251,40.144781],[-80.310972,40.143494],[-80.315316,40.140237],[-80.318213,40.138068],[-80.318814,40.13761],[-80.31929,40.137212],[-80.319614,40.136934],[-80.320053,40.136522],[-80.320366,40.136215],[-80.320775,40.135781],[-80.322312,40.134103],[-80.323032,40.133313],[-80.323631,40.132681],[-80.323897,40.132423],[-80.324135,40.13222],[-80.324444,40.131984],[-80.324669,40.131828],[-80.324978,40.131631],[-80.325194,40.131511],[-80.325419,40.131394],[-80.32578,40.131222],[-80.326119,40.131082],[-80.326483,40.130951],[-80.326851,40.130833],[-80.327277,40.130719],[-80.327616,40.130649],[-80.327921,40.130595],[-80.328345,40.130538],[-80.328666,40.130504],[-80.32905,40.130477],[-80.329545,40.130453],[-80.330059,40.130434],[-80.331076,40.130405],[-80.333272,40.130333],[-80.33504,40.130276],[-80.336009,40.130249],[-80.336476,40.130234],[-80.336962,40.130219],[-80.339201,40.130145],[-80.341782,40.130064],[-80.343918,40.129995],[-80.344297,40.129986],[-80.344742,40.129985],[-80.345187,40.13],[-80.34559,40.130018],[-80.346032,40.130051],[-80.346467,40.130098],[-80.346861,40.130143],[-80.347353,40.13022],[-80.347869,40.130317],[-80.348165,40.130375],[-80.348566,40.130465],[-80.349096,40.1306],[-80.349938,40.130832],[-80.350818,40.131059],[-80.351127,40.131135],[-80.351447,40.131203],[-80.351717,40.131249],[-80.352055,40.131298],[-80.352425,40.131337],[-80.352768,40.131359],[-80.353113,40.131372],[-80.353479,40.131374],[-80.353882,40.131353],[-80.354285,40.131317],[-80.354614,40.131277],[-80.354989,40.131216],[-80.355296,40.131153],[-80.355679,40.131064],[-80.355967,40.130982],[-80.356337,40.130863],[-80.356615,40.130759],[-80.35698,40.130611],[-80.357278,40.130469],[-80.357559,40.130323],[-80.357861,40.130152],[-80.358103,40.130001],[-80.358362,40.129826],[-80.358668,40.129599],[-80.358981,40.129346],[-80.360077,40.128474],[-80.36238,40.126626],[-80.363168,40.125994],[-80.363588,40.125692],[-80.363817,40.12555],[-80.364059,40.125404],[-80.364353,40.125247],[-80.364638,40.125108],[-80.365024,40.124939],[-80.365466,40.124777],[-80.365812,40.124666],[-80.366154,40.124578],[-80.366493,40.124502],[-80.366848,40.124437],[-80.367331,40.124373],[-80.367725,40.124331],[-80.368082,40.124306],[-80.368498,40.1243],[-80.368896,40.124307],[-80.369259,40.124333],[-80.369712,40.12438],[-80.37014,40.124447],[-80.370487,40.124513],[-80.370945,40.124621],[-80.371631,40.124802],[-80.372057,40.124917],[-80.372492,40.125024],[-80.373003,40.125133],[-80.373326,40.125195],[-80.373651,40.125241],[-80.373985,40.125274],[-80.374332,40.125296],[-80.374738,40.125307],[-80.37511,40.125301],[-80.375459,40.125287],[-80.375817,40.12526],[-80.376128,40.125225],[-80.376514,40.125166],[-80.376871,40.125097],[-80.377275,40.125006],[-80.378773,40.124647],[-80.383925,40.12341],[-80.388393,40.122334],[-80.391309,40.12163],[-80.392209,40.121415],[-80.392656,40.121325],[-80.393003,40.121265],[-80.393349,40.121221],[-80.393781,40.121182],[-80.394051,40.121166],[-80.39438,40.121158],[-80.394692,40.121159],[-80.394968,40.121171],[-80.395434,40.121198],[-80.396285,40.121264],[-80.396743,40.121298],[-80.397274,40.121324],[-80.397693,40.121327],[-80.398083,40.12132],[-80.398437,40.121306],[-80.398742,40.121288],[-80.399073,40.121258],[-80.399434,40.121216],[-80.399817,40.121162],[-80.400181,40.121098],[-80.400601,40.121008],[-80.400966,40.120923],[-80.401409,40.120804],[-80.40181,40.120677],[-80.402239,40.120528],[-80.402572,40.120398],[-80.402896,40.120259],[-80.403338,40.120049],[-80.403838,40.119804],[-80.405077,40.119186],[-80.406342,40.118557],[-80.407147,40.118158],[-80.409917,40.116783],[-80.411976,40.115758],[-80.4133,40.115102],[-80.413681,40.114926],[-80.413986,40.1148],[-80.41417,40.114726],[-80.414678,40.114534],[-80.414987,40.114422],[-80.415287,40.114323],[-80.4156,40.114229],[-80.415922,40.114138],[-80.416347,40.114027],[-80.41681,40.113925],[-80.417393,40.113816],[-80.417948,40.113729],[-80.41831,40.113677],[-80.418765,40.113624],[-80.419233,40.113589],[-80.419651,40.113567],[-80.420077,40.113552],[-80.420522,40.113554],[-80.420929,40.113561],[-80.421384,40.11358],[-80.421714,40.113595],[-80.4221,40.11363],[-80.422425,40.113664],[-80.422776,40.113712],[-80.423192,40.11377],[-80.423613,40.113848],[-80.424098,40.113943],[-80.424659,40.114072],[-80.424986,40.114159],[-80.425856,40.114402],[-80.428253,40.11506],[-80.428742,40.115189],[-80.430241,40.115611],[-80.431476,40.115948],[-80.432995,40.116364],[-80.433612,40.116522],[-80.434033,40.116623],[-80.434404,40.116691],[-80.434818,40.11676],[-80.435128,40.116794],[-80.435426,40.116814],[-80.435767,40.11683],[-80.436154,40.116832],[-80.436482,40.116824],[-80.439065,40.116736],[-80.443444,40.116578],[-80.445575,40.1165],[-80.445711,40.116495],[-80.446836,40.116452],[-80.450116,40.116331],[-80.450651,40.116301],[-80.45108,40.116269],[-80.451557,40.116216],[-80.451988,40.116156],[-80.452495,40.116071],[-80.45272,40.116029],[-80.453008,40.115972],[-80.453453,40.115876],[-80.453972,40.115739],[-80.454469,40.115595],[-80.455034,40.115417],[-80.455455,40.115266],[-80.455816,40.115124],[-80.45619,40.114964],[-80.456627,40.114761],[-80.456765,40.114697],[-80.457671,40.114275],[-80.458141,40.114064],[-80.458495,40.11392],[-80.458897,40.113784],[-80.459415,40.113636],[-80.459777,40.113551],[-80.460199,40.113468],[-80.460587,40.113405],[-80.46098,40.113364],[-80.461318,40.113341],[-80.461655,40.113328],[-80.462013,40.113324],[-80.462369,40.113337],[-80.462771,40.113366],[-80.463139,40.113404],[-80.463478,40.113453],[-80.463928,40.113536],[-80.464307,40.113627],[-80.464688,40.113733],[-80.465097,40.113864],[-80.465351,40.113961],[-80.465476,40.114011],[-80.465754,40.114128],[-80.466017,40.114251],[-80.466273,40.114379],[-80.46655,40.114534],[-80.466817,40.114698],[-80.467076,40.114873],[-80.467318,40.115049],[-80.467586,40.115263],[-80.468279,40.115865],[-80.469278,40.116748],[-80.46989,40.117281],[-80.47014,40.117498],[-80.470329,40.117649],[-80.470538,40.117816],[-80.470815,40.118015],[-80.471143,40.118222],[-80.471438,40.118398],[-80.471713,40.118544],[-80.472012,40.118688],[-80.472327,40.118828],[-80.472591,40.118939],[-80.472817,40.119025],[-80.473119,40.119128],[-80.473418,40.119225],[-80.473745,40.119313],[-80.47406,40.119386],[-80.474316,40.119441],[-80.47457,40.119488],[-80.474825,40.119533],[-80.475143,40.119573],[-80.475448,40.119607],[-80.475692,40.119627],[-80.4758,40.119633],[-80.476015,40.119642],[-80.476331,40.11965],[-80.476674,40.119648],[-80.477066,40.119633],[-80.477478,40.119605],[-80.477926,40.119554],[-80.478294,40.1195],[-80.478625,40.119437],[-80.478989,40.119356],[-80.47938,40.119253],[-80.479677,40.119163],[-80.480036,40.119044],[-80.480646,40.118815],[-80.482997,40.117912],[-80.483727,40.117634],[-80.484168,40.117457],[-80.484566,40.1173],[-80.48506,40.117075],[-80.485486,40.116856],[-80.485799,40.11668],[-80.486104,40.116492],[-80.486382,40.1163],[-80.48668,40.116076],[-80.486923,40.115881],[-80.487195,40.115645],[-80.487458,40.11539],[-80.487696,40.115135],[-80.487922,40.114876],[-80.488122,40.114618],[-80.488349,40.114299],[-80.489739,40.112241],[-80.491291,40.109949],[-80.49196,40.108967],[-80.492227,40.10864],[-80.492482,40.10832],[-80.492633,40.108168],[-80.492833,40.10798],[-80.493107,40.107744],[-80.493461,40.107482],[-80.493807,40.107251],[-80.494135,40.107061],[-80.494422,40.106906],[-80.494832,40.106716],[-80.496601,40.105951],[-80.498293,40.105216],[-80.4995,40.104689],[-80.500115,40.104421],[-80.500528,40.104223],[-80.500829,40.104075],[-80.501214,40.10386],[-80.501686,40.103584],[-80.502032,40.103358],[-80.502406,40.103102],[-80.502764,40.102839],[-80.50309,40.102584],[-80.503304,40.102408],[-80.503689,40.10206],[-80.504083,40.101694],[-80.504616,40.101194],[-80.504986,40.100857],[-80.505346,40.100554],[-80.505759,40.10023],[-80.506275,40.09988],[-80.506539,40.099705],[-80.506928,40.099465],[-80.507252,40.09928],[-80.507602,40.099099],[-80.508006,40.098894],[-80.508325,40.098745],[-80.50865,40.098602],[-80.509013,40.098456],[-80.509632,40.098235],[-80.510121,40.098071],[-80.51059,40.097934],[-80.510985,40.097831],[-80.512165,40.097553],[-80.514608,40.096957],[-80.518388,40.096048],[-80.519188,40.095853],[-80.522116,40.095149],[-80.524622,40.094499],[-80.528261,40.093639],[-80.530638,40.093061],[-80.531823,40.09268],[-80.533334,40.092142],[-80.53457,40.091636],[-80.536484,40.090625],[-80.537745,40.089791],[-80.539627,40.08837],[-80.540372,40.087808],[-80.542758,40.086107],[-80.545942,40.083671],[-80.54653,40.083243],[-80.547071,40.082849],[-80.54856,40.081766],[-80.552706,40.078673],[-80.555263,40.076749],[-80.557958,40.074752],[-80.560199,40.073091],[-80.563597,40.070549],[-80.565863,40.068828],[-80.566782,40.068191],[-80.568274,40.067403],[-80.568811,40.067134],[-80.570438,40.066352],[-80.572395,40.065708],[-80.573296,40.065491],[-80.575562,40.065058],[-80.577562,40.064769],[-80.57927,40.064657],[-80.581158,40.064598],[-80.583381,40.064512],[-80.58575,40.064447],[-80.587656,40.064342],[-80.588531,40.064243],[-80.589347,40.064013],[-80.590385,40.063652],[-80.591595,40.062988],[-80.592402,40.062272],[-80.593012,40.061523],[-80.593303,40.061037],[-80.593939,40.059809],[-80.595235,40.057306],[-80.596462,40.054711],[-80.597492,40.052576],[-80.598058,40.05163],[-80.598634,40.0509],[-80.599878,40.049724],[-80.603646,40.046387],[-80.6052,40.044987],[-80.606556,40.04387],[-80.607311,40.043417],[-80.60829,40.042963],[-80.609225,40.0427],[-80.610375,40.042556],[-80.611268,40.042569],[-80.611869,40.042595],[-80.612693,40.042733],[-80.613276,40.042871],[-80.617327,40.044192],[-80.618091,40.044409],[-80.618598,40.044507],[-80.619224,40.044586],[-80.619799,40.044593],[-80.620486,40.044593],[-80.621053,40.044567],[-80.622864,40.044323],[-80.62452,40.044061],[-80.625885,40.04389],[-80.626666,40.04385],[-80.627395,40.043877],[-80.628297,40.043975],[-80.629086,40.044172],[-80.629893,40.044468],[-80.63155,40.045092],[-80.631893,40.045204],[-80.632631,40.04544],[-80.634125,40.045657],[-80.635578,40.045877],[-80.637363,40.04614],[-80.639028,40.04637],[-80.64035,40.046541],[-80.641277,40.046606],[-80.642281,40.046567],[-80.643826,40.046396],[-80.644581,40.046232],[-80.645543,40.045949],[-80.646821,40.045548],[-80.649396,40.044622],[-80.650212,40.044392],[-80.650813,40.044241],[-80.651992,40.044108],[-80.652663,40.044108],[-80.653403,40.044174],[-80.65395,40.044268],[-80.654417,40.044392],[-80.65499,40.044593],[-80.6553,40.044703],[-80.655531,40.044795],[-80.656031,40.045029],[-80.657286,40.045705],[-80.659619,40.046961],[-80.660529,40.0475],[-80.662537,40.048545],[-80.663335,40.048899],[-80.664382,40.049234],[-80.664932,40.049346],[-80.666151,40.04953],[-80.66773,40.049694],[-80.670189,40.049982],[-80.673333,40.050319],[-80.675468,40.050549],[-80.676133,40.050623],[-80.676798,40.050672],[-80.677549,40.050688],[-80.678826,40.050697],[-80.680135,40.050672],[-80.681197,40.050565],[-80.682302,40.050393],[-80.683568,40.050155],[-80.685585,40.049727],[-80.687399,40.049333],[-80.688654,40.049046],[-80.689791,40.048791],[-80.690435,40.048668],[-80.691272,40.048586],[-80.692119,40.04861],[-80.692913,40.048701],[-80.693611,40.048816],[-80.694276,40.049029],[-80.695037,40.0493],[-80.695681,40.049629],[-80.696228,40.04999],[-80.696582,40.050302],[-80.697237,40.050943],[-80.69817,40.052101],[-80.698646,40.052554],[-80.699243,40.05307],[-80.699973,40.053456],[-80.700584,40.053686],[-80.7014,40.053957],[-80.701872,40.054088],[-80.702387,40.05417],[-80.702859,40.05422],[-80.703352,40.054236],[-80.703899,40.054187],[-80.704468,40.054105],[-80.70494,40.054023],[-80.705509,40.053858],[-80.706067,40.053686],[-80.706946,40.053333],[-80.707537,40.053078],[-80.708288,40.052741],[-80.71038,40.051945],[-80.711456,40.051727],[-80.711963,40.051624],[-80.71259,40.051551],[-80.713019,40.051518],[-80.713309,40.051493],[-80.713609,40.051477],[-80.716055,40.051567],[-80.717439,40.051641],[-80.71818,40.051674],[-80.718941,40.051641],[-80.720712,40.051477],[-80.721924,40.051321],[-80.722857,40.051198],[-80.727738,40.050453],[-80.728351,40.05036],[-80.729509,40.050187],[-80.732234,40.049717],[-80.732664,40.049635],[-80.733972,40.049391],[-80.734959,40.049218],[-80.735614,40.04912],[-80.736258,40.049013],[-80.737866,40.048735],[-80.738074,40.048709],[-80.73826,40.048679],[-80.739534,40.048448],[-80.743548,40.047703],[-80.747929,40.046919],[-80.74893,40.046729],[-80.750885,40.046365],[-80.752413,40.046085],[-80.753288,40.045917],[-80.753856,40.045817],[-80.754715,40.045683],[-80.755135,40.045629],[-80.75554,40.045583],[-80.756673,40.045487],[-80.757334,40.045454],[-80.757515,40.045448],[-80.757659,40.045444],[-80.757984,40.045439],[-80.758458,40.045439],[-80.759063,40.045446],[-80.759134,40.045449],[-80.759659,40.045472],[-80.760426,40.045525],[-80.761071,40.045587],[-80.761741,40.045661],[-80.7624,40.045756],[-80.763822,40.045995],[-80.765424,40.04627],[-80.766351,40.046422],[-80.767552,40.046594],[-80.768373,40.046695],[-80.770402,40.046927],[-80.771376,40.047043],[-80.772967,40.047225],[-80.773676,40.047301],[-80.775324,40.04749],[-80.778447,40.047857],[-80.779381,40.047962],[-80.780053,40.048042],[-80.781087,40.048155],[-80.784171,40.048514],[-80.786238,40.048762],[-80.788394,40.049012],[-80.788833,40.049081],[-80.788977,40.0491],[-80.789332,40.049138],[-80.790294,40.049246],[-80.791566,40.04938],[-80.795657,40.04985],[-80.796426,40.049934],[-80.799861,40.050339],[-80.80099,40.050463],[-80.801508,40.050528],[-80.801973,40.050587],[-80.802902,40.05069],[-80.803745,40.050778],[-80.804834,40.050899],[-80.807253,40.051179],[-80.808033,40.051274],[-80.808651,40.051349],[-80.809353,40.051457],[-80.809655,40.051499],[-80.810134,40.051589],[-80.810986,40.051793],[-80.811187,40.051843],[-80.811683,40.051969],[-80.812214,40.052115],[-80.812867,40.052313],[-80.813284,40.052451],[-80.813795,40.052631],[-80.814229,40.052791],[-80.814511,40.052904],[-80.815031,40.053122],[-80.815381,40.053279],[-80.81582,40.053484],[-80.815971,40.053559],[-80.816325,40.053735],[-80.816389,40.053768],[-80.816744,40.053955],[-80.817196,40.054205],[-80.818865,40.055177],[-80.819715,40.055678],[-80.822029,40.057026],[-80.822657,40.057366],[-80.823027,40.057555],[-80.823573,40.057817],[-80.823653,40.057855],[-80.824404,40.058184],[-80.824754,40.058329],[-80.825237,40.058516],[-80.825605,40.058651],[-80.825984,40.058783],[-80.826403,40.058918],[-80.826863,40.059059],[-80.827349,40.059196],[-80.827804,40.059315],[-80.828479,40.059477],[-80.829521,40.059711],[-80.831653,40.060184],[-80.832332,40.060351],[-80.836193,40.061196],[-80.836634,40.0613],[-80.836947,40.061386],[-80.837237,40.061474],[-80.837434,40.061541],[-80.837685,40.061634],[-80.837902,40.061726],[-80.838134,40.06183],[-80.838387,40.061956],[-80.83861,40.062078],[-80.838874,40.062238],[-80.839095,40.062383],[-80.839315,40.062543],[-80.839493,40.062682],[-80.83966,40.062825],[-80.839822,40.062975],[-80.839993,40.063147],[-80.840122,40.063286],[-80.840289,40.063487],[-80.840436,40.063679],[-80.840672,40.06403],[-80.84077,40.064198],[-80.840872,40.064388],[-80.840882,40.06441],[-80.841008,40.064685],[-80.841115,40.064931],[-80.841155,40.065021],[-80.84153,40.065924],[-80.841713,40.066377],[-80.841994,40.067096],[-80.842318,40.067848],[-80.842477,40.068168],[-80.842581,40.068338],[-80.842649,40.068435],[-80.842722,40.068522],[-80.842995,40.068807],[-80.843186,40.068971],[-80.843416,40.069127],[-80.843633,40.069255],[-80.843879,40.069376],[-80.844155,40.069491],[-80.844404,40.069571],[-80.844649,40.069632],[-80.844898,40.069678],[-80.84512,40.069706],[-80.84531,40.069731],[-80.845588,40.069728],[-80.845719,40.069727],[-80.845924,40.069717],[-80.846205,40.069692],[-80.846497,40.069653],[-80.84736,40.069531],[-80.847795,40.06947],[-80.848178,40.069429],[-80.848926,40.069429],[-80.852331,40.069638],[-80.853736,40.069814],[-80.85517,40.06995],[-80.856338,40.070163],[-80.857784,40.070476],[-80.859179,40.07088],[-80.861344,40.071646],[-80.864144,40.072343],[-80.865053,40.07249],[-80.86622,40.072605],[-80.866915,40.072632],[-80.867233,40.072643],[-80.868803,40.072638],[-80.86967,40.072572],[-80.870691,40.072421],[-80.872967,40.072001],[-80.881493,40.07028],[-80.891944,40.068079],[-80.893604,40.06779],[-80.895016,40.067676],[-80.896663,40.067793],[-80.897445,40.067863],[-80.898529,40.068096],[-80.900141,40.068556],[-80.900697,40.068723],[-80.903839,40.069657],[-80.906271,40.070295],[-80.906861,40.070466],[-80.912045,40.071962],[-80.912403,40.072065],[-80.92339,40.075211],[-80.930746,40.077254],[-80.931097,40.07735],[-80.93136,40.077429],[-80.931854,40.077551],[-80.932249,40.077633],[-80.932598,40.0777],[-80.932892,40.077751],[-80.933227,40.077804],[-80.93354,40.077849],[-80.934261,40.07794],[-80.934826,40.077997],[-80.93547,40.078048],[-80.935988,40.078076],[-80.936564,40.078098],[-80.936926,40.078108],[-80.937327,40.078112],[-80.93973,40.078085],[-80.940302,40.078078],[-80.942503,40.078043],[-80.943016,40.07804],[-80.94679,40.077977],[-80.948074,40.077964],[-80.951008,40.077919],[-80.951826,40.077898],[-80.953301,40.077883],[-80.954517,40.077862],[-80.956381,40.077813],[-80.956879,40.07781],[-80.957386,40.077788],[-80.957668,40.077773],[-80.958078,40.077732],[-80.958555,40.077679],[-80.95909,40.077608],[-80.959608,40.077521],[-80.960122,40.077421],[-80.960429,40.077351],[-80.960803,40.077264],[-80.961152,40.077165],[-80.961549,40.077055],[-80.961966,40.076917],[-80.962463,40.076746],[-80.963236,40.076448],[-80.963746,40.076202],[-80.964085,40.07602],[-80.964392,40.07585],[-80.964651,40.075694],[-80.964987,40.075486],[-80.965322,40.07527],[-80.965806,40.074945],[-80.969584,40.072314],[-80.970137,40.071953],[-80.970878,40.071456],[-80.974039,40.069273],[-80.974606,40.068884],[-80.975214,40.068462],[-80.976143,40.067829],[-80.97643,40.067643],[-80.976707,40.067472],[-80.976905,40.067356],[-80.977463,40.067055],[-80.977938,40.06682],[-80.978365,40.066628],[-80.978398,40.066613],[-80.978884,40.066413],[-80.97925,40.066274],[-80.97963,40.066139],[-80.980272,40.06594],[-80.980649,40.065836],[-80.981038,40.065734],[-80.981422,40.065648],[-80.981692,40.065592],[-80.981979,40.065539],[-80.982505,40.065453],[-80.982902,40.0654],[-80.985348,40.06517],[-80.985731,40.065136],[-80.98694,40.065026],[-80.992523,40.064533],[-80.99357,40.06444],[-80.995327,40.064289],[-80.996146,40.064212],[-80.999556,40.063908],[-81.000002,40.063874],[-81.000548,40.063839],[-81.001792,40.063775],[-81.002343,40.063758],[-81.002771,40.063745],[-81.003878,40.06373],[-81.00443,40.06373],[-81.005112,40.063739],[-81.006394,40.063777],[-81.006601,40.063786],[-81.006991,40.063804],[-81.007177,40.063813],[-81.007786,40.063844],[-81.008605,40.06388],[-81.014853,40.064197],[-81.01607,40.064256],[-81.016448,40.064274],[-81.019297,40.064414],[-81.020109,40.064458],[-81.020799,40.064486],[-81.022295,40.064566],[-81.027069,40.064802],[-81.028157,40.064857],[-81.031612,40.06504],[-81.031656,40.065041],[-81.03305,40.065095],[-81.033501,40.065101],[-81.034073,40.065096],[-81.034775,40.065074],[-81.035206,40.065053],[-81.035621,40.065026],[-81.036054,40.064987],[-81.03661,40.064929],[-81.037318,40.064836],[-81.038254,40.064683],[-81.038892,40.064564],[-81.039556,40.064419],[-81.040335,40.064223],[-81.040869,40.064075],[-81.04138,40.063921],[-81.042084,40.063695],[-81.044437,40.062915],[-81.046564,40.06221],[-81.048524,40.061575],[-81.04871,40.061511],[-81.049261,40.061322],[-81.050137,40.061037],[-81.051406,40.060611],[-81.052069,40.060398],[-81.052682,40.060192],[-81.05291,40.06012],[-81.053094,40.06006],[-81.05547,40.059272],[-81.058163,40.058386],[-81.0601,40.057748],[-81.060728,40.057547],[-81.06121,40.057402],[-81.061618,40.057293],[-81.06212,40.057166],[-81.06264,40.057041],[-81.063191,40.056926],[-81.063446,40.056873],[-81.063862,40.056799],[-81.06437,40.056719],[-81.064796,40.056659],[-81.065349,40.056587],[-81.065734,40.056543],[-81.066436,40.056483],[-81.066861,40.056458],[-81.06741,40.056437],[-81.067976,40.056428],[-81.068709,40.05643],[-81.069273,40.056448],[-81.069696,40.056466],[-81.07028,40.056505],[-81.070767,40.05655],[-81.070899,40.056566],[-81.071355,40.05661],[-81.0719,40.056675],[-81.072748,40.056793],[-81.07425,40.05701],[-81.075237,40.057147],[-81.07774,40.057518],[-81.078512,40.057626],[-81.079195,40.057728],[-81.082012,40.058128],[-81.082521,40.058206],[-81.083495,40.058348],[-81.086832,40.058823],[-81.087285,40.058887],[-81.089686,40.059236],[-81.093189,40.059738],[-81.093857,40.059839],[-81.09506,40.060009],[-81.097346,40.060341],[-81.098126,40.060438],[-81.098442,40.060466],[-81.098718,40.060485],[-81.099084,40.060501],[-81.099435,40.060507],[-81.099715,40.060506],[-81.10008,40.060496],[-81.100487,40.060474],[-81.100769,40.060452],[-81.101149,40.060411],[-81.101698,40.06033],[-81.101959,40.060288],[-81.102235,40.060233],[-81.102768,40.060106],[-81.103046,40.060035],[-81.103644,40.059848],[-81.10389,40.059763],[-81.104383,40.059575],[-81.104643,40.05947],[-81.104874,40.059382],[-81.105599,40.059078],[-81.10851,40.057884],[-81.10915,40.05764],[-81.109389,40.057556],[-81.109934,40.057386],[-81.110562,40.057223],[-81.110946,40.05714],[-81.111931,40.056986],[-81.112216,40.056956],[-81.112476,40.056933],[-81.112761,40.056914],[-81.113161,40.056897],[-81.113556,40.056893],[-81.11397,40.056906],[-81.114507,40.056942],[-81.115055,40.056999],[-81.115722,40.057102],[-81.116367,40.057229],[-81.11715,40.057425],[-81.11759,40.057545],[-81.117689,40.057572],[-81.11798,40.057646],[-81.118464,40.05778],[-81.119315,40.058082],[-81.120558,40.05837],[-81.12214,40.058749],[-81.122874,40.058941],[-81.123341,40.059063],[-81.123888,40.059184],[-81.1243,40.059266],[-81.124565,40.059312],[-81.124845,40.059355],[-81.12561,40.059451],[-81.126046,40.059492],[-81.126456,40.059523],[-81.126882,40.059543],[-81.127166,40.059552],[-81.128144,40.059555],[-81.129779,40.059539],[-81.133676,40.059518],[-81.134628,40.059518],[-81.136147,40.059501],[-81.140625,40.059472],[-81.141214,40.059457],[-81.14152,40.059442],[-81.141864,40.059419],[-81.142307,40.059384],[-81.142712,40.05934],[-81.143269,40.059266],[-81.144144,40.059113],[-81.144855,40.058996],[-81.145422,40.058893],[-81.147572,40.058528],[-81.148447,40.058375],[-81.149167,40.058242],[-81.149535,40.058185],[-81.14987,40.05814],[-81.150512,40.058074],[-81.150785,40.058051],[-81.151083,40.058032],[-81.151419,40.058016],[-81.15165,40.05801],[-81.151793,40.058006],[-81.152222,40.058003],[-81.152706,40.058015],[-81.153066,40.058032],[-81.15345,40.058059],[-81.153732,40.058083],[-81.154042,40.058116],[-81.154405,40.058161],[-81.154763,40.058214],[-81.155342,40.058314],[-81.155753,40.058397],[-81.156178,40.058492],[-81.156565,40.05859],[-81.157231,40.058778],[-81.157796,40.058944],[-81.158001,40.059004],[-81.15909,40.059324],[-81.160028,40.0596],[-81.160431,40.059704],[-81.160837,40.059803],[-81.161299,40.059903],[-81.161646,40.059968],[-81.162053,40.060036],[-81.162461,40.060095],[-81.16294,40.06015],[-81.16333,40.06019],[-81.163757,40.060222],[-81.164183,40.060243],[-81.164568,40.060255],[-81.164906,40.060256],[-81.165295,40.060249],[-81.165713,40.060235],[-81.168213,40.060075],[-81.169117,40.060014],[-81.169575,40.059988],[-81.170004,40.059971],[-81.170458,40.059966],[-81.170812,40.059969],[-81.171177,40.05998],[-81.17162,40.060006],[-81.176966,40.060381],[-81.177365,40.060397],[-81.177712,40.060403],[-81.178116,40.060402],[-81.178469,40.060394],[-81.178876,40.060377],[-81.17922,40.060354],[-81.179906,40.060289],[-81.1803,40.060244],[-81.180782,40.060175],[-81.181731,40.060025],[-81.182305,40.059945],[-81.183269,40.059796],[-81.184427,40.059629],[-81.184856,40.059581],[-81.185235,40.059549],[-81.185605,40.059525],[-81.185974,40.059508],[-81.18632,40.059502],[-81.186742,40.0595],[-81.190656,40.059563],[-81.191258,40.059565],[-81.191602,40.059556],[-81.19202,40.059539],[-81.192548,40.059497],[-81.192812,40.059472],[-81.193671,40.059375],[-81.194391,40.059283],[-81.195853,40.059106],[-81.197031,40.058956],[-81.197518,40.058904],[-81.198046,40.058865],[-81.198427,40.058844],[-81.198776,40.058832],[-81.199108,40.058827],[-81.199436,40.05883],[-81.1999,40.058845],[-81.200404,40.058876],[-81.20153,40.058971],[-81.204722,40.059263],[-81.205851,40.059372],[-81.207302,40.059499],[-81.207806,40.059529],[-81.208225,40.059548],[-81.208725,40.059553],[-81.209086,40.05955],[-81.209857,40.059524],[-81.210249,40.059503],[-81.210591,40.05948],[-81.211332,40.059411],[-81.211712,40.059362],[-81.212131,40.059303],[-81.212864,40.05918],[-81.213495,40.05905],[-81.21378,40.058985],[-81.214161,40.058892],[-81.214792,40.05872],[-81.215099,40.058629],[-81.215487,40.058507],[-81.222541,40.056175],[-81.223395,40.055943],[-81.22367,40.055858],[-81.223921,40.055789],[-81.224227,40.055718],[-81.224633,40.055637],[-81.225244,40.055533],[-81.225859,40.055449],[-81.226674,40.055369],[-81.227101,40.055339],[-81.227427,40.055327],[-81.228125,40.055321],[-81.228637,40.055336],[-81.229137,40.055361],[-81.2294,40.055382],[-81.229661,40.055403],[-81.229941,40.055432],[-81.230125,40.055459],[-81.230682,40.055555],[-81.231516,40.05572],[-81.232218,40.055858],[-81.233591,40.056252],[-81.236037,40.056922],[-81.2379,40.057316],[-81.238664,40.057375],[-81.240921,40.057441],[-81.242003,40.057323],[-81.245856,40.056896],[-81.248054,40.056764],[-81.249058,40.056797],[-81.254422,40.057625],[-81.25571,40.057789],[-81.256869,40.057782],[-81.257933,40.05773],[-81.259169,40.057658],[-81.260534,40.057434],[-81.262061,40.05704],[-81.263978,40.056518],[-81.26661,40.055864],[-81.268027,40.055628],[-81.269434,40.055582],[-81.27088,40.055622],[-81.282403,40.055923],[-81.285193,40.056133],[-81.286952,40.056298],[-81.289189,40.056598],[-81.289642,40.056658],[-81.292446,40.057207],[-81.295767,40.057927],[-81.299775,40.058925],[-81.301947,40.059451],[-81.302848,40.059596],[-81.303921,40.059674],[-81.305114,40.059655],[-81.306092,40.059582],[-81.30708,40.059438],[-81.308075,40.059215],[-81.309981,40.058558],[-81.311857,40.057895],[-81.3204,40.054476],[-81.321585,40.05399],[-81.322966,40.053387],[-81.324097,40.052975],[-81.325619,40.052453],[-81.327215,40.051973],[-81.328468,40.051651],[-81.329656,40.051339],[-81.330719,40.051106],[-81.332956,40.050645],[-81.337163,40.050009],[-81.344072,40.049108],[-81.345308,40.048872],[-81.356285,40.046948],[-81.357839,40.046717],[-81.362507,40.045916],[-81.367933,40.044923],[-81.370396,40.044522],[-81.371692,40.044266],[-81.375585,40.043599],[-81.377018,40.043325],[-81.377385,40.043258],[-81.380748,40.042676],[-81.390163,40.040672],[-81.391228,40.040455],[-81.393373,40.040041],[-81.395141,40.039673],[-81.396137,40.039456],[-81.397939,40.039114],[-81.400575,40.038556],[-81.403613,40.037945],[-81.405261,40.0378],[-81.407364,40.037833],[-81.412647,40.038386],[-81.413136,40.038437],[-81.417981,40.038943],[-81.421409,40.038818],[-81.422361,40.038728],[-81.423405,40.038626],[-81.425578,40.038152],[-81.426726,40.03784],[-81.428769,40.037183],[-81.431373,40.036227],[-81.433379,40.035653],[-81.435552,40.035035],[-81.437964,40.034417],[-81.438421,40.034322],[-81.438663,40.034271],[-81.439947,40.034002],[-81.440048,40.033982],[-81.443121,40.033601],[-81.447062,40.033022],[-81.44769,40.03293],[-81.451072,40.03249],[-81.451688,40.032379],[-81.452343,40.032288],[-81.454874,40.031692],[-81.457276,40.031003],[-81.457433,40.030959],[-81.460946,40.029792],[-81.463327,40.028853],[-81.465857,40.027594],[-81.468192,40.026266],[-81.470183,40.024998],[-81.471514,40.024045],[-81.473187,40.022704],[-81.47608,40.020016],[-81.477788,40.018399],[-81.481418,40.014954],[-81.484927,40.011682],[-81.486325,40.010286],[-81.488883,40.007996],[-81.490133,40.007103],[-81.491907,40.005974],[-81.493315,40.005251],[-81.494293,40.004817],[-81.496377,40.004091],[-81.496634,40.004014],[-81.497867,40.003644],[-81.499842,40.003346],[-81.503454,40.003096],[-81.504842,40.003076],[-81.504971,40.003074],[-81.511831,40.003501],[-81.513403,40.003602],[-81.516686,40.003758],[-81.52999,40.004666],[-81.53405,40.004528],[-81.535183,40.004455],[-81.53617,40.004363],[-81.536784,40.004214],[-81.549971,40.001714],[-81.552126,40.001271],[-81.556733,40.000051],[-81.557387,39.999865],[-81.557931,39.999694],[-81.55876,39.999464],[-81.560533,39.998859],[-81.563731,39.99752],[-81.564289,39.997349],[-81.565096,39.997139],[-81.565516,39.997066],[-81.567167,39.99696],[-81.568744,39.997076],[-81.569409,39.997174],[-81.570037,39.997296],[-81.570519,39.997394],[-81.571764,39.997689],[-81.57333,39.998094],[-81.573478,39.998132],[-81.578643,39.999588],[-81.585825,40.001456],[-81.587756,40.001951],[-81.589684,40.002509],[-81.591647,40.003212],[-81.593446,40.003941],[-81.602534,40.007796],[-81.60418,40.008462],[-81.605791,40.008984],[-81.607531,40.009345],[-81.609165,40.009516],[-81.610663,40.009585],[-81.611573,40.009506],[-81.612526,40.009381],[-81.613786,40.009158],[-81.615439,40.008836],[-81.615878,40.008753],[-81.616951,40.008554],[-81.619795,40.007954],[-81.621194,40.007738],[-81.623047,40.00753],[-81.625162,40.007452],[-81.626181,40.007477],[-81.63145,40.007692],[-81.644,40.008173],[-81.645838,40.008244],[-81.647829,40.008126],[-81.650078,40.007777],[-81.65638,40.006457],[-81.658017,40.00601],[-81.65941,40.005415],[-81.660558,40.004854],[-81.662203,40.003682],[-81.66338,40.002627],[-81.664653,40.001004],[-81.667214,39.997374],[-81.66897,39.994885],[-81.670939,39.992917],[-81.672414,39.991733],[-81.674437,39.990383],[-81.680924,39.986609],[-81.682267,39.985933],[-81.684374,39.985155],[-81.686232,39.984782],[-81.687627,39.984609],[-81.689567,39.984577],[-81.70221,39.985521],[-81.702668,39.985561],[-81.706026,39.985813],[-81.708627,39.985739],[-81.710553,39.98552],[-81.712816,39.985085],[-81.718092,39.983823],[-81.725221,39.982119],[-81.72748,39.981595],[-81.728575,39.981321],[-81.730425,39.980965],[-81.731049,39.980938],[-81.73182,39.980907],[-81.732523,39.980857],[-81.733994,39.980882],[-81.738992,39.981305],[-81.740571,39.981288],[-81.742172,39.981122],[-81.743394,39.980907],[-81.749333,39.979406],[-81.751432,39.978917],[-81.752849,39.978652],[-81.754352,39.978503],[-81.756018,39.978428],[-81.757251,39.978437],[-81.764759,39.978818],[-81.766641,39.978901],[-81.767906,39.978892],[-81.768934,39.978859],[-81.77815,39.978262],[-81.779503,39.978146],[-81.781179,39.977914],[-81.782802,39.977566],[-81.783949,39.977268],[-81.785236,39.976853],[-81.798054,39.972601],[-81.799644,39.972112],[-81.801667,39.971739],[-81.802857,39.971623],[-81.813047,39.971399],[-81.816054,39.971399],[-81.81865,39.971531],[-81.82037,39.971681],[-81.8246,39.972112],[-81.826206,39.972284],[-81.827247,39.972502],[-81.828443,39.972859],[-81.831954,39.974324],[-81.832437,39.974513],[-81.835158,39.975687],[-81.836694,39.976189],[-81.837638,39.976395],[-81.839446,39.976674],[-81.841259,39.976723],[-81.842949,39.976629],[-81.844467,39.976395],[-81.845845,39.976111],[-81.851819,39.974832],[-81.852273,39.974726],[-81.85554,39.973964],[-81.858658,39.973199],[-81.862083,39.97236],[-81.867871,39.970878],[-81.869459,39.970516],[-81.870893,39.970339],[-81.874854,39.970192],[-81.883605,39.969718],[-81.884093,39.969691],[-81.88638,39.969567],[-81.888485,39.969294],[-81.894492,39.968424],[-81.898245,39.967882],[-81.901059,39.967483],[-81.903483,39.966941],[-81.904793,39.966502],[-81.915345,39.962894],[-81.916153,39.962619],[-81.919662,39.961521],[-81.922637,39.960744],[-81.925143,39.960164],[-81.930751,39.959009],[-81.931558,39.95884],[-81.934518,39.958242],[-81.93598,39.957878],[-81.938843,39.957132],[-81.942534,39.956156],[-81.943927,39.955709],[-81.945567,39.955062],[-81.947195,39.954249],[-81.950204,39.952583],[-81.951722,39.951744],[-81.953169,39.951069],[-81.954125,39.950749],[-81.954805,39.950521],[-81.956571,39.950104],[-81.957944,39.949943],[-81.959582,39.94988],[-81.964201,39.949838],[-81.9662,39.949731],[-81.967653,39.949609],[-81.969349,39.949445],[-81.978904,39.948157],[-81.980178,39.947899],[-81.98102,39.947667],[-81.98192,39.947371],[-81.982867,39.946994],[-81.983506,39.946667],[-81.985843,39.945458],[-81.98762,39.944623],[-81.988553,39.94428],[-81.989092,39.944118],[-81.989854,39.943915],[-81.990605,39.943796],[-81.991225,39.943741],[-81.991815,39.943681],[-81.992555,39.943664],[-81.993676,39.943716],[-81.99434,39.943792],[-81.99512,39.943952],[-81.998261,39.944518],[-81.999709,39.944646],[-82.000812,39.944653],[-82.001353,39.944659],[-82.003382,39.944696],[-82.003773,39.944703],[-82.004615,39.944733],[-82.004995,39.944767],[-82.005956,39.944915],[-82.006287,39.944965],[-82.006992,39.945133],[-82.007656,39.94536],[-82.007782,39.945393],[-82.008409,39.945648],[-82.010058,39.946364],[-82.010931,39.946744],[-82.011693,39.947005],[-82.012444,39.947204],[-82.013118,39.94736],[-82.013813,39.947459],[-82.014658,39.947545],[-82.01779,39.947894],[-82.02079,39.948545],[-82.022094,39.948886],[-82.023617,39.949128],[-82.025936,39.949401],[-82.026968,39.949474],[-82.028439,39.949494],[-82.029941,39.949413],[-82.041877,39.948263],[-82.043626,39.948107],[-82.04468,39.948064],[-82.046597,39.948171],[-82.047841,39.948336],[-82.049068,39.948608],[-82.051939,39.949521],[-82.05384,39.949934],[-82.055057,39.95002],[-82.057366,39.94998],[-82.05862,39.949853],[-82.060603,39.949434],[-82.068242,39.947091],[-82.06991,39.946619],[-82.071603,39.946331],[-82.083308,39.94485],[-82.085551,39.944641],[-82.087653,39.944635],[-82.096248,39.944935],[-82.096666,39.944952],[-82.144037,39.94709],[-82.147198,39.947223],[-82.150066,39.947505],[-82.154974,39.94817],[-82.170011,39.950453],[-82.170477,39.950527],[-82.177913,39.951678],[-82.179709,39.951949],[-82.181517,39.952233],[-82.185072,39.952784],[-82.18674,39.953047],[-82.188439,39.953307],[-82.189793,39.953464],[-82.190771,39.953503],[-82.191853,39.953501],[-82.192854,39.953429],[-82.193892,39.953311],[-82.198659,39.952425],[-82.208298,39.950634],[-82.211527,39.949977],[-82.214428,39.949471],[-82.216333,39.949076],[-82.217689,39.948668],[-82.21896,39.948148],[-82.221543,39.947043],[-82.225706,39.945299],[-82.229302,39.943785],[-82.232048,39.942652],[-82.242519,39.938223],[-82.243136,39.937962],[-82.245804,39.937053],[-82.246111,39.936951],[-82.246608,39.936812],[-82.247062,39.936702],[-82.247457,39.936605],[-82.248124,39.93647],[-82.249286,39.936279],[-82.25006,39.936182],[-82.250242,39.93616],[-82.25074,39.93613],[-82.250998,39.936108],[-82.251339,39.936084],[-82.251826,39.936069],[-82.252267,39.936058],[-82.253756,39.936079],[-82.254637,39.936103],[-82.254954,39.936122],[-82.255333,39.936143],[-82.257378,39.936243],[-82.26082,39.936325],[-82.273726,39.936911],[-82.279408,39.937165],[-82.282167,39.937289],[-82.288092,39.937605],[-82.288702,39.937638],[-82.304067,39.938273],[-82.311283,39.938619],[-82.318262,39.939054],[-82.318863,39.939087],[-82.321481,39.939233],[-82.326373,39.939456],[-82.328677,39.939566],[-82.329836,39.939631],[-82.330998,39.93969],[-82.335557,39.939963],[-82.358067,39.941053],[-82.379328,39.942195],[-82.394557,39.943037],[-82.395097,39.943076],[-82.403539,39.943608],[-82.408077,39.943913],[-82.408816,39.943969],[-82.409009,39.943984],[-82.40947,39.944026],[-82.410252,39.944079],[-82.411655,39.944183],[-82.412916,39.944291],[-82.414149,39.944383],[-82.414463,39.944409],[-82.41551,39.94448],[-82.416793,39.944562],[-82.41812,39.944641],[-82.419428,39.944728],[-82.420667,39.944813],[-82.42185,39.944899],[-82.424579,39.945078],[-82.425941,39.945162],[-82.42734,39.945262],[-82.428712,39.945352],[-82.429957,39.945425],[-82.431192,39.945506],[-82.432134,39.945564],[-82.433405,39.945635],[-82.43414,39.945671],[-82.435217,39.945728],[-82.436003,39.945762],[-82.437247,39.945814],[-82.438407,39.945877],[-82.439112,39.945924],[-82.442408,39.946146],[-82.444131,39.94626],[-82.447183,39.94644],[-82.449481,39.946515],[-82.450819,39.946597],[-82.452426,39.946681],[-82.453618,39.946766],[-82.455725,39.946868],[-82.456602,39.946911],[-82.457209,39.94692],[-82.457609,39.946934],[-82.458611,39.946931],[-82.459578,39.946931],[-82.460258,39.946909],[-82.461647,39.946833],[-82.463947,39.946641],[-82.466433,39.946433],[-82.470543,39.946108],[-82.473974,39.945828],[-82.47519,39.945728],[-82.476933,39.945608],[-82.478036,39.94551],[-82.478383,39.945481],[-82.47985,39.945358],[-82.480821,39.945287],[-82.483754,39.945048],[-82.487226,39.944761],[-82.490216,39.944518],[-82.49125,39.944436],[-82.491615,39.944404],[-82.493231,39.944327],[-82.495081,39.944174],[-82.49878,39.943876],[-82.502385,39.943581],[-82.503934,39.943456],[-82.506179,39.943278],[-82.510398,39.942935],[-82.515449,39.942501],[-82.516318,39.942423],[-82.517946,39.942287],[-82.518844,39.942223],[-82.519183,39.9422],[-82.51948,39.942181],[-82.520747,39.942109],[-82.521618,39.942073],[-82.522403,39.942046],[-82.52308,39.942042],[-82.52407,39.942051],[-82.524568,39.942057],[-82.52519,39.942075],[-82.526371,39.942121],[-82.527749,39.94218],[-82.529028,39.942232],[-82.531541,39.942336],[-82.534265,39.942474],[-82.53545,39.942524],[-82.536738,39.942551],[-82.53919,39.94263],[-82.540964,39.942727],[-82.543046,39.942841],[-82.544469,39.942903],[-82.545441,39.942946],[-82.54884,39.943013],[-82.549529,39.943043],[-82.550677,39.943151],[-82.552825,39.943239],[-82.554847,39.943323],[-82.557117,39.943411],[-82.563018,39.943631],[-82.566065,39.943764],[-82.569165,39.943892],[-82.572638,39.944019],[-82.573293,39.944046],[-82.576428,39.944172],[-82.579315,39.944286],[-82.581032,39.944355],[-82.582049,39.944392],[-82.583411,39.944454],[-82.588006,39.944588],[-82.591837,39.944798],[-82.593466,39.944885],[-82.594945,39.944958],[-82.595813,39.945],[-82.596701,39.945014],[-82.597362,39.945049],[-82.598542,39.945143],[-82.598858,39.945172],[-82.600078,39.945329],[-82.600856,39.945425],[-82.603984,39.945835],[-82.604283,39.945878],[-82.605131,39.945943],[-82.60591,39.945965],[-82.606479,39.945964],[-82.607206,39.945954],[-82.607744,39.94593],[-82.60838,39.945897],[-82.608871,39.945867],[-82.609164,39.945857],[-82.609536,39.945835],[-82.610845,39.945773],[-82.61197,39.945748],[-82.613027,39.945751],[-82.613868,39.94577],[-82.614349,39.94579],[-82.615577,39.945834],[-82.616826,39.945875],[-82.617685,39.945912],[-82.618447,39.945939],[-82.619385,39.945995],[-82.620376,39.946036],[-82.621191,39.946073],[-82.622327,39.946128],[-82.623434,39.94618],[-82.624608,39.946238],[-82.626901,39.946332],[-82.627542,39.946368],[-82.627774,39.946376],[-82.629735,39.946478],[-82.631744,39.946545],[-82.632749,39.94658],[-82.633744,39.946626],[-82.634618,39.946674],[-82.634954,39.946691],[-82.637323,39.946791],[-82.638458,39.946846],[-82.639654,39.946898],[-82.640538,39.946924],[-82.641537,39.946973],[-82.642557,39.947011],[-82.643627,39.947067],[-82.64473,39.947128],[-82.645922,39.947189],[-82.646354,39.947209],[-82.649441,39.94734],[-82.651438,39.947425],[-82.652753,39.947484],[-82.654067,39.947549],[-82.655363,39.947601],[-82.656275,39.947646],[-82.658037,39.947727],[-82.659432,39.9478],[-82.660905,39.947862],[-82.662403,39.947942],[-82.664473,39.948042],[-82.666085,39.948123],[-82.667218,39.948176],[-82.667926,39.948212],[-82.669288,39.948289],[-82.670748,39.948359],[-82.678705,39.948742],[-82.681608,39.948861],[-82.68368,39.94897],[-82.684021,39.948981],[-82.685517,39.949055],[-82.686816,39.949156],[-82.687596,39.949191],[-82.691321,39.949344],[-82.692904,39.949413],[-82.694712,39.949498],[-82.696039,39.949562],[-82.697032,39.949619],[-82.697929,39.949665],[-82.699124,39.949733],[-82.70043,39.949805],[-82.701748,39.949874],[-82.705732,39.950091],[-82.706592,39.950138],[-82.707709,39.950202],[-82.708556,39.950247],[-82.709741,39.9503],[-82.710926,39.950356],[-82.712148,39.95043],[-82.713305,39.950483],[-82.714554,39.950544],[-82.716054,39.950632],[-82.717048,39.950701],[-82.717731,39.950733],[-82.718966,39.950795],[-82.72183,39.950944],[-82.723364,39.951027],[-82.726398,39.951186],[-82.72775,39.951252],[-82.728926,39.951315],[-82.731077,39.951439],[-82.733131,39.951545],[-82.735478,39.951662],[-82.73591,39.951685],[-82.738484,39.951824],[-82.739398,39.951866],[-82.740183,39.951889],[-82.740515,39.951892],[-82.740992,39.951895],[-82.741541,39.951883],[-82.742218,39.951848],[-82.742592,39.95183],[-82.743025,39.951801],[-82.74337,39.951767],[-82.74375,39.951727],[-82.744041,39.951688],[-82.744429,39.951638],[-82.744777,39.95159],[-82.745076,39.951544],[-82.745311,39.951504],[-82.745587,39.951453],[-82.745803,39.95141],[-82.746215,39.951323],[-82.746468,39.951266],[-82.74691,39.951163],[-82.747162,39.9511],[-82.747765,39.950938],[-82.748146,39.950829],[-82.748495,39.95072],[-82.748888,39.950585],[-82.749587,39.950335],[-82.750045,39.950162],[-82.750331,39.950051],[-82.750604,39.949939],[-82.750886,39.94982],[-82.751034,39.949748],[-82.751508,39.949508],[-82.751796,39.94937],[-82.75242,39.949048],[-82.752674,39.948903],[-82.753195,39.948608],[-82.75344,39.948466],[-82.753703,39.948318],[-82.753935,39.948185],[-82.754103,39.948081],[-82.754319,39.94794],[-82.754675,39.947698],[-82.755059,39.947444],[-82.755424,39.947213],[-82.755778,39.947006],[-82.756186,39.946757],[-82.756621,39.946476],[-82.75698,39.946238],[-82.757147,39.946122],[-82.757326,39.946],[-82.757825,39.945657],[-82.758149,39.945433],[-82.758515,39.945185],[-82.758672,39.945084],[-82.758841,39.944977],[-82.759153,39.944782],[-82.759454,39.944588],[-82.759891,39.944304],[-82.760347,39.944011],[-82.761208,39.943469],[-82.763894,39.94173],[-82.76411,39.941585],[-82.765411,39.940775],[-82.766411,39.940177],[-82.766856,39.939948],[-82.767313,39.939736],[-82.768002,39.939411],[-82.768529,39.939213],[-82.770028,39.938663],[-82.771565,39.938202],[-82.773013,39.937821],[-82.778994,39.936334],[-82.780572,39.935941],[-82.781416,39.935733],[-82.782684,39.935421],[-82.783761,39.935155],[-82.78501,39.934848],[-82.786773,39.934424],[-82.789052,39.93386],[-82.789652,39.933712],[-82.789802,39.933675],[-82.790792,39.93342],[-82.792568,39.932963],[-82.793428,39.932751],[-82.794121,39.932602],[-82.794724,39.93245],[-82.795545,39.932259],[-82.795913,39.932171],[-82.797242,39.931834],[-82.797803,39.931704],[-82.798368,39.931594],[-82.798844,39.931518],[-82.799103,39.931482],[-82.799863,39.931393],[-82.800212,39.931365],[-82.800678,39.931339],[-82.801262,39.931317],[-82.801848,39.931324],[-82.802393,39.931339],[-82.804535,39.93146],[-82.811518,39.931866],[-82.817338,39.932185],[-82.818142,39.932231],[-82.820932,39.932387],[-82.823633,39.93254],[-82.823718,39.932544],[-82.825127,39.932622],[-82.826852,39.932718],[-82.828202,39.932793],[-82.829827,39.932883],[-82.83205,39.933003],[-82.83514,39.933201],[-82.836779,39.933306],[-82.841903,39.933589],[-82.844873,39.93372],[-82.846873,39.933839],[-82.850881,39.93405],[-82.854898,39.93426],[-82.857481,39.934398],[-82.858803,39.934477],[-82.859781,39.934602],[-82.860666,39.934767],[-82.861532,39.934964],[-82.862554,39.935241],[-82.863876,39.935603],[-82.864811,39.935853],[-82.865877,39.93612],[-82.866366,39.936236],[-82.867695,39.936553],[-82.869338,39.936875],[-82.870015,39.936984],[-82.87096,39.937094],[-82.872187,39.937185],[-82.872384,39.937193],[-82.872969,39.93722],[-82.873723,39.937231],[-82.874795,39.937204],[-82.876251,39.937101],[-82.878141,39.936922],[-82.883358,39.936422],[-82.883839,39.93638],[-82.885088,39.936262],[-82.885365,39.936235],[-82.885618,39.936211],[-82.887115,39.936072],[-82.88724,39.93606],[-82.888038,39.935978],[-82.889378,39.93584],[-82.892268,39.93542],[-82.894642,39.934954],[-82.895216,39.934817],[-82.897403,39.934293],[-82.897916,39.934159],[-82.898395,39.934036],[-82.898734,39.933948],[-82.899256,39.933814],[-82.89931,39.933801],[-82.901171,39.933324],[-82.902279,39.933035],[-82.904008,39.932595],[-82.905486,39.932279],[-82.906526,39.932091],[-82.907624,39.931917],[-82.90904,39.931785],[-82.910076,39.931743],[-82.910509,39.931739],[-82.910959,39.931746],[-82.911194,39.93175],[-82.911325,39.931752],[-82.911999,39.931763],[-82.91367,39.93178],[-82.914599,39.931794],[-82.915805,39.93181],[-82.916894,39.931822],[-82.918992,39.931845],[-82.921066,39.931876],[-82.922594,39.931901],[-82.923657,39.931937],[-82.92534,39.931977],[-82.926997,39.932023],[-82.92831,39.93201],[-82.928997,39.932043],[-82.929855,39.932142],[-82.930506,39.932279],[-82.931267,39.932522],[-82.931776,39.932713],[-82.932308,39.932937],[-82.932944,39.933312],[-82.933699,39.933957],[-82.934258,39.934533],[-82.934478,39.934814],[-82.935217,39.935774],[-82.936859,39.937904],[-82.940719,39.942883],[-82.94168,39.944136],[-82.941733,39.944204],[-82.942691,39.945478],[-82.9429,39.945763],[-82.943089,39.946073],[-82.943226,39.946369],[-82.943381,39.946823],[-82.943484,39.947257],[-82.943518,39.947678],[-82.943544,39.948205],[-82.943535,39.948573],[-82.943535,39.949053],[-82.943578,39.94958],[-82.94369,39.950119],[-82.943921,39.950679],[-82.944325,39.951238],[-82.944659,39.951593],[-82.945089,39.951975],[-82.945518,39.952284],[-82.946067,39.952587],[-82.946591,39.952784],[-82.947174,39.952955],[-82.947698,39.953047],[-82.948136,39.953093],[-82.948378,39.953119],[-82.949205,39.953168],[-82.949545,39.95319],[-82.951305,39.953264],[-82.952595,39.953332],[-82.953054,39.953343],[-82.953527,39.95337],[-82.954179,39.953392],[-82.954792,39.953411],[-82.95508,39.953422],[-82.956273,39.953472],[-82.956614,39.953486],[-82.957991,39.953542],[-82.95937,39.953583],[-82.963053,39.953657],[-82.963711,39.953675],[-82.964331,39.953694],[-82.964873,39.953702],[-82.965957,39.95372],[-82.966823,39.953738],[-82.966906,39.95374],[-82.967697,39.953758],[-82.968797,39.953803],[-82.96997,39.953872],[-82.970507,39.953917],[-82.972361,39.954089],[-82.972557,39.954108],[-82.973654,39.954211],[-82.974833,39.954322],[-82.975203,39.954357],[-82.976014,39.954413],[-82.976834,39.954528],[-82.977569,39.954655],[-82.978276,39.954864],[-82.978665,39.954974],[-82.979077,39.955103],[-82.979316,39.955174],[-82.980154,39.955369],[-82.980729,39.955473],[-82.980905,39.955491],[-82.981527,39.955556],[-82.982067,39.955572],[-82.982447,39.955571],[-82.98285,39.955554],[-82.983202,39.955532],[-82.983772,39.955461],[-82.984214,39.955389],[-82.984494,39.955329],[-82.984897,39.955237],[-82.98557,39.955051],[-82.986441,39.9548],[-82.987242,39.954571],[-82.987878,39.954436],[-82.988228,39.954371],[-82.989531,39.954168],[-82.990467,39.954069],[-82.990612,39.954052],[-82.991273,39.954059],[-82.991887,39.954049],[-82.992876,39.954],[-82.994021,39.953996],[-82.994252,39.953996],[-82.994338,39.954005],[-82.994377,39.954039],[-82.99449,39.954058],[-82.994613,39.954152],[-82.994705,39.954638],[-82.994828,39.955305],[-82.994953,39.955982],[-82.995077,39.95666],[-82.995204,39.957319],[-82.995332,39.957984],[-82.995589,39.959315],[-82.995718,39.959987],[-82.995849,39.960667],[-82.99599,39.961398],[-82.996107,39.962007],[-82.996247,39.962731],[-82.997115,39.96263],[-82.997983,39.962524],[-82.998118,39.96251],[-82.99856,39.962464],[-82.998587,39.962462],[-82.999005,39.962415],[-82.999447,39.962365],[-82.999747,39.962332],[-83.000508,39.962247],[-83.000642,39.962232],[-83.000656,39.962305]]},{_id:'6',truck:'2',from:{name:'Columbus',lat:39.962305,lng:-83.000656},to:{name:'Baltimore',lat:39.290887,lng:-76.611076},vectorPath:[[-83.000656,39.962305],[-83.000642,39.962232],[-83.000508,39.962247],[-82.999747,39.962332],[-82.999447,39.962365],[-82.999005,39.962415],[-82.998587,39.962462],[-82.99856,39.962464],[-82.998118,39.96251],[-82.997983,39.962524],[-82.997115,39.96263],[-82.996247,39.962731],[-82.995384,39.962829],[-82.99439,39.962942],[-82.992698,39.963135],[-82.991575,39.963262],[-82.99106,39.963321],[-82.990534,39.963381],[-82.989954,39.963447],[-82.988912,39.963567],[-82.988451,39.96362],[-82.987074,39.963778],[-82.98592,39.96391],[-82.98531,39.96398],[-82.98525,39.963987],[-82.9844,39.964084],[-82.983661,39.964169],[-82.983556,39.964181],[-82.983491,39.964026],[-82.983285,39.963527],[-82.98307,39.963003],[-82.982907,39.962465],[-82.982819,39.962077],[-82.982713,39.96145],[-82.982716,39.96126],[-82.982744,39.960898],[-82.982777,39.96055],[-82.982849,39.960018],[-82.982909,39.959379],[-82.982992,39.958651],[-82.982978,39.957761],[-82.982961,39.957537],[-82.982902,39.95732],[-82.982729,39.956866],[-82.982412,39.95639],[-82.982008,39.955985],[-82.98156,39.955631],[-82.981271,39.955454],[-82.980863,39.955222],[-82.980593,39.955095],[-82.980199,39.954938],[-82.980006,39.954869],[-82.979447,39.954706],[-82.978562,39.954541],[-82.977888,39.95447],[-82.977026,39.954352],[-82.975648,39.954239],[-82.972824,39.953958],[-82.970532,39.953747],[-82.970069,39.953709],[-82.968773,39.953624],[-82.967706,39.953582],[-82.966939,39.953564],[-82.96671,39.953559],[-82.965961,39.953541],[-82.964352,39.953511],[-82.96371,39.953498],[-82.963069,39.953484],[-82.959972,39.953418],[-82.95802,39.95337],[-82.956307,39.953298],[-82.955088,39.953247],[-82.954791,39.953232],[-82.953753,39.953183],[-82.953526,39.953174],[-82.95308,39.953155],[-82.953008,39.953152],[-82.952562,39.953135],[-82.951745,39.953107],[-82.94967,39.953019],[-82.948533,39.952965],[-82.948136,39.952935],[-82.947715,39.952889],[-82.947183,39.952777],[-82.946608,39.952606],[-82.946153,39.952429],[-82.945629,39.952166],[-82.945226,39.951856],[-82.944805,39.951501],[-82.944479,39.951106],[-82.944127,39.950554],[-82.94393,39.95008],[-82.943793,39.949567],[-82.943741,39.949053],[-82.943741,39.94858],[-82.94375,39.948205],[-82.943741,39.947678],[-82.94369,39.947218],[-82.943587,39.94679],[-82.943415,39.946323],[-82.943243,39.946027],[-82.943051,39.945711],[-82.942742,39.945256],[-82.942223,39.944564],[-82.941447,39.943509],[-82.938938,39.940295],[-82.937078,39.937911],[-82.93612,39.93663],[-82.93449,39.934471],[-82.933915,39.933853],[-82.933099,39.933155],[-82.932258,39.932681],[-82.931768,39.93247],[-82.931253,39.932259],[-82.930575,39.932049],[-82.929931,39.93193],[-82.929021,39.931819],[-82.928121,39.931773],[-82.926851,39.931773],[-82.923656,39.931679],[-82.921076,39.931637],[-82.91899,39.931607],[-82.917685,39.931587],[-82.914775,39.931549],[-82.91208,39.931507],[-82.910702,39.931492],[-82.910075,39.931491],[-82.909074,39.931549],[-82.907581,39.9317],[-82.906465,39.931878],[-82.905463,39.932068],[-82.903924,39.932395],[-82.902076,39.932838],[-82.901171,39.933074],[-82.89922,39.933575],[-82.899157,39.93359],[-82.898733,39.933695],[-82.89794,39.9339],[-82.89757,39.933995],[-82.89344,39.934958],[-82.892266,39.935178],[-82.88787,39.935758],[-82.886807,39.935856],[-82.885967,39.935939],[-82.885314,39.936005],[-82.884747,39.936062],[-82.884177,39.936113],[-82.883357,39.936187],[-82.880349,39.93647],[-82.87942,39.93656],[-82.878439,39.936654],[-82.876793,39.936808],[-82.875928,39.93689],[-82.874726,39.936969],[-82.874445,39.936977],[-82.873426,39.936987],[-82.872167,39.936939],[-82.87134,39.936886],[-82.870102,39.936744],[-82.870009,39.936732],[-82.869365,39.936637],[-82.867392,39.936229],[-82.86643,39.93602],[-82.86599,39.935924],[-82.864931,39.935655],[-82.864004,39.935405],[-82.862657,39.935017],[-82.861696,39.934754],[-82.860777,39.93453],[-82.85985,39.934359],[-82.858855,39.934254],[-82.857498,39.934168],[-82.854966,39.934036],[-82.852657,39.933908],[-82.850941,39.933813],[-82.846924,39.933576],[-82.845268,39.933477],[-82.841929,39.933279],[-82.836873,39.933016],[-82.835001,39.932906],[-82.832084,39.932733],[-82.830975,39.932676],[-82.829848,39.932618],[-82.825511,39.932377],[-82.824323,39.932311],[-82.823653,39.932273],[-82.82128,39.932137],[-82.818168,39.931962],[-82.8174,39.931919],[-82.812014,39.931617],[-82.81154,39.931598],[-82.806631,39.931318],[-82.806047,39.931291],[-82.805464,39.93125],[-82.804998,39.931228],[-82.802782,39.931104],[-82.802081,39.931073],[-82.801604,39.931064],[-82.801029,39.931071],[-82.800562,39.931087],[-82.800096,39.931117],[-82.799516,39.931172],[-82.798814,39.931264],[-82.798367,39.931336],[-82.797768,39.931451],[-82.797353,39.931544],[-82.796326,39.931794],[-82.795822,39.93192],[-82.795426,39.932015],[-82.794607,39.932213],[-82.793128,39.932576],[-82.792588,39.932708],[-82.792066,39.932836],[-82.790898,39.933122],[-82.790562,39.933197],[-82.789897,39.933368],[-82.789584,39.933445],[-82.788953,39.933599],[-82.788602,39.933684],[-82.786669,39.934156],[-82.786116,39.9343],[-82.785034,39.934555],[-82.78355,39.934912],[-82.78271,39.935118],[-82.781553,39.935401],[-82.780001,39.935781],[-82.779117,39.935997],[-82.777624,39.93636],[-82.775757,39.936819],[-82.773011,39.937496],[-82.771416,39.937888],[-82.77078,39.93806],[-82.770151,39.938247],[-82.769912,39.938325],[-82.769634,39.938415],[-82.769122,39.938594],[-82.768606,39.938788],[-82.768209,39.938948],[-82.767671,39.939206],[-82.767164,39.939443],[-82.76597,39.940074],[-82.765567,39.9403],[-82.765209,39.940517],[-82.764974,39.940655],[-82.764766,39.940785],[-82.763824,39.941332],[-82.763634,39.941463],[-82.763398,39.941616],[-82.763238,39.941727],[-82.763027,39.941858],[-82.762727,39.942048],[-82.762497,39.9422],[-82.762085,39.942469],[-82.761929,39.942574],[-82.761437,39.942901],[-82.760945,39.943199],[-82.760574,39.943443],[-82.75995,39.943856],[-82.759107,39.944437],[-82.758544,39.944781],[-82.757947,39.945143],[-82.75745,39.945483],[-82.757281,39.945609],[-82.756782,39.945945],[-82.756486,39.946116],[-82.756212,39.94629],[-82.755931,39.946467],[-82.755224,39.946896],[-82.755036,39.947018],[-82.754717,39.947223],[-82.754386,39.947442],[-82.754121,39.947604],[-82.753729,39.947861],[-82.753481,39.948016],[-82.753104,39.948244],[-82.75251,39.948606],[-82.752321,39.948722],[-82.752209,39.948792],[-82.752125,39.948841],[-82.751993,39.948907],[-82.751623,39.949087],[-82.751191,39.949306],[-82.750826,39.94947],[-82.750601,39.949563],[-82.750293,39.949692],[-82.749963,39.949823],[-82.74962,39.949958],[-82.749284,39.950083],[-82.748804,39.950253],[-82.748485,39.950369],[-82.748287,39.950429],[-82.747863,39.950564],[-82.747542,39.950664],[-82.747263,39.95074],[-82.746803,39.95085],[-82.746361,39.95095],[-82.745986,39.951033],[-82.745656,39.951102],[-82.745407,39.951153],[-82.744993,39.951226],[-82.744562,39.951292],[-82.744244,39.951335],[-82.743569,39.951422],[-82.74319,39.951458],[-82.742916,39.951483],[-82.742495,39.951513],[-82.742174,39.951533],[-82.741514,39.951562],[-82.740923,39.951575],[-82.740617,39.951578],[-82.740184,39.951574],[-82.739575,39.951555],[-82.739234,39.951539],[-82.738944,39.951518],[-82.738193,39.951476],[-82.737606,39.951446],[-82.73711,39.951419],[-82.736195,39.951367],[-82.735986,39.951356],[-82.731131,39.951115],[-82.730429,39.951072],[-82.729603,39.951031],[-82.728868,39.950997],[-82.728034,39.950939],[-82.727374,39.95091],[-82.726713,39.950873],[-82.725607,39.950814],[-82.724565,39.950757],[-82.723399,39.9507],[-82.722662,39.950657],[-82.721835,39.950616],[-82.720765,39.950557],[-82.719748,39.950508],[-82.718928,39.950463],[-82.718289,39.950432],[-82.717995,39.950416],[-82.717409,39.95038],[-82.71651,39.950335],[-82.715574,39.950284],[-82.714566,39.950226],[-82.713787,39.950185],[-82.713392,39.950166],[-82.712564,39.950127],[-82.711593,39.950061],[-82.710442,39.950002],[-82.709309,39.949957],[-82.708349,39.949907],[-82.70696,39.949832],[-82.705972,39.949788],[-82.705241,39.949751],[-82.704943,39.949735],[-82.704404,39.949702],[-82.702566,39.949603],[-82.701302,39.949533],[-82.699267,39.949417],[-82.697343,39.949316],[-82.696289,39.949269],[-82.696131,39.949263],[-82.695272,39.94921],[-82.693182,39.9491],[-82.692148,39.94905],[-82.690278,39.948964],[-82.689614,39.948936],[-82.688586,39.948883],[-82.687618,39.948837],[-82.686892,39.948801],[-82.685228,39.948731],[-82.683448,39.948641],[-82.682896,39.94862],[-82.681535,39.948549],[-82.67974,39.948465],[-82.678702,39.948401],[-82.677937,39.948351],[-82.673745,39.948179],[-82.671806,39.948093],[-82.670812,39.948042],[-82.670203,39.948012],[-82.669301,39.947962],[-82.668431,39.947914],[-82.66725,39.947856],[-82.665062,39.947754],[-82.661716,39.947588],[-82.658568,39.947444],[-82.656246,39.94732],[-82.655828,39.947302],[-82.654396,39.947238],[-82.651643,39.947121],[-82.649553,39.947018],[-82.64737,39.946928],[-82.646722,39.946901],[-82.645206,39.946843],[-82.644075,39.946777],[-82.641759,39.946664],[-82.640855,39.94663],[-82.639743,39.946583],[-82.638533,39.946526],[-82.636721,39.946453],[-82.635791,39.946414],[-82.63523,39.946387],[-82.63396,39.946328],[-82.633114,39.946285],[-82.631965,39.946243],[-82.629692,39.946157],[-82.627905,39.946067],[-82.627622,39.946051],[-82.627081,39.946021],[-82.625678,39.94595],[-82.62458,39.945908],[-82.622828,39.945833],[-82.619931,39.945707],[-82.619287,39.945674],[-82.618663,39.945631],[-82.618547,39.945624],[-82.618399,39.945615],[-82.618019,39.945615],[-82.617611,39.945604],[-82.617329,39.945586],[-82.616901,39.945543],[-82.616662,39.945533],[-82.616081,39.945527],[-82.61564,39.945517],[-82.614957,39.945491],[-82.61435,39.945473],[-82.61389,39.945453],[-82.613419,39.945443],[-82.61286,39.945438],[-82.612023,39.945444],[-82.611416,39.945445],[-82.610728,39.945457],[-82.609995,39.945488],[-82.609562,39.945508],[-82.609553,39.945508],[-82.609459,39.945512],[-82.609204,39.945523],[-82.608633,39.945552],[-82.607691,39.945602],[-82.60712,39.945636],[-82.606654,39.945656],[-82.60641,39.945662],[-82.60603,39.945662],[-82.605628,39.945654],[-82.605141,39.94564],[-82.604593,39.945626],[-82.604239,39.945605],[-82.604072,39.945596],[-82.603162,39.945527],[-82.602615,39.945466],[-82.601847,39.945353],[-82.600311,39.945155],[-82.600091,39.945129],[-82.599086,39.944998],[-82.598746,39.944951],[-82.598279,39.94491],[-82.598014,39.94489],[-82.59752,39.944857],[-82.595378,39.944722],[-82.594502,39.944687],[-82.592858,39.944633],[-82.591871,39.944596],[-82.588014,39.944378],[-82.582136,39.944199],[-82.581046,39.944135],[-82.579894,39.944093],[-82.578216,39.944035],[-82.576764,39.943978],[-82.576423,39.943958],[-82.575315,39.943919],[-82.574182,39.943873],[-82.570153,39.943725],[-82.568956,39.943681],[-82.567759,39.943623],[-82.566553,39.94357],[-82.565881,39.943551],[-82.562181,39.943389],[-82.560957,39.943347],[-82.557286,39.943218],[-82.556063,39.943163],[-82.554859,39.943117],[-82.553658,39.943063],[-82.550024,39.942916],[-82.549484,39.94284],[-82.548749,39.942808],[-82.548189,39.942848],[-82.547005,39.942797],[-82.545808,39.942754],[-82.544486,39.942699],[-82.543415,39.942656],[-82.542218,39.942606],[-82.541019,39.942559],[-82.539817,39.942514],[-82.539201,39.942488],[-82.537867,39.942418],[-82.537004,39.942378],[-82.536131,39.942342],[-82.535463,39.94233],[-82.534943,39.942311],[-82.534244,39.942287],[-82.53353,39.94225],[-82.532815,39.942215],[-82.532099,39.942181],[-82.529773,39.942078],[-82.52699,39.941955],[-82.526379,39.941919],[-82.526025,39.941898],[-82.525044,39.941859],[-82.524059,39.941832],[-82.523045,39.941831],[-82.522066,39.941851],[-82.521086,39.941882],[-82.520109,39.941925],[-82.519245,39.941983],[-82.518952,39.942002],[-82.518525,39.94203],[-82.517907,39.942073],[-82.517122,39.942149],[-82.516558,39.942179],[-82.515639,39.942256],[-82.514722,39.942335],[-82.513215,39.942475],[-82.5125,39.942536],[-82.511746,39.94261],[-82.51099,39.94268],[-82.510208,39.942747],[-82.509419,39.942809],[-82.508627,39.942868],[-82.507832,39.942932],[-82.507037,39.942999],[-82.506175,39.943069],[-82.50544,39.94313],[-82.503947,39.943252],[-82.503198,39.943312],[-82.500953,39.943495],[-82.498727,39.943673],[-82.497986,39.943731],[-82.49725,39.943793],[-82.495778,39.943914],[-82.494312,39.944031],[-82.493578,39.944092],[-82.49162,39.944198],[-82.491237,39.944231],[-82.490165,39.94432],[-82.487176,39.944562],[-82.486321,39.944633],[-82.48377,39.944845],[-82.480875,39.945078],[-82.479813,39.945157],[-82.478336,39.945286],[-82.477991,39.945315],[-82.476013,39.945476],[-82.474474,39.9456],[-82.470541,39.945961],[-82.466384,39.946287],[-82.464544,39.946488],[-82.462924,39.94661],[-82.461755,39.946702],[-82.460759,39.946774],[-82.460194,39.946795],[-82.459449,39.946811],[-82.458298,39.946781],[-82.457577,39.946778],[-82.456779,39.94676],[-82.455115,39.946669],[-82.453975,39.946618],[-82.452507,39.946533],[-82.451244,39.946464],[-82.449556,39.946366],[-82.446713,39.946215],[-82.444132,39.946066],[-82.443007,39.946056],[-82.441425,39.945939],[-82.440083,39.94585],[-82.439121,39.945793],[-82.438425,39.945745],[-82.437392,39.945665],[-82.436655,39.945617],[-82.435259,39.945545],[-82.433804,39.945475],[-82.431728,39.945357],[-82.42952,39.945229],[-82.426934,39.945067],[-82.425,39.944933],[-82.42237,39.944777],[-82.421549,39.944728],[-82.420013,39.94461],[-82.418878,39.944526],[-82.417506,39.944444],[-82.415982,39.944364],[-82.414981,39.944282],[-82.413896,39.94418],[-82.413348,39.944139],[-82.412146,39.944065],[-82.411166,39.943994],[-82.410314,39.94393],[-82.409845,39.943913],[-82.409241,39.943869],[-82.408788,39.943838],[-82.408057,39.943791],[-82.401722,39.943349],[-82.395166,39.942973],[-82.394565,39.942924],[-82.379265,39.942042],[-82.358114,39.940897],[-82.335557,39.939773],[-82.331081,39.93954],[-82.32639,39.939312],[-82.321584,39.939088],[-82.318863,39.938922],[-82.318314,39.938888],[-82.311307,39.938414],[-82.304089,39.93807],[-82.288676,39.93746],[-82.288075,39.937414],[-82.282188,39.937096],[-82.279425,39.93697],[-82.27375,39.936712],[-82.261127,39.936139],[-82.259344,39.936055],[-82.258688,39.936051],[-82.258539,39.936044],[-82.258256,39.93604],[-82.257108,39.936015],[-82.254857,39.935903],[-82.253785,39.935862],[-82.252706,39.935846],[-82.251939,39.93584],[-82.251269,39.93588],[-82.250691,39.935924],[-82.249979,39.935983],[-82.249766,39.936005],[-82.249599,39.936022],[-82.249028,39.936107],[-82.248551,39.936184],[-82.247956,39.936295],[-82.247618,39.936355],[-82.247134,39.93646],[-82.246388,39.936648],[-82.246002,39.936764],[-82.245437,39.936949],[-82.243012,39.93779],[-82.242399,39.938048],[-82.23207,39.942396],[-82.229191,39.943575],[-82.22556,39.945115],[-82.221457,39.946826],[-82.219496,39.947661],[-82.21854,39.948047],[-82.218095,39.94823],[-82.217561,39.948378],[-82.216204,39.948754],[-82.21435,39.949168],[-82.211381,39.949708],[-82.206856,39.950575],[-82.198614,39.952111],[-82.193809,39.95301],[-82.192478,39.953163],[-82.191155,39.953221],[-82.190238,39.953183],[-82.189378,39.953129],[-82.188376,39.952996],[-82.18516,39.952496],[-82.181634,39.951943],[-82.178113,39.951405],[-82.176463,39.951145],[-82.174266,39.950802],[-82.170453,39.950212],[-82.170006,39.95015],[-82.15499,39.947849],[-82.150087,39.947259],[-82.147202,39.946941],[-82.144007,39.946779],[-82.096533,39.944651],[-82.096114,39.944634],[-82.087638,39.944301],[-82.085557,39.944356],[-82.083216,39.944559],[-82.071507,39.94606],[-82.069894,39.94633],[-82.068097,39.946779],[-82.06043,39.949175],[-82.058391,39.949581],[-82.057369,39.949715],[-82.055139,39.949744],[-82.053262,39.949526],[-82.05202,39.949169],[-82.051446,39.948933],[-82.049616,39.948433],[-82.048671,39.948195],[-82.04759,39.947998],[-82.04618,39.947832],[-82.044749,39.947772],[-82.042816,39.947873],[-82.039681,39.948176],[-82.031041,39.949004],[-82.028991,39.949178],[-82.028114,39.949211],[-82.026592,39.949221],[-82.024999,39.949157],[-82.023661,39.948986],[-82.02212,39.948718],[-82.021099,39.948489],[-82.018916,39.948011],[-82.018527,39.947933],[-82.017756,39.947774],[-82.016929,39.947667],[-82.016106,39.947582],[-82.014482,39.947401],[-82.013411,39.947271],[-82.012445,39.947097],[-82.011609,39.94686],[-82.01119,39.946721],[-82.011004,39.946643],[-82.009918,39.946181],[-82.008501,39.945529],[-82.007949,39.945312],[-82.007603,39.945189],[-82.00699,39.945016],[-82.006298,39.944836],[-82.005961,39.94477],[-82.00501,39.944614],[-82.004626,39.944585],[-82.00378,39.944574],[-82.003393,39.944568],[-82.001358,39.944516],[-82.000807,39.944506],[-81.999733,39.944466],[-81.998273,39.944358],[-81.997086,39.944215],[-81.995893,39.943966],[-81.995007,39.943779],[-81.993977,39.943612],[-81.993277,39.943559],[-81.99269,39.943511],[-81.992064,39.943507],[-81.991267,39.943558],[-81.99063,39.943641],[-81.990042,39.943738],[-81.989487,39.943849],[-81.988872,39.944024],[-81.988282,39.944221],[-81.987349,39.944559],[-81.985802,39.945339],[-81.9847,39.945898],[-81.9835,39.9465],[-81.98286,39.946785],[-81.982115,39.947072],[-81.981223,39.947369],[-81.980069,39.94765],[-81.978516,39.947908],[-81.969217,39.949149],[-81.967613,39.949325],[-81.966137,39.949399],[-81.964438,39.949524],[-81.958989,39.949628],[-81.957247,39.94976],[-81.956354,39.949865],[-81.955281,39.950083],[-81.953977,39.950438],[-81.95241,39.951005],[-81.950926,39.951683],[-81.949747,39.952431],[-81.946976,39.953988],[-81.94538,39.954778],[-81.944102,39.955304],[-81.942849,39.955724],[-81.941823,39.95602],[-81.940782,39.956289],[-81.937282,39.957225],[-81.93513,39.957775],[-81.931523,39.958511],[-81.930775,39.958684],[-81.924904,39.959888],[-81.922287,39.96043],[-81.920087,39.96098],[-81.917872,39.961624],[-81.904387,39.966322],[-81.903624,39.966551],[-81.902756,39.966833],[-81.901591,39.967102],[-81.900308,39.96733],[-81.898666,39.967588],[-81.894146,39.968199],[-81.88678,39.969168],[-81.884265,39.969313],[-81.88375,39.969339],[-81.87914,39.969663],[-81.871413,39.970074],[-81.8701,39.970166],[-81.868847,39.970417],[-81.852197,39.974412],[-81.851697,39.974532],[-81.849217,39.975127],[-81.846602,39.975638],[-81.845818,39.975778],[-81.844434,39.975979],[-81.842814,39.976045],[-81.841184,39.975975],[-81.840154,39.975831],[-81.839542,39.975712],[-81.838062,39.975392],[-81.836897,39.975022],[-81.834641,39.974063],[-81.834241,39.97388],[-81.832183,39.973048],[-81.830049,39.972427],[-81.827242,39.972064],[-81.825343,39.971834],[-81.820403,39.971324],[-81.818726,39.971191],[-81.816076,39.971042],[-81.813004,39.971051],[-81.802836,39.971299],[-81.801624,39.971407],[-81.799547,39.97178],[-81.79787,39.972261],[-81.785106,39.976538],[-81.783786,39.976969],[-81.782672,39.977259],[-81.781082,39.977616],[-81.779449,39.977848],[-81.778129,39.977989],[-81.76888,39.978519],[-81.767852,39.978561],[-81.766608,39.978569],[-81.764737,39.978495],[-81.757273,39.97808],[-81.755964,39.978064],[-81.754309,39.978138],[-81.752806,39.978321],[-81.751324,39.978569],[-81.749214,39.97905],[-81.743254,39.980559],[-81.742064,39.980757],[-81.740517,39.980932],[-81.738959,39.980965],[-81.734027,39.980559],[-81.732415,39.980542],[-81.731563,39.980575],[-81.730765,39.980637],[-81.730338,39.980658],[-81.728434,39.980998],[-81.726292,39.981545],[-81.722739,39.982386],[-81.71796,39.983538],[-81.712686,39.984764],[-81.710457,39.985188],[-81.70856,39.985416],[-81.706026,39.98548],[-81.702668,39.98523],[-81.70219,39.985195],[-81.689847,39.984297],[-81.687874,39.984302],[-81.68642,39.984461],[-81.684731,39.984785],[-81.683048,39.985278],[-81.681546,39.985904],[-81.680618,39.986387],[-81.674145,39.990116],[-81.672144,39.991474],[-81.670601,39.992768],[-81.669274,39.994104],[-81.668641,39.994741],[-81.667056,39.996746],[-81.665418,39.999083],[-81.664086,40.000983],[-81.662978,40.002367],[-81.661891,40.003375],[-81.660264,40.004489],[-81.659157,40.005067],[-81.6578,40.005655],[-81.656221,40.006095],[-81.650441,40.007331],[-81.648904,40.007596],[-81.64691,40.007824],[-81.6452,40.007872],[-81.644023,40.007851],[-81.632484,40.00742],[-81.626217,40.007182],[-81.624403,40.007167],[-81.622907,40.007209],[-81.621087,40.007421],[-81.615921,40.00845],[-81.615441,40.008529],[-81.613658,40.008858],[-81.612481,40.009083],[-81.611082,40.009201],[-81.609201,40.009174],[-81.607602,40.009002],[-81.605885,40.00866],[-81.60431,40.008165],[-81.602675,40.00749],[-81.593576,40.003662],[-81.5918,40.002951],[-81.589813,40.002257],[-81.587897,40.001654],[-81.586236,40.001231],[-81.578788,39.999295],[-81.57339,39.997805],[-81.572931,39.997698],[-81.571342,39.997292],[-81.570687,39.997124],[-81.570012,39.996989],[-81.569132,39.99684],[-81.56847,39.996752],[-81.56779,39.996702],[-81.566327,39.996614],[-81.565302,39.996611],[-81.564054,39.996585],[-81.562622,39.996556],[-81.560771,39.996642],[-81.55908,39.996932],[-81.558098,39.997241],[-81.556723,39.99783],[-81.556206,39.998134],[-81.555763,39.998391],[-81.555077,39.998784],[-81.554075,39.999413],[-81.55349,39.999775],[-81.551761,40.000658],[-81.549986,40.001324],[-81.548422,40.001711],[-81.547258,40.001937],[-81.536689,40.003891],[-81.536127,40.004008],[-81.53441,40.004192],[-81.532282,40.004376],[-81.52981,40.004363],[-81.526256,40.004107],[-81.518197,40.003594],[-81.512891,40.003343],[-81.51133,40.003241],[-81.50564,40.002792],[-81.50352,40.002766],[-81.50237,40.002838],[-81.498979,40.003226],[-81.495769,40.003962],[-81.493521,40.00485],[-81.491607,40.005757],[-81.490456,40.006493],[-81.489469,40.00719],[-81.488405,40.007986],[-81.486465,40.009761],[-81.483676,40.01239],[-81.479788,40.015993],[-81.476166,40.01947],[-81.475376,40.020226],[-81.471865,40.023289],[-81.469763,40.024801],[-81.467608,40.02622],[-81.464784,40.027745],[-81.462424,40.028876],[-81.460364,40.029704],[-81.456854,40.030821],[-81.454262,40.031511],[-81.452245,40.031945],[-81.448889,40.032457],[-81.447776,40.032608],[-81.447235,40.032687],[-81.446056,40.032858],[-81.442992,40.033292],[-81.439911,40.033745],[-81.437113,40.034291],[-81.434503,40.03504],[-81.431886,40.035816],[-81.428356,40.03699],[-81.425851,40.037762],[-81.424752,40.038033],[-81.423185,40.038325],[-81.421367,40.038542],[-81.419886,40.038621],[-81.417578,40.038569],[-81.41496,40.038319],[-81.413101,40.038128],[-81.412723,40.038089],[-81.410754,40.037886],[-81.407192,40.037504],[-81.406068,40.037472],[-81.405166,40.037485],[-81.403373,40.037616],[-81.401562,40.037997],[-81.397013,40.03893],[-81.393948,40.039574],[-81.391296,40.040126],[-81.389545,40.040494],[-81.386867,40.041059],[-81.381409,40.04217],[-81.377303,40.04297],[-81.376932,40.043041],[-81.368946,40.04443],[-81.363599,40.045383],[-81.354346,40.046953],[-81.347231,40.048189],[-81.343128,40.048918],[-81.338201,40.049555],[-81.334485,40.050015],[-81.332349,40.050427],[-81.330288,40.050849],[-81.328916,40.051195],[-81.326078,40.052004],[-81.323438,40.052899],[-81.32062,40.053972],[-81.320331,40.054082],[-81.313688,40.056744],[-81.309594,40.058308],[-81.308702,40.058669],[-81.307697,40.058971],[-81.306865,40.059136],[-81.305612,40.0593],[-81.304384,40.059372],[-81.302977,40.059287],[-81.301638,40.059083],[-81.299724,40.058689],[-81.296222,40.057776],[-81.293707,40.057178],[-81.290883,40.056606],[-81.28957,40.05637],[-81.289085,40.056299],[-81.28818,40.056166],[-81.286463,40.055982],[-81.283648,40.055739],[-81.279948,40.055595],[-81.277408,40.055549],[-81.27449,40.055437],[-81.271717,40.055384],[-81.269717,40.055332],[-81.26861,40.055339],[-81.267786,40.055391],[-81.266894,40.055536],[-81.265846,40.055713],[-81.265306,40.055864],[-81.263108,40.056475],[-81.261023,40.057073],[-81.259933,40.05727],[-81.258748,40.057401],[-81.257504,40.05746],[-81.256148,40.057487],[-81.254379,40.057375],[-81.253178,40.057191],[-81.249556,40.056574],[-81.24874,40.056495],[-81.246131,40.056606],[-81.243522,40.056869],[-81.241368,40.057125],[-81.240647,40.057178],[-81.239814,40.057171],[-81.238295,40.057119],[-81.237291,40.056922],[-81.236029,40.056672],[-81.232973,40.055759],[-81.231094,40.055352],[-81.230133,40.055227],[-81.22975,40.05518],[-81.229404,40.055149],[-81.229375,40.055146],[-81.229138,40.055129],[-81.22893,40.055117],[-81.228648,40.055105],[-81.228092,40.055092],[-81.227467,40.055097],[-81.227196,40.055105],[-81.226905,40.05512],[-81.226296,40.055167],[-81.225908,40.05521],[-81.225774,40.055227],[-81.225463,40.055266],[-81.225121,40.055315],[-81.224607,40.055404],[-81.224081,40.055513],[-81.223782,40.055582],[-81.223307,40.055677],[-81.222863,40.055812],[-81.2223,40.055994],[-81.221027,40.056421],[-81.219782,40.056824],[-81.218961,40.057106],[-81.218092,40.057395],[-81.215162,40.058355],[-81.214825,40.058462],[-81.214583,40.058532],[-81.213712,40.058761],[-81.213432,40.058825],[-81.213104,40.058894],[-81.212592,40.058992],[-81.212123,40.059069],[-81.211749,40.059124],[-81.211469,40.059161],[-81.211191,40.059192],[-81.210625,40.059246],[-81.21036,40.059265],[-81.209879,40.059293],[-81.20943,40.05931],[-81.20902,40.059317],[-81.208478,40.05932],[-81.207475,40.059274],[-81.206522,40.059201],[-81.204753,40.059032],[-81.202027,40.058787],[-81.200801,40.058672],[-81.200373,40.058638],[-81.19998,40.058616],[-81.199544,40.058602],[-81.199172,40.058599],[-81.1988,40.058602],[-81.198389,40.058614],[-81.197931,40.05864],[-81.197507,40.058672],[-81.196644,40.058769],[-81.194867,40.058995],[-81.192801,40.059245],[-81.192476,40.059278],[-81.19181,40.05932],[-81.191145,40.059339],[-81.19076,40.05934],[-81.18934,40.059319],[-81.187562,40.059285],[-81.186548,40.059272],[-81.186151,40.059275],[-81.185735,40.059289],[-81.185381,40.059309],[-81.185008,40.059335],[-81.184615,40.059377],[-81.184188,40.059431],[-81.18284,40.059624],[-81.182246,40.05972],[-81.181508,40.059828],[-81.180853,40.059933],[-81.180144,40.060031],[-81.179756,40.060078],[-81.179377,40.060115],[-81.179079,40.060137],[-81.178686,40.060158],[-81.178334,40.060169],[-81.177836,40.060177],[-81.177489,40.060172],[-81.177056,40.060155],[-81.176657,40.060132],[-81.17134,40.05976],[-81.171014,40.059744],[-81.170697,40.059739],[-81.170299,40.059738],[-81.169861,40.059748],[-81.169442,40.059767],[-81.168998,40.059793],[-81.16584,40.059999],[-81.165349,40.060021],[-81.164982,40.060029],[-81.164289,40.060019],[-81.163913,40.060003],[-81.163589,40.059982],[-81.163215,40.059949],[-81.162745,40.059896],[-81.162179,40.059822],[-81.16186,40.059771],[-81.161539,40.059714],[-81.161122,40.05963],[-81.160704,40.059534],[-81.160152,40.059384],[-81.158629,40.058946],[-81.157825,40.058708],[-81.157704,40.058673],[-81.157178,40.05852],[-81.156526,40.058337],[-81.156175,40.058251],[-81.155604,40.058128],[-81.155067,40.058028],[-81.154779,40.057982],[-81.15424,40.057908],[-81.153916,40.057872],[-81.153537,40.057837],[-81.153145,40.057812],[-81.152685,40.057791],[-81.152252,40.057779],[-81.151844,40.057779],[-81.151702,40.057782],[-81.151512,40.057785],[-81.15116,40.057799],[-81.150739,40.057825],[-81.150389,40.057855],[-81.150024,40.057893],[-81.149656,40.057936],[-81.149115,40.058015],[-81.148658,40.058087],[-81.148391,40.058138],[-81.147525,40.058278],[-81.145866,40.058582],[-81.143519,40.058986],[-81.143099,40.059054],[-81.142753,40.059104],[-81.142357,40.059148],[-81.142192,40.059162],[-81.141576,40.05921],[-81.140978,40.059233],[-81.140371,40.059244],[-81.139325,40.059255],[-81.135865,40.059272],[-81.135319,40.059278],[-81.133261,40.059289],[-81.132159,40.059299],[-81.128042,40.059323],[-81.127635,40.05932],[-81.127229,40.059322],[-81.126659,40.059304],[-81.126102,40.059266],[-81.125401,40.059195],[-81.125,40.059144],[-81.124588,40.059081],[-81.124166,40.059003],[-81.12351,40.058858],[-81.123056,40.058745],[-81.122863,40.058697],[-81.12223,40.058527],[-81.121597,40.058362],[-81.120575,40.058141],[-81.119381,40.057842],[-81.118259,40.057475],[-81.117914,40.057388],[-81.117605,40.057306],[-81.117155,40.057187],[-81.116404,40.057002],[-81.115877,40.056891],[-81.115605,40.056842],[-81.115035,40.056764],[-81.114584,40.056718],[-81.114297,40.056696],[-81.113909,40.056683],[-81.113262,40.056676],[-81.112719,40.056689],[-81.112324,40.056715],[-81.111938,40.056756],[-81.111523,40.056808],[-81.110985,40.056895],[-81.110485,40.057],[-81.110189,40.05707],[-81.109822,40.057171],[-81.109426,40.057288],[-81.108861,40.057481],[-81.10849,40.057625],[-81.107146,40.058176],[-81.106718,40.058358],[-81.106379,40.058491],[-81.104681,40.0592],[-81.104052,40.059452],[-81.103691,40.059583],[-81.103169,40.059752],[-81.102635,40.059895],[-81.102265,40.059984],[-81.102011,40.060038],[-81.101734,40.06009],[-81.101432,40.060139],[-81.100798,40.060217],[-81.100385,40.060247],[-81.099963,40.060269],[-81.099565,40.060274],[-81.099147,40.060272],[-81.098881,40.06026],[-81.098465,40.060235],[-81.098031,40.060194],[-81.097651,40.060149],[-81.09618,40.059941],[-81.095438,40.05983],[-81.094878,40.059753],[-81.094204,40.059651],[-81.093808,40.059596],[-81.092649,40.059423],[-81.092596,40.059415],[-81.091195,40.059218],[-81.088097,40.058768],[-81.087518,40.058689],[-81.087028,40.05862],[-81.085926,40.058468],[-81.085081,40.058342],[-81.084191,40.058218],[-81.081975,40.05789],[-81.079856,40.057594],[-81.07918,40.05749],[-81.078399,40.05738],[-81.076936,40.057167],[-81.07623,40.057058],[-81.075222,40.056913],[-81.073112,40.056611],[-81.071435,40.056381],[-81.070749,40.056317],[-81.070616,40.056304],[-81.0704,40.056282],[-81.070128,40.05626],[-81.069493,40.056226],[-81.069019,40.056206],[-81.068203,40.056197],[-81.067628,40.056201],[-81.067207,40.056213],[-81.066798,40.056231],[-81.066211,40.056266],[-81.065844,40.056298],[-81.065512,40.056334],[-81.064689,40.056439],[-81.063778,40.056575],[-81.062868,40.056753],[-81.062786,40.056769],[-81.061863,40.056984],[-81.061637,40.057042],[-81.060666,40.057316],[-81.060239,40.057452],[-81.057845,40.058243],[-81.056738,40.058609],[-81.056376,40.058725],[-81.055406,40.059048],[-81.053506,40.059663],[-81.053265,40.059749],[-81.052968,40.059849],[-81.0528,40.059906],[-81.05258,40.059979],[-81.049124,40.06112],[-81.047626,40.061599],[-81.04674,40.061904],[-81.046003,40.06215],[-81.044626,40.062602],[-81.044232,40.062735],[-81.043826,40.062873],[-81.043306,40.06304],[-81.042175,40.063419],[-81.040993,40.0638],[-81.040614,40.063909],[-81.039825,40.064117],[-81.038887,40.06433],[-81.038431,40.064418],[-81.037628,40.064557],[-81.037172,40.064627],[-81.036461,40.064715],[-81.035898,40.064773],[-81.03547,40.064805],[-81.034937,40.064837],[-81.034115,40.064869],[-81.033681,40.064874],[-81.03327,40.064872],[-81.032441,40.064849],[-81.031624,40.064807],[-81.031573,40.064803],[-81.031376,40.06479],[-81.030073,40.064728],[-81.029142,40.064676],[-81.027064,40.064573],[-81.02147,40.064294],[-81.020948,40.064272],[-81.01908,40.064173],[-81.017735,40.064109],[-81.016233,40.064033],[-81.011219,40.063781],[-81.011066,40.06377],[-81.008199,40.063632],[-81.00697,40.063572],[-81.006673,40.06356],[-81.005789,40.063523],[-81.00525,40.063513],[-81.004264,40.063496],[-81.003439,40.063504],[-81.00236,40.06353],[-81.001891,40.063542],[-81.001368,40.063563],[-81.000285,40.063623],[-80.999686,40.063668],[-80.999394,40.06369],[-80.993702,40.064203],[-80.993303,40.064235],[-80.992428,40.064312],[-80.991038,40.064433],[-80.985439,40.064933],[-80.985174,40.064956],[-80.983065,40.065148],[-80.982527,40.065219],[-80.982016,40.0653],[-80.981402,40.065419],[-80.981027,40.065504],[-80.980655,40.065597],[-80.980279,40.0657],[-80.979907,40.065807],[-80.979408,40.065967],[-80.978472,40.066322],[-80.978163,40.066459],[-80.977817,40.066611],[-80.977581,40.066727],[-80.977243,40.066906],[-80.976907,40.067076],[-80.976501,40.067312],[-80.97617,40.067512],[-80.975914,40.067681],[-80.973891,40.06907],[-80.972367,40.070122],[-80.971431,40.070774],[-80.969625,40.071973],[-80.96908,40.072324],[-80.965966,40.074526],[-80.965424,40.074898],[-80.965096,40.075123],[-80.964749,40.075345],[-80.964478,40.075518],[-80.964192,40.075691],[-80.96376,40.075896],[-80.963449,40.076056],[-80.963118,40.076218],[-80.962785,40.076353],[-80.962318,40.076545],[-80.962019,40.076657],[-80.961639,40.076778],[-80.96093,40.07697],[-80.960665,40.07704],[-80.96009,40.077173],[-80.9597,40.077256],[-80.959283,40.077331],[-80.958865,40.077395],[-80.958133,40.077493],[-80.957823,40.077521],[-80.957629,40.077524],[-80.957375,40.077541],[-80.956935,40.077563],[-80.956588,40.077576],[-80.954392,40.07761],[-80.953878,40.077615],[-80.952641,40.077636],[-80.952064,40.077652],[-80.951936,40.077652],[-80.95032,40.077678],[-80.949959,40.077679],[-80.949377,40.07769],[-80.948465,40.0777],[-80.947041,40.077724],[-80.946363,40.07774],[-80.944773,40.077759],[-80.944721,40.077759],[-80.943173,40.077776],[-80.93973,40.077831],[-80.939421,40.077836],[-80.938741,40.07785],[-80.937054,40.077869],[-80.936394,40.077861],[-80.935585,40.077823],[-80.935076,40.077789],[-80.934764,40.07776],[-80.933837,40.077653],[-80.933589,40.077621],[-80.933141,40.07755],[-80.932534,40.077461],[-80.931946,40.077362],[-80.931305,40.077233],[-80.930976,40.077173],[-80.930664,40.077095],[-80.930296,40.077001],[-80.928423,40.076471],[-80.924117,40.075298],[-80.922882,40.07494],[-80.922342,40.074788],[-80.92132,40.07449],[-80.920639,40.074299],[-80.920179,40.074174],[-80.918715,40.073765],[-80.916812,40.073219],[-80.912366,40.071957],[-80.912095,40.07188],[-80.910166,40.07133],[-80.908723,40.070908],[-80.906858,40.070345],[-80.906328,40.070185],[-80.906107,40.070124],[-80.9058,40.070035],[-80.904559,40.069731],[-80.904369,40.069677],[-80.900809,40.068595],[-80.900191,40.068398],[-80.899521,40.068235],[-80.8991,40.068138],[-80.898467,40.06799],[-80.898098,40.06792],[-80.897745,40.067845],[-80.897424,40.067786],[-80.897125,40.06774],[-80.896855,40.067708],[-80.896551,40.067673],[-80.896071,40.067623],[-80.895436,40.067596],[-80.8948,40.067596],[-80.894174,40.067623],[-80.893539,40.067669],[-80.892955,40.067761],[-80.892225,40.067899],[-80.890063,40.068372],[-80.888283,40.068751],[-80.886645,40.069081],[-80.883783,40.069665],[-80.883029,40.069826],[-80.881293,40.070175],[-80.88037,40.07036],[-80.876775,40.071068],[-80.876296,40.071164],[-80.875413,40.071341],[-80.873874,40.071657],[-80.871161,40.072203],[-80.870745,40.072281],[-80.870221,40.072367],[-80.869829,40.072421],[-80.869437,40.072465],[-80.869079,40.072494],[-80.868609,40.072525],[-80.868407,40.072533],[-80.867075,40.0725],[-80.866729,40.072494],[-80.866018,40.072441],[-80.865321,40.072414],[-80.864921,40.072356],[-80.864486,40.072286],[-80.86399,40.072193],[-80.863618,40.072108],[-80.863196,40.072004],[-80.862762,40.071887],[-80.861046,40.071363],[-80.860472,40.071178],[-80.86042,40.071161],[-80.858405,40.070549],[-80.857891,40.070405],[-80.857488,40.0703],[-80.857271,40.070246],[-80.857123,40.07021],[-80.856564,40.070084],[-80.856245,40.07002],[-80.85577,40.069932],[-80.855225,40.069844],[-80.854636,40.06976],[-80.854006,40.069685],[-80.852549,40.069542],[-80.851764,40.069466],[-80.850847,40.069376],[-80.850462,40.069279],[-80.850076,40.069197],[-80.849402,40.069081],[-80.848909,40.069006],[-80.847958,40.068843],[-80.847404,40.068742],[-80.846833,40.068632],[-80.846002,40.068466],[-80.845615,40.068378],[-80.844903,40.068204],[-80.844614,40.06812],[-80.844235,40.067981],[-80.844087,40.067923],[-80.843828,40.067807],[-80.843606,40.067694],[-80.843269,40.067494],[-80.84304,40.067342],[-80.842763,40.067121],[-80.84256,40.066939],[-80.842342,40.066713],[-80.842308,40.066678],[-80.842154,40.066494],[-80.842001,40.066287],[-80.841888,40.066101],[-80.841792,40.065927],[-80.841447,40.065154],[-80.841401,40.06505],[-80.841319,40.064841],[-80.841218,40.064604],[-80.841123,40.064405],[-80.840916,40.064011],[-80.840791,40.063813],[-80.840657,40.063619],[-80.840511,40.063424],[-80.840348,40.063229],[-80.840198,40.063063],[-80.840062,40.062927],[-80.839908,40.062781],[-80.839781,40.062668],[-80.839595,40.062511],[-80.83931,40.062297],[-80.839117,40.062167],[-80.838883,40.062022],[-80.838644,40.061884],[-80.838325,40.061717],[-80.838083,40.061603],[-80.837882,40.061518],[-80.837671,40.061435],[-80.837255,40.061292],[-80.837001,40.061215],[-80.836675,40.061126],[-80.83632,40.061044],[-80.832383,40.060174],[-80.831661,40.060004],[-80.829584,40.059543],[-80.82821,40.05923],[-80.82779,40.059128],[-80.827399,40.059025],[-80.826936,40.058894],[-80.826537,40.058772],[-80.826102,40.058632],[-80.825662,40.058479],[-80.825198,40.058308],[-80.824409,40.057986],[-80.823736,40.057689],[-80.823388,40.05752],[-80.823024,40.057343],[-80.822607,40.057123],[-80.822219,40.056909],[-80.820944,40.056173],[-80.818761,40.05489],[-80.817956,40.054427],[-80.817565,40.054197],[-80.817135,40.053953],[-80.816738,40.053734],[-80.816488,40.053607],[-80.816274,40.053498],[-80.815677,40.053207],[-80.815291,40.053024],[-80.814946,40.052872],[-80.814593,40.052726],[-80.814221,40.05258],[-80.813876,40.052451],[-80.81345,40.052303],[-80.81296,40.05214],[-80.812441,40.051981],[-80.812049,40.051867],[-80.81151,40.051728],[-80.811185,40.051649],[-80.810673,40.051528],[-80.80971,40.051316],[-80.809227,40.051231],[-80.808524,40.051128],[-80.808107,40.051076],[-80.807968,40.051059],[-80.801985,40.050368],[-80.800591,40.050194],[-80.79795,40.049903],[-80.797052,40.049796],[-80.792331,40.049251],[-80.791391,40.04913],[-80.790457,40.049026],[-80.789666,40.048927],[-80.789023,40.04886],[-80.788888,40.048842],[-80.78759,40.048705],[-80.783049,40.04818],[-80.782394,40.048101],[-80.78208,40.048068],[-80.781158,40.047955],[-80.780058,40.047834],[-80.777251,40.047506],[-80.776285,40.047398],[-80.775966,40.047358],[-80.774358,40.047176],[-80.773726,40.047098],[-80.773016,40.047021],[-80.769525,40.046621],[-80.767912,40.046431],[-80.76621,40.046188],[-80.76363,40.045746],[-80.762254,40.045519],[-80.761381,40.045404],[-80.760801,40.045342],[-80.760136,40.045288],[-80.759404,40.045249],[-80.758606,40.045229],[-80.757893,40.045232],[-80.757147,40.045255],[-80.756776,40.045273],[-80.756398,40.045296],[-80.755641,40.045359],[-80.754654,40.045479],[-80.753798,40.045617],[-80.753261,40.045711],[-80.752345,40.045888],[-80.751017,40.046131],[-80.749592,40.046399],[-80.742659,40.047686],[-80.741717,40.047865],[-80.737899,40.04857],[-80.736547,40.048816],[-80.734284,40.049194],[-80.733994,40.049243],[-80.732639,40.049524],[-80.732245,40.049604],[-80.728308,40.050228],[-80.72805,40.050261],[-80.727696,40.050319],[-80.726988,40.050417],[-80.726525,40.050477],[-80.725507,40.050639],[-80.724713,40.050787],[-80.723812,40.050943],[-80.723008,40.05105],[-80.721935,40.051206],[-80.720647,40.051386],[-80.720293,40.051419],[-80.719263,40.051493],[-80.718662,40.051534],[-80.718319,40.051542],[-80.717997,40.051534],[-80.715873,40.051452],[-80.714907,40.051419],[-80.713513,40.051395],[-80.712397,40.051469],[-80.711571,40.0516],[-80.710734,40.051756],[-80.710208,40.051904],[-80.709339,40.052199],[-80.706496,40.053374],[-80.705638,40.053711],[-80.705026,40.053875],[-80.704468,40.053982],[-80.703932,40.054055],[-80.703449,40.054096],[-80.702923,40.054113],[-80.702633,40.054096],[-80.701958,40.053949],[-80.701153,40.053743],[-80.700724,40.053571],[-80.700209,40.053398],[-80.699769,40.053193],[-80.699436,40.052996],[-80.699157,40.052815],[-80.698814,40.052536],[-80.698524,40.05229],[-80.698117,40.051776],[-80.69773,40.051288],[-80.697237,40.050672],[-80.696936,40.050401],[-80.696314,40.0499],[-80.695746,40.049522],[-80.694791,40.049062],[-80.693943,40.04875],[-80.693262,40.048637],[-80.692603,40.048535],[-80.691882,40.048492],[-80.691126,40.048507],[-80.690131,40.048603],[-80.689244,40.048775],[-80.688321,40.048947],[-80.685832,40.049497],[-80.684008,40.049908],[-80.682249,40.050302],[-80.681154,40.050458],[-80.68021,40.050516],[-80.679502,40.050557],[-80.678365,40.050549],[-80.677507,40.050565],[-80.67638,40.050499],[-80.675275,40.050384],[-80.673462,40.050171],[-80.670157,40.049818],[-80.667687,40.049567],[-80.666477,40.049438],[-80.66549,40.049307],[-80.664451,40.049096],[-80.663533,40.048755],[-80.663185,40.048597],[-80.662709,40.04838],[-80.661619,40.047822],[-80.660343,40.047052],[-80.659138,40.046363],[-80.658537,40.046028],[-80.657684,40.045576],[-80.656726,40.045069],[-80.656364,40.044874],[-80.655611,40.044497],[-80.655275,40.044354],[-80.654778,40.044201],[-80.654154,40.044038],[-80.653422,40.043952],[-80.651625,40.043888],[-80.650486,40.044044],[-80.648984,40.044504],[-80.64683,40.045279],[-80.64586,40.045634],[-80.64433,40.046098],[-80.64312,40.046288],[-80.642115,40.0464],[-80.640931,40.046393],[-80.637687,40.045953],[-80.635558,40.04569],[-80.634725,40.045539],[-80.634004,40.045454],[-80.633,40.045283],[-80.631696,40.044935],[-80.631472,40.044856],[-80.629842,40.044231],[-80.629206,40.043982],[-80.628159,40.043772],[-80.627267,40.043653],[-80.626494,40.043634],[-80.625644,40.043726],[-80.624512,40.04385],[-80.623173,40.044087],[-80.621619,40.044304],[-80.620357,40.044409],[-80.619499,40.044396],[-80.618735,40.04431],[-80.617739,40.044093],[-80.613336,40.042681],[-80.612358,40.042457],[-80.611706,40.042359],[-80.61101,40.042326],[-80.609989,40.042398],[-80.609165,40.04251],[-80.608384,40.042694],[-80.607457,40.043062],[-80.606478,40.04362],[-80.605002,40.044836],[-80.604307,40.045473],[-80.603088,40.046551],[-80.599217,40.049928],[-80.598127,40.051091],[-80.597406,40.052096],[-80.596883,40.05318],[-80.596316,40.054317],[-80.592927,40.061199],[-80.592488,40.061826],[-80.591716,40.062569],[-80.590943,40.063087],[-80.590205,40.063422],[-80.589493,40.063724],[-80.588626,40.063974],[-80.587716,40.064099],[-80.586148,40.064169],[-80.582841,40.064282],[-80.579236,40.064414],[-80.577124,40.064545],[-80.575888,40.064723],[-80.57412,40.065058],[-80.573331,40.065228],[-80.57267,40.065399],[-80.571846,40.065583],[-80.570902,40.065905],[-80.570026,40.06624],[-80.569085,40.066713],[-80.568448,40.067044],[-80.567916,40.067319],[-80.566891,40.067853],[-80.565551,40.068737],[-80.55904,40.07357],[-80.55286,40.078161],[-80.547873,40.081904],[-80.546787,40.082717],[-80.546296,40.083084],[-80.540209,40.087637],[-80.537479,40.089627],[-80.535857,40.090713],[-80.534657,40.091385],[-80.533222,40.091945],[-80.532252,40.092286],[-80.531136,40.09268],[-80.530149,40.092949],[-80.528922,40.093245],[-80.527137,40.093672],[-80.525051,40.094164],[-80.522141,40.094873],[-80.520811,40.09521],[-80.519189,40.095609],[-80.518288,40.095828],[-80.512197,40.0973],[-80.510947,40.097592],[-80.510512,40.097707],[-80.510037,40.097845],[-80.509741,40.097938],[-80.509233,40.098121],[-80.508756,40.098298],[-80.508492,40.098409],[-80.50818,40.098548],[-80.507763,40.098746],[-80.507225,40.099016],[-80.506791,40.099264],[-80.50643,40.099472],[-80.506126,40.099663],[-80.505699,40.099956],[-80.50529,40.100264],[-80.504871,40.100607],[-80.504465,40.100973],[-80.503803,40.101594],[-80.503233,40.102117],[-80.50293,40.102374],[-80.502601,40.102633],[-80.502269,40.102878],[-80.50187,40.103152],[-80.501483,40.1034],[-80.501125,40.103613],[-80.50074,40.103825],[-80.500405,40.104003],[-80.499945,40.104223],[-80.499244,40.104535],[-80.496771,40.105598],[-80.494495,40.106595],[-80.494205,40.106735],[-80.493873,40.106905],[-80.493574,40.107085],[-80.493221,40.107319],[-80.492887,40.107571],[-80.492612,40.10781],[-80.49249,40.107919],[-80.492364,40.10804],[-80.492249,40.108165],[-80.492123,40.108307],[-80.491864,40.108648],[-80.491627,40.108954],[-80.491284,40.109457],[-80.490295,40.110852],[-80.489012,40.112693],[-80.488021,40.114115],[-80.487706,40.11455],[-80.487399,40.114938],[-80.487133,40.115231],[-80.486833,40.115525],[-80.48654,40.11578],[-80.486205,40.116047],[-80.485834,40.116314],[-80.485432,40.116566],[-80.484909,40.116856],[-80.484468,40.117066],[-80.484045,40.117248],[-80.483433,40.117479],[-80.481987,40.118036],[-80.480086,40.118766],[-80.479723,40.118899],[-80.479403,40.119002],[-80.478933,40.119122],[-80.478542,40.119213],[-80.478158,40.119285],[-80.477698,40.119349],[-80.477305,40.119385],[-80.476943,40.119409],[-80.476641,40.119419],[-80.47636,40.119421],[-80.476109,40.119416],[-80.475985,40.119411],[-80.475519,40.119381],[-80.475076,40.119333],[-80.474608,40.119255],[-80.474167,40.119168],[-80.473775,40.119075],[-80.473393,40.118963],[-80.473054,40.118852],[-80.472711,40.118723],[-80.472423,40.118605],[-80.472082,40.118446],[-80.471776,40.118294],[-80.471377,40.118069],[-80.471002,40.117829],[-80.470643,40.117572],[-80.470303,40.117293],[-80.469508,40.116597],[-80.468793,40.115961],[-80.468237,40.115475],[-80.467854,40.115146],[-80.467563,40.114911],[-80.467328,40.114732],[-80.467029,40.114525],[-80.466789,40.114377],[-80.466534,40.114228],[-80.466241,40.114074],[-80.465997,40.113958],[-80.465762,40.113848],[-80.465546,40.11376],[-80.465412,40.113709],[-80.465031,40.113566],[-80.464642,40.113453],[-80.464233,40.113341],[-80.463851,40.113256],[-80.463444,40.113183],[-80.463053,40.113126],[-80.462575,40.113079],[-80.462151,40.113054],[-80.461721,40.113048],[-80.461311,40.113058],[-80.460855,40.113083],[-80.460357,40.113135],[-80.4599,40.11321],[-80.459096,40.113386],[-80.458689,40.113497],[-80.458155,40.11368],[-80.457704,40.113861],[-80.45692,40.114223],[-80.456771,40.114293],[-80.455953,40.114671],[-80.45556,40.114852],[-80.455217,40.11499],[-80.454776,40.115154],[-80.454212,40.115332],[-80.453785,40.115455],[-80.453353,40.115568],[-80.4529,40.11567],[-80.452454,40.115755],[-80.451916,40.115838],[-80.451407,40.115902],[-80.450798,40.115953],[-80.450289,40.115981],[-80.449637,40.116008],[-80.448366,40.116067],[-80.44683,40.116133],[-80.445457,40.116195],[-80.445318,40.116202],[-80.442634,40.116321],[-80.436855,40.116577],[-80.43638,40.116595],[-80.436106,40.1166],[-80.435856,40.116585],[-80.435625,40.116579],[-80.435404,40.116566],[-80.434976,40.116528],[-80.434637,40.116482],[-80.434339,40.116432],[-80.434003,40.116363],[-80.433561,40.116252],[-80.432599,40.115993],[-80.432163,40.115887],[-80.429028,40.115021],[-80.428482,40.114873],[-80.426903,40.11444],[-80.4253,40.114005],[-80.424717,40.113847],[-80.424248,40.113737],[-80.423703,40.113623],[-80.423269,40.11355],[-80.423117,40.113523],[-80.422812,40.113481],[-80.422511,40.113438],[-80.422085,40.113393],[-80.421498,40.11335],[-80.421151,40.113333],[-80.420726,40.113322],[-80.420294,40.11332],[-80.419832,40.113327],[-80.419421,40.113343],[-80.419126,40.113363],[-80.418758,40.11339],[-80.418425,40.11343],[-80.417822,40.113513],[-80.417059,40.113639],[-80.416611,40.113725],[-80.416142,40.113835],[-80.415664,40.113964],[-80.415211,40.114099],[-80.414808,40.11423],[-80.414527,40.11433],[-80.414056,40.114509],[-80.413472,40.114755],[-80.413028,40.114954],[-80.412332,40.115299],[-80.409735,40.116594],[-80.406746,40.118074],[-80.405988,40.118462],[-80.404666,40.119111],[-80.403381,40.119757],[-80.402752,40.120057],[-80.402371,40.120212],[-80.401905,40.120391],[-80.401432,40.120539],[-80.401009,40.120659],[-80.400587,40.120768],[-80.400076,40.120874],[-80.399615,40.120955],[-80.399163,40.121012],[-80.398697,40.121051],[-80.398244,40.121081],[-80.397772,40.12109],[-80.397264,40.121087],[-80.396828,40.121069],[-80.396376,40.121037],[-80.39546,40.120972],[-80.394858,40.12093],[-80.394494,40.120915],[-80.394162,40.12091],[-80.393798,40.120915],[-80.393432,40.120931],[-80.393121,40.120957],[-80.392836,40.120985],[-80.392497,40.121031],[-80.3921,40.121103],[-80.391613,40.121205],[-80.391079,40.121332],[-80.388245,40.122014],[-80.383823,40.123074],[-80.37863,40.124323],[-80.377137,40.124683],[-80.376664,40.124784],[-80.376288,40.12485],[-80.375915,40.124903],[-80.375618,40.124935],[-80.375258,40.124963],[-80.374962,40.124977],[-80.374571,40.124984],[-80.374146,40.124977],[-80.373778,40.124951],[-80.373426,40.12492],[-80.373157,40.124885],[-80.372755,40.124815],[-80.372381,40.124741],[-80.371935,40.124636],[-80.371034,40.124397],[-80.370518,40.124269],[-80.370107,40.124182],[-80.36976,40.124125],[-80.369352,40.124077],[-80.368953,40.124039],[-80.368635,40.124022],[-80.368368,40.124015],[-80.368109,40.124017],[-80.367899,40.124024],[-80.367697,40.124036],[-80.367503,40.124051],[-80.367066,40.124102],[-80.366784,40.12414],[-80.366549,40.124172],[-80.366203,40.124235],[-80.365896,40.124303],[-80.365639,40.124373],[-80.365337,40.124463],[-80.364911,40.124609],[-80.364632,40.124721],[-80.364265,40.124886],[-80.363936,40.125056],[-80.36369,40.125195],[-80.363437,40.125348],[-80.363097,40.125576],[-80.362714,40.12587],[-80.361848,40.126555],[-80.359719,40.128259],[-80.358258,40.129434],[-80.357947,40.129658],[-80.357698,40.129821],[-80.357351,40.130022],[-80.357065,40.130177],[-80.356665,40.130366],[-80.356264,40.130522],[-80.355876,40.130656],[-80.355563,40.130751],[-80.355235,40.130836],[-80.354753,40.130937],[-80.354392,40.130994],[-80.353988,40.131041],[-80.35361,40.131067],[-80.353224,40.131081],[-80.352906,40.131082],[-80.35248,40.131069],[-80.351997,40.131028],[-80.351612,40.130976],[-80.351287,40.130916],[-80.350862,40.130826],[-80.350306,40.130682],[-80.348928,40.130315],[-80.348354,40.130172],[-80.348,40.130098],[-80.347646,40.130031],[-80.347188,40.129959],[-80.34661,40.129877],[-80.346129,40.12983],[-80.345644,40.129788],[-80.345093,40.129761],[-80.344418,40.129751],[-80.343935,40.129764],[-80.341761,40.12983],[-80.339158,40.129912],[-80.336273,40.130006],[-80.335833,40.130021],[-80.335669,40.130023],[-80.333505,40.130092],[-80.329846,40.130211],[-80.329121,40.130237],[-80.32883,40.130254],[-80.32853,40.130277],[-80.32824,40.13031],[-80.328002,40.130341],[-80.327734,40.130383],[-80.327406,40.130446],[-80.327155,40.1305],[-80.326804,40.130593],[-80.326484,40.130694],[-80.326146,40.130809],[-80.325811,40.130942],[-80.325456,40.131102],[-80.325142,40.131258],[-80.324816,40.131438],[-80.324539,40.131605],[-80.324319,40.131749],[-80.324088,40.131917],[-80.323773,40.132168],[-80.323532,40.132388],[-80.323315,40.132607],[-80.323017,40.13293],[-80.32274,40.133245],[-80.321979,40.134063],[-80.320628,40.13554],[-80.320192,40.135997],[-80.31987,40.136321],[-80.31943,40.136734],[-80.31904,40.137075],[-80.318603,40.137434],[-80.317932,40.137949],[-80.315041,40.14011],[-80.310734,40.143347],[-80.309048,40.144599],[-80.308229,40.145213],[-80.307767,40.145553],[-80.307545,40.145702],[-80.307309,40.145849],[-80.307021,40.14601],[-80.30677,40.146138],[-80.306538,40.146246],[-80.306311,40.146342],[-80.30598,40.146468],[-80.305664,40.146576],[-80.30534,40.146674],[-80.304985,40.14676],[-80.304572,40.146848],[-80.304086,40.146928],[-80.303438,40.147025],[-80.302291,40.147192],[-80.298462,40.147761],[-80.298087,40.147822],[-80.297637,40.147911],[-80.297145,40.148023],[-80.296724,40.14814],[-80.296183,40.148308],[-80.295726,40.148478],[-80.29537,40.148625],[-80.295019,40.148784],[-80.294615,40.148983],[-80.294411,40.149092],[-80.294188,40.149217],[-80.293739,40.149492],[-80.292164,40.150447],[-80.287893,40.153025],[-80.286325,40.153982],[-80.28515,40.154696],[-80.284714,40.154957],[-80.284422,40.155159],[-80.284156,40.155351],[-80.283835,40.155591],[-80.283479,40.155883],[-80.283216,40.156107],[-80.282902,40.156393],[-80.282601,40.156687],[-80.282226,40.157089],[-80.28189,40.157472],[-80.281406,40.158032],[-80.279589,40.160107],[-80.278443,40.161463],[-80.278101,40.161902],[-80.277893,40.162191],[-80.277707,40.162473],[-80.277478,40.162836],[-80.277262,40.163238],[-80.277096,40.163599],[-80.276897,40.164069],[-80.276176,40.165771],[-80.275631,40.16707],[-80.275334,40.167764],[-80.275187,40.168056],[-80.274998,40.168381],[-80.274765,40.168724],[-80.274511,40.169054],[-80.274287,40.169318],[-80.273912,40.169769],[-80.272748,40.171155],[-80.270746,40.173557],[-80.269765,40.17473],[-80.268089,40.176732],[-80.266628,40.178479],[-80.265723,40.179553],[-80.265282,40.180026],[-80.264987,40.180318],[-80.264572,40.180688],[-80.264343,40.180876],[-80.263892,40.181231],[-80.263594,40.181448],[-80.263128,40.181766],[-80.262777,40.181989],[-80.262328,40.182253],[-80.262021,40.182421],[-80.261797,40.182539],[-80.261385,40.182744],[-80.260974,40.182931],[-80.260662,40.183063],[-80.260321,40.183201],[-80.259933,40.183334],[-80.259526,40.183463],[-80.259058,40.183603],[-80.258694,40.183713],[-80.258104,40.183882],[-80.257608,40.184021],[-80.25726,40.184122],[-80.256951,40.18423],[-80.256519,40.184397],[-80.256152,40.184558],[-80.255839,40.184719],[-80.255471,40.184926],[-80.254718,40.185403],[-80.25349,40.186192],[-80.252898,40.186552],[-80.252479,40.186789],[-80.252043,40.187031],[-80.251545,40.187266],[-80.2511,40.187454],[-80.250667,40.187639],[-80.250157,40.187816],[-80.24976,40.187941],[-80.24938,40.188044],[-80.248896,40.188163],[-80.248613,40.188222],[-80.248285,40.188285],[-80.247906,40.188348],[-80.247507,40.188403],[-80.247178,40.188441],[-80.246788,40.188474],[-80.246129,40.188506],[-80.245741,40.188516],[-80.245224,40.188509],[-80.244759,40.188486],[-80.244402,40.188462],[-80.243925,40.188414],[-80.243504,40.188358],[-80.243097,40.188292],[-80.242691,40.188216],[-80.242265,40.188124],[-80.241738,40.187997],[-80.241011,40.187821],[-80.240518,40.187708],[-80.239775,40.187494],[-80.239342,40.187364],[-80.238732,40.187183],[-80.238199,40.187014],[-80.237742,40.186889],[-80.237106,40.18673],[-80.236561,40.186598],[-80.23578,40.186416],[-80.23486,40.186194],[-80.234503,40.186111],[-80.234079,40.186018],[-80.233598,40.185932],[-80.232623,40.18577],[-80.232201,40.185699],[-80.231942,40.18565],[-80.231683,40.185594],[-80.230891,40.185392],[-80.230421,40.185252],[-80.229904,40.185075],[-80.229336,40.184853],[-80.228937,40.184675],[-80.228412,40.184416],[-80.228251,40.184328],[-80.227817,40.184063],[-80.227237,40.183694],[-80.227037,40.183584],[-80.226513,40.183189],[-80.226157,40.182881],[-80.225924,40.182667],[-80.225701,40.182452],[-80.225556,40.182302],[-80.225435,40.182166],[-80.225348,40.18207],[-80.22502,40.18165],[-80.22481,40.181375],[-80.224569,40.181013],[-80.224422,40.18078],[-80.224203,40.180398],[-80.224038,40.180097],[-80.223877,40.179787],[-80.223643,40.179399],[-80.223411,40.178964],[-80.223176,40.17852],[-80.222967,40.17816],[-80.222842,40.177954],[-80.222681,40.177729],[-80.222505,40.177502],[-80.22236,40.177334],[-80.222113,40.177076],[-80.221908,40.176875],[-80.22166,40.176653],[-80.221427,40.176464],[-80.221201,40.176293],[-80.220916,40.176107],[-80.220707,40.175982],[-80.220376,40.175799],[-80.219989,40.175613],[-80.219566,40.175429],[-80.219155,40.175276],[-80.218584,40.175087],[-80.217349,40.174669],[-80.211914,40.172844],[-80.209092,40.171901],[-80.208548,40.171713],[-80.208124,40.171556],[-80.207719,40.171379],[-80.207341,40.171186],[-80.20691,40.170939],[-80.206606,40.170747],[-80.206291,40.170522],[-80.205896,40.17019],[-80.205639,40.169942],[-80.205354,40.169637],[-80.20505,40.169257],[-80.204457,40.168501],[-80.204155,40.1681],[-80.203786,40.167629],[-80.203364,40.167103],[-80.202988,40.166636],[-80.202475,40.166009],[-80.202188,40.16567],[-80.201938,40.165409],[-80.201744,40.165217],[-80.20156,40.165047],[-80.201353,40.164869],[-80.201109,40.164671],[-80.200871,40.164491],[-80.200538,40.164253],[-80.200212,40.164043],[-80.199974,40.163895],[-80.19975,40.163769],[-80.19944,40.1636],[-80.199099,40.163435],[-80.198717,40.163262],[-80.198315,40.163103],[-80.198019,40.162991],[-80.197703,40.162884],[-80.197392,40.162786],[-80.196994,40.162677],[-80.196674,40.162598],[-80.196418,40.162498],[-80.196017,40.162408],[-80.194938,40.162162],[-80.194772,40.162107],[-80.194635,40.162051],[-80.194506,40.161984],[-80.194394,40.161914],[-80.194278,40.161828],[-80.194182,40.16174],[-80.194088,40.161635],[-80.194026,40.161551],[-80.193959,40.161444],[-80.1939,40.161332],[-80.193841,40.161186],[-80.193806,40.161078],[-80.193777,40.160942],[-80.193761,40.160838],[-80.193776,40.160635],[-80.19382,40.160319],[-80.19386,40.1601],[-80.194074,40.159506],[-80.194332,40.159033],[-80.194495,40.158763],[-80.194741,40.158451],[-80.195063,40.158086],[-80.195348,40.157799],[-80.195911,40.157336],[-80.196404,40.156934],[-80.198791,40.155032],[-80.200251,40.153867],[-80.20171,40.152699],[-80.202588,40.152014],[-80.203619,40.151165],[-80.204124,40.15076],[-80.204429,40.150485],[-80.204714,40.150185],[-80.204955,40.14989],[-80.205234,40.149517],[-80.205492,40.149095],[-80.20569,40.148709],[-80.205851,40.148279],[-80.205964,40.147877],[-80.206039,40.147451],[-80.206087,40.147069],[-80.206125,40.146727],[-80.206194,40.146097],[-80.206473,40.143485],[-80.206634,40.142001],[-80.206747,40.140971],[-80.207004,40.138486],[-80.207128,40.137473],[-80.207192,40.137092],[-80.207332,40.136469],[-80.20753,40.135849],[-80.208249,40.134082],[-80.208598,40.133233],[-80.208973,40.132273],[-80.209327,40.131403],[-80.209633,40.130649],[-80.209772,40.130214],[-80.20988,40.129791],[-80.209939,40.129431],[-80.20996,40.129119],[-80.20996,40.128811],[-80.209949,40.128426],[-80.209912,40.12813],[-80.209848,40.127802],[-80.209772,40.127515],[-80.209692,40.12724],[-80.209622,40.12706],[-80.209494,40.126748],[-80.209343,40.126432],[-80.209193,40.126157],[-80.209021,40.125895],[-80.208814,40.125628],[-80.208407,40.125119],[-80.208072,40.124677],[-80.207804,40.124344],[-80.207509,40.123959],[-80.207273,40.123639],[-80.207021,40.123294],[-80.206768,40.122942],[-80.206554,40.122609],[-80.206334,40.122261],[-80.206146,40.121961],[-80.205932,40.121612],[-80.205722,40.12126],[-80.20562,40.121075],[-80.205352,40.120566],[-80.20503,40.119979],[-80.204677,40.119325],[-80.204294,40.118622],[-80.204013,40.118056],[-80.203818,40.117564],[-80.203668,40.117129],[-80.203507,40.116727],[-80.203314,40.116136],[-80.203142,40.115537],[-80.203035,40.114946],[-80.202927,40.114224],[-80.202852,40.113478],[-80.202791,40.112762],[-80.202802,40.112164],[-80.202831,40.111567],[-80.202874,40.111],[-80.202874,40.110376],[-80.202874,40.109506],[-80.202863,40.109121],[-80.202777,40.108653],[-80.202637,40.108191],[-80.20253,40.107847],[-80.202445,40.10752],[-80.202273,40.107135],[-80.201962,40.106529],[-80.20159,40.105985],[-80.201279,40.105603],[-80.200746,40.10503],[-80.200434,40.104728],[-80.199969,40.104342],[-80.199328,40.103872],[-80.198682,40.103392],[-80.198067,40.102974],[-80.197552,40.102589],[-80.196941,40.102121],[-80.196382,40.101641],[-80.195845,40.10114],[-80.19547,40.100713],[-80.19525,40.100402],[-80.195116,40.100213],[-80.194762,40.099696],[-80.194472,40.099179],[-80.194096,40.098465],[-80.19386,40.097989],[-80.193646,40.097414],[-80.193528,40.097078],[-80.193421,40.096692],[-80.193378,40.096413],[-80.193313,40.095838],[-80.193303,40.095247],[-80.193313,40.094451],[-80.193335,40.093852],[-80.193399,40.093081],[-80.193485,40.091899],[-80.193528,40.091209],[-80.19356,40.09052],[-80.19356,40.089929],[-80.193463,40.089166],[-80.193388,40.088205],[-80.193303,40.087138],[-80.193249,40.086457],[-80.193142,40.085127],[-80.193002,40.083502],[-80.192906,40.082213],[-80.192745,40.081006],[-80.192723,40.080538],[-80.19268,40.080112],[-80.192627,40.079644],[-80.192519,40.079209],[-80.192358,40.078765],[-80.192026,40.077854],[-80.191704,40.07691],[-80.19106,40.075161],[-80.190674,40.074069],[-80.190363,40.073191],[-80.189944,40.07205],[-80.189601,40.071147],[-80.189279,40.070235],[-80.188539,40.068232],[-80.188035,40.066795],[-80.18782,40.066171],[-80.187648,40.065506],[-80.187509,40.064554],[-80.187412,40.063659],[-80.18723,40.062189],[-80.187123,40.061696],[-80.186994,40.060883],[-80.186876,40.060177],[-80.186779,40.059758],[-80.186565,40.058921],[-80.186264,40.057853],[-80.186007,40.056933],[-80.185803,40.056227],[-80.185417,40.054995],[-80.184998,40.053443],[-80.184644,40.052014],[-80.184305,40.051038],[-80.184247,40.050873],[-80.184001,40.049887],[-80.183689,40.048787],[-80.183486,40.048105],[-80.183325,40.047555],[-80.183196,40.046848],[-80.182917,40.046068],[-80.182659,40.045329],[-80.182198,40.044237],[-80.181683,40.043136],[-80.181222,40.042142],[-80.180868,40.041206],[-80.180438,40.040142],[-80.180275,40.039753],[-80.179913,40.038939],[-80.179462,40.037904],[-80.179001,40.036795],[-80.178411,40.035464],[-80.178025,40.034552],[-80.177574,40.033492],[-80.177091,40.032318],[-80.176726,40.031513],[-80.176329,40.030593],[-80.176029,40.029763],[-80.175675,40.028917],[-80.175407,40.028317],[-80.175147,40.027689],[-80.174974,40.027208],[-80.174842,40.026785],[-80.174722,40.026347],[-80.174624,40.025895],[-80.174547,40.025446],[-80.174508,40.025104],[-80.174473,40.024779],[-80.174447,40.02427],[-80.174451,40.023766],[-80.174475,40.023355],[-80.174524,40.022844],[-80.174589,40.02243],[-80.174685,40.021936],[-80.174769,40.021589],[-80.174952,40.020933],[-80.175208,40.020042],[-80.17577,40.01808],[-80.175998,40.017288],[-80.176391,40.015873],[-80.17649,40.015566],[-80.17663,40.015097],[-80.176769,40.014686],[-80.176962,40.014243],[-80.177156,40.013815],[-80.17737,40.013405],[-80.177703,40.012862],[-80.178046,40.012369],[-80.178497,40.011843],[-80.178861,40.011432],[-80.179205,40.011071],[-80.179527,40.010759],[-80.180535,40.010012],[-80.181383,40.009429],[-80.182735,40.008583],[-80.18414,40.007769],[-80.185321,40.00712],[-80.185621,40.006964],[-80.1859,40.006791],[-80.186426,40.006364],[-80.186769,40.00606],[-80.187134,40.005673],[-80.187477,40.005271],[-80.187788,40.004778],[-80.188003,40.00435],[-80.188325,40.003627],[-80.188528,40.003101],[-80.188614,40.002822],[-80.188722,40.002452],[-80.188818,40.002074],[-80.188915,40.001433],[-80.188958,40.000611],[-80.188958,40.000101],[-80.188904,39.999723],[-80.188797,39.99891],[-80.1887,39.998367],[-80.188517,39.997783],[-80.188346,39.997241],[-80.18811,39.996715],[-80.187745,39.995844],[-80.187338,39.995014],[-80.18678,39.993888],[-80.186243,39.992803],[-80.185428,39.991036],[-80.184419,39.988865],[-80.183668,39.987287],[-80.183132,39.986071],[-80.182531,39.984895],[-80.181887,39.983555],[-80.181576,39.982947],[-80.181254,39.982157],[-80.18075,39.981122],[-80.180278,39.980135],[-80.179763,39.978976],[-80.179602,39.978581],[-80.17943,39.978154],[-80.179012,39.977299],[-80.178508,39.976263],[-80.178003,39.975194],[-80.177596,39.974306],[-80.177049,39.973081],[-80.17648,39.971848],[-80.176062,39.970943],[-80.175772,39.970392],[-80.175407,39.969644],[-80.174978,39.96874],[-80.174581,39.967876],[-80.17427,39.96707],[-80.173937,39.966191],[-80.173798,39.965763],[-80.173626,39.96522],[-80.173443,39.964636],[-80.17336,39.964334],[-80.173196,39.963727],[-80.173025,39.963066],[-80.172832,39.962285],[-80.172618,39.961364],[-80.172435,39.960706],[-80.172285,39.960369],[-80.172113,39.959949],[-80.171902,39.959564],[-80.171856,39.95948],[-80.171717,39.959258],[-80.171351,39.958721],[-80.170858,39.958091],[-80.170483,39.957581],[-80.169826,39.956707],[-80.169399,39.956125],[-80.166363,39.952186],[-80.166009,39.951725],[-80.165708,39.951281],[-80.165472,39.950853],[-80.165354,39.9505],[-80.165268,39.950113],[-80.165247,39.949718],[-80.165268,39.949315],[-80.165333,39.948953],[-80.165483,39.948591],[-80.16574,39.948049],[-80.166052,39.947522],[-80.16897,39.942521],[-80.169181,39.942073],[-80.169396,39.941604],[-80.169535,39.941185],[-80.169664,39.940666],[-80.169739,39.940247],[-80.169814,39.939737],[-80.169825,39.939326],[-80.169814,39.938906],[-80.16975,39.938412],[-80.169653,39.937886],[-80.169535,39.937433],[-80.169363,39.936981],[-80.169106,39.936422],[-80.168741,39.935796],[-80.168344,39.935253],[-80.167743,39.934562],[-80.166971,39.933658],[-80.165115,39.931535],[-80.164686,39.931008],[-80.164342,39.930457],[-80.164031,39.929832],[-80.163774,39.929174],[-80.163591,39.928565],[-80.163484,39.927956],[-80.163441,39.927388],[-80.163463,39.92664],[-80.163581,39.925545],[-80.16372,39.924344],[-80.163784,39.923571],[-80.163806,39.92274],[-80.163784,39.92204],[-80.163742,39.92153],[-80.163624,39.920831],[-80.163495,39.920181],[-80.163302,39.919333],[-80.163044,39.918576],[-80.162722,39.91772],[-80.162336,39.91698],[-80.1618,39.916083],[-80.161553,39.9157],[-80.161349,39.915383],[-80.160866,39.914742],[-80.160265,39.914026],[-80.159697,39.913384],[-80.159171,39.912874],[-80.158291,39.912117],[-80.157583,39.911573],[-80.156403,39.910726],[-80.155223,39.909903],[-80.15386,39.908965],[-80.152605,39.908068],[-80.151886,39.907442],[-80.151124,39.906677],[-80.150191,39.905536],[-80.148217,39.903201],[-80.147158,39.901944],[-80.146417,39.901057],[-80.145701,39.900225],[-80.145277,39.899756],[-80.144852,39.899298],[-80.144197,39.89863],[-80.143392,39.897835],[-80.142618,39.897139],[-80.141343,39.896018],[-80.139942,39.894785],[-80.138211,39.893266],[-80.136406,39.891667],[-80.135992,39.891288],[-80.135663,39.890945],[-80.135479,39.890742],[-80.135117,39.890336],[-80.134925,39.890088],[-80.134755,39.88984],[-80.134312,39.889153],[-80.133883,39.888297],[-80.133615,39.88763],[-80.133379,39.886856],[-80.133218,39.88614],[-80.133164,39.885448],[-80.133175,39.884666],[-80.133261,39.883547],[-80.133359,39.882458],[-80.133434,39.88124],[-80.133531,39.880252],[-80.133541,39.878918],[-80.133509,39.878284],[-80.133413,39.877469],[-80.133338,39.876926],[-80.13323,39.876555],[-80.133046,39.876052],[-80.132938,39.875675],[-80.132587,39.874184],[-80.132029,39.872092],[-80.131642,39.870833],[-80.131278,39.869951],[-80.130816,39.869227],[-80.130537,39.868922],[-80.130012,39.868453],[-80.129035,39.867736],[-80.127791,39.866839],[-80.126997,39.866213],[-80.126632,39.865867],[-80.125956,39.865185],[-80.125702,39.864885],[-80.125532,39.864669],[-80.125403,39.864486],[-80.12529,39.864313],[-80.125157,39.864078],[-80.125008,39.863807],[-80.124882,39.863554],[-80.124735,39.863218],[-80.124557,39.862796],[-80.124223,39.861986],[-80.123585,39.86021],[-80.121675,39.855309],[-80.121321,39.854469],[-80.120903,39.853645],[-80.120409,39.852912],[-80.119712,39.852204],[-80.118403,39.850894],[-80.117759,39.850112],[-80.117191,39.849329],[-80.116751,39.848605],[-80.116343,39.847748],[-80.115603,39.846026],[-80.1152,39.845111],[-80.115045,39.844758],[-80.114541,39.843638],[-80.113639,39.841768],[-80.113307,39.840985],[-80.113039,39.840351],[-80.112845,39.839758],[-80.112577,39.838711],[-80.112438,39.837723],[-80.112234,39.835762],[-80.112052,39.834559],[-80.111891,39.833636],[-80.111676,39.832837],[-80.111268,39.831915],[-80.110871,39.831157],[-80.110485,39.830596],[-80.110035,39.829987],[-80.109595,39.829459],[-80.108575,39.828512],[-80.107063,39.827185],[-80.105807,39.826007],[-80.101634,39.82239],[-80.100969,39.821788],[-80.100475,39.821228],[-80.09996,39.820552],[-80.099413,39.819613],[-80.098694,39.818171],[-80.097675,39.816135],[-80.096602,39.813712],[-80.095561,39.811545],[-80.094956,39.810434],[-80.094645,39.809813],[-80.094461,39.809466],[-80.094264,39.809164],[-80.094071,39.808909],[-80.093792,39.808593],[-80.093582,39.808389],[-80.093349,39.808189],[-80.093096,39.807999],[-80.092816,39.807815],[-80.092391,39.807562],[-80.091382,39.807013],[-80.085794,39.804015],[-80.085026,39.803575],[-80.084264,39.803072],[-80.08347,39.802512],[-80.08244,39.801654],[-80.08141,39.800715],[-80.079361,39.798802],[-80.078942,39.798333],[-80.078384,39.797566],[-80.077934,39.796676],[-80.077515,39.795538],[-80.077333,39.794458],[-80.077279,39.793708],[-80.07729,39.793032],[-80.077462,39.791936],[-80.077805,39.789578],[-80.078181,39.786544],[-80.078343,39.785423],[-80.078472,39.784714],[-80.078601,39.784236],[-80.078794,39.783791],[-80.079363,39.782868],[-80.080307,39.781532],[-80.080424,39.781358],[-80.08094,39.780592],[-80.081315,39.779974],[-80.081616,39.779429],[-80.081863,39.778852],[-80.082023,39.778316],[-80.082152,39.777756],[-80.082217,39.777096],[-80.082238,39.776478],[-80.082141,39.775777],[-80.082002,39.77515],[-80.081959,39.774919],[-80.080822,39.771126],[-80.080715,39.770672],[-80.08065,39.77031],[-80.080629,39.769963],[-80.080618,39.769254],[-80.080661,39.768693],[-80.0808,39.76777],[-80.080983,39.76692],[-80.08212,39.76137],[-80.082206,39.760809],[-80.08226,39.760215],[-80.082238,39.759498],[-80.082109,39.758986],[-80.081884,39.758417],[-80.081616,39.757939],[-80.080146,39.755926],[-80.07953,39.755115],[-80.07785,39.752908],[-80.076841,39.751621],[-80.076112,39.750829],[-80.075479,39.750235],[-80.074621,39.749509],[-80.073397,39.748627],[-80.072013,39.74776],[-80.069932,39.746515],[-80.067979,39.745343],[-80.063763,39.742849],[-80.062409,39.742035],[-80.05986,39.740501],[-80.059379,39.740182],[-80.059066,39.739929],[-80.058793,39.739688],[-80.058546,39.739419],[-80.058257,39.73904],[-80.058078,39.738744],[-80.057919,39.738444],[-80.057792,39.738122],[-80.05771,39.737847],[-80.057642,39.737503],[-80.057605,39.737186],[-80.057598,39.736825],[-80.057642,39.736428],[-80.057698,39.736132],[-80.057874,39.735445],[-80.058106,39.734578],[-80.058442,39.733278],[-80.058598,39.732695],[-80.059267,39.730185],[-80.059937,39.72764],[-80.061274,39.722569],[-80.061657,39.721095],[-80.061757,39.720669],[-80.06181,39.720387],[-80.061856,39.720016],[-80.061874,39.719726],[-80.061869,39.71934],[-80.061827,39.718925],[-80.061776,39.718608],[-80.06167,39.718157],[-80.061517,39.717718],[-80.06131,39.717258],[-80.061073,39.716851],[-80.060894,39.716577],[-80.060523,39.716088],[-80.059881,39.715319],[-80.059162,39.714498],[-80.058518,39.713743],[-80.057335,39.712232],[-80.056842,39.711646],[-80.056509,39.711176],[-80.056166,39.710556],[-80.055919,39.70997],[-80.055715,39.709063],[-80.055511,39.70799],[-80.055318,39.707371],[-80.055093,39.706727],[-80.054664,39.705835],[-80.054181,39.705018],[-80.053569,39.704184],[-80.053022,39.703565],[-80.052357,39.702946],[-80.050112,39.701174],[-80.046134,39.698035],[-80.045737,39.69768],[-80.045373,39.6973],[-80.044911,39.696764],[-80.044568,39.696293],[-80.044218,39.695734],[-80.04401,39.695401],[-80.043688,39.694807],[-80.043431,39.694237],[-80.043141,39.69342],[-80.042916,39.692743],[-80.042723,39.692116],[-80.042497,39.691505],[-80.042347,39.691109],[-80.042143,39.690646],[-80.041939,39.690316],[-80.041575,39.689837],[-80.041103,39.689226],[-80.040566,39.688524],[-80.040255,39.688079],[-80.040019,39.687641],[-80.039837,39.687179],[-80.039697,39.686758],[-80.039611,39.686394],[-80.039558,39.68599],[-80.039536,39.685115],[-80.039515,39.684016],[-80.039504,39.683257],[-80.039483,39.682679],[-80.039429,39.682249],[-80.039268,39.681498],[-80.039075,39.680813],[-80.03885,39.680243],[-80.038549,39.679615],[-80.038141,39.678897],[-80.037669,39.67817],[-80.037047,39.677452],[-80.036285,39.676684],[-80.035824,39.676304],[-80.035427,39.675982],[-80.035019,39.675677],[-80.034386,39.675264],[-80.033496,39.674744],[-80.032616,39.674298],[-80.03179,39.673885],[-80.031125,39.673464],[-80.03047,39.672935],[-80.02988,39.672324],[-80.029591,39.671969],[-80.029333,39.671556],[-80.029022,39.671011],[-80.028754,39.670532],[-80.028485,39.670152],[-80.028164,39.669756],[-80.027799,39.669409],[-80.027284,39.669012],[-80.026672,39.668649],[-80.025868,39.668302],[-80.024966,39.66798],[-80.022252,39.667022],[-80.020825,39.666485],[-80.016147,39.6648],[-80.014677,39.664247],[-80.013948,39.66395],[-80.013283,39.663586],[-80.01266,39.663132],[-80.012178,39.662678],[-80.011834,39.662273],[-80.01148,39.66172],[-80.011223,39.661034],[-80.011126,39.660638],[-80.011087,39.660036],[-80.011073,39.659812],[-80.011038,39.659259],[-80.010879,39.656747],[-80.010837,39.656318],[-80.010751,39.655822],[-80.010649,39.655482],[-80.010558,39.655186],[-80.0103,39.6546],[-80.010064,39.654096],[-80.009517,39.65322],[-80.00839,39.651643],[-80.008133,39.651263],[-80.0078,39.650701],[-80.007543,39.650164],[-80.007307,39.649602],[-80.007103,39.648875],[-80.006953,39.648024],[-80.006727,39.64619],[-80.00662,39.64534],[-80.006534,39.644761],[-80.006363,39.644175],[-80.006159,39.643687],[-80.005923,39.643274],[-80.005644,39.642886],[-80.005268,39.642473],[-80.004927,39.642162],[-80.004206,39.641506],[-79.998554,39.636762],[-79.997391,39.635799],[-79.992147,39.631352],[-79.991074,39.630468],[-79.990804,39.630213],[-79.990355,39.62979],[-79.989851,39.629228],[-79.989196,39.628336],[-79.988764,39.627511],[-79.988659,39.627274],[-79.988562,39.626985],[-79.988345,39.626256],[-79.988177,39.625534],[-79.988113,39.624931],[-79.988102,39.62422],[-79.988166,39.623659],[-79.988295,39.622931],[-79.988445,39.622345],[-79.988692,39.621642],[-79.990033,39.618427],[-79.992104,39.61322],[-79.99234,39.612642],[-79.992608,39.61203],[-79.992876,39.611328],[-79.993041,39.610765],[-79.99318,39.610225],[-79.993295,39.609653],[-79.9934,39.608923],[-79.993456,39.608121],[-79.993467,39.607658],[-79.993424,39.607129],[-79.993393,39.606782],[-79.993346,39.606474],[-79.993267,39.60598],[-79.993127,39.605332],[-79.992889,39.604487],[-79.992694,39.603847],[-79.992437,39.603161],[-79.992083,39.60245],[-79.991632,39.601706],[-79.991149,39.600979],[-79.990699,39.600417],[-79.990184,39.599805],[-79.989626,39.599218],[-79.988939,39.598581],[-79.988199,39.597978],[-79.987662,39.597598],[-79.987008,39.597143],[-79.985527,39.596291],[-79.982943,39.594866],[-79.981676,39.594167],[-79.981332,39.593968],[-79.980978,39.593704],[-79.980452,39.593208],[-79.980163,39.592836],[-79.979927,39.592472],[-79.979701,39.59205],[-79.979573,39.591686],[-79.979498,39.591331],[-79.979465,39.590934],[-79.979375,39.590289],[-79.979181,39.588125],[-79.979293,39.585994],[-79.979256,39.584848],[-79.979253,39.584467],[-79.979229,39.583825],[-79.97922,39.583448],[-79.979226,39.582926],[-79.979203,39.582063],[-79.97917,39.581356],[-79.979135,39.581039],[-79.979075,39.580752],[-79.979007,39.580544],[-79.978897,39.580289],[-79.97878,39.580087],[-79.978693,39.579962],[-79.978568,39.579798],[-79.97842,39.579638],[-79.978275,39.579506],[-79.978072,39.579333],[-79.977839,39.579172],[-79.977517,39.578984],[-79.977233,39.578861],[-79.976937,39.578753],[-79.976691,39.578682],[-79.976434,39.578624],[-79.976171,39.578577],[-79.975931,39.578551],[-79.975521,39.578542],[-79.975326,39.578546],[-79.975099,39.578559],[-79.974637,39.578609],[-79.973857,39.578723],[-79.972192,39.578971],[-79.971641,39.579025],[-79.970385,39.579229],[-79.968931,39.579442],[-79.968192,39.579554],[-79.967832,39.579615],[-79.967414,39.579696],[-79.966831,39.579815],[-79.966328,39.57993],[-79.965843,39.580056],[-79.965239,39.580221],[-79.964664,39.580393],[-79.963598,39.580735],[-79.962427,39.581116],[-79.96161,39.581383],[-79.9609,39.581628],[-79.959269,39.582156],[-79.958661,39.58237],[-79.958181,39.582518],[-79.957374,39.582787],[-79.956047,39.583217],[-79.954655,39.583664],[-79.953209,39.584136],[-79.948033,39.585802],[-79.945659,39.586568],[-79.943348,39.587309],[-79.940504,39.588227],[-79.937566,39.589171],[-79.935865,39.589739],[-79.935488,39.589873],[-79.935203,39.589984],[-79.934894,39.590115],[-79.934474,39.590316],[-79.934076,39.590525],[-79.933756,39.590712],[-79.933488,39.59088],[-79.933166,39.591091],[-79.932852,39.591323],[-79.932516,39.591591],[-79.932193,39.591863],[-79.931961,39.592095],[-79.931563,39.592482],[-79.931367,39.592695],[-79.931173,39.592954],[-79.930876,39.593387],[-79.930648,39.593732],[-79.930458,39.594076],[-79.930239,39.594542],[-79.930092,39.594915],[-79.930004,39.595168],[-79.929899,39.595557],[-79.929815,39.59593],[-79.929757,39.59636],[-79.929726,39.596799],[-79.929722,39.597037],[-79.929734,39.59734],[-79.92977,39.597714],[-79.929832,39.598137],[-79.929942,39.598614],[-79.930167,39.599391],[-79.930284,39.599783],[-79.930773,39.60146],[-79.931068,39.602488],[-79.931246,39.603114],[-79.931337,39.603457],[-79.931406,39.603808],[-79.931437,39.604067],[-79.931451,39.604312],[-79.931453,39.604516],[-79.931435,39.60476],[-79.931403,39.605038],[-79.931356,39.605294],[-79.931283,39.605565],[-79.931225,39.605754],[-79.931153,39.605938],[-79.931061,39.606155],[-79.930946,39.606389],[-79.930788,39.606664],[-79.930599,39.606942],[-79.930364,39.607246],[-79.930136,39.60749],[-79.929869,39.607752],[-79.929615,39.607974],[-79.929292,39.608215],[-79.929065,39.608368],[-79.928839,39.608507],[-79.928511,39.608685],[-79.928181,39.608849],[-79.927785,39.609023],[-79.927016,39.609329],[-79.925856,39.609792],[-79.925443,39.609968],[-79.924879,39.610224],[-79.924447,39.610433],[-79.923967,39.610672],[-79.923463,39.610938],[-79.922944,39.611228],[-79.922503,39.611499],[-79.921887,39.61191],[-79.921633,39.612098],[-79.921031,39.612572],[-79.920534,39.612976],[-79.919779,39.613645],[-79.919184,39.614182],[-79.918637,39.614695],[-79.917629,39.615616],[-79.917416,39.615784],[-79.9147,39.618265],[-79.913238,39.619592],[-79.912052,39.620678],[-79.910394,39.622204],[-79.909718,39.622828],[-79.90918,39.623312],[-79.908961,39.623508],[-79.908551,39.623854],[-79.908046,39.624255],[-79.907689,39.624516],[-79.907211,39.624861],[-79.906657,39.625224],[-79.906095,39.62557],[-79.904887,39.626291],[-79.904176,39.626725],[-79.903686,39.627051],[-79.903461,39.627219],[-79.90332,39.627333],[-79.903088,39.627525],[-79.902837,39.627747],[-79.902588,39.627979],[-79.902396,39.628168],[-79.902219,39.628359],[-79.902057,39.628541],[-79.901872,39.62877],[-79.901692,39.629009],[-79.90153,39.629234],[-79.901347,39.629523],[-79.90118,39.629813],[-79.901025,39.630113],[-79.90087,39.630455],[-79.900444,39.631575],[-79.89959,39.633861],[-79.898369,39.63712],[-79.897506,39.639424],[-79.89713,39.640406],[-79.895433,39.644946],[-79.895266,39.645379],[-79.895075,39.645811],[-79.894793,39.646374],[-79.894536,39.646864],[-79.894185,39.647451],[-79.89395,39.647807],[-79.893705,39.648148],[-79.893377,39.648594],[-79.893123,39.648915],[-79.891151,39.651242],[-79.890051,39.652505],[-79.888786,39.653958],[-79.88752,39.655455],[-79.884527,39.658989],[-79.884178,39.659388],[-79.883828,39.65977],[-79.883515,39.660091],[-79.883241,39.660347],[-79.882879,39.660651],[-79.882594,39.66087],[-79.882291,39.661083],[-79.881914,39.661318],[-79.881558,39.661526],[-79.881252,39.661686],[-79.878314,39.663197],[-79.875975,39.664388],[-79.874193,39.665296],[-79.873685,39.665546],[-79.872963,39.665878],[-79.872166,39.666234],[-79.871493,39.666518],[-79.870714,39.66683],[-79.870109,39.667058],[-79.869567,39.667245],[-79.868474,39.667625],[-79.866466,39.668323],[-79.860114,39.670516],[-79.856822,39.67167],[-79.856374,39.671802],[-79.855947,39.67191],[-79.855673,39.671967],[-79.855403,39.672011],[-79.855011,39.67206],[-79.854706,39.672089],[-79.854422,39.672109],[-79.854177,39.672115],[-79.853878,39.67211],[-79.853572,39.672094],[-79.853177,39.672062],[-79.852839,39.672019],[-79.85251,39.671963],[-79.852085,39.67187],[-79.85176,39.671779],[-79.851511,39.671705],[-79.851198,39.671599],[-79.850914,39.671495],[-79.850649,39.671381],[-79.850466,39.671289],[-79.850306,39.671207],[-79.850141,39.671115],[-79.849988,39.671026],[-79.849804,39.670913],[-79.849639,39.670803],[-79.849475,39.670693],[-79.849259,39.670532],[-79.849054,39.670363],[-79.848928,39.670251],[-79.848761,39.670083],[-79.84847,39.669772],[-79.848272,39.669529],[-79.84812,39.669322],[-79.847876,39.668933],[-79.847656,39.668548],[-79.847507,39.668247],[-79.846523,39.666289],[-79.845849,39.664972],[-79.845064,39.663413],[-79.844916,39.663115],[-79.844752,39.662839],[-79.844541,39.66252],[-79.844371,39.662278],[-79.844203,39.662069],[-79.843962,39.661796],[-79.843756,39.66158],[-79.843522,39.661354],[-79.843288,39.661151],[-79.842999,39.66093],[-79.842674,39.660699],[-79.842355,39.660499],[-79.84202,39.660298],[-79.841534,39.660045],[-79.84123,39.659908],[-79.840942,39.659795],[-79.839491,39.659252],[-79.837409,39.658467],[-79.835527,39.657757],[-79.835058,39.657593],[-79.834708,39.657483],[-79.834291,39.657366],[-79.833902,39.657272],[-79.833572,39.657203],[-79.833236,39.657139],[-79.832825,39.657081],[-79.832388,39.657031],[-79.832036,39.657006],[-79.831641,39.656989],[-79.831344,39.656981],[-79.83108,39.656981],[-79.830754,39.656991],[-79.830482,39.657005],[-79.830201,39.657029],[-79.82993,39.657048],[-79.829641,39.657085],[-79.829419,39.657115],[-79.82906,39.657179],[-79.828733,39.657248],[-79.828416,39.657324],[-79.828107,39.657408],[-79.827811,39.657495],[-79.827555,39.657583],[-79.827237,39.657693],[-79.82698,39.657796],[-79.826694,39.657913],[-79.82645,39.658022],[-79.826243,39.658122],[-79.826018,39.658235],[-79.825645,39.658448],[-79.825274,39.658668],[-79.823584,39.659746],[-79.822425,39.660484],[-79.822176,39.660632],[-79.821946,39.660761],[-79.821743,39.660864],[-79.821543,39.660955],[-79.821339,39.661041],[-79.821182,39.661108],[-79.821015,39.661167],[-79.820766,39.661245],[-79.82055,39.661301],[-79.820347,39.661348],[-79.820126,39.661391],[-79.819821,39.661441],[-79.819558,39.661468],[-79.819249,39.661491],[-79.818991,39.661502],[-79.818752,39.661499],[-79.818525,39.661488],[-79.81834,39.661473],[-79.818102,39.661449],[-79.81782,39.661409],[-79.817575,39.661361],[-79.817334,39.661307],[-79.817096,39.661244],[-79.816848,39.661168],[-79.816634,39.661097],[-79.816427,39.661016],[-79.816241,39.660933],[-79.815979,39.660809],[-79.815792,39.660709],[-79.815619,39.660607],[-79.815463,39.660506],[-79.815306,39.660396],[-79.815166,39.660293],[-79.814773,39.659981],[-79.814172,39.659489],[-79.813991,39.659363],[-79.81381,39.659246],[-79.813611,39.659128],[-79.813475,39.659056],[-79.813313,39.658979],[-79.813144,39.658907],[-79.812982,39.658844],[-79.81282,39.658785],[-79.812654,39.658733],[-79.8125,39.658689],[-79.812325,39.658648],[-79.812146,39.658611],[-79.811946,39.658577],[-79.811754,39.658554],[-79.81155,39.658534],[-79.81138,39.658524],[-79.811227,39.65852],[-79.811045,39.658522],[-79.810854,39.658532],[-79.810671,39.658547],[-79.810482,39.658571],[-79.81032,39.658594],[-79.810136,39.658626],[-79.809959,39.658668],[-79.809786,39.658711],[-79.809622,39.658761],[-79.80943,39.658827],[-79.809236,39.658896],[-79.809057,39.658968],[-79.808886,39.659042],[-79.8087,39.659127],[-79.807925,39.659505],[-79.807132,39.659891],[-79.806911,39.659996],[-79.806725,39.660081],[-79.806471,39.660184],[-79.8063,39.660249],[-79.806077,39.660322],[-79.805858,39.660388],[-79.805633,39.660448],[-79.805403,39.660499],[-79.805082,39.660561],[-79.804744,39.660604],[-79.804493,39.66063],[-79.804276,39.660646],[-79.804048,39.660656],[-79.802839,39.660697],[-79.799255,39.66083],[-79.798295,39.660863],[-79.797934,39.660875],[-79.79771,39.660875],[-79.797453,39.660864],[-79.797174,39.660846],[-79.796954,39.660822],[-79.796742,39.660782],[-79.796569,39.660746],[-79.796423,39.660712],[-79.796228,39.660655],[-79.796049,39.660599],[-79.795893,39.660541],[-79.795744,39.660481],[-79.795555,39.660396],[-79.795389,39.660312],[-79.795211,39.660209],[-79.794987,39.660072],[-79.794306,39.659649],[-79.794065,39.659501],[-79.793611,39.659242],[-79.793287,39.659068],[-79.792978,39.658916],[-79.792674,39.658775],[-79.792389,39.65865],[-79.792077,39.658527],[-79.791866,39.65845],[-79.791632,39.658369],[-79.791346,39.658276],[-79.791026,39.658181],[-79.790734,39.658104],[-79.790435,39.658036],[-79.790073,39.657955],[-79.789774,39.657895],[-79.789485,39.657853],[-79.78906,39.657797],[-79.788633,39.657749],[-79.788274,39.657726],[-79.787944,39.657717],[-79.787573,39.65771],[-79.787217,39.657711],[-79.786899,39.657725],[-79.78665,39.657742],[-79.786337,39.657765],[-79.78593,39.657806],[-79.785649,39.657844],[-79.785356,39.657889],[-79.784743,39.657987],[-79.784221,39.658081],[-79.783284,39.658231],[-79.782935,39.658288],[-79.782563,39.658347],[-79.782256,39.658388],[-79.78195,39.658416],[-79.781639,39.658434],[-79.781308,39.658439],[-79.780881,39.658426],[-79.780588,39.6584],[-79.780351,39.658372],[-79.780047,39.658321],[-79.779795,39.65827],[-79.779502,39.658198],[-79.779239,39.658117],[-79.778946,39.658018],[-79.778618,39.657893],[-79.775809,39.656741],[-79.774089,39.65602],[-79.773657,39.655854],[-79.773306,39.655723],[-79.773014,39.655624],[-79.772738,39.655543],[-79.772428,39.655465],[-79.772217,39.655415],[-79.771932,39.655363],[-79.771651,39.655322],[-79.771442,39.655299],[-79.771199,39.655281],[-79.770971,39.655271],[-79.770676,39.65527],[-79.770319,39.655274],[-79.769107,39.65532],[-79.765686,39.655465],[-79.763058,39.655576],[-79.761989,39.655617],[-79.761545,39.655631],[-79.761118,39.655631],[-79.760651,39.655615],[-79.760336,39.655592],[-79.759857,39.655548],[-79.759428,39.655486],[-79.759002,39.655412],[-79.756299,39.654848],[-79.755858,39.654771],[-79.755513,39.654718],[-79.755084,39.654666],[-79.75463,39.654628],[-79.754049,39.654604],[-79.753586,39.654596],[-79.752728,39.654604],[-79.751499,39.654619],[-79.750457,39.654631],[-79.749513,39.654604],[-79.74876,39.654566],[-79.747802,39.654506],[-79.741896,39.654153],[-79.74138,39.65412],[-79.737295,39.65386],[-79.736772,39.653823],[-79.736105,39.653748],[-79.735531,39.653673],[-79.734892,39.653574],[-79.734202,39.653448],[-79.733632,39.65333],[-79.733026,39.653197],[-79.732529,39.653066],[-79.732106,39.652949],[-79.731639,39.652807],[-79.729281,39.652115],[-79.726085,39.651153],[-79.724861,39.650784],[-79.724364,39.650629],[-79.724043,39.650543],[-79.723608,39.650443],[-79.723134,39.650344],[-79.722786,39.650281],[-79.722401,39.650212],[-79.721981,39.650151],[-79.721593,39.650108],[-79.721233,39.650076],[-79.720897,39.650055],[-79.72057,39.650038],[-79.720168,39.650025],[-79.719835,39.65002],[-79.719388,39.650028],[-79.718928,39.650042],[-79.718572,39.650062],[-79.717014,39.650179],[-79.716102,39.65025],[-79.715736,39.650266],[-79.715357,39.650279],[-79.715029,39.650281],[-79.714619,39.650272],[-79.714256,39.650252],[-79.713828,39.650215],[-79.713486,39.650179],[-79.713229,39.650148],[-79.712921,39.650095],[-79.712578,39.650033],[-79.712187,39.649946],[-79.711865,39.649866],[-79.71148,39.64976],[-79.709516,39.64915],[-79.708992,39.649002],[-79.70866,39.648915],[-79.708373,39.64885],[-79.708045,39.648787],[-79.707734,39.648744],[-79.707489,39.648718],[-79.707187,39.648694],[-79.706853,39.64868],[-79.706523,39.648681],[-79.706158,39.6487],[-79.705821,39.648735],[-79.705501,39.648779],[-79.705168,39.648836],[-79.704862,39.648901],[-79.704536,39.648983],[-79.70414,39.649105],[-79.703859,39.649207],[-79.703568,39.64933],[-79.703278,39.649471],[-79.702948,39.649645],[-79.702603,39.649852],[-79.702261,39.650094],[-79.701891,39.650393],[-79.701088,39.651094],[-79.699925,39.652125],[-79.699349,39.652609],[-79.699106,39.652806],[-79.698715,39.653071],[-79.698358,39.653309],[-79.697977,39.653532],[-79.697548,39.653755],[-79.697156,39.653937],[-79.696705,39.65413],[-79.696333,39.654275],[-79.695923,39.654416],[-79.6954,39.654565],[-79.69483,39.654709],[-79.692895,39.655114],[-79.689986,39.65572],[-79.688726,39.655972],[-79.688009,39.656133],[-79.687468,39.65626],[-79.686915,39.656412],[-79.68622,39.656626],[-79.685677,39.656803],[-79.685189,39.656975],[-79.684826,39.657112],[-79.68434,39.657314],[-79.683849,39.657529],[-79.683238,39.657817],[-79.682734,39.658068],[-79.682166,39.658364],[-79.681648,39.658644],[-79.681045,39.659011],[-79.679398,39.660081],[-79.67777,39.661144],[-79.677382,39.661387],[-79.676965,39.661628],[-79.676608,39.661826],[-79.676219,39.66201],[-79.675794,39.662193],[-79.675444,39.662331],[-79.675107,39.662449],[-79.674682,39.662586],[-79.674192,39.662721],[-79.673763,39.662816],[-79.673423,39.662885],[-79.673078,39.662942],[-79.67265,39.663],[-79.672222,39.663041],[-79.671838,39.663068],[-79.671333,39.663084],[-79.670931,39.663086],[-79.670414,39.66307],[-79.669964,39.663033],[-79.669689,39.663009],[-79.669286,39.662958],[-79.668968,39.662907],[-79.668669,39.66285],[-79.66829,39.662774],[-79.667871,39.662669],[-79.667583,39.662591],[-79.667261,39.662489],[-79.666888,39.662361],[-79.666471,39.662205],[-79.666055,39.662028],[-79.665636,39.661824],[-79.665118,39.661547],[-79.664638,39.661256],[-79.662962,39.660166],[-79.662539,39.659906],[-79.662035,39.659596],[-79.661428,39.659265],[-79.661022,39.659052],[-79.660703,39.658892],[-79.660325,39.65871],[-79.6599,39.658514],[-79.659501,39.658341],[-79.659007,39.658148],[-79.658482,39.65795],[-79.657979,39.65777],[-79.657582,39.657635],[-79.657219,39.657521],[-79.656763,39.657387],[-79.656376,39.657278],[-79.655832,39.657141],[-79.655286,39.657018],[-79.65477,39.656905],[-79.654296,39.656816],[-79.653873,39.656747],[-79.653382,39.656671],[-79.651386,39.656394],[-79.648884,39.656035],[-79.646357,39.655679],[-79.643952,39.655346],[-79.642199,39.655094],[-79.641203,39.654957],[-79.640754,39.654888],[-79.640157,39.654805],[-79.639708,39.654747],[-79.63926,39.654695],[-79.638899,39.654661],[-79.638532,39.654631],[-79.638225,39.654614],[-79.637901,39.654603],[-79.637583,39.654605],[-79.637252,39.654611],[-79.636931,39.654627],[-79.636663,39.654645],[-79.636374,39.654671],[-79.636087,39.654704],[-79.635793,39.654744],[-79.635271,39.654833],[-79.635,39.654887],[-79.634729,39.654948],[-79.634457,39.655015],[-79.634131,39.655104],[-79.63379,39.655209],[-79.633512,39.655302],[-79.633272,39.655387],[-79.633032,39.655482],[-79.632716,39.655609],[-79.63239,39.655755],[-79.632055,39.655918],[-79.631722,39.656084],[-79.631409,39.656272],[-79.630746,39.65668],[-79.629934,39.657221],[-79.628676,39.658047],[-79.627514,39.658814],[-79.625691,39.660023],[-79.624915,39.660524],[-79.624567,39.660737],[-79.624379,39.660844],[-79.624098,39.660997],[-79.62385,39.661115],[-79.623557,39.661249],[-79.623288,39.661364],[-79.623077,39.661448],[-79.622847,39.661534],[-79.622635,39.661607],[-79.622361,39.661693],[-79.622078,39.661775],[-79.621788,39.661849],[-79.621566,39.661905],[-79.621316,39.661965],[-79.621077,39.662019],[-79.620839,39.662068],[-79.620605,39.662109],[-79.620372,39.662145],[-79.620116,39.662177],[-79.619897,39.662203],[-79.619702,39.662222],[-79.619499,39.66224],[-79.619232,39.662255],[-79.618979,39.662264],[-79.618694,39.662271],[-79.618441,39.662275],[-79.618223,39.662272],[-79.617984,39.662265],[-79.617768,39.662256],[-79.617388,39.662229],[-79.617057,39.662198],[-79.616596,39.662142],[-79.613136,39.661705],[-79.611195,39.661449],[-79.610663,39.661386],[-79.610299,39.661349],[-79.610046,39.661325],[-79.609729,39.661298],[-79.609361,39.661274],[-79.609052,39.661258],[-79.608666,39.661247],[-79.608291,39.661236],[-79.607863,39.661229],[-79.607561,39.661226],[-79.607126,39.661239],[-79.606703,39.661265],[-79.60627,39.661285],[-79.605951,39.661306],[-79.605457,39.661343],[-79.605137,39.661377],[-79.604728,39.661417],[-79.604307,39.661464],[-79.603942,39.66151],[-79.603585,39.661564],[-79.603151,39.661638],[-79.602724,39.661717],[-79.60221,39.661829],[-79.600698,39.662179],[-79.599173,39.662538],[-79.598241,39.662762],[-79.597783,39.662861],[-79.597378,39.66294],[-79.596957,39.663009],[-79.596473,39.663081],[-79.595998,39.663135],[-79.595586,39.663174],[-79.595196,39.663204],[-79.594853,39.663225],[-79.594328,39.663242],[-79.593743,39.66325],[-79.593285,39.663242],[-79.592948,39.66323],[-79.592561,39.663209],[-79.592141,39.663176],[-79.591655,39.663132],[-79.591273,39.663085],[-79.590894,39.663032],[-79.590463,39.662963],[-79.590101,39.662897],[-79.589793,39.662832],[-79.589425,39.66275],[-79.588935,39.662628],[-79.588539,39.662519],[-79.588055,39.662378],[-79.587637,39.662243],[-79.586808,39.661971],[-79.584991,39.661366],[-79.583156,39.660758],[-79.581656,39.66027],[-79.580088,39.65975],[-79.577322,39.658835],[-79.575017,39.658075],[-79.574453,39.657891],[-79.574134,39.657794],[-79.573793,39.65769],[-79.573436,39.657591],[-79.573052,39.65748],[-79.572691,39.65739],[-79.572284,39.657288],[-79.571793,39.657184],[-79.571447,39.657113],[-79.571019,39.657034],[-79.570534,39.656957],[-79.570007,39.656879],[-79.569589,39.656824],[-79.569158,39.656779],[-79.568728,39.656738],[-79.568304,39.656704],[-79.567813,39.656675],[-79.567216,39.656653],[-79.566719,39.656642],[-79.566325,39.65664],[-79.565992,39.656643],[-79.56562,39.656651],[-79.565302,39.656663],[-79.564941,39.656681],[-79.564593,39.656704],[-79.564087,39.656745],[-79.562836,39.656854],[-79.561609,39.656962],[-79.561018,39.657007],[-79.560552,39.657038],[-79.560079,39.657059],[-79.559613,39.657071],[-79.559074,39.657074],[-79.558195,39.657053],[-79.55736,39.657013],[-79.556432,39.656956],[-79.552985,39.656742],[-79.5496,39.656534],[-79.546464,39.656336],[-79.545917,39.656309],[-79.545499,39.656291],[-79.545183,39.656287],[-79.544847,39.656287],[-79.544501,39.656295],[-79.544168,39.656304],[-79.543887,39.656322],[-79.543596,39.656344],[-79.543238,39.656376],[-79.542846,39.656419],[-79.54246,39.656473],[-79.542022,39.656545],[-79.541593,39.656623],[-79.541276,39.656697],[-79.540928,39.656773],[-79.540449,39.656897],[-79.539778,39.657067],[-79.539208,39.657208],[-79.538714,39.657333],[-79.538141,39.657467],[-79.537667,39.65757],[-79.537238,39.657647],[-79.536771,39.657719],[-79.536302,39.657775],[-79.535801,39.657824],[-79.535414,39.657847],[-79.534915,39.657869],[-79.534395,39.657877],[-79.533735,39.657871],[-79.532673,39.657852],[-79.531075,39.657817],[-79.529502,39.657789],[-79.528043,39.657768],[-79.527341,39.657756],[-79.526738,39.657727],[-79.524302,39.657684],[-79.519698,39.657605],[-79.513464,39.657495],[-79.512313,39.657481],[-79.511939,39.657481],[-79.51161,39.657488],[-79.51137,39.657499],[-79.511071,39.657526],[-79.510811,39.657559],[-79.510514,39.657604],[-79.510208,39.65766],[-79.509829,39.657749],[-79.509503,39.657837],[-79.509221,39.657926],[-79.508927,39.658027],[-79.508311,39.658267],[-79.507473,39.658586],[-79.507074,39.658736],[-79.506696,39.658874],[-79.506326,39.658997],[-79.506004,39.659081],[-79.505763,39.659143],[-79.505501,39.659203],[-79.505282,39.659245],[-79.505056,39.659279],[-79.504752,39.659322],[-79.504439,39.65936],[-79.504097,39.659384],[-79.503831,39.659398],[-79.503592,39.659403],[-79.503301,39.659403],[-79.502974,39.659395],[-79.501898,39.659353],[-79.500213,39.659298],[-79.49988,39.659283],[-79.499583,39.659279],[-79.499332,39.659281],[-79.499006,39.659289],[-79.498748,39.659305],[-79.498474,39.659326],[-79.498256,39.659344],[-79.497947,39.659387],[-79.497619,39.659441],[-79.497353,39.659486],[-79.497079,39.659548],[-79.496831,39.659612],[-79.496599,39.65967],[-79.496324,39.659755],[-79.496046,39.659848],[-79.495753,39.659953],[-79.495492,39.660063],[-79.495227,39.660176],[-79.494995,39.660285],[-79.494715,39.660424],[-79.494239,39.660686],[-79.493051,39.66134],[-79.492565,39.661608],[-79.492248,39.661769],[-79.492055,39.661861],[-79.491838,39.661959],[-79.491565,39.66207],[-79.491332,39.662162],[-79.491094,39.662251],[-79.490768,39.66236],[-79.490469,39.662454],[-79.490153,39.662542],[-79.48987,39.662615],[-79.489584,39.662682],[-79.489323,39.662735],[-79.488975,39.662808],[-79.48878,39.662837],[-79.488588,39.662864],[-79.488295,39.662895],[-79.487986,39.662923],[-79.487706,39.662943],[-79.487429,39.662958],[-79.48711,39.662968],[-79.486774,39.662972],[-79.484631,39.662946],[-79.483681,39.662938],[-79.483259,39.662944],[-79.482673,39.662958],[-79.482239,39.66298],[-79.481666,39.663033],[-79.48114,39.663097],[-79.480472,39.663171],[-79.478335,39.663418],[-79.477883,39.663458],[-79.477407,39.663494],[-79.477086,39.663514],[-79.476511,39.663524],[-79.475962,39.66352],[-79.475447,39.663502],[-79.474953,39.663476],[-79.474413,39.663425],[-79.473952,39.663368],[-79.473375,39.66328],[-79.472806,39.663166],[-79.472217,39.663033],[-79.471576,39.662869],[-79.465276,39.66117],[-79.464624,39.660993],[-79.449529,39.656948],[-79.449106,39.656823],[-79.448827,39.656733],[-79.448479,39.656611],[-79.448118,39.656469],[-79.447756,39.65631],[-79.447387,39.656133],[-79.446962,39.655905],[-79.446499,39.655636],[-79.444747,39.654541],[-79.444373,39.654324],[-79.443975,39.654118],[-79.443628,39.653965],[-79.443309,39.653845],[-79.442961,39.653726],[-79.442488,39.653593],[-79.442091,39.653512],[-79.44167,39.653441],[-79.441245,39.65339],[-79.440817,39.65336],[-79.440369,39.653349],[-79.439905,39.653362],[-79.439454,39.653404],[-79.438891,39.653479],[-79.438418,39.65358],[-79.437958,39.653703],[-79.437507,39.65385],[-79.436996,39.654054],[-79.436517,39.654285],[-79.436167,39.654482],[-79.435825,39.654702],[-79.435451,39.654986],[-79.435064,39.655326],[-79.432382,39.657827],[-79.430757,39.659316],[-79.430499,39.659553],[-79.430209,39.659789],[-79.42991,39.660012],[-79.429516,39.660262],[-79.429113,39.660477],[-79.428597,39.660754],[-79.428067,39.661024],[-79.427588,39.661238],[-79.427115,39.661422],[-79.426697,39.66156],[-79.426281,39.661678],[-79.425794,39.661788],[-79.42535,39.661878],[-79.424896,39.661951],[-79.424452,39.662007],[-79.423989,39.662054],[-79.423536,39.662077],[-79.423041,39.662081],[-79.418002,39.66205],[-79.415461,39.662029],[-79.414955,39.662011],[-79.414436,39.661984],[-79.414084,39.661963],[-79.413625,39.66192],[-79.412876,39.661825],[-79.412254,39.661727],[-79.411773,39.66164],[-79.409433,39.661181],[-79.407664,39.660862],[-79.407193,39.660782],[-79.406715,39.660707],[-79.406209,39.660653],[-79.405797,39.660633],[-79.405395,39.660625],[-79.404937,39.660635],[-79.404466,39.660673],[-79.404004,39.66073],[-79.401867,39.6611],[-79.399297,39.661551],[-79.396656,39.662004],[-79.396074,39.662125],[-79.395553,39.662253],[-79.395047,39.662393],[-79.394489,39.662575],[-79.393974,39.662782],[-79.393536,39.662978],[-79.393028,39.663218],[-79.392643,39.663429],[-79.392262,39.663668],[-79.391865,39.663935],[-79.391448,39.664256],[-79.39105,39.664614],[-79.386781,39.669037],[-79.386451,39.669409],[-79.386099,39.669821],[-79.385611,39.67043],[-79.385195,39.671008],[-79.384817,39.671592],[-79.384508,39.672112],[-79.384241,39.672495],[-79.383895,39.673001],[-79.382983,39.674432],[-79.38267,39.674939],[-79.382432,39.675288],[-79.382175,39.675574],[-79.381869,39.675867],[-79.381556,39.676128],[-79.381205,39.676384],[-79.380816,39.676636],[-79.380447,39.676845],[-79.380034,39.677036],[-79.379559,39.67723],[-79.379095,39.677379],[-79.378599,39.677501],[-79.373862,39.678481],[-79.373152,39.678625],[-79.372462,39.678784],[-79.371878,39.678942],[-79.371163,39.679166],[-79.370444,39.679436],[-79.369859,39.67968],[-79.369305,39.679955],[-79.360874,39.684751],[-79.360398,39.685018],[-79.359873,39.685293],[-79.35944,39.685495],[-79.358939,39.685711],[-79.358402,39.685914],[-79.357815,39.686113],[-79.357166,39.686313],[-79.356602,39.686445],[-79.356081,39.68656],[-79.352188,39.687223],[-79.351569,39.687349],[-79.351032,39.687471],[-79.350492,39.687614],[-79.349969,39.687776],[-79.349318,39.687998],[-79.348686,39.688255],[-79.348072,39.68853],[-79.347487,39.688828],[-79.346685,39.689286],[-79.346108,39.689659],[-79.34551,39.690095],[-79.34499,39.69052],[-79.342702,39.692576],[-79.342281,39.692938],[-79.341974,39.693187],[-79.341536,39.69351],[-79.341089,39.693825],[-79.340608,39.694139],[-79.340017,39.694484],[-79.339615,39.694713],[-79.339098,39.69497],[-79.338547,39.695237],[-79.337889,39.695526],[-79.337291,39.695757],[-79.335672,39.69631],[-79.331108,39.697863],[-79.33057,39.698021],[-79.330063,39.698132],[-79.329617,39.698202],[-79.329178,39.698252],[-79.328658,39.69828],[-79.328202,39.69828],[-79.327731,39.698256],[-79.327282,39.698202],[-79.32679,39.698111],[-79.326251,39.697989],[-79.324645,39.697555],[-79.324116,39.697423],[-79.323693,39.697332],[-79.323267,39.697266],[-79.32278,39.69722],[-79.32231,39.697202],[-79.321841,39.697202],[-79.321307,39.697235],[-79.320757,39.697304],[-79.320319,39.697382],[-79.319766,39.697524],[-79.318883,39.697809],[-79.312975,39.700075],[-79.311238,39.700748],[-79.310578,39.700976],[-79.310031,39.701137],[-79.309461,39.70127],[-79.308856,39.701381],[-79.308313,39.701459],[-79.307695,39.701517],[-79.307027,39.701551],[-79.306465,39.701549],[-79.305883,39.701518],[-79.305445,39.701485],[-79.297301,39.700733],[-79.295511,39.700584],[-79.288469,39.699931],[-79.287878,39.699864],[-79.287312,39.699781],[-79.286758,39.69968],[-79.286207,39.69956],[-79.285612,39.699413],[-79.285068,39.699253],[-79.284442,39.699042],[-79.28383,39.698805],[-79.282752,39.698351],[-79.278514,39.696538],[-79.278011,39.696307],[-79.277559,39.696134],[-79.277138,39.695994],[-79.276674,39.695853],[-79.276234,39.695739],[-79.275741,39.695631],[-79.275197,39.695539],[-79.274705,39.695473],[-79.274224,39.695429],[-79.273691,39.695397],[-79.27326,39.695386],[-79.27055,39.69543],[-79.269694,39.695429],[-79.268997,39.695415],[-79.268149,39.695373],[-79.267305,39.695317],[-79.266464,39.695241],[-79.265611,39.695139],[-79.264789,39.695022],[-79.263963,39.694886],[-79.261023,39.694393],[-79.258967,39.694046],[-79.258281,39.693907],[-79.257595,39.693747],[-79.25691,39.693555],[-79.256382,39.693384],[-79.25579,39.693181],[-79.255086,39.692904],[-79.254416,39.692613],[-79.253754,39.69229],[-79.253159,39.691971],[-79.252438,39.691535],[-79.251593,39.690962],[-79.249209,39.689305],[-79.248059,39.688502],[-79.245779,39.686931],[-79.241826,39.684167],[-79.239304,39.682412],[-79.23884,39.68209],[-79.238504,39.681876],[-79.238175,39.681687],[-79.237692,39.681434],[-79.237242,39.681224],[-79.236694,39.681001],[-79.236221,39.680831],[-79.235714,39.680674],[-79.235209,39.680544],[-79.234685,39.680427],[-79.234206,39.680343],[-79.23367,39.68027],[-79.233203,39.680222],[-79.232732,39.680192],[-79.232254,39.680179],[-79.231111,39.680165],[-79.22897,39.680121],[-79.219663,39.680015],[-79.21807,39.680008],[-79.217365,39.680033],[-79.216793,39.680074],[-79.216225,39.68014],[-79.215688,39.680227],[-79.215207,39.680327],[-79.214681,39.680449],[-79.214053,39.680636],[-79.213469,39.680845],[-79.212918,39.681074],[-79.212421,39.681309],[-79.209451,39.682911],[-79.208937,39.683165],[-79.208513,39.683367],[-79.208051,39.683569],[-79.207552,39.68378],[-79.207093,39.683955],[-79.206562,39.684148],[-79.20593,39.684358],[-79.205458,39.6845],[-79.204819,39.684681],[-79.204194,39.684841],[-79.2008,39.685673],[-79.192041,39.687829],[-79.191585,39.687955],[-79.191119,39.688113],[-79.190674,39.688293],[-79.190264,39.688498],[-79.189863,39.688727],[-79.189531,39.688945],[-79.189165,39.689222],[-79.188847,39.689495],[-79.1864,39.691911],[-79.186138,39.692164],[-79.185884,39.692395],[-79.185575,39.69264],[-79.185279,39.692845],[-79.184962,39.693044],[-79.184599,39.693242],[-79.184249,39.693412],[-79.183881,39.693562],[-79.183362,39.69374],[-79.182963,39.693848],[-79.182576,39.693934],[-79.182194,39.693995],[-79.181717,39.694056],[-79.17786,39.69445],[-79.177406,39.694482],[-79.176905,39.694501],[-79.176386,39.694498],[-79.175848,39.694482],[-79.175278,39.69443],[-79.174831,39.694367],[-79.174288,39.694285],[-79.173785,39.69421],[-79.170901,39.693768],[-79.170479,39.693702],[-79.169273,39.693516],[-79.168196,39.693337],[-79.167138,39.693177],[-79.166222,39.69306],[-79.165437,39.692988],[-79.164706,39.692941],[-79.163928,39.692913],[-79.163341,39.692909],[-79.162566,39.692914],[-79.160301,39.692959],[-79.159088,39.692971],[-79.158573,39.692958],[-79.158099,39.692928],[-79.157609,39.692887],[-79.15714,39.692831],[-79.156653,39.692766],[-79.156208,39.692693],[-79.15569,39.692595],[-79.154301,39.692323],[-79.153783,39.692224],[-79.15339,39.692154],[-79.15292,39.692091],[-79.152482,39.692052],[-79.15204,39.69202],[-79.151438,39.692005],[-79.150908,39.692015],[-79.150474,39.692039],[-79.150027,39.692077],[-79.14958,39.692132],[-79.149074,39.692211],[-79.148607,39.6923],[-79.148166,39.692403],[-79.147807,39.692501],[-79.142713,39.694098],[-79.141269,39.694549],[-79.140667,39.694733],[-79.139608,39.695064],[-79.139396,39.695132],[-79.139056,39.695221],[-79.13855,39.695335],[-79.138191,39.695404],[-79.137761,39.695478],[-79.137325,39.695523],[-79.136799,39.695561],[-79.136397,39.695565],[-79.13596,39.695561],[-79.135526,39.695527],[-79.135028,39.695469],[-79.134616,39.695394],[-79.134213,39.695302],[-79.133209,39.695046],[-79.132813,39.694956],[-79.132465,39.694887],[-79.132038,39.694816],[-79.131398,39.694737],[-79.130945,39.694705],[-79.130414,39.694684],[-79.129829,39.694686],[-79.129238,39.694706],[-79.125199,39.694892],[-79.124681,39.694915],[-79.124194,39.694933],[-79.123695,39.694929],[-79.123194,39.694901],[-79.122659,39.694848],[-79.122142,39.694762],[-79.121618,39.694649],[-79.121051,39.694504],[-79.120435,39.694303],[-79.119978,39.694129],[-79.114504,39.691834],[-79.113178,39.691301],[-79.112636,39.691101],[-79.11202,39.690886],[-79.111377,39.69067],[-79.110791,39.690489],[-79.109903,39.690235],[-79.109229,39.690056],[-79.108623,39.689906],[-79.1031,39.688695],[-79.101082,39.688271],[-79.097822,39.687556],[-79.095313,39.686987],[-79.084696,39.684661],[-79.08391,39.684495],[-79.083111,39.684335],[-79.082165,39.68417],[-79.080979,39.683989],[-79.080265,39.683893],[-79.079695,39.683825],[-79.078794,39.683727],[-79.07685,39.683547],[-79.074848,39.683395],[-79.074284,39.683348],[-79.073763,39.683298],[-79.065032,39.682538],[-79.061735,39.682255],[-79.061154,39.682216],[-79.060637,39.6822],[-79.060115,39.682212],[-79.059658,39.682238],[-79.05916,39.682287],[-79.058685,39.682359],[-79.058172,39.682456],[-79.057051,39.682717],[-79.056267,39.682896],[-79.05575,39.682998],[-79.055201,39.68308],[-79.054674,39.683126],[-79.05419,39.683148],[-79.053656,39.683144],[-79.053175,39.683114],[-79.052644,39.683055],[-79.052146,39.682974],[-79.051579,39.682863],[-79.050399,39.682609],[-79.049417,39.682385],[-79.047062,39.681882],[-79.046499,39.681783],[-79.046036,39.681723],[-79.045586,39.681675],[-79.045049,39.681645],[-79.044498,39.681633],[-79.043947,39.681642],[-79.043404,39.681676],[-79.042859,39.681731],[-79.04228,39.681817],[-79.041623,39.681942],[-79.038965,39.682519],[-79.038597,39.682592],[-79.038161,39.682655],[-79.03754,39.682715],[-79.036998,39.682734],[-79.036529,39.682729],[-79.035994,39.682697],[-79.035526,39.682643],[-79.034959,39.682556],[-79.033462,39.682292],[-79.031996,39.682061],[-79.031309,39.681965],[-79.030733,39.68192],[-79.030151,39.681893],[-79.029453,39.681899],[-79.028847,39.68193],[-79.028301,39.681983],[-79.027753,39.682063],[-79.027159,39.682171],[-79.024441,39.682708],[-79.020312,39.683521],[-79.019748,39.683619],[-79.019201,39.683693],[-79.018633,39.683755],[-79.017968,39.6838],[-79.017414,39.683821],[-79.016858,39.68382],[-79.016234,39.683797],[-79.015543,39.683739],[-79.015002,39.683673],[-79.011383,39.683287],[-79.010564,39.683203],[-79.009754,39.683136],[-79.008988,39.683083],[-79.0082,39.683037],[-79.007486,39.683014],[-79.00664,39.682991],[-79.00578,39.682984],[-79.004909,39.682992],[-79.004108,39.683008],[-79.003499,39.683032],[-79.002629,39.683077],[-79.001843,39.683132],[-79.000891,39.683211],[-79.000156,39.683283],[-78.999653,39.683342],[-78.998923,39.683438],[-78.998108,39.683559],[-78.997237,39.683695],[-78.995869,39.68394],[-78.994819,39.684154],[-78.993598,39.684432],[-78.99277,39.68464],[-78.983273,39.687088],[-78.981219,39.687618],[-78.980711,39.687738],[-78.980256,39.687822],[-78.979812,39.687886],[-78.97932,39.687931],[-78.978734,39.687959],[-78.978196,39.687957],[-78.977698,39.687926],[-78.977287,39.687882],[-78.976873,39.687821],[-78.976397,39.68773],[-78.975947,39.687624],[-78.975399,39.687455],[-78.974896,39.687276],[-78.974429,39.687072],[-78.974001,39.686861],[-78.973621,39.686643],[-78.97324,39.686395],[-78.972824,39.686097],[-78.97245,39.685773],[-78.97212,39.68546],[-78.966765,39.67953],[-78.966365,39.679067],[-78.965575,39.678155],[-78.965157,39.677623],[-78.964784,39.677098],[-78.964431,39.676561],[-78.964037,39.675883],[-78.96377,39.675375],[-78.963483,39.67476],[-78.963259,39.674209],[-78.963029,39.673554],[-78.962868,39.673008],[-78.962687,39.672316],[-78.962233,39.670415],[-78.961981,39.669471],[-78.96153,39.66761],[-78.961205,39.666267],[-78.961076,39.66584],[-78.960903,39.66539],[-78.960694,39.664934],[-78.960421,39.664456],[-78.960106,39.663975],[-78.959712,39.663481],[-78.959291,39.663023],[-78.958864,39.662616],[-78.958357,39.662188],[-78.957042,39.661117],[-78.956598,39.66072],[-78.956344,39.660462],[-78.956036,39.66014],[-78.955718,39.659753],[-78.95536,39.659269],[-78.95507,39.658808],[-78.954821,39.658354],[-78.954596,39.657873],[-78.954404,39.657367],[-78.954264,39.656896],[-78.954168,39.656477],[-78.954095,39.656024],[-78.954044,39.655507],[-78.954034,39.655033],[-78.954062,39.654471],[-78.954114,39.654067],[-78.954203,39.653604],[-78.954314,39.653175],[-78.955023,39.650672],[-78.955111,39.650295],[-78.95517,39.649909],[-78.955217,39.649477],[-78.955237,39.649004],[-78.955234,39.648606],[-78.955198,39.648164],[-78.955148,39.647705],[-78.955104,39.647199],[-78.955052,39.646795],[-78.95499,39.646441],[-78.954875,39.646038],[-78.954754,39.645687],[-78.954589,39.645318],[-78.95438,39.64491],[-78.954137,39.644541],[-78.953906,39.644237],[-78.953554,39.643828],[-78.953307,39.643573],[-78.95133,39.641652],[-78.949927,39.640276],[-78.949396,39.63975],[-78.947844,39.638248],[-78.94744,39.637887],[-78.947014,39.637518],[-78.946452,39.637073],[-78.945933,39.636691],[-78.94544,39.636348],[-78.944996,39.636064],[-78.944634,39.635851],[-78.944265,39.635658],[-78.943832,39.635458],[-78.943322,39.635249],[-78.942728,39.635045],[-78.942115,39.634873],[-78.941386,39.634698],[-78.940387,39.634481],[-78.939629,39.634324],[-78.93858,39.634133],[-78.93674,39.633849],[-78.936031,39.633758],[-78.935218,39.633666],[-78.933981,39.633549],[-78.933425,39.633508],[-78.932392,39.633447],[-78.931625,39.633414],[-78.930882,39.633377],[-78.92993,39.633361],[-78.929136,39.633368],[-78.928298,39.633382],[-78.92737,39.633416],[-78.926475,39.633461],[-78.925436,39.633514],[-78.924784,39.633529],[-78.924224,39.633522],[-78.923518,39.633485],[-78.922954,39.633436],[-78.922398,39.633367],[-78.921828,39.633281],[-78.918167,39.632673],[-78.917157,39.632517],[-78.916526,39.632417],[-78.916044,39.632353],[-78.915561,39.632317],[-78.915085,39.6323],[-78.914656,39.632308],[-78.914132,39.632335],[-78.913684,39.632381],[-78.913253,39.632444],[-78.912749,39.632535],[-78.912254,39.632657],[-78.911753,39.632814],[-78.910066,39.633362],[-78.908893,39.633741],[-78.906118,39.634649],[-78.905074,39.635011],[-78.896475,39.638272],[-78.895783,39.638541],[-78.894965,39.638848],[-78.894414,39.639044],[-78.893885,39.639198],[-78.893409,39.639315],[-78.892372,39.639543],[-78.889894,39.640089],[-78.8889,39.640307],[-78.888395,39.640397],[-78.887803,39.64049],[-78.886906,39.640612],[-78.88579,39.640742],[-78.884354,39.640913],[-78.883779,39.640967],[-78.883083,39.641012],[-78.882475,39.641041],[-78.881846,39.641053],[-78.88115,39.641051],[-78.88054,39.641035],[-78.878147,39.640889],[-78.877442,39.640855],[-78.876975,39.640858],[-78.876556,39.640877],[-78.876169,39.640915],[-78.874927,39.641095],[-78.874368,39.641162],[-78.873967,39.641197],[-78.873639,39.641217],[-78.873306,39.64123],[-78.872935,39.641239],[-78.872498,39.641233],[-78.872186,39.641218],[-78.871855,39.6412],[-78.871555,39.641175],[-78.871175,39.641135],[-78.87081,39.641087],[-78.870447,39.641029],[-78.869765,39.640898],[-78.86924,39.64077],[-78.868617,39.640598],[-78.864835,39.639457],[-78.864059,39.639228],[-78.863202,39.638991],[-78.862444,39.638796],[-78.86153,39.638577],[-78.860757,39.638408],[-78.859113,39.638049],[-78.85722,39.637658],[-78.856352,39.637497],[-78.855596,39.637356],[-78.854719,39.637171],[-78.853951,39.636995],[-78.853337,39.636861],[-78.852742,39.636735],[-78.851855,39.636566],[-78.849736,39.636151],[-78.849162,39.636016],[-78.848643,39.635883],[-78.84665,39.635317],[-78.846084,39.635158],[-78.845556,39.635038],[-78.844987,39.634945],[-78.84451,39.634899],[-78.843995,39.634877],[-78.843431,39.634883],[-78.843115,39.634905],[-78.842803,39.634938],[-78.842441,39.634992],[-78.841457,39.635159],[-78.840945,39.635238],[-78.840391,39.635303],[-78.839752,39.635344],[-78.839175,39.635356],[-78.838569,39.635344],[-78.838044,39.635311],[-78.837591,39.63526],[-78.835358,39.635014],[-78.83476,39.634964],[-78.834165,39.634934],[-78.833582,39.634924],[-78.832921,39.634929],[-78.832338,39.63496],[-78.831694,39.635016],[-78.830235,39.635158],[-78.829698,39.635209],[-78.829144,39.635261],[-78.826524,39.635524],[-78.82611,39.635576],[-78.825718,39.635636],[-78.825394,39.63571],[-78.824924,39.63583],[-78.82441,39.636006],[-78.823843,39.63624],[-78.823339,39.636495],[-78.822877,39.636761],[-78.819261,39.638877],[-78.818477,39.639352],[-78.817483,39.64003],[-78.816753,39.640569],[-78.816336,39.640872],[-78.816008,39.64109],[-78.815684,39.641256],[-78.815394,39.64137],[-78.815052,39.641458],[-78.814664,39.641526],[-78.814326,39.641554],[-78.813964,39.641555],[-78.81369,39.641532],[-78.813423,39.64149],[-78.813125,39.641415],[-78.812757,39.641299],[-78.812105,39.64108],[-78.811741,39.640958],[-78.811417,39.640866],[-78.811098,39.640793],[-78.810742,39.640729],[-78.810308,39.640671],[-78.809806,39.64064],[-78.809325,39.640639],[-78.808853,39.64067],[-78.808469,39.640719],[-78.807562,39.640844],[-78.80718,39.64089],[-78.806809,39.640928],[-78.80628,39.640964],[-78.805791,39.640975],[-78.805328,39.640973],[-78.804916,39.640956],[-78.804521,39.640932],[-78.804042,39.640887],[-78.803544,39.640822],[-78.803197,39.640766],[-78.802732,39.640683],[-78.80225,39.640575],[-78.801303,39.640372],[-78.800991,39.640317],[-78.800733,39.640291],[-78.800451,39.640274],[-78.800146,39.640291],[-78.799797,39.640336],[-78.799408,39.640421],[-78.799067,39.640519],[-78.798762,39.640648],[-78.798384,39.640841],[-78.797975,39.6411],[-78.797101,39.641689],[-78.796565,39.642018],[-78.796118,39.642276],[-78.795635,39.642541],[-78.795248,39.642746],[-78.794774,39.642969],[-78.794381,39.643146],[-78.793946,39.643338],[-78.793414,39.643553],[-78.792869,39.643768],[-78.792297,39.643967],[-78.791767,39.644134],[-78.791182,39.644308],[-78.790623,39.644457],[-78.790027,39.644599],[-78.789522,39.64471],[-78.788757,39.644859],[-78.787779,39.645014],[-78.787284,39.645076],[-78.786791,39.645127],[-78.786088,39.645188],[-78.785524,39.645219],[-78.784945,39.645244],[-78.784329,39.645268],[-78.783846,39.645295],[-78.783314,39.645357],[-78.782644,39.645453],[-78.781962,39.645582],[-78.781426,39.645707],[-78.780712,39.645901],[-78.779756,39.646205],[-78.779235,39.646361],[-78.778545,39.646576],[-78.778073,39.646698],[-78.777671,39.646794],[-78.777161,39.646883],[-78.776541,39.646955],[-78.776093,39.646987],[-78.775616,39.646998],[-78.773897,39.647022],[-78.772753,39.64704],[-78.771889,39.647055],[-78.771469,39.64707],[-78.771154,39.647112],[-78.77087,39.647174],[-78.770555,39.647273],[-78.770269,39.647389],[-78.769963,39.64756],[-78.769779,39.647686],[-78.769648,39.64778],[-78.7688,39.648515],[-78.768504,39.648763],[-78.76832,39.648892],[-78.76799,39.649079],[-78.767619,39.649221],[-78.767497,39.64925],[-78.767203,39.649319],[-78.76685,39.649375],[-78.766565,39.649389],[-78.766251,39.649379],[-78.765961,39.649349],[-78.765562,39.649277],[-78.76464,39.649091],[-78.763679,39.648898],[-78.763371,39.648845],[-78.763106,39.648816],[-78.762832,39.648804],[-78.762522,39.648808],[-78.762189,39.648836],[-78.761859,39.648881],[-78.761206,39.649049],[-78.760769,39.649171],[-78.760434,39.649239],[-78.760115,39.649292],[-78.759827,39.649327],[-78.759399,39.649356],[-78.757361,39.649463],[-78.757018,39.649503],[-78.756677,39.649563],[-78.75639,39.64963],[-78.756064,39.649727],[-78.755804,39.649819],[-78.755462,39.649963],[-78.755198,39.650099],[-78.755117,39.650145],[-78.754915,39.650262],[-78.754674,39.65043],[-78.754356,39.650691],[-78.754073,39.650974],[-78.753402,39.651716],[-78.751731,39.653545],[-78.751323,39.65398],[-78.75086,39.654426],[-78.750422,39.654846],[-78.749571,39.655606],[-78.748255,39.656782],[-78.747915,39.657089],[-78.746503,39.658445],[-78.745719,39.659189],[-78.745047,39.659802],[-78.74465,39.660171],[-78.744179,39.660624],[-78.741101,39.663583],[-78.74071,39.66395],[-78.740352,39.664263],[-78.739936,39.664594],[-78.739543,39.664883],[-78.739259,39.665073],[-78.738789,39.665382],[-78.737633,39.666065],[-78.737423,39.666186],[-78.736984,39.666465],[-78.736375,39.666935],[-78.73571,39.667474],[-78.735235,39.667919],[-78.734832,39.66834],[-78.734378,39.668857],[-78.733992,39.669369],[-78.732565,39.671324],[-78.732271,39.671715],[-78.732001,39.67201],[-78.731731,39.672247],[-78.731416,39.672474],[-78.731083,39.672671],[-78.730654,39.672869],[-78.730151,39.673042],[-78.729679,39.673158],[-78.729228,39.673225],[-78.728815,39.673255],[-78.728413,39.673256],[-78.728015,39.673251],[-78.727594,39.673242],[-78.725323,39.673221],[-78.723932,39.673205],[-78.723597,39.673197],[-78.722963,39.673189],[-78.722351,39.673191],[-78.721728,39.673224],[-78.721117,39.673288],[-78.719102,39.673535],[-78.718589,39.673581],[-78.718038,39.673601],[-78.717661,39.673592],[-78.717205,39.67356],[-78.71681,39.673513],[-78.716355,39.673432],[-78.715862,39.673321],[-78.715424,39.673187],[-78.714946,39.673005],[-78.71425,39.67272],[-78.711463,39.671549],[-78.711048,39.671382],[-78.710669,39.671239],[-78.710255,39.6711],[-78.709792,39.670955],[-78.709368,39.670833],[-78.707456,39.67029],[-78.70474,39.669544],[-78.704332,39.669445],[-78.703824,39.669351],[-78.703348,39.669293],[-78.702937,39.669268],[-78.702488,39.669256],[-78.702042,39.669267],[-78.701498,39.669313],[-78.701033,39.669381],[-78.700627,39.669459],[-78.700106,39.669592],[-78.699661,39.669731],[-78.699164,39.669925],[-78.698685,39.670147],[-78.69823,39.670408],[-78.697829,39.670672],[-78.694298,39.673128],[-78.693692,39.673532],[-78.693103,39.673904],[-78.692462,39.674301],[-78.691923,39.674626],[-78.691273,39.674994],[-78.690617,39.675357],[-78.68996,39.675714],[-78.689469,39.675963],[-78.688782,39.676302],[-78.688057,39.676638],[-78.687456,39.67691],[-78.68686,39.677173],[-78.686158,39.677475],[-78.68546,39.677746],[-78.684794,39.677998],[-78.684212,39.678209],[-78.683569,39.678431],[-78.682832,39.678665],[-78.682023,39.678917],[-78.681284,39.679128],[-78.680535,39.679336],[-78.678039,39.679982],[-78.677156,39.680206],[-78.676125,39.6805],[-78.675022,39.680832],[-78.671094,39.682053],[-78.670237,39.682327],[-78.669639,39.682543],[-78.668919,39.682805],[-78.668273,39.683066],[-78.66759,39.683349],[-78.66676,39.683728],[-78.665204,39.684519],[-78.664543,39.684884],[-78.663851,39.685295],[-78.663278,39.685654],[-78.662545,39.686138],[-78.661935,39.686577],[-78.661338,39.687021],[-78.66074,39.68749],[-78.656767,39.690698],[-78.655882,39.691413],[-78.65498,39.692135],[-78.654573,39.692445],[-78.654172,39.692716],[-78.653726,39.692978],[-78.653186,39.693254],[-78.652654,39.69348],[-78.652041,39.693688],[-78.651448,39.693847],[-78.650764,39.693984],[-78.650137,39.694076],[-78.649215,39.694186],[-78.645424,39.694656],[-78.644656,39.694755],[-78.643954,39.694876],[-78.643337,39.695004],[-78.64267,39.695172],[-78.641733,39.695451],[-78.640921,39.695736],[-78.640312,39.69598],[-78.639655,39.696289],[-78.638952,39.696654],[-78.638291,39.697048],[-78.637681,39.697449],[-78.637025,39.697917],[-78.636444,39.698382],[-78.635847,39.698892],[-78.635261,39.699451],[-78.634682,39.700007],[-78.634031,39.700626],[-78.633596,39.701019],[-78.633189,39.701366],[-78.632642,39.701811],[-78.63208,39.702249],[-78.630474,39.703424],[-78.630059,39.703718],[-78.629603,39.703983],[-78.629253,39.704158],[-78.628888,39.704316],[-78.628497,39.704467],[-78.627959,39.704633],[-78.627441,39.704752],[-78.625937,39.705066],[-78.625294,39.705201],[-78.624695,39.705363],[-78.624164,39.705548],[-78.623714,39.705739],[-78.623225,39.705984],[-78.622738,39.706291],[-78.622263,39.706643],[-78.621945,39.706921],[-78.621662,39.707211],[-78.621398,39.707519],[-78.619076,39.71042],[-78.618774,39.710785],[-78.618455,39.71114],[-78.618036,39.711569],[-78.617654,39.711917],[-78.617245,39.712265],[-78.616848,39.712577],[-78.616395,39.712896],[-78.615861,39.713223],[-78.615408,39.713461],[-78.614925,39.71367],[-78.614391,39.713858],[-78.61377,39.714032],[-78.613179,39.714154],[-78.612625,39.714229],[-78.612106,39.714275],[-78.611671,39.714291],[-78.611245,39.714282],[-78.610683,39.714246],[-78.610463,39.714221],[-78.610039,39.714156],[-78.60957,39.714067],[-78.609131,39.713959],[-78.608612,39.713796],[-78.608085,39.713597],[-78.607669,39.713407],[-78.607242,39.713182],[-78.60683,39.712928],[-78.606399,39.712618],[-78.603122,39.710024],[-78.602585,39.709636],[-78.602167,39.709371],[-78.601699,39.709101],[-78.601213,39.708847],[-78.600716,39.708622],[-78.600208,39.708416],[-78.599663,39.708216],[-78.599081,39.708026],[-78.598487,39.707856],[-78.597859,39.707703],[-78.597285,39.707577],[-78.596609,39.707449],[-78.59599,39.707347],[-78.595326,39.707262],[-78.594789,39.707203],[-78.594178,39.707153],[-78.593609,39.707118],[-78.581812,39.706529],[-78.575437,39.706209],[-78.57336,39.706109],[-78.572769,39.706073],[-78.572119,39.706018],[-78.571586,39.705953],[-78.571049,39.705873],[-78.570562,39.705787],[-78.570051,39.705688],[-78.569519,39.705568],[-78.568881,39.705404],[-78.568221,39.705205],[-78.567531,39.704976],[-78.56714,39.70483],[-78.566785,39.70469],[-78.56643,39.70454],[-78.565987,39.704346],[-78.565481,39.7041],[-78.565049,39.703866],[-78.564624,39.703614],[-78.564234,39.703348],[-78.56381,39.703036],[-78.563365,39.70267],[-78.563103,39.702413],[-78.562807,39.702087],[-78.562579,39.701799],[-78.561345,39.700193],[-78.561094,39.699877],[-78.560834,39.699613],[-78.560578,39.699374],[-78.560308,39.699154],[-78.560003,39.698929],[-78.559618,39.698679],[-78.559211,39.698459],[-78.558845,39.698283],[-78.558417,39.698108],[-78.557945,39.697949],[-78.557484,39.69782],[-78.557061,39.697729],[-78.556544,39.697633],[-78.553366,39.697047],[-78.552435,39.696874],[-78.549395,39.696315],[-78.547254,39.695919],[-78.546342,39.695752],[-78.545154,39.695514],[-78.543759,39.695262],[-78.542828,39.695107],[-78.541878,39.694969],[-78.541164,39.694878],[-78.540314,39.694779],[-78.539602,39.694703],[-78.538776,39.694637],[-78.537823,39.694576],[-78.53677,39.694522],[-78.535993,39.694501],[-78.5352,39.694489],[-78.534409,39.694489],[-78.533728,39.694496],[-78.532928,39.694518],[-78.531928,39.694564],[-78.530986,39.694623],[-78.530206,39.694681],[-78.529451,39.694757],[-78.528727,39.69484],[-78.527998,39.694939],[-78.527317,39.69505],[-78.526504,39.695198],[-78.52581,39.695341],[-78.52484,39.695557],[-78.521179,39.696386],[-78.520609,39.696498],[-78.520107,39.696577],[-78.519583,39.696642],[-78.519163,39.69668],[-78.518664,39.69671],[-78.518169,39.696728],[-78.5177,39.696736],[-78.51716,39.696715],[-78.516667,39.696676],[-78.516175,39.696623],[-78.515679,39.696552],[-78.515187,39.696465],[-78.514642,39.696348],[-78.514123,39.696214],[-78.513649,39.696072],[-78.513148,39.6959],[-78.512615,39.695696],[-78.506918,39.693315],[-78.506515,39.693133],[-78.506121,39.692937],[-78.505786,39.692744],[-78.505399,39.6925],[-78.505031,39.692228],[-78.504694,39.691953],[-78.504352,39.69163],[-78.504026,39.691274],[-78.502851,39.689947],[-78.502429,39.689497],[-78.501922,39.688997],[-78.501545,39.688651],[-78.50116,39.688315],[-78.495457,39.683523],[-78.495097,39.683245],[-78.494736,39.682997],[-78.494374,39.682778],[-78.494011,39.682584],[-78.493604,39.682396],[-78.493135,39.682202],[-78.492674,39.682051],[-78.492186,39.681914],[-78.491684,39.681807],[-78.491054,39.681686],[-78.490403,39.681589],[-78.489757,39.681513],[-78.489078,39.681455],[-78.48846,39.681419],[-78.487844,39.6814],[-78.484942,39.681329],[-78.484472,39.681308],[-78.483978,39.681265],[-78.483506,39.681202],[-78.483037,39.681113],[-78.482566,39.681003],[-78.482092,39.680865],[-78.481632,39.680709],[-78.481156,39.680519],[-78.474964,39.678034],[-78.474525,39.677871],[-78.474158,39.677763],[-78.473704,39.677651],[-78.473271,39.677568],[-78.472791,39.677499],[-78.472387,39.677464],[-78.471909,39.677447],[-78.471443,39.677457],[-78.470942,39.677492],[-78.470448,39.677551],[-78.467311,39.677982],[-78.466961,39.678019],[-78.466573,39.678047],[-78.466215,39.678054],[-78.465874,39.67805],[-78.465476,39.678026],[-78.465056,39.677981],[-78.464604,39.677908],[-78.464202,39.677823],[-78.463845,39.677727],[-78.460228,39.67657],[-78.45977,39.676405],[-78.459326,39.67622],[-78.458972,39.676047],[-78.458543,39.675807],[-78.458187,39.675577],[-78.457786,39.67528],[-78.457511,39.675052],[-78.457287,39.674836],[-78.457066,39.674607],[-78.456834,39.674338],[-78.456586,39.674003],[-78.456392,39.673697],[-78.456069,39.673114],[-78.455637,39.67235],[-78.455328,39.671891],[-78.454937,39.671382],[-78.454505,39.670904],[-78.45409,39.670492],[-78.453624,39.670083],[-78.453215,39.66977],[-78.452714,39.669412],[-78.452244,39.669115],[-78.451845,39.668885],[-78.451354,39.668627],[-78.450732,39.668345],[-78.450155,39.668115],[-78.449558,39.667908],[-78.448973,39.667736],[-78.448484,39.667611],[-78.447996,39.667506],[-78.447478,39.667412],[-78.446802,39.667321],[-78.446137,39.667259],[-78.445536,39.667227],[-78.444937,39.667221],[-78.444343,39.667238],[-78.443803,39.667275],[-78.443247,39.667332],[-78.434684,39.668396],[-78.434161,39.668457],[-78.433776,39.668481],[-78.433351,39.668477],[-78.432958,39.668442],[-78.432568,39.668377],[-78.432208,39.668292],[-78.431845,39.668182],[-78.431472,39.66804],[-78.431168,39.667892],[-78.430824,39.667695],[-78.425986,39.664896],[-78.425656,39.664721],[-78.425277,39.664544],[-78.424887,39.664393],[-78.424416,39.664248],[-78.423966,39.66414],[-78.423479,39.664057],[-78.422957,39.664001],[-78.422432,39.663986],[-78.421923,39.664001],[-78.421459,39.664051],[-78.421025,39.664122],[-78.420582,39.664223],[-78.420156,39.664346],[-78.419741,39.664498],[-78.419318,39.664689],[-78.418883,39.664919],[-78.418532,39.66514],[-78.418184,39.665397],[-78.417755,39.66574],[-78.417289,39.666155],[-78.416778,39.666657],[-78.416296,39.667196],[-78.415875,39.667743],[-78.415394,39.668408],[-78.402504,39.68674],[-78.402142,39.687244],[-78.401784,39.687718],[-78.401341,39.688276],[-78.400883,39.688822],[-78.400397,39.68937],[-78.399898,39.689907],[-78.399391,39.690424],[-78.398842,39.690958],[-78.39825,39.691504],[-78.397655,39.692029],[-78.397126,39.69247],[-78.396471,39.692995],[-78.395811,39.693497],[-78.395158,39.693971],[-78.394466,39.694447],[-78.393762,39.694909],[-78.393,39.695383],[-78.392199,39.695837],[-78.391431,39.69629],[-78.390688,39.69668],[-78.389837,39.697101],[-78.388915,39.697538],[-78.388003,39.697939],[-78.3871,39.698313],[-78.386292,39.698619],[-78.385562,39.698875],[-78.384729,39.699138],[-78.383914,39.699372],[-78.383124,39.699583],[-78.382252,39.699786],[-78.381344,39.699969],[-78.380513,39.700117],[-78.379531,39.700264],[-78.378623,39.700387],[-78.376745,39.700635],[-78.374184,39.700969],[-78.372768,39.70117],[-78.371118,39.701427],[-78.366728,39.702131],[-78.366204,39.702203],[-78.365445,39.702286],[-78.364618,39.702351],[-78.363899,39.702384],[-78.363199,39.7024],[-78.362486,39.702398],[-78.361776,39.702375],[-78.361004,39.702329],[-78.354622,39.701735],[-78.354104,39.701692],[-78.353557,39.701676],[-78.353098,39.70169],[-78.352693,39.701718],[-78.3523,39.701765],[-78.351886,39.701836],[-78.351452,39.701933],[-78.350956,39.702075],[-78.350455,39.702253],[-78.349952,39.702475],[-78.349447,39.702747],[-78.348995,39.703038],[-78.348612,39.703335],[-78.348261,39.703654],[-78.347432,39.704412],[-78.34708,39.704723],[-78.346805,39.704929],[-78.346461,39.705161],[-78.346053,39.705402],[-78.345682,39.705589],[-78.345252,39.705775],[-78.344825,39.705928],[-78.344302,39.706076],[-78.343752,39.706196],[-78.343192,39.70628],[-78.342584,39.706339],[-78.340356,39.706544],[-78.339518,39.706616],[-78.338838,39.706661],[-78.338128,39.706702],[-78.337349,39.706732],[-78.3365,39.706753],[-78.335582,39.706763],[-78.334583,39.706753],[-78.333684,39.706731],[-78.333042,39.706709],[-78.332486,39.706676],[-78.331989,39.706632],[-78.331337,39.706555],[-78.330819,39.706474],[-78.330233,39.706359],[-78.329592,39.706215],[-78.329033,39.70606],[-78.328635,39.70594],[-78.328155,39.705776],[-78.327652,39.705593],[-78.327153,39.70538],[-78.32455,39.704257],[-78.324197,39.704114],[-78.323691,39.703933],[-78.32298,39.703712],[-78.322482,39.703582],[-78.321961,39.703467],[-78.321444,39.703366],[-78.320654,39.703246],[-78.320197,39.703208],[-78.319718,39.703177],[-78.319267,39.703156],[-78.317282,39.703085],[-78.316742,39.703075],[-78.3162,39.703093],[-78.315728,39.70314],[-78.315198,39.703221],[-78.314615,39.703349],[-78.314045,39.703516],[-78.313533,39.703716],[-78.312998,39.703961],[-78.312511,39.704234],[-78.312078,39.704524],[-78.311683,39.704831],[-78.305318,39.710213],[-78.30418,39.711169],[-78.303851,39.71144],[-78.303564,39.711645],[-78.303144,39.711888],[-78.3028,39.712065],[-78.302441,39.712224],[-78.302085,39.712358],[-78.301703,39.712481],[-78.298058,39.713497],[-78.297787,39.713571],[-78.296126,39.714045],[-78.29566,39.714196],[-78.295058,39.714419],[-78.294459,39.714663],[-78.293927,39.714911],[-78.293387,39.715187],[-78.292889,39.71547],[-78.292335,39.71581],[-78.291839,39.716147],[-78.291357,39.716519],[-78.291044,39.716749],[-78.289306,39.718277],[-78.289009,39.71851],[-78.288715,39.71871],[-78.288335,39.71893],[-78.287993,39.719095],[-78.287527,39.719279],[-78.287113,39.719406],[-78.286677,39.719508],[-78.286183,39.719582],[-78.285727,39.719626],[-78.285273,39.719634],[-78.284795,39.719618],[-78.28436,39.719576],[-78.283932,39.719498],[-78.283509,39.719389],[-78.283131,39.719268],[-78.282784,39.719135],[-78.282404,39.718955],[-78.282124,39.718796],[-78.281842,39.718619],[-78.281542,39.718401],[-78.2813,39.718195],[-78.281059,39.717953],[-78.280792,39.717643],[-78.28057,39.717327],[-78.280389,39.717008],[-78.280229,39.716623],[-78.280115,39.716263],[-78.279361,39.713728],[-78.27921,39.713315],[-78.279058,39.712988],[-78.278868,39.712638],[-78.278606,39.712265],[-78.278313,39.711902],[-78.277909,39.711491],[-78.277527,39.711168],[-78.277081,39.710857],[-78.276537,39.710534],[-78.276266,39.7104],[-78.275952,39.710262],[-78.275696,39.710155],[-78.275264,39.710007],[-78.274712,39.709852],[-78.274134,39.709729],[-78.273662,39.709661],[-78.267868,39.708882],[-78.267126,39.708781],[-78.266032,39.708633],[-78.265486,39.708536],[-78.265057,39.708443],[-78.264572,39.70832],[-78.264126,39.708186],[-78.263615,39.708007],[-78.263184,39.707841],[-78.262682,39.707616],[-78.262221,39.70738],[-78.26175,39.707108],[-78.261301,39.706815],[-78.260892,39.706526],[-78.252373,39.699841],[-78.251878,39.699488],[-78.251438,39.699217],[-78.250945,39.698957],[-78.250468,39.698736],[-78.250009,39.698558],[-78.249534,39.6984],[-78.249015,39.69826],[-78.248472,39.698141],[-78.24792,39.698057],[-78.247342,39.697994],[-78.246699,39.697961],[-78.24622,39.697969],[-78.245594,39.698001],[-78.245038,39.698067],[-78.244523,39.698154],[-78.24399,39.698271],[-78.243409,39.698441],[-78.242915,39.698606],[-78.242392,39.698821],[-78.241928,39.699045],[-78.241485,39.699292],[-78.240965,39.699626],[-78.240495,39.699987],[-78.240064,39.70036],[-78.239675,39.700751],[-78.239356,39.701129],[-78.236421,39.704931],[-78.235887,39.705705],[-78.23544,39.706385],[-78.235012,39.707086],[-78.234584,39.707828],[-78.233029,39.710579],[-78.232844,39.710879],[-78.232655,39.711134],[-78.232408,39.711412],[-78.232146,39.711663],[-78.231822,39.711923],[-78.231519,39.712128],[-78.231205,39.712305],[-78.230864,39.712469],[-78.230541,39.712604],[-78.230179,39.712724],[-78.229742,39.712837],[-78.229398,39.712898],[-78.229,39.712957],[-78.228571,39.712987],[-78.228203,39.71299],[-78.227785,39.71297],[-78.22742,39.712928],[-78.227043,39.712865],[-78.226685,39.712781],[-78.221537,39.711483],[-78.217105,39.710367],[-78.216645,39.710264],[-78.216231,39.710184],[-78.215771,39.710112],[-78.215321,39.710059],[-78.214827,39.710022],[-78.214401,39.710004],[-78.213899,39.709999],[-78.213403,39.710016],[-78.21293,39.710047],[-78.212486,39.71009],[-78.212047,39.710151],[-78.203482,39.711562],[-78.203021,39.711636],[-78.198902,39.712317],[-78.197928,39.712463],[-78.197228,39.712557],[-78.19597,39.7127],[-78.194837,39.712807],[-78.192852,39.712977],[-78.191957,39.713062],[-78.19132,39.713117],[-78.191044,39.713124],[-78.19079,39.713109],[-78.190604,39.7131],[-78.190443,39.713082],[-78.190304,39.713056],[-78.190166,39.713025],[-78.190026,39.712993],[-78.189887,39.712952],[-78.18973,39.712905],[-78.189609,39.71286],[-78.189488,39.712815],[-78.189351,39.712751],[-78.189241,39.712697],[-78.189105,39.712624],[-78.189002,39.712563],[-78.188894,39.712488],[-78.188782,39.71241],[-78.188492,39.712163],[-78.188336,39.712006],[-78.188158,39.711785],[-78.187146,39.710398],[-78.186874,39.710043],[-78.186629,39.709743],[-78.186287,39.709388],[-78.185956,39.709079],[-78.185828,39.708992],[-78.185616,39.708853],[-78.185127,39.70845],[-78.184771,39.708182],[-78.184452,39.707957],[-78.184129,39.707743],[-78.183712,39.707503],[-78.183308,39.707295],[-78.182966,39.707122],[-78.182656,39.706989],[-78.182272,39.706834],[-78.18186,39.706693],[-78.181175,39.706478],[-78.18013,39.706192],[-78.17963,39.706051],[-78.175171,39.704827],[-78.172181,39.704001],[-78.171608,39.70385],[-78.171108,39.703724],[-78.1706,39.703603],[-78.170088,39.703486],[-78.169471,39.703358],[-78.168903,39.703252],[-78.168131,39.703124],[-78.167516,39.703038],[-78.160205,39.701996],[-78.159706,39.701925],[-78.159257,39.701832],[-78.158798,39.701728],[-78.158364,39.701606],[-78.15789,39.701445],[-78.157473,39.701282],[-78.157025,39.701079],[-78.15666,39.700875],[-78.156296,39.700645],[-78.155904,39.700343],[-78.155597,39.700065],[-78.155352,39.699811],[-78.155118,39.699532],[-78.15479,39.699133],[-78.154055,39.698184],[-78.153731,39.697767],[-78.153334,39.697325],[-78.153001,39.696994],[-78.15272,39.696753],[-78.15237,39.696485],[-78.152092,39.696301],[-78.1517,39.696071],[-78.151336,39.695887],[-78.150931,39.695698],[-78.150436,39.695526],[-78.150025,39.695391],[-78.149482,39.695229],[-78.143366,39.693384],[-78.1428,39.693225],[-78.14215,39.693054],[-78.141499,39.692895],[-78.140913,39.692766],[-78.140296,39.692641],[-78.139539,39.692497],[-78.138434,39.692288],[-78.133726,39.691404],[-78.133146,39.691289],[-78.132657,39.69118],[-78.132102,39.691036],[-78.131472,39.69085],[-78.130995,39.690691],[-78.128571,39.689829],[-78.127568,39.689474],[-78.127088,39.689309],[-78.126659,39.689177],[-78.126097,39.689036],[-78.125626,39.688922],[-78.125149,39.688829],[-78.1246,39.688731],[-78.124111,39.688648],[-78.105535,39.685568],[-78.104978,39.685464],[-78.104375,39.685338],[-78.103799,39.685197],[-78.103275,39.685054],[-78.102876,39.684928],[-78.102513,39.684808],[-78.101687,39.684532],[-78.101137,39.684309],[-78.100605,39.684079],[-78.100016,39.683804],[-78.099485,39.683536],[-78.098989,39.683267],[-78.098679,39.683087],[-78.098204,39.682794],[-78.092938,39.679289],[-78.092172,39.678804],[-78.091617,39.678454],[-78.090957,39.678051],[-78.090402,39.677728],[-78.084988,39.674639],[-78.084399,39.674308],[-78.083951,39.674067],[-78.08346,39.673822],[-78.082986,39.673604],[-78.082568,39.673417],[-78.082115,39.673222],[-78.081674,39.673047],[-78.081246,39.672892],[-78.080836,39.672751],[-78.080431,39.672616],[-78.079941,39.672469],[-78.079377,39.672301],[-78.076983,39.671614],[-78.076517,39.671472],[-78.075972,39.671289],[-78.075436,39.671084],[-78.075037,39.670917],[-78.074557,39.670704],[-78.074102,39.670479],[-78.070941,39.668791],[-78.070372,39.668465],[-78.06993,39.668188],[-78.069499,39.667907],[-78.069078,39.667614],[-78.06857,39.66723],[-78.059637,39.660314],[-78.058513,39.65946],[-78.057999,39.659101],[-78.057503,39.658765],[-78.056939,39.658408],[-78.056354,39.658055],[-78.055788,39.657729],[-78.054482,39.656963],[-78.050806,39.654814],[-78.050407,39.65458],[-78.049778,39.654205],[-78.049395,39.653963],[-78.04894,39.653646],[-78.048535,39.653338],[-78.048142,39.653012],[-78.047145,39.65214],[-78.046244,39.651352],[-78.040655,39.646456],[-78.040258,39.646134],[-78.039751,39.645747],[-78.039204,39.645359],[-78.038689,39.645018],[-78.03825,39.644749],[-78.037717,39.644431],[-78.030445,39.640173],[-78.030003,39.639892],[-78.029548,39.639588],[-78.029021,39.639198],[-78.028498,39.638795],[-78.028039,39.638412],[-78.027595,39.638022],[-78.027212,39.637658],[-78.026799,39.637234],[-78.022657,39.632724],[-78.022259,39.632334],[-78.021854,39.631959],[-78.021478,39.631639],[-78.020982,39.631232],[-78.020372,39.630772],[-78.019353,39.630019],[-78.0145,39.626439],[-78.013962,39.626043],[-78.013641,39.625827],[-78.013133,39.625514],[-78.012712,39.625267],[-78.012171,39.62499],[-78.01173,39.624781],[-78.011243,39.624568],[-78.010789,39.62439],[-78.01037,39.624239],[-78.009901,39.624082],[-78.009344,39.623922],[-78.008856,39.623799],[-78.008391,39.623696],[-78.007919,39.623603],[-78.007374,39.623514],[-78.006941,39.623456],[-78.006435,39.6234],[-78.005812,39.623355],[-78.005246,39.623336],[-78.004589,39.623334],[-78.004009,39.623349],[-78.00345,39.623384],[-78.002891,39.623441],[-78.002337,39.623512],[-78.001783,39.623599],[-78.001224,39.623708],[-77.985356,39.626788],[-77.984802,39.626888],[-77.984106,39.62699],[-77.983399,39.627077],[-77.982694,39.627147],[-77.98199,39.627193],[-77.981422,39.627216],[-77.980712,39.627229],[-77.974741,39.627207],[-77.974015,39.627212],[-77.973451,39.627229],[-77.97274,39.627279],[-77.972037,39.627357],[-77.971469,39.627444],[-77.970909,39.627548],[-77.970234,39.627695],[-77.969563,39.627875],[-77.968911,39.62808],[-77.968262,39.628314],[-77.967763,39.62852],[-77.967266,39.628742],[-77.966791,39.628982],[-77.966331,39.629226],[-77.96576,39.629564],[-77.955357,39.636381],[-77.954602,39.636868],[-77.953726,39.637432],[-77.952401,39.638261],[-77.943314,39.643834],[-77.942722,39.644183],[-77.942103,39.644523],[-77.941502,39.644846],[-77.940959,39.645116],[-77.940209,39.645465],[-77.939634,39.645716],[-77.938997,39.645978],[-77.938427,39.646203],[-77.937735,39.646457],[-77.930865,39.648923],[-77.928828,39.64963],[-77.928211,39.649834],[-77.923678,39.65129],[-77.922893,39.651527],[-77.92234,39.651672],[-77.921684,39.651836],[-77.921082,39.651961],[-77.920416,39.652089],[-77.919829,39.652182],[-77.919011,39.652295],[-77.918419,39.65236],[-77.91785,39.652404],[-77.917107,39.652452],[-77.916306,39.652474],[-77.915134,39.652464],[-77.914221,39.652421],[-77.913529,39.652369],[-77.909031,39.651983],[-77.908723,39.651954],[-77.902525,39.651439],[-77.901691,39.651378],[-77.900827,39.651329],[-77.9001,39.65129],[-77.899282,39.651251],[-77.898514,39.651222],[-77.897641,39.651195],[-77.896584,39.651173],[-77.895581,39.651159],[-77.888883,39.6511],[-77.88846,39.651094],[-77.880677,39.651029],[-77.879256,39.651011],[-77.878214,39.65099],[-77.877063,39.650957],[-77.876323,39.650927],[-77.875596,39.650893],[-77.865925,39.650491],[-77.865173,39.650468],[-77.864278,39.650451],[-77.863221,39.650434],[-77.854276,39.650331],[-77.853671,39.650312],[-77.85315,39.65028],[-77.852202,39.6502],[-77.851427,39.650105],[-77.850792,39.650011],[-77.8502,39.649909],[-77.849542,39.649776],[-77.848761,39.649595],[-77.848156,39.649436],[-77.847438,39.649225],[-77.846761,39.649005],[-77.846161,39.648795],[-77.845445,39.648514],[-77.843158,39.647571],[-77.842414,39.647267],[-77.841265,39.646831],[-77.840435,39.646542],[-77.839671,39.646281],[-77.838773,39.646004],[-77.837953,39.645758],[-77.837019,39.645477],[-77.836463,39.645305],[-77.835882,39.645104],[-77.835229,39.64486],[-77.834567,39.644595],[-77.834005,39.644349],[-77.833604,39.644159],[-77.833025,39.643867],[-77.832514,39.643599],[-77.831982,39.643293],[-77.831645,39.643092],[-77.831229,39.642824],[-77.830876,39.642584],[-77.830055,39.642007],[-77.829107,39.641333],[-77.82735,39.640087],[-77.826668,39.639621],[-77.826144,39.639292],[-77.825634,39.638993],[-77.825103,39.638704],[-77.824628,39.638455],[-77.824097,39.638197],[-77.823518,39.637941],[-77.822952,39.637706],[-77.820938,39.636913],[-77.820212,39.636624],[-77.819687,39.636399],[-77.819038,39.636099],[-77.818519,39.635842],[-77.817968,39.635546],[-77.817386,39.635212],[-77.816722,39.634801],[-77.816083,39.634371],[-77.815504,39.633942],[-77.814773,39.633362],[-77.814273,39.632958],[-77.813576,39.63242],[-77.813108,39.632076],[-77.812618,39.631738],[-77.812076,39.63138],[-77.81153,39.631049],[-77.810985,39.630726],[-77.810474,39.630446],[-77.809953,39.630169],[-77.809336,39.629859],[-77.80877,39.629597],[-77.807997,39.629267],[-77.807274,39.628966],[-77.803951,39.627622],[-77.792582,39.623036],[-77.792125,39.62284],[-77.791654,39.622624],[-77.791293,39.622447],[-77.79094,39.622261],[-77.790509,39.622007],[-77.790177,39.621804],[-77.789927,39.621635],[-77.789296,39.621181],[-77.7889,39.620869],[-77.788496,39.620512],[-77.788198,39.620231],[-77.787807,39.619821],[-77.787532,39.619506],[-77.787302,39.619231],[-77.786945,39.618753],[-77.785885,39.617256],[-77.785424,39.616599],[-77.782751,39.612797],[-77.782506,39.612435],[-77.782195,39.61202],[-77.781485,39.611069],[-77.781225,39.610761],[-77.780863,39.610363],[-77.780483,39.609994],[-77.780092,39.609641],[-77.779684,39.609306],[-77.779296,39.609011],[-77.778921,39.608745],[-77.778605,39.608535],[-77.777943,39.60814],[-77.777475,39.607891],[-77.776974,39.607645],[-77.776465,39.607416],[-77.775989,39.607226],[-77.77548,39.60704],[-77.774918,39.606857],[-77.774448,39.606716],[-77.773763,39.606542],[-77.773269,39.606438],[-77.772759,39.606352],[-77.772131,39.606253],[-77.771518,39.606182],[-77.770837,39.606129],[-77.770227,39.606107],[-77.769469,39.606105],[-77.762344,39.606257],[-77.755202,39.606408],[-77.754592,39.606421],[-77.753963,39.606439],[-77.752842,39.606447],[-77.752084,39.606432],[-77.75146,39.6064],[-77.750811,39.606353],[-77.750227,39.606295],[-77.744825,39.605655],[-77.744431,39.60561],[-77.742792,39.605425],[-77.742088,39.605348],[-77.741335,39.605277],[-77.740653,39.605224],[-77.739872,39.605174],[-77.739109,39.605132],[-77.738413,39.605108],[-77.737608,39.605086],[-77.736872,39.605081],[-77.736012,39.605086],[-77.735094,39.605107],[-77.729442,39.605298],[-77.728792,39.60532],[-77.726776,39.605385],[-77.726018,39.605389],[-77.725599,39.605381],[-77.72496,39.605367],[-77.724273,39.605337],[-77.723624,39.6053],[-77.722985,39.605252],[-77.722433,39.605202],[-77.721831,39.605133],[-77.721188,39.605052],[-77.720608,39.604969],[-77.720045,39.604878],[-77.719514,39.604784],[-77.718968,39.604683],[-77.718453,39.604577],[-77.717795,39.604428],[-77.717211,39.604284],[-77.716523,39.604103],[-77.715995,39.603952],[-77.715492,39.603804],[-77.714929,39.603625],[-77.714416,39.603451],[-77.71262,39.602813],[-77.711876,39.602551],[-77.706934,39.600815],[-77.705936,39.600466],[-77.70548,39.600313],[-77.705007,39.600162],[-77.704553,39.600028],[-77.704072,39.5999],[-77.703645,39.599788],[-77.703163,39.599678],[-77.70267,39.599572],[-77.702038,39.599452],[-77.701673,39.599393],[-77.701266,39.599329],[-77.700743,39.599261],[-77.700271,39.599207],[-77.699767,39.599159],[-77.699141,39.599114],[-77.69858,39.599086],[-77.697934,39.599068],[-77.697381,39.599065],[-77.696786,39.599076],[-77.696081,39.599105],[-77.688182,39.599564],[-77.682576,39.599895],[-77.681971,39.599931],[-77.676304,39.600262],[-77.673256,39.600442],[-77.672734,39.600466],[-77.672165,39.600479],[-77.671523,39.600483],[-77.670954,39.600473],[-77.670244,39.600441],[-77.66963,39.600391],[-77.668988,39.600329],[-77.668321,39.600251],[-77.667727,39.600167],[-77.666992,39.600033],[-77.666241,39.599881],[-77.665599,39.599732],[-77.665052,39.599585],[-77.66437,39.599389],[-77.663755,39.599188],[-77.663138,39.598969],[-77.662595,39.598763],[-77.662087,39.598556],[-77.66155,39.598318],[-77.661003,39.598063],[-77.660484,39.597799],[-77.659913,39.597483],[-77.659465,39.597231],[-77.655881,39.594986],[-77.655487,39.594748],[-77.646212,39.588962],[-77.645704,39.588657],[-77.645136,39.588325],[-77.644628,39.588038],[-77.643986,39.587688],[-77.643458,39.587415],[-77.642784,39.587074],[-77.642388,39.58688],[-77.64149,39.586462],[-77.640891,39.586189],[-77.64017,39.585859],[-77.639641,39.585618],[-77.636702,39.584275],[-77.636154,39.584018],[-77.63562,39.583751],[-77.634971,39.583407],[-77.634362,39.583052],[-77.633876,39.582747],[-77.633378,39.582417],[-77.632789,39.581995],[-77.632277,39.581606],[-77.631853,39.581247],[-77.631382,39.580839],[-77.630889,39.580364],[-77.630432,39.579896],[-77.629217,39.57865],[-77.628877,39.5783],[-77.626796,39.576178],[-77.626103,39.575471],[-77.625563,39.574914],[-77.625127,39.574431],[-77.624722,39.573977],[-77.624196,39.57336],[-77.623652,39.572672],[-77.623156,39.572023],[-77.622491,39.571068],[-77.622051,39.570378],[-77.617585,39.563728],[-77.617379,39.563424],[-77.614744,39.559476],[-77.611142,39.5541],[-77.610866,39.553659],[-77.610569,39.553115],[-77.610366,39.552681],[-77.610205,39.552293],[-77.610053,39.551867],[-77.609925,39.551419],[-77.609834,39.551044],[-77.609741,39.550538],[-77.609588,39.54953],[-77.609434,39.548617],[-77.609303,39.548017],[-77.609165,39.547495],[-77.609004,39.546994],[-77.608816,39.546468],[-77.608611,39.545971],[-77.608373,39.545433],[-77.608173,39.544981],[-77.60797,39.544532],[-77.606788,39.541889],[-77.606659,39.541575],[-77.606521,39.541186],[-77.606396,39.540779],[-77.606307,39.540417],[-77.606236,39.540025],[-77.606189,39.539628],[-77.606167,39.539311],[-77.606159,39.539032],[-77.606165,39.538657],[-77.60618,39.538373],[-77.606216,39.538066],[-77.606276,39.537627],[-77.606562,39.535966],[-77.6066,39.535729],[-77.606628,39.535403],[-77.606639,39.535069],[-77.606615,39.534764],[-77.60658,39.534482],[-77.606527,39.534187],[-77.606456,39.533942],[-77.606366,39.533691],[-77.606218,39.533334],[-77.606079,39.533064],[-77.605854,39.532704],[-77.605599,39.532361],[-77.604823,39.531347],[-77.604579,39.531022],[-77.604236,39.530559],[-77.603982,39.530124],[-77.603737,39.529614],[-77.603572,39.529204],[-77.603442,39.528801],[-77.603342,39.528389],[-77.602685,39.524936],[-77.602587,39.524524],[-77.602456,39.52411],[-77.6023,39.523706],[-77.602094,39.523266],[-77.601886,39.522891],[-77.601666,39.52254],[-77.601462,39.522251],[-77.601137,39.521841],[-77.597303,39.517344],[-77.596973,39.516932],[-77.596709,39.516578],[-77.596406,39.516136],[-77.596124,39.5157],[-77.595933,39.515383],[-77.59575,39.515048],[-77.595543,39.514665],[-77.595285,39.514135],[-77.594526,39.5125],[-77.593382,39.510067],[-77.593234,39.509815],[-77.593079,39.509579],[-77.592914,39.509369],[-77.592731,39.509161],[-77.592459,39.508908],[-77.592145,39.50865],[-77.591891,39.50848],[-77.591601,39.508301],[-77.591248,39.508136],[-77.590886,39.507981],[-77.590523,39.50786],[-77.590161,39.507758],[-77.589829,39.507679],[-77.589454,39.507587],[-77.585173,39.506572],[-77.584706,39.50646],[-77.584025,39.506264],[-77.583603,39.506118],[-77.583093,39.505918],[-77.582707,39.505755],[-77.582299,39.505553],[-77.581944,39.505361],[-77.581596,39.50516],[-77.58119,39.504897],[-77.575185,39.500853],[-77.572013,39.498733],[-77.568626,39.496451],[-77.5678,39.495881],[-77.567197,39.495442],[-77.566439,39.494864],[-77.565741,39.494311],[-77.563283,39.492328],[-77.562652,39.491828],[-77.560434,39.490044],[-77.559972,39.489674],[-77.557751,39.487899],[-77.55725,39.487537],[-77.556831,39.487264],[-77.556433,39.487034],[-77.555966,39.486786],[-77.55558,39.486592],[-77.555127,39.486406],[-77.554682,39.486243],[-77.554234,39.4861],[-77.553799,39.485974],[-77.553323,39.485862],[-77.552854,39.485771],[-77.552281,39.485674],[-77.550248,39.485367],[-77.547661,39.484989],[-77.54665,39.484826],[-77.546029,39.484705],[-77.545549,39.48459],[-77.545162,39.484481],[-77.54474,39.484349],[-77.544301,39.484193],[-77.543868,39.484016],[-77.54344,39.483825],[-77.542938,39.483563],[-77.542554,39.483345],[-77.542191,39.483117],[-77.54179,39.482843],[-77.541413,39.482548],[-77.54103,39.482219],[-77.539432,39.480764],[-77.538665,39.480072],[-77.535405,39.47711],[-77.534865,39.476602],[-77.534297,39.476106],[-77.533665,39.475588],[-77.533027,39.475079],[-77.532313,39.47454],[-77.531474,39.473943],[-77.519289,39.46554],[-77.514663,39.462345],[-77.514009,39.461877],[-77.513559,39.461536],[-77.513036,39.461136],[-77.512611,39.460801],[-77.512172,39.46044],[-77.509472,39.458145],[-77.509112,39.457843],[-77.506803,39.455878],[-77.506258,39.455338],[-77.50604,39.455079],[-77.505816,39.454791],[-77.505568,39.454415],[-77.50536,39.454045],[-77.50519,39.453688],[-77.505068,39.453375],[-77.504964,39.45303],[-77.504865,39.452644],[-77.503717,39.448089],[-77.503602,39.447664],[-77.503468,39.447279],[-77.50327,39.44684],[-77.503081,39.446502],[-77.502824,39.446108],[-77.502598,39.445808],[-77.502285,39.445452],[-77.501956,39.445125],[-77.501555,39.444791],[-77.501027,39.444406],[-77.500674,39.444175],[-77.500299,39.443958],[-77.499719,39.443674],[-77.497834,39.442759],[-77.494039,39.440921],[-77.493499,39.440651],[-77.493125,39.44044],[-77.492767,39.440212],[-77.492378,39.439931],[-77.492061,39.439676],[-77.491736,39.43938],[-77.49149,39.43912],[-77.491214,39.43881],[-77.490982,39.438505],[-77.490698,39.438064],[-77.490529,39.43776],[-77.490325,39.437343],[-77.490151,39.436929],[-77.489995,39.436481],[-77.489872,39.436063],[-77.489776,39.435608],[-77.48971,39.435188],[-77.489669,39.434752],[-77.489651,39.434227],[-77.489672,39.432694],[-77.489696,39.430702],[-77.489685,39.430082],[-77.489646,39.429534],[-77.489594,39.429093],[-77.489533,39.428694],[-77.489442,39.428217],[-77.489308,39.427687],[-77.48915,39.427135],[-77.488981,39.42666],[-77.488791,39.426172],[-77.488565,39.425677],[-77.488325,39.425209],[-77.488104,39.424804],[-77.48787,39.424404],[-77.487537,39.423902],[-77.487208,39.423446],[-77.48678,39.422904],[-77.48637,39.422429],[-77.486064,39.422114],[-77.485569,39.421632],[-77.485272,39.421354],[-77.484978,39.421091],[-77.484563,39.420742],[-77.484129,39.420414],[-77.483652,39.420063],[-77.483183,39.419759],[-77.482714,39.419464],[-77.481602,39.41881],[-77.480798,39.418345],[-77.480224,39.41801],[-77.479729,39.41771],[-77.47924,39.417401],[-77.47869,39.417029],[-77.478081,39.416577],[-77.477608,39.4162],[-77.477134,39.415792],[-77.476677,39.41538],[-77.476246,39.414957],[-77.4758,39.41449],[-77.475344,39.413965],[-77.474813,39.413289],[-77.474471,39.412812],[-77.47413,39.412301],[-77.473116,39.410702],[-77.472739,39.410136],[-77.472384,39.409667],[-77.472023,39.409226],[-77.471681,39.408846],[-77.471322,39.408473],[-77.470915,39.408082],[-77.470472,39.407692],[-77.470014,39.407324],[-77.469643,39.40704],[-77.46914,39.406687],[-77.468664,39.406378],[-77.468184,39.40609],[-77.467702,39.405819],[-77.467252,39.405587],[-77.466738,39.405335],[-77.466251,39.405124],[-77.465729,39.404912],[-77.465229,39.404727],[-77.464638,39.404526],[-77.464049,39.404349],[-77.46344,39.404188],[-77.462841,39.404044],[-77.462359,39.403946],[-77.461728,39.403834],[-77.461113,39.403746],[-77.460475,39.40367],[-77.457152,39.403305],[-77.454919,39.403061],[-77.451449,39.402681],[-77.450846,39.402609],[-77.450253,39.402528],[-77.449612,39.402419],[-77.448714,39.402236],[-77.448148,39.402109],[-77.44744,39.401918],[-77.446654,39.401691],[-77.445853,39.401412],[-77.44559,39.401336],[-77.444697,39.400994],[-77.444117,39.400746],[-77.44239,39.399956],[-77.442062,39.399804],[-77.441583,39.399591],[-77.44108,39.399373],[-77.440374,39.399098],[-77.440265,39.399057],[-77.439896,39.398935],[-77.439424,39.39879],[-77.438908,39.398643],[-77.438395,39.398506],[-77.437869,39.398391],[-77.437441,39.398306],[-77.437011,39.398231],[-77.436501,39.398152],[-77.435985,39.398089],[-77.435402,39.398029],[-77.434738,39.397984],[-77.433485,39.397932],[-77.428615,39.397932],[-77.424722,39.397927],[-77.423852,39.397927],[-77.42214,39.397916],[-77.421454,39.397893],[-77.42092,39.397867],[-77.419772,39.397789],[-77.419257,39.397767],[-77.41872,39.397767],[-77.418274,39.397783],[-77.417827,39.397816],[-77.417291,39.39788],[-77.416892,39.397942],[-77.416456,39.398029],[-77.416085,39.398115],[-77.408786,39.399955],[-77.403963,39.401208],[-77.403483,39.401335],[-77.397917,39.402737],[-77.394035,39.403715],[-77.393154,39.403937],[-77.392694,39.404051],[-77.391868,39.40424],[-77.39142,39.404324],[-77.390905,39.404403],[-77.390444,39.404462],[-77.389905,39.404513],[-77.389385,39.404546],[-77.388804,39.40456],[-77.388144,39.404567],[-77.386666,39.404556],[-77.386264,39.40454],[-77.385875,39.404519],[-77.385478,39.404487],[-77.385042,39.40443],[-77.384492,39.404349],[-77.381857,39.403879],[-77.381306,39.403771],[-77.380929,39.403725],[-77.380524,39.403678],[-77.379865,39.403646],[-77.379256,39.403634],[-77.378855,39.40365],[-77.374749,39.4038],[-77.366757,39.404098],[-77.364707,39.404178],[-77.362526,39.40426],[-77.361589,39.404298],[-77.360889,39.404339],[-77.360114,39.404392],[-77.35461,39.404796],[-77.354116,39.404822],[-77.353642,39.404835],[-77.353117,39.404835],[-77.352562,39.404813],[-77.352034,39.404776],[-77.35159,39.40474],[-77.351079,39.404678],[-77.350632,39.404604],[-77.350121,39.404511],[-77.349611,39.404405],[-77.347717,39.403924],[-77.347427,39.40385],[-77.338224,39.401491],[-77.337576,39.401314],[-77.337051,39.401151],[-77.336572,39.400994],[-77.336135,39.400826],[-77.335659,39.400634],[-77.335044,39.400355],[-77.334603,39.400136],[-77.334194,39.399915],[-77.333752,39.399654],[-77.33331,39.399379],[-77.332921,39.399118],[-77.332522,39.39882],[-77.332101,39.398484],[-77.33167,39.398113],[-77.327257,39.394146],[-77.326965,39.393886],[-77.326659,39.393633],[-77.326214,39.393295],[-77.325797,39.393002],[-77.325328,39.392705],[-77.324852,39.392425],[-77.324247,39.392101],[-77.323771,39.391874],[-77.323306,39.39167],[-77.32291,39.391511],[-77.322486,39.391354],[-77.322069,39.391216],[-77.321617,39.391077],[-77.320043,39.390639],[-77.31556,39.389393],[-77.314944,39.38922],[-77.314345,39.389061],[-77.313489,39.388842],[-77.312638,39.388633],[-77.311835,39.388446],[-77.311028,39.388267],[-77.310253,39.388098],[-77.309535,39.387952],[-77.308674,39.387788],[-77.283185,39.383077],[-77.282693,39.382984],[-77.282147,39.382859],[-77.281659,39.382726],[-77.281084,39.382554],[-77.280564,39.382382],[-77.280085,39.382195],[-77.27964,39.382007],[-77.278054,39.381292],[-77.277653,39.38112],[-77.27726,39.380966],[-77.276893,39.380842],[-77.276564,39.380747],[-77.276159,39.380646],[-77.275671,39.380544],[-77.275274,39.380482],[-77.2749,39.380433],[-77.274514,39.3804],[-77.274172,39.380384],[-77.273737,39.380376],[-77.273366,39.380389],[-77.272958,39.380408],[-77.272541,39.380453],[-77.272046,39.380523],[-77.269428,39.380958],[-77.26709,39.381341],[-77.265386,39.381619],[-77.264894,39.381694],[-77.264341,39.381757],[-77.263824,39.381795],[-77.263294,39.381821],[-77.26269,39.381837],[-77.262129,39.381823],[-77.261624,39.381802],[-77.261074,39.381756],[-77.260541,39.381694],[-77.259853,39.381597],[-77.259445,39.38152],[-77.258927,39.381409],[-77.253479,39.380205],[-77.251562,39.379781],[-77.244571,39.378231],[-77.231499,39.375326],[-77.230719,39.375153],[-77.230159,39.375022],[-77.229538,39.374862],[-77.228886,39.374675],[-77.228291,39.374493],[-77.227657,39.374266],[-77.227007,39.37402],[-77.226341,39.373738],[-77.225741,39.373465],[-77.225063,39.373134],[-77.224535,39.372854],[-77.22395,39.372509],[-77.223411,39.37218],[-77.222941,39.37187],[-77.221313,39.370757],[-77.220915,39.370512],[-77.220626,39.370352],[-77.220287,39.370178],[-77.21989,39.369999],[-77.219524,39.369856],[-77.21919,39.369738],[-77.218799,39.369623],[-77.218401,39.369524],[-77.217978,39.369434],[-77.217574,39.369368],[-77.217185,39.36932],[-77.216767,39.369286],[-77.216356,39.369274],[-77.215962,39.369276],[-77.215585,39.369291],[-77.215207,39.369316],[-77.214842,39.369361],[-77.214458,39.369417],[-77.214073,39.369493],[-77.213771,39.369559],[-77.213378,39.369666],[-77.212052,39.370086],[-77.211623,39.370215],[-77.211113,39.370344],[-77.210737,39.37043],[-77.210401,39.370493],[-77.210013,39.370555],[-77.209585,39.370612],[-77.20918,39.370661],[-77.208806,39.370693],[-77.208396,39.370714],[-77.208006,39.370722],[-77.207578,39.370717],[-77.207125,39.370704],[-77.206631,39.370665],[-77.206141,39.370615],[-77.205676,39.370551],[-77.205236,39.370474],[-77.204812,39.370382],[-77.204386,39.37027],[-77.203934,39.370127],[-77.203504,39.369965],[-77.203089,39.369788],[-77.20271,39.369613],[-77.202459,39.369476],[-77.202114,39.369276],[-77.201045,39.3686],[-77.200747,39.368428],[-77.200461,39.368272],[-77.200139,39.368119],[-77.199845,39.367995],[-77.199482,39.367863],[-77.199083,39.367736],[-77.198633,39.367629],[-77.198145,39.367528],[-77.196646,39.367242],[-77.196165,39.367148],[-77.195266,39.36698],[-77.194447,39.366824],[-77.193425,39.366627],[-77.185611,39.36514],[-77.184783,39.364971],[-77.184051,39.364792],[-77.183437,39.36462],[-77.182911,39.364456],[-77.182401,39.364276],[-77.181811,39.364053],[-77.181318,39.363843],[-77.180818,39.363614],[-77.180373,39.363391],[-77.179848,39.363115],[-77.179321,39.362806],[-77.178886,39.362536],[-77.178389,39.362196],[-77.177591,39.36161],[-77.176905,39.361109],[-77.176546,39.360848],[-77.1762,39.360622],[-77.175838,39.36041],[-77.175474,39.360211],[-77.175055,39.360005],[-77.17468,39.359838],[-77.174309,39.359687],[-77.17388,39.359533],[-77.173494,39.359409],[-77.173099,39.3593],[-77.172663,39.35919],[-77.172057,39.359071],[-77.17156,39.358991],[-77.171153,39.358942],[-77.170736,39.358907],[-77.170323,39.358877],[-77.16981,39.35887],[-77.169323,39.35888],[-77.168927,39.358897],[-77.1685,39.358932],[-77.168185,39.358965],[-77.167571,39.359038],[-77.167029,39.359113],[-77.166051,39.359233],[-77.162686,39.359659],[-77.158779,39.360147],[-77.150796,39.361149],[-77.150313,39.361196],[-77.149886,39.361221],[-77.149494,39.361234],[-77.149083,39.361232],[-77.148647,39.361212],[-77.148265,39.361178],[-77.147828,39.36113],[-77.147302,39.361043],[-77.146825,39.360944],[-77.146386,39.360831],[-77.145973,39.360707],[-77.14555,39.360558],[-77.14507,39.360367],[-77.144725,39.360213],[-77.144394,39.360046],[-77.143998,39.359826],[-77.143448,39.35949],[-77.139278,39.356882],[-77.1381,39.356148],[-77.137661,39.35589],[-77.137232,39.355649],[-77.136814,39.355438],[-77.136394,39.355243],[-77.136029,39.355089],[-77.135589,39.354913],[-77.135151,39.354757],[-77.134699,39.354607],[-77.134302,39.354488],[-77.133884,39.354378],[-77.133478,39.354279],[-77.13299,39.354175],[-77.132572,39.354096],[-77.132153,39.354029],[-77.131692,39.353967],[-77.131176,39.353913],[-77.130712,39.353875],[-77.124002,39.353432],[-77.123436,39.353381],[-77.122877,39.353316],[-77.12241,39.353257],[-77.121915,39.353182],[-77.121339,39.353085],[-77.120932,39.353006],[-77.120533,39.352914],[-77.118633,39.352465],[-77.106309,39.349474],[-77.105652,39.349321],[-77.10505,39.349183],[-77.104462,39.349059],[-77.103805,39.34893],[-77.103266,39.348832],[-77.102612,39.348719],[-77.101945,39.348611],[-77.10116,39.348498],[-77.085602,39.346357],[-77.084988,39.346262],[-77.084201,39.346135],[-77.08323,39.345956],[-77.082527,39.345817],[-77.081826,39.345662],[-77.081165,39.345513],[-77.080446,39.345334],[-77.079883,39.345189],[-77.079341,39.345036],[-77.0788,39.344885],[-77.07837,39.344759],[-77.076201,39.344053],[-77.070021,39.341994],[-77.069368,39.341786],[-77.068808,39.341619],[-77.068215,39.341448],[-77.067581,39.341271],[-77.066893,39.341093],[-77.064957,39.340607],[-77.058553,39.339002],[-77.057336,39.338697],[-77.05655,39.338503],[-77.055782,39.338323],[-77.055202,39.338194],[-77.054624,39.338076],[-77.054034,39.337962],[-77.053364,39.337838],[-77.052759,39.337735],[-77.052116,39.337637],[-77.051413,39.337536],[-77.045074,39.336698],[-77.044547,39.336623],[-77.043974,39.336527],[-77.043391,39.336416],[-77.042881,39.33631],[-77.042369,39.336188],[-77.041799,39.336041],[-77.041291,39.335896],[-77.040769,39.335732],[-77.040201,39.335548],[-77.039774,39.33539],[-77.028476,39.331136],[-77.022701,39.328956],[-77.016879,39.326765],[-77.015971,39.326428],[-77.009532,39.323997],[-77.007348,39.323177],[-77.00688,39.32301],[-77.006434,39.322863],[-77.006011,39.32274],[-77.005571,39.322624],[-77.005166,39.322525],[-77.004753,39.322439],[-77.004289,39.322355],[-77.003963,39.322303],[-77.003648,39.322257],[-77.003261,39.322213],[-77.002879,39.322172],[-76.994069,39.32145],[-76.993564,39.321398],[-76.993041,39.321335],[-76.992482,39.321253],[-76.992011,39.321179],[-76.991584,39.321102],[-76.991126,39.321009],[-76.990692,39.320914],[-76.990248,39.320806],[-76.989821,39.320697],[-76.98934,39.320564],[-76.988758,39.320388],[-76.977896,39.317068],[-76.977273,39.316859],[-76.976719,39.316668],[-76.976154,39.316463],[-76.975535,39.316232],[-76.974457,39.315802],[-76.963878,39.311391],[-76.96225,39.310717],[-76.961732,39.310518],[-76.961149,39.310305],[-76.960572,39.310117],[-76.960165,39.309993],[-76.959746,39.309875],[-76.95926,39.309745],[-76.958781,39.309627],[-76.958339,39.309527],[-76.957788,39.309415],[-76.957287,39.309324],[-76.956696,39.309234],[-76.956086,39.309152],[-76.955451,39.309078],[-76.953636,39.308878],[-76.953452,39.308857],[-76.95338,39.308849],[-76.952908,39.308797],[-76.952079,39.308708],[-76.945741,39.30802],[-76.928781,39.306169],[-76.919802,39.305183],[-76.919171,39.305108],[-76.918614,39.30504],[-76.918064,39.304961],[-76.917676,39.304885],[-76.917107,39.304756],[-76.916585,39.304615],[-76.916042,39.304453],[-76.915616,39.304309],[-76.915135,39.304132],[-76.914501,39.303861],[-76.913857,39.303565],[-76.913515,39.303406],[-76.913177,39.303255],[-76.912794,39.303097],[-76.912387,39.302944],[-76.91198,39.302804],[-76.911599,39.302683],[-76.911237,39.302585],[-76.910776,39.302468],[-76.910281,39.302362],[-76.909927,39.302297],[-76.90943,39.302222],[-76.908951,39.302164],[-76.908489,39.302125],[-76.908145,39.302108],[-76.907769,39.302094],[-76.907287,39.302093],[-76.906667,39.302115],[-76.906147,39.302145],[-76.905529,39.302207],[-76.905014,39.302273],[-76.904518,39.302358],[-76.904054,39.302455],[-76.903543,39.302582],[-76.902998,39.302738],[-76.902128,39.303037],[-76.901366,39.303294],[-76.900474,39.303579],[-76.899615,39.303834],[-76.898704,39.304088],[-76.897954,39.304277],[-76.897193,39.304467],[-76.896507,39.30462],[-76.895807,39.304768],[-76.895131,39.304899],[-76.894635,39.304993],[-76.894044,39.305092],[-76.893496,39.305182],[-76.892631,39.305301],[-76.891994,39.305372],[-76.89145,39.305424],[-76.890868,39.305472],[-76.890349,39.3055],[-76.889669,39.305531],[-76.889008,39.305543],[-76.888418,39.305548],[-76.887754,39.305546],[-76.887192,39.305526],[-76.886618,39.305502],[-76.885986,39.305461],[-76.885444,39.305417],[-76.884834,39.305357],[-76.884334,39.305301],[-76.883858,39.30524],[-76.883288,39.305159],[-76.882659,39.305058],[-76.882181,39.30497],[-76.881598,39.304855],[-76.881137,39.30476],[-76.880674,39.304651],[-76.880179,39.304532],[-76.879538,39.304364],[-76.878898,39.304179],[-76.878355,39.304015],[-76.877808,39.303834],[-76.877327,39.303671],[-76.876859,39.303499],[-76.876484,39.303363],[-76.876165,39.303232],[-76.875634,39.303018],[-76.871379,39.301179],[-76.866456,39.299055],[-76.865737,39.298751],[-76.865202,39.298532],[-76.864738,39.298354],[-76.864172,39.298145],[-76.863556,39.297922],[-76.862974,39.29773],[-76.862412,39.297553],[-76.861934,39.297405],[-76.86144,39.297264],[-76.860841,39.297096],[-76.860285,39.296955],[-76.859714,39.296813],[-76.859152,39.296686],[-76.858587,39.296564],[-76.858001,39.296445],[-76.857433,39.29634],[-76.856843,39.296237],[-76.856273,39.296147],[-76.855429,39.296029],[-76.854879,39.295963],[-76.85434,39.295902],[-76.853816,39.295849],[-76.853336,39.29581],[-76.852699,39.295763],[-76.852113,39.295725],[-76.851477,39.295698],[-76.850886,39.295681],[-76.850185,39.295668],[-76.849552,39.295664],[-76.84906,39.295672],[-76.848484,39.295683],[-76.834399,39.296216],[-76.833887,39.296235],[-76.832482,39.296282],[-76.831827,39.296304],[-76.830987,39.296321],[-76.830258,39.296326],[-76.829515,39.29633],[-76.82641,39.296302],[-76.82504,39.29629],[-76.823189,39.296284],[-76.822691,39.296275],[-76.822144,39.296251],[-76.821589,39.296219],[-76.821045,39.296176],[-76.819476,39.296053],[-76.81908,39.296023],[-76.818625,39.295997],[-76.81795,39.295959],[-76.817082,39.295977],[-76.816543,39.29602],[-76.816012,39.296074],[-76.813491,39.296392],[-76.812888,39.296461],[-76.812262,39.296529],[-76.811747,39.29658],[-76.811122,39.296651],[-76.810454,39.29674],[-76.809901,39.296819],[-76.809319,39.296909],[-76.808741,39.297002],[-76.808157,39.297114],[-76.807592,39.297234],[-76.807068,39.297362],[-76.806512,39.297525],[-76.80606,39.297675],[-76.805531,39.297866],[-76.805028,39.298065],[-76.804497,39.29831],[-76.804026,39.298534],[-76.803569,39.298784],[-76.803201,39.298996],[-76.802901,39.299194],[-76.802633,39.299381],[-76.802356,39.299594],[-76.80206,39.299847],[-76.801839,39.300053],[-76.801619,39.30027],[-76.801376,39.300555],[-76.800949,39.301094],[-76.800712,39.301402],[-76.800494,39.301651],[-76.80027,39.301889],[-76.799999,39.30216],[-76.799565,39.302542],[-76.799037,39.302945],[-76.798687,39.303185],[-76.798399,39.303366],[-76.798104,39.303539],[-76.797797,39.3037],[-76.797561,39.303819],[-76.79503,39.304972],[-76.794288,39.305271],[-76.793536,39.30556],[-76.79293,39.30578],[-76.792437,39.305948],[-76.791499,39.306232],[-76.790846,39.306407],[-76.790276,39.306542],[-76.789714,39.30666],[-76.788987,39.306796],[-76.788279,39.306907],[-76.787604,39.306995],[-76.787104,39.307047],[-76.786494,39.307098],[-76.785909,39.307132],[-76.785344,39.307152],[-76.78488,39.307163],[-76.784297,39.30716],[-76.783754,39.307146],[-76.783293,39.307125],[-76.782697,39.307094],[-76.777046,39.306752],[-76.776426,39.306718],[-76.77579,39.30669],[-76.775121,39.306666],[-76.774522,39.306655],[-76.773659,39.306647],[-76.772949,39.306655],[-76.772088,39.306677],[-76.77137,39.306703],[-76.770797,39.306733],[-76.770289,39.306761],[-76.769704,39.306805],[-76.769027,39.306861],[-76.763508,39.307392],[-76.759956,39.307735],[-76.759395,39.307782],[-76.758965,39.307811],[-76.758502,39.307823],[-76.757993,39.307828],[-76.757543,39.30782],[-76.757126,39.307801],[-76.756543,39.307758],[-76.756029,39.307689],[-76.755375,39.307607],[-76.754907,39.307522],[-76.75429,39.30739],[-76.753876,39.307278],[-76.753484,39.307172],[-76.752638,39.30691],[-76.75195,39.30659],[-76.751388,39.306319],[-76.750944,39.306102],[-76.749459,39.305388],[-76.748706,39.305004],[-76.748085,39.304705],[-76.747402,39.304383],[-76.74673,39.304071],[-76.74646,39.303928],[-76.746067,39.303707],[-76.745868,39.303585],[-76.74565,39.303434],[-76.745491,39.303322],[-76.745365,39.303232],[-76.745257,39.303137],[-76.744818,39.302741],[-76.744433,39.30231],[-76.744242,39.302072],[-76.743875,39.301506],[-76.743692,39.301117],[-76.743586,39.300822],[-76.743472,39.300473],[-76.743248,39.299605],[-76.742386,39.29276],[-76.742313,39.292217],[-76.742265,39.291927],[-76.742187,39.291561],[-76.742071,39.291115],[-76.741951,39.290743],[-76.741762,39.290236],[-76.741616,39.289894],[-76.741468,39.289593],[-76.741339,39.289339],[-76.741206,39.289107],[-76.740996,39.288773],[-76.740804,39.288475],[-76.740531,39.288104],[-76.740205,39.287709],[-76.739944,39.287421],[-76.739654,39.287124],[-76.739343,39.286823],[-76.739029,39.286529],[-76.738728,39.286262],[-76.738392,39.285993],[-76.738107,39.285774],[-76.737826,39.285574],[-76.737424,39.28531],[-76.737031,39.285066],[-76.736555,39.284799],[-76.736067,39.284529],[-76.735709,39.284333],[-76.734537,39.283691],[-76.731536,39.282051],[-76.731153,39.281842],[-76.730812,39.281655],[-76.728112,39.280177],[-76.727959,39.28009],[-76.727852,39.280028],[-76.727624,39.279887],[-76.727404,39.279739],[-76.727072,39.279488],[-76.726817,39.279274],[-76.726562,39.279006],[-76.726349,39.278755],[-76.726132,39.278459],[-76.725912,39.27808],[-76.725778,39.27779],[-76.72561,39.277342],[-76.725413,39.27673],[-76.724605,39.274189],[-76.724462,39.273756],[-76.724278,39.273317],[-76.724063,39.272908],[-76.723849,39.272581],[-76.72364,39.272305],[-76.723379,39.272011],[-76.72311,39.271748],[-76.722792,39.271476],[-76.722508,39.271257],[-76.722169,39.27102],[-76.721744,39.270758],[-76.720969,39.270274],[-76.711093,39.264598],[-76.708535,39.263146],[-76.707833,39.262757],[-76.707331,39.262485],[-76.706635,39.262113],[-76.703643,39.260533],[-76.702357,39.259822],[-76.700525,39.258828],[-76.700063,39.25858],[-76.699571,39.258329],[-76.699066,39.258095],[-76.698443,39.257836],[-76.697918,39.257642],[-76.697252,39.257422],[-76.695966,39.257083],[-76.693864,39.256518],[-76.692267,39.25609],[-76.690164,39.255534],[-76.689222,39.255289],[-76.688766,39.255155],[-76.688321,39.255009],[-76.687911,39.254872],[-76.687338,39.254677],[-76.686799,39.254473],[-76.685958,39.25412],[-76.685009,39.253621],[-76.684797,39.253488],[-76.68462,39.253359],[-76.684481,39.253244],[-76.684309,39.253086],[-76.684149,39.252907],[-76.684004,39.252723],[-76.683887,39.252537],[-76.683543,39.25186],[-76.683289,39.251394],[-76.682724,39.250285],[-76.6826,39.250047],[-76.68249,39.249891],[-76.682324,39.249691],[-76.682174,39.249544],[-76.682027,39.249433],[-76.681852,39.249319],[-76.681664,39.249211],[-76.681452,39.2491],[-76.681244,39.249019],[-76.680912,39.248931],[-76.680678,39.248883],[-76.68045,39.248858],[-76.680222,39.248851],[-76.679989,39.24886],[-76.679751,39.248878],[-76.679554,39.248907],[-76.679351,39.24895],[-76.679112,39.249018],[-76.678889,39.249102],[-76.678638,39.249227],[-76.678481,39.249319],[-76.678294,39.249456],[-76.678142,39.24958],[-76.677977,39.249745],[-76.677843,39.249919],[-76.67773,39.250077],[-76.677646,39.250263],[-76.677567,39.250479],[-76.676772,39.253297],[-76.676521,39.254059],[-76.676114,39.255583],[-76.675636,39.256747],[-76.675432,39.257204],[-76.675218,39.257667],[-76.674896,39.258289],[-76.674736,39.258587],[-76.674573,39.258892],[-76.673194,39.261117],[-76.672501,39.262168],[-76.672259,39.262504],[-76.672055,39.262762],[-76.671697,39.263132],[-76.671374,39.263428],[-76.670972,39.263749],[-76.670548,39.264037],[-76.670114,39.264298],[-76.669761,39.264484],[-76.669289,39.264705],[-76.666323,39.266013],[-76.664462,39.266838],[-76.662421,39.267757],[-76.66035,39.268688],[-76.660033,39.268828],[-76.657322,39.270013],[-76.655671,39.270734],[-76.655368,39.270853],[-76.655093,39.270954],[-76.654758,39.271057],[-76.654436,39.271145],[-76.654048,39.271229],[-76.653666,39.271294],[-76.653171,39.271349],[-76.65282,39.271373],[-76.65231,39.271389],[-76.651929,39.271378],[-76.651424,39.271349],[-76.649131,39.271145],[-76.64676,39.270925],[-76.643835,39.270638],[-76.642585,39.270539],[-76.641048,39.270389],[-76.640203,39.270305],[-76.639247,39.270205],[-76.637973,39.270041],[-76.637169,39.269918],[-76.635829,39.269721],[-76.634934,39.269575],[-76.634115,39.269428],[-76.632948,39.269212],[-76.631332,39.268818],[-76.630531,39.268633],[-76.630038,39.268499],[-76.629437,39.268318],[-76.628061,39.26786],[-76.62753,39.267702],[-76.627134,39.267604],[-76.62669,39.267517],[-76.626381,39.267483],[-76.626071,39.267472],[-76.625776,39.267484],[-76.625516,39.267514],[-76.625229,39.267571],[-76.624915,39.267658],[-76.6246,39.267778],[-76.624365,39.267892],[-76.624126,39.268044],[-76.623901,39.268227],[-76.623713,39.268394],[-76.623545,39.268592],[-76.623364,39.268842],[-76.623206,39.269091],[-76.622979,39.269493],[-76.622445,39.270658],[-76.621378,39.272947],[-76.620935,39.273956],[-76.620618,39.274914],[-76.620165,39.276023],[-76.619497,39.277456],[-76.619272,39.27795],[-76.619114,39.278359],[-76.618988,39.278762],[-76.618931,39.278951],[-76.618892,39.279079],[-76.618878,39.279167],[-76.618863,39.279245],[-76.618853,39.279329],[-76.618842,39.279402],[-76.618831,39.27949],[-76.618823,39.279572],[-76.618816,39.279643],[-76.618811,39.279708],[-76.618808,39.279773],[-76.6188,39.279958],[-76.618802,39.280067],[-76.618806,39.280286],[-76.618813,39.280393],[-76.618822,39.28063],[-76.618839,39.280956],[-76.618874,39.281621],[-76.618883,39.281897],[-76.618914,39.28245],[-76.618975,39.282779],[-76.619029,39.283561],[-76.619046,39.28386],[-76.619049,39.283986],[-76.61905,39.284021],[-76.619055,39.284116],[-76.619059,39.284206],[-76.61906,39.284267],[-76.619056,39.28439],[-76.619057,39.284522],[-76.619069,39.284824],[-76.619087,39.285107],[-76.619121,39.285179],[-76.619162,39.285264],[-76.619167,39.285348],[-76.619191,39.285756],[-76.619219,39.286223],[-76.619225,39.286314],[-76.619231,39.28641],[-76.619238,39.28652],[-76.619263,39.286903],[-76.619266,39.28698],[-76.619285,39.287506],[-76.619288,39.287564],[-76.619379,39.289351],[-76.61899,39.289366],[-76.618715,39.289377],[-76.618433,39.289388],[-76.61834,39.289392],[-76.618207,39.289398],[-76.618056,39.289405],[-76.61794,39.28941],[-76.617799,39.289417],[-76.617725,39.289419],[-76.617661,39.289421],[-76.616403,39.289478],[-76.616056,39.28949],[-76.615638,39.289505],[-76.615279,39.289518],[-76.615149,39.289523],[-76.615032,39.289528],[-76.614219,39.289564],[-76.613915,39.289574],[-76.613802,39.289578],[-76.613695,39.289581],[-76.613318,39.289599],[-76.61302,39.289612],[-76.612703,39.289625],[-76.612312,39.289644],[-76.61231,39.289796],[-76.612324,39.290052],[-76.612361,39.290443],[-76.612325,39.290506],[-76.612286,39.290576],[-76.612312,39.290967],[-76.612332,39.291034],[-76.612334,39.291042],[-76.612381,39.29111],[-76.612447,39.291199],[-76.611927,39.291219],[-76.611164,39.291251],[-76.611104,39.291254],[-76.611076,39.290887]],startDate:new Date(2017,10,3,11,0),endDate:new Date(2017,10,3,14,0),km:268,revenue:554.76,selected:false,drive:1,duty:2,off:1,berth:2,time:1,distance:50,fuel:185,tolls:35}]});

/***/ }),
/* 174 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
function isAbsolute(pathname) {
  return pathname.charAt(0) === '/';
}

// About 1.5x faster than the two-arg version of Array#splice()
function spliceOne(list, index) {
  for (var i = index, k = i + 1, n = list.length; k < n; i += 1, k += 1) {
    list[i] = list[k];
  }

  list.pop();
}

// This implementation is based heavily on node's url.parse
function resolvePathname(to) {
  var from = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

  var toParts = to && to.split('/') || [];
  var fromParts = from && from.split('/') || [];

  var isToAbs = to && isAbsolute(to);
  var isFromAbs = from && isAbsolute(from);
  var mustEndAbs = isToAbs || isFromAbs;

  if (to && isAbsolute(to)) {
    // to is absolute
    fromParts = toParts;
  } else if (toParts.length) {
    // to is relative, drop the filename
    fromParts.pop();
    fromParts = fromParts.concat(toParts);
  }

  if (!fromParts.length) return '/';

  var hasTrailingSlash = void 0;
  if (fromParts.length) {
    var last = fromParts[fromParts.length - 1];
    hasTrailingSlash = last === '.' || last === '..' || last === '';
  } else {
    hasTrailingSlash = false;
  }

  var up = 0;
  for (var i = fromParts.length; i >= 0; i--) {
    var part = fromParts[i];

    if (part === '.') {
      spliceOne(fromParts, i);
    } else if (part === '..') {
      spliceOne(fromParts, i);
      up++;
    } else if (up) {
      spliceOne(fromParts, i);
      up--;
    }
  }

  if (!mustEndAbs) for (; up--; up) {
    fromParts.unshift('..');
  }if (mustEndAbs && fromParts[0] !== '' && (!fromParts[0] || !isAbsolute(fromParts[0]))) fromParts.unshift('');

  var result = fromParts.join('/');

  if (hasTrailingSlash && result.substr(-1) !== '/') result += '/';

  return result;
}

/* harmony default export */ __webpack_exports__["default"] = (resolvePathname);

/***/ }),
/* 175 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function valueEqual(a, b) {
  if (a === b) return true;

  if (a == null || b == null) return false;

  if (Array.isArray(a)) {
    return Array.isArray(b) && a.length === b.length && a.every(function (item, index) {
      return valueEqual(item, b[index]);
    });
  }

  var aType = typeof a === 'undefined' ? 'undefined' : _typeof(a);
  var bType = typeof b === 'undefined' ? 'undefined' : _typeof(b);

  if (aType !== bType) return false;

  if (aType === 'object') {
    var aValue = a.valueOf();
    var bValue = b.valueOf();

    if (aValue !== a || bValue !== b) return valueEqual(aValue, bValue);

    var aKeys = Object.keys(a);
    var bKeys = Object.keys(b);

    if (aKeys.length !== bKeys.length) return false;

    return aKeys.every(function (key) {
      return valueEqual(a[key], b[key]);
    });
  }

  return false;
}

/* harmony default export */ __webpack_exports__["default"] = (valueEqual);

/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
var canUseDOM = exports.canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

var addEventListener = exports.addEventListener = function addEventListener(node, event, listener) {
  return node.addEventListener ? node.addEventListener(event, listener, false) : node.attachEvent('on' + event, listener);
};

var removeEventListener = exports.removeEventListener = function removeEventListener(node, event, listener) {
  return node.removeEventListener ? node.removeEventListener(event, listener, false) : node.detachEvent('on' + event, listener);
};

var getConfirmation = exports.getConfirmation = function getConfirmation(message, callback) {
  return callback(window.confirm(message));
}; // eslint-disable-line no-alert

/**
 * Returns true if the HTML5 history API is supported. Taken from Modernizr.
 *
 * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
 * changed to avoid false negatives for Windows Phones: https://github.com/reactjs/react-router/issues/586
 */
var supportsHistory = exports.supportsHistory = function supportsHistory() {
  var ua = window.navigator.userAgent;

  if ((ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) && ua.indexOf('Mobile Safari') !== -1 && ua.indexOf('Chrome') === -1 && ua.indexOf('Windows Phone') === -1) return false;

  return window.history && 'pushState' in window.history;
};

/**
 * Returns true if browser fires popstate on hash change.
 * IE10 and IE11 do not.
 */
var supportsPopStateOnHashChange = exports.supportsPopStateOnHashChange = function supportsPopStateOnHashChange() {
  return window.navigator.userAgent.indexOf('Trident') === -1;
};

/**
 * Returns false if using go(n) with hash history causes a full page reload.
 */
var supportsGoWithoutReloadUsingHash = exports.supportsGoWithoutReloadUsingHash = function supportsGoWithoutReloadUsingHash() {
  return window.navigator.userAgent.indexOf('Firefox') === -1;
};

/**
 * Returns true if a given popstate event is an extraneous WebKit event.
 * Accounts for the fact that Chrome on iOS fires real popstate events
 * containing undefined state when pressing the back button.
 */
var isExtraneousPopstateEvent = exports.isExtraneousPopstateEvent = function isExtraneousPopstateEvent(event) {
  return event.state === undefined && navigator.userAgent.indexOf('CriOS') === -1;
};

/***/ }),
/* 177 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_invariant__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var isModifiedEvent = function isModifiedEvent(event) {
  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
};

/**
 * The public API for rendering a history-aware <a>.
 */

var Link = function (_React$Component) {
  _inherits(Link, _React$Component);

  function Link() {
    var _temp, _this, _ret;

    _classCallCheck(this, Link);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.handleClick = function (event) {
      if (_this.props.onClick) _this.props.onClick(event);

      if (!event.defaultPrevented && // onClick prevented default
      event.button === 0 && // ignore right clicks
      !_this.props.target && // let browser handle "target=_blank" etc.
      !isModifiedEvent(event) // ignore clicks with modifier keys
      ) {
          event.preventDefault();

          var history = _this.context.router.history;
          var _this$props = _this.props,
              replace = _this$props.replace,
              to = _this$props.to;


          if (replace) {
            history.replace(to);
          } else {
            history.push(to);
          }
        }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Link.prototype.render = function render() {
    var _props = this.props,
        replace = _props.replace,
        to = _props.to,
        innerRef = _props.innerRef,
        props = _objectWithoutProperties(_props, ['replace', 'to', 'innerRef']); // eslint-disable-line no-unused-vars

    __WEBPACK_IMPORTED_MODULE_2_invariant___default()(this.context.router, 'You should not use <Link> outside a <Router>');

    var href = this.context.router.history.createHref(typeof to === 'string' ? { pathname: to } : to);

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', _extends({}, props, { onClick: this.handleClick, href: href, ref: innerRef }));
  };

  return Link;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Link.propTypes = {
  onClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  target: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  replace: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  to: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object]).isRequired,
  innerRef: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func])
};
Link.defaultProps = {
  replace: false
};
Link.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      push: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
      replace: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
      createHref: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
    }).isRequired
  }).isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Link);

/***/ }),
/* 178 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Route__ = __webpack_require__(179);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Route__["a" /* default */]);

/***/ }),
/* 179 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__matchPath__ = __webpack_require__(109);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var isEmptyChildren = function isEmptyChildren(children) {
  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.count(children) === 0;
};

/**
 * The public API for matching a single path and rendering.
 */

var Route = function (_React$Component) {
  _inherits(Route, _React$Component);

  function Route() {
    var _temp, _this, _ret;

    _classCallCheck(this, Route);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
      match: _this.computeMatch(_this.props, _this.context.router)
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Route.prototype.getChildContext = function getChildContext() {
    return {
      router: _extends({}, this.context.router, {
        route: {
          location: this.props.location || this.context.router.route.location,
          match: this.state.match
        }
      })
    };
  };

  Route.prototype.computeMatch = function computeMatch(_ref, router) {
    var computedMatch = _ref.computedMatch,
        location = _ref.location,
        path = _ref.path,
        strict = _ref.strict,
        exact = _ref.exact,
        sensitive = _ref.sensitive;

    if (computedMatch) return computedMatch; // <Switch> already computed the match for us

    __WEBPACK_IMPORTED_MODULE_1_invariant___default()(router, 'You should not use <Route> or withRouter() outside a <Router>');

    var route = router.route;

    var pathname = (location || route.location).pathname;

    return path ? Object(__WEBPACK_IMPORTED_MODULE_4__matchPath__["a" /* default */])(pathname, { path: path, strict: strict, exact: exact, sensitive: sensitive }) : route.match;
  };

  Route.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(this.props.component && this.props.render), 'You should not use <Route component> and <Route render> in the same route; <Route render> will be ignored');

    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(this.props.component && this.props.children && !isEmptyChildren(this.props.children)), 'You should not use <Route component> and <Route children> in the same route; <Route children> will be ignored');

    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(this.props.render && this.props.children && !isEmptyChildren(this.props.children)), 'You should not use <Route render> and <Route children> in the same route; <Route children> will be ignored');
  };

  Route.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps, nextContext) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(nextProps.location && !this.props.location), '<Route> elements should not change from uncontrolled to controlled (or vice versa). You initially used no "location" prop and then provided one on a subsequent render.');

    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(!nextProps.location && this.props.location), '<Route> elements should not change from controlled to uncontrolled (or vice versa). You provided a "location" prop initially but omitted it on a subsequent render.');

    this.setState({
      match: this.computeMatch(nextProps, nextContext.router)
    });
  };

  Route.prototype.render = function render() {
    var match = this.state.match;
    var _props = this.props,
        children = _props.children,
        component = _props.component,
        render = _props.render;
    var _context$router = this.context.router,
        history = _context$router.history,
        route = _context$router.route,
        staticContext = _context$router.staticContext;

    var location = this.props.location || route.location;
    var props = { match: match, location: location, history: history, staticContext: staticContext };

    return component ? // component prop gets first priority, only called if there's a match
    match ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(component, props) : null : render ? // render prop is next, only called if there's a match
    match ? render(props) : null : children ? // children come last, always called
    typeof children === 'function' ? children(props) : !isEmptyChildren(children) ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.only(children) : null : null;
  };

  return Route;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

Route.propTypes = {
  computedMatch: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object, // private, from <Switch>
  path: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  exact: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  strict: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  sensitive: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  component: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,
  render: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,
  children: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.node]),
  location: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
};
Route.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
    route: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
    staticContext: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
  })
};
Route.childContextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Route);

/***/ }),
/* 180 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return canUseDOM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return addEventListener; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return removeEventListener; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getConfirmation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return supportsHistory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return supportsPopStateOnHashChange; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return supportsGoWithoutReloadUsingHash; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return isExtraneousPopstateEvent; });
var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

var addEventListener = function addEventListener(node, event, listener) {
  return node.addEventListener ? node.addEventListener(event, listener, false) : node.attachEvent('on' + event, listener);
};

var removeEventListener = function removeEventListener(node, event, listener) {
  return node.removeEventListener ? node.removeEventListener(event, listener, false) : node.detachEvent('on' + event, listener);
};

var getConfirmation = function getConfirmation(message, callback) {
  return callback(window.confirm(message));
}; // eslint-disable-line no-alert

/**
 * Returns true if the HTML5 history API is supported. Taken from Modernizr.
 *
 * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
 * changed to avoid false negatives for Windows Phones: https://github.com/reactjs/react-router/issues/586
 */
var supportsHistory = function supportsHistory() {
  var ua = window.navigator.userAgent;

  if ((ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) && ua.indexOf('Mobile Safari') !== -1 && ua.indexOf('Chrome') === -1 && ua.indexOf('Windows Phone') === -1) return false;

  return window.history && 'pushState' in window.history;
};

/**
 * Returns true if browser fires popstate on hash change.
 * IE10 and IE11 do not.
 */
var supportsPopStateOnHashChange = function supportsPopStateOnHashChange() {
  return window.navigator.userAgent.indexOf('Trident') === -1;
};

/**
 * Returns false if using go(n) with hash history causes a full page reload.
 */
var supportsGoWithoutReloadUsingHash = function supportsGoWithoutReloadUsingHash() {
  return window.navigator.userAgent.indexOf('Firefox') === -1;
};

/**
 * Returns true if a given popstate event is an extraneous WebKit event.
 * Accounts for the fact that Chrome on iOS fires real popstate events
 * containing undefined state when pressing the back button.
 */
var isExtraneousPopstateEvent = function isExtraneousPopstateEvent(event) {
  return event.state === undefined && navigator.userAgent.indexOf('CriOS') === -1;
};

/***/ }),
/* 181 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(9));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	(function (Math) {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var WordArray = C_lib.WordArray;
	    var Hasher = C_lib.Hasher;
	    var C_algo = C.algo;

	    // Initialization and round constants tables
	    var H = [];
	    var K = [];

	    // Compute constants
	    (function () {
	        function isPrime(n) {
	            var sqrtN = Math.sqrt(n);
	            for (var factor = 2; factor <= sqrtN; factor++) {
	                if (!(n % factor)) {
	                    return false;
	                }
	            }

	            return true;
	        }

	        function getFractionalBits(n) {
	            return ((n - (n | 0)) * 0x100000000) | 0;
	        }

	        var n = 2;
	        var nPrime = 0;
	        while (nPrime < 64) {
	            if (isPrime(n)) {
	                if (nPrime < 8) {
	                    H[nPrime] = getFractionalBits(Math.pow(n, 1 / 2));
	                }
	                K[nPrime] = getFractionalBits(Math.pow(n, 1 / 3));

	                nPrime++;
	            }

	            n++;
	        }
	    }());

	    // Reusable object
	    var W = [];

	    /**
	     * SHA-256 hash algorithm.
	     */
	    var SHA256 = C_algo.SHA256 = Hasher.extend({
	        _doReset: function () {
	            this._hash = new WordArray.init(H.slice(0));
	        },

	        _doProcessBlock: function (M, offset) {
	            // Shortcut
	            var H = this._hash.words;

	            // Working variables
	            var a = H[0];
	            var b = H[1];
	            var c = H[2];
	            var d = H[3];
	            var e = H[4];
	            var f = H[5];
	            var g = H[6];
	            var h = H[7];

	            // Computation
	            for (var i = 0; i < 64; i++) {
	                if (i < 16) {
	                    W[i] = M[offset + i] | 0;
	                } else {
	                    var gamma0x = W[i - 15];
	                    var gamma0  = ((gamma0x << 25) | (gamma0x >>> 7))  ^
	                                  ((gamma0x << 14) | (gamma0x >>> 18)) ^
	                                   (gamma0x >>> 3);

	                    var gamma1x = W[i - 2];
	                    var gamma1  = ((gamma1x << 15) | (gamma1x >>> 17)) ^
	                                  ((gamma1x << 13) | (gamma1x >>> 19)) ^
	                                   (gamma1x >>> 10);

	                    W[i] = gamma0 + W[i - 7] + gamma1 + W[i - 16];
	                }

	                var ch  = (e & f) ^ (~e & g);
	                var maj = (a & b) ^ (a & c) ^ (b & c);

	                var sigma0 = ((a << 30) | (a >>> 2)) ^ ((a << 19) | (a >>> 13)) ^ ((a << 10) | (a >>> 22));
	                var sigma1 = ((e << 26) | (e >>> 6)) ^ ((e << 21) | (e >>> 11)) ^ ((e << 7)  | (e >>> 25));

	                var t1 = h + sigma1 + ch + K[i] + W[i];
	                var t2 = sigma0 + maj;

	                h = g;
	                g = f;
	                f = e;
	                e = (d + t1) | 0;
	                d = c;
	                c = b;
	                b = a;
	                a = (t1 + t2) | 0;
	            }

	            // Intermediate hash value
	            H[0] = (H[0] + a) | 0;
	            H[1] = (H[1] + b) | 0;
	            H[2] = (H[2] + c) | 0;
	            H[3] = (H[3] + d) | 0;
	            H[4] = (H[4] + e) | 0;
	            H[5] = (H[5] + f) | 0;
	            H[6] = (H[6] + g) | 0;
	            H[7] = (H[7] + h) | 0;
	        },

	        _doFinalize: function () {
	            // Shortcuts
	            var data = this._data;
	            var dataWords = data.words;

	            var nBitsTotal = this._nDataBytes * 8;
	            var nBitsLeft = data.sigBytes * 8;

	            // Add padding
	            dataWords[nBitsLeft >>> 5] |= 0x80 << (24 - nBitsLeft % 32);
	            dataWords[(((nBitsLeft + 64) >>> 9) << 4) + 14] = Math.floor(nBitsTotal / 0x100000000);
	            dataWords[(((nBitsLeft + 64) >>> 9) << 4) + 15] = nBitsTotal;
	            data.sigBytes = dataWords.length * 4;

	            // Hash final blocks
	            this._process();

	            // Return final computed hash
	            return this._hash;
	        },

	        clone: function () {
	            var clone = Hasher.clone.call(this);
	            clone._hash = this._hash.clone();

	            return clone;
	        }
	    });

	    /**
	     * Shortcut function to the hasher's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     *
	     * @return {WordArray} The hash.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hash = CryptoJS.SHA256('message');
	     *     var hash = CryptoJS.SHA256(wordArray);
	     */
	    C.SHA256 = Hasher._createHelper(SHA256);

	    /**
	     * Shortcut function to the HMAC's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     * @param {WordArray|string} key The secret key.
	     *
	     * @return {WordArray} The HMAC.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hmac = CryptoJS.HmacSHA256(message, key);
	     */
	    C.HmacSHA256 = Hasher._createHmacHelper(SHA256);
	}(Math));


	return CryptoJS.SHA256;

}));

/***/ }),
/* 182 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory, undef) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(9), __webpack_require__(73));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core", "./x64-core"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	(function () {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var Hasher = C_lib.Hasher;
	    var C_x64 = C.x64;
	    var X64Word = C_x64.Word;
	    var X64WordArray = C_x64.WordArray;
	    var C_algo = C.algo;

	    function X64Word_create() {
	        return X64Word.create.apply(X64Word, arguments);
	    }

	    // Constants
	    var K = [
	        X64Word_create(0x428a2f98, 0xd728ae22), X64Word_create(0x71374491, 0x23ef65cd),
	        X64Word_create(0xb5c0fbcf, 0xec4d3b2f), X64Word_create(0xe9b5dba5, 0x8189dbbc),
	        X64Word_create(0x3956c25b, 0xf348b538), X64Word_create(0x59f111f1, 0xb605d019),
	        X64Word_create(0x923f82a4, 0xaf194f9b), X64Word_create(0xab1c5ed5, 0xda6d8118),
	        X64Word_create(0xd807aa98, 0xa3030242), X64Word_create(0x12835b01, 0x45706fbe),
	        X64Word_create(0x243185be, 0x4ee4b28c), X64Word_create(0x550c7dc3, 0xd5ffb4e2),
	        X64Word_create(0x72be5d74, 0xf27b896f), X64Word_create(0x80deb1fe, 0x3b1696b1),
	        X64Word_create(0x9bdc06a7, 0x25c71235), X64Word_create(0xc19bf174, 0xcf692694),
	        X64Word_create(0xe49b69c1, 0x9ef14ad2), X64Word_create(0xefbe4786, 0x384f25e3),
	        X64Word_create(0x0fc19dc6, 0x8b8cd5b5), X64Word_create(0x240ca1cc, 0x77ac9c65),
	        X64Word_create(0x2de92c6f, 0x592b0275), X64Word_create(0x4a7484aa, 0x6ea6e483),
	        X64Word_create(0x5cb0a9dc, 0xbd41fbd4), X64Word_create(0x76f988da, 0x831153b5),
	        X64Word_create(0x983e5152, 0xee66dfab), X64Word_create(0xa831c66d, 0x2db43210),
	        X64Word_create(0xb00327c8, 0x98fb213f), X64Word_create(0xbf597fc7, 0xbeef0ee4),
	        X64Word_create(0xc6e00bf3, 0x3da88fc2), X64Word_create(0xd5a79147, 0x930aa725),
	        X64Word_create(0x06ca6351, 0xe003826f), X64Word_create(0x14292967, 0x0a0e6e70),
	        X64Word_create(0x27b70a85, 0x46d22ffc), X64Word_create(0x2e1b2138, 0x5c26c926),
	        X64Word_create(0x4d2c6dfc, 0x5ac42aed), X64Word_create(0x53380d13, 0x9d95b3df),
	        X64Word_create(0x650a7354, 0x8baf63de), X64Word_create(0x766a0abb, 0x3c77b2a8),
	        X64Word_create(0x81c2c92e, 0x47edaee6), X64Word_create(0x92722c85, 0x1482353b),
	        X64Word_create(0xa2bfe8a1, 0x4cf10364), X64Word_create(0xa81a664b, 0xbc423001),
	        X64Word_create(0xc24b8b70, 0xd0f89791), X64Word_create(0xc76c51a3, 0x0654be30),
	        X64Word_create(0xd192e819, 0xd6ef5218), X64Word_create(0xd6990624, 0x5565a910),
	        X64Word_create(0xf40e3585, 0x5771202a), X64Word_create(0x106aa070, 0x32bbd1b8),
	        X64Word_create(0x19a4c116, 0xb8d2d0c8), X64Word_create(0x1e376c08, 0x5141ab53),
	        X64Word_create(0x2748774c, 0xdf8eeb99), X64Word_create(0x34b0bcb5, 0xe19b48a8),
	        X64Word_create(0x391c0cb3, 0xc5c95a63), X64Word_create(0x4ed8aa4a, 0xe3418acb),
	        X64Word_create(0x5b9cca4f, 0x7763e373), X64Word_create(0x682e6ff3, 0xd6b2b8a3),
	        X64Word_create(0x748f82ee, 0x5defb2fc), X64Word_create(0x78a5636f, 0x43172f60),
	        X64Word_create(0x84c87814, 0xa1f0ab72), X64Word_create(0x8cc70208, 0x1a6439ec),
	        X64Word_create(0x90befffa, 0x23631e28), X64Word_create(0xa4506ceb, 0xde82bde9),
	        X64Word_create(0xbef9a3f7, 0xb2c67915), X64Word_create(0xc67178f2, 0xe372532b),
	        X64Word_create(0xca273ece, 0xea26619c), X64Word_create(0xd186b8c7, 0x21c0c207),
	        X64Word_create(0xeada7dd6, 0xcde0eb1e), X64Word_create(0xf57d4f7f, 0xee6ed178),
	        X64Word_create(0x06f067aa, 0x72176fba), X64Word_create(0x0a637dc5, 0xa2c898a6),
	        X64Word_create(0x113f9804, 0xbef90dae), X64Word_create(0x1b710b35, 0x131c471b),
	        X64Word_create(0x28db77f5, 0x23047d84), X64Word_create(0x32caab7b, 0x40c72493),
	        X64Word_create(0x3c9ebe0a, 0x15c9bebc), X64Word_create(0x431d67c4, 0x9c100d4c),
	        X64Word_create(0x4cc5d4be, 0xcb3e42b6), X64Word_create(0x597f299c, 0xfc657e2a),
	        X64Word_create(0x5fcb6fab, 0x3ad6faec), X64Word_create(0x6c44198c, 0x4a475817)
	    ];

	    // Reusable objects
	    var W = [];
	    (function () {
	        for (var i = 0; i < 80; i++) {
	            W[i] = X64Word_create();
	        }
	    }());

	    /**
	     * SHA-512 hash algorithm.
	     */
	    var SHA512 = C_algo.SHA512 = Hasher.extend({
	        _doReset: function () {
	            this._hash = new X64WordArray.init([
	                new X64Word.init(0x6a09e667, 0xf3bcc908), new X64Word.init(0xbb67ae85, 0x84caa73b),
	                new X64Word.init(0x3c6ef372, 0xfe94f82b), new X64Word.init(0xa54ff53a, 0x5f1d36f1),
	                new X64Word.init(0x510e527f, 0xade682d1), new X64Word.init(0x9b05688c, 0x2b3e6c1f),
	                new X64Word.init(0x1f83d9ab, 0xfb41bd6b), new X64Word.init(0x5be0cd19, 0x137e2179)
	            ]);
	        },

	        _doProcessBlock: function (M, offset) {
	            // Shortcuts
	            var H = this._hash.words;

	            var H0 = H[0];
	            var H1 = H[1];
	            var H2 = H[2];
	            var H3 = H[3];
	            var H4 = H[4];
	            var H5 = H[5];
	            var H6 = H[6];
	            var H7 = H[7];

	            var H0h = H0.high;
	            var H0l = H0.low;
	            var H1h = H1.high;
	            var H1l = H1.low;
	            var H2h = H2.high;
	            var H2l = H2.low;
	            var H3h = H3.high;
	            var H3l = H3.low;
	            var H4h = H4.high;
	            var H4l = H4.low;
	            var H5h = H5.high;
	            var H5l = H5.low;
	            var H6h = H6.high;
	            var H6l = H6.low;
	            var H7h = H7.high;
	            var H7l = H7.low;

	            // Working variables
	            var ah = H0h;
	            var al = H0l;
	            var bh = H1h;
	            var bl = H1l;
	            var ch = H2h;
	            var cl = H2l;
	            var dh = H3h;
	            var dl = H3l;
	            var eh = H4h;
	            var el = H4l;
	            var fh = H5h;
	            var fl = H5l;
	            var gh = H6h;
	            var gl = H6l;
	            var hh = H7h;
	            var hl = H7l;

	            // Rounds
	            for (var i = 0; i < 80; i++) {
	                // Shortcut
	                var Wi = W[i];

	                // Extend message
	                if (i < 16) {
	                    var Wih = Wi.high = M[offset + i * 2]     | 0;
	                    var Wil = Wi.low  = M[offset + i * 2 + 1] | 0;
	                } else {
	                    // Gamma0
	                    var gamma0x  = W[i - 15];
	                    var gamma0xh = gamma0x.high;
	                    var gamma0xl = gamma0x.low;
	                    var gamma0h  = ((gamma0xh >>> 1) | (gamma0xl << 31)) ^ ((gamma0xh >>> 8) | (gamma0xl << 24)) ^ (gamma0xh >>> 7);
	                    var gamma0l  = ((gamma0xl >>> 1) | (gamma0xh << 31)) ^ ((gamma0xl >>> 8) | (gamma0xh << 24)) ^ ((gamma0xl >>> 7) | (gamma0xh << 25));

	                    // Gamma1
	                    var gamma1x  = W[i - 2];
	                    var gamma1xh = gamma1x.high;
	                    var gamma1xl = gamma1x.low;
	                    var gamma1h  = ((gamma1xh >>> 19) | (gamma1xl << 13)) ^ ((gamma1xh << 3) | (gamma1xl >>> 29)) ^ (gamma1xh >>> 6);
	                    var gamma1l  = ((gamma1xl >>> 19) | (gamma1xh << 13)) ^ ((gamma1xl << 3) | (gamma1xh >>> 29)) ^ ((gamma1xl >>> 6) | (gamma1xh << 26));

	                    // W[i] = gamma0 + W[i - 7] + gamma1 + W[i - 16]
	                    var Wi7  = W[i - 7];
	                    var Wi7h = Wi7.high;
	                    var Wi7l = Wi7.low;

	                    var Wi16  = W[i - 16];
	                    var Wi16h = Wi16.high;
	                    var Wi16l = Wi16.low;

	                    var Wil = gamma0l + Wi7l;
	                    var Wih = gamma0h + Wi7h + ((Wil >>> 0) < (gamma0l >>> 0) ? 1 : 0);
	                    var Wil = Wil + gamma1l;
	                    var Wih = Wih + gamma1h + ((Wil >>> 0) < (gamma1l >>> 0) ? 1 : 0);
	                    var Wil = Wil + Wi16l;
	                    var Wih = Wih + Wi16h + ((Wil >>> 0) < (Wi16l >>> 0) ? 1 : 0);

	                    Wi.high = Wih;
	                    Wi.low  = Wil;
	                }

	                var chh  = (eh & fh) ^ (~eh & gh);
	                var chl  = (el & fl) ^ (~el & gl);
	                var majh = (ah & bh) ^ (ah & ch) ^ (bh & ch);
	                var majl = (al & bl) ^ (al & cl) ^ (bl & cl);

	                var sigma0h = ((ah >>> 28) | (al << 4))  ^ ((ah << 30)  | (al >>> 2)) ^ ((ah << 25) | (al >>> 7));
	                var sigma0l = ((al >>> 28) | (ah << 4))  ^ ((al << 30)  | (ah >>> 2)) ^ ((al << 25) | (ah >>> 7));
	                var sigma1h = ((eh >>> 14) | (el << 18)) ^ ((eh >>> 18) | (el << 14)) ^ ((eh << 23) | (el >>> 9));
	                var sigma1l = ((el >>> 14) | (eh << 18)) ^ ((el >>> 18) | (eh << 14)) ^ ((el << 23) | (eh >>> 9));

	                // t1 = h + sigma1 + ch + K[i] + W[i]
	                var Ki  = K[i];
	                var Kih = Ki.high;
	                var Kil = Ki.low;

	                var t1l = hl + sigma1l;
	                var t1h = hh + sigma1h + ((t1l >>> 0) < (hl >>> 0) ? 1 : 0);
	                var t1l = t1l + chl;
	                var t1h = t1h + chh + ((t1l >>> 0) < (chl >>> 0) ? 1 : 0);
	                var t1l = t1l + Kil;
	                var t1h = t1h + Kih + ((t1l >>> 0) < (Kil >>> 0) ? 1 : 0);
	                var t1l = t1l + Wil;
	                var t1h = t1h + Wih + ((t1l >>> 0) < (Wil >>> 0) ? 1 : 0);

	                // t2 = sigma0 + maj
	                var t2l = sigma0l + majl;
	                var t2h = sigma0h + majh + ((t2l >>> 0) < (sigma0l >>> 0) ? 1 : 0);

	                // Update working variables
	                hh = gh;
	                hl = gl;
	                gh = fh;
	                gl = fl;
	                fh = eh;
	                fl = el;
	                el = (dl + t1l) | 0;
	                eh = (dh + t1h + ((el >>> 0) < (dl >>> 0) ? 1 : 0)) | 0;
	                dh = ch;
	                dl = cl;
	                ch = bh;
	                cl = bl;
	                bh = ah;
	                bl = al;
	                al = (t1l + t2l) | 0;
	                ah = (t1h + t2h + ((al >>> 0) < (t1l >>> 0) ? 1 : 0)) | 0;
	            }

	            // Intermediate hash value
	            H0l = H0.low  = (H0l + al);
	            H0.high = (H0h + ah + ((H0l >>> 0) < (al >>> 0) ? 1 : 0));
	            H1l = H1.low  = (H1l + bl);
	            H1.high = (H1h + bh + ((H1l >>> 0) < (bl >>> 0) ? 1 : 0));
	            H2l = H2.low  = (H2l + cl);
	            H2.high = (H2h + ch + ((H2l >>> 0) < (cl >>> 0) ? 1 : 0));
	            H3l = H3.low  = (H3l + dl);
	            H3.high = (H3h + dh + ((H3l >>> 0) < (dl >>> 0) ? 1 : 0));
	            H4l = H4.low  = (H4l + el);
	            H4.high = (H4h + eh + ((H4l >>> 0) < (el >>> 0) ? 1 : 0));
	            H5l = H5.low  = (H5l + fl);
	            H5.high = (H5h + fh + ((H5l >>> 0) < (fl >>> 0) ? 1 : 0));
	            H6l = H6.low  = (H6l + gl);
	            H6.high = (H6h + gh + ((H6l >>> 0) < (gl >>> 0) ? 1 : 0));
	            H7l = H7.low  = (H7l + hl);
	            H7.high = (H7h + hh + ((H7l >>> 0) < (hl >>> 0) ? 1 : 0));
	        },

	        _doFinalize: function () {
	            // Shortcuts
	            var data = this._data;
	            var dataWords = data.words;

	            var nBitsTotal = this._nDataBytes * 8;
	            var nBitsLeft = data.sigBytes * 8;

	            // Add padding
	            dataWords[nBitsLeft >>> 5] |= 0x80 << (24 - nBitsLeft % 32);
	            dataWords[(((nBitsLeft + 128) >>> 10) << 5) + 30] = Math.floor(nBitsTotal / 0x100000000);
	            dataWords[(((nBitsLeft + 128) >>> 10) << 5) + 31] = nBitsTotal;
	            data.sigBytes = dataWords.length * 4;

	            // Hash final blocks
	            this._process();

	            // Convert hash to 32-bit word array before returning
	            var hash = this._hash.toX32();

	            // Return final computed hash
	            return hash;
	        },

	        clone: function () {
	            var clone = Hasher.clone.call(this);
	            clone._hash = this._hash.clone();

	            return clone;
	        },

	        blockSize: 1024/32
	    });

	    /**
	     * Shortcut function to the hasher's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     *
	     * @return {WordArray} The hash.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hash = CryptoJS.SHA512('message');
	     *     var hash = CryptoJS.SHA512(wordArray);
	     */
	    C.SHA512 = Hasher._createHelper(SHA512);

	    /**
	     * Shortcut function to the HMAC's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     * @param {WordArray|string} key The secret key.
	     *
	     * @return {WordArray} The HMAC.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hmac = CryptoJS.HmacSHA512(message, key);
	     */
	    C.HmacSHA512 = Hasher._createHmacHelper(SHA512);
	}());


	return CryptoJS.SHA512;

}));

/***/ }),
/* 183 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(184);
module.exports = __webpack_require__(190);


/***/ }),
/* 184 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// @remove-on-eject-begin
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
// @remove-on-eject-end


if (typeof Promise === 'undefined') {
  // Rejection tracking prevents a common issue where React gets into an
  // inconsistent state due to an error, but it gets swallowed by a Promise,
  // and the user has no idea what causes React's erratic future behavior.
  __webpack_require__(185).enable();
  window.Promise = __webpack_require__(188);
}

// fetch() polyfill for making API calls.
__webpack_require__(189);

// Object.assign() is commonly used with React.
// It will use the native implementation if it's present and isn't buggy.
Object.assign = __webpack_require__(24);


/***/ }),
/* 185 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Promise = __webpack_require__(113);

var DEFAULT_WHITELIST = [
  ReferenceError,
  TypeError,
  RangeError
];

var enabled = false;
exports.disable = disable;
function disable() {
  enabled = false;
  Promise._47 = null;
  Promise._71 = null;
}

exports.enable = enable;
function enable(options) {
  options = options || {};
  if (enabled) disable();
  enabled = true;
  var id = 0;
  var displayId = 0;
  var rejections = {};
  Promise._47 = function (promise) {
    if (
      promise._83 === 2 && // IS REJECTED
      rejections[promise._56]
    ) {
      if (rejections[promise._56].logged) {
        onHandled(promise._56);
      } else {
        clearTimeout(rejections[promise._56].timeout);
      }
      delete rejections[promise._56];
    }
  };
  Promise._71 = function (promise, err) {
    if (promise._75 === 0) { // not yet handled
      promise._56 = id++;
      rejections[promise._56] = {
        displayId: null,
        error: err,
        timeout: setTimeout(
          onUnhandled.bind(null, promise._56),
          // For reference errors and type errors, this almost always
          // means the programmer made a mistake, so log them after just
          // 100ms
          // otherwise, wait 2 seconds to see if they get handled
          matchWhitelist(err, DEFAULT_WHITELIST)
            ? 100
            : 2000
        ),
        logged: false
      };
    }
  };
  function onUnhandled(id) {
    if (
      options.allRejections ||
      matchWhitelist(
        rejections[id].error,
        options.whitelist || DEFAULT_WHITELIST
      )
    ) {
      rejections[id].displayId = displayId++;
      if (options.onUnhandled) {
        rejections[id].logged = true;
        options.onUnhandled(
          rejections[id].displayId,
          rejections[id].error
        );
      } else {
        rejections[id].logged = true;
        logError(
          rejections[id].displayId,
          rejections[id].error
        );
      }
    }
  }
  function onHandled(id) {
    if (rejections[id].logged) {
      if (options.onHandled) {
        options.onHandled(rejections[id].displayId, rejections[id].error);
      } else if (!rejections[id].onUnhandled) {
        console.warn(
          'Promise Rejection Handled (id: ' + rejections[id].displayId + '):'
        );
        console.warn(
          '  This means you can ignore any previous messages of the form "Possible Unhandled Promise Rejection" with id ' +
          rejections[id].displayId + '.'
        );
      }
    }
  }
}

function logError(id, error) {
  console.warn('Possible Unhandled Promise Rejection (id: ' + id + '):');
  var errStr = (error && (error.stack || error)) + '';
  errStr.split('\n').forEach(function (line) {
    console.warn('  ' + line);
  });
}

function matchWhitelist(error, list) {
  return list.some(function (cls) {
    return error instanceof cls;
  });
}

/***/ }),
/* 186 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

// Use the fastest means possible to execute a task in its own turn, with
// priority over other events including IO, animation, reflow, and redraw
// events in browsers.
//
// An exception thrown by a task will permanently interrupt the processing of
// subsequent tasks. The higher level `asap` function ensures that if an
// exception is thrown by a task, that the task queue will continue flushing as
// soon as possible, but if you use `rawAsap` directly, you are responsible to
// either ensure that no exceptions are thrown from your task, or to manually
// call `rawAsap.requestFlush` if an exception is thrown.
module.exports = rawAsap;
function rawAsap(task) {
    if (!queue.length) {
        requestFlush();
        flushing = true;
    }
    // Equivalent to push, but avoids a function call.
    queue[queue.length] = task;
}

var queue = [];
// Once a flush has been requested, no further calls to `requestFlush` are
// necessary until the next `flush` completes.
var flushing = false;
// `requestFlush` is an implementation-specific method that attempts to kick
// off a `flush` event as quickly as possible. `flush` will attempt to exhaust
// the event queue before yielding to the browser's own event loop.
var requestFlush;
// The position of the next task to execute in the task queue. This is
// preserved between calls to `flush` so that it can be resumed if
// a task throws an exception.
var index = 0;
// If a task schedules additional tasks recursively, the task queue can grow
// unbounded. To prevent memory exhaustion, the task queue will periodically
// truncate already-completed tasks.
var capacity = 1024;

// The flush function processes all tasks that have been scheduled with
// `rawAsap` unless and until one of those tasks throws an exception.
// If a task throws an exception, `flush` ensures that its state will remain
// consistent and will resume where it left off when called again.
// However, `flush` does not make any arrangements to be called again if an
// exception is thrown.
function flush() {
    while (index < queue.length) {
        var currentIndex = index;
        // Advance the index before calling the task. This ensures that we will
        // begin flushing on the next task the task throws an error.
        index = index + 1;
        queue[currentIndex].call();
        // Prevent leaking memory for long chains of recursive calls to `asap`.
        // If we call `asap` within tasks scheduled by `asap`, the queue will
        // grow, but to avoid an O(n) walk for every task we execute, we don't
        // shift tasks off the queue after they have been executed.
        // Instead, we periodically shift 1024 tasks off the queue.
        if (index > capacity) {
            // Manually shift all values starting at the index back to the
            // beginning of the queue.
            for (var scan = 0, newLength = queue.length - index; scan < newLength; scan++) {
                queue[scan] = queue[scan + index];
            }
            queue.length -= index;
            index = 0;
        }
    }
    queue.length = 0;
    index = 0;
    flushing = false;
}

// `requestFlush` is implemented using a strategy based on data collected from
// every available SauceLabs Selenium web driver worker at time of writing.
// https://docs.google.com/spreadsheets/d/1mG-5UYGup5qxGdEMWkhP6BWCz053NUb2E1QoUTU16uA/edit#gid=783724593

// Safari 6 and 6.1 for desktop, iPad, and iPhone are the only browsers that
// have WebKitMutationObserver but not un-prefixed MutationObserver.
// Must use `global` or `self` instead of `window` to work in both frames and web
// workers. `global` is a provision of Browserify, Mr, Mrs, or Mop.

/* globals self */
var scope = typeof global !== "undefined" ? global : self;
var BrowserMutationObserver = scope.MutationObserver || scope.WebKitMutationObserver;

// MutationObservers are desirable because they have high priority and work
// reliably everywhere they are implemented.
// They are implemented in all modern browsers.
//
// - Android 4-4.3
// - Chrome 26-34
// - Firefox 14-29
// - Internet Explorer 11
// - iPad Safari 6-7.1
// - iPhone Safari 7-7.1
// - Safari 6-7
if (typeof BrowserMutationObserver === "function") {
    requestFlush = makeRequestCallFromMutationObserver(flush);

// MessageChannels are desirable because they give direct access to the HTML
// task queue, are implemented in Internet Explorer 10, Safari 5.0-1, and Opera
// 11-12, and in web workers in many engines.
// Although message channels yield to any queued rendering and IO tasks, they
// would be better than imposing the 4ms delay of timers.
// However, they do not work reliably in Internet Explorer or Safari.

// Internet Explorer 10 is the only browser that has setImmediate but does
// not have MutationObservers.
// Although setImmediate yields to the browser's renderer, it would be
// preferrable to falling back to setTimeout since it does not have
// the minimum 4ms penalty.
// Unfortunately there appears to be a bug in Internet Explorer 10 Mobile (and
// Desktop to a lesser extent) that renders both setImmediate and
// MessageChannel useless for the purposes of ASAP.
// https://github.com/kriskowal/q/issues/396

// Timers are implemented universally.
// We fall back to timers in workers in most engines, and in foreground
// contexts in the following browsers.
// However, note that even this simple case requires nuances to operate in a
// broad spectrum of browsers.
//
// - Firefox 3-13
// - Internet Explorer 6-9
// - iPad Safari 4.3
// - Lynx 2.8.7
} else {
    requestFlush = makeRequestCallFromTimer(flush);
}

// `requestFlush` requests that the high priority event queue be flushed as
// soon as possible.
// This is useful to prevent an error thrown in a task from stalling the event
// queue if the exception handled by Node.js’s
// `process.on("uncaughtException")` or by a domain.
rawAsap.requestFlush = requestFlush;

// To request a high priority event, we induce a mutation observer by toggling
// the text of a text node between "1" and "-1".
function makeRequestCallFromMutationObserver(callback) {
    var toggle = 1;
    var observer = new BrowserMutationObserver(callback);
    var node = document.createTextNode("");
    observer.observe(node, {characterData: true});
    return function requestCall() {
        toggle = -toggle;
        node.data = toggle;
    };
}

// The message channel technique was discovered by Malte Ubl and was the
// original foundation for this library.
// http://www.nonblocking.io/2011/06/windownexttick.html

// Safari 6.0.5 (at least) intermittently fails to create message ports on a
// page's first load. Thankfully, this version of Safari supports
// MutationObservers, so we don't need to fall back in that case.

// function makeRequestCallFromMessageChannel(callback) {
//     var channel = new MessageChannel();
//     channel.port1.onmessage = callback;
//     return function requestCall() {
//         channel.port2.postMessage(0);
//     };
// }

// For reasons explained above, we are also unable to use `setImmediate`
// under any circumstances.
// Even if we were, there is another bug in Internet Explorer 10.
// It is not sufficient to assign `setImmediate` to `requestFlush` because
// `setImmediate` must be called *by name* and therefore must be wrapped in a
// closure.
// Never forget.

// function makeRequestCallFromSetImmediate(callback) {
//     return function requestCall() {
//         setImmediate(callback);
//     };
// }

// Safari 6.0 has a problem where timers will get lost while the user is
// scrolling. This problem does not impact ASAP because Safari 6.0 supports
// mutation observers, so that implementation is used instead.
// However, if we ever elect to use timers in Safari, the prevalent work-around
// is to add a scroll event listener that calls for a flush.

// `setTimeout` does not call the passed callback if the delay is less than
// approximately 7 in web workers in Firefox 8 through 18, and sometimes not
// even then.

function makeRequestCallFromTimer(callback) {
    return function requestCall() {
        // We dispatch a timeout with a specified delay of 0 for engines that
        // can reliably accommodate that request. This will usually be snapped
        // to a 4 milisecond delay, but once we're flushing, there's no delay
        // between events.
        var timeoutHandle = setTimeout(handleTimer, 0);
        // However, since this timer gets frequently dropped in Firefox
        // workers, we enlist an interval handle that will try to fire
        // an event 20 times per second until it succeeds.
        var intervalHandle = setInterval(handleTimer, 50);

        function handleTimer() {
            // Whichever timer succeeds will cancel both timers and
            // execute the callback.
            clearTimeout(timeoutHandle);
            clearInterval(intervalHandle);
            callback();
        }
    };
}

// This is for `asap.js` only.
// Its name will be periodically randomized to break any code that depends on
// its existence.
rawAsap.makeRequestCallFromTimer = makeRequestCallFromTimer;

// ASAP was originally a nextTick shim included in Q. This was factored out
// into this ASAP package. It was later adapted to RSVP which made further
// amendments. These decisions, particularly to marginalize MessageChannel and
// to capture the MutationObserver implementation in a closure, were integrated
// back into ASAP proper.
// https://github.com/tildeio/rsvp.js/blob/cddf7232546a9cf858524b75cde6f9edf72620a7/lib/rsvp/asap.js

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(187)))

/***/ }),
/* 187 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 188 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//This file contains the ES6 extensions to the core Promises/A+ API

var Promise = __webpack_require__(113);

module.exports = Promise;

/* Static Functions */

var TRUE = valuePromise(true);
var FALSE = valuePromise(false);
var NULL = valuePromise(null);
var UNDEFINED = valuePromise(undefined);
var ZERO = valuePromise(0);
var EMPTYSTRING = valuePromise('');

function valuePromise(value) {
  var p = new Promise(Promise._44);
  p._83 = 1;
  p._18 = value;
  return p;
}
Promise.resolve = function (value) {
  if (value instanceof Promise) return value;

  if (value === null) return NULL;
  if (value === undefined) return UNDEFINED;
  if (value === true) return TRUE;
  if (value === false) return FALSE;
  if (value === 0) return ZERO;
  if (value === '') return EMPTYSTRING;

  if (typeof value === 'object' || typeof value === 'function') {
    try {
      var then = value.then;
      if (typeof then === 'function') {
        return new Promise(then.bind(value));
      }
    } catch (ex) {
      return new Promise(function (resolve, reject) {
        reject(ex);
      });
    }
  }
  return valuePromise(value);
};

Promise.all = function (arr) {
  var args = Array.prototype.slice.call(arr);

  return new Promise(function (resolve, reject) {
    if (args.length === 0) return resolve([]);
    var remaining = args.length;
    function res(i, val) {
      if (val && (typeof val === 'object' || typeof val === 'function')) {
        if (val instanceof Promise && val.then === Promise.prototype.then) {
          while (val._83 === 3) {
            val = val._18;
          }
          if (val._83 === 1) return res(i, val._18);
          if (val._83 === 2) reject(val._18);
          val.then(function (val) {
            res(i, val);
          }, reject);
          return;
        } else {
          var then = val.then;
          if (typeof then === 'function') {
            var p = new Promise(then.bind(val));
            p.then(function (val) {
              res(i, val);
            }, reject);
            return;
          }
        }
      }
      args[i] = val;
      if (--remaining === 0) {
        resolve(args);
      }
    }
    for (var i = 0; i < args.length; i++) {
      res(i, args[i]);
    }
  });
};

Promise.reject = function (value) {
  return new Promise(function (resolve, reject) {
    reject(value);
  });
};

Promise.race = function (values) {
  return new Promise(function (resolve, reject) {
    values.forEach(function(value){
      Promise.resolve(value).then(resolve, reject);
    });
  });
};

/* Prototype Methods */

Promise.prototype['catch'] = function (onRejected) {
  return this.then(null, onRejected);
};


/***/ }),
/* 189 */
/***/ (function(module, exports) {

(function(self) {
  'use strict';

  if (self.fetch) {
    return
  }

  var support = {
    searchParams: 'URLSearchParams' in self,
    iterable: 'Symbol' in self && 'iterator' in Symbol,
    blob: 'FileReader' in self && 'Blob' in self && (function() {
      try {
        new Blob()
        return true
      } catch(e) {
        return false
      }
    })(),
    formData: 'FormData' in self,
    arrayBuffer: 'ArrayBuffer' in self
  }

  if (support.arrayBuffer) {
    var viewClasses = [
      '[object Int8Array]',
      '[object Uint8Array]',
      '[object Uint8ClampedArray]',
      '[object Int16Array]',
      '[object Uint16Array]',
      '[object Int32Array]',
      '[object Uint32Array]',
      '[object Float32Array]',
      '[object Float64Array]'
    ]

    var isDataView = function(obj) {
      return obj && DataView.prototype.isPrototypeOf(obj)
    }

    var isArrayBufferView = ArrayBuffer.isView || function(obj) {
      return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
    }
  }

  function normalizeName(name) {
    if (typeof name !== 'string') {
      name = String(name)
    }
    if (/[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(name)) {
      throw new TypeError('Invalid character in header field name')
    }
    return name.toLowerCase()
  }

  function normalizeValue(value) {
    if (typeof value !== 'string') {
      value = String(value)
    }
    return value
  }

  // Build a destructive iterator for the value list
  function iteratorFor(items) {
    var iterator = {
      next: function() {
        var value = items.shift()
        return {done: value === undefined, value: value}
      }
    }

    if (support.iterable) {
      iterator[Symbol.iterator] = function() {
        return iterator
      }
    }

    return iterator
  }

  function Headers(headers) {
    this.map = {}

    if (headers instanceof Headers) {
      headers.forEach(function(value, name) {
        this.append(name, value)
      }, this)
    } else if (Array.isArray(headers)) {
      headers.forEach(function(header) {
        this.append(header[0], header[1])
      }, this)
    } else if (headers) {
      Object.getOwnPropertyNames(headers).forEach(function(name) {
        this.append(name, headers[name])
      }, this)
    }
  }

  Headers.prototype.append = function(name, value) {
    name = normalizeName(name)
    value = normalizeValue(value)
    var oldValue = this.map[name]
    this.map[name] = oldValue ? oldValue+','+value : value
  }

  Headers.prototype['delete'] = function(name) {
    delete this.map[normalizeName(name)]
  }

  Headers.prototype.get = function(name) {
    name = normalizeName(name)
    return this.has(name) ? this.map[name] : null
  }

  Headers.prototype.has = function(name) {
    return this.map.hasOwnProperty(normalizeName(name))
  }

  Headers.prototype.set = function(name, value) {
    this.map[normalizeName(name)] = normalizeValue(value)
  }

  Headers.prototype.forEach = function(callback, thisArg) {
    for (var name in this.map) {
      if (this.map.hasOwnProperty(name)) {
        callback.call(thisArg, this.map[name], name, this)
      }
    }
  }

  Headers.prototype.keys = function() {
    var items = []
    this.forEach(function(value, name) { items.push(name) })
    return iteratorFor(items)
  }

  Headers.prototype.values = function() {
    var items = []
    this.forEach(function(value) { items.push(value) })
    return iteratorFor(items)
  }

  Headers.prototype.entries = function() {
    var items = []
    this.forEach(function(value, name) { items.push([name, value]) })
    return iteratorFor(items)
  }

  if (support.iterable) {
    Headers.prototype[Symbol.iterator] = Headers.prototype.entries
  }

  function consumed(body) {
    if (body.bodyUsed) {
      return Promise.reject(new TypeError('Already read'))
    }
    body.bodyUsed = true
  }

  function fileReaderReady(reader) {
    return new Promise(function(resolve, reject) {
      reader.onload = function() {
        resolve(reader.result)
      }
      reader.onerror = function() {
        reject(reader.error)
      }
    })
  }

  function readBlobAsArrayBuffer(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsArrayBuffer(blob)
    return promise
  }

  function readBlobAsText(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsText(blob)
    return promise
  }

  function readArrayBufferAsText(buf) {
    var view = new Uint8Array(buf)
    var chars = new Array(view.length)

    for (var i = 0; i < view.length; i++) {
      chars[i] = String.fromCharCode(view[i])
    }
    return chars.join('')
  }

  function bufferClone(buf) {
    if (buf.slice) {
      return buf.slice(0)
    } else {
      var view = new Uint8Array(buf.byteLength)
      view.set(new Uint8Array(buf))
      return view.buffer
    }
  }

  function Body() {
    this.bodyUsed = false

    this._initBody = function(body) {
      this._bodyInit = body
      if (!body) {
        this._bodyText = ''
      } else if (typeof body === 'string') {
        this._bodyText = body
      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
        this._bodyBlob = body
      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
        this._bodyFormData = body
      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
        this._bodyText = body.toString()
      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
        this._bodyArrayBuffer = bufferClone(body.buffer)
        // IE 10-11 can't handle a DataView body.
        this._bodyInit = new Blob([this._bodyArrayBuffer])
      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
        this._bodyArrayBuffer = bufferClone(body)
      } else {
        throw new Error('unsupported BodyInit type')
      }

      if (!this.headers.get('content-type')) {
        if (typeof body === 'string') {
          this.headers.set('content-type', 'text/plain;charset=UTF-8')
        } else if (this._bodyBlob && this._bodyBlob.type) {
          this.headers.set('content-type', this._bodyBlob.type)
        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8')
        }
      }
    }

    if (support.blob) {
      this.blob = function() {
        var rejected = consumed(this)
        if (rejected) {
          return rejected
        }

        if (this._bodyBlob) {
          return Promise.resolve(this._bodyBlob)
        } else if (this._bodyArrayBuffer) {
          return Promise.resolve(new Blob([this._bodyArrayBuffer]))
        } else if (this._bodyFormData) {
          throw new Error('could not read FormData body as blob')
        } else {
          return Promise.resolve(new Blob([this._bodyText]))
        }
      }

      this.arrayBuffer = function() {
        if (this._bodyArrayBuffer) {
          return consumed(this) || Promise.resolve(this._bodyArrayBuffer)
        } else {
          return this.blob().then(readBlobAsArrayBuffer)
        }
      }
    }

    this.text = function() {
      var rejected = consumed(this)
      if (rejected) {
        return rejected
      }

      if (this._bodyBlob) {
        return readBlobAsText(this._bodyBlob)
      } else if (this._bodyArrayBuffer) {
        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
      } else if (this._bodyFormData) {
        throw new Error('could not read FormData body as text')
      } else {
        return Promise.resolve(this._bodyText)
      }
    }

    if (support.formData) {
      this.formData = function() {
        return this.text().then(decode)
      }
    }

    this.json = function() {
      return this.text().then(JSON.parse)
    }

    return this
  }

  // HTTP methods whose capitalization should be normalized
  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT']

  function normalizeMethod(method) {
    var upcased = method.toUpperCase()
    return (methods.indexOf(upcased) > -1) ? upcased : method
  }

  function Request(input, options) {
    options = options || {}
    var body = options.body

    if (input instanceof Request) {
      if (input.bodyUsed) {
        throw new TypeError('Already read')
      }
      this.url = input.url
      this.credentials = input.credentials
      if (!options.headers) {
        this.headers = new Headers(input.headers)
      }
      this.method = input.method
      this.mode = input.mode
      if (!body && input._bodyInit != null) {
        body = input._bodyInit
        input.bodyUsed = true
      }
    } else {
      this.url = String(input)
    }

    this.credentials = options.credentials || this.credentials || 'omit'
    if (options.headers || !this.headers) {
      this.headers = new Headers(options.headers)
    }
    this.method = normalizeMethod(options.method || this.method || 'GET')
    this.mode = options.mode || this.mode || null
    this.referrer = null

    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
      throw new TypeError('Body not allowed for GET or HEAD requests')
    }
    this._initBody(body)
  }

  Request.prototype.clone = function() {
    return new Request(this, { body: this._bodyInit })
  }

  function decode(body) {
    var form = new FormData()
    body.trim().split('&').forEach(function(bytes) {
      if (bytes) {
        var split = bytes.split('=')
        var name = split.shift().replace(/\+/g, ' ')
        var value = split.join('=').replace(/\+/g, ' ')
        form.append(decodeURIComponent(name), decodeURIComponent(value))
      }
    })
    return form
  }

  function parseHeaders(rawHeaders) {
    var headers = new Headers()
    rawHeaders.split(/\r?\n/).forEach(function(line) {
      var parts = line.split(':')
      var key = parts.shift().trim()
      if (key) {
        var value = parts.join(':').trim()
        headers.append(key, value)
      }
    })
    return headers
  }

  Body.call(Request.prototype)

  function Response(bodyInit, options) {
    if (!options) {
      options = {}
    }

    this.type = 'default'
    this.status = 'status' in options ? options.status : 200
    this.ok = this.status >= 200 && this.status < 300
    this.statusText = 'statusText' in options ? options.statusText : 'OK'
    this.headers = new Headers(options.headers)
    this.url = options.url || ''
    this._initBody(bodyInit)
  }

  Body.call(Response.prototype)

  Response.prototype.clone = function() {
    return new Response(this._bodyInit, {
      status: this.status,
      statusText: this.statusText,
      headers: new Headers(this.headers),
      url: this.url
    })
  }

  Response.error = function() {
    var response = new Response(null, {status: 0, statusText: ''})
    response.type = 'error'
    return response
  }

  var redirectStatuses = [301, 302, 303, 307, 308]

  Response.redirect = function(url, status) {
    if (redirectStatuses.indexOf(status) === -1) {
      throw new RangeError('Invalid status code')
    }

    return new Response(null, {status: status, headers: {location: url}})
  }

  self.Headers = Headers
  self.Request = Request
  self.Response = Response

  self.fetch = function(input, init) {
    return new Promise(function(resolve, reject) {
      var request = new Request(input, init)
      var xhr = new XMLHttpRequest()

      xhr.onload = function() {
        var options = {
          status: xhr.status,
          statusText: xhr.statusText,
          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
        }
        options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL')
        var body = 'response' in xhr ? xhr.response : xhr.responseText
        resolve(new Response(body, options))
      }

      xhr.onerror = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.ontimeout = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.open(request.method, request.url, true)

      if (request.credentials === 'include') {
        xhr.withCredentials = true
      }

      if ('responseType' in xhr && support.blob) {
        xhr.responseType = 'blob'
      }

      request.headers.forEach(function(value, name) {
        xhr.setRequestHeader(name, value)
      })

      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit)
    })
  }
  self.fetch.polyfill = true
})(typeof self !== 'undefined' ? self : this);


/***/ }),
/* 190 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App__ = __webpack_require__(201);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Expired__ = __webpack_require__(415);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_bootstrap_dist_css_bootstrap_css__ = __webpack_require__(416);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_bootstrap_dist_css_bootstrap_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_bootstrap_dist_css_bootstrap_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_bootstrap_dist_css_bootstrap_theme_css__ = __webpack_require__(417);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_bootstrap_dist_css_bootstrap_theme_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_bootstrap_dist_css_bootstrap_theme_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_leaflet_dist_leaflet_css__ = __webpack_require__(418);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_leaflet_dist_leaflet_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_leaflet_dist_leaflet_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_toastr_build_toastr_min_css__ = __webpack_require__(419);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_toastr_build_toastr_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_toastr_build_toastr_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__css_leaflet_awesome_markers_css__ = __webpack_require__(420);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__css_leaflet_awesome_markers_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__css_leaflet_awesome_markers_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__index_css__ = __webpack_require__(421);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__css_animate_css__ = __webpack_require__(422);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__css_animate_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__css_animate_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__css_style_css__ = __webpack_require__(423);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__css_style_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__css_style_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__css_font_awesome_min_css__ = __webpack_require__(424);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__css_font_awesome_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__css_font_awesome_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__css_App_css__ = __webpack_require__(425);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__css_App_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__css_App_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__css_breadcrumb_css__ = __webpack_require__(426);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__css_breadcrumb_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__css_breadcrumb_css__);
//import registerServiceWorker from './registerServiceWorker';
var cryjs=__webpack_require__(427);__WEBPACK_IMPORTED_MODULE_1_react_dom___default.a.render(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__App__["a" /* default */],null),document.getElementById('root'));//registerServiceWorker();

/***/ }),
/* 191 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
 React v16.0.0
 react.production.min.js

 Copyright (c) 2013-present, Facebook, Inc.

 This source code is licensed under the MIT license found in the
 LICENSE file in the root directory of this source tree.
*/
var f=__webpack_require__(24),p=__webpack_require__(54);__webpack_require__(22);var r=__webpack_require__(27);
function t(a){for(var b=arguments.length-1,d="Minified React error #"+a+"; visit http://facebook.github.io/react/docs/error-decoder.html?invariant\x3d"+a,e=0;e<b;e++)d+="\x26args[]\x3d"+encodeURIComponent(arguments[e+1]);b=Error(d+" for the full message or use the non-minified dev environment for full errors and additional helpful warnings.");b.name="Invariant Violation";b.framesToPop=1;throw b;}
var u={isMounted:function(){return!1},enqueueForceUpdate:function(){},enqueueReplaceState:function(){},enqueueSetState:function(){}};function v(a,b,d){this.props=a;this.context=b;this.refs=p;this.updater=d||u}v.prototype.isReactComponent={};v.prototype.setState=function(a,b){"object"!==typeof a&&"function"!==typeof a&&null!=a?t("85"):void 0;this.updater.enqueueSetState(this,a,b,"setState")};v.prototype.forceUpdate=function(a){this.updater.enqueueForceUpdate(this,a,"forceUpdate")};
function w(a,b,d){this.props=a;this.context=b;this.refs=p;this.updater=d||u}function x(){}x.prototype=v.prototype;var y=w.prototype=new x;y.constructor=w;f(y,v.prototype);y.isPureReactComponent=!0;function z(a,b,d){this.props=a;this.context=b;this.refs=p;this.updater=d||u}var A=z.prototype=new x;A.constructor=z;f(A,v.prototype);A.unstable_isAsyncReactComponent=!0;A.render=function(){return this.props.children};
var B={Component:v,PureComponent:w,AsyncComponent:z},C={current:null},D=Object.prototype.hasOwnProperty,E="function"===typeof Symbol&&Symbol["for"]&&Symbol["for"]("react.element")||60103,F={key:!0,ref:!0,__self:!0,__source:!0};function G(a,b,d,e,c,g,k){return{$$typeof:E,type:a,key:b,ref:d,props:k,_owner:g}}
G.createElement=function(a,b,d){var e,c={},g=null,k=null,m=null,q=null;if(null!=b)for(e in void 0!==b.ref&&(k=b.ref),void 0!==b.key&&(g=""+b.key),m=void 0===b.__self?null:b.__self,q=void 0===b.__source?null:b.__source,b)D.call(b,e)&&!F.hasOwnProperty(e)&&(c[e]=b[e]);var l=arguments.length-2;if(1===l)c.children=d;else if(1<l){for(var h=Array(l),n=0;n<l;n++)h[n]=arguments[n+2];c.children=h}if(a&&a.defaultProps)for(e in l=a.defaultProps,l)void 0===c[e]&&(c[e]=l[e]);return G(a,g,k,m,q,C.current,c)};
G.createFactory=function(a){var b=G.createElement.bind(null,a);b.type=a;return b};G.cloneAndReplaceKey=function(a,b){return G(a.type,b,a.ref,a._self,a._source,a._owner,a.props)};
G.cloneElement=function(a,b,d){var e=f({},a.props),c=a.key,g=a.ref,k=a._self,m=a._source,q=a._owner;if(null!=b){void 0!==b.ref&&(g=b.ref,q=C.current);void 0!==b.key&&(c=""+b.key);if(a.type&&a.type.defaultProps)var l=a.type.defaultProps;for(h in b)D.call(b,h)&&!F.hasOwnProperty(h)&&(e[h]=void 0===b[h]&&void 0!==l?l[h]:b[h])}var h=arguments.length-2;if(1===h)e.children=d;else if(1<h){l=Array(h);for(var n=0;n<h;n++)l[n]=arguments[n+2];e.children=l}return G(a.type,c,g,k,m,q,e)};
G.isValidElement=function(a){return"object"===typeof a&&null!==a&&a.$$typeof===E};var H="function"===typeof Symbol&&Symbol.iterator,I="function"===typeof Symbol&&Symbol["for"]&&Symbol["for"]("react.element")||60103;function escape(a){var b={"\x3d":"\x3d0",":":"\x3d2"};return"$"+(""+a).replace(/[=:]/g,function(a){return b[a]})}var J=/\/+/g,K=[];
function L(a,b,d,e){if(K.length){var c=K.pop();c.result=a;c.keyPrefix=b;c.func=d;c.context=e;c.count=0;return c}return{result:a,keyPrefix:b,func:d,context:e,count:0}}function M(a){a.result=null;a.keyPrefix=null;a.func=null;a.context=null;a.count=0;10>K.length&&K.push(a)}
function N(a,b,d,e){var c=typeof a;if("undefined"===c||"boolean"===c)a=null;if(null===a||"string"===c||"number"===c||"object"===c&&a.$$typeof===I)return d(e,a,""===b?"."+O(a,0):b),1;var g=0;b=""===b?".":b+":";if(Array.isArray(a))for(var k=0;k<a.length;k++){c=a[k];var m=b+O(c,k);g+=N(c,m,d,e)}else if(m=H&&a[H]||a["@@iterator"],"function"===typeof m)for(a=m.call(a),k=0;!(c=a.next()).done;)c=c.value,m=b+O(c,k++),g+=N(c,m,d,e);else"object"===c&&(d=""+a,t("31","[object Object]"===d?"object with keys {"+
Object.keys(a).join(", ")+"}":d,""));return g}function O(a,b){return"object"===typeof a&&null!==a&&null!=a.key?escape(a.key):b.toString(36)}function P(a,b){a.func.call(a.context,b,a.count++)}function Q(a,b,d){var e=a.result,c=a.keyPrefix;a=a.func.call(a.context,b,a.count++);Array.isArray(a)?R(a,e,d,r.thatReturnsArgument):null!=a&&(G.isValidElement(a)&&(a=G.cloneAndReplaceKey(a,c+(!a.key||b&&b.key===a.key?"":(""+a.key).replace(J,"$\x26/")+"/")+d)),e.push(a))}
function R(a,b,d,e,c){var g="";null!=d&&(g=(""+d).replace(J,"$\x26/")+"/");b=L(b,g,e,c);null==a||N(a,"",Q,b);M(b)}var S={forEach:function(a,b,d){if(null==a)return a;b=L(null,null,b,d);null==a||N(a,"",P,b);M(b)},map:function(a,b,d){if(null==a)return a;var e=[];R(a,e,null,b,d);return e},count:function(a){return null==a?0:N(a,"",r.thatReturnsNull,null)},toArray:function(a){var b=[];R(a,b,null,r.thatReturnsArgument);return b}};
module.exports={Children:{map:S.map,forEach:S.forEach,count:S.count,toArray:S.toArray,only:function(a){G.isValidElement(a)?void 0:t("143");return a}},Component:B.Component,PureComponent:B.PureComponent,unstable_AsyncComponent:B.AsyncComponent,createElement:G.createElement,cloneElement:G.cloneElement,isValidElement:G.isValidElement,createFactory:G.createFactory,version:"16.0.0",__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED:{ReactCurrentOwner:C,assign:f}};


/***/ }),
/* 192 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
 React v16.0.0
 react-dom.production.min.js

 Copyright (c) 2013-present, Facebook, Inc.

 This source code is licensed under the MIT license found in the
 LICENSE file in the root directory of this source tree.
 Modernizr 3.0.0pre (Custom Build) | MIT
*/
var aa=__webpack_require__(0);__webpack_require__(22);var l=__webpack_require__(193),n=__webpack_require__(24),ba=__webpack_require__(194),ca=__webpack_require__(27),da=__webpack_require__(54),ea=__webpack_require__(195),fa=__webpack_require__(196),ha=__webpack_require__(199),ia=__webpack_require__(200);
function w(a){for(var b=arguments.length-1,c="Minified React error #"+a+"; visit http://facebook.github.io/react/docs/error-decoder.html?invariant\x3d"+a,d=0;d<b;d++)c+="\x26args[]\x3d"+encodeURIComponent(arguments[d+1]);b=Error(c+" for the full message or use the non-minified dev environment for full errors and additional helpful warnings.");b.name="Invariant Violation";b.framesToPop=1;throw b;}aa?void 0:w("227");
function ja(a){switch(a){case "svg":return"http://www.w3.org/2000/svg";case "math":return"http://www.w3.org/1998/Math/MathML";default:return"http://www.w3.org/1999/xhtml"}}
var ka={Namespaces:{html:"http://www.w3.org/1999/xhtml",mathml:"http://www.w3.org/1998/Math/MathML",svg:"http://www.w3.org/2000/svg"},getIntrinsicNamespace:ja,getChildNamespace:function(a,b){return null==a||"http://www.w3.org/1999/xhtml"===a?ja(b):"http://www.w3.org/2000/svg"===a&&"foreignObject"===b?"http://www.w3.org/1999/xhtml":a}},la=null,oa={};
function pa(){if(la)for(var a in oa){var b=oa[a],c=la.indexOf(a);-1<c?void 0:w("96",a);if(!qa.plugins[c]){b.extractEvents?void 0:w("97",a);qa.plugins[c]=b;c=b.eventTypes;for(var d in c){var e=void 0;var f=c[d],g=b,h=d;qa.eventNameDispatchConfigs.hasOwnProperty(h)?w("99",h):void 0;qa.eventNameDispatchConfigs[h]=f;var k=f.phasedRegistrationNames;if(k){for(e in k)k.hasOwnProperty(e)&&ra(k[e],g,h);e=!0}else f.registrationName?(ra(f.registrationName,g,h),e=!0):e=!1;e?void 0:w("98",d,a)}}}}
function ra(a,b,c){qa.registrationNameModules[a]?w("100",a):void 0;qa.registrationNameModules[a]=b;qa.registrationNameDependencies[a]=b.eventTypes[c].dependencies}
var qa={plugins:[],eventNameDispatchConfigs:{},registrationNameModules:{},registrationNameDependencies:{},possibleRegistrationNames:null,injectEventPluginOrder:function(a){la?w("101"):void 0;la=Array.prototype.slice.call(a);pa()},injectEventPluginsByName:function(a){var b=!1,c;for(c in a)if(a.hasOwnProperty(c)){var d=a[c];oa.hasOwnProperty(c)&&oa[c]===d||(oa[c]?w("102",c):void 0,oa[c]=d,b=!0)}b&&pa()}},sa=qa,ta={children:!0,dangerouslySetInnerHTML:!0,autoFocus:!0,defaultValue:!0,defaultChecked:!0,
innerHTML:!0,suppressContentEditableWarning:!0,style:!0};function ua(a,b){return(a&b)===b}
var wa={MUST_USE_PROPERTY:1,HAS_BOOLEAN_VALUE:4,HAS_NUMERIC_VALUE:8,HAS_POSITIVE_NUMERIC_VALUE:24,HAS_OVERLOADED_BOOLEAN_VALUE:32,HAS_STRING_BOOLEAN_VALUE:64,injectDOMPropertyConfig:function(a){var b=wa,c=a.Properties||{},d=a.DOMAttributeNamespaces||{},e=a.DOMAttributeNames||{};a=a.DOMMutationMethods||{};for(var f in c){xa.properties.hasOwnProperty(f)?w("48",f):void 0;var g=f.toLowerCase(),h=c[f];g={attributeName:g,attributeNamespace:null,propertyName:f,mutationMethod:null,mustUseProperty:ua(h,b.MUST_USE_PROPERTY),
hasBooleanValue:ua(h,b.HAS_BOOLEAN_VALUE),hasNumericValue:ua(h,b.HAS_NUMERIC_VALUE),hasPositiveNumericValue:ua(h,b.HAS_POSITIVE_NUMERIC_VALUE),hasOverloadedBooleanValue:ua(h,b.HAS_OVERLOADED_BOOLEAN_VALUE),hasStringBooleanValue:ua(h,b.HAS_STRING_BOOLEAN_VALUE)};1>=g.hasBooleanValue+g.hasNumericValue+g.hasOverloadedBooleanValue?void 0:w("50",f);e.hasOwnProperty(f)&&(g.attributeName=e[f]);d.hasOwnProperty(f)&&(g.attributeNamespace=d[f]);a.hasOwnProperty(f)&&(g.mutationMethod=a[f]);xa.properties[f]=
g}}},xa={ID_ATTRIBUTE_NAME:"data-reactid",ROOT_ATTRIBUTE_NAME:"data-reactroot",ATTRIBUTE_NAME_START_CHAR:":A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD",ATTRIBUTE_NAME_CHAR:":A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040",
properties:{},shouldSetAttribute:function(a,b){if(xa.isReservedProp(a)||!("o"!==a[0]&&"O"!==a[0]||"n"!==a[1]&&"N"!==a[1]))return!1;if(null===b)return!0;switch(typeof b){case "boolean":return xa.shouldAttributeAcceptBooleanValue(a);case "undefined":case "number":case "string":case "object":return!0;default:return!1}},getPropertyInfo:function(a){return xa.properties.hasOwnProperty(a)?xa.properties[a]:null},shouldAttributeAcceptBooleanValue:function(a){if(xa.isReservedProp(a))return!0;var b=xa.getPropertyInfo(a);
if(b)return b.hasBooleanValue||b.hasStringBooleanValue||b.hasOverloadedBooleanValue;a=a.toLowerCase().slice(0,5);return"data-"===a||"aria-"===a},isReservedProp:function(a){return ta.hasOwnProperty(a)},injection:wa},A=xa,E={IndeterminateComponent:0,FunctionalComponent:1,ClassComponent:2,HostRoot:3,HostPortal:4,HostComponent:5,HostText:6,CoroutineComponent:7,CoroutineHandlerPhase:8,YieldComponent:9,Fragment:10},F={ELEMENT_NODE:1,TEXT_NODE:3,COMMENT_NODE:8,DOCUMENT_NODE:9,DOCUMENT_FRAGMENT_NODE:11},
ya=E.HostComponent,za=E.HostText,Aa=F.ELEMENT_NODE,Ba=F.COMMENT_NODE,Ea=A.ID_ATTRIBUTE_NAME,Fa={hasCachedChildNodes:1},Ga=Math.random().toString(36).slice(2),Ha="__reactInternalInstance$"+Ga,Ia="__reactEventHandlers$"+Ga;function La(a){for(var b;b=a._renderedComponent;)a=b;return a}function Ma(a,b){a=La(a);a._hostNode=b;b[Ha]=a}
function Na(a,b){if(!(a._flags&Fa.hasCachedChildNodes)){var c=a._renderedChildren;b=b.firstChild;var d;a:for(d in c)if(c.hasOwnProperty(d)){var e=c[d],f=La(e)._domID;if(0!==f){for(;null!==b;b=b.nextSibling){var g=b,h=f;if(g.nodeType===Aa&&g.getAttribute(Ea)===""+h||g.nodeType===Ba&&g.nodeValue===" react-text: "+h+" "||g.nodeType===Ba&&g.nodeValue===" react-empty: "+h+" "){Ma(e,b);continue a}}w("32",f)}}a._flags|=Fa.hasCachedChildNodes}}
function Oa(a){if(a[Ha])return a[Ha];for(var b=[];!a[Ha];)if(b.push(a),a.parentNode)a=a.parentNode;else return null;var c=a[Ha];if(c.tag===ya||c.tag===za)return c;for(;a&&(c=a[Ha]);a=b.pop()){var d=c;b.length&&Na(c,a)}return d}
var G={getClosestInstanceFromNode:Oa,getInstanceFromNode:function(a){var b=a[Ha];if(b)return b.tag===ya||b.tag===za?b:b._hostNode===a?b:null;b=Oa(a);return null!=b&&b._hostNode===a?b:null},getNodeFromInstance:function(a){if(a.tag===ya||a.tag===za)return a.stateNode;void 0===a._hostNode?w("33"):void 0;if(a._hostNode)return a._hostNode;for(var b=[];!a._hostNode;)b.push(a),a._hostParent?void 0:w("34"),a=a._hostParent;for(;b.length;a=b.pop())Na(a,a._hostNode);return a._hostNode},precacheChildNodes:Na,
precacheNode:Ma,uncacheNode:function(a){var b=a._hostNode;b&&(delete b[Ha],a._hostNode=null)},precacheFiberNode:function(a,b){b[Ha]=a},getFiberCurrentPropsFromNode:function(a){return a[Ia]||null},updateFiberProps:function(a,b){a[Ia]=b}},Pa={remove:function(a){a._reactInternalFiber=void 0},get:function(a){return a._reactInternalFiber},has:function(a){return void 0!==a._reactInternalFiber},set:function(a,b){a._reactInternalFiber=b}},Qa={ReactCurrentOwner:aa.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner};
function Ra(a){if("function"===typeof a.getName)return a.getName();if("number"===typeof a.tag){a=a.type;if("string"===typeof a)return a;if("function"===typeof a)return a.displayName||a.name}return null}var J={NoEffect:0,PerformedWork:1,Placement:2,Update:4,PlacementAndUpdate:6,Deletion:8,ContentReset:16,Callback:32,Err:64,Ref:128},Sa=E.HostComponent,Ta=E.HostRoot,Ua=E.HostPortal,Va=E.HostText,Wa=J.NoEffect,Xa=J.Placement;
function Za(a){var b=a;if(a.alternate)for(;b["return"];)b=b["return"];else{if((b.effectTag&Xa)!==Wa)return 1;for(;b["return"];)if(b=b["return"],(b.effectTag&Xa)!==Wa)return 1}return b.tag===Ta?2:3}function $a(a){2!==Za(a)?w("188"):void 0}
function ab(a){var b=a.alternate;if(!b)return b=Za(a),3===b?w("188"):void 0,1===b?null:a;for(var c=a,d=b;;){var e=c["return"],f=e?e.alternate:null;if(!e||!f)break;if(e.child===f.child){for(var g=e.child;g;){if(g===c)return $a(e),a;if(g===d)return $a(e),b;g=g.sibling}w("188")}if(c["return"]!==d["return"])c=e,d=f;else{g=!1;for(var h=e.child;h;){if(h===c){g=!0;c=e;d=f;break}if(h===d){g=!0;d=e;c=f;break}h=h.sibling}if(!g){for(h=f.child;h;){if(h===c){g=!0;c=f;d=e;break}if(h===d){g=!0;d=f;c=e;break}h=h.sibling}g?
void 0:w("189")}}c.alternate!==d?w("190"):void 0}c.tag!==Ta?w("188"):void 0;return c.stateNode.current===c?a:b}
var bb={isFiberMounted:function(a){return 2===Za(a)},isMounted:function(a){return(a=Pa.get(a))?2===Za(a):!1},findCurrentFiberUsingSlowPath:ab,findCurrentHostFiber:function(a){a=ab(a);if(!a)return null;for(var b=a;;){if(b.tag===Sa||b.tag===Va)return b;if(b.child)b.child["return"]=b,b=b.child;else{if(b===a)break;for(;!b.sibling;){if(!b["return"]||b["return"]===a)return null;b=b["return"]}b.sibling["return"]=b["return"];b=b.sibling}}return null},findCurrentHostFiberWithNoPortals:function(a){a=ab(a);
if(!a)return null;for(var b=a;;){if(b.tag===Sa||b.tag===Va)return b;if(b.child&&b.tag!==Ua)b.child["return"]=b,b=b.child;else{if(b===a)break;for(;!b.sibling;){if(!b["return"]||b["return"]===a)return null;b=b["return"]}b.sibling["return"]=b["return"];b=b.sibling}}return null}},K={_caughtError:null,_hasCaughtError:!1,_rethrowError:null,_hasRethrowError:!1,injection:{injectErrorUtils:function(a){"function"!==typeof a.invokeGuardedCallback?w("197"):void 0;cb=a.invokeGuardedCallback}},invokeGuardedCallback:function(a,
b,c,d,e,f,g,h,k){cb.apply(K,arguments)},invokeGuardedCallbackAndCatchFirstError:function(a,b,c,d,e,f,g,h,k){K.invokeGuardedCallback.apply(this,arguments);if(K.hasCaughtError()){var p=K.clearCaughtError();K._hasRethrowError||(K._hasRethrowError=!0,K._rethrowError=p)}},rethrowCaughtError:function(){return db.apply(K,arguments)},hasCaughtError:function(){return K._hasCaughtError},clearCaughtError:function(){if(K._hasCaughtError){var a=K._caughtError;K._caughtError=null;K._hasCaughtError=!1;return a}w("198")}};
function cb(a,b,c,d,e,f,g,h,k){K._hasCaughtError=!1;K._caughtError=null;var p=Array.prototype.slice.call(arguments,3);try{b.apply(c,p)}catch(x){K._caughtError=x,K._hasCaughtError=!0}}function db(){if(K._hasRethrowError){var a=K._rethrowError;K._rethrowError=null;K._hasRethrowError=!1;throw a;}}var eb=K,fb;function gb(a,b,c,d){b=a.type||"unknown-event";a.currentTarget=hb.getNodeFromInstance(d);eb.invokeGuardedCallbackAndCatchFirstError(b,c,void 0,a);a.currentTarget=null}
var hb={isEndish:function(a){return"topMouseUp"===a||"topTouchEnd"===a||"topTouchCancel"===a},isMoveish:function(a){return"topMouseMove"===a||"topTouchMove"===a},isStartish:function(a){return"topMouseDown"===a||"topTouchStart"===a},executeDirectDispatch:function(a){var b=a._dispatchListeners,c=a._dispatchInstances;Array.isArray(b)?w("103"):void 0;a.currentTarget=b?hb.getNodeFromInstance(c):null;b=b?b(a):null;a.currentTarget=null;a._dispatchListeners=null;a._dispatchInstances=null;return b},executeDispatchesInOrder:function(a,
b){var c=a._dispatchListeners,d=a._dispatchInstances;if(Array.isArray(c))for(var e=0;e<c.length&&!a.isPropagationStopped();e++)gb(a,b,c[e],d[e]);else c&&gb(a,b,c,d);a._dispatchListeners=null;a._dispatchInstances=null},executeDispatchesInOrderStopAtTrue:function(a){a:{var b=a._dispatchListeners;var c=a._dispatchInstances;if(Array.isArray(b))for(var d=0;d<b.length&&!a.isPropagationStopped();d++){if(b[d](a,c[d])){b=c[d];break a}}else if(b&&b(a,c)){b=c;break a}b=null}a._dispatchInstances=null;a._dispatchListeners=
null;return b},hasDispatches:function(a){return!!a._dispatchListeners},getFiberCurrentPropsFromNode:function(a){return fb.getFiberCurrentPropsFromNode(a)},getInstanceFromNode:function(a){return fb.getInstanceFromNode(a)},getNodeFromInstance:function(a){return fb.getNodeFromInstance(a)},injection:{injectComponentTree:function(a){fb=a}}},ib=hb,jb=null,kb=null,lb=null;
function mb(a){if(a=ib.getInstanceFromNode(a))if("number"===typeof a.tag){jb&&"function"===typeof jb.restoreControlledState?void 0:w("194");var b=ib.getFiberCurrentPropsFromNode(a.stateNode);jb.restoreControlledState(a.stateNode,a.type,b)}else"function"!==typeof a.restoreControlledState?w("195"):void 0,a.restoreControlledState()}
var nb={injection:{injectFiberControlledHostComponent:function(a){jb=a}},enqueueStateRestore:function(a){kb?lb?lb.push(a):lb=[a]:kb=a},restoreStateIfNeeded:function(){if(kb){var a=kb,b=lb;lb=kb=null;mb(a);if(b)for(a=0;a<b.length;a++)mb(b[a])}}};function ob(a,b,c,d,e,f){return a(b,c,d,e,f)}function pb(a,b){return a(b)}function qb(a,b){return pb(a,b)}
var rb=!1,sb={batchedUpdates:function(a,b){if(rb)return ob(qb,a,b);rb=!0;try{return ob(qb,a,b)}finally{rb=!1,nb.restoreStateIfNeeded()}},injection:{injectStackBatchedUpdates:function(a){ob=a},injectFiberBatchedUpdates:function(a){pb=a}}},tb=F.TEXT_NODE;function ub(a){a=a.target||a.srcElement||window;a.correspondingUseElement&&(a=a.correspondingUseElement);return a.nodeType===tb?a.parentNode:a}var vb=E.HostRoot,wb=[];
function xb(a){var b=a.targetInst;do{if(!b){a.ancestors.push(b);break}var c=b;if("number"===typeof c.tag){for(;c["return"];)c=c["return"];c=c.tag!==vb?null:c.stateNode.containerInfo}else{for(;c._hostParent;)c=c._hostParent;c=G.getNodeFromInstance(c).parentNode}if(!c)break;a.ancestors.push(b);b=G.getClosestInstanceFromNode(c)}while(b);for(c=0;c<a.ancestors.length;c++)b=a.ancestors[c],yb._handleTopLevel(a.topLevelType,b,a.nativeEvent,ub(a.nativeEvent))}
var yb={_enabled:!0,_handleTopLevel:null,setHandleTopLevel:function(a){yb._handleTopLevel=a},setEnabled:function(a){yb._enabled=!!a},isEnabled:function(){return yb._enabled},trapBubbledEvent:function(a,b,c){return c?ba.listen(c,b,yb.dispatchEvent.bind(null,a)):null},trapCapturedEvent:function(a,b,c){return c?ba.capture(c,b,yb.dispatchEvent.bind(null,a)):null},dispatchEvent:function(a,b){if(yb._enabled){var c=ub(b);c=G.getClosestInstanceFromNode(c);null===c||"number"!==typeof c.tag||bb.isFiberMounted(c)||
(c=null);if(wb.length){var d=wb.pop();d.topLevelType=a;d.nativeEvent=b;d.targetInst=c;a=d}else a={topLevelType:a,nativeEvent:b,targetInst:c,ancestors:[]};try{sb.batchedUpdates(xb,a)}finally{a.topLevelType=null,a.nativeEvent=null,a.targetInst=null,a.ancestors.length=0,10>wb.length&&wb.push(a)}}}},L=yb;function Cb(a,b){null==b?w("30"):void 0;if(null==a)return b;if(Array.isArray(a)){if(Array.isArray(b))return a.push.apply(a,b),a;a.push(b);return a}return Array.isArray(b)?[a].concat(b):[a,b]}
function Db(a,b,c){Array.isArray(a)?a.forEach(b,c):a&&b.call(c,a)}var Eb=null;function Fb(a,b){a&&(ib.executeDispatchesInOrder(a,b),a.isPersistent()||a.constructor.release(a))}function Gb(a){return Fb(a,!0)}function Hb(a){return Fb(a,!1)}
function Ib(a,b,c){switch(a){case "onClick":case "onClickCapture":case "onDoubleClick":case "onDoubleClickCapture":case "onMouseDown":case "onMouseDownCapture":case "onMouseMove":case "onMouseMoveCapture":case "onMouseUp":case "onMouseUpCapture":return!(!c.disabled||"button"!==b&&"input"!==b&&"select"!==b&&"textarea"!==b);default:return!1}}
var Jb={injection:{injectEventPluginOrder:sa.injectEventPluginOrder,injectEventPluginsByName:sa.injectEventPluginsByName},getListener:function(a,b){if("number"===typeof a.tag){var c=a.stateNode;if(!c)return null;var d=ib.getFiberCurrentPropsFromNode(c);if(!d)return null;c=d[b];if(Ib(b,a.type,d))return null}else{d=a._currentElement;if("string"===typeof d||"number"===typeof d||!a._rootNodeID)return null;a=d.props;c=a[b];if(Ib(b,d.type,a))return null}c&&"function"!==typeof c?w("231",b,typeof c):void 0;
return c},extractEvents:function(a,b,c,d){for(var e,f=sa.plugins,g=0;g<f.length;g++){var h=f[g];h&&(h=h.extractEvents(a,b,c,d))&&(e=Cb(e,h))}return e},enqueueEvents:function(a){a&&(Eb=Cb(Eb,a))},processEventQueue:function(a){var b=Eb;Eb=null;a?Db(b,Gb):Db(b,Hb);Eb?w("95"):void 0;eb.rethrowCaughtError()}},Kb;l.canUseDOM&&(Kb=document.implementation&&document.implementation.hasFeature&&!0!==document.implementation.hasFeature("",""));
function Lb(a,b){if(!l.canUseDOM||b&&!("addEventListener"in document))return!1;b="on"+a;var c=b in document;c||(c=document.createElement("div"),c.setAttribute(b,"return;"),c="function"===typeof c[b]);!c&&Kb&&"wheel"===a&&(c=document.implementation.hasFeature("Events.wheel","3.0"));return c}function Mb(a,b){var c={};c[a.toLowerCase()]=b.toLowerCase();c["Webkit"+a]="webkit"+b;c["Moz"+a]="moz"+b;c["ms"+a]="MS"+b;c["O"+a]="o"+b.toLowerCase();return c}
var Nb={animationend:Mb("Animation","AnimationEnd"),animationiteration:Mb("Animation","AnimationIteration"),animationstart:Mb("Animation","AnimationStart"),transitionend:Mb("Transition","TransitionEnd")},Ob={},Pb={};l.canUseDOM&&(Pb=document.createElement("div").style,"AnimationEvent"in window||(delete Nb.animationend.animation,delete Nb.animationiteration.animation,delete Nb.animationstart.animation),"TransitionEvent"in window||delete Nb.transitionend.transition);
function Qb(a){if(Ob[a])return Ob[a];if(!Nb[a])return a;var b=Nb[a],c;for(c in b)if(b.hasOwnProperty(c)&&c in Pb)return Ob[a]=b[c];return""}
var Rb={topAbort:"abort",topAnimationEnd:Qb("animationend")||"animationend",topAnimationIteration:Qb("animationiteration")||"animationiteration",topAnimationStart:Qb("animationstart")||"animationstart",topBlur:"blur",topCancel:"cancel",topCanPlay:"canplay",topCanPlayThrough:"canplaythrough",topChange:"change",topClick:"click",topClose:"close",topCompositionEnd:"compositionend",topCompositionStart:"compositionstart",topCompositionUpdate:"compositionupdate",topContextMenu:"contextmenu",topCopy:"copy",
topCut:"cut",topDoubleClick:"dblclick",topDrag:"drag",topDragEnd:"dragend",topDragEnter:"dragenter",topDragExit:"dragexit",topDragLeave:"dragleave",topDragOver:"dragover",topDragStart:"dragstart",topDrop:"drop",topDurationChange:"durationchange",topEmptied:"emptied",topEncrypted:"encrypted",topEnded:"ended",topError:"error",topFocus:"focus",topInput:"input",topKeyDown:"keydown",topKeyPress:"keypress",topKeyUp:"keyup",topLoadedData:"loadeddata",topLoad:"load",topLoadedMetadata:"loadedmetadata",topLoadStart:"loadstart",
topMouseDown:"mousedown",topMouseMove:"mousemove",topMouseOut:"mouseout",topMouseOver:"mouseover",topMouseUp:"mouseup",topPaste:"paste",topPause:"pause",topPlay:"play",topPlaying:"playing",topProgress:"progress",topRateChange:"ratechange",topScroll:"scroll",topSeeked:"seeked",topSeeking:"seeking",topSelectionChange:"selectionchange",topStalled:"stalled",topSuspend:"suspend",topTextInput:"textInput",topTimeUpdate:"timeupdate",topToggle:"toggle",topTouchCancel:"touchcancel",topTouchEnd:"touchend",topTouchMove:"touchmove",
topTouchStart:"touchstart",topTransitionEnd:Qb("transitionend")||"transitionend",topVolumeChange:"volumechange",topWaiting:"waiting",topWheel:"wheel"},Sb={},Tb=0,Ub="_reactListenersID"+(""+Math.random()).slice(2);function Vb(a){Object.prototype.hasOwnProperty.call(a,Ub)||(a[Ub]=Tb++,Sb[a[Ub]]={});return Sb[a[Ub]]}
var M=n({},{handleTopLevel:function(a,b,c,d){a=Jb.extractEvents(a,b,c,d);Jb.enqueueEvents(a);Jb.processEventQueue(!1)}},{setEnabled:function(a){L&&L.setEnabled(a)},isEnabled:function(){return!(!L||!L.isEnabled())},listenTo:function(a,b){var c=Vb(b);a=sa.registrationNameDependencies[a];for(var d=0;d<a.length;d++){var e=a[d];c.hasOwnProperty(e)&&c[e]||("topWheel"===e?Lb("wheel")?L.trapBubbledEvent("topWheel","wheel",b):Lb("mousewheel")?L.trapBubbledEvent("topWheel","mousewheel",b):L.trapBubbledEvent("topWheel",
"DOMMouseScroll",b):"topScroll"===e?L.trapCapturedEvent("topScroll","scroll",b):"topFocus"===e||"topBlur"===e?(L.trapCapturedEvent("topFocus","focus",b),L.trapCapturedEvent("topBlur","blur",b),c.topBlur=!0,c.topFocus=!0):"topCancel"===e?(Lb("cancel",!0)&&L.trapCapturedEvent("topCancel","cancel",b),c.topCancel=!0):"topClose"===e?(Lb("close",!0)&&L.trapCapturedEvent("topClose","close",b),c.topClose=!0):Rb.hasOwnProperty(e)&&L.trapBubbledEvent(e,Rb[e],b),c[e]=!0)}},isListeningToAllDependencies:function(a,
b){b=Vb(b);a=sa.registrationNameDependencies[a];for(var c=0;c<a.length;c++){var d=a[c];if(!b.hasOwnProperty(d)||!b[d])return!1}return!0},trapBubbledEvent:function(a,b,c){return L.trapBubbledEvent(a,b,c)},trapCapturedEvent:function(a,b,c){return L.trapCapturedEvent(a,b,c)}}),Wb={animationIterationCount:!0,borderImageOutset:!0,borderImageSlice:!0,borderImageWidth:!0,boxFlex:!0,boxFlexGroup:!0,boxOrdinalGroup:!0,columnCount:!0,columns:!0,flex:!0,flexGrow:!0,flexPositive:!0,flexShrink:!0,flexNegative:!0,
flexOrder:!0,gridRow:!0,gridRowEnd:!0,gridRowSpan:!0,gridRowStart:!0,gridColumn:!0,gridColumnEnd:!0,gridColumnSpan:!0,gridColumnStart:!0,fontWeight:!0,lineClamp:!0,lineHeight:!0,opacity:!0,order:!0,orphans:!0,tabSize:!0,widows:!0,zIndex:!0,zoom:!0,fillOpacity:!0,floodOpacity:!0,stopOpacity:!0,strokeDasharray:!0,strokeDashoffset:!0,strokeMiterlimit:!0,strokeOpacity:!0,strokeWidth:!0},Xb=["Webkit","ms","Moz","O"];
Object.keys(Wb).forEach(function(a){Xb.forEach(function(b){b=b+a.charAt(0).toUpperCase()+a.substring(1);Wb[b]=Wb[a]})});
var Yb={isUnitlessNumber:Wb,shorthandPropertyExpansions:{background:{backgroundAttachment:!0,backgroundColor:!0,backgroundImage:!0,backgroundPositionX:!0,backgroundPositionY:!0,backgroundRepeat:!0},backgroundPosition:{backgroundPositionX:!0,backgroundPositionY:!0},border:{borderWidth:!0,borderStyle:!0,borderColor:!0},borderBottom:{borderBottomWidth:!0,borderBottomStyle:!0,borderBottomColor:!0},borderLeft:{borderLeftWidth:!0,borderLeftStyle:!0,borderLeftColor:!0},borderRight:{borderRightWidth:!0,borderRightStyle:!0,
borderRightColor:!0},borderTop:{borderTopWidth:!0,borderTopStyle:!0,borderTopColor:!0},font:{fontStyle:!0,fontVariant:!0,fontWeight:!0,fontSize:!0,lineHeight:!0,fontFamily:!0},outline:{outlineWidth:!0,outlineStyle:!0,outlineColor:!0}}},Zb=Yb.isUnitlessNumber,$b=!1;if(l.canUseDOM){var ac=document.createElement("div").style;try{ac.font=""}catch(a){$b=!0}}
var bc={createDangerousStringForStyles:function(){},setValueForStyles:function(a,b){a=a.style;for(var c in b)if(b.hasOwnProperty(c)){var d=0===c.indexOf("--");var e=c;var f=b[c];e=null==f||"boolean"===typeof f||""===f?"":d||"number"!==typeof f||0===f||Zb.hasOwnProperty(e)&&Zb[e]?(""+f).trim():f+"px";"float"===c&&(c="cssFloat");if(d)a.setProperty(c,e);else if(e)a[c]=e;else if(d=$b&&Yb.shorthandPropertyExpansions[c])for(var g in d)a[g]="";else a[c]=""}}},cc=new RegExp("^["+A.ATTRIBUTE_NAME_START_CHAR+
"]["+A.ATTRIBUTE_NAME_CHAR+"]*$"),dc={},ec={};function fc(a){if(ec.hasOwnProperty(a))return!0;if(dc.hasOwnProperty(a))return!1;if(cc.test(a))return ec[a]=!0;dc[a]=!0;return!1}
var gc={setAttributeForID:function(a,b){a.setAttribute(A.ID_ATTRIBUTE_NAME,b)},setAttributeForRoot:function(a){a.setAttribute(A.ROOT_ATTRIBUTE_NAME,"")},getValueForProperty:function(){},getValueForAttribute:function(){},setValueForProperty:function(a,b,c){var d=A.getPropertyInfo(b);if(d&&A.shouldSetAttribute(b,c)){var e=d.mutationMethod;e?e(a,c):null==c||d.hasBooleanValue&&!c||d.hasNumericValue&&isNaN(c)||d.hasPositiveNumericValue&&1>c||d.hasOverloadedBooleanValue&&!1===c?gc.deleteValueForProperty(a,
b):d.mustUseProperty?a[d.propertyName]=c:(b=d.attributeName,(e=d.attributeNamespace)?a.setAttributeNS(e,b,""+c):d.hasBooleanValue||d.hasOverloadedBooleanValue&&!0===c?a.setAttribute(b,""):a.setAttribute(b,""+c))}else gc.setValueForAttribute(a,b,A.shouldSetAttribute(b,c)?c:null)},setValueForAttribute:function(a,b,c){fc(b)&&(null==c?a.removeAttribute(b):a.setAttribute(b,""+c))},deleteValueForAttribute:function(a,b){a.removeAttribute(b)},deleteValueForProperty:function(a,b){var c=A.getPropertyInfo(b);
c?(b=c.mutationMethod)?b(a,void 0):c.mustUseProperty?a[c.propertyName]=c.hasBooleanValue?!1:"":a.removeAttribute(c.attributeName):a.removeAttribute(b)}},hc=gc,ic=Qa.ReactDebugCurrentFrame;function jc(){return null}
var kc={current:null,phase:null,resetCurrentFiber:function(){ic.getCurrentStack=null;kc.current=null;kc.phase=null},setCurrentFiber:function(a,b){ic.getCurrentStack=jc;kc.current=a;kc.phase=b},getCurrentFiberOwnerName:function(){return null},getCurrentFiberStackAddendum:jc},lc=kc,mc={getHostProps:function(a,b){var c=b.value,d=b.checked;return n({type:void 0,step:void 0,min:void 0,max:void 0},b,{defaultChecked:void 0,defaultValue:void 0,value:null!=c?c:a._wrapperState.initialValue,checked:null!=d?
d:a._wrapperState.initialChecked})},initWrapperState:function(a,b){var c=b.defaultValue;a._wrapperState={initialChecked:null!=b.checked?b.checked:b.defaultChecked,initialValue:null!=b.value?b.value:c,controlled:"checkbox"===b.type||"radio"===b.type?null!=b.checked:null!=b.value}},updateWrapper:function(a,b){var c=b.checked;null!=c&&hc.setValueForProperty(a,"checked",c||!1);c=b.value;if(null!=c)if(0===c&&""===a.value)a.value="0";else if("number"===b.type){if(b=parseFloat(a.value)||0,c!=b||c==b&&a.value!=
c)a.value=""+c}else a.value!==""+c&&(a.value=""+c);else null==b.value&&null!=b.defaultValue&&a.defaultValue!==""+b.defaultValue&&(a.defaultValue=""+b.defaultValue),null==b.checked&&null!=b.defaultChecked&&(a.defaultChecked=!!b.defaultChecked)},postMountWrapper:function(a,b){switch(b.type){case "submit":case "reset":break;case "color":case "date":case "datetime":case "datetime-local":case "month":case "time":case "week":a.value="";a.value=a.defaultValue;break;default:a.value=a.value}b=a.name;""!==
b&&(a.name="");a.defaultChecked=!a.defaultChecked;a.defaultChecked=!a.defaultChecked;""!==b&&(a.name=b)},restoreControlledState:function(a,b){mc.updateWrapper(a,b);var c=b.name;if("radio"===b.type&&null!=c){for(b=a;b.parentNode;)b=b.parentNode;c=b.querySelectorAll("input[name\x3d"+JSON.stringify(""+c)+'][type\x3d"radio"]');for(b=0;b<c.length;b++){var d=c[b];if(d!==a&&d.form===a.form){var e=G.getFiberCurrentPropsFromNode(d);e?void 0:w("90");mc.updateWrapper(d,e)}}}}},qc=mc;
function rc(a){var b="";aa.Children.forEach(a,function(a){null==a||"string"!==typeof a&&"number"!==typeof a||(b+=a)});return b}var sc={validateProps:function(){},postMountWrapper:function(a,b){null!=b.value&&a.setAttribute("value",b.value)},getHostProps:function(a,b){a=n({children:void 0},b);if(b=rc(b.children))a.children=b;return a}};
function tc(a,b,c){a=a.options;if(b){b={};for(var d=0;d<c.length;d++)b["$"+c[d]]=!0;for(c=0;c<a.length;c++)d=b.hasOwnProperty("$"+a[c].value),a[c].selected!==d&&(a[c].selected=d)}else{c=""+c;b=null;for(d=0;d<a.length;d++){if(a[d].value===c){a[d].selected=!0;return}null!==b||a[d].disabled||(b=a[d])}null!==b&&(b.selected=!0)}}
var uc={getHostProps:function(a,b){return n({},b,{value:void 0})},initWrapperState:function(a,b){var c=b.value;a._wrapperState={initialValue:null!=c?c:b.defaultValue,wasMultiple:!!b.multiple}},postMountWrapper:function(a,b){a.multiple=!!b.multiple;var c=b.value;null!=c?tc(a,!!b.multiple,c):null!=b.defaultValue&&tc(a,!!b.multiple,b.defaultValue)},postUpdateWrapper:function(a,b){a._wrapperState.initialValue=void 0;var c=a._wrapperState.wasMultiple;a._wrapperState.wasMultiple=!!b.multiple;var d=b.value;
null!=d?tc(a,!!b.multiple,d):c!==!!b.multiple&&(null!=b.defaultValue?tc(a,!!b.multiple,b.defaultValue):tc(a,!!b.multiple,b.multiple?[]:""))},restoreControlledState:function(a,b){var c=b.value;null!=c&&tc(a,!!b.multiple,c)}},vc={getHostProps:function(a,b){null!=b.dangerouslySetInnerHTML?w("91"):void 0;return n({},b,{value:void 0,defaultValue:void 0,children:""+a._wrapperState.initialValue})},initWrapperState:function(a,b){var c=b.value,d=c;null==c&&(c=b.defaultValue,b=b.children,null!=b&&(null!=c?
w("92"):void 0,Array.isArray(b)&&(1>=b.length?void 0:w("93"),b=b[0]),c=""+b),null==c&&(c=""),d=c);a._wrapperState={initialValue:""+d}},updateWrapper:function(a,b){var c=b.value;null!=c&&(c=""+c,c!==a.value&&(a.value=c),null==b.defaultValue&&(a.defaultValue=c));null!=b.defaultValue&&(a.defaultValue=b.defaultValue)},postMountWrapper:function(a){var b=a.textContent;b===a._wrapperState.initialValue&&(a.value=b)},restoreControlledState:function(a,b){vc.updateWrapper(a,b)}},wc=vc,xc=n({menuitem:!0},{area:!0,
base:!0,br:!0,col:!0,embed:!0,hr:!0,img:!0,input:!0,keygen:!0,link:!0,meta:!0,param:!0,source:!0,track:!0,wbr:!0});function yc(a,b){b&&(xc[a]&&(null!=b.children||null!=b.dangerouslySetInnerHTML?w("137",a,""):void 0),null!=b.dangerouslySetInnerHTML&&(null!=b.children?w("60"):void 0,"object"===typeof b.dangerouslySetInnerHTML&&"__html"in b.dangerouslySetInnerHTML?void 0:w("61")),null!=b.style&&"object"!==typeof b.style?w("62",""):void 0)}
function zc(a){var b=a.type;return(a=a.nodeName)&&"input"===a.toLowerCase()&&("checkbox"===b||"radio"===b)}
function Ac(a){var b=zc(a)?"checked":"value",c=Object.getOwnPropertyDescriptor(a.constructor.prototype,b),d=""+a[b];if(!a.hasOwnProperty(b)&&"function"===typeof c.get&&"function"===typeof c.set)return Object.defineProperty(a,b,{enumerable:c.enumerable,configurable:!0,get:function(){return c.get.call(this)},set:function(a){d=""+a;c.set.call(this,a)}}),{getValue:function(){return d},setValue:function(a){d=""+a},stopTracking:function(){a._valueTracker=null;delete a[b]}}}
var Bc={_getTrackerFromNode:function(a){return a._valueTracker},track:function(a){a._valueTracker||(a._valueTracker=Ac(a))},updateValueIfChanged:function(a){if(!a)return!1;var b=a._valueTracker;if(!b)return!0;var c=b.getValue();var d="";a&&(d=zc(a)?a.checked?"true":"false":a.value);a=d;return a!==c?(b.setValue(a),!0):!1},stopTracking:function(a){(a=a._valueTracker)&&a.stopTracking()}};
function Cc(a,b){if(-1===a.indexOf("-"))return"string"===typeof b.is;switch(a){case "annotation-xml":case "color-profile":case "font-face":case "font-face-src":case "font-face-uri":case "font-face-format":case "font-face-name":case "missing-glyph":return!1;default:return!0}}
var Dc=ka.Namespaces,Ec,Fc=function(a){return"undefined"!==typeof MSApp&&MSApp.execUnsafeLocalFunction?function(b,c,d,e){MSApp.execUnsafeLocalFunction(function(){return a(b,c,d,e)})}:a}(function(a,b){if(a.namespaceURI!==Dc.svg||"innerHTML"in a)a.innerHTML=b;else for(Ec=Ec||document.createElement("div"),Ec.innerHTML="\x3csvg\x3e"+b+"\x3c/svg\x3e",b=Ec.firstChild;b.firstChild;)a.appendChild(b.firstChild)}),Gc=/["'&<>]/,Hc=F.TEXT_NODE;
function Ic(a,b){if(b){var c=a.firstChild;if(c&&c===a.lastChild&&c.nodeType===Hc){c.nodeValue=b;return}}a.textContent=b}
l.canUseDOM&&("textContent"in document.documentElement||(Ic=function(a,b){if(a.nodeType===Hc)a.nodeValue=b;else{if("boolean"===typeof b||"number"===typeof b)b=""+b;else{b=""+b;var c=Gc.exec(b);if(c){var d="",e,f=0;for(e=c.index;e<b.length;e++){switch(b.charCodeAt(e)){case 34:c="\x26quot;";break;case 38:c="\x26amp;";break;case 39:c="\x26#x27;";break;case 60:c="\x26lt;";break;case 62:c="\x26gt;";break;default:continue}f!==e&&(d+=b.substring(f,e));f=e+1;d+=c}b=f!==e?d+b.substring(f,e):d}}Fc(a,b)}}));
var Jc=Ic,Kc=lc.getCurrentFiberOwnerName,Lc=F.DOCUMENT_NODE,Mc=F.DOCUMENT_FRAGMENT_NODE,Nc=M.listenTo,Oc=sa.registrationNameModules,Pc=ka.Namespaces.html,Qc=ka.getIntrinsicNamespace;function Rc(a,b){Nc(b,a.nodeType===Lc||a.nodeType===Mc?a:a.ownerDocument)}
var Sc={topAbort:"abort",topCanPlay:"canplay",topCanPlayThrough:"canplaythrough",topDurationChange:"durationchange",topEmptied:"emptied",topEncrypted:"encrypted",topEnded:"ended",topError:"error",topLoadedData:"loadeddata",topLoadedMetadata:"loadedmetadata",topLoadStart:"loadstart",topPause:"pause",topPlay:"play",topPlaying:"playing",topProgress:"progress",topRateChange:"ratechange",topSeeked:"seeked",topSeeking:"seeking",topStalled:"stalled",topSuspend:"suspend",topTimeUpdate:"timeupdate",topVolumeChange:"volumechange",
topWaiting:"waiting"},N={createElement:function(a,b,c,d){c=c.nodeType===Lc?c:c.ownerDocument;d===Pc&&(d=Qc(a));d===Pc?"script"===a?(a=c.createElement("div"),a.innerHTML="\x3cscript\x3e\x3c/script\x3e",a=a.removeChild(a.firstChild)):a="string"===typeof b.is?c.createElement(a,{is:b.is}):c.createElement(a):a=c.createElementNS(d,a);return a},createTextNode:function(a,b){return(b.nodeType===Lc?b:b.ownerDocument).createTextNode(a)},setInitialProperties:function(a,b,c,d){var e=Cc(b,c);switch(b){case "iframe":case "object":M.trapBubbledEvent("topLoad",
"load",a);var f=c;break;case "video":case "audio":for(f in Sc)Sc.hasOwnProperty(f)&&M.trapBubbledEvent(f,Sc[f],a);f=c;break;case "source":M.trapBubbledEvent("topError","error",a);f=c;break;case "img":case "image":M.trapBubbledEvent("topError","error",a);M.trapBubbledEvent("topLoad","load",a);f=c;break;case "form":M.trapBubbledEvent("topReset","reset",a);M.trapBubbledEvent("topSubmit","submit",a);f=c;break;case "details":M.trapBubbledEvent("topToggle","toggle",a);f=c;break;case "input":qc.initWrapperState(a,
c);f=qc.getHostProps(a,c);M.trapBubbledEvent("topInvalid","invalid",a);Rc(d,"onChange");break;case "option":sc.validateProps(a,c);f=sc.getHostProps(a,c);break;case "select":uc.initWrapperState(a,c);f=uc.getHostProps(a,c);M.trapBubbledEvent("topInvalid","invalid",a);Rc(d,"onChange");break;case "textarea":wc.initWrapperState(a,c);f=wc.getHostProps(a,c);M.trapBubbledEvent("topInvalid","invalid",a);Rc(d,"onChange");break;default:f=c}yc(b,f,Kc);var g=f,h;for(h in g)if(g.hasOwnProperty(h)){var k=g[h];"style"===
h?bc.setValueForStyles(a,k):"dangerouslySetInnerHTML"===h?(k=k?k.__html:void 0,null!=k&&Fc(a,k)):"children"===h?"string"===typeof k?Jc(a,k):"number"===typeof k&&Jc(a,""+k):"suppressContentEditableWarning"!==h&&(Oc.hasOwnProperty(h)?null!=k&&Rc(d,h):e?hc.setValueForAttribute(a,h,k):null!=k&&hc.setValueForProperty(a,h,k))}switch(b){case "input":Bc.track(a);qc.postMountWrapper(a,c);break;case "textarea":Bc.track(a);wc.postMountWrapper(a,c);break;case "option":sc.postMountWrapper(a,c);break;case "select":uc.postMountWrapper(a,
c);break;default:"function"===typeof f.onClick&&(a.onclick=ca)}},diffProperties:function(a,b,c,d,e){var f=null;switch(b){case "input":c=qc.getHostProps(a,c);d=qc.getHostProps(a,d);f=[];break;case "option":c=sc.getHostProps(a,c);d=sc.getHostProps(a,d);f=[];break;case "select":c=uc.getHostProps(a,c);d=uc.getHostProps(a,d);f=[];break;case "textarea":c=wc.getHostProps(a,c);d=wc.getHostProps(a,d);f=[];break;default:"function"!==typeof c.onClick&&"function"===typeof d.onClick&&(a.onclick=ca)}yc(b,d,Kc);
var g,h;a=null;for(g in c)if(!d.hasOwnProperty(g)&&c.hasOwnProperty(g)&&null!=c[g])if("style"===g)for(h in b=c[g],b)b.hasOwnProperty(h)&&(a||(a={}),a[h]="");else"dangerouslySetInnerHTML"!==g&&"children"!==g&&"suppressContentEditableWarning"!==g&&(Oc.hasOwnProperty(g)?f||(f=[]):(f=f||[]).push(g,null));for(g in d){var k=d[g];b=null!=c?c[g]:void 0;if(d.hasOwnProperty(g)&&k!==b&&(null!=k||null!=b))if("style"===g)if(b){for(h in b)!b.hasOwnProperty(h)||k&&k.hasOwnProperty(h)||(a||(a={}),a[h]="");for(h in k)k.hasOwnProperty(h)&&
b[h]!==k[h]&&(a||(a={}),a[h]=k[h])}else a||(f||(f=[]),f.push(g,a)),a=k;else"dangerouslySetInnerHTML"===g?(k=k?k.__html:void 0,b=b?b.__html:void 0,null!=k&&b!==k&&(f=f||[]).push(g,""+k)):"children"===g?b===k||"string"!==typeof k&&"number"!==typeof k||(f=f||[]).push(g,""+k):"suppressContentEditableWarning"!==g&&(Oc.hasOwnProperty(g)?(null!=k&&Rc(e,g),f||b===k||(f=[])):(f=f||[]).push(g,k))}a&&(f=f||[]).push("style",a);return f},updateProperties:function(a,b,c,d,e){Cc(c,d);d=Cc(c,e);for(var f=0;f<b.length;f+=
2){var g=b[f],h=b[f+1];"style"===g?bc.setValueForStyles(a,h):"dangerouslySetInnerHTML"===g?Fc(a,h):"children"===g?Jc(a,h):d?null!=h?hc.setValueForAttribute(a,g,h):hc.deleteValueForAttribute(a,g):null!=h?hc.setValueForProperty(a,g,h):hc.deleteValueForProperty(a,g)}switch(c){case "input":qc.updateWrapper(a,e);Bc.updateValueIfChanged(a);break;case "textarea":wc.updateWrapper(a,e);break;case "select":uc.postUpdateWrapper(a,e)}},diffHydratedProperties:function(a,b,c,d,e){switch(b){case "iframe":case "object":M.trapBubbledEvent("topLoad",
"load",a);break;case "video":case "audio":for(var f in Sc)Sc.hasOwnProperty(f)&&M.trapBubbledEvent(f,Sc[f],a);break;case "source":M.trapBubbledEvent("topError","error",a);break;case "img":case "image":M.trapBubbledEvent("topError","error",a);M.trapBubbledEvent("topLoad","load",a);break;case "form":M.trapBubbledEvent("topReset","reset",a);M.trapBubbledEvent("topSubmit","submit",a);break;case "details":M.trapBubbledEvent("topToggle","toggle",a);break;case "input":qc.initWrapperState(a,c);M.trapBubbledEvent("topInvalid",
"invalid",a);Rc(e,"onChange");break;case "option":sc.validateProps(a,c);break;case "select":uc.initWrapperState(a,c);M.trapBubbledEvent("topInvalid","invalid",a);Rc(e,"onChange");break;case "textarea":wc.initWrapperState(a,c),M.trapBubbledEvent("topInvalid","invalid",a),Rc(e,"onChange")}yc(b,c,Kc);d=null;for(var g in c)c.hasOwnProperty(g)&&(f=c[g],"children"===g?"string"===typeof f?a.textContent!==f&&(d=["children",f]):"number"===typeof f&&a.textContent!==""+f&&(d=["children",""+f]):Oc.hasOwnProperty(g)&&
null!=f&&Rc(e,g));switch(b){case "input":Bc.track(a);qc.postMountWrapper(a,c);break;case "textarea":Bc.track(a);wc.postMountWrapper(a,c);break;case "select":case "option":break;default:"function"===typeof c.onClick&&(a.onclick=ca)}return d},diffHydratedText:function(a,b){return a.nodeValue!==b},warnForDeletedHydratableElement:function(){},warnForDeletedHydratableText:function(){},warnForInsertedHydratedElement:function(){},warnForInsertedHydratedText:function(){},restoreControlledState:function(a,
b,c){switch(b){case "input":qc.restoreControlledState(a,c);break;case "textarea":wc.restoreControlledState(a,c);break;case "select":uc.restoreControlledState(a,c)}}},Tc=void 0;
if(l.canUseDOM)if("function"!==typeof requestIdleCallback){var Uc=null,Vc=null,Wc=!1,Xc=!1,Yc=0,Zc=33,$c=33,ad={timeRemaining:"object"===typeof performance&&"function"===typeof performance.now?function(){return Yc-performance.now()}:function(){return Yc-Date.now()}},bd="__reactIdleCallback$"+Math.random().toString(36).slice(2);window.addEventListener("message",function(a){a.source===window&&a.data===bd&&(Wc=!1,a=Vc,Vc=null,null!==a&&a(ad))},!1);var cd=function(a){Xc=!1;var b=a-Yc+$c;b<$c&&Zc<$c?(8>
b&&(b=8),$c=b<Zc?Zc:b):Zc=b;Yc=a+$c;Wc||(Wc=!0,window.postMessage(bd,"*"));b=Uc;Uc=null;null!==b&&b(a)};Tc=function(a){Vc=a;Xc||(Xc=!0,requestAnimationFrame(cd));return 0}}else Tc=requestIdleCallback;else Tc=function(a){setTimeout(function(){a({timeRemaining:function(){return Infinity}})});return 0};
var dd={rIC:Tc},ed={enableAsyncSubtreeAPI:!0},Q={NoWork:0,SynchronousPriority:1,TaskPriority:2,HighPriority:3,LowPriority:4,OffscreenPriority:5},fd=J.Callback,gd=Q.NoWork,hd=Q.SynchronousPriority,id=Q.TaskPriority,jd=E.ClassComponent,kd=E.HostRoot,md=void 0,nd=void 0;function od(a,b){return a!==id&&a!==hd||b!==id&&b!==hd?a===gd&&b!==gd?-255:a!==gd&&b===gd?255:a-b:0}function pd(){return{first:null,last:null,hasForceUpdate:!1,callbackList:null}}
function qd(a,b,c,d){null!==c?c.next=b:(b.next=a.first,a.first=b);null!==d?b.next=d:a.last=b}function rd(a,b){b=b.priorityLevel;var c=null;if(null!==a.last&&0>=od(a.last.priorityLevel,b))c=a.last;else for(a=a.first;null!==a&&0>=od(a.priorityLevel,b);)c=a,a=a.next;return c}
function sd(a,b){var c=a.alternate,d=a.updateQueue;null===d&&(d=a.updateQueue=pd());null!==c?(a=c.updateQueue,null===a&&(a=c.updateQueue=pd())):a=null;md=d;nd=a!==d?a:null;var e=md;c=nd;var f=rd(e,b),g=null!==f?f.next:e.first;if(null===c)return qd(e,b,f,g),null;d=rd(c,b);a=null!==d?d.next:c.first;qd(e,b,f,g);if(g===a&&null!==g||f===d&&null!==f)return null===d&&(c.first=b),null===a&&(c.last=null),null;b={priorityLevel:b.priorityLevel,partialState:b.partialState,callback:b.callback,isReplace:b.isReplace,
isForced:b.isForced,isTopLevelUnmount:b.isTopLevelUnmount,next:null};qd(c,b,d,a);return b}function td(a,b,c,d){a=a.partialState;return"function"===typeof a?a.call(b,c,d):a}
var ud={addUpdate:function(a,b,c,d){sd(a,{priorityLevel:d,partialState:b,callback:c,isReplace:!1,isForced:!1,isTopLevelUnmount:!1,next:null})},addReplaceUpdate:function(a,b,c,d){sd(a,{priorityLevel:d,partialState:b,callback:c,isReplace:!0,isForced:!1,isTopLevelUnmount:!1,next:null})},addForceUpdate:function(a,b,c){sd(a,{priorityLevel:c,partialState:null,callback:b,isReplace:!1,isForced:!0,isTopLevelUnmount:!1,next:null})},getUpdatePriority:function(a){var b=a.updateQueue;return null===b||a.tag!==
jd&&a.tag!==kd?gd:null!==b.first?b.first.priorityLevel:gd},addTopLevelUpdate:function(a,b,c,d){var e=null===b.element;b={priorityLevel:d,partialState:b,callback:c,isReplace:!1,isForced:!1,isTopLevelUnmount:e,next:null};a=sd(a,b);e&&(e=md,c=nd,null!==e&&null!==b.next&&(b.next=null,e.last=b),null!==c&&null!==a&&null!==a.next&&(a.next=null,c.last=b))},beginUpdateQueue:function(a,b,c,d,e,f,g){null!==a&&a.updateQueue===c&&(c=b.updateQueue={first:c.first,last:c.last,callbackList:null,hasForceUpdate:!1});
a=c.callbackList;for(var h=c.hasForceUpdate,k=!0,p=c.first;null!==p&&0>=od(p.priorityLevel,g);){c.first=p.next;null===c.first&&(c.last=null);var x;if(p.isReplace)e=td(p,d,e,f),k=!0;else if(x=td(p,d,e,f))e=k?n({},e,x):n(e,x),k=!1;p.isForced&&(h=!0);null===p.callback||p.isTopLevelUnmount&&null!==p.next||(a=null!==a?a:[],a.push(p.callback),b.effectTag|=fd);p=p.next}c.callbackList=a;c.hasForceUpdate=h;null!==c.first||null!==a||h||(b.updateQueue=null);return e},commitCallbacks:function(a,b,c){a=b.callbackList;
if(null!==a)for(b.callbackList=null,b=0;b<a.length;b++){var d=a[b];"function"!==typeof d?w("191",d):void 0;d.call(c)}}},vd=[],wd=-1,xd={createCursor:function(a){return{current:a}},isEmpty:function(){return-1===wd},pop:function(a){0>wd||(a.current=vd[wd],vd[wd]=null,wd--)},push:function(a,b){wd++;vd[wd]=a.current;a.current=b},reset:function(){for(;-1<wd;)vd[wd]=null,wd--}},yd=bb.isFiberMounted,zd=E.ClassComponent,Ad=E.HostRoot,Bd=xd.createCursor,Cd=xd.pop,Dd=xd.push,Ed=Bd(da),Fd=Bd(!1),Ld=da;
function Md(a,b,c){a=a.stateNode;a.__reactInternalMemoizedUnmaskedChildContext=b;a.__reactInternalMemoizedMaskedChildContext=c}function Nd(a){return a.tag===zd&&null!=a.type.childContextTypes}function Od(a,b){var c=a.stateNode,d=a.type.childContextTypes;if("function"!==typeof c.getChildContext)return b;c=c.getChildContext();for(var e in c)e in d?void 0:w("108",Ra(a)||"Unknown",e);return n({},b,c)}
var R={getUnmaskedContext:function(a){return Nd(a)?Ld:Ed.current},cacheContext:Md,getMaskedContext:function(a,b){var c=a.type.contextTypes;if(!c)return da;var d=a.stateNode;if(d&&d.__reactInternalMemoizedUnmaskedChildContext===b)return d.__reactInternalMemoizedMaskedChildContext;var e={},f;for(f in c)e[f]=b[f];d&&Md(a,b,e);return e},hasContextChanged:function(){return Fd.current},isContextConsumer:function(a){return a.tag===zd&&null!=a.type.contextTypes},isContextProvider:Nd,popContextProvider:function(a){Nd(a)&&
(Cd(Fd,a),Cd(Ed,a))},popTopLevelContextObject:function(a){Cd(Fd,a);Cd(Ed,a)},pushTopLevelContextObject:function(a,b,c){null!=Ed.cursor?w("168"):void 0;Dd(Ed,b,a);Dd(Fd,c,a)},processChildContext:Od,pushContextProvider:function(a){if(!Nd(a))return!1;var b=a.stateNode;b=b&&b.__reactInternalMemoizedMergedChildContext||da;Ld=Ed.current;Dd(Ed,b,a);Dd(Fd,Fd.current,a);return!0},invalidateContextProvider:function(a,b){var c=a.stateNode;c?void 0:w("169");if(b){var d=Od(a,Ld,!0);c.__reactInternalMemoizedMergedChildContext=
d;Cd(Fd,a);Cd(Ed,a);Dd(Ed,d,a)}else Cd(Fd,a);Dd(Fd,b,a)},resetContext:function(){Ld=da;Ed.current=da;Fd.current=!1},findCurrentUnmaskedContext:function(a){for(yd(a)&&a.tag===zd?void 0:w("170");a.tag!==Ad;){if(Nd(a))return a.stateNode.__reactInternalMemoizedMergedChildContext;(a=a["return"])?void 0:w("171")}return a.stateNode.context}},Pd={NoContext:0,AsyncUpdates:1},Qd=E.IndeterminateComponent,Rd=E.ClassComponent,Sd=E.HostRoot,Td=E.HostComponent,Ud=E.HostText,Vd=E.HostPortal,Wd=E.CoroutineComponent,
Xd=E.YieldComponent,Yd=E.Fragment,Zd=Q.NoWork,$d=Pd.NoContext,ae=J.NoEffect;function be(a,b,c){this.tag=a;this.key=b;this.stateNode=this.type=null;this.sibling=this.child=this["return"]=null;this.index=0;this.memoizedState=this.updateQueue=this.memoizedProps=this.pendingProps=this.ref=null;this.internalContextTag=c;this.effectTag=ae;this.lastEffect=this.firstEffect=this.nextEffect=null;this.pendingWorkPriority=Zd;this.alternate=null}
function ce(a,b,c){var d=void 0;"function"===typeof a?(d=a.prototype&&a.prototype.isReactComponent?new be(Rd,b,c):new be(Qd,b,c),d.type=a):"string"===typeof a?(d=new be(Td,b,c),d.type=a):"object"===typeof a&&null!==a&&"number"===typeof a.tag?d=a:w("130",null==a?a:typeof a,"");return d}
var de={createWorkInProgress:function(a,b){var c=a.alternate;null===c?(c=new be(a.tag,a.key,a.internalContextTag),c.type=a.type,c.stateNode=a.stateNode,c.alternate=a,a.alternate=c):(c.effectTag=ae,c.nextEffect=null,c.firstEffect=null,c.lastEffect=null);c.pendingWorkPriority=b;c.child=a.child;c.memoizedProps=a.memoizedProps;c.memoizedState=a.memoizedState;c.updateQueue=a.updateQueue;c.sibling=a.sibling;c.index=a.index;c.ref=a.ref;return c},createHostRootFiber:function(){return new be(Sd,null,$d)},
createFiberFromElement:function(a,b,c){b=ce(a.type,a.key,b,null);b.pendingProps=a.props;b.pendingWorkPriority=c;return b},createFiberFromFragment:function(a,b,c){b=new be(Yd,null,b);b.pendingProps=a;b.pendingWorkPriority=c;return b},createFiberFromText:function(a,b,c){b=new be(Ud,null,b);b.pendingProps=a;b.pendingWorkPriority=c;return b},createFiberFromElementType:ce,createFiberFromHostInstanceForDeletion:function(){var a=new be(Td,null,$d);a.type="DELETED";return a},createFiberFromCoroutine:function(a,
b,c){b=new be(Wd,a.key,b);b.type=a.handler;b.pendingProps=a;b.pendingWorkPriority=c;return b},createFiberFromYield:function(a,b){return new be(Xd,null,b)},createFiberFromPortal:function(a,b,c){b=new be(Vd,a.key,b);b.pendingProps=a.children||[];b.pendingWorkPriority=c;b.stateNode={containerInfo:a.containerInfo,implementation:a.implementation};return b},largerPriority:function(a,b){return a!==Zd&&(b===Zd||b>a)?a:b}},ee=de.createHostRootFiber,fe=E.IndeterminateComponent,ge=E.FunctionalComponent,he=E.ClassComponent,
ie=E.HostComponent,je,ke;"function"===typeof Symbol&&Symbol["for"]?(je=Symbol["for"]("react.coroutine"),ke=Symbol["for"]("react.yield")):(je=60104,ke=60105);
var le={createCoroutine:function(a,b,c){var d=3<arguments.length&&void 0!==arguments[3]?arguments[3]:null;return{$$typeof:je,key:null==d?null:""+d,children:a,handler:b,props:c}},createYield:function(a){return{$$typeof:ke,value:a}},isCoroutine:function(a){return"object"===typeof a&&null!==a&&a.$$typeof===je},isYield:function(a){return"object"===typeof a&&null!==a&&a.$$typeof===ke},REACT_YIELD_TYPE:ke,REACT_COROUTINE_TYPE:je},me="function"===typeof Symbol&&Symbol["for"]&&Symbol["for"]("react.portal")||
60106,ne={createPortal:function(a,b,c){var d=3<arguments.length&&void 0!==arguments[3]?arguments[3]:null;return{$$typeof:me,key:null==d?null:""+d,children:a,containerInfo:b,implementation:c}},isPortal:function(a){return"object"===typeof a&&null!==a&&a.$$typeof===me},REACT_PORTAL_TYPE:me},oe=le.REACT_COROUTINE_TYPE,pe=le.REACT_YIELD_TYPE,qe=ne.REACT_PORTAL_TYPE,re=de.createWorkInProgress,se=de.createFiberFromElement,te=de.createFiberFromFragment,ue=de.createFiberFromText,ve=de.createFiberFromCoroutine,
we=de.createFiberFromYield,xe=de.createFiberFromPortal,ye=Array.isArray,ze=E.FunctionalComponent,Ae=E.ClassComponent,Be=E.HostText,Ce=E.HostPortal,De=E.CoroutineComponent,Ee=E.YieldComponent,Fe=E.Fragment,Ge=J.NoEffect,He=J.Placement,Ie=J.Deletion,Je="function"===typeof Symbol&&Symbol.iterator,Ke="function"===typeof Symbol&&Symbol["for"]&&Symbol["for"]("react.element")||60103;
function Le(a){if(null===a||"undefined"===typeof a)return null;a=Je&&a[Je]||a["@@iterator"];return"function"===typeof a?a:null}
function Me(a,b){var c=b.ref;if(null!==c&&"function"!==typeof c){if(b._owner){b=b._owner;var d=void 0;b&&("number"===typeof b.tag?(b.tag!==Ae?w("110"):void 0,d=b.stateNode):d=b.getPublicInstance());d?void 0:w("147",c);var e=""+c;if(null!==a&&null!==a.ref&&a.ref._stringRef===e)return a.ref;a=function(a){var b=d.refs===da?d.refs={}:d.refs;null===a?delete b[e]:b[e]=a};a._stringRef=e;return a}"string"!==typeof c?w("148"):void 0;b._owner?void 0:w("149",c)}return c}
function Ne(a,b){"textarea"!==a.type&&w("31","[object Object]"===Object.prototype.toString.call(b)?"object with keys {"+Object.keys(b).join(", ")+"}":b,"")}
function Oe(a,b){function c(c,d){if(b){if(!a){if(null===d.alternate)return;d=d.alternate}var m=c.lastEffect;null!==m?(m.nextEffect=d,c.lastEffect=d):c.firstEffect=c.lastEffect=d;d.nextEffect=null;d.effectTag=Ie}}function d(a,d){if(!b)return null;for(;null!==d;)c(a,d),d=d.sibling;return null}function e(a,b){for(a=new Map;null!==b;)null!==b.key?a.set(b.key,b):a.set(b.index,b),b=b.sibling;return a}function f(b,c){if(a)return b=re(b,c),b.index=0,b.sibling=null,b;b.pendingWorkPriority=c;b.effectTag=Ge;
b.index=0;b.sibling=null;return b}function g(a,c,d){a.index=d;if(!b)return c;d=a.alternate;if(null!==d)return d=d.index,d<c?(a.effectTag=He,c):d;a.effectTag=He;return c}function h(a){b&&null===a.alternate&&(a.effectTag=He);return a}function k(a,b,c,d){if(null===b||b.tag!==Be)return c=ue(c,a.internalContextTag,d),c["return"]=a,c;b=f(b,d);b.pendingProps=c;b["return"]=a;return b}function p(a,b,c,d){if(null===b||b.type!==c.type)return d=se(c,a.internalContextTag,d),d.ref=Me(b,c),d["return"]=a,d;d=f(b,
d);d.ref=Me(b,c);d.pendingProps=c.props;d["return"]=a;return d}function x(a,b,c,d){if(null===b||b.tag!==De)return c=ve(c,a.internalContextTag,d),c["return"]=a,c;b=f(b,d);b.pendingProps=c;b["return"]=a;return b}function S(a,b,c,d){if(null===b||b.tag!==Ee)return b=we(c,a.internalContextTag,d),b.type=c.value,b["return"]=a,b;b=f(b,d);b.type=c.value;b["return"]=a;return b}function D(a,b,c,d){if(null===b||b.tag!==Ce||b.stateNode.containerInfo!==c.containerInfo||b.stateNode.implementation!==c.implementation)return c=
xe(c,a.internalContextTag,d),c["return"]=a,c;b=f(b,d);b.pendingProps=c.children||[];b["return"]=a;return b}function y(a,b,c,d){if(null===b||b.tag!==Fe)return c=te(c,a.internalContextTag,d),c["return"]=a,c;b=f(b,d);b.pendingProps=c;b["return"]=a;return b}function B(a,b,c){if("string"===typeof b||"number"===typeof b)return b=ue(""+b,a.internalContextTag,c),b["return"]=a,b;if("object"===typeof b&&null!==b){switch(b.$$typeof){case Ke:return c=se(b,a.internalContextTag,c),c.ref=Me(null,b),c["return"]=
a,c;case oe:return b=ve(b,a.internalContextTag,c),b["return"]=a,b;case pe:return c=we(b,a.internalContextTag,c),c.type=b.value,c["return"]=a,c;case qe:return b=xe(b,a.internalContextTag,c),b["return"]=a,b}if(ye(b)||Le(b))return b=te(b,a.internalContextTag,c),b["return"]=a,b;Ne(a,b)}return null}function H(a,b,c,d){var e=null!==b?b.key:null;if("string"===typeof c||"number"===typeof c)return null!==e?null:k(a,b,""+c,d);if("object"===typeof c&&null!==c){switch(c.$$typeof){case Ke:return c.key===e?p(a,
b,c,d):null;case oe:return c.key===e?x(a,b,c,d):null;case pe:return null===e?S(a,b,c,d):null;case qe:return c.key===e?D(a,b,c,d):null}if(ye(c)||Le(c))return null!==e?null:y(a,b,c,d);Ne(a,c)}return null}function C(a,b,c,d,e){if("string"===typeof d||"number"===typeof d)return a=a.get(c)||null,k(b,a,""+d,e);if("object"===typeof d&&null!==d){switch(d.$$typeof){case Ke:return a=a.get(null===d.key?c:d.key)||null,p(b,a,d,e);case oe:return a=a.get(null===d.key?c:d.key)||null,x(b,a,d,e);case pe:return a=a.get(c)||
null,S(b,a,d,e);case qe:return a=a.get(null===d.key?c:d.key)||null,D(b,a,d,e)}if(ye(d)||Le(d))return a=a.get(c)||null,y(b,a,d,e);Ne(b,d)}return null}function Ca(a,f,h,k){for(var m=null,t=null,q=f,r=f=0,p=null;null!==q&&r<h.length;r++){q.index>r?(p=q,q=null):p=q.sibling;var v=H(a,q,h[r],k);if(null===v){null===q&&(q=p);break}b&&q&&null===v.alternate&&c(a,q);f=g(v,f,r);null===t?m=v:t.sibling=v;t=v;q=p}if(r===h.length)return d(a,q),m;if(null===q){for(;r<h.length;r++)if(q=B(a,h[r],k))f=g(q,f,r),null===
t?m=q:t.sibling=q,t=q;return m}for(q=e(a,q);r<h.length;r++)if(p=C(q,a,r,h[r],k)){if(b&&null!==p.alternate)q["delete"](null===p.key?r:p.key);f=g(p,f,r);null===t?m=p:t.sibling=p;t=p}b&&q.forEach(function(b){return c(a,b)});return m}function r(a,f,h,r){var m=Le(h);"function"!==typeof m?w("150"):void 0;h=m.call(h);null==h?w("151"):void 0;for(var t=m=null,q=f,k=f=0,p=null,v=h.next();null!==q&&!v.done;k++,v=h.next()){q.index>k?(p=q,q=null):p=q.sibling;var V=H(a,q,v.value,r);if(null===V){q||(q=p);break}b&&
q&&null===V.alternate&&c(a,q);f=g(V,f,k);null===t?m=V:t.sibling=V;t=V;q=p}if(v.done)return d(a,q),m;if(null===q){for(;!v.done;k++,v=h.next())v=B(a,v.value,r),null!==v&&(f=g(v,f,k),null===t?m=v:t.sibling=v,t=v);return m}for(q=e(a,q);!v.done;k++,v=h.next())if(v=C(q,a,k,v.value,r),null!==v){if(b&&null!==v.alternate)q["delete"](null===v.key?k:v.key);f=g(v,f,k);null===t?m=v:t.sibling=v;t=v}b&&q.forEach(function(b){return c(a,b)});return m}return function(a,b,e,g){var m="object"===typeof e&&null!==e;if(m)switch(e.$$typeof){case Ke:a:{var C=
e.key;for(m=b;null!==m;){if(m.key===C)if(m.type===e.type){d(a,m.sibling);b=f(m,g);b.ref=Me(m,e);b.pendingProps=e.props;b["return"]=a;a=b;break a}else{d(a,m);break}else c(a,m);m=m.sibling}g=se(e,a.internalContextTag,g);g.ref=Me(b,e);g["return"]=a;a=g}return h(a);case oe:a:{for(m=e.key;null!==b;){if(b.key===m)if(b.tag===De){d(a,b.sibling);b=f(b,g);b.pendingProps=e;b["return"]=a;a=b;break a}else{d(a,b);break}else c(a,b);b=b.sibling}e=ve(e,a.internalContextTag,g);e["return"]=a;a=e}return h(a);case pe:a:{if(null!==
b)if(b.tag===Ee){d(a,b.sibling);b=f(b,g);b.type=e.value;b["return"]=a;a=b;break a}else d(a,b);b=we(e,a.internalContextTag,g);b.type=e.value;b["return"]=a;a=b}return h(a);case qe:a:{for(m=e.key;null!==b;){if(b.key===m)if(b.tag===Ce&&b.stateNode.containerInfo===e.containerInfo&&b.stateNode.implementation===e.implementation){d(a,b.sibling);b=f(b,g);b.pendingProps=e.children||[];b["return"]=a;a=b;break a}else{d(a,b);break}else c(a,b);b=b.sibling}e=xe(e,a.internalContextTag,g);e["return"]=a;a=e}return h(a)}if("string"===
typeof e||"number"===typeof e)return e=""+e,null!==b&&b.tag===Be?(d(a,b.sibling),b=f(b,g),b.pendingProps=e,b["return"]=a,a=b):(d(a,b),e=ue(e,a.internalContextTag,g),e["return"]=a,a=e),h(a);if(ye(e))return Ca(a,b,e,g);if(Le(e))return r(a,b,e,g);m&&Ne(a,e);if("undefined"===typeof e)switch(a.tag){case Ae:case ze:e=a.type,w("152",e.displayName||e.name||"Component")}return d(a,b)}}
var Pe=Oe(!0,!0),Qe=Oe(!1,!0),Re=Oe(!1,!1),Se={reconcileChildFibers:Pe,reconcileChildFibersInPlace:Qe,mountChildFibersInPlace:Re,cloneChildFibers:function(a,b){null!==a&&b.child!==a.child?w("153"):void 0;if(null!==b.child){a=b.child;var c=re(a,a.pendingWorkPriority);c.pendingProps=a.pendingProps;b.child=c;for(c["return"]=b;null!==a.sibling;)a=a.sibling,c=c.sibling=re(a,a.pendingWorkPriority),c.pendingProps=a.pendingProps,c["return"]=b;c.sibling=null}}},Te=J.Update,Ue=Pd.AsyncUpdates,Ve=R.cacheContext,
We=R.getMaskedContext,Xe=R.getUnmaskedContext,Ye=R.isContextConsumer,Ze=ud.addUpdate,$e=ud.addReplaceUpdate,af=ud.addForceUpdate,bf=ud.beginUpdateQueue,cf=R.hasContextChanged,df=bb.isMounted;
function ef(a,b,c,d){function e(a,b){b.updater=f;a.stateNode=b;Pa.set(b,a)}var f={isMounted:df,enqueueSetState:function(c,d,e){c=Pa.get(c);var f=b(c,!1);Ze(c,d,void 0===e?null:e,f);a(c,f)},enqueueReplaceState:function(c,d,e){c=Pa.get(c);var f=b(c,!1);$e(c,d,void 0===e?null:e,f);a(c,f)},enqueueForceUpdate:function(c,d){c=Pa.get(c);var e=b(c,!1);af(c,void 0===d?null:d,e);a(c,e)}};return{adoptClassInstance:e,constructClassInstance:function(a,b){var c=a.type,d=Xe(a),f=Ye(a),g=f?We(a,d):da;b=new c(b,g);
e(a,b);f&&Ve(a,d,g);return b},mountClassInstance:function(a,b){var c=a.alternate,d=a.stateNode,e=d.state||null,g=a.pendingProps;g?void 0:w("158");var h=Xe(a);d.props=g;d.state=e;d.refs=da;d.context=We(a,h);ed.enableAsyncSubtreeAPI&&null!=a.type&&null!=a.type.prototype&&!0===a.type.prototype.unstable_isAsyncReactComponent&&(a.internalContextTag|=Ue);"function"===typeof d.componentWillMount&&(h=d.state,d.componentWillMount(),h!==d.state&&f.enqueueReplaceState(d,d.state,null),h=a.updateQueue,null!==
h&&(d.state=bf(c,a,h,d,e,g,b)));"function"===typeof d.componentDidMount&&(a.effectTag|=Te)},updateClassInstance:function(a,b,e){var g=b.stateNode;g.props=b.memoizedProps;g.state=b.memoizedState;var h=b.memoizedProps,k=b.pendingProps;k||(k=h,null==k?w("159"):void 0);var D=g.context,y=Xe(b);y=We(b,y);"function"!==typeof g.componentWillReceiveProps||h===k&&D===y||(D=g.state,g.componentWillReceiveProps(k,y),g.state!==D&&f.enqueueReplaceState(g,g.state,null));D=b.memoizedState;e=null!==b.updateQueue?bf(a,
b,b.updateQueue,g,D,k,e):D;if(!(h!==k||D!==e||cf()||null!==b.updateQueue&&b.updateQueue.hasForceUpdate))return"function"!==typeof g.componentDidUpdate||h===a.memoizedProps&&D===a.memoizedState||(b.effectTag|=Te),!1;var B=k;if(null===h||null!==b.updateQueue&&b.updateQueue.hasForceUpdate)B=!0;else{var H=b.stateNode,C=b.type;B="function"===typeof H.shouldComponentUpdate?H.shouldComponentUpdate(B,e,y):C.prototype&&C.prototype.isPureReactComponent?!ea(h,B)||!ea(D,e):!0}B?("function"===typeof g.componentWillUpdate&&
g.componentWillUpdate(k,e,y),"function"===typeof g.componentDidUpdate&&(b.effectTag|=Te)):("function"!==typeof g.componentDidUpdate||h===a.memoizedProps&&D===a.memoizedState||(b.effectTag|=Te),c(b,k),d(b,e));g.props=k;g.state=e;g.context=y;return B}}}
var ff=Se.mountChildFibersInPlace,gf=Se.reconcileChildFibers,hf=Se.reconcileChildFibersInPlace,jf=Se.cloneChildFibers,kf=ud.beginUpdateQueue,lf=R.getMaskedContext,mf=R.getUnmaskedContext,nf=R.hasContextChanged,of=R.pushContextProvider,pf=R.pushTopLevelContextObject,qf=R.invalidateContextProvider,rf=E.IndeterminateComponent,sf=E.FunctionalComponent,tf=E.ClassComponent,uf=E.HostRoot,wf=E.HostComponent,xf=E.HostText,yf=E.HostPortal,zf=E.CoroutineComponent,Af=E.CoroutineHandlerPhase,Bf=E.YieldComponent,
Cf=E.Fragment,Df=Q.NoWork,Ef=Q.OffscreenPriority,Ff=J.PerformedWork,Gf=J.Placement,Hf=J.ContentReset,If=J.Err,Jf=J.Ref,Kf=Qa.ReactCurrentOwner;
function Lf(a,b,c,d,e){function f(a,b,c){g(a,b,c,b.pendingWorkPriority)}function g(a,b,c,d){b.child=null===a?ff(b,b.child,c,d):a.child===b.child?gf(b,b.child,c,d):hf(b,b.child,c,d)}function h(a,b){var c=b.ref;null===c||a&&a.ref===c||(b.effectTag|=Jf)}function k(a,b,c,d){h(a,b);if(!c)return d&&qf(b,!1),x(a,b);c=b.stateNode;Kf.current=b;var e=c.render();b.effectTag|=Ff;f(a,b,e);b.memoizedState=c.state;b.memoizedProps=c.props;d&&qf(b,!0);return b.child}function p(a){var b=a.stateNode;b.pendingContext?
pf(a,b.pendingContext,b.pendingContext!==b.context):b.context&&pf(a,b.context,!1);C(a,b.containerInfo)}function x(a,b){jf(a,b);return b.child}function S(a,b){switch(b.tag){case uf:p(b);break;case tf:of(b);break;case yf:C(b,b.stateNode.containerInfo)}return null}var D=a.shouldSetTextContent,y=a.useSyncScheduling,B=a.shouldDeprioritizeSubtree,H=b.pushHostContext,C=b.pushHostContainer,Ca=c.enterHydrationState,r=c.resetHydrationState,m=c.tryToClaimNextHydratableInstance;a=ef(d,e,function(a,b){a.memoizedProps=
b},function(a,b){a.memoizedState=b});var t=a.adoptClassInstance,v=a.constructClassInstance,V=a.mountClassInstance,ld=a.updateClassInstance;return{beginWork:function(a,b,c){if(b.pendingWorkPriority===Df||b.pendingWorkPriority>c)return S(a,b);switch(b.tag){case rf:null!==a?w("155"):void 0;var d=b.type,e=b.pendingProps,g=mf(b);g=lf(b,g);d=d(e,g);b.effectTag|=Ff;"object"===typeof d&&null!==d&&"function"===typeof d.render?(b.tag=tf,e=of(b),t(b,d),V(b,c),b=k(a,b,!0,e)):(b.tag=sf,f(a,b,d),b.memoizedProps=
e,b=b.child);return b;case sf:a:{e=b.type;c=b.pendingProps;d=b.memoizedProps;if(nf())null===c&&(c=d);else if(null===c||d===c){b=x(a,b);break a}d=mf(b);d=lf(b,d);e=e(c,d);b.effectTag|=Ff;f(a,b,e);b.memoizedProps=c;b=b.child}return b;case tf:return e=of(b),d=void 0,null===a?b.stateNode?w("153"):(v(b,b.pendingProps),V(b,c),d=!0):d=ld(a,b,c),k(a,b,d,e);case uf:return p(b),d=b.updateQueue,null!==d?(e=b.memoizedState,d=kf(a,b,d,null,e,null,c),e===d?(r(),b=x(a,b)):(e=d.element,null!==a&&null!==a.child||
!Ca(b)?(r(),f(a,b,e)):(b.effectTag|=Gf,b.child=ff(b,b.child,e,c)),b.memoizedState=d,b=b.child)):(r(),b=x(a,b)),b;case wf:H(b);null===a&&m(b);e=b.type;var q=b.memoizedProps;d=b.pendingProps;null===d&&(d=q,null===d?w("154"):void 0);g=null!==a?a.memoizedProps:null;nf()||null!==d&&q!==d?(q=d.children,D(e,d)?q=null:g&&D(e,g)&&(b.effectTag|=Hf),h(a,b),c!==Ef&&!y&&B(e,d)?(b.pendingWorkPriority=Ef,b=null):(f(a,b,q),b.memoizedProps=d,b=b.child)):b=x(a,b);return b;case xf:return null===a&&m(b),a=b.pendingProps,
null===a&&(a=b.memoizedProps),b.memoizedProps=a,null;case Af:b.tag=zf;case zf:c=b.pendingProps;if(nf())null===c&&(c=a&&a.memoizedProps,null===c?w("154"):void 0);else if(null===c||b.memoizedProps===c)c=b.memoizedProps;e=c.children;d=b.pendingWorkPriority;b.stateNode=null===a?ff(b,b.stateNode,e,d):a.child===b.child?gf(b,b.stateNode,e,d):hf(b,b.stateNode,e,d);b.memoizedProps=c;return b.stateNode;case Bf:return null;case yf:a:{C(b,b.stateNode.containerInfo);c=b.pendingWorkPriority;e=b.pendingProps;if(nf())null===
e&&(e=a&&a.memoizedProps,null==e?w("154"):void 0);else if(null===e||b.memoizedProps===e){b=x(a,b);break a}null===a?b.child=hf(b,b.child,e,c):f(a,b,e);b.memoizedProps=e;b=b.child}return b;case Cf:a:{c=b.pendingProps;if(nf())null===c&&(c=b.memoizedProps);else if(null===c||b.memoizedProps===c){b=x(a,b);break a}f(a,b,c);b.memoizedProps=c;b=b.child}return b;default:w("156")}},beginFailedWork:function(a,b,c){switch(b.tag){case tf:of(b);break;case uf:p(b);break;default:w("157")}b.effectTag|=If;null===a?
b.child=null:b.child!==a.child&&(b.child=a.child);if(b.pendingWorkPriority===Df||b.pendingWorkPriority>c)return S(a,b);b.firstEffect=null;b.lastEffect=null;g(a,b,null,c);b.tag===tf&&(a=b.stateNode,b.memoizedProps=a.props,b.memoizedState=a.state);return b.child}}}
var Mf=Se.reconcileChildFibers,Nf=R.popContextProvider,Of=R.popTopLevelContextObject,Pf=E.IndeterminateComponent,Qf=E.FunctionalComponent,Rf=E.ClassComponent,Sf=E.HostRoot,Tf=E.HostComponent,Uf=E.HostText,Vf=E.HostPortal,Wf=E.CoroutineComponent,Xf=E.CoroutineHandlerPhase,Yf=E.YieldComponent,Zf=E.Fragment,ag=J.Placement,bg=J.Ref,cg=J.Update,dg=Q.OffscreenPriority;
function eg(a,b,c){var d=a.createInstance,e=a.createTextInstance,f=a.appendInitialChild,g=a.finalizeInitialChildren,h=a.prepareUpdate,k=b.getRootHostContainer,p=b.popHostContext,x=b.getHostContext,S=b.popHostContainer,D=c.prepareToHydrateHostInstance,y=c.prepareToHydrateHostTextInstance,B=c.popHydrationState;return{completeWork:function(a,b,c){var r=b.pendingProps;if(null===r)r=b.memoizedProps;else if(b.pendingWorkPriority!==dg||c===dg)b.pendingProps=null;switch(b.tag){case Qf:return null;case Rf:return Nf(b),
null;case Sf:S(b);Of(b);r=b.stateNode;r.pendingContext&&(r.context=r.pendingContext,r.pendingContext=null);if(null===a||null===a.child)B(b),b.effectTag&=~ag;return null;case Tf:p(b);c=k();var m=b.type;if(null!==a&&null!=b.stateNode){var t=a.memoizedProps,C=b.stateNode,V=x();r=h(C,m,t,r,c,V);if(b.updateQueue=r)b.effectTag|=cg;a.ref!==b.ref&&(b.effectTag|=bg)}else{if(!r)return null===b.stateNode?w("166"):void 0,null;a=x();if(B(b))D(b,c,a)&&(b.effectTag|=cg);else{a=d(m,r,c,a,b);a:for(t=b.child;null!==
t;){if(t.tag===Tf||t.tag===Uf)f(a,t.stateNode);else if(t.tag!==Vf&&null!==t.child){t=t.child;continue}if(t===b)break a;for(;null===t.sibling;){if(null===t["return"]||t["return"]===b)break a;t=t["return"]}t=t.sibling}g(a,m,r,c)&&(b.effectTag|=cg);b.stateNode=a}null!==b.ref&&(b.effectTag|=bg)}return null;case Uf:if(a&&null!=b.stateNode)a.memoizedProps!==r&&(b.effectTag|=cg);else{if("string"!==typeof r)return null===b.stateNode?w("166"):void 0,null;a=k();c=x();B(b)?y(b)&&(b.effectTag|=cg):b.stateNode=
e(r,a,c,b)}return null;case Wf:(r=b.memoizedProps)?void 0:w("165");b.tag=Xf;c=[];a:for((m=b.stateNode)&&(m["return"]=b);null!==m;){if(m.tag===Tf||m.tag===Uf||m.tag===Vf)w("164");else if(m.tag===Yf)c.push(m.type);else if(null!==m.child){m.child["return"]=m;m=m.child;continue}for(;null===m.sibling;){if(null===m["return"]||m["return"]===b)break a;m=m["return"]}m.sibling["return"]=m["return"];m=m.sibling}m=r.handler;r=m(r.props,c);b.child=Mf(b,null!==a?a.child:null,r,b.pendingWorkPriority);return b.child;
case Xf:return b.tag=Wf,null;case Yf:return null;case Zf:return null;case Vf:return b.effectTag|=cg,S(b),null;case Pf:w("167");default:w("156")}}}}var fg=null,gg=null;function hg(a){return function(b){try{return a(b)}catch(c){}}}
var ig={injectInternals:function(a){if("undefined"===typeof __REACT_DEVTOOLS_GLOBAL_HOOK__)return!1;var b=__REACT_DEVTOOLS_GLOBAL_HOOK__;if(!b.supportsFiber)return!0;try{var c=b.inject(a);fg=hg(function(a){return b.onCommitFiberRoot(c,a)});gg=hg(function(a){return b.onCommitFiberUnmount(c,a)})}catch(d){}return!0},onCommitRoot:function(a){"function"===typeof fg&&fg(a)},onCommitUnmount:function(a){"function"===typeof gg&&gg(a)}},jg=E.ClassComponent,kg=E.HostRoot,lg=E.HostComponent,mg=E.HostText,ng=
E.HostPortal,og=E.CoroutineComponent,pg=ud.commitCallbacks,qg=ig.onCommitUnmount,rg=J.Placement,sg=J.Update,tg=J.Callback,ug=J.ContentReset;
function vg(a,b){function c(a){var c=a.ref;if(null!==c)try{c(null)}catch(t){b(a,t)}}function d(a){return a.tag===lg||a.tag===kg||a.tag===ng}function e(a){for(var b=a;;)if(g(b),null!==b.child&&b.tag!==ng)b.child["return"]=b,b=b.child;else{if(b===a)break;for(;null===b.sibling;){if(null===b["return"]||b["return"]===a)return;b=b["return"]}b.sibling["return"]=b["return"];b=b.sibling}}function f(a){for(var b=a,c=!1,d=void 0,f=void 0;;){if(!c){c=b["return"];a:for(;;){null===c?w("160"):void 0;switch(c.tag){case lg:d=
c.stateNode;f=!1;break a;case kg:d=c.stateNode.containerInfo;f=!0;break a;case ng:d=c.stateNode.containerInfo;f=!0;break a}c=c["return"]}c=!0}if(b.tag===lg||b.tag===mg)e(b),f?C(d,b.stateNode):H(d,b.stateNode);else if(b.tag===ng?d=b.stateNode.containerInfo:g(b),null!==b.child){b.child["return"]=b;b=b.child;continue}if(b===a)break;for(;null===b.sibling;){if(null===b["return"]||b["return"]===a)return;b=b["return"];b.tag===ng&&(c=!1)}b.sibling["return"]=b["return"];b=b.sibling}}function g(a){"function"===
typeof qg&&qg(a);switch(a.tag){case jg:c(a);var d=a.stateNode;if("function"===typeof d.componentWillUnmount)try{d.props=a.memoizedProps,d.state=a.memoizedState,d.componentWillUnmount()}catch(t){b(a,t)}break;case lg:c(a);break;case og:e(a.stateNode);break;case ng:f(a)}}var h=a.commitMount,k=a.commitUpdate,p=a.resetTextContent,x=a.commitTextUpdate,S=a.appendChild,D=a.appendChildToContainer,y=a.insertBefore,B=a.insertInContainerBefore,H=a.removeChild,C=a.removeChildFromContainer,Ca=a.getPublicInstance;
return{commitPlacement:function(a){a:{for(var b=a["return"];null!==b;){if(d(b)){var c=b;break a}b=b["return"]}w("160");c=void 0}var e=b=void 0;switch(c.tag){case lg:b=c.stateNode;e=!1;break;case kg:b=c.stateNode.containerInfo;e=!0;break;case ng:b=c.stateNode.containerInfo;e=!0;break;default:w("161")}c.effectTag&ug&&(p(b),c.effectTag&=~ug);a:b:for(c=a;;){for(;null===c.sibling;){if(null===c["return"]||d(c["return"])){c=null;break a}c=c["return"]}c.sibling["return"]=c["return"];for(c=c.sibling;c.tag!==
lg&&c.tag!==mg;){if(c.effectTag&rg)continue b;if(null===c.child||c.tag===ng)continue b;else c.child["return"]=c,c=c.child}if(!(c.effectTag&rg)){c=c.stateNode;break a}}for(var f=a;;){if(f.tag===lg||f.tag===mg)c?e?B(b,f.stateNode,c):y(b,f.stateNode,c):e?D(b,f.stateNode):S(b,f.stateNode);else if(f.tag!==ng&&null!==f.child){f.child["return"]=f;f=f.child;continue}if(f===a)break;for(;null===f.sibling;){if(null===f["return"]||f["return"]===a)return;f=f["return"]}f.sibling["return"]=f["return"];f=f.sibling}},
commitDeletion:function(a){f(a);a["return"]=null;a.child=null;a.alternate&&(a.alternate.child=null,a.alternate["return"]=null)},commitWork:function(a,b){switch(b.tag){case jg:break;case lg:var c=b.stateNode;if(null!=c){var d=b.memoizedProps;a=null!==a?a.memoizedProps:d;var e=b.type,f=b.updateQueue;b.updateQueue=null;null!==f&&k(c,f,e,a,d,b)}break;case mg:null===b.stateNode?w("162"):void 0;c=b.memoizedProps;x(b.stateNode,null!==a?a.memoizedProps:c,c);break;case kg:break;case ng:break;default:w("163")}},
commitLifeCycles:function(a,b){switch(b.tag){case jg:var c=b.stateNode;if(b.effectTag&sg)if(null===a)c.props=b.memoizedProps,c.state=b.memoizedState,c.componentDidMount();else{var d=a.memoizedProps;a=a.memoizedState;c.props=b.memoizedProps;c.state=b.memoizedState;c.componentDidUpdate(d,a)}b.effectTag&tg&&null!==b.updateQueue&&pg(b,b.updateQueue,c);break;case kg:a=b.updateQueue;null!==a&&pg(b,a,b.child&&b.child.stateNode);break;case lg:c=b.stateNode;null===a&&b.effectTag&sg&&h(c,b.type,b.memoizedProps,
b);break;case mg:break;case ng:break;default:w("163")}},commitAttachRef:function(a){var b=a.ref;if(null!==b){var c=a.stateNode;switch(a.tag){case lg:b(Ca(c));break;default:b(c)}}},commitDetachRef:function(a){a=a.ref;null!==a&&a(null)}}}var wg=xd.createCursor,xg=xd.pop,yg=xd.push,zg={};
function Ag(a){function b(a){a===zg?w("174"):void 0;return a}var c=a.getChildHostContext,d=a.getRootHostContext,e=wg(zg),f=wg(zg),g=wg(zg);return{getHostContext:function(){return b(e.current)},getRootHostContainer:function(){return b(g.current)},popHostContainer:function(a){xg(e,a);xg(f,a);xg(g,a)},popHostContext:function(a){f.current===a&&(xg(e,a),xg(f,a))},pushHostContainer:function(a,b){yg(g,b,a);b=d(b);yg(f,a,a);yg(e,b,a)},pushHostContext:function(a){var d=b(g.current),h=b(e.current);d=c(h,a.type,
d);h!==d&&(yg(f,a,a),yg(e,d,a))},resetHostContainer:function(){e.current=zg;g.current=zg}}}var Bg=E.HostComponent,Cg=E.HostText,Dg=E.HostRoot,Eg=J.Deletion,Fg=J.Placement,Gg=de.createFiberFromHostInstanceForDeletion;
function Hg(a){function b(a,b){var c=Gg();c.stateNode=b;c["return"]=a;c.effectTag=Eg;null!==a.lastEffect?(a.lastEffect.nextEffect=c,a.lastEffect=c):a.firstEffect=a.lastEffect=c}function c(a,b){switch(a.tag){case Bg:return f(b,a.type,a.pendingProps);case Cg:return g(b,a.pendingProps);default:return!1}}function d(a){for(a=a["return"];null!==a&&a.tag!==Bg&&a.tag!==Dg;)a=a["return"];y=a}var e=a.shouldSetTextContent,f=a.canHydrateInstance,g=a.canHydrateTextInstance,h=a.getNextHydratableSibling,k=a.getFirstHydratableChild,
p=a.hydrateInstance,x=a.hydrateTextInstance,S=a.didNotHydrateInstance,D=a.didNotFindHydratableInstance;a=a.didNotFindHydratableTextInstance;if(!(f&&g&&h&&k&&p&&x&&S&&D&&a))return{enterHydrationState:function(){return!1},resetHydrationState:function(){},tryToClaimNextHydratableInstance:function(){},prepareToHydrateHostInstance:function(){w("175")},prepareToHydrateHostTextInstance:function(){w("176")},popHydrationState:function(){return!1}};var y=null,B=null,H=!1;return{enterHydrationState:function(a){B=
k(a.stateNode.containerInfo);y=a;return H=!0},resetHydrationState:function(){B=y=null;H=!1},tryToClaimNextHydratableInstance:function(a){if(H){var d=B;if(d){if(!c(a,d)){d=h(d);if(!d||!c(a,d)){a.effectTag|=Fg;H=!1;y=a;return}b(y,B)}a.stateNode=d;y=a;B=k(d)}else a.effectTag|=Fg,H=!1,y=a}},prepareToHydrateHostInstance:function(a,b,c){b=p(a.stateNode,a.type,a.memoizedProps,b,c,a);a.updateQueue=b;return null!==b?!0:!1},prepareToHydrateHostTextInstance:function(a){return x(a.stateNode,a.memoizedProps,a)},
popHydrationState:function(a){if(a!==y)return!1;if(!H)return d(a),H=!0,!1;var c=a.type;if(a.tag!==Bg||"head"!==c&&"body"!==c&&!e(c,a.memoizedProps))for(c=B;c;)b(a,c),c=h(c);d(a);B=y?h(a.stateNode):null;return!0}}}
var Ig=R.popContextProvider,Jg=xd.reset,Kg=Qa.ReactCurrentOwner,Lg=de.createWorkInProgress,Mg=de.largerPriority,Ng=ig.onCommitRoot,T=Q.NoWork,Og=Q.SynchronousPriority,U=Q.TaskPriority,Pg=Q.HighPriority,Qg=Q.LowPriority,Rg=Q.OffscreenPriority,Sg=Pd.AsyncUpdates,Tg=J.PerformedWork,Ug=J.Placement,Vg=J.Update,Wg=J.PlacementAndUpdate,Xg=J.Deletion,Yg=J.ContentReset,Zg=J.Callback,$g=J.Err,ah=J.Ref,bh=E.HostRoot,ch=E.HostComponent,dh=E.HostPortal,eh=E.ClassComponent,fh=ud.getUpdatePriority,gh=R.resetContext;
function hh(a){function b(){for(;null!==ma&&ma.current.pendingWorkPriority===T;){ma.isScheduled=!1;var a=ma.nextScheduledRoot;ma.nextScheduledRoot=null;if(ma===zb)return zb=ma=null,z=T,null;ma=a}a=ma;for(var b=null,c=T;null!==a;)a.current.pendingWorkPriority!==T&&(c===T||c>a.current.pendingWorkPriority)&&(c=a.current.pendingWorkPriority,b=a),a=a.nextScheduledRoot;null!==b?(z=c,Jg(),gh(),t(),I=Lg(b.current,c),b!==nc&&(oc=0,nc=b)):(z=T,nc=I=null)}function c(c){Hd=!0;na=null;var d=c.stateNode;d.current===
c?w("177"):void 0;z!==Og&&z!==U||oc++;Kg.current=null;if(c.effectTag>Tg)if(null!==c.lastEffect){c.lastEffect.nextEffect=c;var e=c.firstEffect}else e=c;else e=c.firstEffect;Ui();for(u=e;null!==u;){var f=!1,g=void 0;try{for(;null!==u;){var h=u.effectTag;h&Yg&&a.resetTextContent(u.stateNode);if(h&ah){var k=u.alternate;null!==k&&Ph(k)}switch(h&~(Zg|$g|Yg|ah|Tg)){case Ug:q(u);u.effectTag&=~Ug;break;case Wg:q(u);u.effectTag&=~Ug;vf(u.alternate,u);break;case Vg:vf(u.alternate,u);break;case Xg:Id=!0,Mh(u),
Id=!1}u=u.nextEffect}}catch(Jd){f=!0,g=Jd}f&&(null===u?w("178"):void 0,x(u,g),null!==u&&(u=u.nextEffect))}Vi();d.current=c;for(u=e;null!==u;){d=!1;e=void 0;try{for(;null!==u;){var Gd=u.effectTag;Gd&(Vg|Zg)&&Nh(u.alternate,u);Gd&ah&&Oh(u);if(Gd&$g)switch(f=u,g=void 0,null!==P&&(g=P.get(f),P["delete"](f),null==g&&null!==f.alternate&&(f=f.alternate,g=P.get(f),P["delete"](f))),null==g?w("184"):void 0,f.tag){case eh:f.stateNode.componentDidCatch(g.error,{componentStack:g.componentStack});break;case bh:null===
Ja&&(Ja=g.error);break;default:w("157")}var m=u.nextEffect;u.nextEffect=null;u=m}}catch(Jd){d=!0,e=Jd}d&&(null===u?w("178"):void 0,x(u,e),null!==u&&(u=u.nextEffect))}Hd=!1;"function"===typeof Ng&&Ng(c.stateNode);va&&(va.forEach(H),va=null);b()}function d(a){for(;;){var b=Lh(a.alternate,a,z),c=a["return"],d=a.sibling;var e=a;if(!(e.pendingWorkPriority!==T&&e.pendingWorkPriority>z)){for(var f=fh(e),g=e.child;null!==g;)f=Mg(f,g.pendingWorkPriority),g=g.sibling;e.pendingWorkPriority=f}if(null!==b)return b;
null!==c&&(null===c.firstEffect&&(c.firstEffect=a.firstEffect),null!==a.lastEffect&&(null!==c.lastEffect&&(c.lastEffect.nextEffect=a.firstEffect),c.lastEffect=a.lastEffect),a.effectTag>Tg&&(null!==c.lastEffect?c.lastEffect.nextEffect=a:c.firstEffect=a,c.lastEffect=a));if(null!==d)return d;if(null!==c)a=c;else{na=a;break}}return null}function e(a){var b=V(a.alternate,a,z);null===b&&(b=d(a));Kg.current=null;return b}function f(a){var b=ld(a.alternate,a,z);null===b&&(b=d(a));Kg.current=null;return b}
function g(a){p(Rg,a)}function h(){if(null!==P&&0<P.size&&z===U)for(;null!==I;){var a=I;I=null!==P&&(P.has(a)||null!==a.alternate&&P.has(a.alternate))?f(I):e(I);if(null===I&&(null===na?w("179"):void 0,O=U,c(na),O=z,null===P||0===P.size||z!==U))break}}function k(a,d){null!==na?(O=U,c(na),h()):null===I&&b();if(!(z===T||z>a)){O=z;a:do{if(z<=U)for(;null!==I&&!(I=e(I),null===I&&(null===na?w("179"):void 0,O=U,c(na),O=z,h(),z===T||z>a||z>U)););else if(null!==d)for(;null!==I&&!Ab;)if(1<d.timeRemaining()){if(I=
e(I),null===I)if(null===na?w("179"):void 0,1<d.timeRemaining()){if(O=U,c(na),O=z,h(),z===T||z>a||z<Pg)break}else Ab=!0}else Ab=!0;switch(z){case Og:case U:if(z<=a)continue a;break a;case Pg:case Qg:case Rg:if(null===d)break a;if(!Ab&&z<=a)continue a;break a;case T:break a;default:w("181")}}while(1)}}function p(a,b){Da?w("182"):void 0;Da=!0;var c=O,d=!1,e=null;try{k(a,b)}catch(Kd){d=!0,e=Kd}for(;d;){if(Ya){Ja=e;break}var h=I;if(null===h)Ya=!0;else{var p=x(h,e);null===p?w("183"):void 0;if(!Ya){try{d=
p;e=a;p=b;for(var q=d;null!==h;){switch(h.tag){case eh:Ig(h);break;case ch:m(h);break;case bh:r(h);break;case dh:r(h)}if(h===q||h.alternate===q)break;h=h["return"]}I=f(d);k(e,p)}catch(Kd){d=!0;e=Kd;continue}break}}}O=c;null!==b&&(Bb=!1);z>U&&!Bb&&($f(g),Bb=!0);a=Ja;Ya=Ab=Da=!1;nc=Ka=P=Ja=null;oc=0;if(null!==a)throw a;}function x(a,b){var c=Kg.current=null,d=!1,e=!1,f=null;if(a.tag===bh)c=a,S(a)&&(Ya=!0);else for(var g=a["return"];null!==g&&null===c;){g.tag===eh?"function"===typeof g.stateNode.componentDidCatch&&
(d=!0,f=Ra(g),c=g,e=!0):g.tag===bh&&(c=g);if(S(g)){if(Id||null!==va&&(va.has(g)||null!==g.alternate&&va.has(g.alternate)))return null;c=null;e=!1}g=g["return"]}if(null!==c){null===Ka&&(Ka=new Set);Ka.add(c);var h="";g=a;do{a:switch(g.tag){case fe:case ge:case he:case ie:var k=g._debugOwner,m=g._debugSource;var p=Ra(g);var q=null;k&&(q=Ra(k));k=m;p="\n    in "+(p||"Unknown")+(k?" (at "+k.fileName.replace(/^.*[\\\/]/,"")+":"+k.lineNumber+")":q?" (created by "+q+")":"");break a;default:p=""}h+=p;g=g["return"]}while(g);
g=h;a=Ra(a);null===P&&(P=new Map);b={componentName:a,componentStack:g,error:b,errorBoundary:d?c.stateNode:null,errorBoundaryFound:d,errorBoundaryName:f,willRetry:e};P.set(c,b);try{console.error(b.error)}catch(Wi){console.error(Wi)}Hd?(null===va&&(va=new Set),va.add(c)):H(c);return c}null===Ja&&(Ja=b);return null}function S(a){return null!==Ka&&(Ka.has(a)||null!==a.alternate&&Ka.has(a.alternate))}function D(a,b){return y(a,b,!1)}function y(a,b){oc>Xi&&(Ya=!0,w("185"));!Da&&b<=z&&(I=null);for(var c=
!0;null!==a&&c;){c=!1;if(a.pendingWorkPriority===T||a.pendingWorkPriority>b)c=!0,a.pendingWorkPriority=b;null!==a.alternate&&(a.alternate.pendingWorkPriority===T||a.alternate.pendingWorkPriority>b)&&(c=!0,a.alternate.pendingWorkPriority=b);if(null===a["return"])if(a.tag===bh){var d=a.stateNode;b===T||d.isScheduled||(d.isScheduled=!0,zb?zb.nextScheduledRoot=d:ma=d,zb=d);if(!Da)switch(b){case Og:pc?p(Og,null):p(U,null);break;case U:W?void 0:w("186");break;default:Bb||($f(g),Bb=!0)}}else break;a=a["return"]}}
function B(a,b){var c=O;c===T&&(c=!Yi||a.internalContextTag&Sg||b?Qg:Og);return c===Og&&(Da||W)?U:c}function H(a){y(a,U,!0)}var C=Ag(a),Ca=Hg(a),r=C.popHostContainer,m=C.popHostContext,t=C.resetHostContainer,v=Lf(a,C,Ca,D,B),V=v.beginWork,ld=v.beginFailedWork,Lh=eg(a,C,Ca).completeWork;C=vg(a,x);var q=C.commitPlacement,Mh=C.commitDeletion,vf=C.commitWork,Nh=C.commitLifeCycles,Oh=C.commitAttachRef,Ph=C.commitDetachRef,$f=a.scheduleDeferredCallback,Yi=a.useSyncScheduling,Ui=a.prepareForCommit,Vi=a.resetAfterCommit,
O=T,Da=!1,Ab=!1,W=!1,pc=!1,I=null,z=T,u=null,na=null,ma=null,zb=null,Bb=!1,P=null,Ka=null,va=null,Ja=null,Ya=!1,Hd=!1,Id=!1,Xi=1E3,oc=0,nc=null;return{scheduleUpdate:D,getPriorityContext:B,batchedUpdates:function(a,b){var c=W;W=!0;try{return a(b)}finally{W=c,Da||W||p(U,null)}},unbatchedUpdates:function(a){var b=pc,c=W;pc=W;W=!1;try{return a()}finally{W=c,pc=b}},flushSync:function(a){var b=W,c=O;W=!0;O=Og;try{return a()}finally{W=b,O=c,Da?w("187"):void 0,p(U,null)}},deferredUpdates:function(a){var b=
O;O=Qg;try{return a()}finally{O=b}}}}function ih(){w("196")}function jh(a){if(!a)return da;a=Pa.get(a);return"number"===typeof a.tag?ih(a):a._processChildContext(a._context)}jh._injectFiber=function(a){ih=a};var kh=ud.addTopLevelUpdate,lh=R.findCurrentUnmaskedContext,mh=R.isContextProvider,nh=R.processChildContext,oh=E.HostComponent,ph=bb.findCurrentHostFiber,qh=bb.findCurrentHostFiberWithNoPortals;jh._injectFiber(function(a){var b=lh(a);return mh(a)?nh(a,b,!1):b});var rh=F.TEXT_NODE;
function sh(a){for(;a&&a.firstChild;)a=a.firstChild;return a}function th(a,b){var c=sh(a);a=0;for(var d;c;){if(c.nodeType===rh){d=a+c.textContent.length;if(a<=b&&d>=b)return{node:c,offset:b-a};a=d}a:{for(;c;){if(c.nextSibling){c=c.nextSibling;break a}c=c.parentNode}c=void 0}c=sh(c)}}var uh=null;function vh(){!uh&&l.canUseDOM&&(uh="textContent"in document.documentElement?"textContent":"innerText");return uh}
var wh={getOffsets:function(a){var b=window.getSelection&&window.getSelection();if(!b||0===b.rangeCount)return null;var c=b.anchorNode,d=b.anchorOffset,e=b.focusNode,f=b.focusOffset,g=b.getRangeAt(0);try{g.startContainer.nodeType,g.endContainer.nodeType}catch(k){return null}b=b.anchorNode===b.focusNode&&b.anchorOffset===b.focusOffset?0:g.toString().length;var h=g.cloneRange();h.selectNodeContents(a);h.setEnd(g.startContainer,g.startOffset);a=h.startContainer===h.endContainer&&h.startOffset===h.endOffset?
0:h.toString().length;g=a+b;b=document.createRange();b.setStart(c,d);b.setEnd(e,f);c=b.collapsed;return{start:c?g:a,end:c?a:g}},setOffsets:function(a,b){if(window.getSelection){var c=window.getSelection(),d=a[vh()].length,e=Math.min(b.start,d);b=void 0===b.end?e:Math.min(b.end,d);!c.extend&&e>b&&(d=b,b=e,e=d);d=th(a,e);a=th(a,b);if(d&&a){var f=document.createRange();f.setStart(d.node,d.offset);c.removeAllRanges();e>b?(c.addRange(f),c.extend(a.node,a.offset)):(f.setEnd(a.node,a.offset),c.addRange(f))}}}},
xh=F.ELEMENT_NODE,yh={hasSelectionCapabilities:function(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return b&&("input"===b&&"text"===a.type||"textarea"===b||"true"===a.contentEditable)},getSelectionInformation:function(){var a=ia();return{focusedElem:a,selectionRange:yh.hasSelectionCapabilities(a)?yh.getSelection(a):null}},restoreSelection:function(a){var b=ia(),c=a.focusedElem;a=a.selectionRange;if(b!==c&&fa(document.documentElement,c)){yh.hasSelectionCapabilities(c)&&yh.setSelection(c,a);b=
[];for(a=c;a=a.parentNode;)a.nodeType===xh&&b.push({element:a,left:a.scrollLeft,top:a.scrollTop});ha(c);for(c=0;c<b.length;c++)a=b[c],a.element.scrollLeft=a.left,a.element.scrollTop=a.top}},getSelection:function(a){return("selectionStart"in a?{start:a.selectionStart,end:a.selectionEnd}:wh.getOffsets(a))||{start:0,end:0}},setSelection:function(a,b){var c=b.start,d=b.end;void 0===d&&(d=c);"selectionStart"in a?(a.selectionStart=c,a.selectionEnd=Math.min(d,a.value.length)):wh.setOffsets(a,b)}},zh=yh,
Ah=F.ELEMENT_NODE;function Bh(){w("211")}function Ch(){w("212")}function Dh(a){if(null==a)return null;if(a.nodeType===Ah)return a;var b=Pa.get(a);if(b)return"number"===typeof b.tag?Bh(b):Ch(b);"function"===typeof a.render?w("188"):w("213",Object.keys(a))}Dh._injectFiber=function(a){Bh=a};Dh._injectStack=function(a){Ch=a};var Eh=E.HostComponent;function Fh(a){if(void 0!==a._hostParent)return a._hostParent;if("number"===typeof a.tag){do a=a["return"];while(a&&a.tag!==Eh);if(a)return a}return null}
function Gh(a,b){for(var c=0,d=a;d;d=Fh(d))c++;d=0;for(var e=b;e;e=Fh(e))d++;for(;0<c-d;)a=Fh(a),c--;for(;0<d-c;)b=Fh(b),d--;for(;c--;){if(a===b||a===b.alternate)return a;a=Fh(a);b=Fh(b)}return null}
var Hh={isAncestor:function(a,b){for(;b;){if(a===b||a===b.alternate)return!0;b=Fh(b)}return!1},getLowestCommonAncestor:Gh,getParentInstance:function(a){return Fh(a)},traverseTwoPhase:function(a,b,c){for(var d=[];a;)d.push(a),a=Fh(a);for(a=d.length;0<a--;)b(d[a],"captured",c);for(a=0;a<d.length;a++)b(d[a],"bubbled",c)},traverseEnterLeave:function(a,b,c,d,e){for(var f=a&&b?Gh(a,b):null,g=[];a&&a!==f;)g.push(a),a=Fh(a);for(a=[];b&&b!==f;)a.push(b),b=Fh(b);for(b=0;b<g.length;b++)c(g[b],"bubbled",d);for(b=
a.length;0<b--;)c(a[b],"captured",e)}},Ih=Jb.getListener;function Jh(a,b,c){if(b=Ih(a,c.dispatchConfig.phasedRegistrationNames[b]))c._dispatchListeners=Cb(c._dispatchListeners,b),c._dispatchInstances=Cb(c._dispatchInstances,a)}function Kh(a){a&&a.dispatchConfig.phasedRegistrationNames&&Hh.traverseTwoPhase(a._targetInst,Jh,a)}function Qh(a){if(a&&a.dispatchConfig.phasedRegistrationNames){var b=a._targetInst;b=b?Hh.getParentInstance(b):null;Hh.traverseTwoPhase(b,Jh,a)}}
function Rh(a,b,c){a&&c&&c.dispatchConfig.registrationName&&(b=Ih(a,c.dispatchConfig.registrationName))&&(c._dispatchListeners=Cb(c._dispatchListeners,b),c._dispatchInstances=Cb(c._dispatchInstances,a))}function Sh(a){a&&a.dispatchConfig.registrationName&&Rh(a._targetInst,null,a)}
var Th={accumulateTwoPhaseDispatches:function(a){Db(a,Kh)},accumulateTwoPhaseDispatchesSkipTarget:function(a){Db(a,Qh)},accumulateDirectDispatches:function(a){Db(a,Sh)},accumulateEnterLeaveDispatches:function(a,b,c,d){Hh.traverseEnterLeave(c,d,Rh,a,b)}},X={_root:null,_startText:null,_fallbackText:null},Uh={initialize:function(a){X._root=a;X._startText=Uh.getText();return!0},reset:function(){X._root=null;X._startText=null;X._fallbackText=null},getData:function(){if(X._fallbackText)return X._fallbackText;
var a,b=X._startText,c=b.length,d,e=Uh.getText(),f=e.length;for(a=0;a<c&&b[a]===e[a];a++);var g=c-a;for(d=1;d<=g&&b[c-d]===e[f-d];d++);X._fallbackText=e.slice(a,1<d?1-d:void 0);return X._fallbackText},getText:function(){return"value"in X._root?X._root.value:X._root[vh()]}},Vh=Uh,Wh="dispatchConfig _targetInst nativeEvent isDefaultPrevented isPropagationStopped _dispatchListeners _dispatchInstances".split(" "),Xh={type:null,target:null,currentTarget:ca.thatReturnsNull,eventPhase:null,bubbles:null,
cancelable:null,timeStamp:function(a){return a.timeStamp||Date.now()},defaultPrevented:null,isTrusted:null};
function Y(a,b,c,d){this.dispatchConfig=a;this._targetInst=b;this.nativeEvent=c;a=this.constructor.Interface;for(var e in a)a.hasOwnProperty(e)&&((b=a[e])?this[e]=b(c):"target"===e?this.target=d:this[e]=c[e]);this.isDefaultPrevented=(null!=c.defaultPrevented?c.defaultPrevented:!1===c.returnValue)?ca.thatReturnsTrue:ca.thatReturnsFalse;this.isPropagationStopped=ca.thatReturnsFalse;return this}
n(Y.prototype,{preventDefault:function(){this.defaultPrevented=!0;var a=this.nativeEvent;a&&(a.preventDefault?a.preventDefault():"unknown"!==typeof a.returnValue&&(a.returnValue=!1),this.isDefaultPrevented=ca.thatReturnsTrue)},stopPropagation:function(){var a=this.nativeEvent;a&&(a.stopPropagation?a.stopPropagation():"unknown"!==typeof a.cancelBubble&&(a.cancelBubble=!0),this.isPropagationStopped=ca.thatReturnsTrue)},persist:function(){this.isPersistent=ca.thatReturnsTrue},isPersistent:ca.thatReturnsFalse,
destructor:function(){var a=this.constructor.Interface,b;for(b in a)this[b]=null;for(a=0;a<Wh.length;a++)this[Wh[a]]=null}});Y.Interface=Xh;Y.augmentClass=function(a,b){function c(){}c.prototype=this.prototype;var d=new c;n(d,a.prototype);a.prototype=d;a.prototype.constructor=a;a.Interface=n({},this.Interface,b);a.augmentClass=this.augmentClass;Yh(a)};Yh(Y);function Zh(a,b,c,d){if(this.eventPool.length){var e=this.eventPool.pop();this.call(e,a,b,c,d);return e}return new this(a,b,c,d)}
function $h(a){a instanceof this?void 0:w("223");a.destructor();10>this.eventPool.length&&this.eventPool.push(a)}function Yh(a){a.eventPool=[];a.getPooled=Zh;a.release=$h}function ai(a,b,c,d){return Y.call(this,a,b,c,d)}Y.augmentClass(ai,{data:null});function bi(a,b,c,d){return Y.call(this,a,b,c,d)}Y.augmentClass(bi,{data:null});var ci=[9,13,27,32],di=l.canUseDOM&&"CompositionEvent"in window,ei=null;l.canUseDOM&&"documentMode"in document&&(ei=document.documentMode);var fi;
if(fi=l.canUseDOM&&"TextEvent"in window&&!ei){var gi=window.opera;fi=!("object"===typeof gi&&"function"===typeof gi.version&&12>=parseInt(gi.version(),10))}
var hi=fi,ii=l.canUseDOM&&(!di||ei&&8<ei&&11>=ei),ji=String.fromCharCode(32),ki={beforeInput:{phasedRegistrationNames:{bubbled:"onBeforeInput",captured:"onBeforeInputCapture"},dependencies:["topCompositionEnd","topKeyPress","topTextInput","topPaste"]},compositionEnd:{phasedRegistrationNames:{bubbled:"onCompositionEnd",captured:"onCompositionEndCapture"},dependencies:"topBlur topCompositionEnd topKeyDown topKeyPress topKeyUp topMouseDown".split(" ")},compositionStart:{phasedRegistrationNames:{bubbled:"onCompositionStart",
captured:"onCompositionStartCapture"},dependencies:"topBlur topCompositionStart topKeyDown topKeyPress topKeyUp topMouseDown".split(" ")},compositionUpdate:{phasedRegistrationNames:{bubbled:"onCompositionUpdate",captured:"onCompositionUpdateCapture"},dependencies:"topBlur topCompositionUpdate topKeyDown topKeyPress topKeyUp topMouseDown".split(" ")}},li=!1;
function mi(a,b){switch(a){case "topKeyUp":return-1!==ci.indexOf(b.keyCode);case "topKeyDown":return 229!==b.keyCode;case "topKeyPress":case "topMouseDown":case "topBlur":return!0;default:return!1}}function ni(a){a=a.detail;return"object"===typeof a&&"data"in a?a.data:null}var oi=!1;function pi(a,b){switch(a){case "topCompositionEnd":return ni(b);case "topKeyPress":if(32!==b.which)return null;li=!0;return ji;case "topTextInput":return a=b.data,a===ji&&li?null:a;default:return null}}
function qi(a,b){if(oi)return"topCompositionEnd"===a||!di&&mi(a,b)?(a=Vh.getData(),Vh.reset(),oi=!1,a):null;switch(a){case "topPaste":return null;case "topKeyPress":if(!(b.ctrlKey||b.altKey||b.metaKey)||b.ctrlKey&&b.altKey){if(b.char&&1<b.char.length)return b.char;if(b.which)return String.fromCharCode(b.which)}return null;case "topCompositionEnd":return ii?null:b.data;default:return null}}
var ri={eventTypes:ki,extractEvents:function(a,b,c,d){var e;if(di)b:{switch(a){case "topCompositionStart":var f=ki.compositionStart;break b;case "topCompositionEnd":f=ki.compositionEnd;break b;case "topCompositionUpdate":f=ki.compositionUpdate;break b}f=void 0}else oi?mi(a,c)&&(f=ki.compositionEnd):"topKeyDown"===a&&229===c.keyCode&&(f=ki.compositionStart);f?(ii&&(oi||f!==ki.compositionStart?f===ki.compositionEnd&&oi&&(e=Vh.getData()):oi=Vh.initialize(d)),f=ai.getPooled(f,b,c,d),e?f.data=e:(e=ni(c),
null!==e&&(f.data=e)),Th.accumulateTwoPhaseDispatches(f),e=f):e=null;(a=hi?pi(a,c):qi(a,c))?(b=bi.getPooled(ki.beforeInput,b,c,d),b.data=a,Th.accumulateTwoPhaseDispatches(b)):b=null;return[e,b]}},si={color:!0,date:!0,datetime:!0,"datetime-local":!0,email:!0,month:!0,number:!0,password:!0,range:!0,search:!0,tel:!0,text:!0,time:!0,url:!0,week:!0};function ti(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return"input"===b?!!si[a.type]:"textarea"===b?!0:!1}
var ui={change:{phasedRegistrationNames:{bubbled:"onChange",captured:"onChangeCapture"},dependencies:"topBlur topChange topClick topFocus topInput topKeyDown topKeyUp topSelectionChange".split(" ")}};function vi(a,b,c){a=Y.getPooled(ui.change,a,b,c);a.type="change";nb.enqueueStateRestore(c);Th.accumulateTwoPhaseDispatches(a);return a}var wi=null,xi=null;function yi(a){Jb.enqueueEvents(a);Jb.processEventQueue(!1)}
function zi(a){var b=G.getNodeFromInstance(a);if(Bc.updateValueIfChanged(b))return a}function Ai(a,b){if("topChange"===a)return b}var Bi=!1;l.canUseDOM&&(Bi=Lb("input")&&(!document.documentMode||9<document.documentMode));function Ci(){wi&&(wi.detachEvent("onpropertychange",Di),xi=wi=null)}function Di(a){"value"===a.propertyName&&zi(xi)&&(a=vi(xi,a,ub(a)),sb.batchedUpdates(yi,a))}function Ei(a,b,c){"topFocus"===a?(Ci(),wi=b,xi=c,wi.attachEvent("onpropertychange",Di)):"topBlur"===a&&Ci()}
function Fi(a){if("topSelectionChange"===a||"topKeyUp"===a||"topKeyDown"===a)return zi(xi)}function Gi(a,b){if("topClick"===a)return zi(b)}function Hi(a,b){if("topInput"===a||"topChange"===a)return zi(b)}
var Ii={eventTypes:ui,_isInputEventSupported:Bi,extractEvents:function(a,b,c,d){var e=b?G.getNodeFromInstance(b):window,f=e.nodeName&&e.nodeName.toLowerCase();if("select"===f||"input"===f&&"file"===e.type)var g=Ai;else if(ti(e))if(Bi)g=Hi;else{g=Fi;var h=Ei}else f=e.nodeName,!f||"input"!==f.toLowerCase()||"checkbox"!==e.type&&"radio"!==e.type||(g=Gi);if(g&&(g=g(a,b)))return vi(g,c,d);h&&h(a,e,b);"topBlur"===a&&null!=b&&(a=b._wrapperState||e._wrapperState)&&a.controlled&&"number"===e.type&&(a=""+e.value,
e.getAttribute("value")!==a&&e.setAttribute("value",a))}};function Ji(a,b,c,d){return Y.call(this,a,b,c,d)}Y.augmentClass(Ji,{view:function(a){if(a.view)return a.view;a=ub(a);return a.window===a?a:(a=a.ownerDocument)?a.defaultView||a.parentWindow:window},detail:function(a){return a.detail||0}});var Ki={Alt:"altKey",Control:"ctrlKey",Meta:"metaKey",Shift:"shiftKey"};function Li(a){var b=this.nativeEvent;return b.getModifierState?b.getModifierState(a):(a=Ki[a])?!!b[a]:!1}function Mi(){return Li}
function Ni(a,b,c,d){return Y.call(this,a,b,c,d)}Ji.augmentClass(Ni,{screenX:null,screenY:null,clientX:null,clientY:null,pageX:null,pageY:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,getModifierState:Mi,button:null,buttons:null,relatedTarget:function(a){return a.relatedTarget||(a.fromElement===a.srcElement?a.toElement:a.fromElement)}});
var Oi={mouseEnter:{registrationName:"onMouseEnter",dependencies:["topMouseOut","topMouseOver"]},mouseLeave:{registrationName:"onMouseLeave",dependencies:["topMouseOut","topMouseOver"]}},Pi={eventTypes:Oi,extractEvents:function(a,b,c,d){if("topMouseOver"===a&&(c.relatedTarget||c.fromElement)||"topMouseOut"!==a&&"topMouseOver"!==a)return null;var e=d.window===d?d:(e=d.ownerDocument)?e.defaultView||e.parentWindow:window;"topMouseOut"===a?(a=b,b=(b=c.relatedTarget||c.toElement)?G.getClosestInstanceFromNode(b):
null):a=null;if(a===b)return null;var f=null==a?e:G.getNodeFromInstance(a);e=null==b?e:G.getNodeFromInstance(b);var g=Ni.getPooled(Oi.mouseLeave,a,c,d);g.type="mouseleave";g.target=f;g.relatedTarget=e;c=Ni.getPooled(Oi.mouseEnter,b,c,d);c.type="mouseenter";c.target=e;c.relatedTarget=f;Th.accumulateEnterLeaveDispatches(g,c,a,b);return[g,c]}},Qi=F.DOCUMENT_NODE,Ri=l.canUseDOM&&"documentMode"in document&&11>=document.documentMode,Si={select:{phasedRegistrationNames:{bubbled:"onSelect",captured:"onSelectCapture"},
dependencies:"topBlur topContextMenu topFocus topKeyDown topKeyUp topMouseDown topMouseUp topSelectionChange".split(" ")}},Ti=null,Zi=null,$i=null,aj=!1,bj=M.isListeningToAllDependencies;
function cj(a,b){if(aj||null==Ti||Ti!==ia())return null;var c=Ti;"selectionStart"in c&&zh.hasSelectionCapabilities(c)?c={start:c.selectionStart,end:c.selectionEnd}:window.getSelection?(c=window.getSelection(),c={anchorNode:c.anchorNode,anchorOffset:c.anchorOffset,focusNode:c.focusNode,focusOffset:c.focusOffset}):c=void 0;return $i&&ea($i,c)?null:($i=c,a=Y.getPooled(Si.select,Zi,a,b),a.type="select",a.target=Ti,Th.accumulateTwoPhaseDispatches(a),a)}
var dj={eventTypes:Si,extractEvents:function(a,b,c,d){var e=d.window===d?d.document:d.nodeType===Qi?d:d.ownerDocument;if(!e||!bj("onSelect",e))return null;e=b?G.getNodeFromInstance(b):window;switch(a){case "topFocus":if(ti(e)||"true"===e.contentEditable)Ti=e,Zi=b,$i=null;break;case "topBlur":$i=Zi=Ti=null;break;case "topMouseDown":aj=!0;break;case "topContextMenu":case "topMouseUp":return aj=!1,cj(c,d);case "topSelectionChange":if(Ri)break;case "topKeyDown":case "topKeyUp":return cj(c,d)}return null}};
function ej(a,b,c,d){return Y.call(this,a,b,c,d)}Y.augmentClass(ej,{animationName:null,elapsedTime:null,pseudoElement:null});function fj(a,b,c,d){return Y.call(this,a,b,c,d)}Y.augmentClass(fj,{clipboardData:function(a){return"clipboardData"in a?a.clipboardData:window.clipboardData}});function gj(a,b,c,d){return Y.call(this,a,b,c,d)}Ji.augmentClass(gj,{relatedTarget:null});function hj(a){var b=a.keyCode;"charCode"in a?(a=a.charCode,0===a&&13===b&&(a=13)):a=b;return 32<=a||13===a?a:0}
var ij={Esc:"Escape",Spacebar:" ",Left:"ArrowLeft",Up:"ArrowUp",Right:"ArrowRight",Down:"ArrowDown",Del:"Delete",Win:"OS",Menu:"ContextMenu",Apps:"ContextMenu",Scroll:"ScrollLock",MozPrintableKey:"Unidentified"},jj={8:"Backspace",9:"Tab",12:"Clear",13:"Enter",16:"Shift",17:"Control",18:"Alt",19:"Pause",20:"CapsLock",27:"Escape",32:" ",33:"PageUp",34:"PageDown",35:"End",36:"Home",37:"ArrowLeft",38:"ArrowUp",39:"ArrowRight",40:"ArrowDown",45:"Insert",46:"Delete",112:"F1",113:"F2",114:"F3",115:"F4",
116:"F5",117:"F6",118:"F7",119:"F8",120:"F9",121:"F10",122:"F11",123:"F12",144:"NumLock",145:"ScrollLock",224:"Meta"};function kj(a,b,c,d){return Y.call(this,a,b,c,d)}
Ji.augmentClass(kj,{key:function(a){if(a.key){var b=ij[a.key]||a.key;if("Unidentified"!==b)return b}return"keypress"===a.type?(a=hj(a),13===a?"Enter":String.fromCharCode(a)):"keydown"===a.type||"keyup"===a.type?jj[a.keyCode]||"Unidentified":""},location:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,repeat:null,locale:null,getModifierState:Mi,charCode:function(a){return"keypress"===a.type?hj(a):0},keyCode:function(a){return"keydown"===a.type||"keyup"===a.type?a.keyCode:0},which:function(a){return"keypress"===
a.type?hj(a):"keydown"===a.type||"keyup"===a.type?a.keyCode:0}});function lj(a,b,c,d){return Y.call(this,a,b,c,d)}Ni.augmentClass(lj,{dataTransfer:null});function mj(a,b,c,d){return Y.call(this,a,b,c,d)}Ji.augmentClass(mj,{touches:null,targetTouches:null,changedTouches:null,altKey:null,metaKey:null,ctrlKey:null,shiftKey:null,getModifierState:Mi});function nj(a,b,c,d){return Y.call(this,a,b,c,d)}Y.augmentClass(nj,{propertyName:null,elapsedTime:null,pseudoElement:null});
function oj(a,b,c,d){return Y.call(this,a,b,c,d)}Ni.augmentClass(oj,{deltaX:function(a){return"deltaX"in a?a.deltaX:"wheelDeltaX"in a?-a.wheelDeltaX:0},deltaY:function(a){return"deltaY"in a?a.deltaY:"wheelDeltaY"in a?-a.wheelDeltaY:"wheelDelta"in a?-a.wheelDelta:0},deltaZ:null,deltaMode:null});var pj={},qj={};
"abort animationEnd animationIteration animationStart blur cancel canPlay canPlayThrough click close contextMenu copy cut doubleClick drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error focus input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing progress rateChange reset scroll seeked seeking stalled submit suspend timeUpdate toggle touchCancel touchEnd touchMove touchStart transitionEnd volumeChange waiting wheel".split(" ").forEach(function(a){var b=a[0].toUpperCase()+
a.slice(1),c="on"+b;b="top"+b;c={phasedRegistrationNames:{bubbled:c,captured:c+"Capture"},dependencies:[b]};pj[a]=c;qj[b]=c});
var rj={eventTypes:pj,extractEvents:function(a,b,c,d){var e=qj[a];if(!e)return null;switch(a){case "topAbort":case "topCancel":case "topCanPlay":case "topCanPlayThrough":case "topClose":case "topDurationChange":case "topEmptied":case "topEncrypted":case "topEnded":case "topError":case "topInput":case "topInvalid":case "topLoad":case "topLoadedData":case "topLoadedMetadata":case "topLoadStart":case "topPause":case "topPlay":case "topPlaying":case "topProgress":case "topRateChange":case "topReset":case "topSeeked":case "topSeeking":case "topStalled":case "topSubmit":case "topSuspend":case "topTimeUpdate":case "topToggle":case "topVolumeChange":case "topWaiting":var f=Y;
break;case "topKeyPress":if(0===hj(c))return null;case "topKeyDown":case "topKeyUp":f=kj;break;case "topBlur":case "topFocus":f=gj;break;case "topClick":if(2===c.button)return null;case "topDoubleClick":case "topMouseDown":case "topMouseMove":case "topMouseUp":case "topMouseOut":case "topMouseOver":case "topContextMenu":f=Ni;break;case "topDrag":case "topDragEnd":case "topDragEnter":case "topDragExit":case "topDragLeave":case "topDragOver":case "topDragStart":case "topDrop":f=lj;break;case "topTouchCancel":case "topTouchEnd":case "topTouchMove":case "topTouchStart":f=
mj;break;case "topAnimationEnd":case "topAnimationIteration":case "topAnimationStart":f=ej;break;case "topTransitionEnd":f=nj;break;case "topScroll":f=Ji;break;case "topWheel":f=oj;break;case "topCopy":case "topCut":case "topPaste":f=fj}f?void 0:w("86",a);a=f.getPooled(e,b,c,d);Th.accumulateTwoPhaseDispatches(a);return a}};L.setHandleTopLevel(M.handleTopLevel);Jb.injection.injectEventPluginOrder("ResponderEventPlugin SimpleEventPlugin TapEventPlugin EnterLeaveEventPlugin ChangeEventPlugin SelectEventPlugin BeforeInputEventPlugin".split(" "));
ib.injection.injectComponentTree(G);Jb.injection.injectEventPluginsByName({SimpleEventPlugin:rj,EnterLeaveEventPlugin:Pi,ChangeEventPlugin:Ii,SelectEventPlugin:dj,BeforeInputEventPlugin:ri});
var sj=A.injection.MUST_USE_PROPERTY,Z=A.injection.HAS_BOOLEAN_VALUE,tj=A.injection.HAS_NUMERIC_VALUE,uj=A.injection.HAS_POSITIVE_NUMERIC_VALUE,vj=A.injection.HAS_STRING_BOOLEAN_VALUE,wj={Properties:{allowFullScreen:Z,allowTransparency:vj,async:Z,autoPlay:Z,capture:Z,checked:sj|Z,cols:uj,contentEditable:vj,controls:Z,"default":Z,defer:Z,disabled:Z,download:A.injection.HAS_OVERLOADED_BOOLEAN_VALUE,draggable:vj,formNoValidate:Z,hidden:Z,loop:Z,multiple:sj|Z,muted:sj|Z,noValidate:Z,open:Z,playsInline:Z,
readOnly:Z,required:Z,reversed:Z,rows:uj,rowSpan:tj,scoped:Z,seamless:Z,selected:sj|Z,size:uj,start:tj,span:uj,spellCheck:vj,style:0,itemScope:Z,acceptCharset:0,className:0,htmlFor:0,httpEquiv:0,value:vj},DOMAttributeNames:{acceptCharset:"accept-charset",className:"class",htmlFor:"for",httpEquiv:"http-equiv"},DOMMutationMethods:{value:function(a,b){if(null==b)return a.removeAttribute("value");"number"!==a.type||!1===a.hasAttribute("value")?a.setAttribute("value",""+b):a.validity&&!a.validity.badInput&&
a.ownerDocument.activeElement!==a&&a.setAttribute("value",""+b)}}},xj=A.injection.HAS_STRING_BOOLEAN_VALUE,yj={xlink:"http://www.w3.org/1999/xlink",xml:"http://www.w3.org/XML/1998/namespace"},zj={Properties:{autoReverse:xj,externalResourcesRequired:xj,preserveAlpha:xj},DOMAttributeNames:{autoReverse:"autoReverse",externalResourcesRequired:"externalResourcesRequired",preserveAlpha:"preserveAlpha"},DOMAttributeNamespaces:{xlinkActuate:yj.xlink,xlinkArcrole:yj.xlink,xlinkHref:yj.xlink,xlinkRole:yj.xlink,
xlinkShow:yj.xlink,xlinkTitle:yj.xlink,xlinkType:yj.xlink,xmlBase:yj.xml,xmlLang:yj.xml,xmlSpace:yj.xml}},Aj=/[\-\:]([a-z])/g;function Bj(a){return a[1].toUpperCase()}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode x-height xlink:actuate xlink:arcrole xlink:href xlink:role xlink:show xlink:title xlink:type xml:base xmlns:xlink xml:lang xml:space".split(" ").forEach(function(a){var b=a.replace(Aj,
Bj);zj.Properties[b]=0;zj.DOMAttributeNames[b]=a});A.injection.injectDOMPropertyConfig(wj);A.injection.injectDOMPropertyConfig(zj);
var Cj=ig.injectInternals,Dj=F.ELEMENT_NODE,Ej=F.TEXT_NODE,Fj=F.COMMENT_NODE,Gj=F.DOCUMENT_NODE,Hj=F.DOCUMENT_FRAGMENT_NODE,Ij=A.ROOT_ATTRIBUTE_NAME,Jj=ka.getChildNamespace,Kj=N.createElement,Lj=N.createTextNode,Mj=N.setInitialProperties,Nj=N.diffProperties,Oj=N.updateProperties,Pj=N.diffHydratedProperties,Qj=N.diffHydratedText,Rj=N.warnForDeletedHydratableElement,Sj=N.warnForDeletedHydratableText,Tj=N.warnForInsertedHydratedElement,Uj=N.warnForInsertedHydratedText,Vj=G.precacheFiberNode,Wj=G.updateFiberProps;
nb.injection.injectFiberControlledHostComponent(N);Dh._injectFiber(function(a){return Xj.findHostInstance(a)});var Yj=null,Zj=null;function ak(a){return!(!a||a.nodeType!==Dj&&a.nodeType!==Gj&&a.nodeType!==Hj&&(a.nodeType!==Fj||" react-mount-point-unstable "!==a.nodeValue))}function bk(a){a=a?a.nodeType===Gj?a.documentElement:a.firstChild:null;return!(!a||a.nodeType!==Dj||!a.hasAttribute(Ij))}
var Xj=function(a){var b=a.getPublicInstance;a=hh(a);var c=a.scheduleUpdate,d=a.getPriorityContext;return{createContainer:function(a){var b=ee();a={current:b,containerInfo:a,isScheduled:!1,nextScheduledRoot:null,context:null,pendingContext:null};return b.stateNode=a},updateContainer:function(a,b,g,h){var e=b.current;g=jh(g);null===b.context?b.context=g:b.pendingContext=g;b=h;h=d(e,ed.enableAsyncSubtreeAPI&&null!=a&&null!=a.type&&null!=a.type.prototype&&!0===a.type.prototype.unstable_isAsyncReactComponent);
a={element:a};kh(e,a,void 0===b?null:b,h);c(e,h)},batchedUpdates:a.batchedUpdates,unbatchedUpdates:a.unbatchedUpdates,deferredUpdates:a.deferredUpdates,flushSync:a.flushSync,getPublicRootInstance:function(a){a=a.current;if(!a.child)return null;switch(a.child.tag){case oh:return b(a.child.stateNode);default:return a.child.stateNode}},findHostInstance:function(a){a=ph(a);return null===a?null:a.stateNode},findHostInstanceWithNoPortals:function(a){a=qh(a);return null===a?null:a.stateNode}}}({getRootHostContext:function(a){if(a.nodeType===
Gj)a=(a=a.documentElement)?a.namespaceURI:Jj(null,"");else{var b=a.nodeType===Fj?a.parentNode:a;a=b.namespaceURI||null;b=b.tagName;a=Jj(a,b)}return a},getChildHostContext:function(a,b){return Jj(a,b)},getPublicInstance:function(a){return a},prepareForCommit:function(){Yj=M.isEnabled();Zj=zh.getSelectionInformation();M.setEnabled(!1)},resetAfterCommit:function(){zh.restoreSelection(Zj);Zj=null;M.setEnabled(Yj);Yj=null},createInstance:function(a,b,c,d,e){a=Kj(a,b,c,d);Vj(e,a);Wj(a,b);return a},appendInitialChild:function(a,
b){a.appendChild(b)},finalizeInitialChildren:function(a,b,c,d){Mj(a,b,c,d);a:{switch(b){case "button":case "input":case "select":case "textarea":a=!!c.autoFocus;break a}a=!1}return a},prepareUpdate:function(a,b,c,d,e){return Nj(a,b,c,d,e)},commitMount:function(a){a.focus()},commitUpdate:function(a,b,c,d,e){Wj(a,e);Oj(a,b,c,d,e)},shouldSetTextContent:function(a,b){return"textarea"===a||"string"===typeof b.children||"number"===typeof b.children||"object"===typeof b.dangerouslySetInnerHTML&&null!==b.dangerouslySetInnerHTML&&
"string"===typeof b.dangerouslySetInnerHTML.__html},resetTextContent:function(a){a.textContent=""},shouldDeprioritizeSubtree:function(a,b){return!!b.hidden},createTextInstance:function(a,b,c,d){a=Lj(a,b);Vj(d,a);return a},commitTextUpdate:function(a,b,c){a.nodeValue=c},appendChild:function(a,b){a.appendChild(b)},appendChildToContainer:function(a,b){a.nodeType===Fj?a.parentNode.insertBefore(b,a):a.appendChild(b)},insertBefore:function(a,b,c){a.insertBefore(b,c)},insertInContainerBefore:function(a,
b,c){a.nodeType===Fj?a.parentNode.insertBefore(b,c):a.insertBefore(b,c)},removeChild:function(a,b){a.removeChild(b)},removeChildFromContainer:function(a,b){a.nodeType===Fj?a.parentNode.removeChild(b):a.removeChild(b)},canHydrateInstance:function(a,b){return a.nodeType===Dj&&b===a.nodeName.toLowerCase()},canHydrateTextInstance:function(a,b){return""===b?!1:a.nodeType===Ej},getNextHydratableSibling:function(a){for(a=a.nextSibling;a&&a.nodeType!==Dj&&a.nodeType!==Ej;)a=a.nextSibling;return a},getFirstHydratableChild:function(a){for(a=
a.firstChild;a&&a.nodeType!==Dj&&a.nodeType!==Ej;)a=a.nextSibling;return a},hydrateInstance:function(a,b,c,d,e,f){Vj(f,a);Wj(a,c);return Pj(a,b,c,e,d)},hydrateTextInstance:function(a,b,c){Vj(c,a);return Qj(a,b)},didNotHydrateInstance:function(a,b){1===b.nodeType?Rj(a,b):Sj(a,b)},didNotFindHydratableInstance:function(a,b,c){Tj(a,b,c)},didNotFindHydratableTextInstance:function(a,b){Uj(a,b)},scheduleDeferredCallback:dd.rIC,useSyncScheduling:!0});sb.injection.injectFiberBatchedUpdates(Xj.batchedUpdates);
function ck(a,b,c,d,e){ak(c)?void 0:w("200");var f=c._reactRootContainer;if(f)Xj.updateContainer(b,f,a,e);else{if(!d&&!bk(c))for(d=void 0;d=c.lastChild;)c.removeChild(d);var g=Xj.createContainer(c);f=c._reactRootContainer=g;Xj.unbatchedUpdates(function(){Xj.updateContainer(b,g,a,e)})}return Xj.getPublicRootInstance(f)}function dk(a,b){var c=2<arguments.length&&void 0!==arguments[2]?arguments[2]:null;ak(b)?void 0:w("200");return ne.createPortal(a,b,null,c)}
var ek={createPortal:dk,hydrate:function(a,b,c){return ck(null,a,b,!0,c)},render:function(a,b,c){return ck(null,a,b,!1,c)},unstable_renderSubtreeIntoContainer:function(a,b,c,d){null!=a&&Pa.has(a)?void 0:w("38");return ck(a,b,c,!1,d)},unmountComponentAtNode:function(a){ak(a)?void 0:w("40");return a._reactRootContainer?(Xj.unbatchedUpdates(function(){ck(null,null,a,!1,function(){a._reactRootContainer=null})}),!0):!1},findDOMNode:Dh,unstable_createPortal:dk,unstable_batchedUpdates:sb.batchedUpdates,
unstable_deferredUpdates:Xj.deferredUpdates,flushSync:Xj.flushSync,__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED:{EventPluginHub:Jb,EventPluginRegistry:sa,EventPropagators:Th,ReactControlledComponent:nb,ReactDOMComponentTree:G,ReactDOMEventListener:L}};Cj({findFiberByHostInstance:G.getClosestInstanceFromNode,findHostInstanceByFiber:Xj.findHostInstance,bundleType:0,version:"16.0.0",rendererPackageName:"react-dom"});module.exports=ek;


/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

/**
 * Simple, lightweight module assisting with the detection and context of
 * Worker. Helps avoid circular dependencies and allows code to reason about
 * whether or not they are in a Worker, even if they never include the main
 * `ReactWorker` dependency.
 */
var ExecutionEnvironment = {

  canUseDOM: canUseDOM,

  canUseWorkers: typeof Worker !== 'undefined',

  canUseEventListeners: canUseDOM && !!(window.addEventListener || window.attachEvent),

  canUseViewport: canUseDOM && !!window.screen,

  isInWorker: !canUseDOM // For now, this is true - might change in the future.

};

module.exports = ExecutionEnvironment;

/***/ }),
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

var emptyFunction = __webpack_require__(27);

/**
 * Upstream version of event listener. Does not take into account specific
 * nature of platform.
 */
var EventListener = {
  /**
   * Listen to DOM events during the bubble phase.
   *
   * @param {DOMEventTarget} target DOM element to register listener on.
   * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
   * @param {function} callback Callback function.
   * @return {object} Object with a `remove` method.
   */
  listen: function listen(target, eventType, callback) {
    if (target.addEventListener) {
      target.addEventListener(eventType, callback, false);
      return {
        remove: function remove() {
          target.removeEventListener(eventType, callback, false);
        }
      };
    } else if (target.attachEvent) {
      target.attachEvent('on' + eventType, callback);
      return {
        remove: function remove() {
          target.detachEvent('on' + eventType, callback);
        }
      };
    }
  },

  /**
   * Listen to DOM events during the capture phase.
   *
   * @param {DOMEventTarget} target DOM element to register listener on.
   * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
   * @param {function} callback Callback function.
   * @return {object} Object with a `remove` method.
   */
  capture: function capture(target, eventType, callback) {
    if (target.addEventListener) {
      target.addEventListener(eventType, callback, true);
      return {
        remove: function remove() {
          target.removeEventListener(eventType, callback, true);
        }
      };
    } else {
      if (false) {
        console.error('Attempted to listen to events during the capture phase on a ' + 'browser that does not support the capture phase. Your application ' + 'will not receive some events.');
      }
      return {
        remove: emptyFunction
      };
    }
  },

  registerDefault: function registerDefault() {}
};

module.exports = EventListener;

/***/ }),
/* 195 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 * 
 */

/*eslint-disable no-self-compare */



var hasOwnProperty = Object.prototype.hasOwnProperty;

/**
 * inlined Object.is polyfill to avoid requiring consumers ship their own
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
 */
function is(x, y) {
  // SameValue algorithm
  if (x === y) {
    // Steps 1-5, 7-10
    // Steps 6.b-6.e: +0 != -0
    // Added the nonzero y check to make Flow happy, but it is redundant
    return x !== 0 || y !== 0 || 1 / x === 1 / y;
  } else {
    // Step 6.a: NaN == NaN
    return x !== x && y !== y;
  }
}

/**
 * Performs equality by iterating through keys on an object and returning false
 * when any key has values which are not strictly equal between the arguments.
 * Returns true when the values of all keys are strictly equal.
 */
function shallowEqual(objA, objB) {
  if (is(objA, objB)) {
    return true;
  }

  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) {
    return false;
  }

  // Test for A's keys different from B.
  for (var i = 0; i < keysA.length; i++) {
    if (!hasOwnProperty.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
      return false;
    }
  }

  return true;
}

module.exports = shallowEqual;

/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

var isTextNode = __webpack_require__(197);

/*eslint-disable no-bitwise */

/**
 * Checks if a given DOM node contains or is another DOM node.
 */
function containsNode(outerNode, innerNode) {
  if (!outerNode || !innerNode) {
    return false;
  } else if (outerNode === innerNode) {
    return true;
  } else if (isTextNode(outerNode)) {
    return false;
  } else if (isTextNode(innerNode)) {
    return containsNode(outerNode, innerNode.parentNode);
  } else if ('contains' in outerNode) {
    return outerNode.contains(innerNode);
  } else if (outerNode.compareDocumentPosition) {
    return !!(outerNode.compareDocumentPosition(innerNode) & 16);
  } else {
    return false;
  }
}

module.exports = containsNode;

/***/ }),
/* 197 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

var isNode = __webpack_require__(198);

/**
 * @param {*} object The object to check.
 * @return {boolean} Whether or not the object is a DOM text node.
 */
function isTextNode(object) {
  return isNode(object) && object.nodeType == 3;
}

module.exports = isTextNode;

/***/ }),
/* 198 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

/**
 * @param {*} object The object to check.
 * @return {boolean} Whether or not the object is a DOM node.
 */
function isNode(object) {
  var doc = object ? object.ownerDocument || object : document;
  var defaultView = doc.defaultView || window;
  return !!(object && (typeof defaultView.Node === 'function' ? object instanceof defaultView.Node : typeof object === 'object' && typeof object.nodeType === 'number' && typeof object.nodeName === 'string'));
}

module.exports = isNode;

/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * @param {DOMElement} node input/textarea to focus
 */

function focusNode(node) {
  // IE8 can throw "Can't move focus to the control because it is invisible,
  // not enabled, or of a type that does not accept the focus." for all kinds of
  // reasons that are too expensive and fragile to test.
  try {
    node.focus();
  } catch (e) {}
}

module.exports = focusNode;

/***/ }),
/* 200 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

/* eslint-disable fb-www/typeof-undefined */

/**
 * Same as document.activeElement but wraps in a try-catch block. In IE it is
 * not safe to call document.activeElement if there is nothing focused.
 *
 * The activeElement will be null only if the document or document body is not
 * yet defined.
 *
 * @param {?DOMDocument} doc Defaults to current document.
 * @return {?DOMElement}
 */
function getActiveElement(doc) /*?DOMElement*/{
  doc = doc || (typeof document !== 'undefined' ? document : undefined);
  if (typeof doc === 'undefined') {
    return null;
  }
  try {
    return doc.activeElement || doc.body;
  } catch (e) {
    return doc.body;
  }
}

module.exports = getActiveElement;

/***/ }),
/* 201 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__pages_MainDashboard_js__ = __webpack_require__(202);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__pages_Login_js__ = __webpack_require__(365);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__pages_LogisticCreator_js__ = __webpack_require__(366);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__pages_TruckDispatcher_js__ = __webpack_require__(373);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_router_dom__ = __webpack_require__(388);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__data_Trucks_js__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__data_Routes_js__ = __webpack_require__(173);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var App=function(_Component){_inherits(App,_Component);function App(props){_classCallCheck(this,App);var _this=_possibleConstructorReturn(this,(App.__proto__||Object.getPrototypeOf(App)).call(this,props));_this.getRandomColor=function(){var letters='0123456789ABCDEF';var color='#';for(var i=0;i<6;i++){color+=letters[Math.floor(Math.random()*16)];}return color;};_this.addRouteToRoutelist=function(route){//console.log('Add route to list');
//console.log(route);
__WEBPACK_IMPORTED_MODULE_7__data_Routes_js__["a" /* default */].routesList.push(route);};__WEBPACK_IMPORTED_MODULE_7__data_Routes_js__["a" /* default */].routesList.map(function(route){route.pathColor=_this.getRandomColor();if(route.vectorPath){route.vectorPath.map(function(vpath){vpath.reverse();return null;});}return null;});__WEBPACK_IMPORTED_MODULE_6__data_Trucks_js__["a" /* default */].truksList.map(function(truck){if(truck.vectorPath){truck.vectorPath.map(function(vpath){vpath.reverse();return null;});}return null;});return _this;}_createClass(App,[{key:'render',value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_router_dom__["a" /* BrowserRouter */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container-fluid'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_router_dom__["b" /* Route */],{exact:true,path:'/',component:__WEBPACK_IMPORTED_MODULE_2__pages_Login_js__["a" /* Login */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_router_dom__["b" /* Route */],{exact:true,path:'/login',component:__WEBPACK_IMPORTED_MODULE_2__pages_Login_js__["a" /* Login */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_router_dom__["b" /* Route */],{exact:true,path:'/dashboard',component:__WEBPACK_IMPORTED_MODULE_1__pages_MainDashboard_js__["a" /* MainDashboard */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_router_dom__["b" /* Route */],{exact:true,path:'/logisticcreator',render:function render(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__pages_LogisticCreator_js__["a" /* LogisticCreator */],{history:props.history,trucksData:__WEBPACK_IMPORTED_MODULE_6__data_Trucks_js__["a" /* default */],onAddRoute:_this2.addRouteToRoutelist});}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_router_dom__["b" /* Route */],{exact:true,path:'/truckdispatcher',component:__WEBPACK_IMPORTED_MODULE_4__pages_TruckDispatcher_js__["a" /* TruckDispatcher */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_router_dom__["b" /* Route */],{exact:true,path:'/recipientapp',component:__WEBPACK_IMPORTED_MODULE_1__pages_MainDashboard_js__["a" /* MainDashboard */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_router_dom__["b" /* Route */],{exact:true,path:'/truckerapp',component:__WEBPACK_IMPORTED_MODULE_1__pages_MainDashboard_js__["a" /* MainDashboard */]})));}}]);return App;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);;/* harmony default export */ __webpack_exports__["a"] = (App);

/***/ }),
/* 202 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MainDashboard; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_toastr__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_toastr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_toastr__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_HeaderBar_js__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_CollapsablePanel__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_DashboardChart__ = __webpack_require__(339);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_MessagePanel__ = __webpack_require__(364);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var MainDashboard=function(_Component){_inherits(MainDashboard,_Component);function MainDashboard(props){_classCallCheck(this,MainDashboard);var _this=_possibleConstructorReturn(this,(MainDashboard.__proto__||Object.getPrototypeOf(MainDashboard)).call(this,props));_this.onChangeView=function(e){_this.props.history.push('/'+e);};return _this;}_createClass(MainDashboard,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_HeaderBar_js__["a" /* HeaderBar */],{onChangeView:this.onChangeView,actualPosition:"Main Dashboard"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["m" /* Row */],{className:'gray-bg'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["d" /* Col */],{xs:12,sm:12,md:12,lg:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'wrapper wrapper-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-lg-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ibox float-e-margins '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ibox-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'label label-success pull-right'},'Monthly'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5',null,'Revenue')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ibox-content top-summary-box-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h1',{className:'no-margins'},'$16,640,787 \u200B'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('small',null,'Total income')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-lg-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ibox float-e-margins '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ibox-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'label label-info pull-right'},'Annual'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5',null,'Average Margin')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ibox-content top-summary-box-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h1',{className:'no-margins'},'17.4%'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'stat-percent font-bold text-info'},'20% ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-level-up'}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-lg-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ibox float-e-margins '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ibox-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'label label-primary pull-right'},'Today'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5',null,'Active Loads')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ibox-content top-summary-box-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h1',{className:'no-margins'},'144'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'stat-percent font-bold text-green'},'9% ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-level-up'}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-lg-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ibox float-e-margins '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ibox-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'label label-danger pull-right'},'Good'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5',null,'Gross \u200BMargin')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ibox-content top-summary-box-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h1',{className:'no-margins'},'$2,912,454'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'stat-percent font-bold text-green'},'4% ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-level-up'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('small',null,'In first month'))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-lg-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ibox float-e-margins'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ibox-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5',null,'Receivables Ageing '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'pull-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'btn-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button',className:'btn btn-xs btn-white '},'Today'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button',className:'btn btn-xs btn-white active'},'Monthly'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button',className:'btn btn-xs btn-white'},'Annual')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ibox-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-lg-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'flot-chart'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'flot-chart-content',id:'flot-dashboard-chart'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__components_DashboardChart__["a" /* DashboardChart */],null)))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-lg-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'stat-list'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',{className:'no-margins'},'2.346'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('small',null,'Loads paid for with NXXT Tokens'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'stat-percent font-bold text-green'},'4% ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-level-up '})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'progress progress-mini'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'progress-bar',style:{width:'50%'}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',{className:'no-margins '},'4.422'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('small',null,'Loads Paid for with other Tokens'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'stat-percent font-bold text-danger'},'1% ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-level-down text-navy'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'progress progress-mini'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'progress-bar',style:{width:'20%'}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',{className:'no-margins '},'9.180'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('small',null,'Loads Paid for Fiat Currencies'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'stat-percent font-bold text-green'},'3% ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-level-up text-green'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'progress progress-mini'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'progress-bar',style:{width:'70%'}})))))))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-lg-4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_MessagePanel__["a" /* MessagePanel */],null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-lg-8'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-lg-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ibox float-e-margins'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ibox-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5',null,'Open Business')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ibox-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-lg-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'table table-hover margin bottom'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center'},'No.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Transaction'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center'},'Date'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center'},'Amount'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center'},'1'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'  Juniper Networks, #36843'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center small'},'16 Jun 2017'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'label label-primary'},'$ 483.00'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center'},'2'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,' Domus Design Corp, #36789'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center small'},'10 Jun 2017'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'label label-primary'},'$ 327.00'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center'},'3'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,' Apax Corp, # 36798'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center small'},'12 Jun 2017'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'label label-warning'},'$ 125.00'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center'},'4'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'  Juniper Networks, #36876'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center small'},'22 Jun 2017'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'label label-primary'},'$ 344.00'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center'},'5'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'Ellington Electric, #36888'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center small'},'24 Jun 2017'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'label label-primary'},'$ 235.00'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center'},'6'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'Johnson Controls, #36887'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center small'},'26 Jun 2017'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'label label-primary'},'$ 100.00'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center'},'6'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,' Johnson Controls, #36823'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center small'},'26 Jun 2017'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'label label-primary'},'$ 100.00'))))))))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-lg-6'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ibox float-e-margins'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ibox-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5',null,'On Going Delivery')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ibox-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'table table-hover no-margins'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Status'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Date'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Zip'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Phone'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('small',null,'Pending...')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-clock-o'}),' 11:20pm'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'22313'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-success'},' 765-5556.2648 ')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'label label-warning'},'Canceled'),' '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-clock-o'}),' 10:40am'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'12753'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-success'},' 765-5556.2648 ')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('small',null,'Pending...'),' '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-clock-o'}),' 01:30pm'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'19465'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-success'},' 765-5556.2648 ')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('small',null,'Pending...'),' '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-clock-o'}),' 02:20pm'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'09456'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-success'},' 765-5556.2648 ')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('small',null,'Pending...'),' '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-clock-o'}),' 09:40pm'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'02378'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-success'},' 765-5556.2648 ')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'label label-primary'},'Completed'),' '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-clock-o'}),' 04:10am'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'28374'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-success'},' 765-5556.2648 ')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('small',null,'Pending...'),' '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-clock-o'}),' 12:08am'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'27384'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-success'},' 765-5556.2648 '))))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-lg-6'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ibox float-e-margins'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ibox-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5',null,'Task List')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ibox-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'todo-list m-t small-list'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'check-link'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-square-o'}),' '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'m-l-xs'},'Renew Surety Bond')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'check-link'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-square-o'}),' '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'m-l-xs'},'Update Jose Gutierrez Credentials')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'check-link'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-square-o'}),' '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'m-l-xs'},'Send Holiday gift to Anne Schmidt at Domus Design Corp.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('small',{className:'label label-primary'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-clock-o'}),' 1 mins')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'check-link'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-square-o'}),' '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'m-l-xs'},'Revise Master Continuing Contract with Smart Contract engineers')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'check-link'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-square-o'}),' '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'m-l-xs '},'Settle end of year IFTA reports')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'check-link'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-square-o'}),' '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'m-l-xs'},'Submit ELD reports to Audit Blockchain')))))))))))));}}]);return MainDashboard;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);;

/***/ }),
/* 203 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__PanelGroup__ = __webpack_require__(125);








var Accordion = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(Accordion, _React$Component);

  function Accordion() {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Accordion);

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  Accordion.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_5__PanelGroup__["a" /* default */],
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.props, { accordion: true }),
      this.props.children
    );
  };

  return Accordion;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

/* unused harmony default export */ var _unused_webpack_default_export = (Accordion);

/***/ }),
/* 204 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(205);
module.exports = __webpack_require__(19).Object.assign;


/***/ }),
/* 205 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.1 Object.assign(target, source)
var $export = __webpack_require__(25);

$export($export.S + $export.F, 'Object', { assign: __webpack_require__(207) });


/***/ }),
/* 206 */
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};


/***/ }),
/* 207 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.2.1 Object.assign(target, source, ...)
var getKeys = __webpack_require__(45);
var gOPS = __webpack_require__(82);
var pIE = __webpack_require__(46);
var toObject = __webpack_require__(83);
var IObject = __webpack_require__(118);
var $assign = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$assign || __webpack_require__(43)(function () {
  var A = {};
  var B = {};
  // eslint-disable-next-line no-undef
  var S = Symbol();
  var K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function (k) { B[k] = k; });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
  var T = toObject(target);
  var aLen = arguments.length;
  var index = 1;
  var getSymbols = gOPS.f;
  var isEnum = pIE.f;
  while (aLen > index) {
    var S = IObject(arguments[index++]);
    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) if (isEnum.call(S, key = keys[j++])) T[key] = S[key];
  } return T;
} : $assign;


/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {

// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__(30);
var toLength = __webpack_require__(119);
var toAbsoluteIndex = __webpack_require__(209);
module.exports = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};


/***/ }),
/* 209 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(78);
var max = Math.max;
var min = Math.min;
module.exports = function (index, length) {
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};


/***/ }),
/* 210 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(211), __esModule: true };

/***/ }),
/* 211 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(120);
__webpack_require__(217);
module.exports = __webpack_require__(88).f('iterator');


/***/ }),
/* 212 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(78);
var defined = __webpack_require__(77);
// true  -> String#at
// false -> String#codePointAt
module.exports = function (TO_STRING) {
  return function (that, pos) {
    var s = String(defined(that));
    var i = toInteger(pos);
    var l = s.length;
    var a, b;
    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
      ? TO_STRING ? s.charAt(i) : a
      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};


/***/ }),
/* 213 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var create = __webpack_require__(86);
var descriptor = __webpack_require__(44);
var setToStringTag = __webpack_require__(87);
var IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
__webpack_require__(34)(IteratorPrototype, __webpack_require__(20)('iterator'), function () { return this; });

module.exports = function (Constructor, NAME, next) {
  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
  setToStringTag(Constructor, NAME + ' Iterator');
};


/***/ }),
/* 214 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(28);
var anObject = __webpack_require__(35);
var getKeys = __webpack_require__(45);

module.exports = __webpack_require__(36) ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = getKeys(Properties);
  var length = keys.length;
  var i = 0;
  var P;
  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
  return O;
};


/***/ }),
/* 215 */
/***/ (function(module, exports, __webpack_require__) {

var document = __webpack_require__(26).document;
module.exports = document && document.documentElement;


/***/ }),
/* 216 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has = __webpack_require__(29);
var toObject = __webpack_require__(83);
var IE_PROTO = __webpack_require__(79)('IE_PROTO');
var ObjectProto = Object.prototype;

module.exports = Object.getPrototypeOf || function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto : null;
};


/***/ }),
/* 217 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(218);
var global = __webpack_require__(26);
var hide = __webpack_require__(34);
var Iterators = __webpack_require__(47);
var TO_STRING_TAG = __webpack_require__(20)('toStringTag');

var DOMIterables = ('CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,' +
  'DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,' +
  'MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,' +
  'SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,' +
  'TextTrackList,TouchList').split(',');

for (var i = 0; i < DOMIterables.length; i++) {
  var NAME = DOMIterables[i];
  var Collection = global[NAME];
  var proto = Collection && Collection.prototype;
  if (proto && !proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
  Iterators[NAME] = Iterators.Array;
}


/***/ }),
/* 218 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var addToUnscopables = __webpack_require__(219);
var step = __webpack_require__(220);
var Iterators = __webpack_require__(47);
var toIObject = __webpack_require__(30);

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = __webpack_require__(121)(Array, 'Array', function (iterated, kind) {
  this._t = toIObject(iterated); // target
  this._i = 0;                   // next index
  this._k = kind;                // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var kind = this._k;
  var index = this._i++;
  if (!O || index >= O.length) {
    this._t = undefined;
    return step(1);
  }
  if (kind == 'keys') return step(0, index);
  if (kind == 'values') return step(0, O[index]);
  return step(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
Iterators.Arguments = Iterators.Array;

addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');


/***/ }),
/* 219 */
/***/ (function(module, exports) {

module.exports = function () { /* empty */ };


/***/ }),
/* 220 */
/***/ (function(module, exports) {

module.exports = function (done, value) {
  return { value: value, done: !!done };
};


/***/ }),
/* 221 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(222), __esModule: true };

/***/ }),
/* 222 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(223);
__webpack_require__(228);
__webpack_require__(229);
__webpack_require__(230);
module.exports = __webpack_require__(19).Symbol;


/***/ }),
/* 223 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// ECMAScript 6 symbols shim
var global = __webpack_require__(26);
var has = __webpack_require__(29);
var DESCRIPTORS = __webpack_require__(36);
var $export = __webpack_require__(25);
var redefine = __webpack_require__(122);
var META = __webpack_require__(224).KEY;
var $fails = __webpack_require__(43);
var shared = __webpack_require__(80);
var setToStringTag = __webpack_require__(87);
var uid = __webpack_require__(55);
var wks = __webpack_require__(20);
var wksExt = __webpack_require__(88);
var wksDefine = __webpack_require__(89);
var enumKeys = __webpack_require__(225);
var isArray = __webpack_require__(226);
var anObject = __webpack_require__(35);
var toIObject = __webpack_require__(30);
var toPrimitive = __webpack_require__(75);
var createDesc = __webpack_require__(44);
var _create = __webpack_require__(86);
var gOPNExt = __webpack_require__(227);
var $GOPD = __webpack_require__(124);
var $DP = __webpack_require__(28);
var $keys = __webpack_require__(45);
var gOPD = $GOPD.f;
var dP = $DP.f;
var gOPN = gOPNExt.f;
var $Symbol = global.Symbol;
var $JSON = global.JSON;
var _stringify = $JSON && $JSON.stringify;
var PROTOTYPE = 'prototype';
var HIDDEN = wks('_hidden');
var TO_PRIMITIVE = wks('toPrimitive');
var isEnum = {}.propertyIsEnumerable;
var SymbolRegistry = shared('symbol-registry');
var AllSymbols = shared('symbols');
var OPSymbols = shared('op-symbols');
var ObjectProto = Object[PROTOTYPE];
var USE_NATIVE = typeof $Symbol == 'function';
var QObject = global.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDesc = DESCRIPTORS && $fails(function () {
  return _create(dP({}, 'a', {
    get: function () { return dP(this, 'a', { value: 7 }).a; }
  })).a != 7;
}) ? function (it, key, D) {
  var protoDesc = gOPD(ObjectProto, key);
  if (protoDesc) delete ObjectProto[key];
  dP(it, key, D);
  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
} : dP;

var wrap = function (tag) {
  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
  sym._k = tag;
  return sym;
};

var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  return it instanceof $Symbol;
};

var $defineProperty = function defineProperty(it, key, D) {
  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
  anObject(it);
  key = toPrimitive(key, true);
  anObject(D);
  if (has(AllSymbols, key)) {
    if (!D.enumerable) {
      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
      it[HIDDEN][key] = true;
    } else {
      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
      D = _create(D, { enumerable: createDesc(0, false) });
    } return setSymbolDesc(it, key, D);
  } return dP(it, key, D);
};
var $defineProperties = function defineProperties(it, P) {
  anObject(it);
  var keys = enumKeys(P = toIObject(P));
  var i = 0;
  var l = keys.length;
  var key;
  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
  return it;
};
var $create = function create(it, P) {
  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
};
var $propertyIsEnumerable = function propertyIsEnumerable(key) {
  var E = isEnum.call(this, key = toPrimitive(key, true));
  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
};
var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
  it = toIObject(it);
  key = toPrimitive(key, true);
  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
  var D = gOPD(it, key);
  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
  return D;
};
var $getOwnPropertyNames = function getOwnPropertyNames(it) {
  var names = gOPN(toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
  } return result;
};
var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
  var IS_OP = it === ObjectProto;
  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
  } return result;
};

// 19.4.1.1 Symbol([description])
if (!USE_NATIVE) {
  $Symbol = function Symbol() {
    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
    var $set = function (value) {
      if (this === ObjectProto) $set.call(OPSymbols, value);
      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
      setSymbolDesc(this, tag, createDesc(1, value));
    };
    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
    return wrap(tag);
  };
  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
    return this._k;
  });

  $GOPD.f = $getOwnPropertyDescriptor;
  $DP.f = $defineProperty;
  __webpack_require__(123).f = gOPNExt.f = $getOwnPropertyNames;
  __webpack_require__(46).f = $propertyIsEnumerable;
  __webpack_require__(82).f = $getOwnPropertySymbols;

  if (DESCRIPTORS && !__webpack_require__(85)) {
    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
  }

  wksExt.f = function (name) {
    return wrap(wks(name));
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });

for (var es6Symbols = (
  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);

for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);

$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
  // 19.4.2.1 Symbol.for(key)
  'for': function (key) {
    return has(SymbolRegistry, key += '')
      ? SymbolRegistry[key]
      : SymbolRegistry[key] = $Symbol(key);
  },
  // 19.4.2.5 Symbol.keyFor(sym)
  keyFor: function keyFor(sym) {
    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
  },
  useSetter: function () { setter = true; },
  useSimple: function () { setter = false; }
});

$export($export.S + $export.F * !USE_NATIVE, 'Object', {
  // 19.1.2.2 Object.create(O [, Properties])
  create: $create,
  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
  defineProperty: $defineProperty,
  // 19.1.2.3 Object.defineProperties(O, Properties)
  defineProperties: $defineProperties,
  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
  // 19.1.2.7 Object.getOwnPropertyNames(O)
  getOwnPropertyNames: $getOwnPropertyNames,
  // 19.1.2.8 Object.getOwnPropertySymbols(O)
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// 24.3.2 JSON.stringify(value [, replacer [, space]])
$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
  var S = $Symbol();
  // MS Edge converts symbol values to JSON as {}
  // WebKit converts symbol values to JSON as null
  // V8 throws on boxed symbols
  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
})), 'JSON', {
  stringify: function stringify(it) {
    if (it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
    var args = [it];
    var i = 1;
    var replacer, $replacer;
    while (arguments.length > i) args.push(arguments[i++]);
    replacer = args[1];
    if (typeof replacer == 'function') $replacer = replacer;
    if ($replacer || !isArray(replacer)) replacer = function (key, value) {
      if ($replacer) value = $replacer.call(this, key, value);
      if (!isSymbol(value)) return value;
    };
    args[1] = replacer;
    return _stringify.apply($JSON, args);
  }
});

// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(34)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
// 19.4.3.5 Symbol.prototype[@@toStringTag]
setToStringTag($Symbol, 'Symbol');
// 20.2.1.9 Math[@@toStringTag]
setToStringTag(Math, 'Math', true);
// 24.3.3 JSON[@@toStringTag]
setToStringTag(global.JSON, 'JSON', true);


/***/ }),
/* 224 */
/***/ (function(module, exports, __webpack_require__) {

var META = __webpack_require__(55)('meta');
var isObject = __webpack_require__(42);
var has = __webpack_require__(29);
var setDesc = __webpack_require__(28).f;
var id = 0;
var isExtensible = Object.isExtensible || function () {
  return true;
};
var FREEZE = !__webpack_require__(43)(function () {
  return isExtensible(Object.preventExtensions({}));
});
var setMeta = function (it) {
  setDesc(it, META, { value: {
    i: 'O' + ++id, // object ID
    w: {}          // weak collections IDs
  } });
};
var fastKey = function (it, create) {
  // return primitive with prefix
  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMeta(it);
  // return object ID
  } return it[META].i;
};
var getWeak = function (it, create) {
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMeta(it);
  // return hash weak collections IDs
  } return it[META].w;
};
// add metadata on freeze-family methods calling
var onFreeze = function (it) {
  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
  return it;
};
var meta = module.exports = {
  KEY: META,
  NEED: false,
  fastKey: fastKey,
  getWeak: getWeak,
  onFreeze: onFreeze
};


/***/ }),
/* 225 */
/***/ (function(module, exports, __webpack_require__) {

// all enumerable object keys, includes symbols
var getKeys = __webpack_require__(45);
var gOPS = __webpack_require__(82);
var pIE = __webpack_require__(46);
module.exports = function (it) {
  var result = getKeys(it);
  var getSymbols = gOPS.f;
  if (getSymbols) {
    var symbols = getSymbols(it);
    var isEnum = pIE.f;
    var i = 0;
    var key;
    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
  } return result;
};


/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

// 7.2.2 IsArray(argument)
var cof = __webpack_require__(76);
module.exports = Array.isArray || function isArray(arg) {
  return cof(arg) == 'Array';
};


/***/ }),
/* 227 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var toIObject = __webpack_require__(30);
var gOPN = __webpack_require__(123).f;
var toString = {}.toString;

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function (it) {
  try {
    return gOPN(it);
  } catch (e) {
    return windowNames.slice();
  }
};

module.exports.f = function getOwnPropertyNames(it) {
  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
};


/***/ }),
/* 228 */
/***/ (function(module, exports) {



/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(89)('asyncIterator');


/***/ }),
/* 230 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(89)('observable');


/***/ }),
/* 231 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(232), __esModule: true };

/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(233);
module.exports = __webpack_require__(19).Object.setPrototypeOf;


/***/ }),
/* 233 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.19 Object.setPrototypeOf(O, proto)
var $export = __webpack_require__(25);
$export($export.S, 'Object', { setPrototypeOf: __webpack_require__(234).set });


/***/ }),
/* 234 */
/***/ (function(module, exports, __webpack_require__) {

// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */
var isObject = __webpack_require__(42);
var anObject = __webpack_require__(35);
var check = function (O, proto) {
  anObject(O);
  if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
};
module.exports = {
  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
    function (test, buggy, set) {
      try {
        set = __webpack_require__(74)(Function.call, __webpack_require__(124).f(Object.prototype, '__proto__').set, 2);
        set(test, []);
        buggy = !(test instanceof Array);
      } catch (e) { buggy = true; }
      return function setPrototypeOf(O, proto) {
        check(O, proto);
        if (buggy) O.__proto__ = proto;
        else set(O, proto);
        return O;
      };
    }({}, false) : undefined),
  check: check
};


/***/ }),
/* 235 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(236), __esModule: true };

/***/ }),
/* 236 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(237);
var $Object = __webpack_require__(19).Object;
module.exports = function create(P, D) {
  return $Object.create(P, D);
};


/***/ }),
/* 237 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(25);
// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
$export($export.S, 'Object', { create: __webpack_require__(86) });


/***/ }),
/* 238 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var emptyFunction = __webpack_require__(27);
var invariant = __webpack_require__(22);
var ReactPropTypesSecret = __webpack_require__(126);

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    invariant(
      false,
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim
  };

  ReactPropTypes.checkPropTypes = emptyFunction;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 239 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(240);
module.exports = __webpack_require__(19).Object.entries;


/***/ }),
/* 240 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-values-entries
var $export = __webpack_require__(25);
var $entries = __webpack_require__(128)(true);

$export($export.S, 'Object', {
  entries: function entries(it) {
    return $entries(it);
  }
});


/***/ }),
/* 241 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_StyleConfig__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__CloseButton__ = __webpack_require__(90);














var propTypes = {
  onDismiss: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func,
  closeLabel: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.string
};

var defaultProps = {
  closeLabel: 'Close alert'
};

var Alert = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(Alert, _React$Component);

  function Alert() {
    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, Alert);

    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  Alert.prototype.render = function render() {
    var _extends2;

    var _props = this.props,
        onDismiss = _props.onDismiss,
        closeLabel = _props.closeLabel,
        className = _props.className,
        children = _props.children,
        props = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['onDismiss', 'closeLabel', 'className', 'children']);

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["f" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var dismissable = !!onDismiss;
    var classes = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["d" /* getClassSet */])(bsProps), (_extends2 = {}, _extends2[Object(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["e" /* prefix */])(bsProps, 'dismissable')] = dismissable, _extends2));

    return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
      'div',
      __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, elementProps, {
        role: 'alert',
        className: __WEBPACK_IMPORTED_MODULE_6_classnames___default()(className, classes)
      }),
      dismissable && __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__CloseButton__["a" /* default */], {
        onClick: onDismiss,
        label: closeLabel
      }),
      children
    );
  };

  return Alert;
}(__WEBPACK_IMPORTED_MODULE_7_react___default.a.Component);

Alert.propTypes = propTypes;
Alert.defaultProps = defaultProps;

/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["c" /* bsStyles */])(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default()(__WEBPACK_IMPORTED_MODULE_10__utils_StyleConfig__["d" /* State */]), __WEBPACK_IMPORTED_MODULE_10__utils_StyleConfig__["d" /* State */].INFO, Object(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["a" /* bsClass */])('alert', Alert)));

/***/ }),
/* 242 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(243);
module.exports = __webpack_require__(19).Object.values;


/***/ }),
/* 243 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-values-entries
var $export = __webpack_require__(25);
var $values = __webpack_require__(128)(false);

$export($export.S, 'Object', {
  values: function values(it) {
    return $values(it);
  }
});


/***/ }),
/* 244 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__ = __webpack_require__(8);











// TODO: `pullRight` doesn't belong here. There's no special handling here.

var propTypes = {
  pullRight: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool
};

var defaultProps = {
  pullRight: false
};

var Badge = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Badge, _React$Component);

  function Badge() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, Badge);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  Badge.prototype.hasContent = function hasContent(children) {
    var result = false;

    __WEBPACK_IMPORTED_MODULE_6_react___default.a.Children.forEach(children, function (child) {
      if (result) {
        return;
      }

      if (child || child === 0) {
        result = true;
      }
    });

    return result;
  };

  Badge.prototype.render = function render() {
    var _props = this.props,
        pullRight = _props.pullRight,
        className = _props.className,
        children = _props.children,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['pullRight', 'className', 'children']);

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["f" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["d" /* getClassSet */])(bsProps), {
      'pull-right': pullRight,

      // Hack for collapsing on IE8.
      hidden: !this.hasContent(children)
    });

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
      'span',
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, elementProps, {
        className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, classes)
      }),
      children
    );
  };

  return Badge;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

Badge.propTypes = propTypes;
Badge.defaultProps = defaultProps;

/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["a" /* bsClass */])('badge', Badge));

/***/ }),
/* 245 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__BreadcrumbItem__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__ = __webpack_require__(8);











var Breadcrumb = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Breadcrumb, _React$Component);

  function Breadcrumb() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, Breadcrumb);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  Breadcrumb.prototype.render = function render() {
    var _props = this.props,
        className = _props.className,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['className']);

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["f" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = Object(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["d" /* getClassSet */])(bsProps);

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('ol', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, elementProps, {
      role: 'navigation',
      'aria-label': 'breadcrumbs',
      className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, classes)
    }));
  };

  return Breadcrumb;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

Breadcrumb.Item = __WEBPACK_IMPORTED_MODULE_7__BreadcrumbItem__["a" /* default */];

/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["a" /* bsClass */])('breadcrumb', Breadcrumb));

/***/ }),
/* 246 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__ = __webpack_require__(8);










var ButtonToolbar = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(ButtonToolbar, _React$Component);

  function ButtonToolbar() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, ButtonToolbar);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  ButtonToolbar.prototype.render = function render() {
    var _props = this.props,
        className = _props.className,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['className']);

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["f" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["d" /* getClassSet */])(bsProps);

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('div', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, elementProps, {
      role: 'toolbar',
      className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, classes)
    }));
  };

  return ButtonToolbar;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["a" /* bsClass */])('btn-toolbar', ButtonToolbar));

/***/ }),
/* 247 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__CarouselCaption__ = __webpack_require__(248);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__CarouselItem__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Glyphicon__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__SafeAnchor__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__utils_bootstrapUtils__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__utils_ValidComponentChildren__ = __webpack_require__(18);
















// TODO: `slide` should be `animate`.

// TODO: Use uncontrollable.

var propTypes = {
  slide: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  indicators: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  /**
   * The amount of time to delay between automatically cycling an item.
   * If `null`, carousel will not automatically cycle.
   */
  interval: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.number,
  controls: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  pauseOnHover: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  wrap: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  /**
   * Callback fired when the active item changes.
   *
   * ```js
   * (eventKey: any) => any | (eventKey: any, event: Object) => any
   * ```
   *
   * If this callback takes two or more arguments, the second argument will
   * be a persisted event object with `direction` set to the direction of the
   * transition.
   */
  onSelect: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
  onSlideEnd: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
  activeIndex: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.number,
  defaultActiveIndex: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.number,
  direction: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.oneOf(['prev', 'next']),
  prevIcon: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.node,
  /**
   * Label shown to screen readers only, can be used to show the previous element
   * in the carousel.
   * Set to null to deactivate.
   */
  prevLabel: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string,
  nextIcon: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.node,
  /**
   * Label shown to screen readers only, can be used to show the next element
   * in the carousel.
   * Set to null to deactivate.
   */
  nextLabel: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string
};

var defaultProps = {
  slide: true,
  interval: 5000,
  pauseOnHover: true,
  wrap: true,
  indicators: true,
  controls: true,
  prevIcon: __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__Glyphicon__["a" /* default */], { glyph: 'chevron-left' }),
  prevLabel: 'Previous',
  nextIcon: __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__Glyphicon__["a" /* default */], { glyph: 'chevron-right' }),
  nextLabel: 'Next'
};

var Carousel = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Carousel, _React$Component);

  function Carousel(props, context) {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, Carousel);

    var _this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props, context));

    _this.handleMouseOver = _this.handleMouseOver.bind(_this);
    _this.handleMouseOut = _this.handleMouseOut.bind(_this);
    _this.handlePrev = _this.handlePrev.bind(_this);
    _this.handleNext = _this.handleNext.bind(_this);
    _this.handleItemAnimateOutEnd = _this.handleItemAnimateOutEnd.bind(_this);

    var defaultActiveIndex = props.defaultActiveIndex;


    _this.state = {
      activeIndex: defaultActiveIndex != null ? defaultActiveIndex : 0,
      previousActiveIndex: null,
      direction: null
    };

    _this.isUnmounted = false;
    return _this;
  }

  Carousel.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var activeIndex = this.getActiveIndex();

    if (nextProps.activeIndex != null && nextProps.activeIndex !== activeIndex) {
      clearTimeout(this.timeout);

      this.setState({
        previousActiveIndex: activeIndex,
        direction: nextProps.direction != null ? nextProps.direction : this.getDirection(activeIndex, nextProps.activeIndex)
      });
    }

    if (nextProps.activeIndex == null && this.state.activeIndex >= nextProps.children.length) {
      this.setState({
        activeIndex: 0,
        previousActiveIndex: null,
        direction: null
      });
    }
  };

  Carousel.prototype.componentDidMount = function componentDidMount() {
    this.waitForNext();
  };

  Carousel.prototype.componentWillUnmount = function componentWillUnmount() {
    clearTimeout(this.timeout);
    this.isUnmounted = true;
  };

  Carousel.prototype.handleMouseOver = function handleMouseOver() {
    if (this.props.pauseOnHover) {
      this.pause();
    }
  };

  Carousel.prototype.handleMouseOut = function handleMouseOut() {
    if (this.isPaused) {
      this.play();
    }
  };

  Carousel.prototype.handlePrev = function handlePrev(e) {
    var index = this.getActiveIndex() - 1;

    if (index < 0) {
      if (!this.props.wrap) {
        return;
      }
      index = __WEBPACK_IMPORTED_MODULE_13__utils_ValidComponentChildren__["a" /* default */].count(this.props.children) - 1;
    }

    this.select(index, e, 'prev');
  };

  Carousel.prototype.handleNext = function handleNext(e) {
    var index = this.getActiveIndex() + 1;
    var count = __WEBPACK_IMPORTED_MODULE_13__utils_ValidComponentChildren__["a" /* default */].count(this.props.children);

    if (index > count - 1) {
      if (!this.props.wrap) {
        return;
      }
      index = 0;
    }

    this.select(index, e, 'next');
  };

  Carousel.prototype.handleItemAnimateOutEnd = function handleItemAnimateOutEnd() {
    var _this2 = this;

    this.setState({
      previousActiveIndex: null,
      direction: null
    }, function () {
      _this2.waitForNext();

      if (_this2.props.onSlideEnd) {
        _this2.props.onSlideEnd();
      }
    });
  };

  Carousel.prototype.getActiveIndex = function getActiveIndex() {
    var activeIndexProp = this.props.activeIndex;
    return activeIndexProp != null ? activeIndexProp : this.state.activeIndex;
  };

  Carousel.prototype.getDirection = function getDirection(prevIndex, index) {
    if (prevIndex === index) {
      return null;
    }

    return prevIndex > index ? 'prev' : 'next';
  };

  Carousel.prototype.select = function select(index, e, direction) {
    clearTimeout(this.timeout);

    // TODO: Is this necessary? Seems like the only risk is if the component
    // unmounts while handleItemAnimateOutEnd fires.
    if (this.isUnmounted) {
      return;
    }

    var previousActiveIndex = this.props.slide ? this.getActiveIndex() : null;
    direction = direction || this.getDirection(previousActiveIndex, index);

    var onSelect = this.props.onSelect;


    if (onSelect) {
      if (onSelect.length > 1) {
        // React SyntheticEvents are pooled, so we need to remove this event
        // from the pool to add a custom property. To avoid unnecessarily
        // removing objects from the pool, only do this when the listener
        // actually wants the event.
        if (e) {
          e.persist();
          e.direction = direction;
        } else {
          e = { direction: direction };
        }

        onSelect(index, e);
      } else {
        onSelect(index);
      }
    }

    if (this.props.activeIndex == null && index !== previousActiveIndex) {
      if (this.state.previousActiveIndex != null) {
        // If currently animating don't activate the new index.
        // TODO: look into queueing this canceled call and
        // animating after the current animation has ended.
        return;
      }

      this.setState({
        activeIndex: index,
        previousActiveIndex: previousActiveIndex,
        direction: direction
      });
    }
  };

  Carousel.prototype.waitForNext = function waitForNext() {
    var _props = this.props,
        slide = _props.slide,
        interval = _props.interval,
        activeIndexProp = _props.activeIndex;


    if (!this.isPaused && slide && interval && activeIndexProp == null) {
      this.timeout = setTimeout(this.handleNext, interval);
    }
  };

  // This might be a public API.


  Carousel.prototype.pause = function pause() {
    this.isPaused = true;
    clearTimeout(this.timeout);
  };

  // This might be a public API.


  Carousel.prototype.play = function play() {
    this.isPaused = false;
    this.waitForNext();
  };

  Carousel.prototype.renderIndicators = function renderIndicators(children, activeIndex, bsProps) {
    var _this3 = this;

    var indicators = [];

    __WEBPACK_IMPORTED_MODULE_13__utils_ValidComponentChildren__["a" /* default */].forEach(children, function (child, index) {
      indicators.push(__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('li', {
        key: index,
        className: index === activeIndex ? 'active' : null,
        onClick: function onClick(e) {
          return _this3.select(index, e);
        }
      }),

      // Force whitespace between indicator elements. Bootstrap requires
      // this for correct spacing of elements.
      ' ');
    });

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
      'ol',
      { className: Object(__WEBPACK_IMPORTED_MODULE_12__utils_bootstrapUtils__["e" /* prefix */])(bsProps, 'indicators') },
      indicators
    );
  };

  Carousel.prototype.renderControls = function renderControls(properties) {
    var wrap = properties.wrap,
        children = properties.children,
        activeIndex = properties.activeIndex,
        prevIcon = properties.prevIcon,
        nextIcon = properties.nextIcon,
        bsProps = properties.bsProps,
        prevLabel = properties.prevLabel,
        nextLabel = properties.nextLabel;

    var controlClassName = Object(__WEBPACK_IMPORTED_MODULE_12__utils_bootstrapUtils__["e" /* prefix */])(bsProps, 'control');
    var count = __WEBPACK_IMPORTED_MODULE_13__utils_ValidComponentChildren__["a" /* default */].count(children);

    return [(wrap || activeIndex !== 0) && __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_11__SafeAnchor__["a" /* default */],
      {
        key: 'prev',
        className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(controlClassName, 'left'),
        onClick: this.handlePrev
      },
      prevIcon,
      prevLabel && __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        'span',
        { className: 'sr-only' },
        prevLabel
      )
    ), (wrap || activeIndex !== count - 1) && __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_11__SafeAnchor__["a" /* default */],
      {
        key: 'next',
        className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(controlClassName, 'right'),
        onClick: this.handleNext
      },
      nextIcon,
      nextLabel && __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        'span',
        { className: 'sr-only' },
        nextLabel
      )
    )];
  };

  Carousel.prototype.render = function render() {
    var _this4 = this;

    var _props2 = this.props,
        slide = _props2.slide,
        indicators = _props2.indicators,
        controls = _props2.controls,
        wrap = _props2.wrap,
        prevIcon = _props2.prevIcon,
        prevLabel = _props2.prevLabel,
        nextIcon = _props2.nextIcon,
        nextLabel = _props2.nextLabel,
        className = _props2.className,
        children = _props2.children,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props2, ['slide', 'indicators', 'controls', 'wrap', 'prevIcon', 'prevLabel', 'nextIcon', 'nextLabel', 'className', 'children']);

    var _state = this.state,
        previousActiveIndex = _state.previousActiveIndex,
        direction = _state.direction;

    var _splitBsPropsAndOmit = Object(__WEBPACK_IMPORTED_MODULE_12__utils_bootstrapUtils__["g" /* splitBsPropsAndOmit */])(props, ['interval', 'pauseOnHover', 'onSelect', 'onSlideEnd', 'activeIndex', // Accessed via this.getActiveIndex().
    'defaultActiveIndex', 'direction']),
        bsProps = _splitBsPropsAndOmit[0],
        elementProps = _splitBsPropsAndOmit[1];

    var activeIndex = this.getActiveIndex();

    var classes = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_12__utils_bootstrapUtils__["d" /* getClassSet */])(bsProps), {
      slide: slide
    });

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
      'div',
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, elementProps, {
        className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, classes),
        onMouseOver: this.handleMouseOver,
        onMouseOut: this.handleMouseOut
      }),
      indicators && this.renderIndicators(children, activeIndex, bsProps),
      __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        'div',
        { className: Object(__WEBPACK_IMPORTED_MODULE_12__utils_bootstrapUtils__["e" /* prefix */])(bsProps, 'inner') },
        __WEBPACK_IMPORTED_MODULE_13__utils_ValidComponentChildren__["a" /* default */].map(children, function (child, index) {
          var active = index === activeIndex;
          var previousActive = slide && index === previousActiveIndex;

          return Object(__WEBPACK_IMPORTED_MODULE_6_react__["cloneElement"])(child, {
            active: active,
            index: index,
            animateOut: previousActive,
            animateIn: active && previousActiveIndex != null && slide,
            direction: direction,
            onAnimateOutEnd: previousActive ? _this4.handleItemAnimateOutEnd : null
          });
        })
      ),
      controls && this.renderControls({
        wrap: wrap,
        children: children,
        activeIndex: activeIndex,
        prevIcon: prevIcon,
        prevLabel: prevLabel,
        nextIcon: nextIcon,
        nextLabel: nextLabel,
        bsProps: bsProps
      })
    );
  };

  return Carousel;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

Carousel.propTypes = propTypes;
Carousel.defaultProps = defaultProps;

Carousel.Caption = __WEBPACK_IMPORTED_MODULE_8__CarouselCaption__["a" /* default */];
Carousel.Item = __WEBPACK_IMPORTED_MODULE_9__CarouselItem__["a" /* default */];

/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_12__utils_bootstrapUtils__["a" /* bsClass */])('carousel', Carousel));

/***/ }),
/* 248 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_elementType__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_elementType___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_elementType__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__ = __webpack_require__(8);











var propTypes = {
  componentClass: __WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_elementType___default.a
};

var defaultProps = {
  componentClass: 'div'
};

var CarouselCaption = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(CarouselCaption, _React$Component);

  function CarouselCaption() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, CarouselCaption);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  CarouselCaption.prototype.render = function render() {
    var _props = this.props,
        Component = _props.componentClass,
        className = _props.className,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['componentClass', 'className']);

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["f" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = Object(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["d" /* getClassSet */])(bsProps);

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Component, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, elementProps, {
      className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, classes)
    }));
  };

  return CarouselCaption;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

CarouselCaption.propTypes = propTypes;
CarouselCaption.defaultProps = defaultProps;

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["a" /* bsClass */])('carousel-caption', CarouselCaption));

/***/ }),
/* 249 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-2014, Facebook, Inc.
 * All rights reserved.
 *
 * This file contains a modified version of:
 * https://github.com/facebook/react/blob/v0.12.0/src/addons/transitions/ReactTransitionEvents.js
 *
 * This source code is licensed under the BSD-style license found here:
 * https://github.com/facebook/react/blob/v0.12.0/LICENSE
 * An additional grant of patent rights can be found here:
 * https://github.com/facebook/react/blob/v0.12.0/PATENTS
 */

var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

/**
 * EVENT_NAME_MAP is used to determine which event fired when a
 * transition/animation ends, based on the style property used to
 * define that event.
 */
var EVENT_NAME_MAP = {
  transitionend: {
    'transition': 'transitionend',
    'WebkitTransition': 'webkitTransitionEnd',
    'MozTransition': 'mozTransitionEnd',
    'OTransition': 'oTransitionEnd',
    'msTransition': 'MSTransitionEnd'
  },

  animationend: {
    'animation': 'animationend',
    'WebkitAnimation': 'webkitAnimationEnd',
    'MozAnimation': 'mozAnimationEnd',
    'OAnimation': 'oAnimationEnd',
    'msAnimation': 'MSAnimationEnd'
  }
};

var endEvents = [];

function detectEvents() {
  var testEl = document.createElement('div');
  var style = testEl.style;

  // On some platforms, in particular some releases of Android 4.x,
  // the un-prefixed "animation" and "transition" properties are defined on the
  // style object but the events that fire will still be prefixed, so we need
  // to check if the un-prefixed events are useable, and if not remove them
  // from the map
  if (!('AnimationEvent' in window)) {
    delete EVENT_NAME_MAP.animationend.animation;
  }

  if (!('TransitionEvent' in window)) {
    delete EVENT_NAME_MAP.transitionend.transition;
  }

  for (var baseEventName in EVENT_NAME_MAP) {
    // eslint-disable-line guard-for-in
    var baseEvents = EVENT_NAME_MAP[baseEventName];
    for (var styleName in baseEvents) {
      if (styleName in style) {
        endEvents.push(baseEvents[styleName]);
        break;
      }
    }
  }
}

if (canUseDOM) {
  detectEvents();
}

// We use the raw {add|remove}EventListener() call because EventListener
// does not know how to remove event listeners and we really should
// clean up. Also, these events are not triggered in older browsers
// so we should be A-OK here.

function addEventListener(node, eventName, eventListener) {
  node.addEventListener(eventName, eventListener, false);
}

function removeEventListener(node, eventName, eventListener) {
  node.removeEventListener(eventName, eventListener, false);
}

var ReactTransitionEvents = {
  addEndEventListener: function addEndEventListener(node, eventListener) {
    if (endEvents.length === 0) {
      // If CSS transitions are not supported, trigger an "end animation"
      // event immediately.
      window.setTimeout(eventListener, 0);
      return;
    }
    endEvents.forEach(function (endEvent) {
      addEventListener(node, endEvent, eventListener);
    });
  },
  removeEndEventListener: function removeEndEventListener(node, eventListener) {
    if (endEvents.length === 0) {
      return;
    }
    endEvents.forEach(function (endEvent) {
      removeEventListener(node, endEvent, eventListener);
    });
  }
};

/* harmony default export */ __webpack_exports__["a"] = (ReactTransitionEvents);

/***/ }),
/* 250 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_warning__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__ = __webpack_require__(8);












var propTypes = {
  inline: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  disabled: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  title: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string,
  /**
   * Only valid if `inline` is not set.
   */
  validationState: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.oneOf(['success', 'warning', 'error', null]),
  /**
   * Attaches a ref to the `<input>` element. Only functions can be used here.
   *
   * ```js
   * <Checkbox inputRef={ref => { this.input = ref; }} />
   * ```
   */
  inputRef: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func
};

var defaultProps = {
  inline: false,
  disabled: false,
  title: ''
};

var Checkbox = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Checkbox, _React$Component);

  function Checkbox() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, Checkbox);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  Checkbox.prototype.render = function render() {
    var _props = this.props,
        inline = _props.inline,
        disabled = _props.disabled,
        validationState = _props.validationState,
        inputRef = _props.inputRef,
        className = _props.className,
        style = _props.style,
        title = _props.title,
        children = _props.children,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['inline', 'disabled', 'validationState', 'inputRef', 'className', 'style', 'title', 'children']);

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["f" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var input = __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('input', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, elementProps, {
      ref: inputRef,
      type: 'checkbox',
      disabled: disabled
    }));

    if (inline) {
      var _classes2;

      var _classes = (_classes2 = {}, _classes2[Object(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["e" /* prefix */])(bsProps, 'inline')] = true, _classes2.disabled = disabled, _classes2);

      // Use a warning here instead of in propTypes to get better-looking
      // generated documentation.
       false ? warning(!validationState, '`validationState` is ignored on `<Checkbox inline>`. To display ' + 'validation state on an inline checkbox, set `validationState` on a ' + 'parent `<FormGroup>` or other element instead.') : void 0;

      return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        'label',
        { className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, _classes), style: style, title: title },
        input,
        children
      );
    }

    var classes = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["d" /* getClassSet */])(bsProps), {
      disabled: disabled
    });
    if (validationState) {
      classes['has-' + validationState] = true;
    }

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
      'div',
      { className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, classes), style: style },
      __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        'label',
        { title: title },
        input,
        children
      )
    );
  };

  return Checkbox;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

Checkbox.propTypes = propTypes;
Checkbox.defaultProps = defaultProps;

/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["a" /* bsClass */])('checkbox', Checkbox));

/***/ }),
/* 251 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types_extra_lib_elementType__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types_extra_lib_elementType___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_prop_types_extra_lib_elementType__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_capitalize__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils_StyleConfig__ = __webpack_require__(15);














var propTypes = {
  componentClass: __WEBPACK_IMPORTED_MODULE_8_prop_types_extra_lib_elementType___default.a,

  /**
   * Apply clearfix
   *
   * on Extra small devices Phones
   *
   * adds class `visible-xs-block`
   */
  visibleXsBlock: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  /**
   * Apply clearfix
   *
   * on Small devices Tablets
   *
   * adds class `visible-sm-block`
   */
  visibleSmBlock: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  /**
   * Apply clearfix
   *
   * on Medium devices Desktops
   *
   * adds class `visible-md-block`
   */
  visibleMdBlock: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  /**
   * Apply clearfix
   *
   * on Large devices Desktops
   *
   * adds class `visible-lg-block`
   */
  visibleLgBlock: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool
};

var defaultProps = {
  componentClass: 'div'
};

var Clearfix = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Clearfix, _React$Component);

  function Clearfix() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, Clearfix);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  Clearfix.prototype.render = function render() {
    var _props = this.props,
        Component = _props.componentClass,
        className = _props.className,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['componentClass', 'className']);

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["f" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = Object(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["d" /* getClassSet */])(bsProps);

    __WEBPACK_IMPORTED_MODULE_11__utils_StyleConfig__["a" /* DEVICE_SIZES */].forEach(function (size) {
      var propName = 'visible' + Object(__WEBPACK_IMPORTED_MODULE_10__utils_capitalize__["a" /* default */])(size) + 'Block';
      if (elementProps[propName]) {
        classes['visible-' + size + '-block'] = true;
      }

      delete elementProps[propName];
    });

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Component, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, elementProps, {
      className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, classes)
    }));
  };

  return Clearfix;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

Clearfix.propTypes = propTypes;
Clearfix.defaultProps = defaultProps;

/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["a" /* bsClass */])('clearfix', Clearfix));

/***/ }),
/* 252 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_warning__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__ = __webpack_require__(8);












var propTypes = {
  /**
   * Uses `controlId` from `<FormGroup>` if not explicitly specified.
   */
  htmlFor: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string,
  srOnly: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool
};

var defaultProps = {
  srOnly: false
};

var contextTypes = {
  $bs_formGroup: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.object
};

var ControlLabel = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(ControlLabel, _React$Component);

  function ControlLabel() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, ControlLabel);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  ControlLabel.prototype.render = function render() {
    var formGroup = this.context.$bs_formGroup;
    var controlId = formGroup && formGroup.controlId;

    var _props = this.props,
        _props$htmlFor = _props.htmlFor,
        htmlFor = _props$htmlFor === undefined ? controlId : _props$htmlFor,
        srOnly = _props.srOnly,
        className = _props.className,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['htmlFor', 'srOnly', 'className']);

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["f" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

     false ? warning(controlId == null || htmlFor === controlId, '`controlId` is ignored on `<ControlLabel>` when `htmlFor` is specified.') : void 0;

    var classes = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["d" /* getClassSet */])(bsProps), {
      'sr-only': srOnly
    });

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('label', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, elementProps, {
      htmlFor: htmlFor,
      className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, classes)
    }));
  };

  return ControlLabel;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

ControlLabel.propTypes = propTypes;
ControlLabel.defaultProps = defaultProps;
ControlLabel.contextTypes = contextTypes;

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["a" /* bsClass */])('control-label', ControlLabel));

/***/ }),
/* 253 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types_extra_lib_elementType__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types_extra_lib_elementType___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_prop_types_extra_lib_elementType__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_StyleConfig__ = __webpack_require__(15);













var propTypes = {
  componentClass: __WEBPACK_IMPORTED_MODULE_8_prop_types_extra_lib_elementType___default.a,

  /**
   * The number of columns you wish to span
   *
   * for Extra small devices Phones (<768px)
   *
   * class-prefix `col-xs-`
   */
  xs: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.number,
  /**
   * The number of columns you wish to span
   *
   * for Small devices Tablets (≥768px)
   *
   * class-prefix `col-sm-`
   */
  sm: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.number,
  /**
   * The number of columns you wish to span
   *
   * for Medium devices Desktops (≥992px)
   *
   * class-prefix `col-md-`
   */
  md: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.number,
  /**
   * The number of columns you wish to span
   *
   * for Large devices Desktops (≥1200px)
   *
   * class-prefix `col-lg-`
   */
  lg: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.number,
  /**
   * Hide column
   *
   * on Extra small devices Phones
   *
   * adds class `hidden-xs`
   */
  xsHidden: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  /**
   * Hide column
   *
   * on Small devices Tablets
   *
   * adds class `hidden-sm`
   */
  smHidden: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  /**
   * Hide column
   *
   * on Medium devices Desktops
   *
   * adds class `hidden-md`
   */
  mdHidden: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  /**
   * Hide column
   *
   * on Large devices Desktops
   *
   * adds class `hidden-lg`
   */
  lgHidden: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  /**
   * Move columns to the right
   *
   * for Extra small devices Phones
   *
   * class-prefix `col-xs-offset-`
   */
  xsOffset: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.number,
  /**
   * Move columns to the right
   *
   * for Small devices Tablets
   *
   * class-prefix `col-sm-offset-`
   */
  smOffset: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.number,
  /**
   * Move columns to the right
   *
   * for Medium devices Desktops
   *
   * class-prefix `col-md-offset-`
   */
  mdOffset: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.number,
  /**
   * Move columns to the right
   *
   * for Large devices Desktops
   *
   * class-prefix `col-lg-offset-`
   */
  lgOffset: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.number,
  /**
   * Change the order of grid columns to the right
   *
   * for Extra small devices Phones
   *
   * class-prefix `col-xs-push-`
   */
  xsPush: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.number,
  /**
   * Change the order of grid columns to the right
   *
   * for Small devices Tablets
   *
   * class-prefix `col-sm-push-`
   */
  smPush: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.number,
  /**
   * Change the order of grid columns to the right
   *
   * for Medium devices Desktops
   *
   * class-prefix `col-md-push-`
   */
  mdPush: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.number,
  /**
   * Change the order of grid columns to the right
   *
   * for Large devices Desktops
   *
   * class-prefix `col-lg-push-`
   */
  lgPush: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.number,
  /**
   * Change the order of grid columns to the left
   *
   * for Extra small devices Phones
   *
   * class-prefix `col-xs-pull-`
   */
  xsPull: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.number,
  /**
   * Change the order of grid columns to the left
   *
   * for Small devices Tablets
   *
   * class-prefix `col-sm-pull-`
   */
  smPull: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.number,
  /**
   * Change the order of grid columns to the left
   *
   * for Medium devices Desktops
   *
   * class-prefix `col-md-pull-`
   */
  mdPull: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.number,
  /**
   * Change the order of grid columns to the left
   *
   * for Large devices Desktops
   *
   * class-prefix `col-lg-pull-`
   */
  lgPull: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.number
};

var defaultProps = {
  componentClass: 'div'
};

var Col = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Col, _React$Component);

  function Col() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, Col);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  Col.prototype.render = function render() {
    var _props = this.props,
        Component = _props.componentClass,
        className = _props.className,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['componentClass', 'className']);

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["f" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = [];

    __WEBPACK_IMPORTED_MODULE_10__utils_StyleConfig__["a" /* DEVICE_SIZES */].forEach(function (size) {
      function popProp(propSuffix, modifier) {
        var propName = '' + size + propSuffix;
        var propValue = elementProps[propName];

        if (propValue != null) {
          classes.push(Object(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["e" /* prefix */])(bsProps, '' + size + modifier + '-' + propValue));
        }

        delete elementProps[propName];
      }

      popProp('', '');
      popProp('Offset', '-offset');
      popProp('Push', '-push');
      popProp('Pull', '-pull');

      var hiddenPropName = size + 'Hidden';
      if (elementProps[hiddenPropName]) {
        classes.push('hidden-' + size);
      }
      delete elementProps[hiddenPropName];
    });

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Component, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, elementProps, {
      className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, classes)
    }));
  };

  return Col;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

Col.propTypes = propTypes;
Col.defaultProps = defaultProps;

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["a" /* bsClass */])('col', Col));

/***/ }),
/* 254 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = camelize;
var rHyphen = /-(.)/g;

function camelize(string) {
  return string.replace(rHyphen, function (_, chr) {
    return chr.toUpperCase();
  });
}
module.exports = exports["default"];

/***/ }),
/* 255 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = hyphenateStyleName;

var _hyphenate = __webpack_require__(256);

var _hyphenate2 = _interopRequireDefault(_hyphenate);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var msPattern = /^ms-/; /**
                         * Copyright 2013-2014, Facebook, Inc.
                         * All rights reserved.
                         * https://github.com/facebook/react/blob/2aeb8a2a6beb00617a4217f7f8284924fa2ad819/src/vendor/core/hyphenateStyleName.js
                         */

function hyphenateStyleName(string) {
  return (0, _hyphenate2.default)(string).replace(msPattern, '-ms-');
}
module.exports = exports['default'];

/***/ }),
/* 256 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = hyphenate;

var rUpper = /([A-Z])/g;

function hyphenate(string) {
  return string.replace(rUpper, '-$1').toLowerCase();
}
module.exports = exports['default'];

/***/ }),
/* 257 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _getComputedStyle;

var _camelizeStyle = __webpack_require__(132);

var _camelizeStyle2 = _interopRequireDefault(_camelizeStyle);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var rposition = /^(top|right|bottom|left)$/;
var rnumnonpx = /^([+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|))(?!px)[a-z%]+$/i;

function _getComputedStyle(node) {
  if (!node) throw new TypeError('No Element passed to `getComputedStyle()`');
  var doc = node.ownerDocument;

  return 'defaultView' in doc ? doc.defaultView.opener ? node.ownerDocument.defaultView.getComputedStyle(node, null) : window.getComputedStyle(node, null) : {
    //ie 8 "magic" from: https://github.com/jquery/jquery/blob/1.11-stable/src/css/curCSS.js#L72
    getPropertyValue: function getPropertyValue(prop) {
      var style = node.style;

      prop = (0, _camelizeStyle2.default)(prop);

      if (prop == 'float') prop = 'styleFloat';

      var current = node.currentStyle[prop] || null;

      if (current == null && style && style[prop]) current = style[prop];

      if (rnumnonpx.test(current) && !rposition.test(prop)) {
        // Remember the original values
        var left = style.left;
        var runStyle = node.runtimeStyle;
        var rsLeft = runStyle && runStyle.left;

        // Put in the new values to get a computed value out
        if (rsLeft) runStyle.left = node.currentStyle.left;

        style.left = prop === 'fontSize' ? '1em' : current;
        current = style.pixelLeft + 'px';

        // Revert the changed values
        style.left = left;
        if (rsLeft) runStyle.left = rsLeft;
      }

      return current;
    }
  };
}
module.exports = exports['default'];

/***/ }),
/* 258 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = removeStyle;
function removeStyle(node, key) {
  return 'removeProperty' in node.style ? node.style.removeProperty(key) : node.style.removeAttribute(key);
}
module.exports = exports['default'];

/***/ }),
/* 259 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isTransform;
var supportedTransforms = /^((translate|rotate|scale)(X|Y|Z|3d)?|matrix(3d)?|perspective|skew(X|Y)?)$/i;

function isTransform(property) {
  return !!(property && supportedTransforms.test(property));
}
module.exports = exports["default"];

/***/ }),
/* 260 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = createUncontrollable;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _invariant = __webpack_require__(17);

var _invariant2 = _interopRequireDefault(_invariant);

var _utils = __webpack_require__(261);

var utils = _interopRequireWildcard(_utils);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function createUncontrollable(mixin, set) {

  return uncontrollable;

  function uncontrollable(Component, controlledValues) {
    var _class, _temp;

    var methods = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];

    var displayName = Component.displayName || Component.name || 'Component',
        basePropTypes = utils.getType(Component).propTypes,
        isCompositeComponent = utils.isReactComponent(Component),
        controlledProps = Object.keys(controlledValues),
        propTypes;

    var OMIT_PROPS = ['valueLink', 'checkedLink'].concat(controlledProps.map(utils.defaultKey));

    propTypes = utils.uncontrolledPropTypes(controlledValues, basePropTypes, displayName);

    (0, _invariant2.default)(isCompositeComponent || !methods.length, '[uncontrollable] stateless function components cannot pass through methods ' + 'because they have no associated instances. Check component: ' + displayName + ', ' + 'attempting to pass through methods: ' + methods.join(', '));

    methods = utils.transform(methods, function (obj, method) {
      obj[method] = function () {
        var _refs$inner;

        return (_refs$inner = this.refs.inner)[method].apply(_refs$inner, arguments);
      };
    }, {});

    var component = (_temp = _class = function (_React$Component) {
      _inherits(component, _React$Component);

      function component() {
        _classCallCheck(this, component);

        return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
      }

      component.prototype.shouldComponentUpdate = function shouldComponentUpdate() {
        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        return !mixin.shouldComponentUpdate || mixin.shouldComponentUpdate.apply(this, args);
      };

      component.prototype.componentWillMount = function componentWillMount() {
        var _this2 = this;

        var props = this.props;

        this._values = {};

        controlledProps.forEach(function (key) {
          _this2._values[key] = props[utils.defaultKey(key)];
        });
      };

      /**
       * If a prop switches from controlled to Uncontrolled
       * reset its value to the defaultValue
       */


      component.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
        var _this3 = this;

        var props = this.props;

        if (mixin.componentWillReceiveProps) {
          mixin.componentWillReceiveProps.call(this, nextProps);
        }

        controlledProps.forEach(function (key) {
          if (utils.getValue(nextProps, key) === undefined && utils.getValue(props, key) !== undefined) {
            _this3._values[key] = nextProps[utils.defaultKey(key)];
          }
        });
      };

      component.prototype.componentWillUnmount = function componentWillUnmount() {
        this.unmounted = true;
      };

      component.prototype.getControlledInstance = function getControlledInstance() {
        return this.refs.inner;
      };

      component.prototype.render = function render() {
        var _this4 = this;

        var newProps = {},
            props = omitProps(this.props);

        utils.each(controlledValues, function (handle, propName) {
          var linkPropName = utils.getLinkName(propName),
              prop = _this4.props[propName];

          if (linkPropName && !isProp(_this4.props, propName) && isProp(_this4.props, linkPropName)) {
            prop = _this4.props[linkPropName].value;
          }

          newProps[propName] = prop !== undefined ? prop : _this4._values[propName];

          newProps[handle] = setAndNotify.bind(_this4, propName);
        });

        newProps = _extends({}, props, newProps, {
          ref: isCompositeComponent ? 'inner' : null
        });

        return _react2.default.createElement(Component, newProps);
      };

      return component;
    }(_react2.default.Component), _class.displayName = 'Uncontrolled(' + displayName + ')', _class.propTypes = propTypes, _temp);

    _extends(component.prototype, methods);

    component.ControlledComponent = Component;

    /**
     * useful when wrapping a Component and you want to control
     * everything
     */
    component.deferControlTo = function (newComponent) {
      var additions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var nextMethods = arguments[2];

      return uncontrollable(newComponent, _extends({}, controlledValues, additions), nextMethods);
    };

    return component;

    function setAndNotify(propName, value) {
      var linkName = utils.getLinkName(propName),
          handler = this.props[controlledValues[propName]];

      if (linkName && isProp(this.props, linkName) && !handler) {
        handler = this.props[linkName].requestChange;
      }

      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
        args[_key2 - 2] = arguments[_key2];
      }

      set(this, propName, handler, value, args);
    }

    function isProp(props, prop) {
      return props[prop] !== undefined;
    }

    function omitProps(props) {
      var result = {};

      utils.each(props, function (value, key) {
        if (OMIT_PROPS.indexOf(key) === -1) result[key] = value;
      });

      return result;
    }
  }
}
module.exports = exports['default'];

/***/ }),
/* 261 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.version = undefined;
exports.uncontrolledPropTypes = uncontrolledPropTypes;
exports.getType = getType;
exports.getValue = getValue;
exports.getLinkName = getLinkName;
exports.defaultKey = defaultKey;
exports.chain = chain;
exports.transform = transform;
exports.each = each;
exports.has = has;
exports.isReactComponent = isReactComponent;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _invariant = __webpack_require__(17);

var _invariant2 = _interopRequireDefault(_invariant);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function readOnlyPropType(handler, name) {
  return function (props, propName) {
    if (props[propName] !== undefined) {
      if (!props[handler]) {
        return new Error('You have provided a `' + propName + '` prop to ' + '`' + name + '` without an `' + handler + '` handler. This will render a read-only field. ' + 'If the field should be mutable use `' + defaultKey(propName) + '`. Otherwise, set `' + handler + '`');
      }
    }
  };
}

function uncontrolledPropTypes(controlledValues, basePropTypes, displayName) {
  var propTypes = {};

  if (false) {
    transform(controlledValues, function (obj, handler, prop) {
      (0, _invariant2.default)(typeof handler === 'string' && handler.trim().length, 'Uncontrollable - [%s]: the prop `%s` needs a valid handler key name in order to make it uncontrollable', displayName, prop);

      obj[prop] = readOnlyPropType(handler, displayName);
    }, propTypes);
  }

  return propTypes;
}

var version = exports.version = _react2.default.version.split('.').map(parseFloat);

function getType(component) {
  if (version[0] >= 15 || version[0] === 0 && version[1] >= 13) return component;

  return component.type;
}

function getValue(props, name) {
  var linkPropName = getLinkName(name);

  if (linkPropName && !isProp(props, name) && isProp(props, linkPropName)) return props[linkPropName].value;

  return props[name];
}

function isProp(props, prop) {
  return props[prop] !== undefined;
}

function getLinkName(name) {
  return name === 'value' ? 'valueLink' : name === 'checked' ? 'checkedLink' : null;
}

function defaultKey(key) {
  return 'default' + key.charAt(0).toUpperCase() + key.substr(1);
}

function chain(thisArg, a, b) {
  return function chainedFunction() {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    a && a.call.apply(a, [thisArg].concat(args));
    b && b.call.apply(b, [thisArg].concat(args));
  };
}

function transform(obj, cb, seed) {
  each(obj, cb.bind(null, seed = seed || (Array.isArray(obj) ? [] : {})));
  return seed;
}

function each(obj, cb, thisArg) {
  if (Array.isArray(obj)) return obj.forEach(cb, thisArg);

  for (var key in obj) {
    if (has(obj, key)) cb.call(thisArg, obj[key], key, obj);
  }
}

function has(o, k) {
  return o ? Object.prototype.hasOwnProperty.call(o, k) : false;
}

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */
function isReactComponent(component) {
  return !!(component && component.prototype && component.prototype.isReactComponent);
}

/***/ }),
/* 262 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_array_from__ = __webpack_require__(263);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_keycode__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_keycode___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_keycode__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_dom__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_overlays_lib_RootCloseWrapper__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_overlays_lib_RootCloseWrapper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_react_overlays_lib_RootCloseWrapper__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__utils_bootstrapUtils__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__utils_createChainedFunction__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__utils_ValidComponentChildren__ = __webpack_require__(18);

















var propTypes = {
  open: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.bool,
  pullRight: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.bool,
  onClose: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.func,
  labelledBy: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.number]),
  onSelect: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.func,
  rootCloseEvent: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.oneOf(['click', 'mousedown'])
};

var defaultProps = {
  bsRole: 'menu',
  pullRight: false
};

var DropdownMenu = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(DropdownMenu, _React$Component);

  function DropdownMenu(props) {
    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, DropdownMenu);

    var _this = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    _this.handleRootClose = _this.handleRootClose.bind(_this);
    _this.handleKeyDown = _this.handleKeyDown.bind(_this);
    return _this;
  }

  DropdownMenu.prototype.handleRootClose = function handleRootClose(event) {
    this.props.onClose(event, { source: 'rootClose' });
  };

  DropdownMenu.prototype.handleKeyDown = function handleKeyDown(event) {
    switch (event.keyCode) {
      case __WEBPACK_IMPORTED_MODULE_7_keycode___default.a.codes.down:
        this.focusNext();
        event.preventDefault();
        break;
      case __WEBPACK_IMPORTED_MODULE_7_keycode___default.a.codes.up:
        this.focusPrevious();
        event.preventDefault();
        break;
      case __WEBPACK_IMPORTED_MODULE_7_keycode___default.a.codes.esc:
      case __WEBPACK_IMPORTED_MODULE_7_keycode___default.a.codes.tab:
        this.props.onClose(event, { source: 'keydown' });
        break;
      default:
    }
  };

  DropdownMenu.prototype.getItemsAndActiveIndex = function getItemsAndActiveIndex() {
    var items = this.getFocusableMenuItems();
    var activeIndex = items.indexOf(document.activeElement);

    return { items: items, activeIndex: activeIndex };
  };

  DropdownMenu.prototype.getFocusableMenuItems = function getFocusableMenuItems() {
    var node = __WEBPACK_IMPORTED_MODULE_10_react_dom___default.a.findDOMNode(this);
    if (!node) {
      return [];
    }

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_array_from___default()(node.querySelectorAll('[tabIndex="-1"]'));
  };

  DropdownMenu.prototype.focusNext = function focusNext() {
    var _getItemsAndActiveInd = this.getItemsAndActiveIndex(),
        items = _getItemsAndActiveInd.items,
        activeIndex = _getItemsAndActiveInd.activeIndex;

    if (items.length === 0) {
      return;
    }

    var nextIndex = activeIndex === items.length - 1 ? 0 : activeIndex + 1;
    items[nextIndex].focus();
  };

  DropdownMenu.prototype.focusPrevious = function focusPrevious() {
    var _getItemsAndActiveInd2 = this.getItemsAndActiveIndex(),
        items = _getItemsAndActiveInd2.items,
        activeIndex = _getItemsAndActiveInd2.activeIndex;

    if (items.length === 0) {
      return;
    }

    var prevIndex = activeIndex === 0 ? items.length - 1 : activeIndex - 1;
    items[prevIndex].focus();
  };

  DropdownMenu.prototype.render = function render() {
    var _extends2,
        _this2 = this;

    var _props = this.props,
        open = _props.open,
        pullRight = _props.pullRight,
        labelledBy = _props.labelledBy,
        onSelect = _props.onSelect,
        className = _props.className,
        rootCloseEvent = _props.rootCloseEvent,
        children = _props.children,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['open', 'pullRight', 'labelledBy', 'onSelect', 'className', 'rootCloseEvent', 'children']);

    var _splitBsPropsAndOmit = Object(__WEBPACK_IMPORTED_MODULE_12__utils_bootstrapUtils__["g" /* splitBsPropsAndOmit */])(props, ['onClose']),
        bsProps = _splitBsPropsAndOmit[0],
        elementProps = _splitBsPropsAndOmit[1];

    var classes = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_12__utils_bootstrapUtils__["d" /* getClassSet */])(bsProps), (_extends2 = {}, _extends2[Object(__WEBPACK_IMPORTED_MODULE_12__utils_bootstrapUtils__["e" /* prefix */])(bsProps, 'right')] = pullRight, _extends2));

    return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_11_react_overlays_lib_RootCloseWrapper___default.a,
      {
        disabled: !open,
        onRootClose: this.handleRootClose,
        event: rootCloseEvent
      },
      __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(
        'ul',
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, elementProps, {
          role: 'menu',
          className: __WEBPACK_IMPORTED_MODULE_6_classnames___default()(className, classes),
          'aria-labelledby': labelledBy
        }),
        __WEBPACK_IMPORTED_MODULE_14__utils_ValidComponentChildren__["a" /* default */].map(children, function (child) {
          return __WEBPACK_IMPORTED_MODULE_8_react___default.a.cloneElement(child, {
            onKeyDown: Object(__WEBPACK_IMPORTED_MODULE_13__utils_createChainedFunction__["a" /* default */])(child.props.onKeyDown, _this2.handleKeyDown),
            onSelect: Object(__WEBPACK_IMPORTED_MODULE_13__utils_createChainedFunction__["a" /* default */])(child.props.onSelect, onSelect)
          });
        })
      )
    );
  };

  return DropdownMenu;
}(__WEBPACK_IMPORTED_MODULE_8_react___default.a.Component);

DropdownMenu.propTypes = propTypes;
DropdownMenu.defaultProps = defaultProps;

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_12__utils_bootstrapUtils__["a" /* bsClass */])('dropdown-menu', DropdownMenu));

/***/ }),
/* 263 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(264), __esModule: true };

/***/ }),
/* 264 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(120);
__webpack_require__(265);
module.exports = __webpack_require__(19).Array.from;


/***/ }),
/* 265 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ctx = __webpack_require__(74);
var $export = __webpack_require__(25);
var toObject = __webpack_require__(83);
var call = __webpack_require__(266);
var isArrayIter = __webpack_require__(267);
var toLength = __webpack_require__(119);
var createProperty = __webpack_require__(268);
var getIterFn = __webpack_require__(269);

$export($export.S + $export.F * !__webpack_require__(271)(function (iter) { Array.from(iter); }), 'Array', {
  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
  from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
    var O = toObject(arrayLike);
    var C = typeof this == 'function' ? this : Array;
    var aLen = arguments.length;
    var mapfn = aLen > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    var index = 0;
    var iterFn = getIterFn(O);
    var length, result, step, iterator;
    if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
    // if object isn't iterable or it's array with default iterator - use simple case
    if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
      for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
      }
    } else {
      length = toLength(O.length);
      for (result = new C(length); length > index; index++) {
        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
      }
    }
    result.length = index;
    return result;
  }
});


/***/ }),
/* 266 */
/***/ (function(module, exports, __webpack_require__) {

// call something on iterator step with safe closing on error
var anObject = __webpack_require__(35);
module.exports = function (iterator, fn, value, entries) {
  try {
    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
  // 7.4.6 IteratorClose(iterator, completion)
  } catch (e) {
    var ret = iterator['return'];
    if (ret !== undefined) anObject(ret.call(iterator));
    throw e;
  }
};


/***/ }),
/* 267 */
/***/ (function(module, exports, __webpack_require__) {

// check on default Array iterator
var Iterators = __webpack_require__(47);
var ITERATOR = __webpack_require__(20)('iterator');
var ArrayProto = Array.prototype;

module.exports = function (it) {
  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
};


/***/ }),
/* 268 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $defineProperty = __webpack_require__(28);
var createDesc = __webpack_require__(44);

module.exports = function (object, index, value) {
  if (index in object) $defineProperty.f(object, index, createDesc(0, value));
  else object[index] = value;
};


/***/ }),
/* 269 */
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__(270);
var ITERATOR = __webpack_require__(20)('iterator');
var Iterators = __webpack_require__(47);
module.exports = __webpack_require__(19).getIteratorMethod = function (it) {
  if (it != undefined) return it[ITERATOR]
    || it['@@iterator']
    || Iterators[classof(it)];
};


/***/ }),
/* 270 */
/***/ (function(module, exports, __webpack_require__) {

// getting tag from 19.1.3.6 Object.prototype.toString()
var cof = __webpack_require__(76);
var TAG = __webpack_require__(20)('toStringTag');
// ES3 wrong here
var ARG = cof(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (e) { /* empty */ }
};

module.exports = function (it) {
  var O, T, B;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
    // builtinTag case
    : ARG ? cof(O)
    // ES3 arguments fallback
    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
};


/***/ }),
/* 271 */
/***/ (function(module, exports, __webpack_require__) {

var ITERATOR = __webpack_require__(20)('iterator');
var SAFE_CLOSING = false;

try {
  var riter = [7][ITERATOR]();
  riter['return'] = function () { SAFE_CLOSING = true; };
  // eslint-disable-next-line no-throw-literal
  Array.from(riter, function () { throw 2; });
} catch (e) { /* empty */ }

module.exports = function (exec, skipClosing) {
  if (!skipClosing && !SAFE_CLOSING) return false;
  var safe = false;
  try {
    var arr = [7];
    var iter = arr[ITERATOR]();
    iter.next = function () { return { done: safe = true }; };
    arr[ITERATOR] = function () { return iter; };
    exec(arr);
  } catch (e) { /* empty */ }
  return safe;
};


/***/ }),
/* 272 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = requiredRoles;
/* harmony export (immutable) */ __webpack_exports__["a"] = exclusiveRoles;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types_extra_lib_utils_createChainableTypeChecker__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types_extra_lib_utils_createChainableTypeChecker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types_extra_lib_utils_createChainableTypeChecker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ValidComponentChildren__ = __webpack_require__(18);




function requiredRoles() {
  for (var _len = arguments.length, roles = Array(_len), _key = 0; _key < _len; _key++) {
    roles[_key] = arguments[_key];
  }

  return __WEBPACK_IMPORTED_MODULE_0_prop_types_extra_lib_utils_createChainableTypeChecker___default()(function (props, propName, component) {
    var missing = void 0;

    roles.every(function (role) {
      if (!__WEBPACK_IMPORTED_MODULE_1__ValidComponentChildren__["a" /* default */].some(props.children, function (child) {
        return child.props.bsRole === role;
      })) {
        missing = role;
        return false;
      }

      return true;
    });

    if (missing) {
      return new Error('(children) ' + component + ' - Missing a required child with bsRole: ' + (missing + '. ' + component + ' must have at least one child of each of ') + ('the following bsRoles: ' + roles.join(', ')));
    }

    return null;
  });
}

function exclusiveRoles() {
  for (var _len2 = arguments.length, roles = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    roles[_key2] = arguments[_key2];
  }

  return __WEBPACK_IMPORTED_MODULE_0_prop_types_extra_lib_utils_createChainableTypeChecker___default()(function (props, propName, component) {
    var duplicate = void 0;

    roles.every(function (role) {
      var childrenWithRole = __WEBPACK_IMPORTED_MODULE_1__ValidComponentChildren__["a" /* default */].filter(props.children, function (child) {
        return child.props.bsRole === role;
      });

      if (childrenWithRole.length > 1) {
        duplicate = role;
        return false;
      }

      return true;
    });

    if (duplicate) {
      return new Error('(children) ' + component + ' - Duplicate children detected of bsRole: ' + (duplicate + '. Only one child each allowed with the following ') + ('bsRoles: ' + roles.join(', ')));
    }

    return null;
  });
}

/***/ }),
/* 273 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Dropdown__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_splitComponentProps__ = __webpack_require__(63);











var propTypes = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_7__Dropdown__["a" /* default */].propTypes, {

  // Toggle props.
  bsStyle: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  bsSize: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  title: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.node.isRequired,
  noCaret: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,

  // Override generated docs from <Dropdown>.
  /**
   * @private
   */
  children: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.node
});

var DropdownButton = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(DropdownButton, _React$Component);

  function DropdownButton() {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, DropdownButton);

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  DropdownButton.prototype.render = function render() {
    var _props = this.props,
        bsSize = _props.bsSize,
        bsStyle = _props.bsStyle,
        title = _props.title,
        children = _props.children,
        props = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['bsSize', 'bsStyle', 'title', 'children']);

    var _splitComponentProps = Object(__WEBPACK_IMPORTED_MODULE_8__utils_splitComponentProps__["a" /* default */])(props, __WEBPACK_IMPORTED_MODULE_7__Dropdown__["a" /* default */].ControlledComponent),
        dropdownProps = _splitComponentProps[0],
        toggleProps = _splitComponentProps[1];

    return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_7__Dropdown__["a" /* default */],
      __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, dropdownProps, {
        bsSize: bsSize,
        bsStyle: bsStyle
      }),
      __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_7__Dropdown__["a" /* default */].Toggle,
        __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, toggleProps, {
          bsSize: bsSize,
          bsStyle: bsStyle
        }),
        title
      ),
      __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_7__Dropdown__["a" /* default */].Menu,
        null,
        children
      )
    );
  };

  return DropdownButton;
}(__WEBPACK_IMPORTED_MODULE_5_react___default.a.Component);

DropdownButton.propTypes = propTypes;

/* unused harmony default export */ var _unused_webpack_default_export = (DropdownButton);

/***/ }),
/* 274 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types_extra_lib_elementType__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types_extra_lib_elementType___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_prop_types_extra_lib_elementType__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__ = __webpack_require__(8);












var propTypes = {
  horizontal: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  inline: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  componentClass: __WEBPACK_IMPORTED_MODULE_8_prop_types_extra_lib_elementType___default.a
};

var defaultProps = {
  horizontal: false,
  inline: false,
  componentClass: 'form'
};

var Form = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Form, _React$Component);

  function Form() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, Form);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  Form.prototype.render = function render() {
    var _props = this.props,
        horizontal = _props.horizontal,
        inline = _props.inline,
        Component = _props.componentClass,
        className = _props.className,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['horizontal', 'inline', 'componentClass', 'className']);

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["f" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = [];
    if (horizontal) {
      classes.push(Object(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["e" /* prefix */])(bsProps, 'horizontal'));
    }
    if (inline) {
      classes.push(Object(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["e" /* prefix */])(bsProps, 'inline'));
    }

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Component, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, elementProps, {
      className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, classes)
    }));
  };

  return Form;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

Form.propTypes = propTypes;
Form.defaultProps = defaultProps;

/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["a" /* bsClass */])('form', Form));

/***/ }),
/* 275 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types_extra_lib_elementType__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types_extra_lib_elementType___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_prop_types_extra_lib_elementType__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_warning__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__FormControlFeedback__ = __webpack_require__(276);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__FormControlStatic__ = __webpack_require__(277);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__utils_bootstrapUtils__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__utils_StyleConfig__ = __webpack_require__(15);

















var propTypes = {
  componentClass: __WEBPACK_IMPORTED_MODULE_8_prop_types_extra_lib_elementType___default.a,
  /**
   * Only relevant if `componentClass` is `'input'`.
   */
  type: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string,
  /**
   * Uses `controlId` from `<FormGroup>` if not explicitly specified.
   */
  id: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string,
  /**
   * Attaches a ref to the `<input>` element. Only functions can be used here.
   *
   * ```js
   * <FormControl inputRef={ref => { this.input = ref; }} />
   * ```
   */
  inputRef: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func
};

var defaultProps = {
  componentClass: 'input'
};

var contextTypes = {
  $bs_formGroup: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.object
};

var FormControl = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(FormControl, _React$Component);

  function FormControl() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, FormControl);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  FormControl.prototype.render = function render() {
    var formGroup = this.context.$bs_formGroup;
    var controlId = formGroup && formGroup.controlId;

    var _props = this.props,
        Component = _props.componentClass,
        type = _props.type,
        _props$id = _props.id,
        id = _props$id === undefined ? controlId : _props$id,
        inputRef = _props.inputRef,
        className = _props.className,
        bsSize = _props.bsSize,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['componentClass', 'type', 'id', 'inputRef', 'className', 'bsSize']);

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_12__utils_bootstrapUtils__["f" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

     false ? warning(controlId == null || id === controlId, '`controlId` is ignored on `<FormControl>` when `id` is specified.') : void 0;

    // input[type="file"] should not have .form-control.
    var classes = void 0;
    if (type !== 'file') {
      classes = Object(__WEBPACK_IMPORTED_MODULE_12__utils_bootstrapUtils__["d" /* getClassSet */])(bsProps);
    }

    // If user provides a size, make sure to append it to classes as input-
    // e.g. if bsSize is small, it will append input-sm
    if (bsSize) {
      var size = __WEBPACK_IMPORTED_MODULE_13__utils_StyleConfig__["b" /* SIZE_MAP */][bsSize] || bsSize;
      classes[Object(__WEBPACK_IMPORTED_MODULE_12__utils_bootstrapUtils__["e" /* prefix */])({ bsClass: 'input' }, size)] = true;
    }

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Component, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, elementProps, {
      type: type,
      id: id,
      ref: inputRef,
      className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, classes)
    }));
  };

  return FormControl;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

FormControl.propTypes = propTypes;
FormControl.defaultProps = defaultProps;
FormControl.contextTypes = contextTypes;

FormControl.Feedback = __WEBPACK_IMPORTED_MODULE_10__FormControlFeedback__["a" /* default */];
FormControl.Static = __WEBPACK_IMPORTED_MODULE_11__FormControlStatic__["a" /* default */];

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_12__utils_bootstrapUtils__["a" /* bsClass */])('form-control', Object(__WEBPACK_IMPORTED_MODULE_12__utils_bootstrapUtils__["b" /* bsSizes */])([__WEBPACK_IMPORTED_MODULE_13__utils_StyleConfig__["c" /* Size */].SMALL, __WEBPACK_IMPORTED_MODULE_13__utils_StyleConfig__["c" /* Size */].LARGE], FormControl)));

/***/ }),
/* 276 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Glyphicon__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__ = __webpack_require__(8);












var defaultProps = {
  bsRole: 'feedback'
};

var contextTypes = {
  $bs_formGroup: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.object
};

var FormControlFeedback = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(FormControlFeedback, _React$Component);

  function FormControlFeedback() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, FormControlFeedback);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  FormControlFeedback.prototype.getGlyph = function getGlyph(validationState) {
    switch (validationState) {
      case 'success':
        return 'ok';
      case 'warning':
        return 'warning-sign';
      case 'error':
        return 'remove';
      default:
        return null;
    }
  };

  FormControlFeedback.prototype.renderDefaultFeedback = function renderDefaultFeedback(formGroup, className, classes, elementProps) {
    var glyph = this.getGlyph(formGroup && formGroup.validationState);
    if (!glyph) {
      return null;
    }

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Glyphicon__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, elementProps, {
      glyph: glyph,
      className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, classes)
    }));
  };

  FormControlFeedback.prototype.render = function render() {
    var _props = this.props,
        className = _props.className,
        children = _props.children,
        props = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['className', 'children']);

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["f" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = Object(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["d" /* getClassSet */])(bsProps);

    if (!children) {
      return this.renderDefaultFeedback(this.context.$bs_formGroup, className, classes, elementProps);
    }

    var child = __WEBPACK_IMPORTED_MODULE_6_react___default.a.Children.only(children);
    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.cloneElement(child, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, elementProps, {
      className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(child.props.className, className, classes)
    }));
  };

  return FormControlFeedback;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

FormControlFeedback.defaultProps = defaultProps;
FormControlFeedback.contextTypes = contextTypes;

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["a" /* bsClass */])('form-control-feedback', FormControlFeedback));

/***/ }),
/* 277 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_elementType__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_elementType___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_elementType__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__ = __webpack_require__(8);











var propTypes = {
  componentClass: __WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_elementType___default.a
};

var defaultProps = {
  componentClass: 'p'
};

var FormControlStatic = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(FormControlStatic, _React$Component);

  function FormControlStatic() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, FormControlStatic);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  FormControlStatic.prototype.render = function render() {
    var _props = this.props,
        Component = _props.componentClass,
        className = _props.className,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['componentClass', 'className']);

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["f" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = Object(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["d" /* getClassSet */])(bsProps);

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Component, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, elementProps, {
      className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, classes)
    }));
  };

  return FormControlStatic;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

FormControlStatic.propTypes = propTypes;
FormControlStatic.defaultProps = defaultProps;

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["a" /* bsClass */])('form-control-static', FormControlStatic));

/***/ }),
/* 278 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_StyleConfig__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_ValidComponentChildren__ = __webpack_require__(18);













var propTypes = {
  /**
   * Sets `id` on `<FormControl>` and `htmlFor` on `<FormGroup.Label>`.
   */
  controlId: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string,
  validationState: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.oneOf(['success', 'warning', 'error', null])
};

var childContextTypes = {
  $bs_formGroup: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.object.isRequired
};

var FormGroup = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(FormGroup, _React$Component);

  function FormGroup() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, FormGroup);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  FormGroup.prototype.getChildContext = function getChildContext() {
    var _props = this.props,
        controlId = _props.controlId,
        validationState = _props.validationState;


    return {
      $bs_formGroup: {
        controlId: controlId,
        validationState: validationState
      }
    };
  };

  FormGroup.prototype.hasFeedback = function hasFeedback(children) {
    var _this2 = this;

    return __WEBPACK_IMPORTED_MODULE_10__utils_ValidComponentChildren__["a" /* default */].some(children, function (child) {
      return child.props.bsRole === 'feedback' || child.props.children && _this2.hasFeedback(child.props.children);
    });
  };

  FormGroup.prototype.render = function render() {
    var _props2 = this.props,
        validationState = _props2.validationState,
        className = _props2.className,
        children = _props2.children,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props2, ['validationState', 'className', 'children']);

    var _splitBsPropsAndOmit = Object(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["g" /* splitBsPropsAndOmit */])(props, ['controlId']),
        bsProps = _splitBsPropsAndOmit[0],
        elementProps = _splitBsPropsAndOmit[1];

    var classes = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["d" /* getClassSet */])(bsProps), {
      'has-feedback': this.hasFeedback(children)
    });
    if (validationState) {
      classes['has-' + validationState] = true;
    }

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
      'div',
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, elementProps, {
        className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, classes)
      }),
      children
    );
  };

  return FormGroup;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

FormGroup.propTypes = propTypes;
FormGroup.childContextTypes = childContextTypes;

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["a" /* bsClass */])('form-group', Object(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["b" /* bsSizes */])([__WEBPACK_IMPORTED_MODULE_9__utils_StyleConfig__["c" /* Size */].LARGE, __WEBPACK_IMPORTED_MODULE_9__utils_StyleConfig__["c" /* Size */].SMALL], FormGroup)));

/***/ }),
/* 279 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__ = __webpack_require__(8);










var HelpBlock = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(HelpBlock, _React$Component);

  function HelpBlock() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, HelpBlock);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  HelpBlock.prototype.render = function render() {
    var _props = this.props,
        className = _props.className,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['className']);

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["f" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["d" /* getClassSet */])(bsProps);

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('span', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, elementProps, {
      className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, classes)
    }));
  };

  return HelpBlock;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["a" /* bsClass */])('help-block', HelpBlock));

/***/ }),
/* 280 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__ = __webpack_require__(8);











var propTypes = {
  /**
   * Sets image as responsive image
   */
  responsive: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,

  /**
   * Sets image shape as rounded
   */
  rounded: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,

  /**
   * Sets image shape as circle
   */
  circle: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,

  /**
   * Sets image shape as thumbnail
   */
  thumbnail: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool
};

var defaultProps = {
  responsive: false,
  rounded: false,
  circle: false,
  thumbnail: false
};

var Image = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Image, _React$Component);

  function Image() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, Image);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  Image.prototype.render = function render() {
    var _classes;

    var _props = this.props,
        responsive = _props.responsive,
        rounded = _props.rounded,
        circle = _props.circle,
        thumbnail = _props.thumbnail,
        className = _props.className,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['responsive', 'rounded', 'circle', 'thumbnail', 'className']);

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["f" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = (_classes = {}, _classes[Object(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["e" /* prefix */])(bsProps, 'responsive')] = responsive, _classes[Object(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["e" /* prefix */])(bsProps, 'rounded')] = rounded, _classes[Object(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["e" /* prefix */])(bsProps, 'circle')] = circle, _classes[Object(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["e" /* prefix */])(bsProps, 'thumbnail')] = thumbnail, _classes);

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('img', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, elementProps, {
      className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, classes)
    }));
  };

  return Image;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

Image.propTypes = propTypes;
Image.defaultProps = defaultProps;

/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["a" /* bsClass */])('img', Image));

/***/ }),
/* 281 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__InputGroupAddon__ = __webpack_require__(282);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__InputGroupButton__ = __webpack_require__(283);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_StyleConfig__ = __webpack_require__(15);













var InputGroup = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(InputGroup, _React$Component);

  function InputGroup() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, InputGroup);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  InputGroup.prototype.render = function render() {
    var _props = this.props,
        className = _props.className,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['className']);

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["f" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = Object(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["d" /* getClassSet */])(bsProps);

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('span', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, elementProps, {
      className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, classes)
    }));
  };

  return InputGroup;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

InputGroup.Addon = __WEBPACK_IMPORTED_MODULE_7__InputGroupAddon__["a" /* default */];
InputGroup.Button = __WEBPACK_IMPORTED_MODULE_8__InputGroupButton__["a" /* default */];

/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["a" /* bsClass */])('input-group', Object(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["b" /* bsSizes */])([__WEBPACK_IMPORTED_MODULE_10__utils_StyleConfig__["c" /* Size */].LARGE, __WEBPACK_IMPORTED_MODULE_10__utils_StyleConfig__["c" /* Size */].SMALL], InputGroup)));

/***/ }),
/* 282 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__ = __webpack_require__(8);










var InputGroupAddon = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(InputGroupAddon, _React$Component);

  function InputGroupAddon() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, InputGroupAddon);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  InputGroupAddon.prototype.render = function render() {
    var _props = this.props,
        className = _props.className,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['className']);

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["f" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["d" /* getClassSet */])(bsProps);

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('span', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, elementProps, {
      className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, classes)
    }));
  };

  return InputGroupAddon;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["a" /* bsClass */])('input-group-addon', InputGroupAddon));

/***/ }),
/* 283 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__ = __webpack_require__(8);










var InputGroupButton = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(InputGroupButton, _React$Component);

  function InputGroupButton() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, InputGroupButton);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  InputGroupButton.prototype.render = function render() {
    var _props = this.props,
        className = _props.className,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['className']);

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["f" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["d" /* getClassSet */])(bsProps);

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('span', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, elementProps, {
      className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, classes)
    }));
  };

  return InputGroupButton;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["a" /* bsClass */])('input-group-btn', InputGroupButton));

/***/ }),
/* 284 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_elementType__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_elementType___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_elementType__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__ = __webpack_require__(8);











var propTypes = {
  componentClass: __WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_elementType___default.a
};

var defaultProps = {
  componentClass: 'div'
};

var Jumbotron = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Jumbotron, _React$Component);

  function Jumbotron() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, Jumbotron);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  Jumbotron.prototype.render = function render() {
    var _props = this.props,
        Component = _props.componentClass,
        className = _props.className,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['componentClass', 'className']);

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["f" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = Object(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["d" /* getClassSet */])(bsProps);

    return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(Component, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, elementProps, {
      className: __WEBPACK_IMPORTED_MODULE_6_classnames___default()(className, classes)
    }));
  };

  return Jumbotron;
}(__WEBPACK_IMPORTED_MODULE_5_react___default.a.Component);

Jumbotron.propTypes = propTypes;
Jumbotron.defaultProps = defaultProps;

/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["a" /* bsClass */])('jumbotron', Jumbotron));

/***/ }),
/* 285 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_StyleConfig__ = __webpack_require__(15);












var Label = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(Label, _React$Component);

  function Label() {
    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, Label);

    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  Label.prototype.hasContent = function hasContent(children) {
    var result = false;

    __WEBPACK_IMPORTED_MODULE_7_react___default.a.Children.forEach(children, function (child) {
      if (result) {
        return;
      }

      if (child || child === 0) {
        result = true;
      }
    });

    return result;
  };

  Label.prototype.render = function render() {
    var _props = this.props,
        className = _props.className,
        children = _props.children,
        props = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['className', 'children']);

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["f" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["d" /* getClassSet */])(bsProps), {

      // Hack for collapsing on IE8.
      hidden: !this.hasContent(children)
    });

    return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
      'span',
      __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, elementProps, {
        className: __WEBPACK_IMPORTED_MODULE_6_classnames___default()(className, classes)
      }),
      children
    );
  };

  return Label;
}(__WEBPACK_IMPORTED_MODULE_7_react___default.a.Component);

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["a" /* bsClass */])('label', Object(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["c" /* bsStyles */])([].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default()(__WEBPACK_IMPORTED_MODULE_9__utils_StyleConfig__["d" /* State */]), [__WEBPACK_IMPORTED_MODULE_9__utils_StyleConfig__["e" /* Style */].DEFAULT, __WEBPACK_IMPORTED_MODULE_9__utils_StyleConfig__["e" /* Style */].PRIMARY]), __WEBPACK_IMPORTED_MODULE_9__utils_StyleConfig__["e" /* Style */].DEFAULT, Label)));

/***/ }),
/* 286 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_elementType__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_elementType___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_elementType__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ListGroupItem__ = __webpack_require__(137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_ValidComponentChildren__ = __webpack_require__(18);













var propTypes = {
  /**
   * You can use a custom element type for this component.
   *
   * If not specified, it will be treated as `'li'` if every child is a
   * non-actionable `<ListGroupItem>`, and `'div'` otherwise.
   */
  componentClass: __WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_elementType___default.a
};

function getDefaultComponent(children) {
  if (!children) {
    // FIXME: This is the old behavior. Is this right?
    return 'div';
  }

  if (__WEBPACK_IMPORTED_MODULE_10__utils_ValidComponentChildren__["a" /* default */].some(children, function (child) {
    return child.type !== __WEBPACK_IMPORTED_MODULE_8__ListGroupItem__["a" /* default */] || child.props.href || child.props.onClick;
  })) {
    return 'div';
  }

  return 'ul';
}

var ListGroup = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(ListGroup, _React$Component);

  function ListGroup() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, ListGroup);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  ListGroup.prototype.render = function render() {
    var _props = this.props,
        children = _props.children,
        _props$componentClass = _props.componentClass,
        Component = _props$componentClass === undefined ? getDefaultComponent(children) : _props$componentClass,
        className = _props.className,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['children', 'componentClass', 'className']);

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["f" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = Object(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["d" /* getClassSet */])(bsProps);

    var useListItem = Component === 'ul' && __WEBPACK_IMPORTED_MODULE_10__utils_ValidComponentChildren__["a" /* default */].every(children, function (child) {
      return child.type === __WEBPACK_IMPORTED_MODULE_8__ListGroupItem__["a" /* default */];
    });

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
      Component,
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, elementProps, {
        className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, classes)
      }),
      useListItem ? __WEBPACK_IMPORTED_MODULE_10__utils_ValidComponentChildren__["a" /* default */].map(children, function (child) {
        return Object(__WEBPACK_IMPORTED_MODULE_6_react__["cloneElement"])(child, { listItem: true });
      }) : children
    );
  };

  return ListGroup;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

ListGroup.propTypes = propTypes;

/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["a" /* bsClass */])('list-group', ListGroup));

/***/ }),
/* 287 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_elementType__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_elementType___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_elementType__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__ = __webpack_require__(8);











var propTypes = {
  componentClass: __WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_elementType___default.a
};

var defaultProps = {
  componentClass: 'div'
};

var MediaBody = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(MediaBody, _React$Component);

  function MediaBody() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, MediaBody);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  MediaBody.prototype.render = function render() {
    var _props = this.props,
        Component = _props.componentClass,
        className = _props.className,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['componentClass', 'className']);

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["f" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = Object(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["d" /* getClassSet */])(bsProps);

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Component, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, elementProps, {
      className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, classes)
    }));
  };

  return MediaBody;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

MediaBody.propTypes = propTypes;
MediaBody.defaultProps = defaultProps;

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["a" /* bsClass */])('media-body', MediaBody));

/***/ }),
/* 288 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_elementType__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_elementType___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_elementType__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__ = __webpack_require__(8);











var propTypes = {
  componentClass: __WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_elementType___default.a
};

var defaultProps = {
  componentClass: 'h4'
};

var MediaHeading = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(MediaHeading, _React$Component);

  function MediaHeading() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, MediaHeading);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  MediaHeading.prototype.render = function render() {
    var _props = this.props,
        Component = _props.componentClass,
        className = _props.className,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['componentClass', 'className']);

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["f" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = Object(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["d" /* getClassSet */])(bsProps);

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Component, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, elementProps, {
      className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, classes)
    }));
  };

  return MediaHeading;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

MediaHeading.propTypes = propTypes;
MediaHeading.defaultProps = defaultProps;

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["a" /* bsClass */])('media-heading', MediaHeading));

/***/ }),
/* 289 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Media__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__ = __webpack_require__(8);












var propTypes = {
  /**
   * Align the media to the top, middle, or bottom of the media object.
   */
  align: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.oneOf(['top', 'middle', 'bottom'])
};

var MediaLeft = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(MediaLeft, _React$Component);

  function MediaLeft() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, MediaLeft);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  MediaLeft.prototype.render = function render() {
    var _props = this.props,
        align = _props.align,
        className = _props.className,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['align', 'className']);

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["f" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = Object(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["d" /* getClassSet */])(bsProps);

    if (align) {
      // The class is e.g. `media-top`, not `media-left-top`.
      classes[Object(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["e" /* prefix */])(__WEBPACK_IMPORTED_MODULE_8__Media__["a" /* default */].defaultProps, align)] = true;
    }

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('div', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, elementProps, {
      className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, classes)
    }));
  };

  return MediaLeft;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

MediaLeft.propTypes = propTypes;

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["a" /* bsClass */])('media-left', MediaLeft));

/***/ }),
/* 290 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__ = __webpack_require__(8);










var MediaList = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(MediaList, _React$Component);

  function MediaList() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, MediaList);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  MediaList.prototype.render = function render() {
    var _props = this.props,
        className = _props.className,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['className']);

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["f" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["d" /* getClassSet */])(bsProps);

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('ul', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, elementProps, {
      className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, classes)
    }));
  };

  return MediaList;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["a" /* bsClass */])('media-list', MediaList));

/***/ }),
/* 291 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__ = __webpack_require__(8);










var MediaListItem = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(MediaListItem, _React$Component);

  function MediaListItem() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, MediaListItem);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  MediaListItem.prototype.render = function render() {
    var _props = this.props,
        className = _props.className,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['className']);

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["f" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["d" /* getClassSet */])(bsProps);

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('li', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, elementProps, {
      className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, classes)
    }));
  };

  return MediaListItem;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["a" /* bsClass */])('media', MediaListItem));

/***/ }),
/* 292 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Media__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__ = __webpack_require__(8);












var propTypes = {
  /**
   * Align the media to the top, middle, or bottom of the media object.
   */
  align: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.oneOf(['top', 'middle', 'bottom'])
};

var MediaRight = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(MediaRight, _React$Component);

  function MediaRight() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, MediaRight);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  MediaRight.prototype.render = function render() {
    var _props = this.props,
        align = _props.align,
        className = _props.className,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['align', 'className']);

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["f" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = Object(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["d" /* getClassSet */])(bsProps);

    if (align) {
      // The class is e.g. `media-top`, not `media-right-top`.
      classes[Object(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["e" /* prefix */])(__WEBPACK_IMPORTED_MODULE_8__Media__["a" /* default */].defaultProps, align)] = true;
    }

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('div', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, elementProps, {
      className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, classes)
    }));
  };

  return MediaRight;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

MediaRight.propTypes = propTypes;

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["a" /* bsClass */])('media-right', MediaRight));

/***/ }),
/* 293 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types_extra_lib_all__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types_extra_lib_all___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_prop_types_extra_lib_all__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__SafeAnchor__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_bootstrapUtils__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils_createChainedFunction__ = __webpack_require__(12);














var propTypes = {
  /**
   * Highlight the menu item as active.
   */
  active: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,

  /**
   * Disable the menu item, making it unselectable.
   */
  disabled: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,

  /**
   * Styles the menu item as a horizontal rule, providing visual separation between
   * groups of menu items.
   */
  divider: __WEBPACK_IMPORTED_MODULE_8_prop_types_extra_lib_all___default()(__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool, function (_ref) {
    var divider = _ref.divider,
        children = _ref.children;
    return divider && children ? new Error('Children will not be rendered for dividers') : null;
  }),

  /**
   * Value passed to the `onSelect` handler, useful for identifying the selected menu item.
   */
  eventKey: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.any,

  /**
   * Styles the menu item as a header label, useful for describing a group of menu items.
   */
  header: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,

  /**
   * HTML `href` attribute corresponding to `a.href`.
   */
  href: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string,

  /**
   * Callback fired when the menu item is clicked.
   */
  onClick: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,

  /**
   * Callback fired when the menu item is selected.
   *
   * ```js
   * (eventKey: any, event: Object) => any
   * ```
   */
  onSelect: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func
};

var defaultProps = {
  divider: false,
  disabled: false,
  header: false
};

var MenuItem = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(MenuItem, _React$Component);

  function MenuItem(props, context) {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, MenuItem);

    var _this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props, context));

    _this.handleClick = _this.handleClick.bind(_this);
    return _this;
  }

  MenuItem.prototype.handleClick = function handleClick(event) {
    var _props = this.props,
        href = _props.href,
        disabled = _props.disabled,
        onSelect = _props.onSelect,
        eventKey = _props.eventKey;


    if (!href || disabled) {
      event.preventDefault();
    }

    if (disabled) {
      return;
    }

    if (onSelect) {
      onSelect(eventKey, event);
    }
  };

  MenuItem.prototype.render = function render() {
    var _props2 = this.props,
        active = _props2.active,
        disabled = _props2.disabled,
        divider = _props2.divider,
        header = _props2.header,
        onClick = _props2.onClick,
        className = _props2.className,
        style = _props2.style,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props2, ['active', 'disabled', 'divider', 'header', 'onClick', 'className', 'style']);

    var _splitBsPropsAndOmit = Object(__WEBPACK_IMPORTED_MODULE_10__utils_bootstrapUtils__["g" /* splitBsPropsAndOmit */])(props, ['eventKey', 'onSelect']),
        bsProps = _splitBsPropsAndOmit[0],
        elementProps = _splitBsPropsAndOmit[1];

    if (divider) {
      // Forcibly blank out the children; separators shouldn't render any.
      elementProps.children = undefined;

      return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('li', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, elementProps, {
        role: 'separator',
        className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, 'divider'),
        style: style
      }));
    }

    if (header) {
      return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('li', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, elementProps, {
        role: 'heading',
        className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, Object(__WEBPACK_IMPORTED_MODULE_10__utils_bootstrapUtils__["e" /* prefix */])(bsProps, 'header')),
        style: style
      }));
    }

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
      'li',
      {
        role: 'presentation',
        className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, { active: active, disabled: disabled }),
        style: style
      },
      __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__SafeAnchor__["a" /* default */], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, elementProps, {
        role: 'menuitem',
        tabIndex: '-1',
        onClick: Object(__WEBPACK_IMPORTED_MODULE_11__utils_createChainedFunction__["a" /* default */])(onClick, this.handleClick)
      }))
    );
  };

  return MenuItem;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

MenuItem.propTypes = propTypes;
MenuItem.defaultProps = defaultProps;

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_10__utils_bootstrapUtils__["a" /* bsClass */])('dropdown', MenuItem));

/***/ }),
/* 294 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_dom_helpers_events__ = __webpack_require__(295);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_dom_helpers_events___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_dom_helpers_events__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_dom_helpers_ownerDocument__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_dom_helpers_ownerDocument___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_dom_helpers_ownerDocument__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_dom_helpers_util_inDOM__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_dom_helpers_util_inDOM___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_dom_helpers_util_inDOM__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_dom_helpers_util_scrollbarSize__ = __webpack_require__(138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_dom_helpers_util_scrollbarSize___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_dom_helpers_util_scrollbarSize__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react_dom__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react_overlays_lib_Modal__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react_overlays_lib_Modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_react_overlays_lib_Modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react_overlays_lib_utils_isOverflowing__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react_overlays_lib_utils_isOverflowing___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_react_overlays_lib_utils_isOverflowing__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_prop_types_extra_lib_elementType__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_prop_types_extra_lib_elementType___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_prop_types_extra_lib_elementType__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__Fade__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__ModalBody__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__ModalDialog__ = __webpack_require__(306);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__ModalFooter__ = __webpack_require__(143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__ModalHeader__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__ModalTitle__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__utils_bootstrapUtils__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__utils_createChainedFunction__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__utils_splitComponentProps__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__utils_StyleConfig__ = __webpack_require__(15);




























var propTypes = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_13_react_overlays_lib_Modal___default.a.propTypes, __WEBPACK_IMPORTED_MODULE_18__ModalDialog__["a" /* default */].propTypes, {

  /**
   * Include a backdrop component. Specify 'static' for a backdrop that doesn't
   * trigger an "onHide" when clicked.
   */
  backdrop: __WEBPACK_IMPORTED_MODULE_11_prop_types___default.a.oneOf(['static', true, false]),

  /**
   * Add an optional extra class name to .modal-backdrop
   * It could end up looking like class="modal-backdrop foo-modal-backdrop in".
   */
  backdropClassName: __WEBPACK_IMPORTED_MODULE_11_prop_types___default.a.string,

  /**
   * Close the modal when escape key is pressed
   */
  keyboard: __WEBPACK_IMPORTED_MODULE_11_prop_types___default.a.bool,

  /**
   * Open and close the Modal with a slide and fade animation.
   */
  animation: __WEBPACK_IMPORTED_MODULE_11_prop_types___default.a.bool,

  /**
   * A Component type that provides the modal content Markup. This is a useful
   * prop when you want to use your own styles and markup to create a custom
   * modal component.
   */
  dialogComponentClass: __WEBPACK_IMPORTED_MODULE_15_prop_types_extra_lib_elementType___default.a,

  /**
   * When `true` The modal will automatically shift focus to itself when it
   * opens, and replace it to the last focused element when it closes.
   * Generally this should never be set to false as it makes the Modal less
   * accessible to assistive technologies, like screen-readers.
   */
  autoFocus: __WEBPACK_IMPORTED_MODULE_11_prop_types___default.a.bool,

  /**
   * When `true` The modal will prevent focus from leaving the Modal while
   * open. Consider leaving the default value here, as it is necessary to make
   * the Modal work well with assistive technologies, such as screen readers.
   */
  enforceFocus: __WEBPACK_IMPORTED_MODULE_11_prop_types___default.a.bool,

  /**
   * When `true` The modal will restore focus to previously focused element once
   * modal is hidden
   */
  restoreFocus: __WEBPACK_IMPORTED_MODULE_11_prop_types___default.a.bool,

  /**
   * When `true` The modal will show itself.
   */
  show: __WEBPACK_IMPORTED_MODULE_11_prop_types___default.a.bool,

  /**
   * A callback fired when the header closeButton or non-static backdrop is
   * clicked. Required if either are specified.
   */
  onHide: __WEBPACK_IMPORTED_MODULE_11_prop_types___default.a.func,

  /**
   * Callback fired before the Modal transitions in
   */
  onEnter: __WEBPACK_IMPORTED_MODULE_11_prop_types___default.a.func,

  /**
   * Callback fired as the Modal begins to transition in
   */
  onEntering: __WEBPACK_IMPORTED_MODULE_11_prop_types___default.a.func,

  /**
   * Callback fired after the Modal finishes transitioning in
   */
  onEntered: __WEBPACK_IMPORTED_MODULE_11_prop_types___default.a.func,

  /**
   * Callback fired right before the Modal transitions out
   */
  onExit: __WEBPACK_IMPORTED_MODULE_11_prop_types___default.a.func,

  /**
   * Callback fired as the Modal begins to transition out
   */
  onExiting: __WEBPACK_IMPORTED_MODULE_11_prop_types___default.a.func,

  /**
   * Callback fired after the Modal finishes transitioning out
   */
  onExited: __WEBPACK_IMPORTED_MODULE_11_prop_types___default.a.func,

  /**
   * @private
   */
  container: __WEBPACK_IMPORTED_MODULE_13_react_overlays_lib_Modal___default.a.propTypes.container
});

var defaultProps = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_13_react_overlays_lib_Modal___default.a.defaultProps, {
  animation: true,
  dialogComponentClass: __WEBPACK_IMPORTED_MODULE_18__ModalDialog__["a" /* default */]
});

var childContextTypes = {
  $bs_modal: __WEBPACK_IMPORTED_MODULE_11_prop_types___default.a.shape({
    onHide: __WEBPACK_IMPORTED_MODULE_11_prop_types___default.a.func
  })
};

var Modal = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(Modal, _React$Component);

  function Modal(props, context) {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Modal);

    var _this = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props, context));

    _this.handleEntering = _this.handleEntering.bind(_this);
    _this.handleExited = _this.handleExited.bind(_this);
    _this.handleWindowResize = _this.handleWindowResize.bind(_this);
    _this.handleDialogClick = _this.handleDialogClick.bind(_this);

    _this.state = {
      style: {}
    };
    return _this;
  }

  Modal.prototype.getChildContext = function getChildContext() {
    return {
      $bs_modal: {
        onHide: this.props.onHide
      }
    };
  };

  Modal.prototype.componentWillUnmount = function componentWillUnmount() {
    // Clean up the listener if we need to.
    this.handleExited();
  };

  Modal.prototype.handleEntering = function handleEntering() {
    // FIXME: This should work even when animation is disabled.
    __WEBPACK_IMPORTED_MODULE_6_dom_helpers_events___default.a.on(window, 'resize', this.handleWindowResize);
    this.updateStyle();
  };

  Modal.prototype.handleExited = function handleExited() {
    // FIXME: This should work even when animation is disabled.
    __WEBPACK_IMPORTED_MODULE_6_dom_helpers_events___default.a.off(window, 'resize', this.handleWindowResize);
  };

  Modal.prototype.handleWindowResize = function handleWindowResize() {
    this.updateStyle();
  };

  Modal.prototype.handleDialogClick = function handleDialogClick(e) {
    if (e.target !== e.currentTarget) {
      return;
    }

    this.props.onHide();
  };

  Modal.prototype.updateStyle = function updateStyle() {
    if (!__WEBPACK_IMPORTED_MODULE_8_dom_helpers_util_inDOM___default.a) {
      return;
    }

    var dialogNode = this._modal.getDialogElement();
    var dialogHeight = dialogNode.scrollHeight;

    var document = __WEBPACK_IMPORTED_MODULE_7_dom_helpers_ownerDocument___default()(dialogNode);
    var bodyIsOverflowing = __WEBPACK_IMPORTED_MODULE_14_react_overlays_lib_utils_isOverflowing___default()(__WEBPACK_IMPORTED_MODULE_12_react_dom___default.a.findDOMNode(this.props.container || document.body));
    var modalIsOverflowing = dialogHeight > document.documentElement.clientHeight;

    this.setState({
      style: {
        paddingRight: bodyIsOverflowing && !modalIsOverflowing ? __WEBPACK_IMPORTED_MODULE_9_dom_helpers_util_scrollbarSize___default()() : undefined,
        paddingLeft: !bodyIsOverflowing && modalIsOverflowing ? __WEBPACK_IMPORTED_MODULE_9_dom_helpers_util_scrollbarSize___default()() : undefined
      }
    });
  };

  Modal.prototype.render = function render() {
    var _this2 = this;

    var _props = this.props,
        backdrop = _props.backdrop,
        backdropClassName = _props.backdropClassName,
        animation = _props.animation,
        show = _props.show,
        Dialog = _props.dialogComponentClass,
        className = _props.className,
        style = _props.style,
        children = _props.children,
        onEntering = _props.onEntering,
        onExited = _props.onExited,
        props = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['backdrop', 'backdropClassName', 'animation', 'show', 'dialogComponentClass', 'className', 'style', 'children', 'onEntering', 'onExited']);

    var _splitComponentProps = Object(__WEBPACK_IMPORTED_MODULE_24__utils_splitComponentProps__["a" /* default */])(props, __WEBPACK_IMPORTED_MODULE_13_react_overlays_lib_Modal___default.a),
        baseModalProps = _splitComponentProps[0],
        dialogProps = _splitComponentProps[1];

    var inClassName = show && !animation && 'in';

    return __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_13_react_overlays_lib_Modal___default.a,
      __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, baseModalProps, {
        ref: function ref(c) {
          _this2._modal = c;
        },
        show: show,
        onEntering: Object(__WEBPACK_IMPORTED_MODULE_23__utils_createChainedFunction__["a" /* default */])(onEntering, this.handleEntering),
        onExited: Object(__WEBPACK_IMPORTED_MODULE_23__utils_createChainedFunction__["a" /* default */])(onExited, this.handleExited),
        backdrop: backdrop,
        backdropClassName: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(Object(__WEBPACK_IMPORTED_MODULE_22__utils_bootstrapUtils__["e" /* prefix */])(props, 'backdrop'), backdropClassName, inClassName),
        containerClassName: Object(__WEBPACK_IMPORTED_MODULE_22__utils_bootstrapUtils__["e" /* prefix */])(props, 'open'),
        transition: animation ? __WEBPACK_IMPORTED_MODULE_16__Fade__["a" /* default */] : undefined,
        dialogTransitionTimeout: Modal.TRANSITION_DURATION,
        backdropTransitionTimeout: Modal.BACKDROP_TRANSITION_DURATION
      }),
      __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
        Dialog,
        __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, dialogProps, {
          style: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, this.state.style, style),
          className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, inClassName),
          onClick: backdrop === true ? this.handleDialogClick : null
        }),
        children
      )
    );
  };

  return Modal;
}(__WEBPACK_IMPORTED_MODULE_10_react___default.a.Component);

Modal.propTypes = propTypes;
Modal.defaultProps = defaultProps;
Modal.childContextTypes = childContextTypes;

Modal.Body = __WEBPACK_IMPORTED_MODULE_17__ModalBody__["a" /* default */];
Modal.Header = __WEBPACK_IMPORTED_MODULE_20__ModalHeader__["a" /* default */];
Modal.Title = __WEBPACK_IMPORTED_MODULE_21__ModalTitle__["a" /* default */];
Modal.Footer = __WEBPACK_IMPORTED_MODULE_19__ModalFooter__["a" /* default */];

Modal.Dialog = __WEBPACK_IMPORTED_MODULE_18__ModalDialog__["a" /* default */];

Modal.TRANSITION_DURATION = 300;
Modal.BACKDROP_TRANSITION_DURATION = 150;

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_22__utils_bootstrapUtils__["a" /* bsClass */])('modal', Object(__WEBPACK_IMPORTED_MODULE_22__utils_bootstrapUtils__["b" /* bsSizes */])([__WEBPACK_IMPORTED_MODULE_25__utils_StyleConfig__["c" /* Size */].LARGE, __WEBPACK_IMPORTED_MODULE_25__utils_StyleConfig__["c" /* Size */].SMALL], Modal)));

/***/ }),
/* 295 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.listen = exports.filter = exports.off = exports.on = undefined;

var _on = __webpack_require__(59);

var _on2 = _interopRequireDefault(_on);

var _off = __webpack_require__(97);

var _off2 = _interopRequireDefault(_off);

var _filter = __webpack_require__(296);

var _filter2 = _interopRequireDefault(_filter);

var _listen = __webpack_require__(298);

var _listen2 = _interopRequireDefault(_listen);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.on = _on2.default;
exports.off = _off2.default;
exports.filter = _filter2.default;
exports.listen = _listen2.default;
exports.default = { on: _on2.default, off: _off2.default, filter: _filter2.default, listen: _listen2.default };

/***/ }),
/* 296 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = filterEvents;

var _contains = __webpack_require__(38);

var _contains2 = _interopRequireDefault(_contains);

var _querySelectorAll = __webpack_require__(297);

var _querySelectorAll2 = _interopRequireDefault(_querySelectorAll);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function filterEvents(selector, handler) {
  return function filterHandler(e) {
    var top = e.currentTarget,
        target = e.target,
        matches = (0, _querySelectorAll2.default)(top, selector);

    if (matches.some(function (match) {
      return (0, _contains2.default)(match, target);
    })) handler.call(this, e);
  };
}
module.exports = exports['default'];

/***/ }),
/* 297 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = qsa;
// Zepto.js
// (c) 2010-2015 Thomas Fuchs
// Zepto.js may be freely distributed under the MIT license.
var simpleSelectorRE = /^[\w-]*$/;
var toArray = Function.prototype.bind.call(Function.prototype.call, [].slice);

function qsa(element, selector) {
  var maybeID = selector[0] === '#',
      maybeClass = selector[0] === '.',
      nameOnly = maybeID || maybeClass ? selector.slice(1) : selector,
      isSimple = simpleSelectorRE.test(nameOnly),
      found;

  if (isSimple) {
    if (maybeID) {
      element = element.getElementById ? element : document;
      return (found = element.getElementById(nameOnly)) ? [found] : [];
    }

    if (element.getElementsByClassName && maybeClass) return toArray(element.getElementsByClassName(nameOnly));

    return toArray(element.getElementsByTagName(selector));
  }

  return toArray(element.querySelectorAll(selector));
}
module.exports = exports['default'];

/***/ }),
/* 298 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _inDOM = __webpack_require__(23);

var _inDOM2 = _interopRequireDefault(_inDOM);

var _on = __webpack_require__(59);

var _on2 = _interopRequireDefault(_on);

var _off = __webpack_require__(97);

var _off2 = _interopRequireDefault(_off);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var listen = function listen() {};

if (_inDOM2.default) {
  listen = function listen(node, eventName, handler, capture) {
    (0, _on2.default)(node, eventName, handler, capture);
    return function () {
      (0, _off2.default)(node, eventName, handler, capture);
    };
  };
}

exports.default = listen;
module.exports = exports['default'];

/***/ }),
/* 299 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = deprecated;

var _warning = __webpack_require__(11);

var _warning2 = _interopRequireDefault(_warning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var warned = {};

function deprecated(validator, reason) {
  return function validate(props, propName, componentName, location, propFullName) {
    var componentNameSafe = componentName || '<<anonymous>>';
    var propFullNameSafe = propFullName || propName;

    if (props[propName] != null) {
      var messageKey = componentName + '.' + propName;

      (0, _warning2.default)(warned[messageKey], 'The ' + location + ' `' + propFullNameSafe + '` of ' + ('`' + componentNameSafe + '` is deprecated. ' + reason + '.'));

      warned[messageKey] = true;
    }

    for (var _len = arguments.length, args = Array(_len > 5 ? _len - 5 : 0), _key = 5; _key < _len; _key++) {
      args[_key - 5] = arguments[_key];
    }

    return validator.apply(undefined, [props, propName, componentName, location, propFullName].concat(args));
  };
}

/* eslint-disable no-underscore-dangle */
function _resetWarned() {
  warned = {};
}

deprecated._resetWarned = _resetWarned;
/* eslint-enable no-underscore-dangle */

module.exports = exports['default'];

/***/ }),
/* 300 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _class = __webpack_require__(301);

var _class2 = _interopRequireDefault(_class);

var _style = __webpack_require__(58);

var _style2 = _interopRequireDefault(_style);

var _scrollbarSize = __webpack_require__(138);

var _scrollbarSize2 = _interopRequireDefault(_scrollbarSize);

var _isOverflowing = __webpack_require__(141);

var _isOverflowing2 = _interopRequireDefault(_isOverflowing);

var _manageAriaHidden = __webpack_require__(304);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function findIndexOf(arr, cb) {
  var idx = -1;
  arr.some(function (d, i) {
    if (cb(d, i)) {
      idx = i;
      return true;
    }
  });
  return idx;
}

function findContainer(data, modal) {
  return findIndexOf(data, function (d) {
    return d.modals.indexOf(modal) !== -1;
  });
}

function setContainerStyle(state, container) {
  var style = { overflow: 'hidden' };

  // we are only interested in the actual `style` here
  // becasue we will override it
  state.style = {
    overflow: container.style.overflow,
    paddingRight: container.style.paddingRight
  };

  if (state.overflowing) {
    // use computed style, here to get the real padding
    // to add our scrollbar width
    style.paddingRight = parseInt((0, _style2.default)(container, 'paddingRight') || 0, 10) + (0, _scrollbarSize2.default)() + 'px';
  }

  (0, _style2.default)(container, style);
}

function removeContainerStyle(_ref, container) {
  var style = _ref.style;


  Object.keys(style).forEach(function (key) {
    return container.style[key] = style[key];
  });
}
/**
 * Proper state managment for containers and the modals in those containers.
 *
 * @internal Used by the Modal to ensure proper styling of containers.
 */

var ModalManager = function ModalManager() {
  var _this = this;

  var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref2$hideSiblingNode = _ref2.hideSiblingNodes,
      hideSiblingNodes = _ref2$hideSiblingNode === undefined ? true : _ref2$hideSiblingNode,
      _ref2$handleContainer = _ref2.handleContainerOverflow,
      handleContainerOverflow = _ref2$handleContainer === undefined ? true : _ref2$handleContainer;

  _classCallCheck(this, ModalManager);

  this.add = function (modal, container, className) {
    var modalIdx = _this.modals.indexOf(modal);
    var containerIdx = _this.containers.indexOf(container);

    if (modalIdx !== -1) {
      return modalIdx;
    }

    modalIdx = _this.modals.length;
    _this.modals.push(modal);

    if (_this.hideSiblingNodes) {
      (0, _manageAriaHidden.hideSiblings)(container, modal.mountNode);
    }

    if (containerIdx !== -1) {
      _this.data[containerIdx].modals.push(modal);
      return modalIdx;
    }

    var data = {
      modals: [modal],
      //right now only the first modal of a container will have its classes applied
      classes: className ? className.split(/\s+/) : [],

      overflowing: (0, _isOverflowing2.default)(container)
    };

    if (_this.handleContainerOverflow) {
      setContainerStyle(data, container);
    }

    data.classes.forEach(_class2.default.addClass.bind(null, container));

    _this.containers.push(container);
    _this.data.push(data);

    return modalIdx;
  };

  this.remove = function (modal) {
    var modalIdx = _this.modals.indexOf(modal);

    if (modalIdx === -1) {
      return;
    }

    var containerIdx = findContainer(_this.data, modal);
    var data = _this.data[containerIdx];
    var container = _this.containers[containerIdx];

    data.modals.splice(data.modals.indexOf(modal), 1);

    _this.modals.splice(modalIdx, 1);

    // if that was the last modal in a container,
    // clean up the container
    if (data.modals.length === 0) {
      data.classes.forEach(_class2.default.removeClass.bind(null, container));

      if (_this.handleContainerOverflow) {
        removeContainerStyle(data, container);
      }

      if (_this.hideSiblingNodes) {
        (0, _manageAriaHidden.showSiblings)(container, modal.mountNode);
      }
      _this.containers.splice(containerIdx, 1);
      _this.data.splice(containerIdx, 1);
    } else if (_this.hideSiblingNodes) {
      //otherwise make sure the next top modal is visible to a SR
      (0, _manageAriaHidden.ariaHidden)(false, data.modals[data.modals.length - 1].mountNode);
    }
  };

  this.isTopModal = function (modal) {
    return !!_this.modals.length && _this.modals[_this.modals.length - 1] === modal;
  };

  this.hideSiblingNodes = hideSiblingNodes;
  this.handleContainerOverflow = handleContainerOverflow;
  this.modals = [];
  this.containers = [];
  this.data = [];
};

exports.default = ModalManager;
module.exports = exports['default'];

/***/ }),
/* 301 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.hasClass = exports.removeClass = exports.addClass = undefined;

var _addClass = __webpack_require__(302);

var _addClass2 = _interopRequireDefault(_addClass);

var _removeClass = __webpack_require__(303);

var _removeClass2 = _interopRequireDefault(_removeClass);

var _hasClass = __webpack_require__(140);

var _hasClass2 = _interopRequireDefault(_hasClass);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.addClass = _addClass2.default;
exports.removeClass = _removeClass2.default;
exports.hasClass = _hasClass2.default;
exports.default = { addClass: _addClass2.default, removeClass: _removeClass2.default, hasClass: _hasClass2.default };

/***/ }),
/* 302 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = addClass;

var _hasClass = __webpack_require__(140);

var _hasClass2 = _interopRequireDefault(_hasClass);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function addClass(element, className) {
  if (element.classList) element.classList.add(className);else if (!(0, _hasClass2.default)(element)) element.className = element.className + ' ' + className;
}
module.exports = exports['default'];

/***/ }),
/* 303 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function removeClass(element, className) {
  if (element.classList) element.classList.remove(className);else element.className = element.className.replace(new RegExp('(^|\\s)' + className + '(?:\\s|$)', 'g'), '$1').replace(/\s+/g, ' ').replace(/^\s*|\s*$/g, '');
};

/***/ }),
/* 304 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.ariaHidden = ariaHidden;
exports.hideSiblings = hideSiblings;
exports.showSiblings = showSiblings;

var BLACKLIST = ['template', 'script', 'style'];

var isHidable = function isHidable(_ref) {
  var nodeType = _ref.nodeType,
      tagName = _ref.tagName;
  return nodeType === 1 && BLACKLIST.indexOf(tagName.toLowerCase()) === -1;
};

var siblings = function siblings(container, mount, cb) {
  mount = [].concat(mount);

  [].forEach.call(container.children, function (node) {
    if (mount.indexOf(node) === -1 && isHidable(node)) {
      cb(node);
    }
  });
};

function ariaHidden(show, node) {
  if (!node) {
    return;
  }
  if (show) {
    node.setAttribute('aria-hidden', 'true');
  } else {
    node.removeAttribute('aria-hidden');
  }
}

function hideSiblings(container, mountNode) {
  siblings(container, mountNode, function (node) {
    return ariaHidden(true, node);
  });
}

function showSiblings(container, mountNode) {
  siblings(container, mountNode, function (node) {
    return ariaHidden(false, node);
  });
}

/***/ }),
/* 305 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = addFocusListener;
/**
 * Firefox doesn't have a focusin event so using capture is easiest way to get bubbling
 * IE8 can't do addEventListener, but does have onfocusin, so we use that in ie8
 *
 * We only allow one Listener at a time to avoid stack overflows
 */
function addFocusListener(handler) {
  var useFocusin = !document.addEventListener;
  var remove = void 0;

  if (useFocusin) {
    document.attachEvent('onfocusin', handler);
    remove = function remove() {
      return document.detachEvent('onfocusin', handler);
    };
  } else {
    document.addEventListener('focus', handler, true);
    remove = function remove() {
      return document.removeEventListener('focus', handler, true);
    };
  }

  return { remove: remove };
}
module.exports = exports['default'];

/***/ }),
/* 306 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_StyleConfig__ = __webpack_require__(15);












var propTypes = {
  /**
   * A css class to apply to the Modal dialog DOM node.
   */
  dialogClassName: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string
};

var ModalDialog = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(ModalDialog, _React$Component);

  function ModalDialog() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, ModalDialog);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  ModalDialog.prototype.render = function render() {
    var _extends2;

    var _props = this.props,
        dialogClassName = _props.dialogClassName,
        className = _props.className,
        style = _props.style,
        children = _props.children,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['dialogClassName', 'className', 'style', 'children']);

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["f" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var bsClassName = Object(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["e" /* prefix */])(bsProps);

    var modalStyle = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({ display: 'block' }, style);

    var dialogClasses = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["d" /* getClassSet */])(bsProps), (_extends2 = {}, _extends2[bsClassName] = false, _extends2[Object(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["e" /* prefix */])(bsProps, 'dialog')] = true, _extends2));

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
      'div',
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, elementProps, {
        tabIndex: '-1',
        role: 'dialog',
        style: modalStyle,
        className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, bsClassName)
      }),
      __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        'div',
        { className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(dialogClassName, dialogClasses) },
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          'div',
          { className: Object(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["e" /* prefix */])(bsProps, 'content'), role: 'document' },
          children
        )
      )
    );
  };

  return ModalDialog;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

ModalDialog.propTypes = propTypes;

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["a" /* bsClass */])('modal', Object(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["b" /* bsSizes */])([__WEBPACK_IMPORTED_MODULE_9__utils_StyleConfig__["c" /* Size */].LARGE, __WEBPACK_IMPORTED_MODULE_9__utils_StyleConfig__["c" /* Size */].SMALL], ModalDialog)));

/***/ }),
/* 307 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types_extra_lib_elementType__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types_extra_lib_elementType___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_prop_types_extra_lib_elementType__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_uncontrollable__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_uncontrollable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_uncontrollable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Grid__ = __webpack_require__(136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__NavbarBrand__ = __webpack_require__(147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__NavbarCollapse__ = __webpack_require__(308);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__NavbarHeader__ = __webpack_require__(309);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__NavbarToggle__ = __webpack_require__(310);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__utils_bootstrapUtils__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__utils_StyleConfig__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__utils_createChainedFunction__ = __webpack_require__(12);





// TODO: Remove this pragma once we upgrade eslint-config-airbnb.
/* eslint-disable react/no-multi-comp */
















var propTypes = {
  /**
   * Create a fixed navbar along the top of the screen, that scrolls with the
   * page
   */
  fixedTop: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  /**
   * Create a fixed navbar along the bottom of the screen, that scrolls with
   * the page
   */
  fixedBottom: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  /**
   * Create a full-width navbar that scrolls away with the page
   */
  staticTop: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  /**
   * An alternative dark visual style for the Navbar
   */
  inverse: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  /**
   * Allow the Navbar to fluidly adjust to the page or container width, instead
   * of at the predefined screen breakpoints
   */
  fluid: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,

  /**
   * Set a custom element for this component.
   */
  componentClass: __WEBPACK_IMPORTED_MODULE_8_prop_types_extra_lib_elementType___default.a,
  /**
   * A callback fired when the `<Navbar>` body collapses or expands. Fired when
   * a `<Navbar.Toggle>` is clicked and called with the new `navExpanded`
   * boolean value.
   *
   * @controllable navExpanded
   */
  onToggle: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
  /**
   * A callback fired when a descendant of a child `<Nav>` is selected. Should
   * be used to execute complex closing or other miscellaneous actions desired
   * after selecting a descendant of `<Nav>`. Does nothing if no `<Nav>` or `<Nav>`
   * descendants exist. The callback is called with an eventKey, which is a
   * prop from the selected `<Nav>` descendant, and an event.
   *
   * ```js
   * function (
   * 	Any eventKey,
   * 	SyntheticEvent event?
   * )
   * ```
   *
   * For basic closing behavior after all `<Nav>` descendant onSelect events in
   * mobile viewports, try using collapseOnSelect.
   *
   * Note: If you are manually closing the navbar using this `OnSelect` prop,
   * ensure that you are setting `expanded` to false and not *toggling* between
   * true and false.
   */
  onSelect: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
  /**
   * Sets `expanded` to `false` after the onSelect event of a descendant of a
   * child `<Nav>`. Does nothing if no `<Nav>` or `<Nav>` descendants exist.
   *
   * The onSelect callback should be used instead for more complex operations
   * that need to be executed after the `select` event of `<Nav>` descendants.
   */
  collapseOnSelect: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  /**
   * Explicitly set the visiblity of the navbar body
   *
   * @controllable onToggle
   */
  expanded: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,

  role: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string
};

var defaultProps = {
  componentClass: 'nav',
  fixedTop: false,
  fixedBottom: false,
  staticTop: false,
  inverse: false,
  fluid: false,
  collapseOnSelect: false
};

var childContextTypes = {
  $bs_navbar: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.shape({
    bsClass: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string,
    expanded: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
    onToggle: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func.isRequired,
    onSelect: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func
  })
};

var Navbar = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Navbar, _React$Component);

  function Navbar(props, context) {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, Navbar);

    var _this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props, context));

    _this.handleToggle = _this.handleToggle.bind(_this);
    _this.handleCollapse = _this.handleCollapse.bind(_this);
    return _this;
  }

  Navbar.prototype.getChildContext = function getChildContext() {
    var _props = this.props,
        bsClass = _props.bsClass,
        expanded = _props.expanded,
        onSelect = _props.onSelect,
        collapseOnSelect = _props.collapseOnSelect;


    return {
      $bs_navbar: {
        bsClass: bsClass,
        expanded: expanded,
        onToggle: this.handleToggle,
        onSelect: Object(__WEBPACK_IMPORTED_MODULE_17__utils_createChainedFunction__["a" /* default */])(onSelect, collapseOnSelect ? this.handleCollapse : null)
      }
    };
  };

  Navbar.prototype.handleCollapse = function handleCollapse() {
    var _props2 = this.props,
        onToggle = _props2.onToggle,
        expanded = _props2.expanded;


    if (expanded) {
      onToggle(false);
    }
  };

  Navbar.prototype.handleToggle = function handleToggle() {
    var _props3 = this.props,
        onToggle = _props3.onToggle,
        expanded = _props3.expanded;


    onToggle(!expanded);
  };

  Navbar.prototype.render = function render() {
    var _extends2;

    var _props4 = this.props,
        Component = _props4.componentClass,
        fixedTop = _props4.fixedTop,
        fixedBottom = _props4.fixedBottom,
        staticTop = _props4.staticTop,
        inverse = _props4.inverse,
        fluid = _props4.fluid,
        className = _props4.className,
        children = _props4.children,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props4, ['componentClass', 'fixedTop', 'fixedBottom', 'staticTop', 'inverse', 'fluid', 'className', 'children']);

    var _splitBsPropsAndOmit = Object(__WEBPACK_IMPORTED_MODULE_15__utils_bootstrapUtils__["g" /* splitBsPropsAndOmit */])(props, ['expanded', 'onToggle', 'onSelect', 'collapseOnSelect']),
        bsProps = _splitBsPropsAndOmit[0],
        elementProps = _splitBsPropsAndOmit[1];

    // will result in some false positives but that seems better
    // than false negatives. strict `undefined` check allows explicit
    // "nulling" of the role if the user really doesn't want one


    if (elementProps.role === undefined && Component !== 'nav') {
      elementProps.role = 'navigation';
    }

    if (inverse) {
      bsProps.bsStyle = __WEBPACK_IMPORTED_MODULE_16__utils_StyleConfig__["e" /* Style */].INVERSE;
    }

    var classes = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_15__utils_bootstrapUtils__["d" /* getClassSet */])(bsProps), (_extends2 = {}, _extends2[Object(__WEBPACK_IMPORTED_MODULE_15__utils_bootstrapUtils__["e" /* prefix */])(bsProps, 'fixed-top')] = fixedTop, _extends2[Object(__WEBPACK_IMPORTED_MODULE_15__utils_bootstrapUtils__["e" /* prefix */])(bsProps, 'fixed-bottom')] = fixedBottom, _extends2[Object(__WEBPACK_IMPORTED_MODULE_15__utils_bootstrapUtils__["e" /* prefix */])(bsProps, 'static-top')] = staticTop, _extends2));

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
      Component,
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, elementProps, {
        className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, classes)
      }),
      __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_10__Grid__["a" /* default */],
        { fluid: fluid },
        children
      )
    );
  };

  return Navbar;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

Navbar.propTypes = propTypes;
Navbar.defaultProps = defaultProps;
Navbar.childContextTypes = childContextTypes;

Object(__WEBPACK_IMPORTED_MODULE_15__utils_bootstrapUtils__["a" /* bsClass */])('navbar', Navbar);

var UncontrollableNavbar = __WEBPACK_IMPORTED_MODULE_9_uncontrollable___default()(Navbar, { expanded: 'onToggle' });

function createSimpleWrapper(tag, suffix, displayName) {
  var Wrapper = function Wrapper(_ref, _ref2) {
    var _ref2$$bs_navbar = _ref2.$bs_navbar,
        navbarProps = _ref2$$bs_navbar === undefined ? { bsClass: 'navbar' } : _ref2$$bs_navbar;

    var Component = _ref.componentClass,
        className = _ref.className,
        pullRight = _ref.pullRight,
        pullLeft = _ref.pullLeft,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_ref, ['componentClass', 'className', 'pullRight', 'pullLeft']);

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Component, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, props, {
      className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, Object(__WEBPACK_IMPORTED_MODULE_15__utils_bootstrapUtils__["e" /* prefix */])(navbarProps, suffix), pullRight && Object(__WEBPACK_IMPORTED_MODULE_15__utils_bootstrapUtils__["e" /* prefix */])(navbarProps, 'right'), pullLeft && Object(__WEBPACK_IMPORTED_MODULE_15__utils_bootstrapUtils__["e" /* prefix */])(navbarProps, 'left'))
    }));
  };

  Wrapper.displayName = displayName;

  Wrapper.propTypes = {
    componentClass: __WEBPACK_IMPORTED_MODULE_8_prop_types_extra_lib_elementType___default.a,
    pullRight: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
    pullLeft: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool
  };

  Wrapper.defaultProps = {
    componentClass: tag,
    pullRight: false,
    pullLeft: false
  };

  Wrapper.contextTypes = {
    $bs_navbar: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.shape({
      bsClass: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string
    })
  };

  return Wrapper;
}

UncontrollableNavbar.Brand = __WEBPACK_IMPORTED_MODULE_11__NavbarBrand__["a" /* default */];
UncontrollableNavbar.Header = __WEBPACK_IMPORTED_MODULE_13__NavbarHeader__["a" /* default */];
UncontrollableNavbar.Toggle = __WEBPACK_IMPORTED_MODULE_14__NavbarToggle__["a" /* default */];
UncontrollableNavbar.Collapse = __WEBPACK_IMPORTED_MODULE_12__NavbarCollapse__["a" /* default */];

UncontrollableNavbar.Form = createSimpleWrapper('div', 'form', 'NavbarForm');
UncontrollableNavbar.Text = createSimpleWrapper('p', 'text', 'NavbarText');
UncontrollableNavbar.Link = createSimpleWrapper('a', 'link', 'NavbarLink');

// Set bsStyles here so they can be overridden.
/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_15__utils_bootstrapUtils__["c" /* bsStyles */])([__WEBPACK_IMPORTED_MODULE_16__utils_StyleConfig__["e" /* Style */].DEFAULT, __WEBPACK_IMPORTED_MODULE_16__utils_StyleConfig__["e" /* Style */].INVERSE], __WEBPACK_IMPORTED_MODULE_16__utils_StyleConfig__["e" /* Style */].DEFAULT, UncontrollableNavbar));

/***/ }),
/* 308 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Collapse__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__ = __webpack_require__(8);











var contextTypes = {
  $bs_navbar: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.shape({
    bsClass: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
    expanded: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool
  })
};

var NavbarCollapse = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(NavbarCollapse, _React$Component);

  function NavbarCollapse() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, NavbarCollapse);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  NavbarCollapse.prototype.render = function render() {
    var _props = this.props,
        children = _props.children,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['children']);

    var navbarProps = this.context.$bs_navbar || { bsClass: 'navbar' };

    var bsClassName = Object(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["e" /* prefix */])(navbarProps, 'collapse');

    return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_7__Collapse__["a" /* default */],
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({ 'in': navbarProps.expanded }, props),
      __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        'div',
        { className: bsClassName },
        children
      )
    );
  };

  return NavbarCollapse;
}(__WEBPACK_IMPORTED_MODULE_5_react___default.a.Component);

NavbarCollapse.contextTypes = contextTypes;

/* harmony default export */ __webpack_exports__["a"] = (NavbarCollapse);

/***/ }),
/* 309 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__ = __webpack_require__(8);











var contextTypes = {
  $bs_navbar: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.shape({
    bsClass: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string
  })
};

var NavbarHeader = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(NavbarHeader, _React$Component);

  function NavbarHeader() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, NavbarHeader);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  NavbarHeader.prototype.render = function render() {
    var _props = this.props,
        className = _props.className,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['className']);

    var navbarProps = this.context.$bs_navbar || { bsClass: 'navbar' };

    var bsClassName = Object(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["e" /* prefix */])(navbarProps, 'header');

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('div', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, props, { className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, bsClassName) }));
  };

  return NavbarHeader;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

NavbarHeader.contextTypes = contextTypes;

/* harmony default export */ __webpack_exports__["a"] = (NavbarHeader);

/***/ }),
/* 310 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_createChainedFunction__ = __webpack_require__(12);












var propTypes = {
  onClick: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
  /**
   * The toggle content, if left empty it will render the default toggle (seen above).
   */
  children: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.node
};

var contextTypes = {
  $bs_navbar: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.shape({
    bsClass: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string,
    expanded: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
    onToggle: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func.isRequired
  })
};

var NavbarToggle = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(NavbarToggle, _React$Component);

  function NavbarToggle() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, NavbarToggle);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  NavbarToggle.prototype.render = function render() {
    var _props = this.props,
        onClick = _props.onClick,
        className = _props.className,
        children = _props.children,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['onClick', 'className', 'children']);

    var navbarProps = this.context.$bs_navbar || { bsClass: 'navbar' };

    var buttonProps = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
      type: 'button'
    }, props, {
      onClick: Object(__WEBPACK_IMPORTED_MODULE_9__utils_createChainedFunction__["a" /* default */])(onClick, navbarProps.onToggle),
      className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, Object(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["e" /* prefix */])(navbarProps, 'toggle'), !navbarProps.expanded && 'collapsed')
    });

    if (children) {
      return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        'button',
        buttonProps,
        children
      );
    }

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
      'button',
      buttonProps,
      __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        'span',
        { className: 'sr-only' },
        'Toggle navigation'
      ),
      __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('span', { className: 'icon-bar' }),
      __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('span', { className: 'icon-bar' }),
      __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('span', { className: 'icon-bar' })
    );
  };

  return NavbarToggle;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

NavbarToggle.propTypes = propTypes;
NavbarToggle.contextTypes = contextTypes;

/* harmony default export */ __webpack_exports__["a"] = (NavbarToggle);

/***/ }),
/* 311 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Dropdown__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_splitComponentProps__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_ValidComponentChildren__ = __webpack_require__(18);













var propTypes = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_8__Dropdown__["a" /* default */].propTypes, {

  // Toggle props.
  title: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.node.isRequired,
  noCaret: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  active: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,

  // Override generated docs from <Dropdown>.
  /**
   * @private
   */
  children: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.node
});

var NavDropdown = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(NavDropdown, _React$Component);

  function NavDropdown() {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, NavDropdown);

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  NavDropdown.prototype.isActive = function isActive(_ref, activeKey, activeHref) {
    var props = _ref.props;

    var _this2 = this;

    if (props.active || activeKey != null && props.eventKey === activeKey || activeHref && props.href === activeHref) {
      return true;
    }

    if (__WEBPACK_IMPORTED_MODULE_10__utils_ValidComponentChildren__["a" /* default */].some(props.children, function (child) {
      return _this2.isActive(child, activeKey, activeHref);
    })) {
      return true;
    }

    return props.active;
  };

  NavDropdown.prototype.render = function render() {
    var _this3 = this;

    var _props = this.props,
        title = _props.title,
        activeKey = _props.activeKey,
        activeHref = _props.activeHref,
        className = _props.className,
        style = _props.style,
        children = _props.children,
        props = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['title', 'activeKey', 'activeHref', 'className', 'style', 'children']);

    var active = this.isActive(this, activeKey, activeHref);
    delete props.active; // Accessed via this.isActive().
    delete props.eventKey; // Accessed via this.isActive().

    var _splitComponentProps = Object(__WEBPACK_IMPORTED_MODULE_9__utils_splitComponentProps__["a" /* default */])(props, __WEBPACK_IMPORTED_MODULE_8__Dropdown__["a" /* default */].ControlledComponent),
        dropdownProps = _splitComponentProps[0],
        toggleProps = _splitComponentProps[1];

    // Unlike for the other dropdowns, styling needs to go to the `<Dropdown>`
    // rather than the `<Dropdown.Toggle>`.

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_8__Dropdown__["a" /* default */],
      __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, dropdownProps, {
        componentClass: 'li',
        className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, { active: active }),
        style: style
      }),
      __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_8__Dropdown__["a" /* default */].Toggle,
        __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, toggleProps, { useAnchor: true }),
        title
      ),
      __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_8__Dropdown__["a" /* default */].Menu,
        null,
        __WEBPACK_IMPORTED_MODULE_10__utils_ValidComponentChildren__["a" /* default */].map(children, function (child) {
          return __WEBPACK_IMPORTED_MODULE_6_react___default.a.cloneElement(child, {
            active: _this3.isActive(child, activeKey, activeHref)
          });
        })
      )
    );
  };

  return NavDropdown;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

NavDropdown.propTypes = propTypes;

/* harmony default export */ __webpack_exports__["a"] = (NavDropdown);

/***/ }),
/* 312 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = calculatePosition;

var _offset = __webpack_require__(51);

var _offset2 = _interopRequireDefault(_offset);

var _position = __webpack_require__(313);

var _position2 = _interopRequireDefault(_position);

var _scrollTop = __webpack_require__(100);

var _scrollTop2 = _interopRequireDefault(_scrollTop);

var _ownerDocument = __webpack_require__(32);

var _ownerDocument2 = _interopRequireDefault(_ownerDocument);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getContainerDimensions(containerNode) {
  var width = void 0,
      height = void 0,
      scroll = void 0;

  if (containerNode.tagName === 'BODY') {
    width = window.innerWidth;
    height = window.innerHeight;

    scroll = (0, _scrollTop2.default)((0, _ownerDocument2.default)(containerNode).documentElement) || (0, _scrollTop2.default)(containerNode);
  } else {
    var _getOffset = (0, _offset2.default)(containerNode);

    width = _getOffset.width;
    height = _getOffset.height;

    scroll = (0, _scrollTop2.default)(containerNode);
  }

  return { width: width, height: height, scroll: scroll };
}

function getTopDelta(top, overlayHeight, container, padding) {
  var containerDimensions = getContainerDimensions(container);
  var containerScroll = containerDimensions.scroll;
  var containerHeight = containerDimensions.height;

  var topEdgeOffset = top - padding - containerScroll;
  var bottomEdgeOffset = top + padding - containerScroll + overlayHeight;

  if (topEdgeOffset < 0) {
    return -topEdgeOffset;
  } else if (bottomEdgeOffset > containerHeight) {
    return containerHeight - bottomEdgeOffset;
  } else {
    return 0;
  }
}

function getLeftDelta(left, overlayWidth, container, padding) {
  var containerDimensions = getContainerDimensions(container);
  var containerWidth = containerDimensions.width;

  var leftEdgeOffset = left - padding;
  var rightEdgeOffset = left + padding + overlayWidth;

  if (leftEdgeOffset < 0) {
    return -leftEdgeOffset;
  } else if (rightEdgeOffset > containerWidth) {
    return containerWidth - rightEdgeOffset;
  }

  return 0;
}

function calculatePosition(placement, overlayNode, target, container, padding) {
  var childOffset = container.tagName === 'BODY' ? (0, _offset2.default)(target) : (0, _position2.default)(target, container);

  var _getOffset2 = (0, _offset2.default)(overlayNode),
      overlayHeight = _getOffset2.height,
      overlayWidth = _getOffset2.width;

  var positionLeft = void 0,
      positionTop = void 0,
      arrowOffsetLeft = void 0,
      arrowOffsetTop = void 0;

  if (placement === 'left' || placement === 'right') {
    positionTop = childOffset.top + (childOffset.height - overlayHeight) / 2;

    if (placement === 'left') {
      positionLeft = childOffset.left - overlayWidth;
    } else {
      positionLeft = childOffset.left + childOffset.width;
    }

    var topDelta = getTopDelta(positionTop, overlayHeight, container, padding);

    positionTop += topDelta;
    arrowOffsetTop = 50 * (1 - 2 * topDelta / overlayHeight) + '%';
    arrowOffsetLeft = void 0;
  } else if (placement === 'top' || placement === 'bottom') {
    positionLeft = childOffset.left + (childOffset.width - overlayWidth) / 2;

    if (placement === 'top') {
      positionTop = childOffset.top - overlayHeight;
    } else {
      positionTop = childOffset.top + childOffset.height;
    }

    var leftDelta = getLeftDelta(positionLeft, overlayWidth, container, padding);

    positionLeft += leftDelta;
    arrowOffsetLeft = 50 * (1 - 2 * leftDelta / overlayWidth) + '%';
    arrowOffsetTop = void 0;
  } else {
    throw new Error('calcOverlayPosition(): No such placement of "' + placement + '" found.');
  }

  return { positionLeft: positionLeft, positionTop: positionTop, arrowOffsetLeft: arrowOffsetLeft, arrowOffsetTop: arrowOffsetTop };
}
module.exports = exports['default'];

/***/ }),
/* 313 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = position;

var _offset = __webpack_require__(51);

var _offset2 = _interopRequireDefault(_offset);

var _offsetParent = __webpack_require__(152);

var _offsetParent2 = _interopRequireDefault(_offsetParent);

var _scrollTop = __webpack_require__(100);

var _scrollTop2 = _interopRequireDefault(_scrollTop);

var _scrollLeft = __webpack_require__(314);

var _scrollLeft2 = _interopRequireDefault(_scrollLeft);

var _style = __webpack_require__(58);

var _style2 = _interopRequireDefault(_style);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function nodeName(node) {
  return node.nodeName && node.nodeName.toLowerCase();
}

function position(node, offsetParent) {
  var parentOffset = { top: 0, left: 0 },
      offset;

  // Fixed elements are offset from window (parentOffset = {top:0, left: 0},
  // because it is its only offset parent
  if ((0, _style2.default)(node, 'position') === 'fixed') {
    offset = node.getBoundingClientRect();
  } else {
    offsetParent = offsetParent || (0, _offsetParent2.default)(node);
    offset = (0, _offset2.default)(node);

    if (nodeName(offsetParent) !== 'html') parentOffset = (0, _offset2.default)(offsetParent);

    parentOffset.top += parseInt((0, _style2.default)(offsetParent, 'borderTopWidth'), 10) - (0, _scrollTop2.default)(offsetParent) || 0;
    parentOffset.left += parseInt((0, _style2.default)(offsetParent, 'borderLeftWidth'), 10) - (0, _scrollLeft2.default)(offsetParent) || 0;
  }

  // Subtract parent offsets and node margins
  return _extends({}, offset, {
    top: offset.top - parentOffset.top - (parseInt((0, _style2.default)(node, 'marginTop'), 10) || 0),
    left: offset.left - parentOffset.left - (parseInt((0, _style2.default)(node, 'marginLeft'), 10) || 0)
  });
}
module.exports = exports['default'];

/***/ }),
/* 314 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = scrollTop;

var _isWindow = __webpack_require__(50);

var _isWindow2 = _interopRequireDefault(_isWindow);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function scrollTop(node, val) {
  var win = (0, _isWindow2.default)(node);

  if (val === undefined) return win ? 'pageXOffset' in win ? win.pageXOffset : win.document.documentElement.scrollLeft : node.scrollLeft;

  if (win) win.scrollTo(val, 'pageYOffset' in win ? win.pageYOffset : win.document.documentElement.scrollTop);else node.scrollLeft = val;
}
module.exports = exports['default'];

/***/ }),
/* 315 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_dom_helpers_query_contains__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_dom_helpers_query_contains___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_dom_helpers_query_contains__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_dom__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_warning__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Overlay__ = __webpack_require__(149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils_createChainedFunction__ = __webpack_require__(12);















/**
 * Check if value one is inside or equal to the of value
 *
 * @param {string} one
 * @param {string|array} of
 * @returns {boolean}
 */
function isOneOf(one, of) {
  if (Array.isArray(of)) {
    return of.indexOf(one) >= 0;
  }
  return one === of;
}

var triggerType = __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.oneOf(['click', 'hover', 'focus']);

var propTypes = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_10__Overlay__["a" /* default */].propTypes, {

  /**
  * Specify which action or actions trigger Overlay visibility
  */
  trigger: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.oneOfType([triggerType, __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.arrayOf(triggerType)]),

  /**
   * A millisecond delay amount to show and hide the Overlay once triggered
   */
  delay: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.number,
  /**
   * A millisecond delay amount before showing the Overlay once triggered.
   */
  delayShow: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.number,
  /**
   * A millisecond delay amount before hiding the Overlay once triggered.
   */
  delayHide: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.number,

  // FIXME: This should be `defaultShow`.
  /**
   * The initial visibility state of the Overlay. For more nuanced visibility
   * control, consider using the Overlay component directly.
   */
  defaultOverlayShown: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,

  /**
   * An element or text to overlay next to the target.
   */
  overlay: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.node.isRequired,

  /**
   * @private
   */
  onBlur: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
  /**
   * @private
   */
  onClick: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
  /**
   * @private
   */
  onFocus: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
  /**
   * @private
   */
  onMouseOut: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
  /**
   * @private
   */
  onMouseOver: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,

  // Overridden props from `<Overlay>`.
  /**
   * @private
   */
  target: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.oneOf([null]),
  /**
  * @private
  */
  onHide: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.oneOf([null]),
  /**
   * @private
   */
  show: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.oneOf([null])
});

var defaultProps = {
  defaultOverlayShown: false,
  trigger: ['hover', 'focus']
};

var OverlayTrigger = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(OverlayTrigger, _React$Component);

  function OverlayTrigger(props, context) {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, OverlayTrigger);

    var _this = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props, context));

    _this.handleToggle = _this.handleToggle.bind(_this);
    _this.handleDelayedShow = _this.handleDelayedShow.bind(_this);
    _this.handleDelayedHide = _this.handleDelayedHide.bind(_this);
    _this.handleHide = _this.handleHide.bind(_this);

    _this.handleMouseOver = function (e) {
      return _this.handleMouseOverOut(_this.handleDelayedShow, e);
    };
    _this.handleMouseOut = function (e) {
      return _this.handleMouseOverOut(_this.handleDelayedHide, e);
    };

    _this._mountNode = null;

    _this.state = {
      show: props.defaultOverlayShown
    };
    return _this;
  }

  OverlayTrigger.prototype.componentDidMount = function componentDidMount() {
    this._mountNode = document.createElement('div');
    this.renderOverlay();
  };

  OverlayTrigger.prototype.componentDidUpdate = function componentDidUpdate() {
    this.renderOverlay();
  };

  OverlayTrigger.prototype.componentWillUnmount = function componentWillUnmount() {
    __WEBPACK_IMPORTED_MODULE_8_react_dom___default.a.unmountComponentAtNode(this._mountNode);
    this._mountNode = null;

    clearTimeout(this._hoverShowDelay);
    clearTimeout(this._hoverHideDelay);
  };

  OverlayTrigger.prototype.handleToggle = function handleToggle() {
    if (this.state.show) {
      this.hide();
    } else {
      this.show();
    }
  };

  OverlayTrigger.prototype.handleDelayedShow = function handleDelayedShow() {
    var _this2 = this;

    if (this._hoverHideDelay != null) {
      clearTimeout(this._hoverHideDelay);
      this._hoverHideDelay = null;
      return;
    }

    if (this.state.show || this._hoverShowDelay != null) {
      return;
    }

    var delay = this.props.delayShow != null ? this.props.delayShow : this.props.delay;

    if (!delay) {
      this.show();
      return;
    }

    this._hoverShowDelay = setTimeout(function () {
      _this2._hoverShowDelay = null;
      _this2.show();
    }, delay);
  };

  OverlayTrigger.prototype.handleDelayedHide = function handleDelayedHide() {
    var _this3 = this;

    if (this._hoverShowDelay != null) {
      clearTimeout(this._hoverShowDelay);
      this._hoverShowDelay = null;
      return;
    }

    if (!this.state.show || this._hoverHideDelay != null) {
      return;
    }

    var delay = this.props.delayHide != null ? this.props.delayHide : this.props.delay;

    if (!delay) {
      this.hide();
      return;
    }

    this._hoverHideDelay = setTimeout(function () {
      _this3._hoverHideDelay = null;
      _this3.hide();
    }, delay);
  };

  // Simple implementation of mouseEnter and mouseLeave.
  // React's built version is broken: https://github.com/facebook/react/issues/4251
  // for cases when the trigger is disabled and mouseOut/Over can cause flicker
  // moving from one child element to another.


  OverlayTrigger.prototype.handleMouseOverOut = function handleMouseOverOut(handler, e) {
    var target = e.currentTarget;
    var related = e.relatedTarget || e.nativeEvent.toElement;

    if (!related || related !== target && !__WEBPACK_IMPORTED_MODULE_5_dom_helpers_query_contains___default()(target, related)) {
      handler(e);
    }
  };

  OverlayTrigger.prototype.handleHide = function handleHide() {
    this.hide();
  };

  OverlayTrigger.prototype.show = function show() {
    this.setState({ show: true });
  };

  OverlayTrigger.prototype.hide = function hide() {
    this.setState({ show: false });
  };

  OverlayTrigger.prototype.makeOverlay = function makeOverlay(overlay, props) {
    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_10__Overlay__["a" /* default */],
      __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, props, {
        show: this.state.show,
        onHide: this.handleHide,
        target: this
      }),
      overlay
    );
  };

  OverlayTrigger.prototype.renderOverlay = function renderOverlay() {
    __WEBPACK_IMPORTED_MODULE_8_react_dom___default.a.unstable_renderSubtreeIntoContainer(this, this._overlay, this._mountNode);
  };

  OverlayTrigger.prototype.render = function render() {
    var _props = this.props,
        trigger = _props.trigger,
        overlay = _props.overlay,
        children = _props.children,
        onBlur = _props.onBlur,
        onClick = _props.onClick,
        onFocus = _props.onFocus,
        onMouseOut = _props.onMouseOut,
        onMouseOver = _props.onMouseOver,
        props = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['trigger', 'overlay', 'children', 'onBlur', 'onClick', 'onFocus', 'onMouseOut', 'onMouseOver']);

    delete props.delay;
    delete props.delayShow;
    delete props.delayHide;
    delete props.defaultOverlayShown;

    var child = __WEBPACK_IMPORTED_MODULE_6_react___default.a.Children.only(children);
    var childProps = child.props;
    var triggerProps = {};

    if (this.state.show) {
      triggerProps['aria-describedby'] = overlay.props.id;
    }

    // FIXME: The logic here for passing through handlers on this component is
    // inconsistent. We shouldn't be passing any of these props through.

    triggerProps.onClick = Object(__WEBPACK_IMPORTED_MODULE_11__utils_createChainedFunction__["a" /* default */])(childProps.onClick, onClick);

    if (isOneOf('click', trigger)) {
      triggerProps.onClick = Object(__WEBPACK_IMPORTED_MODULE_11__utils_createChainedFunction__["a" /* default */])(triggerProps.onClick, this.handleToggle);
    }

    if (isOneOf('hover', trigger)) {
       false ? warning(!(trigger === 'hover'), '[react-bootstrap] Specifying only the `"hover"` trigger limits the ' + 'visibility of the overlay to just mouse users. Consider also ' + 'including the `"focus"` trigger so that touch and keyboard only ' + 'users can see the overlay as well.') : void 0;

      triggerProps.onMouseOver = Object(__WEBPACK_IMPORTED_MODULE_11__utils_createChainedFunction__["a" /* default */])(childProps.onMouseOver, onMouseOver, this.handleMouseOver);
      triggerProps.onMouseOut = Object(__WEBPACK_IMPORTED_MODULE_11__utils_createChainedFunction__["a" /* default */])(childProps.onMouseOut, onMouseOut, this.handleMouseOut);
    }

    if (isOneOf('focus', trigger)) {
      triggerProps.onFocus = Object(__WEBPACK_IMPORTED_MODULE_11__utils_createChainedFunction__["a" /* default */])(childProps.onFocus, onFocus, this.handleDelayedShow);
      triggerProps.onBlur = Object(__WEBPACK_IMPORTED_MODULE_11__utils_createChainedFunction__["a" /* default */])(childProps.onBlur, onBlur, this.handleDelayedHide);
    }

    this._overlay = this.makeOverlay(overlay, props);

    return Object(__WEBPACK_IMPORTED_MODULE_6_react__["cloneElement"])(child, triggerProps);
  };

  return OverlayTrigger;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

OverlayTrigger.propTypes = propTypes;
OverlayTrigger.defaultProps = defaultProps;

/* unused harmony default export */ var _unused_webpack_default_export = (OverlayTrigger);

/***/ }),
/* 316 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__ = __webpack_require__(8);










var PageHeader = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(PageHeader, _React$Component);

  function PageHeader() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, PageHeader);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  PageHeader.prototype.render = function render() {
    var _props = this.props,
        className = _props.className,
        children = _props.children,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['className', 'children']);

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["f" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["d" /* getClassSet */])(bsProps);

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
      'div',
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, elementProps, {
        className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, classes)
      }),
      __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        'h1',
        null,
        children
      )
    );
  };

  return PageHeader;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["a" /* bsClass */])('page-header', PageHeader));

/***/ }),
/* 317 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__PagerItem__ = __webpack_require__(153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_deprecationWarning__ = __webpack_require__(318);



/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_1__utils_deprecationWarning__["a" /* default */].wrapper(__WEBPACK_IMPORTED_MODULE_0__PagerItem__["a" /* default */], '`<PageItem>`', '`<Pager.Item>`'));

/***/ }),
/* 318 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export _resetWarned */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_warning__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_warning__);






var warned = {};

function deprecationWarning(oldname, newname, link) {
  var message = void 0;

  if ((typeof oldname === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default()(oldname)) === 'object') {
    message = oldname.message;
  } else {
    message = oldname + ' is deprecated. Use ' + newname + ' instead.';

    if (link) {
      message += '\nYou can read more about it at ' + link;
    }
  }

  if (warned[message]) {
    return;
  }

   false ? warning(false, message) : void 0;
  warned[message] = true;
}

deprecationWarning.wrapper = function (Component) {
  for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }

  return function (_Component) {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(DeprecatedComponent, _Component);

    function DeprecatedComponent() {
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, DeprecatedComponent);

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, _Component.apply(this, arguments));
    }

    DeprecatedComponent.prototype.componentWillMount = function componentWillMount() {
      deprecationWarning.apply(undefined, args);

      if (_Component.prototype.componentWillMount) {
        var _Component$prototype$;

        for (var _len2 = arguments.length, methodArgs = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
          methodArgs[_key2] = arguments[_key2];
        }

        (_Component$prototype$ = _Component.prototype.componentWillMount).call.apply(_Component$prototype$, [this].concat(methodArgs));
      }
    };

    return DeprecatedComponent;
  }(Component);
};

/* harmony default export */ __webpack_exports__["a"] = (deprecationWarning);

function _resetWarned() {
  warned = {};
}

/***/ }),
/* 319 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__PagerItem__ = __webpack_require__(153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_createChainedFunction__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils_ValidComponentChildren__ = __webpack_require__(18);














var propTypes = {
  onSelect: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func
};

var Pager = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Pager, _React$Component);

  function Pager() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, Pager);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  Pager.prototype.render = function render() {
    var _props = this.props,
        onSelect = _props.onSelect,
        className = _props.className,
        children = _props.children,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['onSelect', 'className', 'children']);

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["f" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = Object(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["d" /* getClassSet */])(bsProps);

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
      'ul',
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, elementProps, {
        className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, classes)
      }),
      __WEBPACK_IMPORTED_MODULE_11__utils_ValidComponentChildren__["a" /* default */].map(children, function (child) {
        return Object(__WEBPACK_IMPORTED_MODULE_6_react__["cloneElement"])(child, {
          onSelect: Object(__WEBPACK_IMPORTED_MODULE_10__utils_createChainedFunction__["a" /* default */])(child.props.onSelect, onSelect)
        });
      })
    );
  };

  return Pager;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

Pager.propTypes = propTypes;

Pager.Item = __WEBPACK_IMPORTED_MODULE_8__PagerItem__["a" /* default */];

/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["a" /* bsClass */])('pager', Pager));

/***/ }),
/* 320 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types_extra_lib_elementType__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types_extra_lib_elementType___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_prop_types_extra_lib_elementType__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__PaginationButton__ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_bootstrapUtils__ = __webpack_require__(8);













var propTypes = {
  activePage: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.number,
  items: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.number,
  maxButtons: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.number,

  /**
   * When `true`, will display the first and the last button page when
   * displaying ellipsis.
   */
  boundaryLinks: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,

  /**
   * When `true`, will display the default node value ('&hellip;').
   * Otherwise, will display provided node (when specified).
   */
  ellipsis: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool, __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.node]),

  /**
   * When `true`, will display the default node value ('&laquo;').
   * Otherwise, will display provided node (when specified).
   */
  first: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool, __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.node]),

  /**
   * When `true`, will display the default node value ('&raquo;').
   * Otherwise, will display provided node (when specified).
   */
  last: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool, __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.node]),

  /**
   * When `true`, will display the default node value ('&lsaquo;').
   * Otherwise, will display provided node (when specified).
   */
  prev: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool, __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.node]),

  /**
   * When `true`, will display the default node value ('&rsaquo;').
   * Otherwise, will display provided node (when specified).
   */
  next: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool, __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.node]),

  onSelect: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,

  /**
   * You can use a custom element for the buttons
   */
  buttonComponentClass: __WEBPACK_IMPORTED_MODULE_8_prop_types_extra_lib_elementType___default.a
};

var defaultProps = {
  activePage: 1,
  items: 1,
  maxButtons: 0,
  first: false,
  last: false,
  prev: false,
  next: false,
  ellipsis: true,
  boundaryLinks: false
};

var Pagination = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Pagination, _React$Component);

  function Pagination() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, Pagination);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  Pagination.prototype.renderPageButtons = function renderPageButtons(activePage, items, maxButtons, boundaryLinks, ellipsis, buttonProps) {
    var pageButtons = [];

    var startPage = void 0;
    var endPage = void 0;

    if (maxButtons && maxButtons < items) {
      startPage = Math.max(Math.min(activePage - Math.floor(maxButtons / 2, 10), items - maxButtons + 1), 1);
      endPage = startPage + maxButtons - 1;
    } else {
      startPage = 1;
      endPage = items;
    }

    for (var page = startPage; page <= endPage; ++page) {
      pageButtons.push(__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_9__PaginationButton__["a" /* default */],
        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, buttonProps, {
          key: page,
          eventKey: page,
          active: page === activePage
        }),
        page
      ));
    }

    if (ellipsis && boundaryLinks && startPage > 1) {
      if (startPage > 2) {
        pageButtons.unshift(__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_9__PaginationButton__["a" /* default */],
          {
            key: 'ellipsisFirst',
            disabled: true,
            componentClass: buttonProps.componentClass
          },
          __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
            'span',
            { 'aria-label': 'More' },
            ellipsis === true ? '\u2026' : ellipsis
          )
        ));
      }

      pageButtons.unshift(__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_9__PaginationButton__["a" /* default */],
        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, buttonProps, {
          key: 1,
          eventKey: 1,
          active: false
        }),
        '1'
      ));
    }

    if (ellipsis && endPage < items) {
      if (!boundaryLinks || endPage < items - 1) {
        pageButtons.push(__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_9__PaginationButton__["a" /* default */],
          {
            key: 'ellipsis',
            disabled: true,
            componentClass: buttonProps.componentClass
          },
          __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
            'span',
            { 'aria-label': 'More' },
            ellipsis === true ? '\u2026' : ellipsis
          )
        ));
      }

      if (boundaryLinks) {
        pageButtons.push(__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_9__PaginationButton__["a" /* default */],
          __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, buttonProps, {
            key: items,
            eventKey: items,
            active: false
          }),
          items
        ));
      }
    }

    return pageButtons;
  };

  Pagination.prototype.render = function render() {
    var _props = this.props,
        activePage = _props.activePage,
        items = _props.items,
        maxButtons = _props.maxButtons,
        boundaryLinks = _props.boundaryLinks,
        ellipsis = _props.ellipsis,
        first = _props.first,
        last = _props.last,
        prev = _props.prev,
        next = _props.next,
        onSelect = _props.onSelect,
        buttonComponentClass = _props.buttonComponentClass,
        className = _props.className,
        props = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['activePage', 'items', 'maxButtons', 'boundaryLinks', 'ellipsis', 'first', 'last', 'prev', 'next', 'onSelect', 'buttonComponentClass', 'className']);

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_10__utils_bootstrapUtils__["f" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = Object(__WEBPACK_IMPORTED_MODULE_10__utils_bootstrapUtils__["d" /* getClassSet */])(bsProps);

    var buttonProps = {
      onSelect: onSelect,
      componentClass: buttonComponentClass
    };

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
      'ul',
      __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, elementProps, {
        className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, classes)
      }),
      first && __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_9__PaginationButton__["a" /* default */],
        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, buttonProps, {
          eventKey: 1,
          disabled: activePage === 1
        }),
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          'span',
          { 'aria-label': 'First' },
          first === true ? '\xAB' : first
        )
      ),
      prev && __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_9__PaginationButton__["a" /* default */],
        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, buttonProps, {
          eventKey: activePage - 1,
          disabled: activePage === 1
        }),
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          'span',
          { 'aria-label': 'Previous' },
          prev === true ? '\u2039' : prev
        )
      ),
      this.renderPageButtons(activePage, items, maxButtons, boundaryLinks, ellipsis, buttonProps),
      next && __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_9__PaginationButton__["a" /* default */],
        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, buttonProps, {
          eventKey: activePage + 1,
          disabled: activePage >= items
        }),
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          'span',
          { 'aria-label': 'Next' },
          next === true ? '\u203A' : next
        )
      ),
      last && __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_9__PaginationButton__["a" /* default */],
        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, buttonProps, {
          eventKey: items,
          disabled: activePage >= items
        }),
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          'span',
          { 'aria-label': 'Last' },
          last === true ? '\xBB' : last
        )
      )
    );
  };

  return Pagination;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

Pagination.propTypes = propTypes;
Pagination.defaultProps = defaultProps;

/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_10__utils_bootstrapUtils__["a" /* bsClass */])('pagination', Pagination));

/***/ }),
/* 321 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Collapse__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_bootstrapUtils__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils_StyleConfig__ = __webpack_require__(15);














// TODO: Use uncontrollable.

var propTypes = {
  collapsible: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool,
  onSelect: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func,
  header: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.node,
  id: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.number]),
  footer: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.node,
  defaultExpanded: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool,
  expanded: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool,
  eventKey: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.any,
  headerRole: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.string,
  panelRole: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.string,

  // From Collapse.
  onEnter: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func,
  onEntering: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func,
  onEntered: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func,
  onExit: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func,
  onExiting: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func,
  onExited: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func
};

var defaultProps = {
  defaultExpanded: false
};

var Panel = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(Panel, _React$Component);

  function Panel(props, context) {
    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, Panel);

    var _this = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props, context));

    _this.handleClickTitle = _this.handleClickTitle.bind(_this);

    _this.state = {
      expanded: _this.props.defaultExpanded
    };
    return _this;
  }

  Panel.prototype.handleClickTitle = function handleClickTitle(e) {
    // FIXME: What the heck? This API is horrible. This needs to go away!
    e.persist();
    e.selected = true;

    if (this.props.onSelect) {
      this.props.onSelect(this.props.eventKey, e);
    } else {
      e.preventDefault();
    }

    if (e.selected) {
      this.setState({ expanded: !this.state.expanded });
    }
  };

  Panel.prototype.renderHeader = function renderHeader(collapsible, header, id, role, expanded, bsProps) {
    var titleClassName = Object(__WEBPACK_IMPORTED_MODULE_10__utils_bootstrapUtils__["e" /* prefix */])(bsProps, 'title');

    if (!collapsible) {
      if (!__WEBPACK_IMPORTED_MODULE_7_react___default.a.isValidElement(header)) {
        return header;
      }

      return Object(__WEBPACK_IMPORTED_MODULE_7_react__["cloneElement"])(header, {
        className: __WEBPACK_IMPORTED_MODULE_6_classnames___default()(header.props.className, titleClassName)
      });
    }

    if (!__WEBPACK_IMPORTED_MODULE_7_react___default.a.isValidElement(header)) {
      return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
        'h4',
        { role: 'presentation', className: titleClassName },
        this.renderAnchor(header, id, role, expanded)
      );
    }

    return Object(__WEBPACK_IMPORTED_MODULE_7_react__["cloneElement"])(header, {
      className: __WEBPACK_IMPORTED_MODULE_6_classnames___default()(header.props.className, titleClassName),
      children: this.renderAnchor(header.props.children, id, role, expanded)
    });
  };

  Panel.prototype.renderAnchor = function renderAnchor(header, id, role, expanded) {
    return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
      'a',
      {
        role: role,
        href: id && '#' + id,
        onClick: this.handleClickTitle,
        'aria-controls': id,
        'aria-expanded': expanded,
        'aria-selected': expanded,
        className: expanded ? null : 'collapsed'
      },
      header
    );
  };

  Panel.prototype.renderCollapsibleBody = function renderCollapsibleBody(id, expanded, role, children, bsProps, animationHooks) {
    return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_9__Collapse__["a" /* default */],
      __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({ 'in': expanded }, animationHooks),
      __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
        'div',
        {
          id: id,
          role: role,
          className: Object(__WEBPACK_IMPORTED_MODULE_10__utils_bootstrapUtils__["e" /* prefix */])(bsProps, 'collapse'),
          'aria-hidden': !expanded
        },
        this.renderBody(children, bsProps)
      )
    );
  };

  Panel.prototype.renderBody = function renderBody(rawChildren, bsProps) {
    var children = [];
    var bodyChildren = [];

    var bodyClassName = Object(__WEBPACK_IMPORTED_MODULE_10__utils_bootstrapUtils__["e" /* prefix */])(bsProps, 'body');

    function maybeAddBody() {
      if (!bodyChildren.length) {
        return;
      }

      // Derive the key from the index here, since we need to make one up.
      children.push(__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
        'div',
        { key: children.length, className: bodyClassName },
        bodyChildren
      ));

      bodyChildren = [];
    }

    // Convert to array so we can re-use keys.
    __WEBPACK_IMPORTED_MODULE_7_react___default.a.Children.toArray(rawChildren).forEach(function (child) {
      if (__WEBPACK_IMPORTED_MODULE_7_react___default.a.isValidElement(child) && child.props.fill) {
        maybeAddBody();

        // Remove the child's unknown `fill` prop.
        children.push(Object(__WEBPACK_IMPORTED_MODULE_7_react__["cloneElement"])(child, { fill: undefined }));

        return;
      }

      bodyChildren.push(child);
    });

    maybeAddBody();

    return children;
  };

  Panel.prototype.render = function render() {
    var _props = this.props,
        collapsible = _props.collapsible,
        header = _props.header,
        id = _props.id,
        footer = _props.footer,
        propsExpanded = _props.expanded,
        headerRole = _props.headerRole,
        panelRole = _props.panelRole,
        className = _props.className,
        children = _props.children,
        onEnter = _props.onEnter,
        onEntering = _props.onEntering,
        onEntered = _props.onEntered,
        onExit = _props.onExit,
        onExiting = _props.onExiting,
        onExited = _props.onExited,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['collapsible', 'header', 'id', 'footer', 'expanded', 'headerRole', 'panelRole', 'className', 'children', 'onEnter', 'onEntering', 'onEntered', 'onExit', 'onExiting', 'onExited']);

    var _splitBsPropsAndOmit = Object(__WEBPACK_IMPORTED_MODULE_10__utils_bootstrapUtils__["g" /* splitBsPropsAndOmit */])(props, ['defaultExpanded', 'eventKey', 'onSelect']),
        bsProps = _splitBsPropsAndOmit[0],
        elementProps = _splitBsPropsAndOmit[1];

    var expanded = propsExpanded != null ? propsExpanded : this.state.expanded;

    var classes = Object(__WEBPACK_IMPORTED_MODULE_10__utils_bootstrapUtils__["d" /* getClassSet */])(bsProps);

    return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
      'div',
      __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, elementProps, {
        className: __WEBPACK_IMPORTED_MODULE_6_classnames___default()(className, classes),
        id: collapsible ? null : id
      }),
      header && __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
        'div',
        { className: Object(__WEBPACK_IMPORTED_MODULE_10__utils_bootstrapUtils__["e" /* prefix */])(bsProps, 'heading') },
        this.renderHeader(collapsible, header, id, headerRole, expanded, bsProps)
      ),
      collapsible ? this.renderCollapsibleBody(id, expanded, panelRole, children, bsProps, { onEnter: onEnter, onEntering: onEntering, onEntered: onEntered, onExit: onExit, onExiting: onExiting, onExited: onExited }) : this.renderBody(children, bsProps),
      footer && __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
        'div',
        { className: Object(__WEBPACK_IMPORTED_MODULE_10__utils_bootstrapUtils__["e" /* prefix */])(bsProps, 'footer') },
        footer
      )
    );
  };

  return Panel;
}(__WEBPACK_IMPORTED_MODULE_7_react___default.a.Component);

Panel.propTypes = propTypes;
Panel.defaultProps = defaultProps;

/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_10__utils_bootstrapUtils__["a" /* bsClass */])('panel', Object(__WEBPACK_IMPORTED_MODULE_10__utils_bootstrapUtils__["c" /* bsStyles */])([].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default()(__WEBPACK_IMPORTED_MODULE_11__utils_StyleConfig__["d" /* State */]), [__WEBPACK_IMPORTED_MODULE_11__utils_StyleConfig__["e" /* Style */].DEFAULT, __WEBPACK_IMPORTED_MODULE_11__utils_StyleConfig__["e" /* Style */].PRIMARY]), __WEBPACK_IMPORTED_MODULE_11__utils_StyleConfig__["e" /* Style */].DEFAULT, Panel)));

/***/ }),
/* 322 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types_extra_lib_isRequiredForA11y__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types_extra_lib_isRequiredForA11y___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_prop_types_extra_lib_isRequiredForA11y__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__ = __webpack_require__(8);












var propTypes = {
  /**
   * An html id attribute, necessary for accessibility
   * @type {string}
   * @required
   */
  id: __WEBPACK_IMPORTED_MODULE_8_prop_types_extra_lib_isRequiredForA11y___default()(__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.number])),

  /**
   * Sets the direction the Popover is positioned towards.
   */
  placement: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.oneOf(['top', 'right', 'bottom', 'left']),

  /**
   * The "top" position value for the Popover.
   */
  positionTop: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string]),
  /**
   * The "left" position value for the Popover.
   */
  positionLeft: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string]),

  /**
   * The "top" position value for the Popover arrow.
   */
  arrowOffsetTop: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string]),
  /**
   * The "left" position value for the Popover arrow.
   */
  arrowOffsetLeft: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string]),

  /**
   * Title content
   */
  title: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.node
};

var defaultProps = {
  placement: 'right'
};

var Popover = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Popover, _React$Component);

  function Popover() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, Popover);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  Popover.prototype.render = function render() {
    var _extends2;

    var _props = this.props,
        placement = _props.placement,
        positionTop = _props.positionTop,
        positionLeft = _props.positionLeft,
        arrowOffsetTop = _props.arrowOffsetTop,
        arrowOffsetLeft = _props.arrowOffsetLeft,
        title = _props.title,
        className = _props.className,
        style = _props.style,
        children = _props.children,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['placement', 'positionTop', 'positionLeft', 'arrowOffsetTop', 'arrowOffsetLeft', 'title', 'className', 'style', 'children']);

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["f" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["d" /* getClassSet */])(bsProps), (_extends2 = {}, _extends2[placement] = true, _extends2));

    var outerStyle = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
      display: 'block',
      top: positionTop,
      left: positionLeft
    }, style);

    var arrowStyle = {
      top: arrowOffsetTop,
      left: arrowOffsetLeft
    };

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
      'div',
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, elementProps, {
        role: 'tooltip',
        className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, classes),
        style: outerStyle
      }),
      __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('div', { className: 'arrow', style: arrowStyle }),
      title && __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        'h3',
        { className: Object(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["e" /* prefix */])(bsProps, 'title') },
        title
      ),
      __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        'div',
        { className: Object(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["e" /* prefix */])(bsProps, 'content') },
        children
      )
    );
  };

  return Popover;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

Popover.propTypes = propTypes;
Popover.defaultProps = defaultProps;

/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["a" /* bsClass */])('popover', Popover));

/***/ }),
/* 323 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_StyleConfig__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils_ValidComponentChildren__ = __webpack_require__(18);














var ROUND_PRECISION = 1000;

/**
 * Validate that children, if any, are instances of `<ProgressBar>`.
 */
function onlyProgressBar(props, propName, componentName) {
  var children = props[propName];
  if (!children) {
    return null;
  }

  var error = null;

  __WEBPACK_IMPORTED_MODULE_7_react___default.a.Children.forEach(children, function (child) {
    if (error) {
      return;
    }

    if (child.type === ProgressBar) {
      // eslint-disable-line no-use-before-define
      return;
    }

    var childIdentifier = __WEBPACK_IMPORTED_MODULE_7_react___default.a.isValidElement(child) ? child.type.displayName || child.type.name || child.type : child;
    error = new Error('Children of ' + componentName + ' can contain only ProgressBar ' + ('components. Found ' + childIdentifier + '.'));
  });

  return error;
}

var propTypes = {
  min: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.number,
  now: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.number,
  max: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.number,
  label: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.node,
  srOnly: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool,
  striped: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool,
  active: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool,
  children: onlyProgressBar,

  /**
   * @private
   */
  isChild: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool
};

var defaultProps = {
  min: 0,
  max: 100,
  active: false,
  isChild: false,
  srOnly: false,
  striped: false
};

function getPercentage(now, min, max) {
  var percentage = (now - min) / (max - min) * 100;
  return Math.round(percentage * ROUND_PRECISION) / ROUND_PRECISION;
}

var ProgressBar = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(ProgressBar, _React$Component);

  function ProgressBar() {
    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, ProgressBar);

    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  ProgressBar.prototype.renderProgressBar = function renderProgressBar(_ref) {
    var _extends2;

    var min = _ref.min,
        now = _ref.now,
        max = _ref.max,
        label = _ref.label,
        srOnly = _ref.srOnly,
        striped = _ref.striped,
        active = _ref.active,
        className = _ref.className,
        style = _ref.style,
        props = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_objectWithoutProperties___default()(_ref, ['min', 'now', 'max', 'label', 'srOnly', 'striped', 'active', 'className', 'style']);

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["f" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["d" /* getClassSet */])(bsProps), (_extends2 = {
      active: active
    }, _extends2[Object(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["e" /* prefix */])(bsProps, 'striped')] = active || striped, _extends2));

    return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
      'div',
      __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, elementProps, {
        role: 'progressbar',
        className: __WEBPACK_IMPORTED_MODULE_6_classnames___default()(className, classes),
        style: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({ width: getPercentage(now, min, max) + '%' }, style),
        'aria-valuenow': now,
        'aria-valuemin': min,
        'aria-valuemax': max
      }),
      srOnly ? __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
        'span',
        { className: 'sr-only' },
        label
      ) : label
    );
  };

  ProgressBar.prototype.render = function render() {
    var _props = this.props,
        isChild = _props.isChild,
        props = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['isChild']);

    if (isChild) {
      return this.renderProgressBar(props);
    }

    var min = props.min,
        now = props.now,
        max = props.max,
        label = props.label,
        srOnly = props.srOnly,
        striped = props.striped,
        active = props.active,
        bsClass = props.bsClass,
        bsStyle = props.bsStyle,
        className = props.className,
        children = props.children,
        wrapperProps = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_objectWithoutProperties___default()(props, ['min', 'now', 'max', 'label', 'srOnly', 'striped', 'active', 'bsClass', 'bsStyle', 'className', 'children']);

    return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
      'div',
      __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, wrapperProps, {
        className: __WEBPACK_IMPORTED_MODULE_6_classnames___default()(className, 'progress')
      }),
      children ? __WEBPACK_IMPORTED_MODULE_11__utils_ValidComponentChildren__["a" /* default */].map(children, function (child) {
        return Object(__WEBPACK_IMPORTED_MODULE_7_react__["cloneElement"])(child, { isChild: true });
      }) : this.renderProgressBar({
        min: min, now: now, max: max, label: label, srOnly: srOnly, striped: striped, active: active, bsClass: bsClass, bsStyle: bsStyle
      })
    );
  };

  return ProgressBar;
}(__WEBPACK_IMPORTED_MODULE_7_react___default.a.Component);

ProgressBar.propTypes = propTypes;
ProgressBar.defaultProps = defaultProps;

/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["a" /* bsClass */])('progress-bar', Object(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["c" /* bsStyles */])(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default()(__WEBPACK_IMPORTED_MODULE_10__utils_StyleConfig__["d" /* State */]), ProgressBar)));

/***/ }),
/* 324 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_warning__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__ = __webpack_require__(8);












var propTypes = {
  inline: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  disabled: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  title: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string,
  /**
   * Only valid if `inline` is not set.
   */
  validationState: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.oneOf(['success', 'warning', 'error', null]),
  /**
   * Attaches a ref to the `<input>` element. Only functions can be used here.
   *
   * ```js
   * <Radio inputRef={ref => { this.input = ref; }} />
   * ```
   */
  inputRef: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func
};

var defaultProps = {
  inline: false,
  disabled: false,
  title: ''
};

var Radio = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Radio, _React$Component);

  function Radio() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, Radio);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  Radio.prototype.render = function render() {
    var _props = this.props,
        inline = _props.inline,
        disabled = _props.disabled,
        validationState = _props.validationState,
        inputRef = _props.inputRef,
        className = _props.className,
        style = _props.style,
        title = _props.title,
        children = _props.children,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['inline', 'disabled', 'validationState', 'inputRef', 'className', 'style', 'title', 'children']);

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["f" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var input = __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('input', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, elementProps, {
      ref: inputRef,
      type: 'radio',
      disabled: disabled
    }));

    if (inline) {
      var _classes2;

      var _classes = (_classes2 = {}, _classes2[Object(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["e" /* prefix */])(bsProps, 'inline')] = true, _classes2.disabled = disabled, _classes2);

      // Use a warning here instead of in propTypes to get better-looking
      // generated documentation.
       false ? warning(!validationState, '`validationState` is ignored on `<Radio inline>`. To display ' + 'validation state on an inline radio, set `validationState` on a ' + 'parent `<FormGroup>` or other element instead.') : void 0;

      return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        'label',
        { className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, _classes), style: style, title: title },
        input,
        children
      );
    }

    var classes = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["d" /* getClassSet */])(bsProps), {
      disabled: disabled
    });
    if (validationState) {
      classes['has-' + validationState] = true;
    }

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
      'div',
      { className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, classes), style: style },
      __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        'label',
        { title: title },
        input,
        children
      )
    );
  };

  return Radio;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

Radio.propTypes = propTypes;
Radio.defaultProps = defaultProps;

/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["a" /* bsClass */])('radio', Radio));

/***/ }),
/* 325 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_warning__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__ = __webpack_require__(8);












// TODO: This should probably take a single `aspectRatio` prop.

var propTypes = {
  /**
   * This component requires a single child element
   */
  children: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.element.isRequired,
  /**
   * 16by9 aspect ratio
   */
  a16by9: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  /**
   * 4by3 aspect ratio
   */
  a4by3: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool
};

var defaultProps = {
  a16by9: false,
  a4by3: false
};

var ResponsiveEmbed = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(ResponsiveEmbed, _React$Component);

  function ResponsiveEmbed() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, ResponsiveEmbed);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  ResponsiveEmbed.prototype.render = function render() {
    var _extends2;

    var _props = this.props,
        a16by9 = _props.a16by9,
        a4by3 = _props.a4by3,
        className = _props.className,
        children = _props.children,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['a16by9', 'a4by3', 'className', 'children']);

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["f" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

     false ? warning(a16by9 || a4by3, 'Either `a16by9` or `a4by3` must be set.') : void 0;
     false ? warning(!(a16by9 && a4by3), 'Only one of `a16by9` or `a4by3` can be set.') : void 0;

    var classes = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["d" /* getClassSet */])(bsProps), (_extends2 = {}, _extends2[Object(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["e" /* prefix */])(bsProps, '16by9')] = a16by9, _extends2[Object(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["e" /* prefix */])(bsProps, '4by3')] = a4by3, _extends2));

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
      'div',
      { className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(classes) },
      Object(__WEBPACK_IMPORTED_MODULE_6_react__["cloneElement"])(children, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, elementProps, {
        className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, Object(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["e" /* prefix */])(bsProps, 'item'))
      }))
    );
  };

  return ResponsiveEmbed;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

ResponsiveEmbed.propTypes = propTypes;
ResponsiveEmbed.defaultProps = defaultProps;

/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["a" /* bsClass */])('embed-responsive', ResponsiveEmbed));

/***/ }),
/* 326 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_elementType__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_elementType___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_elementType__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__ = __webpack_require__(8);











var propTypes = {
  componentClass: __WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_elementType___default.a
};

var defaultProps = {
  componentClass: 'div'
};

var Row = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Row, _React$Component);

  function Row() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, Row);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  Row.prototype.render = function render() {
    var _props = this.props,
        Component = _props.componentClass,
        className = _props.className,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['componentClass', 'className']);

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["f" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = Object(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["d" /* getClassSet */])(bsProps);

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Component, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, elementProps, {
      className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, classes)
    }));
  };

  return Row;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

Row.propTypes = propTypes;
Row.defaultProps = defaultProps;

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["a" /* bsClass */])('row', Row));

/***/ }),
/* 327 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Button__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Dropdown__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__SplitToggle__ = __webpack_require__(328);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_splitComponentProps__ = __webpack_require__(63);













var propTypes = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_8__Dropdown__["a" /* default */].propTypes, {

  // Toggle props.
  bsStyle: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  bsSize: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  href: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  onClick: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  /**
   * The content of the split button.
   */
  title: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.node.isRequired,
  /**
   * Accessible label for the toggle; the value of `title` if not specified.
   */
  toggleLabel: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,

  // Override generated docs from <Dropdown>.
  /**
   * @private
   */
  children: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.node
});

var SplitButton = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(SplitButton, _React$Component);

  function SplitButton() {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, SplitButton);

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  SplitButton.prototype.render = function render() {
    var _props = this.props,
        bsSize = _props.bsSize,
        bsStyle = _props.bsStyle,
        title = _props.title,
        toggleLabel = _props.toggleLabel,
        children = _props.children,
        props = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['bsSize', 'bsStyle', 'title', 'toggleLabel', 'children']);

    var _splitComponentProps = Object(__WEBPACK_IMPORTED_MODULE_10__utils_splitComponentProps__["a" /* default */])(props, __WEBPACK_IMPORTED_MODULE_8__Dropdown__["a" /* default */].ControlledComponent),
        dropdownProps = _splitComponentProps[0],
        buttonProps = _splitComponentProps[1];

    return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_8__Dropdown__["a" /* default */],
      __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, dropdownProps, {
        bsSize: bsSize,
        bsStyle: bsStyle
      }),
      __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_7__Button__["a" /* default */],
        __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, buttonProps, {
          disabled: props.disabled,
          bsSize: bsSize,
          bsStyle: bsStyle
        }),
        title
      ),
      __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__SplitToggle__["a" /* default */], {
        'aria-label': toggleLabel || title,
        bsSize: bsSize,
        bsStyle: bsStyle
      }),
      __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_8__Dropdown__["a" /* default */].Menu,
        null,
        children
      )
    );
  };

  return SplitButton;
}(__WEBPACK_IMPORTED_MODULE_5_react___default.a.Component);

SplitButton.propTypes = propTypes;

SplitButton.Toggle = __WEBPACK_IMPORTED_MODULE_9__SplitToggle__["a" /* default */];

/* unused harmony default export */ var _unused_webpack_default_export = (SplitButton);

/***/ }),
/* 328 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__DropdownToggle__ = __webpack_require__(135);








var SplitToggle = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(SplitToggle, _React$Component);

  function SplitToggle() {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, SplitToggle);

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  SplitToggle.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__DropdownToggle__["a" /* default */], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.props, {
      useAnchor: false,
      noCaret: false
    }));
  };

  return SplitToggle;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

SplitToggle.defaultProps = __WEBPACK_IMPORTED_MODULE_5__DropdownToggle__["a" /* default */].defaultProps;

/* harmony default export */ __webpack_exports__["a"] = (SplitToggle);

/***/ }),
/* 329 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__TabContainer__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__TabContent__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__TabPane__ = __webpack_require__(155);











var propTypes = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_8__TabPane__["a" /* default */].propTypes, {

  disabled: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,

  title: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.node,

  /**
   * tabClassName is used as className for the associated NavItem
   */
  tabClassName: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string
});

var Tab = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(Tab, _React$Component);

  function Tab() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Tab);

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  Tab.prototype.render = function render() {
    var props = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, this.props);

    // These props are for the parent `<Tabs>` rather than the `<TabPane>`.
    delete props.title;
    delete props.disabled;
    delete props.tabClassName;

    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__TabPane__["a" /* default */], props);
  };

  return Tab;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

Tab.propTypes = propTypes;

Tab.Container = __WEBPACK_IMPORTED_MODULE_6__TabContainer__["a" /* default */];
Tab.Content = __WEBPACK_IMPORTED_MODULE_7__TabContent__["a" /* default */];
Tab.Pane = __WEBPACK_IMPORTED_MODULE_8__TabPane__["a" /* default */];

/* unused harmony default export */ var _unused_webpack_default_export = (Tab);

/***/ }),
/* 330 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__ = __webpack_require__(8);











var propTypes = {
  striped: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  bordered: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  condensed: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  hover: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  responsive: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool
};

var defaultProps = {
  bordered: false,
  condensed: false,
  hover: false,
  responsive: false,
  striped: false
};

var Table = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Table, _React$Component);

  function Table() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, Table);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  Table.prototype.render = function render() {
    var _extends2;

    var _props = this.props,
        striped = _props.striped,
        bordered = _props.bordered,
        condensed = _props.condensed,
        hover = _props.hover,
        responsive = _props.responsive,
        className = _props.className,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['striped', 'bordered', 'condensed', 'hover', 'responsive', 'className']);

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["f" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["d" /* getClassSet */])(bsProps), (_extends2 = {}, _extends2[Object(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["e" /* prefix */])(bsProps, 'striped')] = striped, _extends2[Object(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["e" /* prefix */])(bsProps, 'bordered')] = bordered, _extends2[Object(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["e" /* prefix */])(bsProps, 'condensed')] = condensed, _extends2[Object(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["e" /* prefix */])(bsProps, 'hover')] = hover, _extends2));

    var table = __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('table', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, elementProps, {
      className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, classes)
    }));

    if (responsive) {
      return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        'div',
        { className: Object(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["e" /* prefix */])(bsProps, 'responsive') },
        table
      );
    }

    return table;
  };

  return Table;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

Table.propTypes = propTypes;
Table.defaultProps = defaultProps;

/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["a" /* bsClass */])('table', Table));

/***/ }),
/* 331 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_isRequiredForA11y__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_isRequiredForA11y___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_isRequiredForA11y__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_uncontrollable__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_uncontrollable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_uncontrollable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Nav__ = __webpack_require__(146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__NavItem__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__TabContainer__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__TabContent__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__utils_bootstrapUtils__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__utils_ValidComponentChildren__ = __webpack_require__(18);

















var TabContainer = __WEBPACK_IMPORTED_MODULE_11__TabContainer__["a" /* default */].ControlledComponent;

var propTypes = {
  /**
   * Mark the Tab with a matching `eventKey` as active.
   *
   * @controllable onSelect
   */
  activeKey: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any,

  /**
   * Navigation style
   */
  bsStyle: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOf(['tabs', 'pills']),

  animation: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,

  id: __WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_isRequiredForA11y___default()(__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number])),

  /**
   * Callback fired when a Tab is selected.
   *
   * ```js
   * function (
   * 	Any eventKey,
   * 	SyntheticEvent event?
   * )
   * ```
   *
   * @controllable activeKey
   */
  onSelect: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,

  /**
   * Wait until the first "enter" transition to mount tabs (add them to the DOM)
   */
  mountOnEnter: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,

  /**
   * Unmount tabs (remove it from the DOM) when it is no longer visible
   */
  unmountOnExit: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool
};

var defaultProps = {
  bsStyle: 'tabs',
  animation: true,
  mountOnEnter: false,
  unmountOnExit: false
};

function getDefaultActiveKey(children) {
  var defaultActiveKey = void 0;
  __WEBPACK_IMPORTED_MODULE_14__utils_ValidComponentChildren__["a" /* default */].forEach(children, function (child) {
    if (defaultActiveKey == null) {
      defaultActiveKey = child.props.eventKey;
    }
  });

  return defaultActiveKey;
}

var Tabs = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Tabs, _React$Component);

  function Tabs() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, Tabs);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  Tabs.prototype.renderTab = function renderTab(child) {
    var _child$props = child.props,
        title = _child$props.title,
        eventKey = _child$props.eventKey,
        disabled = _child$props.disabled,
        tabClassName = _child$props.tabClassName;

    if (title == null) {
      return null;
    }

    return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_10__NavItem__["a" /* default */],
      {
        eventKey: eventKey,
        disabled: disabled,
        className: tabClassName
      },
      title
    );
  };

  Tabs.prototype.render = function render() {
    var _props = this.props,
        id = _props.id,
        onSelect = _props.onSelect,
        animation = _props.animation,
        mountOnEnter = _props.mountOnEnter,
        unmountOnExit = _props.unmountOnExit,
        bsClass = _props.bsClass,
        className = _props.className,
        style = _props.style,
        children = _props.children,
        _props$activeKey = _props.activeKey,
        activeKey = _props$activeKey === undefined ? getDefaultActiveKey(children) : _props$activeKey,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['id', 'onSelect', 'animation', 'mountOnEnter', 'unmountOnExit', 'bsClass', 'className', 'style', 'children', 'activeKey']);

    return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
      TabContainer,
      {
        id: id,
        activeKey: activeKey,
        onSelect: onSelect,
        className: className,
        style: style
      },
      __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_9__Nav__["a" /* default */],
          __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, props, {
            role: 'tablist'
          }),
          __WEBPACK_IMPORTED_MODULE_14__utils_ValidComponentChildren__["a" /* default */].map(children, this.renderTab)
        ),
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_12__TabContent__["a" /* default */],
          {
            bsClass: bsClass,
            animation: animation,
            mountOnEnter: mountOnEnter,
            unmountOnExit: unmountOnExit
          },
          children
        )
      )
    );
  };

  return Tabs;
}(__WEBPACK_IMPORTED_MODULE_5_react___default.a.Component);

Tabs.propTypes = propTypes;
Tabs.defaultProps = defaultProps;

Object(__WEBPACK_IMPORTED_MODULE_13__utils_bootstrapUtils__["a" /* bsClass */])('tab', Tabs);

/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_8_uncontrollable___default()(Tabs, { activeKey: 'onSelect' }));

/***/ }),
/* 332 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__SafeAnchor__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__ = __webpack_require__(8);












var propTypes = {
  /**
   * src property that is passed down to the image inside this component
   */
  src: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string,
  /**
   * alt property that is passed down to the image inside this component
   */
  alt: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string,
  /**
   * href property that is passed down to the image inside this component
   */
  href: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string,
  /**
   * onError callback that is passed down to the image inside this component
   */
  onError: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
  /**
   * onLoad callback that is passed down to the image inside this component
   */
  onLoad: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func
};

var Thumbnail = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Thumbnail, _React$Component);

  function Thumbnail() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, Thumbnail);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  Thumbnail.prototype.render = function render() {
    var _props = this.props,
        src = _props.src,
        alt = _props.alt,
        onError = _props.onError,
        onLoad = _props.onLoad,
        className = _props.className,
        children = _props.children,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['src', 'alt', 'onError', 'onLoad', 'className', 'children']);

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["f" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var Component = elementProps.href ? __WEBPACK_IMPORTED_MODULE_8__SafeAnchor__["a" /* default */] : 'div';
    var classes = Object(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["d" /* getClassSet */])(bsProps);

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
      Component,
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, elementProps, {
        className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, classes)
      }),
      __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('img', { src: src, alt: alt, onError: onError, onLoad: onLoad }),
      children && __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        'div',
        { className: 'caption' },
        children
      )
    );
  };

  return Thumbnail;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

Thumbnail.propTypes = propTypes;

/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["a" /* bsClass */])('thumbnail', Thumbnail));

/***/ }),
/* 333 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_invariant__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_uncontrollable__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_uncontrollable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_uncontrollable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_createChainedFunction__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_ValidComponentChildren__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__ButtonGroup__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__ToggleButton__ = __webpack_require__(156);















var propTypes = {
  /**
   * An HTML `<input>` name for each child button.
   *
   * __Required if `type` is set to `'radio'`__
   */
  name: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,

  /**
   * The value, or array of values, of the active (pressed) buttons
   *
   * @controllable onChange
   */
  value: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.any,

  /**
   * Callback fired when a button is pressed, depending on whether the `type`
   * is `'radio'` or `'checkbox'`, `onChange` will be called with the value or
   * array of active values
   *
   * @controllable values
   */
  onChange: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,

  /**
   * The input `type` of the rendered buttons, determines the toggle behavior
   * of the buttons
   */
  type: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.oneOf(['checkbox', 'radio']).isRequired
};

var defaultProps = {
  type: 'radio'
};

var ToggleButtonGroup = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(ToggleButtonGroup, _React$Component);

  function ToggleButtonGroup() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, ToggleButtonGroup);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  ToggleButtonGroup.prototype.getValues = function getValues() {
    var value = this.props.value;

    return value == null ? [] : [].concat(value);
  };

  ToggleButtonGroup.prototype.handleToggle = function handleToggle(value) {
    var _props = this.props,
        type = _props.type,
        onChange = _props.onChange;

    var values = this.getValues();
    var isActive = values.indexOf(value) !== -1;

    if (type === 'radio') {
      if (!isActive) {
        onChange(value);
      }
      return;
    }

    if (isActive) {
      onChange(values.filter(function (n) {
        return n !== value;
      }));
    } else {
      onChange([].concat(values, [value]));
    }
  };

  ToggleButtonGroup.prototype.render = function render() {
    var _this2 = this;

    var _props2 = this.props,
        children = _props2.children,
        type = _props2.type,
        name = _props2.name,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props2, ['children', 'type', 'name']);

    var values = this.getValues();

    !(type !== 'radio' || !!name) ?  false ? invariant(false, 'A `name` is required to group the toggle buttons when the `type` ' + 'is set to "radio"') : __WEBPACK_IMPORTED_MODULE_7_invariant___default()(false) : void 0;

    delete props.onChange;
    delete props.value;

    // the data attribute is required b/c twbs css uses it in the selector
    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_11__ButtonGroup__["a" /* default */],
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, props, { 'data-toggle': 'buttons' }),
      __WEBPACK_IMPORTED_MODULE_10__utils_ValidComponentChildren__["a" /* default */].map(children, function (child) {
        var _child$props = child.props,
            value = _child$props.value,
            onChange = _child$props.onChange;

        var handler = function handler() {
          return _this2.handleToggle(value);
        };

        return __WEBPACK_IMPORTED_MODULE_6_react___default.a.cloneElement(child, {
          type: type,
          name: child.name || name,
          checked: values.indexOf(value) !== -1,
          onChange: Object(__WEBPACK_IMPORTED_MODULE_9__utils_createChainedFunction__["a" /* default */])(onChange, handler)
        });
      })
    );
  };

  return ToggleButtonGroup;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

ToggleButtonGroup.propTypes = propTypes;
ToggleButtonGroup.defaultProps = defaultProps;

var UncontrolledToggleButtonGroup = __WEBPACK_IMPORTED_MODULE_8_uncontrollable___default()(ToggleButtonGroup, {
  value: 'onChange'
});

UncontrolledToggleButtonGroup.Button = __WEBPACK_IMPORTED_MODULE_12__ToggleButton__["a" /* default */];

/* unused harmony default export */ var _unused_webpack_default_export = (UncontrolledToggleButtonGroup);

/***/ }),
/* 334 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types_extra_lib_isRequiredForA11y__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types_extra_lib_isRequiredForA11y___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_prop_types_extra_lib_isRequiredForA11y__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__ = __webpack_require__(8);












var propTypes = {
  /**
   * An html id attribute, necessary for accessibility
   * @type {string|number}
   * @required
   */
  id: __WEBPACK_IMPORTED_MODULE_8_prop_types_extra_lib_isRequiredForA11y___default()(__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.number])),

  /**
   * Sets the direction the Tooltip is positioned towards.
   */
  placement: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.oneOf(['top', 'right', 'bottom', 'left']),

  /**
   * The "top" position value for the Tooltip.
   */
  positionTop: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string]),
  /**
   * The "left" position value for the Tooltip.
   */
  positionLeft: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string]),

  /**
   * The "top" position value for the Tooltip arrow.
   */
  arrowOffsetTop: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string]),
  /**
   * The "left" position value for the Tooltip arrow.
   */
  arrowOffsetLeft: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string])
};

var defaultProps = {
  placement: 'right'
};

var Tooltip = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Tooltip, _React$Component);

  function Tooltip() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, Tooltip);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  Tooltip.prototype.render = function render() {
    var _extends2;

    var _props = this.props,
        placement = _props.placement,
        positionTop = _props.positionTop,
        positionLeft = _props.positionLeft,
        arrowOffsetTop = _props.arrowOffsetTop,
        arrowOffsetLeft = _props.arrowOffsetLeft,
        className = _props.className,
        style = _props.style,
        children = _props.children,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['placement', 'positionTop', 'positionLeft', 'arrowOffsetTop', 'arrowOffsetLeft', 'className', 'style', 'children']);

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["f" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["d" /* getClassSet */])(bsProps), (_extends2 = {}, _extends2[placement] = true, _extends2));

    var outerStyle = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
      top: positionTop,
      left: positionLeft
    }, style);

    var arrowStyle = {
      top: arrowOffsetTop,
      left: arrowOffsetLeft
    };

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
      'div',
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, elementProps, {
        role: 'tooltip',
        className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, classes),
        style: outerStyle
      }),
      __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('div', { className: Object(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["e" /* prefix */])(bsProps, 'arrow'), style: arrowStyle }),
      __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        'div',
        { className: Object(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["e" /* prefix */])(bsProps, 'inner') },
        children
      )
    );
  };

  return Tooltip;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

Tooltip.propTypes = propTypes;
Tooltip.defaultProps = defaultProps;

/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["a" /* bsClass */])('tooltip', Tooltip));

/***/ }),
/* 335 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_StyleConfig__ = __webpack_require__(15);











var Well = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Well, _React$Component);

  function Well() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, Well);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  Well.prototype.render = function render() {
    var _props = this.props,
        className = _props.className,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['className']);

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["f" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["d" /* getClassSet */])(bsProps);

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('div', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, elementProps, {
      className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, classes)
    }));
  };

  return Well;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["a" /* bsClass */])('well', Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["b" /* bsSizes */])([__WEBPACK_IMPORTED_MODULE_8__utils_StyleConfig__["c" /* Size */].LARGE, __WEBPACK_IMPORTED_MODULE_8__utils_StyleConfig__["c" /* Size */].SMALL], Well)));

/***/ }),
/* 336 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__bootstrapUtils__ = __webpack_require__(8);
/* unused harmony reexport bootstrapUtils */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__createChainedFunction__ = __webpack_require__(12);
/* unused harmony reexport createChainedFunction */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ValidComponentChildren__ = __webpack_require__(18);
/* unused harmony reexport ValidComponentChildren */







/***/ }),
/* 337 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * jQuery JavaScript Library v3.2.1
 * https://jquery.com/
 *
 * Includes Sizzle.js
 * https://sizzlejs.com/
 *
 * Copyright JS Foundation and other contributors
 * Released under the MIT license
 * https://jquery.org/license
 *
 * Date: 2017-03-20T18:59Z
 */
( function( global, factory ) {

	"use strict";

	if ( typeof module === "object" && typeof module.exports === "object" ) {

		// For CommonJS and CommonJS-like environments where a proper `window`
		// is present, execute the factory and get jQuery.
		// For environments that do not have a `window` with a `document`
		// (such as Node.js), expose a factory as module.exports.
		// This accentuates the need for the creation of a real `window`.
		// e.g. var jQuery = require("jquery")(window);
		// See ticket #14549 for more info.
		module.exports = global.document ?
			factory( global, true ) :
			function( w ) {
				if ( !w.document ) {
					throw new Error( "jQuery requires a window with a document" );
				}
				return factory( w );
			};
	} else {
		factory( global );
	}

// Pass this if window is not defined yet
} )( typeof window !== "undefined" ? window : this, function( window, noGlobal ) {

// Edge <= 12 - 13+, Firefox <=18 - 45+, IE 10 - 11, Safari 5.1 - 9+, iOS 6 - 9.1
// throw exceptions when non-strict code (e.g., ASP.NET 4.5) accesses strict mode
// arguments.callee.caller (trac-13335). But as of jQuery 3.0 (2016), strict mode should be common
// enough that all such attempts are guarded in a try block.
"use strict";

var arr = [];

var document = window.document;

var getProto = Object.getPrototypeOf;

var slice = arr.slice;

var concat = arr.concat;

var push = arr.push;

var indexOf = arr.indexOf;

var class2type = {};

var toString = class2type.toString;

var hasOwn = class2type.hasOwnProperty;

var fnToString = hasOwn.toString;

var ObjectFunctionString = fnToString.call( Object );

var support = {};



	function DOMEval( code, doc ) {
		doc = doc || document;

		var script = doc.createElement( "script" );

		script.text = code;
		doc.head.appendChild( script ).parentNode.removeChild( script );
	}
/* global Symbol */
// Defining this global in .eslintrc.json would create a danger of using the global
// unguarded in another place, it seems safer to define global only for this module



var
	version = "3.2.1",

	// Define a local copy of jQuery
	jQuery = function( selector, context ) {

		// The jQuery object is actually just the init constructor 'enhanced'
		// Need init if jQuery is called (just allow error to be thrown if not included)
		return new jQuery.fn.init( selector, context );
	},

	// Support: Android <=4.0 only
	// Make sure we trim BOM and NBSP
	rtrim = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g,

	// Matches dashed string for camelizing
	rmsPrefix = /^-ms-/,
	rdashAlpha = /-([a-z])/g,

	// Used by jQuery.camelCase as callback to replace()
	fcamelCase = function( all, letter ) {
		return letter.toUpperCase();
	};

jQuery.fn = jQuery.prototype = {

	// The current version of jQuery being used
	jquery: version,

	constructor: jQuery,

	// The default length of a jQuery object is 0
	length: 0,

	toArray: function() {
		return slice.call( this );
	},

	// Get the Nth element in the matched element set OR
	// Get the whole matched element set as a clean array
	get: function( num ) {

		// Return all the elements in a clean array
		if ( num == null ) {
			return slice.call( this );
		}

		// Return just the one element from the set
		return num < 0 ? this[ num + this.length ] : this[ num ];
	},

	// Take an array of elements and push it onto the stack
	// (returning the new matched element set)
	pushStack: function( elems ) {

		// Build a new jQuery matched element set
		var ret = jQuery.merge( this.constructor(), elems );

		// Add the old object onto the stack (as a reference)
		ret.prevObject = this;

		// Return the newly-formed element set
		return ret;
	},

	// Execute a callback for every element in the matched set.
	each: function( callback ) {
		return jQuery.each( this, callback );
	},

	map: function( callback ) {
		return this.pushStack( jQuery.map( this, function( elem, i ) {
			return callback.call( elem, i, elem );
		} ) );
	},

	slice: function() {
		return this.pushStack( slice.apply( this, arguments ) );
	},

	first: function() {
		return this.eq( 0 );
	},

	last: function() {
		return this.eq( -1 );
	},

	eq: function( i ) {
		var len = this.length,
			j = +i + ( i < 0 ? len : 0 );
		return this.pushStack( j >= 0 && j < len ? [ this[ j ] ] : [] );
	},

	end: function() {
		return this.prevObject || this.constructor();
	},

	// For internal use only.
	// Behaves like an Array's method, not like a jQuery method.
	push: push,
	sort: arr.sort,
	splice: arr.splice
};

jQuery.extend = jQuery.fn.extend = function() {
	var options, name, src, copy, copyIsArray, clone,
		target = arguments[ 0 ] || {},
		i = 1,
		length = arguments.length,
		deep = false;

	// Handle a deep copy situation
	if ( typeof target === "boolean" ) {
		deep = target;

		// Skip the boolean and the target
		target = arguments[ i ] || {};
		i++;
	}

	// Handle case when target is a string or something (possible in deep copy)
	if ( typeof target !== "object" && !jQuery.isFunction( target ) ) {
		target = {};
	}

	// Extend jQuery itself if only one argument is passed
	if ( i === length ) {
		target = this;
		i--;
	}

	for ( ; i < length; i++ ) {

		// Only deal with non-null/undefined values
		if ( ( options = arguments[ i ] ) != null ) {

			// Extend the base object
			for ( name in options ) {
				src = target[ name ];
				copy = options[ name ];

				// Prevent never-ending loop
				if ( target === copy ) {
					continue;
				}

				// Recurse if we're merging plain objects or arrays
				if ( deep && copy && ( jQuery.isPlainObject( copy ) ||
					( copyIsArray = Array.isArray( copy ) ) ) ) {

					if ( copyIsArray ) {
						copyIsArray = false;
						clone = src && Array.isArray( src ) ? src : [];

					} else {
						clone = src && jQuery.isPlainObject( src ) ? src : {};
					}

					// Never move original objects, clone them
					target[ name ] = jQuery.extend( deep, clone, copy );

				// Don't bring in undefined values
				} else if ( copy !== undefined ) {
					target[ name ] = copy;
				}
			}
		}
	}

	// Return the modified object
	return target;
};

jQuery.extend( {

	// Unique for each copy of jQuery on the page
	expando: "jQuery" + ( version + Math.random() ).replace( /\D/g, "" ),

	// Assume jQuery is ready without the ready module
	isReady: true,

	error: function( msg ) {
		throw new Error( msg );
	},

	noop: function() {},

	isFunction: function( obj ) {
		return jQuery.type( obj ) === "function";
	},

	isWindow: function( obj ) {
		return obj != null && obj === obj.window;
	},

	isNumeric: function( obj ) {

		// As of jQuery 3.0, isNumeric is limited to
		// strings and numbers (primitives or objects)
		// that can be coerced to finite numbers (gh-2662)
		var type = jQuery.type( obj );
		return ( type === "number" || type === "string" ) &&

			// parseFloat NaNs numeric-cast false positives ("")
			// ...but misinterprets leading-number strings, particularly hex literals ("0x...")
			// subtraction forces infinities to NaN
			!isNaN( obj - parseFloat( obj ) );
	},

	isPlainObject: function( obj ) {
		var proto, Ctor;

		// Detect obvious negatives
		// Use toString instead of jQuery.type to catch host objects
		if ( !obj || toString.call( obj ) !== "[object Object]" ) {
			return false;
		}

		proto = getProto( obj );

		// Objects with no prototype (e.g., `Object.create( null )`) are plain
		if ( !proto ) {
			return true;
		}

		// Objects with prototype are plain iff they were constructed by a global Object function
		Ctor = hasOwn.call( proto, "constructor" ) && proto.constructor;
		return typeof Ctor === "function" && fnToString.call( Ctor ) === ObjectFunctionString;
	},

	isEmptyObject: function( obj ) {

		/* eslint-disable no-unused-vars */
		// See https://github.com/eslint/eslint/issues/6125
		var name;

		for ( name in obj ) {
			return false;
		}
		return true;
	},

	type: function( obj ) {
		if ( obj == null ) {
			return obj + "";
		}

		// Support: Android <=2.3 only (functionish RegExp)
		return typeof obj === "object" || typeof obj === "function" ?
			class2type[ toString.call( obj ) ] || "object" :
			typeof obj;
	},

	// Evaluates a script in a global context
	globalEval: function( code ) {
		DOMEval( code );
	},

	// Convert dashed to camelCase; used by the css and data modules
	// Support: IE <=9 - 11, Edge 12 - 13
	// Microsoft forgot to hump their vendor prefix (#9572)
	camelCase: function( string ) {
		return string.replace( rmsPrefix, "ms-" ).replace( rdashAlpha, fcamelCase );
	},

	each: function( obj, callback ) {
		var length, i = 0;

		if ( isArrayLike( obj ) ) {
			length = obj.length;
			for ( ; i < length; i++ ) {
				if ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {
					break;
				}
			}
		} else {
			for ( i in obj ) {
				if ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {
					break;
				}
			}
		}

		return obj;
	},

	// Support: Android <=4.0 only
	trim: function( text ) {
		return text == null ?
			"" :
			( text + "" ).replace( rtrim, "" );
	},

	// results is for internal usage only
	makeArray: function( arr, results ) {
		var ret = results || [];

		if ( arr != null ) {
			if ( isArrayLike( Object( arr ) ) ) {
				jQuery.merge( ret,
					typeof arr === "string" ?
					[ arr ] : arr
				);
			} else {
				push.call( ret, arr );
			}
		}

		return ret;
	},

	inArray: function( elem, arr, i ) {
		return arr == null ? -1 : indexOf.call( arr, elem, i );
	},

	// Support: Android <=4.0 only, PhantomJS 1 only
	// push.apply(_, arraylike) throws on ancient WebKit
	merge: function( first, second ) {
		var len = +second.length,
			j = 0,
			i = first.length;

		for ( ; j < len; j++ ) {
			first[ i++ ] = second[ j ];
		}

		first.length = i;

		return first;
	},

	grep: function( elems, callback, invert ) {
		var callbackInverse,
			matches = [],
			i = 0,
			length = elems.length,
			callbackExpect = !invert;

		// Go through the array, only saving the items
		// that pass the validator function
		for ( ; i < length; i++ ) {
			callbackInverse = !callback( elems[ i ], i );
			if ( callbackInverse !== callbackExpect ) {
				matches.push( elems[ i ] );
			}
		}

		return matches;
	},

	// arg is for internal usage only
	map: function( elems, callback, arg ) {
		var length, value,
			i = 0,
			ret = [];

		// Go through the array, translating each of the items to their new values
		if ( isArrayLike( elems ) ) {
			length = elems.length;
			for ( ; i < length; i++ ) {
				value = callback( elems[ i ], i, arg );

				if ( value != null ) {
					ret.push( value );
				}
			}

		// Go through every key on the object,
		} else {
			for ( i in elems ) {
				value = callback( elems[ i ], i, arg );

				if ( value != null ) {
					ret.push( value );
				}
			}
		}

		// Flatten any nested arrays
		return concat.apply( [], ret );
	},

	// A global GUID counter for objects
	guid: 1,

	// Bind a function to a context, optionally partially applying any
	// arguments.
	proxy: function( fn, context ) {
		var tmp, args, proxy;

		if ( typeof context === "string" ) {
			tmp = fn[ context ];
			context = fn;
			fn = tmp;
		}

		// Quick check to determine if target is callable, in the spec
		// this throws a TypeError, but we will just return undefined.
		if ( !jQuery.isFunction( fn ) ) {
			return undefined;
		}

		// Simulated bind
		args = slice.call( arguments, 2 );
		proxy = function() {
			return fn.apply( context || this, args.concat( slice.call( arguments ) ) );
		};

		// Set the guid of unique handler to the same of original handler, so it can be removed
		proxy.guid = fn.guid = fn.guid || jQuery.guid++;

		return proxy;
	},

	now: Date.now,

	// jQuery.support is not used in Core but other projects attach their
	// properties to it so it needs to exist.
	support: support
} );

if ( typeof Symbol === "function" ) {
	jQuery.fn[ Symbol.iterator ] = arr[ Symbol.iterator ];
}

// Populate the class2type map
jQuery.each( "Boolean Number String Function Array Date RegExp Object Error Symbol".split( " " ),
function( i, name ) {
	class2type[ "[object " + name + "]" ] = name.toLowerCase();
} );

function isArrayLike( obj ) {

	// Support: real iOS 8.2 only (not reproducible in simulator)
	// `in` check used to prevent JIT error (gh-2145)
	// hasOwn isn't used here due to false negatives
	// regarding Nodelist length in IE
	var length = !!obj && "length" in obj && obj.length,
		type = jQuery.type( obj );

	if ( type === "function" || jQuery.isWindow( obj ) ) {
		return false;
	}

	return type === "array" || length === 0 ||
		typeof length === "number" && length > 0 && ( length - 1 ) in obj;
}
var Sizzle =
/*!
 * Sizzle CSS Selector Engine v2.3.3
 * https://sizzlejs.com/
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license
 * http://jquery.org/license
 *
 * Date: 2016-08-08
 */
(function( window ) {

var i,
	support,
	Expr,
	getText,
	isXML,
	tokenize,
	compile,
	select,
	outermostContext,
	sortInput,
	hasDuplicate,

	// Local document vars
	setDocument,
	document,
	docElem,
	documentIsHTML,
	rbuggyQSA,
	rbuggyMatches,
	matches,
	contains,

	// Instance-specific data
	expando = "sizzle" + 1 * new Date(),
	preferredDoc = window.document,
	dirruns = 0,
	done = 0,
	classCache = createCache(),
	tokenCache = createCache(),
	compilerCache = createCache(),
	sortOrder = function( a, b ) {
		if ( a === b ) {
			hasDuplicate = true;
		}
		return 0;
	},

	// Instance methods
	hasOwn = ({}).hasOwnProperty,
	arr = [],
	pop = arr.pop,
	push_native = arr.push,
	push = arr.push,
	slice = arr.slice,
	// Use a stripped-down indexOf as it's faster than native
	// https://jsperf.com/thor-indexof-vs-for/5
	indexOf = function( list, elem ) {
		var i = 0,
			len = list.length;
		for ( ; i < len; i++ ) {
			if ( list[i] === elem ) {
				return i;
			}
		}
		return -1;
	},

	booleans = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped",

	// Regular expressions

	// http://www.w3.org/TR/css3-selectors/#whitespace
	whitespace = "[\\x20\\t\\r\\n\\f]",

	// http://www.w3.org/TR/CSS21/syndata.html#value-def-identifier
	identifier = "(?:\\\\.|[\\w-]|[^\0-\\xa0])+",

	// Attribute selectors: http://www.w3.org/TR/selectors/#attribute-selectors
	attributes = "\\[" + whitespace + "*(" + identifier + ")(?:" + whitespace +
		// Operator (capture 2)
		"*([*^$|!~]?=)" + whitespace +
		// "Attribute values must be CSS identifiers [capture 5] or strings [capture 3 or capture 4]"
		"*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + identifier + "))|)" + whitespace +
		"*\\]",

	pseudos = ":(" + identifier + ")(?:\\((" +
		// To reduce the number of selectors needing tokenize in the preFilter, prefer arguments:
		// 1. quoted (capture 3; capture 4 or capture 5)
		"('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|" +
		// 2. simple (capture 6)
		"((?:\\\\.|[^\\\\()[\\]]|" + attributes + ")*)|" +
		// 3. anything else (capture 2)
		".*" +
		")\\)|)",

	// Leading and non-escaped trailing whitespace, capturing some non-whitespace characters preceding the latter
	rwhitespace = new RegExp( whitespace + "+", "g" ),
	rtrim = new RegExp( "^" + whitespace + "+|((?:^|[^\\\\])(?:\\\\.)*)" + whitespace + "+$", "g" ),

	rcomma = new RegExp( "^" + whitespace + "*," + whitespace + "*" ),
	rcombinators = new RegExp( "^" + whitespace + "*([>+~]|" + whitespace + ")" + whitespace + "*" ),

	rattributeQuotes = new RegExp( "=" + whitespace + "*([^\\]'\"]*?)" + whitespace + "*\\]", "g" ),

	rpseudo = new RegExp( pseudos ),
	ridentifier = new RegExp( "^" + identifier + "$" ),

	matchExpr = {
		"ID": new RegExp( "^#(" + identifier + ")" ),
		"CLASS": new RegExp( "^\\.(" + identifier + ")" ),
		"TAG": new RegExp( "^(" + identifier + "|[*])" ),
		"ATTR": new RegExp( "^" + attributes ),
		"PSEUDO": new RegExp( "^" + pseudos ),
		"CHILD": new RegExp( "^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" + whitespace +
			"*(even|odd|(([+-]|)(\\d*)n|)" + whitespace + "*(?:([+-]|)" + whitespace +
			"*(\\d+)|))" + whitespace + "*\\)|)", "i" ),
		"bool": new RegExp( "^(?:" + booleans + ")$", "i" ),
		// For use in libraries implementing .is()
		// We use this for POS matching in `select`
		"needsContext": new RegExp( "^" + whitespace + "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" +
			whitespace + "*((?:-\\d)?\\d*)" + whitespace + "*\\)|)(?=[^-]|$)", "i" )
	},

	rinputs = /^(?:input|select|textarea|button)$/i,
	rheader = /^h\d$/i,

	rnative = /^[^{]+\{\s*\[native \w/,

	// Easily-parseable/retrievable ID or TAG or CLASS selectors
	rquickExpr = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,

	rsibling = /[+~]/,

	// CSS escapes
	// http://www.w3.org/TR/CSS21/syndata.html#escaped-characters
	runescape = new RegExp( "\\\\([\\da-f]{1,6}" + whitespace + "?|(" + whitespace + ")|.)", "ig" ),
	funescape = function( _, escaped, escapedWhitespace ) {
		var high = "0x" + escaped - 0x10000;
		// NaN means non-codepoint
		// Support: Firefox<24
		// Workaround erroneous numeric interpretation of +"0x"
		return high !== high || escapedWhitespace ?
			escaped :
			high < 0 ?
				// BMP codepoint
				String.fromCharCode( high + 0x10000 ) :
				// Supplemental Plane codepoint (surrogate pair)
				String.fromCharCode( high >> 10 | 0xD800, high & 0x3FF | 0xDC00 );
	},

	// CSS string/identifier serialization
	// https://drafts.csswg.org/cssom/#common-serializing-idioms
	rcssescape = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\0-\x1f\x7f-\uFFFF\w-]/g,
	fcssescape = function( ch, asCodePoint ) {
		if ( asCodePoint ) {

			// U+0000 NULL becomes U+FFFD REPLACEMENT CHARACTER
			if ( ch === "\0" ) {
				return "\uFFFD";
			}

			// Control characters and (dependent upon position) numbers get escaped as code points
			return ch.slice( 0, -1 ) + "\\" + ch.charCodeAt( ch.length - 1 ).toString( 16 ) + " ";
		}

		// Other potentially-special ASCII characters get backslash-escaped
		return "\\" + ch;
	},

	// Used for iframes
	// See setDocument()
	// Removing the function wrapper causes a "Permission Denied"
	// error in IE
	unloadHandler = function() {
		setDocument();
	},

	disabledAncestor = addCombinator(
		function( elem ) {
			return elem.disabled === true && ("form" in elem || "label" in elem);
		},
		{ dir: "parentNode", next: "legend" }
	);

// Optimize for push.apply( _, NodeList )
try {
	push.apply(
		(arr = slice.call( preferredDoc.childNodes )),
		preferredDoc.childNodes
	);
	// Support: Android<4.0
	// Detect silently failing push.apply
	arr[ preferredDoc.childNodes.length ].nodeType;
} catch ( e ) {
	push = { apply: arr.length ?

		// Leverage slice if possible
		function( target, els ) {
			push_native.apply( target, slice.call(els) );
		} :

		// Support: IE<9
		// Otherwise append directly
		function( target, els ) {
			var j = target.length,
				i = 0;
			// Can't trust NodeList.length
			while ( (target[j++] = els[i++]) ) {}
			target.length = j - 1;
		}
	};
}

function Sizzle( selector, context, results, seed ) {
	var m, i, elem, nid, match, groups, newSelector,
		newContext = context && context.ownerDocument,

		// nodeType defaults to 9, since context defaults to document
		nodeType = context ? context.nodeType : 9;

	results = results || [];

	// Return early from calls with invalid selector or context
	if ( typeof selector !== "string" || !selector ||
		nodeType !== 1 && nodeType !== 9 && nodeType !== 11 ) {

		return results;
	}

	// Try to shortcut find operations (as opposed to filters) in HTML documents
	if ( !seed ) {

		if ( ( context ? context.ownerDocument || context : preferredDoc ) !== document ) {
			setDocument( context );
		}
		context = context || document;

		if ( documentIsHTML ) {

			// If the selector is sufficiently simple, try using a "get*By*" DOM method
			// (excepting DocumentFragment context, where the methods don't exist)
			if ( nodeType !== 11 && (match = rquickExpr.exec( selector )) ) {

				// ID selector
				if ( (m = match[1]) ) {

					// Document context
					if ( nodeType === 9 ) {
						if ( (elem = context.getElementById( m )) ) {

							// Support: IE, Opera, Webkit
							// TODO: identify versions
							// getElementById can match elements by name instead of ID
							if ( elem.id === m ) {
								results.push( elem );
								return results;
							}
						} else {
							return results;
						}

					// Element context
					} else {

						// Support: IE, Opera, Webkit
						// TODO: identify versions
						// getElementById can match elements by name instead of ID
						if ( newContext && (elem = newContext.getElementById( m )) &&
							contains( context, elem ) &&
							elem.id === m ) {

							results.push( elem );
							return results;
						}
					}

				// Type selector
				} else if ( match[2] ) {
					push.apply( results, context.getElementsByTagName( selector ) );
					return results;

				// Class selector
				} else if ( (m = match[3]) && support.getElementsByClassName &&
					context.getElementsByClassName ) {

					push.apply( results, context.getElementsByClassName( m ) );
					return results;
				}
			}

			// Take advantage of querySelectorAll
			if ( support.qsa &&
				!compilerCache[ selector + " " ] &&
				(!rbuggyQSA || !rbuggyQSA.test( selector )) ) {

				if ( nodeType !== 1 ) {
					newContext = context;
					newSelector = selector;

				// qSA looks outside Element context, which is not what we want
				// Thanks to Andrew Dupont for this workaround technique
				// Support: IE <=8
				// Exclude object elements
				} else if ( context.nodeName.toLowerCase() !== "object" ) {

					// Capture the context ID, setting it first if necessary
					if ( (nid = context.getAttribute( "id" )) ) {
						nid = nid.replace( rcssescape, fcssescape );
					} else {
						context.setAttribute( "id", (nid = expando) );
					}

					// Prefix every selector in the list
					groups = tokenize( selector );
					i = groups.length;
					while ( i-- ) {
						groups[i] = "#" + nid + " " + toSelector( groups[i] );
					}
					newSelector = groups.join( "," );

					// Expand context for sibling selectors
					newContext = rsibling.test( selector ) && testContext( context.parentNode ) ||
						context;
				}

				if ( newSelector ) {
					try {
						push.apply( results,
							newContext.querySelectorAll( newSelector )
						);
						return results;
					} catch ( qsaError ) {
					} finally {
						if ( nid === expando ) {
							context.removeAttribute( "id" );
						}
					}
				}
			}
		}
	}

	// All others
	return select( selector.replace( rtrim, "$1" ), context, results, seed );
}

/**
 * Create key-value caches of limited size
 * @returns {function(string, object)} Returns the Object data after storing it on itself with
 *	property name the (space-suffixed) string and (if the cache is larger than Expr.cacheLength)
 *	deleting the oldest entry
 */
function createCache() {
	var keys = [];

	function cache( key, value ) {
		// Use (key + " ") to avoid collision with native prototype properties (see Issue #157)
		if ( keys.push( key + " " ) > Expr.cacheLength ) {
			// Only keep the most recent entries
			delete cache[ keys.shift() ];
		}
		return (cache[ key + " " ] = value);
	}
	return cache;
}

/**
 * Mark a function for special use by Sizzle
 * @param {Function} fn The function to mark
 */
function markFunction( fn ) {
	fn[ expando ] = true;
	return fn;
}

/**
 * Support testing using an element
 * @param {Function} fn Passed the created element and returns a boolean result
 */
function assert( fn ) {
	var el = document.createElement("fieldset");

	try {
		return !!fn( el );
	} catch (e) {
		return false;
	} finally {
		// Remove from its parent by default
		if ( el.parentNode ) {
			el.parentNode.removeChild( el );
		}
		// release memory in IE
		el = null;
	}
}

/**
 * Adds the same handler for all of the specified attrs
 * @param {String} attrs Pipe-separated list of attributes
 * @param {Function} handler The method that will be applied
 */
function addHandle( attrs, handler ) {
	var arr = attrs.split("|"),
		i = arr.length;

	while ( i-- ) {
		Expr.attrHandle[ arr[i] ] = handler;
	}
}

/**
 * Checks document order of two siblings
 * @param {Element} a
 * @param {Element} b
 * @returns {Number} Returns less than 0 if a precedes b, greater than 0 if a follows b
 */
function siblingCheck( a, b ) {
	var cur = b && a,
		diff = cur && a.nodeType === 1 && b.nodeType === 1 &&
			a.sourceIndex - b.sourceIndex;

	// Use IE sourceIndex if available on both nodes
	if ( diff ) {
		return diff;
	}

	// Check if b follows a
	if ( cur ) {
		while ( (cur = cur.nextSibling) ) {
			if ( cur === b ) {
				return -1;
			}
		}
	}

	return a ? 1 : -1;
}

/**
 * Returns a function to use in pseudos for input types
 * @param {String} type
 */
function createInputPseudo( type ) {
	return function( elem ) {
		var name = elem.nodeName.toLowerCase();
		return name === "input" && elem.type === type;
	};
}

/**
 * Returns a function to use in pseudos for buttons
 * @param {String} type
 */
function createButtonPseudo( type ) {
	return function( elem ) {
		var name = elem.nodeName.toLowerCase();
		return (name === "input" || name === "button") && elem.type === type;
	};
}

/**
 * Returns a function to use in pseudos for :enabled/:disabled
 * @param {Boolean} disabled true for :disabled; false for :enabled
 */
function createDisabledPseudo( disabled ) {

	// Known :disabled false positives: fieldset[disabled] > legend:nth-of-type(n+2) :can-disable
	return function( elem ) {

		// Only certain elements can match :enabled or :disabled
		// https://html.spec.whatwg.org/multipage/scripting.html#selector-enabled
		// https://html.spec.whatwg.org/multipage/scripting.html#selector-disabled
		if ( "form" in elem ) {

			// Check for inherited disabledness on relevant non-disabled elements:
			// * listed form-associated elements in a disabled fieldset
			//   https://html.spec.whatwg.org/multipage/forms.html#category-listed
			//   https://html.spec.whatwg.org/multipage/forms.html#concept-fe-disabled
			// * option elements in a disabled optgroup
			//   https://html.spec.whatwg.org/multipage/forms.html#concept-option-disabled
			// All such elements have a "form" property.
			if ( elem.parentNode && elem.disabled === false ) {

				// Option elements defer to a parent optgroup if present
				if ( "label" in elem ) {
					if ( "label" in elem.parentNode ) {
						return elem.parentNode.disabled === disabled;
					} else {
						return elem.disabled === disabled;
					}
				}

				// Support: IE 6 - 11
				// Use the isDisabled shortcut property to check for disabled fieldset ancestors
				return elem.isDisabled === disabled ||

					// Where there is no isDisabled, check manually
					/* jshint -W018 */
					elem.isDisabled !== !disabled &&
						disabledAncestor( elem ) === disabled;
			}

			return elem.disabled === disabled;

		// Try to winnow out elements that can't be disabled before trusting the disabled property.
		// Some victims get caught in our net (label, legend, menu, track), but it shouldn't
		// even exist on them, let alone have a boolean value.
		} else if ( "label" in elem ) {
			return elem.disabled === disabled;
		}

		// Remaining elements are neither :enabled nor :disabled
		return false;
	};
}

/**
 * Returns a function to use in pseudos for positionals
 * @param {Function} fn
 */
function createPositionalPseudo( fn ) {
	return markFunction(function( argument ) {
		argument = +argument;
		return markFunction(function( seed, matches ) {
			var j,
				matchIndexes = fn( [], seed.length, argument ),
				i = matchIndexes.length;

			// Match elements found at the specified indexes
			while ( i-- ) {
				if ( seed[ (j = matchIndexes[i]) ] ) {
					seed[j] = !(matches[j] = seed[j]);
				}
			}
		});
	});
}

/**
 * Checks a node for validity as a Sizzle context
 * @param {Element|Object=} context
 * @returns {Element|Object|Boolean} The input node if acceptable, otherwise a falsy value
 */
function testContext( context ) {
	return context && typeof context.getElementsByTagName !== "undefined" && context;
}

// Expose support vars for convenience
support = Sizzle.support = {};

/**
 * Detects XML nodes
 * @param {Element|Object} elem An element or a document
 * @returns {Boolean} True iff elem is a non-HTML XML node
 */
isXML = Sizzle.isXML = function( elem ) {
	// documentElement is verified for cases where it doesn't yet exist
	// (such as loading iframes in IE - #4833)
	var documentElement = elem && (elem.ownerDocument || elem).documentElement;
	return documentElement ? documentElement.nodeName !== "HTML" : false;
};

/**
 * Sets document-related variables once based on the current document
 * @param {Element|Object} [doc] An element or document object to use to set the document
 * @returns {Object} Returns the current document
 */
setDocument = Sizzle.setDocument = function( node ) {
	var hasCompare, subWindow,
		doc = node ? node.ownerDocument || node : preferredDoc;

	// Return early if doc is invalid or already selected
	if ( doc === document || doc.nodeType !== 9 || !doc.documentElement ) {
		return document;
	}

	// Update global variables
	document = doc;
	docElem = document.documentElement;
	documentIsHTML = !isXML( document );

	// Support: IE 9-11, Edge
	// Accessing iframe documents after unload throws "permission denied" errors (jQuery #13936)
	if ( preferredDoc !== document &&
		(subWindow = document.defaultView) && subWindow.top !== subWindow ) {

		// Support: IE 11, Edge
		if ( subWindow.addEventListener ) {
			subWindow.addEventListener( "unload", unloadHandler, false );

		// Support: IE 9 - 10 only
		} else if ( subWindow.attachEvent ) {
			subWindow.attachEvent( "onunload", unloadHandler );
		}
	}

	/* Attributes
	---------------------------------------------------------------------- */

	// Support: IE<8
	// Verify that getAttribute really returns attributes and not properties
	// (excepting IE8 booleans)
	support.attributes = assert(function( el ) {
		el.className = "i";
		return !el.getAttribute("className");
	});

	/* getElement(s)By*
	---------------------------------------------------------------------- */

	// Check if getElementsByTagName("*") returns only elements
	support.getElementsByTagName = assert(function( el ) {
		el.appendChild( document.createComment("") );
		return !el.getElementsByTagName("*").length;
	});

	// Support: IE<9
	support.getElementsByClassName = rnative.test( document.getElementsByClassName );

	// Support: IE<10
	// Check if getElementById returns elements by name
	// The broken getElementById methods don't pick up programmatically-set names,
	// so use a roundabout getElementsByName test
	support.getById = assert(function( el ) {
		docElem.appendChild( el ).id = expando;
		return !document.getElementsByName || !document.getElementsByName( expando ).length;
	});

	// ID filter and find
	if ( support.getById ) {
		Expr.filter["ID"] = function( id ) {
			var attrId = id.replace( runescape, funescape );
			return function( elem ) {
				return elem.getAttribute("id") === attrId;
			};
		};
		Expr.find["ID"] = function( id, context ) {
			if ( typeof context.getElementById !== "undefined" && documentIsHTML ) {
				var elem = context.getElementById( id );
				return elem ? [ elem ] : [];
			}
		};
	} else {
		Expr.filter["ID"] =  function( id ) {
			var attrId = id.replace( runescape, funescape );
			return function( elem ) {
				var node = typeof elem.getAttributeNode !== "undefined" &&
					elem.getAttributeNode("id");
				return node && node.value === attrId;
			};
		};

		// Support: IE 6 - 7 only
		// getElementById is not reliable as a find shortcut
		Expr.find["ID"] = function( id, context ) {
			if ( typeof context.getElementById !== "undefined" && documentIsHTML ) {
				var node, i, elems,
					elem = context.getElementById( id );

				if ( elem ) {

					// Verify the id attribute
					node = elem.getAttributeNode("id");
					if ( node && node.value === id ) {
						return [ elem ];
					}

					// Fall back on getElementsByName
					elems = context.getElementsByName( id );
					i = 0;
					while ( (elem = elems[i++]) ) {
						node = elem.getAttributeNode("id");
						if ( node && node.value === id ) {
							return [ elem ];
						}
					}
				}

				return [];
			}
		};
	}

	// Tag
	Expr.find["TAG"] = support.getElementsByTagName ?
		function( tag, context ) {
			if ( typeof context.getElementsByTagName !== "undefined" ) {
				return context.getElementsByTagName( tag );

			// DocumentFragment nodes don't have gEBTN
			} else if ( support.qsa ) {
				return context.querySelectorAll( tag );
			}
		} :

		function( tag, context ) {
			var elem,
				tmp = [],
				i = 0,
				// By happy coincidence, a (broken) gEBTN appears on DocumentFragment nodes too
				results = context.getElementsByTagName( tag );

			// Filter out possible comments
			if ( tag === "*" ) {
				while ( (elem = results[i++]) ) {
					if ( elem.nodeType === 1 ) {
						tmp.push( elem );
					}
				}

				return tmp;
			}
			return results;
		};

	// Class
	Expr.find["CLASS"] = support.getElementsByClassName && function( className, context ) {
		if ( typeof context.getElementsByClassName !== "undefined" && documentIsHTML ) {
			return context.getElementsByClassName( className );
		}
	};

	/* QSA/matchesSelector
	---------------------------------------------------------------------- */

	// QSA and matchesSelector support

	// matchesSelector(:active) reports false when true (IE9/Opera 11.5)
	rbuggyMatches = [];

	// qSa(:focus) reports false when true (Chrome 21)
	// We allow this because of a bug in IE8/9 that throws an error
	// whenever `document.activeElement` is accessed on an iframe
	// So, we allow :focus to pass through QSA all the time to avoid the IE error
	// See https://bugs.jquery.com/ticket/13378
	rbuggyQSA = [];

	if ( (support.qsa = rnative.test( document.querySelectorAll )) ) {
		// Build QSA regex
		// Regex strategy adopted from Diego Perini
		assert(function( el ) {
			// Select is set to empty string on purpose
			// This is to test IE's treatment of not explicitly
			// setting a boolean content attribute,
			// since its presence should be enough
			// https://bugs.jquery.com/ticket/12359
			docElem.appendChild( el ).innerHTML = "<a id='" + expando + "'></a>" +
				"<select id='" + expando + "-\r\\' msallowcapture=''>" +
				"<option selected=''></option></select>";

			// Support: IE8, Opera 11-12.16
			// Nothing should be selected when empty strings follow ^= or $= or *=
			// The test attribute must be unknown in Opera but "safe" for WinRT
			// https://msdn.microsoft.com/en-us/library/ie/hh465388.aspx#attribute_section
			if ( el.querySelectorAll("[msallowcapture^='']").length ) {
				rbuggyQSA.push( "[*^$]=" + whitespace + "*(?:''|\"\")" );
			}

			// Support: IE8
			// Boolean attributes and "value" are not treated correctly
			if ( !el.querySelectorAll("[selected]").length ) {
				rbuggyQSA.push( "\\[" + whitespace + "*(?:value|" + booleans + ")" );
			}

			// Support: Chrome<29, Android<4.4, Safari<7.0+, iOS<7.0+, PhantomJS<1.9.8+
			if ( !el.querySelectorAll( "[id~=" + expando + "-]" ).length ) {
				rbuggyQSA.push("~=");
			}

			// Webkit/Opera - :checked should return selected option elements
			// http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
			// IE8 throws error here and will not see later tests
			if ( !el.querySelectorAll(":checked").length ) {
				rbuggyQSA.push(":checked");
			}

			// Support: Safari 8+, iOS 8+
			// https://bugs.webkit.org/show_bug.cgi?id=136851
			// In-page `selector#id sibling-combinator selector` fails
			if ( !el.querySelectorAll( "a#" + expando + "+*" ).length ) {
				rbuggyQSA.push(".#.+[+~]");
			}
		});

		assert(function( el ) {
			el.innerHTML = "<a href='' disabled='disabled'></a>" +
				"<select disabled='disabled'><option/></select>";

			// Support: Windows 8 Native Apps
			// The type and name attributes are restricted during .innerHTML assignment
			var input = document.createElement("input");
			input.setAttribute( "type", "hidden" );
			el.appendChild( input ).setAttribute( "name", "D" );

			// Support: IE8
			// Enforce case-sensitivity of name attribute
			if ( el.querySelectorAll("[name=d]").length ) {
				rbuggyQSA.push( "name" + whitespace + "*[*^$|!~]?=" );
			}

			// FF 3.5 - :enabled/:disabled and hidden elements (hidden elements are still enabled)
			// IE8 throws error here and will not see later tests
			if ( el.querySelectorAll(":enabled").length !== 2 ) {
				rbuggyQSA.push( ":enabled", ":disabled" );
			}

			// Support: IE9-11+
			// IE's :disabled selector does not pick up the children of disabled fieldsets
			docElem.appendChild( el ).disabled = true;
			if ( el.querySelectorAll(":disabled").length !== 2 ) {
				rbuggyQSA.push( ":enabled", ":disabled" );
			}

			// Opera 10-11 does not throw on post-comma invalid pseudos
			el.querySelectorAll("*,:x");
			rbuggyQSA.push(",.*:");
		});
	}

	if ( (support.matchesSelector = rnative.test( (matches = docElem.matches ||
		docElem.webkitMatchesSelector ||
		docElem.mozMatchesSelector ||
		docElem.oMatchesSelector ||
		docElem.msMatchesSelector) )) ) {

		assert(function( el ) {
			// Check to see if it's possible to do matchesSelector
			// on a disconnected node (IE 9)
			support.disconnectedMatch = matches.call( el, "*" );

			// This should fail with an exception
			// Gecko does not error, returns false instead
			matches.call( el, "[s!='']:x" );
			rbuggyMatches.push( "!=", pseudos );
		});
	}

	rbuggyQSA = rbuggyQSA.length && new RegExp( rbuggyQSA.join("|") );
	rbuggyMatches = rbuggyMatches.length && new RegExp( rbuggyMatches.join("|") );

	/* Contains
	---------------------------------------------------------------------- */
	hasCompare = rnative.test( docElem.compareDocumentPosition );

	// Element contains another
	// Purposefully self-exclusive
	// As in, an element does not contain itself
	contains = hasCompare || rnative.test( docElem.contains ) ?
		function( a, b ) {
			var adown = a.nodeType === 9 ? a.documentElement : a,
				bup = b && b.parentNode;
			return a === bup || !!( bup && bup.nodeType === 1 && (
				adown.contains ?
					adown.contains( bup ) :
					a.compareDocumentPosition && a.compareDocumentPosition( bup ) & 16
			));
		} :
		function( a, b ) {
			if ( b ) {
				while ( (b = b.parentNode) ) {
					if ( b === a ) {
						return true;
					}
				}
			}
			return false;
		};

	/* Sorting
	---------------------------------------------------------------------- */

	// Document order sorting
	sortOrder = hasCompare ?
	function( a, b ) {

		// Flag for duplicate removal
		if ( a === b ) {
			hasDuplicate = true;
			return 0;
		}

		// Sort on method existence if only one input has compareDocumentPosition
		var compare = !a.compareDocumentPosition - !b.compareDocumentPosition;
		if ( compare ) {
			return compare;
		}

		// Calculate position if both inputs belong to the same document
		compare = ( a.ownerDocument || a ) === ( b.ownerDocument || b ) ?
			a.compareDocumentPosition( b ) :

			// Otherwise we know they are disconnected
			1;

		// Disconnected nodes
		if ( compare & 1 ||
			(!support.sortDetached && b.compareDocumentPosition( a ) === compare) ) {

			// Choose the first element that is related to our preferred document
			if ( a === document || a.ownerDocument === preferredDoc && contains(preferredDoc, a) ) {
				return -1;
			}
			if ( b === document || b.ownerDocument === preferredDoc && contains(preferredDoc, b) ) {
				return 1;
			}

			// Maintain original order
			return sortInput ?
				( indexOf( sortInput, a ) - indexOf( sortInput, b ) ) :
				0;
		}

		return compare & 4 ? -1 : 1;
	} :
	function( a, b ) {
		// Exit early if the nodes are identical
		if ( a === b ) {
			hasDuplicate = true;
			return 0;
		}

		var cur,
			i = 0,
			aup = a.parentNode,
			bup = b.parentNode,
			ap = [ a ],
			bp = [ b ];

		// Parentless nodes are either documents or disconnected
		if ( !aup || !bup ) {
			return a === document ? -1 :
				b === document ? 1 :
				aup ? -1 :
				bup ? 1 :
				sortInput ?
				( indexOf( sortInput, a ) - indexOf( sortInput, b ) ) :
				0;

		// If the nodes are siblings, we can do a quick check
		} else if ( aup === bup ) {
			return siblingCheck( a, b );
		}

		// Otherwise we need full lists of their ancestors for comparison
		cur = a;
		while ( (cur = cur.parentNode) ) {
			ap.unshift( cur );
		}
		cur = b;
		while ( (cur = cur.parentNode) ) {
			bp.unshift( cur );
		}

		// Walk down the tree looking for a discrepancy
		while ( ap[i] === bp[i] ) {
			i++;
		}

		return i ?
			// Do a sibling check if the nodes have a common ancestor
			siblingCheck( ap[i], bp[i] ) :

			// Otherwise nodes in our document sort first
			ap[i] === preferredDoc ? -1 :
			bp[i] === preferredDoc ? 1 :
			0;
	};

	return document;
};

Sizzle.matches = function( expr, elements ) {
	return Sizzle( expr, null, null, elements );
};

Sizzle.matchesSelector = function( elem, expr ) {
	// Set document vars if needed
	if ( ( elem.ownerDocument || elem ) !== document ) {
		setDocument( elem );
	}

	// Make sure that attribute selectors are quoted
	expr = expr.replace( rattributeQuotes, "='$1']" );

	if ( support.matchesSelector && documentIsHTML &&
		!compilerCache[ expr + " " ] &&
		( !rbuggyMatches || !rbuggyMatches.test( expr ) ) &&
		( !rbuggyQSA     || !rbuggyQSA.test( expr ) ) ) {

		try {
			var ret = matches.call( elem, expr );

			// IE 9's matchesSelector returns false on disconnected nodes
			if ( ret || support.disconnectedMatch ||
					// As well, disconnected nodes are said to be in a document
					// fragment in IE 9
					elem.document && elem.document.nodeType !== 11 ) {
				return ret;
			}
		} catch (e) {}
	}

	return Sizzle( expr, document, null, [ elem ] ).length > 0;
};

Sizzle.contains = function( context, elem ) {
	// Set document vars if needed
	if ( ( context.ownerDocument || context ) !== document ) {
		setDocument( context );
	}
	return contains( context, elem );
};

Sizzle.attr = function( elem, name ) {
	// Set document vars if needed
	if ( ( elem.ownerDocument || elem ) !== document ) {
		setDocument( elem );
	}

	var fn = Expr.attrHandle[ name.toLowerCase() ],
		// Don't get fooled by Object.prototype properties (jQuery #13807)
		val = fn && hasOwn.call( Expr.attrHandle, name.toLowerCase() ) ?
			fn( elem, name, !documentIsHTML ) :
			undefined;

	return val !== undefined ?
		val :
		support.attributes || !documentIsHTML ?
			elem.getAttribute( name ) :
			(val = elem.getAttributeNode(name)) && val.specified ?
				val.value :
				null;
};

Sizzle.escape = function( sel ) {
	return (sel + "").replace( rcssescape, fcssescape );
};

Sizzle.error = function( msg ) {
	throw new Error( "Syntax error, unrecognized expression: " + msg );
};

/**
 * Document sorting and removing duplicates
 * @param {ArrayLike} results
 */
Sizzle.uniqueSort = function( results ) {
	var elem,
		duplicates = [],
		j = 0,
		i = 0;

	// Unless we *know* we can detect duplicates, assume their presence
	hasDuplicate = !support.detectDuplicates;
	sortInput = !support.sortStable && results.slice( 0 );
	results.sort( sortOrder );

	if ( hasDuplicate ) {
		while ( (elem = results[i++]) ) {
			if ( elem === results[ i ] ) {
				j = duplicates.push( i );
			}
		}
		while ( j-- ) {
			results.splice( duplicates[ j ], 1 );
		}
	}

	// Clear input after sorting to release objects
	// See https://github.com/jquery/sizzle/pull/225
	sortInput = null;

	return results;
};

/**
 * Utility function for retrieving the text value of an array of DOM nodes
 * @param {Array|Element} elem
 */
getText = Sizzle.getText = function( elem ) {
	var node,
		ret = "",
		i = 0,
		nodeType = elem.nodeType;

	if ( !nodeType ) {
		// If no nodeType, this is expected to be an array
		while ( (node = elem[i++]) ) {
			// Do not traverse comment nodes
			ret += getText( node );
		}
	} else if ( nodeType === 1 || nodeType === 9 || nodeType === 11 ) {
		// Use textContent for elements
		// innerText usage removed for consistency of new lines (jQuery #11153)
		if ( typeof elem.textContent === "string" ) {
			return elem.textContent;
		} else {
			// Traverse its children
			for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
				ret += getText( elem );
			}
		}
	} else if ( nodeType === 3 || nodeType === 4 ) {
		return elem.nodeValue;
	}
	// Do not include comment or processing instruction nodes

	return ret;
};

Expr = Sizzle.selectors = {

	// Can be adjusted by the user
	cacheLength: 50,

	createPseudo: markFunction,

	match: matchExpr,

	attrHandle: {},

	find: {},

	relative: {
		">": { dir: "parentNode", first: true },
		" ": { dir: "parentNode" },
		"+": { dir: "previousSibling", first: true },
		"~": { dir: "previousSibling" }
	},

	preFilter: {
		"ATTR": function( match ) {
			match[1] = match[1].replace( runescape, funescape );

			// Move the given value to match[3] whether quoted or unquoted
			match[3] = ( match[3] || match[4] || match[5] || "" ).replace( runescape, funescape );

			if ( match[2] === "~=" ) {
				match[3] = " " + match[3] + " ";
			}

			return match.slice( 0, 4 );
		},

		"CHILD": function( match ) {
			/* matches from matchExpr["CHILD"]
				1 type (only|nth|...)
				2 what (child|of-type)
				3 argument (even|odd|\d*|\d*n([+-]\d+)?|...)
				4 xn-component of xn+y argument ([+-]?\d*n|)
				5 sign of xn-component
				6 x of xn-component
				7 sign of y-component
				8 y of y-component
			*/
			match[1] = match[1].toLowerCase();

			if ( match[1].slice( 0, 3 ) === "nth" ) {
				// nth-* requires argument
				if ( !match[3] ) {
					Sizzle.error( match[0] );
				}

				// numeric x and y parameters for Expr.filter.CHILD
				// remember that false/true cast respectively to 0/1
				match[4] = +( match[4] ? match[5] + (match[6] || 1) : 2 * ( match[3] === "even" || match[3] === "odd" ) );
				match[5] = +( ( match[7] + match[8] ) || match[3] === "odd" );

			// other types prohibit arguments
			} else if ( match[3] ) {
				Sizzle.error( match[0] );
			}

			return match;
		},

		"PSEUDO": function( match ) {
			var excess,
				unquoted = !match[6] && match[2];

			if ( matchExpr["CHILD"].test( match[0] ) ) {
				return null;
			}

			// Accept quoted arguments as-is
			if ( match[3] ) {
				match[2] = match[4] || match[5] || "";

			// Strip excess characters from unquoted arguments
			} else if ( unquoted && rpseudo.test( unquoted ) &&
				// Get excess from tokenize (recursively)
				(excess = tokenize( unquoted, true )) &&
				// advance to the next closing parenthesis
				(excess = unquoted.indexOf( ")", unquoted.length - excess ) - unquoted.length) ) {

				// excess is a negative index
				match[0] = match[0].slice( 0, excess );
				match[2] = unquoted.slice( 0, excess );
			}

			// Return only captures needed by the pseudo filter method (type and argument)
			return match.slice( 0, 3 );
		}
	},

	filter: {

		"TAG": function( nodeNameSelector ) {
			var nodeName = nodeNameSelector.replace( runescape, funescape ).toLowerCase();
			return nodeNameSelector === "*" ?
				function() { return true; } :
				function( elem ) {
					return elem.nodeName && elem.nodeName.toLowerCase() === nodeName;
				};
		},

		"CLASS": function( className ) {
			var pattern = classCache[ className + " " ];

			return pattern ||
				(pattern = new RegExp( "(^|" + whitespace + ")" + className + "(" + whitespace + "|$)" )) &&
				classCache( className, function( elem ) {
					return pattern.test( typeof elem.className === "string" && elem.className || typeof elem.getAttribute !== "undefined" && elem.getAttribute("class") || "" );
				});
		},

		"ATTR": function( name, operator, check ) {
			return function( elem ) {
				var result = Sizzle.attr( elem, name );

				if ( result == null ) {
					return operator === "!=";
				}
				if ( !operator ) {
					return true;
				}

				result += "";

				return operator === "=" ? result === check :
					operator === "!=" ? result !== check :
					operator === "^=" ? check && result.indexOf( check ) === 0 :
					operator === "*=" ? check && result.indexOf( check ) > -1 :
					operator === "$=" ? check && result.slice( -check.length ) === check :
					operator === "~=" ? ( " " + result.replace( rwhitespace, " " ) + " " ).indexOf( check ) > -1 :
					operator === "|=" ? result === check || result.slice( 0, check.length + 1 ) === check + "-" :
					false;
			};
		},

		"CHILD": function( type, what, argument, first, last ) {
			var simple = type.slice( 0, 3 ) !== "nth",
				forward = type.slice( -4 ) !== "last",
				ofType = what === "of-type";

			return first === 1 && last === 0 ?

				// Shortcut for :nth-*(n)
				function( elem ) {
					return !!elem.parentNode;
				} :

				function( elem, context, xml ) {
					var cache, uniqueCache, outerCache, node, nodeIndex, start,
						dir = simple !== forward ? "nextSibling" : "previousSibling",
						parent = elem.parentNode,
						name = ofType && elem.nodeName.toLowerCase(),
						useCache = !xml && !ofType,
						diff = false;

					if ( parent ) {

						// :(first|last|only)-(child|of-type)
						if ( simple ) {
							while ( dir ) {
								node = elem;
								while ( (node = node[ dir ]) ) {
									if ( ofType ?
										node.nodeName.toLowerCase() === name :
										node.nodeType === 1 ) {

										return false;
									}
								}
								// Reverse direction for :only-* (if we haven't yet done so)
								start = dir = type === "only" && !start && "nextSibling";
							}
							return true;
						}

						start = [ forward ? parent.firstChild : parent.lastChild ];

						// non-xml :nth-child(...) stores cache data on `parent`
						if ( forward && useCache ) {

							// Seek `elem` from a previously-cached index

							// ...in a gzip-friendly way
							node = parent;
							outerCache = node[ expando ] || (node[ expando ] = {});

							// Support: IE <9 only
							// Defend against cloned attroperties (jQuery gh-1709)
							uniqueCache = outerCache[ node.uniqueID ] ||
								(outerCache[ node.uniqueID ] = {});

							cache = uniqueCache[ type ] || [];
							nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
							diff = nodeIndex && cache[ 2 ];
							node = nodeIndex && parent.childNodes[ nodeIndex ];

							while ( (node = ++nodeIndex && node && node[ dir ] ||

								// Fallback to seeking `elem` from the start
								(diff = nodeIndex = 0) || start.pop()) ) {

								// When found, cache indexes on `parent` and break
								if ( node.nodeType === 1 && ++diff && node === elem ) {
									uniqueCache[ type ] = [ dirruns, nodeIndex, diff ];
									break;
								}
							}

						} else {
							// Use previously-cached element index if available
							if ( useCache ) {
								// ...in a gzip-friendly way
								node = elem;
								outerCache = node[ expando ] || (node[ expando ] = {});

								// Support: IE <9 only
								// Defend against cloned attroperties (jQuery gh-1709)
								uniqueCache = outerCache[ node.uniqueID ] ||
									(outerCache[ node.uniqueID ] = {});

								cache = uniqueCache[ type ] || [];
								nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
								diff = nodeIndex;
							}

							// xml :nth-child(...)
							// or :nth-last-child(...) or :nth(-last)?-of-type(...)
							if ( diff === false ) {
								// Use the same loop as above to seek `elem` from the start
								while ( (node = ++nodeIndex && node && node[ dir ] ||
									(diff = nodeIndex = 0) || start.pop()) ) {

									if ( ( ofType ?
										node.nodeName.toLowerCase() === name :
										node.nodeType === 1 ) &&
										++diff ) {

										// Cache the index of each encountered element
										if ( useCache ) {
											outerCache = node[ expando ] || (node[ expando ] = {});

											// Support: IE <9 only
											// Defend against cloned attroperties (jQuery gh-1709)
											uniqueCache = outerCache[ node.uniqueID ] ||
												(outerCache[ node.uniqueID ] = {});

											uniqueCache[ type ] = [ dirruns, diff ];
										}

										if ( node === elem ) {
											break;
										}
									}
								}
							}
						}

						// Incorporate the offset, then check against cycle size
						diff -= last;
						return diff === first || ( diff % first === 0 && diff / first >= 0 );
					}
				};
		},

		"PSEUDO": function( pseudo, argument ) {
			// pseudo-class names are case-insensitive
			// http://www.w3.org/TR/selectors/#pseudo-classes
			// Prioritize by case sensitivity in case custom pseudos are added with uppercase letters
			// Remember that setFilters inherits from pseudos
			var args,
				fn = Expr.pseudos[ pseudo ] || Expr.setFilters[ pseudo.toLowerCase() ] ||
					Sizzle.error( "unsupported pseudo: " + pseudo );

			// The user may use createPseudo to indicate that
			// arguments are needed to create the filter function
			// just as Sizzle does
			if ( fn[ expando ] ) {
				return fn( argument );
			}

			// But maintain support for old signatures
			if ( fn.length > 1 ) {
				args = [ pseudo, pseudo, "", argument ];
				return Expr.setFilters.hasOwnProperty( pseudo.toLowerCase() ) ?
					markFunction(function( seed, matches ) {
						var idx,
							matched = fn( seed, argument ),
							i = matched.length;
						while ( i-- ) {
							idx = indexOf( seed, matched[i] );
							seed[ idx ] = !( matches[ idx ] = matched[i] );
						}
					}) :
					function( elem ) {
						return fn( elem, 0, args );
					};
			}

			return fn;
		}
	},

	pseudos: {
		// Potentially complex pseudos
		"not": markFunction(function( selector ) {
			// Trim the selector passed to compile
			// to avoid treating leading and trailing
			// spaces as combinators
			var input = [],
				results = [],
				matcher = compile( selector.replace( rtrim, "$1" ) );

			return matcher[ expando ] ?
				markFunction(function( seed, matches, context, xml ) {
					var elem,
						unmatched = matcher( seed, null, xml, [] ),
						i = seed.length;

					// Match elements unmatched by `matcher`
					while ( i-- ) {
						if ( (elem = unmatched[i]) ) {
							seed[i] = !(matches[i] = elem);
						}
					}
				}) :
				function( elem, context, xml ) {
					input[0] = elem;
					matcher( input, null, xml, results );
					// Don't keep the element (issue #299)
					input[0] = null;
					return !results.pop();
				};
		}),

		"has": markFunction(function( selector ) {
			return function( elem ) {
				return Sizzle( selector, elem ).length > 0;
			};
		}),

		"contains": markFunction(function( text ) {
			text = text.replace( runescape, funescape );
			return function( elem ) {
				return ( elem.textContent || elem.innerText || getText( elem ) ).indexOf( text ) > -1;
			};
		}),

		// "Whether an element is represented by a :lang() selector
		// is based solely on the element's language value
		// being equal to the identifier C,
		// or beginning with the identifier C immediately followed by "-".
		// The matching of C against the element's language value is performed case-insensitively.
		// The identifier C does not have to be a valid language name."
		// http://www.w3.org/TR/selectors/#lang-pseudo
		"lang": markFunction( function( lang ) {
			// lang value must be a valid identifier
			if ( !ridentifier.test(lang || "") ) {
				Sizzle.error( "unsupported lang: " + lang );
			}
			lang = lang.replace( runescape, funescape ).toLowerCase();
			return function( elem ) {
				var elemLang;
				do {
					if ( (elemLang = documentIsHTML ?
						elem.lang :
						elem.getAttribute("xml:lang") || elem.getAttribute("lang")) ) {

						elemLang = elemLang.toLowerCase();
						return elemLang === lang || elemLang.indexOf( lang + "-" ) === 0;
					}
				} while ( (elem = elem.parentNode) && elem.nodeType === 1 );
				return false;
			};
		}),

		// Miscellaneous
		"target": function( elem ) {
			var hash = window.location && window.location.hash;
			return hash && hash.slice( 1 ) === elem.id;
		},

		"root": function( elem ) {
			return elem === docElem;
		},

		"focus": function( elem ) {
			return elem === document.activeElement && (!document.hasFocus || document.hasFocus()) && !!(elem.type || elem.href || ~elem.tabIndex);
		},

		// Boolean properties
		"enabled": createDisabledPseudo( false ),
		"disabled": createDisabledPseudo( true ),

		"checked": function( elem ) {
			// In CSS3, :checked should return both checked and selected elements
			// http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
			var nodeName = elem.nodeName.toLowerCase();
			return (nodeName === "input" && !!elem.checked) || (nodeName === "option" && !!elem.selected);
		},

		"selected": function( elem ) {
			// Accessing this property makes selected-by-default
			// options in Safari work properly
			if ( elem.parentNode ) {
				elem.parentNode.selectedIndex;
			}

			return elem.selected === true;
		},

		// Contents
		"empty": function( elem ) {
			// http://www.w3.org/TR/selectors/#empty-pseudo
			// :empty is negated by element (1) or content nodes (text: 3; cdata: 4; entity ref: 5),
			//   but not by others (comment: 8; processing instruction: 7; etc.)
			// nodeType < 6 works because attributes (2) do not appear as children
			for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
				if ( elem.nodeType < 6 ) {
					return false;
				}
			}
			return true;
		},

		"parent": function( elem ) {
			return !Expr.pseudos["empty"]( elem );
		},

		// Element/input types
		"header": function( elem ) {
			return rheader.test( elem.nodeName );
		},

		"input": function( elem ) {
			return rinputs.test( elem.nodeName );
		},

		"button": function( elem ) {
			var name = elem.nodeName.toLowerCase();
			return name === "input" && elem.type === "button" || name === "button";
		},

		"text": function( elem ) {
			var attr;
			return elem.nodeName.toLowerCase() === "input" &&
				elem.type === "text" &&

				// Support: IE<8
				// New HTML5 attribute values (e.g., "search") appear with elem.type === "text"
				( (attr = elem.getAttribute("type")) == null || attr.toLowerCase() === "text" );
		},

		// Position-in-collection
		"first": createPositionalPseudo(function() {
			return [ 0 ];
		}),

		"last": createPositionalPseudo(function( matchIndexes, length ) {
			return [ length - 1 ];
		}),

		"eq": createPositionalPseudo(function( matchIndexes, length, argument ) {
			return [ argument < 0 ? argument + length : argument ];
		}),

		"even": createPositionalPseudo(function( matchIndexes, length ) {
			var i = 0;
			for ( ; i < length; i += 2 ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		}),

		"odd": createPositionalPseudo(function( matchIndexes, length ) {
			var i = 1;
			for ( ; i < length; i += 2 ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		}),

		"lt": createPositionalPseudo(function( matchIndexes, length, argument ) {
			var i = argument < 0 ? argument + length : argument;
			for ( ; --i >= 0; ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		}),

		"gt": createPositionalPseudo(function( matchIndexes, length, argument ) {
			var i = argument < 0 ? argument + length : argument;
			for ( ; ++i < length; ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		})
	}
};

Expr.pseudos["nth"] = Expr.pseudos["eq"];

// Add button/input type pseudos
for ( i in { radio: true, checkbox: true, file: true, password: true, image: true } ) {
	Expr.pseudos[ i ] = createInputPseudo( i );
}
for ( i in { submit: true, reset: true } ) {
	Expr.pseudos[ i ] = createButtonPseudo( i );
}

// Easy API for creating new setFilters
function setFilters() {}
setFilters.prototype = Expr.filters = Expr.pseudos;
Expr.setFilters = new setFilters();

tokenize = Sizzle.tokenize = function( selector, parseOnly ) {
	var matched, match, tokens, type,
		soFar, groups, preFilters,
		cached = tokenCache[ selector + " " ];

	if ( cached ) {
		return parseOnly ? 0 : cached.slice( 0 );
	}

	soFar = selector;
	groups = [];
	preFilters = Expr.preFilter;

	while ( soFar ) {

		// Comma and first run
		if ( !matched || (match = rcomma.exec( soFar )) ) {
			if ( match ) {
				// Don't consume trailing commas as valid
				soFar = soFar.slice( match[0].length ) || soFar;
			}
			groups.push( (tokens = []) );
		}

		matched = false;

		// Combinators
		if ( (match = rcombinators.exec( soFar )) ) {
			matched = match.shift();
			tokens.push({
				value: matched,
				// Cast descendant combinators to space
				type: match[0].replace( rtrim, " " )
			});
			soFar = soFar.slice( matched.length );
		}

		// Filters
		for ( type in Expr.filter ) {
			if ( (match = matchExpr[ type ].exec( soFar )) && (!preFilters[ type ] ||
				(match = preFilters[ type ]( match ))) ) {
				matched = match.shift();
				tokens.push({
					value: matched,
					type: type,
					matches: match
				});
				soFar = soFar.slice( matched.length );
			}
		}

		if ( !matched ) {
			break;
		}
	}

	// Return the length of the invalid excess
	// if we're just parsing
	// Otherwise, throw an error or return tokens
	return parseOnly ?
		soFar.length :
		soFar ?
			Sizzle.error( selector ) :
			// Cache the tokens
			tokenCache( selector, groups ).slice( 0 );
};

function toSelector( tokens ) {
	var i = 0,
		len = tokens.length,
		selector = "";
	for ( ; i < len; i++ ) {
		selector += tokens[i].value;
	}
	return selector;
}

function addCombinator( matcher, combinator, base ) {
	var dir = combinator.dir,
		skip = combinator.next,
		key = skip || dir,
		checkNonElements = base && key === "parentNode",
		doneName = done++;

	return combinator.first ?
		// Check against closest ancestor/preceding element
		function( elem, context, xml ) {
			while ( (elem = elem[ dir ]) ) {
				if ( elem.nodeType === 1 || checkNonElements ) {
					return matcher( elem, context, xml );
				}
			}
			return false;
		} :

		// Check against all ancestor/preceding elements
		function( elem, context, xml ) {
			var oldCache, uniqueCache, outerCache,
				newCache = [ dirruns, doneName ];

			// We can't set arbitrary data on XML nodes, so they don't benefit from combinator caching
			if ( xml ) {
				while ( (elem = elem[ dir ]) ) {
					if ( elem.nodeType === 1 || checkNonElements ) {
						if ( matcher( elem, context, xml ) ) {
							return true;
						}
					}
				}
			} else {
				while ( (elem = elem[ dir ]) ) {
					if ( elem.nodeType === 1 || checkNonElements ) {
						outerCache = elem[ expando ] || (elem[ expando ] = {});

						// Support: IE <9 only
						// Defend against cloned attroperties (jQuery gh-1709)
						uniqueCache = outerCache[ elem.uniqueID ] || (outerCache[ elem.uniqueID ] = {});

						if ( skip && skip === elem.nodeName.toLowerCase() ) {
							elem = elem[ dir ] || elem;
						} else if ( (oldCache = uniqueCache[ key ]) &&
							oldCache[ 0 ] === dirruns && oldCache[ 1 ] === doneName ) {

							// Assign to newCache so results back-propagate to previous elements
							return (newCache[ 2 ] = oldCache[ 2 ]);
						} else {
							// Reuse newcache so results back-propagate to previous elements
							uniqueCache[ key ] = newCache;

							// A match means we're done; a fail means we have to keep checking
							if ( (newCache[ 2 ] = matcher( elem, context, xml )) ) {
								return true;
							}
						}
					}
				}
			}
			return false;
		};
}

function elementMatcher( matchers ) {
	return matchers.length > 1 ?
		function( elem, context, xml ) {
			var i = matchers.length;
			while ( i-- ) {
				if ( !matchers[i]( elem, context, xml ) ) {
					return false;
				}
			}
			return true;
		} :
		matchers[0];
}

function multipleContexts( selector, contexts, results ) {
	var i = 0,
		len = contexts.length;
	for ( ; i < len; i++ ) {
		Sizzle( selector, contexts[i], results );
	}
	return results;
}

function condense( unmatched, map, filter, context, xml ) {
	var elem,
		newUnmatched = [],
		i = 0,
		len = unmatched.length,
		mapped = map != null;

	for ( ; i < len; i++ ) {
		if ( (elem = unmatched[i]) ) {
			if ( !filter || filter( elem, context, xml ) ) {
				newUnmatched.push( elem );
				if ( mapped ) {
					map.push( i );
				}
			}
		}
	}

	return newUnmatched;
}

function setMatcher( preFilter, selector, matcher, postFilter, postFinder, postSelector ) {
	if ( postFilter && !postFilter[ expando ] ) {
		postFilter = setMatcher( postFilter );
	}
	if ( postFinder && !postFinder[ expando ] ) {
		postFinder = setMatcher( postFinder, postSelector );
	}
	return markFunction(function( seed, results, context, xml ) {
		var temp, i, elem,
			preMap = [],
			postMap = [],
			preexisting = results.length,

			// Get initial elements from seed or context
			elems = seed || multipleContexts( selector || "*", context.nodeType ? [ context ] : context, [] ),

			// Prefilter to get matcher input, preserving a map for seed-results synchronization
			matcherIn = preFilter && ( seed || !selector ) ?
				condense( elems, preMap, preFilter, context, xml ) :
				elems,

			matcherOut = matcher ?
				// If we have a postFinder, or filtered seed, or non-seed postFilter or preexisting results,
				postFinder || ( seed ? preFilter : preexisting || postFilter ) ?

					// ...intermediate processing is necessary
					[] :

					// ...otherwise use results directly
					results :
				matcherIn;

		// Find primary matches
		if ( matcher ) {
			matcher( matcherIn, matcherOut, context, xml );
		}

		// Apply postFilter
		if ( postFilter ) {
			temp = condense( matcherOut, postMap );
			postFilter( temp, [], context, xml );

			// Un-match failing elements by moving them back to matcherIn
			i = temp.length;
			while ( i-- ) {
				if ( (elem = temp[i]) ) {
					matcherOut[ postMap[i] ] = !(matcherIn[ postMap[i] ] = elem);
				}
			}
		}

		if ( seed ) {
			if ( postFinder || preFilter ) {
				if ( postFinder ) {
					// Get the final matcherOut by condensing this intermediate into postFinder contexts
					temp = [];
					i = matcherOut.length;
					while ( i-- ) {
						if ( (elem = matcherOut[i]) ) {
							// Restore matcherIn since elem is not yet a final match
							temp.push( (matcherIn[i] = elem) );
						}
					}
					postFinder( null, (matcherOut = []), temp, xml );
				}

				// Move matched elements from seed to results to keep them synchronized
				i = matcherOut.length;
				while ( i-- ) {
					if ( (elem = matcherOut[i]) &&
						(temp = postFinder ? indexOf( seed, elem ) : preMap[i]) > -1 ) {

						seed[temp] = !(results[temp] = elem);
					}
				}
			}

		// Add elements to results, through postFinder if defined
		} else {
			matcherOut = condense(
				matcherOut === results ?
					matcherOut.splice( preexisting, matcherOut.length ) :
					matcherOut
			);
			if ( postFinder ) {
				postFinder( null, results, matcherOut, xml );
			} else {
				push.apply( results, matcherOut );
			}
		}
	});
}

function matcherFromTokens( tokens ) {
	var checkContext, matcher, j,
		len = tokens.length,
		leadingRelative = Expr.relative[ tokens[0].type ],
		implicitRelative = leadingRelative || Expr.relative[" "],
		i = leadingRelative ? 1 : 0,

		// The foundational matcher ensures that elements are reachable from top-level context(s)
		matchContext = addCombinator( function( elem ) {
			return elem === checkContext;
		}, implicitRelative, true ),
		matchAnyContext = addCombinator( function( elem ) {
			return indexOf( checkContext, elem ) > -1;
		}, implicitRelative, true ),
		matchers = [ function( elem, context, xml ) {
			var ret = ( !leadingRelative && ( xml || context !== outermostContext ) ) || (
				(checkContext = context).nodeType ?
					matchContext( elem, context, xml ) :
					matchAnyContext( elem, context, xml ) );
			// Avoid hanging onto element (issue #299)
			checkContext = null;
			return ret;
		} ];

	for ( ; i < len; i++ ) {
		if ( (matcher = Expr.relative[ tokens[i].type ]) ) {
			matchers = [ addCombinator(elementMatcher( matchers ), matcher) ];
		} else {
			matcher = Expr.filter[ tokens[i].type ].apply( null, tokens[i].matches );

			// Return special upon seeing a positional matcher
			if ( matcher[ expando ] ) {
				// Find the next relative operator (if any) for proper handling
				j = ++i;
				for ( ; j < len; j++ ) {
					if ( Expr.relative[ tokens[j].type ] ) {
						break;
					}
				}
				return setMatcher(
					i > 1 && elementMatcher( matchers ),
					i > 1 && toSelector(
						// If the preceding token was a descendant combinator, insert an implicit any-element `*`
						tokens.slice( 0, i - 1 ).concat({ value: tokens[ i - 2 ].type === " " ? "*" : "" })
					).replace( rtrim, "$1" ),
					matcher,
					i < j && matcherFromTokens( tokens.slice( i, j ) ),
					j < len && matcherFromTokens( (tokens = tokens.slice( j )) ),
					j < len && toSelector( tokens )
				);
			}
			matchers.push( matcher );
		}
	}

	return elementMatcher( matchers );
}

function matcherFromGroupMatchers( elementMatchers, setMatchers ) {
	var bySet = setMatchers.length > 0,
		byElement = elementMatchers.length > 0,
		superMatcher = function( seed, context, xml, results, outermost ) {
			var elem, j, matcher,
				matchedCount = 0,
				i = "0",
				unmatched = seed && [],
				setMatched = [],
				contextBackup = outermostContext,
				// We must always have either seed elements or outermost context
				elems = seed || byElement && Expr.find["TAG"]( "*", outermost ),
				// Use integer dirruns iff this is the outermost matcher
				dirrunsUnique = (dirruns += contextBackup == null ? 1 : Math.random() || 0.1),
				len = elems.length;

			if ( outermost ) {
				outermostContext = context === document || context || outermost;
			}

			// Add elements passing elementMatchers directly to results
			// Support: IE<9, Safari
			// Tolerate NodeList properties (IE: "length"; Safari: <number>) matching elements by id
			for ( ; i !== len && (elem = elems[i]) != null; i++ ) {
				if ( byElement && elem ) {
					j = 0;
					if ( !context && elem.ownerDocument !== document ) {
						setDocument( elem );
						xml = !documentIsHTML;
					}
					while ( (matcher = elementMatchers[j++]) ) {
						if ( matcher( elem, context || document, xml) ) {
							results.push( elem );
							break;
						}
					}
					if ( outermost ) {
						dirruns = dirrunsUnique;
					}
				}

				// Track unmatched elements for set filters
				if ( bySet ) {
					// They will have gone through all possible matchers
					if ( (elem = !matcher && elem) ) {
						matchedCount--;
					}

					// Lengthen the array for every element, matched or not
					if ( seed ) {
						unmatched.push( elem );
					}
				}
			}

			// `i` is now the count of elements visited above, and adding it to `matchedCount`
			// makes the latter nonnegative.
			matchedCount += i;

			// Apply set filters to unmatched elements
			// NOTE: This can be skipped if there are no unmatched elements (i.e., `matchedCount`
			// equals `i`), unless we didn't visit _any_ elements in the above loop because we have
			// no element matchers and no seed.
			// Incrementing an initially-string "0" `i` allows `i` to remain a string only in that
			// case, which will result in a "00" `matchedCount` that differs from `i` but is also
			// numerically zero.
			if ( bySet && i !== matchedCount ) {
				j = 0;
				while ( (matcher = setMatchers[j++]) ) {
					matcher( unmatched, setMatched, context, xml );
				}

				if ( seed ) {
					// Reintegrate element matches to eliminate the need for sorting
					if ( matchedCount > 0 ) {
						while ( i-- ) {
							if ( !(unmatched[i] || setMatched[i]) ) {
								setMatched[i] = pop.call( results );
							}
						}
					}

					// Discard index placeholder values to get only actual matches
					setMatched = condense( setMatched );
				}

				// Add matches to results
				push.apply( results, setMatched );

				// Seedless set matches succeeding multiple successful matchers stipulate sorting
				if ( outermost && !seed && setMatched.length > 0 &&
					( matchedCount + setMatchers.length ) > 1 ) {

					Sizzle.uniqueSort( results );
				}
			}

			// Override manipulation of globals by nested matchers
			if ( outermost ) {
				dirruns = dirrunsUnique;
				outermostContext = contextBackup;
			}

			return unmatched;
		};

	return bySet ?
		markFunction( superMatcher ) :
		superMatcher;
}

compile = Sizzle.compile = function( selector, match /* Internal Use Only */ ) {
	var i,
		setMatchers = [],
		elementMatchers = [],
		cached = compilerCache[ selector + " " ];

	if ( !cached ) {
		// Generate a function of recursive functions that can be used to check each element
		if ( !match ) {
			match = tokenize( selector );
		}
		i = match.length;
		while ( i-- ) {
			cached = matcherFromTokens( match[i] );
			if ( cached[ expando ] ) {
				setMatchers.push( cached );
			} else {
				elementMatchers.push( cached );
			}
		}

		// Cache the compiled function
		cached = compilerCache( selector, matcherFromGroupMatchers( elementMatchers, setMatchers ) );

		// Save selector and tokenization
		cached.selector = selector;
	}
	return cached;
};

/**
 * A low-level selection function that works with Sizzle's compiled
 *  selector functions
 * @param {String|Function} selector A selector or a pre-compiled
 *  selector function built with Sizzle.compile
 * @param {Element} context
 * @param {Array} [results]
 * @param {Array} [seed] A set of elements to match against
 */
select = Sizzle.select = function( selector, context, results, seed ) {
	var i, tokens, token, type, find,
		compiled = typeof selector === "function" && selector,
		match = !seed && tokenize( (selector = compiled.selector || selector) );

	results = results || [];

	// Try to minimize operations if there is only one selector in the list and no seed
	// (the latter of which guarantees us context)
	if ( match.length === 1 ) {

		// Reduce context if the leading compound selector is an ID
		tokens = match[0] = match[0].slice( 0 );
		if ( tokens.length > 2 && (token = tokens[0]).type === "ID" &&
				context.nodeType === 9 && documentIsHTML && Expr.relative[ tokens[1].type ] ) {

			context = ( Expr.find["ID"]( token.matches[0].replace(runescape, funescape), context ) || [] )[0];
			if ( !context ) {
				return results;

			// Precompiled matchers will still verify ancestry, so step up a level
			} else if ( compiled ) {
				context = context.parentNode;
			}

			selector = selector.slice( tokens.shift().value.length );
		}

		// Fetch a seed set for right-to-left matching
		i = matchExpr["needsContext"].test( selector ) ? 0 : tokens.length;
		while ( i-- ) {
			token = tokens[i];

			// Abort if we hit a combinator
			if ( Expr.relative[ (type = token.type) ] ) {
				break;
			}
			if ( (find = Expr.find[ type ]) ) {
				// Search, expanding context for leading sibling combinators
				if ( (seed = find(
					token.matches[0].replace( runescape, funescape ),
					rsibling.test( tokens[0].type ) && testContext( context.parentNode ) || context
				)) ) {

					// If seed is empty or no tokens remain, we can return early
					tokens.splice( i, 1 );
					selector = seed.length && toSelector( tokens );
					if ( !selector ) {
						push.apply( results, seed );
						return results;
					}

					break;
				}
			}
		}
	}

	// Compile and execute a filtering function if one is not provided
	// Provide `match` to avoid retokenization if we modified the selector above
	( compiled || compile( selector, match ) )(
		seed,
		context,
		!documentIsHTML,
		results,
		!context || rsibling.test( selector ) && testContext( context.parentNode ) || context
	);
	return results;
};

// One-time assignments

// Sort stability
support.sortStable = expando.split("").sort( sortOrder ).join("") === expando;

// Support: Chrome 14-35+
// Always assume duplicates if they aren't passed to the comparison function
support.detectDuplicates = !!hasDuplicate;

// Initialize against the default document
setDocument();

// Support: Webkit<537.32 - Safari 6.0.3/Chrome 25 (fixed in Chrome 27)
// Detached nodes confoundingly follow *each other*
support.sortDetached = assert(function( el ) {
	// Should return 1, but returns 4 (following)
	return el.compareDocumentPosition( document.createElement("fieldset") ) & 1;
});

// Support: IE<8
// Prevent attribute/property "interpolation"
// https://msdn.microsoft.com/en-us/library/ms536429%28VS.85%29.aspx
if ( !assert(function( el ) {
	el.innerHTML = "<a href='#'></a>";
	return el.firstChild.getAttribute("href") === "#" ;
}) ) {
	addHandle( "type|href|height|width", function( elem, name, isXML ) {
		if ( !isXML ) {
			return elem.getAttribute( name, name.toLowerCase() === "type" ? 1 : 2 );
		}
	});
}

// Support: IE<9
// Use defaultValue in place of getAttribute("value")
if ( !support.attributes || !assert(function( el ) {
	el.innerHTML = "<input/>";
	el.firstChild.setAttribute( "value", "" );
	return el.firstChild.getAttribute( "value" ) === "";
}) ) {
	addHandle( "value", function( elem, name, isXML ) {
		if ( !isXML && elem.nodeName.toLowerCase() === "input" ) {
			return elem.defaultValue;
		}
	});
}

// Support: IE<9
// Use getAttributeNode to fetch booleans when getAttribute lies
if ( !assert(function( el ) {
	return el.getAttribute("disabled") == null;
}) ) {
	addHandle( booleans, function( elem, name, isXML ) {
		var val;
		if ( !isXML ) {
			return elem[ name ] === true ? name.toLowerCase() :
					(val = elem.getAttributeNode( name )) && val.specified ?
					val.value :
				null;
		}
	});
}

return Sizzle;

})( window );



jQuery.find = Sizzle;
jQuery.expr = Sizzle.selectors;

// Deprecated
jQuery.expr[ ":" ] = jQuery.expr.pseudos;
jQuery.uniqueSort = jQuery.unique = Sizzle.uniqueSort;
jQuery.text = Sizzle.getText;
jQuery.isXMLDoc = Sizzle.isXML;
jQuery.contains = Sizzle.contains;
jQuery.escapeSelector = Sizzle.escape;




var dir = function( elem, dir, until ) {
	var matched = [],
		truncate = until !== undefined;

	while ( ( elem = elem[ dir ] ) && elem.nodeType !== 9 ) {
		if ( elem.nodeType === 1 ) {
			if ( truncate && jQuery( elem ).is( until ) ) {
				break;
			}
			matched.push( elem );
		}
	}
	return matched;
};


var siblings = function( n, elem ) {
	var matched = [];

	for ( ; n; n = n.nextSibling ) {
		if ( n.nodeType === 1 && n !== elem ) {
			matched.push( n );
		}
	}

	return matched;
};


var rneedsContext = jQuery.expr.match.needsContext;



function nodeName( elem, name ) {

  return elem.nodeName && elem.nodeName.toLowerCase() === name.toLowerCase();

};
var rsingleTag = ( /^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i );



var risSimple = /^.[^:#\[\.,]*$/;

// Implement the identical functionality for filter and not
function winnow( elements, qualifier, not ) {
	if ( jQuery.isFunction( qualifier ) ) {
		return jQuery.grep( elements, function( elem, i ) {
			return !!qualifier.call( elem, i, elem ) !== not;
		} );
	}

	// Single element
	if ( qualifier.nodeType ) {
		return jQuery.grep( elements, function( elem ) {
			return ( elem === qualifier ) !== not;
		} );
	}

	// Arraylike of elements (jQuery, arguments, Array)
	if ( typeof qualifier !== "string" ) {
		return jQuery.grep( elements, function( elem ) {
			return ( indexOf.call( qualifier, elem ) > -1 ) !== not;
		} );
	}

	// Simple selector that can be filtered directly, removing non-Elements
	if ( risSimple.test( qualifier ) ) {
		return jQuery.filter( qualifier, elements, not );
	}

	// Complex selector, compare the two sets, removing non-Elements
	qualifier = jQuery.filter( qualifier, elements );
	return jQuery.grep( elements, function( elem ) {
		return ( indexOf.call( qualifier, elem ) > -1 ) !== not && elem.nodeType === 1;
	} );
}

jQuery.filter = function( expr, elems, not ) {
	var elem = elems[ 0 ];

	if ( not ) {
		expr = ":not(" + expr + ")";
	}

	if ( elems.length === 1 && elem.nodeType === 1 ) {
		return jQuery.find.matchesSelector( elem, expr ) ? [ elem ] : [];
	}

	return jQuery.find.matches( expr, jQuery.grep( elems, function( elem ) {
		return elem.nodeType === 1;
	} ) );
};

jQuery.fn.extend( {
	find: function( selector ) {
		var i, ret,
			len = this.length,
			self = this;

		if ( typeof selector !== "string" ) {
			return this.pushStack( jQuery( selector ).filter( function() {
				for ( i = 0; i < len; i++ ) {
					if ( jQuery.contains( self[ i ], this ) ) {
						return true;
					}
				}
			} ) );
		}

		ret = this.pushStack( [] );

		for ( i = 0; i < len; i++ ) {
			jQuery.find( selector, self[ i ], ret );
		}

		return len > 1 ? jQuery.uniqueSort( ret ) : ret;
	},
	filter: function( selector ) {
		return this.pushStack( winnow( this, selector || [], false ) );
	},
	not: function( selector ) {
		return this.pushStack( winnow( this, selector || [], true ) );
	},
	is: function( selector ) {
		return !!winnow(
			this,

			// If this is a positional/relative selector, check membership in the returned set
			// so $("p:first").is("p:last") won't return true for a doc with two "p".
			typeof selector === "string" && rneedsContext.test( selector ) ?
				jQuery( selector ) :
				selector || [],
			false
		).length;
	}
} );


// Initialize a jQuery object


// A central reference to the root jQuery(document)
var rootjQuery,

	// A simple way to check for HTML strings
	// Prioritize #id over <tag> to avoid XSS via location.hash (#9521)
	// Strict HTML recognition (#11290: must start with <)
	// Shortcut simple #id case for speed
	rquickExpr = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/,

	init = jQuery.fn.init = function( selector, context, root ) {
		var match, elem;

		// HANDLE: $(""), $(null), $(undefined), $(false)
		if ( !selector ) {
			return this;
		}

		// Method init() accepts an alternate rootjQuery
		// so migrate can support jQuery.sub (gh-2101)
		root = root || rootjQuery;

		// Handle HTML strings
		if ( typeof selector === "string" ) {
			if ( selector[ 0 ] === "<" &&
				selector[ selector.length - 1 ] === ">" &&
				selector.length >= 3 ) {

				// Assume that strings that start and end with <> are HTML and skip the regex check
				match = [ null, selector, null ];

			} else {
				match = rquickExpr.exec( selector );
			}

			// Match html or make sure no context is specified for #id
			if ( match && ( match[ 1 ] || !context ) ) {

				// HANDLE: $(html) -> $(array)
				if ( match[ 1 ] ) {
					context = context instanceof jQuery ? context[ 0 ] : context;

					// Option to run scripts is true for back-compat
					// Intentionally let the error be thrown if parseHTML is not present
					jQuery.merge( this, jQuery.parseHTML(
						match[ 1 ],
						context && context.nodeType ? context.ownerDocument || context : document,
						true
					) );

					// HANDLE: $(html, props)
					if ( rsingleTag.test( match[ 1 ] ) && jQuery.isPlainObject( context ) ) {
						for ( match in context ) {

							// Properties of context are called as methods if possible
							if ( jQuery.isFunction( this[ match ] ) ) {
								this[ match ]( context[ match ] );

							// ...and otherwise set as attributes
							} else {
								this.attr( match, context[ match ] );
							}
						}
					}

					return this;

				// HANDLE: $(#id)
				} else {
					elem = document.getElementById( match[ 2 ] );

					if ( elem ) {

						// Inject the element directly into the jQuery object
						this[ 0 ] = elem;
						this.length = 1;
					}
					return this;
				}

			// HANDLE: $(expr, $(...))
			} else if ( !context || context.jquery ) {
				return ( context || root ).find( selector );

			// HANDLE: $(expr, context)
			// (which is just equivalent to: $(context).find(expr)
			} else {
				return this.constructor( context ).find( selector );
			}

		// HANDLE: $(DOMElement)
		} else if ( selector.nodeType ) {
			this[ 0 ] = selector;
			this.length = 1;
			return this;

		// HANDLE: $(function)
		// Shortcut for document ready
		} else if ( jQuery.isFunction( selector ) ) {
			return root.ready !== undefined ?
				root.ready( selector ) :

				// Execute immediately if ready is not present
				selector( jQuery );
		}

		return jQuery.makeArray( selector, this );
	};

// Give the init function the jQuery prototype for later instantiation
init.prototype = jQuery.fn;

// Initialize central reference
rootjQuery = jQuery( document );


var rparentsprev = /^(?:parents|prev(?:Until|All))/,

	// Methods guaranteed to produce a unique set when starting from a unique set
	guaranteedUnique = {
		children: true,
		contents: true,
		next: true,
		prev: true
	};

jQuery.fn.extend( {
	has: function( target ) {
		var targets = jQuery( target, this ),
			l = targets.length;

		return this.filter( function() {
			var i = 0;
			for ( ; i < l; i++ ) {
				if ( jQuery.contains( this, targets[ i ] ) ) {
					return true;
				}
			}
		} );
	},

	closest: function( selectors, context ) {
		var cur,
			i = 0,
			l = this.length,
			matched = [],
			targets = typeof selectors !== "string" && jQuery( selectors );

		// Positional selectors never match, since there's no _selection_ context
		if ( !rneedsContext.test( selectors ) ) {
			for ( ; i < l; i++ ) {
				for ( cur = this[ i ]; cur && cur !== context; cur = cur.parentNode ) {

					// Always skip document fragments
					if ( cur.nodeType < 11 && ( targets ?
						targets.index( cur ) > -1 :

						// Don't pass non-elements to Sizzle
						cur.nodeType === 1 &&
							jQuery.find.matchesSelector( cur, selectors ) ) ) {

						matched.push( cur );
						break;
					}
				}
			}
		}

		return this.pushStack( matched.length > 1 ? jQuery.uniqueSort( matched ) : matched );
	},

	// Determine the position of an element within the set
	index: function( elem ) {

		// No argument, return index in parent
		if ( !elem ) {
			return ( this[ 0 ] && this[ 0 ].parentNode ) ? this.first().prevAll().length : -1;
		}

		// Index in selector
		if ( typeof elem === "string" ) {
			return indexOf.call( jQuery( elem ), this[ 0 ] );
		}

		// Locate the position of the desired element
		return indexOf.call( this,

			// If it receives a jQuery object, the first element is used
			elem.jquery ? elem[ 0 ] : elem
		);
	},

	add: function( selector, context ) {
		return this.pushStack(
			jQuery.uniqueSort(
				jQuery.merge( this.get(), jQuery( selector, context ) )
			)
		);
	},

	addBack: function( selector ) {
		return this.add( selector == null ?
			this.prevObject : this.prevObject.filter( selector )
		);
	}
} );

function sibling( cur, dir ) {
	while ( ( cur = cur[ dir ] ) && cur.nodeType !== 1 ) {}
	return cur;
}

jQuery.each( {
	parent: function( elem ) {
		var parent = elem.parentNode;
		return parent && parent.nodeType !== 11 ? parent : null;
	},
	parents: function( elem ) {
		return dir( elem, "parentNode" );
	},
	parentsUntil: function( elem, i, until ) {
		return dir( elem, "parentNode", until );
	},
	next: function( elem ) {
		return sibling( elem, "nextSibling" );
	},
	prev: function( elem ) {
		return sibling( elem, "previousSibling" );
	},
	nextAll: function( elem ) {
		return dir( elem, "nextSibling" );
	},
	prevAll: function( elem ) {
		return dir( elem, "previousSibling" );
	},
	nextUntil: function( elem, i, until ) {
		return dir( elem, "nextSibling", until );
	},
	prevUntil: function( elem, i, until ) {
		return dir( elem, "previousSibling", until );
	},
	siblings: function( elem ) {
		return siblings( ( elem.parentNode || {} ).firstChild, elem );
	},
	children: function( elem ) {
		return siblings( elem.firstChild );
	},
	contents: function( elem ) {
        if ( nodeName( elem, "iframe" ) ) {
            return elem.contentDocument;
        }

        // Support: IE 9 - 11 only, iOS 7 only, Android Browser <=4.3 only
        // Treat the template element as a regular one in browsers that
        // don't support it.
        if ( nodeName( elem, "template" ) ) {
            elem = elem.content || elem;
        }

        return jQuery.merge( [], elem.childNodes );
	}
}, function( name, fn ) {
	jQuery.fn[ name ] = function( until, selector ) {
		var matched = jQuery.map( this, fn, until );

		if ( name.slice( -5 ) !== "Until" ) {
			selector = until;
		}

		if ( selector && typeof selector === "string" ) {
			matched = jQuery.filter( selector, matched );
		}

		if ( this.length > 1 ) {

			// Remove duplicates
			if ( !guaranteedUnique[ name ] ) {
				jQuery.uniqueSort( matched );
			}

			// Reverse order for parents* and prev-derivatives
			if ( rparentsprev.test( name ) ) {
				matched.reverse();
			}
		}

		return this.pushStack( matched );
	};
} );
var rnothtmlwhite = ( /[^\x20\t\r\n\f]+/g );



// Convert String-formatted options into Object-formatted ones
function createOptions( options ) {
	var object = {};
	jQuery.each( options.match( rnothtmlwhite ) || [], function( _, flag ) {
		object[ flag ] = true;
	} );
	return object;
}

/*
 * Create a callback list using the following parameters:
 *
 *	options: an optional list of space-separated options that will change how
 *			the callback list behaves or a more traditional option object
 *
 * By default a callback list will act like an event callback list and can be
 * "fired" multiple times.
 *
 * Possible options:
 *
 *	once:			will ensure the callback list can only be fired once (like a Deferred)
 *
 *	memory:			will keep track of previous values and will call any callback added
 *					after the list has been fired right away with the latest "memorized"
 *					values (like a Deferred)
 *
 *	unique:			will ensure a callback can only be added once (no duplicate in the list)
 *
 *	stopOnFalse:	interrupt callings when a callback returns false
 *
 */
jQuery.Callbacks = function( options ) {

	// Convert options from String-formatted to Object-formatted if needed
	// (we check in cache first)
	options = typeof options === "string" ?
		createOptions( options ) :
		jQuery.extend( {}, options );

	var // Flag to know if list is currently firing
		firing,

		// Last fire value for non-forgettable lists
		memory,

		// Flag to know if list was already fired
		fired,

		// Flag to prevent firing
		locked,

		// Actual callback list
		list = [],

		// Queue of execution data for repeatable lists
		queue = [],

		// Index of currently firing callback (modified by add/remove as needed)
		firingIndex = -1,

		// Fire callbacks
		fire = function() {

			// Enforce single-firing
			locked = locked || options.once;

			// Execute callbacks for all pending executions,
			// respecting firingIndex overrides and runtime changes
			fired = firing = true;
			for ( ; queue.length; firingIndex = -1 ) {
				memory = queue.shift();
				while ( ++firingIndex < list.length ) {

					// Run callback and check for early termination
					if ( list[ firingIndex ].apply( memory[ 0 ], memory[ 1 ] ) === false &&
						options.stopOnFalse ) {

						// Jump to end and forget the data so .add doesn't re-fire
						firingIndex = list.length;
						memory = false;
					}
				}
			}

			// Forget the data if we're done with it
			if ( !options.memory ) {
				memory = false;
			}

			firing = false;

			// Clean up if we're done firing for good
			if ( locked ) {

				// Keep an empty list if we have data for future add calls
				if ( memory ) {
					list = [];

				// Otherwise, this object is spent
				} else {
					list = "";
				}
			}
		},

		// Actual Callbacks object
		self = {

			// Add a callback or a collection of callbacks to the list
			add: function() {
				if ( list ) {

					// If we have memory from a past run, we should fire after adding
					if ( memory && !firing ) {
						firingIndex = list.length - 1;
						queue.push( memory );
					}

					( function add( args ) {
						jQuery.each( args, function( _, arg ) {
							if ( jQuery.isFunction( arg ) ) {
								if ( !options.unique || !self.has( arg ) ) {
									list.push( arg );
								}
							} else if ( arg && arg.length && jQuery.type( arg ) !== "string" ) {

								// Inspect recursively
								add( arg );
							}
						} );
					} )( arguments );

					if ( memory && !firing ) {
						fire();
					}
				}
				return this;
			},

			// Remove a callback from the list
			remove: function() {
				jQuery.each( arguments, function( _, arg ) {
					var index;
					while ( ( index = jQuery.inArray( arg, list, index ) ) > -1 ) {
						list.splice( index, 1 );

						// Handle firing indexes
						if ( index <= firingIndex ) {
							firingIndex--;
						}
					}
				} );
				return this;
			},

			// Check if a given callback is in the list.
			// If no argument is given, return whether or not list has callbacks attached.
			has: function( fn ) {
				return fn ?
					jQuery.inArray( fn, list ) > -1 :
					list.length > 0;
			},

			// Remove all callbacks from the list
			empty: function() {
				if ( list ) {
					list = [];
				}
				return this;
			},

			// Disable .fire and .add
			// Abort any current/pending executions
			// Clear all callbacks and values
			disable: function() {
				locked = queue = [];
				list = memory = "";
				return this;
			},
			disabled: function() {
				return !list;
			},

			// Disable .fire
			// Also disable .add unless we have memory (since it would have no effect)
			// Abort any pending executions
			lock: function() {
				locked = queue = [];
				if ( !memory && !firing ) {
					list = memory = "";
				}
				return this;
			},
			locked: function() {
				return !!locked;
			},

			// Call all callbacks with the given context and arguments
			fireWith: function( context, args ) {
				if ( !locked ) {
					args = args || [];
					args = [ context, args.slice ? args.slice() : args ];
					queue.push( args );
					if ( !firing ) {
						fire();
					}
				}
				return this;
			},

			// Call all the callbacks with the given arguments
			fire: function() {
				self.fireWith( this, arguments );
				return this;
			},

			// To know if the callbacks have already been called at least once
			fired: function() {
				return !!fired;
			}
		};

	return self;
};


function Identity( v ) {
	return v;
}
function Thrower( ex ) {
	throw ex;
}

function adoptValue( value, resolve, reject, noValue ) {
	var method;

	try {

		// Check for promise aspect first to privilege synchronous behavior
		if ( value && jQuery.isFunction( ( method = value.promise ) ) ) {
			method.call( value ).done( resolve ).fail( reject );

		// Other thenables
		} else if ( value && jQuery.isFunction( ( method = value.then ) ) ) {
			method.call( value, resolve, reject );

		// Other non-thenables
		} else {

			// Control `resolve` arguments by letting Array#slice cast boolean `noValue` to integer:
			// * false: [ value ].slice( 0 ) => resolve( value )
			// * true: [ value ].slice( 1 ) => resolve()
			resolve.apply( undefined, [ value ].slice( noValue ) );
		}

	// For Promises/A+, convert exceptions into rejections
	// Since jQuery.when doesn't unwrap thenables, we can skip the extra checks appearing in
	// Deferred#then to conditionally suppress rejection.
	} catch ( value ) {

		// Support: Android 4.0 only
		// Strict mode functions invoked without .call/.apply get global-object context
		reject.apply( undefined, [ value ] );
	}
}

jQuery.extend( {

	Deferred: function( func ) {
		var tuples = [

				// action, add listener, callbacks,
				// ... .then handlers, argument index, [final state]
				[ "notify", "progress", jQuery.Callbacks( "memory" ),
					jQuery.Callbacks( "memory" ), 2 ],
				[ "resolve", "done", jQuery.Callbacks( "once memory" ),
					jQuery.Callbacks( "once memory" ), 0, "resolved" ],
				[ "reject", "fail", jQuery.Callbacks( "once memory" ),
					jQuery.Callbacks( "once memory" ), 1, "rejected" ]
			],
			state = "pending",
			promise = {
				state: function() {
					return state;
				},
				always: function() {
					deferred.done( arguments ).fail( arguments );
					return this;
				},
				"catch": function( fn ) {
					return promise.then( null, fn );
				},

				// Keep pipe for back-compat
				pipe: function( /* fnDone, fnFail, fnProgress */ ) {
					var fns = arguments;

					return jQuery.Deferred( function( newDefer ) {
						jQuery.each( tuples, function( i, tuple ) {

							// Map tuples (progress, done, fail) to arguments (done, fail, progress)
							var fn = jQuery.isFunction( fns[ tuple[ 4 ] ] ) && fns[ tuple[ 4 ] ];

							// deferred.progress(function() { bind to newDefer or newDefer.notify })
							// deferred.done(function() { bind to newDefer or newDefer.resolve })
							// deferred.fail(function() { bind to newDefer or newDefer.reject })
							deferred[ tuple[ 1 ] ]( function() {
								var returned = fn && fn.apply( this, arguments );
								if ( returned && jQuery.isFunction( returned.promise ) ) {
									returned.promise()
										.progress( newDefer.notify )
										.done( newDefer.resolve )
										.fail( newDefer.reject );
								} else {
									newDefer[ tuple[ 0 ] + "With" ](
										this,
										fn ? [ returned ] : arguments
									);
								}
							} );
						} );
						fns = null;
					} ).promise();
				},
				then: function( onFulfilled, onRejected, onProgress ) {
					var maxDepth = 0;
					function resolve( depth, deferred, handler, special ) {
						return function() {
							var that = this,
								args = arguments,
								mightThrow = function() {
									var returned, then;

									// Support: Promises/A+ section 2.3.3.3.3
									// https://promisesaplus.com/#point-59
									// Ignore double-resolution attempts
									if ( depth < maxDepth ) {
										return;
									}

									returned = handler.apply( that, args );

									// Support: Promises/A+ section 2.3.1
									// https://promisesaplus.com/#point-48
									if ( returned === deferred.promise() ) {
										throw new TypeError( "Thenable self-resolution" );
									}

									// Support: Promises/A+ sections 2.3.3.1, 3.5
									// https://promisesaplus.com/#point-54
									// https://promisesaplus.com/#point-75
									// Retrieve `then` only once
									then = returned &&

										// Support: Promises/A+ section 2.3.4
										// https://promisesaplus.com/#point-64
										// Only check objects and functions for thenability
										( typeof returned === "object" ||
											typeof returned === "function" ) &&
										returned.then;

									// Handle a returned thenable
									if ( jQuery.isFunction( then ) ) {

										// Special processors (notify) just wait for resolution
										if ( special ) {
											then.call(
												returned,
												resolve( maxDepth, deferred, Identity, special ),
												resolve( maxDepth, deferred, Thrower, special )
											);

										// Normal processors (resolve) also hook into progress
										} else {

											// ...and disregard older resolution values
											maxDepth++;

											then.call(
												returned,
												resolve( maxDepth, deferred, Identity, special ),
												resolve( maxDepth, deferred, Thrower, special ),
												resolve( maxDepth, deferred, Identity,
													deferred.notifyWith )
											);
										}

									// Handle all other returned values
									} else {

										// Only substitute handlers pass on context
										// and multiple values (non-spec behavior)
										if ( handler !== Identity ) {
											that = undefined;
											args = [ returned ];
										}

										// Process the value(s)
										// Default process is resolve
										( special || deferred.resolveWith )( that, args );
									}
								},

								// Only normal processors (resolve) catch and reject exceptions
								process = special ?
									mightThrow :
									function() {
										try {
											mightThrow();
										} catch ( e ) {

											if ( jQuery.Deferred.exceptionHook ) {
												jQuery.Deferred.exceptionHook( e,
													process.stackTrace );
											}

											// Support: Promises/A+ section 2.3.3.3.4.1
											// https://promisesaplus.com/#point-61
											// Ignore post-resolution exceptions
											if ( depth + 1 >= maxDepth ) {

												// Only substitute handlers pass on context
												// and multiple values (non-spec behavior)
												if ( handler !== Thrower ) {
													that = undefined;
													args = [ e ];
												}

												deferred.rejectWith( that, args );
											}
										}
									};

							// Support: Promises/A+ section 2.3.3.3.1
							// https://promisesaplus.com/#point-57
							// Re-resolve promises immediately to dodge false rejection from
							// subsequent errors
							if ( depth ) {
								process();
							} else {

								// Call an optional hook to record the stack, in case of exception
								// since it's otherwise lost when execution goes async
								if ( jQuery.Deferred.getStackHook ) {
									process.stackTrace = jQuery.Deferred.getStackHook();
								}
								window.setTimeout( process );
							}
						};
					}

					return jQuery.Deferred( function( newDefer ) {

						// progress_handlers.add( ... )
						tuples[ 0 ][ 3 ].add(
							resolve(
								0,
								newDefer,
								jQuery.isFunction( onProgress ) ?
									onProgress :
									Identity,
								newDefer.notifyWith
							)
						);

						// fulfilled_handlers.add( ... )
						tuples[ 1 ][ 3 ].add(
							resolve(
								0,
								newDefer,
								jQuery.isFunction( onFulfilled ) ?
									onFulfilled :
									Identity
							)
						);

						// rejected_handlers.add( ... )
						tuples[ 2 ][ 3 ].add(
							resolve(
								0,
								newDefer,
								jQuery.isFunction( onRejected ) ?
									onRejected :
									Thrower
							)
						);
					} ).promise();
				},

				// Get a promise for this deferred
				// If obj is provided, the promise aspect is added to the object
				promise: function( obj ) {
					return obj != null ? jQuery.extend( obj, promise ) : promise;
				}
			},
			deferred = {};

		// Add list-specific methods
		jQuery.each( tuples, function( i, tuple ) {
			var list = tuple[ 2 ],
				stateString = tuple[ 5 ];

			// promise.progress = list.add
			// promise.done = list.add
			// promise.fail = list.add
			promise[ tuple[ 1 ] ] = list.add;

			// Handle state
			if ( stateString ) {
				list.add(
					function() {

						// state = "resolved" (i.e., fulfilled)
						// state = "rejected"
						state = stateString;
					},

					// rejected_callbacks.disable
					// fulfilled_callbacks.disable
					tuples[ 3 - i ][ 2 ].disable,

					// progress_callbacks.lock
					tuples[ 0 ][ 2 ].lock
				);
			}

			// progress_handlers.fire
			// fulfilled_handlers.fire
			// rejected_handlers.fire
			list.add( tuple[ 3 ].fire );

			// deferred.notify = function() { deferred.notifyWith(...) }
			// deferred.resolve = function() { deferred.resolveWith(...) }
			// deferred.reject = function() { deferred.rejectWith(...) }
			deferred[ tuple[ 0 ] ] = function() {
				deferred[ tuple[ 0 ] + "With" ]( this === deferred ? undefined : this, arguments );
				return this;
			};

			// deferred.notifyWith = list.fireWith
			// deferred.resolveWith = list.fireWith
			// deferred.rejectWith = list.fireWith
			deferred[ tuple[ 0 ] + "With" ] = list.fireWith;
		} );

		// Make the deferred a promise
		promise.promise( deferred );

		// Call given func if any
		if ( func ) {
			func.call( deferred, deferred );
		}

		// All done!
		return deferred;
	},

	// Deferred helper
	when: function( singleValue ) {
		var

			// count of uncompleted subordinates
			remaining = arguments.length,

			// count of unprocessed arguments
			i = remaining,

			// subordinate fulfillment data
			resolveContexts = Array( i ),
			resolveValues = slice.call( arguments ),

			// the master Deferred
			master = jQuery.Deferred(),

			// subordinate callback factory
			updateFunc = function( i ) {
				return function( value ) {
					resolveContexts[ i ] = this;
					resolveValues[ i ] = arguments.length > 1 ? slice.call( arguments ) : value;
					if ( !( --remaining ) ) {
						master.resolveWith( resolveContexts, resolveValues );
					}
				};
			};

		// Single- and empty arguments are adopted like Promise.resolve
		if ( remaining <= 1 ) {
			adoptValue( singleValue, master.done( updateFunc( i ) ).resolve, master.reject,
				!remaining );

			// Use .then() to unwrap secondary thenables (cf. gh-3000)
			if ( master.state() === "pending" ||
				jQuery.isFunction( resolveValues[ i ] && resolveValues[ i ].then ) ) {

				return master.then();
			}
		}

		// Multiple arguments are aggregated like Promise.all array elements
		while ( i-- ) {
			adoptValue( resolveValues[ i ], updateFunc( i ), master.reject );
		}

		return master.promise();
	}
} );


// These usually indicate a programmer mistake during development,
// warn about them ASAP rather than swallowing them by default.
var rerrorNames = /^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;

jQuery.Deferred.exceptionHook = function( error, stack ) {

	// Support: IE 8 - 9 only
	// Console exists when dev tools are open, which can happen at any time
	if ( window.console && window.console.warn && error && rerrorNames.test( error.name ) ) {
		window.console.warn( "jQuery.Deferred exception: " + error.message, error.stack, stack );
	}
};




jQuery.readyException = function( error ) {
	window.setTimeout( function() {
		throw error;
	} );
};




// The deferred used on DOM ready
var readyList = jQuery.Deferred();

jQuery.fn.ready = function( fn ) {

	readyList
		.then( fn )

		// Wrap jQuery.readyException in a function so that the lookup
		// happens at the time of error handling instead of callback
		// registration.
		.catch( function( error ) {
			jQuery.readyException( error );
		} );

	return this;
};

jQuery.extend( {

	// Is the DOM ready to be used? Set to true once it occurs.
	isReady: false,

	// A counter to track how many items to wait for before
	// the ready event fires. See #6781
	readyWait: 1,

	// Handle when the DOM is ready
	ready: function( wait ) {

		// Abort if there are pending holds or we're already ready
		if ( wait === true ? --jQuery.readyWait : jQuery.isReady ) {
			return;
		}

		// Remember that the DOM is ready
		jQuery.isReady = true;

		// If a normal DOM Ready event fired, decrement, and wait if need be
		if ( wait !== true && --jQuery.readyWait > 0 ) {
			return;
		}

		// If there are functions bound, to execute
		readyList.resolveWith( document, [ jQuery ] );
	}
} );

jQuery.ready.then = readyList.then;

// The ready event handler and self cleanup method
function completed() {
	document.removeEventListener( "DOMContentLoaded", completed );
	window.removeEventListener( "load", completed );
	jQuery.ready();
}

// Catch cases where $(document).ready() is called
// after the browser event has already occurred.
// Support: IE <=9 - 10 only
// Older IE sometimes signals "interactive" too soon
if ( document.readyState === "complete" ||
	( document.readyState !== "loading" && !document.documentElement.doScroll ) ) {

	// Handle it asynchronously to allow scripts the opportunity to delay ready
	window.setTimeout( jQuery.ready );

} else {

	// Use the handy event callback
	document.addEventListener( "DOMContentLoaded", completed );

	// A fallback to window.onload, that will always work
	window.addEventListener( "load", completed );
}




// Multifunctional method to get and set values of a collection
// The value/s can optionally be executed if it's a function
var access = function( elems, fn, key, value, chainable, emptyGet, raw ) {
	var i = 0,
		len = elems.length,
		bulk = key == null;

	// Sets many values
	if ( jQuery.type( key ) === "object" ) {
		chainable = true;
		for ( i in key ) {
			access( elems, fn, i, key[ i ], true, emptyGet, raw );
		}

	// Sets one value
	} else if ( value !== undefined ) {
		chainable = true;

		if ( !jQuery.isFunction( value ) ) {
			raw = true;
		}

		if ( bulk ) {

			// Bulk operations run against the entire set
			if ( raw ) {
				fn.call( elems, value );
				fn = null;

			// ...except when executing function values
			} else {
				bulk = fn;
				fn = function( elem, key, value ) {
					return bulk.call( jQuery( elem ), value );
				};
			}
		}

		if ( fn ) {
			for ( ; i < len; i++ ) {
				fn(
					elems[ i ], key, raw ?
					value :
					value.call( elems[ i ], i, fn( elems[ i ], key ) )
				);
			}
		}
	}

	if ( chainable ) {
		return elems;
	}

	// Gets
	if ( bulk ) {
		return fn.call( elems );
	}

	return len ? fn( elems[ 0 ], key ) : emptyGet;
};
var acceptData = function( owner ) {

	// Accepts only:
	//  - Node
	//    - Node.ELEMENT_NODE
	//    - Node.DOCUMENT_NODE
	//  - Object
	//    - Any
	return owner.nodeType === 1 || owner.nodeType === 9 || !( +owner.nodeType );
};




function Data() {
	this.expando = jQuery.expando + Data.uid++;
}

Data.uid = 1;

Data.prototype = {

	cache: function( owner ) {

		// Check if the owner object already has a cache
		var value = owner[ this.expando ];

		// If not, create one
		if ( !value ) {
			value = {};

			// We can accept data for non-element nodes in modern browsers,
			// but we should not, see #8335.
			// Always return an empty object.
			if ( acceptData( owner ) ) {

				// If it is a node unlikely to be stringify-ed or looped over
				// use plain assignment
				if ( owner.nodeType ) {
					owner[ this.expando ] = value;

				// Otherwise secure it in a non-enumerable property
				// configurable must be true to allow the property to be
				// deleted when data is removed
				} else {
					Object.defineProperty( owner, this.expando, {
						value: value,
						configurable: true
					} );
				}
			}
		}

		return value;
	},
	set: function( owner, data, value ) {
		var prop,
			cache = this.cache( owner );

		// Handle: [ owner, key, value ] args
		// Always use camelCase key (gh-2257)
		if ( typeof data === "string" ) {
			cache[ jQuery.camelCase( data ) ] = value;

		// Handle: [ owner, { properties } ] args
		} else {

			// Copy the properties one-by-one to the cache object
			for ( prop in data ) {
				cache[ jQuery.camelCase( prop ) ] = data[ prop ];
			}
		}
		return cache;
	},
	get: function( owner, key ) {
		return key === undefined ?
			this.cache( owner ) :

			// Always use camelCase key (gh-2257)
			owner[ this.expando ] && owner[ this.expando ][ jQuery.camelCase( key ) ];
	},
	access: function( owner, key, value ) {

		// In cases where either:
		//
		//   1. No key was specified
		//   2. A string key was specified, but no value provided
		//
		// Take the "read" path and allow the get method to determine
		// which value to return, respectively either:
		//
		//   1. The entire cache object
		//   2. The data stored at the key
		//
		if ( key === undefined ||
				( ( key && typeof key === "string" ) && value === undefined ) ) {

			return this.get( owner, key );
		}

		// When the key is not a string, or both a key and value
		// are specified, set or extend (existing objects) with either:
		//
		//   1. An object of properties
		//   2. A key and value
		//
		this.set( owner, key, value );

		// Since the "set" path can have two possible entry points
		// return the expected data based on which path was taken[*]
		return value !== undefined ? value : key;
	},
	remove: function( owner, key ) {
		var i,
			cache = owner[ this.expando ];

		if ( cache === undefined ) {
			return;
		}

		if ( key !== undefined ) {

			// Support array or space separated string of keys
			if ( Array.isArray( key ) ) {

				// If key is an array of keys...
				// We always set camelCase keys, so remove that.
				key = key.map( jQuery.camelCase );
			} else {
				key = jQuery.camelCase( key );

				// If a key with the spaces exists, use it.
				// Otherwise, create an array by matching non-whitespace
				key = key in cache ?
					[ key ] :
					( key.match( rnothtmlwhite ) || [] );
			}

			i = key.length;

			while ( i-- ) {
				delete cache[ key[ i ] ];
			}
		}

		// Remove the expando if there's no more data
		if ( key === undefined || jQuery.isEmptyObject( cache ) ) {

			// Support: Chrome <=35 - 45
			// Webkit & Blink performance suffers when deleting properties
			// from DOM nodes, so set to undefined instead
			// https://bugs.chromium.org/p/chromium/issues/detail?id=378607 (bug restricted)
			if ( owner.nodeType ) {
				owner[ this.expando ] = undefined;
			} else {
				delete owner[ this.expando ];
			}
		}
	},
	hasData: function( owner ) {
		var cache = owner[ this.expando ];
		return cache !== undefined && !jQuery.isEmptyObject( cache );
	}
};
var dataPriv = new Data();

var dataUser = new Data();



//	Implementation Summary
//
//	1. Enforce API surface and semantic compatibility with 1.9.x branch
//	2. Improve the module's maintainability by reducing the storage
//		paths to a single mechanism.
//	3. Use the same single mechanism to support "private" and "user" data.
//	4. _Never_ expose "private" data to user code (TODO: Drop _data, _removeData)
//	5. Avoid exposing implementation details on user objects (eg. expando properties)
//	6. Provide a clear path for implementation upgrade to WeakMap in 2014

var rbrace = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,
	rmultiDash = /[A-Z]/g;

function getData( data ) {
	if ( data === "true" ) {
		return true;
	}

	if ( data === "false" ) {
		return false;
	}

	if ( data === "null" ) {
		return null;
	}

	// Only convert to a number if it doesn't change the string
	if ( data === +data + "" ) {
		return +data;
	}

	if ( rbrace.test( data ) ) {
		return JSON.parse( data );
	}

	return data;
}

function dataAttr( elem, key, data ) {
	var name;

	// If nothing was found internally, try to fetch any
	// data from the HTML5 data-* attribute
	if ( data === undefined && elem.nodeType === 1 ) {
		name = "data-" + key.replace( rmultiDash, "-$&" ).toLowerCase();
		data = elem.getAttribute( name );

		if ( typeof data === "string" ) {
			try {
				data = getData( data );
			} catch ( e ) {}

			// Make sure we set the data so it isn't changed later
			dataUser.set( elem, key, data );
		} else {
			data = undefined;
		}
	}
	return data;
}

jQuery.extend( {
	hasData: function( elem ) {
		return dataUser.hasData( elem ) || dataPriv.hasData( elem );
	},

	data: function( elem, name, data ) {
		return dataUser.access( elem, name, data );
	},

	removeData: function( elem, name ) {
		dataUser.remove( elem, name );
	},

	// TODO: Now that all calls to _data and _removeData have been replaced
	// with direct calls to dataPriv methods, these can be deprecated.
	_data: function( elem, name, data ) {
		return dataPriv.access( elem, name, data );
	},

	_removeData: function( elem, name ) {
		dataPriv.remove( elem, name );
	}
} );

jQuery.fn.extend( {
	data: function( key, value ) {
		var i, name, data,
			elem = this[ 0 ],
			attrs = elem && elem.attributes;

		// Gets all values
		if ( key === undefined ) {
			if ( this.length ) {
				data = dataUser.get( elem );

				if ( elem.nodeType === 1 && !dataPriv.get( elem, "hasDataAttrs" ) ) {
					i = attrs.length;
					while ( i-- ) {

						// Support: IE 11 only
						// The attrs elements can be null (#14894)
						if ( attrs[ i ] ) {
							name = attrs[ i ].name;
							if ( name.indexOf( "data-" ) === 0 ) {
								name = jQuery.camelCase( name.slice( 5 ) );
								dataAttr( elem, name, data[ name ] );
							}
						}
					}
					dataPriv.set( elem, "hasDataAttrs", true );
				}
			}

			return data;
		}

		// Sets multiple values
		if ( typeof key === "object" ) {
			return this.each( function() {
				dataUser.set( this, key );
			} );
		}

		return access( this, function( value ) {
			var data;

			// The calling jQuery object (element matches) is not empty
			// (and therefore has an element appears at this[ 0 ]) and the
			// `value` parameter was not undefined. An empty jQuery object
			// will result in `undefined` for elem = this[ 0 ] which will
			// throw an exception if an attempt to read a data cache is made.
			if ( elem && value === undefined ) {

				// Attempt to get data from the cache
				// The key will always be camelCased in Data
				data = dataUser.get( elem, key );
				if ( data !== undefined ) {
					return data;
				}

				// Attempt to "discover" the data in
				// HTML5 custom data-* attrs
				data = dataAttr( elem, key );
				if ( data !== undefined ) {
					return data;
				}

				// We tried really hard, but the data doesn't exist.
				return;
			}

			// Set the data...
			this.each( function() {

				// We always store the camelCased key
				dataUser.set( this, key, value );
			} );
		}, null, value, arguments.length > 1, null, true );
	},

	removeData: function( key ) {
		return this.each( function() {
			dataUser.remove( this, key );
		} );
	}
} );


jQuery.extend( {
	queue: function( elem, type, data ) {
		var queue;

		if ( elem ) {
			type = ( type || "fx" ) + "queue";
			queue = dataPriv.get( elem, type );

			// Speed up dequeue by getting out quickly if this is just a lookup
			if ( data ) {
				if ( !queue || Array.isArray( data ) ) {
					queue = dataPriv.access( elem, type, jQuery.makeArray( data ) );
				} else {
					queue.push( data );
				}
			}
			return queue || [];
		}
	},

	dequeue: function( elem, type ) {
		type = type || "fx";

		var queue = jQuery.queue( elem, type ),
			startLength = queue.length,
			fn = queue.shift(),
			hooks = jQuery._queueHooks( elem, type ),
			next = function() {
				jQuery.dequeue( elem, type );
			};

		// If the fx queue is dequeued, always remove the progress sentinel
		if ( fn === "inprogress" ) {
			fn = queue.shift();
			startLength--;
		}

		if ( fn ) {

			// Add a progress sentinel to prevent the fx queue from being
			// automatically dequeued
			if ( type === "fx" ) {
				queue.unshift( "inprogress" );
			}

			// Clear up the last queue stop function
			delete hooks.stop;
			fn.call( elem, next, hooks );
		}

		if ( !startLength && hooks ) {
			hooks.empty.fire();
		}
	},

	// Not public - generate a queueHooks object, or return the current one
	_queueHooks: function( elem, type ) {
		var key = type + "queueHooks";
		return dataPriv.get( elem, key ) || dataPriv.access( elem, key, {
			empty: jQuery.Callbacks( "once memory" ).add( function() {
				dataPriv.remove( elem, [ type + "queue", key ] );
			} )
		} );
	}
} );

jQuery.fn.extend( {
	queue: function( type, data ) {
		var setter = 2;

		if ( typeof type !== "string" ) {
			data = type;
			type = "fx";
			setter--;
		}

		if ( arguments.length < setter ) {
			return jQuery.queue( this[ 0 ], type );
		}

		return data === undefined ?
			this :
			this.each( function() {
				var queue = jQuery.queue( this, type, data );

				// Ensure a hooks for this queue
				jQuery._queueHooks( this, type );

				if ( type === "fx" && queue[ 0 ] !== "inprogress" ) {
					jQuery.dequeue( this, type );
				}
			} );
	},
	dequeue: function( type ) {
		return this.each( function() {
			jQuery.dequeue( this, type );
		} );
	},
	clearQueue: function( type ) {
		return this.queue( type || "fx", [] );
	},

	// Get a promise resolved when queues of a certain type
	// are emptied (fx is the type by default)
	promise: function( type, obj ) {
		var tmp,
			count = 1,
			defer = jQuery.Deferred(),
			elements = this,
			i = this.length,
			resolve = function() {
				if ( !( --count ) ) {
					defer.resolveWith( elements, [ elements ] );
				}
			};

		if ( typeof type !== "string" ) {
			obj = type;
			type = undefined;
		}
		type = type || "fx";

		while ( i-- ) {
			tmp = dataPriv.get( elements[ i ], type + "queueHooks" );
			if ( tmp && tmp.empty ) {
				count++;
				tmp.empty.add( resolve );
			}
		}
		resolve();
		return defer.promise( obj );
	}
} );
var pnum = ( /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/ ).source;

var rcssNum = new RegExp( "^(?:([+-])=|)(" + pnum + ")([a-z%]*)$", "i" );


var cssExpand = [ "Top", "Right", "Bottom", "Left" ];

var isHiddenWithinTree = function( elem, el ) {

		// isHiddenWithinTree might be called from jQuery#filter function;
		// in that case, element will be second argument
		elem = el || elem;

		// Inline style trumps all
		return elem.style.display === "none" ||
			elem.style.display === "" &&

			// Otherwise, check computed style
			// Support: Firefox <=43 - 45
			// Disconnected elements can have computed display: none, so first confirm that elem is
			// in the document.
			jQuery.contains( elem.ownerDocument, elem ) &&

			jQuery.css( elem, "display" ) === "none";
	};

var swap = function( elem, options, callback, args ) {
	var ret, name,
		old = {};

	// Remember the old values, and insert the new ones
	for ( name in options ) {
		old[ name ] = elem.style[ name ];
		elem.style[ name ] = options[ name ];
	}

	ret = callback.apply( elem, args || [] );

	// Revert the old values
	for ( name in options ) {
		elem.style[ name ] = old[ name ];
	}

	return ret;
};




function adjustCSS( elem, prop, valueParts, tween ) {
	var adjusted,
		scale = 1,
		maxIterations = 20,
		currentValue = tween ?
			function() {
				return tween.cur();
			} :
			function() {
				return jQuery.css( elem, prop, "" );
			},
		initial = currentValue(),
		unit = valueParts && valueParts[ 3 ] || ( jQuery.cssNumber[ prop ] ? "" : "px" ),

		// Starting value computation is required for potential unit mismatches
		initialInUnit = ( jQuery.cssNumber[ prop ] || unit !== "px" && +initial ) &&
			rcssNum.exec( jQuery.css( elem, prop ) );

	if ( initialInUnit && initialInUnit[ 3 ] !== unit ) {

		// Trust units reported by jQuery.css
		unit = unit || initialInUnit[ 3 ];

		// Make sure we update the tween properties later on
		valueParts = valueParts || [];

		// Iteratively approximate from a nonzero starting point
		initialInUnit = +initial || 1;

		do {

			// If previous iteration zeroed out, double until we get *something*.
			// Use string for doubling so we don't accidentally see scale as unchanged below
			scale = scale || ".5";

			// Adjust and apply
			initialInUnit = initialInUnit / scale;
			jQuery.style( elem, prop, initialInUnit + unit );

		// Update scale, tolerating zero or NaN from tween.cur()
		// Break the loop if scale is unchanged or perfect, or if we've just had enough.
		} while (
			scale !== ( scale = currentValue() / initial ) && scale !== 1 && --maxIterations
		);
	}

	if ( valueParts ) {
		initialInUnit = +initialInUnit || +initial || 0;

		// Apply relative offset (+=/-=) if specified
		adjusted = valueParts[ 1 ] ?
			initialInUnit + ( valueParts[ 1 ] + 1 ) * valueParts[ 2 ] :
			+valueParts[ 2 ];
		if ( tween ) {
			tween.unit = unit;
			tween.start = initialInUnit;
			tween.end = adjusted;
		}
	}
	return adjusted;
}


var defaultDisplayMap = {};

function getDefaultDisplay( elem ) {
	var temp,
		doc = elem.ownerDocument,
		nodeName = elem.nodeName,
		display = defaultDisplayMap[ nodeName ];

	if ( display ) {
		return display;
	}

	temp = doc.body.appendChild( doc.createElement( nodeName ) );
	display = jQuery.css( temp, "display" );

	temp.parentNode.removeChild( temp );

	if ( display === "none" ) {
		display = "block";
	}
	defaultDisplayMap[ nodeName ] = display;

	return display;
}

function showHide( elements, show ) {
	var display, elem,
		values = [],
		index = 0,
		length = elements.length;

	// Determine new display value for elements that need to change
	for ( ; index < length; index++ ) {
		elem = elements[ index ];
		if ( !elem.style ) {
			continue;
		}

		display = elem.style.display;
		if ( show ) {

			// Since we force visibility upon cascade-hidden elements, an immediate (and slow)
			// check is required in this first loop unless we have a nonempty display value (either
			// inline or about-to-be-restored)
			if ( display === "none" ) {
				values[ index ] = dataPriv.get( elem, "display" ) || null;
				if ( !values[ index ] ) {
					elem.style.display = "";
				}
			}
			if ( elem.style.display === "" && isHiddenWithinTree( elem ) ) {
				values[ index ] = getDefaultDisplay( elem );
			}
		} else {
			if ( display !== "none" ) {
				values[ index ] = "none";

				// Remember what we're overwriting
				dataPriv.set( elem, "display", display );
			}
		}
	}

	// Set the display of the elements in a second loop to avoid constant reflow
	for ( index = 0; index < length; index++ ) {
		if ( values[ index ] != null ) {
			elements[ index ].style.display = values[ index ];
		}
	}

	return elements;
}

jQuery.fn.extend( {
	show: function() {
		return showHide( this, true );
	},
	hide: function() {
		return showHide( this );
	},
	toggle: function( state ) {
		if ( typeof state === "boolean" ) {
			return state ? this.show() : this.hide();
		}

		return this.each( function() {
			if ( isHiddenWithinTree( this ) ) {
				jQuery( this ).show();
			} else {
				jQuery( this ).hide();
			}
		} );
	}
} );
var rcheckableType = ( /^(?:checkbox|radio)$/i );

var rtagName = ( /<([a-z][^\/\0>\x20\t\r\n\f]+)/i );

var rscriptType = ( /^$|\/(?:java|ecma)script/i );



// We have to close these tags to support XHTML (#13200)
var wrapMap = {

	// Support: IE <=9 only
	option: [ 1, "<select multiple='multiple'>", "</select>" ],

	// XHTML parsers do not magically insert elements in the
	// same way that tag soup parsers do. So we cannot shorten
	// this by omitting <tbody> or other required elements.
	thead: [ 1, "<table>", "</table>" ],
	col: [ 2, "<table><colgroup>", "</colgroup></table>" ],
	tr: [ 2, "<table><tbody>", "</tbody></table>" ],
	td: [ 3, "<table><tbody><tr>", "</tr></tbody></table>" ],

	_default: [ 0, "", "" ]
};

// Support: IE <=9 only
wrapMap.optgroup = wrapMap.option;

wrapMap.tbody = wrapMap.tfoot = wrapMap.colgroup = wrapMap.caption = wrapMap.thead;
wrapMap.th = wrapMap.td;


function getAll( context, tag ) {

	// Support: IE <=9 - 11 only
	// Use typeof to avoid zero-argument method invocation on host objects (#15151)
	var ret;

	if ( typeof context.getElementsByTagName !== "undefined" ) {
		ret = context.getElementsByTagName( tag || "*" );

	} else if ( typeof context.querySelectorAll !== "undefined" ) {
		ret = context.querySelectorAll( tag || "*" );

	} else {
		ret = [];
	}

	if ( tag === undefined || tag && nodeName( context, tag ) ) {
		return jQuery.merge( [ context ], ret );
	}

	return ret;
}


// Mark scripts as having already been evaluated
function setGlobalEval( elems, refElements ) {
	var i = 0,
		l = elems.length;

	for ( ; i < l; i++ ) {
		dataPriv.set(
			elems[ i ],
			"globalEval",
			!refElements || dataPriv.get( refElements[ i ], "globalEval" )
		);
	}
}


var rhtml = /<|&#?\w+;/;

function buildFragment( elems, context, scripts, selection, ignored ) {
	var elem, tmp, tag, wrap, contains, j,
		fragment = context.createDocumentFragment(),
		nodes = [],
		i = 0,
		l = elems.length;

	for ( ; i < l; i++ ) {
		elem = elems[ i ];

		if ( elem || elem === 0 ) {

			// Add nodes directly
			if ( jQuery.type( elem ) === "object" ) {

				// Support: Android <=4.0 only, PhantomJS 1 only
				// push.apply(_, arraylike) throws on ancient WebKit
				jQuery.merge( nodes, elem.nodeType ? [ elem ] : elem );

			// Convert non-html into a text node
			} else if ( !rhtml.test( elem ) ) {
				nodes.push( context.createTextNode( elem ) );

			// Convert html into DOM nodes
			} else {
				tmp = tmp || fragment.appendChild( context.createElement( "div" ) );

				// Deserialize a standard representation
				tag = ( rtagName.exec( elem ) || [ "", "" ] )[ 1 ].toLowerCase();
				wrap = wrapMap[ tag ] || wrapMap._default;
				tmp.innerHTML = wrap[ 1 ] + jQuery.htmlPrefilter( elem ) + wrap[ 2 ];

				// Descend through wrappers to the right content
				j = wrap[ 0 ];
				while ( j-- ) {
					tmp = tmp.lastChild;
				}

				// Support: Android <=4.0 only, PhantomJS 1 only
				// push.apply(_, arraylike) throws on ancient WebKit
				jQuery.merge( nodes, tmp.childNodes );

				// Remember the top-level container
				tmp = fragment.firstChild;

				// Ensure the created nodes are orphaned (#12392)
				tmp.textContent = "";
			}
		}
	}

	// Remove wrapper from fragment
	fragment.textContent = "";

	i = 0;
	while ( ( elem = nodes[ i++ ] ) ) {

		// Skip elements already in the context collection (trac-4087)
		if ( selection && jQuery.inArray( elem, selection ) > -1 ) {
			if ( ignored ) {
				ignored.push( elem );
			}
			continue;
		}

		contains = jQuery.contains( elem.ownerDocument, elem );

		// Append to fragment
		tmp = getAll( fragment.appendChild( elem ), "script" );

		// Preserve script evaluation history
		if ( contains ) {
			setGlobalEval( tmp );
		}

		// Capture executables
		if ( scripts ) {
			j = 0;
			while ( ( elem = tmp[ j++ ] ) ) {
				if ( rscriptType.test( elem.type || "" ) ) {
					scripts.push( elem );
				}
			}
		}
	}

	return fragment;
}


( function() {
	var fragment = document.createDocumentFragment(),
		div = fragment.appendChild( document.createElement( "div" ) ),
		input = document.createElement( "input" );

	// Support: Android 4.0 - 4.3 only
	// Check state lost if the name is set (#11217)
	// Support: Windows Web Apps (WWA)
	// `name` and `type` must use .setAttribute for WWA (#14901)
	input.setAttribute( "type", "radio" );
	input.setAttribute( "checked", "checked" );
	input.setAttribute( "name", "t" );

	div.appendChild( input );

	// Support: Android <=4.1 only
	// Older WebKit doesn't clone checked state correctly in fragments
	support.checkClone = div.cloneNode( true ).cloneNode( true ).lastChild.checked;

	// Support: IE <=11 only
	// Make sure textarea (and checkbox) defaultValue is properly cloned
	div.innerHTML = "<textarea>x</textarea>";
	support.noCloneChecked = !!div.cloneNode( true ).lastChild.defaultValue;
} )();
var documentElement = document.documentElement;



var
	rkeyEvent = /^key/,
	rmouseEvent = /^(?:mouse|pointer|contextmenu|drag|drop)|click/,
	rtypenamespace = /^([^.]*)(?:\.(.+)|)/;

function returnTrue() {
	return true;
}

function returnFalse() {
	return false;
}

// Support: IE <=9 only
// See #13393 for more info
function safeActiveElement() {
	try {
		return document.activeElement;
	} catch ( err ) { }
}

function on( elem, types, selector, data, fn, one ) {
	var origFn, type;

	// Types can be a map of types/handlers
	if ( typeof types === "object" ) {

		// ( types-Object, selector, data )
		if ( typeof selector !== "string" ) {

			// ( types-Object, data )
			data = data || selector;
			selector = undefined;
		}
		for ( type in types ) {
			on( elem, type, selector, data, types[ type ], one );
		}
		return elem;
	}

	if ( data == null && fn == null ) {

		// ( types, fn )
		fn = selector;
		data = selector = undefined;
	} else if ( fn == null ) {
		if ( typeof selector === "string" ) {

			// ( types, selector, fn )
			fn = data;
			data = undefined;
		} else {

			// ( types, data, fn )
			fn = data;
			data = selector;
			selector = undefined;
		}
	}
	if ( fn === false ) {
		fn = returnFalse;
	} else if ( !fn ) {
		return elem;
	}

	if ( one === 1 ) {
		origFn = fn;
		fn = function( event ) {

			// Can use an empty set, since event contains the info
			jQuery().off( event );
			return origFn.apply( this, arguments );
		};

		// Use same guid so caller can remove using origFn
		fn.guid = origFn.guid || ( origFn.guid = jQuery.guid++ );
	}
	return elem.each( function() {
		jQuery.event.add( this, types, fn, data, selector );
	} );
}

/*
 * Helper functions for managing events -- not part of the public interface.
 * Props to Dean Edwards' addEvent library for many of the ideas.
 */
jQuery.event = {

	global: {},

	add: function( elem, types, handler, data, selector ) {

		var handleObjIn, eventHandle, tmp,
			events, t, handleObj,
			special, handlers, type, namespaces, origType,
			elemData = dataPriv.get( elem );

		// Don't attach events to noData or text/comment nodes (but allow plain objects)
		if ( !elemData ) {
			return;
		}

		// Caller can pass in an object of custom data in lieu of the handler
		if ( handler.handler ) {
			handleObjIn = handler;
			handler = handleObjIn.handler;
			selector = handleObjIn.selector;
		}

		// Ensure that invalid selectors throw exceptions at attach time
		// Evaluate against documentElement in case elem is a non-element node (e.g., document)
		if ( selector ) {
			jQuery.find.matchesSelector( documentElement, selector );
		}

		// Make sure that the handler has a unique ID, used to find/remove it later
		if ( !handler.guid ) {
			handler.guid = jQuery.guid++;
		}

		// Init the element's event structure and main handler, if this is the first
		if ( !( events = elemData.events ) ) {
			events = elemData.events = {};
		}
		if ( !( eventHandle = elemData.handle ) ) {
			eventHandle = elemData.handle = function( e ) {

				// Discard the second event of a jQuery.event.trigger() and
				// when an event is called after a page has unloaded
				return typeof jQuery !== "undefined" && jQuery.event.triggered !== e.type ?
					jQuery.event.dispatch.apply( elem, arguments ) : undefined;
			};
		}

		// Handle multiple events separated by a space
		types = ( types || "" ).match( rnothtmlwhite ) || [ "" ];
		t = types.length;
		while ( t-- ) {
			tmp = rtypenamespace.exec( types[ t ] ) || [];
			type = origType = tmp[ 1 ];
			namespaces = ( tmp[ 2 ] || "" ).split( "." ).sort();

			// There *must* be a type, no attaching namespace-only handlers
			if ( !type ) {
				continue;
			}

			// If event changes its type, use the special event handlers for the changed type
			special = jQuery.event.special[ type ] || {};

			// If selector defined, determine special event api type, otherwise given type
			type = ( selector ? special.delegateType : special.bindType ) || type;

			// Update special based on newly reset type
			special = jQuery.event.special[ type ] || {};

			// handleObj is passed to all event handlers
			handleObj = jQuery.extend( {
				type: type,
				origType: origType,
				data: data,
				handler: handler,
				guid: handler.guid,
				selector: selector,
				needsContext: selector && jQuery.expr.match.needsContext.test( selector ),
				namespace: namespaces.join( "." )
			}, handleObjIn );

			// Init the event handler queue if we're the first
			if ( !( handlers = events[ type ] ) ) {
				handlers = events[ type ] = [];
				handlers.delegateCount = 0;

				// Only use addEventListener if the special events handler returns false
				if ( !special.setup ||
					special.setup.call( elem, data, namespaces, eventHandle ) === false ) {

					if ( elem.addEventListener ) {
						elem.addEventListener( type, eventHandle );
					}
				}
			}

			if ( special.add ) {
				special.add.call( elem, handleObj );

				if ( !handleObj.handler.guid ) {
					handleObj.handler.guid = handler.guid;
				}
			}

			// Add to the element's handler list, delegates in front
			if ( selector ) {
				handlers.splice( handlers.delegateCount++, 0, handleObj );
			} else {
				handlers.push( handleObj );
			}

			// Keep track of which events have ever been used, for event optimization
			jQuery.event.global[ type ] = true;
		}

	},

	// Detach an event or set of events from an element
	remove: function( elem, types, handler, selector, mappedTypes ) {

		var j, origCount, tmp,
			events, t, handleObj,
			special, handlers, type, namespaces, origType,
			elemData = dataPriv.hasData( elem ) && dataPriv.get( elem );

		if ( !elemData || !( events = elemData.events ) ) {
			return;
		}

		// Once for each type.namespace in types; type may be omitted
		types = ( types || "" ).match( rnothtmlwhite ) || [ "" ];
		t = types.length;
		while ( t-- ) {
			tmp = rtypenamespace.exec( types[ t ] ) || [];
			type = origType = tmp[ 1 ];
			namespaces = ( tmp[ 2 ] || "" ).split( "." ).sort();

			// Unbind all events (on this namespace, if provided) for the element
			if ( !type ) {
				for ( type in events ) {
					jQuery.event.remove( elem, type + types[ t ], handler, selector, true );
				}
				continue;
			}

			special = jQuery.event.special[ type ] || {};
			type = ( selector ? special.delegateType : special.bindType ) || type;
			handlers = events[ type ] || [];
			tmp = tmp[ 2 ] &&
				new RegExp( "(^|\\.)" + namespaces.join( "\\.(?:.*\\.|)" ) + "(\\.|$)" );

			// Remove matching events
			origCount = j = handlers.length;
			while ( j-- ) {
				handleObj = handlers[ j ];

				if ( ( mappedTypes || origType === handleObj.origType ) &&
					( !handler || handler.guid === handleObj.guid ) &&
					( !tmp || tmp.test( handleObj.namespace ) ) &&
					( !selector || selector === handleObj.selector ||
						selector === "**" && handleObj.selector ) ) {
					handlers.splice( j, 1 );

					if ( handleObj.selector ) {
						handlers.delegateCount--;
					}
					if ( special.remove ) {
						special.remove.call( elem, handleObj );
					}
				}
			}

			// Remove generic event handler if we removed something and no more handlers exist
			// (avoids potential for endless recursion during removal of special event handlers)
			if ( origCount && !handlers.length ) {
				if ( !special.teardown ||
					special.teardown.call( elem, namespaces, elemData.handle ) === false ) {

					jQuery.removeEvent( elem, type, elemData.handle );
				}

				delete events[ type ];
			}
		}

		// Remove data and the expando if it's no longer used
		if ( jQuery.isEmptyObject( events ) ) {
			dataPriv.remove( elem, "handle events" );
		}
	},

	dispatch: function( nativeEvent ) {

		// Make a writable jQuery.Event from the native event object
		var event = jQuery.event.fix( nativeEvent );

		var i, j, ret, matched, handleObj, handlerQueue,
			args = new Array( arguments.length ),
			handlers = ( dataPriv.get( this, "events" ) || {} )[ event.type ] || [],
			special = jQuery.event.special[ event.type ] || {};

		// Use the fix-ed jQuery.Event rather than the (read-only) native event
		args[ 0 ] = event;

		for ( i = 1; i < arguments.length; i++ ) {
			args[ i ] = arguments[ i ];
		}

		event.delegateTarget = this;

		// Call the preDispatch hook for the mapped type, and let it bail if desired
		if ( special.preDispatch && special.preDispatch.call( this, event ) === false ) {
			return;
		}

		// Determine handlers
		handlerQueue = jQuery.event.handlers.call( this, event, handlers );

		// Run delegates first; they may want to stop propagation beneath us
		i = 0;
		while ( ( matched = handlerQueue[ i++ ] ) && !event.isPropagationStopped() ) {
			event.currentTarget = matched.elem;

			j = 0;
			while ( ( handleObj = matched.handlers[ j++ ] ) &&
				!event.isImmediatePropagationStopped() ) {

				// Triggered event must either 1) have no namespace, or 2) have namespace(s)
				// a subset or equal to those in the bound event (both can have no namespace).
				if ( !event.rnamespace || event.rnamespace.test( handleObj.namespace ) ) {

					event.handleObj = handleObj;
					event.data = handleObj.data;

					ret = ( ( jQuery.event.special[ handleObj.origType ] || {} ).handle ||
						handleObj.handler ).apply( matched.elem, args );

					if ( ret !== undefined ) {
						if ( ( event.result = ret ) === false ) {
							event.preventDefault();
							event.stopPropagation();
						}
					}
				}
			}
		}

		// Call the postDispatch hook for the mapped type
		if ( special.postDispatch ) {
			special.postDispatch.call( this, event );
		}

		return event.result;
	},

	handlers: function( event, handlers ) {
		var i, handleObj, sel, matchedHandlers, matchedSelectors,
			handlerQueue = [],
			delegateCount = handlers.delegateCount,
			cur = event.target;

		// Find delegate handlers
		if ( delegateCount &&

			// Support: IE <=9
			// Black-hole SVG <use> instance trees (trac-13180)
			cur.nodeType &&

			// Support: Firefox <=42
			// Suppress spec-violating clicks indicating a non-primary pointer button (trac-3861)
			// https://www.w3.org/TR/DOM-Level-3-Events/#event-type-click
			// Support: IE 11 only
			// ...but not arrow key "clicks" of radio inputs, which can have `button` -1 (gh-2343)
			!( event.type === "click" && event.button >= 1 ) ) {

			for ( ; cur !== this; cur = cur.parentNode || this ) {

				// Don't check non-elements (#13208)
				// Don't process clicks on disabled elements (#6911, #8165, #11382, #11764)
				if ( cur.nodeType === 1 && !( event.type === "click" && cur.disabled === true ) ) {
					matchedHandlers = [];
					matchedSelectors = {};
					for ( i = 0; i < delegateCount; i++ ) {
						handleObj = handlers[ i ];

						// Don't conflict with Object.prototype properties (#13203)
						sel = handleObj.selector + " ";

						if ( matchedSelectors[ sel ] === undefined ) {
							matchedSelectors[ sel ] = handleObj.needsContext ?
								jQuery( sel, this ).index( cur ) > -1 :
								jQuery.find( sel, this, null, [ cur ] ).length;
						}
						if ( matchedSelectors[ sel ] ) {
							matchedHandlers.push( handleObj );
						}
					}
					if ( matchedHandlers.length ) {
						handlerQueue.push( { elem: cur, handlers: matchedHandlers } );
					}
				}
			}
		}

		// Add the remaining (directly-bound) handlers
		cur = this;
		if ( delegateCount < handlers.length ) {
			handlerQueue.push( { elem: cur, handlers: handlers.slice( delegateCount ) } );
		}

		return handlerQueue;
	},

	addProp: function( name, hook ) {
		Object.defineProperty( jQuery.Event.prototype, name, {
			enumerable: true,
			configurable: true,

			get: jQuery.isFunction( hook ) ?
				function() {
					if ( this.originalEvent ) {
							return hook( this.originalEvent );
					}
				} :
				function() {
					if ( this.originalEvent ) {
							return this.originalEvent[ name ];
					}
				},

			set: function( value ) {
				Object.defineProperty( this, name, {
					enumerable: true,
					configurable: true,
					writable: true,
					value: value
				} );
			}
		} );
	},

	fix: function( originalEvent ) {
		return originalEvent[ jQuery.expando ] ?
			originalEvent :
			new jQuery.Event( originalEvent );
	},

	special: {
		load: {

			// Prevent triggered image.load events from bubbling to window.load
			noBubble: true
		},
		focus: {

			// Fire native event if possible so blur/focus sequence is correct
			trigger: function() {
				if ( this !== safeActiveElement() && this.focus ) {
					this.focus();
					return false;
				}
			},
			delegateType: "focusin"
		},
		blur: {
			trigger: function() {
				if ( this === safeActiveElement() && this.blur ) {
					this.blur();
					return false;
				}
			},
			delegateType: "focusout"
		},
		click: {

			// For checkbox, fire native event so checked state will be right
			trigger: function() {
				if ( this.type === "checkbox" && this.click && nodeName( this, "input" ) ) {
					this.click();
					return false;
				}
			},

			// For cross-browser consistency, don't fire native .click() on links
			_default: function( event ) {
				return nodeName( event.target, "a" );
			}
		},

		beforeunload: {
			postDispatch: function( event ) {

				// Support: Firefox 20+
				// Firefox doesn't alert if the returnValue field is not set.
				if ( event.result !== undefined && event.originalEvent ) {
					event.originalEvent.returnValue = event.result;
				}
			}
		}
	}
};

jQuery.removeEvent = function( elem, type, handle ) {

	// This "if" is needed for plain objects
	if ( elem.removeEventListener ) {
		elem.removeEventListener( type, handle );
	}
};

jQuery.Event = function( src, props ) {

	// Allow instantiation without the 'new' keyword
	if ( !( this instanceof jQuery.Event ) ) {
		return new jQuery.Event( src, props );
	}

	// Event object
	if ( src && src.type ) {
		this.originalEvent = src;
		this.type = src.type;

		// Events bubbling up the document may have been marked as prevented
		// by a handler lower down the tree; reflect the correct value.
		this.isDefaultPrevented = src.defaultPrevented ||
				src.defaultPrevented === undefined &&

				// Support: Android <=2.3 only
				src.returnValue === false ?
			returnTrue :
			returnFalse;

		// Create target properties
		// Support: Safari <=6 - 7 only
		// Target should not be a text node (#504, #13143)
		this.target = ( src.target && src.target.nodeType === 3 ) ?
			src.target.parentNode :
			src.target;

		this.currentTarget = src.currentTarget;
		this.relatedTarget = src.relatedTarget;

	// Event type
	} else {
		this.type = src;
	}

	// Put explicitly provided properties onto the event object
	if ( props ) {
		jQuery.extend( this, props );
	}

	// Create a timestamp if incoming event doesn't have one
	this.timeStamp = src && src.timeStamp || jQuery.now();

	// Mark it as fixed
	this[ jQuery.expando ] = true;
};

// jQuery.Event is based on DOM3 Events as specified by the ECMAScript Language Binding
// https://www.w3.org/TR/2003/WD-DOM-Level-3-Events-20030331/ecma-script-binding.html
jQuery.Event.prototype = {
	constructor: jQuery.Event,
	isDefaultPrevented: returnFalse,
	isPropagationStopped: returnFalse,
	isImmediatePropagationStopped: returnFalse,
	isSimulated: false,

	preventDefault: function() {
		var e = this.originalEvent;

		this.isDefaultPrevented = returnTrue;

		if ( e && !this.isSimulated ) {
			e.preventDefault();
		}
	},
	stopPropagation: function() {
		var e = this.originalEvent;

		this.isPropagationStopped = returnTrue;

		if ( e && !this.isSimulated ) {
			e.stopPropagation();
		}
	},
	stopImmediatePropagation: function() {
		var e = this.originalEvent;

		this.isImmediatePropagationStopped = returnTrue;

		if ( e && !this.isSimulated ) {
			e.stopImmediatePropagation();
		}

		this.stopPropagation();
	}
};

// Includes all common event props including KeyEvent and MouseEvent specific props
jQuery.each( {
	altKey: true,
	bubbles: true,
	cancelable: true,
	changedTouches: true,
	ctrlKey: true,
	detail: true,
	eventPhase: true,
	metaKey: true,
	pageX: true,
	pageY: true,
	shiftKey: true,
	view: true,
	"char": true,
	charCode: true,
	key: true,
	keyCode: true,
	button: true,
	buttons: true,
	clientX: true,
	clientY: true,
	offsetX: true,
	offsetY: true,
	pointerId: true,
	pointerType: true,
	screenX: true,
	screenY: true,
	targetTouches: true,
	toElement: true,
	touches: true,

	which: function( event ) {
		var button = event.button;

		// Add which for key events
		if ( event.which == null && rkeyEvent.test( event.type ) ) {
			return event.charCode != null ? event.charCode : event.keyCode;
		}

		// Add which for click: 1 === left; 2 === middle; 3 === right
		if ( !event.which && button !== undefined && rmouseEvent.test( event.type ) ) {
			if ( button & 1 ) {
				return 1;
			}

			if ( button & 2 ) {
				return 3;
			}

			if ( button & 4 ) {
				return 2;
			}

			return 0;
		}

		return event.which;
	}
}, jQuery.event.addProp );

// Create mouseenter/leave events using mouseover/out and event-time checks
// so that event delegation works in jQuery.
// Do the same for pointerenter/pointerleave and pointerover/pointerout
//
// Support: Safari 7 only
// Safari sends mouseenter too often; see:
// https://bugs.chromium.org/p/chromium/issues/detail?id=470258
// for the description of the bug (it existed in older Chrome versions as well).
jQuery.each( {
	mouseenter: "mouseover",
	mouseleave: "mouseout",
	pointerenter: "pointerover",
	pointerleave: "pointerout"
}, function( orig, fix ) {
	jQuery.event.special[ orig ] = {
		delegateType: fix,
		bindType: fix,

		handle: function( event ) {
			var ret,
				target = this,
				related = event.relatedTarget,
				handleObj = event.handleObj;

			// For mouseenter/leave call the handler if related is outside the target.
			// NB: No relatedTarget if the mouse left/entered the browser window
			if ( !related || ( related !== target && !jQuery.contains( target, related ) ) ) {
				event.type = handleObj.origType;
				ret = handleObj.handler.apply( this, arguments );
				event.type = fix;
			}
			return ret;
		}
	};
} );

jQuery.fn.extend( {

	on: function( types, selector, data, fn ) {
		return on( this, types, selector, data, fn );
	},
	one: function( types, selector, data, fn ) {
		return on( this, types, selector, data, fn, 1 );
	},
	off: function( types, selector, fn ) {
		var handleObj, type;
		if ( types && types.preventDefault && types.handleObj ) {

			// ( event )  dispatched jQuery.Event
			handleObj = types.handleObj;
			jQuery( types.delegateTarget ).off(
				handleObj.namespace ?
					handleObj.origType + "." + handleObj.namespace :
					handleObj.origType,
				handleObj.selector,
				handleObj.handler
			);
			return this;
		}
		if ( typeof types === "object" ) {

			// ( types-object [, selector] )
			for ( type in types ) {
				this.off( type, selector, types[ type ] );
			}
			return this;
		}
		if ( selector === false || typeof selector === "function" ) {

			// ( types [, fn] )
			fn = selector;
			selector = undefined;
		}
		if ( fn === false ) {
			fn = returnFalse;
		}
		return this.each( function() {
			jQuery.event.remove( this, types, fn, selector );
		} );
	}
} );


var

	/* eslint-disable max-len */

	// See https://github.com/eslint/eslint/issues/3229
	rxhtmlTag = /<(?!area|br|col|embed|hr|img|input|link|meta|param)(([a-z][^\/\0>\x20\t\r\n\f]*)[^>]*)\/>/gi,

	/* eslint-enable */

	// Support: IE <=10 - 11, Edge 12 - 13
	// In IE/Edge using regex groups here causes severe slowdowns.
	// See https://connect.microsoft.com/IE/feedback/details/1736512/
	rnoInnerhtml = /<script|<style|<link/i,

	// checked="checked" or checked
	rchecked = /checked\s*(?:[^=]|=\s*.checked.)/i,
	rscriptTypeMasked = /^true\/(.*)/,
	rcleanScript = /^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g;

// Prefer a tbody over its parent table for containing new rows
function manipulationTarget( elem, content ) {
	if ( nodeName( elem, "table" ) &&
		nodeName( content.nodeType !== 11 ? content : content.firstChild, "tr" ) ) {

		return jQuery( ">tbody", elem )[ 0 ] || elem;
	}

	return elem;
}

// Replace/restore the type attribute of script elements for safe DOM manipulation
function disableScript( elem ) {
	elem.type = ( elem.getAttribute( "type" ) !== null ) + "/" + elem.type;
	return elem;
}
function restoreScript( elem ) {
	var match = rscriptTypeMasked.exec( elem.type );

	if ( match ) {
		elem.type = match[ 1 ];
	} else {
		elem.removeAttribute( "type" );
	}

	return elem;
}

function cloneCopyEvent( src, dest ) {
	var i, l, type, pdataOld, pdataCur, udataOld, udataCur, events;

	if ( dest.nodeType !== 1 ) {
		return;
	}

	// 1. Copy private data: events, handlers, etc.
	if ( dataPriv.hasData( src ) ) {
		pdataOld = dataPriv.access( src );
		pdataCur = dataPriv.set( dest, pdataOld );
		events = pdataOld.events;

		if ( events ) {
			delete pdataCur.handle;
			pdataCur.events = {};

			for ( type in events ) {
				for ( i = 0, l = events[ type ].length; i < l; i++ ) {
					jQuery.event.add( dest, type, events[ type ][ i ] );
				}
			}
		}
	}

	// 2. Copy user data
	if ( dataUser.hasData( src ) ) {
		udataOld = dataUser.access( src );
		udataCur = jQuery.extend( {}, udataOld );

		dataUser.set( dest, udataCur );
	}
}

// Fix IE bugs, see support tests
function fixInput( src, dest ) {
	var nodeName = dest.nodeName.toLowerCase();

	// Fails to persist the checked state of a cloned checkbox or radio button.
	if ( nodeName === "input" && rcheckableType.test( src.type ) ) {
		dest.checked = src.checked;

	// Fails to return the selected option to the default selected state when cloning options
	} else if ( nodeName === "input" || nodeName === "textarea" ) {
		dest.defaultValue = src.defaultValue;
	}
}

function domManip( collection, args, callback, ignored ) {

	// Flatten any nested arrays
	args = concat.apply( [], args );

	var fragment, first, scripts, hasScripts, node, doc,
		i = 0,
		l = collection.length,
		iNoClone = l - 1,
		value = args[ 0 ],
		isFunction = jQuery.isFunction( value );

	// We can't cloneNode fragments that contain checked, in WebKit
	if ( isFunction ||
			( l > 1 && typeof value === "string" &&
				!support.checkClone && rchecked.test( value ) ) ) {
		return collection.each( function( index ) {
			var self = collection.eq( index );
			if ( isFunction ) {
				args[ 0 ] = value.call( this, index, self.html() );
			}
			domManip( self, args, callback, ignored );
		} );
	}

	if ( l ) {
		fragment = buildFragment( args, collection[ 0 ].ownerDocument, false, collection, ignored );
		first = fragment.firstChild;

		if ( fragment.childNodes.length === 1 ) {
			fragment = first;
		}

		// Require either new content or an interest in ignored elements to invoke the callback
		if ( first || ignored ) {
			scripts = jQuery.map( getAll( fragment, "script" ), disableScript );
			hasScripts = scripts.length;

			// Use the original fragment for the last item
			// instead of the first because it can end up
			// being emptied incorrectly in certain situations (#8070).
			for ( ; i < l; i++ ) {
				node = fragment;

				if ( i !== iNoClone ) {
					node = jQuery.clone( node, true, true );

					// Keep references to cloned scripts for later restoration
					if ( hasScripts ) {

						// Support: Android <=4.0 only, PhantomJS 1 only
						// push.apply(_, arraylike) throws on ancient WebKit
						jQuery.merge( scripts, getAll( node, "script" ) );
					}
				}

				callback.call( collection[ i ], node, i );
			}

			if ( hasScripts ) {
				doc = scripts[ scripts.length - 1 ].ownerDocument;

				// Reenable scripts
				jQuery.map( scripts, restoreScript );

				// Evaluate executable scripts on first document insertion
				for ( i = 0; i < hasScripts; i++ ) {
					node = scripts[ i ];
					if ( rscriptType.test( node.type || "" ) &&
						!dataPriv.access( node, "globalEval" ) &&
						jQuery.contains( doc, node ) ) {

						if ( node.src ) {

							// Optional AJAX dependency, but won't run scripts if not present
							if ( jQuery._evalUrl ) {
								jQuery._evalUrl( node.src );
							}
						} else {
							DOMEval( node.textContent.replace( rcleanScript, "" ), doc );
						}
					}
				}
			}
		}
	}

	return collection;
}

function remove( elem, selector, keepData ) {
	var node,
		nodes = selector ? jQuery.filter( selector, elem ) : elem,
		i = 0;

	for ( ; ( node = nodes[ i ] ) != null; i++ ) {
		if ( !keepData && node.nodeType === 1 ) {
			jQuery.cleanData( getAll( node ) );
		}

		if ( node.parentNode ) {
			if ( keepData && jQuery.contains( node.ownerDocument, node ) ) {
				setGlobalEval( getAll( node, "script" ) );
			}
			node.parentNode.removeChild( node );
		}
	}

	return elem;
}

jQuery.extend( {
	htmlPrefilter: function( html ) {
		return html.replace( rxhtmlTag, "<$1></$2>" );
	},

	clone: function( elem, dataAndEvents, deepDataAndEvents ) {
		var i, l, srcElements, destElements,
			clone = elem.cloneNode( true ),
			inPage = jQuery.contains( elem.ownerDocument, elem );

		// Fix IE cloning issues
		if ( !support.noCloneChecked && ( elem.nodeType === 1 || elem.nodeType === 11 ) &&
				!jQuery.isXMLDoc( elem ) ) {

			// We eschew Sizzle here for performance reasons: https://jsperf.com/getall-vs-sizzle/2
			destElements = getAll( clone );
			srcElements = getAll( elem );

			for ( i = 0, l = srcElements.length; i < l; i++ ) {
				fixInput( srcElements[ i ], destElements[ i ] );
			}
		}

		// Copy the events from the original to the clone
		if ( dataAndEvents ) {
			if ( deepDataAndEvents ) {
				srcElements = srcElements || getAll( elem );
				destElements = destElements || getAll( clone );

				for ( i = 0, l = srcElements.length; i < l; i++ ) {
					cloneCopyEvent( srcElements[ i ], destElements[ i ] );
				}
			} else {
				cloneCopyEvent( elem, clone );
			}
		}

		// Preserve script evaluation history
		destElements = getAll( clone, "script" );
		if ( destElements.length > 0 ) {
			setGlobalEval( destElements, !inPage && getAll( elem, "script" ) );
		}

		// Return the cloned set
		return clone;
	},

	cleanData: function( elems ) {
		var data, elem, type,
			special = jQuery.event.special,
			i = 0;

		for ( ; ( elem = elems[ i ] ) !== undefined; i++ ) {
			if ( acceptData( elem ) ) {
				if ( ( data = elem[ dataPriv.expando ] ) ) {
					if ( data.events ) {
						for ( type in data.events ) {
							if ( special[ type ] ) {
								jQuery.event.remove( elem, type );

							// This is a shortcut to avoid jQuery.event.remove's overhead
							} else {
								jQuery.removeEvent( elem, type, data.handle );
							}
						}
					}

					// Support: Chrome <=35 - 45+
					// Assign undefined instead of using delete, see Data#remove
					elem[ dataPriv.expando ] = undefined;
				}
				if ( elem[ dataUser.expando ] ) {

					// Support: Chrome <=35 - 45+
					// Assign undefined instead of using delete, see Data#remove
					elem[ dataUser.expando ] = undefined;
				}
			}
		}
	}
} );

jQuery.fn.extend( {
	detach: function( selector ) {
		return remove( this, selector, true );
	},

	remove: function( selector ) {
		return remove( this, selector );
	},

	text: function( value ) {
		return access( this, function( value ) {
			return value === undefined ?
				jQuery.text( this ) :
				this.empty().each( function() {
					if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
						this.textContent = value;
					}
				} );
		}, null, value, arguments.length );
	},

	append: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
				var target = manipulationTarget( this, elem );
				target.appendChild( elem );
			}
		} );
	},

	prepend: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
				var target = manipulationTarget( this, elem );
				target.insertBefore( elem, target.firstChild );
			}
		} );
	},

	before: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.parentNode ) {
				this.parentNode.insertBefore( elem, this );
			}
		} );
	},

	after: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.parentNode ) {
				this.parentNode.insertBefore( elem, this.nextSibling );
			}
		} );
	},

	empty: function() {
		var elem,
			i = 0;

		for ( ; ( elem = this[ i ] ) != null; i++ ) {
			if ( elem.nodeType === 1 ) {

				// Prevent memory leaks
				jQuery.cleanData( getAll( elem, false ) );

				// Remove any remaining nodes
				elem.textContent = "";
			}
		}

		return this;
	},

	clone: function( dataAndEvents, deepDataAndEvents ) {
		dataAndEvents = dataAndEvents == null ? false : dataAndEvents;
		deepDataAndEvents = deepDataAndEvents == null ? dataAndEvents : deepDataAndEvents;

		return this.map( function() {
			return jQuery.clone( this, dataAndEvents, deepDataAndEvents );
		} );
	},

	html: function( value ) {
		return access( this, function( value ) {
			var elem = this[ 0 ] || {},
				i = 0,
				l = this.length;

			if ( value === undefined && elem.nodeType === 1 ) {
				return elem.innerHTML;
			}

			// See if we can take a shortcut and just use innerHTML
			if ( typeof value === "string" && !rnoInnerhtml.test( value ) &&
				!wrapMap[ ( rtagName.exec( value ) || [ "", "" ] )[ 1 ].toLowerCase() ] ) {

				value = jQuery.htmlPrefilter( value );

				try {
					for ( ; i < l; i++ ) {
						elem = this[ i ] || {};

						// Remove element nodes and prevent memory leaks
						if ( elem.nodeType === 1 ) {
							jQuery.cleanData( getAll( elem, false ) );
							elem.innerHTML = value;
						}
					}

					elem = 0;

				// If using innerHTML throws an exception, use the fallback method
				} catch ( e ) {}
			}

			if ( elem ) {
				this.empty().append( value );
			}
		}, null, value, arguments.length );
	},

	replaceWith: function() {
		var ignored = [];

		// Make the changes, replacing each non-ignored context element with the new content
		return domManip( this, arguments, function( elem ) {
			var parent = this.parentNode;

			if ( jQuery.inArray( this, ignored ) < 0 ) {
				jQuery.cleanData( getAll( this ) );
				if ( parent ) {
					parent.replaceChild( elem, this );
				}
			}

		// Force callback invocation
		}, ignored );
	}
} );

jQuery.each( {
	appendTo: "append",
	prependTo: "prepend",
	insertBefore: "before",
	insertAfter: "after",
	replaceAll: "replaceWith"
}, function( name, original ) {
	jQuery.fn[ name ] = function( selector ) {
		var elems,
			ret = [],
			insert = jQuery( selector ),
			last = insert.length - 1,
			i = 0;

		for ( ; i <= last; i++ ) {
			elems = i === last ? this : this.clone( true );
			jQuery( insert[ i ] )[ original ]( elems );

			// Support: Android <=4.0 only, PhantomJS 1 only
			// .get() because push.apply(_, arraylike) throws on ancient WebKit
			push.apply( ret, elems.get() );
		}

		return this.pushStack( ret );
	};
} );
var rmargin = ( /^margin/ );

var rnumnonpx = new RegExp( "^(" + pnum + ")(?!px)[a-z%]+$", "i" );

var getStyles = function( elem ) {

		// Support: IE <=11 only, Firefox <=30 (#15098, #14150)
		// IE throws on elements created in popups
		// FF meanwhile throws on frame elements through "defaultView.getComputedStyle"
		var view = elem.ownerDocument.defaultView;

		if ( !view || !view.opener ) {
			view = window;
		}

		return view.getComputedStyle( elem );
	};



( function() {

	// Executing both pixelPosition & boxSizingReliable tests require only one layout
	// so they're executed at the same time to save the second computation.
	function computeStyleTests() {

		// This is a singleton, we need to execute it only once
		if ( !div ) {
			return;
		}

		div.style.cssText =
			"box-sizing:border-box;" +
			"position:relative;display:block;" +
			"margin:auto;border:1px;padding:1px;" +
			"top:1%;width:50%";
		div.innerHTML = "";
		documentElement.appendChild( container );

		var divStyle = window.getComputedStyle( div );
		pixelPositionVal = divStyle.top !== "1%";

		// Support: Android 4.0 - 4.3 only, Firefox <=3 - 44
		reliableMarginLeftVal = divStyle.marginLeft === "2px";
		boxSizingReliableVal = divStyle.width === "4px";

		// Support: Android 4.0 - 4.3 only
		// Some styles come back with percentage values, even though they shouldn't
		div.style.marginRight = "50%";
		pixelMarginRightVal = divStyle.marginRight === "4px";

		documentElement.removeChild( container );

		// Nullify the div so it wouldn't be stored in the memory and
		// it will also be a sign that checks already performed
		div = null;
	}

	var pixelPositionVal, boxSizingReliableVal, pixelMarginRightVal, reliableMarginLeftVal,
		container = document.createElement( "div" ),
		div = document.createElement( "div" );

	// Finish early in limited (non-browser) environments
	if ( !div.style ) {
		return;
	}

	// Support: IE <=9 - 11 only
	// Style of cloned element affects source element cloned (#8908)
	div.style.backgroundClip = "content-box";
	div.cloneNode( true ).style.backgroundClip = "";
	support.clearCloneStyle = div.style.backgroundClip === "content-box";

	container.style.cssText = "border:0;width:8px;height:0;top:0;left:-9999px;" +
		"padding:0;margin-top:1px;position:absolute";
	container.appendChild( div );

	jQuery.extend( support, {
		pixelPosition: function() {
			computeStyleTests();
			return pixelPositionVal;
		},
		boxSizingReliable: function() {
			computeStyleTests();
			return boxSizingReliableVal;
		},
		pixelMarginRight: function() {
			computeStyleTests();
			return pixelMarginRightVal;
		},
		reliableMarginLeft: function() {
			computeStyleTests();
			return reliableMarginLeftVal;
		}
	} );
} )();


function curCSS( elem, name, computed ) {
	var width, minWidth, maxWidth, ret,

		// Support: Firefox 51+
		// Retrieving style before computed somehow
		// fixes an issue with getting wrong values
		// on detached elements
		style = elem.style;

	computed = computed || getStyles( elem );

	// getPropertyValue is needed for:
	//   .css('filter') (IE 9 only, #12537)
	//   .css('--customProperty) (#3144)
	if ( computed ) {
		ret = computed.getPropertyValue( name ) || computed[ name ];

		if ( ret === "" && !jQuery.contains( elem.ownerDocument, elem ) ) {
			ret = jQuery.style( elem, name );
		}

		// A tribute to the "awesome hack by Dean Edwards"
		// Android Browser returns percentage for some values,
		// but width seems to be reliably pixels.
		// This is against the CSSOM draft spec:
		// https://drafts.csswg.org/cssom/#resolved-values
		if ( !support.pixelMarginRight() && rnumnonpx.test( ret ) && rmargin.test( name ) ) {

			// Remember the original values
			width = style.width;
			minWidth = style.minWidth;
			maxWidth = style.maxWidth;

			// Put in the new values to get a computed value out
			style.minWidth = style.maxWidth = style.width = ret;
			ret = computed.width;

			// Revert the changed values
			style.width = width;
			style.minWidth = minWidth;
			style.maxWidth = maxWidth;
		}
	}

	return ret !== undefined ?

		// Support: IE <=9 - 11 only
		// IE returns zIndex value as an integer.
		ret + "" :
		ret;
}


function addGetHookIf( conditionFn, hookFn ) {

	// Define the hook, we'll check on the first run if it's really needed.
	return {
		get: function() {
			if ( conditionFn() ) {

				// Hook not needed (or it's not possible to use it due
				// to missing dependency), remove it.
				delete this.get;
				return;
			}

			// Hook needed; redefine it so that the support test is not executed again.
			return ( this.get = hookFn ).apply( this, arguments );
		}
	};
}


var

	// Swappable if display is none or starts with table
	// except "table", "table-cell", or "table-caption"
	// See here for display values: https://developer.mozilla.org/en-US/docs/CSS/display
	rdisplayswap = /^(none|table(?!-c[ea]).+)/,
	rcustomProp = /^--/,
	cssShow = { position: "absolute", visibility: "hidden", display: "block" },
	cssNormalTransform = {
		letterSpacing: "0",
		fontWeight: "400"
	},

	cssPrefixes = [ "Webkit", "Moz", "ms" ],
	emptyStyle = document.createElement( "div" ).style;

// Return a css property mapped to a potentially vendor prefixed property
function vendorPropName( name ) {

	// Shortcut for names that are not vendor prefixed
	if ( name in emptyStyle ) {
		return name;
	}

	// Check for vendor prefixed names
	var capName = name[ 0 ].toUpperCase() + name.slice( 1 ),
		i = cssPrefixes.length;

	while ( i-- ) {
		name = cssPrefixes[ i ] + capName;
		if ( name in emptyStyle ) {
			return name;
		}
	}
}

// Return a property mapped along what jQuery.cssProps suggests or to
// a vendor prefixed property.
function finalPropName( name ) {
	var ret = jQuery.cssProps[ name ];
	if ( !ret ) {
		ret = jQuery.cssProps[ name ] = vendorPropName( name ) || name;
	}
	return ret;
}

function setPositiveNumber( elem, value, subtract ) {

	// Any relative (+/-) values have already been
	// normalized at this point
	var matches = rcssNum.exec( value );
	return matches ?

		// Guard against undefined "subtract", e.g., when used as in cssHooks
		Math.max( 0, matches[ 2 ] - ( subtract || 0 ) ) + ( matches[ 3 ] || "px" ) :
		value;
}

function augmentWidthOrHeight( elem, name, extra, isBorderBox, styles ) {
	var i,
		val = 0;

	// If we already have the right measurement, avoid augmentation
	if ( extra === ( isBorderBox ? "border" : "content" ) ) {
		i = 4;

	// Otherwise initialize for horizontal or vertical properties
	} else {
		i = name === "width" ? 1 : 0;
	}

	for ( ; i < 4; i += 2 ) {

		// Both box models exclude margin, so add it if we want it
		if ( extra === "margin" ) {
			val += jQuery.css( elem, extra + cssExpand[ i ], true, styles );
		}

		if ( isBorderBox ) {

			// border-box includes padding, so remove it if we want content
			if ( extra === "content" ) {
				val -= jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );
			}

			// At this point, extra isn't border nor margin, so remove border
			if ( extra !== "margin" ) {
				val -= jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
			}
		} else {

			// At this point, extra isn't content, so add padding
			val += jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );

			// At this point, extra isn't content nor padding, so add border
			if ( extra !== "padding" ) {
				val += jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
			}
		}
	}

	return val;
}

function getWidthOrHeight( elem, name, extra ) {

	// Start with computed style
	var valueIsBorderBox,
		styles = getStyles( elem ),
		val = curCSS( elem, name, styles ),
		isBorderBox = jQuery.css( elem, "boxSizing", false, styles ) === "border-box";

	// Computed unit is not pixels. Stop here and return.
	if ( rnumnonpx.test( val ) ) {
		return val;
	}

	// Check for style in case a browser which returns unreliable values
	// for getComputedStyle silently falls back to the reliable elem.style
	valueIsBorderBox = isBorderBox &&
		( support.boxSizingReliable() || val === elem.style[ name ] );

	// Fall back to offsetWidth/Height when value is "auto"
	// This happens for inline elements with no explicit setting (gh-3571)
	if ( val === "auto" ) {
		val = elem[ "offset" + name[ 0 ].toUpperCase() + name.slice( 1 ) ];
	}

	// Normalize "", auto, and prepare for extra
	val = parseFloat( val ) || 0;

	// Use the active box-sizing model to add/subtract irrelevant styles
	return ( val +
		augmentWidthOrHeight(
			elem,
			name,
			extra || ( isBorderBox ? "border" : "content" ),
			valueIsBorderBox,
			styles
		)
	) + "px";
}

jQuery.extend( {

	// Add in style property hooks for overriding the default
	// behavior of getting and setting a style property
	cssHooks: {
		opacity: {
			get: function( elem, computed ) {
				if ( computed ) {

					// We should always get a number back from opacity
					var ret = curCSS( elem, "opacity" );
					return ret === "" ? "1" : ret;
				}
			}
		}
	},

	// Don't automatically add "px" to these possibly-unitless properties
	cssNumber: {
		"animationIterationCount": true,
		"columnCount": true,
		"fillOpacity": true,
		"flexGrow": true,
		"flexShrink": true,
		"fontWeight": true,
		"lineHeight": true,
		"opacity": true,
		"order": true,
		"orphans": true,
		"widows": true,
		"zIndex": true,
		"zoom": true
	},

	// Add in properties whose names you wish to fix before
	// setting or getting the value
	cssProps: {
		"float": "cssFloat"
	},

	// Get and set the style property on a DOM Node
	style: function( elem, name, value, extra ) {

		// Don't set styles on text and comment nodes
		if ( !elem || elem.nodeType === 3 || elem.nodeType === 8 || !elem.style ) {
			return;
		}

		// Make sure that we're working with the right name
		var ret, type, hooks,
			origName = jQuery.camelCase( name ),
			isCustomProp = rcustomProp.test( name ),
			style = elem.style;

		// Make sure that we're working with the right name. We don't
		// want to query the value if it is a CSS custom property
		// since they are user-defined.
		if ( !isCustomProp ) {
			name = finalPropName( origName );
		}

		// Gets hook for the prefixed version, then unprefixed version
		hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];

		// Check if we're setting a value
		if ( value !== undefined ) {
			type = typeof value;

			// Convert "+=" or "-=" to relative numbers (#7345)
			if ( type === "string" && ( ret = rcssNum.exec( value ) ) && ret[ 1 ] ) {
				value = adjustCSS( elem, name, ret );

				// Fixes bug #9237
				type = "number";
			}

			// Make sure that null and NaN values aren't set (#7116)
			if ( value == null || value !== value ) {
				return;
			}

			// If a number was passed in, add the unit (except for certain CSS properties)
			if ( type === "number" ) {
				value += ret && ret[ 3 ] || ( jQuery.cssNumber[ origName ] ? "" : "px" );
			}

			// background-* props affect original clone's values
			if ( !support.clearCloneStyle && value === "" && name.indexOf( "background" ) === 0 ) {
				style[ name ] = "inherit";
			}

			// If a hook was provided, use that value, otherwise just set the specified value
			if ( !hooks || !( "set" in hooks ) ||
				( value = hooks.set( elem, value, extra ) ) !== undefined ) {

				if ( isCustomProp ) {
					style.setProperty( name, value );
				} else {
					style[ name ] = value;
				}
			}

		} else {

			// If a hook was provided get the non-computed value from there
			if ( hooks && "get" in hooks &&
				( ret = hooks.get( elem, false, extra ) ) !== undefined ) {

				return ret;
			}

			// Otherwise just get the value from the style object
			return style[ name ];
		}
	},

	css: function( elem, name, extra, styles ) {
		var val, num, hooks,
			origName = jQuery.camelCase( name ),
			isCustomProp = rcustomProp.test( name );

		// Make sure that we're working with the right name. We don't
		// want to modify the value if it is a CSS custom property
		// since they are user-defined.
		if ( !isCustomProp ) {
			name = finalPropName( origName );
		}

		// Try prefixed name followed by the unprefixed name
		hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];

		// If a hook was provided get the computed value from there
		if ( hooks && "get" in hooks ) {
			val = hooks.get( elem, true, extra );
		}

		// Otherwise, if a way to get the computed value exists, use that
		if ( val === undefined ) {
			val = curCSS( elem, name, styles );
		}

		// Convert "normal" to computed value
		if ( val === "normal" && name in cssNormalTransform ) {
			val = cssNormalTransform[ name ];
		}

		// Make numeric if forced or a qualifier was provided and val looks numeric
		if ( extra === "" || extra ) {
			num = parseFloat( val );
			return extra === true || isFinite( num ) ? num || 0 : val;
		}

		return val;
	}
} );

jQuery.each( [ "height", "width" ], function( i, name ) {
	jQuery.cssHooks[ name ] = {
		get: function( elem, computed, extra ) {
			if ( computed ) {

				// Certain elements can have dimension info if we invisibly show them
				// but it must have a current display style that would benefit
				return rdisplayswap.test( jQuery.css( elem, "display" ) ) &&

					// Support: Safari 8+
					// Table columns in Safari have non-zero offsetWidth & zero
					// getBoundingClientRect().width unless display is changed.
					// Support: IE <=11 only
					// Running getBoundingClientRect on a disconnected node
					// in IE throws an error.
					( !elem.getClientRects().length || !elem.getBoundingClientRect().width ) ?
						swap( elem, cssShow, function() {
							return getWidthOrHeight( elem, name, extra );
						} ) :
						getWidthOrHeight( elem, name, extra );
			}
		},

		set: function( elem, value, extra ) {
			var matches,
				styles = extra && getStyles( elem ),
				subtract = extra && augmentWidthOrHeight(
					elem,
					name,
					extra,
					jQuery.css( elem, "boxSizing", false, styles ) === "border-box",
					styles
				);

			// Convert to pixels if value adjustment is needed
			if ( subtract && ( matches = rcssNum.exec( value ) ) &&
				( matches[ 3 ] || "px" ) !== "px" ) {

				elem.style[ name ] = value;
				value = jQuery.css( elem, name );
			}

			return setPositiveNumber( elem, value, subtract );
		}
	};
} );

jQuery.cssHooks.marginLeft = addGetHookIf( support.reliableMarginLeft,
	function( elem, computed ) {
		if ( computed ) {
			return ( parseFloat( curCSS( elem, "marginLeft" ) ) ||
				elem.getBoundingClientRect().left -
					swap( elem, { marginLeft: 0 }, function() {
						return elem.getBoundingClientRect().left;
					} )
				) + "px";
		}
	}
);

// These hooks are used by animate to expand properties
jQuery.each( {
	margin: "",
	padding: "",
	border: "Width"
}, function( prefix, suffix ) {
	jQuery.cssHooks[ prefix + suffix ] = {
		expand: function( value ) {
			var i = 0,
				expanded = {},

				// Assumes a single number if not a string
				parts = typeof value === "string" ? value.split( " " ) : [ value ];

			for ( ; i < 4; i++ ) {
				expanded[ prefix + cssExpand[ i ] + suffix ] =
					parts[ i ] || parts[ i - 2 ] || parts[ 0 ];
			}

			return expanded;
		}
	};

	if ( !rmargin.test( prefix ) ) {
		jQuery.cssHooks[ prefix + suffix ].set = setPositiveNumber;
	}
} );

jQuery.fn.extend( {
	css: function( name, value ) {
		return access( this, function( elem, name, value ) {
			var styles, len,
				map = {},
				i = 0;

			if ( Array.isArray( name ) ) {
				styles = getStyles( elem );
				len = name.length;

				for ( ; i < len; i++ ) {
					map[ name[ i ] ] = jQuery.css( elem, name[ i ], false, styles );
				}

				return map;
			}

			return value !== undefined ?
				jQuery.style( elem, name, value ) :
				jQuery.css( elem, name );
		}, name, value, arguments.length > 1 );
	}
} );


function Tween( elem, options, prop, end, easing ) {
	return new Tween.prototype.init( elem, options, prop, end, easing );
}
jQuery.Tween = Tween;

Tween.prototype = {
	constructor: Tween,
	init: function( elem, options, prop, end, easing, unit ) {
		this.elem = elem;
		this.prop = prop;
		this.easing = easing || jQuery.easing._default;
		this.options = options;
		this.start = this.now = this.cur();
		this.end = end;
		this.unit = unit || ( jQuery.cssNumber[ prop ] ? "" : "px" );
	},
	cur: function() {
		var hooks = Tween.propHooks[ this.prop ];

		return hooks && hooks.get ?
			hooks.get( this ) :
			Tween.propHooks._default.get( this );
	},
	run: function( percent ) {
		var eased,
			hooks = Tween.propHooks[ this.prop ];

		if ( this.options.duration ) {
			this.pos = eased = jQuery.easing[ this.easing ](
				percent, this.options.duration * percent, 0, 1, this.options.duration
			);
		} else {
			this.pos = eased = percent;
		}
		this.now = ( this.end - this.start ) * eased + this.start;

		if ( this.options.step ) {
			this.options.step.call( this.elem, this.now, this );
		}

		if ( hooks && hooks.set ) {
			hooks.set( this );
		} else {
			Tween.propHooks._default.set( this );
		}
		return this;
	}
};

Tween.prototype.init.prototype = Tween.prototype;

Tween.propHooks = {
	_default: {
		get: function( tween ) {
			var result;

			// Use a property on the element directly when it is not a DOM element,
			// or when there is no matching style property that exists.
			if ( tween.elem.nodeType !== 1 ||
				tween.elem[ tween.prop ] != null && tween.elem.style[ tween.prop ] == null ) {
				return tween.elem[ tween.prop ];
			}

			// Passing an empty string as a 3rd parameter to .css will automatically
			// attempt a parseFloat and fallback to a string if the parse fails.
			// Simple values such as "10px" are parsed to Float;
			// complex values such as "rotate(1rad)" are returned as-is.
			result = jQuery.css( tween.elem, tween.prop, "" );

			// Empty strings, null, undefined and "auto" are converted to 0.
			return !result || result === "auto" ? 0 : result;
		},
		set: function( tween ) {

			// Use step hook for back compat.
			// Use cssHook if its there.
			// Use .style if available and use plain properties where available.
			if ( jQuery.fx.step[ tween.prop ] ) {
				jQuery.fx.step[ tween.prop ]( tween );
			} else if ( tween.elem.nodeType === 1 &&
				( tween.elem.style[ jQuery.cssProps[ tween.prop ] ] != null ||
					jQuery.cssHooks[ tween.prop ] ) ) {
				jQuery.style( tween.elem, tween.prop, tween.now + tween.unit );
			} else {
				tween.elem[ tween.prop ] = tween.now;
			}
		}
	}
};

// Support: IE <=9 only
// Panic based approach to setting things on disconnected nodes
Tween.propHooks.scrollTop = Tween.propHooks.scrollLeft = {
	set: function( tween ) {
		if ( tween.elem.nodeType && tween.elem.parentNode ) {
			tween.elem[ tween.prop ] = tween.now;
		}
	}
};

jQuery.easing = {
	linear: function( p ) {
		return p;
	},
	swing: function( p ) {
		return 0.5 - Math.cos( p * Math.PI ) / 2;
	},
	_default: "swing"
};

jQuery.fx = Tween.prototype.init;

// Back compat <1.8 extension point
jQuery.fx.step = {};




var
	fxNow, inProgress,
	rfxtypes = /^(?:toggle|show|hide)$/,
	rrun = /queueHooks$/;

function schedule() {
	if ( inProgress ) {
		if ( document.hidden === false && window.requestAnimationFrame ) {
			window.requestAnimationFrame( schedule );
		} else {
			window.setTimeout( schedule, jQuery.fx.interval );
		}

		jQuery.fx.tick();
	}
}

// Animations created synchronously will run synchronously
function createFxNow() {
	window.setTimeout( function() {
		fxNow = undefined;
	} );
	return ( fxNow = jQuery.now() );
}

// Generate parameters to create a standard animation
function genFx( type, includeWidth ) {
	var which,
		i = 0,
		attrs = { height: type };

	// If we include width, step value is 1 to do all cssExpand values,
	// otherwise step value is 2 to skip over Left and Right
	includeWidth = includeWidth ? 1 : 0;
	for ( ; i < 4; i += 2 - includeWidth ) {
		which = cssExpand[ i ];
		attrs[ "margin" + which ] = attrs[ "padding" + which ] = type;
	}

	if ( includeWidth ) {
		attrs.opacity = attrs.width = type;
	}

	return attrs;
}

function createTween( value, prop, animation ) {
	var tween,
		collection = ( Animation.tweeners[ prop ] || [] ).concat( Animation.tweeners[ "*" ] ),
		index = 0,
		length = collection.length;
	for ( ; index < length; index++ ) {
		if ( ( tween = collection[ index ].call( animation, prop, value ) ) ) {

			// We're done with this property
			return tween;
		}
	}
}

function defaultPrefilter( elem, props, opts ) {
	var prop, value, toggle, hooks, oldfire, propTween, restoreDisplay, display,
		isBox = "width" in props || "height" in props,
		anim = this,
		orig = {},
		style = elem.style,
		hidden = elem.nodeType && isHiddenWithinTree( elem ),
		dataShow = dataPriv.get( elem, "fxshow" );

	// Queue-skipping animations hijack the fx hooks
	if ( !opts.queue ) {
		hooks = jQuery._queueHooks( elem, "fx" );
		if ( hooks.unqueued == null ) {
			hooks.unqueued = 0;
			oldfire = hooks.empty.fire;
			hooks.empty.fire = function() {
				if ( !hooks.unqueued ) {
					oldfire();
				}
			};
		}
		hooks.unqueued++;

		anim.always( function() {

			// Ensure the complete handler is called before this completes
			anim.always( function() {
				hooks.unqueued--;
				if ( !jQuery.queue( elem, "fx" ).length ) {
					hooks.empty.fire();
				}
			} );
		} );
	}

	// Detect show/hide animations
	for ( prop in props ) {
		value = props[ prop ];
		if ( rfxtypes.test( value ) ) {
			delete props[ prop ];
			toggle = toggle || value === "toggle";
			if ( value === ( hidden ? "hide" : "show" ) ) {

				// Pretend to be hidden if this is a "show" and
				// there is still data from a stopped show/hide
				if ( value === "show" && dataShow && dataShow[ prop ] !== undefined ) {
					hidden = true;

				// Ignore all other no-op show/hide data
				} else {
					continue;
				}
			}
			orig[ prop ] = dataShow && dataShow[ prop ] || jQuery.style( elem, prop );
		}
	}

	// Bail out if this is a no-op like .hide().hide()
	propTween = !jQuery.isEmptyObject( props );
	if ( !propTween && jQuery.isEmptyObject( orig ) ) {
		return;
	}

	// Restrict "overflow" and "display" styles during box animations
	if ( isBox && elem.nodeType === 1 ) {

		// Support: IE <=9 - 11, Edge 12 - 13
		// Record all 3 overflow attributes because IE does not infer the shorthand
		// from identically-valued overflowX and overflowY
		opts.overflow = [ style.overflow, style.overflowX, style.overflowY ];

		// Identify a display type, preferring old show/hide data over the CSS cascade
		restoreDisplay = dataShow && dataShow.display;
		if ( restoreDisplay == null ) {
			restoreDisplay = dataPriv.get( elem, "display" );
		}
		display = jQuery.css( elem, "display" );
		if ( display === "none" ) {
			if ( restoreDisplay ) {
				display = restoreDisplay;
			} else {

				// Get nonempty value(s) by temporarily forcing visibility
				showHide( [ elem ], true );
				restoreDisplay = elem.style.display || restoreDisplay;
				display = jQuery.css( elem, "display" );
				showHide( [ elem ] );
			}
		}

		// Animate inline elements as inline-block
		if ( display === "inline" || display === "inline-block" && restoreDisplay != null ) {
			if ( jQuery.css( elem, "float" ) === "none" ) {

				// Restore the original display value at the end of pure show/hide animations
				if ( !propTween ) {
					anim.done( function() {
						style.display = restoreDisplay;
					} );
					if ( restoreDisplay == null ) {
						display = style.display;
						restoreDisplay = display === "none" ? "" : display;
					}
				}
				style.display = "inline-block";
			}
		}
	}

	if ( opts.overflow ) {
		style.overflow = "hidden";
		anim.always( function() {
			style.overflow = opts.overflow[ 0 ];
			style.overflowX = opts.overflow[ 1 ];
			style.overflowY = opts.overflow[ 2 ];
		} );
	}

	// Implement show/hide animations
	propTween = false;
	for ( prop in orig ) {

		// General show/hide setup for this element animation
		if ( !propTween ) {
			if ( dataShow ) {
				if ( "hidden" in dataShow ) {
					hidden = dataShow.hidden;
				}
			} else {
				dataShow = dataPriv.access( elem, "fxshow", { display: restoreDisplay } );
			}

			// Store hidden/visible for toggle so `.stop().toggle()` "reverses"
			if ( toggle ) {
				dataShow.hidden = !hidden;
			}

			// Show elements before animating them
			if ( hidden ) {
				showHide( [ elem ], true );
			}

			/* eslint-disable no-loop-func */

			anim.done( function() {

			/* eslint-enable no-loop-func */

				// The final step of a "hide" animation is actually hiding the element
				if ( !hidden ) {
					showHide( [ elem ] );
				}
				dataPriv.remove( elem, "fxshow" );
				for ( prop in orig ) {
					jQuery.style( elem, prop, orig[ prop ] );
				}
			} );
		}

		// Per-property setup
		propTween = createTween( hidden ? dataShow[ prop ] : 0, prop, anim );
		if ( !( prop in dataShow ) ) {
			dataShow[ prop ] = propTween.start;
			if ( hidden ) {
				propTween.end = propTween.start;
				propTween.start = 0;
			}
		}
	}
}

function propFilter( props, specialEasing ) {
	var index, name, easing, value, hooks;

	// camelCase, specialEasing and expand cssHook pass
	for ( index in props ) {
		name = jQuery.camelCase( index );
		easing = specialEasing[ name ];
		value = props[ index ];
		if ( Array.isArray( value ) ) {
			easing = value[ 1 ];
			value = props[ index ] = value[ 0 ];
		}

		if ( index !== name ) {
			props[ name ] = value;
			delete props[ index ];
		}

		hooks = jQuery.cssHooks[ name ];
		if ( hooks && "expand" in hooks ) {
			value = hooks.expand( value );
			delete props[ name ];

			// Not quite $.extend, this won't overwrite existing keys.
			// Reusing 'index' because we have the correct "name"
			for ( index in value ) {
				if ( !( index in props ) ) {
					props[ index ] = value[ index ];
					specialEasing[ index ] = easing;
				}
			}
		} else {
			specialEasing[ name ] = easing;
		}
	}
}

function Animation( elem, properties, options ) {
	var result,
		stopped,
		index = 0,
		length = Animation.prefilters.length,
		deferred = jQuery.Deferred().always( function() {

			// Don't match elem in the :animated selector
			delete tick.elem;
		} ),
		tick = function() {
			if ( stopped ) {
				return false;
			}
			var currentTime = fxNow || createFxNow(),
				remaining = Math.max( 0, animation.startTime + animation.duration - currentTime ),

				// Support: Android 2.3 only
				// Archaic crash bug won't allow us to use `1 - ( 0.5 || 0 )` (#12497)
				temp = remaining / animation.duration || 0,
				percent = 1 - temp,
				index = 0,
				length = animation.tweens.length;

			for ( ; index < length; index++ ) {
				animation.tweens[ index ].run( percent );
			}

			deferred.notifyWith( elem, [ animation, percent, remaining ] );

			// If there's more to do, yield
			if ( percent < 1 && length ) {
				return remaining;
			}

			// If this was an empty animation, synthesize a final progress notification
			if ( !length ) {
				deferred.notifyWith( elem, [ animation, 1, 0 ] );
			}

			// Resolve the animation and report its conclusion
			deferred.resolveWith( elem, [ animation ] );
			return false;
		},
		animation = deferred.promise( {
			elem: elem,
			props: jQuery.extend( {}, properties ),
			opts: jQuery.extend( true, {
				specialEasing: {},
				easing: jQuery.easing._default
			}, options ),
			originalProperties: properties,
			originalOptions: options,
			startTime: fxNow || createFxNow(),
			duration: options.duration,
			tweens: [],
			createTween: function( prop, end ) {
				var tween = jQuery.Tween( elem, animation.opts, prop, end,
						animation.opts.specialEasing[ prop ] || animation.opts.easing );
				animation.tweens.push( tween );
				return tween;
			},
			stop: function( gotoEnd ) {
				var index = 0,

					// If we are going to the end, we want to run all the tweens
					// otherwise we skip this part
					length = gotoEnd ? animation.tweens.length : 0;
				if ( stopped ) {
					return this;
				}
				stopped = true;
				for ( ; index < length; index++ ) {
					animation.tweens[ index ].run( 1 );
				}

				// Resolve when we played the last frame; otherwise, reject
				if ( gotoEnd ) {
					deferred.notifyWith( elem, [ animation, 1, 0 ] );
					deferred.resolveWith( elem, [ animation, gotoEnd ] );
				} else {
					deferred.rejectWith( elem, [ animation, gotoEnd ] );
				}
				return this;
			}
		} ),
		props = animation.props;

	propFilter( props, animation.opts.specialEasing );

	for ( ; index < length; index++ ) {
		result = Animation.prefilters[ index ].call( animation, elem, props, animation.opts );
		if ( result ) {
			if ( jQuery.isFunction( result.stop ) ) {
				jQuery._queueHooks( animation.elem, animation.opts.queue ).stop =
					jQuery.proxy( result.stop, result );
			}
			return result;
		}
	}

	jQuery.map( props, createTween, animation );

	if ( jQuery.isFunction( animation.opts.start ) ) {
		animation.opts.start.call( elem, animation );
	}

	// Attach callbacks from options
	animation
		.progress( animation.opts.progress )
		.done( animation.opts.done, animation.opts.complete )
		.fail( animation.opts.fail )
		.always( animation.opts.always );

	jQuery.fx.timer(
		jQuery.extend( tick, {
			elem: elem,
			anim: animation,
			queue: animation.opts.queue
		} )
	);

	return animation;
}

jQuery.Animation = jQuery.extend( Animation, {

	tweeners: {
		"*": [ function( prop, value ) {
			var tween = this.createTween( prop, value );
			adjustCSS( tween.elem, prop, rcssNum.exec( value ), tween );
			return tween;
		} ]
	},

	tweener: function( props, callback ) {
		if ( jQuery.isFunction( props ) ) {
			callback = props;
			props = [ "*" ];
		} else {
			props = props.match( rnothtmlwhite );
		}

		var prop,
			index = 0,
			length = props.length;

		for ( ; index < length; index++ ) {
			prop = props[ index ];
			Animation.tweeners[ prop ] = Animation.tweeners[ prop ] || [];
			Animation.tweeners[ prop ].unshift( callback );
		}
	},

	prefilters: [ defaultPrefilter ],

	prefilter: function( callback, prepend ) {
		if ( prepend ) {
			Animation.prefilters.unshift( callback );
		} else {
			Animation.prefilters.push( callback );
		}
	}
} );

jQuery.speed = function( speed, easing, fn ) {
	var opt = speed && typeof speed === "object" ? jQuery.extend( {}, speed ) : {
		complete: fn || !fn && easing ||
			jQuery.isFunction( speed ) && speed,
		duration: speed,
		easing: fn && easing || easing && !jQuery.isFunction( easing ) && easing
	};

	// Go to the end state if fx are off
	if ( jQuery.fx.off ) {
		opt.duration = 0;

	} else {
		if ( typeof opt.duration !== "number" ) {
			if ( opt.duration in jQuery.fx.speeds ) {
				opt.duration = jQuery.fx.speeds[ opt.duration ];

			} else {
				opt.duration = jQuery.fx.speeds._default;
			}
		}
	}

	// Normalize opt.queue - true/undefined/null -> "fx"
	if ( opt.queue == null || opt.queue === true ) {
		opt.queue = "fx";
	}

	// Queueing
	opt.old = opt.complete;

	opt.complete = function() {
		if ( jQuery.isFunction( opt.old ) ) {
			opt.old.call( this );
		}

		if ( opt.queue ) {
			jQuery.dequeue( this, opt.queue );
		}
	};

	return opt;
};

jQuery.fn.extend( {
	fadeTo: function( speed, to, easing, callback ) {

		// Show any hidden elements after setting opacity to 0
		return this.filter( isHiddenWithinTree ).css( "opacity", 0 ).show()

			// Animate to the value specified
			.end().animate( { opacity: to }, speed, easing, callback );
	},
	animate: function( prop, speed, easing, callback ) {
		var empty = jQuery.isEmptyObject( prop ),
			optall = jQuery.speed( speed, easing, callback ),
			doAnimation = function() {

				// Operate on a copy of prop so per-property easing won't be lost
				var anim = Animation( this, jQuery.extend( {}, prop ), optall );

				// Empty animations, or finishing resolves immediately
				if ( empty || dataPriv.get( this, "finish" ) ) {
					anim.stop( true );
				}
			};
			doAnimation.finish = doAnimation;

		return empty || optall.queue === false ?
			this.each( doAnimation ) :
			this.queue( optall.queue, doAnimation );
	},
	stop: function( type, clearQueue, gotoEnd ) {
		var stopQueue = function( hooks ) {
			var stop = hooks.stop;
			delete hooks.stop;
			stop( gotoEnd );
		};

		if ( typeof type !== "string" ) {
			gotoEnd = clearQueue;
			clearQueue = type;
			type = undefined;
		}
		if ( clearQueue && type !== false ) {
			this.queue( type || "fx", [] );
		}

		return this.each( function() {
			var dequeue = true,
				index = type != null && type + "queueHooks",
				timers = jQuery.timers,
				data = dataPriv.get( this );

			if ( index ) {
				if ( data[ index ] && data[ index ].stop ) {
					stopQueue( data[ index ] );
				}
			} else {
				for ( index in data ) {
					if ( data[ index ] && data[ index ].stop && rrun.test( index ) ) {
						stopQueue( data[ index ] );
					}
				}
			}

			for ( index = timers.length; index--; ) {
				if ( timers[ index ].elem === this &&
					( type == null || timers[ index ].queue === type ) ) {

					timers[ index ].anim.stop( gotoEnd );
					dequeue = false;
					timers.splice( index, 1 );
				}
			}

			// Start the next in the queue if the last step wasn't forced.
			// Timers currently will call their complete callbacks, which
			// will dequeue but only if they were gotoEnd.
			if ( dequeue || !gotoEnd ) {
				jQuery.dequeue( this, type );
			}
		} );
	},
	finish: function( type ) {
		if ( type !== false ) {
			type = type || "fx";
		}
		return this.each( function() {
			var index,
				data = dataPriv.get( this ),
				queue = data[ type + "queue" ],
				hooks = data[ type + "queueHooks" ],
				timers = jQuery.timers,
				length = queue ? queue.length : 0;

			// Enable finishing flag on private data
			data.finish = true;

			// Empty the queue first
			jQuery.queue( this, type, [] );

			if ( hooks && hooks.stop ) {
				hooks.stop.call( this, true );
			}

			// Look for any active animations, and finish them
			for ( index = timers.length; index--; ) {
				if ( timers[ index ].elem === this && timers[ index ].queue === type ) {
					timers[ index ].anim.stop( true );
					timers.splice( index, 1 );
				}
			}

			// Look for any animations in the old queue and finish them
			for ( index = 0; index < length; index++ ) {
				if ( queue[ index ] && queue[ index ].finish ) {
					queue[ index ].finish.call( this );
				}
			}

			// Turn off finishing flag
			delete data.finish;
		} );
	}
} );

jQuery.each( [ "toggle", "show", "hide" ], function( i, name ) {
	var cssFn = jQuery.fn[ name ];
	jQuery.fn[ name ] = function( speed, easing, callback ) {
		return speed == null || typeof speed === "boolean" ?
			cssFn.apply( this, arguments ) :
			this.animate( genFx( name, true ), speed, easing, callback );
	};
} );

// Generate shortcuts for custom animations
jQuery.each( {
	slideDown: genFx( "show" ),
	slideUp: genFx( "hide" ),
	slideToggle: genFx( "toggle" ),
	fadeIn: { opacity: "show" },
	fadeOut: { opacity: "hide" },
	fadeToggle: { opacity: "toggle" }
}, function( name, props ) {
	jQuery.fn[ name ] = function( speed, easing, callback ) {
		return this.animate( props, speed, easing, callback );
	};
} );

jQuery.timers = [];
jQuery.fx.tick = function() {
	var timer,
		i = 0,
		timers = jQuery.timers;

	fxNow = jQuery.now();

	for ( ; i < timers.length; i++ ) {
		timer = timers[ i ];

		// Run the timer and safely remove it when done (allowing for external removal)
		if ( !timer() && timers[ i ] === timer ) {
			timers.splice( i--, 1 );
		}
	}

	if ( !timers.length ) {
		jQuery.fx.stop();
	}
	fxNow = undefined;
};

jQuery.fx.timer = function( timer ) {
	jQuery.timers.push( timer );
	jQuery.fx.start();
};

jQuery.fx.interval = 13;
jQuery.fx.start = function() {
	if ( inProgress ) {
		return;
	}

	inProgress = true;
	schedule();
};

jQuery.fx.stop = function() {
	inProgress = null;
};

jQuery.fx.speeds = {
	slow: 600,
	fast: 200,

	// Default speed
	_default: 400
};


// Based off of the plugin by Clint Helfers, with permission.
// https://web.archive.org/web/20100324014747/http://blindsignals.com/index.php/2009/07/jquery-delay/
jQuery.fn.delay = function( time, type ) {
	time = jQuery.fx ? jQuery.fx.speeds[ time ] || time : time;
	type = type || "fx";

	return this.queue( type, function( next, hooks ) {
		var timeout = window.setTimeout( next, time );
		hooks.stop = function() {
			window.clearTimeout( timeout );
		};
	} );
};


( function() {
	var input = document.createElement( "input" ),
		select = document.createElement( "select" ),
		opt = select.appendChild( document.createElement( "option" ) );

	input.type = "checkbox";

	// Support: Android <=4.3 only
	// Default value for a checkbox should be "on"
	support.checkOn = input.value !== "";

	// Support: IE <=11 only
	// Must access selectedIndex to make default options select
	support.optSelected = opt.selected;

	// Support: IE <=11 only
	// An input loses its value after becoming a radio
	input = document.createElement( "input" );
	input.value = "t";
	input.type = "radio";
	support.radioValue = input.value === "t";
} )();


var boolHook,
	attrHandle = jQuery.expr.attrHandle;

jQuery.fn.extend( {
	attr: function( name, value ) {
		return access( this, jQuery.attr, name, value, arguments.length > 1 );
	},

	removeAttr: function( name ) {
		return this.each( function() {
			jQuery.removeAttr( this, name );
		} );
	}
} );

jQuery.extend( {
	attr: function( elem, name, value ) {
		var ret, hooks,
			nType = elem.nodeType;

		// Don't get/set attributes on text, comment and attribute nodes
		if ( nType === 3 || nType === 8 || nType === 2 ) {
			return;
		}

		// Fallback to prop when attributes are not supported
		if ( typeof elem.getAttribute === "undefined" ) {
			return jQuery.prop( elem, name, value );
		}

		// Attribute hooks are determined by the lowercase version
		// Grab necessary hook if one is defined
		if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {
			hooks = jQuery.attrHooks[ name.toLowerCase() ] ||
				( jQuery.expr.match.bool.test( name ) ? boolHook : undefined );
		}

		if ( value !== undefined ) {
			if ( value === null ) {
				jQuery.removeAttr( elem, name );
				return;
			}

			if ( hooks && "set" in hooks &&
				( ret = hooks.set( elem, value, name ) ) !== undefined ) {
				return ret;
			}

			elem.setAttribute( name, value + "" );
			return value;
		}

		if ( hooks && "get" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {
			return ret;
		}

		ret = jQuery.find.attr( elem, name );

		// Non-existent attributes return null, we normalize to undefined
		return ret == null ? undefined : ret;
	},

	attrHooks: {
		type: {
			set: function( elem, value ) {
				if ( !support.radioValue && value === "radio" &&
					nodeName( elem, "input" ) ) {
					var val = elem.value;
					elem.setAttribute( "type", value );
					if ( val ) {
						elem.value = val;
					}
					return value;
				}
			}
		}
	},

	removeAttr: function( elem, value ) {
		var name,
			i = 0,

			// Attribute names can contain non-HTML whitespace characters
			// https://html.spec.whatwg.org/multipage/syntax.html#attributes-2
			attrNames = value && value.match( rnothtmlwhite );

		if ( attrNames && elem.nodeType === 1 ) {
			while ( ( name = attrNames[ i++ ] ) ) {
				elem.removeAttribute( name );
			}
		}
	}
} );

// Hooks for boolean attributes
boolHook = {
	set: function( elem, value, name ) {
		if ( value === false ) {

			// Remove boolean attributes when set to false
			jQuery.removeAttr( elem, name );
		} else {
			elem.setAttribute( name, name );
		}
		return name;
	}
};

jQuery.each( jQuery.expr.match.bool.source.match( /\w+/g ), function( i, name ) {
	var getter = attrHandle[ name ] || jQuery.find.attr;

	attrHandle[ name ] = function( elem, name, isXML ) {
		var ret, handle,
			lowercaseName = name.toLowerCase();

		if ( !isXML ) {

			// Avoid an infinite loop by temporarily removing this function from the getter
			handle = attrHandle[ lowercaseName ];
			attrHandle[ lowercaseName ] = ret;
			ret = getter( elem, name, isXML ) != null ?
				lowercaseName :
				null;
			attrHandle[ lowercaseName ] = handle;
		}
		return ret;
	};
} );




var rfocusable = /^(?:input|select|textarea|button)$/i,
	rclickable = /^(?:a|area)$/i;

jQuery.fn.extend( {
	prop: function( name, value ) {
		return access( this, jQuery.prop, name, value, arguments.length > 1 );
	},

	removeProp: function( name ) {
		return this.each( function() {
			delete this[ jQuery.propFix[ name ] || name ];
		} );
	}
} );

jQuery.extend( {
	prop: function( elem, name, value ) {
		var ret, hooks,
			nType = elem.nodeType;

		// Don't get/set properties on text, comment and attribute nodes
		if ( nType === 3 || nType === 8 || nType === 2 ) {
			return;
		}

		if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {

			// Fix name and attach hooks
			name = jQuery.propFix[ name ] || name;
			hooks = jQuery.propHooks[ name ];
		}

		if ( value !== undefined ) {
			if ( hooks && "set" in hooks &&
				( ret = hooks.set( elem, value, name ) ) !== undefined ) {
				return ret;
			}

			return ( elem[ name ] = value );
		}

		if ( hooks && "get" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {
			return ret;
		}

		return elem[ name ];
	},

	propHooks: {
		tabIndex: {
			get: function( elem ) {

				// Support: IE <=9 - 11 only
				// elem.tabIndex doesn't always return the
				// correct value when it hasn't been explicitly set
				// https://web.archive.org/web/20141116233347/http://fluidproject.org/blog/2008/01/09/getting-setting-and-removing-tabindex-values-with-javascript/
				// Use proper attribute retrieval(#12072)
				var tabindex = jQuery.find.attr( elem, "tabindex" );

				if ( tabindex ) {
					return parseInt( tabindex, 10 );
				}

				if (
					rfocusable.test( elem.nodeName ) ||
					rclickable.test( elem.nodeName ) &&
					elem.href
				) {
					return 0;
				}

				return -1;
			}
		}
	},

	propFix: {
		"for": "htmlFor",
		"class": "className"
	}
} );

// Support: IE <=11 only
// Accessing the selectedIndex property
// forces the browser to respect setting selected
// on the option
// The getter ensures a default option is selected
// when in an optgroup
// eslint rule "no-unused-expressions" is disabled for this code
// since it considers such accessions noop
if ( !support.optSelected ) {
	jQuery.propHooks.selected = {
		get: function( elem ) {

			/* eslint no-unused-expressions: "off" */

			var parent = elem.parentNode;
			if ( parent && parent.parentNode ) {
				parent.parentNode.selectedIndex;
			}
			return null;
		},
		set: function( elem ) {

			/* eslint no-unused-expressions: "off" */

			var parent = elem.parentNode;
			if ( parent ) {
				parent.selectedIndex;

				if ( parent.parentNode ) {
					parent.parentNode.selectedIndex;
				}
			}
		}
	};
}

jQuery.each( [
	"tabIndex",
	"readOnly",
	"maxLength",
	"cellSpacing",
	"cellPadding",
	"rowSpan",
	"colSpan",
	"useMap",
	"frameBorder",
	"contentEditable"
], function() {
	jQuery.propFix[ this.toLowerCase() ] = this;
} );




	// Strip and collapse whitespace according to HTML spec
	// https://html.spec.whatwg.org/multipage/infrastructure.html#strip-and-collapse-whitespace
	function stripAndCollapse( value ) {
		var tokens = value.match( rnothtmlwhite ) || [];
		return tokens.join( " " );
	}


function getClass( elem ) {
	return elem.getAttribute && elem.getAttribute( "class" ) || "";
}

jQuery.fn.extend( {
	addClass: function( value ) {
		var classes, elem, cur, curValue, clazz, j, finalValue,
			i = 0;

		if ( jQuery.isFunction( value ) ) {
			return this.each( function( j ) {
				jQuery( this ).addClass( value.call( this, j, getClass( this ) ) );
			} );
		}

		if ( typeof value === "string" && value ) {
			classes = value.match( rnothtmlwhite ) || [];

			while ( ( elem = this[ i++ ] ) ) {
				curValue = getClass( elem );
				cur = elem.nodeType === 1 && ( " " + stripAndCollapse( curValue ) + " " );

				if ( cur ) {
					j = 0;
					while ( ( clazz = classes[ j++ ] ) ) {
						if ( cur.indexOf( " " + clazz + " " ) < 0 ) {
							cur += clazz + " ";
						}
					}

					// Only assign if different to avoid unneeded rendering.
					finalValue = stripAndCollapse( cur );
					if ( curValue !== finalValue ) {
						elem.setAttribute( "class", finalValue );
					}
				}
			}
		}

		return this;
	},

	removeClass: function( value ) {
		var classes, elem, cur, curValue, clazz, j, finalValue,
			i = 0;

		if ( jQuery.isFunction( value ) ) {
			return this.each( function( j ) {
				jQuery( this ).removeClass( value.call( this, j, getClass( this ) ) );
			} );
		}

		if ( !arguments.length ) {
			return this.attr( "class", "" );
		}

		if ( typeof value === "string" && value ) {
			classes = value.match( rnothtmlwhite ) || [];

			while ( ( elem = this[ i++ ] ) ) {
				curValue = getClass( elem );

				// This expression is here for better compressibility (see addClass)
				cur = elem.nodeType === 1 && ( " " + stripAndCollapse( curValue ) + " " );

				if ( cur ) {
					j = 0;
					while ( ( clazz = classes[ j++ ] ) ) {

						// Remove *all* instances
						while ( cur.indexOf( " " + clazz + " " ) > -1 ) {
							cur = cur.replace( " " + clazz + " ", " " );
						}
					}

					// Only assign if different to avoid unneeded rendering.
					finalValue = stripAndCollapse( cur );
					if ( curValue !== finalValue ) {
						elem.setAttribute( "class", finalValue );
					}
				}
			}
		}

		return this;
	},

	toggleClass: function( value, stateVal ) {
		var type = typeof value;

		if ( typeof stateVal === "boolean" && type === "string" ) {
			return stateVal ? this.addClass( value ) : this.removeClass( value );
		}

		if ( jQuery.isFunction( value ) ) {
			return this.each( function( i ) {
				jQuery( this ).toggleClass(
					value.call( this, i, getClass( this ), stateVal ),
					stateVal
				);
			} );
		}

		return this.each( function() {
			var className, i, self, classNames;

			if ( type === "string" ) {

				// Toggle individual class names
				i = 0;
				self = jQuery( this );
				classNames = value.match( rnothtmlwhite ) || [];

				while ( ( className = classNames[ i++ ] ) ) {

					// Check each className given, space separated list
					if ( self.hasClass( className ) ) {
						self.removeClass( className );
					} else {
						self.addClass( className );
					}
				}

			// Toggle whole class name
			} else if ( value === undefined || type === "boolean" ) {
				className = getClass( this );
				if ( className ) {

					// Store className if set
					dataPriv.set( this, "__className__", className );
				}

				// If the element has a class name or if we're passed `false`,
				// then remove the whole classname (if there was one, the above saved it).
				// Otherwise bring back whatever was previously saved (if anything),
				// falling back to the empty string if nothing was stored.
				if ( this.setAttribute ) {
					this.setAttribute( "class",
						className || value === false ?
						"" :
						dataPriv.get( this, "__className__" ) || ""
					);
				}
			}
		} );
	},

	hasClass: function( selector ) {
		var className, elem,
			i = 0;

		className = " " + selector + " ";
		while ( ( elem = this[ i++ ] ) ) {
			if ( elem.nodeType === 1 &&
				( " " + stripAndCollapse( getClass( elem ) ) + " " ).indexOf( className ) > -1 ) {
					return true;
			}
		}

		return false;
	}
} );




var rreturn = /\r/g;

jQuery.fn.extend( {
	val: function( value ) {
		var hooks, ret, isFunction,
			elem = this[ 0 ];

		if ( !arguments.length ) {
			if ( elem ) {
				hooks = jQuery.valHooks[ elem.type ] ||
					jQuery.valHooks[ elem.nodeName.toLowerCase() ];

				if ( hooks &&
					"get" in hooks &&
					( ret = hooks.get( elem, "value" ) ) !== undefined
				) {
					return ret;
				}

				ret = elem.value;

				// Handle most common string cases
				if ( typeof ret === "string" ) {
					return ret.replace( rreturn, "" );
				}

				// Handle cases where value is null/undef or number
				return ret == null ? "" : ret;
			}

			return;
		}

		isFunction = jQuery.isFunction( value );

		return this.each( function( i ) {
			var val;

			if ( this.nodeType !== 1 ) {
				return;
			}

			if ( isFunction ) {
				val = value.call( this, i, jQuery( this ).val() );
			} else {
				val = value;
			}

			// Treat null/undefined as ""; convert numbers to string
			if ( val == null ) {
				val = "";

			} else if ( typeof val === "number" ) {
				val += "";

			} else if ( Array.isArray( val ) ) {
				val = jQuery.map( val, function( value ) {
					return value == null ? "" : value + "";
				} );
			}

			hooks = jQuery.valHooks[ this.type ] || jQuery.valHooks[ this.nodeName.toLowerCase() ];

			// If set returns undefined, fall back to normal setting
			if ( !hooks || !( "set" in hooks ) || hooks.set( this, val, "value" ) === undefined ) {
				this.value = val;
			}
		} );
	}
} );

jQuery.extend( {
	valHooks: {
		option: {
			get: function( elem ) {

				var val = jQuery.find.attr( elem, "value" );
				return val != null ?
					val :

					// Support: IE <=10 - 11 only
					// option.text throws exceptions (#14686, #14858)
					// Strip and collapse whitespace
					// https://html.spec.whatwg.org/#strip-and-collapse-whitespace
					stripAndCollapse( jQuery.text( elem ) );
			}
		},
		select: {
			get: function( elem ) {
				var value, option, i,
					options = elem.options,
					index = elem.selectedIndex,
					one = elem.type === "select-one",
					values = one ? null : [],
					max = one ? index + 1 : options.length;

				if ( index < 0 ) {
					i = max;

				} else {
					i = one ? index : 0;
				}

				// Loop through all the selected options
				for ( ; i < max; i++ ) {
					option = options[ i ];

					// Support: IE <=9 only
					// IE8-9 doesn't update selected after form reset (#2551)
					if ( ( option.selected || i === index ) &&

							// Don't return options that are disabled or in a disabled optgroup
							!option.disabled &&
							( !option.parentNode.disabled ||
								!nodeName( option.parentNode, "optgroup" ) ) ) {

						// Get the specific value for the option
						value = jQuery( option ).val();

						// We don't need an array for one selects
						if ( one ) {
							return value;
						}

						// Multi-Selects return an array
						values.push( value );
					}
				}

				return values;
			},

			set: function( elem, value ) {
				var optionSet, option,
					options = elem.options,
					values = jQuery.makeArray( value ),
					i = options.length;

				while ( i-- ) {
					option = options[ i ];

					/* eslint-disable no-cond-assign */

					if ( option.selected =
						jQuery.inArray( jQuery.valHooks.option.get( option ), values ) > -1
					) {
						optionSet = true;
					}

					/* eslint-enable no-cond-assign */
				}

				// Force browsers to behave consistently when non-matching value is set
				if ( !optionSet ) {
					elem.selectedIndex = -1;
				}
				return values;
			}
		}
	}
} );

// Radios and checkboxes getter/setter
jQuery.each( [ "radio", "checkbox" ], function() {
	jQuery.valHooks[ this ] = {
		set: function( elem, value ) {
			if ( Array.isArray( value ) ) {
				return ( elem.checked = jQuery.inArray( jQuery( elem ).val(), value ) > -1 );
			}
		}
	};
	if ( !support.checkOn ) {
		jQuery.valHooks[ this ].get = function( elem ) {
			return elem.getAttribute( "value" ) === null ? "on" : elem.value;
		};
	}
} );




// Return jQuery for attributes-only inclusion


var rfocusMorph = /^(?:focusinfocus|focusoutblur)$/;

jQuery.extend( jQuery.event, {

	trigger: function( event, data, elem, onlyHandlers ) {

		var i, cur, tmp, bubbleType, ontype, handle, special,
			eventPath = [ elem || document ],
			type = hasOwn.call( event, "type" ) ? event.type : event,
			namespaces = hasOwn.call( event, "namespace" ) ? event.namespace.split( "." ) : [];

		cur = tmp = elem = elem || document;

		// Don't do events on text and comment nodes
		if ( elem.nodeType === 3 || elem.nodeType === 8 ) {
			return;
		}

		// focus/blur morphs to focusin/out; ensure we're not firing them right now
		if ( rfocusMorph.test( type + jQuery.event.triggered ) ) {
			return;
		}

		if ( type.indexOf( "." ) > -1 ) {

			// Namespaced trigger; create a regexp to match event type in handle()
			namespaces = type.split( "." );
			type = namespaces.shift();
			namespaces.sort();
		}
		ontype = type.indexOf( ":" ) < 0 && "on" + type;

		// Caller can pass in a jQuery.Event object, Object, or just an event type string
		event = event[ jQuery.expando ] ?
			event :
			new jQuery.Event( type, typeof event === "object" && event );

		// Trigger bitmask: & 1 for native handlers; & 2 for jQuery (always true)
		event.isTrigger = onlyHandlers ? 2 : 3;
		event.namespace = namespaces.join( "." );
		event.rnamespace = event.namespace ?
			new RegExp( "(^|\\.)" + namespaces.join( "\\.(?:.*\\.|)" ) + "(\\.|$)" ) :
			null;

		// Clean up the event in case it is being reused
		event.result = undefined;
		if ( !event.target ) {
			event.target = elem;
		}

		// Clone any incoming data and prepend the event, creating the handler arg list
		data = data == null ?
			[ event ] :
			jQuery.makeArray( data, [ event ] );

		// Allow special events to draw outside the lines
		special = jQuery.event.special[ type ] || {};
		if ( !onlyHandlers && special.trigger && special.trigger.apply( elem, data ) === false ) {
			return;
		}

		// Determine event propagation path in advance, per W3C events spec (#9951)
		// Bubble up to document, then to window; watch for a global ownerDocument var (#9724)
		if ( !onlyHandlers && !special.noBubble && !jQuery.isWindow( elem ) ) {

			bubbleType = special.delegateType || type;
			if ( !rfocusMorph.test( bubbleType + type ) ) {
				cur = cur.parentNode;
			}
			for ( ; cur; cur = cur.parentNode ) {
				eventPath.push( cur );
				tmp = cur;
			}

			// Only add window if we got to document (e.g., not plain obj or detached DOM)
			if ( tmp === ( elem.ownerDocument || document ) ) {
				eventPath.push( tmp.defaultView || tmp.parentWindow || window );
			}
		}

		// Fire handlers on the event path
		i = 0;
		while ( ( cur = eventPath[ i++ ] ) && !event.isPropagationStopped() ) {

			event.type = i > 1 ?
				bubbleType :
				special.bindType || type;

			// jQuery handler
			handle = ( dataPriv.get( cur, "events" ) || {} )[ event.type ] &&
				dataPriv.get( cur, "handle" );
			if ( handle ) {
				handle.apply( cur, data );
			}

			// Native handler
			handle = ontype && cur[ ontype ];
			if ( handle && handle.apply && acceptData( cur ) ) {
				event.result = handle.apply( cur, data );
				if ( event.result === false ) {
					event.preventDefault();
				}
			}
		}
		event.type = type;

		// If nobody prevented the default action, do it now
		if ( !onlyHandlers && !event.isDefaultPrevented() ) {

			if ( ( !special._default ||
				special._default.apply( eventPath.pop(), data ) === false ) &&
				acceptData( elem ) ) {

				// Call a native DOM method on the target with the same name as the event.
				// Don't do default actions on window, that's where global variables be (#6170)
				if ( ontype && jQuery.isFunction( elem[ type ] ) && !jQuery.isWindow( elem ) ) {

					// Don't re-trigger an onFOO event when we call its FOO() method
					tmp = elem[ ontype ];

					if ( tmp ) {
						elem[ ontype ] = null;
					}

					// Prevent re-triggering of the same event, since we already bubbled it above
					jQuery.event.triggered = type;
					elem[ type ]();
					jQuery.event.triggered = undefined;

					if ( tmp ) {
						elem[ ontype ] = tmp;
					}
				}
			}
		}

		return event.result;
	},

	// Piggyback on a donor event to simulate a different one
	// Used only for `focus(in | out)` events
	simulate: function( type, elem, event ) {
		var e = jQuery.extend(
			new jQuery.Event(),
			event,
			{
				type: type,
				isSimulated: true
			}
		);

		jQuery.event.trigger( e, null, elem );
	}

} );

jQuery.fn.extend( {

	trigger: function( type, data ) {
		return this.each( function() {
			jQuery.event.trigger( type, data, this );
		} );
	},
	triggerHandler: function( type, data ) {
		var elem = this[ 0 ];
		if ( elem ) {
			return jQuery.event.trigger( type, data, elem, true );
		}
	}
} );


jQuery.each( ( "blur focus focusin focusout resize scroll click dblclick " +
	"mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave " +
	"change select submit keydown keypress keyup contextmenu" ).split( " " ),
	function( i, name ) {

	// Handle event binding
	jQuery.fn[ name ] = function( data, fn ) {
		return arguments.length > 0 ?
			this.on( name, null, data, fn ) :
			this.trigger( name );
	};
} );

jQuery.fn.extend( {
	hover: function( fnOver, fnOut ) {
		return this.mouseenter( fnOver ).mouseleave( fnOut || fnOver );
	}
} );




support.focusin = "onfocusin" in window;


// Support: Firefox <=44
// Firefox doesn't have focus(in | out) events
// Related ticket - https://bugzilla.mozilla.org/show_bug.cgi?id=687787
//
// Support: Chrome <=48 - 49, Safari <=9.0 - 9.1
// focus(in | out) events fire after focus & blur events,
// which is spec violation - http://www.w3.org/TR/DOM-Level-3-Events/#events-focusevent-event-order
// Related ticket - https://bugs.chromium.org/p/chromium/issues/detail?id=449857
if ( !support.focusin ) {
	jQuery.each( { focus: "focusin", blur: "focusout" }, function( orig, fix ) {

		// Attach a single capturing handler on the document while someone wants focusin/focusout
		var handler = function( event ) {
			jQuery.event.simulate( fix, event.target, jQuery.event.fix( event ) );
		};

		jQuery.event.special[ fix ] = {
			setup: function() {
				var doc = this.ownerDocument || this,
					attaches = dataPriv.access( doc, fix );

				if ( !attaches ) {
					doc.addEventListener( orig, handler, true );
				}
				dataPriv.access( doc, fix, ( attaches || 0 ) + 1 );
			},
			teardown: function() {
				var doc = this.ownerDocument || this,
					attaches = dataPriv.access( doc, fix ) - 1;

				if ( !attaches ) {
					doc.removeEventListener( orig, handler, true );
					dataPriv.remove( doc, fix );

				} else {
					dataPriv.access( doc, fix, attaches );
				}
			}
		};
	} );
}
var location = window.location;

var nonce = jQuery.now();

var rquery = ( /\?/ );



// Cross-browser xml parsing
jQuery.parseXML = function( data ) {
	var xml;
	if ( !data || typeof data !== "string" ) {
		return null;
	}

	// Support: IE 9 - 11 only
	// IE throws on parseFromString with invalid input.
	try {
		xml = ( new window.DOMParser() ).parseFromString( data, "text/xml" );
	} catch ( e ) {
		xml = undefined;
	}

	if ( !xml || xml.getElementsByTagName( "parsererror" ).length ) {
		jQuery.error( "Invalid XML: " + data );
	}
	return xml;
};


var
	rbracket = /\[\]$/,
	rCRLF = /\r?\n/g,
	rsubmitterTypes = /^(?:submit|button|image|reset|file)$/i,
	rsubmittable = /^(?:input|select|textarea|keygen)/i;

function buildParams( prefix, obj, traditional, add ) {
	var name;

	if ( Array.isArray( obj ) ) {

		// Serialize array item.
		jQuery.each( obj, function( i, v ) {
			if ( traditional || rbracket.test( prefix ) ) {

				// Treat each array item as a scalar.
				add( prefix, v );

			} else {

				// Item is non-scalar (array or object), encode its numeric index.
				buildParams(
					prefix + "[" + ( typeof v === "object" && v != null ? i : "" ) + "]",
					v,
					traditional,
					add
				);
			}
		} );

	} else if ( !traditional && jQuery.type( obj ) === "object" ) {

		// Serialize object item.
		for ( name in obj ) {
			buildParams( prefix + "[" + name + "]", obj[ name ], traditional, add );
		}

	} else {

		// Serialize scalar item.
		add( prefix, obj );
	}
}

// Serialize an array of form elements or a set of
// key/values into a query string
jQuery.param = function( a, traditional ) {
	var prefix,
		s = [],
		add = function( key, valueOrFunction ) {

			// If value is a function, invoke it and use its return value
			var value = jQuery.isFunction( valueOrFunction ) ?
				valueOrFunction() :
				valueOrFunction;

			s[ s.length ] = encodeURIComponent( key ) + "=" +
				encodeURIComponent( value == null ? "" : value );
		};

	// If an array was passed in, assume that it is an array of form elements.
	if ( Array.isArray( a ) || ( a.jquery && !jQuery.isPlainObject( a ) ) ) {

		// Serialize the form elements
		jQuery.each( a, function() {
			add( this.name, this.value );
		} );

	} else {

		// If traditional, encode the "old" way (the way 1.3.2 or older
		// did it), otherwise encode params recursively.
		for ( prefix in a ) {
			buildParams( prefix, a[ prefix ], traditional, add );
		}
	}

	// Return the resulting serialization
	return s.join( "&" );
};

jQuery.fn.extend( {
	serialize: function() {
		return jQuery.param( this.serializeArray() );
	},
	serializeArray: function() {
		return this.map( function() {

			// Can add propHook for "elements" to filter or add form elements
			var elements = jQuery.prop( this, "elements" );
			return elements ? jQuery.makeArray( elements ) : this;
		} )
		.filter( function() {
			var type = this.type;

			// Use .is( ":disabled" ) so that fieldset[disabled] works
			return this.name && !jQuery( this ).is( ":disabled" ) &&
				rsubmittable.test( this.nodeName ) && !rsubmitterTypes.test( type ) &&
				( this.checked || !rcheckableType.test( type ) );
		} )
		.map( function( i, elem ) {
			var val = jQuery( this ).val();

			if ( val == null ) {
				return null;
			}

			if ( Array.isArray( val ) ) {
				return jQuery.map( val, function( val ) {
					return { name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
				} );
			}

			return { name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
		} ).get();
	}
} );


var
	r20 = /%20/g,
	rhash = /#.*$/,
	rantiCache = /([?&])_=[^&]*/,
	rheaders = /^(.*?):[ \t]*([^\r\n]*)$/mg,

	// #7653, #8125, #8152: local protocol detection
	rlocalProtocol = /^(?:about|app|app-storage|.+-extension|file|res|widget):$/,
	rnoContent = /^(?:GET|HEAD)$/,
	rprotocol = /^\/\//,

	/* Prefilters
	 * 1) They are useful to introduce custom dataTypes (see ajax/jsonp.js for an example)
	 * 2) These are called:
	 *    - BEFORE asking for a transport
	 *    - AFTER param serialization (s.data is a string if s.processData is true)
	 * 3) key is the dataType
	 * 4) the catchall symbol "*" can be used
	 * 5) execution will start with transport dataType and THEN continue down to "*" if needed
	 */
	prefilters = {},

	/* Transports bindings
	 * 1) key is the dataType
	 * 2) the catchall symbol "*" can be used
	 * 3) selection will start with transport dataType and THEN go to "*" if needed
	 */
	transports = {},

	// Avoid comment-prolog char sequence (#10098); must appease lint and evade compression
	allTypes = "*/".concat( "*" ),

	// Anchor tag for parsing the document origin
	originAnchor = document.createElement( "a" );
	originAnchor.href = location.href;

// Base "constructor" for jQuery.ajaxPrefilter and jQuery.ajaxTransport
function addToPrefiltersOrTransports( structure ) {

	// dataTypeExpression is optional and defaults to "*"
	return function( dataTypeExpression, func ) {

		if ( typeof dataTypeExpression !== "string" ) {
			func = dataTypeExpression;
			dataTypeExpression = "*";
		}

		var dataType,
			i = 0,
			dataTypes = dataTypeExpression.toLowerCase().match( rnothtmlwhite ) || [];

		if ( jQuery.isFunction( func ) ) {

			// For each dataType in the dataTypeExpression
			while ( ( dataType = dataTypes[ i++ ] ) ) {

				// Prepend if requested
				if ( dataType[ 0 ] === "+" ) {
					dataType = dataType.slice( 1 ) || "*";
					( structure[ dataType ] = structure[ dataType ] || [] ).unshift( func );

				// Otherwise append
				} else {
					( structure[ dataType ] = structure[ dataType ] || [] ).push( func );
				}
			}
		}
	};
}

// Base inspection function for prefilters and transports
function inspectPrefiltersOrTransports( structure, options, originalOptions, jqXHR ) {

	var inspected = {},
		seekingTransport = ( structure === transports );

	function inspect( dataType ) {
		var selected;
		inspected[ dataType ] = true;
		jQuery.each( structure[ dataType ] || [], function( _, prefilterOrFactory ) {
			var dataTypeOrTransport = prefilterOrFactory( options, originalOptions, jqXHR );
			if ( typeof dataTypeOrTransport === "string" &&
				!seekingTransport && !inspected[ dataTypeOrTransport ] ) {

				options.dataTypes.unshift( dataTypeOrTransport );
				inspect( dataTypeOrTransport );
				return false;
			} else if ( seekingTransport ) {
				return !( selected = dataTypeOrTransport );
			}
		} );
		return selected;
	}

	return inspect( options.dataTypes[ 0 ] ) || !inspected[ "*" ] && inspect( "*" );
}

// A special extend for ajax options
// that takes "flat" options (not to be deep extended)
// Fixes #9887
function ajaxExtend( target, src ) {
	var key, deep,
		flatOptions = jQuery.ajaxSettings.flatOptions || {};

	for ( key in src ) {
		if ( src[ key ] !== undefined ) {
			( flatOptions[ key ] ? target : ( deep || ( deep = {} ) ) )[ key ] = src[ key ];
		}
	}
	if ( deep ) {
		jQuery.extend( true, target, deep );
	}

	return target;
}

/* Handles responses to an ajax request:
 * - finds the right dataType (mediates between content-type and expected dataType)
 * - returns the corresponding response
 */
function ajaxHandleResponses( s, jqXHR, responses ) {

	var ct, type, finalDataType, firstDataType,
		contents = s.contents,
		dataTypes = s.dataTypes;

	// Remove auto dataType and get content-type in the process
	while ( dataTypes[ 0 ] === "*" ) {
		dataTypes.shift();
		if ( ct === undefined ) {
			ct = s.mimeType || jqXHR.getResponseHeader( "Content-Type" );
		}
	}

	// Check if we're dealing with a known content-type
	if ( ct ) {
		for ( type in contents ) {
			if ( contents[ type ] && contents[ type ].test( ct ) ) {
				dataTypes.unshift( type );
				break;
			}
		}
	}

	// Check to see if we have a response for the expected dataType
	if ( dataTypes[ 0 ] in responses ) {
		finalDataType = dataTypes[ 0 ];
	} else {

		// Try convertible dataTypes
		for ( type in responses ) {
			if ( !dataTypes[ 0 ] || s.converters[ type + " " + dataTypes[ 0 ] ] ) {
				finalDataType = type;
				break;
			}
			if ( !firstDataType ) {
				firstDataType = type;
			}
		}

		// Or just use first one
		finalDataType = finalDataType || firstDataType;
	}

	// If we found a dataType
	// We add the dataType to the list if needed
	// and return the corresponding response
	if ( finalDataType ) {
		if ( finalDataType !== dataTypes[ 0 ] ) {
			dataTypes.unshift( finalDataType );
		}
		return responses[ finalDataType ];
	}
}

/* Chain conversions given the request and the original response
 * Also sets the responseXXX fields on the jqXHR instance
 */
function ajaxConvert( s, response, jqXHR, isSuccess ) {
	var conv2, current, conv, tmp, prev,
		converters = {},

		// Work with a copy of dataTypes in case we need to modify it for conversion
		dataTypes = s.dataTypes.slice();

	// Create converters map with lowercased keys
	if ( dataTypes[ 1 ] ) {
		for ( conv in s.converters ) {
			converters[ conv.toLowerCase() ] = s.converters[ conv ];
		}
	}

	current = dataTypes.shift();

	// Convert to each sequential dataType
	while ( current ) {

		if ( s.responseFields[ current ] ) {
			jqXHR[ s.responseFields[ current ] ] = response;
		}

		// Apply the dataFilter if provided
		if ( !prev && isSuccess && s.dataFilter ) {
			response = s.dataFilter( response, s.dataType );
		}

		prev = current;
		current = dataTypes.shift();

		if ( current ) {

			// There's only work to do if current dataType is non-auto
			if ( current === "*" ) {

				current = prev;

			// Convert response if prev dataType is non-auto and differs from current
			} else if ( prev !== "*" && prev !== current ) {

				// Seek a direct converter
				conv = converters[ prev + " " + current ] || converters[ "* " + current ];

				// If none found, seek a pair
				if ( !conv ) {
					for ( conv2 in converters ) {

						// If conv2 outputs current
						tmp = conv2.split( " " );
						if ( tmp[ 1 ] === current ) {

							// If prev can be converted to accepted input
							conv = converters[ prev + " " + tmp[ 0 ] ] ||
								converters[ "* " + tmp[ 0 ] ];
							if ( conv ) {

								// Condense equivalence converters
								if ( conv === true ) {
									conv = converters[ conv2 ];

								// Otherwise, insert the intermediate dataType
								} else if ( converters[ conv2 ] !== true ) {
									current = tmp[ 0 ];
									dataTypes.unshift( tmp[ 1 ] );
								}
								break;
							}
						}
					}
				}

				// Apply converter (if not an equivalence)
				if ( conv !== true ) {

					// Unless errors are allowed to bubble, catch and return them
					if ( conv && s.throws ) {
						response = conv( response );
					} else {
						try {
							response = conv( response );
						} catch ( e ) {
							return {
								state: "parsererror",
								error: conv ? e : "No conversion from " + prev + " to " + current
							};
						}
					}
				}
			}
		}
	}

	return { state: "success", data: response };
}

jQuery.extend( {

	// Counter for holding the number of active queries
	active: 0,

	// Last-Modified header cache for next request
	lastModified: {},
	etag: {},

	ajaxSettings: {
		url: location.href,
		type: "GET",
		isLocal: rlocalProtocol.test( location.protocol ),
		global: true,
		processData: true,
		async: true,
		contentType: "application/x-www-form-urlencoded; charset=UTF-8",

		/*
		timeout: 0,
		data: null,
		dataType: null,
		username: null,
		password: null,
		cache: null,
		throws: false,
		traditional: false,
		headers: {},
		*/

		accepts: {
			"*": allTypes,
			text: "text/plain",
			html: "text/html",
			xml: "application/xml, text/xml",
			json: "application/json, text/javascript"
		},

		contents: {
			xml: /\bxml\b/,
			html: /\bhtml/,
			json: /\bjson\b/
		},

		responseFields: {
			xml: "responseXML",
			text: "responseText",
			json: "responseJSON"
		},

		// Data converters
		// Keys separate source (or catchall "*") and destination types with a single space
		converters: {

			// Convert anything to text
			"* text": String,

			// Text to html (true = no transformation)
			"text html": true,

			// Evaluate text as a json expression
			"text json": JSON.parse,

			// Parse text as xml
			"text xml": jQuery.parseXML
		},

		// For options that shouldn't be deep extended:
		// you can add your own custom options here if
		// and when you create one that shouldn't be
		// deep extended (see ajaxExtend)
		flatOptions: {
			url: true,
			context: true
		}
	},

	// Creates a full fledged settings object into target
	// with both ajaxSettings and settings fields.
	// If target is omitted, writes into ajaxSettings.
	ajaxSetup: function( target, settings ) {
		return settings ?

			// Building a settings object
			ajaxExtend( ajaxExtend( target, jQuery.ajaxSettings ), settings ) :

			// Extending ajaxSettings
			ajaxExtend( jQuery.ajaxSettings, target );
	},

	ajaxPrefilter: addToPrefiltersOrTransports( prefilters ),
	ajaxTransport: addToPrefiltersOrTransports( transports ),

	// Main method
	ajax: function( url, options ) {

		// If url is an object, simulate pre-1.5 signature
		if ( typeof url === "object" ) {
			options = url;
			url = undefined;
		}

		// Force options to be an object
		options = options || {};

		var transport,

			// URL without anti-cache param
			cacheURL,

			// Response headers
			responseHeadersString,
			responseHeaders,

			// timeout handle
			timeoutTimer,

			// Url cleanup var
			urlAnchor,

			// Request state (becomes false upon send and true upon completion)
			completed,

			// To know if global events are to be dispatched
			fireGlobals,

			// Loop variable
			i,

			// uncached part of the url
			uncached,

			// Create the final options object
			s = jQuery.ajaxSetup( {}, options ),

			// Callbacks context
			callbackContext = s.context || s,

			// Context for global events is callbackContext if it is a DOM node or jQuery collection
			globalEventContext = s.context &&
				( callbackContext.nodeType || callbackContext.jquery ) ?
					jQuery( callbackContext ) :
					jQuery.event,

			// Deferreds
			deferred = jQuery.Deferred(),
			completeDeferred = jQuery.Callbacks( "once memory" ),

			// Status-dependent callbacks
			statusCode = s.statusCode || {},

			// Headers (they are sent all at once)
			requestHeaders = {},
			requestHeadersNames = {},

			// Default abort message
			strAbort = "canceled",

			// Fake xhr
			jqXHR = {
				readyState: 0,

				// Builds headers hashtable if needed
				getResponseHeader: function( key ) {
					var match;
					if ( completed ) {
						if ( !responseHeaders ) {
							responseHeaders = {};
							while ( ( match = rheaders.exec( responseHeadersString ) ) ) {
								responseHeaders[ match[ 1 ].toLowerCase() ] = match[ 2 ];
							}
						}
						match = responseHeaders[ key.toLowerCase() ];
					}
					return match == null ? null : match;
				},

				// Raw string
				getAllResponseHeaders: function() {
					return completed ? responseHeadersString : null;
				},

				// Caches the header
				setRequestHeader: function( name, value ) {
					if ( completed == null ) {
						name = requestHeadersNames[ name.toLowerCase() ] =
							requestHeadersNames[ name.toLowerCase() ] || name;
						requestHeaders[ name ] = value;
					}
					return this;
				},

				// Overrides response content-type header
				overrideMimeType: function( type ) {
					if ( completed == null ) {
						s.mimeType = type;
					}
					return this;
				},

				// Status-dependent callbacks
				statusCode: function( map ) {
					var code;
					if ( map ) {
						if ( completed ) {

							// Execute the appropriate callbacks
							jqXHR.always( map[ jqXHR.status ] );
						} else {

							// Lazy-add the new callbacks in a way that preserves old ones
							for ( code in map ) {
								statusCode[ code ] = [ statusCode[ code ], map[ code ] ];
							}
						}
					}
					return this;
				},

				// Cancel the request
				abort: function( statusText ) {
					var finalText = statusText || strAbort;
					if ( transport ) {
						transport.abort( finalText );
					}
					done( 0, finalText );
					return this;
				}
			};

		// Attach deferreds
		deferred.promise( jqXHR );

		// Add protocol if not provided (prefilters might expect it)
		// Handle falsy url in the settings object (#10093: consistency with old signature)
		// We also use the url parameter if available
		s.url = ( ( url || s.url || location.href ) + "" )
			.replace( rprotocol, location.protocol + "//" );

		// Alias method option to type as per ticket #12004
		s.type = options.method || options.type || s.method || s.type;

		// Extract dataTypes list
		s.dataTypes = ( s.dataType || "*" ).toLowerCase().match( rnothtmlwhite ) || [ "" ];

		// A cross-domain request is in order when the origin doesn't match the current origin.
		if ( s.crossDomain == null ) {
			urlAnchor = document.createElement( "a" );

			// Support: IE <=8 - 11, Edge 12 - 13
			// IE throws exception on accessing the href property if url is malformed,
			// e.g. http://example.com:80x/
			try {
				urlAnchor.href = s.url;

				// Support: IE <=8 - 11 only
				// Anchor's host property isn't correctly set when s.url is relative
				urlAnchor.href = urlAnchor.href;
				s.crossDomain = originAnchor.protocol + "//" + originAnchor.host !==
					urlAnchor.protocol + "//" + urlAnchor.host;
			} catch ( e ) {

				// If there is an error parsing the URL, assume it is crossDomain,
				// it can be rejected by the transport if it is invalid
				s.crossDomain = true;
			}
		}

		// Convert data if not already a string
		if ( s.data && s.processData && typeof s.data !== "string" ) {
			s.data = jQuery.param( s.data, s.traditional );
		}

		// Apply prefilters
		inspectPrefiltersOrTransports( prefilters, s, options, jqXHR );

		// If request was aborted inside a prefilter, stop there
		if ( completed ) {
			return jqXHR;
		}

		// We can fire global events as of now if asked to
		// Don't fire events if jQuery.event is undefined in an AMD-usage scenario (#15118)
		fireGlobals = jQuery.event && s.global;

		// Watch for a new set of requests
		if ( fireGlobals && jQuery.active++ === 0 ) {
			jQuery.event.trigger( "ajaxStart" );
		}

		// Uppercase the type
		s.type = s.type.toUpperCase();

		// Determine if request has content
		s.hasContent = !rnoContent.test( s.type );

		// Save the URL in case we're toying with the If-Modified-Since
		// and/or If-None-Match header later on
		// Remove hash to simplify url manipulation
		cacheURL = s.url.replace( rhash, "" );

		// More options handling for requests with no content
		if ( !s.hasContent ) {

			// Remember the hash so we can put it back
			uncached = s.url.slice( cacheURL.length );

			// If data is available, append data to url
			if ( s.data ) {
				cacheURL += ( rquery.test( cacheURL ) ? "&" : "?" ) + s.data;

				// #9682: remove data so that it's not used in an eventual retry
				delete s.data;
			}

			// Add or update anti-cache param if needed
			if ( s.cache === false ) {
				cacheURL = cacheURL.replace( rantiCache, "$1" );
				uncached = ( rquery.test( cacheURL ) ? "&" : "?" ) + "_=" + ( nonce++ ) + uncached;
			}

			// Put hash and anti-cache on the URL that will be requested (gh-1732)
			s.url = cacheURL + uncached;

		// Change '%20' to '+' if this is encoded form body content (gh-2658)
		} else if ( s.data && s.processData &&
			( s.contentType || "" ).indexOf( "application/x-www-form-urlencoded" ) === 0 ) {
			s.data = s.data.replace( r20, "+" );
		}

		// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
		if ( s.ifModified ) {
			if ( jQuery.lastModified[ cacheURL ] ) {
				jqXHR.setRequestHeader( "If-Modified-Since", jQuery.lastModified[ cacheURL ] );
			}
			if ( jQuery.etag[ cacheURL ] ) {
				jqXHR.setRequestHeader( "If-None-Match", jQuery.etag[ cacheURL ] );
			}
		}

		// Set the correct header, if data is being sent
		if ( s.data && s.hasContent && s.contentType !== false || options.contentType ) {
			jqXHR.setRequestHeader( "Content-Type", s.contentType );
		}

		// Set the Accepts header for the server, depending on the dataType
		jqXHR.setRequestHeader(
			"Accept",
			s.dataTypes[ 0 ] && s.accepts[ s.dataTypes[ 0 ] ] ?
				s.accepts[ s.dataTypes[ 0 ] ] +
					( s.dataTypes[ 0 ] !== "*" ? ", " + allTypes + "; q=0.01" : "" ) :
				s.accepts[ "*" ]
		);

		// Check for headers option
		for ( i in s.headers ) {
			jqXHR.setRequestHeader( i, s.headers[ i ] );
		}

		// Allow custom headers/mimetypes and early abort
		if ( s.beforeSend &&
			( s.beforeSend.call( callbackContext, jqXHR, s ) === false || completed ) ) {

			// Abort if not done already and return
			return jqXHR.abort();
		}

		// Aborting is no longer a cancellation
		strAbort = "abort";

		// Install callbacks on deferreds
		completeDeferred.add( s.complete );
		jqXHR.done( s.success );
		jqXHR.fail( s.error );

		// Get transport
		transport = inspectPrefiltersOrTransports( transports, s, options, jqXHR );

		// If no transport, we auto-abort
		if ( !transport ) {
			done( -1, "No Transport" );
		} else {
			jqXHR.readyState = 1;

			// Send global event
			if ( fireGlobals ) {
				globalEventContext.trigger( "ajaxSend", [ jqXHR, s ] );
			}

			// If request was aborted inside ajaxSend, stop there
			if ( completed ) {
				return jqXHR;
			}

			// Timeout
			if ( s.async && s.timeout > 0 ) {
				timeoutTimer = window.setTimeout( function() {
					jqXHR.abort( "timeout" );
				}, s.timeout );
			}

			try {
				completed = false;
				transport.send( requestHeaders, done );
			} catch ( e ) {

				// Rethrow post-completion exceptions
				if ( completed ) {
					throw e;
				}

				// Propagate others as results
				done( -1, e );
			}
		}

		// Callback for when everything is done
		function done( status, nativeStatusText, responses, headers ) {
			var isSuccess, success, error, response, modified,
				statusText = nativeStatusText;

			// Ignore repeat invocations
			if ( completed ) {
				return;
			}

			completed = true;

			// Clear timeout if it exists
			if ( timeoutTimer ) {
				window.clearTimeout( timeoutTimer );
			}

			// Dereference transport for early garbage collection
			// (no matter how long the jqXHR object will be used)
			transport = undefined;

			// Cache response headers
			responseHeadersString = headers || "";

			// Set readyState
			jqXHR.readyState = status > 0 ? 4 : 0;

			// Determine if successful
			isSuccess = status >= 200 && status < 300 || status === 304;

			// Get response data
			if ( responses ) {
				response = ajaxHandleResponses( s, jqXHR, responses );
			}

			// Convert no matter what (that way responseXXX fields are always set)
			response = ajaxConvert( s, response, jqXHR, isSuccess );

			// If successful, handle type chaining
			if ( isSuccess ) {

				// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
				if ( s.ifModified ) {
					modified = jqXHR.getResponseHeader( "Last-Modified" );
					if ( modified ) {
						jQuery.lastModified[ cacheURL ] = modified;
					}
					modified = jqXHR.getResponseHeader( "etag" );
					if ( modified ) {
						jQuery.etag[ cacheURL ] = modified;
					}
				}

				// if no content
				if ( status === 204 || s.type === "HEAD" ) {
					statusText = "nocontent";

				// if not modified
				} else if ( status === 304 ) {
					statusText = "notmodified";

				// If we have data, let's convert it
				} else {
					statusText = response.state;
					success = response.data;
					error = response.error;
					isSuccess = !error;
				}
			} else {

				// Extract error from statusText and normalize for non-aborts
				error = statusText;
				if ( status || !statusText ) {
					statusText = "error";
					if ( status < 0 ) {
						status = 0;
					}
				}
			}

			// Set data for the fake xhr object
			jqXHR.status = status;
			jqXHR.statusText = ( nativeStatusText || statusText ) + "";

			// Success/Error
			if ( isSuccess ) {
				deferred.resolveWith( callbackContext, [ success, statusText, jqXHR ] );
			} else {
				deferred.rejectWith( callbackContext, [ jqXHR, statusText, error ] );
			}

			// Status-dependent callbacks
			jqXHR.statusCode( statusCode );
			statusCode = undefined;

			if ( fireGlobals ) {
				globalEventContext.trigger( isSuccess ? "ajaxSuccess" : "ajaxError",
					[ jqXHR, s, isSuccess ? success : error ] );
			}

			// Complete
			completeDeferred.fireWith( callbackContext, [ jqXHR, statusText ] );

			if ( fireGlobals ) {
				globalEventContext.trigger( "ajaxComplete", [ jqXHR, s ] );

				// Handle the global AJAX counter
				if ( !( --jQuery.active ) ) {
					jQuery.event.trigger( "ajaxStop" );
				}
			}
		}

		return jqXHR;
	},

	getJSON: function( url, data, callback ) {
		return jQuery.get( url, data, callback, "json" );
	},

	getScript: function( url, callback ) {
		return jQuery.get( url, undefined, callback, "script" );
	}
} );

jQuery.each( [ "get", "post" ], function( i, method ) {
	jQuery[ method ] = function( url, data, callback, type ) {

		// Shift arguments if data argument was omitted
		if ( jQuery.isFunction( data ) ) {
			type = type || callback;
			callback = data;
			data = undefined;
		}

		// The url can be an options object (which then must have .url)
		return jQuery.ajax( jQuery.extend( {
			url: url,
			type: method,
			dataType: type,
			data: data,
			success: callback
		}, jQuery.isPlainObject( url ) && url ) );
	};
} );


jQuery._evalUrl = function( url ) {
	return jQuery.ajax( {
		url: url,

		// Make this explicit, since user can override this through ajaxSetup (#11264)
		type: "GET",
		dataType: "script",
		cache: true,
		async: false,
		global: false,
		"throws": true
	} );
};


jQuery.fn.extend( {
	wrapAll: function( html ) {
		var wrap;

		if ( this[ 0 ] ) {
			if ( jQuery.isFunction( html ) ) {
				html = html.call( this[ 0 ] );
			}

			// The elements to wrap the target around
			wrap = jQuery( html, this[ 0 ].ownerDocument ).eq( 0 ).clone( true );

			if ( this[ 0 ].parentNode ) {
				wrap.insertBefore( this[ 0 ] );
			}

			wrap.map( function() {
				var elem = this;

				while ( elem.firstElementChild ) {
					elem = elem.firstElementChild;
				}

				return elem;
			} ).append( this );
		}

		return this;
	},

	wrapInner: function( html ) {
		if ( jQuery.isFunction( html ) ) {
			return this.each( function( i ) {
				jQuery( this ).wrapInner( html.call( this, i ) );
			} );
		}

		return this.each( function() {
			var self = jQuery( this ),
				contents = self.contents();

			if ( contents.length ) {
				contents.wrapAll( html );

			} else {
				self.append( html );
			}
		} );
	},

	wrap: function( html ) {
		var isFunction = jQuery.isFunction( html );

		return this.each( function( i ) {
			jQuery( this ).wrapAll( isFunction ? html.call( this, i ) : html );
		} );
	},

	unwrap: function( selector ) {
		this.parent( selector ).not( "body" ).each( function() {
			jQuery( this ).replaceWith( this.childNodes );
		} );
		return this;
	}
} );


jQuery.expr.pseudos.hidden = function( elem ) {
	return !jQuery.expr.pseudos.visible( elem );
};
jQuery.expr.pseudos.visible = function( elem ) {
	return !!( elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length );
};




jQuery.ajaxSettings.xhr = function() {
	try {
		return new window.XMLHttpRequest();
	} catch ( e ) {}
};

var xhrSuccessStatus = {

		// File protocol always yields status code 0, assume 200
		0: 200,

		// Support: IE <=9 only
		// #1450: sometimes IE returns 1223 when it should be 204
		1223: 204
	},
	xhrSupported = jQuery.ajaxSettings.xhr();

support.cors = !!xhrSupported && ( "withCredentials" in xhrSupported );
support.ajax = xhrSupported = !!xhrSupported;

jQuery.ajaxTransport( function( options ) {
	var callback, errorCallback;

	// Cross domain only allowed if supported through XMLHttpRequest
	if ( support.cors || xhrSupported && !options.crossDomain ) {
		return {
			send: function( headers, complete ) {
				var i,
					xhr = options.xhr();

				xhr.open(
					options.type,
					options.url,
					options.async,
					options.username,
					options.password
				);

				// Apply custom fields if provided
				if ( options.xhrFields ) {
					for ( i in options.xhrFields ) {
						xhr[ i ] = options.xhrFields[ i ];
					}
				}

				// Override mime type if needed
				if ( options.mimeType && xhr.overrideMimeType ) {
					xhr.overrideMimeType( options.mimeType );
				}

				// X-Requested-With header
				// For cross-domain requests, seeing as conditions for a preflight are
				// akin to a jigsaw puzzle, we simply never set it to be sure.
				// (it can always be set on a per-request basis or even using ajaxSetup)
				// For same-domain requests, won't change header if already provided.
				if ( !options.crossDomain && !headers[ "X-Requested-With" ] ) {
					headers[ "X-Requested-With" ] = "XMLHttpRequest";
				}

				// Set headers
				for ( i in headers ) {
					xhr.setRequestHeader( i, headers[ i ] );
				}

				// Callback
				callback = function( type ) {
					return function() {
						if ( callback ) {
							callback = errorCallback = xhr.onload =
								xhr.onerror = xhr.onabort = xhr.onreadystatechange = null;

							if ( type === "abort" ) {
								xhr.abort();
							} else if ( type === "error" ) {

								// Support: IE <=9 only
								// On a manual native abort, IE9 throws
								// errors on any property access that is not readyState
								if ( typeof xhr.status !== "number" ) {
									complete( 0, "error" );
								} else {
									complete(

										// File: protocol always yields status 0; see #8605, #14207
										xhr.status,
										xhr.statusText
									);
								}
							} else {
								complete(
									xhrSuccessStatus[ xhr.status ] || xhr.status,
									xhr.statusText,

									// Support: IE <=9 only
									// IE9 has no XHR2 but throws on binary (trac-11426)
									// For XHR2 non-text, let the caller handle it (gh-2498)
									( xhr.responseType || "text" ) !== "text"  ||
									typeof xhr.responseText !== "string" ?
										{ binary: xhr.response } :
										{ text: xhr.responseText },
									xhr.getAllResponseHeaders()
								);
							}
						}
					};
				};

				// Listen to events
				xhr.onload = callback();
				errorCallback = xhr.onerror = callback( "error" );

				// Support: IE 9 only
				// Use onreadystatechange to replace onabort
				// to handle uncaught aborts
				if ( xhr.onabort !== undefined ) {
					xhr.onabort = errorCallback;
				} else {
					xhr.onreadystatechange = function() {

						// Check readyState before timeout as it changes
						if ( xhr.readyState === 4 ) {

							// Allow onerror to be called first,
							// but that will not handle a native abort
							// Also, save errorCallback to a variable
							// as xhr.onerror cannot be accessed
							window.setTimeout( function() {
								if ( callback ) {
									errorCallback();
								}
							} );
						}
					};
				}

				// Create the abort callback
				callback = callback( "abort" );

				try {

					// Do send the request (this may raise an exception)
					xhr.send( options.hasContent && options.data || null );
				} catch ( e ) {

					// #14683: Only rethrow if this hasn't been notified as an error yet
					if ( callback ) {
						throw e;
					}
				}
			},

			abort: function() {
				if ( callback ) {
					callback();
				}
			}
		};
	}
} );




// Prevent auto-execution of scripts when no explicit dataType was provided (See gh-2432)
jQuery.ajaxPrefilter( function( s ) {
	if ( s.crossDomain ) {
		s.contents.script = false;
	}
} );

// Install script dataType
jQuery.ajaxSetup( {
	accepts: {
		script: "text/javascript, application/javascript, " +
			"application/ecmascript, application/x-ecmascript"
	},
	contents: {
		script: /\b(?:java|ecma)script\b/
	},
	converters: {
		"text script": function( text ) {
			jQuery.globalEval( text );
			return text;
		}
	}
} );

// Handle cache's special case and crossDomain
jQuery.ajaxPrefilter( "script", function( s ) {
	if ( s.cache === undefined ) {
		s.cache = false;
	}
	if ( s.crossDomain ) {
		s.type = "GET";
	}
} );

// Bind script tag hack transport
jQuery.ajaxTransport( "script", function( s ) {

	// This transport only deals with cross domain requests
	if ( s.crossDomain ) {
		var script, callback;
		return {
			send: function( _, complete ) {
				script = jQuery( "<script>" ).prop( {
					charset: s.scriptCharset,
					src: s.url
				} ).on(
					"load error",
					callback = function( evt ) {
						script.remove();
						callback = null;
						if ( evt ) {
							complete( evt.type === "error" ? 404 : 200, evt.type );
						}
					}
				);

				// Use native DOM manipulation to avoid our domManip AJAX trickery
				document.head.appendChild( script[ 0 ] );
			},
			abort: function() {
				if ( callback ) {
					callback();
				}
			}
		};
	}
} );




var oldCallbacks = [],
	rjsonp = /(=)\?(?=&|$)|\?\?/;

// Default jsonp settings
jQuery.ajaxSetup( {
	jsonp: "callback",
	jsonpCallback: function() {
		var callback = oldCallbacks.pop() || ( jQuery.expando + "_" + ( nonce++ ) );
		this[ callback ] = true;
		return callback;
	}
} );

// Detect, normalize options and install callbacks for jsonp requests
jQuery.ajaxPrefilter( "json jsonp", function( s, originalSettings, jqXHR ) {

	var callbackName, overwritten, responseContainer,
		jsonProp = s.jsonp !== false && ( rjsonp.test( s.url ) ?
			"url" :
			typeof s.data === "string" &&
				( s.contentType || "" )
					.indexOf( "application/x-www-form-urlencoded" ) === 0 &&
				rjsonp.test( s.data ) && "data"
		);

	// Handle iff the expected data type is "jsonp" or we have a parameter to set
	if ( jsonProp || s.dataTypes[ 0 ] === "jsonp" ) {

		// Get callback name, remembering preexisting value associated with it
		callbackName = s.jsonpCallback = jQuery.isFunction( s.jsonpCallback ) ?
			s.jsonpCallback() :
			s.jsonpCallback;

		// Insert callback into url or form data
		if ( jsonProp ) {
			s[ jsonProp ] = s[ jsonProp ].replace( rjsonp, "$1" + callbackName );
		} else if ( s.jsonp !== false ) {
			s.url += ( rquery.test( s.url ) ? "&" : "?" ) + s.jsonp + "=" + callbackName;
		}

		// Use data converter to retrieve json after script execution
		s.converters[ "script json" ] = function() {
			if ( !responseContainer ) {
				jQuery.error( callbackName + " was not called" );
			}
			return responseContainer[ 0 ];
		};

		// Force json dataType
		s.dataTypes[ 0 ] = "json";

		// Install callback
		overwritten = window[ callbackName ];
		window[ callbackName ] = function() {
			responseContainer = arguments;
		};

		// Clean-up function (fires after converters)
		jqXHR.always( function() {

			// If previous value didn't exist - remove it
			if ( overwritten === undefined ) {
				jQuery( window ).removeProp( callbackName );

			// Otherwise restore preexisting value
			} else {
				window[ callbackName ] = overwritten;
			}

			// Save back as free
			if ( s[ callbackName ] ) {

				// Make sure that re-using the options doesn't screw things around
				s.jsonpCallback = originalSettings.jsonpCallback;

				// Save the callback name for future use
				oldCallbacks.push( callbackName );
			}

			// Call if it was a function and we have a response
			if ( responseContainer && jQuery.isFunction( overwritten ) ) {
				overwritten( responseContainer[ 0 ] );
			}

			responseContainer = overwritten = undefined;
		} );

		// Delegate to script
		return "script";
	}
} );




// Support: Safari 8 only
// In Safari 8 documents created via document.implementation.createHTMLDocument
// collapse sibling forms: the second one becomes a child of the first one.
// Because of that, this security measure has to be disabled in Safari 8.
// https://bugs.webkit.org/show_bug.cgi?id=137337
support.createHTMLDocument = ( function() {
	var body = document.implementation.createHTMLDocument( "" ).body;
	body.innerHTML = "<form></form><form></form>";
	return body.childNodes.length === 2;
} )();


// Argument "data" should be string of html
// context (optional): If specified, the fragment will be created in this context,
// defaults to document
// keepScripts (optional): If true, will include scripts passed in the html string
jQuery.parseHTML = function( data, context, keepScripts ) {
	if ( typeof data !== "string" ) {
		return [];
	}
	if ( typeof context === "boolean" ) {
		keepScripts = context;
		context = false;
	}

	var base, parsed, scripts;

	if ( !context ) {

		// Stop scripts or inline event handlers from being executed immediately
		// by using document.implementation
		if ( support.createHTMLDocument ) {
			context = document.implementation.createHTMLDocument( "" );

			// Set the base href for the created document
			// so any parsed elements with URLs
			// are based on the document's URL (gh-2965)
			base = context.createElement( "base" );
			base.href = document.location.href;
			context.head.appendChild( base );
		} else {
			context = document;
		}
	}

	parsed = rsingleTag.exec( data );
	scripts = !keepScripts && [];

	// Single tag
	if ( parsed ) {
		return [ context.createElement( parsed[ 1 ] ) ];
	}

	parsed = buildFragment( [ data ], context, scripts );

	if ( scripts && scripts.length ) {
		jQuery( scripts ).remove();
	}

	return jQuery.merge( [], parsed.childNodes );
};


/**
 * Load a url into a page
 */
jQuery.fn.load = function( url, params, callback ) {
	var selector, type, response,
		self = this,
		off = url.indexOf( " " );

	if ( off > -1 ) {
		selector = stripAndCollapse( url.slice( off ) );
		url = url.slice( 0, off );
	}

	// If it's a function
	if ( jQuery.isFunction( params ) ) {

		// We assume that it's the callback
		callback = params;
		params = undefined;

	// Otherwise, build a param string
	} else if ( params && typeof params === "object" ) {
		type = "POST";
	}

	// If we have elements to modify, make the request
	if ( self.length > 0 ) {
		jQuery.ajax( {
			url: url,

			// If "type" variable is undefined, then "GET" method will be used.
			// Make value of this field explicit since
			// user can override it through ajaxSetup method
			type: type || "GET",
			dataType: "html",
			data: params
		} ).done( function( responseText ) {

			// Save response for use in complete callback
			response = arguments;

			self.html( selector ?

				// If a selector was specified, locate the right elements in a dummy div
				// Exclude scripts to avoid IE 'Permission Denied' errors
				jQuery( "<div>" ).append( jQuery.parseHTML( responseText ) ).find( selector ) :

				// Otherwise use the full result
				responseText );

		// If the request succeeds, this function gets "data", "status", "jqXHR"
		// but they are ignored because response was set above.
		// If it fails, this function gets "jqXHR", "status", "error"
		} ).always( callback && function( jqXHR, status ) {
			self.each( function() {
				callback.apply( this, response || [ jqXHR.responseText, status, jqXHR ] );
			} );
		} );
	}

	return this;
};




// Attach a bunch of functions for handling common AJAX events
jQuery.each( [
	"ajaxStart",
	"ajaxStop",
	"ajaxComplete",
	"ajaxError",
	"ajaxSuccess",
	"ajaxSend"
], function( i, type ) {
	jQuery.fn[ type ] = function( fn ) {
		return this.on( type, fn );
	};
} );




jQuery.expr.pseudos.animated = function( elem ) {
	return jQuery.grep( jQuery.timers, function( fn ) {
		return elem === fn.elem;
	} ).length;
};




jQuery.offset = {
	setOffset: function( elem, options, i ) {
		var curPosition, curLeft, curCSSTop, curTop, curOffset, curCSSLeft, calculatePosition,
			position = jQuery.css( elem, "position" ),
			curElem = jQuery( elem ),
			props = {};

		// Set position first, in-case top/left are set even on static elem
		if ( position === "static" ) {
			elem.style.position = "relative";
		}

		curOffset = curElem.offset();
		curCSSTop = jQuery.css( elem, "top" );
		curCSSLeft = jQuery.css( elem, "left" );
		calculatePosition = ( position === "absolute" || position === "fixed" ) &&
			( curCSSTop + curCSSLeft ).indexOf( "auto" ) > -1;

		// Need to be able to calculate position if either
		// top or left is auto and position is either absolute or fixed
		if ( calculatePosition ) {
			curPosition = curElem.position();
			curTop = curPosition.top;
			curLeft = curPosition.left;

		} else {
			curTop = parseFloat( curCSSTop ) || 0;
			curLeft = parseFloat( curCSSLeft ) || 0;
		}

		if ( jQuery.isFunction( options ) ) {

			// Use jQuery.extend here to allow modification of coordinates argument (gh-1848)
			options = options.call( elem, i, jQuery.extend( {}, curOffset ) );
		}

		if ( options.top != null ) {
			props.top = ( options.top - curOffset.top ) + curTop;
		}
		if ( options.left != null ) {
			props.left = ( options.left - curOffset.left ) + curLeft;
		}

		if ( "using" in options ) {
			options.using.call( elem, props );

		} else {
			curElem.css( props );
		}
	}
};

jQuery.fn.extend( {
	offset: function( options ) {

		// Preserve chaining for setter
		if ( arguments.length ) {
			return options === undefined ?
				this :
				this.each( function( i ) {
					jQuery.offset.setOffset( this, options, i );
				} );
		}

		var doc, docElem, rect, win,
			elem = this[ 0 ];

		if ( !elem ) {
			return;
		}

		// Return zeros for disconnected and hidden (display: none) elements (gh-2310)
		// Support: IE <=11 only
		// Running getBoundingClientRect on a
		// disconnected node in IE throws an error
		if ( !elem.getClientRects().length ) {
			return { top: 0, left: 0 };
		}

		rect = elem.getBoundingClientRect();

		doc = elem.ownerDocument;
		docElem = doc.documentElement;
		win = doc.defaultView;

		return {
			top: rect.top + win.pageYOffset - docElem.clientTop,
			left: rect.left + win.pageXOffset - docElem.clientLeft
		};
	},

	position: function() {
		if ( !this[ 0 ] ) {
			return;
		}

		var offsetParent, offset,
			elem = this[ 0 ],
			parentOffset = { top: 0, left: 0 };

		// Fixed elements are offset from window (parentOffset = {top:0, left: 0},
		// because it is its only offset parent
		if ( jQuery.css( elem, "position" ) === "fixed" ) {

			// Assume getBoundingClientRect is there when computed position is fixed
			offset = elem.getBoundingClientRect();

		} else {

			// Get *real* offsetParent
			offsetParent = this.offsetParent();

			// Get correct offsets
			offset = this.offset();
			if ( !nodeName( offsetParent[ 0 ], "html" ) ) {
				parentOffset = offsetParent.offset();
			}

			// Add offsetParent borders
			parentOffset = {
				top: parentOffset.top + jQuery.css( offsetParent[ 0 ], "borderTopWidth", true ),
				left: parentOffset.left + jQuery.css( offsetParent[ 0 ], "borderLeftWidth", true )
			};
		}

		// Subtract parent offsets and element margins
		return {
			top: offset.top - parentOffset.top - jQuery.css( elem, "marginTop", true ),
			left: offset.left - parentOffset.left - jQuery.css( elem, "marginLeft", true )
		};
	},

	// This method will return documentElement in the following cases:
	// 1) For the element inside the iframe without offsetParent, this method will return
	//    documentElement of the parent window
	// 2) For the hidden or detached element
	// 3) For body or html element, i.e. in case of the html node - it will return itself
	//
	// but those exceptions were never presented as a real life use-cases
	// and might be considered as more preferable results.
	//
	// This logic, however, is not guaranteed and can change at any point in the future
	offsetParent: function() {
		return this.map( function() {
			var offsetParent = this.offsetParent;

			while ( offsetParent && jQuery.css( offsetParent, "position" ) === "static" ) {
				offsetParent = offsetParent.offsetParent;
			}

			return offsetParent || documentElement;
		} );
	}
} );

// Create scrollLeft and scrollTop methods
jQuery.each( { scrollLeft: "pageXOffset", scrollTop: "pageYOffset" }, function( method, prop ) {
	var top = "pageYOffset" === prop;

	jQuery.fn[ method ] = function( val ) {
		return access( this, function( elem, method, val ) {

			// Coalesce documents and windows
			var win;
			if ( jQuery.isWindow( elem ) ) {
				win = elem;
			} else if ( elem.nodeType === 9 ) {
				win = elem.defaultView;
			}

			if ( val === undefined ) {
				return win ? win[ prop ] : elem[ method ];
			}

			if ( win ) {
				win.scrollTo(
					!top ? val : win.pageXOffset,
					top ? val : win.pageYOffset
				);

			} else {
				elem[ method ] = val;
			}
		}, method, val, arguments.length );
	};
} );

// Support: Safari <=7 - 9.1, Chrome <=37 - 49
// Add the top/left cssHooks using jQuery.fn.position
// Webkit bug: https://bugs.webkit.org/show_bug.cgi?id=29084
// Blink bug: https://bugs.chromium.org/p/chromium/issues/detail?id=589347
// getComputedStyle returns percent when specified for top/left/bottom/right;
// rather than make the css module depend on the offset module, just check for it here
jQuery.each( [ "top", "left" ], function( i, prop ) {
	jQuery.cssHooks[ prop ] = addGetHookIf( support.pixelPosition,
		function( elem, computed ) {
			if ( computed ) {
				computed = curCSS( elem, prop );

				// If curCSS returns percentage, fallback to offset
				return rnumnonpx.test( computed ) ?
					jQuery( elem ).position()[ prop ] + "px" :
					computed;
			}
		}
	);
} );


// Create innerHeight, innerWidth, height, width, outerHeight and outerWidth methods
jQuery.each( { Height: "height", Width: "width" }, function( name, type ) {
	jQuery.each( { padding: "inner" + name, content: type, "": "outer" + name },
		function( defaultExtra, funcName ) {

		// Margin is only for outerHeight, outerWidth
		jQuery.fn[ funcName ] = function( margin, value ) {
			var chainable = arguments.length && ( defaultExtra || typeof margin !== "boolean" ),
				extra = defaultExtra || ( margin === true || value === true ? "margin" : "border" );

			return access( this, function( elem, type, value ) {
				var doc;

				if ( jQuery.isWindow( elem ) ) {

					// $( window ).outerWidth/Height return w/h including scrollbars (gh-1729)
					return funcName.indexOf( "outer" ) === 0 ?
						elem[ "inner" + name ] :
						elem.document.documentElement[ "client" + name ];
				}

				// Get document width or height
				if ( elem.nodeType === 9 ) {
					doc = elem.documentElement;

					// Either scroll[Width/Height] or offset[Width/Height] or client[Width/Height],
					// whichever is greatest
					return Math.max(
						elem.body[ "scroll" + name ], doc[ "scroll" + name ],
						elem.body[ "offset" + name ], doc[ "offset" + name ],
						doc[ "client" + name ]
					);
				}

				return value === undefined ?

					// Get width or height on the element, requesting but not forcing parseFloat
					jQuery.css( elem, type, extra ) :

					// Set width or height on the element
					jQuery.style( elem, type, value, extra );
			}, type, chainable ? margin : undefined, chainable );
		};
	} );
} );


jQuery.fn.extend( {

	bind: function( types, data, fn ) {
		return this.on( types, null, data, fn );
	},
	unbind: function( types, fn ) {
		return this.off( types, null, fn );
	},

	delegate: function( selector, types, data, fn ) {
		return this.on( types, selector, data, fn );
	},
	undelegate: function( selector, types, fn ) {

		// ( namespace ) or ( selector, types [, fn] )
		return arguments.length === 1 ?
			this.off( selector, "**" ) :
			this.off( types, selector || "**", fn );
	}
} );

jQuery.holdReady = function( hold ) {
	if ( hold ) {
		jQuery.readyWait++;
	} else {
		jQuery.ready( true );
	}
};
jQuery.isArray = Array.isArray;
jQuery.parseJSON = JSON.parse;
jQuery.nodeName = nodeName;




// Register as a named AMD module, since jQuery can be concatenated with other
// files that may use define, but not via a proper concatenation script that
// understands anonymous AMD modules. A named AMD is safest and most robust
// way to register. Lowercase jquery is used because AMD module names are
// derived from file names, and jQuery is normally delivered in a lowercase
// file name. Do this after creating the global so that if an AMD module wants
// to call noConflict to hide this version of jQuery, it will work.

// Note that for maximum portability, libraries that are not jQuery should
// declare themselves as anonymous modules, and avoid setting a global if an
// AMD loader is present. jQuery is a special case. For more information, see
// https://github.com/jrburke/requirejs/wiki/Updating-existing-libraries#wiki-anon

if ( true ) {
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function() {
		return jQuery;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
}




var

	// Map over jQuery in case of overwrite
	_jQuery = window.jQuery,

	// Map over the $ in case of overwrite
	_$ = window.$;

jQuery.noConflict = function( deep ) {
	if ( window.$ === jQuery ) {
		window.$ = _$;
	}

	if ( deep && window.jQuery === jQuery ) {
		window.jQuery = _jQuery;
	}

	return jQuery;
};

// Expose jQuery and $ identifiers, even in AMD
// (#7102#comment:10, https://github.com/jquery/jquery/pull/557)
// and CommonJS for browser emulators (#13566)
if ( !noGlobal ) {
	window.jQuery = window.$ = jQuery;
}




return jQuery;
} );


/***/ }),
/* 338 */
/***/ (function(module, exports) {

module.exports = function() {
	throw new Error("define cannot be used indirect");
};


/***/ }),
/* 339 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DashboardChart; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_google_charts__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_google_charts___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_google_charts__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var DashboardChart=function(_Component){_inherits(DashboardChart,_Component);function DashboardChart(){var _ref;var _temp,_this,_ret;_classCallCheck(this,DashboardChart);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=DashboardChart.__proto__||Object.getPrototypeOf(DashboardChart)).call.apply(_ref,[this].concat(args))),_this),_this.isDataPresent=function(){if(_this.props.routesList.filter(function(route){return route.selected;}).length>0){return true;}else{return false;}},_this.getCols=function(){var cols=[];cols.push({label:'Id',type:'string'});_this.props.routesList.filter(function(route){return route.selected;}).map(function(route,index){cols.push({label:route.from.name+" - "+route.to.name,type:'number'});return null;});return cols;},_this.getChartData=function(){var chartData=[];chartData.push('Drive');_this.props.routesList.filter(function(route){return route.selected;}).map(function(route,index){//chartData.push(Math.floor(Math.random() * (10 - 1 + 1)) + 1);
chartData.push(route.endDate.getHours()-route.startDate.getHours());return null;});return[chartData];},_this.getChartColors=function(){return _this.props.routesList.filter(function(route){return route.selected;}).map(function(route,index){return''+route.pathColor;});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(DashboardChart,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_google_charts__["Chart"],{chartType:'ComboChart',data:[['Month',' ​< 7 Days','7 - 14 days','15 - 30 days','30 days'],['January',.20,.225,.45,.24],['February',.56,.33,.45,.20],['March',.35,.23,.28,.34],['April',.24,.11,.36,.55],['May',.60,.45,.23,.35],['June',.27,.53,.49,.24],['July',.12,.23,.34,.56],['August',.25,.36,.14,.62],['September',.14,.37,.34,.23],['October',.24,.32,.65,.34],['November',.24,.34,.43,.42],['December',.62,.52,.53,.32]],options:{legend:{position:'right',textStyle:{fontSize:10}},bar:{groupWidth:'65%'},vAxis:{format:'percent',textStyle:{fontSize:10}},hAxis:{textStyle:{fontSize:10}}},graph_id:'DashboardChart',width:'100%',height:'200px'});}}]);return DashboardChart;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);;

/***/ }),
/* 340 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = undefined;

var _react = __webpack_require__(341);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(5);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _debug = __webpack_require__(162);

var _debug2 = _interopRequireDefault(_debug);

var _DEFAULT_CHART_COLORS = __webpack_require__(361);

var _DEFAULT_CHART_COLORS2 = _interopRequireDefault(_DEFAULT_CHART_COLORS);

var _GoogleChartLoader = __webpack_require__(362);

var _GoogleChartLoader2 = _interopRequireDefault(_GoogleChartLoader);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint react/forbid-prop-types: "off" */


var debug = new _debug2.default('react-google-charts:Chart');

var uniqueID = 0;

var generateUniqueID = function generateUniqueID() {
  uniqueID += 1;
  return 'reactgooglegraph-' + uniqueID;
};

var Chart = function (_React$Component) {
  _inherits(Chart, _React$Component);

  function Chart(props) {
    _classCallCheck(this, Chart);

    debug('constructor', props);

    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));

    _this.state = { graphID: props.graph_id || generateUniqueID() };
    _this.chart = null;
    _this.wrapper = null;
    _this.hidden_columns = {};
    _this.dataTable = [];

    _this.debounce = _this.debounce.bind(_this);
    _this.onResize = _this.onResize.bind(_this);
    _this.drawChart = _this.drawChart.bind(_this);
    _this.togglePoints = _this.togglePoints.bind(_this);
    _this.buildDataTableFromProps = _this.buildDataTableFromProps.bind(_this);
    _this.listenToChartEvents = _this.listenToChartEvents.bind(_this);
    _this.addChartActions = _this.addChartActions.bind(_this);
    _this.updateDataTable = _this.updateDataTable.bind(_this);
    _this.onSelectToggle = _this.onSelectToggle.bind(_this);
    _this.addSourceColumnTo = _this.addSourceColumnTo.bind(_this);
    _this.restoreColorTo = _this.restoreColorTo.bind(_this);
    _this.hideColumn = _this.hideColumn.bind(_this);
    return _this;
  }

  Chart.prototype.componentDidMount = function componentDidMount() {
    var _this2 = this;

    debug('componentDidMount');
    if (typeof window === 'undefined') {
      return;
    }
    if (this.props.loadCharts) {
      _GoogleChartLoader2.default.init(this.props.chartPackages, this.props.chartVersion).then(function () {
        _this2.drawChart();
      });
      this.onResize = this.debounce(this.onResize, 200);
      window.addEventListener('resize', this.onResize);
    } else {
      this.drawChart();
    }
  };

  Chart.prototype.componentDidUpdate = function componentDidUpdate() {
    var _this3 = this;

    debug('componentDidUpdate');
    if (!this.props.loadCharts) {
      this.drawChart();
    } else if (_GoogleChartLoader2.default.isLoading) {
      _GoogleChartLoader2.default.initPromise.then(function () {
        _this3.drawChart();
      });
    } else if (_GoogleChartLoader2.default.isLoaded) {
      this.drawChart();
    }
  };

  Chart.prototype.componentWillUnmount = function componentWillUnmount() {
    try {
      if (window) {
        if (window.google && window.google.visualization) {
          window.google.visualization.events.removeAllListeners(this.wrapper);
        }
        window.removeEventListener('resize', this.onResize);
      }
    } catch (err) {
      return;
    }
  };

  Chart.prototype.onResize = function onResize() {
    debug('Chart::onResize');
    this.drawChart();
  };

  Chart.prototype.onSelectToggle = function onSelectToggle() {
    debug('onSelectToggle');
    var selection = this.chart.getSelection();
    if (selection.length > 0) {
      if (selection[0].row == null) {
        var column = selection[0].column;
        this.togglePoints(column);
      }
    }
  };

  Chart.prototype.getColumnColor = function getColumnColor(columnIndex) {
    if (this.props.options.colors) {
      if (this.props.options.colors[columnIndex]) {
        return this.props.options.colors[columnIndex];
      }
    } else if (columnIndex in _DEFAULT_CHART_COLORS2.default) {
      return _DEFAULT_CHART_COLORS2.default[columnIndex];
    }
    return _DEFAULT_CHART_COLORS2.default[0];
  };

  Chart.prototype.buildDataTableFromProps = function buildDataTableFromProps() {
    debug('buildDataTableFromProps', this.props);

    if (this.props.diffdata) {
      var diffdata = this.props.diffdata;
      var oldData = window.google.visualization.arrayToDataTable(diffdata.old);
      var newData = window.google.visualization.arrayToDataTable(diffdata.new);
      // must take computeDiff from prototypes since not available with charts early in process
      var computeDiff = window.google.visualization[this.props.chartType].prototype.computeDiff;
      var chartDiff = computeDiff(oldData, newData);
      return chartDiff;
    }

    if (this.props.data === null && this.props.rows.length === 0 && !this.props.allowEmptyRows) {
      throw new Error("Can't build DataTable from rows and columns: rows array in props is empty");
    } else if (this.props.data === null && this.props.columns.length === 0) {
      throw new Error("Can't build DataTable from rows and columns: columns array in props is empty");
    }
    if (this.props.data !== null) {
      try {
        this.wrapper.setDataTable(this.props.data);
        var _dataTable = this.wrapper.getDataTable();
        return _dataTable;
      } catch (err) {
        // console.error('Failed to set DataTable from data props ! ', err);
        throw new Error('Failed to set DataTable from data props ! ', err);
      }
    }

    var dataTable = new window.google.visualization.DataTable();
    this.props.columns.forEach(function (column) {
      dataTable.addColumn(column);
    });
    dataTable.addRows(this.props.rows);
    if (this.props.numberFormat) {
      var formatter = new window.google.visualization.NumberFormat(this.props.numberFormat.options);
      formatter.format(dataTable, this.props.numberFormat.column);
    }

    if (this.props.dateFormat) {
      var dateFormat = new window.google.visualization.DateFormat(this.props.dateFormat.options);
      this.props.dateFormat.columns.forEach(function (columnIdx) {
        dateFormat.format(dataTable, columnIdx);
      });
    }

    return dataTable;
  };

  Chart.prototype.updateDataTable = function updateDataTable() {
    debug('updateDataTable');
    window.google.visualization.errors.removeAll(document.getElementById(this.wrapper.getContainerId()));
    this.dataTable.removeRows(0, this.dataTable.getNumberOfRows());
    this.dataTable.removeColumns(0, this.dataTable.getNumberOfColumns());
    this.dataTable = this.buildDataTableFromProps();
    return this.dataTable;
  };

  Chart.prototype.drawChart = function drawChart() {
    var _this4 = this;

    debug('drawChart', this);
    if (!this.wrapper) {
      var chartConfig = {
        chartType: this.props.chartType,
        options: this.props.options,
        containerId: this.state.graphID
      };
      this.wrapper = new window.google.visualization.ChartWrapper(chartConfig);
      this.dataTable = this.buildDataTableFromProps();
      this.wrapper.setDataTable(this.dataTable);

      window.google.visualization.events.addOneTimeListener(this.wrapper, 'ready', function () {
        _this4.chart = _this4.wrapper.getChart();
        _this4.listenToChartEvents();
        _this4.addChartActions();
      });
    } else {
      this.updateDataTable();
      this.wrapper.setDataTable(this.dataTable);
      // this.wrapper.setChartType(this.props.chartType)
      this.wrapper.setOptions(this.props.options);
      if (this.wrapper.getChartType() !== this.props.chartType) {
        window.google.visualization.events.removeAllListeners(this.wrapper);
        this.wrapper.setChartType(this.props.chartType);
        var self = this;
        window.google.visualization.events.addOneTimeListener(this.wrapper, 'ready', function () {
          self.chart = self.wrapper.getChart();
          self.listenToChartEvents.call(self);
        });
      }
    }
    this.wrapper.draw();
  };

  Chart.prototype.addChartActions = function addChartActions() {
    var _this5 = this;

    debug('addChartActions', this.props.chartActions);
    if (this.props.chartActions === null) {
      return;
    }
    this.props.chartActions.forEach(function (chartAction) {
      _this5.chart.setAction({
        id: chartAction.id,
        text: chartAction.text,
        action: chartAction.action.bind(_this5, _this5.chart)
      });
    });
  };

  Chart.prototype.listenToChartEvents = function listenToChartEvents() {
    var _this6 = this;

    debug('listenToChartEvents', this.props.legend_toggle, this.props.chartEvents);
    if (this.props.legend_toggle) {
      window.google.visualization.events.addListener(this.wrapper, 'select', this.onSelectToggle);
    }
    this.props.chartEvents.forEach(function (chartEvent) {
      if (chartEvent.eventName === 'ready') {
        chartEvent.callback(_this6);
      } else {
        (function (event) {
          window.google.visualization.events.addListener(_this6.chart, event.eventName, function (e) {
            event.callback(_this6, e);
          });
        })(chartEvent);
      }
    });
  };

  Chart.prototype.buildColumnFromSourceData = function buildColumnFromSourceData(columnIndex) {
    debug('buildColumnFromSourceData', columnIndex);
    return {
      label: this.dataTable.getColumnLabel(columnIndex),
      type: this.dataTable.getColumnType(columnIndex),
      sourceColumn: columnIndex
    };
  };

  Chart.prototype.buildEmptyColumnFromSourceData = function buildEmptyColumnFromSourceData(columnIndex) {
    debug('buildEmptyColumnFromSourceData', columnIndex);
    return {
      label: this.dataTable.getColumnLabel(columnIndex),
      type: this.dataTable.getColumnType(columnIndex),
      calc: function calc() {
        return null;
      }
    };
  };

  Chart.prototype.addEmptyColumnTo = function addEmptyColumnTo(columns, columnIndex) {
    debug('addEmptyColumnTo', columns, columnIndex);
    var emptyColumn = this.buildEmptyColumnFromSourceData(columnIndex);
    columns.push(emptyColumn);
  };

  Chart.prototype.hideColumn = function hideColumn(colors, columnIndex) {
    debug('hideColumn', colors, columnIndex);
    if (!this.isHidden(columnIndex)) {
      this.hidden_columns[columnIndex] = { color: this.getColumnColor(columnIndex - 1) };
    }
    colors.push('#CCCCCC');
  };

  Chart.prototype.addSourceColumnTo = function addSourceColumnTo(columns, columnIndex) {
    debug('addSourceColumnTo', columns, columnIndex);
    var sourceColumn = this.buildColumnFromSourceData(columnIndex);
    columns.push(sourceColumn);
  };

  Chart.prototype.isHidden = function isHidden(columnIndex) {
    return this.hidden_columns[columnIndex] !== undefined;
  };

  Chart.prototype.restoreColorTo = function restoreColorTo(colors, columnIndex) {
    debug('restoreColorTo', colors, columnIndex);
    debug('hidden_columns', this.hidden_columns);
    var previousColor = void 0;
    if (this.isHidden(columnIndex)) {
      previousColor = this.hidden_columns[columnIndex].color;
      delete this.hidden_columns[columnIndex];
    } else {
      previousColor = this.getColumnColor(columnIndex - 1);
    }
    if (columnIndex !== 0) {
      colors.push(previousColor);
    }
  };
  // eslint-disable-next-line class-methods-use-this


  Chart.prototype.debounce = function debounce(func, wait) {
    var timeout = void 0;
    return function () {
      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      var context = this;
      clearTimeout(timeout);
      timeout = setTimeout(function () {
        return func.apply(context, args);
      }, wait);
    };
  };

  Chart.prototype.togglePoints = function togglePoints(column) {
    debug('togglePoints', column);
    var view = new window.google.visualization.DataView(this.wrapper.getDataTable());
    var columnCount = view.getNumberOfColumns();
    var colors = []; // eslint-disable-line prefer-const
    var columns = []; // eslint-disable-line prefer-const
    for (var i = 0; i < columnCount; i += 1) {
      // If user clicked on legend
      if (i === 0) {
        this.addSourceColumnTo(columns, i);
      } else if (i === column) {
        if (this.isHidden(i)) {
          this.addSourceColumnTo(columns, i);
          this.restoreColorTo(colors, i);
        } else {
          this.addEmptyColumnTo(columns, i);
          this.hideColumn(colors, i);
        }
      } else if (this.isHidden(i)) {
        this.addEmptyColumnTo(columns, i);
        this.hideColumn(colors, i);
      } else {
        this.addSourceColumnTo(columns, i);
        this.restoreColorTo(colors, i);
      }
    }
    view.setColumns(columns);
    this.props.options.colors = colors;
    this.chart.draw(view, this.props.options);
  };

  Chart.prototype.render = function render() {
    debug('render', this.props, this.state);
    var divStyle = {
      height: this.props.height || this.props.options.height,
      width: this.props.width || this.props.options.width
    };
    return _react2.default.createElement(
      'div',
      { id: this.state.graphID, style: divStyle },
      this.props.loader ? this.props.loader : 'Rendering Chart...'
    );
  };

  return Chart;
}(_react2.default.Component);

exports.default = Chart;


 false ? Chart.propTypes = {
  graph_id: _propTypes2.default.string,
  chartType: _propTypes2.default.string,
  rows: _propTypes2.default.arrayOf(_propTypes2.default.array),
  columns: _propTypes2.default.arrayOf(_propTypes2.default.object),
  data: _propTypes2.default.arrayOf(_propTypes2.default.array),
  options: _propTypes2.default.any,
  width: _propTypes2.default.string,
  height: _propTypes2.default.string,
  chartEvents: _propTypes2.default.arrayOf(_propTypes2.default.shape({
    // https://github.com/yannickcr/eslint-plugin-react/issues/819
    eventName: _propTypes2.default.string, // eslint-disable-line react/no-unused-prop-types
    callback: _propTypes2.default.func })),
  chartActions: _propTypes2.default.arrayOf(_propTypes2.default.shape({
    id: _propTypes2.default.string, // eslint-disable-line react/no-unused-prop-types
    text: _propTypes2.default.string, // eslint-disable-line react/no-unused-prop-types
    action: _propTypes2.default.func })),
  loadCharts: _propTypes2.default.bool,
  loader: _propTypes2.default.node,
  legend_toggle: _propTypes2.default.bool,
  allowEmptyRows: _propTypes2.default.bool,
  chartPackages: _propTypes2.default.arrayOf(_propTypes2.default.string),
  chartVersion: _propTypes2.default.string,
  numberFormat: _propTypes2.default.shape({
    column: _propTypes2.default.number, // eslint-disable-line react/no-unused-prop-types
    options: _propTypes2.default.shape({
      decimalSymbol: _propTypes2.default.string, // eslint-disable-line react/no-unused-prop-types
      fractionDigits: _propTypes2.default.number, // eslint-disable-line react/no-unused-prop-types
      groupingSymbol: _propTypes2.default.string, // eslint-disable-line react/no-unused-prop-types
      negativeColor: _propTypes2.default.string, // eslint-disable-line react/no-unused-prop-types
      negativeParens: _propTypes2.default.bool, // eslint-disable-line react/no-unused-prop-types
      pattern: _propTypes2.default.string, // eslint-disable-line react/no-unused-prop-types
      prefix: _propTypes2.default.string, // eslint-disable-line react/no-unused-prop-types
      suffix: _propTypes2.default.string })
  }),
  dateFormat: _propTypes2.default.shape({
    // eslint-disable-next-line react/no-unused-prop-types
    columns: _propTypes2.default.arrayOf(_propTypes2.default.number),
    options: _propTypes2.default.shape({
      formatType: _propTypes2.default.string, // eslint-disable-line react/no-unused-prop-types
      pattern: _propTypes2.default.string, // eslint-disable-line react/no-unused-prop-types
      timeZone: _propTypes2.default.number })
  }),
  diffdata: _propTypes2.default.shape({
    on: _propTypes2.default.array, // eslint-disable-line react/no-unused-prop-types
    off: _propTypes2.default.array })
} : void 0;

Chart.defaultProps = {
  chartType: 'LineChart',
  rows: [],
  columns: [],
  options: {
    chart: {
      title: 'Chart Title',
      subtitle: 'Subtitle'
    },
    hAxis: { title: 'X Label' },
    vAxis: { title: 'Y Label' },
    width: '400px',
    height: '300px'
  },
  width: '400px',
  height: '300px',
  chartEvents: [],
  chartActions: null,
  data: null,
  legend_toggle: false,
  allowEmptyRows: false,
  loadCharts: true,
  loader: _react2.default.createElement(
    'div',
    null,
    'Rendering Chart'
  ),
  chartPackages: ['corechart'],
  chartVersion: 'current',
  numberFormat: null,
  dateFormat: null,
  diffdata: null
};
module.exports = exports['default'];

/***/ }),
/* 341 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = __webpack_require__(342);


/***/ }),
/* 342 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _assign = __webpack_require__(24);

var ReactBaseClasses = __webpack_require__(157);
var ReactChildren = __webpack_require__(344);
var ReactDOMFactories = __webpack_require__(349);
var ReactElement = __webpack_require__(39);
var ReactPropTypes = __webpack_require__(350);
var ReactVersion = __webpack_require__(354);

var createReactClass = __webpack_require__(355);
var onlyChild = __webpack_require__(357);

var createElement = ReactElement.createElement;
var createFactory = ReactElement.createFactory;
var cloneElement = ReactElement.cloneElement;

if (false) {
  var lowPriorityWarning = require('./lowPriorityWarning');
  var canDefineProperty = require('./canDefineProperty');
  var ReactElementValidator = require('./ReactElementValidator');
  var didWarnPropTypesDeprecated = false;
  createElement = ReactElementValidator.createElement;
  createFactory = ReactElementValidator.createFactory;
  cloneElement = ReactElementValidator.cloneElement;
}

var __spread = _assign;
var createMixin = function (mixin) {
  return mixin;
};

if (false) {
  var warnedForSpread = false;
  var warnedForCreateMixin = false;
  __spread = function () {
    lowPriorityWarning(warnedForSpread, 'React.__spread is deprecated and should not be used. Use ' + 'Object.assign directly or another helper function with similar ' + 'semantics. You may be seeing this warning due to your compiler. ' + 'See https://fb.me/react-spread-deprecation for more details.');
    warnedForSpread = true;
    return _assign.apply(null, arguments);
  };

  createMixin = function (mixin) {
    lowPriorityWarning(warnedForCreateMixin, 'React.createMixin is deprecated and should not be used. ' + 'In React v16.0, it will be removed. ' + 'You can use this mixin directly instead. ' + 'See https://fb.me/createmixin-was-never-implemented for more info.');
    warnedForCreateMixin = true;
    return mixin;
  };
}

var React = {
  // Modern

  Children: {
    map: ReactChildren.map,
    forEach: ReactChildren.forEach,
    count: ReactChildren.count,
    toArray: ReactChildren.toArray,
    only: onlyChild
  },

  Component: ReactBaseClasses.Component,
  PureComponent: ReactBaseClasses.PureComponent,

  createElement: createElement,
  cloneElement: cloneElement,
  isValidElement: ReactElement.isValidElement,

  // Classic

  PropTypes: ReactPropTypes,
  createClass: createReactClass,
  createFactory: createFactory,
  createMixin: createMixin,

  // This looks DOM specific but these are actually isomorphic helpers
  // since they are just generating DOM strings.
  DOM: ReactDOMFactories,

  version: ReactVersion,

  // Deprecated hook for JSX spread, don't use this for anything.
  __spread: __spread
};

if (false) {
  var warnedForCreateClass = false;
  if (canDefineProperty) {
    Object.defineProperty(React, 'PropTypes', {
      get: function () {
        lowPriorityWarning(didWarnPropTypesDeprecated, 'Accessing PropTypes via the main React package is deprecated,' + ' and will be removed in  React v16.0.' + ' Use the latest available v15.* prop-types package from npm instead.' + ' For info on usage, compatibility, migration and more, see ' + 'https://fb.me/prop-types-docs');
        didWarnPropTypesDeprecated = true;
        return ReactPropTypes;
      }
    });

    Object.defineProperty(React, 'createClass', {
      get: function () {
        lowPriorityWarning(warnedForCreateClass, 'Accessing createClass via the main React package is deprecated,' + ' and will be removed in React v16.0.' + " Use a plain JavaScript class instead. If you're not yet " + 'ready to migrate, create-react-class v15.* is available ' + 'on npm as a temporary, drop-in replacement. ' + 'For more info see https://fb.me/react-create-class');
        warnedForCreateClass = true;
        return createReactClass;
      }
    });
  }

  // React.DOM factories are deprecated. Wrap these methods so that
  // invocations of the React.DOM namespace and alert users to switch
  // to the `react-dom-factories` package.
  React.DOM = {};
  var warnedForFactories = false;
  Object.keys(ReactDOMFactories).forEach(function (factory) {
    React.DOM[factory] = function () {
      if (!warnedForFactories) {
        lowPriorityWarning(false, 'Accessing factories like React.DOM.%s has been deprecated ' + 'and will be removed in v16.0+. Use the ' + 'react-dom-factories package instead. ' + ' Version 1.0 provides a drop-in replacement.' + ' For more info, see https://fb.me/react-dom-factories', factory);
        warnedForFactories = true;
      }
      return ReactDOMFactories[factory].apply(ReactDOMFactories, arguments);
    };
  });
}

module.exports = React;

/***/ }),
/* 343 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * Forked from fbjs/warning:
 * https://github.com/facebook/fbjs/blob/e66ba20ad5be433eb54423f2b097d829324d9de6/packages/fbjs/src/__forks__/warning.js
 *
 * Only change is we use console.warn instead of console.error,
 * and do nothing when 'console' is not supported.
 * This really simplifies the code.
 * ---
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var lowPriorityWarning = function () {};

if (false) {
  var printWarning = function (format) {
    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    var argIndex = 0;
    var message = 'Warning: ' + format.replace(/%s/g, function () {
      return args[argIndex++];
    });
    if (typeof console !== 'undefined') {
      console.warn(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };

  lowPriorityWarning = function (condition, format) {
    if (format === undefined) {
      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
    }
    if (!condition) {
      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
        args[_key2 - 2] = arguments[_key2];
      }

      printWarning.apply(undefined, [format].concat(args));
    }
  };
}

module.exports = lowPriorityWarning;

/***/ }),
/* 344 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var PooledClass = __webpack_require__(345);
var ReactElement = __webpack_require__(39);

var emptyFunction = __webpack_require__(27);
var traverseAllChildren = __webpack_require__(346);

var twoArgumentPooler = PooledClass.twoArgumentPooler;
var fourArgumentPooler = PooledClass.fourArgumentPooler;

var userProvidedKeyEscapeRegex = /\/+/g;
function escapeUserProvidedKey(text) {
  return ('' + text).replace(userProvidedKeyEscapeRegex, '$&/');
}

/**
 * PooledClass representing the bookkeeping associated with performing a child
 * traversal. Allows avoiding binding callbacks.
 *
 * @constructor ForEachBookKeeping
 * @param {!function} forEachFunction Function to perform traversal with.
 * @param {?*} forEachContext Context to perform context with.
 */
function ForEachBookKeeping(forEachFunction, forEachContext) {
  this.func = forEachFunction;
  this.context = forEachContext;
  this.count = 0;
}
ForEachBookKeeping.prototype.destructor = function () {
  this.func = null;
  this.context = null;
  this.count = 0;
};
PooledClass.addPoolingTo(ForEachBookKeeping, twoArgumentPooler);

function forEachSingleChild(bookKeeping, child, name) {
  var func = bookKeeping.func,
      context = bookKeeping.context;

  func.call(context, child, bookKeeping.count++);
}

/**
 * Iterates through children that are typically specified as `props.children`.
 *
 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.foreach
 *
 * The provided forEachFunc(child, index) will be called for each
 * leaf child.
 *
 * @param {?*} children Children tree container.
 * @param {function(*, int)} forEachFunc
 * @param {*} forEachContext Context for forEachContext.
 */
function forEachChildren(children, forEachFunc, forEachContext) {
  if (children == null) {
    return children;
  }
  var traverseContext = ForEachBookKeeping.getPooled(forEachFunc, forEachContext);
  traverseAllChildren(children, forEachSingleChild, traverseContext);
  ForEachBookKeeping.release(traverseContext);
}

/**
 * PooledClass representing the bookkeeping associated with performing a child
 * mapping. Allows avoiding binding callbacks.
 *
 * @constructor MapBookKeeping
 * @param {!*} mapResult Object containing the ordered map of results.
 * @param {!function} mapFunction Function to perform mapping with.
 * @param {?*} mapContext Context to perform mapping with.
 */
function MapBookKeeping(mapResult, keyPrefix, mapFunction, mapContext) {
  this.result = mapResult;
  this.keyPrefix = keyPrefix;
  this.func = mapFunction;
  this.context = mapContext;
  this.count = 0;
}
MapBookKeeping.prototype.destructor = function () {
  this.result = null;
  this.keyPrefix = null;
  this.func = null;
  this.context = null;
  this.count = 0;
};
PooledClass.addPoolingTo(MapBookKeeping, fourArgumentPooler);

function mapSingleChildIntoContext(bookKeeping, child, childKey) {
  var result = bookKeeping.result,
      keyPrefix = bookKeeping.keyPrefix,
      func = bookKeeping.func,
      context = bookKeeping.context;


  var mappedChild = func.call(context, child, bookKeeping.count++);
  if (Array.isArray(mappedChild)) {
    mapIntoWithKeyPrefixInternal(mappedChild, result, childKey, emptyFunction.thatReturnsArgument);
  } else if (mappedChild != null) {
    if (ReactElement.isValidElement(mappedChild)) {
      mappedChild = ReactElement.cloneAndReplaceKey(mappedChild,
      // Keep both the (mapped) and old keys if they differ, just as
      // traverseAllChildren used to do for objects as children
      keyPrefix + (mappedChild.key && (!child || child.key !== mappedChild.key) ? escapeUserProvidedKey(mappedChild.key) + '/' : '') + childKey);
    }
    result.push(mappedChild);
  }
}

function mapIntoWithKeyPrefixInternal(children, array, prefix, func, context) {
  var escapedPrefix = '';
  if (prefix != null) {
    escapedPrefix = escapeUserProvidedKey(prefix) + '/';
  }
  var traverseContext = MapBookKeeping.getPooled(array, escapedPrefix, func, context);
  traverseAllChildren(children, mapSingleChildIntoContext, traverseContext);
  MapBookKeeping.release(traverseContext);
}

/**
 * Maps children that are typically specified as `props.children`.
 *
 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.map
 *
 * The provided mapFunction(child, key, index) will be called for each
 * leaf child.
 *
 * @param {?*} children Children tree container.
 * @param {function(*, int)} func The map function.
 * @param {*} context Context for mapFunction.
 * @return {object} Object containing the ordered map of results.
 */
function mapChildren(children, func, context) {
  if (children == null) {
    return children;
  }
  var result = [];
  mapIntoWithKeyPrefixInternal(children, result, null, func, context);
  return result;
}

function forEachSingleChildDummy(traverseContext, child, name) {
  return null;
}

/**
 * Count the number of children that are typically specified as
 * `props.children`.
 *
 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.count
 *
 * @param {?*} children Children tree container.
 * @return {number} The number of children.
 */
function countChildren(children, context) {
  return traverseAllChildren(children, forEachSingleChildDummy, null);
}

/**
 * Flatten a children object (typically specified as `props.children`) and
 * return an array with appropriately re-keyed children.
 *
 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.toarray
 */
function toArray(children) {
  var result = [];
  mapIntoWithKeyPrefixInternal(children, result, null, emptyFunction.thatReturnsArgument);
  return result;
}

var ReactChildren = {
  forEach: forEachChildren,
  map: mapChildren,
  mapIntoWithKeyPrefixInternal: mapIntoWithKeyPrefixInternal,
  count: countChildren,
  toArray: toArray
};

module.exports = ReactChildren;

/***/ }),
/* 345 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



var _prodInvariant = __webpack_require__(69);

var invariant = __webpack_require__(22);

/**
 * Static poolers. Several custom versions for each potential number of
 * arguments. A completely generic pooler is easy to implement, but would
 * require accessing the `arguments` object. In each of these, `this` refers to
 * the Class itself, not an instance. If any others are needed, simply add them
 * here, or in their own files.
 */
var oneArgumentPooler = function (copyFieldsFrom) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, copyFieldsFrom);
    return instance;
  } else {
    return new Klass(copyFieldsFrom);
  }
};

var twoArgumentPooler = function (a1, a2) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, a1, a2);
    return instance;
  } else {
    return new Klass(a1, a2);
  }
};

var threeArgumentPooler = function (a1, a2, a3) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, a1, a2, a3);
    return instance;
  } else {
    return new Klass(a1, a2, a3);
  }
};

var fourArgumentPooler = function (a1, a2, a3, a4) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, a1, a2, a3, a4);
    return instance;
  } else {
    return new Klass(a1, a2, a3, a4);
  }
};

var standardReleaser = function (instance) {
  var Klass = this;
  !(instance instanceof Klass) ?  false ? invariant(false, 'Trying to release an instance into a pool of a different type.') : _prodInvariant('25') : void 0;
  instance.destructor();
  if (Klass.instancePool.length < Klass.poolSize) {
    Klass.instancePool.push(instance);
  }
};

var DEFAULT_POOL_SIZE = 10;
var DEFAULT_POOLER = oneArgumentPooler;

/**
 * Augments `CopyConstructor` to be a poolable class, augmenting only the class
 * itself (statically) not adding any prototypical fields. Any CopyConstructor
 * you give this may have a `poolSize` property, and will look for a
 * prototypical `destructor` on instances.
 *
 * @param {Function} CopyConstructor Constructor that can be used to reset.
 * @param {Function} pooler Customizable pooler.
 */
var addPoolingTo = function (CopyConstructor, pooler) {
  // Casting as any so that flow ignores the actual implementation and trusts
  // it to match the type we declared
  var NewKlass = CopyConstructor;
  NewKlass.instancePool = [];
  NewKlass.getPooled = pooler || DEFAULT_POOLER;
  if (!NewKlass.poolSize) {
    NewKlass.poolSize = DEFAULT_POOL_SIZE;
  }
  NewKlass.release = standardReleaser;
  return NewKlass;
};

var PooledClass = {
  addPoolingTo: addPoolingTo,
  oneArgumentPooler: oneArgumentPooler,
  twoArgumentPooler: twoArgumentPooler,
  threeArgumentPooler: threeArgumentPooler,
  fourArgumentPooler: fourArgumentPooler
};

module.exports = PooledClass;

/***/ }),
/* 346 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _prodInvariant = __webpack_require__(69);

var ReactCurrentOwner = __webpack_require__(160);
var REACT_ELEMENT_TYPE = __webpack_require__(161);

var getIteratorFn = __webpack_require__(347);
var invariant = __webpack_require__(22);
var KeyEscapeUtils = __webpack_require__(348);
var warning = __webpack_require__(70);

var SEPARATOR = '.';
var SUBSEPARATOR = ':';

/**
 * This is inlined from ReactElement since this file is shared between
 * isomorphic and renderers. We could extract this to a
 *
 */

/**
 * TODO: Test that a single child and an array with one item have the same key
 * pattern.
 */

var didWarnAboutMaps = false;

/**
 * Generate a key string that identifies a component within a set.
 *
 * @param {*} component A component that could contain a manual key.
 * @param {number} index Index that is used if a manual key is not provided.
 * @return {string}
 */
function getComponentKey(component, index) {
  // Do some typechecking here since we call this blindly. We want to ensure
  // that we don't block potential future ES APIs.
  if (component && typeof component === 'object' && component.key != null) {
    // Explicit key
    return KeyEscapeUtils.escape(component.key);
  }
  // Implicit key determined by the index in the set
  return index.toString(36);
}

/**
 * @param {?*} children Children tree container.
 * @param {!string} nameSoFar Name of the key path so far.
 * @param {!function} callback Callback to invoke with each child found.
 * @param {?*} traverseContext Used to pass information throughout the traversal
 * process.
 * @return {!number} The number of children in this subtree.
 */
function traverseAllChildrenImpl(children, nameSoFar, callback, traverseContext) {
  var type = typeof children;

  if (type === 'undefined' || type === 'boolean') {
    // All of the above are perceived as null.
    children = null;
  }

  if (children === null || type === 'string' || type === 'number' ||
  // The following is inlined from ReactElement. This means we can optimize
  // some checks. React Fiber also inlines this logic for similar purposes.
  type === 'object' && children.$$typeof === REACT_ELEMENT_TYPE) {
    callback(traverseContext, children,
    // If it's the only child, treat the name as if it was wrapped in an array
    // so that it's consistent if the number of children grows.
    nameSoFar === '' ? SEPARATOR + getComponentKey(children, 0) : nameSoFar);
    return 1;
  }

  var child;
  var nextName;
  var subtreeCount = 0; // Count of children found in the current subtree.
  var nextNamePrefix = nameSoFar === '' ? SEPARATOR : nameSoFar + SUBSEPARATOR;

  if (Array.isArray(children)) {
    for (var i = 0; i < children.length; i++) {
      child = children[i];
      nextName = nextNamePrefix + getComponentKey(child, i);
      subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
    }
  } else {
    var iteratorFn = getIteratorFn(children);
    if (iteratorFn) {
      var iterator = iteratorFn.call(children);
      var step;
      if (iteratorFn !== children.entries) {
        var ii = 0;
        while (!(step = iterator.next()).done) {
          child = step.value;
          nextName = nextNamePrefix + getComponentKey(child, ii++);
          subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
        }
      } else {
        if (false) {
          var mapsAsChildrenAddendum = '';
          if (ReactCurrentOwner.current) {
            var mapsAsChildrenOwnerName = ReactCurrentOwner.current.getName();
            if (mapsAsChildrenOwnerName) {
              mapsAsChildrenAddendum = ' Check the render method of `' + mapsAsChildrenOwnerName + '`.';
            }
          }
          process.env.NODE_ENV !== 'production' ? warning(didWarnAboutMaps, 'Using Maps as children is not yet fully supported. It is an ' + 'experimental feature that might be removed. Convert it to a ' + 'sequence / iterable of keyed ReactElements instead.%s', mapsAsChildrenAddendum) : void 0;
          didWarnAboutMaps = true;
        }
        // Iterator will provide entry [k,v] tuples rather than values.
        while (!(step = iterator.next()).done) {
          var entry = step.value;
          if (entry) {
            child = entry[1];
            nextName = nextNamePrefix + KeyEscapeUtils.escape(entry[0]) + SUBSEPARATOR + getComponentKey(child, 0);
            subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
          }
        }
      }
    } else if (type === 'object') {
      var addendum = '';
      if (false) {
        addendum = ' If you meant to render a collection of children, use an array ' + 'instead or wrap the object using createFragment(object) from the ' + 'React add-ons.';
        if (children._isReactElement) {
          addendum = " It looks like you're using an element created by a different " + 'version of React. Make sure to use only one copy of React.';
        }
        if (ReactCurrentOwner.current) {
          var name = ReactCurrentOwner.current.getName();
          if (name) {
            addendum += ' Check the render method of `' + name + '`.';
          }
        }
      }
      var childrenString = String(children);
       true ?  false ? invariant(false, 'Objects are not valid as a React child (found: %s).%s', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : _prodInvariant('31', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : void 0;
    }
  }

  return subtreeCount;
}

/**
 * Traverses children that are typically specified as `props.children`, but
 * might also be specified through attributes:
 *
 * - `traverseAllChildren(this.props.children, ...)`
 * - `traverseAllChildren(this.props.leftPanelChildren, ...)`
 *
 * The `traverseContext` is an optional argument that is passed through the
 * entire traversal. It can be used to store accumulations or anything else that
 * the callback might find relevant.
 *
 * @param {?*} children Children tree object.
 * @param {!function} callback To invoke upon traversing each child.
 * @param {?*} traverseContext Context for traversal.
 * @return {!number} The number of children in this subtree.
 */
function traverseAllChildren(children, callback, traverseContext) {
  if (children == null) {
    return 0;
  }

  return traverseAllChildrenImpl(children, '', callback, traverseContext);
}

module.exports = traverseAllChildren;

/***/ }),
/* 347 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



/* global Symbol */

var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

/**
 * Returns the iterator method function contained on the iterable object.
 *
 * Be sure to invoke the function with the iterable as context:
 *
 *     var iteratorFn = getIteratorFn(myIterable);
 *     if (iteratorFn) {
 *       var iterator = iteratorFn.call(myIterable);
 *       ...
 *     }
 *
 * @param {?object} maybeIterable
 * @return {?function}
 */
function getIteratorFn(maybeIterable) {
  var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
  if (typeof iteratorFn === 'function') {
    return iteratorFn;
  }
}

module.exports = getIteratorFn;

/***/ }),
/* 348 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



/**
 * Escape and wrap key so it is safe to use as a reactid
 *
 * @param {string} key to be escaped.
 * @return {string} the escaped key.
 */

function escape(key) {
  var escapeRegex = /[=:]/g;
  var escaperLookup = {
    '=': '=0',
    ':': '=2'
  };
  var escapedString = ('' + key).replace(escapeRegex, function (match) {
    return escaperLookup[match];
  });

  return '$' + escapedString;
}

/**
 * Unescape and unwrap key for human-readable display
 *
 * @param {string} key to unescape.
 * @return {string} the unescaped key.
 */
function unescape(key) {
  var unescapeRegex = /(=0|=2)/g;
  var unescaperLookup = {
    '=0': '=',
    '=2': ':'
  };
  var keySubstring = key[0] === '.' && key[1] === '$' ? key.substring(2) : key.substring(1);

  return ('' + keySubstring).replace(unescapeRegex, function (match) {
    return unescaperLookup[match];
  });
}

var KeyEscapeUtils = {
  escape: escape,
  unescape: unescape
};

module.exports = KeyEscapeUtils;

/***/ }),
/* 349 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var ReactElement = __webpack_require__(39);

/**
 * Create a factory that creates HTML tag elements.
 *
 * @private
 */
var createDOMFactory = ReactElement.createFactory;
if (false) {
  var ReactElementValidator = require('./ReactElementValidator');
  createDOMFactory = ReactElementValidator.createFactory;
}

/**
 * Creates a mapping from supported HTML tags to `ReactDOMComponent` classes.
 *
 * @public
 */
var ReactDOMFactories = {
  a: createDOMFactory('a'),
  abbr: createDOMFactory('abbr'),
  address: createDOMFactory('address'),
  area: createDOMFactory('area'),
  article: createDOMFactory('article'),
  aside: createDOMFactory('aside'),
  audio: createDOMFactory('audio'),
  b: createDOMFactory('b'),
  base: createDOMFactory('base'),
  bdi: createDOMFactory('bdi'),
  bdo: createDOMFactory('bdo'),
  big: createDOMFactory('big'),
  blockquote: createDOMFactory('blockquote'),
  body: createDOMFactory('body'),
  br: createDOMFactory('br'),
  button: createDOMFactory('button'),
  canvas: createDOMFactory('canvas'),
  caption: createDOMFactory('caption'),
  cite: createDOMFactory('cite'),
  code: createDOMFactory('code'),
  col: createDOMFactory('col'),
  colgroup: createDOMFactory('colgroup'),
  data: createDOMFactory('data'),
  datalist: createDOMFactory('datalist'),
  dd: createDOMFactory('dd'),
  del: createDOMFactory('del'),
  details: createDOMFactory('details'),
  dfn: createDOMFactory('dfn'),
  dialog: createDOMFactory('dialog'),
  div: createDOMFactory('div'),
  dl: createDOMFactory('dl'),
  dt: createDOMFactory('dt'),
  em: createDOMFactory('em'),
  embed: createDOMFactory('embed'),
  fieldset: createDOMFactory('fieldset'),
  figcaption: createDOMFactory('figcaption'),
  figure: createDOMFactory('figure'),
  footer: createDOMFactory('footer'),
  form: createDOMFactory('form'),
  h1: createDOMFactory('h1'),
  h2: createDOMFactory('h2'),
  h3: createDOMFactory('h3'),
  h4: createDOMFactory('h4'),
  h5: createDOMFactory('h5'),
  h6: createDOMFactory('h6'),
  head: createDOMFactory('head'),
  header: createDOMFactory('header'),
  hgroup: createDOMFactory('hgroup'),
  hr: createDOMFactory('hr'),
  html: createDOMFactory('html'),
  i: createDOMFactory('i'),
  iframe: createDOMFactory('iframe'),
  img: createDOMFactory('img'),
  input: createDOMFactory('input'),
  ins: createDOMFactory('ins'),
  kbd: createDOMFactory('kbd'),
  keygen: createDOMFactory('keygen'),
  label: createDOMFactory('label'),
  legend: createDOMFactory('legend'),
  li: createDOMFactory('li'),
  link: createDOMFactory('link'),
  main: createDOMFactory('main'),
  map: createDOMFactory('map'),
  mark: createDOMFactory('mark'),
  menu: createDOMFactory('menu'),
  menuitem: createDOMFactory('menuitem'),
  meta: createDOMFactory('meta'),
  meter: createDOMFactory('meter'),
  nav: createDOMFactory('nav'),
  noscript: createDOMFactory('noscript'),
  object: createDOMFactory('object'),
  ol: createDOMFactory('ol'),
  optgroup: createDOMFactory('optgroup'),
  option: createDOMFactory('option'),
  output: createDOMFactory('output'),
  p: createDOMFactory('p'),
  param: createDOMFactory('param'),
  picture: createDOMFactory('picture'),
  pre: createDOMFactory('pre'),
  progress: createDOMFactory('progress'),
  q: createDOMFactory('q'),
  rp: createDOMFactory('rp'),
  rt: createDOMFactory('rt'),
  ruby: createDOMFactory('ruby'),
  s: createDOMFactory('s'),
  samp: createDOMFactory('samp'),
  script: createDOMFactory('script'),
  section: createDOMFactory('section'),
  select: createDOMFactory('select'),
  small: createDOMFactory('small'),
  source: createDOMFactory('source'),
  span: createDOMFactory('span'),
  strong: createDOMFactory('strong'),
  style: createDOMFactory('style'),
  sub: createDOMFactory('sub'),
  summary: createDOMFactory('summary'),
  sup: createDOMFactory('sup'),
  table: createDOMFactory('table'),
  tbody: createDOMFactory('tbody'),
  td: createDOMFactory('td'),
  textarea: createDOMFactory('textarea'),
  tfoot: createDOMFactory('tfoot'),
  th: createDOMFactory('th'),
  thead: createDOMFactory('thead'),
  time: createDOMFactory('time'),
  title: createDOMFactory('title'),
  tr: createDOMFactory('tr'),
  track: createDOMFactory('track'),
  u: createDOMFactory('u'),
  ul: createDOMFactory('ul'),
  'var': createDOMFactory('var'),
  video: createDOMFactory('video'),
  wbr: createDOMFactory('wbr'),

  // SVG
  circle: createDOMFactory('circle'),
  clipPath: createDOMFactory('clipPath'),
  defs: createDOMFactory('defs'),
  ellipse: createDOMFactory('ellipse'),
  g: createDOMFactory('g'),
  image: createDOMFactory('image'),
  line: createDOMFactory('line'),
  linearGradient: createDOMFactory('linearGradient'),
  mask: createDOMFactory('mask'),
  path: createDOMFactory('path'),
  pattern: createDOMFactory('pattern'),
  polygon: createDOMFactory('polygon'),
  polyline: createDOMFactory('polyline'),
  radialGradient: createDOMFactory('radialGradient'),
  rect: createDOMFactory('rect'),
  stop: createDOMFactory('stop'),
  svg: createDOMFactory('svg'),
  text: createDOMFactory('text'),
  tspan: createDOMFactory('tspan')
};

module.exports = ReactDOMFactories;

/***/ }),
/* 350 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _require = __webpack_require__(39),
    isValidElement = _require.isValidElement;

var factory = __webpack_require__(351);

module.exports = factory(isValidElement);

/***/ }),
/* 351 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



// React 15.5 references this module, and assumes PropTypes are still callable in production.
// Therefore we re-export development-only version with all the PropTypes checks here.
// However if one is migrating to the `prop-types` npm library, they will go through the
// `index.js` entry point, and it will branch depending on the environment.
var factory = __webpack_require__(352);
module.exports = function(isValidElement) {
  // It is still allowed in 15.5.
  var throwOnDirectAccess = false;
  return factory(isValidElement, throwOnDirectAccess);
};


/***/ }),
/* 352 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var emptyFunction = __webpack_require__(27);
var invariant = __webpack_require__(22);
var warning = __webpack_require__(70);
var assign = __webpack_require__(24);

var ReactPropTypesSecret = __webpack_require__(126);
var checkPropTypes = __webpack_require__(353);

module.exports = function(isValidElement, throwOnDirectAccess) {
  /* global Symbol */
  var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
  var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

  /**
   * Returns the iterator method function contained on the iterable object.
   *
   * Be sure to invoke the function with the iterable as context:
   *
   *     var iteratorFn = getIteratorFn(myIterable);
   *     if (iteratorFn) {
   *       var iterator = iteratorFn.call(myIterable);
   *       ...
   *     }
   *
   * @param {?object} maybeIterable
   * @return {?function}
   */
  function getIteratorFn(maybeIterable) {
    var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
    if (typeof iteratorFn === 'function') {
      return iteratorFn;
    }
  }

  /**
   * Collection of methods that allow declaration and validation of props that are
   * supplied to React components. Example usage:
   *
   *   var Props = require('ReactPropTypes');
   *   var MyArticle = React.createClass({
   *     propTypes: {
   *       // An optional string prop named "description".
   *       description: Props.string,
   *
   *       // A required enum prop named "category".
   *       category: Props.oneOf(['News','Photos']).isRequired,
   *
   *       // A prop named "dialog" that requires an instance of Dialog.
   *       dialog: Props.instanceOf(Dialog).isRequired
   *     },
   *     render: function() { ... }
   *   });
   *
   * A more formal specification of how these methods are used:
   *
   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
   *   decl := ReactPropTypes.{type}(.isRequired)?
   *
   * Each and every declaration produces a function with the same signature. This
   * allows the creation of custom validation functions. For example:
   *
   *  var MyLink = React.createClass({
   *    propTypes: {
   *      // An optional string or URI prop named "href".
   *      href: function(props, propName, componentName) {
   *        var propValue = props[propName];
   *        if (propValue != null && typeof propValue !== 'string' &&
   *            !(propValue instanceof URI)) {
   *          return new Error(
   *            'Expected a string or an URI for ' + propName + ' in ' +
   *            componentName
   *          );
   *        }
   *      }
   *    },
   *    render: function() {...}
   *  });
   *
   * @internal
   */

  var ANONYMOUS = '<<anonymous>>';

  // Important!
  // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
  var ReactPropTypes = {
    array: createPrimitiveTypeChecker('array'),
    bool: createPrimitiveTypeChecker('boolean'),
    func: createPrimitiveTypeChecker('function'),
    number: createPrimitiveTypeChecker('number'),
    object: createPrimitiveTypeChecker('object'),
    string: createPrimitiveTypeChecker('string'),
    symbol: createPrimitiveTypeChecker('symbol'),

    any: createAnyTypeChecker(),
    arrayOf: createArrayOfTypeChecker,
    element: createElementTypeChecker(),
    instanceOf: createInstanceTypeChecker,
    node: createNodeChecker(),
    objectOf: createObjectOfTypeChecker,
    oneOf: createEnumTypeChecker,
    oneOfType: createUnionTypeChecker,
    shape: createShapeTypeChecker,
    exact: createStrictShapeTypeChecker,
  };

  /**
   * inlined Object.is polyfill to avoid requiring consumers ship their own
   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
   */
  /*eslint-disable no-self-compare*/
  function is(x, y) {
    // SameValue algorithm
    if (x === y) {
      // Steps 1-5, 7-10
      // Steps 6.b-6.e: +0 != -0
      return x !== 0 || 1 / x === 1 / y;
    } else {
      // Step 6.a: NaN == NaN
      return x !== x && y !== y;
    }
  }
  /*eslint-enable no-self-compare*/

  /**
   * We use an Error-like object for backward compatibility as people may call
   * PropTypes directly and inspect their output. However, we don't use real
   * Errors anymore. We don't inspect their stack anyway, and creating them
   * is prohibitively expensive if they are created too often, such as what
   * happens in oneOfType() for any type before the one that matched.
   */
  function PropTypeError(message) {
    this.message = message;
    this.stack = '';
  }
  // Make `instanceof Error` still work for returned errors.
  PropTypeError.prototype = Error.prototype;

  function createChainableTypeChecker(validate) {
    if (false) {
      var manualPropTypeCallCache = {};
      var manualPropTypeWarningCount = 0;
    }
    function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
      componentName = componentName || ANONYMOUS;
      propFullName = propFullName || propName;

      if (secret !== ReactPropTypesSecret) {
        if (throwOnDirectAccess) {
          // New behavior only for users of `prop-types` package
          invariant(
            false,
            'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
            'Use `PropTypes.checkPropTypes()` to call them. ' +
            'Read more at http://fb.me/use-check-prop-types'
          );
        } else if (false) {
          // Old behavior for people using React.PropTypes
          var cacheKey = componentName + ':' + propName;
          if (
            !manualPropTypeCallCache[cacheKey] &&
            // Avoid spamming the console because they are often not actionable except for lib authors
            manualPropTypeWarningCount < 3
          ) {
            warning(
              false,
              'You are manually calling a React.PropTypes validation ' +
              'function for the `%s` prop on `%s`. This is deprecated ' +
              'and will throw in the standalone `prop-types` package. ' +
              'You may be seeing this warning due to a third-party PropTypes ' +
              'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.',
              propFullName,
              componentName
            );
            manualPropTypeCallCache[cacheKey] = true;
            manualPropTypeWarningCount++;
          }
        }
      }
      if (props[propName] == null) {
        if (isRequired) {
          if (props[propName] === null) {
            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
          }
          return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
        }
        return null;
      } else {
        return validate(props, propName, componentName, location, propFullName);
      }
    }

    var chainedCheckType = checkType.bind(null, false);
    chainedCheckType.isRequired = checkType.bind(null, true);

    return chainedCheckType;
  }

  function createPrimitiveTypeChecker(expectedType) {
    function validate(props, propName, componentName, location, propFullName, secret) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== expectedType) {
        // `propValue` being instance of, say, date/regexp, pass the 'object'
        // check, but we can offer a more precise error message here rather than
        // 'of type `object`'.
        var preciseType = getPreciseType(propValue);

        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createAnyTypeChecker() {
    return createChainableTypeChecker(emptyFunction.thatReturnsNull);
  }

  function createArrayOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
      }
      var propValue = props[propName];
      if (!Array.isArray(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
      }
      for (var i = 0; i < propValue.length; i++) {
        var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret);
        if (error instanceof Error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createElementTypeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      if (!isValidElement(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createInstanceTypeChecker(expectedClass) {
    function validate(props, propName, componentName, location, propFullName) {
      if (!(props[propName] instanceof expectedClass)) {
        var expectedClassName = expectedClass.name || ANONYMOUS;
        var actualClassName = getClassName(props[propName]);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createEnumTypeChecker(expectedValues) {
    if (!Array.isArray(expectedValues)) {
       false ? warning(false, 'Invalid argument supplied to oneOf, expected an instance of array.') : void 0;
      return emptyFunction.thatReturnsNull;
    }

    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      for (var i = 0; i < expectedValues.length; i++) {
        if (is(propValue, expectedValues[i])) {
          return null;
        }
      }

      var valuesString = JSON.stringify(expectedValues);
      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + propValue + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
    }
    return createChainableTypeChecker(validate);
  }

  function createObjectOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
      }
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
      }
      for (var key in propValue) {
        if (propValue.hasOwnProperty(key)) {
          var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
          if (error instanceof Error) {
            return error;
          }
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createUnionTypeChecker(arrayOfTypeCheckers) {
    if (!Array.isArray(arrayOfTypeCheckers)) {
       false ? warning(false, 'Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
      return emptyFunction.thatReturnsNull;
    }

    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
      var checker = arrayOfTypeCheckers[i];
      if (typeof checker !== 'function') {
        warning(
          false,
          'Invalid argument supplied to oneOfType. Expected an array of check functions, but ' +
          'received %s at index %s.',
          getPostfixForTypeWarning(checker),
          i
        );
        return emptyFunction.thatReturnsNull;
      }
    }

    function validate(props, propName, componentName, location, propFullName) {
      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
        var checker = arrayOfTypeCheckers[i];
        if (checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret) == null) {
          return null;
        }
      }

      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`.'));
    }
    return createChainableTypeChecker(validate);
  }

  function createNodeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      if (!isNode(props[propName])) {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      }
      for (var key in shapeTypes) {
        var checker = shapeTypes[key];
        if (!checker) {
          continue;
        }
        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
        if (error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createStrictShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      }
      // We need to check all keys in case some are required but missing from
      // props.
      var allKeys = assign({}, props[propName], shapeTypes);
      for (var key in allKeys) {
        var checker = shapeTypes[key];
        if (!checker) {
          return new PropTypeError(
            'Invalid ' + location + ' `' + propFullName + '` key `' + key + '` supplied to `' + componentName + '`.' +
            '\nBad object: ' + JSON.stringify(props[propName], null, '  ') +
            '\nValid keys: ' +  JSON.stringify(Object.keys(shapeTypes), null, '  ')
          );
        }
        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
        if (error) {
          return error;
        }
      }
      return null;
    }

    return createChainableTypeChecker(validate);
  }

  function isNode(propValue) {
    switch (typeof propValue) {
      case 'number':
      case 'string':
      case 'undefined':
        return true;
      case 'boolean':
        return !propValue;
      case 'object':
        if (Array.isArray(propValue)) {
          return propValue.every(isNode);
        }
        if (propValue === null || isValidElement(propValue)) {
          return true;
        }

        var iteratorFn = getIteratorFn(propValue);
        if (iteratorFn) {
          var iterator = iteratorFn.call(propValue);
          var step;
          if (iteratorFn !== propValue.entries) {
            while (!(step = iterator.next()).done) {
              if (!isNode(step.value)) {
                return false;
              }
            }
          } else {
            // Iterator will provide entry [k,v] tuples rather than values.
            while (!(step = iterator.next()).done) {
              var entry = step.value;
              if (entry) {
                if (!isNode(entry[1])) {
                  return false;
                }
              }
            }
          }
        } else {
          return false;
        }

        return true;
      default:
        return false;
    }
  }

  function isSymbol(propType, propValue) {
    // Native Symbol.
    if (propType === 'symbol') {
      return true;
    }

    // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
    if (propValue['@@toStringTag'] === 'Symbol') {
      return true;
    }

    // Fallback for non-spec compliant Symbols which are polyfilled.
    if (typeof Symbol === 'function' && propValue instanceof Symbol) {
      return true;
    }

    return false;
  }

  // Equivalent of `typeof` but with special handling for array and regexp.
  function getPropType(propValue) {
    var propType = typeof propValue;
    if (Array.isArray(propValue)) {
      return 'array';
    }
    if (propValue instanceof RegExp) {
      // Old webkits (at least until Android 4.0) return 'function' rather than
      // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
      // passes PropTypes.object.
      return 'object';
    }
    if (isSymbol(propType, propValue)) {
      return 'symbol';
    }
    return propType;
  }

  // This handles more types than `getPropType`. Only used for error messages.
  // See `createPrimitiveTypeChecker`.
  function getPreciseType(propValue) {
    if (typeof propValue === 'undefined' || propValue === null) {
      return '' + propValue;
    }
    var propType = getPropType(propValue);
    if (propType === 'object') {
      if (propValue instanceof Date) {
        return 'date';
      } else if (propValue instanceof RegExp) {
        return 'regexp';
      }
    }
    return propType;
  }

  // Returns a string that is postfixed to a warning about an invalid type.
  // For example, "undefined" or "of type array"
  function getPostfixForTypeWarning(value) {
    var type = getPreciseType(value);
    switch (type) {
      case 'array':
      case 'object':
        return 'an ' + type;
      case 'boolean':
      case 'date':
      case 'regexp':
        return 'a ' + type;
      default:
        return type;
    }
  }

  // Returns class name of the object, if any.
  function getClassName(propValue) {
    if (!propValue.constructor || !propValue.constructor.name) {
      return ANONYMOUS;
    }
    return propValue.constructor.name;
  }

  ReactPropTypes.checkPropTypes = checkPropTypes;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 353 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



if (false) {
  var invariant = require('fbjs/lib/invariant');
  var warning = require('fbjs/lib/warning');
  var ReactPropTypesSecret = require('./lib/ReactPropTypesSecret');
  var loggedTypeFailures = {};
}

/**
 * Assert that the values match with the type specs.
 * Error messages are memorized and will only be shown once.
 *
 * @param {object} typeSpecs Map of name to a ReactPropType
 * @param {object} values Runtime values that need to be type-checked
 * @param {string} location e.g. "prop", "context", "child context"
 * @param {string} componentName Name of the component for error messages.
 * @param {?Function} getStack Returns the component stack.
 * @private
 */
function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
  if (false) {
    for (var typeSpecName in typeSpecs) {
      if (typeSpecs.hasOwnProperty(typeSpecName)) {
        var error;
        // Prop type validation may throw. In case they do, we don't want to
        // fail the render phase where it didn't fail before. So we log it.
        // After these have been cleaned up, we'll let them throw.
        try {
          // This is intentionally an invariant that gets caught. It's the same
          // behavior as without this statement except with a better message.
          invariant(typeof typeSpecs[typeSpecName] === 'function', '%s: %s type `%s` is invalid; it must be a function, usually from ' + 'the `prop-types` package, but received `%s`.', componentName || 'React class', location, typeSpecName, typeof typeSpecs[typeSpecName]);
          error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret);
        } catch (ex) {
          error = ex;
        }
        warning(!error || error instanceof Error, '%s: type specification of %s `%s` is invalid; the type checker ' + 'function must return `null` or an `Error` but returned a %s. ' + 'You may have forgotten to pass an argument to the type checker ' + 'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' + 'shape all require an argument).', componentName || 'React class', location, typeSpecName, typeof error);
        if (error instanceof Error && !(error.message in loggedTypeFailures)) {
          // Only monitor this failure once because there tends to be a lot of the
          // same error.
          loggedTypeFailures[error.message] = true;

          var stack = getStack ? getStack() : '';

          warning(false, 'Failed %s type: %s%s', location, error.message, stack != null ? stack : '');
        }
      }
    }
  }
}

module.exports = checkPropTypes;


/***/ }),
/* 354 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



module.exports = '15.6.2';

/***/ }),
/* 355 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _require = __webpack_require__(157),
    Component = _require.Component;

var _require2 = __webpack_require__(39),
    isValidElement = _require2.isValidElement;

var ReactNoopUpdateQueue = __webpack_require__(158);
var factory = __webpack_require__(356);

module.exports = factory(Component, isValidElement, ReactNoopUpdateQueue);

/***/ }),
/* 356 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _assign = __webpack_require__(24);

var emptyObject = __webpack_require__(54);
var _invariant = __webpack_require__(22);

if (false) {
  var warning = require('fbjs/lib/warning');
}

var MIXINS_KEY = 'mixins';

// Helper function to allow the creation of anonymous functions which do not
// have .name set to the name of the variable being assigned to.
function identity(fn) {
  return fn;
}

var ReactPropTypeLocationNames;
if (false) {
  ReactPropTypeLocationNames = {
    prop: 'prop',
    context: 'context',
    childContext: 'child context'
  };
} else {
  ReactPropTypeLocationNames = {};
}

function factory(ReactComponent, isValidElement, ReactNoopUpdateQueue) {
  /**
   * Policies that describe methods in `ReactClassInterface`.
   */

  var injectedMixins = [];

  /**
   * Composite components are higher-level components that compose other composite
   * or host components.
   *
   * To create a new type of `ReactClass`, pass a specification of
   * your new class to `React.createClass`. The only requirement of your class
   * specification is that you implement a `render` method.
   *
   *   var MyComponent = React.createClass({
   *     render: function() {
   *       return <div>Hello World</div>;
   *     }
   *   });
   *
   * The class specification supports a specific protocol of methods that have
   * special meaning (e.g. `render`). See `ReactClassInterface` for
   * more the comprehensive protocol. Any other properties and methods in the
   * class specification will be available on the prototype.
   *
   * @interface ReactClassInterface
   * @internal
   */
  var ReactClassInterface = {
    /**
     * An array of Mixin objects to include when defining your component.
     *
     * @type {array}
     * @optional
     */
    mixins: 'DEFINE_MANY',

    /**
     * An object containing properties and methods that should be defined on
     * the component's constructor instead of its prototype (static methods).
     *
     * @type {object}
     * @optional
     */
    statics: 'DEFINE_MANY',

    /**
     * Definition of prop types for this component.
     *
     * @type {object}
     * @optional
     */
    propTypes: 'DEFINE_MANY',

    /**
     * Definition of context types for this component.
     *
     * @type {object}
     * @optional
     */
    contextTypes: 'DEFINE_MANY',

    /**
     * Definition of context types this component sets for its children.
     *
     * @type {object}
     * @optional
     */
    childContextTypes: 'DEFINE_MANY',

    // ==== Definition methods ====

    /**
     * Invoked when the component is mounted. Values in the mapping will be set on
     * `this.props` if that prop is not specified (i.e. using an `in` check).
     *
     * This method is invoked before `getInitialState` and therefore cannot rely
     * on `this.state` or use `this.setState`.
     *
     * @return {object}
     * @optional
     */
    getDefaultProps: 'DEFINE_MANY_MERGED',

    /**
     * Invoked once before the component is mounted. The return value will be used
     * as the initial value of `this.state`.
     *
     *   getInitialState: function() {
     *     return {
     *       isOn: false,
     *       fooBaz: new BazFoo()
     *     }
     *   }
     *
     * @return {object}
     * @optional
     */
    getInitialState: 'DEFINE_MANY_MERGED',

    /**
     * @return {object}
     * @optional
     */
    getChildContext: 'DEFINE_MANY_MERGED',

    /**
     * Uses props from `this.props` and state from `this.state` to render the
     * structure of the component.
     *
     * No guarantees are made about when or how often this method is invoked, so
     * it must not have side effects.
     *
     *   render: function() {
     *     var name = this.props.name;
     *     return <div>Hello, {name}!</div>;
     *   }
     *
     * @return {ReactComponent}
     * @required
     */
    render: 'DEFINE_ONCE',

    // ==== Delegate methods ====

    /**
     * Invoked when the component is initially created and about to be mounted.
     * This may have side effects, but any external subscriptions or data created
     * by this method must be cleaned up in `componentWillUnmount`.
     *
     * @optional
     */
    componentWillMount: 'DEFINE_MANY',

    /**
     * Invoked when the component has been mounted and has a DOM representation.
     * However, there is no guarantee that the DOM node is in the document.
     *
     * Use this as an opportunity to operate on the DOM when the component has
     * been mounted (initialized and rendered) for the first time.
     *
     * @param {DOMElement} rootNode DOM element representing the component.
     * @optional
     */
    componentDidMount: 'DEFINE_MANY',

    /**
     * Invoked before the component receives new props.
     *
     * Use this as an opportunity to react to a prop transition by updating the
     * state using `this.setState`. Current props are accessed via `this.props`.
     *
     *   componentWillReceiveProps: function(nextProps, nextContext) {
     *     this.setState({
     *       likesIncreasing: nextProps.likeCount > this.props.likeCount
     *     });
     *   }
     *
     * NOTE: There is no equivalent `componentWillReceiveState`. An incoming prop
     * transition may cause a state change, but the opposite is not true. If you
     * need it, you are probably looking for `componentWillUpdate`.
     *
     * @param {object} nextProps
     * @optional
     */
    componentWillReceiveProps: 'DEFINE_MANY',

    /**
     * Invoked while deciding if the component should be updated as a result of
     * receiving new props, state and/or context.
     *
     * Use this as an opportunity to `return false` when you're certain that the
     * transition to the new props/state/context will not require a component
     * update.
     *
     *   shouldComponentUpdate: function(nextProps, nextState, nextContext) {
     *     return !equal(nextProps, this.props) ||
     *       !equal(nextState, this.state) ||
     *       !equal(nextContext, this.context);
     *   }
     *
     * @param {object} nextProps
     * @param {?object} nextState
     * @param {?object} nextContext
     * @return {boolean} True if the component should update.
     * @optional
     */
    shouldComponentUpdate: 'DEFINE_ONCE',

    /**
     * Invoked when the component is about to update due to a transition from
     * `this.props`, `this.state` and `this.context` to `nextProps`, `nextState`
     * and `nextContext`.
     *
     * Use this as an opportunity to perform preparation before an update occurs.
     *
     * NOTE: You **cannot** use `this.setState()` in this method.
     *
     * @param {object} nextProps
     * @param {?object} nextState
     * @param {?object} nextContext
     * @param {ReactReconcileTransaction} transaction
     * @optional
     */
    componentWillUpdate: 'DEFINE_MANY',

    /**
     * Invoked when the component's DOM representation has been updated.
     *
     * Use this as an opportunity to operate on the DOM when the component has
     * been updated.
     *
     * @param {object} prevProps
     * @param {?object} prevState
     * @param {?object} prevContext
     * @param {DOMElement} rootNode DOM element representing the component.
     * @optional
     */
    componentDidUpdate: 'DEFINE_MANY',

    /**
     * Invoked when the component is about to be removed from its parent and have
     * its DOM representation destroyed.
     *
     * Use this as an opportunity to deallocate any external resources.
     *
     * NOTE: There is no `componentDidUnmount` since your component will have been
     * destroyed by that point.
     *
     * @optional
     */
    componentWillUnmount: 'DEFINE_MANY',

    // ==== Advanced methods ====

    /**
     * Updates the component's currently mounted DOM representation.
     *
     * By default, this implements React's rendering and reconciliation algorithm.
     * Sophisticated clients may wish to override this.
     *
     * @param {ReactReconcileTransaction} transaction
     * @internal
     * @overridable
     */
    updateComponent: 'OVERRIDE_BASE'
  };

  /**
   * Mapping from class specification keys to special processing functions.
   *
   * Although these are declared like instance properties in the specification
   * when defining classes using `React.createClass`, they are actually static
   * and are accessible on the constructor instead of the prototype. Despite
   * being static, they must be defined outside of the "statics" key under
   * which all other static methods are defined.
   */
  var RESERVED_SPEC_KEYS = {
    displayName: function(Constructor, displayName) {
      Constructor.displayName = displayName;
    },
    mixins: function(Constructor, mixins) {
      if (mixins) {
        for (var i = 0; i < mixins.length; i++) {
          mixSpecIntoComponent(Constructor, mixins[i]);
        }
      }
    },
    childContextTypes: function(Constructor, childContextTypes) {
      if (false) {
        validateTypeDef(Constructor, childContextTypes, 'childContext');
      }
      Constructor.childContextTypes = _assign(
        {},
        Constructor.childContextTypes,
        childContextTypes
      );
    },
    contextTypes: function(Constructor, contextTypes) {
      if (false) {
        validateTypeDef(Constructor, contextTypes, 'context');
      }
      Constructor.contextTypes = _assign(
        {},
        Constructor.contextTypes,
        contextTypes
      );
    },
    /**
     * Special case getDefaultProps which should move into statics but requires
     * automatic merging.
     */
    getDefaultProps: function(Constructor, getDefaultProps) {
      if (Constructor.getDefaultProps) {
        Constructor.getDefaultProps = createMergedResultFunction(
          Constructor.getDefaultProps,
          getDefaultProps
        );
      } else {
        Constructor.getDefaultProps = getDefaultProps;
      }
    },
    propTypes: function(Constructor, propTypes) {
      if (false) {
        validateTypeDef(Constructor, propTypes, 'prop');
      }
      Constructor.propTypes = _assign({}, Constructor.propTypes, propTypes);
    },
    statics: function(Constructor, statics) {
      mixStaticSpecIntoComponent(Constructor, statics);
    },
    autobind: function() {}
  };

  function validateTypeDef(Constructor, typeDef, location) {
    for (var propName in typeDef) {
      if (typeDef.hasOwnProperty(propName)) {
        // use a warning instead of an _invariant so components
        // don't show up in prod but only in __DEV__
        if (false) {
          warning(
            typeof typeDef[propName] === 'function',
            '%s: %s type `%s` is invalid; it must be a function, usually from ' +
              'React.PropTypes.',
            Constructor.displayName || 'ReactClass',
            ReactPropTypeLocationNames[location],
            propName
          );
        }
      }
    }
  }

  function validateMethodOverride(isAlreadyDefined, name) {
    var specPolicy = ReactClassInterface.hasOwnProperty(name)
      ? ReactClassInterface[name]
      : null;

    // Disallow overriding of base class methods unless explicitly allowed.
    if (ReactClassMixin.hasOwnProperty(name)) {
      _invariant(
        specPolicy === 'OVERRIDE_BASE',
        'ReactClassInterface: You are attempting to override ' +
          '`%s` from your class specification. Ensure that your method names ' +
          'do not overlap with React methods.',
        name
      );
    }

    // Disallow defining methods more than once unless explicitly allowed.
    if (isAlreadyDefined) {
      _invariant(
        specPolicy === 'DEFINE_MANY' || specPolicy === 'DEFINE_MANY_MERGED',
        'ReactClassInterface: You are attempting to define ' +
          '`%s` on your component more than once. This conflict may be due ' +
          'to a mixin.',
        name
      );
    }
  }

  /**
   * Mixin helper which handles policy validation and reserved
   * specification keys when building React classes.
   */
  function mixSpecIntoComponent(Constructor, spec) {
    if (!spec) {
      if (false) {
        var typeofSpec = typeof spec;
        var isMixinValid = typeofSpec === 'object' && spec !== null;

        if (process.env.NODE_ENV !== 'production') {
          warning(
            isMixinValid,
            "%s: You're attempting to include a mixin that is either null " +
              'or not an object. Check the mixins included by the component, ' +
              'as well as any mixins they include themselves. ' +
              'Expected object but got %s.',
            Constructor.displayName || 'ReactClass',
            spec === null ? null : typeofSpec
          );
        }
      }

      return;
    }

    _invariant(
      typeof spec !== 'function',
      "ReactClass: You're attempting to " +
        'use a component class or function as a mixin. Instead, just use a ' +
        'regular object.'
    );
    _invariant(
      !isValidElement(spec),
      "ReactClass: You're attempting to " +
        'use a component as a mixin. Instead, just use a regular object.'
    );

    var proto = Constructor.prototype;
    var autoBindPairs = proto.__reactAutoBindPairs;

    // By handling mixins before any other properties, we ensure the same
    // chaining order is applied to methods with DEFINE_MANY policy, whether
    // mixins are listed before or after these methods in the spec.
    if (spec.hasOwnProperty(MIXINS_KEY)) {
      RESERVED_SPEC_KEYS.mixins(Constructor, spec.mixins);
    }

    for (var name in spec) {
      if (!spec.hasOwnProperty(name)) {
        continue;
      }

      if (name === MIXINS_KEY) {
        // We have already handled mixins in a special case above.
        continue;
      }

      var property = spec[name];
      var isAlreadyDefined = proto.hasOwnProperty(name);
      validateMethodOverride(isAlreadyDefined, name);

      if (RESERVED_SPEC_KEYS.hasOwnProperty(name)) {
        RESERVED_SPEC_KEYS[name](Constructor, property);
      } else {
        // Setup methods on prototype:
        // The following member methods should not be automatically bound:
        // 1. Expected ReactClass methods (in the "interface").
        // 2. Overridden methods (that were mixed in).
        var isReactClassMethod = ReactClassInterface.hasOwnProperty(name);
        var isFunction = typeof property === 'function';
        var shouldAutoBind =
          isFunction &&
          !isReactClassMethod &&
          !isAlreadyDefined &&
          spec.autobind !== false;

        if (shouldAutoBind) {
          autoBindPairs.push(name, property);
          proto[name] = property;
        } else {
          if (isAlreadyDefined) {
            var specPolicy = ReactClassInterface[name];

            // These cases should already be caught by validateMethodOverride.
            _invariant(
              isReactClassMethod &&
                (specPolicy === 'DEFINE_MANY_MERGED' ||
                  specPolicy === 'DEFINE_MANY'),
              'ReactClass: Unexpected spec policy %s for key %s ' +
                'when mixing in component specs.',
              specPolicy,
              name
            );

            // For methods which are defined more than once, call the existing
            // methods before calling the new property, merging if appropriate.
            if (specPolicy === 'DEFINE_MANY_MERGED') {
              proto[name] = createMergedResultFunction(proto[name], property);
            } else if (specPolicy === 'DEFINE_MANY') {
              proto[name] = createChainedFunction(proto[name], property);
            }
          } else {
            proto[name] = property;
            if (false) {
              // Add verbose displayName to the function, which helps when looking
              // at profiling tools.
              if (typeof property === 'function' && spec.displayName) {
                proto[name].displayName = spec.displayName + '_' + name;
              }
            }
          }
        }
      }
    }
  }

  function mixStaticSpecIntoComponent(Constructor, statics) {
    if (!statics) {
      return;
    }
    for (var name in statics) {
      var property = statics[name];
      if (!statics.hasOwnProperty(name)) {
        continue;
      }

      var isReserved = name in RESERVED_SPEC_KEYS;
      _invariant(
        !isReserved,
        'ReactClass: You are attempting to define a reserved ' +
          'property, `%s`, that shouldn\'t be on the "statics" key. Define it ' +
          'as an instance property instead; it will still be accessible on the ' +
          'constructor.',
        name
      );

      var isInherited = name in Constructor;
      _invariant(
        !isInherited,
        'ReactClass: You are attempting to define ' +
          '`%s` on your component more than once. This conflict may be ' +
          'due to a mixin.',
        name
      );
      Constructor[name] = property;
    }
  }

  /**
   * Merge two objects, but throw if both contain the same key.
   *
   * @param {object} one The first object, which is mutated.
   * @param {object} two The second object
   * @return {object} one after it has been mutated to contain everything in two.
   */
  function mergeIntoWithNoDuplicateKeys(one, two) {
    _invariant(
      one && two && typeof one === 'object' && typeof two === 'object',
      'mergeIntoWithNoDuplicateKeys(): Cannot merge non-objects.'
    );

    for (var key in two) {
      if (two.hasOwnProperty(key)) {
        _invariant(
          one[key] === undefined,
          'mergeIntoWithNoDuplicateKeys(): ' +
            'Tried to merge two objects with the same key: `%s`. This conflict ' +
            'may be due to a mixin; in particular, this may be caused by two ' +
            'getInitialState() or getDefaultProps() methods returning objects ' +
            'with clashing keys.',
          key
        );
        one[key] = two[key];
      }
    }
    return one;
  }

  /**
   * Creates a function that invokes two functions and merges their return values.
   *
   * @param {function} one Function to invoke first.
   * @param {function} two Function to invoke second.
   * @return {function} Function that invokes the two argument functions.
   * @private
   */
  function createMergedResultFunction(one, two) {
    return function mergedResult() {
      var a = one.apply(this, arguments);
      var b = two.apply(this, arguments);
      if (a == null) {
        return b;
      } else if (b == null) {
        return a;
      }
      var c = {};
      mergeIntoWithNoDuplicateKeys(c, a);
      mergeIntoWithNoDuplicateKeys(c, b);
      return c;
    };
  }

  /**
   * Creates a function that invokes two functions and ignores their return vales.
   *
   * @param {function} one Function to invoke first.
   * @param {function} two Function to invoke second.
   * @return {function} Function that invokes the two argument functions.
   * @private
   */
  function createChainedFunction(one, two) {
    return function chainedFunction() {
      one.apply(this, arguments);
      two.apply(this, arguments);
    };
  }

  /**
   * Binds a method to the component.
   *
   * @param {object} component Component whose method is going to be bound.
   * @param {function} method Method to be bound.
   * @return {function} The bound method.
   */
  function bindAutoBindMethod(component, method) {
    var boundMethod = method.bind(component);
    if (false) {
      boundMethod.__reactBoundContext = component;
      boundMethod.__reactBoundMethod = method;
      boundMethod.__reactBoundArguments = null;
      var componentName = component.constructor.displayName;
      var _bind = boundMethod.bind;
      boundMethod.bind = function(newThis) {
        for (
          var _len = arguments.length,
            args = Array(_len > 1 ? _len - 1 : 0),
            _key = 1;
          _key < _len;
          _key++
        ) {
          args[_key - 1] = arguments[_key];
        }

        // User is trying to bind() an autobound method; we effectively will
        // ignore the value of "this" that the user is trying to use, so
        // let's warn.
        if (newThis !== component && newThis !== null) {
          if (process.env.NODE_ENV !== 'production') {
            warning(
              false,
              'bind(): React component methods may only be bound to the ' +
                'component instance. See %s',
              componentName
            );
          }
        } else if (!args.length) {
          if (process.env.NODE_ENV !== 'production') {
            warning(
              false,
              'bind(): You are binding a component method to the component. ' +
                'React does this for you automatically in a high-performance ' +
                'way, so you can safely remove this call. See %s',
              componentName
            );
          }
          return boundMethod;
        }
        var reboundMethod = _bind.apply(boundMethod, arguments);
        reboundMethod.__reactBoundContext = component;
        reboundMethod.__reactBoundMethod = method;
        reboundMethod.__reactBoundArguments = args;
        return reboundMethod;
      };
    }
    return boundMethod;
  }

  /**
   * Binds all auto-bound methods in a component.
   *
   * @param {object} component Component whose method is going to be bound.
   */
  function bindAutoBindMethods(component) {
    var pairs = component.__reactAutoBindPairs;
    for (var i = 0; i < pairs.length; i += 2) {
      var autoBindKey = pairs[i];
      var method = pairs[i + 1];
      component[autoBindKey] = bindAutoBindMethod(component, method);
    }
  }

  var IsMountedPreMixin = {
    componentDidMount: function() {
      this.__isMounted = true;
    }
  };

  var IsMountedPostMixin = {
    componentWillUnmount: function() {
      this.__isMounted = false;
    }
  };

  /**
   * Add more to the ReactClass base class. These are all legacy features and
   * therefore not already part of the modern ReactComponent.
   */
  var ReactClassMixin = {
    /**
     * TODO: This will be deprecated because state should always keep a consistent
     * type signature and the only use case for this, is to avoid that.
     */
    replaceState: function(newState, callback) {
      this.updater.enqueueReplaceState(this, newState, callback);
    },

    /**
     * Checks whether or not this composite component is mounted.
     * @return {boolean} True if mounted, false otherwise.
     * @protected
     * @final
     */
    isMounted: function() {
      if (false) {
        warning(
          this.__didWarnIsMounted,
          '%s: isMounted is deprecated. Instead, make sure to clean up ' +
            'subscriptions and pending requests in componentWillUnmount to ' +
            'prevent memory leaks.',
          (this.constructor && this.constructor.displayName) ||
            this.name ||
            'Component'
        );
        this.__didWarnIsMounted = true;
      }
      return !!this.__isMounted;
    }
  };

  var ReactClassComponent = function() {};
  _assign(
    ReactClassComponent.prototype,
    ReactComponent.prototype,
    ReactClassMixin
  );

  /**
   * Creates a composite component class given a class specification.
   * See https://facebook.github.io/react/docs/top-level-api.html#react.createclass
   *
   * @param {object} spec Class specification (which must define `render`).
   * @return {function} Component constructor function.
   * @public
   */
  function createClass(spec) {
    // To keep our warnings more understandable, we'll use a little hack here to
    // ensure that Constructor.name !== 'Constructor'. This makes sure we don't
    // unnecessarily identify a class without displayName as 'Constructor'.
    var Constructor = identity(function(props, context, updater) {
      // This constructor gets overridden by mocks. The argument is used
      // by mocks to assert on what gets mounted.

      if (false) {
        warning(
          this instanceof Constructor,
          'Something is calling a React component directly. Use a factory or ' +
            'JSX instead. See: https://fb.me/react-legacyfactory'
        );
      }

      // Wire up auto-binding
      if (this.__reactAutoBindPairs.length) {
        bindAutoBindMethods(this);
      }

      this.props = props;
      this.context = context;
      this.refs = emptyObject;
      this.updater = updater || ReactNoopUpdateQueue;

      this.state = null;

      // ReactClasses doesn't have constructors. Instead, they use the
      // getInitialState and componentWillMount methods for initialization.

      var initialState = this.getInitialState ? this.getInitialState() : null;
      if (false) {
        // We allow auto-mocks to proceed as if they're returning null.
        if (
          initialState === undefined &&
          this.getInitialState._isMockFunction
        ) {
          // This is probably bad practice. Consider warning here and
          // deprecating this convenience.
          initialState = null;
        }
      }
      _invariant(
        typeof initialState === 'object' && !Array.isArray(initialState),
        '%s.getInitialState(): must return an object or null',
        Constructor.displayName || 'ReactCompositeComponent'
      );

      this.state = initialState;
    });
    Constructor.prototype = new ReactClassComponent();
    Constructor.prototype.constructor = Constructor;
    Constructor.prototype.__reactAutoBindPairs = [];

    injectedMixins.forEach(mixSpecIntoComponent.bind(null, Constructor));

    mixSpecIntoComponent(Constructor, IsMountedPreMixin);
    mixSpecIntoComponent(Constructor, spec);
    mixSpecIntoComponent(Constructor, IsMountedPostMixin);

    // Initialize the defaultProps property after all mixins have been merged.
    if (Constructor.getDefaultProps) {
      Constructor.defaultProps = Constructor.getDefaultProps();
    }

    if (false) {
      // This is a tag to indicate that the use of these method names is ok,
      // since it's used with createClass. If it's not, then it's likely a
      // mistake so we'll warn you to use the static property, property
      // initializer or constructor respectively.
      if (Constructor.getDefaultProps) {
        Constructor.getDefaultProps.isReactClassApproved = {};
      }
      if (Constructor.prototype.getInitialState) {
        Constructor.prototype.getInitialState.isReactClassApproved = {};
      }
    }

    _invariant(
      Constructor.prototype.render,
      'createClass(...): Class specification must implement a `render` method.'
    );

    if (false) {
      warning(
        !Constructor.prototype.componentShouldUpdate,
        '%s has a method called ' +
          'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' +
          'The name is phrased as a question because the function is ' +
          'expected to return a value.',
        spec.displayName || 'A component'
      );
      warning(
        !Constructor.prototype.componentWillRecieveProps,
        '%s has a method called ' +
          'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?',
        spec.displayName || 'A component'
      );
    }

    // Reduce time spent doing lookups by setting these on the prototype.
    for (var methodName in ReactClassInterface) {
      if (!Constructor.prototype[methodName]) {
        Constructor.prototype[methodName] = null;
      }
    }

    return Constructor;
  }

  return createClass;
}

module.exports = factory;


/***/ }),
/* 357 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */


var _prodInvariant = __webpack_require__(69);

var ReactElement = __webpack_require__(39);

var invariant = __webpack_require__(22);

/**
 * Returns the first child in a collection of children and verifies that there
 * is only one child in the collection.
 *
 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.only
 *
 * The current implementation of this function assumes that a single child gets
 * passed without a wrapper, but the purpose of this helper function is to
 * abstract away the particular structure of children.
 *
 * @param {?object} children Child collection structure.
 * @return {ReactElement} The first and only `ReactElement` contained in the
 * structure.
 */
function onlyChild(children) {
  !ReactElement.isValidElement(children) ?  false ? invariant(false, 'React.Children.only expected to receive a single React element child.') : _prodInvariant('143') : void 0;
  return children;
}

module.exports = onlyChild;

/***/ }),
/* 358 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 359 */
/***/ (function(module, exports, __webpack_require__) {


/**
 * This is the common logic for both the Node.js and web browser
 * implementations of `debug()`.
 *
 * Expose `debug()` as the module.
 */

exports = module.exports = createDebug.debug = createDebug['default'] = createDebug;
exports.coerce = coerce;
exports.disable = disable;
exports.enable = enable;
exports.enabled = enabled;
exports.humanize = __webpack_require__(360);

/**
 * The currently active debug mode names, and names to skip.
 */

exports.names = [];
exports.skips = [];

/**
 * Map of special "%n" handling functions, for the debug "format" argument.
 *
 * Valid key names are a single, lower or upper-case letter, i.e. "n" and "N".
 */

exports.formatters = {};

/**
 * Previous log timestamp.
 */

var prevTime;

/**
 * Select a color.
 * @param {String} namespace
 * @return {Number}
 * @api private
 */

function selectColor(namespace) {
  var hash = 0, i;

  for (i in namespace) {
    hash  = ((hash << 5) - hash) + namespace.charCodeAt(i);
    hash |= 0; // Convert to 32bit integer
  }

  return exports.colors[Math.abs(hash) % exports.colors.length];
}

/**
 * Create a debugger with the given `namespace`.
 *
 * @param {String} namespace
 * @return {Function}
 * @api public
 */

function createDebug(namespace) {

  function debug() {
    // disabled?
    if (!debug.enabled) return;

    var self = debug;

    // set `diff` timestamp
    var curr = +new Date();
    var ms = curr - (prevTime || curr);
    self.diff = ms;
    self.prev = prevTime;
    self.curr = curr;
    prevTime = curr;

    // turn the `arguments` into a proper Array
    var args = new Array(arguments.length);
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }

    args[0] = exports.coerce(args[0]);

    if ('string' !== typeof args[0]) {
      // anything else let's inspect with %O
      args.unshift('%O');
    }

    // apply any `formatters` transformations
    var index = 0;
    args[0] = args[0].replace(/%([a-zA-Z%])/g, function(match, format) {
      // if we encounter an escaped % then don't increase the array index
      if (match === '%%') return match;
      index++;
      var formatter = exports.formatters[format];
      if ('function' === typeof formatter) {
        var val = args[index];
        match = formatter.call(self, val);

        // now we need to remove `args[index]` since it's inlined in the `format`
        args.splice(index, 1);
        index--;
      }
      return match;
    });

    // apply env-specific formatting (colors, etc.)
    exports.formatArgs.call(self, args);

    var logFn = debug.log || exports.log || console.log.bind(console);
    logFn.apply(self, args);
  }

  debug.namespace = namespace;
  debug.enabled = exports.enabled(namespace);
  debug.useColors = exports.useColors();
  debug.color = selectColor(namespace);

  // env-specific initialization logic for debug instances
  if ('function' === typeof exports.init) {
    exports.init(debug);
  }

  return debug;
}

/**
 * Enables a debug mode by namespaces. This can include modes
 * separated by a colon and wildcards.
 *
 * @param {String} namespaces
 * @api public
 */

function enable(namespaces) {
  exports.save(namespaces);

  exports.names = [];
  exports.skips = [];

  var split = (typeof namespaces === 'string' ? namespaces : '').split(/[\s,]+/);
  var len = split.length;

  for (var i = 0; i < len; i++) {
    if (!split[i]) continue; // ignore empty strings
    namespaces = split[i].replace(/\*/g, '.*?');
    if (namespaces[0] === '-') {
      exports.skips.push(new RegExp('^' + namespaces.substr(1) + '$'));
    } else {
      exports.names.push(new RegExp('^' + namespaces + '$'));
    }
  }
}

/**
 * Disable debug output.
 *
 * @api public
 */

function disable() {
  exports.enable('');
}

/**
 * Returns true if the given mode name is enabled, false otherwise.
 *
 * @param {String} name
 * @return {Boolean}
 * @api public
 */

function enabled(name) {
  var i, len;
  for (i = 0, len = exports.skips.length; i < len; i++) {
    if (exports.skips[i].test(name)) {
      return false;
    }
  }
  for (i = 0, len = exports.names.length; i < len; i++) {
    if (exports.names[i].test(name)) {
      return true;
    }
  }
  return false;
}

/**
 * Coerce `val`.
 *
 * @param {Mixed} val
 * @return {Mixed}
 * @api private
 */

function coerce(val) {
  if (val instanceof Error) return val.stack || val.message;
  return val;
}


/***/ }),
/* 360 */
/***/ (function(module, exports) {

/**
 * Helpers.
 */

var s = 1000;
var m = s * 60;
var h = m * 60;
var d = h * 24;
var y = d * 365.25;

/**
 * Parse or format the given `val`.
 *
 * Options:
 *
 *  - `long` verbose formatting [false]
 *
 * @param {String|Number} val
 * @param {Object} [options]
 * @throws {Error} throw an error if val is not a non-empty string or a number
 * @return {String|Number}
 * @api public
 */

module.exports = function(val, options) {
  options = options || {};
  var type = typeof val;
  if (type === 'string' && val.length > 0) {
    return parse(val);
  } else if (type === 'number' && isNaN(val) === false) {
    return options.long ? fmtLong(val) : fmtShort(val);
  }
  throw new Error(
    'val is not a non-empty string or a valid number. val=' +
      JSON.stringify(val)
  );
};

/**
 * Parse the given `str` and return milliseconds.
 *
 * @param {String} str
 * @return {Number}
 * @api private
 */

function parse(str) {
  str = String(str);
  if (str.length > 100) {
    return;
  }
  var match = /^((?:\d+)?\.?\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|years?|yrs?|y)?$/i.exec(
    str
  );
  if (!match) {
    return;
  }
  var n = parseFloat(match[1]);
  var type = (match[2] || 'ms').toLowerCase();
  switch (type) {
    case 'years':
    case 'year':
    case 'yrs':
    case 'yr':
    case 'y':
      return n * y;
    case 'days':
    case 'day':
    case 'd':
      return n * d;
    case 'hours':
    case 'hour':
    case 'hrs':
    case 'hr':
    case 'h':
      return n * h;
    case 'minutes':
    case 'minute':
    case 'mins':
    case 'min':
    case 'm':
      return n * m;
    case 'seconds':
    case 'second':
    case 'secs':
    case 'sec':
    case 's':
      return n * s;
    case 'milliseconds':
    case 'millisecond':
    case 'msecs':
    case 'msec':
    case 'ms':
      return n;
    default:
      return undefined;
  }
}

/**
 * Short format for `ms`.
 *
 * @param {Number} ms
 * @return {String}
 * @api private
 */

function fmtShort(ms) {
  if (ms >= d) {
    return Math.round(ms / d) + 'd';
  }
  if (ms >= h) {
    return Math.round(ms / h) + 'h';
  }
  if (ms >= m) {
    return Math.round(ms / m) + 'm';
  }
  if (ms >= s) {
    return Math.round(ms / s) + 's';
  }
  return ms + 'ms';
}

/**
 * Long format for `ms`.
 *
 * @param {Number} ms
 * @return {String}
 * @api private
 */

function fmtLong(ms) {
  return plural(ms, d, 'day') ||
    plural(ms, h, 'hour') ||
    plural(ms, m, 'minute') ||
    plural(ms, s, 'second') ||
    ms + ' ms';
}

/**
 * Pluralization helper.
 */

function plural(ms, n, name) {
  if (ms < n) {
    return;
  }
  if (ms < n * 1.5) {
    return Math.floor(ms / n) + ' ' + name;
  }
  return Math.ceil(ms / n) + ' ' + name + 's';
}


/***/ }),
/* 361 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// Taken from http://there4development.com/blog/2012/05/02/google-chart-color-list/

module.exports = ['#3366CC', '#DC3912', '#FF9900', '#109618', '#990099', '#3B3EAC', '#0099C6', '#DD4477', '#66AA00', '#B82E2E', '#316395', '#994499', '#22AA99', '#AAAA11', '#6633CC', '#E67300', '#8B0707', '#329262', '#5574A6', '#3B3EAC'];

/***/ }),
/* 362 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _debug = __webpack_require__(162);

var _debug2 = _interopRequireDefault(_debug);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var debug = new _debug2.default('react-google-charts:GoogleChartLoader'); // GoogleChartLoader Singleton

// Based on http://blog.arkency.com/2014/09/react-dot-js-and-google-charts/

var script = typeof window !== 'undefined' ? __webpack_require__(363) : function (link, _ref) {
  var callback = _ref.success;
  return callback();
};

var googleChartLoader = {
  isLoaded: false,
  isLoading: false,
  initPromise: {},
  init: function init(packages, version) {
    var _this = this;

    debug('init', packages, version);
    if (this.isLoading || this.isLoaded) {
      return this.initPromise;
    }
    this.isLoading = true;
    this.initPromise = new Promise(function (resolve) {
      script('https://www.gstatic.com/charts/loader.js', { success: function success() {
          window.google.charts.load(version || 'current', { packages: packages || ['corechart'] });
          window.google.charts.setOnLoadCallback(function () {
            debug('Chart Loaded');
            _this.isLoaded = true;
            _this.isLoading = false;
            resolve();
          });
        } });
    });
    return this.initPromise;
  }
};

exports.default = googleChartLoader;
module.exports = exports['default'];

/***/ }),
/* 363 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(root, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports === 'object') {
    module.exports = factory();
  } else {
    root.loadjs = factory();
  }
}(this, function() {
/**
 * Global dependencies.
 * @global {Object} document - DOM
 */

var devnull = function() {},
    bundleIdCache = {},
    bundleResultCache = {},
    bundleCallbackQueue = {};


/**
 * Subscribe to bundle load event.
 * @param {string[]} bundleIds - Bundle ids
 * @param {Function} callbackFn - The callback function
 */
function subscribe(bundleIds, callbackFn) {
  // listify
  bundleIds = bundleIds.push ? bundleIds : [bundleIds];

  var depsNotFound = [],
      i = bundleIds.length,
      numWaiting = i,
      fn,
      bundleId,
      r,
      q;

  // define callback function
  fn = function (bundleId, pathsNotFound) {
    if (pathsNotFound.length) depsNotFound.push(bundleId);

    numWaiting--;
    if (!numWaiting) callbackFn(depsNotFound);
  };

  // register callback
  while (i--) {
    bundleId = bundleIds[i];

    // execute callback if in result cache
    r = bundleResultCache[bundleId];
    if (r) {
      fn(bundleId, r);
      continue;
    }

    // add to callback queue
    q = bundleCallbackQueue[bundleId] = bundleCallbackQueue[bundleId] || [];
    q.push(fn);
  }
}


/**
 * Publish bundle load event.
 * @param {string} bundleId - Bundle id
 * @param {string[]} pathsNotFound - List of files not found
 */
function publish(bundleId, pathsNotFound) {
  // exit if id isn't defined
  if (!bundleId) return;

  var q = bundleCallbackQueue[bundleId];

  // cache result
  bundleResultCache[bundleId] = pathsNotFound;

  // exit if queue is empty
  if (!q) return;

  // empty callback queue
  while (q.length) {
    q[0](bundleId, pathsNotFound);
    q.splice(0, 1);
  }
}


/**
 * Load individual file.
 * @param {string} path - The file path
 * @param {Function} callbackFn - The callback function
 */
function loadFile(path, callbackFn, args, numTries) {
  var doc = document,
      async = args.async,
      maxTries = (args.numRetries || 0) + 1,
      beforeCallbackFn = args.before || devnull,
      isCss,
      e;

  numTries = numTries || 0;

  if (/(^css!|\.css$)/.test(path)) {
    isCss = true;

    // css
    e = doc.createElement('link');
    e.rel = 'stylesheet';
    e.href = path.replace(/^css!/, '');  // remove "css!" prefix
  } else {
    // javascript
    e = doc.createElement('script');
    e.src = path;
    e.async = async === undefined ? true : async;
  }

  e.onload = e.onerror = e.onbeforeload = function (ev) {
    var result = ev.type[0];

    // Note: The following code isolates IE using `hideFocus` and treats empty
    // stylesheets as failures to get around lack of onerror support
    if (isCss && 'hideFocus' in e) {
      try {
        if (!e.sheet.cssText.length) result = 'e';
      } catch (x) {
        // sheets objects created from load errors don't allow access to
        // `cssText`
        result = 'e';
      }
    }

    // handle retries in case of load failure
    if (result == 'e') {
      // increment counter
      numTries += 1;

      // exit function and try again
      if (numTries < maxTries) {
        return loadFile(path, callbackFn, args, numTries);
      }
    }

    // execute callback
    callbackFn(path, result, ev.defaultPrevented);
  };

  // add to document (unless callback returns `false`)
  if (beforeCallbackFn(path, e) !== false) doc.head.appendChild(e);
}


/**
 * Load multiple files.
 * @param {string[]} paths - The file paths
 * @param {Function} callbackFn - The callback function
 */
function loadFiles(paths, callbackFn, args) {
  // listify paths
  paths = paths.push ? paths : [paths];

  var numWaiting = paths.length,
      x = numWaiting,
      pathsNotFound = [],
      fn,
      i;

  // define callback function
  fn = function(path, result, defaultPrevented) {
    // handle error
    if (result == 'e') pathsNotFound.push(path);

    // handle beforeload event. If defaultPrevented then that means the load
    // will be blocked (ex. Ghostery/ABP on Safari)
    if (result == 'b') {
      if (defaultPrevented) pathsNotFound.push(path);
      else return;
    }

    numWaiting--;
    if (!numWaiting) callbackFn(pathsNotFound);
  };

  // load scripts
  for (i=0; i < x; i++) loadFile(paths[i], fn, args);
}


/**
 * Initiate script load and register bundle.
 * @param {(string|string[])} paths - The file paths
 * @param {(string|Function)} [arg1] - The bundleId or success callback
 * @param {Function} [arg2] - The success or error callback
 * @param {Function} [arg3] - The error callback
 */
function loadjs(paths, arg1, arg2) {
  var bundleId,
      args;

  // bundleId (if string)
  if (arg1 && arg1.trim) bundleId = arg1;

  // args (default is {})
  args = (bundleId ? arg2 : arg1) || {};

  // throw error if bundle is already defined
  if (bundleId) {
    if (bundleId in bundleIdCache) {
      throw "LoadJS";
    } else {
      bundleIdCache[bundleId] = true;
    }
  }

  // load scripts
  loadFiles(paths, function (pathsNotFound) {
    // success and error callbacks
    if (pathsNotFound.length) (args.error || devnull)(pathsNotFound);
    else (args.success || devnull)();

    // publish bundle load event
    publish(bundleId, pathsNotFound);
  }, args);
}


/**
 * Execute callbacks when dependencies have been satisfied.
 * @param {(string|string[])} deps - List of bundle ids
 * @param {Object} args - success/error arguments
 */
loadjs.ready = function ready(deps, args) {
  // subscribe to bundle load event
  subscribe(deps, function (depsNotFound) {
    // execute callbacks
    if (depsNotFound.length) (args.error || devnull)(depsNotFound);
    else (args.success || devnull)();
  });

  return loadjs;
};


/**
 * Manually satisfy bundle dependencies.
 * @param {string} bundleId - The bundle id
 */
loadjs.done = function done(bundleId) {
  publish(bundleId, []);
};


/**
 * Reset loadjs dependencies statuses
 */
loadjs.reset = function reset() {
  bundleIdCache = {};
  bundleResultCache = {};
  bundleCallbackQueue = {};
};


/**
 * Determine if bundle has already been defined
 * @param String} bundleId - The bundle id
 */
loadjs.isDefined = function isDefined(bundleId) {
  return bundleId in bundleIdCache;
};


// export
return loadjs;

}));


/***/ }),
/* 364 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MessagePanel; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__ = __webpack_require__(13);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var MessagePanel=function(_Component){_inherits(MessagePanel,_Component);function MessagePanel(){_classCallCheck(this,MessagePanel);return _possibleConstructorReturn(this,(MessagePanel.__proto__||Object.getPrototypeOf(MessagePanel)).apply(this,arguments));}_createClass(MessagePanel,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ibox float-e-margins'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ibox-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5',null,'Messages')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ibox-content ibox-heading'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-envelope-o'}),' New messages'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('small',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-tim'}),' You have 22 new messages and 16 waiting in draft folder.')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ibox-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'feed-activity-list'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'feed-element'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('small',{className:'pull-right text-navy'},'1m ago'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'System Message'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'Driver Jose Gutierrez is 45 minutes ahead of schedule. Dropoff location notified and will try and unload early.'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'feed-element'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('small',{className:'pull-right'},'2m ago'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'Email:\xA0john.schwarz@insuranceco.com\xA0'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'Subject: I uploaded New Certificates of Insurance for Driver Margaret Johnson to NXXT'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'feed-element'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('small',{className:'pull-right'},'5m ago'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'System Message'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'Received updated Certificates of Insurance for Driver Margaret Johnson'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'feed-element'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('small',{className:'pull-right'},'5m ago'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'System Message'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'Due to traffic delay Driver John Braxton is within 95% of maximum allowable Driving Time for this period.'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'feed-element'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('small',{className:'pull-right'},'5m ago'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'Email: jshane@dmxproducts.com'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'Subject: Need to increase the insurance coverage on tomorrow\u2019s load.'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'feed-element'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('small',{className:'pull-right'},'5m ago'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'System Message'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'Load #36798, Apax Corp Completed, BOL and POD in System, Payment $784.34 by ACH Confirmed Tomorrow'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'feed-element'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('small',{className:'pull-right'},'5m ago'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'System Message'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'Load # 36793 value over insured limit. Contact Shipper DMX Products and increase coverage by $47,560.'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'feed-element'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('small',{className:'pull-right'},'5m ago'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'Chat with Joel at DMX Products'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'Hi Hillary, got a notification we need to update Insurance coverage. Will there be an additional charge?'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'feed-element'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('small',{className:'pull-right'},'5m ago'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'System Message'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'Severe Weather Alert: Blizzards in Detroit, MI area may impact Driver John Braxton Pickup # 36789'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'feed-element'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('small',{className:'pull-right'},'5m ago'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'System Message'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,' Load #36794 Delivery Completed, BOL & POD Uploaded. Payment received CargoCoins 229.4'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'feed-element'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('small',{className:'pull-right'},'5m ago'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'System Message'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,' Maintenance Alert: Driver Jose Gutierrez, Volvo D13 needs scheduled brake maintenance. RFQ Issued'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'feed-element'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('small',{className:'pull-right'},'5m ago'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'System Message'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,' Maintenance Quote: Driver Jose Gutierrez, Volvo D13 quote received for maintenance $389.99'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'feed-element'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('small',{className:'pull-right'},'5m ago'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'System Message'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,' Maintenance Quote: Driver Jose Gutierrez, Volvo D13 quote received for maintenance $410.00'))))));}}]);return MessagePanel;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/***/ }),
/* 365 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Login; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_toastr__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_toastr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_toastr__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Login=function(_Component){_inherits(Login,_Component);function Login(props){_classCallCheck(this,Login);var _this=_possibleConstructorReturn(this,(Login.__proto__||Object.getPrototypeOf(Login)).call(this,props));_this.moveAway=function(e){e.preventDefault();_this.props.history.push('/dashboard');};__WEBPACK_IMPORTED_MODULE_2_toastr___default.a.options.closeDuration=200;return _this;}_createClass(Login,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'middle-box text-center loginscreen animated fadeInDown'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h1',{className:'logo-name'},'NXXT')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,'Welcome to NXXT'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'MOVE FREIGHT WITH EASE'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Login in. To see it in action.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('form',{className:'m-t',role:'form',action:'index.html'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'email',className:'form-control',placeholder:'Username',required:''})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'password',className:'form-control',placeholder:'Password',required:''})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-danger full-width',onClick:this.moveAway},'Login'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('small',null,'Forgot password?')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'text-muted text-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('small',null,'Do not have an account?')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'btn btn-sm btn-white btn-block'},'Create an account')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'m-t'},' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('small',null,'all rights reserved'),' ')));}}]);return Login;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);;

/***/ }),
/* 366 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LogisticCreator; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_modal_shim__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_toastr__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_toastr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_toastr__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_HeaderBar_js__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_CollapsablePanel__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_MapCreatorPanel__ = __webpack_require__(371);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_ContactList__ = __webpack_require__(372);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var LogisticCreator=function(_Component){_inherits(LogisticCreator,_Component);function LogisticCreator(props){_classCallCheck(this,LogisticCreator);var _this=_possibleConstructorReturn(this,(LogisticCreator.__proto__||Object.getPrototypeOf(LogisticCreator)).call(this,props));_this.addRouteToList=function(){var _r=_this.state.route;_r._id=Math.round(Math.random()*100);_r.polyline.remove();_r.polyline=null;_r.from.marker.remove();_r.from.marker=null;_r.to.marker.remove();_r.to.marker=null;_r.from.name=_r.from.address;_r.to.name=_r.to.address;_this.props.onAddRoute(_r);__WEBPACK_IMPORTED_MODULE_3_toastr___default.a.info('You added route from '+_r.from.name+' to '+_r.to_name+' for Truk id: '+_r.truck);_r=_this.resetRoute();_this.setState({route:_r});};_this.resetRoute=function(){var _r={_id:'100',truck:'',from:{address:'',name:'',lat:0,lng:0},to:{company:'',address:'',name:'',lat:0,lng:0},startDate:new Date(),endDate:new Date(),km:0,revenue:0,selected:false,drive:0,duty:0,off:0,berth:0,time:0,fuel:0,tolls:0,vectorPath:[],polyline:null};return _r;};_this.closeAddressBook=function(){_this.setState({showModal:false});};_this.openAddressBook=function(){_this.setState({showModal:true});};_this.updateFromLocation=function(e){//console.log(e.target.value);
var _r=_this.state.route;_r.from.address=e.target.value;_this.setState({route:_r});};_this.updateToLocation=function(e){//console.log(e.target.value);
var _r=_this.state.route;_r.to.address=e.target.value;_this.setState({route:_r});};_this.updateFromCompany=function(e){//console.log(e.target.value);
var _r=_this.state.route;_r.from.name=e.target.value;_this.setState({route:_r});};_this.updateToCompany=function(e){//console.log(e.target.value);
var _r=_this.state.route;_r.to.name=e.target.value;_this.setState({route:_r});};_this.updateFromCoordinates=function(e){if(e.target.value.trim().length>0){//console.log("update from coordinates...");
fetch('https://api.mapbox.com/geocoding/v5/mapbox.places/'+e.target.value+'.json?access_token='+"pk.eyJ1IjoicmRzbGFiIiwiYSI6ImNqZXJjeDR1eDEwdHQzM280YmxobDR1d3IifQ.-kg4yiUEPenYfPVgUFdWPQ").then(function(response){return response.json();}).then(function(json){//console.log(json);
if(json.features.length>0){var _r=_this.state.route;_r.from.lat=json.features[0].center[1];_r.from.lng=json.features[0].center[0];_this.setState({route:_r});}else{//Nessun riscontro mapbox
__WEBPACK_IMPORTED_MODULE_3_toastr___default.a.error('Error during city location');}});}};_this.updateToCoordinates=function(e){if(e.target.value.trim().length>0){//console.log("update to coordinates...");
fetch('https://api.mapbox.com/geocoding/v5/mapbox.places/'+e.target.value+'.json?access_token='+"pk.eyJ1IjoicmRzbGFiIiwiYSI6ImNqZXJjeDR1eDEwdHQzM280YmxobDR1d3IifQ.-kg4yiUEPenYfPVgUFdWPQ").then(function(response){return response.json();}).then(function(json){//console.log(json);
if(json.features.length>0){var _r=_this.state.route;_r.to.lat=json.features[0].center[1];_r.to.lng=json.features[0].center[0];_this.setState({route:_r});}else{__WEBPACK_IMPORTED_MODULE_3_toastr___default.a.error('Error during city location');}});}};_this.updateMapRoute=function(e){//console.log("update route...");
fetch('https://api.mapbox.com/directions/v5/mapbox/driving/'+_this.state.route.from.lng+','+_this.state.route.from.lat+';'+_this.state.route.to.lng+','+_this.state.route.to.lat+'?overview=full&geometries=geojson&access_token='+"pk.eyJ1IjoicmRzbGFiIiwiYSI6ImNqZXJjeDR1eDEwdHQzM280YmxobDR1d3IifQ.-kg4yiUEPenYfPVgUFdWPQ").then(function(response){return response.json();}).then(function(json){//console.log(json);
var _r=_this.state.route;if(json.routes.length>0){_r.km=Math.round(json.routes[0].distance/1600);// im miglia....
_r.time=Math.round(json.routes[0].duration/3600);_r.revenue=Math.round(_r.km*2.07);_r.endDate.setHours(_r.endDate.getHours()+Math.floor(_r.time));_r.vectorPath=json.routes[0].geometry.coordinates;//console.log(JSON.stringify(_r.vectorPath));
_r.vectorPath.map(function(vpath){vpath.reverse();return null;});}else{_r.vectorPath=[];}//_r.revenue= Math.round(Math.random()*500)
_r.drive=Math.round(Math.random()*10);_r.duty=Math.round(Math.random()*10);_r.off=Math.round(Math.random()*10);_r.berth=Math.round(Math.random()*10);_r.fuel=Math.round(Math.random()*10);_r.tolls=Math.round(Math.random()*100);_r.truck=(Math.round(Math.random()*10)%3+1).toString();//console.log(_r);
_this.setState({route:_r,routeList:json.routes});});};_this.onChangeView=function(e){_this.props.history.push('/'+e);};_this.state={route:_this.resetRoute(),routeList:[],showModal:false};return _this;}_createClass(LogisticCreator,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components_HeaderBar_js__["a" /* HeaderBar */],{onChangeView:this.onChangeView,actualPosition:"Shipper RFQ"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["m" /* Row */],{className:'gray-bg'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["d" /* Col */],{xs:7,sm:7,md:7,lg:7},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'top-spacer'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__components_CollapsablePanel__["a" /* CollapsablePanel */],{title:'Request For Quote'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["d" /* Col */],{xs:6,sm:6,md:6,lg:6},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'from-form'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["i" /* Label */],{bsStyle:'danger'},'Origin'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-circle btn-xs pull-right',type:'button',onClick:this.openAddressBook},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-plus'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["h" /* FormGroup */],{controlId:'formHorizontalEmail'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["d" /* Col */],{componentClass:__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["f" /* ControlLabel */],sm:2},'Zip'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["d" /* Col */],{sm:10},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["g" /* FormControl */],{type:'text',placeholder:'Zip code',onChange:this.updateFromCompany,value:this.state.route.from.name}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["h" /* FormGroup */],{controlId:'formHorizontalEmail'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["d" /* Col */],{componentClass:__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["f" /* ControlLabel */],sm:2},'City'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["d" /* Col */],{sm:10},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["g" /* FormControl */],{type:'text',placeholder:'City',value:this.state.route.from.address,onChange:this.updateFromLocation,onBlur:this.updateFromCoordinates}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["h" /* FormGroup */],{controlId:'formHorizontalEmail'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["d" /* Col */],{componentClass:__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["f" /* ControlLabel */],sm:2},'State'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["d" /* Col */],{sm:10},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["g" /* FormControl */],{type:'text',placeholder:'State'}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["d" /* Col */],{xs:6,sm:6,md:6,lg:6},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'to-form'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["i" /* Label */],{bsStyle:'danger'},'Destination'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-circle btn-xs pull-right',type:'button',onClick:this.openAddressBook},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-plus'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["h" /* FormGroup */],{controlId:'formHorizontalEmail'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["d" /* Col */],{componentClass:__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["f" /* ControlLabel */],sm:2},'Zip'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["d" /* Col */],{sm:10},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["g" /* FormControl */],{type:'text',placeholder:'Zip code',onChange:this.updateToCompany,value:this.state.route.to.name}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["h" /* FormGroup */],{controlId:'formHorizontalEmail'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["d" /* Col */],{componentClass:__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["f" /* ControlLabel */],sm:2},'City'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["d" /* Col */],{sm:10},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["g" /* FormControl */],{type:'text',placeholder:'City',value:this.state.route.to.address,onChange:this.updateToLocation,onBlur:this.updateToCoordinates}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["h" /* FormGroup */],{controlId:'formHorizontalEmail'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["d" /* Col */],{componentClass:__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["f" /* ControlLabel */],sm:2},'State'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["d" /* Col */],{sm:10},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["g" /* FormControl */],{type:'text',placeholder:'State'}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["d" /* Col */],{xs:12,sm:12,md:12,lg:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["a" /* Button */],{type:'button',bsSize:'small',className:'btn full-width btn-outline btn-danger btn-sm',onClick:this.updateMapRoute},'Generate Route'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'shipment-form'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["i" /* Label */],{bsStyle:'danger'},'Shipment Data'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["b" /* ButtonGroup */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["a" /* Button */],{bsSize:'small'},'Route Info'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["a" /* Button */],{bsSize:'small'},'Content'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["a" /* Button */],{bsSize:'small'},'Documents')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["h" /* FormGroup */],{controlId:'formHorizontalEmail'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["d" /* Col */],{componentClass:__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["f" /* ControlLabel */],sm:2},'Cargo Type'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["d" /* Col */],{sm:10},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["g" /* FormControl */],{type:'text',placeholder:'Cargo Type'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["h" /* FormGroup */],{controlId:'formHorizontalEmail'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["d" /* Col */],{componentClass:__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["f" /* ControlLabel */],sm:2},'Packaging'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["d" /* Col */],{sm:10},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["g" /* FormControl */],{type:'text',placeholder:'Packaging'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["h" /* FormGroup */],{controlId:'formHorizontalEmail'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["d" /* Col */],{componentClass:__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["f" /* ControlLabel */],sm:2},'Equipment Needed'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["d" /* Col */],{sm:10},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["g" /* FormControl */],{type:'textg',placeholder:'Equipment Needed'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["h" /* FormGroup */],{controlId:'formHorizontalEmail'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["d" /* Col */],{componentClass:__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["f" /* ControlLabel */],sm:2},'Weight'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["d" /* Col */],{sm:10},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["g" /* FormControl */],{type:'text',placeholder:'Weight'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["h" /* FormGroup */],{controlId:'formHorizontalEmail'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["d" /* Col */],{componentClass:__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["f" /* ControlLabel */],sm:2},'Dimensions'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["d" /* Col */],{sm:10},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["g" /* FormControl */],{type:'text',placeholder:'Dimensions'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["h" /* FormGroup */],{controlId:'formHorizontalEmail'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["d" /* Col */],{componentClass:__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["f" /* ControlLabel */],sm:2},'Special Instrunctions'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["d" /* Col */],{sm:10},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["g" /* FormControl */],{type:'text',placeholder:'Special Instrunctions'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["h" /* FormGroup */],{controlId:'formHorizontalEmail'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["d" /* Col */],{componentClass:__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["f" /* ControlLabel */],sm:2},'Handling Instructions'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["d" /* Col */],{sm:10},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["g" /* FormControl */],{type:'text',placeholder:'Handling Instructions'})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr',null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-danger full-width',onClick:this.addRouteToList},'Submit RFQ'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'clearfix'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["d" /* Col */],{xs:5,sm:5,md:5,lg:5},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'top-spacer'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__components_CollapsablePanel__["a" /* CollapsablePanel */],{title:'Map'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_MapCreatorPanel__["a" /* MapCreatorPanel */],{routesList:[],route:this.state.route,onRouteSelect:this.onRouteSelect})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__components_CollapsablePanel__["a" /* CollapsablePanel */],{title:'Summary'},'From: ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,this.state.route.from.address?this.state.route.from.address:''),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'To: ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,this.state.route.to.address?this.state.route.to.address:''),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'Distance: ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,this.state.route.km,' mi'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'Time: ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,this.state.route.time,' hr'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'Average Cost: ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'$ ',this.state.route.revenue,' '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null)))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__lib_modal_shim__["a" /* default */],{show:this.state.showModal,onHide:this.closeAddressBook},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__lib_modal_shim__["a" /* default */].Header,{closeButton:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__lib_modal_shim__["a" /* default */].Title,null,'Address Book')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__lib_modal_shim__["a" /* default */].Body,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__components_ContactList__["a" /* ContactList */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'clearfix'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__lib_modal_shim__["a" /* default */].Footer,null)));}}]);return LogisticCreator;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);;

/***/ }),
/* 367 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.RootCloseWrapper = exports.Transition = exports.Position = exports.Portal = exports.Overlay = exports.Modal = exports.AutoAffix = exports.Affix = undefined;

var _Affix2 = __webpack_require__(163);

var _Affix3 = _interopRequireDefault(_Affix2);

var _AutoAffix2 = __webpack_require__(370);

var _AutoAffix3 = _interopRequireDefault(_AutoAffix2);

var _Modal2 = __webpack_require__(139);

var _Modal3 = _interopRequireDefault(_Modal2);

var _Overlay2 = __webpack_require__(150);

var _Overlay3 = _interopRequireDefault(_Overlay2);

var _Portal2 = __webpack_require__(99);

var _Portal3 = _interopRequireDefault(_Portal2);

var _Position2 = __webpack_require__(151);

var _Position3 = _interopRequireDefault(_Position2);

var _Transition2 = __webpack_require__(94);

var _Transition3 = _interopRequireDefault(_Transition2);

var _RootCloseWrapper2 = __webpack_require__(96);

var _RootCloseWrapper3 = _interopRequireDefault(_RootCloseWrapper2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.Affix = _Affix3.default;
exports.AutoAffix = _AutoAffix3.default;
exports.Modal = _Modal3.default;
exports.Overlay = _Overlay3.default;
exports.Portal = _Portal3.default;
exports.Position = _Position3.default;
exports.Transition = _Transition3.default;
exports.RootCloseWrapper = _RootCloseWrapper3.default;

/***/ }),
/* 368 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = height;

var _offset = __webpack_require__(51);

var _offset2 = _interopRequireDefault(_offset);

var _isWindow = __webpack_require__(50);

var _isWindow2 = _interopRequireDefault(_isWindow);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function height(node, client) {
  var win = (0, _isWindow2.default)(node);
  return win ? win.innerHeight : client ? node.clientHeight : (0, _offset2.default)(node).height;
}
module.exports = exports['default'];

/***/ }),
/* 369 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = ownerWindow;

var _ownerDocument = __webpack_require__(31);

var _ownerDocument2 = _interopRequireDefault(_ownerDocument);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ownerWindow(node) {
  var doc = (0, _ownerDocument2.default)(node);
  return doc && doc.defaultView || doc.parentWindow;
}
module.exports = exports['default'];

/***/ }),
/* 370 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _offset = __webpack_require__(51);

var _offset2 = _interopRequireDefault(_offset);

var _requestAnimationFrame = __webpack_require__(164);

var _requestAnimationFrame2 = _interopRequireDefault(_requestAnimationFrame);

var _propTypes = __webpack_require__(5);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _componentOrElement = __webpack_require__(65);

var _componentOrElement2 = _interopRequireDefault(_componentOrElement);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Affix = __webpack_require__(163);

var _Affix2 = _interopRequireDefault(_Affix);

var _addEventListener = __webpack_require__(62);

var _addEventListener2 = _interopRequireDefault(_addEventListener);

var _getContainer = __webpack_require__(66);

var _getContainer2 = _interopRequireDefault(_getContainer);

var _getDocumentHeight = __webpack_require__(165);

var _getDocumentHeight2 = _interopRequireDefault(_getDocumentHeight);

var _ownerDocument = __webpack_require__(32);

var _ownerDocument2 = _interopRequireDefault(_ownerDocument);

var _ownerWindow = __webpack_require__(166);

var _ownerWindow2 = _interopRequireDefault(_ownerWindow);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var displayName = 'AutoAffix';

var propTypes = _extends({}, _Affix2.default.propTypes, {
  /**
   * The logical container node or component for determining offset from bottom
   * of viewport, or a function that returns it
   */
  container: _propTypes2.default.oneOfType([_componentOrElement2.default, _propTypes2.default.func]),
  /**
   * Automatically set width when affixed
   */
  autoWidth: _propTypes2.default.bool
});

// This intentionally doesn't inherit default props from `<Affix>`, so that the
// auto-calculated offsets can apply.
var defaultProps = {
  viewportOffsetTop: 0,
  autoWidth: true
};

/**
 * The `<AutoAffix/>` component wraps `<Affix/>` to automatically calculate
 * offsets in many common cases.
 */

var AutoAffix = function (_React$Component) {
  _inherits(AutoAffix, _React$Component);

  function AutoAffix(props, context) {
    _classCallCheck(this, AutoAffix);

    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props, context));

    _this.onWindowScroll = function () {
      _this.onUpdate();
    };

    _this.onWindowResize = function () {
      if (_this.props.autoWidth) {
        (0, _requestAnimationFrame2.default)(function () {
          return _this.onUpdate();
        });
      }
    };

    _this.onDocumentClick = function () {
      (0, _requestAnimationFrame2.default)(function () {
        return _this.onUpdate();
      });
    };

    _this.onUpdate = function () {
      if (!_this._isMounted) {
        return;
      }

      var _getOffset = (0, _offset2.default)(_this.positioner),
          offsetTop = _getOffset.top,
          width = _getOffset.width;

      var container = (0, _getContainer2.default)(_this.props.container);
      var offsetBottom = void 0;
      if (container) {
        var documentHeight = (0, _getDocumentHeight2.default)((0, _ownerDocument2.default)(_this));

        var _getOffset2 = (0, _offset2.default)(container),
            top = _getOffset2.top,
            height = _getOffset2.height;

        offsetBottom = documentHeight - top - height;
      } else {
        offsetBottom = null;
      }

      _this.updateState(offsetTop, offsetBottom, width);
    };

    _this.updateState = function (offsetTop, offsetBottom, width) {
      if (offsetTop === _this.state.offsetTop && offsetBottom === _this.state.offsetBottom && width === _this.state.width) {
        return;
      }

      _this.setState({ offsetTop: offsetTop, offsetBottom: offsetBottom, width: width });
    };

    _this.state = {
      offsetTop: null,
      offsetBottom: null,
      width: null
    };
    return _this;
  }

  AutoAffix.prototype.componentDidMount = function componentDidMount() {
    var _this2 = this;

    this._isMounted = true;

    this._windowScrollListener = (0, _addEventListener2.default)((0, _ownerWindow2.default)(this), 'scroll', function () {
      return _this2.onWindowScroll();
    });

    this._windowResizeListener = (0, _addEventListener2.default)((0, _ownerWindow2.default)(this), 'resize', function () {
      return _this2.onWindowResize();
    });

    this._documentClickListener = (0, _addEventListener2.default)((0, _ownerDocument2.default)(this), 'click', function () {
      return _this2.onDocumentClick();
    });

    this.onUpdate();
  };

  AutoAffix.prototype.componentWillReceiveProps = function componentWillReceiveProps() {
    this._needPositionUpdate = true;
  };

  AutoAffix.prototype.componentDidUpdate = function componentDidUpdate() {
    if (this._needPositionUpdate) {
      this._needPositionUpdate = false;
      this.onUpdate();
    }
  };

  AutoAffix.prototype.componentWillUnmount = function componentWillUnmount() {
    this._isMounted = false;

    if (this._windowScrollListener) {
      this._windowScrollListener.remove();
    }
    if (this._documentClickListener) {
      this._documentClickListener.remove();
    }
    if (this._windowResizeListener) {
      this._windowResizeListener.remove();
    }
  };

  AutoAffix.prototype.render = function render() {
    var _this3 = this;

    var _props = this.props,
        autoWidth = _props.autoWidth,
        viewportOffsetTop = _props.viewportOffsetTop,
        children = _props.children,
        props = _objectWithoutProperties(_props, ['autoWidth', 'viewportOffsetTop', 'children']);

    var _state = this.state,
        offsetTop = _state.offsetTop,
        offsetBottom = _state.offsetBottom,
        width = _state.width;


    delete props.container;

    var effectiveOffsetTop = Math.max(offsetTop, viewportOffsetTop || 0);

    var _props2 = this.props,
        affixStyle = _props2.affixStyle,
        bottomStyle = _props2.bottomStyle;

    if (autoWidth) {
      affixStyle = _extends({ width: width }, affixStyle);
      bottomStyle = _extends({ width: width }, bottomStyle);
    }

    return _react2.default.createElement(
      'div',
      null,
      _react2.default.createElement('div', { ref: function ref(c) {
          _this3.positioner = c;
        } }),
      _react2.default.createElement(
        _Affix2.default,
        _extends({}, props, {
          offsetTop: effectiveOffsetTop,
          viewportOffsetTop: viewportOffsetTop,
          offsetBottom: offsetBottom,
          affixStyle: affixStyle,
          bottomStyle: bottomStyle
        }),
        children
      )
    );
  };

  return AutoAffix;
}(_react2.default.Component);

AutoAffix.displayName = displayName;
AutoAffix.propTypes = propTypes;
AutoAffix.defaultProps = defaultProps;

exports.default = AutoAffix;
module.exports = exports['default'];

/***/ }),
/* 371 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MapCreatorPanel; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_leaflet__ = __webpack_require__(167);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_leaflet___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_leaflet__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_leaflet_dist_images_marker_icon_2x_png__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_leaflet_dist_images_marker_icon_2x_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_leaflet_dist_images_marker_icon_2x_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_leaflet_dist_images_marker_icon_png__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_leaflet_dist_images_marker_icon_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_leaflet_dist_images_marker_icon_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_leaflet_dist_images_marker_shadow_png__ = __webpack_require__(170);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_leaflet_dist_images_marker_shadow_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_leaflet_dist_images_marker_shadow_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lib_leaflet_awesome_markers_js__ = __webpack_require__(171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lib_leaflet_awesome_markers_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__lib_leaflet_awesome_markers_js__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var MapCreatorPanel=function(_Component){_inherits(MapCreatorPanel,_Component);function MapCreatorPanel(props){_classCallCheck(this,MapCreatorPanel);var _this=_possibleConstructorReturn(this,(MapCreatorPanel.__proto__||Object.getPrototypeOf(MapCreatorPanel)).call(this,props));_this.addStartMarkerToMap=function(route){var greenMarker=__WEBPACK_IMPORTED_MODULE_1_leaflet___default.a.AwesomeMarkers.icon({icon:'arrow-up',prefix:'fa',markerColor:'green'//iconAnchor: [10, 40]
});route.from.marker=__WEBPACK_IMPORTED_MODULE_1_leaflet___default.a.marker([route.from.lat,route.from.lng],{icon:greenMarker}).bindTooltip(_this.getStartMarkerTooltip(route),{}).addTo(_this.map);};_this.addEndMarkerToMap=function(route){var redMarker=__WEBPACK_IMPORTED_MODULE_1_leaflet___default.a.AwesomeMarkers.icon({icon:'arrow-down',prefix:'fa',markerColor:'red'//iconAnchor: [10, 40]
});route.to.marker=__WEBPACK_IMPORTED_MODULE_1_leaflet___default.a.marker([route.to.lat,route.to.lng],{icon:redMarker}).bindTooltip(_this.getEndMarkerTooltip(route),{}).addTo(_this.map);};_this.getRouteTooltip=function(route){return null;};_this.getStartMarkerTooltip=function(route){return'<ul class="tooltip-content">'+'<li>'+route.from.name+'</li>'+'<li>Pick: '+route.startDate.getHours()+':'+route.startDate.getMinutes()+'</li>'+'<li>Dist: '+route.distance+' Km</li>'+'<li>Rev: '+route.revenue+' €</li>'+'</ul>';};_this.getEndMarkerTooltip=function(route){return'<ul class="tooltip-content">'+'<li>'+route.to.name+'</li>'+'<li>Rel: '+route.endDate.getHours()+':'+route.endDate.getMinutes()+'</li>'+'<li>Dist: '+route.distance+' Km</li>'+'<li>Rev: '+route.revenue+' €</li>'+'</ul>';};_this.addRouteToMap=function(route){//console.log('Aggiorno la path');
//console.log(route.vectorPath);
/*
      if (route.vectorPath) {
        route.vectorPath.map((vpath) => {
          vpath.reverse();
          return null;
        });
      }
      */var polyline=__WEBPACK_IMPORTED_MODULE_1_leaflet___default.a.polyline(route.vectorPath,{color:'red',className:'map-selected-polyline'}).bindTooltip('Info on the route...').addTo(_this.map);_this.props.route.polyline=polyline;};_this.componentDidUpdate=function(){//console.log('update');
if(_this.props.route.from.marker!=null){_this.props.route.from.marker.remove();}if(_this.props.route.to.marker!=null){_this.props.route.to.marker.remove();}if(_this.props.route.polyline!=null){_this.props.route.polyline.remove();_this.props.route.polyline=null;}if(_this.props.route.from.lat>0){_this.addStartMarkerToMap(_this.props.route);}if(_this.props.route.to.lat>0){_this.addEndMarkerToMap(_this.props.route);}if(_this.props.route.vectorPath.length>0){_this.addRouteToMap(_this.props.route);}if(_this.props.route.from.lat!=0&&_this.props.route.from.lng!=0&&_this.props.route.to.lat!=0&&_this.props.route.to.lng!=0){_this.map.fitBounds([[_this.props.route.from.lat,_this.props.route.from.lng],[_this.props.route.to.lat,_this.props.route.to.lng]]);}};return _this;}_createClass(MapCreatorPanel,[{key:'componentDidMount',value:function componentDidMount(){//Rewrite prototype for Icon
__WEBPACK_IMPORTED_MODULE_1_leaflet___default.a.Marker.prototype.options.icon=__WEBPACK_IMPORTED_MODULE_1_leaflet___default.a.icon({iconRetinaUrl:__WEBPACK_IMPORTED_MODULE_2_leaflet_dist_images_marker_icon_2x_png___default.a,iconUrl:__WEBPACK_IMPORTED_MODULE_3_leaflet_dist_images_marker_icon_png___default.a,shadowUrl:__WEBPACK_IMPORTED_MODULE_4_leaflet_dist_images_marker_shadow_png___default.a,iconSize:[25,41],iconAnchor:[12,41],popupAnchor:[1,-34],tooltipAnchor:[16,-28],shadowSize:[41,41]});/*
      var mapboxLayer = L.tileLayer('https://api.mapbox.com/styles/v1/mapbox/streets-v9/tiles/{z}/{x}/{y}?access_token=pk.eyJ1IjoiZmxhdmlldHRvIiwiYSI6ImNpdndidGxicDAwMGsyeXFjcnVucjY3bXIifQ.FFGUhmc3K9UqyOJbU2jKpA', {
  			attribution: 'Mapbox Map',
  			maxZoom: 18
  		});
      */var osmLayer=__WEBPACK_IMPORTED_MODULE_1_leaflet___default.a.tileLayer('http://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',{//attribution: 'Map data © <a href="http://openstreetmap.org">OpenStreetMap</a> contributors',
maxZoom:18});var gmapLayer=__WEBPACK_IMPORTED_MODULE_1_leaflet___default.a.tileLayer('http://{s}.google.com/vt/lyrs=s&x={x}&y={y}&z={z}',{//attribution: '© Google Maps 2017',
maxZoom:20,subdomains:['mt0','mt1','mt2','mt3']});var baseMaps={"Google Satellite":gmapLayer,//"Mapbox Street": mapboxLayer,
"Open Street View":osmLayer};this.map=__WEBPACK_IMPORTED_MODULE_1_leaflet___default.a.map('map',{center:[39.542938,-97.367541],zoom:4});gmapLayer.addTo(this.map);//mapboxLayer.addTo(this.map);
osmLayer.addTo(this.map);__WEBPACK_IMPORTED_MODULE_1_leaflet___default.a.control.layers(baseMaps).addTo(this.map);}},{key:'componentWillUpdate',value:function componentWillUpdate(){/* Cancellazione della route a video al cambio di un dato qualsiasi *///console.log('Cancellazione della route attuale...');
if(this.props.route.polyline){//console.log('Eseguo la cancellazione...');
this.props.route.polyline.remove();this.props.route.polyline=null;}}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'map'}));}}]);return MapCreatorPanel;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);;

/***/ }),
/* 372 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ContactList; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__ = __webpack_require__(13);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ContactList=function(_Component){_inherits(ContactList,_Component);function ContactList(){_classCallCheck(this,ContactList);return _possibleConstructorReturn(this,(ContactList.__proto__||Object.getPrototypeOf(ContactList)).apply(this,arguments));}_createClass(ContactList,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-lg-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["c" /* ButtonToolbar */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["b" /* ButtonGroup */],{bsSize:'xsmall'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["a" /* Button */],null,'A'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["a" /* Button */],null,'B'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["a" /* Button */],null,'C'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["a" /* Button */],null,'D'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["a" /* Button */],null,'E'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["a" /* Button */],null,'F'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["a" /* Button */],null,'G'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["a" /* Button */],null,'H'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["a" /* Button */],null,'I'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr',null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-lg-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'contact-box'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-sm-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'text-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{width:'50',alt:'image',className:'img-circle m-t-xs img-responsive',src:'/img/a3.jpg'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-sm-8'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'m-t-xs font-bold'},' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'Monica Smith'),' - Marketing manager'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-map-marker'}),' Riviera State 32/106 - Washington DC - USA')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-sm-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-circle btn-xs pull-right',type:'button',onClick:this.openAddressBook},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-id-card'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'clearfix'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-lg-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'contact-box'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-sm-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'text-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{width:'50',alt:'image',className:'img-circle m-t-xs img-responsive',src:'/img/a2.jpg'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-sm-8'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'m-t-xs font-bold'},' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'Monica Smith'),' - Marketing manager'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-map-marker'}),' Riviera State 32/106 - Washington DC - USA')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-sm-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-circle btn-xs pull-right',type:'button',onClick:this.openAddressBook},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-id-card'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'clearfix'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-lg-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'contact-box'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-sm-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'text-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{width:'50',alt:'image',className:'img-circle m-t-xs img-responsive',src:'/img/a4.jpg'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-sm-8'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'m-t-xs font-bold'},' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'Monica Smith'),' - Marketing manager'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-map-marker'}),' Riviera State 32/106 - Washington DC - USA')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-sm-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-circle btn-xs pull-right',type:'button',onClick:this.openAddressBook},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-id-card'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'clearfix'}))));}}]);return ContactList;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/***/ }),
/* 373 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TruckDispatcher; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_toastr__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_toastr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_toastr__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_HeaderBar_js__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_CollapsablePanel__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_TruckSelectionPanel__ = __webpack_require__(374);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_RouteListPanel__ = __webpack_require__(376);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_MapPanel__ = __webpack_require__(378);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_SummaryPanel__ = __webpack_require__(379);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_ChartPanel__ = __webpack_require__(381);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__lib_modal_shim__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_ModalChatPanel__ = __webpack_require__(385);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_ModalDriverPanel__ = __webpack_require__(386);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_MessagePanelSmall__ = __webpack_require__(387);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__data_Trucks_js__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__data_Routes_js__ = __webpack_require__(173);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var TruckDispatcher=function(_Component){_inherits(TruckDispatcher,_Component);function TruckDispatcher(props){_classCallCheck(this,TruckDispatcher);var _this=_possibleConstructorReturn(this,(TruckDispatcher.__proto__||Object.getPrototypeOf(TruckDispatcher)).call(this,props));_this.getRandomColor=function(){var letters='0123456789ABCDEF';var color='#';for(var i=0;i<6;i++){color+=letters[Math.floor(Math.random()*16)];}return color;};_this.onTruckSelect=function(e){_this.setState({selectedTruck:e.target.value});if(e.target.value>=0){__WEBPACK_IMPORTED_MODULE_2_toastr___default.a.info('You have selected a new Truck');}else{__WEBPACK_IMPORTED_MODULE_2_toastr___default.a.warning('No truck selected...');}};_this.onRouteSelect=function(_id){var _rtl=_this.state.routesList;_rtl.filter(function(route){return route._id===_id;}).map(function(route){//console.log(route);
if(!route.selected){__WEBPACK_IMPORTED_MODULE_2_toastr___default.a.success('You added a new route!');}else{__WEBPACK_IMPORTED_MODULE_2_toastr___default.a.error('You removed a route!');}route.selected=!route.selected;return null;});_this.setState({routesList:_rtl});};_this.getRouteList=function(){if(_this.state.selectedTruck>=0){return __WEBPACK_IMPORTED_MODULE_15__data_Routes_js__["a" /* default */].routesList.filter(function(route){return route.truck===__WEBPACK_IMPORTED_MODULE_14__data_Trucks_js__["a" /* default */].truksList[_this.state.selectedTruck]._id;});}else{return[];}};_this.getSelectedRouteList=function(){if(_this.state.selectedTruck>=0){return __WEBPACK_IMPORTED_MODULE_15__data_Routes_js__["a" /* default */].routesList.filter(function(route){return route.truck===__WEBPACK_IMPORTED_MODULE_14__data_Trucks_js__["a" /* default */].truksList[_this.state.selectedTruck]._id&&route.selected;});}else{return[];}};_this.onChangeView=function(e){_this.props.history.push('/'+e);};_this.openChatPanel=function(){_this.setState({showChatPanel:true});};_this.closeChatPanel=function(){_this.setState({showChatPanel:false});};_this.openDriverPanel=function(){_this.setState({showDriverPanel:true});};_this.closeDriverPanel=function(){_this.setState({showDriverPanel:false});};__WEBPACK_IMPORTED_MODULE_15__data_Routes_js__["a" /* default */].routesList.map(function(route){route.pathColor=_this.getRandomColor();return null;});__WEBPACK_IMPORTED_MODULE_2_toastr___default.a.options.closeDuration=200;_this.state={truckList:__WEBPACK_IMPORTED_MODULE_14__data_Trucks_js__["a" /* default */].truksList,routesList:__WEBPACK_IMPORTED_MODULE_15__data_Routes_js__["a" /* default */].routesList,selectedTruck:-1,showChatPanel:false,showDriverPanel:false};return _this;}_createClass(TruckDispatcher,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_HeaderBar_js__["a" /* HeaderBar */],{onChangeView:this.onChangeView,actualPosition:"Carrier View"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["m" /* Row */],{className:'gray-bg'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["d" /* Col */],{xs:4,sm:4,md:4,lg:4},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'top-spacer'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components_CollapsablePanel__["a" /* CollapsablePanel */],{title:'Truck Selection'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__components_TruckSelectionPanel__["a" /* TruckSelectionPanel */],{truckList:this.state.truckList,selectedTruck:this.state.selectedTruck,onTruckSelect:this.onTruckSelect,onOpenChatPanel:this.openChatPanel,onOpenDriverPanel:this.openDriverPanel})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components_CollapsablePanel__["a" /* CollapsablePanel */],{title:'Routes Available'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_RouteListPanel__["a" /* RouteListPanel */],{routesList:this.getRouteList(),onRouteSelect:this.onRouteSelect}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["d" /* Col */],{xs:8,sm:8,md:8,lg:8},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'top-spacer'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components_CollapsablePanel__["a" /* CollapsablePanel */],{title:'Map'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__components_MapPanel__["a" /* MapPanel */],{routesList:this.getRouteList(),onRouteSelect:this.onRouteSelect,selectedTruck:this.state.truckList[this.state.selectedTruck]})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components_CollapsablePanel__["a" /* CollapsablePanel */],{title:'Summary and Chart'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__components_ChartPanel__["a" /* ChartPanel */],{routesList:this.getRouteList()})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__components_MessagePanelSmall__["a" /* MessagePanelSmall */],null))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__components_ModalChatPanel__["a" /* ModalChatPanel */],{showPanel:this.state.showChatPanel,onClose:this.closeChatPanel}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__components_ModalDriverPanel__["a" /* ModalDriverPanel */],{showPanel:this.state.showDriverPanel,onClose:this.closeDriverPanel,data:this.state.truckList[this.state.selectedTruck]}));}}]);return TruckDispatcher;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);;

/***/ }),
/* 374 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TruckSelectionPanel; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__TruckContactBox__ = __webpack_require__(375);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var TruckSelectionPanel=function(_Component){_inherits(TruckSelectionPanel,_Component);function TruckSelectionPanel(){var _ref;var _temp,_this,_ret;_classCallCheck(this,TruckSelectionPanel);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=TruckSelectionPanel.__proto__||Object.getPrototypeOf(TruckSelectionPanel)).call.apply(_ref,[this].concat(args))),_this),_this.getTruckFrom=function(){if(_this.props.selectedTruck>=0){return _this.props.truckList[_this.props.selectedTruck].fromLocation;}else{return'';}},_this.getTruckTo=function(){if(_this.props.selectedTruck>=0){return _this.props.truckList[_this.props.selectedTruck].toLocation;}else{return'';}},_this.getSelectdTruck=function(){if(_this.props.selectedTruck>=0){return _this.props.truckList[_this.props.selectedTruck];}else{return null;}},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(TruckSelectionPanel,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["m" /* Row */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["d" /* Col */],{lg:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('form',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{className:'form-control m-b',name:'account',onChange:this.props.onTruckSelect},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'-1'},'Select a truck'),this.props.truckList.map(function(truck,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{key:index,value:index},truck.pilotName);})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["d" /* Col */],{lg:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__TruckContactBox__["a" /* TruckContactBox */],{truck:this.getSelectdTruck(),onOpenChatPanel:this.props.onOpenChatPanel,onOpenDriverPanel:this.props.onOpenDriverPanel},' ')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["d" /* Col */],{lg:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'track-panel-start'},'Current Route:')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["d" /* Col */],{lg:6},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'track-panel-start'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-map-marker','aria-hidden':'true'}),' From: ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,this.getTruckFrom()))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["d" /* Col */],{lg:6},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'track-panel-start'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-map-marker','aria-hidden':'true'}),' To: ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,this.getTruckTo()))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["d" /* Col */],{lg:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["a" /* Button */],{type:'button',className:'btn full-width btn-outline btn-danger btn-sm'},'Save WorkList')));}}]);return TruckSelectionPanel;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);;

/***/ }),
/* 375 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TruckContactBox; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var TruckContactBox=function(_Component){_inherits(TruckContactBox,_Component);function TruckContactBox(){_classCallCheck(this,TruckContactBox);return _possibleConstructorReturn(this,(TruckContactBox.__proto__||Object.getPrototypeOf(TruckContactBox)).apply(this,arguments));}_createClass(TruckContactBox,[{key:"render",value:function render(){if(this.props.truck!=null){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-sm-2"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"text-center"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{alt:"image",className:"img-circle m-t-xs img-responsive driver-image",src:this.props.truck.image,onClick:this.props.onOpenDriverPanel}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-sm-5"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h3",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,this.props.truck.plate)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,this.props.truck.pilotName),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button",{className:"btn btn-circle btn-xs",type:"button",onClick:this.props.onOpenChatPanel},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:"fa fa-comments"}))," click to chat ")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-sm-5"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("address",null,"Type: ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,this.props.truck.truckType),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),"Tractor: ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,this.props.truck.truckModel),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),"Max Load: ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,this.props.truck.maxCharge," lbs"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("abbr",{title:"Phone"},"Phone:")," ",this.props.truck.mobile)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"clearfix"}));}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"Truck not selected");}}}]);return TruckContactBox;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/***/ }),
/* 376 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return RouteListPanel; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_RouteListItem__ = __webpack_require__(377);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var RouteListPanel=function(_Component){_inherits(RouteListPanel,_Component);function RouteListPanel(props){_classCallCheck(this,RouteListPanel);var _this=_possibleConstructorReturn(this,(RouteListPanel.__proto__||Object.getPrototypeOf(RouteListPanel)).call(this,props));_this.onFilterChange=function(e){_this.setState({filterValue:e.target.value});};_this.getFilteredRoutes=function(){return _this.props.routesList.filter(function(route){return route.from.name.toLowerCase().search(_this.state.filterValue.toLowerCase())!==-1||route.to.name.toLowerCase().search(_this.state.filterValue.toLowerCase())!==-1;});};_this.state={filterValue:''};return _this;}_createClass(RouteListPanel,[{key:'render',value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'route-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["h" /* FormGroup */],{controlId:'formBasicText'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["g" /* FormControl */],{type:'text',value:this.state.filterValue,placeholder:'Filter routes...',onChange:this.onFilterChange}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["g" /* FormControl */].Feedback,null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'todo-list m-t small-list ui-sortable'},this.getFilteredRoutes().map(function(route,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_RouteListItem__["a" /* RouteListItem */],{key:index,routeData:route,onRouteSelect:_this2.props.onRouteSelect});})));}}]);return RouteListPanel;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);;

/***/ }),
/* 377 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return RouteListItem; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__ = __webpack_require__(13);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var RouteListItem=function(_Component){_inherits(RouteListItem,_Component);function RouteListItem(props){_classCallCheck(this,RouteListItem);var _this=_possibleConstructorReturn(this,(RouteListItem.__proto__||Object.getPrototypeOf(RouteListItem)).call(this,props));_this.onCollapse=function(e){_this.setState({isPanelOpen:!_this.state.isPanelOpen});};_this.onSelect=function(e){_this.props.onRouteSelect(_this.props.routeData._id);};_this.selectedInfoClass=function(){return _this.props.routeData.selected?'route-info-selected':null;};_this.selectedIconClass=function(){return"fa route-check-square "+(_this.props.routeData.selected?'fa-check-square':'fa-square-o');};_this.openPanelIcon=function(){return _this.state.isPanelOpen?'fa-compress':'fa-expand';};_this.selectedRouteLiClass=function(){return _this.props.routeData.selected?'selected-route-item':'';};_this.getLayerColorBox=function(){if(_this.props.routeData.selected){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'layer-color-icon pull-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('svg',{width:'10',height:'10',xmlns:'http://www.w3.org/2000/svg'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('rect',{style:{strokeWidth:1,stroke:'black',fill:_this.props.routeData.pathColor},x:'0',y:'0',width:'10',height:'10',rx:'3',ry:'3'})));}else{return'';}};_this.state={isPanelOpen:false};return _this;}_createClass(RouteListItem,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'route-item '+this.selectedRouteLiClass()},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{onClick:this.onSelect,className:this.selectedIconClass()}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:"m-l-xs "+this.selectedInfoClass()},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'route-item-data'},this.props.routeData.from.name),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'route-item-data'},this.props.routeData.to.name),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'route-item-data'},'Miles: ',this.props.routeData.km),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'route-item-data'},'Revenue: $ ',this.props.routeData.revenue)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{onClick:this.onCollapse,className:'fa route-info-icon pull-right '+this.openPanelIcon()}),this.getLayerColorBox()),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["e" /* Collapse */],{'in':this.state.isPanelOpen},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'route-extended-info'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'table'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'Drive'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,this.props.routeData.drive,' hr'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'Duty'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,this.props.routeData.duty,' hr'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'Time'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,this.props.routeData.time,' hr')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'Off'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,this.props.routeData.off,' hr'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'Berth'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,this.props.routeData.berth,' $'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'Fuel'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,this.props.routeData.fuel,' lt'))))))));}}]);return RouteListItem;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);;

/***/ }),
/* 378 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MapPanel; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_leaflet__ = __webpack_require__(167);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_leaflet___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_leaflet__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_leaflet_dist_images_marker_icon_2x_png__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_leaflet_dist_images_marker_icon_2x_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_leaflet_dist_images_marker_icon_2x_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_leaflet_dist_images_marker_icon_png__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_leaflet_dist_images_marker_icon_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_leaflet_dist_images_marker_icon_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_leaflet_dist_images_marker_shadow_png__ = __webpack_require__(170);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_leaflet_dist_images_marker_shadow_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_leaflet_dist_images_marker_shadow_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lib_leaflet_awesome_markers_js__ = __webpack_require__(171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lib_leaflet_awesome_markers_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__lib_leaflet_awesome_markers_js__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}//import svgIcon from '../lib/svg-icon.js';
var MapPanel=function(_Component){_inherits(MapPanel,_Component);function MapPanel(){var _ref;var _temp,_this,_ret;_classCallCheck(this,MapPanel);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=MapPanel.__proto__||Object.getPrototypeOf(MapPanel)).call.apply(_ref,[this].concat(args))),_this),_this.getSelectedBounds=function(){return _this.props.routesList.filter(function(route){return route.selected;}).map(function(route,index){return[route.from.lat,route.from.lng];}).concat(_this.props.routesList.filter(function(route){return route.selected;}).map(function(route,index){return[route.to.lat,route.to.lng];}));},_this.getUnselectedBounds=function(){return _this.props.routesList.map(function(route,index){return[route.from.lat,route.from.lng];}).concat(_this.props.routesList.map(function(route,index){return[route.to.lat,route.to.lng];}));},_this.addSelectedRouteToMap=function(route){var polyline=__WEBPACK_IMPORTED_MODULE_1_leaflet___default.a.polyline(route.vectorPath,{color:route.pathColor,className:'map-selected-polyline'}).bindTooltip('Info on the route...').addTo(_this.map);route.polyline=polyline;},_this.addUnselectedRouteToMap=function(route){var polyline=__WEBPACK_IMPORTED_MODULE_1_leaflet___default.a.polyline(route.vectorPath,{color:'#4f4f4f',className:'map-unselected-polyline'}).bindTooltip('Info on the route...').addTo(_this.map);route.polyline=polyline;},_this.addActualRouteToMap=function(route){//console.log('Disegna la mappa del truck attuale');
//console.log(route);
var polyline=__WEBPACK_IMPORTED_MODULE_1_leaflet___default.a.polyline(route.vectorPath,{color:'#FF0000',className:'map-selected-polyline'}).bindTooltip('Info on the route...').addTo(_this.map);route.polyline=polyline;},_this.addUnselectedMarker=function(lat,lng,tooltip){var unsMarker=__WEBPACK_IMPORTED_MODULE_1_leaflet___default.a.AwesomeMarkers.icon({icon:'user-circle-o',prefix:'fa',markerColor:'gray',iconAnchor:[20,50]});/*
      var unselectedIcon = L.icon({
          iconUrl: '/images/marker_unselected.png',
          iconSize:     [16, 16], // size of the icon
          iconAnchor:   [8, 8], // point of the icon which will correspond to marker's location
          popupAnchor:  [8, 8] // point from which the popup should open relative to the iconAnchor
      });
      */return __WEBPACK_IMPORTED_MODULE_1_leaflet___default.a.marker([lat,lng],{icon:unsMarker}).bindTooltip(tooltip).addTo(_this.map);},_this.addActualTruckPosition=function(truck){var greenMarker=__WEBPACK_IMPORTED_MODULE_1_leaflet___default.a.AwesomeMarkers.icon({icon:'fa-truck',prefix:'fa',markerColor:'purple',iconAnchor:[10,40]});truck.truckMarker=__WEBPACK_IMPORTED_MODULE_1_leaflet___default.a.marker(truck.actualPosition,{icon:greenMarker})//.bindTooltip(this.getStartMarkerTooltip(route), {offset:[25, 0]})
.addTo(_this.map);},_this.addStartMarkerToMap=function(route){var greenMarker=__WEBPACK_IMPORTED_MODULE_1_leaflet___default.a.AwesomeMarkers.icon({icon:'arrow-up',prefix:'fa',markerColor:'green',iconAnchor:[10,40]});route.from.marker=__WEBPACK_IMPORTED_MODULE_1_leaflet___default.a.marker([route.from.lat,route.from.lng],{icon:greenMarker}).bindTooltip(_this.getStartMarkerTooltip(route),{offset:[25,0]}).addTo(_this.map);},_this.addEndMarkerToMap=function(route){var redMarker=__WEBPACK_IMPORTED_MODULE_1_leaflet___default.a.AwesomeMarkers.icon({icon:'arrow-down',prefix:'fa',markerColor:'red',iconAnchor:[-2,40]});route.to.marker=__WEBPACK_IMPORTED_MODULE_1_leaflet___default.a.marker([route.to.lat,route.to.lng],{icon:redMarker}).bindTooltip(_this.getEndMarkerTooltip(route),{offset:[25,0]}).addTo(_this.map);},_this.getRouteTooltip=function(route){return null;},_this.getStartMarkerTooltip=function(route){return'<ul class="tooltip-content">'+'<li>'+route.from.name+'</li>'+'<li>Pick: '+route.startDate.getHours()+':'+route.startDate.getMinutes()+'</li>'+'<li>Dist: '+route.distance+' Km</li>'+'<li>Rev: '+route.revenue+' €</li>'+'</ul>';},_this.getEndMarkerTooltip=function(route){return'<ul class="tooltip-content">'+'<li>'+route.to.name+'</li>'+'<li>Rel: '+route.endDate.getHours()+':'+route.endDate.getMinutes()+'</li>'+'<li>Dist: '+route.distance+' Km</li>'+'<li>Rev: '+route.revenue+' €</li>'+'</ul>';},_this.onRouteSelect=function(_id){_this.props.onRouteSelect(_id);},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(MapPanel,[{key:'componentDidMount',value:function componentDidMount(){//Rewrite prototype for Icon
__WEBPACK_IMPORTED_MODULE_1_leaflet___default.a.Marker.prototype.options.icon=__WEBPACK_IMPORTED_MODULE_1_leaflet___default.a.icon({iconRetinaUrl:__WEBPACK_IMPORTED_MODULE_2_leaflet_dist_images_marker_icon_2x_png___default.a,iconUrl:__WEBPACK_IMPORTED_MODULE_3_leaflet_dist_images_marker_icon_png___default.a,shadowUrl:__WEBPACK_IMPORTED_MODULE_4_leaflet_dist_images_marker_shadow_png___default.a,iconSize:[25,41],iconAnchor:[12,41],popupAnchor:[1,-34],tooltipAnchor:[16,-28],shadowSize:[41,41]});/*
      var mapboxLayer = L.tileLayer('https://api.mapbox.com/styles/v1/mapbox/streets-v9/tiles/{z}/{x}/{y}?access_token=pk.eyJ1IjoiZmxhdmlldHRvIiwiYSI6ImNpdndidGxicDAwMGsyeXFjcnVucjY3bXIifQ.FFGUhmc3K9UqyOJbU2jKpA', {
  			attribution: 'Mapbox Map',
  			maxZoom: 18
  		});
      */var osmLayer=__WEBPACK_IMPORTED_MODULE_1_leaflet___default.a.tileLayer('http://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',{//attribution: 'Map data © <a href="http://openstreetmap.org">OpenStreetMap</a> contributors',
maxZoom:18});var gmapLayer=__WEBPACK_IMPORTED_MODULE_1_leaflet___default.a.tileLayer('http://{s}.google.com/vt/lyrs=s&x={x}&y={y}&z={z}',{//attribution: '© Google Maps 2017',
maxZoom:20,subdomains:['mt0','mt1','mt2','mt3']});var baseMaps={"Google Satellite":gmapLayer,//"Mapbox Street": mapboxLayer,
"Open Street View":osmLayer};this.map=__WEBPACK_IMPORTED_MODULE_1_leaflet___default.a.map('map',{center:[39.542938,-97.367541],zoom:4});gmapLayer.addTo(this.map);//mapboxLayer.addTo(this.map);
osmLayer.addTo(this.map);__WEBPACK_IMPORTED_MODULE_1_leaflet___default.a.control.layers(baseMaps).addTo(this.map);}},{key:'componentWillUpdate',value:function componentWillUpdate(){if(this.props.selectedTruck){if(this.props.selectedTruck.truckMarker){this.props.selectedTruck.truckMarker.remove();this.props.selectedTruck.truckMarker=null;}}if(this.props.selectedTruck){if(this.props.selectedTruck.polyline){this.props.selectedTruck.polyline.remove();this.props.selectedTruck.polyline=null;}}this.props.routesList.filter(function(route){return route.polyline!=null;}).map(function(route){route.polyline.remove();route.polyline=null;route.from.marker.remove();route.from.marker=null;route.to.marker.remove();route.to.marker=null;});}},{key:'componentDidUpdate',value:function componentDidUpdate(){var _this2=this;this.props.routesList.filter(function(route){return!route.selected;}).map(function(route,index){//this.addStartMarkerToMap(route);
//this.addEndMarkerToMap(route);
_this2.addUnselectedRouteToMap(route);route.from.marker=_this2.addUnselectedMarker(route.from.lat,route.from.lng,_this2.getStartMarkerTooltip(route));route.to.marker=_this2.addUnselectedMarker(route.to.lat,route.to.lng,_this2.getEndMarkerTooltip(route));route.polyline.on("click",function(e){_this2.onRouteSelect(route._id);});return null;});this.props.routesList.filter(function(route){return route.selected;}).map(function(route,index){_this2.addStartMarkerToMap(route);_this2.addEndMarkerToMap(route);_this2.addSelectedRouteToMap(route);route.polyline.on("click",function(e){_this2.onRouteSelect(route._id);});return null;});/* Aggiungiamo la posizione attuale del truck */if(this.props.selectedTruck){this.addActualTruckPosition(this.props.selectedTruck);this.addActualRouteToMap(this.props.selectedTruck);}/* Fit della mappa sulle rotte selezionate o su tutte quelle unselected */if(this.props.routesList.length>0){var ab=this.getSelectedBounds();if(ab.length>0){this.map.fitBounds(ab);}else{this.map.fitBounds(this.getUnselectedBounds());}}}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'map'}));}}]);return MapPanel;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);;

/***/ }),
/* 379 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export SummaryPanel */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__SummaryItem__ = __webpack_require__(380);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var SummaryPanel=function(_Component){_inherits(SummaryPanel,_Component);function SummaryPanel(props){_classCallCheck(this,SummaryPanel);var _this=_possibleConstructorReturn(this,(SummaryPanel.__proto__||Object.getPrototypeOf(SummaryPanel)).call(this,props));_this.getSummaryData=function(){var summary={drive:0,duty:0,off:0,berth:0,revenue:0,time:0,distance:0,fuel:0,tolls:0};_this.props.routesList.filter(function(route){return route.selected;}).map(function(route){summary.drive+=route.drive;summary.duty+=route.duty;summary.off+=route.off;summary.berth+=route.berth;summary.revenue+=route.revenue;summary.time+=route.time;summary.distance+=route.distance;summary.fuel+=route.fuel;summary.tolls+=route.tolls;return null;});return summary;};_this.state={drive:0};return _this;}_createClass(SummaryPanel,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'summary-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__SummaryItem__["a" /* SummaryItem */],{title:'Drive',value:this.getSummaryData().drive+' hr',iconClass:'fa-truck'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__SummaryItem__["a" /* SummaryItem */],{title:'Duty',value:this.getSummaryData().duty+' hr',iconClass:'fa-hourglass-start'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__SummaryItem__["a" /* SummaryItem */],{title:'Off',value:this.getSummaryData().off+' hr',iconClass:'fa-moon-o'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__SummaryItem__["a" /* SummaryItem */],{title:'Berth',value:this.getSummaryData().berth+' hr',iconClass:'fa-bed'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__SummaryItem__["a" /* SummaryItem */],{title:'Rev',value:this.getSummaryData().revenue+' €',iconClass:'fa-eur'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__SummaryItem__["a" /* SummaryItem */],{title:'Time',value:this.getSummaryData().time+' hr',iconClass:'fa-clock-o'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__SummaryItem__["a" /* SummaryItem */],{title:'Km',value:this.getSummaryData().distance+' km',iconClass:'fa-cogs'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__SummaryItem__["a" /* SummaryItem */],{title:'Fuel',value:this.getSummaryData().fuel+' lt',iconClass:'fa-battery-full'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__SummaryItem__["a" /* SummaryItem */],{title:'Tolls',value:this.getSummaryData().tolls+' €',iconClass:'fa-ticket'}));}}]);return SummaryPanel;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);;

/***/ }),
/* 380 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SummaryItem; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var SummaryItem=function(_Component){_inherits(SummaryItem,_Component);function SummaryItem(){var _ref;var _temp,_this,_ret;_classCallCheck(this,SummaryItem);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=SummaryItem.__proto__||Object.getPrototypeOf(SummaryItem)).call.apply(_ref,[this].concat(args))),_this),_this.getIconClass=function(){return"fa fa-1x "+_this.props.iconClass;},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(SummaryItem,[{key:"render",value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"widget widget-summary navy-bg  text-center summary-item"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h5",{className:"no-margins"},this.props.title," ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:this.getIconClass()})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h5",{className:"m-xs summary-value"},this.props.value)));}}]);return SummaryItem;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/***/ }),
/* 381 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ChartPanel; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__TimelineChartPanel__ = __webpack_require__(382);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__StackbarChartPanel__ = __webpack_require__(383);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__DonutsChartPanel__ = __webpack_require__(384);
function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ChartPanel=function(_Component){_inherits(ChartPanel,_Component);function ChartPanel(props){_classCallCheck(this,ChartPanel);var _this=_possibleConstructorReturn(this,(ChartPanel.__proto__||Object.getPrototypeOf(ChartPanel)).call(this,props));_this.onSelectChange=function(e){console.log('Hai selezionato il chart: '+e.target.value);_this.setState({selectedChart:e.target.value});};_this.getSelectedChart=function(){switch(_this.state.selectedChart){case'none':return'';case'timeline':return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__TimelineChartPanel__["a" /* TimelineChartPanel */],{routesList:_this.props.routesList});case'stackbar':return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__StackbarChartPanel__["a" /* StackbarChartPanel */],{routesList:_this.props.routesList});case'donuts':return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__DonutsChartPanel__["a" /* DonutsChartPanel */],{routesList:_this.props.routesList});default:return'';}};_this.render=function(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'chart-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__DonutsChartPanel__["a" /* DonutsChartPanel */],{routesList:_this.props.routesList})));};_this.state={selectedChart:'none'};return _this;}return ChartPanel;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/***/ }),
/* 382 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TimelineChartPanel; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_google_charts__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_google_charts___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_google_charts__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var TimelineChartPanel=function(_Component){_inherits(TimelineChartPanel,_Component);function TimelineChartPanel(){var _ref;var _temp,_this,_ret;_classCallCheck(this,TimelineChartPanel);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=TimelineChartPanel.__proto__||Object.getPrototypeOf(TimelineChartPanel)).call.apply(_ref,[this].concat(args))),_this),_this.isDataPresent=function(){if(_this.props.routesList.filter(function(route){return route.selected;}).length>0){return true;}else{return false;}},_this.getCols=function(){return[{type:'string',label:'Type'},{type:'string',label:'barLabel'},{type:'date',label:'start'},{type:'date',label:'end'}];},_this.getChartData=function(){var _chartData=[];//_chartData.push(['Ident','bar', 'Start', 'End']);
_this.props.routesList.filter(function(route){return route.selected;}).map(function(route,index){_chartData.push(['Transito',route.from.name+' - '+route.to.name,route.startDate,route.endDate]);return null;});return _chartData;},_this.getChartColors=function(){return _this.props.routesList.filter(function(route){return route.selected;}).map(function(route,index){return''+route.pathColor;});},_this.getChart=function(){if(_this.isDataPresent()){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_google_charts__["Chart"],{chartType:'Timeline',columns:_this.getCols(),rows:_this.getChartData(),options:{colors:_this.getChartColors(),timeline:{rowLabelStyle:{fontName:'Open Sans',fontSize:12,color:'#603913'},barLabelStyle:{fontName:'Open Sans',fontSize:10},showRowLabels:false,showBarLabels:true},tooltip:{isHtml:true}},graph_id:'TimelineChart',width:'100%',height:'160px',legend_toggle:true});}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null);}},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(TimelineChartPanel,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'my-pretty-chart-container'},this.getChart());}}]);return TimelineChartPanel;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);;

/***/ }),
/* 383 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return StackbarChartPanel; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_google_charts__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_google_charts___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_google_charts__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var StackbarChartPanel=function(_Component){_inherits(StackbarChartPanel,_Component);function StackbarChartPanel(){var _ref;var _temp,_this,_ret;_classCallCheck(this,StackbarChartPanel);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=StackbarChartPanel.__proto__||Object.getPrototypeOf(StackbarChartPanel)).call.apply(_ref,[this].concat(args))),_this),_this.isDataPresent=function(){if(_this.props.routesList.filter(function(route){return route.selected;}).length>0){return true;}else{return false;}},_this.getCols=function(){var cols=[];cols.push({label:'Id',type:'string'});_this.props.routesList.filter(function(route){return route.selected;}).map(function(route,index){cols.push({label:route.from.name+" - "+route.to.name,type:'number'});return null;});return cols;},_this.getChartData=function(){var chartData=[];chartData.push('Drive');_this.props.routesList.filter(function(route){return route.selected;}).map(function(route,index){//chartData.push(Math.floor(Math.random() * (10 - 1 + 1)) + 1);
chartData.push(route.endDate.getHours()-route.startDate.getHours());return null;});return[chartData];},_this.getChartColors=function(){return _this.props.routesList.filter(function(route){return route.selected;}).map(function(route,index){return''+route.pathColor;});},_this.getChart=function(){if(_this.isDataPresent()){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_google_charts__["Chart"],{chartType:'BarChart',columns:_this.getCols(),rows:_this.getChartData(),options:{legend:{position:'top',maxLines:2},bar:{groupWidth:'75%'},isStacked:true,colors:_this.getChartColors()},graph_id:'BarChart',width:'100%',height:'160px'});}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null);}},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(StackbarChartPanel,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'my-pretty-chart-container'},this.getChart());}}]);return StackbarChartPanel;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);;

/***/ }),
/* 384 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DonutsChartPanel; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_google_charts__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_google_charts___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_google_charts__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var DonutsChartPanel=function(_Component){_inherits(DonutsChartPanel,_Component);function DonutsChartPanel(){var _ref;var _temp,_this,_ret;_classCallCheck(this,DonutsChartPanel);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=DonutsChartPanel.__proto__||Object.getPrototypeOf(DonutsChartPanel)).call.apply(_ref,[this].concat(args))),_this),_this.isDataPresent=function(){if(_this.props.routesList.filter(function(route){return route.selected;}).length>0){return true;}else{return false;}},_this.getChartColors=function(){return _this.props.routesList.filter(function(route){return route.selected;}).map(function(route,index){return''+route.pathColor;});},_this.getChartData=function(){var totDrive=0;var totDuty=0;var totOff=0;var totTime=0;_this.props.routesList.filter(function(route){return route.selected;}).map(function(route,index){//chartData.push(Math.floor(Math.random() * (10 - 1 + 1)) + 1);
//chartData.push([route.from.name + ' ' + route.to.name, route.endDate.getHours()-route.startDate.getHours()]);
totDrive+=route.drive;totDuty+=route.duty;totOff+=route.off;totTime+=route.time;return null;});var chartData=[['drive (hr)',totDrive],['duty (hr)',totDuty],['off (hr)',totOff],['time (hr)',totTime]];return chartData;},_this.getSecondChartData=function(){var totRevenue=0;var totFuel=0;var totTolls=0;_this.props.routesList.filter(function(route){return route.selected;}).map(function(route,index){//chartData.push(Math.floor(Math.random() * (10 - 1 + 1)) + 1);
//chartData.push([route.from.name + ' ' + route.to.name, route.endDate.getHours()-route.startDate.getHours()]);
totRevenue+=route.revenue;totFuel+=route.fuel;totTolls+=route.tolls;return null;});var chartData=[['revenue ($/hr)',totRevenue],['fuel ($/hr)',totFuel],['tolls ($/hr)',totTolls]];return chartData;},_this.getChart=function(){if(_this.isDataPresent()){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_google_charts__["Chart"],{chartType:'PieChart',rows:_this.getChartData(),columns:[{type:'string',label:'label'},{type:'number',label:'value'}],options:{title:'Time reference',pieHole:0.5,pieSliceTextStyle:{color:'black'}},graph_id:'PieChart',width:'100%',height:'160px'});}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null);}},_this.getSecondChart=function(){if(_this.isDataPresent()){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_google_charts__["Chart"],{chartType:'PieChart',rows:_this.getSecondChartData(),columns:[{type:'string',label:'Age'},{type:'number',label:'Weight'}],options:{title:'Cash reference',pieHole:0.5,pieSliceTextStyle:{color:'black'},colors:['#f4e842','#ffb30f','#ff630f','#af0000']},graph_id:'PieChart2',width:'100%',height:'160px'});}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null);}},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(DonutsChartPanel,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'my-pretty-chart-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["d" /* Col */],{xs:6,sm:6,md:6,lg:6},this.getChart()),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["d" /* Col */],{xs:6,sm:6,md:6,lg:6},this.getSecondChart()),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'clearfix'}));}}]);return DonutsChartPanel;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);;

/***/ }),
/* 385 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ModalChatPanel; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_modal_shim__ = __webpack_require__(71);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ModalChatPanel=function(_Component){_inherits(ModalChatPanel,_Component);function ModalChatPanel(){_classCallCheck(this,ModalChatPanel);return _possibleConstructorReturn(this,(ModalChatPanel.__proto__||Object.getPrototypeOf(ModalChatPanel)).apply(this,arguments));}_createClass(ModalChatPanel,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__lib_modal_shim__["a" /* default */],{show:this.props.showPanel,onHide:this.props.onClose},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__lib_modal_shim__["a" /* default */].Header,{closeButton:true,className:'chat-modal-header'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__lib_modal_shim__["a" /* default */].Title,null,'Chat Panel')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__lib_modal_shim__["a" /* default */].Body,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'chat'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'left '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'chat-img pull-left'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:'http://placehold.it/50/55C1E7/fff&text=U',alt:'User Avatar',className:'img-circle'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'chat-body'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'header'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',{className:'primary-font'},'Jack Sparrow'),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('small',{className:'pull-right text-muted'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'glyphicon glyphicon-time'}),'12 mins ago')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Curabitur bibendum ornare dolor, quis ullamcorper ligula sodales.'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'chat-img pull-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:'http://placehold.it/50/FA6F57/fff&text=ME',alt:'User Avatar',className:'img-circle'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'chat-body'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'header'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('small',{className:' text-muted'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'glyphicon glyphicon-time'}),'13 mins ago'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',{className:'pull-right primary-font'},'Bhaumik Patel')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Curabitur bibendum ornare dolor, quis ullamcorper ligula sodales.'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'left'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'chat-img pull-left'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:'http://placehold.it/50/55C1E7/fff&text=U',alt:'User Avatar',className:'img-circle'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'chat-body'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'header'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',{className:'primary-font'},'Jack Sparrow'),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('small',{className:'pull-right text-muted'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'glyphicon glyphicon-time'}),'14 mins ago')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Curabitur bibendum ornare dolor, quis ullamcorper ligula sodales.'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'chat-img pull-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:'http://placehold.it/50/FA6F57/fff&text=ME',alt:'User Avatar',className:'img-circle'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'chat-body'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'header'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('small',{className:' text-muted'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'glyphicon glyphicon-time'}),'15 mins ago'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',{className:'pull-right primary-font'},'Bhaumik Patel')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Curabitur bibendum ornare dolor, quis ullamcorper ligula sodales.')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'clearfix'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__lib_modal_shim__["a" /* default */].Footer,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('textarea',{className:'form-control',rows:'3'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'col-lg-6 col-lg-offset-3 col-md-6 col-md-offset-3 col-xs-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-warning btn-lg btn-block',id:'btn-chat'},'Send'))));}}]);return ModalChatPanel;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/***/ }),
/* 386 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ModalDriverPanel; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_modal_shim__ = __webpack_require__(71);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ModalDriverPanel=function(_Component){_inherits(ModalDriverPanel,_Component);function ModalDriverPanel(){_classCallCheck(this,ModalDriverPanel);return _possibleConstructorReturn(this,(ModalDriverPanel.__proto__||Object.getPrototypeOf(ModalDriverPanel)).apply(this,arguments));}_createClass(ModalDriverPanel,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__lib_modal_shim__["a" /* default */],{show:this.props.showPanel,onHide:this.props.onClose},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__lib_modal_shim__["a" /* default */].Header,{closeButton:true,className:'chat-modal-header'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__lib_modal_shim__["a" /* default */].Title,null,'Driver Details')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__lib_modal_shim__["a" /* default */].Body,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["m" /* Row */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["d" /* Col */],{lg:12,md:12,sm:12,xs:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'profile-image'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:this.props.data?this.props.data.image:'',className:'img-circle circle-border m-b-md',alt:'profile'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'profile-info'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',{className:'no-margins'},this.props.data?this.props.data.pilotName:''),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',null,'Driver n. 111111'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('small',null,'Simple description or more driver info')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'clearfix'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["d" /* Col */],{lg:6,md:6,sm:6,xs:6},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('dl',{className:'dl-horizontal'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('dt',null,'Name:'),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('dd',null,this.props.data?this.props.data.pilotName:''),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('dt',null,'License n.:'),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('dd',null,'12345678 '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('dt',null,'License date:'),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('dd',null,'01/01/2000'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["d" /* Col */],{lg:6,md:6,sm:6,xs:6},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('dl',{className:'dl-horizontal'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('dt',null,'Special license:'),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('dd',null,'hazardous material'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('dt',null,'Truck n. :'),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('dd',null,'22222'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["d" /* Col */],{lg:12,md:12,sm:12,xs:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:'img/driver-license.jpg',className:'img-responsive',alt:'license'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["d" /* Col */],{lg:12,md:12,sm:12,xs:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'file-manager'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5',null,'File attached'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'folder-list'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:''},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-file-pdf-o'}),' Driver license')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:''},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-file-word-o'}),' Cargo documentation')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:''},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-file-pdf-o'}),' Hazardous special license')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:''},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-file-pdf-o'}),' Shipment Receipt')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:''},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-file-word-o'}),' File')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:''},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-file-pdf-o'}),' File'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'clearfix'}))))));}}]);return ModalDriverPanel;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/***/ }),
/* 387 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MessagePanelSmall; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__ = __webpack_require__(13);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var MessagePanelSmall=function(_Component){_inherits(MessagePanelSmall,_Component);function MessagePanelSmall(){_classCallCheck(this,MessagePanelSmall);return _possibleConstructorReturn(this,(MessagePanelSmall.__proto__||Object.getPrototypeOf(MessagePanelSmall)).apply(this,arguments));}_createClass(MessagePanelSmall,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ibox float-e-margins'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ibox-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5',null,'Messages')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ibox-content ibox-heading'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-envelope-o'}),' New messages'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('small',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-tim'}),' You have 22 new messages and 16 waiting in draft folder.')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ibox-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'feed-activity-list'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'feed-element'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('small',{className:'pull-right text-navy'},'1m ago'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'System Message'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'Driver Jose Gutierrez is 45 minutes ahead of schedule. Dropoff location notified and will try and unload early.'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'feed-element'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('small',{className:'pull-right'},'2m ago'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'Email:\xA0john.schwarz@insuranceco.com\xA0'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'Subject: I uploaded New Certificates of Insurance for Driver Margaret Johnson to NXXT'))))));}}]);return MessagePanelSmall;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/***/ }),
/* 388 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__BrowserRouter__ = __webpack_require__(389);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__BrowserRouter__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__HashRouter__ = __webpack_require__(391);
/* unused harmony reexport HashRouter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Link__ = __webpack_require__(177);
/* unused harmony reexport Link */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__MemoryRouter__ = __webpack_require__(393);
/* unused harmony reexport MemoryRouter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__NavLink__ = __webpack_require__(396);
/* unused harmony reexport NavLink */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Prompt__ = __webpack_require__(399);
/* unused harmony reexport Prompt */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Redirect__ = __webpack_require__(401);
/* unused harmony reexport Redirect */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Route__ = __webpack_require__(178);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_7__Route__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Router__ = __webpack_require__(107);
/* unused harmony reexport Router */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__StaticRouter__ = __webpack_require__(407);
/* unused harmony reexport StaticRouter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Switch__ = __webpack_require__(409);
/* unused harmony reexport Switch */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__matchPath__ = __webpack_require__(411);
/* unused harmony reexport matchPath */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__withRouter__ = __webpack_require__(412);
/* unused harmony reexport withRouter */



























/***/ }),
/* 389 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history_createBrowserHistory__ = __webpack_require__(390);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history_createBrowserHistory___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_history_createBrowserHistory__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Router__ = __webpack_require__(107);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for a <Router> that uses HTML5 history.
 */

var BrowserRouter = function (_React$Component) {
  _inherits(BrowserRouter, _React$Component);

  function BrowserRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, BrowserRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = __WEBPACK_IMPORTED_MODULE_3_history_createBrowserHistory___default()(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
  }

  BrowserRouter.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!this.props.history, '<BrowserRouter> ignores the history prop. To use a custom history, ' + 'use `import { Router }` instead of `import { BrowserRouter as Router }`.');
  };

  BrowserRouter.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Router__["a" /* default */], { history: this.history, children: this.props.children });
  };

  return BrowserRouter;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

BrowserRouter.propTypes = {
  basename: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
  forceRefresh: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
  getUserConfirmation: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  keyLength: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node
};


/* harmony default export */ __webpack_exports__["a"] = (BrowserRouter);

/***/ }),
/* 390 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _warning = __webpack_require__(11);

var _warning2 = _interopRequireDefault(_warning);

var _invariant = __webpack_require__(17);

var _invariant2 = _interopRequireDefault(_invariant);

var _LocationUtils = __webpack_require__(105);

var _PathUtils = __webpack_require__(52);

var _createTransitionManager = __webpack_require__(106);

var _createTransitionManager2 = _interopRequireDefault(_createTransitionManager);

var _DOMUtils = __webpack_require__(176);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PopStateEvent = 'popstate';
var HashChangeEvent = 'hashchange';

var getHistoryState = function getHistoryState() {
  try {
    return window.history.state || {};
  } catch (e) {
    // IE 11 sometimes throws when accessing window.history.state
    // See https://github.com/ReactTraining/history/pull/289
    return {};
  }
};

/**
 * Creates a history object that uses the HTML5 history API including
 * pushState, replaceState, and the popstate event.
 */
var createBrowserHistory = function createBrowserHistory() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  (0, _invariant2.default)(_DOMUtils.canUseDOM, 'Browser history needs a DOM');

  var globalHistory = window.history;
  var canUseHistory = (0, _DOMUtils.supportsHistory)();
  var needsHashChangeListener = !(0, _DOMUtils.supportsPopStateOnHashChange)();

  var _props$forceRefresh = props.forceRefresh,
      forceRefresh = _props$forceRefresh === undefined ? false : _props$forceRefresh,
      _props$getUserConfirm = props.getUserConfirmation,
      getUserConfirmation = _props$getUserConfirm === undefined ? _DOMUtils.getConfirmation : _props$getUserConfirm,
      _props$keyLength = props.keyLength,
      keyLength = _props$keyLength === undefined ? 6 : _props$keyLength;

  var basename = props.basename ? (0, _PathUtils.stripTrailingSlash)((0, _PathUtils.addLeadingSlash)(props.basename)) : '';

  var getDOMLocation = function getDOMLocation(historyState) {
    var _ref = historyState || {},
        key = _ref.key,
        state = _ref.state;

    var _window$location = window.location,
        pathname = _window$location.pathname,
        search = _window$location.search,
        hash = _window$location.hash;


    var path = pathname + search + hash;

    (0, _warning2.default)(!basename || (0, _PathUtils.hasBasename)(path, basename), 'You are attempting to use a basename on a page whose URL path does not begin ' + 'with the basename. Expected path "' + path + '" to begin with "' + basename + '".');

    if (basename) path = (0, _PathUtils.stripBasename)(path, basename);

    return (0, _LocationUtils.createLocation)(path, state, key);
  };

  var createKey = function createKey() {
    return Math.random().toString(36).substr(2, keyLength);
  };

  var transitionManager = (0, _createTransitionManager2.default)();

  var setState = function setState(nextState) {
    _extends(history, nextState);

    history.length = globalHistory.length;

    transitionManager.notifyListeners(history.location, history.action);
  };

  var handlePopState = function handlePopState(event) {
    // Ignore extraneous popstate events in WebKit.
    if ((0, _DOMUtils.isExtraneousPopstateEvent)(event)) return;

    handlePop(getDOMLocation(event.state));
  };

  var handleHashChange = function handleHashChange() {
    handlePop(getDOMLocation(getHistoryState()));
  };

  var forceNextPop = false;

  var handlePop = function handlePop(location) {
    if (forceNextPop) {
      forceNextPop = false;
      setState();
    } else {
      var action = 'POP';

      transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
        if (ok) {
          setState({ action: action, location: location });
        } else {
          revertPop(location);
        }
      });
    }
  };

  var revertPop = function revertPop(fromLocation) {
    var toLocation = history.location;

    // TODO: We could probably make this more reliable by
    // keeping a list of keys we've seen in sessionStorage.
    // Instead, we just default to 0 for keys we don't know.

    var toIndex = allKeys.indexOf(toLocation.key);

    if (toIndex === -1) toIndex = 0;

    var fromIndex = allKeys.indexOf(fromLocation.key);

    if (fromIndex === -1) fromIndex = 0;

    var delta = toIndex - fromIndex;

    if (delta) {
      forceNextPop = true;
      go(delta);
    }
  };

  var initialLocation = getDOMLocation(getHistoryState());
  var allKeys = [initialLocation.key];

  // Public interface

  var createHref = function createHref(location) {
    return basename + (0, _PathUtils.createPath)(location);
  };

  var push = function push(path, state) {
    (0, _warning2.default)(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to push when the 1st ' + 'argument is a location-like object that already has state; it is ignored');

    var action = 'PUSH';
    var location = (0, _LocationUtils.createLocation)(path, state, createKey(), history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var href = createHref(location);
      var key = location.key,
          state = location.state;


      if (canUseHistory) {
        globalHistory.pushState({ key: key, state: state }, null, href);

        if (forceRefresh) {
          window.location.href = href;
        } else {
          var prevIndex = allKeys.indexOf(history.location.key);
          var nextKeys = allKeys.slice(0, prevIndex === -1 ? 0 : prevIndex + 1);

          nextKeys.push(location.key);
          allKeys = nextKeys;

          setState({ action: action, location: location });
        }
      } else {
        (0, _warning2.default)(state === undefined, 'Browser history cannot push state in browsers that do not support HTML5 history');

        window.location.href = href;
      }
    });
  };

  var replace = function replace(path, state) {
    (0, _warning2.default)(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to replace when the 1st ' + 'argument is a location-like object that already has state; it is ignored');

    var action = 'REPLACE';
    var location = (0, _LocationUtils.createLocation)(path, state, createKey(), history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var href = createHref(location);
      var key = location.key,
          state = location.state;


      if (canUseHistory) {
        globalHistory.replaceState({ key: key, state: state }, null, href);

        if (forceRefresh) {
          window.location.replace(href);
        } else {
          var prevIndex = allKeys.indexOf(history.location.key);

          if (prevIndex !== -1) allKeys[prevIndex] = location.key;

          setState({ action: action, location: location });
        }
      } else {
        (0, _warning2.default)(state === undefined, 'Browser history cannot replace state in browsers that do not support HTML5 history');

        window.location.replace(href);
      }
    });
  };

  var go = function go(n) {
    globalHistory.go(n);
  };

  var goBack = function goBack() {
    return go(-1);
  };

  var goForward = function goForward() {
    return go(1);
  };

  var listenerCount = 0;

  var checkDOMListeners = function checkDOMListeners(delta) {
    listenerCount += delta;

    if (listenerCount === 1) {
      (0, _DOMUtils.addEventListener)(window, PopStateEvent, handlePopState);

      if (needsHashChangeListener) (0, _DOMUtils.addEventListener)(window, HashChangeEvent, handleHashChange);
    } else if (listenerCount === 0) {
      (0, _DOMUtils.removeEventListener)(window, PopStateEvent, handlePopState);

      if (needsHashChangeListener) (0, _DOMUtils.removeEventListener)(window, HashChangeEvent, handleHashChange);
    }
  };

  var isBlocked = false;

  var block = function block() {
    var prompt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    var unblock = transitionManager.setPrompt(prompt);

    if (!isBlocked) {
      checkDOMListeners(1);
      isBlocked = true;
    }

    return function () {
      if (isBlocked) {
        isBlocked = false;
        checkDOMListeners(-1);
      }

      return unblock();
    };
  };

  var listen = function listen(listener) {
    var unlisten = transitionManager.appendListener(listener);
    checkDOMListeners(1);

    return function () {
      checkDOMListeners(-1);
      unlisten();
    };
  };

  var history = {
    length: globalHistory.length,
    action: 'POP',
    location: initialLocation,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    block: block,
    listen: listen
  };

  return history;
};

exports.default = createBrowserHistory;

/***/ }),
/* 391 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history_createHashHistory__ = __webpack_require__(392);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history_createHashHistory___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_history_createHashHistory__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Router__ = __webpack_require__(107);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for a <Router> that uses window.location.hash.
 */

var HashRouter = function (_React$Component) {
  _inherits(HashRouter, _React$Component);

  function HashRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, HashRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = __WEBPACK_IMPORTED_MODULE_3_history_createHashHistory___default()(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
  }

  HashRouter.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!this.props.history, '<HashRouter> ignores the history prop. To use a custom history, ' + 'use `import { Router }` instead of `import { HashRouter as Router }`.');
  };

  HashRouter.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Router__["a" /* default */], { history: this.history, children: this.props.children });
  };

  return HashRouter;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

HashRouter.propTypes = {
  basename: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
  getUserConfirmation: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  hashType: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOf(['hashbang', 'noslash', 'slash']),
  children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node
};


/* unused harmony default export */ var _unused_webpack_default_export = (HashRouter);

/***/ }),
/* 392 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _warning = __webpack_require__(11);

var _warning2 = _interopRequireDefault(_warning);

var _invariant = __webpack_require__(17);

var _invariant2 = _interopRequireDefault(_invariant);

var _LocationUtils = __webpack_require__(105);

var _PathUtils = __webpack_require__(52);

var _createTransitionManager = __webpack_require__(106);

var _createTransitionManager2 = _interopRequireDefault(_createTransitionManager);

var _DOMUtils = __webpack_require__(176);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HashChangeEvent = 'hashchange';

var HashPathCoders = {
  hashbang: {
    encodePath: function encodePath(path) {
      return path.charAt(0) === '!' ? path : '!/' + (0, _PathUtils.stripLeadingSlash)(path);
    },
    decodePath: function decodePath(path) {
      return path.charAt(0) === '!' ? path.substr(1) : path;
    }
  },
  noslash: {
    encodePath: _PathUtils.stripLeadingSlash,
    decodePath: _PathUtils.addLeadingSlash
  },
  slash: {
    encodePath: _PathUtils.addLeadingSlash,
    decodePath: _PathUtils.addLeadingSlash
  }
};

var getHashPath = function getHashPath() {
  // We can't use window.location.hash here because it's not
  // consistent across browsers - Firefox will pre-decode it!
  var href = window.location.href;
  var hashIndex = href.indexOf('#');
  return hashIndex === -1 ? '' : href.substring(hashIndex + 1);
};

var pushHashPath = function pushHashPath(path) {
  return window.location.hash = path;
};

var replaceHashPath = function replaceHashPath(path) {
  var hashIndex = window.location.href.indexOf('#');

  window.location.replace(window.location.href.slice(0, hashIndex >= 0 ? hashIndex : 0) + '#' + path);
};

var createHashHistory = function createHashHistory() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  (0, _invariant2.default)(_DOMUtils.canUseDOM, 'Hash history needs a DOM');

  var globalHistory = window.history;
  var canGoWithoutReload = (0, _DOMUtils.supportsGoWithoutReloadUsingHash)();

  var _props$getUserConfirm = props.getUserConfirmation,
      getUserConfirmation = _props$getUserConfirm === undefined ? _DOMUtils.getConfirmation : _props$getUserConfirm,
      _props$hashType = props.hashType,
      hashType = _props$hashType === undefined ? 'slash' : _props$hashType;

  var basename = props.basename ? (0, _PathUtils.stripTrailingSlash)((0, _PathUtils.addLeadingSlash)(props.basename)) : '';

  var _HashPathCoders$hashT = HashPathCoders[hashType],
      encodePath = _HashPathCoders$hashT.encodePath,
      decodePath = _HashPathCoders$hashT.decodePath;


  var getDOMLocation = function getDOMLocation() {
    var path = decodePath(getHashPath());

    (0, _warning2.default)(!basename || (0, _PathUtils.hasBasename)(path, basename), 'You are attempting to use a basename on a page whose URL path does not begin ' + 'with the basename. Expected path "' + path + '" to begin with "' + basename + '".');

    if (basename) path = (0, _PathUtils.stripBasename)(path, basename);

    return (0, _LocationUtils.createLocation)(path);
  };

  var transitionManager = (0, _createTransitionManager2.default)();

  var setState = function setState(nextState) {
    _extends(history, nextState);

    history.length = globalHistory.length;

    transitionManager.notifyListeners(history.location, history.action);
  };

  var forceNextPop = false;
  var ignorePath = null;

  var handleHashChange = function handleHashChange() {
    var path = getHashPath();
    var encodedPath = encodePath(path);

    if (path !== encodedPath) {
      // Ensure we always have a properly-encoded hash.
      replaceHashPath(encodedPath);
    } else {
      var location = getDOMLocation();
      var prevLocation = history.location;

      if (!forceNextPop && (0, _LocationUtils.locationsAreEqual)(prevLocation, location)) return; // A hashchange doesn't always == location change.

      if (ignorePath === (0, _PathUtils.createPath)(location)) return; // Ignore this change; we already setState in push/replace.

      ignorePath = null;

      handlePop(location);
    }
  };

  var handlePop = function handlePop(location) {
    if (forceNextPop) {
      forceNextPop = false;
      setState();
    } else {
      var action = 'POP';

      transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
        if (ok) {
          setState({ action: action, location: location });
        } else {
          revertPop(location);
        }
      });
    }
  };

  var revertPop = function revertPop(fromLocation) {
    var toLocation = history.location;

    // TODO: We could probably make this more reliable by
    // keeping a list of paths we've seen in sessionStorage.
    // Instead, we just default to 0 for paths we don't know.

    var toIndex = allPaths.lastIndexOf((0, _PathUtils.createPath)(toLocation));

    if (toIndex === -1) toIndex = 0;

    var fromIndex = allPaths.lastIndexOf((0, _PathUtils.createPath)(fromLocation));

    if (fromIndex === -1) fromIndex = 0;

    var delta = toIndex - fromIndex;

    if (delta) {
      forceNextPop = true;
      go(delta);
    }
  };

  // Ensure the hash is encoded properly before doing anything else.
  var path = getHashPath();
  var encodedPath = encodePath(path);

  if (path !== encodedPath) replaceHashPath(encodedPath);

  var initialLocation = getDOMLocation();
  var allPaths = [(0, _PathUtils.createPath)(initialLocation)];

  // Public interface

  var createHref = function createHref(location) {
    return '#' + encodePath(basename + (0, _PathUtils.createPath)(location));
  };

  var push = function push(path, state) {
    (0, _warning2.default)(state === undefined, 'Hash history cannot push state; it is ignored');

    var action = 'PUSH';
    var location = (0, _LocationUtils.createLocation)(path, undefined, undefined, history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var path = (0, _PathUtils.createPath)(location);
      var encodedPath = encodePath(basename + path);
      var hashChanged = getHashPath() !== encodedPath;

      if (hashChanged) {
        // We cannot tell if a hashchange was caused by a PUSH, so we'd
        // rather setState here and ignore the hashchange. The caveat here
        // is that other hash histories in the page will consider it a POP.
        ignorePath = path;
        pushHashPath(encodedPath);

        var prevIndex = allPaths.lastIndexOf((0, _PathUtils.createPath)(history.location));
        var nextPaths = allPaths.slice(0, prevIndex === -1 ? 0 : prevIndex + 1);

        nextPaths.push(path);
        allPaths = nextPaths;

        setState({ action: action, location: location });
      } else {
        (0, _warning2.default)(false, 'Hash history cannot PUSH the same path; a new entry will not be added to the history stack');

        setState();
      }
    });
  };

  var replace = function replace(path, state) {
    (0, _warning2.default)(state === undefined, 'Hash history cannot replace state; it is ignored');

    var action = 'REPLACE';
    var location = (0, _LocationUtils.createLocation)(path, undefined, undefined, history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var path = (0, _PathUtils.createPath)(location);
      var encodedPath = encodePath(basename + path);
      var hashChanged = getHashPath() !== encodedPath;

      if (hashChanged) {
        // We cannot tell if a hashchange was caused by a REPLACE, so we'd
        // rather setState here and ignore the hashchange. The caveat here
        // is that other hash histories in the page will consider it a POP.
        ignorePath = path;
        replaceHashPath(encodedPath);
      }

      var prevIndex = allPaths.indexOf((0, _PathUtils.createPath)(history.location));

      if (prevIndex !== -1) allPaths[prevIndex] = path;

      setState({ action: action, location: location });
    });
  };

  var go = function go(n) {
    (0, _warning2.default)(canGoWithoutReload, 'Hash history go(n) causes a full page reload in this browser');

    globalHistory.go(n);
  };

  var goBack = function goBack() {
    return go(-1);
  };

  var goForward = function goForward() {
    return go(1);
  };

  var listenerCount = 0;

  var checkDOMListeners = function checkDOMListeners(delta) {
    listenerCount += delta;

    if (listenerCount === 1) {
      (0, _DOMUtils.addEventListener)(window, HashChangeEvent, handleHashChange);
    } else if (listenerCount === 0) {
      (0, _DOMUtils.removeEventListener)(window, HashChangeEvent, handleHashChange);
    }
  };

  var isBlocked = false;

  var block = function block() {
    var prompt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    var unblock = transitionManager.setPrompt(prompt);

    if (!isBlocked) {
      checkDOMListeners(1);
      isBlocked = true;
    }

    return function () {
      if (isBlocked) {
        isBlocked = false;
        checkDOMListeners(-1);
      }

      return unblock();
    };
  };

  var listen = function listen(listener) {
    var unlisten = transitionManager.appendListener(listener);
    checkDOMListeners(1);

    return function () {
      checkDOMListeners(-1);
      unlisten();
    };
  };

  var history = {
    length: globalHistory.length,
    action: 'POP',
    location: initialLocation,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    block: block,
    listen: listen
  };

  return history;
};

exports.default = createHashHistory;

/***/ }),
/* 393 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_MemoryRouter__ = __webpack_require__(394);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_MemoryRouter__["a" /* default */]);

/***/ }),
/* 394 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history_createMemoryHistory__ = __webpack_require__(395);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history_createMemoryHistory___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_history_createMemoryHistory__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Router__ = __webpack_require__(108);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for a <Router> that stores location in memory.
 */

var MemoryRouter = function (_React$Component) {
  _inherits(MemoryRouter, _React$Component);

  function MemoryRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, MemoryRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = __WEBPACK_IMPORTED_MODULE_3_history_createMemoryHistory___default()(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
  }

  MemoryRouter.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!this.props.history, '<MemoryRouter> ignores the history prop. To use a custom history, ' + 'use `import { Router }` instead of `import { MemoryRouter as Router }`.');
  };

  MemoryRouter.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Router__["a" /* default */], { history: this.history, children: this.props.children });
  };

  return MemoryRouter;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

MemoryRouter.propTypes = {
  initialEntries: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array,
  initialIndex: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  getUserConfirmation: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  keyLength: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node
};


/* harmony default export */ __webpack_exports__["a"] = (MemoryRouter);

/***/ }),
/* 395 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _warning = __webpack_require__(11);

var _warning2 = _interopRequireDefault(_warning);

var _PathUtils = __webpack_require__(52);

var _LocationUtils = __webpack_require__(105);

var _createTransitionManager = __webpack_require__(106);

var _createTransitionManager2 = _interopRequireDefault(_createTransitionManager);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var clamp = function clamp(n, lowerBound, upperBound) {
  return Math.min(Math.max(n, lowerBound), upperBound);
};

/**
 * Creates a history object that stores locations in memory.
 */
var createMemoryHistory = function createMemoryHistory() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var getUserConfirmation = props.getUserConfirmation,
      _props$initialEntries = props.initialEntries,
      initialEntries = _props$initialEntries === undefined ? ['/'] : _props$initialEntries,
      _props$initialIndex = props.initialIndex,
      initialIndex = _props$initialIndex === undefined ? 0 : _props$initialIndex,
      _props$keyLength = props.keyLength,
      keyLength = _props$keyLength === undefined ? 6 : _props$keyLength;


  var transitionManager = (0, _createTransitionManager2.default)();

  var setState = function setState(nextState) {
    _extends(history, nextState);

    history.length = history.entries.length;

    transitionManager.notifyListeners(history.location, history.action);
  };

  var createKey = function createKey() {
    return Math.random().toString(36).substr(2, keyLength);
  };

  var index = clamp(initialIndex, 0, initialEntries.length - 1);
  var entries = initialEntries.map(function (entry) {
    return typeof entry === 'string' ? (0, _LocationUtils.createLocation)(entry, undefined, createKey()) : (0, _LocationUtils.createLocation)(entry, undefined, entry.key || createKey());
  });

  // Public interface

  var createHref = _PathUtils.createPath;

  var push = function push(path, state) {
    (0, _warning2.default)(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to push when the 1st ' + 'argument is a location-like object that already has state; it is ignored');

    var action = 'PUSH';
    var location = (0, _LocationUtils.createLocation)(path, state, createKey(), history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var prevIndex = history.index;
      var nextIndex = prevIndex + 1;

      var nextEntries = history.entries.slice(0);
      if (nextEntries.length > nextIndex) {
        nextEntries.splice(nextIndex, nextEntries.length - nextIndex, location);
      } else {
        nextEntries.push(location);
      }

      setState({
        action: action,
        location: location,
        index: nextIndex,
        entries: nextEntries
      });
    });
  };

  var replace = function replace(path, state) {
    (0, _warning2.default)(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to replace when the 1st ' + 'argument is a location-like object that already has state; it is ignored');

    var action = 'REPLACE';
    var location = (0, _LocationUtils.createLocation)(path, state, createKey(), history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      history.entries[history.index] = location;

      setState({ action: action, location: location });
    });
  };

  var go = function go(n) {
    var nextIndex = clamp(history.index + n, 0, history.entries.length - 1);

    var action = 'POP';
    var location = history.entries[nextIndex];

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (ok) {
        setState({
          action: action,
          location: location,
          index: nextIndex
        });
      } else {
        // Mimic the behavior of DOM histories by
        // causing a render after a cancelled POP.
        setState();
      }
    });
  };

  var goBack = function goBack() {
    return go(-1);
  };

  var goForward = function goForward() {
    return go(1);
  };

  var canGo = function canGo(n) {
    var nextIndex = history.index + n;
    return nextIndex >= 0 && nextIndex < history.entries.length;
  };

  var block = function block() {
    var prompt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    return transitionManager.setPrompt(prompt);
  };

  var listen = function listen(listener) {
    return transitionManager.appendListener(listener);
  };

  var history = {
    length: entries.length,
    action: 'POP',
    location: entries[index],
    index: index,
    entries: entries,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    canGo: canGo,
    block: block,
    listen: listen
  };

  return history;
};

exports.default = createMemoryHistory;

/***/ }),
/* 396 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Route__ = __webpack_require__(178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Link__ = __webpack_require__(177);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }






/**
 * A <Link> wrapper that knows if it's "active" or not.
 */
var NavLink = function NavLink(_ref) {
  var to = _ref.to,
      exact = _ref.exact,
      strict = _ref.strict,
      location = _ref.location,
      activeClassName = _ref.activeClassName,
      className = _ref.className,
      activeStyle = _ref.activeStyle,
      style = _ref.style,
      getIsActive = _ref.isActive,
      ariaCurrent = _ref.ariaCurrent,
      rest = _objectWithoutProperties(_ref, ['to', 'exact', 'strict', 'location', 'activeClassName', 'className', 'activeStyle', 'style', 'isActive', 'ariaCurrent']);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Route__["a" /* default */], {
    path: (typeof to === 'undefined' ? 'undefined' : _typeof(to)) === 'object' ? to.pathname : to,
    exact: exact,
    strict: strict,
    location: location,
    children: function children(_ref2) {
      var location = _ref2.location,
          match = _ref2.match;

      var isActive = !!(getIsActive ? getIsActive(match, location) : match);

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Link__["a" /* default */], _extends({
        to: to,
        className: isActive ? [className, activeClassName].filter(function (i) {
          return i;
        }).join(' ') : className,
        style: isActive ? _extends({}, style, activeStyle) : style,
        'aria-current': isActive && ariaCurrent
      }, rest));
    }
  });
};

NavLink.propTypes = {
  to: __WEBPACK_IMPORTED_MODULE_3__Link__["a" /* default */].propTypes.to,
  exact: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  strict: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  location: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  activeClassName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  activeStyle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  style: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  isActive: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  ariaCurrent: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['page', 'step', 'location', 'true'])
};

NavLink.defaultProps = {
  activeClassName: 'active',
  ariaCurrent: 'true'
};

/* unused harmony default export */ var _unused_webpack_default_export = (NavLink);

/***/ }),
/* 397 */
/***/ (function(module, exports, __webpack_require__) {

var isarray = __webpack_require__(398)

/**
 * Expose `pathToRegexp`.
 */
module.exports = pathToRegexp
module.exports.parse = parse
module.exports.compile = compile
module.exports.tokensToFunction = tokensToFunction
module.exports.tokensToRegExp = tokensToRegExp

/**
 * The main path matching regexp utility.
 *
 * @type {RegExp}
 */
var PATH_REGEXP = new RegExp([
  // Match escaped characters that would otherwise appear in future matches.
  // This allows the user to escape special characters that won't transform.
  '(\\\\.)',
  // Match Express-style parameters and un-named parameters with a prefix
  // and optional suffixes. Matches appear as:
  //
  // "/:test(\\d+)?" => ["/", "test", "\d+", undefined, "?", undefined]
  // "/route(\\d+)"  => [undefined, undefined, undefined, "\d+", undefined, undefined]
  // "/*"            => ["/", undefined, undefined, undefined, undefined, "*"]
  '([\\/.])?(?:(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?|(\\*))'
].join('|'), 'g')

/**
 * Parse a string for the raw tokens.
 *
 * @param  {string}  str
 * @param  {Object=} options
 * @return {!Array}
 */
function parse (str, options) {
  var tokens = []
  var key = 0
  var index = 0
  var path = ''
  var defaultDelimiter = options && options.delimiter || '/'
  var res

  while ((res = PATH_REGEXP.exec(str)) != null) {
    var m = res[0]
    var escaped = res[1]
    var offset = res.index
    path += str.slice(index, offset)
    index = offset + m.length

    // Ignore already escaped sequences.
    if (escaped) {
      path += escaped[1]
      continue
    }

    var next = str[index]
    var prefix = res[2]
    var name = res[3]
    var capture = res[4]
    var group = res[5]
    var modifier = res[6]
    var asterisk = res[7]

    // Push the current path onto the tokens.
    if (path) {
      tokens.push(path)
      path = ''
    }

    var partial = prefix != null && next != null && next !== prefix
    var repeat = modifier === '+' || modifier === '*'
    var optional = modifier === '?' || modifier === '*'
    var delimiter = res[2] || defaultDelimiter
    var pattern = capture || group

    tokens.push({
      name: name || key++,
      prefix: prefix || '',
      delimiter: delimiter,
      optional: optional,
      repeat: repeat,
      partial: partial,
      asterisk: !!asterisk,
      pattern: pattern ? escapeGroup(pattern) : (asterisk ? '.*' : '[^' + escapeString(delimiter) + ']+?')
    })
  }

  // Match any characters still remaining.
  if (index < str.length) {
    path += str.substr(index)
  }

  // If the path exists, push it onto the end.
  if (path) {
    tokens.push(path)
  }

  return tokens
}

/**
 * Compile a string to a template function for the path.
 *
 * @param  {string}             str
 * @param  {Object=}            options
 * @return {!function(Object=, Object=)}
 */
function compile (str, options) {
  return tokensToFunction(parse(str, options))
}

/**
 * Prettier encoding of URI path segments.
 *
 * @param  {string}
 * @return {string}
 */
function encodeURIComponentPretty (str) {
  return encodeURI(str).replace(/[\/?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Encode the asterisk parameter. Similar to `pretty`, but allows slashes.
 *
 * @param  {string}
 * @return {string}
 */
function encodeAsterisk (str) {
  return encodeURI(str).replace(/[?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Expose a method for transforming tokens into the path function.
 */
function tokensToFunction (tokens) {
  // Compile all the tokens into regexps.
  var matches = new Array(tokens.length)

  // Compile all the patterns before compilation.
  for (var i = 0; i < tokens.length; i++) {
    if (typeof tokens[i] === 'object') {
      matches[i] = new RegExp('^(?:' + tokens[i].pattern + ')$')
    }
  }

  return function (obj, opts) {
    var path = ''
    var data = obj || {}
    var options = opts || {}
    var encode = options.pretty ? encodeURIComponentPretty : encodeURIComponent

    for (var i = 0; i < tokens.length; i++) {
      var token = tokens[i]

      if (typeof token === 'string') {
        path += token

        continue
      }

      var value = data[token.name]
      var segment

      if (value == null) {
        if (token.optional) {
          // Prepend partial segment prefixes.
          if (token.partial) {
            path += token.prefix
          }

          continue
        } else {
          throw new TypeError('Expected "' + token.name + '" to be defined')
        }
      }

      if (isarray(value)) {
        if (!token.repeat) {
          throw new TypeError('Expected "' + token.name + '" to not repeat, but received `' + JSON.stringify(value) + '`')
        }

        if (value.length === 0) {
          if (token.optional) {
            continue
          } else {
            throw new TypeError('Expected "' + token.name + '" to not be empty')
          }
        }

        for (var j = 0; j < value.length; j++) {
          segment = encode(value[j])

          if (!matches[i].test(segment)) {
            throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '", but received `' + JSON.stringify(segment) + '`')
          }

          path += (j === 0 ? token.prefix : token.delimiter) + segment
        }

        continue
      }

      segment = token.asterisk ? encodeAsterisk(value) : encode(value)

      if (!matches[i].test(segment)) {
        throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but received "' + segment + '"')
      }

      path += token.prefix + segment
    }

    return path
  }
}

/**
 * Escape a regular expression string.
 *
 * @param  {string} str
 * @return {string}
 */
function escapeString (str) {
  return str.replace(/([.+*?=^!:${}()[\]|\/\\])/g, '\\$1')
}

/**
 * Escape the capturing group by escaping special characters and meaning.
 *
 * @param  {string} group
 * @return {string}
 */
function escapeGroup (group) {
  return group.replace(/([=!:$\/()])/g, '\\$1')
}

/**
 * Attach the keys as a property of the regexp.
 *
 * @param  {!RegExp} re
 * @param  {Array}   keys
 * @return {!RegExp}
 */
function attachKeys (re, keys) {
  re.keys = keys
  return re
}

/**
 * Get the flags for a regexp from the options.
 *
 * @param  {Object} options
 * @return {string}
 */
function flags (options) {
  return options.sensitive ? '' : 'i'
}

/**
 * Pull out keys from a regexp.
 *
 * @param  {!RegExp} path
 * @param  {!Array}  keys
 * @return {!RegExp}
 */
function regexpToRegexp (path, keys) {
  // Use a negative lookahead to match only capturing groups.
  var groups = path.source.match(/\((?!\?)/g)

  if (groups) {
    for (var i = 0; i < groups.length; i++) {
      keys.push({
        name: i,
        prefix: null,
        delimiter: null,
        optional: false,
        repeat: false,
        partial: false,
        asterisk: false,
        pattern: null
      })
    }
  }

  return attachKeys(path, keys)
}

/**
 * Transform an array into a regexp.
 *
 * @param  {!Array}  path
 * @param  {Array}   keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function arrayToRegexp (path, keys, options) {
  var parts = []

  for (var i = 0; i < path.length; i++) {
    parts.push(pathToRegexp(path[i], keys, options).source)
  }

  var regexp = new RegExp('(?:' + parts.join('|') + ')', flags(options))

  return attachKeys(regexp, keys)
}

/**
 * Create a path regexp from string input.
 *
 * @param  {string}  path
 * @param  {!Array}  keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function stringToRegexp (path, keys, options) {
  return tokensToRegExp(parse(path, options), keys, options)
}

/**
 * Expose a function for taking tokens and returning a RegExp.
 *
 * @param  {!Array}          tokens
 * @param  {(Array|Object)=} keys
 * @param  {Object=}         options
 * @return {!RegExp}
 */
function tokensToRegExp (tokens, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options)
    keys = []
  }

  options = options || {}

  var strict = options.strict
  var end = options.end !== false
  var route = ''

  // Iterate over the tokens and create our regexp string.
  for (var i = 0; i < tokens.length; i++) {
    var token = tokens[i]

    if (typeof token === 'string') {
      route += escapeString(token)
    } else {
      var prefix = escapeString(token.prefix)
      var capture = '(?:' + token.pattern + ')'

      keys.push(token)

      if (token.repeat) {
        capture += '(?:' + prefix + capture + ')*'
      }

      if (token.optional) {
        if (!token.partial) {
          capture = '(?:' + prefix + '(' + capture + '))?'
        } else {
          capture = prefix + '(' + capture + ')?'
        }
      } else {
        capture = prefix + '(' + capture + ')'
      }

      route += capture
    }
  }

  var delimiter = escapeString(options.delimiter || '/')
  var endsWithDelimiter = route.slice(-delimiter.length) === delimiter

  // In non-strict mode we allow a slash at the end of match. If the path to
  // match already ends with a slash, we remove it for consistency. The slash
  // is valid at the end of a path match, not in the middle. This is important
  // in non-ending mode, where "/test/" shouldn't match "/test//route".
  if (!strict) {
    route = (endsWithDelimiter ? route.slice(0, -delimiter.length) : route) + '(?:' + delimiter + '(?=$))?'
  }

  if (end) {
    route += '$'
  } else {
    // In non-ending mode, we need the capturing groups to match as much as
    // possible by using a positive lookahead to the end or next path segment.
    route += strict && endsWithDelimiter ? '' : '(?=' + delimiter + '|$)'
  }

  return attachKeys(new RegExp('^' + route, flags(options)), keys)
}

/**
 * Normalize the given path string, returning a regular expression.
 *
 * An empty array can be passed in for the keys, which will hold the
 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
 *
 * @param  {(string|RegExp|Array)} path
 * @param  {(Array|Object)=}       keys
 * @param  {Object=}               options
 * @return {!RegExp}
 */
function pathToRegexp (path, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options)
    keys = []
  }

  options = options || {}

  if (path instanceof RegExp) {
    return regexpToRegexp(path, /** @type {!Array} */ (keys))
  }

  if (isarray(path)) {
    return arrayToRegexp(/** @type {!Array} */ (path), /** @type {!Array} */ (keys), options)
  }

  return stringToRegexp(/** @type {string} */ (path), /** @type {!Array} */ (keys), options)
}


/***/ }),
/* 398 */
/***/ (function(module, exports) {

module.exports = Array.isArray || function (arr) {
  return Object.prototype.toString.call(arr) == '[object Array]';
};


/***/ }),
/* 399 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Prompt__ = __webpack_require__(400);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Prompt__["a" /* default */]);

/***/ }),
/* 400 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_invariant__);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





/**
 * The public API for prompting the user before navigating away
 * from a screen with a component.
 */

var Prompt = function (_React$Component) {
  _inherits(Prompt, _React$Component);

  function Prompt() {
    _classCallCheck(this, Prompt);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  Prompt.prototype.enable = function enable(message) {
    if (this.unblock) this.unblock();

    this.unblock = this.context.router.history.block(message);
  };

  Prompt.prototype.disable = function disable() {
    if (this.unblock) {
      this.unblock();
      this.unblock = null;
    }
  };

  Prompt.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_2_invariant___default()(this.context.router, 'You should not use <Prompt> outside a <Router>');

    if (this.props.when) this.enable(this.props.message);
  };

  Prompt.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if (nextProps.when) {
      if (!this.props.when || this.props.message !== nextProps.message) this.enable(nextProps.message);
    } else {
      this.disable();
    }
  };

  Prompt.prototype.componentWillUnmount = function componentWillUnmount() {
    this.disable();
  };

  Prompt.prototype.render = function render() {
    return null;
  };

  return Prompt;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Prompt.propTypes = {
  when: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  message: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]).isRequired
};
Prompt.defaultProps = {
  when: true
};
Prompt.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      block: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
    }).isRequired
  }).isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Prompt);

/***/ }),
/* 401 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Redirect__ = __webpack_require__(402);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Redirect__["a" /* default */]);

/***/ }),
/* 402 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_warning__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_history__ = __webpack_require__(403);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for updating the location programmatically
 * with a component.
 */

var Redirect = function (_React$Component) {
  _inherits(Redirect, _React$Component);

  function Redirect() {
    _classCallCheck(this, Redirect);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  Redirect.prototype.isStatic = function isStatic() {
    return this.context.router && this.context.router.staticContext;
  };

  Redirect.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_3_invariant___default()(this.context.router, 'You should not use <Redirect> outside a <Router>');

    if (this.isStatic()) this.perform();
  };

  Redirect.prototype.componentDidMount = function componentDidMount() {
    if (!this.isStatic()) this.perform();
  };

  Redirect.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
    var prevTo = Object(__WEBPACK_IMPORTED_MODULE_4_history__["a" /* createLocation */])(prevProps.to);
    var nextTo = Object(__WEBPACK_IMPORTED_MODULE_4_history__["a" /* createLocation */])(this.props.to);

    if (Object(__WEBPACK_IMPORTED_MODULE_4_history__["b" /* locationsAreEqual */])(prevTo, nextTo)) {
      __WEBPACK_IMPORTED_MODULE_2_warning___default()(false, 'You tried to redirect to the same route you\'re currently on: ' + ('"' + nextTo.pathname + nextTo.search + '"'));
      return;
    }

    this.perform();
  };

  Redirect.prototype.perform = function perform() {
    var history = this.context.router.history;
    var _props = this.props,
        push = _props.push,
        to = _props.to;


    if (push) {
      history.push(to);
    } else {
      history.replace(to);
    }
  };

  Redirect.prototype.render = function render() {
    return null;
  };

  return Redirect;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Redirect.propTypes = {
  push: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  from: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  to: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object]).isRequired
};
Redirect.defaultProps = {
  push: false
};
Redirect.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      push: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
      replace: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
    }).isRequired,
    staticContext: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
  }).isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Redirect);

/***/ }),
/* 403 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createBrowserHistory__ = __webpack_require__(404);
/* unused harmony reexport createBrowserHistory */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__createHashHistory__ = __webpack_require__(405);
/* unused harmony reexport createHashHistory */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__createMemoryHistory__ = __webpack_require__(406);
/* unused harmony reexport createMemoryHistory */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__LocationUtils__ = __webpack_require__(72);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_3__LocationUtils__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_3__LocationUtils__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__PathUtils__ = __webpack_require__(53);
/* unused harmony reexport parsePath */
/* unused harmony reexport createPath */










/***/ }),
/* 404 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__LocationUtils__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__PathUtils__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__createTransitionManager__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__DOMUtils__ = __webpack_require__(180);
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };








var PopStateEvent = 'popstate';
var HashChangeEvent = 'hashchange';

var getHistoryState = function getHistoryState() {
  try {
    return window.history.state || {};
  } catch (e) {
    // IE 11 sometimes throws when accessing window.history.state
    // See https://github.com/ReactTraining/history/pull/289
    return {};
  }
};

/**
 * Creates a history object that uses the HTML5 history API including
 * pushState, replaceState, and the popstate event.
 */
var createBrowserHistory = function createBrowserHistory() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  __WEBPACK_IMPORTED_MODULE_1_invariant___default()(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["b" /* canUseDOM */], 'Browser history needs a DOM');

  var globalHistory = window.history;
  var canUseHistory = Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["g" /* supportsHistory */])();
  var needsHashChangeListener = !Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["h" /* supportsPopStateOnHashChange */])();

  var _props$forceRefresh = props.forceRefresh,
      forceRefresh = _props$forceRefresh === undefined ? false : _props$forceRefresh,
      _props$getUserConfirm = props.getUserConfirmation,
      getUserConfirmation = _props$getUserConfirm === undefined ? __WEBPACK_IMPORTED_MODULE_5__DOMUtils__["c" /* getConfirmation */] : _props$getUserConfirm,
      _props$keyLength = props.keyLength,
      keyLength = _props$keyLength === undefined ? 6 : _props$keyLength;

  var basename = props.basename ? Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["g" /* stripTrailingSlash */])(Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["a" /* addLeadingSlash */])(props.basename)) : '';

  var getDOMLocation = function getDOMLocation(historyState) {
    var _ref = historyState || {},
        key = _ref.key,
        state = _ref.state;

    var _window$location = window.location,
        pathname = _window$location.pathname,
        search = _window$location.search,
        hash = _window$location.hash;


    var path = pathname + search + hash;

    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!basename || Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["c" /* hasBasename */])(path, basename), 'You are attempting to use a basename on a page whose URL path does not begin ' + 'with the basename. Expected path "' + path + '" to begin with "' + basename + '".');

    if (basename) path = Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["e" /* stripBasename */])(path, basename);

    return Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(path, state, key);
  };

  var createKey = function createKey() {
    return Math.random().toString(36).substr(2, keyLength);
  };

  var transitionManager = Object(__WEBPACK_IMPORTED_MODULE_4__createTransitionManager__["a" /* default */])();

  var setState = function setState(nextState) {
    _extends(history, nextState);

    history.length = globalHistory.length;

    transitionManager.notifyListeners(history.location, history.action);
  };

  var handlePopState = function handlePopState(event) {
    // Ignore extraneous popstate events in WebKit.
    if (Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["d" /* isExtraneousPopstateEvent */])(event)) return;

    handlePop(getDOMLocation(event.state));
  };

  var handleHashChange = function handleHashChange() {
    handlePop(getDOMLocation(getHistoryState()));
  };

  var forceNextPop = false;

  var handlePop = function handlePop(location) {
    if (forceNextPop) {
      forceNextPop = false;
      setState();
    } else {
      var action = 'POP';

      transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
        if (ok) {
          setState({ action: action, location: location });
        } else {
          revertPop(location);
        }
      });
    }
  };

  var revertPop = function revertPop(fromLocation) {
    var toLocation = history.location;

    // TODO: We could probably make this more reliable by
    // keeping a list of keys we've seen in sessionStorage.
    // Instead, we just default to 0 for keys we don't know.

    var toIndex = allKeys.indexOf(toLocation.key);

    if (toIndex === -1) toIndex = 0;

    var fromIndex = allKeys.indexOf(fromLocation.key);

    if (fromIndex === -1) fromIndex = 0;

    var delta = toIndex - fromIndex;

    if (delta) {
      forceNextPop = true;
      go(delta);
    }
  };

  var initialLocation = getDOMLocation(getHistoryState());
  var allKeys = [initialLocation.key];

  // Public interface

  var createHref = function createHref(location) {
    return basename + Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(location);
  };

  var push = function push(path, state) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to push when the 1st ' + 'argument is a location-like object that already has state; it is ignored');

    var action = 'PUSH';
    var location = Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(path, state, createKey(), history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var href = createHref(location);
      var key = location.key,
          state = location.state;


      if (canUseHistory) {
        globalHistory.pushState({ key: key, state: state }, null, href);

        if (forceRefresh) {
          window.location.href = href;
        } else {
          var prevIndex = allKeys.indexOf(history.location.key);
          var nextKeys = allKeys.slice(0, prevIndex === -1 ? 0 : prevIndex + 1);

          nextKeys.push(location.key);
          allKeys = nextKeys;

          setState({ action: action, location: location });
        }
      } else {
        __WEBPACK_IMPORTED_MODULE_0_warning___default()(state === undefined, 'Browser history cannot push state in browsers that do not support HTML5 history');

        window.location.href = href;
      }
    });
  };

  var replace = function replace(path, state) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to replace when the 1st ' + 'argument is a location-like object that already has state; it is ignored');

    var action = 'REPLACE';
    var location = Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(path, state, createKey(), history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var href = createHref(location);
      var key = location.key,
          state = location.state;


      if (canUseHistory) {
        globalHistory.replaceState({ key: key, state: state }, null, href);

        if (forceRefresh) {
          window.location.replace(href);
        } else {
          var prevIndex = allKeys.indexOf(history.location.key);

          if (prevIndex !== -1) allKeys[prevIndex] = location.key;

          setState({ action: action, location: location });
        }
      } else {
        __WEBPACK_IMPORTED_MODULE_0_warning___default()(state === undefined, 'Browser history cannot replace state in browsers that do not support HTML5 history');

        window.location.replace(href);
      }
    });
  };

  var go = function go(n) {
    globalHistory.go(n);
  };

  var goBack = function goBack() {
    return go(-1);
  };

  var goForward = function goForward() {
    return go(1);
  };

  var listenerCount = 0;

  var checkDOMListeners = function checkDOMListeners(delta) {
    listenerCount += delta;

    if (listenerCount === 1) {
      Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["a" /* addEventListener */])(window, PopStateEvent, handlePopState);

      if (needsHashChangeListener) Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["a" /* addEventListener */])(window, HashChangeEvent, handleHashChange);
    } else if (listenerCount === 0) {
      Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["e" /* removeEventListener */])(window, PopStateEvent, handlePopState);

      if (needsHashChangeListener) Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["e" /* removeEventListener */])(window, HashChangeEvent, handleHashChange);
    }
  };

  var isBlocked = false;

  var block = function block() {
    var prompt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    var unblock = transitionManager.setPrompt(prompt);

    if (!isBlocked) {
      checkDOMListeners(1);
      isBlocked = true;
    }

    return function () {
      if (isBlocked) {
        isBlocked = false;
        checkDOMListeners(-1);
      }

      return unblock();
    };
  };

  var listen = function listen(listener) {
    var unlisten = transitionManager.appendListener(listener);
    checkDOMListeners(1);

    return function () {
      checkDOMListeners(-1);
      unlisten();
    };
  };

  var history = {
    length: globalHistory.length,
    action: 'POP',
    location: initialLocation,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    block: block,
    listen: listen
  };

  return history;
};

/* unused harmony default export */ var _unused_webpack_default_export = (createBrowserHistory);

/***/ }),
/* 405 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__LocationUtils__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__PathUtils__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__createTransitionManager__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__DOMUtils__ = __webpack_require__(180);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };








var HashChangeEvent = 'hashchange';

var HashPathCoders = {
  hashbang: {
    encodePath: function encodePath(path) {
      return path.charAt(0) === '!' ? path : '!/' + Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["f" /* stripLeadingSlash */])(path);
    },
    decodePath: function decodePath(path) {
      return path.charAt(0) === '!' ? path.substr(1) : path;
    }
  },
  noslash: {
    encodePath: __WEBPACK_IMPORTED_MODULE_3__PathUtils__["f" /* stripLeadingSlash */],
    decodePath: __WEBPACK_IMPORTED_MODULE_3__PathUtils__["a" /* addLeadingSlash */]
  },
  slash: {
    encodePath: __WEBPACK_IMPORTED_MODULE_3__PathUtils__["a" /* addLeadingSlash */],
    decodePath: __WEBPACK_IMPORTED_MODULE_3__PathUtils__["a" /* addLeadingSlash */]
  }
};

var getHashPath = function getHashPath() {
  // We can't use window.location.hash here because it's not
  // consistent across browsers - Firefox will pre-decode it!
  var href = window.location.href;
  var hashIndex = href.indexOf('#');
  return hashIndex === -1 ? '' : href.substring(hashIndex + 1);
};

var pushHashPath = function pushHashPath(path) {
  return window.location.hash = path;
};

var replaceHashPath = function replaceHashPath(path) {
  var hashIndex = window.location.href.indexOf('#');

  window.location.replace(window.location.href.slice(0, hashIndex >= 0 ? hashIndex : 0) + '#' + path);
};

var createHashHistory = function createHashHistory() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  __WEBPACK_IMPORTED_MODULE_1_invariant___default()(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["b" /* canUseDOM */], 'Hash history needs a DOM');

  var globalHistory = window.history;
  var canGoWithoutReload = Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["f" /* supportsGoWithoutReloadUsingHash */])();

  var _props$getUserConfirm = props.getUserConfirmation,
      getUserConfirmation = _props$getUserConfirm === undefined ? __WEBPACK_IMPORTED_MODULE_5__DOMUtils__["c" /* getConfirmation */] : _props$getUserConfirm,
      _props$hashType = props.hashType,
      hashType = _props$hashType === undefined ? 'slash' : _props$hashType;

  var basename = props.basename ? Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["g" /* stripTrailingSlash */])(Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["a" /* addLeadingSlash */])(props.basename)) : '';

  var _HashPathCoders$hashT = HashPathCoders[hashType],
      encodePath = _HashPathCoders$hashT.encodePath,
      decodePath = _HashPathCoders$hashT.decodePath;


  var getDOMLocation = function getDOMLocation() {
    var path = decodePath(getHashPath());

    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!basename || Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["c" /* hasBasename */])(path, basename), 'You are attempting to use a basename on a page whose URL path does not begin ' + 'with the basename. Expected path "' + path + '" to begin with "' + basename + '".');

    if (basename) path = Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["e" /* stripBasename */])(path, basename);

    return Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(path);
  };

  var transitionManager = Object(__WEBPACK_IMPORTED_MODULE_4__createTransitionManager__["a" /* default */])();

  var setState = function setState(nextState) {
    _extends(history, nextState);

    history.length = globalHistory.length;

    transitionManager.notifyListeners(history.location, history.action);
  };

  var forceNextPop = false;
  var ignorePath = null;

  var handleHashChange = function handleHashChange() {
    var path = getHashPath();
    var encodedPath = encodePath(path);

    if (path !== encodedPath) {
      // Ensure we always have a properly-encoded hash.
      replaceHashPath(encodedPath);
    } else {
      var location = getDOMLocation();
      var prevLocation = history.location;

      if (!forceNextPop && Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["b" /* locationsAreEqual */])(prevLocation, location)) return; // A hashchange doesn't always == location change.

      if (ignorePath === Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(location)) return; // Ignore this change; we already setState in push/replace.

      ignorePath = null;

      handlePop(location);
    }
  };

  var handlePop = function handlePop(location) {
    if (forceNextPop) {
      forceNextPop = false;
      setState();
    } else {
      var action = 'POP';

      transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
        if (ok) {
          setState({ action: action, location: location });
        } else {
          revertPop(location);
        }
      });
    }
  };

  var revertPop = function revertPop(fromLocation) {
    var toLocation = history.location;

    // TODO: We could probably make this more reliable by
    // keeping a list of paths we've seen in sessionStorage.
    // Instead, we just default to 0 for paths we don't know.

    var toIndex = allPaths.lastIndexOf(Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(toLocation));

    if (toIndex === -1) toIndex = 0;

    var fromIndex = allPaths.lastIndexOf(Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(fromLocation));

    if (fromIndex === -1) fromIndex = 0;

    var delta = toIndex - fromIndex;

    if (delta) {
      forceNextPop = true;
      go(delta);
    }
  };

  // Ensure the hash is encoded properly before doing anything else.
  var path = getHashPath();
  var encodedPath = encodePath(path);

  if (path !== encodedPath) replaceHashPath(encodedPath);

  var initialLocation = getDOMLocation();
  var allPaths = [Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(initialLocation)];

  // Public interface

  var createHref = function createHref(location) {
    return '#' + encodePath(basename + Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(location));
  };

  var push = function push(path, state) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(state === undefined, 'Hash history cannot push state; it is ignored');

    var action = 'PUSH';
    var location = Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(path, undefined, undefined, history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var path = Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(location);
      var encodedPath = encodePath(basename + path);
      var hashChanged = getHashPath() !== encodedPath;

      if (hashChanged) {
        // We cannot tell if a hashchange was caused by a PUSH, so we'd
        // rather setState here and ignore the hashchange. The caveat here
        // is that other hash histories in the page will consider it a POP.
        ignorePath = path;
        pushHashPath(encodedPath);

        var prevIndex = allPaths.lastIndexOf(Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(history.location));
        var nextPaths = allPaths.slice(0, prevIndex === -1 ? 0 : prevIndex + 1);

        nextPaths.push(path);
        allPaths = nextPaths;

        setState({ action: action, location: location });
      } else {
        __WEBPACK_IMPORTED_MODULE_0_warning___default()(false, 'Hash history cannot PUSH the same path; a new entry will not be added to the history stack');

        setState();
      }
    });
  };

  var replace = function replace(path, state) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(state === undefined, 'Hash history cannot replace state; it is ignored');

    var action = 'REPLACE';
    var location = Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(path, undefined, undefined, history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var path = Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(location);
      var encodedPath = encodePath(basename + path);
      var hashChanged = getHashPath() !== encodedPath;

      if (hashChanged) {
        // We cannot tell if a hashchange was caused by a REPLACE, so we'd
        // rather setState here and ignore the hashchange. The caveat here
        // is that other hash histories in the page will consider it a POP.
        ignorePath = path;
        replaceHashPath(encodedPath);
      }

      var prevIndex = allPaths.indexOf(Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(history.location));

      if (prevIndex !== -1) allPaths[prevIndex] = path;

      setState({ action: action, location: location });
    });
  };

  var go = function go(n) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(canGoWithoutReload, 'Hash history go(n) causes a full page reload in this browser');

    globalHistory.go(n);
  };

  var goBack = function goBack() {
    return go(-1);
  };

  var goForward = function goForward() {
    return go(1);
  };

  var listenerCount = 0;

  var checkDOMListeners = function checkDOMListeners(delta) {
    listenerCount += delta;

    if (listenerCount === 1) {
      Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["a" /* addEventListener */])(window, HashChangeEvent, handleHashChange);
    } else if (listenerCount === 0) {
      Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["e" /* removeEventListener */])(window, HashChangeEvent, handleHashChange);
    }
  };

  var isBlocked = false;

  var block = function block() {
    var prompt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    var unblock = transitionManager.setPrompt(prompt);

    if (!isBlocked) {
      checkDOMListeners(1);
      isBlocked = true;
    }

    return function () {
      if (isBlocked) {
        isBlocked = false;
        checkDOMListeners(-1);
      }

      return unblock();
    };
  };

  var listen = function listen(listener) {
    var unlisten = transitionManager.appendListener(listener);
    checkDOMListeners(1);

    return function () {
      checkDOMListeners(-1);
      unlisten();
    };
  };

  var history = {
    length: globalHistory.length,
    action: 'POP',
    location: initialLocation,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    block: block,
    listen: listen
  };

  return history;
};

/* unused harmony default export */ var _unused_webpack_default_export = (createHashHistory);

/***/ }),
/* 406 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PathUtils__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__LocationUtils__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__createTransitionManager__ = __webpack_require__(110);
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };






var clamp = function clamp(n, lowerBound, upperBound) {
  return Math.min(Math.max(n, lowerBound), upperBound);
};

/**
 * Creates a history object that stores locations in memory.
 */
var createMemoryHistory = function createMemoryHistory() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var getUserConfirmation = props.getUserConfirmation,
      _props$initialEntries = props.initialEntries,
      initialEntries = _props$initialEntries === undefined ? ['/'] : _props$initialEntries,
      _props$initialIndex = props.initialIndex,
      initialIndex = _props$initialIndex === undefined ? 0 : _props$initialIndex,
      _props$keyLength = props.keyLength,
      keyLength = _props$keyLength === undefined ? 6 : _props$keyLength;


  var transitionManager = Object(__WEBPACK_IMPORTED_MODULE_3__createTransitionManager__["a" /* default */])();

  var setState = function setState(nextState) {
    _extends(history, nextState);

    history.length = history.entries.length;

    transitionManager.notifyListeners(history.location, history.action);
  };

  var createKey = function createKey() {
    return Math.random().toString(36).substr(2, keyLength);
  };

  var index = clamp(initialIndex, 0, initialEntries.length - 1);
  var entries = initialEntries.map(function (entry) {
    return typeof entry === 'string' ? Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(entry, undefined, createKey()) : Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(entry, undefined, entry.key || createKey());
  });

  // Public interface

  var createHref = __WEBPACK_IMPORTED_MODULE_1__PathUtils__["b" /* createPath */];

  var push = function push(path, state) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to push when the 1st ' + 'argument is a location-like object that already has state; it is ignored');

    var action = 'PUSH';
    var location = Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(path, state, createKey(), history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var prevIndex = history.index;
      var nextIndex = prevIndex + 1;

      var nextEntries = history.entries.slice(0);
      if (nextEntries.length > nextIndex) {
        nextEntries.splice(nextIndex, nextEntries.length - nextIndex, location);
      } else {
        nextEntries.push(location);
      }

      setState({
        action: action,
        location: location,
        index: nextIndex,
        entries: nextEntries
      });
    });
  };

  var replace = function replace(path, state) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to replace when the 1st ' + 'argument is a location-like object that already has state; it is ignored');

    var action = 'REPLACE';
    var location = Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(path, state, createKey(), history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      history.entries[history.index] = location;

      setState({ action: action, location: location });
    });
  };

  var go = function go(n) {
    var nextIndex = clamp(history.index + n, 0, history.entries.length - 1);

    var action = 'POP';
    var location = history.entries[nextIndex];

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (ok) {
        setState({
          action: action,
          location: location,
          index: nextIndex
        });
      } else {
        // Mimic the behavior of DOM histories by
        // causing a render after a cancelled POP.
        setState();
      }
    });
  };

  var goBack = function goBack() {
    return go(-1);
  };

  var goForward = function goForward() {
    return go(1);
  };

  var canGo = function canGo(n) {
    var nextIndex = history.index + n;
    return nextIndex >= 0 && nextIndex < history.entries.length;
  };

  var block = function block() {
    var prompt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    return transitionManager.setPrompt(prompt);
  };

  var listen = function listen(listener) {
    return transitionManager.appendListener(listener);
  };

  var history = {
    length: entries.length,
    action: 'POP',
    location: entries[index],
    index: index,
    entries: entries,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    canGo: canGo,
    block: block,
    listen: listen
  };

  return history;
};

/* unused harmony default export */ var _unused_webpack_default_export = (createMemoryHistory);

/***/ }),
/* 407 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_StaticRouter__ = __webpack_require__(408);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_StaticRouter__["a" /* default */]);

/***/ }),
/* 408 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_history_PathUtils__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_history_PathUtils___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_history_PathUtils__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Router__ = __webpack_require__(108);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var normalizeLocation = function normalizeLocation(object) {
  var _object$pathname = object.pathname,
      pathname = _object$pathname === undefined ? '/' : _object$pathname,
      _object$search = object.search,
      search = _object$search === undefined ? '' : _object$search,
      _object$hash = object.hash,
      hash = _object$hash === undefined ? '' : _object$hash;


  return {
    pathname: pathname,
    search: search === '?' ? '' : search,
    hash: hash === '#' ? '' : hash
  };
};

var addBasename = function addBasename(basename, location) {
  if (!basename) return location;

  return _extends({}, location, {
    pathname: Object(__WEBPACK_IMPORTED_MODULE_4_history_PathUtils__["addLeadingSlash"])(basename) + location.pathname
  });
};

var stripBasename = function stripBasename(basename, location) {
  if (!basename) return location;

  var base = Object(__WEBPACK_IMPORTED_MODULE_4_history_PathUtils__["addLeadingSlash"])(basename);

  if (location.pathname.indexOf(base) !== 0) return location;

  return _extends({}, location, {
    pathname: location.pathname.substr(base.length)
  });
};

var createLocation = function createLocation(location) {
  return typeof location === 'string' ? Object(__WEBPACK_IMPORTED_MODULE_4_history_PathUtils__["parsePath"])(location) : normalizeLocation(location);
};

var createURL = function createURL(location) {
  return typeof location === 'string' ? location : Object(__WEBPACK_IMPORTED_MODULE_4_history_PathUtils__["createPath"])(location);
};

var staticHandler = function staticHandler(methodName) {
  return function () {
    __WEBPACK_IMPORTED_MODULE_1_invariant___default()(false, 'You cannot %s with <StaticRouter>', methodName);
  };
};

var noop = function noop() {};

/**
 * The public top-level API for a "static" <Router>, so-called because it
 * can't actually change the current location. Instead, it just records
 * location changes in a context object. Useful mainly in testing and
 * server-rendering scenarios.
 */

var StaticRouter = function (_React$Component) {
  _inherits(StaticRouter, _React$Component);

  function StaticRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, StaticRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.createHref = function (path) {
      return Object(__WEBPACK_IMPORTED_MODULE_4_history_PathUtils__["addLeadingSlash"])(_this.props.basename + createURL(path));
    }, _this.handlePush = function (location) {
      var _this$props = _this.props,
          basename = _this$props.basename,
          context = _this$props.context;

      context.action = 'PUSH';
      context.location = addBasename(basename, createLocation(location));
      context.url = createURL(context.location);
    }, _this.handleReplace = function (location) {
      var _this$props2 = _this.props,
          basename = _this$props2.basename,
          context = _this$props2.context;

      context.action = 'REPLACE';
      context.location = addBasename(basename, createLocation(location));
      context.url = createURL(context.location);
    }, _this.handleListen = function () {
      return noop;
    }, _this.handleBlock = function () {
      return noop;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  StaticRouter.prototype.getChildContext = function getChildContext() {
    return {
      router: {
        staticContext: this.props.context
      }
    };
  };

  StaticRouter.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!this.props.history, '<StaticRouter> ignores the history prop. To use a custom history, ' + 'use `import { Router }` instead of `import { StaticRouter as Router }`.');
  };

  StaticRouter.prototype.render = function render() {
    var _props = this.props,
        basename = _props.basename,
        context = _props.context,
        location = _props.location,
        props = _objectWithoutProperties(_props, ['basename', 'context', 'location']);

    var history = {
      createHref: this.createHref,
      action: 'POP',
      location: stripBasename(basename, createLocation(location)),
      push: this.handlePush,
      replace: this.handleReplace,
      go: staticHandler('go'),
      goBack: staticHandler('goBack'),
      goForward: staticHandler('goForward'),
      listen: this.handleListen,
      block: this.handleBlock
    };

    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Router__["a" /* default */], _extends({}, props, { history: history }));
  };

  return StaticRouter;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

StaticRouter.propTypes = {
  basename: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  context: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
  location: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object])
};
StaticRouter.defaultProps = {
  basename: '',
  location: '/'
};
StaticRouter.childContextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (StaticRouter);

/***/ }),
/* 409 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Switch__ = __webpack_require__(410);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Switch__["a" /* default */]);

/***/ }),
/* 410 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_warning__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__matchPath__ = __webpack_require__(109);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for rendering the first <Route> that matches.
 */

var Switch = function (_React$Component) {
  _inherits(Switch, _React$Component);

  function Switch() {
    _classCallCheck(this, Switch);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  Switch.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_3_invariant___default()(this.context.router, 'You should not use <Switch> outside a <Router>');
  };

  Switch.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    __WEBPACK_IMPORTED_MODULE_2_warning___default()(!(nextProps.location && !this.props.location), '<Switch> elements should not change from uncontrolled to controlled (or vice versa). You initially used no "location" prop and then provided one on a subsequent render.');

    __WEBPACK_IMPORTED_MODULE_2_warning___default()(!(!nextProps.location && this.props.location), '<Switch> elements should not change from controlled to uncontrolled (or vice versa). You provided a "location" prop initially but omitted it on a subsequent render.');
  };

  Switch.prototype.render = function render() {
    var route = this.context.router.route;
    var children = this.props.children;

    var location = this.props.location || route.location;

    var match = void 0,
        child = void 0;
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.forEach(children, function (element) {
      if (!__WEBPACK_IMPORTED_MODULE_0_react___default.a.isValidElement(element)) return;

      var _element$props = element.props,
          pathProp = _element$props.path,
          exact = _element$props.exact,
          strict = _element$props.strict,
          sensitive = _element$props.sensitive,
          from = _element$props.from;

      var path = pathProp || from;

      if (match == null) {
        child = element;
        match = path ? Object(__WEBPACK_IMPORTED_MODULE_4__matchPath__["a" /* default */])(location.pathname, { path: path, exact: exact, strict: strict, sensitive: sensitive }) : route.match;
      }
    });

    return match ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.cloneElement(child, { location: location, computedMatch: match }) : null;
  };

  return Switch;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Switch.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    route: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired
  }).isRequired
};
Switch.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  location: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};


/* harmony default export */ __webpack_exports__["a"] = (Switch);

/***/ }),
/* 411 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_matchPath__ = __webpack_require__(109);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_matchPath__["a" /* default */]);

/***/ }),
/* 412 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_withRouter__ = __webpack_require__(413);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_withRouter__["a" /* default */]);

/***/ }),
/* 413 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics__ = __webpack_require__(414);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Route__ = __webpack_require__(179);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }






/**
 * A public higher-order component to access the imperative API
 */
var withRouter = function withRouter(Component) {
  var C = function C(props) {
    var wrappedComponentRef = props.wrappedComponentRef,
        remainingProps = _objectWithoutProperties(props, ['wrappedComponentRef']);

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Route__["a" /* default */], { render: function render(routeComponentProps) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Component, _extends({}, remainingProps, routeComponentProps, { ref: wrappedComponentRef }));
      } });
  };

  C.displayName = 'withRouter(' + (Component.displayName || Component.name) + ')';
  C.WrappedComponent = Component;
  C.propTypes = {
    wrappedComponentRef: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
  };

  return __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics___default()(C, Component);
};

/* harmony default export */ __webpack_exports__["a"] = (withRouter);

/***/ }),
/* 414 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */


var REACT_STATICS = {
    childContextTypes: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    mixins: true,
    propTypes: true,
    type: true
};

var KNOWN_STATICS = {
  name: true,
  length: true,
  prototype: true,
  caller: true,
  callee: true,
  arguments: true,
  arity: true
};

var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = getPrototypeOf && getPrototypeOf(Object);

module.exports = function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components

        if (objectPrototype) {
            var inheritedComponent = getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== objectPrototype) {
                hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
            }
        }

        var keys = getOwnPropertyNames(sourceComponent);

        if (getOwnPropertySymbols) {
            keys = keys.concat(getOwnPropertySymbols(sourceComponent));
        }

        for (var i = 0; i < keys.length; ++i) {
            var key = keys[i];
            if (!REACT_STATICS[key] && !KNOWN_STATICS[key] && (!blacklist || !blacklist[key])) {
                var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
                try { // Avoid failures from read-only properties
                    defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }

        return targetComponent;
    }

    return targetComponent;
};


/***/ }),
/* 415 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__ = __webpack_require__(13);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Expired=function(_Component){_inherits(Expired,_Component);function Expired(){_classCallCheck(this,Expired);return _possibleConstructorReturn(this,(Expired.__proto__||Object.getPrototypeOf(Expired)).apply(this,arguments));}_createClass(Expired,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'middle-box text-center loginscreen animated fadeInDown'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h1',{className:'logo-name'},'ERROR')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,'LICENSE EXPIRED'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Please verify your license credentials'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'m-t'},' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('small',null,'Call Main Project Support'),' ')));}}]);return Expired;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);;/* unused harmony default export */ var _unused_webpack_default_export = (Expired);

/***/ }),
/* 416 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 417 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 418 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 419 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 420 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 421 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 422 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 423 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 424 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 425 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 426 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 427 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory, undef) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(9), __webpack_require__(73), __webpack_require__(428), __webpack_require__(429), __webpack_require__(40), __webpack_require__(41), __webpack_require__(111), __webpack_require__(181), __webpack_require__(430), __webpack_require__(182), __webpack_require__(431), __webpack_require__(432), __webpack_require__(433), __webpack_require__(112), __webpack_require__(434), __webpack_require__(33), __webpack_require__(14), __webpack_require__(435), __webpack_require__(436), __webpack_require__(437), __webpack_require__(438), __webpack_require__(439), __webpack_require__(440), __webpack_require__(441), __webpack_require__(442), __webpack_require__(443), __webpack_require__(444), __webpack_require__(445), __webpack_require__(446), __webpack_require__(447), __webpack_require__(448), __webpack_require__(449), __webpack_require__(450));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core", "./x64-core", "./lib-typedarrays", "./enc-utf16", "./enc-base64", "./md5", "./sha1", "./sha256", "./sha224", "./sha512", "./sha384", "./sha3", "./ripemd160", "./hmac", "./pbkdf2", "./evpkdf", "./cipher-core", "./mode-cfb", "./mode-ctr", "./mode-ctr-gladman", "./mode-ofb", "./mode-ecb", "./pad-ansix923", "./pad-iso10126", "./pad-iso97971", "./pad-zeropadding", "./pad-nopadding", "./format-hex", "./aes", "./tripledes", "./rc4", "./rabbit", "./rabbit-legacy"], factory);
	}
	else {
		// Global (browser)
		root.CryptoJS = factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	return CryptoJS;

}));

/***/ }),
/* 428 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(9));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	(function () {
	    // Check if typed arrays are supported
	    if (typeof ArrayBuffer != 'function') {
	        return;
	    }

	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var WordArray = C_lib.WordArray;

	    // Reference original init
	    var superInit = WordArray.init;

	    // Augment WordArray.init to handle typed arrays
	    var subInit = WordArray.init = function (typedArray) {
	        // Convert buffers to uint8
	        if (typedArray instanceof ArrayBuffer) {
	            typedArray = new Uint8Array(typedArray);
	        }

	        // Convert other array views to uint8
	        if (
	            typedArray instanceof Int8Array ||
	            (typeof Uint8ClampedArray !== "undefined" && typedArray instanceof Uint8ClampedArray) ||
	            typedArray instanceof Int16Array ||
	            typedArray instanceof Uint16Array ||
	            typedArray instanceof Int32Array ||
	            typedArray instanceof Uint32Array ||
	            typedArray instanceof Float32Array ||
	            typedArray instanceof Float64Array
	        ) {
	            typedArray = new Uint8Array(typedArray.buffer, typedArray.byteOffset, typedArray.byteLength);
	        }

	        // Handle Uint8Array
	        if (typedArray instanceof Uint8Array) {
	            // Shortcut
	            var typedArrayByteLength = typedArray.byteLength;

	            // Extract bytes
	            var words = [];
	            for (var i = 0; i < typedArrayByteLength; i++) {
	                words[i >>> 2] |= typedArray[i] << (24 - (i % 4) * 8);
	            }

	            // Initialize this word array
	            superInit.call(this, words, typedArrayByteLength);
	        } else {
	            // Else call normal init
	            superInit.apply(this, arguments);
	        }
	    };

	    subInit.prototype = WordArray;
	}());


	return CryptoJS.lib.WordArray;

}));

/***/ }),
/* 429 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(9));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	(function () {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var WordArray = C_lib.WordArray;
	    var C_enc = C.enc;

	    /**
	     * UTF-16 BE encoding strategy.
	     */
	    var Utf16BE = C_enc.Utf16 = C_enc.Utf16BE = {
	        /**
	         * Converts a word array to a UTF-16 BE string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @return {string} The UTF-16 BE string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var utf16String = CryptoJS.enc.Utf16.stringify(wordArray);
	         */
	        stringify: function (wordArray) {
	            // Shortcuts
	            var words = wordArray.words;
	            var sigBytes = wordArray.sigBytes;

	            // Convert
	            var utf16Chars = [];
	            for (var i = 0; i < sigBytes; i += 2) {
	                var codePoint = (words[i >>> 2] >>> (16 - (i % 4) * 8)) & 0xffff;
	                utf16Chars.push(String.fromCharCode(codePoint));
	            }

	            return utf16Chars.join('');
	        },

	        /**
	         * Converts a UTF-16 BE string to a word array.
	         *
	         * @param {string} utf16Str The UTF-16 BE string.
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Utf16.parse(utf16String);
	         */
	        parse: function (utf16Str) {
	            // Shortcut
	            var utf16StrLength = utf16Str.length;

	            // Convert
	            var words = [];
	            for (var i = 0; i < utf16StrLength; i++) {
	                words[i >>> 1] |= utf16Str.charCodeAt(i) << (16 - (i % 2) * 16);
	            }

	            return WordArray.create(words, utf16StrLength * 2);
	        }
	    };

	    /**
	     * UTF-16 LE encoding strategy.
	     */
	    C_enc.Utf16LE = {
	        /**
	         * Converts a word array to a UTF-16 LE string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @return {string} The UTF-16 LE string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var utf16Str = CryptoJS.enc.Utf16LE.stringify(wordArray);
	         */
	        stringify: function (wordArray) {
	            // Shortcuts
	            var words = wordArray.words;
	            var sigBytes = wordArray.sigBytes;

	            // Convert
	            var utf16Chars = [];
	            for (var i = 0; i < sigBytes; i += 2) {
	                var codePoint = swapEndian((words[i >>> 2] >>> (16 - (i % 4) * 8)) & 0xffff);
	                utf16Chars.push(String.fromCharCode(codePoint));
	            }

	            return utf16Chars.join('');
	        },

	        /**
	         * Converts a UTF-16 LE string to a word array.
	         *
	         * @param {string} utf16Str The UTF-16 LE string.
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Utf16LE.parse(utf16Str);
	         */
	        parse: function (utf16Str) {
	            // Shortcut
	            var utf16StrLength = utf16Str.length;

	            // Convert
	            var words = [];
	            for (var i = 0; i < utf16StrLength; i++) {
	                words[i >>> 1] |= swapEndian(utf16Str.charCodeAt(i) << (16 - (i % 2) * 16));
	            }

	            return WordArray.create(words, utf16StrLength * 2);
	        }
	    };

	    function swapEndian(word) {
	        return ((word << 8) & 0xff00ff00) | ((word >>> 8) & 0x00ff00ff);
	    }
	}());


	return CryptoJS.enc.Utf16;

}));

/***/ }),
/* 430 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory, undef) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(9), __webpack_require__(181));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core", "./sha256"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	(function () {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var WordArray = C_lib.WordArray;
	    var C_algo = C.algo;
	    var SHA256 = C_algo.SHA256;

	    /**
	     * SHA-224 hash algorithm.
	     */
	    var SHA224 = C_algo.SHA224 = SHA256.extend({
	        _doReset: function () {
	            this._hash = new WordArray.init([
	                0xc1059ed8, 0x367cd507, 0x3070dd17, 0xf70e5939,
	                0xffc00b31, 0x68581511, 0x64f98fa7, 0xbefa4fa4
	            ]);
	        },

	        _doFinalize: function () {
	            var hash = SHA256._doFinalize.call(this);

	            hash.sigBytes -= 4;

	            return hash;
	        }
	    });

	    /**
	     * Shortcut function to the hasher's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     *
	     * @return {WordArray} The hash.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hash = CryptoJS.SHA224('message');
	     *     var hash = CryptoJS.SHA224(wordArray);
	     */
	    C.SHA224 = SHA256._createHelper(SHA224);

	    /**
	     * Shortcut function to the HMAC's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     * @param {WordArray|string} key The secret key.
	     *
	     * @return {WordArray} The HMAC.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hmac = CryptoJS.HmacSHA224(message, key);
	     */
	    C.HmacSHA224 = SHA256._createHmacHelper(SHA224);
	}());


	return CryptoJS.SHA224;

}));

/***/ }),
/* 431 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory, undef) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(9), __webpack_require__(73), __webpack_require__(182));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core", "./x64-core", "./sha512"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	(function () {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_x64 = C.x64;
	    var X64Word = C_x64.Word;
	    var X64WordArray = C_x64.WordArray;
	    var C_algo = C.algo;
	    var SHA512 = C_algo.SHA512;

	    /**
	     * SHA-384 hash algorithm.
	     */
	    var SHA384 = C_algo.SHA384 = SHA512.extend({
	        _doReset: function () {
	            this._hash = new X64WordArray.init([
	                new X64Word.init(0xcbbb9d5d, 0xc1059ed8), new X64Word.init(0x629a292a, 0x367cd507),
	                new X64Word.init(0x9159015a, 0x3070dd17), new X64Word.init(0x152fecd8, 0xf70e5939),
	                new X64Word.init(0x67332667, 0xffc00b31), new X64Word.init(0x8eb44a87, 0x68581511),
	                new X64Word.init(0xdb0c2e0d, 0x64f98fa7), new X64Word.init(0x47b5481d, 0xbefa4fa4)
	            ]);
	        },

	        _doFinalize: function () {
	            var hash = SHA512._doFinalize.call(this);

	            hash.sigBytes -= 16;

	            return hash;
	        }
	    });

	    /**
	     * Shortcut function to the hasher's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     *
	     * @return {WordArray} The hash.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hash = CryptoJS.SHA384('message');
	     *     var hash = CryptoJS.SHA384(wordArray);
	     */
	    C.SHA384 = SHA512._createHelper(SHA384);

	    /**
	     * Shortcut function to the HMAC's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     * @param {WordArray|string} key The secret key.
	     *
	     * @return {WordArray} The HMAC.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hmac = CryptoJS.HmacSHA384(message, key);
	     */
	    C.HmacSHA384 = SHA512._createHmacHelper(SHA384);
	}());


	return CryptoJS.SHA384;

}));

/***/ }),
/* 432 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory, undef) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(9), __webpack_require__(73));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core", "./x64-core"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	(function (Math) {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var WordArray = C_lib.WordArray;
	    var Hasher = C_lib.Hasher;
	    var C_x64 = C.x64;
	    var X64Word = C_x64.Word;
	    var C_algo = C.algo;

	    // Constants tables
	    var RHO_OFFSETS = [];
	    var PI_INDEXES  = [];
	    var ROUND_CONSTANTS = [];

	    // Compute Constants
	    (function () {
	        // Compute rho offset constants
	        var x = 1, y = 0;
	        for (var t = 0; t < 24; t++) {
	            RHO_OFFSETS[x + 5 * y] = ((t + 1) * (t + 2) / 2) % 64;

	            var newX = y % 5;
	            var newY = (2 * x + 3 * y) % 5;
	            x = newX;
	            y = newY;
	        }

	        // Compute pi index constants
	        for (var x = 0; x < 5; x++) {
	            for (var y = 0; y < 5; y++) {
	                PI_INDEXES[x + 5 * y] = y + ((2 * x + 3 * y) % 5) * 5;
	            }
	        }

	        // Compute round constants
	        var LFSR = 0x01;
	        for (var i = 0; i < 24; i++) {
	            var roundConstantMsw = 0;
	            var roundConstantLsw = 0;

	            for (var j = 0; j < 7; j++) {
	                if (LFSR & 0x01) {
	                    var bitPosition = (1 << j) - 1;
	                    if (bitPosition < 32) {
	                        roundConstantLsw ^= 1 << bitPosition;
	                    } else /* if (bitPosition >= 32) */ {
	                        roundConstantMsw ^= 1 << (bitPosition - 32);
	                    }
	                }

	                // Compute next LFSR
	                if (LFSR & 0x80) {
	                    // Primitive polynomial over GF(2): x^8 + x^6 + x^5 + x^4 + 1
	                    LFSR = (LFSR << 1) ^ 0x71;
	                } else {
	                    LFSR <<= 1;
	                }
	            }

	            ROUND_CONSTANTS[i] = X64Word.create(roundConstantMsw, roundConstantLsw);
	        }
	    }());

	    // Reusable objects for temporary values
	    var T = [];
	    (function () {
	        for (var i = 0; i < 25; i++) {
	            T[i] = X64Word.create();
	        }
	    }());

	    /**
	     * SHA-3 hash algorithm.
	     */
	    var SHA3 = C_algo.SHA3 = Hasher.extend({
	        /**
	         * Configuration options.
	         *
	         * @property {number} outputLength
	         *   The desired number of bits in the output hash.
	         *   Only values permitted are: 224, 256, 384, 512.
	         *   Default: 512
	         */
	        cfg: Hasher.cfg.extend({
	            outputLength: 512
	        }),

	        _doReset: function () {
	            var state = this._state = []
	            for (var i = 0; i < 25; i++) {
	                state[i] = new X64Word.init();
	            }

	            this.blockSize = (1600 - 2 * this.cfg.outputLength) / 32;
	        },

	        _doProcessBlock: function (M, offset) {
	            // Shortcuts
	            var state = this._state;
	            var nBlockSizeLanes = this.blockSize / 2;

	            // Absorb
	            for (var i = 0; i < nBlockSizeLanes; i++) {
	                // Shortcuts
	                var M2i  = M[offset + 2 * i];
	                var M2i1 = M[offset + 2 * i + 1];

	                // Swap endian
	                M2i = (
	                    (((M2i << 8)  | (M2i >>> 24)) & 0x00ff00ff) |
	                    (((M2i << 24) | (M2i >>> 8))  & 0xff00ff00)
	                );
	                M2i1 = (
	                    (((M2i1 << 8)  | (M2i1 >>> 24)) & 0x00ff00ff) |
	                    (((M2i1 << 24) | (M2i1 >>> 8))  & 0xff00ff00)
	                );

	                // Absorb message into state
	                var lane = state[i];
	                lane.high ^= M2i1;
	                lane.low  ^= M2i;
	            }

	            // Rounds
	            for (var round = 0; round < 24; round++) {
	                // Theta
	                for (var x = 0; x < 5; x++) {
	                    // Mix column lanes
	                    var tMsw = 0, tLsw = 0;
	                    for (var y = 0; y < 5; y++) {
	                        var lane = state[x + 5 * y];
	                        tMsw ^= lane.high;
	                        tLsw ^= lane.low;
	                    }

	                    // Temporary values
	                    var Tx = T[x];
	                    Tx.high = tMsw;
	                    Tx.low  = tLsw;
	                }
	                for (var x = 0; x < 5; x++) {
	                    // Shortcuts
	                    var Tx4 = T[(x + 4) % 5];
	                    var Tx1 = T[(x + 1) % 5];
	                    var Tx1Msw = Tx1.high;
	                    var Tx1Lsw = Tx1.low;

	                    // Mix surrounding columns
	                    var tMsw = Tx4.high ^ ((Tx1Msw << 1) | (Tx1Lsw >>> 31));
	                    var tLsw = Tx4.low  ^ ((Tx1Lsw << 1) | (Tx1Msw >>> 31));
	                    for (var y = 0; y < 5; y++) {
	                        var lane = state[x + 5 * y];
	                        lane.high ^= tMsw;
	                        lane.low  ^= tLsw;
	                    }
	                }

	                // Rho Pi
	                for (var laneIndex = 1; laneIndex < 25; laneIndex++) {
	                    // Shortcuts
	                    var lane = state[laneIndex];
	                    var laneMsw = lane.high;
	                    var laneLsw = lane.low;
	                    var rhoOffset = RHO_OFFSETS[laneIndex];

	                    // Rotate lanes
	                    if (rhoOffset < 32) {
	                        var tMsw = (laneMsw << rhoOffset) | (laneLsw >>> (32 - rhoOffset));
	                        var tLsw = (laneLsw << rhoOffset) | (laneMsw >>> (32 - rhoOffset));
	                    } else /* if (rhoOffset >= 32) */ {
	                        var tMsw = (laneLsw << (rhoOffset - 32)) | (laneMsw >>> (64 - rhoOffset));
	                        var tLsw = (laneMsw << (rhoOffset - 32)) | (laneLsw >>> (64 - rhoOffset));
	                    }

	                    // Transpose lanes
	                    var TPiLane = T[PI_INDEXES[laneIndex]];
	                    TPiLane.high = tMsw;
	                    TPiLane.low  = tLsw;
	                }

	                // Rho pi at x = y = 0
	                var T0 = T[0];
	                var state0 = state[0];
	                T0.high = state0.high;
	                T0.low  = state0.low;

	                // Chi
	                for (var x = 0; x < 5; x++) {
	                    for (var y = 0; y < 5; y++) {
	                        // Shortcuts
	                        var laneIndex = x + 5 * y;
	                        var lane = state[laneIndex];
	                        var TLane = T[laneIndex];
	                        var Tx1Lane = T[((x + 1) % 5) + 5 * y];
	                        var Tx2Lane = T[((x + 2) % 5) + 5 * y];

	                        // Mix rows
	                        lane.high = TLane.high ^ (~Tx1Lane.high & Tx2Lane.high);
	                        lane.low  = TLane.low  ^ (~Tx1Lane.low  & Tx2Lane.low);
	                    }
	                }

	                // Iota
	                var lane = state[0];
	                var roundConstant = ROUND_CONSTANTS[round];
	                lane.high ^= roundConstant.high;
	                lane.low  ^= roundConstant.low;;
	            }
	        },

	        _doFinalize: function () {
	            // Shortcuts
	            var data = this._data;
	            var dataWords = data.words;
	            var nBitsTotal = this._nDataBytes * 8;
	            var nBitsLeft = data.sigBytes * 8;
	            var blockSizeBits = this.blockSize * 32;

	            // Add padding
	            dataWords[nBitsLeft >>> 5] |= 0x1 << (24 - nBitsLeft % 32);
	            dataWords[((Math.ceil((nBitsLeft + 1) / blockSizeBits) * blockSizeBits) >>> 5) - 1] |= 0x80;
	            data.sigBytes = dataWords.length * 4;

	            // Hash final blocks
	            this._process();

	            // Shortcuts
	            var state = this._state;
	            var outputLengthBytes = this.cfg.outputLength / 8;
	            var outputLengthLanes = outputLengthBytes / 8;

	            // Squeeze
	            var hashWords = [];
	            for (var i = 0; i < outputLengthLanes; i++) {
	                // Shortcuts
	                var lane = state[i];
	                var laneMsw = lane.high;
	                var laneLsw = lane.low;

	                // Swap endian
	                laneMsw = (
	                    (((laneMsw << 8)  | (laneMsw >>> 24)) & 0x00ff00ff) |
	                    (((laneMsw << 24) | (laneMsw >>> 8))  & 0xff00ff00)
	                );
	                laneLsw = (
	                    (((laneLsw << 8)  | (laneLsw >>> 24)) & 0x00ff00ff) |
	                    (((laneLsw << 24) | (laneLsw >>> 8))  & 0xff00ff00)
	                );

	                // Squeeze state to retrieve hash
	                hashWords.push(laneLsw);
	                hashWords.push(laneMsw);
	            }

	            // Return final computed hash
	            return new WordArray.init(hashWords, outputLengthBytes);
	        },

	        clone: function () {
	            var clone = Hasher.clone.call(this);

	            var state = clone._state = this._state.slice(0);
	            for (var i = 0; i < 25; i++) {
	                state[i] = state[i].clone();
	            }

	            return clone;
	        }
	    });

	    /**
	     * Shortcut function to the hasher's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     *
	     * @return {WordArray} The hash.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hash = CryptoJS.SHA3('message');
	     *     var hash = CryptoJS.SHA3(wordArray);
	     */
	    C.SHA3 = Hasher._createHelper(SHA3);

	    /**
	     * Shortcut function to the HMAC's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     * @param {WordArray|string} key The secret key.
	     *
	     * @return {WordArray} The HMAC.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hmac = CryptoJS.HmacSHA3(message, key);
	     */
	    C.HmacSHA3 = Hasher._createHmacHelper(SHA3);
	}(Math));


	return CryptoJS.SHA3;

}));

/***/ }),
/* 433 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(9));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	/** @preserve
	(c) 2012 by Cédric Mesnil. All rights reserved.

	Redistribution and use in source and binary forms, with or without modification, are permitted provided that the following conditions are met:

	    - Redistributions of source code must retain the above copyright notice, this list of conditions and the following disclaimer.
	    - Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the following disclaimer in the documentation and/or other materials provided with the distribution.

	THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
	*/

	(function (Math) {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var WordArray = C_lib.WordArray;
	    var Hasher = C_lib.Hasher;
	    var C_algo = C.algo;

	    // Constants table
	    var _zl = WordArray.create([
	        0,  1,  2,  3,  4,  5,  6,  7,  8,  9, 10, 11, 12, 13, 14, 15,
	        7,  4, 13,  1, 10,  6, 15,  3, 12,  0,  9,  5,  2, 14, 11,  8,
	        3, 10, 14,  4,  9, 15,  8,  1,  2,  7,  0,  6, 13, 11,  5, 12,
	        1,  9, 11, 10,  0,  8, 12,  4, 13,  3,  7, 15, 14,  5,  6,  2,
	        4,  0,  5,  9,  7, 12,  2, 10, 14,  1,  3,  8, 11,  6, 15, 13]);
	    var _zr = WordArray.create([
	        5, 14,  7,  0,  9,  2, 11,  4, 13,  6, 15,  8,  1, 10,  3, 12,
	        6, 11,  3,  7,  0, 13,  5, 10, 14, 15,  8, 12,  4,  9,  1,  2,
	        15,  5,  1,  3,  7, 14,  6,  9, 11,  8, 12,  2, 10,  0,  4, 13,
	        8,  6,  4,  1,  3, 11, 15,  0,  5, 12,  2, 13,  9,  7, 10, 14,
	        12, 15, 10,  4,  1,  5,  8,  7,  6,  2, 13, 14,  0,  3,  9, 11]);
	    var _sl = WordArray.create([
	         11, 14, 15, 12,  5,  8,  7,  9, 11, 13, 14, 15,  6,  7,  9,  8,
	        7, 6,   8, 13, 11,  9,  7, 15,  7, 12, 15,  9, 11,  7, 13, 12,
	        11, 13,  6,  7, 14,  9, 13, 15, 14,  8, 13,  6,  5, 12,  7,  5,
	          11, 12, 14, 15, 14, 15,  9,  8,  9, 14,  5,  6,  8,  6,  5, 12,
	        9, 15,  5, 11,  6,  8, 13, 12,  5, 12, 13, 14, 11,  8,  5,  6 ]);
	    var _sr = WordArray.create([
	        8,  9,  9, 11, 13, 15, 15,  5,  7,  7,  8, 11, 14, 14, 12,  6,
	        9, 13, 15,  7, 12,  8,  9, 11,  7,  7, 12,  7,  6, 15, 13, 11,
	        9,  7, 15, 11,  8,  6,  6, 14, 12, 13,  5, 14, 13, 13,  7,  5,
	        15,  5,  8, 11, 14, 14,  6, 14,  6,  9, 12,  9, 12,  5, 15,  8,
	        8,  5, 12,  9, 12,  5, 14,  6,  8, 13,  6,  5, 15, 13, 11, 11 ]);

	    var _hl =  WordArray.create([ 0x00000000, 0x5A827999, 0x6ED9EBA1, 0x8F1BBCDC, 0xA953FD4E]);
	    var _hr =  WordArray.create([ 0x50A28BE6, 0x5C4DD124, 0x6D703EF3, 0x7A6D76E9, 0x00000000]);

	    /**
	     * RIPEMD160 hash algorithm.
	     */
	    var RIPEMD160 = C_algo.RIPEMD160 = Hasher.extend({
	        _doReset: function () {
	            this._hash  = WordArray.create([0x67452301, 0xEFCDAB89, 0x98BADCFE, 0x10325476, 0xC3D2E1F0]);
	        },

	        _doProcessBlock: function (M, offset) {

	            // Swap endian
	            for (var i = 0; i < 16; i++) {
	                // Shortcuts
	                var offset_i = offset + i;
	                var M_offset_i = M[offset_i];

	                // Swap
	                M[offset_i] = (
	                    (((M_offset_i << 8)  | (M_offset_i >>> 24)) & 0x00ff00ff) |
	                    (((M_offset_i << 24) | (M_offset_i >>> 8))  & 0xff00ff00)
	                );
	            }
	            // Shortcut
	            var H  = this._hash.words;
	            var hl = _hl.words;
	            var hr = _hr.words;
	            var zl = _zl.words;
	            var zr = _zr.words;
	            var sl = _sl.words;
	            var sr = _sr.words;

	            // Working variables
	            var al, bl, cl, dl, el;
	            var ar, br, cr, dr, er;

	            ar = al = H[0];
	            br = bl = H[1];
	            cr = cl = H[2];
	            dr = dl = H[3];
	            er = el = H[4];
	            // Computation
	            var t;
	            for (var i = 0; i < 80; i += 1) {
	                t = (al +  M[offset+zl[i]])|0;
	                if (i<16){
		            t +=  f1(bl,cl,dl) + hl[0];
	                } else if (i<32) {
		            t +=  f2(bl,cl,dl) + hl[1];
	                } else if (i<48) {
		            t +=  f3(bl,cl,dl) + hl[2];
	                } else if (i<64) {
		            t +=  f4(bl,cl,dl) + hl[3];
	                } else {// if (i<80) {
		            t +=  f5(bl,cl,dl) + hl[4];
	                }
	                t = t|0;
	                t =  rotl(t,sl[i]);
	                t = (t+el)|0;
	                al = el;
	                el = dl;
	                dl = rotl(cl, 10);
	                cl = bl;
	                bl = t;

	                t = (ar + M[offset+zr[i]])|0;
	                if (i<16){
		            t +=  f5(br,cr,dr) + hr[0];
	                } else if (i<32) {
		            t +=  f4(br,cr,dr) + hr[1];
	                } else if (i<48) {
		            t +=  f3(br,cr,dr) + hr[2];
	                } else if (i<64) {
		            t +=  f2(br,cr,dr) + hr[3];
	                } else {// if (i<80) {
		            t +=  f1(br,cr,dr) + hr[4];
	                }
	                t = t|0;
	                t =  rotl(t,sr[i]) ;
	                t = (t+er)|0;
	                ar = er;
	                er = dr;
	                dr = rotl(cr, 10);
	                cr = br;
	                br = t;
	            }
	            // Intermediate hash value
	            t    = (H[1] + cl + dr)|0;
	            H[1] = (H[2] + dl + er)|0;
	            H[2] = (H[3] + el + ar)|0;
	            H[3] = (H[4] + al + br)|0;
	            H[4] = (H[0] + bl + cr)|0;
	            H[0] =  t;
	        },

	        _doFinalize: function () {
	            // Shortcuts
	            var data = this._data;
	            var dataWords = data.words;

	            var nBitsTotal = this._nDataBytes * 8;
	            var nBitsLeft = data.sigBytes * 8;

	            // Add padding
	            dataWords[nBitsLeft >>> 5] |= 0x80 << (24 - nBitsLeft % 32);
	            dataWords[(((nBitsLeft + 64) >>> 9) << 4) + 14] = (
	                (((nBitsTotal << 8)  | (nBitsTotal >>> 24)) & 0x00ff00ff) |
	                (((nBitsTotal << 24) | (nBitsTotal >>> 8))  & 0xff00ff00)
	            );
	            data.sigBytes = (dataWords.length + 1) * 4;

	            // Hash final blocks
	            this._process();

	            // Shortcuts
	            var hash = this._hash;
	            var H = hash.words;

	            // Swap endian
	            for (var i = 0; i < 5; i++) {
	                // Shortcut
	                var H_i = H[i];

	                // Swap
	                H[i] = (((H_i << 8)  | (H_i >>> 24)) & 0x00ff00ff) |
	                       (((H_i << 24) | (H_i >>> 8))  & 0xff00ff00);
	            }

	            // Return final computed hash
	            return hash;
	        },

	        clone: function () {
	            var clone = Hasher.clone.call(this);
	            clone._hash = this._hash.clone();

	            return clone;
	        }
	    });


	    function f1(x, y, z) {
	        return ((x) ^ (y) ^ (z));

	    }

	    function f2(x, y, z) {
	        return (((x)&(y)) | ((~x)&(z)));
	    }

	    function f3(x, y, z) {
	        return (((x) | (~(y))) ^ (z));
	    }

	    function f4(x, y, z) {
	        return (((x) & (z)) | ((y)&(~(z))));
	    }

	    function f5(x, y, z) {
	        return ((x) ^ ((y) |(~(z))));

	    }

	    function rotl(x,n) {
	        return (x<<n) | (x>>>(32-n));
	    }


	    /**
	     * Shortcut function to the hasher's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     *
	     * @return {WordArray} The hash.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hash = CryptoJS.RIPEMD160('message');
	     *     var hash = CryptoJS.RIPEMD160(wordArray);
	     */
	    C.RIPEMD160 = Hasher._createHelper(RIPEMD160);

	    /**
	     * Shortcut function to the HMAC's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     * @param {WordArray|string} key The secret key.
	     *
	     * @return {WordArray} The HMAC.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hmac = CryptoJS.HmacRIPEMD160(message, key);
	     */
	    C.HmacRIPEMD160 = Hasher._createHmacHelper(RIPEMD160);
	}(Math));


	return CryptoJS.RIPEMD160;

}));

/***/ }),
/* 434 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory, undef) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(9), __webpack_require__(111), __webpack_require__(112));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core", "./sha1", "./hmac"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	(function () {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var Base = C_lib.Base;
	    var WordArray = C_lib.WordArray;
	    var C_algo = C.algo;
	    var SHA1 = C_algo.SHA1;
	    var HMAC = C_algo.HMAC;

	    /**
	     * Password-Based Key Derivation Function 2 algorithm.
	     */
	    var PBKDF2 = C_algo.PBKDF2 = Base.extend({
	        /**
	         * Configuration options.
	         *
	         * @property {number} keySize The key size in words to generate. Default: 4 (128 bits)
	         * @property {Hasher} hasher The hasher to use. Default: SHA1
	         * @property {number} iterations The number of iterations to perform. Default: 1
	         */
	        cfg: Base.extend({
	            keySize: 128/32,
	            hasher: SHA1,
	            iterations: 1
	        }),

	        /**
	         * Initializes a newly created key derivation function.
	         *
	         * @param {Object} cfg (Optional) The configuration options to use for the derivation.
	         *
	         * @example
	         *
	         *     var kdf = CryptoJS.algo.PBKDF2.create();
	         *     var kdf = CryptoJS.algo.PBKDF2.create({ keySize: 8 });
	         *     var kdf = CryptoJS.algo.PBKDF2.create({ keySize: 8, iterations: 1000 });
	         */
	        init: function (cfg) {
	            this.cfg = this.cfg.extend(cfg);
	        },

	        /**
	         * Computes the Password-Based Key Derivation Function 2.
	         *
	         * @param {WordArray|string} password The password.
	         * @param {WordArray|string} salt A salt.
	         *
	         * @return {WordArray} The derived key.
	         *
	         * @example
	         *
	         *     var key = kdf.compute(password, salt);
	         */
	        compute: function (password, salt) {
	            // Shortcut
	            var cfg = this.cfg;

	            // Init HMAC
	            var hmac = HMAC.create(cfg.hasher, password);

	            // Initial values
	            var derivedKey = WordArray.create();
	            var blockIndex = WordArray.create([0x00000001]);

	            // Shortcuts
	            var derivedKeyWords = derivedKey.words;
	            var blockIndexWords = blockIndex.words;
	            var keySize = cfg.keySize;
	            var iterations = cfg.iterations;

	            // Generate key
	            while (derivedKeyWords.length < keySize) {
	                var block = hmac.update(salt).finalize(blockIndex);
	                hmac.reset();

	                // Shortcuts
	                var blockWords = block.words;
	                var blockWordsLength = blockWords.length;

	                // Iterations
	                var intermediate = block;
	                for (var i = 1; i < iterations; i++) {
	                    intermediate = hmac.finalize(intermediate);
	                    hmac.reset();

	                    // Shortcut
	                    var intermediateWords = intermediate.words;

	                    // XOR intermediate with block
	                    for (var j = 0; j < blockWordsLength; j++) {
	                        blockWords[j] ^= intermediateWords[j];
	                    }
	                }

	                derivedKey.concat(block);
	                blockIndexWords[0]++;
	            }
	            derivedKey.sigBytes = keySize * 4;

	            return derivedKey;
	        }
	    });

	    /**
	     * Computes the Password-Based Key Derivation Function 2.
	     *
	     * @param {WordArray|string} password The password.
	     * @param {WordArray|string} salt A salt.
	     * @param {Object} cfg (Optional) The configuration options to use for this computation.
	     *
	     * @return {WordArray} The derived key.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var key = CryptoJS.PBKDF2(password, salt);
	     *     var key = CryptoJS.PBKDF2(password, salt, { keySize: 8 });
	     *     var key = CryptoJS.PBKDF2(password, salt, { keySize: 8, iterations: 1000 });
	     */
	    C.PBKDF2 = function (password, salt, cfg) {
	        return PBKDF2.create(cfg).compute(password, salt);
	    };
	}());


	return CryptoJS.PBKDF2;

}));

/***/ }),
/* 435 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory, undef) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(9), __webpack_require__(14));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core", "./cipher-core"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	/**
	 * Cipher Feedback block mode.
	 */
	CryptoJS.mode.CFB = (function () {
	    var CFB = CryptoJS.lib.BlockCipherMode.extend();

	    CFB.Encryptor = CFB.extend({
	        processBlock: function (words, offset) {
	            // Shortcuts
	            var cipher = this._cipher;
	            var blockSize = cipher.blockSize;

	            generateKeystreamAndEncrypt.call(this, words, offset, blockSize, cipher);

	            // Remember this block to use with next block
	            this._prevBlock = words.slice(offset, offset + blockSize);
	        }
	    });

	    CFB.Decryptor = CFB.extend({
	        processBlock: function (words, offset) {
	            // Shortcuts
	            var cipher = this._cipher;
	            var blockSize = cipher.blockSize;

	            // Remember this block to use with next block
	            var thisBlock = words.slice(offset, offset + blockSize);

	            generateKeystreamAndEncrypt.call(this, words, offset, blockSize, cipher);

	            // This block becomes the previous block
	            this._prevBlock = thisBlock;
	        }
	    });

	    function generateKeystreamAndEncrypt(words, offset, blockSize, cipher) {
	        // Shortcut
	        var iv = this._iv;

	        // Generate keystream
	        if (iv) {
	            var keystream = iv.slice(0);

	            // Remove IV for subsequent blocks
	            this._iv = undefined;
	        } else {
	            var keystream = this._prevBlock;
	        }
	        cipher.encryptBlock(keystream, 0);

	        // Encrypt
	        for (var i = 0; i < blockSize; i++) {
	            words[offset + i] ^= keystream[i];
	        }
	    }

	    return CFB;
	}());


	return CryptoJS.mode.CFB;

}));

/***/ }),
/* 436 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory, undef) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(9), __webpack_require__(14));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core", "./cipher-core"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	/**
	 * Counter block mode.
	 */
	CryptoJS.mode.CTR = (function () {
	    var CTR = CryptoJS.lib.BlockCipherMode.extend();

	    var Encryptor = CTR.Encryptor = CTR.extend({
	        processBlock: function (words, offset) {
	            // Shortcuts
	            var cipher = this._cipher
	            var blockSize = cipher.blockSize;
	            var iv = this._iv;
	            var counter = this._counter;

	            // Generate keystream
	            if (iv) {
	                counter = this._counter = iv.slice(0);

	                // Remove IV for subsequent blocks
	                this._iv = undefined;
	            }
	            var keystream = counter.slice(0);
	            cipher.encryptBlock(keystream, 0);

	            // Increment counter
	            counter[blockSize - 1] = (counter[blockSize - 1] + 1) | 0

	            // Encrypt
	            for (var i = 0; i < blockSize; i++) {
	                words[offset + i] ^= keystream[i];
	            }
	        }
	    });

	    CTR.Decryptor = Encryptor;

	    return CTR;
	}());


	return CryptoJS.mode.CTR;

}));

/***/ }),
/* 437 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory, undef) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(9), __webpack_require__(14));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core", "./cipher-core"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	/** @preserve
	 * Counter block mode compatible with  Dr Brian Gladman fileenc.c
	 * derived from CryptoJS.mode.CTR
	 * Jan Hruby jhruby.web@gmail.com
	 */
	CryptoJS.mode.CTRGladman = (function () {
	    var CTRGladman = CryptoJS.lib.BlockCipherMode.extend();

		function incWord(word)
		{
			if (((word >> 24) & 0xff) === 0xff) { //overflow
			var b1 = (word >> 16)&0xff;
			var b2 = (word >> 8)&0xff;
			var b3 = word & 0xff;

			if (b1 === 0xff) // overflow b1
			{
			b1 = 0;
			if (b2 === 0xff)
			{
				b2 = 0;
				if (b3 === 0xff)
				{
					b3 = 0;
				}
				else
				{
					++b3;
				}
			}
			else
			{
				++b2;
			}
			}
			else
			{
			++b1;
			}

			word = 0;
			word += (b1 << 16);
			word += (b2 << 8);
			word += b3;
			}
			else
			{
			word += (0x01 << 24);
			}
			return word;
		}

		function incCounter(counter)
		{
			if ((counter[0] = incWord(counter[0])) === 0)
			{
				// encr_data in fileenc.c from  Dr Brian Gladman's counts only with DWORD j < 8
				counter[1] = incWord(counter[1]);
			}
			return counter;
		}

	    var Encryptor = CTRGladman.Encryptor = CTRGladman.extend({
	        processBlock: function (words, offset) {
	            // Shortcuts
	            var cipher = this._cipher
	            var blockSize = cipher.blockSize;
	            var iv = this._iv;
	            var counter = this._counter;

	            // Generate keystream
	            if (iv) {
	                counter = this._counter = iv.slice(0);

	                // Remove IV for subsequent blocks
	                this._iv = undefined;
	            }

				incCounter(counter);

				var keystream = counter.slice(0);
	            cipher.encryptBlock(keystream, 0);

	            // Encrypt
	            for (var i = 0; i < blockSize; i++) {
	                words[offset + i] ^= keystream[i];
	            }
	        }
	    });

	    CTRGladman.Decryptor = Encryptor;

	    return CTRGladman;
	}());




	return CryptoJS.mode.CTRGladman;

}));

/***/ }),
/* 438 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory, undef) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(9), __webpack_require__(14));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core", "./cipher-core"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	/**
	 * Output Feedback block mode.
	 */
	CryptoJS.mode.OFB = (function () {
	    var OFB = CryptoJS.lib.BlockCipherMode.extend();

	    var Encryptor = OFB.Encryptor = OFB.extend({
	        processBlock: function (words, offset) {
	            // Shortcuts
	            var cipher = this._cipher
	            var blockSize = cipher.blockSize;
	            var iv = this._iv;
	            var keystream = this._keystream;

	            // Generate keystream
	            if (iv) {
	                keystream = this._keystream = iv.slice(0);

	                // Remove IV for subsequent blocks
	                this._iv = undefined;
	            }
	            cipher.encryptBlock(keystream, 0);

	            // Encrypt
	            for (var i = 0; i < blockSize; i++) {
	                words[offset + i] ^= keystream[i];
	            }
	        }
	    });

	    OFB.Decryptor = Encryptor;

	    return OFB;
	}());


	return CryptoJS.mode.OFB;

}));

/***/ }),
/* 439 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory, undef) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(9), __webpack_require__(14));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core", "./cipher-core"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	/**
	 * Electronic Codebook block mode.
	 */
	CryptoJS.mode.ECB = (function () {
	    var ECB = CryptoJS.lib.BlockCipherMode.extend();

	    ECB.Encryptor = ECB.extend({
	        processBlock: function (words, offset) {
	            this._cipher.encryptBlock(words, offset);
	        }
	    });

	    ECB.Decryptor = ECB.extend({
	        processBlock: function (words, offset) {
	            this._cipher.decryptBlock(words, offset);
	        }
	    });

	    return ECB;
	}());


	return CryptoJS.mode.ECB;

}));

/***/ }),
/* 440 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory, undef) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(9), __webpack_require__(14));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core", "./cipher-core"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	/**
	 * ANSI X.923 padding strategy.
	 */
	CryptoJS.pad.AnsiX923 = {
	    pad: function (data, blockSize) {
	        // Shortcuts
	        var dataSigBytes = data.sigBytes;
	        var blockSizeBytes = blockSize * 4;

	        // Count padding bytes
	        var nPaddingBytes = blockSizeBytes - dataSigBytes % blockSizeBytes;

	        // Compute last byte position
	        var lastBytePos = dataSigBytes + nPaddingBytes - 1;

	        // Pad
	        data.clamp();
	        data.words[lastBytePos >>> 2] |= nPaddingBytes << (24 - (lastBytePos % 4) * 8);
	        data.sigBytes += nPaddingBytes;
	    },

	    unpad: function (data) {
	        // Get number of padding bytes from last byte
	        var nPaddingBytes = data.words[(data.sigBytes - 1) >>> 2] & 0xff;

	        // Remove padding
	        data.sigBytes -= nPaddingBytes;
	    }
	};


	return CryptoJS.pad.Ansix923;

}));

/***/ }),
/* 441 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory, undef) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(9), __webpack_require__(14));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core", "./cipher-core"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	/**
	 * ISO 10126 padding strategy.
	 */
	CryptoJS.pad.Iso10126 = {
	    pad: function (data, blockSize) {
	        // Shortcut
	        var blockSizeBytes = blockSize * 4;

	        // Count padding bytes
	        var nPaddingBytes = blockSizeBytes - data.sigBytes % blockSizeBytes;

	        // Pad
	        data.concat(CryptoJS.lib.WordArray.random(nPaddingBytes - 1)).
	             concat(CryptoJS.lib.WordArray.create([nPaddingBytes << 24], 1));
	    },

	    unpad: function (data) {
	        // Get number of padding bytes from last byte
	        var nPaddingBytes = data.words[(data.sigBytes - 1) >>> 2] & 0xff;

	        // Remove padding
	        data.sigBytes -= nPaddingBytes;
	    }
	};


	return CryptoJS.pad.Iso10126;

}));

/***/ }),
/* 442 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory, undef) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(9), __webpack_require__(14));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core", "./cipher-core"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	/**
	 * ISO/IEC 9797-1 Padding Method 2.
	 */
	CryptoJS.pad.Iso97971 = {
	    pad: function (data, blockSize) {
	        // Add 0x80 byte
	        data.concat(CryptoJS.lib.WordArray.create([0x80000000], 1));

	        // Zero pad the rest
	        CryptoJS.pad.ZeroPadding.pad(data, blockSize);
	    },

	    unpad: function (data) {
	        // Remove zero padding
	        CryptoJS.pad.ZeroPadding.unpad(data);

	        // Remove one more byte -- the 0x80 byte
	        data.sigBytes--;
	    }
	};


	return CryptoJS.pad.Iso97971;

}));

/***/ }),
/* 443 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory, undef) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(9), __webpack_require__(14));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core", "./cipher-core"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	/**
	 * Zero padding strategy.
	 */
	CryptoJS.pad.ZeroPadding = {
	    pad: function (data, blockSize) {
	        // Shortcut
	        var blockSizeBytes = blockSize * 4;

	        // Pad
	        data.clamp();
	        data.sigBytes += blockSizeBytes - ((data.sigBytes % blockSizeBytes) || blockSizeBytes);
	    },

	    unpad: function (data) {
	        // Shortcut
	        var dataWords = data.words;

	        // Unpad
	        var i = data.sigBytes - 1;
	        while (!((dataWords[i >>> 2] >>> (24 - (i % 4) * 8)) & 0xff)) {
	            i--;
	        }
	        data.sigBytes = i + 1;
	    }
	};


	return CryptoJS.pad.ZeroPadding;

}));

/***/ }),
/* 444 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory, undef) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(9), __webpack_require__(14));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core", "./cipher-core"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	/**
	 * A noop padding strategy.
	 */
	CryptoJS.pad.NoPadding = {
	    pad: function () {
	    },

	    unpad: function () {
	    }
	};


	return CryptoJS.pad.NoPadding;

}));

/***/ }),
/* 445 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory, undef) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(9), __webpack_require__(14));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core", "./cipher-core"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	(function (undefined) {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var CipherParams = C_lib.CipherParams;
	    var C_enc = C.enc;
	    var Hex = C_enc.Hex;
	    var C_format = C.format;

	    var HexFormatter = C_format.Hex = {
	        /**
	         * Converts the ciphertext of a cipher params object to a hexadecimally encoded string.
	         *
	         * @param {CipherParams} cipherParams The cipher params object.
	         *
	         * @return {string} The hexadecimally encoded string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var hexString = CryptoJS.format.Hex.stringify(cipherParams);
	         */
	        stringify: function (cipherParams) {
	            return cipherParams.ciphertext.toString(Hex);
	        },

	        /**
	         * Converts a hexadecimally encoded ciphertext string to a cipher params object.
	         *
	         * @param {string} input The hexadecimally encoded string.
	         *
	         * @return {CipherParams} The cipher params object.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var cipherParams = CryptoJS.format.Hex.parse(hexString);
	         */
	        parse: function (input) {
	            var ciphertext = Hex.parse(input);
	            return CipherParams.create({ ciphertext: ciphertext });
	        }
	    };
	}());


	return CryptoJS.format.Hex;

}));

/***/ }),
/* 446 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory, undef) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(9), __webpack_require__(40), __webpack_require__(41), __webpack_require__(33), __webpack_require__(14));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core", "./enc-base64", "./md5", "./evpkdf", "./cipher-core"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	(function () {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var BlockCipher = C_lib.BlockCipher;
	    var C_algo = C.algo;

	    // Lookup tables
	    var SBOX = [];
	    var INV_SBOX = [];
	    var SUB_MIX_0 = [];
	    var SUB_MIX_1 = [];
	    var SUB_MIX_2 = [];
	    var SUB_MIX_3 = [];
	    var INV_SUB_MIX_0 = [];
	    var INV_SUB_MIX_1 = [];
	    var INV_SUB_MIX_2 = [];
	    var INV_SUB_MIX_3 = [];

	    // Compute lookup tables
	    (function () {
	        // Compute double table
	        var d = [];
	        for (var i = 0; i < 256; i++) {
	            if (i < 128) {
	                d[i] = i << 1;
	            } else {
	                d[i] = (i << 1) ^ 0x11b;
	            }
	        }

	        // Walk GF(2^8)
	        var x = 0;
	        var xi = 0;
	        for (var i = 0; i < 256; i++) {
	            // Compute sbox
	            var sx = xi ^ (xi << 1) ^ (xi << 2) ^ (xi << 3) ^ (xi << 4);
	            sx = (sx >>> 8) ^ (sx & 0xff) ^ 0x63;
	            SBOX[x] = sx;
	            INV_SBOX[sx] = x;

	            // Compute multiplication
	            var x2 = d[x];
	            var x4 = d[x2];
	            var x8 = d[x4];

	            // Compute sub bytes, mix columns tables
	            var t = (d[sx] * 0x101) ^ (sx * 0x1010100);
	            SUB_MIX_0[x] = (t << 24) | (t >>> 8);
	            SUB_MIX_1[x] = (t << 16) | (t >>> 16);
	            SUB_MIX_2[x] = (t << 8)  | (t >>> 24);
	            SUB_MIX_3[x] = t;

	            // Compute inv sub bytes, inv mix columns tables
	            var t = (x8 * 0x1010101) ^ (x4 * 0x10001) ^ (x2 * 0x101) ^ (x * 0x1010100);
	            INV_SUB_MIX_0[sx] = (t << 24) | (t >>> 8);
	            INV_SUB_MIX_1[sx] = (t << 16) | (t >>> 16);
	            INV_SUB_MIX_2[sx] = (t << 8)  | (t >>> 24);
	            INV_SUB_MIX_3[sx] = t;

	            // Compute next counter
	            if (!x) {
	                x = xi = 1;
	            } else {
	                x = x2 ^ d[d[d[x8 ^ x2]]];
	                xi ^= d[d[xi]];
	            }
	        }
	    }());

	    // Precomputed Rcon lookup
	    var RCON = [0x00, 0x01, 0x02, 0x04, 0x08, 0x10, 0x20, 0x40, 0x80, 0x1b, 0x36];

	    /**
	     * AES block cipher algorithm.
	     */
	    var AES = C_algo.AES = BlockCipher.extend({
	        _doReset: function () {
	            // Skip reset of nRounds has been set before and key did not change
	            if (this._nRounds && this._keyPriorReset === this._key) {
	                return;
	            }

	            // Shortcuts
	            var key = this._keyPriorReset = this._key;
	            var keyWords = key.words;
	            var keySize = key.sigBytes / 4;

	            // Compute number of rounds
	            var nRounds = this._nRounds = keySize + 6;

	            // Compute number of key schedule rows
	            var ksRows = (nRounds + 1) * 4;

	            // Compute key schedule
	            var keySchedule = this._keySchedule = [];
	            for (var ksRow = 0; ksRow < ksRows; ksRow++) {
	                if (ksRow < keySize) {
	                    keySchedule[ksRow] = keyWords[ksRow];
	                } else {
	                    var t = keySchedule[ksRow - 1];

	                    if (!(ksRow % keySize)) {
	                        // Rot word
	                        t = (t << 8) | (t >>> 24);

	                        // Sub word
	                        t = (SBOX[t >>> 24] << 24) | (SBOX[(t >>> 16) & 0xff] << 16) | (SBOX[(t >>> 8) & 0xff] << 8) | SBOX[t & 0xff];

	                        // Mix Rcon
	                        t ^= RCON[(ksRow / keySize) | 0] << 24;
	                    } else if (keySize > 6 && ksRow % keySize == 4) {
	                        // Sub word
	                        t = (SBOX[t >>> 24] << 24) | (SBOX[(t >>> 16) & 0xff] << 16) | (SBOX[(t >>> 8) & 0xff] << 8) | SBOX[t & 0xff];
	                    }

	                    keySchedule[ksRow] = keySchedule[ksRow - keySize] ^ t;
	                }
	            }

	            // Compute inv key schedule
	            var invKeySchedule = this._invKeySchedule = [];
	            for (var invKsRow = 0; invKsRow < ksRows; invKsRow++) {
	                var ksRow = ksRows - invKsRow;

	                if (invKsRow % 4) {
	                    var t = keySchedule[ksRow];
	                } else {
	                    var t = keySchedule[ksRow - 4];
	                }

	                if (invKsRow < 4 || ksRow <= 4) {
	                    invKeySchedule[invKsRow] = t;
	                } else {
	                    invKeySchedule[invKsRow] = INV_SUB_MIX_0[SBOX[t >>> 24]] ^ INV_SUB_MIX_1[SBOX[(t >>> 16) & 0xff]] ^
	                                               INV_SUB_MIX_2[SBOX[(t >>> 8) & 0xff]] ^ INV_SUB_MIX_3[SBOX[t & 0xff]];
	                }
	            }
	        },

	        encryptBlock: function (M, offset) {
	            this._doCryptBlock(M, offset, this._keySchedule, SUB_MIX_0, SUB_MIX_1, SUB_MIX_2, SUB_MIX_3, SBOX);
	        },

	        decryptBlock: function (M, offset) {
	            // Swap 2nd and 4th rows
	            var t = M[offset + 1];
	            M[offset + 1] = M[offset + 3];
	            M[offset + 3] = t;

	            this._doCryptBlock(M, offset, this._invKeySchedule, INV_SUB_MIX_0, INV_SUB_MIX_1, INV_SUB_MIX_2, INV_SUB_MIX_3, INV_SBOX);

	            // Inv swap 2nd and 4th rows
	            var t = M[offset + 1];
	            M[offset + 1] = M[offset + 3];
	            M[offset + 3] = t;
	        },

	        _doCryptBlock: function (M, offset, keySchedule, SUB_MIX_0, SUB_MIX_1, SUB_MIX_2, SUB_MIX_3, SBOX) {
	            // Shortcut
	            var nRounds = this._nRounds;

	            // Get input, add round key
	            var s0 = M[offset]     ^ keySchedule[0];
	            var s1 = M[offset + 1] ^ keySchedule[1];
	            var s2 = M[offset + 2] ^ keySchedule[2];
	            var s3 = M[offset + 3] ^ keySchedule[3];

	            // Key schedule row counter
	            var ksRow = 4;

	            // Rounds
	            for (var round = 1; round < nRounds; round++) {
	                // Shift rows, sub bytes, mix columns, add round key
	                var t0 = SUB_MIX_0[s0 >>> 24] ^ SUB_MIX_1[(s1 >>> 16) & 0xff] ^ SUB_MIX_2[(s2 >>> 8) & 0xff] ^ SUB_MIX_3[s3 & 0xff] ^ keySchedule[ksRow++];
	                var t1 = SUB_MIX_0[s1 >>> 24] ^ SUB_MIX_1[(s2 >>> 16) & 0xff] ^ SUB_MIX_2[(s3 >>> 8) & 0xff] ^ SUB_MIX_3[s0 & 0xff] ^ keySchedule[ksRow++];
	                var t2 = SUB_MIX_0[s2 >>> 24] ^ SUB_MIX_1[(s3 >>> 16) & 0xff] ^ SUB_MIX_2[(s0 >>> 8) & 0xff] ^ SUB_MIX_3[s1 & 0xff] ^ keySchedule[ksRow++];
	                var t3 = SUB_MIX_0[s3 >>> 24] ^ SUB_MIX_1[(s0 >>> 16) & 0xff] ^ SUB_MIX_2[(s1 >>> 8) & 0xff] ^ SUB_MIX_3[s2 & 0xff] ^ keySchedule[ksRow++];

	                // Update state
	                s0 = t0;
	                s1 = t1;
	                s2 = t2;
	                s3 = t3;
	            }

	            // Shift rows, sub bytes, add round key
	            var t0 = ((SBOX[s0 >>> 24] << 24) | (SBOX[(s1 >>> 16) & 0xff] << 16) | (SBOX[(s2 >>> 8) & 0xff] << 8) | SBOX[s3 & 0xff]) ^ keySchedule[ksRow++];
	            var t1 = ((SBOX[s1 >>> 24] << 24) | (SBOX[(s2 >>> 16) & 0xff] << 16) | (SBOX[(s3 >>> 8) & 0xff] << 8) | SBOX[s0 & 0xff]) ^ keySchedule[ksRow++];
	            var t2 = ((SBOX[s2 >>> 24] << 24) | (SBOX[(s3 >>> 16) & 0xff] << 16) | (SBOX[(s0 >>> 8) & 0xff] << 8) | SBOX[s1 & 0xff]) ^ keySchedule[ksRow++];
	            var t3 = ((SBOX[s3 >>> 24] << 24) | (SBOX[(s0 >>> 16) & 0xff] << 16) | (SBOX[(s1 >>> 8) & 0xff] << 8) | SBOX[s2 & 0xff]) ^ keySchedule[ksRow++];

	            // Set output
	            M[offset]     = t0;
	            M[offset + 1] = t1;
	            M[offset + 2] = t2;
	            M[offset + 3] = t3;
	        },

	        keySize: 256/32
	    });

	    /**
	     * Shortcut functions to the cipher's object interface.
	     *
	     * @example
	     *
	     *     var ciphertext = CryptoJS.AES.encrypt(message, key, cfg);
	     *     var plaintext  = CryptoJS.AES.decrypt(ciphertext, key, cfg);
	     */
	    C.AES = BlockCipher._createHelper(AES);
	}());


	return CryptoJS.AES;

}));

/***/ }),
/* 447 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory, undef) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(9), __webpack_require__(40), __webpack_require__(41), __webpack_require__(33), __webpack_require__(14));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core", "./enc-base64", "./md5", "./evpkdf", "./cipher-core"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	(function () {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var WordArray = C_lib.WordArray;
	    var BlockCipher = C_lib.BlockCipher;
	    var C_algo = C.algo;

	    // Permuted Choice 1 constants
	    var PC1 = [
	        57, 49, 41, 33, 25, 17, 9,  1,
	        58, 50, 42, 34, 26, 18, 10, 2,
	        59, 51, 43, 35, 27, 19, 11, 3,
	        60, 52, 44, 36, 63, 55, 47, 39,
	        31, 23, 15, 7,  62, 54, 46, 38,
	        30, 22, 14, 6,  61, 53, 45, 37,
	        29, 21, 13, 5,  28, 20, 12, 4
	    ];

	    // Permuted Choice 2 constants
	    var PC2 = [
	        14, 17, 11, 24, 1,  5,
	        3,  28, 15, 6,  21, 10,
	        23, 19, 12, 4,  26, 8,
	        16, 7,  27, 20, 13, 2,
	        41, 52, 31, 37, 47, 55,
	        30, 40, 51, 45, 33, 48,
	        44, 49, 39, 56, 34, 53,
	        46, 42, 50, 36, 29, 32
	    ];

	    // Cumulative bit shift constants
	    var BIT_SHIFTS = [1,  2,  4,  6,  8,  10, 12, 14, 15, 17, 19, 21, 23, 25, 27, 28];

	    // SBOXes and round permutation constants
	    var SBOX_P = [
	        {
	            0x0: 0x808200,
	            0x10000000: 0x8000,
	            0x20000000: 0x808002,
	            0x30000000: 0x2,
	            0x40000000: 0x200,
	            0x50000000: 0x808202,
	            0x60000000: 0x800202,
	            0x70000000: 0x800000,
	            0x80000000: 0x202,
	            0x90000000: 0x800200,
	            0xa0000000: 0x8200,
	            0xb0000000: 0x808000,
	            0xc0000000: 0x8002,
	            0xd0000000: 0x800002,
	            0xe0000000: 0x0,
	            0xf0000000: 0x8202,
	            0x8000000: 0x0,
	            0x18000000: 0x808202,
	            0x28000000: 0x8202,
	            0x38000000: 0x8000,
	            0x48000000: 0x808200,
	            0x58000000: 0x200,
	            0x68000000: 0x808002,
	            0x78000000: 0x2,
	            0x88000000: 0x800200,
	            0x98000000: 0x8200,
	            0xa8000000: 0x808000,
	            0xb8000000: 0x800202,
	            0xc8000000: 0x800002,
	            0xd8000000: 0x8002,
	            0xe8000000: 0x202,
	            0xf8000000: 0x800000,
	            0x1: 0x8000,
	            0x10000001: 0x2,
	            0x20000001: 0x808200,
	            0x30000001: 0x800000,
	            0x40000001: 0x808002,
	            0x50000001: 0x8200,
	            0x60000001: 0x200,
	            0x70000001: 0x800202,
	            0x80000001: 0x808202,
	            0x90000001: 0x808000,
	            0xa0000001: 0x800002,
	            0xb0000001: 0x8202,
	            0xc0000001: 0x202,
	            0xd0000001: 0x800200,
	            0xe0000001: 0x8002,
	            0xf0000001: 0x0,
	            0x8000001: 0x808202,
	            0x18000001: 0x808000,
	            0x28000001: 0x800000,
	            0x38000001: 0x200,
	            0x48000001: 0x8000,
	            0x58000001: 0x800002,
	            0x68000001: 0x2,
	            0x78000001: 0x8202,
	            0x88000001: 0x8002,
	            0x98000001: 0x800202,
	            0xa8000001: 0x202,
	            0xb8000001: 0x808200,
	            0xc8000001: 0x800200,
	            0xd8000001: 0x0,
	            0xe8000001: 0x8200,
	            0xf8000001: 0x808002
	        },
	        {
	            0x0: 0x40084010,
	            0x1000000: 0x4000,
	            0x2000000: 0x80000,
	            0x3000000: 0x40080010,
	            0x4000000: 0x40000010,
	            0x5000000: 0x40084000,
	            0x6000000: 0x40004000,
	            0x7000000: 0x10,
	            0x8000000: 0x84000,
	            0x9000000: 0x40004010,
	            0xa000000: 0x40000000,
	            0xb000000: 0x84010,
	            0xc000000: 0x80010,
	            0xd000000: 0x0,
	            0xe000000: 0x4010,
	            0xf000000: 0x40080000,
	            0x800000: 0x40004000,
	            0x1800000: 0x84010,
	            0x2800000: 0x10,
	            0x3800000: 0x40004010,
	            0x4800000: 0x40084010,
	            0x5800000: 0x40000000,
	            0x6800000: 0x80000,
	            0x7800000: 0x40080010,
	            0x8800000: 0x80010,
	            0x9800000: 0x0,
	            0xa800000: 0x4000,
	            0xb800000: 0x40080000,
	            0xc800000: 0x40000010,
	            0xd800000: 0x84000,
	            0xe800000: 0x40084000,
	            0xf800000: 0x4010,
	            0x10000000: 0x0,
	            0x11000000: 0x40080010,
	            0x12000000: 0x40004010,
	            0x13000000: 0x40084000,
	            0x14000000: 0x40080000,
	            0x15000000: 0x10,
	            0x16000000: 0x84010,
	            0x17000000: 0x4000,
	            0x18000000: 0x4010,
	            0x19000000: 0x80000,
	            0x1a000000: 0x80010,
	            0x1b000000: 0x40000010,
	            0x1c000000: 0x84000,
	            0x1d000000: 0x40004000,
	            0x1e000000: 0x40000000,
	            0x1f000000: 0x40084010,
	            0x10800000: 0x84010,
	            0x11800000: 0x80000,
	            0x12800000: 0x40080000,
	            0x13800000: 0x4000,
	            0x14800000: 0x40004000,
	            0x15800000: 0x40084010,
	            0x16800000: 0x10,
	            0x17800000: 0x40000000,
	            0x18800000: 0x40084000,
	            0x19800000: 0x40000010,
	            0x1a800000: 0x40004010,
	            0x1b800000: 0x80010,
	            0x1c800000: 0x0,
	            0x1d800000: 0x4010,
	            0x1e800000: 0x40080010,
	            0x1f800000: 0x84000
	        },
	        {
	            0x0: 0x104,
	            0x100000: 0x0,
	            0x200000: 0x4000100,
	            0x300000: 0x10104,
	            0x400000: 0x10004,
	            0x500000: 0x4000004,
	            0x600000: 0x4010104,
	            0x700000: 0x4010000,
	            0x800000: 0x4000000,
	            0x900000: 0x4010100,
	            0xa00000: 0x10100,
	            0xb00000: 0x4010004,
	            0xc00000: 0x4000104,
	            0xd00000: 0x10000,
	            0xe00000: 0x4,
	            0xf00000: 0x100,
	            0x80000: 0x4010100,
	            0x180000: 0x4010004,
	            0x280000: 0x0,
	            0x380000: 0x4000100,
	            0x480000: 0x4000004,
	            0x580000: 0x10000,
	            0x680000: 0x10004,
	            0x780000: 0x104,
	            0x880000: 0x4,
	            0x980000: 0x100,
	            0xa80000: 0x4010000,
	            0xb80000: 0x10104,
	            0xc80000: 0x10100,
	            0xd80000: 0x4000104,
	            0xe80000: 0x4010104,
	            0xf80000: 0x4000000,
	            0x1000000: 0x4010100,
	            0x1100000: 0x10004,
	            0x1200000: 0x10000,
	            0x1300000: 0x4000100,
	            0x1400000: 0x100,
	            0x1500000: 0x4010104,
	            0x1600000: 0x4000004,
	            0x1700000: 0x0,
	            0x1800000: 0x4000104,
	            0x1900000: 0x4000000,
	            0x1a00000: 0x4,
	            0x1b00000: 0x10100,
	            0x1c00000: 0x4010000,
	            0x1d00000: 0x104,
	            0x1e00000: 0x10104,
	            0x1f00000: 0x4010004,
	            0x1080000: 0x4000000,
	            0x1180000: 0x104,
	            0x1280000: 0x4010100,
	            0x1380000: 0x0,
	            0x1480000: 0x10004,
	            0x1580000: 0x4000100,
	            0x1680000: 0x100,
	            0x1780000: 0x4010004,
	            0x1880000: 0x10000,
	            0x1980000: 0x4010104,
	            0x1a80000: 0x10104,
	            0x1b80000: 0x4000004,
	            0x1c80000: 0x4000104,
	            0x1d80000: 0x4010000,
	            0x1e80000: 0x4,
	            0x1f80000: 0x10100
	        },
	        {
	            0x0: 0x80401000,
	            0x10000: 0x80001040,
	            0x20000: 0x401040,
	            0x30000: 0x80400000,
	            0x40000: 0x0,
	            0x50000: 0x401000,
	            0x60000: 0x80000040,
	            0x70000: 0x400040,
	            0x80000: 0x80000000,
	            0x90000: 0x400000,
	            0xa0000: 0x40,
	            0xb0000: 0x80001000,
	            0xc0000: 0x80400040,
	            0xd0000: 0x1040,
	            0xe0000: 0x1000,
	            0xf0000: 0x80401040,
	            0x8000: 0x80001040,
	            0x18000: 0x40,
	            0x28000: 0x80400040,
	            0x38000: 0x80001000,
	            0x48000: 0x401000,
	            0x58000: 0x80401040,
	            0x68000: 0x0,
	            0x78000: 0x80400000,
	            0x88000: 0x1000,
	            0x98000: 0x80401000,
	            0xa8000: 0x400000,
	            0xb8000: 0x1040,
	            0xc8000: 0x80000000,
	            0xd8000: 0x400040,
	            0xe8000: 0x401040,
	            0xf8000: 0x80000040,
	            0x100000: 0x400040,
	            0x110000: 0x401000,
	            0x120000: 0x80000040,
	            0x130000: 0x0,
	            0x140000: 0x1040,
	            0x150000: 0x80400040,
	            0x160000: 0x80401000,
	            0x170000: 0x80001040,
	            0x180000: 0x80401040,
	            0x190000: 0x80000000,
	            0x1a0000: 0x80400000,
	            0x1b0000: 0x401040,
	            0x1c0000: 0x80001000,
	            0x1d0000: 0x400000,
	            0x1e0000: 0x40,
	            0x1f0000: 0x1000,
	            0x108000: 0x80400000,
	            0x118000: 0x80401040,
	            0x128000: 0x0,
	            0x138000: 0x401000,
	            0x148000: 0x400040,
	            0x158000: 0x80000000,
	            0x168000: 0x80001040,
	            0x178000: 0x40,
	            0x188000: 0x80000040,
	            0x198000: 0x1000,
	            0x1a8000: 0x80001000,
	            0x1b8000: 0x80400040,
	            0x1c8000: 0x1040,
	            0x1d8000: 0x80401000,
	            0x1e8000: 0x400000,
	            0x1f8000: 0x401040
	        },
	        {
	            0x0: 0x80,
	            0x1000: 0x1040000,
	            0x2000: 0x40000,
	            0x3000: 0x20000000,
	            0x4000: 0x20040080,
	            0x5000: 0x1000080,
	            0x6000: 0x21000080,
	            0x7000: 0x40080,
	            0x8000: 0x1000000,
	            0x9000: 0x20040000,
	            0xa000: 0x20000080,
	            0xb000: 0x21040080,
	            0xc000: 0x21040000,
	            0xd000: 0x0,
	            0xe000: 0x1040080,
	            0xf000: 0x21000000,
	            0x800: 0x1040080,
	            0x1800: 0x21000080,
	            0x2800: 0x80,
	            0x3800: 0x1040000,
	            0x4800: 0x40000,
	            0x5800: 0x20040080,
	            0x6800: 0x21040000,
	            0x7800: 0x20000000,
	            0x8800: 0x20040000,
	            0x9800: 0x0,
	            0xa800: 0x21040080,
	            0xb800: 0x1000080,
	            0xc800: 0x20000080,
	            0xd800: 0x21000000,
	            0xe800: 0x1000000,
	            0xf800: 0x40080,
	            0x10000: 0x40000,
	            0x11000: 0x80,
	            0x12000: 0x20000000,
	            0x13000: 0x21000080,
	            0x14000: 0x1000080,
	            0x15000: 0x21040000,
	            0x16000: 0x20040080,
	            0x17000: 0x1000000,
	            0x18000: 0x21040080,
	            0x19000: 0x21000000,
	            0x1a000: 0x1040000,
	            0x1b000: 0x20040000,
	            0x1c000: 0x40080,
	            0x1d000: 0x20000080,
	            0x1e000: 0x0,
	            0x1f000: 0x1040080,
	            0x10800: 0x21000080,
	            0x11800: 0x1000000,
	            0x12800: 0x1040000,
	            0x13800: 0x20040080,
	            0x14800: 0x20000000,
	            0x15800: 0x1040080,
	            0x16800: 0x80,
	            0x17800: 0x21040000,
	            0x18800: 0x40080,
	            0x19800: 0x21040080,
	            0x1a800: 0x0,
	            0x1b800: 0x21000000,
	            0x1c800: 0x1000080,
	            0x1d800: 0x40000,
	            0x1e800: 0x20040000,
	            0x1f800: 0x20000080
	        },
	        {
	            0x0: 0x10000008,
	            0x100: 0x2000,
	            0x200: 0x10200000,
	            0x300: 0x10202008,
	            0x400: 0x10002000,
	            0x500: 0x200000,
	            0x600: 0x200008,
	            0x700: 0x10000000,
	            0x800: 0x0,
	            0x900: 0x10002008,
	            0xa00: 0x202000,
	            0xb00: 0x8,
	            0xc00: 0x10200008,
	            0xd00: 0x202008,
	            0xe00: 0x2008,
	            0xf00: 0x10202000,
	            0x80: 0x10200000,
	            0x180: 0x10202008,
	            0x280: 0x8,
	            0x380: 0x200000,
	            0x480: 0x202008,
	            0x580: 0x10000008,
	            0x680: 0x10002000,
	            0x780: 0x2008,
	            0x880: 0x200008,
	            0x980: 0x2000,
	            0xa80: 0x10002008,
	            0xb80: 0x10200008,
	            0xc80: 0x0,
	            0xd80: 0x10202000,
	            0xe80: 0x202000,
	            0xf80: 0x10000000,
	            0x1000: 0x10002000,
	            0x1100: 0x10200008,
	            0x1200: 0x10202008,
	            0x1300: 0x2008,
	            0x1400: 0x200000,
	            0x1500: 0x10000000,
	            0x1600: 0x10000008,
	            0x1700: 0x202000,
	            0x1800: 0x202008,
	            0x1900: 0x0,
	            0x1a00: 0x8,
	            0x1b00: 0x10200000,
	            0x1c00: 0x2000,
	            0x1d00: 0x10002008,
	            0x1e00: 0x10202000,
	            0x1f00: 0x200008,
	            0x1080: 0x8,
	            0x1180: 0x202000,
	            0x1280: 0x200000,
	            0x1380: 0x10000008,
	            0x1480: 0x10002000,
	            0x1580: 0x2008,
	            0x1680: 0x10202008,
	            0x1780: 0x10200000,
	            0x1880: 0x10202000,
	            0x1980: 0x10200008,
	            0x1a80: 0x2000,
	            0x1b80: 0x202008,
	            0x1c80: 0x200008,
	            0x1d80: 0x0,
	            0x1e80: 0x10000000,
	            0x1f80: 0x10002008
	        },
	        {
	            0x0: 0x100000,
	            0x10: 0x2000401,
	            0x20: 0x400,
	            0x30: 0x100401,
	            0x40: 0x2100401,
	            0x50: 0x0,
	            0x60: 0x1,
	            0x70: 0x2100001,
	            0x80: 0x2000400,
	            0x90: 0x100001,
	            0xa0: 0x2000001,
	            0xb0: 0x2100400,
	            0xc0: 0x2100000,
	            0xd0: 0x401,
	            0xe0: 0x100400,
	            0xf0: 0x2000000,
	            0x8: 0x2100001,
	            0x18: 0x0,
	            0x28: 0x2000401,
	            0x38: 0x2100400,
	            0x48: 0x100000,
	            0x58: 0x2000001,
	            0x68: 0x2000000,
	            0x78: 0x401,
	            0x88: 0x100401,
	            0x98: 0x2000400,
	            0xa8: 0x2100000,
	            0xb8: 0x100001,
	            0xc8: 0x400,
	            0xd8: 0x2100401,
	            0xe8: 0x1,
	            0xf8: 0x100400,
	            0x100: 0x2000000,
	            0x110: 0x100000,
	            0x120: 0x2000401,
	            0x130: 0x2100001,
	            0x140: 0x100001,
	            0x150: 0x2000400,
	            0x160: 0x2100400,
	            0x170: 0x100401,
	            0x180: 0x401,
	            0x190: 0x2100401,
	            0x1a0: 0x100400,
	            0x1b0: 0x1,
	            0x1c0: 0x0,
	            0x1d0: 0x2100000,
	            0x1e0: 0x2000001,
	            0x1f0: 0x400,
	            0x108: 0x100400,
	            0x118: 0x2000401,
	            0x128: 0x2100001,
	            0x138: 0x1,
	            0x148: 0x2000000,
	            0x158: 0x100000,
	            0x168: 0x401,
	            0x178: 0x2100400,
	            0x188: 0x2000001,
	            0x198: 0x2100000,
	            0x1a8: 0x0,
	            0x1b8: 0x2100401,
	            0x1c8: 0x100401,
	            0x1d8: 0x400,
	            0x1e8: 0x2000400,
	            0x1f8: 0x100001
	        },
	        {
	            0x0: 0x8000820,
	            0x1: 0x20000,
	            0x2: 0x8000000,
	            0x3: 0x20,
	            0x4: 0x20020,
	            0x5: 0x8020820,
	            0x6: 0x8020800,
	            0x7: 0x800,
	            0x8: 0x8020000,
	            0x9: 0x8000800,
	            0xa: 0x20800,
	            0xb: 0x8020020,
	            0xc: 0x820,
	            0xd: 0x0,
	            0xe: 0x8000020,
	            0xf: 0x20820,
	            0x80000000: 0x800,
	            0x80000001: 0x8020820,
	            0x80000002: 0x8000820,
	            0x80000003: 0x8000000,
	            0x80000004: 0x8020000,
	            0x80000005: 0x20800,
	            0x80000006: 0x20820,
	            0x80000007: 0x20,
	            0x80000008: 0x8000020,
	            0x80000009: 0x820,
	            0x8000000a: 0x20020,
	            0x8000000b: 0x8020800,
	            0x8000000c: 0x0,
	            0x8000000d: 0x8020020,
	            0x8000000e: 0x8000800,
	            0x8000000f: 0x20000,
	            0x10: 0x20820,
	            0x11: 0x8020800,
	            0x12: 0x20,
	            0x13: 0x800,
	            0x14: 0x8000800,
	            0x15: 0x8000020,
	            0x16: 0x8020020,
	            0x17: 0x20000,
	            0x18: 0x0,
	            0x19: 0x20020,
	            0x1a: 0x8020000,
	            0x1b: 0x8000820,
	            0x1c: 0x8020820,
	            0x1d: 0x20800,
	            0x1e: 0x820,
	            0x1f: 0x8000000,
	            0x80000010: 0x20000,
	            0x80000011: 0x800,
	            0x80000012: 0x8020020,
	            0x80000013: 0x20820,
	            0x80000014: 0x20,
	            0x80000015: 0x8020000,
	            0x80000016: 0x8000000,
	            0x80000017: 0x8000820,
	            0x80000018: 0x8020820,
	            0x80000019: 0x8000020,
	            0x8000001a: 0x8000800,
	            0x8000001b: 0x0,
	            0x8000001c: 0x20800,
	            0x8000001d: 0x820,
	            0x8000001e: 0x20020,
	            0x8000001f: 0x8020800
	        }
	    ];

	    // Masks that select the SBOX input
	    var SBOX_MASK = [
	        0xf8000001, 0x1f800000, 0x01f80000, 0x001f8000,
	        0x0001f800, 0x00001f80, 0x000001f8, 0x8000001f
	    ];

	    /**
	     * DES block cipher algorithm.
	     */
	    var DES = C_algo.DES = BlockCipher.extend({
	        _doReset: function () {
	            // Shortcuts
	            var key = this._key;
	            var keyWords = key.words;

	            // Select 56 bits according to PC1
	            var keyBits = [];
	            for (var i = 0; i < 56; i++) {
	                var keyBitPos = PC1[i] - 1;
	                keyBits[i] = (keyWords[keyBitPos >>> 5] >>> (31 - keyBitPos % 32)) & 1;
	            }

	            // Assemble 16 subkeys
	            var subKeys = this._subKeys = [];
	            for (var nSubKey = 0; nSubKey < 16; nSubKey++) {
	                // Create subkey
	                var subKey = subKeys[nSubKey] = [];

	                // Shortcut
	                var bitShift = BIT_SHIFTS[nSubKey];

	                // Select 48 bits according to PC2
	                for (var i = 0; i < 24; i++) {
	                    // Select from the left 28 key bits
	                    subKey[(i / 6) | 0] |= keyBits[((PC2[i] - 1) + bitShift) % 28] << (31 - i % 6);

	                    // Select from the right 28 key bits
	                    subKey[4 + ((i / 6) | 0)] |= keyBits[28 + (((PC2[i + 24] - 1) + bitShift) % 28)] << (31 - i % 6);
	                }

	                // Since each subkey is applied to an expanded 32-bit input,
	                // the subkey can be broken into 8 values scaled to 32-bits,
	                // which allows the key to be used without expansion
	                subKey[0] = (subKey[0] << 1) | (subKey[0] >>> 31);
	                for (var i = 1; i < 7; i++) {
	                    subKey[i] = subKey[i] >>> ((i - 1) * 4 + 3);
	                }
	                subKey[7] = (subKey[7] << 5) | (subKey[7] >>> 27);
	            }

	            // Compute inverse subkeys
	            var invSubKeys = this._invSubKeys = [];
	            for (var i = 0; i < 16; i++) {
	                invSubKeys[i] = subKeys[15 - i];
	            }
	        },

	        encryptBlock: function (M, offset) {
	            this._doCryptBlock(M, offset, this._subKeys);
	        },

	        decryptBlock: function (M, offset) {
	            this._doCryptBlock(M, offset, this._invSubKeys);
	        },

	        _doCryptBlock: function (M, offset, subKeys) {
	            // Get input
	            this._lBlock = M[offset];
	            this._rBlock = M[offset + 1];

	            // Initial permutation
	            exchangeLR.call(this, 4,  0x0f0f0f0f);
	            exchangeLR.call(this, 16, 0x0000ffff);
	            exchangeRL.call(this, 2,  0x33333333);
	            exchangeRL.call(this, 8,  0x00ff00ff);
	            exchangeLR.call(this, 1,  0x55555555);

	            // Rounds
	            for (var round = 0; round < 16; round++) {
	                // Shortcuts
	                var subKey = subKeys[round];
	                var lBlock = this._lBlock;
	                var rBlock = this._rBlock;

	                // Feistel function
	                var f = 0;
	                for (var i = 0; i < 8; i++) {
	                    f |= SBOX_P[i][((rBlock ^ subKey[i]) & SBOX_MASK[i]) >>> 0];
	                }
	                this._lBlock = rBlock;
	                this._rBlock = lBlock ^ f;
	            }

	            // Undo swap from last round
	            var t = this._lBlock;
	            this._lBlock = this._rBlock;
	            this._rBlock = t;

	            // Final permutation
	            exchangeLR.call(this, 1,  0x55555555);
	            exchangeRL.call(this, 8,  0x00ff00ff);
	            exchangeRL.call(this, 2,  0x33333333);
	            exchangeLR.call(this, 16, 0x0000ffff);
	            exchangeLR.call(this, 4,  0x0f0f0f0f);

	            // Set output
	            M[offset] = this._lBlock;
	            M[offset + 1] = this._rBlock;
	        },

	        keySize: 64/32,

	        ivSize: 64/32,

	        blockSize: 64/32
	    });

	    // Swap bits across the left and right words
	    function exchangeLR(offset, mask) {
	        var t = ((this._lBlock >>> offset) ^ this._rBlock) & mask;
	        this._rBlock ^= t;
	        this._lBlock ^= t << offset;
	    }

	    function exchangeRL(offset, mask) {
	        var t = ((this._rBlock >>> offset) ^ this._lBlock) & mask;
	        this._lBlock ^= t;
	        this._rBlock ^= t << offset;
	    }

	    /**
	     * Shortcut functions to the cipher's object interface.
	     *
	     * @example
	     *
	     *     var ciphertext = CryptoJS.DES.encrypt(message, key, cfg);
	     *     var plaintext  = CryptoJS.DES.decrypt(ciphertext, key, cfg);
	     */
	    C.DES = BlockCipher._createHelper(DES);

	    /**
	     * Triple-DES block cipher algorithm.
	     */
	    var TripleDES = C_algo.TripleDES = BlockCipher.extend({
	        _doReset: function () {
	            // Shortcuts
	            var key = this._key;
	            var keyWords = key.words;

	            // Create DES instances
	            this._des1 = DES.createEncryptor(WordArray.create(keyWords.slice(0, 2)));
	            this._des2 = DES.createEncryptor(WordArray.create(keyWords.slice(2, 4)));
	            this._des3 = DES.createEncryptor(WordArray.create(keyWords.slice(4, 6)));
	        },

	        encryptBlock: function (M, offset) {
	            this._des1.encryptBlock(M, offset);
	            this._des2.decryptBlock(M, offset);
	            this._des3.encryptBlock(M, offset);
	        },

	        decryptBlock: function (M, offset) {
	            this._des3.decryptBlock(M, offset);
	            this._des2.encryptBlock(M, offset);
	            this._des1.decryptBlock(M, offset);
	        },

	        keySize: 192/32,

	        ivSize: 64/32,

	        blockSize: 64/32
	    });

	    /**
	     * Shortcut functions to the cipher's object interface.
	     *
	     * @example
	     *
	     *     var ciphertext = CryptoJS.TripleDES.encrypt(message, key, cfg);
	     *     var plaintext  = CryptoJS.TripleDES.decrypt(ciphertext, key, cfg);
	     */
	    C.TripleDES = BlockCipher._createHelper(TripleDES);
	}());


	return CryptoJS.TripleDES;

}));

/***/ }),
/* 448 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory, undef) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(9), __webpack_require__(40), __webpack_require__(41), __webpack_require__(33), __webpack_require__(14));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core", "./enc-base64", "./md5", "./evpkdf", "./cipher-core"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	(function () {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var StreamCipher = C_lib.StreamCipher;
	    var C_algo = C.algo;

	    /**
	     * RC4 stream cipher algorithm.
	     */
	    var RC4 = C_algo.RC4 = StreamCipher.extend({
	        _doReset: function () {
	            // Shortcuts
	            var key = this._key;
	            var keyWords = key.words;
	            var keySigBytes = key.sigBytes;

	            // Init sbox
	            var S = this._S = [];
	            for (var i = 0; i < 256; i++) {
	                S[i] = i;
	            }

	            // Key setup
	            for (var i = 0, j = 0; i < 256; i++) {
	                var keyByteIndex = i % keySigBytes;
	                var keyByte = (keyWords[keyByteIndex >>> 2] >>> (24 - (keyByteIndex % 4) * 8)) & 0xff;

	                j = (j + S[i] + keyByte) % 256;

	                // Swap
	                var t = S[i];
	                S[i] = S[j];
	                S[j] = t;
	            }

	            // Counters
	            this._i = this._j = 0;
	        },

	        _doProcessBlock: function (M, offset) {
	            M[offset] ^= generateKeystreamWord.call(this);
	        },

	        keySize: 256/32,

	        ivSize: 0
	    });

	    function generateKeystreamWord() {
	        // Shortcuts
	        var S = this._S;
	        var i = this._i;
	        var j = this._j;

	        // Generate keystream word
	        var keystreamWord = 0;
	        for (var n = 0; n < 4; n++) {
	            i = (i + 1) % 256;
	            j = (j + S[i]) % 256;

	            // Swap
	            var t = S[i];
	            S[i] = S[j];
	            S[j] = t;

	            keystreamWord |= S[(S[i] + S[j]) % 256] << (24 - n * 8);
	        }

	        // Update counters
	        this._i = i;
	        this._j = j;

	        return keystreamWord;
	    }

	    /**
	     * Shortcut functions to the cipher's object interface.
	     *
	     * @example
	     *
	     *     var ciphertext = CryptoJS.RC4.encrypt(message, key, cfg);
	     *     var plaintext  = CryptoJS.RC4.decrypt(ciphertext, key, cfg);
	     */
	    C.RC4 = StreamCipher._createHelper(RC4);

	    /**
	     * Modified RC4 stream cipher algorithm.
	     */
	    var RC4Drop = C_algo.RC4Drop = RC4.extend({
	        /**
	         * Configuration options.
	         *
	         * @property {number} drop The number of keystream words to drop. Default 192
	         */
	        cfg: RC4.cfg.extend({
	            drop: 192
	        }),

	        _doReset: function () {
	            RC4._doReset.call(this);

	            // Drop
	            for (var i = this.cfg.drop; i > 0; i--) {
	                generateKeystreamWord.call(this);
	            }
	        }
	    });

	    /**
	     * Shortcut functions to the cipher's object interface.
	     *
	     * @example
	     *
	     *     var ciphertext = CryptoJS.RC4Drop.encrypt(message, key, cfg);
	     *     var plaintext  = CryptoJS.RC4Drop.decrypt(ciphertext, key, cfg);
	     */
	    C.RC4Drop = StreamCipher._createHelper(RC4Drop);
	}());


	return CryptoJS.RC4;

}));

/***/ }),
/* 449 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory, undef) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(9), __webpack_require__(40), __webpack_require__(41), __webpack_require__(33), __webpack_require__(14));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core", "./enc-base64", "./md5", "./evpkdf", "./cipher-core"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	(function () {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var StreamCipher = C_lib.StreamCipher;
	    var C_algo = C.algo;

	    // Reusable objects
	    var S  = [];
	    var C_ = [];
	    var G  = [];

	    /**
	     * Rabbit stream cipher algorithm
	     */
	    var Rabbit = C_algo.Rabbit = StreamCipher.extend({
	        _doReset: function () {
	            // Shortcuts
	            var K = this._key.words;
	            var iv = this.cfg.iv;

	            // Swap endian
	            for (var i = 0; i < 4; i++) {
	                K[i] = (((K[i] << 8)  | (K[i] >>> 24)) & 0x00ff00ff) |
	                       (((K[i] << 24) | (K[i] >>> 8))  & 0xff00ff00);
	            }

	            // Generate initial state values
	            var X = this._X = [
	                K[0], (K[3] << 16) | (K[2] >>> 16),
	                K[1], (K[0] << 16) | (K[3] >>> 16),
	                K[2], (K[1] << 16) | (K[0] >>> 16),
	                K[3], (K[2] << 16) | (K[1] >>> 16)
	            ];

	            // Generate initial counter values
	            var C = this._C = [
	                (K[2] << 16) | (K[2] >>> 16), (K[0] & 0xffff0000) | (K[1] & 0x0000ffff),
	                (K[3] << 16) | (K[3] >>> 16), (K[1] & 0xffff0000) | (K[2] & 0x0000ffff),
	                (K[0] << 16) | (K[0] >>> 16), (K[2] & 0xffff0000) | (K[3] & 0x0000ffff),
	                (K[1] << 16) | (K[1] >>> 16), (K[3] & 0xffff0000) | (K[0] & 0x0000ffff)
	            ];

	            // Carry bit
	            this._b = 0;

	            // Iterate the system four times
	            for (var i = 0; i < 4; i++) {
	                nextState.call(this);
	            }

	            // Modify the counters
	            for (var i = 0; i < 8; i++) {
	                C[i] ^= X[(i + 4) & 7];
	            }

	            // IV setup
	            if (iv) {
	                // Shortcuts
	                var IV = iv.words;
	                var IV_0 = IV[0];
	                var IV_1 = IV[1];

	                // Generate four subvectors
	                var i0 = (((IV_0 << 8) | (IV_0 >>> 24)) & 0x00ff00ff) | (((IV_0 << 24) | (IV_0 >>> 8)) & 0xff00ff00);
	                var i2 = (((IV_1 << 8) | (IV_1 >>> 24)) & 0x00ff00ff) | (((IV_1 << 24) | (IV_1 >>> 8)) & 0xff00ff00);
	                var i1 = (i0 >>> 16) | (i2 & 0xffff0000);
	                var i3 = (i2 << 16)  | (i0 & 0x0000ffff);

	                // Modify counter values
	                C[0] ^= i0;
	                C[1] ^= i1;
	                C[2] ^= i2;
	                C[3] ^= i3;
	                C[4] ^= i0;
	                C[5] ^= i1;
	                C[6] ^= i2;
	                C[7] ^= i3;

	                // Iterate the system four times
	                for (var i = 0; i < 4; i++) {
	                    nextState.call(this);
	                }
	            }
	        },

	        _doProcessBlock: function (M, offset) {
	            // Shortcut
	            var X = this._X;

	            // Iterate the system
	            nextState.call(this);

	            // Generate four keystream words
	            S[0] = X[0] ^ (X[5] >>> 16) ^ (X[3] << 16);
	            S[1] = X[2] ^ (X[7] >>> 16) ^ (X[5] << 16);
	            S[2] = X[4] ^ (X[1] >>> 16) ^ (X[7] << 16);
	            S[3] = X[6] ^ (X[3] >>> 16) ^ (X[1] << 16);

	            for (var i = 0; i < 4; i++) {
	                // Swap endian
	                S[i] = (((S[i] << 8)  | (S[i] >>> 24)) & 0x00ff00ff) |
	                       (((S[i] << 24) | (S[i] >>> 8))  & 0xff00ff00);

	                // Encrypt
	                M[offset + i] ^= S[i];
	            }
	        },

	        blockSize: 128/32,

	        ivSize: 64/32
	    });

	    function nextState() {
	        // Shortcuts
	        var X = this._X;
	        var C = this._C;

	        // Save old counter values
	        for (var i = 0; i < 8; i++) {
	            C_[i] = C[i];
	        }

	        // Calculate new counter values
	        C[0] = (C[0] + 0x4d34d34d + this._b) | 0;
	        C[1] = (C[1] + 0xd34d34d3 + ((C[0] >>> 0) < (C_[0] >>> 0) ? 1 : 0)) | 0;
	        C[2] = (C[2] + 0x34d34d34 + ((C[1] >>> 0) < (C_[1] >>> 0) ? 1 : 0)) | 0;
	        C[3] = (C[3] + 0x4d34d34d + ((C[2] >>> 0) < (C_[2] >>> 0) ? 1 : 0)) | 0;
	        C[4] = (C[4] + 0xd34d34d3 + ((C[3] >>> 0) < (C_[3] >>> 0) ? 1 : 0)) | 0;
	        C[5] = (C[5] + 0x34d34d34 + ((C[4] >>> 0) < (C_[4] >>> 0) ? 1 : 0)) | 0;
	        C[6] = (C[6] + 0x4d34d34d + ((C[5] >>> 0) < (C_[5] >>> 0) ? 1 : 0)) | 0;
	        C[7] = (C[7] + 0xd34d34d3 + ((C[6] >>> 0) < (C_[6] >>> 0) ? 1 : 0)) | 0;
	        this._b = (C[7] >>> 0) < (C_[7] >>> 0) ? 1 : 0;

	        // Calculate the g-values
	        for (var i = 0; i < 8; i++) {
	            var gx = X[i] + C[i];

	            // Construct high and low argument for squaring
	            var ga = gx & 0xffff;
	            var gb = gx >>> 16;

	            // Calculate high and low result of squaring
	            var gh = ((((ga * ga) >>> 17) + ga * gb) >>> 15) + gb * gb;
	            var gl = (((gx & 0xffff0000) * gx) | 0) + (((gx & 0x0000ffff) * gx) | 0);

	            // High XOR low
	            G[i] = gh ^ gl;
	        }

	        // Calculate new state values
	        X[0] = (G[0] + ((G[7] << 16) | (G[7] >>> 16)) + ((G[6] << 16) | (G[6] >>> 16))) | 0;
	        X[1] = (G[1] + ((G[0] << 8)  | (G[0] >>> 24)) + G[7]) | 0;
	        X[2] = (G[2] + ((G[1] << 16) | (G[1] >>> 16)) + ((G[0] << 16) | (G[0] >>> 16))) | 0;
	        X[3] = (G[3] + ((G[2] << 8)  | (G[2] >>> 24)) + G[1]) | 0;
	        X[4] = (G[4] + ((G[3] << 16) | (G[3] >>> 16)) + ((G[2] << 16) | (G[2] >>> 16))) | 0;
	        X[5] = (G[5] + ((G[4] << 8)  | (G[4] >>> 24)) + G[3]) | 0;
	        X[6] = (G[6] + ((G[5] << 16) | (G[5] >>> 16)) + ((G[4] << 16) | (G[4] >>> 16))) | 0;
	        X[7] = (G[7] + ((G[6] << 8)  | (G[6] >>> 24)) + G[5]) | 0;
	    }

	    /**
	     * Shortcut functions to the cipher's object interface.
	     *
	     * @example
	     *
	     *     var ciphertext = CryptoJS.Rabbit.encrypt(message, key, cfg);
	     *     var plaintext  = CryptoJS.Rabbit.decrypt(ciphertext, key, cfg);
	     */
	    C.Rabbit = StreamCipher._createHelper(Rabbit);
	}());


	return CryptoJS.Rabbit;

}));

/***/ }),
/* 450 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory, undef) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(9), __webpack_require__(40), __webpack_require__(41), __webpack_require__(33), __webpack_require__(14));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core", "./enc-base64", "./md5", "./evpkdf", "./cipher-core"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	(function () {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var StreamCipher = C_lib.StreamCipher;
	    var C_algo = C.algo;

	    // Reusable objects
	    var S  = [];
	    var C_ = [];
	    var G  = [];

	    /**
	     * Rabbit stream cipher algorithm.
	     *
	     * This is a legacy version that neglected to convert the key to little-endian.
	     * This error doesn't affect the cipher's security,
	     * but it does affect its compatibility with other implementations.
	     */
	    var RabbitLegacy = C_algo.RabbitLegacy = StreamCipher.extend({
	        _doReset: function () {
	            // Shortcuts
	            var K = this._key.words;
	            var iv = this.cfg.iv;

	            // Generate initial state values
	            var X = this._X = [
	                K[0], (K[3] << 16) | (K[2] >>> 16),
	                K[1], (K[0] << 16) | (K[3] >>> 16),
	                K[2], (K[1] << 16) | (K[0] >>> 16),
	                K[3], (K[2] << 16) | (K[1] >>> 16)
	            ];

	            // Generate initial counter values
	            var C = this._C = [
	                (K[2] << 16) | (K[2] >>> 16), (K[0] & 0xffff0000) | (K[1] & 0x0000ffff),
	                (K[3] << 16) | (K[3] >>> 16), (K[1] & 0xffff0000) | (K[2] & 0x0000ffff),
	                (K[0] << 16) | (K[0] >>> 16), (K[2] & 0xffff0000) | (K[3] & 0x0000ffff),
	                (K[1] << 16) | (K[1] >>> 16), (K[3] & 0xffff0000) | (K[0] & 0x0000ffff)
	            ];

	            // Carry bit
	            this._b = 0;

	            // Iterate the system four times
	            for (var i = 0; i < 4; i++) {
	                nextState.call(this);
	            }

	            // Modify the counters
	            for (var i = 0; i < 8; i++) {
	                C[i] ^= X[(i + 4) & 7];
	            }

	            // IV setup
	            if (iv) {
	                // Shortcuts
	                var IV = iv.words;
	                var IV_0 = IV[0];
	                var IV_1 = IV[1];

	                // Generate four subvectors
	                var i0 = (((IV_0 << 8) | (IV_0 >>> 24)) & 0x00ff00ff) | (((IV_0 << 24) | (IV_0 >>> 8)) & 0xff00ff00);
	                var i2 = (((IV_1 << 8) | (IV_1 >>> 24)) & 0x00ff00ff) | (((IV_1 << 24) | (IV_1 >>> 8)) & 0xff00ff00);
	                var i1 = (i0 >>> 16) | (i2 & 0xffff0000);
	                var i3 = (i2 << 16)  | (i0 & 0x0000ffff);

	                // Modify counter values
	                C[0] ^= i0;
	                C[1] ^= i1;
	                C[2] ^= i2;
	                C[3] ^= i3;
	                C[4] ^= i0;
	                C[5] ^= i1;
	                C[6] ^= i2;
	                C[7] ^= i3;

	                // Iterate the system four times
	                for (var i = 0; i < 4; i++) {
	                    nextState.call(this);
	                }
	            }
	        },

	        _doProcessBlock: function (M, offset) {
	            // Shortcut
	            var X = this._X;

	            // Iterate the system
	            nextState.call(this);

	            // Generate four keystream words
	            S[0] = X[0] ^ (X[5] >>> 16) ^ (X[3] << 16);
	            S[1] = X[2] ^ (X[7] >>> 16) ^ (X[5] << 16);
	            S[2] = X[4] ^ (X[1] >>> 16) ^ (X[7] << 16);
	            S[3] = X[6] ^ (X[3] >>> 16) ^ (X[1] << 16);

	            for (var i = 0; i < 4; i++) {
	                // Swap endian
	                S[i] = (((S[i] << 8)  | (S[i] >>> 24)) & 0x00ff00ff) |
	                       (((S[i] << 24) | (S[i] >>> 8))  & 0xff00ff00);

	                // Encrypt
	                M[offset + i] ^= S[i];
	            }
	        },

	        blockSize: 128/32,

	        ivSize: 64/32
	    });

	    function nextState() {
	        // Shortcuts
	        var X = this._X;
	        var C = this._C;

	        // Save old counter values
	        for (var i = 0; i < 8; i++) {
	            C_[i] = C[i];
	        }

	        // Calculate new counter values
	        C[0] = (C[0] + 0x4d34d34d + this._b) | 0;
	        C[1] = (C[1] + 0xd34d34d3 + ((C[0] >>> 0) < (C_[0] >>> 0) ? 1 : 0)) | 0;
	        C[2] = (C[2] + 0x34d34d34 + ((C[1] >>> 0) < (C_[1] >>> 0) ? 1 : 0)) | 0;
	        C[3] = (C[3] + 0x4d34d34d + ((C[2] >>> 0) < (C_[2] >>> 0) ? 1 : 0)) | 0;
	        C[4] = (C[4] + 0xd34d34d3 + ((C[3] >>> 0) < (C_[3] >>> 0) ? 1 : 0)) | 0;
	        C[5] = (C[5] + 0x34d34d34 + ((C[4] >>> 0) < (C_[4] >>> 0) ? 1 : 0)) | 0;
	        C[6] = (C[6] + 0x4d34d34d + ((C[5] >>> 0) < (C_[5] >>> 0) ? 1 : 0)) | 0;
	        C[7] = (C[7] + 0xd34d34d3 + ((C[6] >>> 0) < (C_[6] >>> 0) ? 1 : 0)) | 0;
	        this._b = (C[7] >>> 0) < (C_[7] >>> 0) ? 1 : 0;

	        // Calculate the g-values
	        for (var i = 0; i < 8; i++) {
	            var gx = X[i] + C[i];

	            // Construct high and low argument for squaring
	            var ga = gx & 0xffff;
	            var gb = gx >>> 16;

	            // Calculate high and low result of squaring
	            var gh = ((((ga * ga) >>> 17) + ga * gb) >>> 15) + gb * gb;
	            var gl = (((gx & 0xffff0000) * gx) | 0) + (((gx & 0x0000ffff) * gx) | 0);

	            // High XOR low
	            G[i] = gh ^ gl;
	        }

	        // Calculate new state values
	        X[0] = (G[0] + ((G[7] << 16) | (G[7] >>> 16)) + ((G[6] << 16) | (G[6] >>> 16))) | 0;
	        X[1] = (G[1] + ((G[0] << 8)  | (G[0] >>> 24)) + G[7]) | 0;
	        X[2] = (G[2] + ((G[1] << 16) | (G[1] >>> 16)) + ((G[0] << 16) | (G[0] >>> 16))) | 0;
	        X[3] = (G[3] + ((G[2] << 8)  | (G[2] >>> 24)) + G[1]) | 0;
	        X[4] = (G[4] + ((G[3] << 16) | (G[3] >>> 16)) + ((G[2] << 16) | (G[2] >>> 16))) | 0;
	        X[5] = (G[5] + ((G[4] << 8)  | (G[4] >>> 24)) + G[3]) | 0;
	        X[6] = (G[6] + ((G[5] << 16) | (G[5] >>> 16)) + ((G[4] << 16) | (G[4] >>> 16))) | 0;
	        X[7] = (G[7] + ((G[6] << 8)  | (G[6] >>> 24)) + G[5]) | 0;
	    }

	    /**
	     * Shortcut functions to the cipher's object interface.
	     *
	     * @example
	     *
	     *     var ciphertext = CryptoJS.RabbitLegacy.encrypt(message, key, cfg);
	     *     var plaintext  = CryptoJS.RabbitLegacy.decrypt(ciphertext, key, cfg);
	     */
	    C.RabbitLegacy = StreamCipher._createHelper(RabbitLegacy);
	}());


	return CryptoJS.RabbitLegacy;

}));

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// static/js/main.7f04a72f.js